(function(){
  'use strict';
  angular.module('FTBonpreuApp', [ 'FTBaseApp' ]);

	//scrollbars

  angular.module('FTBonpreuApp').config(['ScrollBarsProvider',function (ScrollBarsProvider) {
    ScrollBarsProvider.defaults = {
      scrollButtons: {
        scrollAmount: 'auto', // scroll amount when button pressed
        enable: false // enable scrolling buttons by default
      },
      axis: 'y', // enable 2 axis scrollbars by default
      autoHideScrollbar: false,
      theme: '3d-thick-dark',//lista de temas disponibles en http://iominh.github.io/ng-scrollbars/
      advanced:{
        updateOnContentResize: true
      }
    };
  }]);
})();

angular.module('FTBonpreuApp').controller('RenombrarArchivoPopupController', ['$scope', '$uibModalInstance', 'ixStatusService', '$http', 'cfg', function ($scope, $uibModalInstance, ixStatusService, $http, cfg) {
	$scope.status = ixStatusService.current;
	$scope.data = {};
  $scope.data.idfichero = $scope.$resolve.idfichero;
	$scope.data.nombre_original = $scope.$resolve.nombre_original;
	$scope.data.nuevo_nombre = "";
  $scope.data.changed = false;
 
  $scope.guardar = function(){
    $http.put(cfg.baseURL + "proveedores_ficheros/CambiarNombreFichero?idfichero=" + $scope.data.idfichero + "&nuevo_nombre=" + $scope.data.nuevo_nombre).then(function (r) {
      $scope.data.changed = true;
      //ixStatusService.setResponse(r);
      $uibModalInstance.close($scope.data);
      }, function (err){
        ixStatusService.setResponse(err);
    });
  };

  $scope.$dismiss = function (){
    $uibModalInstance.close($scope.data);
  }

}]);
/*global ixGetPatchOperations*/

angular.module('FTBonpreuApp').controller('PopupFicheroProveedorController', [ '$scope', 'cfg', '$http', '$uibModalInstance', '$log', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, $log, Upload, ixStatusService){
	$scope.status = ixStatusService.current;
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
  $scope.data = {};
  $scope.idFichero = $scope.$resolve.id_fichero;
  $scope.idProveedor = $scope.$resolve.id_proveedor;
  $scope.nombreProveedor = $scope.$resolve.nombre_proveedor;
  $scope.mant_proveedor = $scope.$resolve.mantenimiento_proveedor;

  $scope.data.proveedor = $scope.idProveedor;
  if (angular.isDefined($scope.$resolve.fabricante)) $scope.data.fabricante = $scope.$resolve.fabricante;
  if (angular.isDefined($scope.$resolve.planta)) $scope.data.planta = $scope.$resolve.planta;
  if (angular.isDefined($scope.$resolve.grupo)){
    $scope.bloquearGrupos = true;
    $scope.data.grupo = $scope.$resolve.grupo;
  }
  else {
    $scope.bloquearGrupos = false;
  }
  if (!$scope.mant_proveedor) $scope.bloquearGrupos = true;
  $scope.uploadingFile = false;
  $scope.uploadedFile = false;
  $scope.status.editing = true;
  $scope.esNuevo = false;

  if ($scope.idFichero == 0){
		//Es un nuevo fichero
		$scope.esNuevo = true;
    $scope.tituloPopup = "Cargar nuevo fichero";
    $scope.caducityDateRequired = false;
	}
  else {
    //Se está editando un fichero existente
    $scope.tituloPopup = "Editar fichero";
    $http.get(cfg.baseURL + "proveedores_ficheros/" + $scope.idFichero).then(function(response){
			$scope.data = response.data;
			$scope.original_data = angular.copy($scope.data);
      //TODO: GET Tipo_fichero
      $http.get(cfg.baseURL + "tipos_fichero_proveedor/" + $scope.data.tipo).then(function(response){
        $scope.setCaducityRequired(response.data);
      },
      function(error){
        ixStatusService.setResponse(error);
      });
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }

  $scope.setCaducityRequired = function (entity){
    if (entity)
      $scope.caducityDateRequired = (entity.caducidad_obligatoria == 1);
    else
      $scope.caducityDateRequired = false;
  };


  $scope.save = function(){
    if ($scope.esNuevo){
      if (angular.isUndefined($scope.archivosToUpload)){
        $log.log("No se ha seleccionado un archivo");
        //TODO: Add simulateAPIError
      }
      else {
        var fileNames = [];
        fileNames.push($scope.archivosToUpload[0].name);

        $http.post(cfg.baseURL + "proveedores_ficheros/CanUpload?id_proveedor=" + $scope.idProveedor, fileNames).then(function(response){
          if (response.data.GlobalMessage.ErrType == 0){
            $scope.uploadingFile = true;
            var upload = Upload.upload({
              url: cfg.baseURL + "proveedores_ficheros/UploadAndCreate",
              data: {
                file: $scope.archivosToUpload,
                grupo: $scope.data.grupo,
                proveedor: $scope.idProveedor,
                fabricante: $scope.data.fabricante,
                planta: $scope.data.planta,
                tipo: $scope.data.tipo,
                fecha_caducidad: $scope.data.fecha_caducidad,
                inicio_validez: $scope.data.inicio_validez,
                fecha_carga: $scope.data.fecha_carga
              },
              dataType: 'json'
            });

            upload.then(function(response){
              if (response.data){
                delete $scope.data.ixProgress;
                $scope.uploadingFile = false;
                $scope.uploadedFile = true;
                ixStatusService.setResponse(response);
                //Cuando se agregan nuevos ficheros: En cambio de cerrar modal, limpio campos para ejecutar una nueva carga
                //$uibModalInstance.close($scope.uploadedFile);
                $scope.archivosToUpload = null;
                $scope.archivo = null;
                $scope.data.tipo = null;
                $scope.data.fecha_caducidad = null;
                $scope.data.inicio_validez = null;
                $scope.data.fecha_carga = null;
                }
            }, function(error){
              if (error.data) {
                delete $scope.data.ixProgress;
                $scope.uploadingFile = false;
              }
              ixStatusService.setResponse(error);
            }, function(evt){
              $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
          }
          else {
            ixStatusService.setResponse(response);
          }
        }, function(error){
          ixStatusService.setResponse(error);
        });
      }
    }
    else { //EDITAR
      var param = {};
      if ($scope.data.grupo == "PROVEÏDOR"){
        $scope.data.fabricante = null;
        $scope.data.planta = null;
      }
      if ($scope.data.grupo == "EMPRESA"){
        if (!$scope.data.fabricante){
          $log.log("No se puede asignar el grupo EMPRESA si no se ha seleccionado una empresa");
          //simulateAPIError
          return;
        }
        else {
          $scope.data.planta = null;
        }
      }
      if ($scope.data.grupo == "PLANTA"){
        if (!$scope.data.planta){
          $log.log("No se puede asignar el grupo PLANTA si no se ha seleccionado una planta");
          //simulateAPIError
          return;
        }
      }

      param = ixGetPatchOperations($scope.original_data, $scope.data);

      $http.put(cfg.baseURL + "proveedores_ficheros/" + $scope.data.id, param).then(function(response){
        ixStatusService.setResponse(response);
        //$scope.status.editing = false;
        $uibModalInstance.close(true);
      }, function(error){
        ixStatusService.setResponse(error);
      });
    }
  };


  $scope.$dismiss = function () {
		$uibModalInstance.close($scope.uploadedFile);
	};

}]);

/*global CMP_EQ*/
/*global ixGetPatchOperations*/
/*global saveAs*/

angular.module('FTBonpreuApp').controller('PlantasBPPopupController', ['$scope', '$uibModalInstance', 'gridService', 'uiGridConstants', 'ixStatusService', '$http', 'cfg', 'ixUtilsService', 'authService', '$translate', function ($scope, $uibModalInstance, gridService, uiGridConstants, ixStatusService, $http, cfg, ixUtilsService, authService, $translate) {
	$scope.status = ixStatusService.current;
	$scope.data = {};
	$scope.data.planta = $scope.$resolve.clickedItem;
	$scope.data.planta_datos_originales = angular.copy($scope.$resolve.clickedItem);
	$scope.data.fabricante = $scope.$resolve.fabricante;
	$scope.data.planta.fabricante = $scope.data.fabricante.fabricante;
	$scope.proveedor = $scope.data.fabricante.proveedor; // $scope.$resolve.id_proveedor;
	$scope.cod_empresa = $scope.data.planta.planta;
	$scope.nombre_planta = $scope.data.planta.nombre_planta;
	$scope.isNew = $scope.$resolve.isNew || !$scope.data.planta.planta;
	$scope.gridManualLoad = true;
	$scope.dataModified = false;
	$scope.editOnlyFiles = $scope.$resolve.editOnlyFiles;

	// Sólo admin, userkey y rol bonpreu_qualitat pueden ver algunos campos
	$scope.status.editing = $scope.$resolve.editAllowed;

	var usuario = authService.authentication.userName;
	var perfilesUsuario = authService.perfilesUsuario();
	$scope.tienePerfilAdminUsrKey = authService.tienePerfilAdmin() || authService.tienePerfilUserKey();
	$scope.tienePerfilBP = (perfilesUsuario[0] == 'usr_bp_qualitat');
	

	$scope.addFicheros = function () {
		var urlTemplate = "app/FTBonpreu/MantenimientosBP/proveedores/modales/popupFicheroProveedor.html";
		var controllerName = "PopupFicheroProveedorController";
		var optionsPopupFicheros = {
			controller: controllerName
		};
		var params = { "id_fichero": 0, "id_proveedor": $scope.proveedor, "mantenimiento_proveedor": true, "grupo": "PLANTA", "fabricante": $scope.data.planta.fabricante, "planta": $scope.data.planta.planta };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'small', params);
		modalInstance.then(function (resp) {
			if (resp){
				$scope.data.gridCertificadosPlanta.ixLoadInitialData();
				$scope.dataModified = true;
			}
		});
	};


	// $scope.addRow = function (grid, item) {
	// 	var nuevo = item || {};
	// 	nuevo.id = 0;
	// 	if($scope.data.planta.planta)
	// 		nuevo.planta = $scope.data.planta.planta;
	// 	grid.ixAddRow(nuevo);
	// };

	$scope.deleteSelectedRows = function (grid) {
		grid.ixDeleteSelectedRows();
	};


	//GRID CERTIFICADOS PLANTA
	if (!$scope.data.gridCertificadosPlanta) {
		var metadata = [
			{
				Name: "fecha_caducidad",
				Sort:
				{
					direction: uiGridConstants.DESC,
					ignoreSort: false,
					priority: 0
				}
			},
			{ Name: "archivo", NoEditable: true },
			{ Name: "fecha_carga", NoEditable: true }
			// {
			// 	Name: "visto",
			// 	Sort:
			// 	{
			// 		direction: uiGridConstants.ASC,
			// 		ignoreSort: false,
			// 		priority: 0
			// 	},
			// 	filterOptions: [ "-1 - Desautorizado", "0 - Pendiente", "1 - Autorizado" ],
			// 	APIStringDefValue: "0"
			// },
		];

		var accionesCertificados = [
			{
				title: $translate.instant('Previsualizar PDF'),
				icon: "fa-file-pdf-o",
				visible: function (entity) {
					return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
				},
				accion: function (entity) {
					var tabla = "proveedores_ficheros";
					$http({
						method: 'post',
						url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
						headers: {},
						responseType: 'arraybuffer'
					}).then(function (r) {
						$scope.selectedPDF = new Uint8Array(r.data);
						$scope.idFicheroPreview = entity.id;
						var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
						ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
					},
						function (err) {
							ixStatusService.setResponse(err);
						});
				}
			},
			{
				title: $translate.instant('Previsualizar Imagen'),
				icon: "fa-file-image-o",
				visible: function (entity) {
					return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
				},
				accion: function (entity) {
					var tabla = $scope.getEntity();
					$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
						$scope.selectedImage = r.data;
						$scope.idFicheroPreview = entity.id;
						var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
						ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
					},
						function (err) {
							ixStatusService.setResponse(err);
						});
				}
			},
			{
				title: $translate.instant('Descargar fichero'),
				icon: "fa-download",
				visible: function (entity) {
					return entity.archivo;
				},
				accion: function (entity) {
					$scope.downloadFile(entity.id);
				}
			},
			{
				title: $translate.instant('Editar fichero'),
				icon: "fa-pencil",
				visible: function(){
					return $scope.status.editing;
				},
				accion: function(entity) {
					var urlTemplate = "app/FTBonpreu/MantenimientosBP/proveedores/modales/popupFicheroProveedor.html";
					var controllerName = "PopupFicheroProveedorController";
					var optionsPopupEditarArchivo = {
						controller: controllerName
					};
					var params = { "id_fichero": entity.id, "id_proveedor": entity.proveedor, "mantenimiento_proveedor": true, "grupo": "PLANTA", "fabricante": entity.fabricante, "planta": entity.planta };
					var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupEditarArchivo, 'small', params);
					modalInstance.then(function (resp) {
						if (resp){
						// Recargar grid de ficheros
						$scope.data.gridCertificadosPlanta.ixLoadInitialData();
						}
					});
				}
			}
		];
		
		var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.activo == 0), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
		$scope.data.gridCertificadosPlanta = gridService.createGrid($scope, 'gnet_grid_certificados_planta', { metadata: metadata, minRowsToShow: 5, showOnlyDescribedCols: ["tipo", "archivo", "fecha_carga", "inicio_validez", "fecha_caducidad", "activo"] }, "proveedores_ficheros", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: accionesCertificados }]);
		$scope.data.gridCertificadosPlanta.rowTemplate = rowTemplate;
		$scope.data.gridCertificadosPlanta.filtroExterno = [{ Field: 'planta', Value: $scope.data.planta.planta, Operator: CMP_EQ }];
		$scope.data.gridCertificadosPlanta.ixLoadInitialData();
	}
	else {
		$scope.data.gridCertificadosPlanta = gridService.createGridFunctions($scope, $scope.data.gridCertificadosPlanta);
		$scope.data.gridCertificadosPlanta.ixRestoreConfig();
	}

	$scope.guardar = function () {
		if ($scope.isNew) {
			$http.post(cfg.baseURL + "plantas", $scope.data.planta).then(function (r) {
				delete $scope.isNew;
				$scope.data.planta.planta = r.data.obj.Record.planta;
				$scope.data.planta_datos_originales = angular.copy($scope.data.planta);
				//Actualizo el filtro externo
				$scope.data.gridCertificadosPlanta.filtroExterno = [{ Field: 'planta', Value: $scope.data.planta.planta, Operator: CMP_EQ }];
				$scope.dataModified = true;
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
		else {
			var data = {};
			data.jpdPlanta = ixGetPatchOperations($scope.data.planta_datos_originales, $scope.data.planta);
			data.ubpFicheros = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
			if ($scope.data.gridCertificadosPlanta.gridApi.rowEdit){
				data.ubpFicheros = $scope.data.gridCertificadosPlanta.ixGetBulkParam();
			}

			$http.put(cfg.baseURL + "plantas/PutPlanta/" + $scope.data.planta.planta, data).then(function (r) {
				$scope.data.planta_datos_originales = angular.copy($scope.data.planta);
				$scope.dataModified = true;
				$scope.data.gridCertificadosPlanta.clearGridAfterSave();

				$scope.status.editing = true;
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
	};

	$scope.copiarDatos = function(){
		$http.get(cfg.baseURL + 'fabricantes/' + $scope.data.planta.fabricante).then(function(response){
			$scope.data.planta.direccion = response.data.direccion;
			$scope.data.planta.cp = response.data.cp;
			$scope.data.planta.localidad = response.data.localidad;
			$scope.data.planta.provincia = response.data.provincia;
			$scope.data.planta.pais = response.data.pais;
			$scope.data.planta.telefono = response.data.telefono;
		}, function (error){
			ixStatusService.setResponse(error);
		});
	};


	$scope.downloadFile = function (id) {
		$http({
			method: 'post',
			url: cfg.baseURL + 'proveedores_ficheros/DownloadFile?id=' + id,
			//headers: { 'Content-type': 'application/pdf' },
			headers: {},
			responseType: 'arraybuffer'
		}).then(function (r) {
			var mimetype = r.headers('Content-type');
			var file = new Blob([r.data], { type: mimetype });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function (err) {
			ixStatusService.setResponse(err);
		});
	};


	$scope.$dismiss = function () {
		var resp = {};
		resp.isNew = $scope.isNew;
		resp.dataModified = $scope.dataModified;
		$uibModalInstance.close(resp);
	};


	$scope.$on('$destroy', function () {
    if ($scope.data.gridCertificadosPlanta)
      $scope.data.gridCertificadosPlanta.ixSaveConfig();
    // $scope.isDestroyed = true;
  });

}]);

/*global buildIxSearch*/
/*global CMP_EQ*/
/*global CMP_ISNULL*/
/*global ixGetPatchOperations*/
/*global saveAs*/

angular.module('FTBonpreuApp').controller('EmpresasPopupController', ['$scope', '$uibModalInstance', 'gridService', 'uiGridConstants', 'ixStatusService', '$http', 'cfg', '$timeout', '$q', 'ixUtilsService', '$log', '$translate', function ($scope, $uibModalInstance, gridService, uiGridConstants, ixStatusService, $http, cfg, $timeout, $q, ixUtilsService, $log, $translate) {
	$scope.status = ixStatusService.current;
	$scope.data = {};
	$scope.data.fabricante = $scope.$resolve.clickedItem;
	$scope.data.fabricante_datos_originales = angular.copy($scope.$resolve.clickedItem);
	$scope.isNew = $scope.$resolve.isNew;
	$scope.editOnlyFiles = $scope.$resolve.editOnlyFiles;
	$scope.cod_empresa = $scope.data.fabricante.fabricante;
	$scope.nombre_empresa = $scope.data.fabricante.razon_social;

	$scope.dataModified = false;

	$scope.gridManualLoad = true;

	$scope.status.editing = $scope.$resolve.editAllowed;

	if (angular.isUndefined($scope.data.activeTab)){
		$scope.data.activeTab = 0;
	}

	$scope.changeTab = function(tabIdx) {
		if (angular.isDefined($scope.data.gridPlantas) && $scope.data.activeTab == 0) 
			$scope.data.gridPlantas.ixSaveConfig();
		if (angular.isDefined($scope.data.gridCertificadosFabricante) && $scope.data.activeTab == 1) 
			$scope.data.gridCertificadosFabricante.ixSaveConfig();

		$scope.data.activeTab = tabIdx;

		if (angular.isDefined($scope.data.gridPlantas) && $scope.data.activeTab == 0) 
			$scope.data.gridPlantas.ixRestoreConfig();
		if (angular.isDefined($scope.data.gridCertificadosFabricante) && $scope.data.activeTab == 1) 
			$scope.data.gridCertificadosFabricante.ixRestoreConfig();

	};

	$scope.addFicheros = function () {
		var urlTemplate = "app/FTBonpreu/MantenimientosBP/proveedores/modales/popupFicheroProveedor.html";
		var controllerName = "PopupFicheroProveedorController";
		var optionsPopupFicheros = {
			controller: controllerName
		};
		var params = { "id_fichero": 0, "id_proveedor": $scope.data.fabricante.proveedor, "mantenimiento_proveedor": true, "grupo": "EMPRESA", "fabricante": $scope.data.fabricante.fabricante };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'small', params);
		modalInstance.then(function (resp) {
			if (resp) {
				$scope.data.gridCertificadosFabricante.ixLoadInitialData();
				$scope.dataModified = true;
			}

		});
	};

	$scope.addRow = function (grid, item) {
		var nuevo = item || {};
		if (grid.entity == 'plantas') {
			//nuevo.fabricante = $scope.data.fabricante.fabricante;
			abrirPopupPlantas(nuevo, true);
		}

		grid.ixAddRow(nuevo);
	};

	$scope.deleteSelectedRows = function (grid) {
		grid.ixDeleteSelectedRows();
	};

	//GRID PLANTAS
	if (!$scope.data.gridPlantas) {
		//var metadata = [];
		var acciones = [
			{
				icon: "fa-search",
				title: $translate.instant('Plantas'),
				visible: function (entity) {
					return true;//!$scope.data.datos.isNew;
				},
				accion: function (entity) {
					abrirPopupPlantas(entity, false);
				}
			}
		];

		var rowTemplate2 = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.baja == 1), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
		$scope.data.gridPlantas = gridService.createGrid($scope, 'gnet_grid_plantas', { metadata: [], enableCellEdit: false, minRowsToShow: 5 }, "plantas", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
		$scope.data.gridPlantas.rowTemplate = rowTemplate2;
		$scope.data.gridPlantas.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }];
		$scope.data.gridPlantas.ixLoadInitialData();

	} else {
		$scope.data.gridPlantas = gridService.createGridFunctions($scope, $scope.data.gridPlantas);
		$scope.data.gridPlantas.ixRestoreConfig();
	}

	//GRID CERTIFICADOS EMPRESA
	if (!$scope.data.gridCertificadosFabricante) {
		var accionesCertificados = [
			{
				title: $translate.instant('Previsualizar PDF'),
				icon: "fa-file-pdf-o",
				visible: function (entity) {
					return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
				},
				accion: function (entity) {
					var tabla = "proveedores_ficheros";
					$http({
						method: 'post',
						url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
						headers: {},
						responseType: 'arraybuffer'
					}).then(function (r) {
						$scope.selectedPDF = new Uint8Array(r.data);
						$scope.idFicheroPreview = entity.id;
						var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
						ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
					},
						function (err) {
							ixStatusService.setResponse(err);
						});
				}
			},
			{
				title: $translate.instant('Previsualizar Imagen'),
				icon: "fa-file-image-o",
				visible: function (entity) {
					return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
				},
				accion: function (entity) {
					var tabla = $scope.getEntity();
					$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
						$scope.selectedImage = r.data;
						$scope.idFicheroPreview = entity.id;
						var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
						ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
					},
						function (err) {
							ixStatusService.setResponse(err);
						});
				}
			},
			{
				title: $translate.instant('Descargar fichero'),
				icon: "fa-download",
				visible: function (entity) {
					return entity.archivo;
				},
				accion: function (entity) {
					$scope.downloadFile(entity.id);
				}
			},
			{
				title: $translate.instant('Editar fichero'),
				icon: "fa-pencil",
				visible: function(){
					return $scope.status.editing;
				},
				accion: function(entity) {
					var urlTemplate = "app/FTBonpreu/MantenimientosBP/proveedores/modales/popupFicheroProveedor.html";
					var controllerName = "PopupFicheroProveedorController";
					var optionsPopupEditarArchivo = {
						controller: controllerName
					};
					var params = { "id_fichero": entity.id, "id_proveedor": $scope.data.fabricante.proveedor, "mantenimiento_proveedor": true, "grupo": "EMPRESA", "fabricante": $scope.data.fabricante.fabricante };
					var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupEditarArchivo, 'small', params);
					modalInstance.then(function (resp) {
						if (resp){
						// Recargar grid de ficheros
						$scope.data.gridCertificadosFabricante.ixLoadInitialData();
						$scope.data.gridCertificadosFabricante.clearGridAfterSave();
						$scope.status.editing = true;
						}
					});
				}
			}
		];
		var metadata = [
			{
				Name: "fecha_caducidad",
				Sort:
				{
					direction: uiGridConstants.DESC,
					ignoreSort: false,
					priority: 0
				}
			},
			{ Name: "archivo", NoEditable: true },
			{ Name: "fecha_carga", NoEditable: true }		
		];

		var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.activo == 0), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
		$scope.data.gridCertificadosFabricante = gridService.createGrid($scope, 'gnet_grid_certificados_fabricante', { metadata: metadata, minRowsToShow: 5, showOnlyDescribedCols: ["tipo", "archivo", "fecha_carga", "inicio_validez", "fecha_caducidad", "activo"] }, "proveedores_ficheros", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: accionesCertificados }]);
		$scope.data.gridCertificadosFabricante.rowTemplate = rowTemplate;
		$scope.data.gridCertificadosFabricante.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }, { Field: 'planta', Value: null, Operator: CMP_ISNULL }];
		$scope.data.gridCertificadosFabricante.ixLoadInitialData();

	} else {
		$scope.data.gridCertificadosFabricante = gridService.createGridFunctions($scope, $scope.data.gridCertificadosFabricante);
		$scope.data.gridCertificadosFabricante.ixRestoreConfig();
	}

	$scope.guardar = function () {
		if ($scope.isNew) {
			$http.post(cfg.baseURL + "fabricantes", $scope.data.fabricante).then(function (r) {
				delete $scope.isNew;
				$scope.dataModified = true;
				$scope.data.fabricante.fabricante = r.data.obj.Record.fabricante;
				$scope.data.fabricante_datos_originales = angular.copy($scope.data.fabricante);
				//Actualizo el filtro externo de los ficheros y plantas (????)
				$scope.data.gridCertificadosFabricante.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }, { Field: 'planta', Value: null, Operator: CMP_ISNULL }];
				// $scope.data.gridPlantas.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }];
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
		else {
			var data = {};

			data.jpdFabricante = ixGetPatchOperations($scope.data.fabricante_datos_originales, $scope.data.fabricante);

			data.ubpFicheros = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
			if ($scope.data.gridCertificadosFabricante)
				data.ubpFicheros = $scope.data.gridCertificadosFabricante.ixGetBulkParam();

			data.ubpPlantas = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
			if ($scope.data.gridPlantas)
				data.ubpPlantas = $scope.data.gridPlantas.ixGetBulkParam();

			$http.put(cfg.baseURL + "fabricantes/PutFabricante/" + $scope.data.fabricante.fabricante, data).then(function (r) {
				$scope.data.fabricante_datos_originales = angular.copy($scope.data.fabricante);
				$scope.dataModified = true;

				$scope.data.gridPlantas.clearGridAfterSave();
				$scope.data.gridCertificadosFabricante.clearGridAfterSave();

				$scope.status.editing = true; //Porque las llamadas al clearGridAfterSave lo ponen a false
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
	};


	// $scope.$close = function () {
	// 	$uibModalInstance.dismiss('cancel');
	// };

	$scope.$dismiss = function () {
		var resp = {};
		resp.isNew = $scope.isNew;
		resp.dataModified = $scope.dataModified;
		$uibModalInstance.close(resp);
	}

	var abrirPopupPlantas = function (entity, isNew) {
		var urlTemplate = "app/FTBonpreu/MantenimientosBP/proveedores/modales/plantasBpPopup.html";
		var controllerName = "PlantasBPPopupController";
		var optionsPopupPlantas = {
			controller: controllerName
		};
		
		var params = { "clickedItem": entity, "isNew": isNew, "fabricante": $scope.data.fabricante, "nombre_planta": entity.nombre_planta, "editAllowed": $scope.$resolve.editAllowed, "editOnlyFiles": $scope.editOnlyFiles, "id_proveedor": $scope.data.proveedor };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupPlantas, 'medium', params);
		modalInstance.then(function (resp) {
			if (resp.isNew || resp.dataModified) {
				$scope.data.gridPlantas.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }];
				$scope.data.gridPlantas.ixLoadInitialData();
				$scope.status.editing = true;
			}
			if (resp.dataModified) $scope.dataModified = resp.dataModified;
		});
	};

	$scope.downloadFile = function (id) {
		$http({
			method: 'post',
			url: cfg.baseURL + 'proveedores_ficheros/DownloadFile?id=' + id,
			//headers: { 'Content-type': 'application/pdf' },
			headers: {},
			responseType: 'arraybuffer'
		}).then(function (r) {
			var file = new Blob([r.data], { type: r.headers('Content-type') });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function (err) {
			ixStatusService.setResponse(err);
		});
	}

	$scope.copiarDatos = function(){
		$http.get(cfg.baseURL + 'proveedores/' + $scope.data.fabricante.proveedor).then(function(response){
			$scope.data.fabricante.razon_social = response.data.razon;
			$scope.data.fabricante.cif = response.data.nif;
			$scope.data.fabricante.direccion = response.data.direccion;
			$scope.data.fabricante.cp = response.data.cpostal;
			$scope.data.fabricante.localidad = response.data.poblacion;
			$scope.data.fabricante.provincia = response.data.provincia;
			$scope.data.fabricante.pais = response.data.pais;
			$scope.data.fabricante.telefono = response.data.telefono;
			$scope.data.fabricante.email = response.data.email;
		}, function(error){
			ixStatusService.setResponse(error);
		});
	};

	$scope.$on('$destroy', function () {
    if ($scope.data.gridPlantas)
      $scope.data.gridPlantas.ixSaveConfig();
		if ($scope.data.gridCertificadosFabricante)
      $scope.data.gridCertificadosFabricante.ixSaveConfig();
    //$scope.isDestroyed = true;
  });

}]);

/*global ixFiltersToArray*/
/*global saveAs*/
"use strict";

angular.module('FTBonpreuApp').controller('ListadoProductosRecepcionController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'authService', 'ixUtilsService','$translate', '$window', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, authService, ixUtilsService, $translate, $window) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;

  if (!$scope.data.filtro) $scope.data.filtro = {};
	if(angular.isUndefined($scope.filterStatus))
		$scope.filterStatus = { isCollapsed: true };

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {
    if (!$scope.data.gridProductos){
      var acciones = [
        {
          title: $translate.instant('Visualizar'),
          icon: 'fa-file-text',
          accion: function(entity){
            //$scope.openVistaRecepcion(entity);
            //$scope.imprimirRecepcion(entity);
						$scope.abrirHTML(entity);
          }
        }
				// {
				// 	title: $translate.instant("Imprimir"),
				// 	icon: 'fa-file-pdf-o',
        //   accion: function(entity){
        //     $scope.imprimirRecepcion(entity);
        //   }
				// }
      ];
      var metadata = [];

      $scope.data.gridProductos = gridService.createGrid($scope, 'Grid_productos_recepcion', { metadata: metadata }, 'listado_bp_recepcionVM', [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }] );
      //$scope.data.gridProductos.entity = "listado_bp_recepcion";
    }
    else {
      $scope.data.gridProductos = gridService.createGridFunctions($scope, $scope.data.gridProductos);
      $scope.data.gridProductos.ixRestoreConfig();
    }

    $scope.ixDownloadExcel = $scope.data.gridProductos.ixDownloadExcel;

    $scope.ixFiltrar(); //Cargo el grid

		$scope.$on("$destroy", function() {
			$scope.data.gridProductos.ixSaveConfig();
			$scope.isDestroyed=true;
		});
  };

  $scope.imprimirRecepcion = function(entity){
    var config = { responseType: 'arraybuffer' };
    $http.get(cfg.baseURL + "impresosBp/ImpresoRecepcionFt?idft=" + entity.id + "&docformat=PDF", config).then(function (response) {
      var file = new Blob([response.data], { type: 'application/pdf' });
      var filename = "ImpresoRecepcioProducte_" + entity.CodInterno + ".pdf";
      if (response.headers('Content-Disposition')) {
				filename = response.headers('Content-Disposition').split("=")[1];
      saveAs(file, filename);
			}
    }, function(error){
      ixStatusService.setResponse(error);
    });
  };
	
	$scope.abrirHTML = function(entity){
		var id_ft = entity.id;
		$http.get(cfg.baseURL + "recepcion_bp?id_ft=" + id_ft).then(function(response){
			//TODO: Dar tratamiento a toda la info que nos llega.
			var data = response.data;
			var cabecera = data.cabecera[0];
			var base64_image = data.imagen_cabecera;
			var base64_image_arr = data.imagenes_ficha;
			
			var html = "<html><head><style>html * {font-family: Verdana, Arial, sans-serif; }</style><div id='container' style='padding: 0px 34px; font-family: Verdana, Arial, sans-serif'>"
				html += "<div style='color:white;border: 1px solid #a03033;background-color: #a03033;border-radius: 15px 0px 15px 0px;'>";
					html += "<div style='width: 66%;display: inline-block;'>";
						html += "<H1 style='text-align: center;'>FITXA DE CONTROL PRODUCTES</H1>";
					html += "</div>";
					html += "<div style='width: 32%;display: inline-block;'>"
						html += "<img src='data:image/png;base64, " + data.imagen_logo + "' alt='Red dot' />";
					html += "</div>";
				html += "</div>";
				
				html += "<div class='row'>";
					html += "<div style='width: 66%;display: inline-block;'>";
						html += "<h4 style='margin: 10px 0 0 0;font-size: 19px;'><b>" + cabecera.lbl_desc_producto + ": <span style='font-size: 30px;'>" + cabecera.desc_producto + "</span></b></h4>";
						html += "<h4 style='margin: 10px 0 0 0;font-size: 19px;'><b>" + cabecera.lbl_cod_producto + ":</b> <span style='font-weight: 100;font-size: 19px;'>" + (cabecera.cod_producto || '') + "</span></h4>";
						html += "<h4 style='margin: 10px 0 0 0;font-size: 19px;'><b>" + cabecera.lbl_marca + ":</b> <span style='font-weight: 100;font-size: 19px;'>" + (cabecera.marca || '') + "</span></h4>";
						html += "<h4 style='margin: 10px 0 0 0;font-size: 19px;'><b>" + cabecera.lbl_ean + ":</b> <span style='font-weight: 100;font-size: 19px;'>" + (cabecera.ean || '') + "</span></h4>";
					html += "</div>";
					html += "<div style='width: 33%;display: inline-block;'>";
						html += "<h4 style='margin: 10px 0 0 0;font-size: 19px;'><b>" + cabecera.lbl_id_ficha_tecnica + ":</b> <span style='font-weight: 100;font-size: 19px;'>" + cabecera.id_ficha_tecnica + "</span></h4>";
						html += "<h4 style='margin: 10px 0 0 0;font-size: 19px;'><b>" + cabecera.lbl_fecha_alta + ":</b> <span style='font-weight: 100;font-size: 19px;'>" + $filter("date")(cabecera.fecha_alta, cfg.dateFormat) + "</span></h4>";
						if (cabecera.fecha_aprobada){
							html += "<h4 style='margin: 10px 0 0 0;font-size: 19px;'><b>" + cabecera.lbl_fecha_aprobada + ":</b> <span style='font-weight: 100;font-size: 19px;'>" + $filter("date")(cabecera.fecha_aprobada, cfg.dateFormat) + "</span></h4>";
						}
						if (cabecera.fecha_revision){
							html += "<h4 style='margin: 10px 0 0 0;font-size: 19px;'><b>" + cabecera.lbl_fecha_revision + ":</b> <span style='font-weight: 100;font-size: 19px;'>" + $filter("date")(cabecera.fecha_revision, cfg.dateFormat) + "</span></h4>";
						}
						html += "<h4 style='margin: 10px 0 0 0;font-size: 19px;'><b>" + cabecera.lbl_nombre_proveedor + ":</b> <span style='font-weight: 100;font-size: 19px;'>" + (cabecera.nombre_proveedor || '') + "</span></h4>";
					html += "</div>";
				html += "</div>";

				if (cabecera.mensaje_recepcion){
					html += "<div style='width: 66%;display: inline-block;'>";
						html += "<p style='margin: 30px 0 0 0;font-weight: bold;font-size: 19px;'>" + cabecera.lbl_mensaje_recepcion + ":</p>";
						html += "<p>" + cabecera.mensaje_recepcion + "</p>";
					html += "</div>";
				}

				if(base64_image){
					html += "<div style='width: 33%;display: inline-block;'>";
						html += "<img src='data:image/png;base64, " + base64_image + "' alt='Red dot' />";
					html += "</div>";
				}

			var currentN1 = 0;
			var currentN2 = 0;
			var currentN3 = 0;
			for(var i = 0; i < data.respuestas.length; i++)
			{
				if (currentN1 != data.respuestas[i].nivel1 || currentN2 != data.respuestas[i].nivel2 || currentN3 != data.respuestas[i].nivel3){
					html = $scope.montarCabeceraNivelHTML(html, data.respuestas[i]);
					currentN1 = data.respuestas[i].nivel1;
					currentN2 = data.respuestas[i].nivel2;
					currentN3 = data.respuestas[i].nivel3;
				}

				if (data.respuestas[i].bucle == 1){
					var respuestas_arr = data.respuestas_bucle.filter(function(e){ return e.id_pregunta == data.respuestas[i].id_pregunta; }); 
					html = $scope.montarRespuestaTablaHTML(html, respuestas_arr);
				}
				else {
					html = $scope.montarRespuestaHTML(html, data.respuestas[i]);
				}
			}

			if(base64_image_arr.length > 0){
				html += "<div style='line-height: 25px;color:white;background-color: #a03033;'>";
					html += "<h4>FOTOS</h4>";
				html += "</div>";
	
				html = $scope.montarImagenesHTML(html, base64_image_arr);
			}
				

			html += "</div></html>";
			var tab = $window.open('about:blank', '_blank');
			tab.document.write(html);
		});
	};
	

	$scope.montarCabeceraNivelHTML = function(html, respuesta){
		html += "<div style='line-height: 25px;color:white;background-color: #a03033;'>";
			html += "<h4>" + respuesta.nivel_nombre + "</h4>";
		html += "</div>";

		return html;
	};


	$scope.montarRespuestaHTML = function(html, respuesta){
		if(respuesta.valor){
			html += "<div style='line-height: 25px;width: 33%;display: inline-block;'>";
				html += "<span><b>" + respuesta.pregunta + "</b></span>";
			html += "</div>";
			html += "<div style='line-height: 25px;width: 66%;display: inline-block;'>";
				html += "<span>" + respuesta.valor + "</span>";
			html += "</div>";
		}
		return html;
	};


	$scope.montarRespuestaTablaHTML_OLdWebSite = function(html, respuestas){
		var respuesta = respuestas[0];
		if(respuesta.valor){
			html += "<table class='table table-bordered'>";
				html += "<thead class='tableHeadForPrint'>"
					html += "<tr>";
						html += ((respuesta.pregunta) ? "<th>" + respuesta.pregunta + "</th>" : "");
						html += ((respuesta.sp1) ? "<th>" + respuesta.sp1 + "</th>" : "");
						html += ((respuesta.sp2) ? "<th>" + respuesta.sp2 + "</th>" : "");
						html += ((respuesta.sp3) ? "<th>" + respuesta.sp3 + "</th>" : "");
						html += ((respuesta.sp4) ? "<th>" + respuesta.sp4 + "</th>" : "");
						html += ((respuesta.sp5) ? "<th>" + respuesta.sp5 + "</th>" : "");
						html += ((respuesta.sp6) ? "<th>" + respuesta.sp6 + "</th>" : "");
						html += ((respuesta.sp7) ? "<th>" + respuesta.sp7 + "</th>" : "");
						html += ((respuesta.sp8) ? "<th>" + respuesta.sp8 + "</th>" : "");
					html += "</tr>";
				html += "</thead>"
			
				html += "<tbody>";
					angular.forEach(respuestas, function(resp){
						html += "<tr>";
							html += "<td style='word-wrap: break-word;'>" + resp.valor + "</td>";
							html += ((resp.sp1) ? "<td style='word-wrap: break-word;'>" + (resp.sr1 || '') + "</td>" : "");
							html += ((resp.sp2) ? "<td style='word-wrap: break-word;'>" + (resp.sr2 || '') + "</td>" : "");
							html += ((resp.sp3) ? "<td style='word-wrap: break-word;'>" + (resp.sr3 || '') + "</td>" : "");
							html += ((resp.sp4) ? "<td style='word-wrap: break-word;'>" + (resp.sr4 || '') + "</td>" : "");
							html += ((resp.sp5) ? "<td style='word-wrap: break-word;'>" + (resp.sr5 || '') + "</td>" : "");
							html += ((resp.sp6) ? "<td style='word-wrap: break-word;'>" + (resp.sr6 || '') + "</td>" : "");
							html += ((resp.sp7) ? "<td style='word-wrap: break-word;'>" + (resp.sr7 || '') + "</td>" : "");
							html += ((resp.sp8) ? "<td style='word-wrap: break-word;'>" + (resp.sr8 || '') + "</td>" : "");
						html += "</tr>";	
					});
				html += "</tbody>";
			html += "</table>";
			html += "<br/>"
		}
		return html;
	};


	//Estilo propuesto por Arnau
	$scope.montarRespuestaTablaHTML = function(html, respuestas){
		var respuesta = respuestas[0];
		if(respuesta.valor){
			html += "<table style='border-collapse: collapse;'>";
				html += "<tr>";
					html += ((respuesta.pregunta) ? "<th style='padding: 8px;border:1px solid gray;'>" + respuesta.pregunta + "</th>" : "");
					html += ((respuesta.sp1) ? "<th style='padding: 8px;border:1px solid gray;'>" + respuesta.sp1 + "</th>" : "");
					html += ((respuesta.sp2) ? "<th style='padding: 8px;border:1px solid gray;'>" + respuesta.sp2 + "</th>" : "");
					html += ((respuesta.sp3) ? "<th style='padding: 8px;border:1px solid gray;'>" + respuesta.sp3 + "</th>" : "");
					html += ((respuesta.sp4) ? "<th style='padding: 8px;border:1px solid gray;'>" + respuesta.sp4 + "</th>" : "");
					html += ((respuesta.sp5) ? "<th style='padding: 8px;border:1px solid gray;'>" + respuesta.sp5 + "</th>" : "");
					html += ((respuesta.sp6) ? "<th style='padding: 8px;border:1px solid gray;'>" + respuesta.sp6 + "</th>" : "");
					html += ((respuesta.sp7) ? "<th style='padding: 8px;border:1px solid gray;'>" + respuesta.sp7 + "</th>" : "");
					html += ((respuesta.sp8) ? "<th style='padding: 8px;border:1px solid gray;'>" + respuesta.sp8 + "</th>" : "");
				html += "</tr>";
			
			angular.forEach(respuestas, function(resp){
				html += "<tr>";
					html += "<td style='padding: 8px;border:1px solid gray;'>" + resp.valor + "</td>";
					html += ((resp.sp1) ? "<td style='padding: 8px;border:1px solid gray;'>" + (resp.sr1 || '') + "</td>" : "");
					html += ((resp.sp2) ? "<td style='padding: 8px;border:1px solid gray;'>" + (resp.sr2 || '') + "</td>" : "");
					html += ((resp.sp3) ? "<td style='padding: 8px;border:1px solid gray;'>" + (resp.sr3 || '') + "</td>" : "");
					html += ((resp.sp4) ? "<td style='padding: 8px;border:1px solid gray;'>" + (resp.sr4 || '') + "</td>" : "");
					html += ((resp.sp5) ? "<td style='padding: 8px;border:1px solid gray;'>" + (resp.sr5 || '') + "</td>" : "");
					html += ((resp.sp6) ? "<td style='padding: 8px;border:1px solid gray;'>" + (resp.sr6 || '') + "</td>" : "");
					html += ((resp.sp7) ? "<td style='padding: 8px;border:1px solid gray;'>" + (resp.sr7 || '') + "</td>" : "");
					html += ((resp.sp8) ? "<td style='padding: 8px;border:1px solid gray;'>" + (resp.sr8 || '') + "</td>" : "");
				html += "</tr>";	
			});
			html += "</table>";
			html += "<br/>"
		}
		return html;
	};

	$scope.montarImagenesHTML = function(html, base64_image_arr){
		angular.forEach(base64_image_arr, function(base64_image){
			html += "<div style='width: 50%;display: inline-block;'>";
				html += "<img src='data:image/png;base64, " + base64_image + "' />";
			html += "</div>";
		});
		return html;
	}


  $scope.openVistaRecepcion = function(entity){
    var app = {};
    app.icon = 'perm_device_information';
    app.display = 'Ficha de control productes';

    app.href = "Recepcion/Vista";
    app.atributos = { id_ficha_tecnica: entity.id };
    app.multiple = true;

    // if((entity.idioma) && entity.idioma != idioma){
    //   app.atributos.idioma = idioma;
    // }

    // if(angular.isDefined($scope.informativeDialog))
    //   $scope.informativeDialog.close();

    ixStatusService.openApp(app).bind(ixStatusService);
};


  $scope.ixFiltrar = function (){
    $scope.filterStatus.isCollapsed = false;

    if (!$scope.data.filtro.estado || $scope.data.filtro.estado.length == 0) {
      $scope.data.filtro.estado = ["A", "B", "C", "E", "I", "L", "M", "N", "P", "R", "O", "Q", "S"];
    }
  
    $scope.data.gridProductos.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["tipo_ft", "estado", "marca", "proveedor", "departamento", "busqueda_generica"]);
    $scope.data.gridProductos.ixLoadInitialData();
  
    $scope.status.filtered = true;
  };

}]);

"use strict";

angular.module('FTBonpreuApp').controller('ConfigPreguntasRecepcionController', [ '$scope', '$controller', 'ixUtilsService', '$http', 'cfg', 'ixStatusService', 'gridService', function($scope, $controller, ixUtilsService, $http, cfg, ixStatusService, gridService){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function (){
    //Cargar grid
    if(!$scope.data.gridConfigRecepcion){
      //$scope.data.gridConfigRecepcion = gridService.createGrid($scope, 'grid_config_recepcion', { enableCellEdit: true, ixGuardarAction: "ActualizarConfiguracionRecepcion" }, 'config_preguntas_recepcion');
      $scope.data.gridConfigRecepcion = gridService.createGrid($scope, 'grid_config_recepcion', { enableCellEdit: true }, 'config_preguntas_recepcionVM');
      $scope.data.gridConfigRecepcion.entity = "config_preguntas_recepcion";
    }
    else {
      $scope.data.gridConfigRecepcion = gridService.createGridFunctions($scope, $scope.data.gridConfigRecepcion);
      $scope.data.gridConfigRecepcion.ixRestoreConfig();
    }

    $scope.data.gridConfigRecepcion.ixLoadInitialData();

    $scope.ixEditar = $scope.data.gridConfigRecepcion.ixEditar;
    $scope.ixCancelEdit = $scope.data.gridConfigRecepcion.ixCancelEdit;
    $scope.ixGuardar = $scope.data.gridConfigRecepcion.ixGuardar;
    $scope.numberOfChanges = $scope.data.gridConfigRecepcion.numberOfChanges;
  };

	$scope.$on("$destroy", function() {
		$scope.data.gridConfigRecepcion.ixSaveConfig();
		$scope.isDestroyed=true;
	});


// $scope.entity = "config_preguntas_recepcionVM";

  // $scope.ocultaEditar = true;
	// $controller('GridEditorController', { $scope: $scope });
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_ISNULL*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
/*global saveAs*/

angular.module('FTBonpreuApp').controller("ProveedoresBPController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', 'ixUtilsService', 'ixWarningsService', 'authService', '$translate', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, ixUtilsService, ixWarningsService, authService, $translate) {
	$scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

	$scope.data.tituloCabecera = "nombre";
  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

	if (angular.isUndefined($scope.data.current))
		$scope.data.current = {};

	var usuario = authService.authentication.userName;
	$scope.tienePerfilAdminUsrKey = authService.tienePerfilAdmin() || authService.tienePerfilUserKey();

	$scope.showCodProveedor = true;

	$http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
		$scope.extranetUser = response.data;
		if (($scope.extranetUser.cliente != null && !$scope.tienePerfilAdminUsrKey) || $scope.extranetUser.comprador) {
			$scope.ixEditar = undefined;
			$scope.status.editing = false;
			$scope.$parent.$parent.$parent.addNewItem = undefined;
		}
		if ($scope.extranetUser.proveedor != null) {
		 	//$scope.blockMainDetails = true;
			 $scope.showCodProveedor = false;
			 $scope.data.ocultaExportarList = true;
			 $scope.$parent.$parent.$parent.addNewItem = undefined;
		 }
	}, function (error) {
		ixStatusService.setResponse(error);
	});

	if (!$scope.data.metadataForm) {
		$scope.loadMetadata("proveedores");
	}

	if (angular.isUndefined($scope.data.activeTab)) {
		$scope.data.activeTab = 0;
	}

	$scope.data.pk = "proveedor";
	$scope.data.useModel = true;
	$scope.data.fieldsToOrderBy = ["nombre ASC"];
	$scope.data.fieldsToFilter = ["nombre", "razon"];

	$scope.$parent.filters[0].onNew = function () {
		var nuevo = {};
		nuevo[$scope.data.pk] = "0";
		nuevo.isNew = true;
		$scope.data.datos = {};
		$scope.data.datos = nuevo;

		$scope.crearGridFabricantes();
		$scope.crearGridFicheros();
		$scope.crearGridComentarios();

		return nuevo;
	};


	$scope.$watch('current', function (current) {
		if (!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
			if (angular.isDefined($scope.data.activeTab)){
				switch($scope.data.activeTab){
					case 1:
						if (angular.isDefined($scope.data.gridFabricantes)) $scope.data.gridFabricantes.ixSaveConfig();
						break;
					case 2:
						if (angular.isDefined($scope.data.gridFicheros)) $scope.data.gridFicheros.ixSaveConfig();
						break;
					case 3:
						if (angular.isDefined($scope.data.gridComentarios)) $scope.data.gridComentarios.ixSaveConfig();
						break;
					default:
						break;
				}
			}
			$http.get(cfg.baseURL + "proveedores/" + current[$scope.data.pk]).then(function (response) {
				response.data = corregirTiposProveedor(response.data);
				$scope.data.datos = response.data;
				$scope.data.datosOriginales = angular.copy(response.data);
				$scope.data.current = response.data;

				$scope.crearGridFabricantes();
				$scope.crearGridFicheros();
				$scope.crearGridComentarios();

			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
	}, true);

	//Preguntar a Arnau si es correcto mantener las lineas 93-97
	if (angular.isDefined($routeParams.id)) {
		//$scope.current = {};
		$scope.current[$scope.data.pk] = $routeParams.id;
	}
	if (angular.isDefined($routeParams.proveedor)) {
		//$scope.current = {};
		$scope.current[$scope.data.pk] = $routeParams.proveedor;
	}

	$scope.actualizarListado();

	$scope.loadTiposProveedor = function () {
		var deferred = $q.defer();
		$timeout(function () {
			//ALIMENTACIÓ, NO ALIMENTACIÓ, COSMÈTICA, DROGUERIA
			var list = [
				{ tipo: "ALIMENTACIÓ" },
				{ tipo: "NO ALIMENTACIÓ" },
				{ tipo: "COSMÈTICA" },
				{ tipo: "DROGUERIA" }
			];
			return deferred.resolve({ data: list });
		}, 1);
		return deferred.promise;

	};


	$scope.loadAreasProveedor = function () {
		var deferred = $q.defer();
		$timeout(function () {
			//MARCA PROPIA BP, MARCA PROPIA IFA, CARNISSERIA, FRUITA, FLECA, PEIXATERIA
			var list = [
				{ area: "MARCA PROPIA BP" },
				{ area: "MARCA PROPIA IFA" },
				{ area: "CARNISSERIA" },
				{ area: "FRUITA" },
				{ area: "FLECA" },
				{ area: "PEIXATERIA "},
				{ area: "BONPROFIT"},
				{ area: "MARCA PROPIA BP + BONPROFIT"}
			];
			return deferred.resolve({ data: list });
		}, 1);
		return deferred.promise;

	};


	$scope.ixGuardar = function () {
		if ($scope.data.datos.isNew) {
			//En el caso de que se haya especificado el/los tipo(s) hay que transformar el dato en cadena separada por comas
			var np = angular.copy($scope.data.datos);
			if (np.tipo){
				np.tipo = np.tipo.join();
			}
			$http.post(cfg.baseURL + "proveedores", np).then(function (r) {
				delete $scope.data.datos.isNew;
				r.data.obj.Record = corregirTiposProveedor(r.data.obj.Record);
				ixStatusService.setResponse(r);
				//TODO: ¿Recargar datos del grid ficheros? Para actualizar eventales cambios en el estado activo/caducado del fichero
				ixStatusService.setEditing(false);
				$scope.data.datos = r.data.obj.Record;
				$scope.data.datosOriginales = angular.copy($scope.data.datos);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		} 
		else {
			var data = {};
			//OJO: En este caso en la API se realizará el control y transformación en la eventualidad que se modifique el campo tipo (array --> cadena separada por comas)
			data.jpdProveedor = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
			data.ubpFabricantes = $scope.data.gridFabricantes.ixGetBulkParam();
			data.ubpFicheros = $scope.data.gridFicheros.ixGetBulkParam();
			data.ubpComentarios = $scope.data.gridComentarios.ixGetBulkParam();
			
			$http.put(cfg.baseURL + "proveedores/PutProveedor/" + $scope.data.datos.proveedor, data).then(function (r) {
				r.data.obj.Record = corregirTiposProveedor(r.data.obj.Record);

				ixStatusService.setResponse(r);
				ixStatusService.setEditing(false);

				if (angular.isDefined($scope.data.gridFabricantes.gridApi))
					$scope.data.gridFabricantes.clearGridAfterSave();
				if (angular.isDefined($scope.data.gridFicheros.gridApi))
					$scope.data.gridFicheros.clearGridAfterSave();
				if (angular.isDefined($scope.data.gridComentarios.gridApi))
					$scope.data.gridComentarios.clearGridAfterSave();
				$scope.ixCancelEdit();
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
	};

	$scope.eliminarProveedor = function () {
		var frase = "Se va a eliminar el proveedor " + $scope.data.datos.nombre + " ¿Desea continuar?";
		ixWarningsService.warningConfirmacion($scope, frase, accionEliminar);
	};


	var accionEliminar = function () {
		$http.delete(cfg.baseURL + "proveedores/" + $scope.data.datos[$scope.data.pk]).then(function (r) {
			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);

			$scope.data.datos = {};
			$scope.data.gridFabricantes.data = {};
			// $scope.data.gridCertificadosProveedor.data = {};
			$scope.data.gridFicheros.data = {};

			$scope.ixCancelEdit();
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	};

	if ($scope.tienePerfilAdminUsrKey){
		$scope.ixDeleteSelectedRows = $scope.eliminarProveedor;
	}
	else {
		$scope.ixDeleteSelectedRows = undefined;
		$scope.data.ocultaExportarList = true;
	}

	$scope.changeTab = function (tabIdx) {
		if (angular.isDefined($scope.data.gridFabricantes) && $scope.data.activeTab == 1) 
			$scope.data.gridFabricantes.ixSaveConfig();
		if (angular.isDefined($scope.data.gridFicheros) && $scope.data.activeTab == 2) 
			$scope.data.gridFicheros.ixSaveConfig();
		if (angular.isDefined($scope.data.gridComentarios) && $scope.data.activeTab == 3)
			$scope.data.gridComentarios.ixSaveConfig();
		
		$scope.data.activeTab = tabIdx;

		if (angular.isDefined($scope.data.gridFabricantes) && $scope.data.activeTab == 1)
			$scope.data.gridFabricantes.ixRestoreConfig();
		if (angular.isDefined($scope.data.gridFicheros) && $scope.data.activeTab == 2)
			$scope.data.gridFicheros.ixRestoreConfig();
		if (angular.isDefined($scope.data.gridComentarios) && $scope.data.activeTab == 3)
			$scope.data.gridComentarios.ixRestoreConfig();
	};


	$scope.crearGridFabricantes = function () {
		// var metadata = [
		// 	{ Name: "reg_sanitario", NoVisible: true },
		// 	{ Name: "fax", NoVisible: true },
		// 	{ Name: "acreditaciones_certificados", NoVisible: true },
		// 	{ Name: "cif", ColumnDescription: "NIF" }
		// ];
		var metadata = [];
		var filtroFabricantes = [];
		if (!$scope.data.gridFabricantes) {
			var acciones = [
				{
					icon: "fa-search",
					title: $translate.instant('Fabricante'), // "Fabricante",
					visible: function (entity) {
						return true;//!$scope.data.datos.isNew;
					},
					accion: function (entity) {
						abrirPopupFabricante(entity, false);
					}
				}
			];
			//$scope.data.gridFabricantes = gridService.createGrid($scope, 'gnet_grid_proveedores_fabricantes', { minRowsToShow: 5, metadata: metadata }, "fabricantes", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
			var rowTemplate2 = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.activo == 0), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
			$scope.data.gridFabricantes = gridService.createGrid($scope, 'gnet_grid_proveedores_fabricantes', { minRowsToShow: 5, metadata: metadata }, "fabricantes_bpVM", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
			$scope.data.gridFabricantes.rowTemplate = rowTemplate2;
			filtroFabricantes = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFabricantes.filtroExterno = filtroFabricantes;
			$scope.data.gridFabricantes.ixLoadInitialData();
		} else {
			$scope.data.gridFabricantes = gridService.createGridFunctions($scope, $scope.data.gridFabricantes);
			$scope.data.gridFabricantes.ixRestoreConfig();
			filtroFabricantes = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFabricantes.filtroExterno = filtroFabricantes;
			$scope.data.gridFabricantes.ixLoadInitialData();
		}
	};


	$scope.crearGridFicheros = function () {
		var metadata = [
			{
				Name: "fecha_caducidad",
				Sort:
				{
					direction: uiGridConstants.DESC,
					ignoreSort: false,
					priority: 0
				}
			},
			{ Name: "fabricante", ColumnDescription: "Nombre Empresa" },
			{ Name: "planta", ColumnDescription: "Nombre planta" }, //$translate.instant('Nombre planta')
			{ Name: "archivo", NoEditable: true },
			{ Name: "fecha_carga", NoEditable: true }
		];
		var filtroFicheros = [];
		if (!$scope.data.gridFicheros) {
			var acciones = [
				{
					title: $translate.instant('Previsualizar PDF'),
					icon: "fa-file-pdf-o",
					visible: function (entity) {
						return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
					},
					accion: function (entity) {
						var tabla = "proveedores_ficheros";
						$http({
							method: 'post',
							url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
							headers: {},
							responseType: 'arraybuffer'
						}).then(function (r) {
							$scope.selectedPDF = new Uint8Array(r.data);
							$scope.idFicheroPreview = entity.id;
							var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
							ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
						},
							function (err) {
								ixStatusService.setResponse(err);
							});
					}
				},
				{
					title:  $translate.instant('Previsualizar Imagen'),
					icon: "fa-file-image-o",
					visible: function (entity) {
						return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
					},
					accion: function (entity) {
						var tabla = "proveedores_ficheros";
						$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
							$scope.selectedImage = r.data;
							$scope.idFicheroPreview = entity.id;
							var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
							ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
						},
							function (err) {
								ixStatusService.setResponse(err);
							});
					}
				},
				{
					title:  $translate.instant('Descargar fichero'),
					icon: "fa-download",
					visible: function (entity) {
						return entity.archivo;
					},
					accion: function (entity) {
						var esProveedor = angular.isDefined(entity.proveedor);
						$scope.downloadFile(entity.id, esProveedor);
					}
				},
				{
					title:  $translate.instant('Editar fichero'),
					icon: "fa-pencil",
					visible: function(){
						return $scope.status.editing;
					},
					accion: function(entity) {
						var urlTemplate = "app/FTBonpreu/MantenimientosBP/proveedores/modales/popupFicheroProveedor.html";
						var controllerName = "PopupFicheroProveedorController";
						var optionsPopupEditarArchivo = {
							controller: controllerName
						};
						var params = { "id_fichero": entity.id, "id_proveedor": entity.proveedor, nombre_proveedor: entity.proveedornombre, "mantenimiento_proveedor": true };
						var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupEditarArchivo, 'small', params);
						modalInstance.then(function (resp) {
							if (resp){
							// Recargar grid de ficheros
							$scope.data.gridFicheros.ixLoadInitialData();
							}
						});
					}
				}
			];
			
			var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.activo == 0), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
			$scope.data.gridFicheros = gridService.createGrid($scope, 'gnet_grid_proveedores_ficheros', { minRowsToShow: 5, metadata: metadata, showOnlyDescribedCols: ["grupo", "fabricante", "planta", "archivo", "tipo", "fecha_carga", "inicio_validez", "fecha_caducidad", "activo"] }, "proveedores_ficheros", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
			$scope.data.gridFicheros.rowTemplate = rowTemplate;
			filtroFicheros = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFicheros.filtroExterno = filtroFicheros;
			$scope.data.gridFicheros.ixLoadInitialData();
		} else {
			$scope.data.gridFicheros = gridService.createGridFunctions($scope, $scope.data.gridFicheros);
			$scope.data.gridFicheros.ixRestoreConfig();
			filtroFicheros = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFicheros.filtroExterno = filtroFicheros;
			$scope.data.gridFicheros.ixLoadInitialData();
		}
	};

	$scope.crearGridComentarios = function() {
		var metadata = [
			{
				Name: "fecha",
				Sort:
				{
					direction: uiGridConstants.DESC,
					ignoreSort: false,
					priority: 0
				}
			}
		];

		if (!$scope.data.gridComentarios){
			$scope.data.gridComentarios = gridService.createGrid($scope, 'gnet_grid_proveedores_comentarios', { metadata: metadata }, "notas_proveedores");
		}
		else {
			$scope.data.gridComentarios = gridService.createGridFunctions($scope, $scope.data.gridComentarios);
			$scope.data.gridComentarios.ixRestoreConfig();
		}
		$scope.data.gridComentarios.filtroExterno = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
		$scope.data.gridComentarios.ixLoadInitialData();
};


	$scope.deleteSelectedRows = function (grid) {
		grid.ixDeleteSelectedRows();
	};


	$scope.addRow = function (grid, item) {
		var nuevo = item || {};

		//if (grid.entity == 'fabricantes') {
		if (grid.entity == 'fabricantes_bpVM') {
			nuevo.proveedor = $scope.data.datos.proveedor;
			abrirPopupFabricante(nuevo, true);
		}
		// if (grid.entity == 'proveedores_certificados') {
		// 	nuevo.id = 0;
		// }
		grid.ixAddRow(nuevo);
	};


	$scope.addFicheros = function () {
		var urlTemplate = "app/FTBonpreu/MantenimientosBP/proveedores/modales/popupFicheroProveedor.html";
		var controllerName = "PopupFicheroProveedorController";
		var optionsPopupFicheros = {
			controller: controllerName
		};
		var params = { "id_fichero": 0, "id_proveedor": $scope.data.datos.proveedor, "mantenimiento_proveedor": true };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'small', params);
		modalInstance.then(function (resp) {
			if (resp){
			// Recargar grid de ficheros
			$scope.data.gridFicheros.ixLoadInitialData();
			}
		});
	};


	//Los datos en BBDD se guardan en formato cadena separada por coma.
	//Para poder visualizar correctamente la información en el control ix-select-multiple, tengo que transformar el dato en un array
	var corregirTiposProveedor = function(o){
		if (o.tipo){
			var array = o.tipo.split(',');
			// var jsonTipo = '[';
			// angular.forEach(array, function(e){
			// 	if (jsonTipo != '[') jsonTipo = jsonTipo + ',';
			// 	jsonTipo = jsonTipo + '"' + e + '"';
			// });
			// jsonTipo = jsonTipo + ']';
			// o.tipo = ixUtilsService.fromJson(jsonTipo);
			o.tipo = array;
		}
		
		return o;
	};


	var abrirPopupFabricante = function (entity, isNew, editBlocked) {
		var urlTemplate = "app/FTBonpreu/MantenimientosBP/proveedores/modales/empresasPopup.html";
		var controllerName = "EmpresasPopupController";
		var optionsPopupFabricante = {
			controller: controllerName,
			resolve: {
				// clickedItem: function () {
				// 	return entity;
				// },
				// isNew: function () {
				// 	return isNew;
				// },
				editOnlyFiles: function(){
					return $scope.data.datos.fabricantes_bloqueado;
				}
			}
		};
		var params = { "clickedItem": entity, "isNew": isNew, "editAllowed": $scope.tienePerfilAdminUsrKey || $scope.extranetUser.proveedor != null };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFabricante, 'medium', params);
		modalInstance.then(function (resp) {
			if (resp.isNew || resp.dataModified){
				$scope.data.gridFabricantes.ixLoadInitialData();
				if ($scope.data.gridFicheros.deletedRows.length > 0 || $scope.data.gridComentarios.gridApi.rowEdit.getDirtyRows().length > 0){
					//$scope.data.gridFicheros.deletedRows = [];
					//$scope.data.gridFicheros.ixLoadInitialData();
					$scope.status.editing = true;
				}
			}
			else{
				$scope.status.editing = false;
			}
		});
	};


	$scope.ixCancelEdit = function () {
		if (angular.isDefined($scope.data.gridFabricantes.gridApi))
			$scope.data.gridFabricantes.clearGridAfterSave();
		if (angular.isDefined($scope.data.gridFicheros.gridApi))
			$scope.data.gridFicheros.clearGridAfterSave();
		$scope.$parent.ixCancelEdit();
	};


	$scope.downloadFile = function (id, esProveedor) {
		var entity = (esProveedor) ? "proveedores_ficheros" : "fichas_tecnicas_ficheros";
		$http({
			method: 'post',
			url: cfg.baseURL + entity + '/DownloadFile?id=' + id,
			//headers: { 'Content-type': 'application/pdf' }, //TODEL?
			headers: {},
			responseType: 'arraybuffer'
		}).then(function (r) {
			var mimetype = r.headers('Content-type');
			var file = new Blob([r.data], { type: mimetype });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		},
			function (err) {
				ixStatusService.setResponse(err);
			});
	};

	$scope.$on('$destroy', function () {
    if ($scope.data.gridFabricantes)
      $scope.data.gridFabricantes.ixSaveConfig();
		if ($scope.data.gridFicheros)
      $scope.data.gridFicheros.ixSaveConfig();
		if ($scope.data.gridComentarios)
			$scope.data.gridComentarios.ixSaveConfig();
    $scope.isDestroyed = true;
  });
}]);

/*global simulateAPIError*/
/*global saveAs*/
/*global ixGetPatchOperations*/
/*global CMP_EQ*/

"use strict";

angular.module('FTBonpreuApp').controller('ResultadosAnalisisController', ['$scope', '$http', '$timeout', '$translate', '$uibModalInstance', '$log', '$ngConfirm', 'cfg', 'ixStatusService', 'gridService', 'Upload', 'ixUtilsService', 'authService', function ($scope, $http, $timeout, $translate, $uibModalInstance, $log, $ngConfirm, cfg, ixStatusService, gridService, Upload, ixUtilsService, authService) {
  $scope.status = ixStatusService.current;
  $scope.status.editing = false;
  $scope.maxUploadFileSize = cfg.maxUploadFileSize;
  $scope.uploadingFile = false;

  $scope.data = {};
  $scope.data.isNew = $scope.$resolve.isNew;
  $scope.data.datos_resultado = {};
  $scope.data.info = {};
  $scope.data.modified = false;

  var perfilesUsuario = authService.perfilesUsuario();

  $scope.tienePerfilUserkey = function () {
		return (perfilesUsuario.indexOf("ixnet") >= 0) || (perfilesUsuario.indexOf("usr_bio_userkey") >= 0) || (perfilesUsuario.indexOf("usr_bp_userkey") >= 0);
	};

  //Variables para gestionar visualización resultados Bonpreu
  $scope.showResultsBp_FQ = false;
  $scope.showResultsBp_MICRO = false;
  $scope.showResultsBp_VIDAUTIL = false;
  $scope.showResultsBp_NUTRICIONAL = false;
  $scope.showResultsBp_ALERGENOS = false;
  $scope.showResultsBp_PESO = false;
  $scope.showResultsBp_ORGANOLEPTICO = false;
  $scope.showResultsBp_ETIQUETADO = false;
  $scope.showResultsBp_RESIDUOS = false;
  $scope.showResultsBp_OTROS = false;

  var buildGridBoletines = function () {
    if (!$scope.data.gridBoletines) {
      var acciones = [
        {
          title: $translate.instant("Descargar fichero"),
          icon: "fa-download",
          visible: function (entity) {
            return entity.archivo;
          },
          accion: function (entity) {
            $scope.downloadFile(entity);
          }
        }
      ];
      var metadata = [];

      $scope.data.gridBoletines = gridService.createGrid($scope, "grid_boletines_resultados", { minRowsToShow: 4, enableCellEdit: false, showOnlyDescribedCols: ["archivo"] }, "boletines_analisis", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
      $scope.data.gridBoletines.filtroExterno = [{ Field: "id_analisis", Operator: CMP_EQ, Value: $scope.data.datos_resultado.id }];
      $scope.data.gridBoletines.ixLoadInitialData();
    }
    else {
      $scope.data.gridBoletines = gridService.createGridFunctions($scope, $scope.data.gridBoletines);
      $scope.data.gridBoletines.ixRestoreConfig();
    }
  };


  if ($scope.data.isNew) {
    $scope.data.datos_resultado.id_ficha_tecnica = $scope.$resolve.id_ficha_tecnica;
    $scope.data.datos_resultado.cod_articulo = $scope.$resolve.cod_articulo;
    $scope.data.datos_resultado.proveedor = $scope.$resolve.proveedor;
    $scope.data.datos_resultado.laboratorio = $scope.$resolve.laboratorio;
    $scope.data.datos_resultado.tipo_analisis = $scope.$resolve.tipo_analisis;
    $scope.data.info.id_analisis_extra = $scope.$resolve.id_analisis_extra;
    $scope.data.es_extra = $scope.$resolve.es_extra;
    $scope.data.datos_resultado.finalizada = 0;
    $scope.data.datos_resultado.boletin_enviado = 0;

    var idft = $scope.data.datos_resultado.id_ficha_tecnica.replace("/", "-");
    $http.get(cfg.baseURL + "extranet_fichas_tecnicas/" + idft).then(function (response) {
      $scope.data.info.desc_articulo = response.data.titulo;
      $scope.data.info.ean = response.data.ean;
      $scope.data.info.marca = response.data.marca;

      $scope.status.editing = true;
      $scope.save = $scope.guardarDatos;
    },
      function (error) {
        $log.log(error);

      });
  }
  else {
    $scope.data.datos_resultado.id = $scope.$resolve.id;

    $http.get(cfg.baseURL + "resultados_analisis/" + $scope.data.datos_resultado.id).then(function (response) {
      $scope.data.datos_resultado = angular.copy(response.data);
      //Guardo los valores originales
      $scope.data.datos_resultado_originales = angular.copy($scope.data.datos_resultado);

      if ($scope.data.datos_resultado.finalizada == 0 || $scope.tienePerfilUserkey()){
        $scope.status.editing = true;
        $scope.save = $scope.guardarDatos;

        if ($scope.tienePerfilUserkey()){
          if ($scope.data.datos_resultado.resultado2_fq)
            $scope.showResultsBp_FQ = true;
          if ($scope.data.datos_resultado.resultado2_micro)
            $scope.showResultsBp_MICRO = true;
          if ($scope.data.datos_resultado.resultado2_vidautil)
            $scope.showResultsBp_VIDAUTIL = true;
          if ($scope.data.datos_resultado.resultado2_nutricional)
            $scope.showResultsBp_NUTRICIONAL = true;
          if ($scope.data.datos_resultado.resultado2_alergenos)
            $scope.showResultsBp_ALERGENOS = true;
          if ($scope.data.datos_resultado.resultado2_peso)
            $scope.showResultsBp_PESO = true;
          if ($scope.data.datos_resultado.resultado2_organoleptico)
            $scope.showResultsBp_ORGANOLEPTICO = true;
          if ($scope.data.datos_resultado.resultado2_etiquetado)
            $scope.showResultsBp_ETIQUETADO = true;
          if ($scope.data.datos_resultado.resultado2_residuos)
            $scope.showResultsBp_RESIDUOS = true;
          if ($scope.data.datos_resultado.resultado2_otros)
            $scope.showResultsBp_OTROS = true;
        }
      }
      else{
        $scope.status.editing = false;
        $scope.save = undefined;
      }
        

      //Obtengo data.info
      var idft = $scope.data.datos_resultado.id_ficha_tecnica.replace("/", "-");
      $http.get(cfg.baseURL + "extranet_fichas_tecnicas/" + idft).then(function (response) {
        $scope.data.info.desc_articulo = response.data.titulo;
        $scope.data.info.ean = response.data.ean;
        $scope.data.info.marca = response.data.marca;
  
        // if ($scope.data.datos_resultado.finalizada == 0){
        //   $scope.status.editing = true;
        //   $scope.save = $scope.guardarDatos;
        // }
        // else{
        //   $scope.status.editing = false;
        //   $scope.save = undefined;
        // }
      },
        function (error) {
          $log.log(error);
  
        });
  
      ixStatusService.setResponse(response);
    },
      function (error) {
        ixStatusService.setResponse(error);
      });

    buildGridBoletines();
  }

  $scope.downloadFile = function (entity) {
    $http({
      method: 'post',
      url: cfg.baseURL + 'boletines_analisis/DownloadFile?id=' + entity.id,
      headers: {},
      responseType: 'arraybuffer'
    }).then(function (r) {
      var mimetype = r.headers('Content-type');
      var file = new Blob([r.data], { type: mimetype });

      var filename = entity.archivo;
      if (r.headers('Content-Disposition')) {
        //filename = r.headers('Content-Disposition').split("=")[1];
        filename = r.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
      }
      saveAs(file, filename);
    }, function (err) {
      ixStatusService.setResponse(err);
    });
  };


  $scope.enviarBoletin = function () {
    $http.put(cfg.baseURL + "resultados_analisis/EnviarBoletin/" + $scope.data.datos_resultado.id).then(function (response) {
      ixStatusService.setResponse(response);
      $scope.data.datos_resultado = response.data;
    },
      function (err) {
        ixStatusService.setResponse(err);
      });
  };


  $scope.checkValid = function () {
    if (!$scope.data.datos_resultado.resultado_fq &&
      !$scope.data.datos_resultado.resultado_micro &&
      !$scope.data.datos_resultado.resultado_peso &&
      !$scope.data.datos_resultado.resultado_organoleptico &&
      !$scope.data.datos_resultado.resultado_etiquetado &&
      !$scope.data.datos_resultado.resultado_residuos &&
      !$scope.data.datos_resultado.resultado_vidautil &&
      !$scope.data.datos_resultado.resultado_nutricional &&
      !$scope.data.datos_resultado.resultado_alergenos &&
      !$scope.data.datos_resultado.resultado_otros) {
      $scope.form.$invalid = true;

      return;
    }
    else {
      $scope.form.$invalid = false;
      delete $scope.form.$error["Atención"];
    }
  };


  $scope.guardarDatos = function () {
    //Controlar que al menos un resultado se haya cumplimentado
    if (!$scope.data.datos_resultado.resultado_fq &&
      !$scope.data.datos_resultado.resultado_micro &&
      !$scope.data.datos_resultado.resultado_peso &&
      !$scope.data.datos_resultado.resultado_organoleptico &&
      !$scope.data.datos_resultado.resultado_etiquetado &&
      !$scope.data.datos_resultado.resultado_residuos &&
      !$scope.data.datos_resultado.resultado_vidautil &&
      !$scope.data.datos_resultado.resultado_nutricional &&
      !$scope.data.datos_resultado.resultado_alergenos &&
      !$scope.data.datos_resultado.resultado_otros) {

      simulateAPIError($scope.form, "Atención", [{ message: "Es necesario introducir al menos un resultado" }]);
      //  $timeout(function(){
      //   scope.form.$invalid = false;
      //   delete scope.form.$error["atencion"];	
      //  }, 200);

      return;
    }

    if ($scope.data.isNew) {
      var nuevos_datos = {};
      $scope.data.datos_resultado.finalizada = 1; //Fuerzo la finalización
      nuevos_datos.datos_resultado = $scope.data.datos_resultado;
      nuevos_datos.boletines = [];
      angular.forEach($scope.data.boletinesToUpload, function (elem) {
        nuevos_datos.boletines.push(elem.name);
      });
      $log.log(nuevos_datos);
      $http.post(cfg.baseURL + "resultados_analisis", nuevos_datos).then(function (response) {
        $scope.data.datos_resultado.id = response.data.obj.Record.id;
        //Ahora subo el/los archivo/s
        $scope.uploadingFile = true;
        var upload = Upload.upload({
          url: cfg.baseURL + "boletines_analisis/UploadAndCreate",
          data: {
            file: $scope.data.boletinesToUpload,
            id_analisis: $scope.data.datos_resultado.id
          },
          dataType: 'json'
        });

        upload.then(function (response) {
          delete $scope.data.ixProgress;
          $scope.uploadingFile = false;

          //Si todo ha ido bien y los resultados son relativos a una planificación extra, marco la planificación como completada
          if ($scope.data.info.id_analisis_extra) {
            var patch = [];
            patch.push({ value: 1, path: '/completada', op: 'replace' });
            $http.put(cfg.baseURL + "planificacion_analisis_extra_bp/" + $scope.data.info.id_analisis_extra, patch).then(function (response) {
              ixStatusService.setResponse(response);
            },
              function (error) {
                ixStatusService.setResponse(error);
              });
          }

          $scope.data.modified = true;
          ixStatusService.setResponse(response);
          $scope.data.isNew = false;
          if (!$scope.tienePerfilUserkey())
            $scope.status.editing = false;
        },
          function (error) {
            $log.log("Error al subir fichero");
            $log.log(error);
            delete $scope.data.ixProgress;
            $scope.uploadingFile = false;
            //Eliminar el resultado análisis apenas introducido
            $http.delete(cfg.baseURL + "resultados_analisis/" + $scope.data.datos_resultado.id).then(function (response) {
              $scope.data.datos_resultado.id = undefined; //Anulo el ID precedentemente generado
              ixStatusService.setResponse(response);
            },
              function (error) {
                ixStatusService.setResponse(error);
              });
            ixStatusService.setResponse(error);
          },
          function (evt) {
            $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          });
      },
        function (error) {
          ixStatusService.setResponse(error);
        });
    }
    else {
      //Verificar que tenga al menos un fichero
      if ($scope.data.gridBoletines.gridApi.grid.rows.length == 0) {
        simulateAPIError($scope.form, "Atención", [{ message: "Es necesario introducir al menos un boletín" }]);
        return;
      }

      //Editar datos
      var obj = ixGetPatchOperations($scope.data.datos_resultado_originales, $scope.data.datos_resultado);
      //Agrego cambio para finalizar
      obj.push({ value: 1, path: "/finalizada", op: "replace" });

      $http.put(cfg.baseURL + "resultados_analisis/" + $scope.data.datos_resultado.id, obj).then(function (response) {
        $scope.data.modified = true;
        ixStatusService.setResponse(response);
        buildGridBoletines();
        if (!$scope.tienePerfilUserkey())
          $scope.status.editing = false;
      },
        function (error) {
          ixStatusService.setResponse(error);
        });
    }
  };

  $scope.addBoletin = function () {
    //añadir uno o más boletines mediante popup
    var urlTemplate = "app/FTBonpreu/GestionAnaliticasBP/modales/addBoletinesPopup.html";
    var optionsPopupBoletines = { controller: "AddBoletinesPopupController" };
    var params = { id_resultado: $scope.data.datos_resultado.id };
    var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupBoletines, 'small', params);
    modalInstance.then(function (resp) {
      //Si se han agregado boletines, actualizar el grid de boletines
      if (resp) {
        $scope.data.gridBoletines.ixLoadInitialData();
      }
      ixStatusService.setEditing(!$scope.data.datos_resultado.finalizada);
    });
  };


  $scope.deleteSelectedBoletines = function () {
    $scope.data.gridBoletines.ixDeleteSelectedRows();
    var dataToDel = $scope.data.gridBoletines.ixGetBulkParam();
    $http.post(cfg.baseURL + "boletines_analisis/UpdateBulk", dataToDel).then(function (response) {
      //Volver a marcar como finalizado el resultado: ¿se hará en WebApi o obligamos a que se haga click en el guardar?
      //Marcar que se ha modificado el resultado
      $scope.data.modified = true;
      ixStatusService.setResponse(response);
    },
      function (error) {
        ixStatusService.setResponse(error);
      });
  };

  $scope.confirmarEliminarBoletines = function(){
    $ngConfirm({
      icon: 'fa fa-warning',
      title: $translate.instant("¡Atención!"),
      content: $translate.instant("Los boletines seleccionados serán eliminados. ¿Desea continuar?"),
      type: 'red',
			typeAnimated: true,
			closeIcon: false,
      buttons: {
        ok: {
          text: 'Si',
          btnClass: 'btn-ix-green',
          show: 'true',
          action: function () {
            //Llamar WebAPI
            $scope.deleteSelectedBoletines();
            return true;
          }
        },
        cancelar: {
          text: "Cancelar",
          btnClass: 'btn-ix-red',
          show: 'true',
          action: function () {
            //Do Nothing
            return true;
          }
        }
      }
    });
  };


  $scope.visualizarNCBp = function(pmt){
    switch(pmt){
      case 'FQ':
        $scope.showResultsBp_FQ = true;
        break;
      case 'MICRO':
        $scope.showResultsBp_MICRO = true;
        break;
      case 'VIDAUTIL':
        $scope.showResultsBp_VIDAUTIL = true;
        break;
      case 'NUTRICIONAL':
        $scope.showResultsBp_NUTRICIONAL = true;
        break;
      case 'ALERGENOS':
        $scope.showResultsBp_ALERGENOS = true;
        break;
      case 'PESO':
        $scope.showResultsBp_PESO = true;
        break;
      case 'ORGANOLEPTICO':
        $scope.showResultsBp_ORGANOLEPTICO = true;
        break;
      case 'ETIQUETADO':
        $scope.showResultsBp_ETIQUETADO = true;
        break;
      case 'RESIDUOS':
        $scope.showResultsBp_RESIDUOS = true;
        break;
      case 'OTROS':
        $scope.showResultsBp_OTROS = true;
        break;
    }
  };


  $scope.borrarNCBp = function(pmt){
    switch(pmt){
      case 'FQ':
        $scope.data.datos_resultado.resultado2_fq = null;
        $scope.data.datos_resultado.resultado2_fq_obs = null;
        $scope.showResultsBp_FQ = false;
        break;
      case 'MICRO':
        $scope.data.datos_resultado.resultado2_micro = null;
        $scope.data.datos_resultado.resultado2_micro_obs = null;
        $scope.showResultsBp_MICRO = false;
        break;
      case 'VIDAUTIL':
        $scope.data.datos_resultado.resultado2_vidautil = null;
        $scope.data.datos_resultado.resultado2_vidautil_obs = null;
        $scope.showResultsBp_VIDAUTIL = false;
        break;
      case 'NUTRICIONAL':
        $scope.data.datos_resultado.resultado2_nutricional = null;
        $scope.data.datos_resultado.resultado2_nutricional_obs = null;
        $scope.showResultsBp_NUTRICIONAL = false;
        break;
      case 'ALERGENOS':
        $scope.data.datos_resultado.resultado2_alergenos = null;
        $scope.data.datos_resultado.resultado2_alergenos_obs = null;
        $scope.showResultsBp_ALERGENOS = false;
        break;
      case 'PESO':
        $scope.data.datos_resultado.resultado2_peso = null;
        $scope.data.datos_resultado.resultado2_peso_obs = null;
        $scope.showResultsBp_PESO = false;
        break;
      case 'ORGANOLEPTICO':
        $scope.data.datos_resultado.resultado2_organoleptico = null;
        $scope.data.datos_resultado.resultado2_organoleptico_obs = null;
        $scope.showResultsBp_ORGANOLEPTICO = false;
        break;
      case 'ETIQUETADO':
        $scope.data.datos_resultado.resultado2_etiquetado = null;
        $scope.data.datos_resultado.resultado2_etiquetado_obs = null;
        $scope.showResultsBp_ETIQUETADO = false;
        break;
      case 'RESIDUOS':
        $scope.data.datos_resultado.resultado2_residuos = null;
        $scope.data.datos_resultado.resultado2_residuos_obs = null;
        $scope.showResultsBp_RESIDUOS = false;
        break;
      case 'OTROS':
        $scope.data.datos_resultado.resultado2_otros = null;
        $scope.data.datos_resultado.resultado2_otros_obs = null;
        $scope.showResultsBp_OTROS = false;
        break;
    }

  };


  $scope.crearCopia = function () {
    $scope.data.datos_resultado = {};
    $scope.data.boletinesToUpload = [];
    $scope.data.isNew = true;

    $scope.data.datos_resultado.id_ficha_tecnica = $scope.$resolve.id_ficha_tecnica;
    $scope.data.datos_resultado.cod_articulo = $scope.$resolve.cod_articulo;
    $scope.data.datos_resultado.proveedor = $scope.$resolve.proveedor;
    $scope.data.datos_resultado.laboratorio = $scope.$resolve.laboratorio;
    $scope.data.datos_resultado.tipo_analisis = $scope.$resolve.tipo_analisis;
    //$scope.data.info.id_analisis_extra = $scope.$resolve.id_analisis_extra;
    $scope.data.es_extra = true;
    $scope.data.datos_resultado.finalizada = 0;
    $scope.data.datos_resultado.boletin_enviado = 0;

    $scope.showResultsBp_FQ = false;
    $scope.showResultsBp_MICRO = false;
    $scope.showResultsBp_VIDAUTIL = false;
    $scope.showResultsBp_NUTRICIONAL = false;
    $scope.showResultsBp_ALERGENOS = false;
    $scope.showResultsBp_PESO = false;
    $scope.showResultsBp_ORGANOLEPTICO = false;
    $scope.showResultsBp_ETIQUETADO = false;
    $scope.showResultsBp_RESIDUOS = false;
    $scope.showResultsBp_OTROS = false;
  
    $scope.status.editing = true;
  };


  $scope.$dismiss = function () {
    $uibModalInstance.close($scope.data.modified);
  };


}]);
/*global simulateAPIError*/
/*global saveAs*/
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global convertDateStringsToDates*/

"use strict";

angular.module('FTBonpreuApp').controller('EditarNcAnalisisController', ['$scope', '$http', '$translate', '$uibModalInstance', '$log', '$ngConfirm', 'cfg', 'ixStatusService', 'gridService', 'ixUtilsService', 'authService', function ($scope, $http, $translate, $uibModalInstance, $log, $ngConfirm, cfg, ixStatusService, gridService, ixUtilsService, authService) {
  $scope.status = ixStatusService.current;
  $scope.maxUploadFileSize = cfg.maxUploadFileSize;
  $scope.uploadingFile = false;
  $scope.status.editing = true;
  $scope.editar_estado_nc = false;
  $scope.data = {modified: false};
  $scope.data.datos_resultado = {};
  $scope.data.info = {};
  if (angular.isUndefined($scope.data.activeTab)) {
		$scope.data.activeTab = 0;
	}

  $scope.data.datos_resultado.id = $scope.$resolve.id;
  $scope.data.info.desc_articulo = $scope.$resolve.desc_articulo;
  $scope.data.info.ean = $scope.$resolve.ean;
  $scope.data.info.marca = $scope.$resolve.marca;
  $scope.data.info.parametro = $scope.$resolve.parametro;
  $scope.data.nc_bonpreu = $scope.$resolve.nc_bonpreu;

  var cod_parametro = "";
  switch($scope.data.info.parametro){
    case "FQ":
      cod_parametro = "FQ";
      break;
    case "MICRO":
      cod_parametro = "MICRO";
      break;
    case "VIDA ÚTIL":
      cod_parametro = "VIDA ÚTIL";
      break;
    case "NUTRICIONAL":
      cod_parametro = "NUTRICIONAL";
      break;
    case "ALÉRGENOS":
    case "AL·LÈRGENS":
      cod_parametro = "ALÉRGENOS";
      break;
    case "PESO":
    case "PES":
      cod_parametro = "PESO";
      break;
    case "ORGANOLÉPTICO":
    case "ORGANOLÈPTIC":
      cod_parametro = "ORGANOLÉPTICO";
      break;
    case "ETIQUETADO":
    case "ETIQUETAT":
      cod_parametro = "ETIQUETADO";
      break;
    case "RESIDUOS":
    case "RESIDUS":
      cod_parametro = "RESIDUOS";
      break;
    case "OTROS":
    case "ALTRES":
      cod_parametro = "OTROS";
      break;

  }

  var perfilesUsuario = authService.perfilesUsuario();

  $http.get(cfg.baseURL + "resultados_analisis/" + $scope.data.datos_resultado.id).then(function (response) {
    $scope.data.datos_resultado = angular.copy(response.data);
    //Guardo los valores originales
    $scope.data.datos_resultado_originales = angular.copy($scope.data.datos_resultado);

    if ($scope.tienePerfilUserkey()){
      $scope.editar_estado_nc = true;
    }
    else {
      //Si el estado de la NC está cerrado bloqueo la edición
      if (($scope.data.info.parametro == 'FQ' && (($scope.data.datos_resultado.estado_nc_fq == 4 && !$scope.data.nc_bonpreu) || ($scope.data.datos_resultado.estado2_nc_fq == 4 && $scope.data.nc_bonpreu)))
        || ($scope.data.info.parametro == 'MICRO' && (($scope.data.datos_resultado.estado_nc_micro == 4 && !$scope.data.nc_bonpreu) || ($scope.data.datos_resultado.estado2_nc_micro == 4 && $scope.data.nc_bonpreu)))
        || ($scope.data.info.parametro == 'VIDA ÚTIL' && (($scope.data.datos_resultado.estado_nc_vidautil == 4 && !$scope.data.nc_bonpreu) || ($scope.data.datos_resultado.estado2_nc_vidautil == 4 && $scope.data.nc_bonpreu)))
        || ($scope.data.info.parametro == 'NUTRICIONAL' && (($scope.data.datos_resultado.estado_nc_nutricional == 4 && !$scope.data.nc_bonpreu) || ($scope.data.datos_resultado.estado2_nc_nutricional == 4 && $scope.data.nc_bonpreu)))
        || (($scope.data.info.parametro == 'AL·LÈRGENS' || $scope.data.info.parametro == 'ALÉRGENOS') && (($scope.data.datos_resultado.estado_nc_alergenos == 4 && !$scope.data.nc_bonpreu) || ($scope.data.datos_resultado.estado2_nc_alergenos == 4 && $scope.data.nc_bonpreu)))
        // || (($scope.data.info.parametro == 'PES' || $scope.data.info.parametro == 'PESO') && ($scope.data.datos_resultado.estado_nc_peso == 1 || $scope.data.datos_resultado.estado_nc_peso == null))
        // || (($scope.data.info.parametro == 'ORGANOLÈPTIC' || $scope.data.info.parametro == 'ORGANOLÉPTICO') && ($scope.data.datos_resultado.estado_nc_org == 1 || $scope.data.datos_resultado.estado_nc_org == null))
        // || (($scope.data.info.parametro == 'ETIQUETAT' || $scope.data.info.parametro == 'ETIQUETADO') && ($scope.data.datos_resultado.estado_nc_etiq == 1 || $scope.data.datos_resultado.estado_nc_etiq == null))
        // || (($scope.data.info.parametro == 'RESIDUS' || $scope.data.info.parametro == 'RESIDUOS') && ($scope.data.datos_resultado.estado_nc_residuos == 1 || $scope.data.datos_resultado.estado_nc_residuos == null))
        // || (($scope.data.info.parametro == 'ALTRES' || $scope.data.info.parametro == 'OTROS') && ($scope.data.datos_resultado.estado_nc_otros == 1 || $scope.data.datos_resultado.estado_nc_otros == null))
        ){
          $scope.status.editing = false;
      }

      if (!$scope.data.nc_bonpreu){
        if (($scope.data.info.parametro == 'FQ' && $scope.data.datos_resultado.estado_nc_fq == 4)
          || ($scope.data.info.parametro == 'MICRO' && $scope.data.datos_resultado.estado_nc_micro == 4)
          || ($scope.data.info.parametro == 'VIDA ÚTIL' && $scope.data.datos_resultado.estado_nc_vidautil == 4)
          || ($scope.data.info.parametro == 'NUTRICIONAL' && $scope.data.datos_resultado.estado_nc_nutricional == 4)
          || (($scope.data.info.parametro == 'AL·LÈRGENS' || $scope.data.info.parametro == 'ALÉRGENOS') && $scope.data.datos_resultado.estado_nc_alergenos == 4)
          || (($scope.data.info.parametro == 'PES' || $scope.data.info.parametro == 'PESO') && $scope.data.datos_resultado.estado_nc_peso == 4)
          || (($scope.data.info.parametro == 'ORGANOLÈPTIC' || $scope.data.info.parametro == 'ORGANOLÉPTICO') && $scope.data.datos_resultado.estado_nc_org ==4)
          || (($scope.data.info.parametro == 'ETIQUETAT' || $scope.data.info.parametro == 'ETIQUETADO') && $scope.data.datos_resultado.estado_nc_etiq == 4)
          || (($scope.data.info.parametro == 'RESIDUS' || $scope.data.info.parametro == 'RESIDUOS') && $scope.data.datos_resultado.estado_nc_residuos == 4)
          || (($scope.data.info.parametro == 'ALTRES' || $scope.data.info.parametro == 'OTROS') && $scope.data.datos_resultado.estado_nc_otros == 4)
        ){
          $scope.status.editing = false;
        }
        if (($scope.data.info.parametro == 'FQ' && ($scope.data.datos_resultado.estado_nc_fq == 1 || $scope.data.datos_resultado.estado_nc_fq == null)) 
        || ($scope.data.info.parametro == 'MICRO' && ($scope.data.datos_resultado.estado_nc_micro == 1 || $scope.data.datos_resultado.estado_nc_micro == null))
        || ($scope.data.info.parametro == 'VIDA ÚTIL' && ($scope.data.datos_resultado.estado_nc_vidautil == 1 || $scope.data.datos_resultado.estado_nc_vidautil == null))
        || ($scope.data.info.parametro == 'NUTRICIONAL' && ($scope.data.datos_resultado.estado_nc_nutricional == 1 || $scope.data.datos_resultado.estado_nc_nutricional == null))
        || (($scope.data.info.parametro == 'AL·LÈRGENS' || $scope.data.info.parametro == 'ALÉRGENOS') && ($scope.data.datos_resultado.estado_nc_alergenos == 1 || $scope.data.datos_resultado.estado_nc_alergenos == null))
        || (($scope.data.info.parametro == 'PES' || $scope.data.info.parametro == 'PESO') && ($scope.data.datos_resultado.estado_nc_peso == 1 || $scope.data.datos_resultado.estado_nc_peso == null))
        || (($scope.data.info.parametro == 'ORGANOLÈPTIC' || $scope.data.info.parametro == 'ORGANOLÉPTICO') && ($scope.data.datos_resultado.estado_nc_org == 1 || $scope.data.datos_resultado.estado_nc_org == null))
        || (($scope.data.info.parametro == 'ETIQUETAT' || $scope.data.info.parametro == 'ETIQUETADO') && ($scope.data.datos_resultado.estado_nc_etiq == 1 || $scope.data.datos_resultado.estado_nc_etiq == null))
        || (($scope.data.info.parametro == 'RESIDUS' || $scope.data.info.parametro == 'RESIDUOS') && ($scope.data.datos_resultado.estado_nc_residuos == 1 || $scope.data.datos_resultado.estado_nc_residuos == null))
        || (($scope.data.info.parametro == 'ALTRES' || $scope.data.info.parametro == 'OTROS') && ($scope.data.datos_resultado.estado_nc_otros == 1 || $scope.data.datos_resultado.estado_nc_otros == null))
        ){
        $scope.editar_estado_nc = true;
        }
      }
      else {
        if (($scope.data.info.parametro == 'FQ' && $scope.data.datos_resultado.estado2_nc_fq == 4)
          || ($scope.data.info.parametro == 'MICRO' && $scope.data.datos_resultado.estado2_nc_micro == 4)
          || ($scope.data.info.parametro == 'VIDA ÚTIL' && $scope.data.datos_resultado.estado2_nc_vidautil == 4)
          || ($scope.data.info.parametro == 'NUTRICIONAL' && $scope.data.datos_resultado.estado2_nc_nutricional == 4)
          || (($scope.data.info.parametro == 'AL·LÈRGENS' || $scope.data.info.parametro == 'ALÉRGENOS') && $scope.data.datos_resultado.estado2_nc_alergenos == 4)
          || (($scope.data.info.parametro == 'PES' || $scope.data.info.parametro == 'PESO') && $scope.data.datos_resultado.estado2_nc_peso == 4)
          || (($scope.data.info.parametro == 'ORGANOLÈPTIC' || $scope.data.info.parametro == 'ORGANOLÉPTICO') && $scope.data.datos_resultado.estado2_nc_organoleptico ==4)
          || (($scope.data.info.parametro == 'ETIQUETAT' || $scope.data.info.parametro == 'ETIQUETADO') && $scope.data.datos_resultado.estado2_nc_etiquetado == 4)
          || (($scope.data.info.parametro == 'RESIDUS' || $scope.data.info.parametro == 'RESIDUOS') && $scope.data.datos_resultado.estado2_nc_residuos == 4)
          || (($scope.data.info.parametro == 'ALTRES' || $scope.data.info.parametro == 'OTROS') && $scope.data.datos_resultado.estado2_nc_otros == 4)
        ){
          $scope.status.editing = false;
        }
        if (($scope.data.info.parametro == 'FQ' && ($scope.data.datos_resultado.estado2_nc_fq == 1 || $scope.data.datos_resultado.estado2_nc_fq == null)) 
        || ($scope.data.info.parametro == 'MICRO' && ($scope.data.datos_resultado.estado2_nc_micro == 1 || $scope.data.datos_resultado.estado2_nc_micro == null))
        || ($scope.data.info.parametro == 'VIDA ÚTIL' && ($scope.data.datos_resultado.estado2_nc_vidautil == 1 || $scope.data.datos_resultado.estado2_nc_vidautil == null))
        || ($scope.data.info.parametro == 'NUTRICIONAL' && ($scope.data.datos_resultado.estado2_nc_nutricional == 1 || $scope.data.datos_resultado.estado2_nc_nutricional == null))
        || (($scope.data.info.parametro == 'AL·LÈRGENS' || $scope.data.info.parametro == 'ALÉRGENOS') && ($scope.data.datos_resultado.estado2_nc_alergenos == 1 || $scope.data.datos_resultado.estado2_nc_alergenos == null))
        || (($scope.data.info.parametro == 'PES' || $scope.data.info.parametro == 'PESO') && ($scope.data.datos_resultado.estado2_nc_peso == 1 || $scope.data.datos_resultado.estado2_nc_peso == null))
        || (($scope.data.info.parametro == 'ORGANOLÈPTIC' || $scope.data.info.parametro == 'ORGANOLÉPTICO') && ($scope.data.datos_resultado.estado2_nc_organoleptico == 1 || $scope.data.datos_resultado.estado2_nc_organoleptico == null))
        || (($scope.data.info.parametro == 'ETIQUETAT' || $scope.data.info.parametro == 'ETIQUETADO') && ($scope.data.datos_resultado.estado2_nc_etiquetado == 1 || $scope.data.datos_resultado.estado2_nc_etiquetado == null))
        || (($scope.data.info.parametro == 'RESIDUS' || $scope.data.info.parametro == 'RESIDUOS') && ($scope.data.datos_resultado.estado2_nc_residuos == 1 || $scope.data.datos_resultado.estado2_nc_residuos == null))
        || (($scope.data.info.parametro == 'ALTRES' || $scope.data.info.parametro == 'OTROS') && ($scope.data.datos_resultado.estado2_nc_otros == 1 || $scope.data.datos_resultado.estado2_nc_otros == null))
        ){
        $scope.editar_estado_nc = true;
        }
      }
    }
  
    buildGridDocumentosNc();
    buildGridBoletines();
  },
  function (error) {
    ixStatusService.setResponse(error);
  });

  var buildGridDocumentosNc = function(){
    if (!$scope.data.gridDocsNc){
      var acciones = [
        {
          title: $translate.instant("Descargar fichero"),
          icon: "fa-download",
          visible: function(entity){
            return entity.archivo;
          },
          accion: function(entity){
            $scope.downloadDocNcFile(entity);
          }
        }
      ];

      var metadata = [];

      $scope.data.gridDocsNc = gridService.createGrid($scope, "grid_docs_nc_analisisi", { minRowsToShow: 4, enableCellEdit: false, showOnlyDescribedCols: ["archivo"] }, "documentos_nc_analisis", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
      $scope.data.gridDocsNc.filtroExterno = [{ Field: "id_analisis", Operator: CMP_EQ, Value: $scope.data.datos_resultado.id },{ Field: "parametro", Operator: CMP_EQ, Value: cod_parametro}];
      $scope.data.gridDocsNc.ixLoadInitialData();
    }
    else {
      $scope.data.gridDocsNc = gridService.createGridFunctions($scope, $scope.data.gridDocsNc);
      $scope.data.gridDocsNc.ixRestoreConfig();
    }
  };


  var buildGridBoletines = function () {
    if (!$scope.data.gridBoletines) {
      var acciones = [
        {
          title: $translate.instant("Descargar fichero"),
          icon: "fa-download",
          visible: function (entity) {
            return entity.archivo;
          },
          accion: function (entity) {
            $scope.downloadFile(entity);
          }
        }
      ];
      var metadata = [];

      $scope.data.gridBoletines = gridService.createGrid($scope, "grid_boletines_resultados", { minRowsToShow: 4, enableCellEdit: false, showOnlyDescribedCols: ["archivo"] }, "boletines_analisis", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
      $scope.data.gridBoletines.filtroExterno = [{ Field: "id_analisis", Operator: CMP_EQ, Value: $scope.data.datos_resultado.id }];
      $scope.data.gridBoletines.ixLoadInitialData();
    }
    else {
      $scope.data.gridBoletines = gridService.createGridFunctions($scope, $scope.data.gridBoletines);
      $scope.data.gridBoletines.ixRestoreConfig();
    }
  };

  $scope.checkCierre = function(){
    switch($scope.data.info.parametro){
      case "FQ":
        if ($scope.data.datos_resultado.estado_nc_fq == 4 && $scope.data.datos_resultado.estado_nc_fq != $scope.data.datos_resultado_originales.estado_nc_fq)
          $scope.data.datos_resultado.fecha_cierre_nc_fq = new Date();
        else
          $scope.data.datos_resultado.fecha_cierre_nc_fq = null;
        break;

        case "MICRO":
          if ($scope.data.datos_resultado.estado_nc_micro == 4 && $scope.data.datos_resultado.estado_nc_micro != $scope.data.datos_resultado_originales.estado_nc_micro)
            $scope.data.datos_resultado.fecha_cierre_nc_micro = new Date();
          else
            $scope.data.datos_resultado.fecha_cierre_nc_micro = null;
          break;

        case "VIDA ÚTIL":
          if ($scope.data.datos_resultado.estado_nc_vidautil == 4 && $scope.data.datos_resultado.estado_nc_vidautil != $scope.data.datos_resultado_originales.estado_nc_vidautil)
            $scope.data.datos_resultado.fecha_cierre_nc_vidautil = new Date();
          else
            $scope.data.datos_resultado.fecha_cierre_nc_vidautil = null;
          break;

        case "NUTRICIONAL":
          if ($scope.data.datos_resultado.estado_nc_nutricional == 4 && $scope.data.datos_resultado.estado_nc_nutricional != $scope.data.datos_resultado_originales.estado_nc_nutricional)
            $scope.data.datos_resultado.fecha_cierre_nc_nutricional = new Date();
          else
            $scope.data.datos_resultado.fecha_cierre_nc_nutricional = null;
          break;

        case "AL·LÈRGENS":
        case "ALÉRGENOS":
          if ($scope.data.datos_resultado.estado_nc_alergenos == 4 && $scope.data.datos_resultado.estado_nc_alergenos != $scope.data.datos_resultado_originales.estado_nc_alergenos)
            $scope.data.datos_resultado.fecha_cierre_nc_alergenos = new Date();
          else
            $scope.data.datos_resultado.fecha_cierre_nc_alergenos = null;
          break;
         
        case "PES":
        case "PESO":
          if ($scope.data.datos_resultado.estado_nc_peso == 4 && $scope.data.datos_resultado.estado_nc_peso != $scope.data.datos_resultado_originales.estado_nc_peso)
            $scope.data.datos_resultado.fecha_cierre_nc_peso = new Date();
          else
            $scope.data.datos_resultado.fecha_cierre_nc_peso = null;
          break;

        case "ORGANOLÈPTIC":
        case "ORGANOLÉPTICO":
          if ($scope.data.datos_resultado.estado_nc_org == 4 && $scope.data.datos_resultado.estado_nc_org != $scope.data.datos_resultado_originales.estado_nc_org)
            $scope.data.datos_resultado.fecha_cierre_nc_org = new Date();
          else
            $scope.data.datos_resultado.fecha_cierre_nc_org = null;
          break;

        case "ETIQUETAT":
        case "ETIQUETADO":
          if ($scope.data.datos_resultado.estado_nc_etiq == 4 && $scope.data.datos_resultado.estado_nc_etiq != $scope.data.datos_resultado_originales.estado_nc_etiq)
            $scope.data.datos_resultado.fecha_cierre_nc_etiq = new Date();
          else
            $scope.data.datos_resultado.fecha_cierre_nc_etiq = null;
          break;

        case "RESIDUS":
        case "RESIDUOS":
          if ($scope.data.datos_resultado.estado_nc_residuos == 4 && $scope.data.datos_resultado.estado_nc_residuos != $scope.data.datos_resultado_originales.estado_nc_residuos)
            $scope.data.datos_resultado.fecha_cierre_nc_residuos = new Date();
          else
            $scope.data.datos_resultado.fecha_cierre_nc_residuos = null;
          break;

        case "ALTRES":
        case "OTROS":
          if ($scope.data.datos_resultado.estado_nc_otros == 4 && $scope.data.datos_resultado.estado_nc_otros != $scope.data.datos_resultado_originales.estado_nc_otros)
            $scope.data.datos_resultado.fecha_cierre_nc_otros = new Date();
          else
            $scope.data.datos_resultado.fecha_cierre_nc_otros = null;
          break;
    }

    return;
  };

  $scope.save = function (){
    var obj = ixGetPatchOperations($scope.data.datos_resultado_originales, $scope.data.datos_resultado);

    if (obj.length > 0){
      $log.log(obj);
      
      //SI se está cerrando la NC, se actualiza la fecha
      // var cierre_nc = null;
      // angular.forEach(obj, function(elem){
      //   if (elem.path.startsWith("/estado_nc") && elem.value == 4){
      //     var field = elem.path.replace("estado", "fecha_cierre");
      //     cierre_nc = { value: new Date(), path: field, op: elem.op};
      //   }
          
      // });
      // if (cierre_nc) obj.push(cierre_nc);
      $http.put(cfg.baseURL + "resultados_analisis/EditNC/" + $scope.data.datos_resultado.id, obj).then(function (response) {
        $scope.data.modified = true;
        $scope.data.datos_resultado_originales = angular.copy($scope.data.datos_resultado);
        ixStatusService.setResponse(response);
        // buildGridBoletines();
      },
        function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };


  $scope.addDocNc = function(){
    var urlTemplate = "app/FTBonpreu/GestionAnaliticasBP/modales/addDocumentosNcAnalisisPopup.html";
    var optionsPopupBoletines = { controller: "AddDocsNcPopupController" };
    var params = { id_resultado: $scope.data.datos_resultado.id, cod_parametro: cod_parametro };
    var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupBoletines, 'small', params);
    modalInstance.then(function (resp) {
      //Si se han agregado boletines, actualizar el grid de boletines
      if (resp) {
        $scope.data.gridDocsNc.ixLoadInitialData();
      }
    });
  };


  // $scope.addBoletin = function () {
  //   //añadir uno o más boletines mediante popup
  //   var urlTemplate = "app/FTBonpreu/GestionAnaliticasBP/modales/addBoletinesPopup.html";
  //   var optionsPopupBoletines = { controller: "AddBoletinesPopupController" };
  //   var params = { id_resultado: $scope.data.datos_resultado.id };
  //   var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupBoletines, 'small', params);
  //   modalInstance.then(function (resp) {
  //     //Si se han agregado boletines, actualizar el grid de boletines
  //     if (resp) {
  //       $scope.data.gridBoletines.ixLoadInitialData();
  //     }
  //   });
  // };

  $scope.downloadDocNcFile = function(entity){
    $http({
      method: 'post',
      url: cfg.baseURL + 'documentos_nc_analisis/DownloadFile?id=' + entity.id,
      headers: {},
      responseType: 'arraybuffer'
    }).then(function (r) {
      var mimetype = r.headers('Content-type');
      var file = new Blob([r.data], { type: mimetype });

      var filename = entity.archivo;
      if (r.headers('Content-Disposition')) {
        //filename = r.headers('Content-Disposition').split("=")[1];
        filename = r.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
      }
      saveAs(file, filename);
    }, function (err) {
      ixStatusService.setResponse(err);
    });
  };


  $scope.downloadFile = function (entity) {
    //TODO: Definir el content Type de manera que se puedan descargar documentos WORD (???)
    $http({
      method: 'post',
      url: cfg.baseURL + 'boletines_analisis/DownloadFile?id=' + entity.id,
      headers: {},
      responseType: 'arraybuffer'
    }).then(function (r) {
      var mimetype = r.headers('Content-type');
      var file = new Blob([r.data], { type: mimetype });

      var filename = entity.archivo;
      if (r.headers('Content-Disposition')) {
        //filename = r.headers('Content-Disposition').split("=")[1];
        filename = r.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
      }
      saveAs(file, filename);
    }, function (err) {
      ixStatusService.setResponse(err);
    });
  };

  $scope.deleteSelectedDocNc = function(){
    $scope.data.gridDocsNc.ixDeleteSelectedRows();
    var dataToDel = $scope.data.gridDocsNc.ixGetBulkParam();
    $http.post(cfg.baseURL + "documentos_nc_analisis/UpdateBulk", dataToDel).then(function(response){
      $scope.data.modified = true;
      ixStatusService.setResponse(response);
    },
    function(error){
      ixStatusService.setResponse(error);
    });
  };


  // $scope.deleteSelectedBoletines = function () {
  //   $scope.data.gridBoletines.ixDeleteSelectedRows();
  //   var dataToDel = $scope.data.gridBoletines.ixGetBulkParam();
  //   $http.post(cfg.baseURL + "boletines_analisis/UpdateBulk", dataToDel).then(function (response) {
  //     //Volver a marcar como finalizado el resultado: ¿se hará en WebApi o obligamos a que se haga click en el guardar? NOTA COMENTARIO del Copia-Pega de resultadosAnalisisPopupController.js
  //     //Marcar que se ha modificado el resultado
  //     $scope.data.modified = true;
  //     ixStatusService.setResponse(response);
  //   },
  //     function (error) {
  //       ixStatusService.setResponse(error);
  //     });
  // };


  $scope.confirmarEliminarDocNc = function(){
    $ngConfirm({
      icon: 'fa fa-warning',
      title: $translate.instant("¡Atención!"),
      content: $translate.instant("Los documentos seleccionados serán eliminados. ¿Desea continuar?"),
      type: 'red',
			typeAnimated: true,
			closeIcon: false,
      buttons: {
        ok: {
          text: 'Si',
          btnClass: 'btn-ix-green',
          show: 'true',
          action: function () {
            //Llamar WebAPI
            $scope.deleteSelectedDocNc();
            return true;
          }
        },
        cancelar: {
          text: "Cancelar",
          btnClass: 'btn-ix-red',
          show: 'true',
          action: function () {
            //Do Nothing
            return true;
          }
        }
      }
    });
  };


  // $scope.confirmarEliminarBoletines = function(){
  //   $ngConfirm({
  //     icon: 'fa fa-warning',
  //     title: $translate.instant("¡Atención!"),
  //     content: $translate.instant("Los boletines seleccionados serán eliminados. ¿Desea continuar?"),
  //     type: 'red',
	// 		typeAnimated: true,
	// 		closeIcon: false,
  //     buttons: {
  //       ok: {
  //         text: 'Si',
  //         btnClass: 'btn-ix-green',
  //         show: 'true',
  //         action: function () {
  //           //Llamar WebAPI
  //           $scope.deleteSelectedBoletines();
  //           return true;
  //         }
  //       },
  //       cancelar: {
  //         text: "Cancelar",
  //         btnClass: 'btn-ix-red',
  //         show: 'true',
  //         action: function () {
  //           //Do Nothing
  //           return true;
  //         }
  //       }
  //     }
  //   });
  // };


  $scope.tienePerfilUserkey = function () {
		return (perfilesUsuario.indexOf("ixnet") >= 0) || (perfilesUsuario.indexOf("usr_bio_userkey") >= 0) || (perfilesUsuario.indexOf("usr_bp_userkey") >= 0);
	};


  $scope.loadEstados = function(params, search) {
    if (!$scope.tienePerfilUserkey()){
      params.Filters.push({Field: "esProveedor", Operator: CMP_EQ, Value: 1, Skip: true});
    }
    return $http.post(cfg.baseURL + "estados_nc_bp/Search", params);
  };


  $scope.$dismiss = function () {
    $uibModalInstance.close($scope.data.modified);
  };

}]);
"use strict";

angular.module('FTBonpreuApp').controller('AddPlanificacionExtraController', ['$scope', '$http', '$uibModalInstance', 'cfg', 'ixStatusService', '$log', function($scope, $http, $uibModalInstance, cfg, ixStatusService, $log){
  $scope.status = ixStatusService.current;
  $scope.data = {};
  $scope.status.editing = true;

  $scope.data.resultOp = false;
  $scope.data.nueva_planificacion = {};

  $scope.save = function(){
    $log.log($scope.data.nueva_planificacion);
    $http.post(cfg.baseURL + "planificacion_analisis_extra_bp", $scope.data.nueva_planificacion).then(function(response){
      ixStatusService.setResponse(response);
      $scope.status.editing = false;
      $scope.data.resultOp = true;
      $uibModalInstance.close($scope.data.resultOp);
    },
    function(error){
      ixStatusService.setResponse(error);
    });
  };

	$scope.$dismiss = function () {
    $scope.status.editing = false;
		$uibModalInstance.close($scope.data.resultOp);
	}

}]);
"use strict"

angular.module("FTBonpreuApp").controller("AddDocsNcPopupController", ['$scope', '$http', '$uibModalInstance', 'cfg', 'ixStatusService', 'Upload', function ($scope, $http, $uibModalInstance, cfg, ixStatusService, Upload) {
  $scope.status = ixStatusService.current;
  $scope.data = {};
  $scope.data.id_resultado = $scope.$resolve.id_resultado;
  $scope.data.parametro = $scope.$resolve.cod_parametro;

  $scope.fileUploaded = false; //El volver a la pantalla de llamada esta variable me permitirá señalar si se ha cargado algún archivo nuevo o no

  ixStatusService.setEditing(true); //Siempre se podrá añadir fichero

  $scope.save = function () {
    //Si no hay archivos seleccionados el botón GUARDAR está desactivado
    var fileNames = [];
    angular.forEach($scope.data.filesToUpload, function (elem) {
      fileNames.push(elem.name);
    });

    $http.post(cfg.baseURL + "documentos_nc_analisis/CanUpload?id_analisis=" + $scope.data.id_resultado + "&pmt=" + $scope.data.parametro, fileNames).then(function (resp) {
      //Carga ficheros
      var upload = Upload.upload({
        url: cfg.baseURL + "documentos_nc_analisis/UploadAndCreate",
        data: {
          file: $scope.data.filesToUpload,
          id_analisis: $scope.data.id_resultado,
          pmt_tipo: $scope.data.parametro
        },
        dataType: 'json'
      });

      upload.then(function (response) {
        // $scope.uploadingFile = true;
        delete $scope.data.ixProgress;
        $scope.fileUploaded = true;
        ixStatusService.setResponse(response);
        $uibModalInstance.close($scope.fileUploaded);
      }, function (error) {
        delete $scope.data.ixProgress;
        ixStatusService.setResponse(error);
      }, function (evt) {
        $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });

    }, function (error) {
      ixStatusService.setResponse(error);
    });
  };


  $scope.$dismiss = function () {
    $uibModalInstance.close($scope.fileUploaded);
  };
}]);
"use strict";

angular.module("FTBonpreuApp").controller("AddBoletinesPopupController", ['$scope', '$http', '$uibModalInstance', '$log', 'cfg', 'ixStatusService', 'Upload', function ($scope, $http, $uibModalInstance, $log, cfg, ixStatusService, Upload) {
  $scope.status = ixStatusService.current;
  $scope.data = {};
  $scope.data.id_resultado = $scope.$resolve.id_resultado;
  // $scope.uploadingFile = false;
  $scope.fileUploaded = false; //El volver a la pantalla de llamada esta variable me permitirá señalar si se ha cargado algún archivo nuevo o no

  ixStatusService.setEditing(true); //Siempre se podrá añadir fichero

  $scope.save = function () {
    //Si no hay archivos seleccionados el botón GUARDAR está desactivado

    var fileNames = [];
    angular.forEach($scope.data.filesToUpload, function (elem) {
      fileNames.push(elem.name);
    });

    $http.post(cfg.baseURL + "boletines_analisis/CanUpload?id_analisis=" + $scope.data.id_resultado, fileNames).then(function (resp) {
      //Carga ficheros
      // $scope.uploadingFile = true;
      var upload = Upload.upload({
        url: cfg.baseURL + "boletines_analisis/UploadAndCreate",
        data: {
          file: $scope.data.filesToUpload,
          id_analisis: $scope.data.id_resultado
        },
        dataType: 'json'
      });

      upload.then(function (response) {
        // $scope.uploadingFile = true;
        delete $scope.data.ixProgress;
        $scope.fileUploaded = true;
        ixStatusService.setResponse(response);
        $uibModalInstance.close($scope.fileUploaded);
      }, function (error) {
        // $scope.uploadingFile = true;
        delete $scope.data.ixProgress;
        ixStatusService.setResponse(error);
      }, function (evt) {
        $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });

    }, function (error) {
      ixStatusService.setResponse(error);
    });
  };

  $scope.$dismiss = function () {
		$uibModalInstance.close($scope.fileUploaded);
	};

}]);
/*global saveAs*/
angular.module("FTBonpreuApp").controller('ArchivosAyudaController', ['$scope', 'authService', 'ixStatusService', '$http', 'cfg', function ($scope, authService, ixStatusService, $http, cfg) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.init = function(){
    $scope.archivos_proveedor = [];
    $scope.archivos_laboratorio = [];
    $scope.archivos_comprador = [];
    $scope.archivos_consulta = [];

    $scope.perfilActivo = $scope.getPerfilActivo();

    //Carreguem els fitxers que ensenyarem desde la API:
    // $http.get(cfg.baseURL + "ficheros_ayuda/GetByRole?perfil=usr_bp_userkey").then(function(response){
    //   if((response) && response.data){
    //     $scope.archivos_bp = response.data;
    //   }
    // }, function(err){
    //   ixStatusService.setResponse(err);
    // });

    $http.get(cfg.baseURL + "ficheros_ayuda/GetByRole?perfil=usr_proveedor").then(function(response){
      if((response) && response.data){
        $scope.archivos_proveedor = response.data;
      }
    }, function(err){
      ixStatusService.setResponse(err);
    });

    $http.get(cfg.baseURL + "ficheros_ayuda/GetByRole?perfil=usr_laboratorio").then(function(response){
      if((response) && response.data){
        $scope.archivos_laboratorio = response.data;
      }
    }, function(err){
      ixStatusService.setResponse(err);
    });

    $http.get(cfg.baseURL + "ficheros_ayuda/GetByRole?perfil=usr_comprador").then(function(response){
      if((response) && response.data){
        $scope.archivos_comprador = response.data;
      }
    }, function(err){
      ixStatusService.setResponse(err);
    });

    $http.get(cfg.baseURL + "ficheros_ayuda/GetByRole?perfil=usr_bp_consulta").then(function(response){
      if((response) && response.data){
        $scope.archivos_consulta = response.data;
      }
    }, function(err){
      ixStatusService.setResponse(err);
    });

    $scope.$on("$destroy", function() {
      $scope.isDestroyed=true;
    });

    $scope.downloadFile = function(archivo){
      var config = {responseType:"arraybuffer"};
      $http.post(cfg.baseURL + "ficheros_ayuda/DownloadFile", archivo, config).then(function(r){
        var file = new Blob([r.data], { type: archivo.mime_type });

        var filename =  archivo.nombre;
        if(r.headers('Content-Disposition')) {
          filename = r.headers('Content-Disposition').split("=")[1];
        }
        saveAs(file, filename);
      }, function(err){
        ixStatusService.setResponse(err);
      });
    };
  };


  $scope.getPerfilActivo = function(){
    var perfilesUsuario = authService.perfilesUsuario();
    if (perfilesUsuario.length == 1)
      return perfilesUsuario[0];
    else
      return "usr_bp_userkey";
  }
  
}]);

/*global saveAs*/
angular.module('FTBonpreuApp').controller('ImprimirFTBPPopupController', [ "$scope", "$uibModalInstance", "$http", "cfg", "ixStatusService", "idiomasFTBP", 'authService', function($scope, $uibModalInstance, $http, cfg, ixStatusService, idiomasFTBP, authService){

	$scope.status = { editing: true };

	var tipo = $scope.$resolve.tipo;
	
	$scope.datos = {};
	$scope.datos.tipo_doc = "PDF"; //Por algún motivo no le gustaba $scope.tipo_doc
	$scope.reducida = 0;
	
	$scope.idiomas = idiomasFTBP.map(function(e){ return { value: e.codigo, text: e.descripcion, icon: e.icon }});
	var idioma_default = undefined;
	if (angular.isDefined($scope.$resolve.idioma))
		idioma_default = $scope.$resolve.idioma;
	$scope.idioma = idioma_default;

	var usuario = authService.authentication.userName;
	//Get condition user
  $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
    $scope.extranetUser = response.data;
  }, function (error) {
    ixStatusService.setResponse(error);
  });

	$scope.okBtnText = "Descargar";

	$scope.save = function(){
		if (tipo == "FT_UNICA")
			$scope.imprimirFtProducto();
		if (tipo == "FT_MASIVA")
			$scope.impresionMasivaFT();
	};


	// $scope.imprimirFt = function(){
	// 	var path = cfg.baseURL + "impresos/impresoFT/?idft=" + id_ficha_tecnica + "&docformat="+ $scope.datos.tipo_doc + "&reducido=" + $scope.reducida;
	// 	if($scope.idioma)
	// 		path+= "&idioma="+$scope.idioma;

	// 	var config = {responseType: 'arraybuffer'};

	// 	$http.get(path, config).then(function(response){

	// 		var file = new Blob([response.data], { type: 'application/zip'});

	// 		var filename = "ImpresosFichaTecnica_" + id_ficha_tecnica.replace("/","-") +".zip";
	// 		if(response.headers('Content-Disposition')) {
	// 			filename = response.headers('Content-Disposition').split("=")[1];
	// 		}
	// 		saveAs(file, filename);
	// 	}, function(error){
	// 		ixStatusService.setResponse(error);
	// 	});
	// };
	
	$scope.imprimirFtProducto = function () {
		var id_ficha_tecnica = $scope.$resolve.id_ficha_tecnica;
		var red = "false";
		if ($scope.reducida == 1) red = "true"
		var path = cfg.baseURL + "impresosBp/ImpresoFtBp?idft=" + id_ficha_tecnica + "&docformat=" + $scope.datos.tipo_doc + "&reducido=" + red;
		if($scope.idioma)
			path += "&idioma="+$scope.idioma;

    var config = { responseType: 'arraybuffer' };
    $http.get(path, config).then(function (response) {
      var file;
			var filename = id_ficha_tecnica.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'-');

      if ($scope.datos.tipo_doc == "PDF") {
        file = new Blob([response.data], { type: 'application/pdf' });
        filename = filename + ".pdf";
      }
      else {
        file = new Blob([response.data], { type: 'application/ms-word' });
        filename = filename + ".doc";
      }
      if (response.headers('Content-Disposition')) {
        // filename = response.headers('Content-Disposition').split("=")[1];
				filename = response.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
      }

      saveAs(file, filename);
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  };
	

	$scope.impresionMasivaFT = function () {
		var lista_fichas = $scope.$resolve.lista_fichas;
		var red = "false";
		if ($scope.reducida == 1) red = "true"

    var params = { docformat: $scope.datos.tipo_doc, reducido: red, idioma: $scope.idioma };
    params.lista_fichas = lista_fichas;

    var config = { responseType: 'arraybuffer' };

    $http.post(cfg.baseURL + "impresosBp/ImpresionMasivaFtBp", params, config).then(function (response) {
      var file = new Blob([response.data], { type: 'application/zip' });

      var filename = "fitxas_tecnicas.zip";
      if (response.headers('Content-Disposition')) {
        // filename = response.headers('Content-Disposition').split("=")[1];
				filename = response.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
      }
      saveAs(file, filename);
    }, function (error) {
      ixStatusService.setResponse(error);
		});
  };


}]);

/*global saveAs*/

angular.module('FTBonpreuApp').controller('CargaMasivaFicherosFtBPController', ['$scope', 'cfg', '$http', '$uibModalInstance', '$log', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, $log, Upload, ixStatusService){

  $scope.status = ixStatusService.current;
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
  $scope.recargarGrid = false;

  $scope.data = {};
  $scope.resultReady = false;
  $scope.resultData = null;

  $scope.subirZip = function(){
    var upload = Upload.upload({
      url: cfg.baseURL + "fichas_tecnicas_ficheros/CargaMasivaZip",
      data: {
        file: $scope.archivoToUpload
      },
      dataType: 'json'
    });
    
    upload.then(function(response){
      if(response.data){
        delete $scope.data.ixProgress;
        $scope.data.uploadingFile = false;
        $log.log("Resultado carga", response.data);
        $scope.gridResultData = { data: response.data };
        $scope.resultReady = true;
        //ixStatusService.setResponse(response);
        $scope.status.editing = false;
        //$uibModalInstance.close(true);
      }
    }, function(response){
      if(response.data){
        delete $scope.data.ixProgress;
        $scope.data.uploadingFile = false;
      }
      ixStatusService.setResponse(response);
    }, function(evt){
      $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });
  };


  $scope.descargarPlantillaIndex = function(){
    $http(
      {
        method: 'post',
        url: cfg.baseURL +'fichas_tecnicas_ficheros/DescargarPlantillaCargaMasiva',
        headers:{},
        responseType: 'arraybuffer'
      }
    ).then(function (r) {
      var mimetype = r.headers('Content-type');
      var file = new Blob([r.data], { type: mimetype });
      var filename  = "index.xlsx";
      if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
      }
      saveAs(file, filename);
    }, function (err) {
      ixStatusService.setResponse(err);
    });
  };

	$scope.$dismiss = function () {
		$uibModalInstance.close($scope.recargarGrid);
	};
}]);
angular.module('FTBonpreuApp').controller('AddFtBpPopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, ixStatusService){
  $scope.status = {editing: true};

	// $scope.loadIdiomas = function(param){
	// 	var deferral = $q.defer();
  //   deferral.resolve({
  //       data: idiomasFT
  //   });
  //   return deferral.promise;
	// };

  $scope.save = function(){
    //Crear nueva FT.
    $http.post(cfg.baseURL + "fichas_tecnicas_bp", $scope.nuevaft).then(function (r) {
      ixStatusService.setResponse(r);
      $scope.newIdFicha = r.data.obj.Record.id;
      $uibModalInstance.close(r.data.obj.Record.id);
      //Abro nueva FT generada
    },
    function (error) {
      ixStatusService.setResponse(error);
    });
  }
}]);

/*global CMP_EQ*/

angular.module('FTBonpreuApp').controller('SeleccionarEstadoVersionarController', ['$scope', 'cfg', '$http', '$uibModalInstance', '$log', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, $log, Upload, ixStatusService){
	$scope.status = ixStatusService.current;
  $scope.status.editing = true;

  $scope.loadEstados = function () {
    var searchParam = {Filters:[]};
    searchParam.Filters.push({Field: 'codigo', Value: 'C', Operator: CMP_EQ, Or: true, StartPar: true, EndPar: false });
    searchParam.Filters.push({Field: 'codigo', Value: 'O', Operator: CMP_EQ, Or: true, StartPar: false, EndPar: false });
    searchParam.Filters.push({Field: 'codigo', Value: 'Q', Operator: CMP_EQ, Or: true, StartPar: false, EndPar: false });
    searchParam.Filters.push({Field: 'codigo', Value: 'N', Operator: CMP_EQ, Or: true, StartPar: false, EndPar: true });
		return $http.post(cfg.baseURL + "estados/Search", searchParam);
	};


  $scope.save = function(){
		$scope.status.editing = false;
		$uibModalInstance.close($scope.estado_sel);
  };


	// $scope.$close = function () {
	// 	$scope.status.editing = false;
	// 	$uibModalInstance.dismiss('cancel');
	// };
  

	$scope.$dismiss = function () {
		$scope.status.editing = false;
		$uibModalInstance.close('CANCEL');
	};

}]);
/*global ixGetPatchOperations*/

"use strict";

angular.module('FTBonpreuApp').controller('PlanificacionAnaliticaPopupController', ['$scope', '$http', '$uibModalInstance', 'cfg', 'ixStatusService', '$log', function($scope, $http, $uibModalInstance, cfg, ixStatusService, $log){
  $scope.status = ixStatusService.current;
  $scope.data = {};

  $scope.data.isNew = $scope.$resolve.isNew;
  $scope.data.datos = {};

  if ($scope.data.isNew){
    $scope.tituloPopup = "Nueva planificación analítica rutinaria";
    $scope.data.datos.id_ficha_tecnica = $scope.$resolve.id_ficha_tecnica;
  }
  else{
    $scope.tituloPopup = "Editar planificación analítica rutinaria";
    $scope.data.datos = $scope.$resolve.planificacion;
    $scope.data.datos_originales = angular.copy($scope.$resolve.planificacion);
  }

  $scope.save = function (){
    if ($scope.data.isNew){
      $http.post(cfg.baseURL + "planificacion_analisis_rutinarias",$scope.data.datos).then(function(response){
        ixStatusService.setResponse(response);
        $uibModalInstance.close(true);
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
    else{
      var obj = ixGetPatchOperations($scope.data.datos_originales, $scope.data.datos);
      $http.put(cfg.baseURL + "planificacion_analisis_rutinarias/" + $scope.data.datos.id, obj).then(function(response){
        ixStatusService.setResponse(response);
        $uibModalInstance.close(true);
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.$dismiss = function () {
		$uibModalInstance.close(false);
	}


}]);
/*global ixGetPatchOperations*/

angular.module('FTBonpreuApp').controller('EditarFicheroFtPopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', '$log', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, $log, Upload, ixStatusService){
	$scope.status = ixStatusService.current;
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
	$scope.id_ficha_tecnica = $scope.$resolve.id_ft;
  $scope.idFichero = $scope.$resolve.id_fichero;
	$scope.tipoSeleccionadoFt = $scope.$resolve.tipo;
	//$scope.status = { editing: true };
	$scope.status.editing = true;
	$scope.esNuevo = false;
	// $scope.changed = false;
	$scope.data = {};

	if ($scope.idFichero == 0){
		//Es un nuevo fichero
		$scope.esNuevo = true;
		$scope.tituloPopup = "Cargar nuevo fichero";
	}
	else {
		//Se está editando un fichero existente
		$scope.tituloPopup = "Editar fichero";
		$http.get(cfg.baseURL + "fichas_tecnicas_ficheros/" + $scope.idFichero).then(function(response){
			$scope.data = response.data;
			$scope.original_data = angular.copy($scope.data);
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

	$scope.save = function(){
		if ($scope.esNuevo){
			var fileNames = [];
			fileNames.push($scope.archivosToUpload[0].name);
			// angular.forEach($scope.archivosToUpload, function(fileToUpload){
			// 	fileNames.push(fileToUpload.name);
			// });
	
			$http.post(cfg.baseURL + "fichas_tecnicas_ficheros/CanUpload?id_ficha_tecnica="+$scope.id_ficha_tecnica, fileNames).then(function(response){
				if(response.data.GlobalMessage.ErrType == 0){
					$scope.data.uploadingFile = true;
					var upload = Upload.upload({
						url: cfg.baseURL + "fichas_tecnicas_ficheros/UploadAndCreate",
						data: {
							file: $scope.archivosToUpload,
							id_ficha_tecnica: $scope.id_ficha_tecnica,
							tipo: $scope.data.tipo,
							fecha_caducidad: $scope.data.fecha_caducidad,
							inicio_validez: $scope.data.inicio_validez,
							en_impreso: $scope.data.en_impreso,
							fecha_carga: $scope.data.fecha_carga
						},
						dataType: 'json'
					});
	
					upload.then(function(response){
						if(response.data){
							delete $scope.data.ixProgress;
							$scope.data.uploadingFile = false;
							ixStatusService.setResponse(response);
							$scope.status.editing = false;
							// var resultOp = {};
							// resultOp.changed = true;
							// resultOp.data = response.data.obj.Record;
							$uibModalInstance.close(true);
						}
					}, function(response){
						if(response.data){
							delete $scope.data.ixProgress;
							$scope.data.uploadingFile = false;
						}
						ixStatusService.setResponse(response);
					}, function(evt){
						$scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
				else {
					ixStatusService.setResponse(response);
				}
			}, function(err){
				ixStatusService.setResponse(err);
			});
		}
		else {
			$log.log("TODO Update")
			var param = {};
			param = ixGetPatchOperations($scope.original_data, $scope.data);
			
			$http.put(cfg.baseURL + "/fichas_tecnicas_ficheros/" + $scope.data.id, param).then(function(response){
				ixStatusService.setResponse(response);
				$scope.status.editing = false;
				$uibModalInstance.close(true);
			}, function(error){
				ixStatusService.setResponse(error);
			});
		}


		// $uibModalInstance.close($scope.data);
	};

	$scope.$close = function () {
		$scope.status.editing = false;
		$uibModalInstance.dismiss('cancel');
	};
  
	$scope.$dismiss = function () {
		$scope.status.editing = false;
		$uibModalInstance.close(false);
	};

	// $scope.getTiposFichero = function(){
	// 	var method;
	// 	if($scope.tipo == "ficheros_ft")
	// 		method = "tipos_fichero_ft";
	// 	else
	// 		method = "tipos_fichero_proveedor";
	//
	// 	return $http.get(cfg.baseURL + method);
	// };
	// $scope.$close = function () {
	// 	$scope.status.editing = false;
	// 	$uibModalInstance.dismiss('cancel');
	// };

	// $scope.hideTipoFicheroFt = function(){
	// 	if($scope.tipo == "ficheros_ft"){
	// 		return false;
	// 	}
	// 	else {
	// 		return true;
	// 	}
	// };
	//
	// $scope.hideTipoFicheroProveedor = function(){
	// 	if($scope.tipo == "proveedor"){
	// 		return false;
	// 	}
	// 	else {
	// 		return true;
	// 	}
	// };

}]);

angular.module('FTBonpreuApp').controller('GridJerarquicoBonpreuAddRowPopupController', [ '$scope', '$uibModalInstance', '$translate', 'ixStatusService', 'ixUtilsService', '$q', 'ivhTreeviewMgr', '$http', 'cfg', '$timeout', function($scope, $uibModalInstance, $translate, ixStatusService, ixUtilsService, $q, ivhTreeviewMgr, $http, cfg, $timeout){
	$scope.status = { editing: true };

	$scope.entity = $scope.$resolve.entity;
	$scope.entityMaster = $scope.$resolve.entityMaster;
	$scope.entityOriginal = angular.copy($scope.entity);
	$scope.modoTraduccion = $scope.$resolve.modoTraduccion;
	$scope.datos_grid = $scope.$resolve.datos_grid || [];
	
	$scope.pregunta = { pregunta: angular.copy($scope.$resolve.pregunta.pregunta), respuestas: [ $scope.entity ] };
	if($scope.modoTraduccion){
		$scope.pregunta.respuestas = [ $scope.entityMaster ];
		$scope.pregunta.pregunta_idioma = angular.copy($scope.$resolve.pregunta.pregunta_idioma);
		$scope.pregunta.respuestas_idioma = [ $scope.entity ];
	}


	//$scope.pregunta = { pregunta: angular.copy($scope.$resolve.pregunta.pregunta), respuestas: angular.copy($scope.$resolve.pregunta.respuestas) };
	$scope.pregunta.pregunta.bucle = 0;
	$scope.pregunta.pregunta.sub_bucle = 0;
	$scope.pregunta.pregunta.preguntar_componente = 0;

	if($scope.pregunta.pregunta.tipo_valor_sub_pregunta1 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta1 && !angular.isArray($scope.entity.sub_respuesta1))
		$scope.entity.sub_respuesta1 = $scope.entity.sub_respuesta1.replace('"','').replace('[','').replace(']','').replaceAll(';',',').split(",");

	if($scope.pregunta.pregunta.tipo_valor_sub_pregunta2 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta2 && !angular.isArray($scope.entity.sub_respuesta2))
		$scope.entity.sub_respuesta2 = $scope.entity.sub_respuesta2.replace('"','').replace('[','').replace(']','').replaceAll(';',',').split(",");

	if($scope.pregunta.pregunta.tipo_valor_sub_pregunta3 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta3 && !angular.isArray($scope.entity.sub_respuesta3))
		$scope.entity.sub_respuesta3 = $scope.entity.sub_respuesta3.replace('"','').replace('[','').replace(']','').replaceAll(';',',').split(",");

	if($scope.pregunta.pregunta.tipo_valor_sub_pregunta4 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta4 && !angular.isArray($scope.entity.sub_respuesta4))
		$scope.entity.sub_respuesta4 = $scope.entity.sub_respuesta4.replace('"','').replace('[','').replace(']','').replaceAll(';',',').split(",");

	if($scope.pregunta.pregunta.tipo_valor_sub_pregunta5 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta5 && !angular.isArray($scope.entity.sub_respuesta5))
		$scope.entity.sub_respuesta5 = $scope.entity.sub_respuesta5.replace('"','').replace('[','').replace(']','').replaceAll(';',',').split(",");
	
	if($scope.pregunta.pregunta.tipo_valor_sub_pregunta6 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta6 && !angular.isArray($scope.entity.sub_respuesta6))
		$scope.entity.sub_respuesta6 = $scope.entity.sub_respuesta6.replace('"','').replace('[','').replace(']','').replaceAll(';',',').split(",");

	if($scope.pregunta.pregunta.tipo_valor_sub_pregunta7 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta7 && !angular.isArray($scope.entity.sub_respuesta7))
		$scope.entity.sub_respuesta7 = $scope.entity.sub_respuesta7.replaceAll(';',',').split(",");

	if($scope.pregunta.pregunta.tipo_valor_sub_pregunta8 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta8 && !angular.isArray($scope.entity.sub_respuesta8))
		$scope.entity.sub_respuesta8 = $scope.entity.sub_respuesta8.replaceAll(';',',').split(",");



	$scope.rowsGrid = $scope.$resolve.rowsGrid || [];
	$scope.isNew = $scope.$resolve.isNew;
	$scope.grid = $scope.$resolve.grid;
	if (!$scope.isNew){
		$scope.valIngredienteModificar = $scope.entity.valor;
		var idx = $scope.datos_grid.indexOf($scope.entity);
		if(idx != -1){
			do {
				var item = $scope.datos_grid[idx];
				if(item["$$treeLevel"] < $scope.entity["$$treeLevel"])
					$scope.valIngredienteModificar += " - " + item.valor;
				idx--;
			} while(idx != -1);
		}
	} else
		$scope.valIngredienteModificar = "";

	$scope.clearEmptyRow = function(){
		var emptyRow = $scope.grid.data.find(function(e){ return !e.valor && !e.sub_respuesta1 && !e.sub_respuesta2 && !e.sub_respuesta3 && !e.sub_respuesta4 && !e.sub_respuesta5 && !e.sub_respuesta6 && !e.sub_respuesta7 && !e.sub_respuesta8; });
		if(angular.isDefined(emptyRow)){
			$scope.grid.data.splice($scope.grid.data.indexOf(emptyRow), 1);
		}
	};

	$scope.resetForm = function(){
		$scope.searchtext = "";
		$scope.entity.orden_bucle = "";
		$scope.entity.orden_subingrediente = "";
		$scope.entity.valor = "";
		$scope.entity.sub_respuesta1 = "";
		$scope.entity.sub_respuesta2 = null;
		$scope.entity.sub_respuesta3 = null;
		$scope.entity.sub_respuesta4 = "";
		$scope.entity.sub_respuesta5 = "";
		$scope.entity.sub_respuesta6 = "";
		$scope.entity.sub_respuesta7 = "";
		$scope.entity.sub_respuesta8 = "";
		ivhTreeviewMgr.deselectAll($scope.listOfValues);
		$scope.reloadDropdown();
	};
	$scope.reloadDropdown = function(){
		$scope.reload = true;
		$timeout(function(){
			$scope.reload = false;
		},1);
	};

	$scope.cargarValoresNivel = function(){
		var deferr = $q.defer();

		var opciones = [{ codigo: 0, descripcion: $translate.instant("Ingrediente Principal") }, { codigo: 1, descripcion: $translate.instant("Subingrediente") }];
		deferr.resolve({ data: opciones });
		return deferr.promise;
	};

	$scope.cargarIngredientes = function(){
		var deferr = $q.defer();

		var ingredientesPrincipales = [];

		$scope.rowsGrid.filter(function(e){ return (e["$$treeLevel"] == 0 || e["$$treeLevel"] == 1) && (e.valor); }).forEach(function(row, idx){
			var orden_sub_bucle = row.orden_sub_bucle || row.orden_tab;
			var descripcion = row.valor;
			if(row["$$treeLevel"] == 1){
				var ingrediente = $scope.rowsGrid.find(function(e){ return e["$$treeLevel"] == 0 && e.orden_bucle == row.orden_bucle; });
				descripcion = ingrediente.valor + " - " + descripcion;
			}
			ingredientesPrincipales.push({ codigo: row.orden_bucle+"-"+orden_sub_bucle, descripcion: descripcion });
		});

		deferr.resolve({ data: ingredientesPrincipales });
		return deferr.promise;
	};

	$scope.$watch('searchtext', function(newVal, oldVal){
		$scope.changeSelectionIfItemMatching();
	});

	$scope.changeSelectionIfItemMatching = function(){
		if($scope.searchtext){
			var matchingItem = $scope.listOfValues.find(function(e){ return e.id.toString().toUpperCase().toString() == $scope.searchtext.toUpperCase()});
			ivhTreeviewMgr.selectAll($scope.listOfValues);
			ivhTreeviewMgr.deselectAll($scope.listOfValues);
//			if(angular.isDefined(matchingItem)){
//				ivhTreeviewMgr.select($scope.listOfValues, matchingItem);
//			} else {
//				ivhTreeviewMgr.select($scope.listOfValues, $scope.listOfValues.find(function(e){ return e.id === 0; }));
//			}
			$scope.entity.valor = $scope.searchtext;
		}
	};

	$scope.filterItems = function(node){
		return (node.id == 0) || ixUtilsService.comparar(node.id,$scope.searchtext)>=0;
	};

	var getListIngredientesDiccionario = function(){
		var lista = [{ id: 0, label: $translate.instant("Crear ingrediente"), selected: 0 }];
		if($scope.pregunta.pregunta.diccionario_valores){
			$scope.pregunta.pregunta.diccionario_valores.forEach(function(valor){
				if(valor != null)
					lista.push({ id: valor, label: valor, selected: 0 });
			});
		}
		return lista;
	};

	$scope.listOfValues = getListIngredientesDiccionario();

	$scope.selectionChanged = function(ivhNode, ivhIsSelected, ivhTree){
		$scope.entity.valor = null;
		if(ivhIsSelected){
			ivhTreeviewMgr.selectAll($scope.listOfValues);
			ivhTreeviewMgr.deselectAll($scope.listOfValues);
			ivhTreeviewMgr.selectEach(ivhTree, [ivhNode]);

			if(ivhNode.id == 0){
				$scope.entity.valor = $scope.searchtext;
			} else {
				$scope.entity.valor = ivhNode.label;
				$scope.searchtext = $scope.entity.valor;
			}
		}
		else
			$scope.searchtext = "";
  };

	var getMaxOrdenBucle = function(){
		var max_orden_bucle = 0;
		$scope.rowsGrid.filter(function(e){ return (e.orden_sub_bucle === 0 || e.orden_tab === 0) && e.valor; }).forEach(function(nivel_principal){
			if(max_orden_bucle < nivel_principal.orden_bucle)
				max_orden_bucle = nivel_principal.orden_bucle;
		});
		return max_orden_bucle;
	};
	$scope.save = function(){
		if($scope.rowsGrid.length > 0){
			if($scope.entity.orden_bucle == 0){
				//Get max orden_bucle and sum 1.
				$scope.entity.orden_bucle = getMaxOrdenBucle() + 1;
				$scope.entity.orden_tab = 0;
			} else {
				var partsCodigo = $scope.entity.orden_subingrediente.split("-");
				var orden_bucle = parseInt(partsCodigo[0]);
				$scope.entity.orden_bucle = orden_bucle;
				var orden_sub_bucle = parseInt(partsCodigo[1]);
				if(isNaN(orden_sub_bucle))
					orden_sub_bucle = 0;
				if(orden_sub_bucle == 0){
					$scope.entity.orden_tab = ($scope.rowsGrid.filter(function(e){ return e.orden_bucle == orden_bucle && (e.orden_sub_bucle > 0 || e.orden_tab > 0) && (!e.orden_tab2 && !e.orden_sub_sub_bucle); }).length) + 1;
					$scope.entity.orden_tab2 = 0;
				} else {
					$scope.entity.orden_tab = orden_sub_bucle;
					$scope.entity.orden_tab2 = ($scope.rowsGrid.filter(function(e){ return e.orden_bucle == orden_bucle && (e.orden_sub_bucle == orden_sub_bucle || e.orden_tab == orden_sub_bucle) && (e.orden_sub_sub_bucle > 0 || e.orden_tab2 > 0); }).length) + 1;	
				}
			}
		}
		
		$scope.transformListsToStrings();
		
		if($scope.isNew){
			$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det", $scope.entity).then(function(response){
				//Marcar la pregunta 702 para recargar.
				if($scope.pregunta.pregunta.id_pregunta == 64)
					ixStatusService.current.data.ToReload = { 702: true };
				$scope.clearEmptyRow();
				$scope.resetForm();
				ixStatusService.setResponse(response);
				response.data.obj.Record["$$treeLevel"] = ((response.data.obj.Record.orden_tab == 0) ? 0 : (!response.data.obj.Record.orden_tab2) ? 1 : 2);
				$scope.grid.ixAddRow(response.data.obj.Record);
				$timeout(function(){
					if($scope.grid.data[$scope.grid.data.length - 1].orden_tab >= 1){
						var addedRow = $scope.grid.data.splice($scope.grid.data.length - 1, 1);
						addedRow = addedRow[0];
						addedRow.orden_sub_bucle = addedRow.orden_tab;
						addedRow.orden_sub_sub_bucle = addedRow.orden_tab2;

						var itemsNivel2 = $scope.grid.data.filter(function(e){ return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle > 0 && (!e.orden_sub_sub_bucle); });//sub ingredientes
						var itemsNivel3 = [];//sub sub ingredientes
						var previousItem = null;
						if(itemsNivel2.length > 0){
							if(addedRow.orden_sub_sub_bucle >= 1){
								previousItem = $scope.grid.data.find(function(e){ return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle == (addedRow.orden_sub_bucle); });//ingrediente contenedor
								itemsNivel3 = $scope.grid.data.filter(function(e){ return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle == addedRow.orden_sub_bucle && (e.orden_sub_sub_bucle > 0); });//sub sub ingredientes
							}
							else {
								previousItem = $scope.grid.data.find(function(e){ return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle == (addedRow.orden_sub_bucle - 1); });
								itemsNivel3 = $scope.grid.data.filter(function(e){ return e.orden_bucle == previousItem.orden_bucle && e.orden_sub_bucle == previousItem.orden_sub_bucle && e.orden_sub_sub_bucle > 0; });//sub sub ingredientes del anterior
							}


						}
						else
							previousItem = $scope.grid.data.find(function(e){ return e.orden_bucle == addedRow.orden_bucle; });

						var indexPreviousItem = $scope.grid.data.indexOf(previousItem);
						$scope.grid.data.splice((indexPreviousItem + 1 + itemsNivel3.length), 0, addedRow);
					}
				},250);
			}, function(err){
				ixStatusService.setResponse(err);
			});
		} else {
			$uibModalInstance.close($scope.entity);
		}

	};
	
	$scope.transformListsToStrings = function(){
		if($scope.entity.sub_respuesta1 && angular.isArray($scope.entity.sub_respuesta1))
				$scope.entity.sub_respuesta1 = $scope.entity.sub_respuesta1.join(",");

		if($scope.entity.sub_respuesta2 && angular.isArray($scope.entity.sub_respuesta2))
			$scope.entity.sub_respuesta2 = $scope.entity.sub_respuesta2.join(",");

		if($scope.entity.sub_respuesta3 && angular.isArray($scope.entity.sub_respuesta3))
			$scope.entity.sub_respuesta3 = $scope.entity.sub_respuesta3.join(",");

		if($scope.entity.sub_respuesta4 && angular.isArray($scope.entity.sub_respuesta4))
			$scope.entity.sub_respuesta4 = $scope.entity.sub_respuesta4.join(",");

		if($scope.entity.sub_respuesta5 && angular.isArray($scope.entity.sub_respuesta5))
			$scope.entity.sub_respuesta5 = $scope.entity.sub_respuesta5.join(",");

		if($scope.entity.sub_respuesta6 && angular.isArray($scope.entity.sub_respuesta6))
			$scope.entity.sub_respuesta6 = $scope.entity.sub_respuesta6.join(",");

		if($scope.entity.sub_respuesta7 && angular.isArray($scope.entity.sub_respuesta7))
			$scope.entity.sub_respuesta7 = $scope.entity.sub_respuesta7.join(",");

		if($scope.entity.sub_respuesta8 && angular.isArray($scope.entity.sub_respuesta8))
			$scope.entity.sub_respuesta8 = $scope.entity.sub_respuesta8.join(",");
	};
	
	$scope.$dismiss = function(){
		$scope.entity.orden_bucle = $scope.entityOriginal.orden_bucle;
		$scope.entity.valor = $scope.entityOriginal.valor;
		$scope.entity.sub_respuesta1 = $scope.entityOriginal.sub_respuesta1;
		$scope.entity.sub_respuesta2 = $scope.entityOriginal.sub_respuesta2;
		$scope.entity.sub_respuesta3 = $scope.entityOriginal.sub_respuesta3;
		$scope.entity.sub_respuesta4 = $scope.entityOriginal.sub_respuesta4;
		$scope.entity.sub_respuesta5 = $scope.entityOriginal.sub_respuesta5;
		$scope.entity.sub_respuesta6 = $scope.entityOriginal.sub_respuesta6;
		$scope.entity.sub_respuesta7 = $scope.entityOriginal.sub_respuesta7;
		$scope.entity.sub_respuesta8 = $scope.entityOriginal.sub_respuesta8;

		if($scope.entity.sub_respuesta1 && angular.isArray($scope.entity.sub_respuesta1))
			$scope.entity.sub_respuesta1 = $scope.entity.sub_respuesta1.join(",");

		if($scope.entity.sub_respuesta2 && angular.isArray($scope.entity.sub_respuesta2))
			$scope.entity.sub_respuesta2 = $scope.entity.sub_respuesta2.join(",");

		if($scope.entity.sub_respuesta3 && angular.isArray($scope.entity.sub_respuesta3))
			$scope.entity.sub_respuesta3 = $scope.entity.sub_respuesta3.join(",");

		if($scope.entity.sub_respuesta4 && angular.isArray($scope.entity.sub_respuesta4))
			$scope.entity.sub_respuesta4 = $scope.entity.sub_respuesta4.join(",");
		
		if($scope.entity.sub_respuesta5 && angular.isArray($scope.entity.sub_respuesta5))
			$scope.entity.sub_respuesta5 = $scope.entity.sub_respuesta5.join(",");

		if($scope.entity.sub_respuesta6 && angular.isArray($scope.entity.sub_respuesta6))
			$scope.entity.sub_respuesta6 = $scope.entity.sub_respuesta6.join(",");

		if($scope.entity.sub_respuesta7 && angular.isArray($scope.entity.sub_respuesta7))
			$scope.entity.sub_respuesta7 = $scope.entity.sub_respuesta7.join(",");

		if($scope.entity.sub_respuesta8 && angular.isArray($scope.entity.sub_respuesta8))
			$scope.entity.sub_respuesta8 = $scope.entity.sub_respuesta8.join(",");

		$uibModalInstance.close();
	};
	
}]);

angular.module('FTBonpreuApp').controller("VistaRecepcionController", ['$scope', '$http', '$routeParams', 'cfg', 'ixStatusService', '$location', '$compile', '$log', '$translate', function ($scope, $http, $routeParams, cfg, ixStatusService, $location, $compile, $log, $translate) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.onCloseGoTo = "Recepcion/ListadoProductos";
  
  $scope.data.id_ficha_tecnica = $routeParams.id_ficha_tecnica;

  $http.get(cfg.baseURL + "recepcion_bp?id_ft=" + $scope.data.id_ficha_tecnica).then(function(response){
    $scope.data.cabecera = response.data.cabecera;
    $scope.status.display = $scope.status.display + ' ' + $scope.data.cabecera.tipo_ft;
    $scope.data.preguntas = response.data.preguntas;
  }, function(error){
    ixStatusService.setResponse(error);
  });


}]);

angular.module('FTBonpreuApp').controller('FormRecepcionController', ['$scope', 'ixStatusService', '$http', '$sce', '$compile', '$routeParams', '$log', '$translate', function ($scope, ixStatusService, $http, $sce, $compile, $routeParams, $log, $translate) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.data.id_ficha_tecnica = $routeParams.id_ficha_tecnica;
}]);
//ListadoProveedoresBPController
"use strict";

angular.module("FTBonpreuApp").controller('ListadoProveedoresBPController',['$scope', 'ixStatusService', 'gridService', function($scope, ixStatusService, gridService){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.init = function(){
    if (!$scope.data.gridProveedores){
      var acciones = [];
      var metadata = [];

      $scope.data.gridProveedores = gridService.createGrid($scope, 'grid_listproveedores_bp', { metadata: metadata }, 'listado_proveedores_bpVM');
    }
    else{
      $scope.data.gridProveedores = gridService.createGridFunctions($scope, $scope.data.gridProveedores);
      $scope.data.gridProveedores.ixRestoreConfig();
    }

    $scope.ixDownloadExcel = $scope.data.gridProveedores.ixDownloadExcel;
    $scope.data.gridProveedores.ixLoadInitialData();
  };

  $scope.$on('$destroy', function () {
    if ($scope.data.gridProveedores)
      $scope.data.gridProveedores.ixSaveConfig();
    $scope.isDestroyed = true;
  });

}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/

"use strict";

angular.module('FTBonpreuApp').controller('ListadoPlantasProductosBPController', ['$scope', '$filter', '$translate', 'ixStatusService', 'gridService', function($scope, $filter, $translate, ixStatusService, gridService){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  // $scope.status.editing = false;
  $scope.data.filtro = {};
  $scope.data.filtro.ft_activas = 1;

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function(){
    $scope.filterStatus = { isCollapsed: false };

    $scope.cargarGrid = function(){
      if (!$scope.data.gridPlantas){
        var acciones = [];
        var metadata = [];

        $scope.data.gridPlantas = gridService.createGrid($scope, 'grid_plantas_bp', { metadata: metadata }, 'listado_productos_plantasVM');
      }
      else {
        $scope.data.gridPlantas = gridService.createGridFunctions($scope, $scope.data.gridPlantas);
        $scope.data.gridPlantas.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.gridPlantas.ixDownloadExcel;
      //$scope.data.gridPlantas.filtroExterno = [{ Field: "ft_activas", OPerator: CMP_EQ, Value: $scope.data.filtro.ft_activas, Skip: true }];
      $scope.data.gridPlantas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['ft_activas']);
      $scope.data.gridPlantas.ixLoadInitialData();
    };


    $scope.cargarGrid();
  };
  /* ***** END INIT ***** */


  $scope.ixFiltrar = function () {
    $scope.filterStatus.isCollapsed = false;
    //$scope.data.gridPlantas.filtroExterno = [{ Field: "ft_activas", OPerator: CMP_EQ, Value: $scope.data.filtro.ft_activas, Skip: true }];
    $scope.data.gridPlantas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['ft_activas']);
    $scope.data.gridPlantas.ixLoadInitialData();
  };

 
  $scope.$on('$destroy', function () {
    if ($scope.data.gridPlantas)
      $scope.data.gridPlantas.ixSaveConfig();
    $scope.isDestroyed = true;
  });
  
}]);
/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
"use strict";

angular.module('FTBonpreuApp').controller('Listado_Ft_BpController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'authService', 'ixUtilsService', '$translate', '$window', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, authService, ixUtilsService, $translate, $window) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.data.activeTab = 0;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');
  // $scope.ocultaGuardar = true;

  $scope.gridManualLoad = true;

  $scope.biotecnalUser = false;

  if (!$scope.data.filtro) $scope.data.filtro = {};

  if (angular.isUndefined($scope.filterStatus))
    $scope.filterStatus = { isCollapsed: false };

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {

    var usuario = authService.authentication.userName;

    //Get condition user
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.data.extranetUser = response.data;

      if ($scope.data.extranetUser.cliente == null && $scope.data.extranetUser.proveedor == null && $scope.data.extranetUser.laboratorio == null && $scope.data.extranetUser.comprador == null) $scope.biotecnalUser = true;
      $scope.esLaboratorio = ($scope.data.extranetUser.laboratorio != null);

      $scope.cargarGrid();
      //if(!$scope.data.gridFtBp.data) {
        $timeout(function(){
          $scope.ixFiltrar();
        }, 0);  
      //}
      $scope.filterStatus.isCollapsed = false;
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.displayInformationPopup = function () {
      $scope.informativeDialog = $ngConfirm({
        icon: 'fa fa-info',
        title: '<translate>Información</translate>',
        content: '<translate>Se está generando la estructura necesaria para realizar la traducción. Cuándo haya terminado serás redireccionado al modo traducción de la ficha técnica.<translate>',
        scope: $scope,
        buttons: {
          close: {
            text: "Cerrar"
          }
        }
      });
    };

    $scope.crearTraduccionesFaltantes = function (id_ficha_tecnica, idioma) {
      $scope.displayInformationPopup();
      return $http.post(cfg.baseURL + "extranet_fichas_tecnicas_idioma/CreateTraduccionesFaltantes?id=" + id_ficha_tecnica + "&idioma=" + idioma);
    };


    $scope.openAppFT = function (entity, idioma, modo_traduccion) {
      var app = {};
      app.icon = 'perm_device_information';

      if (angular.isArray(entity)) {
        var id_fichas_tecnicas = entity.map(function (e) { return e.id; });

        app.display = 'Datos Ficha Tecnica';
        app.href = "FormularioFtBP/list";
        app.atributos = { id_fichas_tecnicas: id_fichas_tecnicas };
        app.multiple = true;
        app.atributos.idioma = idioma;
      }
      else {
        if ((entity.idioma) && entity.idioma != idioma)
          app.display = 'Modo Traducción' + idioma.toUpperCase();
        else
          app.display = 'Datos Ficha Técnica';

        app.href = "FormularioFtBP/list";
        app.atributos = { id_ficha_tecnica: entity.id };
        app.multiple = true;
        if ((entity.idioma) && entity.idioma != idioma)
          app.atributos.idioma = idioma;
      }

      if (angular.isDefined($scope.informativeDialog))
        $scope.informativeDialog.close();

      ixStatusService.openApp.bind(ixStatusService)(app);
    };

    // $scope.openAppFT_OLD = function(entity, idioma){
    // 	var app = {};
    // 	app.icon = 'perm_device_information';

    // 	if((entity.idioma) && entity.idioma != idioma)
    // 		app.display = 'Modo Traducción ' + idioma.toUpperCase();
    // 	else
    // 		app.display = 'Datos Ficha Técnica';

    // 	app.href = "FormularioFtBP/list";
    // 	app.atributos = { id_ficha_tecnica: entity.id };
    // 	app.multiple = true;

    // 	if((entity.idioma) && entity.idioma != idioma){
    // 		app.atributos.idioma = idioma;
    // 	}

    // 	if(angular.isDefined($scope.informativeDialog))
    // 		$scope.informativeDialog.close();

    // 	ixStatusService.openApp(app).bind(ixStatusService);
    // };

    $scope.cargarGrid = function () {
      if (!$scope.data.gridFtBp) {
        var acciones = [
					{
            titleFunction: function (entity) {
              var title = $translate.instant("Datos Ficha Técnica");
              if ((entity.idioma) && entity.idioma.toUpperCase() != "ES")
                title = $translate.instant("Modo Traducción");
              return title;
            },
            icon: 'assets/images/flags/es.png',
            customType: true,
            getStyle: function (entity) {
              return {
                "position": "relative",
                "top": "-1px",
                "margin": "0 3px"
              };
            },
            visible: function (entity) {
              if (angular.isDefined(entity)) {
                if (entity.idioma == null) return false;
                if ($scope.esLaboratorio) return false;
                if (entity.traducible && entity.idioma.toUpperCase() != "ES" && !$scope.tienePerfilAdmin()) return false;
                return entity.traducible || entity.idioma.toUpperCase() == "ES";
              }
              return false;
            },
            accion: function (entity) {
              var idiomaDistinto = (entity.idioma.toUpperCase() != "ES");
              if (idiomaDistinto && entity.traducible) {
                $scope.crearTraduccionesFaltantes(entity.id, "es").then(function (response) {
                  if (response.data) {
                    if (response.data.Result)
                      $scope.openAppFT(entity, "es");
                  }
                }, function (err) {
                  ixStatusService.setResponse(err);
                });
              } else
                $scope.openAppFT(entity, "es");
            }
          },
          {
            titleFunction: function (entity) {
              var title = $translate.instant("Datos Ficha Técnica");
              if ((entity.idioma) && entity.idioma.toUpperCase() != "CA")
                title = $translate.instant("Modo Traducción");
              return title;
            },
            icon: 'assets/images/flags/catalonia.png',
            customType: true,
            getStyle: function (entity) {
              return {
                "position": "relative",
                "top": "-1px",
                "margin": "0 3px"
              };
            },
            visible: function (entity) {
              if (angular.isDefined(entity)) {
                if (entity.idioma == null) return false;
                if ($scope.esLaboratorio) return false;
                if (entity.traducible && entity.idioma.toUpperCase() != "CA" && !$scope.tienePerfilAdmin()) return false;
                return entity.traducible || entity.idioma.toUpperCase() == "CA";
              }
              return false;
            },
            accion: function (entity) {
              var idiomaDistinto = ((entity.idioma) && entity.idioma.toUpperCase() != "CA");
              if (idiomaDistinto && entity.traducible) {
                $scope.crearTraduccionesFaltantes(entity.id, "ca").then(function (response) {
                  if (response.data) {
                    if (response.data.Result)
                      $scope.openAppFT(entity, "ca");
                  }
                }, function (err) {
                  ixStatusService.setResponse(err);
                });
              } else
                $scope.openAppFT(entity, "ca");
            }
          },
          {
            title: $translate.instant("Descargar Ficha Técnica"),
            icon: 'fa-download',
            accion: function (entity) {
              var template = "app/FTBonpreu/ListadosFtBP/acciones/imprimir_ftbp_popup.html";
              var options = { controller: "ImprimirFTBPPopupController" };
              var params = { id_ficha_tecnica: entity.id, idioma: entity.idioma, tipo: "FT_UNICA" };

              ixUtilsService.openModalV2(template, options, "small", params);
            }
          }
        ];
        var metadata = [
          {
            Name: "agrupacion",
            NoVisible: ($scope.data.extranetUser.proveedor || $scope.data.extranetUser.laboratorio)
          },
          {
            Name: "comentarios",
            NoVisible: ($scope.data.extranetUser.proveedor || $scope.data.extranetUser.laboratorio)
          },
          {
            Name: "ultimo_comentario",
            NoVisible: ($scope.data.extranetUser.proveedor || $scope.data.extranetUser.laboratorio)
          },
          {
            Name: "comprador",
            NoVisible: ($scope.data.extranetUser.proveedor || $scope.data.extranetUser.laboratorio)
          },
          {
            Name: "comunicaciones_recepcion",
            NoVisible: ($scope.data.extranetUser.proveedor || $scope.data.extranetUser.laboratorio)
          },
          {
            Name: "traducible",
            NoVisible: ($scope.data.extranetUser.proveedor || $scope.data.extranetUser.laboratorio)
          },
          {
            Name: "idioma",
            NoVisible: ($scope.data.extranetUser.proveedor || $scope.data.extranetUser.laboratorio)
          },
          {
            Name: "revision_inicial",
            NoVisible: !$scope.biotecnalUser
          },
          {
            Name: "revision_final",
            NoVisible: !$scope.biotecnalUser
          },
          {
            Name: "notificacion_proveedor",
            NoVisible: !$scope.biotecnalUser
          }
        ];

        $scope.compruebaEstadoFT = function (row) {
          return (row.entity.codigo_estado == 'X' || row.entity.codigo_estado == 'S');
        };

        $scope.data.gridFtBp = gridService.createGrid($scope, 'bp_ftGrid', { metadata: metadata, compruebaAlarmaFunc: $scope.compruebaEstadoFT }, 'listado_bp_ftVM', [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);

        //$scope.numberOfChanges = angular.isUndefined($scope.numberOfChanges) ? $scope.data.gridFtBp.numberOfChanges : $scope.numberOfChanges;//podem sobreescriure la funció.
        $scope.numberOfChanges = $scope.data.gridFtBp.numberOfChanges;
      }
      else {
        $scope.data.gridFtBp = gridService.createGridFunctions($scope, $scope.data.gridFtBp);
        $scope.data.gridFtBp.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.gridFtBp.ixDownloadExcel;
    }

    $scope.ixGuardar = function () {
      $scope.data.gridFtBp.ixGuardar();
    };

    $scope.ixEditar = function () {
      //$scope.status.editing = true;
      ixStatusService.setEditing(true);
    }

    $scope.ixCancelEdit = function () {
      $scope.data.gridFtBp.ixCancelEdit();
    }


    $scope.getSelectedRows = function () {
      var selectedRows = [];
      if (angular.isDefined($scope.data.gridFtBp)) {
        selectedRows = $scope.data.gridFtBp.data.filter(function (e) { return e.Selector; });
      }

      return selectedRows;
    };


    $scope.abrirMultiplesFichasTecnicas = function () {
      var fichas_tecnicas = $scope.getSelectedRows();
      if (fichas_tecnicas.length > 0)
        $scope.openAppFT(fichas_tecnicas);
    };


    $scope.ixDeleteSelectedRows = function () {
      $scope.data.gridFtBp.ixDeleteSelectedRows();
    }
    // $scope.ixCancelEdit = function(){
    //   $scope.data.gridFtBp.ixCancelEdit();
    //   ixStatusService.setEditing(false);
    // };

    if (!$scope.tienePerfilAdmin())
      $scope.ixEditar = undefined;
  }

  $scope.tienePerfilAdmin = function () {
    return authService.tienePerfilAdmin() || authService.tienePerfilUserKey();
  }

  $scope.esPerfilVisitante = function () {
    var esVisitante = false;
    var perfilesUsuario = authService.perfilesUsuario();

    angular.forEach(perfilesUsuario, function (perfil) {
      if (perfil == "usr_visitante")
        esVisitante = true;
    });
    return esVisitante;
  }

  $scope.openAddFtPopup = function () {
    var template = "app/FTBonpreu/ListadosFtBP/acciones/add_ftbp_popup.html";
    var optionsPopup = { controller: "AddFtBpPopupController" };
    var modalAdd = ixUtilsService.openModalV2(template, optionsPopup, "small");
    modalAdd.then(function (response) {
      $log.log(response);
      if (response) {
        var app = {};
        app.icon = "list";
        app.display = "Ficha técnica";
        app.href = "FormularioFtBP/list";
        app.atributos = { id_ficha_tecnica: response };
        app.multiple = true;
        $timeout(function () {
          ixStatusService.openApp(app).bind(ixStatusService);
        }, 1);
      }
    });
  }

  $scope.$on("$destroy", function () {
    $scope.data.gridFtBp.ixSaveConfig();
    $scope.isDestroyed = true;
  });

  /* **** FUNCTION: IXFILTRAR **** */
  $scope.ixFiltrar = function () {
    $log.log("EJECUTANDO ixFiltrar");
    angular.forEach($scope.data.filtro, function(value,key){
      if(value == null || value == undefined || value=="")
        delete $scope.data.filtro[key];
    });
    $scope.filterStatus.isCollapsed = false;
    
    if (!$scope.data.filtro.estado || $scope.data.filtro.estado.length == 0) {
       $scope.data.filtro.estado = ["A", "B", "C", "E", "I", "L", "M", "N", "P", "R", "O", "Q", "S", "T"];
     }

    if ($scope.data.extranetUser.proveedor) {
      if ($scope.data.filtro.estado) {
        $scope.data.filtro.estado = $scope.data.filtro.estado.filter(function (x) { return (x != "L" && x != "T") });
      }
    }
    if ($scope.data.extranetUser.laboratorio) {
      if ($scope.data.filtro.estado) {
        $scope.data.filtro.estado = $scope.data.filtro.estado.filter(function (x) { return x != "X" });
      }
    }

    $scope.data.gridFtBp.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["tipo_ft", "estado", "marca", "proveedor", "departamento", "busqueda_generica"]);
    $scope.data.gridFtBp.ixLoadInitialData().then(function (response) {
      $scope.drawPivotFt();

      if ($scope.data.activeTab == 1) {
        $timeout(function () {
          $scope.changeTab(1);
        }, 1);
      }
    });

    $scope.status.filtered = true;
  }

  // if ($scope.status.filtered)
  //   $scope.ixFiltrar();

  /* ***** FUNCTION: CHANGETAB ***** */
  $scope.changeTab = function (idxTab) {
    $scope.data.activeTab = idxTab;
    switch (idxTab) {
      case 0:
        $timeout(function () {
          $scope.showGrid($scope.data.gridFtBp);
        }, 400);
        break;
      case 1:
        $scope.drawPivotFt();
        break;
      default:
        break;
    }
  }

  /* ***** FUNCTION: DRAWPIVOTFICHASTECNICAS ***** */
  $scope.drawPivotFt = function () {
    $timeout(function () {
      var filteredRows = $scope.data.gridFtBp.gridApi.grid.getVisibleRows().map(function (e) { return angular.copy(e.entity); });
      angular.forEach(filteredRows, function (row) {
        if (row.estado == null) {
          row.estado = "SIN ESTADO";
        }
        if (row.tipo_ft == null) {
          row.tipo_ft = "TIPO DESCONOCIDO";
        }
      });
      $scope.drawPivot("#pivotFtBp", filteredRows, { rows: ["nombre_estado"], cols: ["descripcion_tipo_ft"] });
    }, 1);
  }

  /* ***** FUNCTION: DRAWPIVOT ***** */
  // $scope.drawPivot = function (tagId, data, pivotOptionsOverride) {
  //   $scope.renderers = $.pivotUtilities;
  //   $scope.pivotData = data;
  //   var pivotOptionsDefault = {
  //     rows: [],
  //     cols: [],
  //     renderers: $.extend($.pivotUtilities.renderers, $.pivotUtilities.d3_renderers, $.pivotUtilities.c3_renderers, $.pivotUtilities.export_renderers),
  //     rendererName: "Table",
  //     derivedAttributes: addDateDeriveds(cfg, $filter, $.pivotUtilities.derivers, data)
  //   };

  //   var pivotOptions = angular.merge(pivotOptionsDefault, pivotOptionsOverride);
  //   angular.element(tagId).pivotUI($scope.pivotData, pivotOptions, false, "es");
  // };

  $scope.drawPivot = function (tagId, data, pivotOptionsOverride) {
    $timeout(function () {
      ixUtilsService.drawPivot(tagId, angular.copy(data), pivotOptionsOverride);
    }, 1);
  };


  $scope.impresionMasivaFT = function () {
    var template = "app/FTBonpreu/ListadosFtBP/acciones/imprimir_ftbp_popup.html";
    var options = { controller: "ImprimirFTBPPopupController" };
    var params = { tipo: "FT_MASIVA", idioma: authService.authentication.language };

    var lista_ft_sel = [];

    $scope.data.gridFtBp.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
      var idft = row.id;
      lista_ft_sel.push(idft);
    });

    params.lista_fichas = lista_ft_sel;

    if (lista_ft_sel.length > 0)
      ixUtilsService.openModalV2(template, options, "small", params);
  };

  $scope.seleccionarRowsVisibles = function () {
    $scope.data.gridFtBp.gridApi.grid.getVisibleRows().forEach(function (row) {
      row.entity.Selector = true;
    });
  }

  $scope.desSeleccionarRows = function () {
    $scope.data.gridFtBp.data.forEach(function (row) {
      row.Selector = false;
    });
  }

}]);

/*global CMP_EQ*/
/*global saveAs*/
/*global ixFiltersToArray*/

"use strict";

angular.module('FTBonpreuApp').controller('ListadoFicherosProveedoresBPController', ['$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'uiGridConstants', 'cfg', '$http', '$filter', '$translate', '$log', 'authService', function ($scope, ixUtilsService, ixStatusService, gridService, uiGridConstants, cfg, $http, $filter, $translate, $log, authService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;
  $scope.data.filtro = {};
  $scope.data.filtro.vigentes = 1;

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {
    var usuario = authService.authentication.userName;
    var perfilesUsuario = authService.perfilesUsuario();
    $scope.esComprador = perfilesUsuario.includes('usr_comprador');

    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.extranetUser = response.data;
      $scope.cargarGrid();
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.filterStatus = { isCollapsed: false };

    if ($scope.data.gridProveedoresFicheros)
      $scope.ixDownloadExcel = $scope.data.gridProveedoresFicheros.ixDownloadExcel;

    $scope.cargarGrid = function () {
      if (!$scope.data.gridProveedoresFicheros) {
        var acciones = [
          {
            title: $translate.instant('Previsualizar PDF'),
            icon: "fa-file-pdf-o",
            visible: function (entity) {
              return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
            },
            accion: function (entity) {
              var tabla = "proveedores_ficheros";
              $http({
                method: 'post',
                url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
                headers: {},
                responseType: 'arraybuffer'
              }).then(function (r) {
                $scope.selectedPDF = new Uint8Array(r.data);
                $scope.idFicheroPreview = entity.id;
                var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
                ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
              },
                function (err) {
                  ixStatusService.setResponse(err);
                });
            }
          },
          {
            title: $translate.instant('Previsualizar Imagen'),
            icon: "fa-file-image-o",
            visible: function (entity) {
              return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
            },
            accion: function (entity) {
              var tabla = $scope.getEntity();
              $http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
                $scope.selectedImage = r.data;
                $scope.idFicheroPreview = entity.id;
                var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
                ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
              },
                function (err) {
                  ixStatusService.setResponse(err);
                });
            }
          },
          {
            title: $translate.instant('Descargar fichero'),
            icon: "fa-download",
            visible: function (entity) {
              return entity.archivo;
            },
            accion: function (entity) {
              //var esProveedor = angular.isDefined(entity.proveedor);
              // $scope.downloadFile(entity.id, esProveedor);
              $scope.downloadFile(entity.id);
            }
          },
          {
            title: $translate.instant('Editar fichero'),
            icon: "fa-pencil",
            visible: function(){
              return ($scope.esComprador == false);
            },
            accion: function(entity){
              // $scope.openPopupEditarFichero();
              var urlTemplate = "app/FTBonpreu/MantenimientosBP/proveedores/modales/popupFicheroProveedor.html";
              var controllerName = "PopupFicheroProveedorController";
              var optionsPopup = {
                controller: controllerName
              };
              var params = { "id_fichero": entity.id, "id_proveedor": entity.proveedor, "mantenimiento_proveedor": false, "grupo": entity.grupo, "fabricante": entity.fabricante, "planta": entity.planta };
              var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopup, 'small', params);
              modalInstance.then(function(resp){
                //Recargar grid de ficheros
                if (resp) $scope.data.gridProveedoresFicheros.ixLoadInitialData();
                $scope.status.editing = false;
              });
            }
          }
        ];

        var metadata = [
          { Name: 'tipo_proveedor', NoVisible: false },
          { Name: 'area_proveedor', NoVisible: false },
          { Name: 'alcance', NoVisible: true },
          { Name: 'comentarios', NoVisible: true },
          { Name: 'verificacion', NoVisible: true },
          {
            Name: "fecha_caducidad",
            Sort:
            {
              direction: uiGridConstants.DESC,
              ignoreSort: false,
              //skipTableNameOrderBy: true, //??? YVES
              skipTableName: true,
              priority: 0
            }
          }		
        ];

        var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.activo == 0), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
        $scope.data.gridProveedoresFicheros = gridService.createGrid($scope, 'grid_ficheros_proveedores', { metadata: metadata }, 'listado_proveedores_ficherosVM', [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
        $scope.data.gridProveedoresFicheros.rowTemplate = rowTemplate;
        $scope.numberOfChanges = angular.isUndefined($scope.numberOfChanges) ? $scope.data.gridProveedoresFicheros.numberOfChanges : $scope.numberOfChanges;//podem sobreescriure la funció.
        $scope.ixDownloadExcel = $scope.data.gridProveedoresFicheros.ixDownloadExcel;
        if ($scope.extranetUser.comprador != null) {
          $scope.data.filtro.comprador = $scope.extranetUser.comprador;
        }
        $scope.data.gridProveedoresFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['comprador', 'vigentes']);
      }
      else {
        $scope.data.gridProveedoresFicheros = gridService.createGridFunctions($scope, $scope.data.gridProveedoresFicheros);
        $scope.data.gridProveedoresFicheros.ixRestoreConfig();
      }

      //$scope.data.gridProveedoresFicheros.ixLoadInitialData();
    };


  }; //END INIT


  $scope.downloadFile = function (id) {
    var entity = "proveedores_ficheros";
    $http({
      method: 'post',
      url: cfg.baseURL + entity + '/DownloadFile?id=' + id,
      headers: { 'Content-type': 'application/pdf' },
      responseType: 'arraybuffer'
    }).then(function (r) {
      var mimetype = r.headers('Content-type');
      var file = new Blob([r.data], { type: mimetype });

      var filename = $scope.entity + ".pdf";
      if (r.headers('Content-Disposition')) {
        filename = r.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    },
      function (err) {
        ixStatusService.setResponse(err);
      });
  };


  $scope.ixFiltrar = function () {
    $scope.filterStatus.isCollapsed = false;
    $scope.data.gridProveedoresFicheros.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }];
    if ($scope.extranetUser.comprador != null) {
      $scope.data.filtro.comprador = $scope.extranetUser.comprador;
    }

    $scope.data.gridProveedoresFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['comprador', 'vigentes']);
    $scope.data.gridProveedoresFicheros.ixLoadInitialData();
  };

  // $scope.ixEditar = function(){
  //   ixStatusService.setEditing(true);
  // };


  // $scope.ixGuardar = function(){
  //   var bulkParam = $scope.data.gridProveedoresFicheros.ixGetBulkParam();
  //   $http.post(cfg.baseURL + "listado_ficheros_proveedorBP/ActualizarFechas",bulkParam).then(function(r){
  //     $scope.data.gridProveedoresFicheros.clearGridAfterSave();
  //     ixStatusService.setResponse(r);
  //   },function(error){
  //     ixStatusService.setResponse(error);
  //   });

  //   ixStatusService.setEditing(false);
  // };


  $scope.impresionMasivaFicheros = function(){
    var lista = [];

    $scope.data.gridProveedoresFicheros.data.filter(function(row) { return row.Selector == true; }).forEach(function(row){
      //var fichero = { id: row.id };
      lista.push(row.id);
    });

    var config = { responseType: 'arraybuffer' };

    $http.post(cfg.baseURL + "proveedores_ficheros/DescargaMultiple", lista, config).then(function(response){
      var file = new Blob([response.data], { type: 'application/zip' });

      var filename = "ficheros_proveedores.zip";
      if (response.headers('Content-Disposition')) {
        filename = response.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    }, function(error){
      ixStatusService.setResponse(error);
    });
  };


  $scope.seleccionarRowsVisibles = function(){
    $scope.data.gridProveedoresFicheros.gridApi.grid.getVisibleRows().forEach(function(row){
      row.entity.Selector = true;
    });
  };


  $scope.borrarSeleccionRows = function(){
    $scope.data.gridProveedoresFicheros.data.forEach(function(row){
      row.Selector = false;
    });
  };


  $scope.$on('$destroy', function () {
    if ($scope.data.gridProveedoresFicheros)
      $scope.data.gridProveedoresFicheros.ixSaveConfig();
    $scope.isDestroyed = true;
  });

}]);
/*global CMP_EQ*/
/*global saveAs*/
/*global ixFiltersToArray*/

"use strict";

angular.module('FTBonpreuApp').controller('ListadoFicherosFtBPController', ['$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'uiGridConstants', 'cfg', '$http', '$filter', '$translate', '$log', 'authService', function ($scope, ixUtilsService, ixStatusService, gridService, uiGridConstants, cfg, $http, $filter, $translate, $log, authService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;
  $scope.data.filtro = {};
  $scope.data.filtro.vigentes = 1;

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {
    var usuario = authService.authentication.userName;

    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.extranetUser = response.data;
      $scope.cargarGrid();
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.filterStatus = { isCollapsed: false };

    if ($scope.data.gridFtFicheros)
      $scope.ixDownloadExcel = $scope.data.gridFtFicheros.ixDownloadExcel;

    $scope.cargarGrid = function () {
      if (!$scope.data.gridFtFicheros) {
        var acciones = [
          {
            title: $translate.instant("Previsualizar PDF"),
            icon: "fa-file-pdf-o",
            visible: function (entity) {
              return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
            },
            accion: function (entity) {
              var tabla = "fichas_tecnicas_ficheros";
              $http({
                method: 'post',
                url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
                headers: {},
                responseType: 'arraybuffer'
              }).then(function (r) {
                $scope.selectedPDF = new Uint8Array(r.data);
                $scope.idFicheroPreview = entity.id;
                var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
                ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
              },
                function (err) {
                  ixStatusService.setResponse(err);
                });
            }
          },
          {
            title: $translate.instant("Previsualizar Imagen"),
            icon: "fa-file-image-o",
            visible: function (entity) {
              return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
            },
            accion: function (entity) {
              var tabla = "fichas_tecnicas_ficheros"; //$scope.getEntity();
              $http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
                $scope.selectedImage = r.data;
                $scope.idFicheroPreview = entity.id;
                var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
                ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
              },
                function (err) {
                  ixStatusService.setResponse(err);
                });
            }
          },
          {
            title: $translate.instant("Descargar fichero"),
            icon: "fa-download",
            visible: function (entity) {
              return entity.archivo;
            },
            accion: function (entity) {
              $scope.downloadFile(entity.id);
            }
          },
          {
            title: $translate.instant("Editar"),
            icon: "fa-pencil",
            visible: function(){
              return true;
            },
            accion: function(entity){
              var urlTemplate = "app/FTBonpreu/FormularioFtBP/modales/editarFicheroFtPopup.html";
              var controllerName = "EditarFicheroFtPopupController";
              var optionsPopup = {
                controller: controllerName
              };
              var params = { "id_ft": entity.id_ficha_tecnica, "id_fichero": entity.id };
              var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopup, 'medium', params);
              modalInstance.then(function(resp){
                //Recargar grid de ficheros
                if (resp) $scope.data.gridFtFicheros.ixLoadInitialData();
                $scope.status.editing = false;
              });
            }
          }
        ];

        var metadata = [
          { Name: 'id_ficha_tecnica', NoVisible: false },
          { Name: 'activo', NoVisible: false },
          {
            Name: "fecha_caducidad",
            Sort:
            {
              direction: uiGridConstants.DESC,
              ignoreSort: false,
              //skipTableNameOrderBy: true, //??? YVES
              skipTableName: true,
              priority: 0
            }
          }		
        ];

        var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.activo == 0), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
        $scope.data.gridFtFicheros = gridService.createGrid($scope, 'grid_ficheros_fichastecnicas', { metadata: metadata }, 'listado_ficheros_ftBPVM', [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
        $scope.data.gridFtFicheros.rowTemplate = rowTemplate;
        $scope.numberOfChanges = angular.isUndefined($scope.numberOfChanges) ? $scope.data.gridFtFicheros.numberOfChanges : $scope.numberOfChanges;//podem sobreescriure la funció.
        $scope.ixDownloadExcel = $scope.data.gridFtFicheros.ixDownloadExcel;
        $scope.data.gridFtFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['vigentes']);
      }
      else {
        $scope.data.gridFtFicheros = gridService.createGridFunctions($scope, $scope.data.gridFtFicheros);
        $scope.data.gridFtFicheros.ixRestoreConfig();
      }

      $scope.data.gridFtFicheros.ixLoadInitialData();
    };


  }; //END INIT


  $scope.downloadFile = function (id) {
    var entity = "fichas_tecnicas_ficheros";
    $http({
      method: 'post',
      url: cfg.baseURL + entity + '/DownloadFile?id=' + id,
      headers: {},
      responseType: 'arraybuffer'
    }).then(function (r) {
      var mimetype = r.headers('Content-type');
      var file = new Blob([r.data], { type: mimetype });

      var filename = $scope.entity + ".pdf";
      if (r.headers('Content-Disposition')) {
        filename = r.headers('Content-Disposition').split("=")[1];
      }
      /*
      if (r.headers('Content-Disposition')) {
        // filename = response.headers('Content-Disposition').split("=")[1];
				filename = r.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
      }
      */
      saveAs(file, filename);
    },
      function (err) {
        ixStatusService.setResponse(err);
      });
  };


  $scope.ixFiltrar = function () {
    $scope.filterStatus.isCollapsed = false;
    $scope.data.gridFtFicheros.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }];
    // if ($scope.extranetUser.comprador != null) {
    //   $scope.data.filtro.comprador = $scope.extranetUser.comprador;
    // }

    // $scope.data.gridFtFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['comprador', 'vigentes']);
    $scope.data.gridFtFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['vigentes']);
    $scope.data.gridFtFicheros.ixLoadInitialData();
  };


  $scope.impresionMasivaFicheros = function(){
    var lista = [];

    $scope.data.gridFtFicheros.data.filter(function(row) { return row.Selector == true; }).forEach(function(row){
      //var fichero = { id: row.id };
      lista.push(row.id);
    });

    var config = { responseType: 'arraybuffer' };

    $http.post(cfg.baseURL + "fichas_tecnicas_ficheros/DescargaMultiple", lista, config).then(function(response){
      var file = new Blob([response.data], { type: 'application/zip' });

      var filename = "ficheros_fichastecnicas.zip";
      if (response.headers('Content-Disposition')) {
        filename = response.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    }, function(error){
      ixStatusService.setResponse(error);
    });
  };


  $scope.loadFiles = function(){
    var template = "app/FTBonpreu/ListadosFtBP/acciones/carga_masiva_ficheros_ftbp_popup.html";
		var optionsPopup = { controller: "CargaMasivaFicherosFtBPController" };
    var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium");
    popup.then(function (data){
      $log.log("Cerrado popup");
    });
  };


  $scope.seleccionarRowsVisibles = function(){
    $scope.data.gridFtFicheros.gridApi.grid.getVisibleRows().forEach(function(row){
      row.entity.Selector = true;
    });
  };


  $scope.borrarSeleccionRows = function(){
    $scope.data.gridFtFicheros.data.forEach(function(row){
      row.Selector = false;
    });
  };


  $scope.$on('$destroy', function () {
    if ($scope.data.gridFtFicheros)
      $scope.data.gridFtFicheros.ixSaveConfig();
    $scope.isDestroyed = true;
  });

}]);
/*global CMP_EQ*/
/*global ixFiltersToArray*/

"use strict";

angular.module('FTBonpreuApp').controller('ListadoEmpresasPlantasBPController', ['$scope', '$filter', '$translate', 'ixStatusService', 'gridService', function($scope, $filter, $translate, ixStatusService, gridService){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  // $scope.status.editing = false;
  $scope.data.filtro = {};
  $scope.data.filtro.activas = 1;

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function(){
    $scope.filterStatus = { isCollapsed: false };

    $scope.cargarGrid = function(){
      if (!$scope.data.gridPlantas){
        var acciones = [];
        var metadata = [];

        $scope.data.gridPlantas = gridService.createGrid($scope, 'grid_empresas_plantas_bp', { metadata: metadata }, 'listado_empresas_plantasVM');
      }
      else {
        $scope.data.gridPlantas = gridService.createGridFunctions($scope, $scope.data.gridPlantas);
        $scope.data.gridPlantas.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.gridPlantas.ixDownloadExcel;
      //$scope.data.gridPlantas.filtroExterno = [{ Field: "activas", OPerator: CMP_EQ, Value: $scope.data.filtro.activas, Skip: true }];
      $scope.data.gridPlantas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['activas']);
      $scope.data.gridPlantas.ixLoadInitialData();
    };


    $scope.cargarGrid();
  };
  /* ***** END INIT ***** */


  $scope.ixFiltrar = function () {
    $scope.filterStatus.isCollapsed = false;
    $scope.data.gridPlantas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['activas']);
    $scope.data.gridPlantas.ixLoadInitialData();
  };

  
  $scope.$on('$destroy', function () {
    if ($scope.data.gridPlantas)
      $scope.data.gridPlantas.ixSaveConfig();
    $scope.isDestroyed = true;
  });

}]);
"use strict";

angular.module('FTBonpreuApp').controller('TirajesEtiquetadoController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$translate', '$log', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $translate, $log) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;

  $scope.init = function () {
    if (!$scope.data.gridTirajes) {
      var acciones = [
        {
          title: $translate.instant("Datos Ficha Técnica"),
          icon: 'fa-pencil',
          accion: function (entity) {
            $scope.openAppFT(entity);
          }
        }
      ];

      $scope.data.gridTirajes = gridService.createGrid($scope, 'grid_tirajes_etiquetado', { enableCellEdit: false }, 'listado_tiraje_etiquetasVM', [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
    }
    else {
      $scope.data.gridTirajes = gridService.createGridFunctions($scope, $scope.data.gridTirajes);
      $scope.data.gridTirajes.ixRestoreConfig();
    }

    $scope.ixDownloadExcel = $scope.data.gridTirajes.ixDownloadExcel;
    $scope.data.gridTirajes.ixLoadInitialData();

    $scope.openAppFT = function (entity) {
      var app = {};
      app.icon = 'perm_device_information';

      app.display = 'Datos Ficha Técnica';

      app.href = "FormularioFtBP/list";
      app.atributos = { id_ficha_tecnica: entity.id_ficha_tecnica };
      app.multiple = true;

      //app.atributos.idioma = entity.idioma;
      app.atributos.idioma = undefined;

      ixStatusService.openApp(app).bind(ixStatusService);
    };

    $scope.$on('$destroy', function () {
      $scope.data.gridTirajes.ixSaveConfig();
      $scope.isDestroyed = true;
    });

  }


}]);

/*global CMP_EQ*/
/*global saveAs */
"use strict";

angular.module('FTBonpreuApp').controller('Busqueda_AvanzadaBPController', [ '$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$translate', '$log', function($scope, ixStatusService, gridService, cfg, $http, $filter, $translate, $log){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.data.activeTab = 0;

  var imprimirExcel = function(id_pregunta){
    var param = {};
    param.Selection = {};
    param.Selection.Filters = [{Field: 'id_pregunta', Value: id_pregunta, Operator: CMP_EQ, Skip:true}];
    param.Fields = [
      {Field: 'ficha_tecnica'},
      {Field: 'tipo'},
      {Field: 'cod_proveedor'},
      {Field: 'cod_producto'},
      {Field: 'desc_producto'},
      {Field: 'ean'},
      {Field: 'marca'},
      {Field: 'area'},
      {Field: 'estado'},
      {Field: 'agrupacion'},
      {Field: 'fecha_baja_axional'},
      {Field: 'componente'},
      {Field: 'respuesta'},
      {Field: 'observaciones'},
      {Field: 'sub_respuesta1'},
      {Field: 'sub_respuesta2'},
      {Field: 'sub_respuesta3'},
      {Field: 'sub_respuesta4'},
      {Field: 'sub_respuesta5'},
      {Field: 'sub_respuesta6'},
      {Field: 'sub_respuesta7'},
      {Field: 'sub_respuesta8'}
    ];

    var config = {responseType:"arraybuffer"};

    $http.post(cfg.baseURL +'listado_busqueda_avanzada_bpVM' + '/Excel' , param, config).then(function(r){
      var file = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      var filename = "llistat_recerca_avançada_" + $filter('date')(new Date(), 'HHmmss', null) + ".xlsx";

      if(r.headers('Content-Disposition')) {
        var nameFromServer = r.headers('Content-Disposition').split("=")[1];
        if(nameFromServer != "\""){
          filename = nameFromServer;
        }
      }

      saveAs(file, filename);
    }, function(err){
      ixStatusService.setResponse(err);
    });
  };


  $scope.init = function(){
    if (!$scope.data.gridBusqueda) {
      var acciones = [
        {
          title: $translate.instant('Imprimir excel'),
          icon: 'fa-file-excel-o',
          accion: function(entity){
  					imprimirExcel(entity.id_pregunta);
  				}
        }
      ];
      var metadata = [];

      $scope.data.gridBusqueda = gridService.createGrid($scope, 'grid_busqueda_avanzada_bp', { }, 'list_preguntas_busqueda_avanzadaVM', [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
    }
    else {
      $scope.data.gridBusqueda = gridService.createGridFunctions($scope, $scope.data.gridBusqueda);
      $scope.data.gridBusqueda.ixRestoreConfig();
    }
  };


  $scope.$on('$destroy', function () {
    if ($scope.data.gridBusqueda)
      $scope.data.gridBusqueda.ixSaveConfig();
    $scope.isDestroyed = true;
  });


}]);
/*global CMP_EQ*/
/*global saveAs*/

"use strict";

angular.module("FTBonpreuApp").controller("ListadoResultadosAnalisisController", ['$scope', '$routeParams', '$http', '$translate', '$filter', '$log', 'cfg', 'authService', 'ixStatusService', 'ixUtilsService', 'gridService', function ($scope, $routeParams, $http, $translate, $filter, $log, cfg, authService, ixStatusService, ixUtilsService, gridService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;

  $scope.init = function () {
    $scope.filterAPIBy = "year";
    $scope.period = 1;

    // var usuario = authService.authentication.userName;
    var perfilesUsuario = authService.perfilesUsuario();
    var perfilPuedeDesfinalizar = authService.tienePerfilAdmin() || authService.tienePerfilUserKey() || perfilesUsuario.includes('usr_laboratorio');
    //var perfilProveedor = perfilesUsuario.includes('usr_proveedor');

    if (!$scope.data.gridResultados) {
      var acciones = [
        {
          title: $translate.instant('Visualizar'),
          icon: 'fa-search',
          visible: function (entity) {
            return entity.finalizada == 1 && perfilPuedeDesfinalizar;
          },
          accion: function (entity) {
            //Abrir resultadosAnalisisPopup en modalidad visualizacion
            openResultado(entity);
          }
        },
        {
          title: $translate.instant('Modificar'),
          icon: 'fa-pencil',
          visible: function (entity) {
            return entity.finalizada == 0 && perfilPuedeDesfinalizar;
          },
          accion: function (entity) {
            //Abrir resultadosAnalisisPopup en modalidad visualizacion
            openResultado(entity);
          }
        },
        {
          title: $translate.instant('Descargar informes'),
          icon: "fa-download",
          accion: function (entity) {
            $scope.descargarInformesResultado(entity.id);
          }
        },
        {
          title: $translate.instant('Duplicar por lote'),
          icon: 'fa-clipboard',
          visible: function (entity) {
            return entity.extra == 1 && entity.finalizada == 1 && perfilPuedeDesfinalizar;
          },
          accion: function (entity) {
            duplicarPorLote(entity);
          }
        },
        {
          title: $translate.instant("Desfinalizar"),
          icon: "fa-undo",
          visible: function (entity) {
            return (perfilPuedeDesfinalizar && entity.finalizada == 1);
          },
          accion: function (entity) {
            desfinalizarResultado(entity);
          }
        },
        {
          title: $translate.instant('Eliminar resultado'),
          icon: 'fa-trash',
          visible: function (entity) {
            return $scope.tienePerfilBio();
          },
          accion: function (entity) {
            $scope.eliminarResultado(entity);
          }
        }
      ];

      var metadata = [];

      $scope.data.gridResultados = gridService.createGrid($scope, 'grid_resultados_analisis', { enableCellEdit: false }, 'listado_resultados_analiticasVM', [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
      if (angular.isDefined($routeParams.id_ft)) {
        $scope.data.gridResultados.filtroExterno = [
          { Field: "id_ficha_tecnica", Skip: true, Value: $routeParams.id_ft }
        ];
      }
    }
    else {
      $scope.data.gridResultados = gridService.createGridFunctions($scope, $scope.data.gridResultados);
      $scope.data.gridResultados.ixRestoreConfig();
    }

    //Intervalo fechas por defecto: primer día del año pasado - hoy;
    // $log.log($scope.data.gridResultados.columnDefs);
    // var col = $filter("filter")($scope.data.gridResultados.columnDefs, { 'field': 'fecha_analisis'});
    // var today = new Date();
    // var firstDayLastYear = new Date(new Date().getFullYear() - 1, 0, 1);
    // col[0].filters[0].data_ini = firstDayLastYear;
    // col[0].filters[0].data_fi = today;

    $scope.ixDownloadExcel = $scope.data.gridResultados.ixDownloadExcel;
    // $scope.data.gridResultados.ixLoadInitialData();

    var openResultado = function (entity) {
      var template = "app/FTBonpreu/GestionAnaliticasBP/modales/resultadosAnalisisPopup.html";
      var optionspopup = { controller: "ResultadosAnalisisController" };
      var paramsPopup = { isNew: false, id: entity.id, finalizada: entity.finalizada };
      if (entity.extra == 1)
        paramsPopup.id_analisis_extra = entity.id;

      ixUtilsService.openModalV2(template, optionspopup, "big", paramsPopup).then(function (response) {
        if (response) {
          $scope.data.gridResultados.ixLoadInitialData();
        }
      });
    };


    var desfinalizarResultado = function (entity) {
      $http.put(cfg.baseURL + "resultados_analisis/DesfinalizarResultado/" + entity.id).then(function (response) {
        ixStatusService.setResponse(response);
        $scope.data.gridResultados.ixLoadInitialData();
      },
        function (error) {
          ixStatusService.setResponse(error);
        });
    };


    var duplicarPorLote = function (entity) {
      //Obtengo información de cabecera de analisis actual
      $http.get(cfg.baseURL + "resultados_analisis/" + entity.id).then(function (response) {
        var template = "app/FTBonpreu/GestionAnaliticasBP/modales/resultadosAnalisisPopup.html";
        var optionspopup = { controller: "ResultadosAnalisisController" };
        var paramsPopup = {
          isNew: true,
          id_ficha_tecnica: response.data.id_ficha_tecnica,
          cod_articulo: response.data.cod_articulo,
          proveedor: response.data.proveedor,
          laboratorio: response.data.laboratorio,
          tipo_analisis: response.data.tipo_analisis,
          finalizada: 0,
          es_extra: true
        };

        ixUtilsService.openModalV2(template, optionspopup, "big", paramsPopup).then(function (response) {
          if (response) {
            $scope.data.gridResultados.ixLoadInitialData();
          }
        },
          function (error) {
            ixStatusService.setResponse(error);
          });
      },
        function (error) {
          ixStatusService.setResponse(error);
        });

    };


    $scope.descargarInformesResultado = function (id) {
      $http({
        method: 'post',
        url: cfg.baseURL + 'boletines_analisis/DescargaBoletinesResultado?id_ra=' + id,
        headers: { 'Content-type': 'application/zip' },
        responseType: 'arraybuffer'
      }).then(function (r) {
        var file = new Blob([r.data], { type: 'application/zip' });

        var filename = "InformesResultats.zip";
        if (r.headers('Content-Disposition')) {
          filename = r.headers('Content-Disposition').split("=")[1];
        }
        saveAs(file, filename);
      }, function (err) {
        ixStatusService.setResponse(err);
      });

    };

    $scope.eliminarResultado = function (e) {
      $http.delete(cfg.baseURL + '/resultados_analisis/' + e.id).then(function (response) {
        $scope.data.gridResultados.ixLoadInitialData();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    };


    $scope.impresionMasivaInformes = function () {
      var lista = [];

      $scope.data.gridResultados.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
        //var fichero = { id: row.id };
        lista.push(row.id);
      });

      var config = { responseType: 'arraybuffer' };

      $http.post(cfg.baseURL + "boletines_analisis/DescargaMultiple", lista, config).then(function (response) {
        var file = new Blob([response.data], { type: 'application/zip' });

        var filename = "descarga_masiva_informes.zip";
        if (response.headers('Content-Disposition')) {
          filename = response.headers('Content-Disposition').split("=")[1];
        }
        saveAs(file, filename);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    };

    $scope.tienePerfilBio = function () {
      return (perfilesUsuario.indexOf("ixnet") >= 0) || (perfilesUsuario.indexOf("usr_bio_userkey") >= 0);
    };

    $scope.seleccionarRowsVisibles = function () {
      $scope.data.gridResultados.gridApi.grid.getVisibleRows().forEach(function (row) {
        row.entity.Selector = true;
      });
    };


    $scope.borrarSeleccionRows = function () {
      $scope.data.gridResultados.data.forEach(function (row) {
        row.Selector = false;
      });
    };

    $scope.$on('$destroy', function () {
      if ($scope.data.gridResultados)
        $scope.data.gridResultados.ixSaveConfig();
      $scope.isDestroyed = true;
    });
  };


}]);
"use strict";

angular.module("FTBonpreuApp").controller("ListadoPlanificacionController", ['$scope', '$http', '$translate', 'cfg', 'authService', 'ixStatusService', 'ixUtilsService', 'gridService', function ($scope, $http, $translate, cfg, authService, ixStatusService, ixUtilsService, gridService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;

  $scope.init = function () {
    if (!$scope.data.gridPlan) {
      var acciones = [
        {
          title: $translate.instant('Ver resultados'),
          icon: 'fa-flask',
          accion: function (entity) {
            $scope.openResultados(entity);
          }
        },
        {
          title: $translate.instant('Nuevo resultado'),
          icon: 'fa-plus-circle',
          accion: function (entity) {
            $scope.addResultado(entity);
          }
        },
        {
          title: $translate.instant('Eliminar planificación'),
          icon: 'fa-trash',
          visible: function (entity) {
            return entity.extra == 1 && $scope.tienePerfilAdmin();
          },
          accion: function (entity) {
            $scope.eliminarPlanificacionExtra(entity);
          }
        }
      ];

      var metadata = [];

      $scope.compruebaTiempoVencido = function (row) {
        if (row.entity.prox_analisis)
          return row.entity.prox_analisis < Date.now();
        else
          return false;
      };

      $scope.data.gridPlan = gridService.createGrid($scope, 'grid_planificacion', { enableCellEdit: false, compruebaAlarmaFunc: $scope.compruebaTiempoVencido }, 'listado_planificacion_analiticasVM', [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
      //$scope.ixDownloadExcel = $scope.data.gridPlan.ixDownloadExcel;
    }
    else {
      $scope.data.gridPlan = gridService.createGridFunctions($scope, $scope.data.gridPlan);
      $scope.data.gridPlan.ixRestoreConfig();
    }

    $scope.ixDownloadExcel = $scope.data.gridPlan.ixDownloadExcel;
    //$scope.data.gridPlan.ixLoadInitialData();

    $scope.openResultados = function (entity) {
      var app = {};
      app.icon = 'perm_device_information';
      app.display = 'Resultados análisis ' + entity.num_ft.substring(0, 9);
      app.href = "GestionAnaliticasBP/Listado_resultados_analisis";
      app.atributos = { id_ft: entity.num_ft };
      app.multiple = true;

      ixStatusService.openApp(app).bind(ixStatusService);
    };


    $scope.addResultado = function (entity) {
      var template = "app/FTBonpreu/GestionAnaliticasBP/modales/resultadosAnalisisPopup.html";
      var optionspopup = { controller: "ResultadosAnalisisController" };
      var paramsPopup = { isNew: true, id_ficha_tecnica: entity.num_ft, cod_articulo: entity.CodInterno, proveedor: entity.proveedor, laboratorio: entity.id_laboratorio, tipo_analisis: entity.id_tipo_analisis, finalizada: 0, es_extra: false };
      if (entity.extra == 1) {
        paramsPopup.id_analisis_extra = entity.id;
        paramsPopup.es_extra = true;
      }


      ixUtilsService.openModalV2(template, optionspopup, "big", paramsPopup).then(function (response) {
        if (response) {
          //Si la analítica es extra, actualizo grid
          // if (entity.extra == 1) {
          //   $scope.data.gridPlan.ixLoadInitialData();
          // }
          //Response es TRUE si se han modificado datos
          $scope.data.gridPlan.ixLoadInitialData();
        }
      });
    };


    $scope.eliminarPlanificacionExtra = function (e) {
      //TODO
      $http.delete(cfg.baseURL + '/planificacion_analisis_extra_bp/' + e.id).then(function (response) {
        $scope.data.gridPlan.ixLoadInitialData();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    };


    $scope.tienePerfilAdmin = function () {
      return authService.tienePerfilAdmin() || authService.tienePerfilUserKey();
    };


    $scope.openAddExtraPopup = function () {
      var template = "app/FTBonpreu/GestionAnaliticasBP/modales/addPlanificacionExtraPopup.html";
      var optionsPopup = { controller: "AddPlanificacionExtraController" };
      var modalAdd = ixUtilsService.openModalV2(template, optionsPopup, "small");
      modalAdd.then(function (response) {
        if (response) {
          //Recargo el grid
          $scope.data.gridPlan.ixLoadInitialData();
        }
      });
    };

    $scope.$on('$destroy', function () {
      if ($scope.data.gridPlan)
        $scope.data.gridPlan.ixSaveConfig();
      $scope.isDestroyed = true;
    });
  }

}]);

/*global saveAs*/

"use strict";

angular.module("FTBonpreuApp").controller("ListadoNcAnalisisController", ['$scope', '$routeParams', '$http', '$translate', '$log', 'cfg', 'ixStatusService', 'ixUtilsService', 'gridService', 'authService', function ($scope, $routeParams, $http, $translate, $log, cfg, ixStatusService, ixUtilsService, gridService, authService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;

  $scope.init = function () {
    $scope.filterAPIBy = "year";
    $scope.period = 1;

    var perfilesUsuario = authService.perfilesUsuario();

    $scope.esProveedor = function () {
      return (perfilesUsuario.indexOf("usr_proveedor") >= 0);
    };

    if (!$scope.data.gridNc){
      var acciones = [
        {
          title: $translate.instant('Editar no conformidad'),
          icon: 'fa-pencil',
          visible: function (entity) {
            return true;
          },
          accion: function (entity) {
            //Abrir popup de edición
            openEditNcPopup(entity);
          }
        },
        {
          title: $translate.instant('Visualizar resultados'),
          icon: 'fa-search',
          visible: function (entity) {
            return !$scope.esProveedor();
          },
          accion: function (entity) {
            //Abrir resultadosAnalisisPopup en modalidad visualizacion
            openResultado(entity);
          }
        },
        {
          title: $translate.instant('Descargar documentos'),
          icon: 'fa-cloud-download',
          accion: function (entity) {
            $scope.descargarDocumentosNc(entity);
          } 
        },
        {
          title: $translate.instant('Descargar informes'),
          icon: "fa-download",
          accion: function (entity) {
            $scope.descargarInformesResultado(entity.id);
          }
        }
      ];
      var metadata = [];

      $scope.data.gridNc = gridService.createGrid($scope, 'grid_nc_analisis_bp', { enableCellEdit: false }, 'listado_nc_analiticas_bpVM', [ { name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones } /*, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } } */]);
    }
    else {
      $scope.data.gridNc = gridService.createGridFunctions($scope, $scope.data.gridNc);
      $scope.data.gridNc.ixRestoreConfig();
    }

    $scope.ixDownloadExcel = $scope.data.gridNc.ixDownloadExcel;

    var openEditNcPopup = function (entity){
      var template = "app/FTBonpreu/GestionAnaliticasBP/modales/editarNcAnalisisPopup.html";
      var optionspopup = { controller: "EditarNcAnalisisController" };
      var paramsPopup = { id: entity.id, parametro: entity.parametro, desc_articulo: entity.desc_articulo, ean: entity.ean, marca: entity.marca, nc_bonpreu: entity.nc_bonpreu };
      ixUtilsService.openModalV2(template, optionspopup, "big", paramsPopup).then(function (response) {
        if (response) {
          $scope.data.gridNc.ixLoadInitialData();
        }
      });
    };


    var openResultado = function(entity){
      var template = "app/FTBonpreu/GestionAnaliticasBP/modales/resultadosAnalisisPopup.html";
      var optionspopup = { controller: "ResultadosAnalisisController" };
      var paramsPopup = { isNew: false, id: entity.id, finalizada: 1 };
      // if (entity.extra == 1)
      //   paramsPopup.id_analisis_extra = entity.id;
      ixUtilsService.openModalV2(template, optionspopup, "big", paramsPopup).then(function (response) {
        if (response) {
          //DO NOTHING
          //$scope.data.gridNc.ixLoadInitialData();
        }
      });
    };


    $scope.descargarDocumentosNc = function(entity){
      var cod_parametro = "";
      switch(entity.parametro){
        case "FQ":
          cod_parametro = "FQ";
          break;
        case "MICRO":
          cod_parametro = "MICRO";
          break;
        case "VIDA ÚTIL":
          cod_parametro = "VIDA ÚTIL";
          break;
        case "NUTRICIONAL":
          cod_parametro = "NUTRICIONAL";
          break;
        case "ALÉRGENOS":
        case "AL·LÈRGENS":
          cod_parametro = "ALÉRGENOS";
          break;
        case "PESO":
        case "PES":
          cod_parametro = "PESO";
          break;
        case "ORGANOLÉPTICO":
        case "ORGANOLÈPTIC":
          cod_parametro = "ORGANOLÉPTICO";
          break;
        case "ETIQUETADO":
        case "ETIQUETAT":
          cod_parametro = "ETIQUETADO";
          break;
        case "RESIDUOS":
        case "RESIDUS":
          cod_parametro = "RESIDUOS";
          break;
        case "OTROS":
        case "ALTRES":
          cod_parametro = "OTROS";
          break;
      }

      $http({
        method: 'post',
        url: cfg.baseURL + 'documentos_nc_analisis/DescargaDocumentosNc?id_ra=' + entity.id + '&pmt='+cod_parametro,
        headers: { 'Content-type': 'application/zip' },
        responseType: 'arraybuffer'
      }).then(function (r) {
        var file = new Blob([r.data], { type: 'application/zip' });

        var filename = "DocumentsNCAnalisis.zip";
        if (r.headers('Content-Disposition')) {
          filename = r.headers('Content-Disposition').split("=")[1];
        }
        saveAs(file, filename);
      }, function (err) {
        ixStatusService.setResponse(err);
      });
    };


    $scope.descargarInformesResultado = function (id) {
      $http({
        method: 'post',
        url: cfg.baseURL + 'boletines_analisis/DescargaBoletinesResultado?id_ra=' + id,
        headers: { 'Content-type': 'application/zip' },
        responseType: 'arraybuffer'
      }).then(function (r) {
        var file = new Blob([r.data], { type: 'application/zip' });

        var filename = "InformesResultats.zip";
        if (r.headers('Content-Disposition')) {
          filename = r.headers('Content-Disposition').split("=")[1];
        }
        saveAs(file, filename);
      }, function (err) {
        ixStatusService.setResponse(err);
      });
    };


    $scope.$on('$destroy', function () {
      if ($scope.data.gridNc)
        $scope.data.gridNc.ixSaveConfig();
      $scope.isDestroyed = true;
    });
  };


}]);
angular.module('FTBonpreuApp').controller('CargaMasivaPlanificacionesAnaliticasFTController', ['$scope', 'ixStatusService', 'cfg', '$http', 'ixUtilsService', '$timeout', '$document', 'apiHubService', function ($scope, ixStatusService, cfg, $http, ixUtilsService, $timeout, $document, apiHubService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  //GestPark ofrece la opción de simular. De momento solo actualizaremos.
  $scope.operaciones = { SIMULAR: 1, ACTUALIZAR: 2 };

  $scope.init = function () {
    $scope.ixEditar = function () {
      ixStatusService.setEditing(true);
      $scope.renderExcelTable();
    };


    $scope.ixCancelEdit = function(){
      $scope.data.excelData = [];
      ixStatusService.setEditing(false);
    };
  
    ///////////////////////Funciones excel////////////////////////////
  
    $scope.heightStyle = {'height': 'calc(100vh - 420px)'};
  
    $scope.data.excelData = [];
  
    // Columnas del excel a mostrar
    var buildExcelCols = function(){
      return [
        {title: 'ARTICLE', readOnly: false, width: 100 },
        {title: 'TIPUS', readOnly: false, width: 150 },
        {title: 'LABORATORI', readOnly: false, width: 150 },
        {title: 'INTERVAL', readOnly: false, width: 80 },
        {title: 'DATA ULTIM ANALISIS', readOnly: false, width: 120 },
        {title: 'COMENTARIS', readOnly: false, width: 260 }
      ];
    };
  
    $scope.excelsettings = {
      contextMenu: ['row_above', 'row_below', 'remove_row'],
      minSpareRows: 1
    };
  
    // Excel
    $scope.renderExcelTable = function(){
      $timeout(function(){
        var hotDiv=angular.element("hot-table");
        if(hotDiv.isolateScope()){
          var hotInstance=hotDiv.isolateScope().hotInstance;
  
          var element = angular.element($document.find('#hot-container'));
          var height = element[0].offsetHeight;
          hotInstance.updateSettings({
            height: height,
            cells: function (row, col, prop) {
              var cellProperties = {};
              cellProperties.readOnly = !$scope.status.editing;
              return cellProperties;
            }
          });
          hotInstance.render();
        }
      },5);
    };
  
    // Columnas que va a mostra el excel (Requerido, si no se instancian no muestra nada)
    $scope.data.excelcolumns = buildExcelCols();
  
    // Color de las celdas en función de errores o no
    $scope.rendererColor = function(hotInstance, TD, row, col, prop, value, cellProperties) {
      TD.style.backgroundColor = value;
      TD.innerHTML = "";
    };
  
    var showErrorsInExcel = function(dataResult){
      $scope.data.excelDataErrors = [];
      $scope.data.lineasConError = [];
      $scope.data.lineasOK = 0;
      $scope.data.lineasConflicto = 0;
      $scope.data.lineasError = 0;
      angular.forEach(dataResult, function(data, i){
        var lineaOk = true;
        var results = [];
  
        if(data.ErrType == 2 || data.ErrType == 1)
          results.push(data.Msg);
  
        if(results.length == 0){
          results.push("OK");
        }
  
        var codigoColor;
        var errorMsg = {};
        if(data.ErrType == 0){
          codigoColor = "#008000";
          $scope.data.lineasOK++;
        } else if(data.ErrType == 2){
          lineaOk = false;
          codigoColor = "#FF0000";
          $scope.data.lineasError++;
          errorMsg = { error: data.Msg, total: 1 };
          $scope.data.excelDataErrors.push(errorMsg);
  
        } else if(data.ErrType == 1){
          lineaOk = true;
          codigoColor = "#FF9912";
          $scope.data.lineasConflicto++;
          errorMsg = { error: data.Msg, total: 1 };
          $scope.data.excelDataErrors.push(errorMsg);
        }
  
        if(ixUtilsService.isNotEmptyObject($scope.data.excelData[i])){
          $scope.data.excelData[i]["resultado_color"] = codigoColor;
          $scope.data.excelData[i]["resultado_msg"] = results.join("\n");
        }
  
        if(!lineaOk){
          $scope.data.lineasConError.push($scope.data.excelData[i]);
        }
      });
    };
  
    function trackUpdateJobProgress(job) {
      $scope.data.showResults = false;
      $scope.data.excelDataErrors = [];
      $scope.data.actualizando = true;
      $scope.$emit("loader_show");
      setProgressBarWidth(1);
      var hubProxy = apiHubService("ixJobHub", job);
  
      hubProxy.on('progressChanged', function (progress) {
        setProgressBarWidth(progress);
      });
  
      hubProxy.on('jobResult', function (result) {
        showErrorsInExcel(result.DetalleErrores);
      });
  
      hubProxy.on('jobCompleted', function (jobId) {
        $scope.data.showResults = true;
        $scope.$emit("loader_hide");
  
  //				if($scope.operacion == $scope.operaciones.ACTUALIZAR){
          if($scope.data.lineasConError.length > 0){
            $scope.data.mostrarBtnContinuarTraspaso = false;
            $scope.data.mostrarBtnContinuarErroneas = true;
          }
          else {
            $scope.data.mostrarBtnContinuarTraspaso = true;
            $scope.data.mostrarBtnContinuarErroneas = false;
          }
  
          $scope.hideCancelOnFilter = true;
          $scope.data.updatedTransfered = true;
  //				}
  
        hubProxy.closeConnection(hubProxy.getConnection());
  
        var msg = "";
  
  //				if($scope.operacion == $scope.operaciones.SIMULAR){
  //					msg = "Simulación terminada. Registros correctos: " + $scope.data.lineasOK;
  //				} else {
        msg = "Registros actualizados: " + $scope.data.lineasOK;
  //				}
        var responseObj = {
          status:200,
          data: {
            Result: true,
            GlobalMessage: {
              ErrType:0,
              Msg: msg,
              Property:null,
              TypeOfError:0
            }
          }
        };
  
        ixStatusService.setResponse(responseObj);
        $scope.data.showResults = true;
        $timeout(function() { delete($scope.data.ixProgress); }, 1000);
      });
    }
  
  
    function setProgressBarWidth(progress) {
      $scope.data.ixProgress = progress;
    }
  
    $scope.ixGuardar = function(){
      $scope.operacion = $scope.operaciones.ACTUALIZAR;
      var planificaciones = [];
      angular.forEach($scope.data.excelData, function(item){
        var plan = ObjKeyRename(item, {"0":"article", "1":"tipus", "2":"laboratori", "3":"interval", "4":"data_ultim_analisis", "5":"comentaris"});
        planificaciones.push(plan);
      });
  
      var data = ixUtilsService.toJson(planificaciones);
      $http.post(cfg.baseURL + "planificacion_analisis_rutinarias/CargaMasiva?operacion="+$scope.operacion, data).then(function (r) {
        trackUpdateJobProgress(r.data);
      }, function(error){
        ixStatusService.setResponse(error);
      });
  };
  ///////////////////////Fin Funciones excel////////////////////////////
  
	//================================================
	// Rename Objet's Keys [Copy]
	//   src : object - source obj
	//   map : object - rename map
	//           {"old1":"new1", "old2":"new2", ...}
	//================================================
	function ObjKeyRename(src, map) {
    var dst = {};
    // src --> dst (copy)
    for(var key in src){
        if(key in map)
            // rename key
            dst[map[key]] = src[key];
        else
            // same key
            dst[key] = src[key];
    }
    return dst;
}

//================================================
// Rename Objet's Keys [Direct]
//   src : object - source obj
//   map : object - rename map
//           {"old1":"new1", "old2":"new2", ...}
//================================================
function ObjKeyRename2(src, map) {
    var dst = {};
    // src --> dst
    for(var key in src){
        if(key in map)
            // rename key
            dst[map[key]] = src[key];
        else
            // same key
            dst[key] = src[key];
    }
    // clear src
    for(var key2 in src){
        delete src[key2];
    }
    // dst --> src
    for(var key3 in dst){
        src[key3] = dst[key3];
    }
}

  $scope.$on("$destroy", function() {
    $scope.isDestroyed=true;
  });

  }
  
}]);
/*jslint browser: true, white: true, plusplus: true, node: true */
/*eslint angular/no-private-call: 0*/
/*eslint angular/document-service: 0*/
/*global angular */
/*global convertDateStringsToDates*/
/*global ixGetPatchOperations*/
/*global saveAs*/
/*global CMP_EQ*/
/*global buildIxSearch*/
"use strict";

angular.module('FTBonpreuApp').controller("FtBPController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$ngConfirm', '$timeout', 'ViewBuilderService', '$q', 'ixUtilsService', '$location', '$compile', '$log', '$window', '$rootScope', 'authService', '$filter', '$translate', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $ngConfirm, $timeout, ViewBuilderService, $q, ixUtilsService, $location, $compile, $log, $window, $rootScope, authService, $filter, $translate) {
	$scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

	var usuario = authService.authentication.userName;
	var perfilesUsuario = authService.perfilesUsuario();
	$scope.perfil = perfilesUsuario.find(function (p) { return p != 'usr_visitante'; });
	// var esVisitante = perfilesUsuario.includes('usr_visitante');
	$scope.esProveedor = perfilesUsuario.includes('usr_proveedor');
	var timer;
	var lastBusqueda = "";

	if ($scope.perfil != 'usr_proveedor') {
		//$scope.ixEditar = undefined;
		$scope.status.editing = false;
	}

	$scope.manualEditing = false;

	if (angular.isUndefined($scope.data.fullItemsList))
		$scope.data.fullItemsList = {};

	$scope.data.firstLoad = true;
	$scope.data.startingApp = true;

	//TODO: Verificar que efectivamente sea necesaria la información de extranet_condition_user
	$http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
		$scope.extranetUser = response.data;
	}, function (error) {
		ixStatusService.setResponse(error);
	});

	$scope.status.onCloseGoTo = "ListadosFtBP/Listado_Ft_Bp";

	//YVES_DUDA ¿Para qué sirve esta?
	$scope.$parent.$parent.$parent.changeWhileEditing = true;

	if (angular.isDefined($routeParams.id_fichas_tecnicas)) {
		$scope.data.id_fichas_tecnicas = $routeParams.id_fichas_tecnicas;
		$scope.data.id_ficha_tecnica = $scope.data.id_fichas_tecnicas[0];
	}
	else
		$scope.data.id_ficha_tecnica = $routeParams.id_ficha_tecnica;

	if ($routeParams.idioma) { //YVES: OJO! Siempre llega algún valor ¿por qué ponerlo siempre en modo traducción?
		$scope.data.idioma = $routeParams.idioma;
		$scope.data.modoTraduccion = true;
	}

	//YVES_DUDA ¿Obsoleta?
	convertDateStringsToDates($scope.miFt);

	$scope.data.activeTabCabecera = 0;
	$scope.data.activeTabFicheros = 0;

	$scope.data.ixReadOnly = true;
	$scope.gridManualLoad = true;

	$scope.data.pk = "id";
	$scope.data.tituloCabecera = "id_ficha_tecnica";
	$scope.data.tituloExtra = "";

	$scope.changeTabFicheros = function (idxTab) {
		$log.log("Calling changeTabFicheros");
		$scope.data.activeTabFicheros = idxTab;
		switch (idxTab) {
			case 0:
				$scope.data.gridFicherosTab = 0;
				if (angular.isDefined($scope.data.gridFicherosFT))
					ixUtilsService.showGrid($scope.data.gridFicherosFT);
				break;
			case 1:
				$scope.data.gridFicherosTab = 1;
				if (angular.isDefined($scope.data.gridFicherosProveedor))
					ixUtilsService.showGrid($scope.data.gridFicherosProveedor);
				else
					buildGridFicherosProveedor();
				if ($scope.data.forzarCargaGridFicherosProveedor) {
					$scope.data.forzarCargaGridFicherosProveedor = false;
					$scope.data.gridFicherosProveedor.ixLoadInitialData();
				}
				break;
			default:
				//$scope.ixEditarDisabled = true;
				break;
		}
	};


	$scope.refreshCurrentCardContent = function () {
		var aux = angular.copy($scope.data.currentPreguntasTab);
		$scope.data.currentPreguntasTab = "";
		$timeout(function () {
			$scope.data.currentPreguntasTab = aux;
		}, 0);
	};


	$scope.changeTabCabecera = function (idxTab) {
		$scope.data.activeTabCabecera = idxTab;
		switch (idxTab) {
			case 0:
				if (angular.isDefined($scope.data.gridTirajeEtiquetas))
					ixUtilsService.showGrid($scope.data.gridTirajeEtiquetas);
				break;
			case 1:
				if (angular.isDefined($scope.data.gridAnaliticas))
					ixUtilsService.showGrid($scope.data.gridAnaliticas);
				else
					buildGridAnaliticas();
				break;
			default:
				break;
		}
	};


	//authService.tienePerfilAdmin restituye TRUE sólo en caso de perfil ixnet
	$scope.$parent.$parent.$parent.tienePerfilAdmin = function () {
		return authService.tienePerfilAdmin() || authService.tienePerfilUserKey();
	};


	//sobreescrita la función
	$scope.$parent.$parent.$parent.actualizarListado = function (forzarActualizacion) {
		$log.log("Calling actualizarListado (parent)");
		if (angular.isUndefined($scope.data.list) || forzarActualizacion) {
			$scope.data.list = [];
			$scope.data.loaded = false;
		}
		if (timer) { $timeout.cancel(timer); }
		timer = $timeout(function () {
			getListElements();
		}, 350);
		lastBusqueda = $scope.data.busqueda;
	};

	//sobreescrita la función
	$scope.$parent.$parent.$parent.cargarGrid = function () {
		$log.log("Calling cargarGrid (parent)");
	};


	//Sobreescrita la función ya que no vamos a acceder API llamada por ListEditController para cargar los datos.
	var getListElements = function (modo) {
		if (angular.isUndefined($scope.data.fullList))
			$scope.data.fullList = [];
		var list = [];
		if ($scope.data.fullList.length == 0) {
			var path = cfg.baseURL + "ftbp_data?id_ft=" + $scope.data.id_ficha_tecnica;
			if ($scope.data.idioma)
				path += "&idioma_traduccion=" + $scope.data.idioma;

			$http.get(path).then(function (response) {
				$scope.data.fullItemsList[$scope.data.id_ficha_tecnica] = response.data;
				$scope.data.fullList = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica].tarjetas;

				// Establecer el valor parent de cada tarjeta, se usa para poder marcar visible la Card activa
				$scope.data.fullList.forEach(function (card) {
					if (card.subniveles) {
						card.subniveles.forEach(function (subnivel) {
							subnivel.parent = card;
							if (subnivel.subniveles) {
								subnivel.subniveles.forEach(function (subsubnivel) {
									subsubnivel.parent = subnivel
								});
							}
						});
					}
				});

				//YVES DUDA ¿Descomentar?
				//$scope.excluirTarjetasRestringidas();

				list = angular.copy($scope.data.fullList);
				// if (angular.isUndefined($scope.data.id_fichas_tecnicas))
				// 	$scope.data.tituloExtra = ("- " + response.data.ft_cabecera.CodInterno + " " + response.data.ft_cabecera.titulo);
				// else
				// 	$scope.data.tituloExtra = " - Fichas multiples";
				$scope.data.tituloExtra = ("- " + response.data.ft_cabecera.CodInterno + " " + response.data.ft_cabecera.titulo);

				// $scope.data.datos = {
				// 	id: response.data.ft_cabecera.id,
				// 	comprador: response.data.comprador,
				// 	total_preguntas: response.data.total_preguntas,
				// 	total_preguntas_obligatorias: response.data.total_preguntas_obligatorias,
				// 	count_preguntas_obligatorias: response.data.count_preguntas_obligatorias,
				// 	ft_cabecera: response.data.ft_cabecera,
				// 	ft_ficheros_fichas_tecnicas: response.data.ft_ficheros_fichas_tecnicas,
				// 	ft_ficheros_proveedores: response.data.ft_ficheros_proveedores,
				// 	//ft_productos: response.data.ft_productos,
				// 	plantas_asociadas: response.data.plantas_asociadas,
				// 	tiraje_etiquetas: response.data.tiraje_etiquetas,
				// 	planificacion_analiticas: response.data.planificacion_analiticas,
				// 	comentarios: response.data.comentarios,
				// 	estado_traduccion: response.data.estado_traduccion,
				// 	traducir_completa: response.data.traducir_completa
				// };
				$scope.setDatosCabecera($scope.data.fullItemsList[$scope.data.id_ficha_tecnica]);

				$scope.data.ft_cabecera_original = angular.copy($scope.data.datos.ft_cabecera);
				if ($scope.data.modoTraduccion) {
					$scope.data.estado_traduccion_original = $scope.data.datos.estado_traduccion;
				}
				else {
					$scope.data.traducir_completa_original = $scope.data.datos.traducir_completa;
				}

				if ($scope.data.busqueda || angular.isDefined(modo)) {
					list = list.filter(function (e) {
						return ((e.subniveles) && buscarEnSubniveles(e, modo).length > 0) || $scope.filterAlgorithmSelector(e, modo);
					});
				}

				$scope.data.list = list;
				$scope.data.loaded = true;
				// $scope.selectNextPage();
				if ($scope.data.firstLoad) {
					if ($scope.data.startingApp) {
						// La primera vez damos tiempo a que se reciban y muestren antes de seleccionar la primera tarjeta.
						$timeout(function () {
							$scope.selectNextPage();
						}, 500)
						$scope.data.startingApp = false;
					}
					else {
						$scope.selectCurrentPage();
					}
					$scope.data.firstload = false;
				}
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
		else {
			$scope.setDatosCabecera($scope.data.fullItemsList[$scope.data.id_ficha_tecnica]);
			$scope.data.tituloExtra = ("- " + $scope.data.datos.ft_cabecera.CodInterno + " " + $scope.data.datos.ft_cabecera.titulo);
			list = angular.copy($scope.data.fullList);
			if ($scope.data.busqueda || angular.isDefined(modo))
				list = list.filter(function (e) {
					return ((e.subniveles) && buscarEnSubniveles(e, modo).length > 0) || $scope.filterAlgorithmSelector(e, modo);
				});
			$scope.data.list = list;
		}
	};


	if (!$scope.data.list) {
		$scope.$parent.$parent.$parent.actualizarListado();
	}

	$scope.restoreConfigCreatedGrids = function () {
		if ($scope.data.gridTirajeEtiquetas)
			$scope.data.gridTirajeEtiquetas.ixRestoreConfig();
		if ($scope.data.gridAnaliticas)
			$scope.data.gridAnaliticas.ixRestoreConfig();
		if ($scope.data.gridFicherosFT)
			$scope.data.gridFicherosFT.ixRestoreConfig();
		if ($scope.data.gridFicherosProveedor)
			$scope.data.gridFicherosProveedor.ixRestoreConfig();
		if ($scope.data.gridPlantasFabricante)
			$scope.data.gridPlantasFabricante.ixRestoreConfig();
	};


	$scope.restoreConfigCreatedGrids();

	$scope.saveConfigCreatedGrids = function () {
		if ($scope.data.gridTirajeEtiquetas)
			$scope.data.gridTirajeEtiquetas.ixSaveConfig();
		if ($scope.data.gridAnaliticas)
			$scope.data.gridAnaliticas.ixSaveConfig();
		if ($scope.data.gridFicherosFT)
			$scope.data.gridFicherosFT.ixSaveConfig();
		if ($scope.data.gridFicherosProveedor)
			$scope.data.gridFicherosProveedor.ixSaveConfig();
		if ($scope.data.gridPlantasFabricante)
			$scope.data.gridPlantasFabricante.ixSaveConfig();
	};

	$scope.$on('RECALCULAR_CUMPLIMENTACION', function (event, data) {
		$log.log('RECALCULAR_CUMPLIMENTACION');
		//identificar tarjeta con los niveles e ir decrementando.
		var incrementar = null;
		// if (data.newValue && !data.oldValue) {
		// 	//incrementar uno
		// 	incrementar = true;
		// 	$scope.data.list[0].titulo4_valor = 1;
		// } else if (!data.newValue && data.oldValue) {
		// 	//decrementar uno.
		// 	incrementar = false;
		// 	$scope.data.list[0].titulo4_valor = 0;
		// }

		// if (incrementar != null) {
		// 	var currentPreguntaParts = $scope.data.currentPreguntasTab.split("-");

		// 	var tarjetaNivel1 = undefined;
		// 	var tarjetaNivel2 = undefined;
		// 	var tarjetaNivel3 = undefined;

		// 	tarjetaNivel1 = $scope.data.list.find(function (e) { return e.nivel1 == currentPreguntaParts[0]; });
		// 	if (currentPreguntaParts[1] && tarjetaNivel1 && tarjetaNivel1.subniveles) {
		// 		tarjetaNivel2 = tarjetaNivel1.subniveles.find(function (e) { return e.nivel2 == currentPreguntaParts[1]; });
		// 		if (currentPreguntaParts[2] && tarjetaNivel2 && tarjetaNivel2.subniveles)
		// 			tarjetaNivel3 = tarjetaNivel2.subniveles.find(function (e) { return e.nivel3 == currentPreguntaParts[2]; });
		// 	}

		// 	if (angular.isDefined(tarjetaNivel1)) {
		// 		if (incrementar)
		// 			tarjetaNivel1.titulo4_valor++;
		// 		else
		// 			tarjetaNivel1.titulo4_valor--;
		// 	}
		// 	if (angular.isDefined(tarjetaNivel2)) {
		// 		if (incrementar)
		// 			tarjetaNivel2.titulo4_valor++;
		// 		else
		// 			tarjetaNivel2.titulo4_valor--;
		// 	}
		// 	if (angular.isDefined(tarjetaNivel3)) {
		// 		if (incrementar)
		// 			tarjetaNivel3.titulo4_valor++;
		// 		else
		// 			tarjetaNivel3.titulo4_valor--;
		// 	}

		// 	$scope.calcularPorcentajeCumplimentacion();
		// }
	});

	$scope.calcularPorcentajeCumplimentacion = function () { 	
		var cumplimentadas = 0;
		var cumplimentadasObligatorias = 0;
		var totalPreguntas = 0;
		var totalPreguntasObligatorias = 0;

		var tarjetasPreguntas = $scope.data.fullList.filter(function (e) { return e.nivel1 != null; });
		for (var i = 0; i < tarjetasPreguntas.length; i++) {
			var tarjeta = tarjetasPreguntas[i];
			for (var j = 0; j < tarjeta.subniveles.length; j++) {
				var subniveles = tarjeta.subniveles[j];
				if(subniveles.preguntas == null)
				{
					for (var k = 0; k < subniveles.subniveles.length; k++) 
					{
						var subsubnivel = subniveles.subniveles[k];
						for (var y = 0; y < subsubnivel.preguntas.length; y++) {
							var preguntasub = subsubnivel.preguntas[y];
							for (var x = 0; x < preguntasub.respuestas.length; x++) {
								var respuestasub = preguntasub.respuestas[x];
								totalPreguntas++;
								if ($scope.IsCompleted(preguntasub.pregunta, respuestasub)) cumplimentadas++;
								if (preguntasub.pregunta.obligatoria == 1) {
									if ($scope.IsCompleted(preguntasub.pregunta, respuestasub)) {
										cumplimentadasObligatorias++;
									}
									totalPreguntasObligatorias++;
								}
							}
						}
					}
				}
				else
				{
					for (var z = 0; z < subniveles.preguntas.length; z++) {
						var pregunta = subniveles.preguntas[z];
						for (var r = 0; r < pregunta.respuestas.length; r++) {
							var respuesta = pregunta.respuestas[r];
							totalPreguntas++;
							if ($scope.IsCompleted(pregunta.pregunta, respuesta)) cumplimentadas++;
							if (pregunta.pregunta.obligatoria == 1) {
								if ($scope.IsCompleted(pregunta.pregunta, respuesta)) {
									cumplimentadasObligatorias++;
								}
								totalPreguntasObligatorias++;
							}
						}
					}
				}
			}
		}
		$scope.data.list[0].titulo4_valor = $filter("number")(((cumplimentadas / totalPreguntas) * 100), 0);
		$scope.data.list[0].titulo5_valor = $filter("number")(((cumplimentadasObligatorias / totalPreguntasObligatorias) * 100), 0);
	};

	$scope.IsCompleted = function (ftp, eftd) {
		var answer_complete = true;
		if (ftp.id_pregunta == 1160 || ftp.id_pregunta == 1168 || ftp.id_pregunta == 1173 || ftp.id_pregunta == 1178) {
			answer_complete = answer_complete && (eftd.valor == null || eftd.valor == '');

			if (ftp.validar_sub_pregunta1 == 1) answer_complete = answer_complete && (eftd.sub_respuesta1 != null && eftd.sub_respuesta1 != '');
			if (ftp.validar_sub_pregunta2 == 1) answer_complete = answer_complete && (eftd.sub_respuesta2 != null && eftd.sub_respuesta2 != '');
			if (ftp.validar_sub_pregunta3 == 1) answer_complete = answer_complete && (eftd.sub_respuesta3 != null && eftd.sub_respuesta3 != '');

			if (eftd.sub_respuesta3 != null && eftd.sub_respuesta3 != '') {
				if (eftd.sub_respuesta3 === "No") {
					if (ftp.validar_sub_pregunta4 == 1) answer_complete = answer_complete && (eftd.sub_respuesta4 != null && eftd.sub_respuesta4 != '');
					if (ftp.validar_sub_pregunta5 == 1) answer_complete = answer_complete && (eftd.sub_respuesta5 != null && eftd.sub_respuesta5 != '');
					if (ftp.validar_sub_pregunta6 == 1) answer_complete = answer_complete && (eftd.sub_respuesta6 != null && eftd.sub_respuesta6 != '');
					if (ftp.validar_sub_pregunta7 == 1) answer_complete = answer_complete && (eftd.sub_respuesta7 != null && eftd.sub_respuesta7 != '');
					if (ftp.validar_sub_pregunta8 == 1) answer_complete = answer_complete && (eftd.sub_respuesta8 != null && eftd.sub_respuesta8 != '');
					if (ftp.validar_sub_pregunta9 == 1) answer_complete = answer_complete && (eftd.sub_respuesta9 != null && eftd.sub_respuesta9 != '');
					if (ftp.validar_sub_pregunta10 == 1) answer_complete = answer_complete && (eftd.sub_respuesta10 != null && eftd.sub_respuesta10 != '');
					if (ftp.validar_sub_pregunta11 == 1) answer_complete = answer_complete && (eftd.sub_respuesta11 != null && eftd.sub_respuesta11 != '');
					if (ftp.validar_sub_pregunta12 == 1) answer_complete = answer_complete && (eftd.sub_respuesta12 != null && eftd.sub_respuesta12 != '');
					if (ftp.validar_sub_pregunta13 == 1) answer_complete = answer_complete && (eftd.sub_respuesta13 != null && eftd.sub_respuesta13 != '');
					if (ftp.validar_sub_pregunta14 == 1) answer_complete = answer_complete && (eftd.sub_respuesta14 != null && eftd.sub_respuesta14 != '');
				}
			}
			else {
				answer_complete = false;
			}

			return answer_complete;
		}

		answer_complete = answer_complete && (eftd.valor != null && eftd.valor != '');

		if (ftp.validar_sub_pregunta1 == 1
			&& !(ftp.id_pregunta == 777 && (eftd.orden_bucle.Value == 5 || eftd.orden_bucle.Value == 6 || eftd.orden_bucle.Value == 9 || eftd.orden_bucle.Value == 10 || eftd.orden_bucle.Value == 11)))
			answer_complete = answer_complete && (eftd.sub_respuesta1 != null && eftd.sub_respuesta1 != '');

		if (ftp.validar_sub_pregunta2 == 1) answer_complete = answer_complete && (eftd.sub_respuesta2 != null && eftd.sub_respuesta2 != '');
		if (ftp.validar_sub_pregunta3 == 1) answer_complete = answer_complete && (eftd.sub_respuesta3 != null && eftd.sub_respuesta3 != '');
		if (ftp.validar_sub_pregunta4 == 1) answer_complete = answer_complete && (eftd.sub_respuesta4 != null && eftd.sub_respuesta4 != '');
		if (ftp.validar_sub_pregunta5 == 1) answer_complete = answer_complete && (eftd.sub_respuesta5 != null && eftd.sub_respuesta5 != '');
		if (ftp.validar_sub_pregunta6 == 1) answer_complete = answer_complete && (eftd.sub_respuesta6 != null && eftd.sub_respuesta6 != '');
		if (ftp.validar_sub_pregunta7 == 1) answer_complete = answer_complete && (eftd.sub_respuesta7 != null && eftd.sub_respuesta7 != '');
		if (ftp.validar_sub_pregunta8 == 1) answer_complete = answer_complete && (eftd.sub_respuesta8 != null && eftd.sub_respuesta8 != '');
		if (ftp.validar_sub_pregunta9 == 1) answer_complete = answer_complete && (eftd.sub_respuesta9 != null && eftd.sub_respuesta9 != '');
		if (ftp.validar_sub_pregunta10 == 1) answer_complete = answer_complete && (eftd.sub_respuesta10 != null && eftd.sub_respuesta10 != '');
		if (ftp.validar_sub_pregunta11 == 1) answer_complete = answer_complete && (eftd.sub_respuesta11 != null && eftd.sub_respuesta11 != '');
		if (ftp.validar_sub_pregunta12 == 1) answer_complete = answer_complete && (eftd.sub_respuesta12 != null && eftd.sub_respuesta12 != '');
		if (ftp.validar_sub_pregunta13 == 1) answer_complete = answer_complete && (eftd.sub_respuesta13 != null && eftd.sub_respuesta13 != '');
		if (ftp.validar_sub_pregunta14 == 1) answer_complete = answer_complete && (eftd.sub_respuesta14 != null && eftd.sub_respuesta14 != '');

		return answer_complete;

	}

	//Sobreescribo la función ixCloseApp para poder realizar el cálculo de los porcentajes de cumplimentación
	//La llamada se ejecuta al hacer click en el botón CERRAR de la app
	$scope.ixCloseApp = function () {
		$scope.isDestroyed = true;
		$http.put(cfg.baseURL + 'extranet_fichas_tecnicas/ActualizarPorcentajesCumplimentacion?id_ficha_tecnica=' + $scope.data.id_ficha_tecnica).then(function (response) {
			ixStatusService.closeApp(ixStatusService.current);
		},
			function (error) {
				$log.log("Error al registrar Porcentajes cumplimentación");
				$log.log(error);
				ixStatusService.closeApp(ixStatusService.current);
			});
	};

	//Se ejecuta al cerrar la App desde el botón CERRAR o al pasar a otras App
	$scope.$on("$destroy", function () {
		if (!$scope.isDestroyed) {
			$http.put(cfg.baseURL + 'extranet_fichas_tecnicas/ActualizarPorcentajesCumplimentacion?id_ficha_tecnica=' + $scope.data.id_ficha_tecnica).then(function (response) {
				$scope.saveConfigCreatedGrids();
				$scope.isDestroyed = true;
			},
				function (error) {
					$log.log("Error al registrar Porcentajes cumplimentación");
					$log.log(error);
					$scope.saveConfigCreatedGrids();
					$scope.isDestroyed = true;
				});
		}
		else {
			$scope.saveConfigCreatedGrids();
		}
	});

	$scope.$on('metadataLoaded', function () {
		$timeout(function () {
			if ($scope.data.pantalla == "ficheros") {
				$scope.data.gridFicherosFT.data = $scope.data.datos.ft_ficheros_fichas_tecnicas;
				if (angular.isDefined($scope.data.gridFicherosProveedor))
					$scope.data.gridFicherosProveedor.data = $scope.data.datos.ft_ficheros_proveedores;
			}
			else if ($scope.data.pantalla == "proveedor") {
				$scope.data.gridPlantasFabricante.data = $scope.data.datos.plantas_asociadas;
			}
			else if ($scope.data.pantalla == "comentarios") {
				$scope.data.gridComentariosFt.data = $scope.data.datos.comentarios;
			}
			else if ($scope.data.pantalla == 'cabecera') {
				$scope.data.gridTirajeEtiquetas.data = $scope.data.datos.tiraje_etiquetas;
				$scope.data.gridAnaliticas.data = $scope.data.datos.planificacion_analiticas;
			}
		}, 300);
	})


	$scope.isShowing = function (id) {
		return ("preguntas" + $scope.data.currentPreguntasTab) == id;
	};


	/* ***** FUNCIONES CONTROL EDICION Y CONTROL RESTRICCIONES ***** */
	$scope.$parent.$parent.$parent.ixEditar = function () {
		//Sobreescrita
		$scope.manualEditing = true;
		ixStatusService.setEditing(true);
	};


	$scope.$parent.$parent.$parent.ixCancelEdit = function () {
		$log.log('Calling parent.ixCancelEdit sobreescrita');
		//FUNCION CUSTOM
		delete ixStatusService.current.response; //?
		//Volver a poner datos cabecera como estaban
		$scope.data.datos.ft_cabecera = angular.copy($scope.data.ft_cabecera_original);

		//Vuelvo a poner grids tal y como estaban
		if (angular.isDefined($scope.data.gridTirajeEtiquetas))
			$scope.data.gridTirajeEtiquetas.ixCancelEdit();
		if (angular.isDefined($scope.data.gridAnaliticas))
			$scope.data.gridAnaliticas.ixCancelEdit();
		if (angular.isDefined($scope.data.gridComentariosFt))
			$scope.data.gridComentariosFt.ixCancelEdit();

		$scope.manualEditing = false;
		ixStatusService.setEditing(false);
	}

	$scope.ixGuardar = function (generar_preguntas) {
		var param = {};
		param.jpdFichaTecnica = ixGetPatchOperations($scope.data.ft_cabecera_original, $scope.data.datos.ft_cabecera);
		param.generar_preguntas = generar_preguntas;
		if ($scope.data.datos.comprador)
			param.comprador = $scope.data.datos.comprador.id;
		else
			param.comprador = null;

		//Cambios en tiraje de etiquetado
		param.ubpTirajeEtiquetas = $scope.data.gridTirajeEtiquetas.ixGetBulkParam();

		//Cambios en planificación analíticas
		param.ubpPlanificacion = $scope.data.gridAnaliticas.ixGetBulkParam();

		//Cambios en grid comentarios
		if ($scope.data.gridComentariosFt)
			param.ubpComentariosFichaTecnica = $scope.data.gridComentariosFt.ixGetBulkParam();

		var path = cfg.baseURL + "fichas_tecnicas_bp/PutFichaTecnica?id=" + $scope.data.id_ficha_tecnica;

		if ($scope.data.modoTraduccion) {
			//TODO
		}

		$http.put(path, param).then(function (resp) {
			ixStatusService.setResponse(resp);
			// if ($scope.data.modoTraduccion) {
			// 	$scope.data.estado_traduccion_original = r.data.obj.Record.estado;
			// }
			// else {
			// 	$scope.data.traducir_completa_original = $scope.data.datos.traducir_completa;
			// }
			//Actualizar ng-model
			$scope.data.datos.ft_cabecera.fecha = resp.data.obj.Record.fecha;
			$scope.data.datos.ft_cabecera.tiempo_cumplimentacion = resp.data.obj.Record.tiempo_cumplimentacion;
			$scope.data.datos.ft_cabecera.fecha_aprobada = resp.data.obj.Record.fecha_aprobada;
			$scope.data.datos.ft_cabecera.fecha_baja = resp.data.obj.Record.fecha_baja;
			$scope.data.datos.ft_cabecera.idioma = resp.data.obj.Record.idioma;
			$scope.data.ft_cabecera_original = angular.copy($scope.data.datos.ft_cabecera);

			$scope.data.gridTirajeEtiquetas.clearGridAfterSave();
			$scope.data.gridAnaliticas.clearGridAfterSave();
			ixStatusService.setEditing(false);
			if ($scope.data.forzarCargaGridFicherosProveedor) {
				//Lineas 469 + 470 comentadas por Yves (08/07/2021)... Por el momento ver si va bien llamar las siguientes instrucciones o hay que construir una función más "ligera"
				$scope.data.gridPlantasFabricante.ixLoadInitialData();
				$scope.data.gridFicherosProveedor.ixLoadInitialData();
				// buildGridListaPlantasFabricante();
				// buildGridFicherosProveedor();
			}

			if ($scope.data.gridComentariosFt) {
				$scope.data.gridComentariosFt.clearGridAfterSave();
				$http.get(cfg.baseURL + "ftbp_data/GetComentariosFt?id_ft=" + $scope.data.id_ficha_tecnica).then(function (resp) {
					$scope.data.datos.comentarios = resp.data;
					$scope.data.gridComentariosFt.data = $scope.data.datos.comentarios;
				}, function (err) {
					ixStatusService.setResponse(err);
				});
			}

			//Si he modificado el estado de bloqueo para la tarjeta proveedores debo actualizar el bloqueo general
			$scope.verificarBloqueoTodaFt();

			//Si se generaron las preguntas hay que cargar las preguntas
			//TODO
			if (generar_preguntas) {
				$log.log("TODO: Recargar preguntas");
				$scope.data.fullList = [];
				$scope.data.list = [];
				$scope.$parent.$parent.$parent.actualizarListado(true);
			}
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	}

	$scope.compruebaRestricciones = function (perfilesRestringidos) {
		var perfilRestringido = false;

		angular.forEach(perfilesUsuario, function (perfil) {
			if (perfilesRestringidos.indexOf(perfil) != -1)
				perfilRestringido = true;
		});
		return perfilRestringido;
	}

	$scope.tieneCabeceraRestringida = function () {
		var perfilesRestringidos = ["usr_bp_consulta", "usr_bp_recepcio", "usr_comprador", "usr_laboratorio", "usr_proveedor"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};

	$scope.esUsuarioConsulta = function () {
		var perfilesRestringidos = ["usr_bp_consulta", "usr_visitante", "usr_proveedor"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};

	$scope.tieneAccionesRestringidas = function () {
		var perfilesRestringidos = ["usr_bp_consulta", "usr_bp_recepcio", "usr_comprador", "usr_laboratorio", "usr_proveedor"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};


	$scope.edicionPreguntasRestringida = function () {
		var perfilesRestringidos = ["usr_bp_consulta", "usr_bp_recepcio", "usr_comprador", "usr_laboratorio"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};


	$scope.tienePerfilBio = function () {
		return (perfilesUsuario.indexOf("ixnet") >= 0) || (perfilesUsuario.indexOf("usr_bio_userkey") >= 0);
	};

	if ($scope.tieneAccionesRestringidas()) {
		$scope.ixEditar = undefined;
		$scope.ixGuardar = undefined;
	}

	/* ***** FIN FUNCIONES CONTROL EDICION Y CONTROL RESTRICCIONES ***** */

	/* ***** FUNCIONES GENERICAS GRIDS ***** */
	$scope.addRow = function (grid) {
		grid.ixAddRow();
	};


	$scope.deleteSelectedRows = function (grid, guardarCambios) {
		grid.ixDeleteSelectedRows();
		if (guardarCambios) {
			grid.ixGuardar();
		}
	};

	$scope.addRowComentarioFt = function () {
		var nuevo = {};
		nuevo.idficha = $scope.data.datos.ft_cabecera.id;
		nuevo.usuario = usuario;
		$scope.data.gridComentariosFt.ixAddRow(nuevo);
	}


	var buildGridTirajeEtiquetas = function () {
		if (!$scope.data.gridTirajeEtiquetas) {
			$scope.data.gridTirajeEtiquetas = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridTirajeEtiquetas", { minRowsToShow: 5, enableCellEdit: true, disableFiltering: true, enableFiltering: false, enableSorting: false }, "ft_tiraje_etiquetas");
			$scope.data.gridTirajeEtiquetas.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }];
			$scope.data.gridTirajeEtiquetas.data = $scope.data.datos.tiraje_etiquetas;
		}
		else {
			$scope.data.gridTirajeEtiquetas = gridService.createGridFunctions($scope, $scope.data.gridTirajeEtiquetas);
			$scope.data.gridTirajeEtiquetas.ixRestoreConfig();
		}
	};


	var buildGridAnaliticas = function () {
		if (!$scope.data.gridAnaliticas) {

			var acciones = [
				{
					title: 'Editar',
					icon: 'fa-pencil',
					visible: function () {
						return $scope.status.editing;
					},
					accion: function (entity) {
						//Open PopUp en edición
						var data = {
							id: entity.id,
							id_ficha_tecnica: entity.id_ficha_tecnica,
							tipo: entity.tipo,
							laboratorio: entity.laboratorio,
							intervalo_meses: entity.intervalo_meses,
							fecha_ultima_analisis: entity.fecha_ultima_analisis,
							comentarios: entity.comentarios
						};
						$scope.openPopupPlanificacion(false, data);
					}
				}
			];

			$scope.data.gridAnaliticas = gridService.createGrid($scope, "formft_grid_analiticas_plan", { minRowsToShow: 5, enableCellEdit: false }, "planificacion_analisis_rutinarias", [{ name: 'Acciones', type: 'detalle', allowCellFocus: false, width: 100, acciones: acciones }]);
			$scope.data.gridAnaliticas.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }];
			$scope.data.gridAnaliticas.data = angular.copy($scope.data.datos.planificacion_analiticas);

			//cargar desplegables
			angular.forEach($scope.data.gridAnaliticas.data, function (row) {
				var columnFKDescs = $scope.data.gridAnaliticas.columnDefs.filter(function (e) { return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });
				angular.forEach(columnFKDescs, function (columnFKDesc) {
					columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
				});
			});


		}
		else {
			$scope.data.gridAnaliticas = gridService.createGridFunctions($scope, $scope.data.gridAnaliticas);
			$scope.data.gridAnaliticas.ixRestoreConfig();
		}
	};


	$scope.addPlanificacionAnalitica = function () {
		var data = { id_ficha_tecnica: $scope.data.id_ficha_tecnica };
		$scope.openPopupPlanificacion(true, data);
	};


	$scope.openPopupPlanificacion = function (nuevo, entity) {
		var template = "app/FTBonpreu/FormularioFtBP/modales/planificacionAnaliticaPopup.html";
		var optionsPopup = { controller: "PlanificacionAnaliticaPopupController" };
		var paramsPopup = { isNew: nuevo };

		//paramsPopup.isNew = nuevo;
		if (nuevo) {
			paramsPopup.id_ficha_tecnica = entity.id_ficha_tecnica;
		}
		else {
			paramsPopup.planificacion = entity;
		}

		var popup = ixUtilsService.openModalV2(template, optionsPopup, "small", paramsPopup);
		popup.then(function (resp) {
			if (resp) {
				//TODO: Recargar información
				$http.get(cfg.baseURL + "ftbp_data/GetPlanificacionAnaliticas?id_ft=" + $scope.data.id_ficha_tecnica).then(function (response) {
					$scope.data.datos.planificacion_analiticas = response.data;
					//buildGridAnaliticas();
					$scope.data.gridAnaliticas.data = angular.copy($scope.data.datos.planificacion_analiticas);
				},
					function (error) {
						ixStatusService.setResponse(error);
					});
			}
		});
	};


	var buildGridFicherosProveedor = function () {
		$scope.extraColumnsGrid = [{ name: 'Acciones', type: 'detalle', allowCellFocus: false, width: 100, acciones: $scope.accionesGridFicheros }];

		if (!$scope.data.gridFicherosProveedor) {
			var metadata = [
				{ Name: 'nombre_proveedor', NoVisible: true },
				{ Name: 'alcance', NoVisible: true },
				{ Name: 'comentarios', NoVisible: true },
				{ Name: 'verificacion', NoVisible: true }
			];

			var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.activo == 0), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
			//$scope.data.gridFicherosProveedor = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridFicherosProveedor", { minRowsToShow: 10, enableCellEdit: false, disableFiltering: true, enableFiltering: false, enableSorting: false, metadata: metadata, ixLoadInitialDataAction: "SearchCustom" }, "proveedores_ficheros", $scope.extraColumnsGrid);
			$scope.data.gridFicherosProveedor = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridFicherosProveedor", { minRowsToShow: 10, enableCellEdit: false, metadata: metadata, ixLoadInitialDataAction: "SearchCustom" }, "listado_proveedores_ficherosVM", $scope.extraColumnsGrid);
			$scope.data.gridFicherosProveedor.rowTemplate = rowTemplate;
			$scope.data.gridFicherosProveedor.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }, { Field: "vigentes", Operator: CMP_EQ, Value: 0 }];
		} else {
			$scope.data.gridFicherosProveedor = gridService.createGridFunctions($scope, $scope.data.gridFicherosProveedor);
			$scope.data.gridFicherosProveedor.ixRestoreConfig();
		}
	};


	$scope.marcarRecargaFicherosProveedor = function () {
		$scope.data.forzarCargaGridFicherosProveedor = true;
	};


	$scope.accionesGridFicheros = [
		{
			title: $translate.instant("Previsualizar PDF"),
			icon: "fa-file-pdf-o",
			visible: function (entity) {
				return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
			},
			accion: function (entity) {
				var tabla = $scope.getEntity();
				$http({
					method: 'post',
					url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
					headers: {},
					responseType: 'arraybuffer'
				}).then(function (r) {
					$scope.selectedPDF = new Uint8Array(r.data);
					$scope.idFicheroPreview = entity.id;
					var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
					ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
				},
					function (err) {
						ixStatusService.setResponse(err);
					});
			}
		},
		{
			title: $translate.instant("Previsualizar Imagen"),
			icon: "fa-file-image-o",
			visible: function (entity) {
				return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
			},
			accion: function (entity) {
				var tabla = $scope.getEntity();
				$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
					//$scope.selectedImage = new Uint8Array(r.data);
					$scope.selectedImage = r.data;
					$scope.idFicheroPreview = entity.id;
					var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
					ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
				},
					function (err) {
						ixStatusService.setResponse(err);
					});
			}
		},
		{
			title: $translate.instant("Descargar fichero"),
			icon: "fa-download",
			visible: function (entity) {
				return entity.archivo;
			},
			accion: function (entity) {
				$scope.downloadFile(entity);
			}
		},
		{
			title: "Editar fichero",
			icon: "fa-pencil",
			visible: function () {
				var check = ($scope.data.gridFicherosTab) ? false : true;
				return check && $scope.status.editing && !$scope.tieneAccionesRestringidas();
			},
			accion: function (entity) {
				$scope.openPopupFicherosFt(entity.id, entity);
			}
		}
	];

	var buildGridFicherosFT = function () {
		$scope.extraColumnsGrid = [{ name: $translate.instant('Acciones'), type: 'detalle', allowCellFocus: false, width: 100, acciones: $scope.accionesGridFicheros }];

		if (!$scope.data.gridFicherosFT) {
			var metadata = [
				// { Name: 'tipo', NoVisible: true },
				// { Name: 'id', NoVisible: true },
				// { Name: 'id_ficha_tecnica', NoVisible: true },
				// { Name: 'ruta_raiz', NoVisible: true },
				// { Name: 'ruta_relativa', NoVisible: true },
				// { Name: 'tipo', NoVisible: true },
				// { Name: 'version', NoVisible: true }
			];

			var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.activo == 0), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"

			// $scope.data.gridFicherosFT = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridFicherosFT", { minRowsToShow: 10, enableCellEdit: false, disableFiltering: true, enableFiltering: false, enableSorting: false, metadata: metadata }, "fichas_tecnicas_ficheros", $scope.extraColumnsGrid);
			$scope.data.gridFicherosFT = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridFicherosFT", { minRowsToShow: 10, enableCellEdit: false, metadata: metadata }, "listado_ft_ficherosVM", $scope.extraColumnsGrid);
			$scope.data.gridFicherosFT.entity = "fichas_tecnicas_ficheros";
			$scope.data.gridFicherosFT.rowTemplate = rowTemplate;
			$scope.data.gridFicherosFT.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }];
			$scope.data.gridFicherosFT.data = $scope.data.datos.ft_ficheros_fichas_tecnicas;
		} else {
			$scope.data.gridFicherosFT.data = $scope.data.datos.ft_ficheros_fichas_tecnicas;
		}
	};


	$scope.openPopupFicherosFt = function (id_fichero, entity) {
		var template = "app/FTBonpreu/FormularioFtBP/modales/editarFicheroFtPopup.html";
		var optionsPopup = { controller: "EditarFicheroFtPopupController" };
		var tipo = null;
		if (id_fichero != 0)
			tipo = entity.tipo;

		var paramsPopup = { id_ft: $scope.data.id_ficha_tecnica, id_fichero: id_fichero };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "small", paramsPopup);
		popup.then(function (data) {
			//grid.ixAddRow(data.obj.Record);
			$http.get(cfg.baseURL + "ftbp_data/GetFicherosFt?id_ft=" + $scope.data.id_ficha_tecnica).then(function (resp) {
				// Replace array content with received data
				$scope.data.datos.ft_ficheros_fichas_tecnicas.length = 0;
				$scope.data.datos.ft_ficheros_fichas_tecnicas.push.apply($scope.data.datos.ft_ficheros_fichas_tecnicas, resp.data);
				$scope.data.gridFicherosFT.data = $scope.data.datos.ft_ficheros_fichas_tecnicas;
			}, function (err) {
				ixStatusService.setResponse(err);
			});

		});
	};


	$scope.getEntity = function () {
		return ($scope.data.gridFicherosTab) ? "proveedores_ficheros" : "fichas_tecnicas_ficheros";
	};


	$scope.downloadFile = function (entity) {
		var id = entity.id;
		var tabla = $scope.getEntity();
		$http({
			method: 'post',
			url: cfg.baseURL + tabla + '/DownloadFile?id=' + id,
			//headers: { 'Content-type': 'application/pdf' },
			headers: {},
			responseType: 'arraybuffer'
		}).then(function (r) {
			var mimetype = r.headers('Content-type');
			//var file = new Blob([r.data], { type: 'application/pdf' });
			var file = new Blob([r.data], { type: mimetype });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		},
			function (err) {
				ixStatusService.setResponse(err);
			});
	};


	var asociarPlantaFt = function (rowEntity, colDef, newValue, oldValue) {
		$log.log("Llamada función asociarPlantaFt");
		$log.log(rowEntity);
		$log.log(colDef);
		$log.log(newValue);
		$log.log(oldValue);

		$scope.data.forzarCargaGridFicherosProveedor = true;

		var param = {
			id_ficha_tecnica: $scope.data.id_ficha_tecnica,
			id_fabricante: rowEntity.id_fabricante,
			id_planta: rowEntity.id_planta,
			fabricante: rowEntity.fabricante,
			envasador: rowEntity.envasador,
			etiquetador: rowEntity.etiquetador,
			importador: rowEntity.importador,
			distribuidor: rowEntity.distribuidor
		};
		$http.put(cfg.baseURL + "fichas_tecnicas_plantas_asociadas/PutAsociaPlantasActividadFt", param).then(function (r) {
			ixStatusService.setResponse(r);
			$scope.data.gridPlantasFabricante.clearGridAfterSave();
			//Dejar habilitado solo para admin, bonpreu y proveedor
			if ($scope.perfil == "usr_proveedor" || $scope.tienePerfilAdmin())
				ixStatusService.setEditing(true);
		}, function (error) {
			rowEntity.fabricante = rowEntity.fabricante == 0 ? 1 : 0;
			rowEntity.envasador = rowEntity.envasador == 0 ? 1 : 0;
			rowEntity.etiquetador = rowEntity.etiquetador == 0 ? 1 : 0;
			rowEntity.importador = rowEntity.importador == 0 ? 1 : 0;
			rowEntity.distribuidor = rowEntity.distribuidor == 0 ? 1 : 0;
			ixStatusService.setResponse(error);
		});
	};


	var buildGridListaPlantasFabricante = function () {
		var acciones = [
			{
				title: 'Datos de fabricante',
				icon: "fa-industry",
				accion: function (entity) {
					var template = "app/FTBase/GestionFichasTecnicas/acciones/datos_fabricante_popup.html";
					var optionsPopup = { controller: "DatosFabricantePopupController" };
					var paramsPopup = { fabricante: entity.id_fabricante };
					ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
				}
			},
			{
				title: 'Datos de planta',
				icon: "fa-building",
				accion: function (entity) {
					var template = "app/FTBase/GestionFichasTecnicas/acciones/datos_planta_popup.html";
					var optionsPopup = {
						controller: ['$scope', '$http', 'cfg', '$uibModalInstance', 'ixStatusService', function ($scope, $http, cfg, $uibModalInstance, ixStatusService) {
							$scope.status = { editing: false };
							$scope.data = {};
							$http.get(cfg.baseURL + "plantas/" + $scope.$resolve.planta).then(function (response) {
								$scope.datos_planta = response.data;
							}, function (err) {
								ixStatusService.setResponse(err);
							});
						}]
					};
					var params = { planta: entity.id_planta };
					ixUtilsService.openModalV2(template, optionsPopup, "medium", params);
				}
			}
		];

		$scope.extraColumnsGrid = [{ name: $translate.instant('Detalles'), type: 'detalle', width: 100, acciones: acciones }];

		if (!$scope.data.gridPlantasFabricante) {
			var metadata = [
				{ Name: 'razon_social', ColumnDescription: 'Empresa', Type: "string", NoEditable: true },
				{ Name: 'nombre_planta', ColumnDescription: 'Planta', Type: "string", NoEditable: true },
				{ Name: 'id_fabricante', Pk: true, NoVisible: true },
				{ Name: 'id_planta', Pk: true, NoVisible: true },
				{ Name: 'fabricante', Type: "Int32", Control: "CheckBox", NoEditable: function () { return $scope.data.datos.ft_cabecera.bloqueo_datos_proveedor || !$scope.status.editing; } },
				{ Name: 'envasador', Type: "Int32", Control: "CheckBox", NoEditable: function () { return $scope.data.datos.ft_cabecera.bloqueo_datos_proveedor || !$scope.status.editing; } },
				{ Name: 'etiquetador', Type: "Int32", Control: "CheckBox", NoEditable: function () { return $scope.data.datos.ft_cabecera.bloqueo_datos_proveedor || !$scope.status.editing; } },
				{ Name: 'importador', Type: "Int32", Control: "CheckBox", NoEditable: function () { return $scope.data.datos.ft_cabecera.bloqueo_datos_proveedor || !$scope.status.editing; } },
				{ Name: 'distribuidor', Type: "Int32", Control: "CheckBox", NoEditable: function () { return $scope.data.datos.ft_cabecera.bloqueo_datos_proveedor || !$scope.status.editing; } }
			];

			var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.baja == 1), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
			$scope.data.gridPlantasFabricante = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridPlantasFabricante", { onCellEdit: asociarPlantaFt, minRowsToShow: 10, disableFiltering: true, metadata: metadata });
			$scope.data.gridPlantasFabricante.rowTemplate = rowTemplate;
			$scope.data.gridPlantasFabricante.columnDefs = [];

			$scope.data.gridPlantasFabricante.cellEditableCondition = function (cell) {
				$log.log("NoEditable: " + cell.col.colDef.noeditable());
				return !cell.col.colDef.noeditable();
			};


			$scope.data.gridPlantasFabricante.drawExtraColumns($scope.extraColumnsGrid);
			$scope.data.gridPlantasFabricante.ixGetColsFromAPI();
		}
		else {
			$scope.data.gridPlantasFabricante = gridService.createGridFunctions($scope, $scope.data.gridPlantasFabricante);
			$scope.data.gridPlantasFabricante.cellEditableCondition = function (cell) {
				return !cell.col.colDef.noeditable();
			};


			$scope.data.gridPlantasFabricante.ixRestoreConfig();
		}

		$scope.data.gridPlantasFabricante.ixLoadInitialData = function () {
			$scope.data.gridPlantasFabricante.data = $scope.data.datos.plantas_asociadas;
		};

		$scope.data.gridPlantasFabricante.ixLoadInitialData();
	};


	var buildGridComentariosFt = function () {
		if (!$scope.data.gridComentariosFt) {
			var metadata = [
				{ Name: 'idcomentario', NoVisible: true },
				{ Name: 'idficha', NoVisible: true },
				{ Name: 'fecha', NoEditable: false },
				{ Name: 'usu', NoVisible: true },
				{ Name: 'comentario', NoEditable: false },
				{ Name: 'ruta_archivo', NoVisible: true },
				{ Name: 'es_Interno', NoVisible: true }
			];
			$scope.data.gridComentariosFt = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridComentariosFt", { minRowsToShow: 10, enableCellEdit: true, disableFiltering: true, enableFiltering: false, enableSorting: true, metadata: metadata }, "ft_comentarios");
			$scope.data.gridComentariosFt.data = $scope.data.datos.comentarios;
		} else {
			$scope.data.gridComentariosFt.data = $scope.data.datos.comentarios;
			$scope.data.gridComentariosFt = gridService.createGridFunctions($scope, $scope.data.gridComentariosFt);
			$scope.data.gridComentariosFt.ixRestoreConfig();
		}

		$scope.data.gridComentariosFt.ixLoadInitialData = function () { return true; };
	};


	var buildGridCambioDatosFt = function () {
		if (!$scope.data.gridCambioDatosFt) {
			var metadata = [
				{
					Name: "fecha",
					Sort: {
						direction: uiGridConstants.DESC,
						ignoreSort: false,
						priority: 0
					}
				},
				{
					Name: "hora",
					Sort: {
						direction: uiGridConstants.DESC,
						ignoreSort: false,
						priority: 1
					}
				},
				{
					Name: "id",
					Sort: {
						direction: uiGridConstants.DESC,
						ignoreSort: false,
						priority: 2
					}
				}
			];
			//$scope.data.gridCambioDatosFt = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridCambioDatossFt", { minRowsToShow: 20, enableCellEdit: false, enableSorting: true, metadata: metadata }, "listado_cambio_datosFtVM");
			$scope.data.gridCambioDatosFt = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridLogAuditoriasFt", { minRowsToShow: 20, enableCellEdit: false, enableSorting: true, metadata: metadata }, "listado_log_auditoriasFtVM");
			$scope.data.gridCambioDatosFt.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }]
		} else {
			$scope.data.gridCambioDatosFt.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }]
		}


		$scope.data.gridCambioDatosFt.ixLoadInitialData = function () {
			var param = buildIxSearch();
			//param.Filters.push({ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica });
			param.Filters = $scope.data.gridCambioDatosFt.filtroExterno;
			$http.post(cfg.baseURL + "listado_log_auditoriasFtVM/Search", param).then(function (response) {
				$scope.data.gridCambioDatosFt.data = response.data.Items;
			}, function (error) {
				ixStatusService.setResponse(error);
			});

			return true;
		};

		$scope.data.gridCambioDatosFt.ixLoadInitialData();
	};


	$scope.descargarExcelLog = function () {
		$scope.data.gridCambioDatosFt.ixDownloadExcel();
	};
	/* ***** FIN FUNCIONES GENERICAS GRIDS ***** */

	/* ***** FUNCIONES POPUPS ***** */
	/* ***** FIN FUNCIONES POPUPS ***** */

	/* ***** FUNCIONES BLOQUEO-DESBLOQUEO PREGUNTAS ***** */
	$scope.$parent.$parent.$parent.bloquearPreguntas = function (ev, item, bloquear) {
		ev.stopPropagation();
		if (item.icono == 'home') {
			//Bloqueo total de la ficha técnica
			$log.log("Bloquear todas las preguntas FT");
			item.bloqueado = bloquear;
			//BLOQUEAR/DESBLOQUEAR Tarjeta Proveedores
			//TODO
			if (bloquear)
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 1;
			else
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 0;

			var tarjetaProveedores = $scope.data.list.find(function (n) { return n.icono == "industry"; });
			tarjetaProveedores.bloqueado = bloquear;
			$scope.ixGuardar(false);

			//BLOQUEO/DESBLOQUEO Preguntas
			var bulkUpdateTotal = $scope.bloquearTodasPreguntasFt(bulkUpdateTotal, bloquear);
			$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/UpdateBulk", bulkUpdateTotal).then(function (response) {
				ixStatusService.setResponse(response);
			}, function (err) {
				ixStatusService.setResponse(err);
				item.bloqueado = !bloquear;
				$scope.bloquearTodasPreguntasFt(bulkUpdateTotal, !bloquear);
			});
		}
		else if (item.icono == 'industry') {
			$log.log("Bloquear datos plantas-fabricantes (TODO)");
			if (bloquear)
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 1;
			else
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 0;
			item.bloqueado = bloquear;
			$scope.ixGuardar(false);
		}
		else { //Tarjetas preguntas
			var bulkUpdate = $scope.bloquearRecursivamente(bulkUpdate, $scope.getObjSeleccionado(item), bloquear);
			$scope.bloquearRecursivamente(undefined, item, bloquear);
			$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/UpdateBulk", bulkUpdate).then(function (response) {
				ixStatusService.setResponse(response);
				$scope.verificarBloqueoTarjetasPadre(item);
				$scope.verificarBloqueoTodaFt();
			}, function (err) {
				ixStatusService.setResponse(err);
				$scope.bloquearRecursivamente(bulkUpdate, item, !bloquear);
				$scope.bloquearRecursivamente(undefined, $scope.getObjSeleccionado(item), !bloquear);
			});
		}
	};

	$scope.getObjSeleccionado = function (item) {
		var ficha_tecnica = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica];

		if (angular.isDefined(ficha_tecnica)) {
			var obj_seleccionado = ficha_tecnica.tarjetas.find(function (e) { return e.nivel1 == item.nivel1 });
			if (item.nivel2)
				obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel2 == item.nivel2 });
			if (item.nivel3)
				obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel3 == item.nivel3 });

			item = obj_seleccionado;
		}

		return item;
	};


	$scope.bloquearRecursivamente = function (bulkUpdate, item, bloquear) {
		//bloqueamos tarjeta.
		item.bloqueado = bloquear;

		if (angular.isUndefined(bulkUpdate)) {
			bulkUpdate = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			}
		}
		angular.forEach(item.subniveles, function (subnivel) {
			$scope.bloquearRecursivamente(bulkUpdate, subnivel, bloquear);
		});
		angular.forEach(item.preguntas, function (pregunta) {
			angular.forEach(pregunta.respuestas, function (respuesta) {
				//bloquemos todas las preguntas de la tarjeta.
				respuesta.bloqueado = bloquear;
				bulkUpdate.ToUpdate.push({
					PK: { id: respuesta.id },
					PocoToUpdate: [
						{
							value: item.bloqueado,
							path: "/bloqueado",
							op: "replace"
						},
						{
							value: true,
							path: "/disable_before_after",
							op: "replace"
						}
					]
				});
			});
		});
		return bulkUpdate;
	};


	$scope.bloquearTodasPreguntasFt = function (bulkUpdateTotal, bloquear) {
		if (angular.isUndefined(bulkUpdateTotal)) {
			bulkUpdateTotal = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
		}

		angular.forEach($scope.data.list, function (item) {
			var itemsToSkip = ["home", "paperclip", "industry", "comments", "database"];
			if (!itemsToSkip.includes(item.icono)) {
				var bulkUpdate = $scope.bloquearRecursivamente(bulkUpdate, $scope.getObjSeleccionado(item), bloquear);
				$scope.bloquearRecursivamente(undefined, item, bloquear);
				bulkUpdateTotal.ToUpdate = bulkUpdateTotal.ToUpdate.concat(bulkUpdate.ToUpdate);
			}
		});

		return bulkUpdateTotal;
	};


	$scope.verificarBloqueoTarjetasPadre = function (item) {
		if (item.nivel2) {
			var tarjetaPadre = $scope.data.list.find(function (n) { return n.nivel1 == item.nivel1 && !n.nivel2; });
			var setBloqueo = 1;
			angular.forEach(tarjetaPadre.subniveles, function (t) {
				if (t.bloqueado == 0) setBloqueo = 0;
			});
			tarjetaPadre.bloqueado = setBloqueo;
		}
	};


	$scope.verificarBloqueoTodaFt = function () {
		var itemsToSkip = ["home", "paperclip", "industry", "comments", "database"];
		var tarjetaHome = $scope.data.list.find(function (n) { return n.icono == "home"; });
		var setBloqueo = 1;
		angular.forEach($scope.data.list, function (item) {
			if (!itemsToSkip.includes(item.icono)) {
				if (item.bloqueado == 0) setBloqueo = 0;
			}
		});

		tarjetaHome.bloqueado = setBloqueo && $scope.data.datos.ft_cabecera.bloqueo_datos_proveedor;
	};


	/* ***** FIN FUNCIONES BLOQUEO-DESBLOQUEO PREGUNTAS ***** */

	$scope.guardarConfigGridsActivos = function () {
		var num_card_activa = ixStatusService.current.data.currentPreguntasTab;
		if (num_card_activa) {
			var partes_card_activa = num_card_activa.split('-');

			var card_activa = undefined;

			if (partes_card_activa[0] != "null") {
				card_activa = ixStatusService.current.data.list[parseInt(partes_card_activa[0]) + 1];
				if (partes_card_activa[1] != "null") {
					card_activa = card_activa.subniveles[parseInt(partes_card_activa[1]) - 1];
					if (partes_card_activa[2] != "null") {
						card_activa = card_activa.subniveles[parseInt(partes_card_activa[2]) - 1];
					}
				}
			}

			if (angular.isDefined(card_activa)) {
				var preguntas_grid = card_activa.preguntas.filter(function (e) { return e.pregunta.bucle; });
				angular.forEach(preguntas_grid, function (pregunta_grid) {
					angular.forEach(Object.keys(ixStatusService.current.data.grids), function (key, idx) {
						if (key.lastIndexOf("grid" + pregunta_grid.pregunta.id_pregunta) != -1) {
							ixStatusService.current.data.grids[key].ixSaveConfig();
						}
					});
				});
			}
		}

	};

	$scope.$parent.$parent.$parent.selectItem = function (item, evt) {
		$log.log("Calling selectItem parent");
		if (!ixStatusService.current.editing && !ixStatusService.current.filtered || $scope.changeWhileEditing) {
			$log.log("selectItem");
			$log.log(item);

			// Marcamos este item como selected
			item.selected = true;
			// Marcamos y desmarcamos item.selected recursivamente en $scope.data.list			
			$scope.data.list.forEach(function (i) {
				i.selected = (i.titulo1 == item.titulo1 && i.nivel1 == item.nivel1 && i.nivel2 == item.nivel2 && i.nivel3 == item.nivel3)
				i.subniveles && i.subniveles.forEach(function (ii) {
					ii.selected = (ii.titulo1 == item.titulo1 && ii.nivel1 == item.nivel1 && ii.nivel2 == item.nivel2 && ii.nivel3 == item.nivel3);
					ii.subniveles && ii.subniveles.forEach(function (iii) {
						iii.selected = (iii.titulo1 == item.titulo1 && iii.nivel1 == item.nivel1 && iii.nivel2 == item.nivel2 && iii.nivel3 == item.nivel3);
					})
				})
			});

			if (!item.subniveles) {
				$scope.guardarConfigGridsActivos();
				$log.log("no tiene detalles/subniveles, cargamos pantalla");

				// Hacer visible la ficha abierta previamente
				item.visible = true;
				if (item.parent) {
					item.parent.visible = true;
					item.parent.subniveles.forEach(function (s) { s.visible = true });
				}

				var currentCard = item.icono;
				var idxCard = $scope.data.list.indexOf(item);
				if (!$scope.manualEditing) ixStatusService.setEditing(false);
				if (currentCard == "home") {
					$scope.ocultaGuardar = false;
					$scope.ocultaEditar = false;
					//Cabecera.
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "cabecera";
					buildGridTirajeEtiquetas();
					buildGridAnaliticas();
				} else if (currentCard == "paperclip") {
					$scope.ocultaGuardar = false;
					$scope.ocultaEditar = false;
					if ($scope.perfil == "usr_proveedor")
						ixStatusService.setEditing(true);
					//Ficheros.
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "ficheros";
					buildGridFicherosFT();
				} else if (currentCard == "industry") {
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					if ($scope.perfil == "usr_proveedor" || $scope.tienePerfilAdmin())
						ixStatusService.setEditing(true);
					//Datos proveedor.
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "proveedor";
					buildGridListaPlantasFabricante();
				} else if (currentCard == "comments") {
					$scope.ocultaGuardar = false;
					$scope.ocultaEditar = false;
					//Comentarios
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "comentarios";
					buildGridComentariosFt();
				} else if (currentCard == "database") {
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					//Log de cambios
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "log";
					buildGridCambioDatosFt();
				} else {
					//TODO: TARJETAS CON PREGUNTAS
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					if ($scope.edicionPreguntasRestringida())
						ixStatusService.setEditing(false);
					else
						ixStatusService.setEditing(true);
					//Cargar dinámicamente:
					$scope.data.pantalla = "preguntas";
					$scope.data.currentPreguntasTab = item.nivel1 + "-" + item.nivel2 + "-" + item.nivel3;

					// $scope.data.selectedItem = item;
					var ficha_tecnica = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica];

					if (angular.isDefined(ficha_tecnica)) {
						var obj_seleccionado = ficha_tecnica.tarjetas.find(function (e) { return e.nivel1 == item.nivel1 });
						if (item.nivel2)
							obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel2 == item.nivel2 });
						if (item.nivel3)
							obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel3 == item.nivel3 });

						$scope.data.selectedItem = obj_seleccionado;
					}
					else {
						$scope.data.selectedItem = item;
					}

					$log.log("Element: " + "#preguntas" + $scope.data.currentPreguntasTab);
					$log.log(angular.element('#preguntas' + $scope.data.currentPreguntasTab));
					$log.log("Length element: " + angular.element('#preguntas' + $scope.data.currentPreguntasTab).length);

					if (angular.element('#preguntas' + $scope.data.currentPreguntasTab).length == 0) {
						$timeout(function () {
							if ($scope.data.modoTraduccion) {
								angular.element("form").append($compile("<div ng-show='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")' id='preguntas" + $scope.data.currentPreguntasTab + "'><div ng-if='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")'><ft-titulo item='data.selectedItem'></ft-titulo><ft-preguntas-bp preguntas='data.selectedItem.preguntas' data='data' modo-traduccion='true' idioma='data.datos.ft_cabecera.idioma' solo-preguntas-pdt-traduccion='data.solo_preguntas_pdt'></ft-preguntas-bp></div></div>")($scope));
							} else {
								angular.element("form").append($compile("<div ng-show='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")' id='preguntas" + $scope.data.currentPreguntasTab + "'><div ng-if='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")'><ft-titulo item='data.selectedItem'></ft-titulo><ft-preguntas-bp preguntas='data.selectedItem.preguntas' data='data' idioma='data.datos.ft_cabecera.idioma'></ft-preguntas-bp></div></div>")($scope));
							}
						}, 200);
					}
				}
			}
			else {
				$log.log("que se vean/oculten todas las cards que tiene por debajo.");
				$scope.data.pantalla = "";
				angular.forEach(item.subniveles, function (detalle) {
					var cur = $scope.$parent.$parent.$parent.current
					if ((cur.titulo1 != item.titulo1 || cur.nivel1 != item.nivel1 || cur.nivel2 != item.nivel2 || cur.nivel3 != item.nivel3)) {
						detalle.visible = true;
					} else {
						detalle.visible = !detalle.visible;
					}

				});
			}

			$scope.$parent.$parent.$parent.current = item;
		}
	};

	// Si la pantalla activa es preguntas (cambio de FT o venimos de otro controller y restauramos estado), 
	// llamamos a selectItem para que se muestre marcada la opción activa	
	if ($scope.data.pantalla == "preguntas") {
		$scope.selectItem($scope.data.selectedItem);
	}

	/* ***** FUNCIONES ACCIONES ***** */
	$scope.generarPreguntasFt = function () {
		//Verificar requisitos mínimos cumplimentados
		if (!$scope.data.datos.ft_cabecera.CodInterno || !$scope.data.datos.ft_cabecera.titulo || !$scope.data.datos.ft_cabecera.ft_version) {
			$ngConfirm({
				icon: 'fa fa-warning',
				title: 'Datos incompletos!',
				content: 'No se ha cumplimentado uno o varios de los siguientes campos: Número de artículo, título o el tipo de ficha técnica.',
				type: 'red',
				typeAnimated: true,
				closeIcon: false,
				buttons: {
					cerrar: {
						text: 'Cerrar',
						btnClass: 'btn-ix-red',
						action: function () {
							return true;
						}
					}
				}
			});
		}
		else {
			//Si ya hay preguntas generadas, enviar alerta y permitir opción de eliminar preguntas generadas
			if ($scope.data.fullList.length > 5) {
				$ngConfirm({
					icon: 'fa fa-warning',
					title: '¡Atención!',
					content: 'Los datos de la ficha actual Serán eliminados. ¿Desea continuar?',
					type: 'red',
					typeAnimated: true,
					closeIcon: false,
					buttons: {
						ok: {
							text: 'Si',
							btnClass: 'btn-ix-green',
							show: 'true',
							action: function () {
								//Llamar WebAPI
								$scope.ixGuardar(true);
								return true;
							}
						},
						cancelar: {
							text: "Cancelar",
							btnClass: 'btn-ix-red',
							show: 'true',
							action: function () {
								//Do Nothing
								return true;
							}
						}
					}
				});
			}
			else {
				//Llamar WebAPI
				$scope.ixGuardar(true);
			}
		}
	};


	$scope.duplicarFt = function (n) {
		var template = "app/FTBase/GestionFichasTecnicas/acciones/duplicarFT_popup.html";
		var optionsPopup = { controller: "DuplicarFtPopupController" };
		var paramsPopup = { ft_origen: $scope.data.id_ficha_tecnica, ft_tipo: $scope.data.datos.ft_cabecera.ft_version, niveles: n };
		ixUtilsService.openModalV2(template, optionsPopup, "small", paramsPopup);
	};


	$scope.versionarFt = function () {
		var template = "app/FTBonpreu/FormularioFtBP/modales/seleccionarEstadoVersion.html";
		var optionsPopup = { controller: "SeleccionarEstadoVersionarController" };
		ixUtilsService.openModalV2(template, optionsPopup, "small", undefined).then(function (sel) {
			$log.log("openModal sel version: " + sel);
			if (sel != 'CANCEL') {
				$http.put(cfg.baseURL + "extranet_fichas_tecnicas_bp/VersionarFT?ft_origen=" + $scope.data.id_ficha_tecnica + "&estado_ini=" + sel).then(function (response) {
					ixStatusService.setResponse(response);
				}, function (err) {
					ixStatusService.setResponse(err);
				});
			}
		});
	};


	$scope.marcarPreguntasErroneas = function (error) {
		var erroresTarjetas = error.obj.Errors;
		angular.forEach(erroresTarjetas, function (errorTarjetaCab) {
			var errorTarjetaDet = errorTarjetaCab.Values;
			var tarjeta = $scope.data.list.find(function (e) { return e.nivel1 == errorTarjetaDet[0].nivel1; });
			tarjeta.visible = true;
			if (errorTarjetaDet[0].nivel2) {
				if (tarjeta.subniveles)
					tarjeta.subniveles.forEach(function (x) { x.visible = true; });
				tarjeta = tarjeta.subniveles.find(function (e) { return e.nivel2 == errorTarjetaDet[0].nivel2; });
				if (errorTarjetaDet[0].nivel3) {
					if (tarjeta.subniveles)
						tarjeta.subniveles.forEach(function (x) { x.visible = true; });
					tarjeta = tarjeta.subniveles.find(function (e) { return e.nivel3 == errorTarjetaDet[0].nivel3; });
				}
			}
			if (angular.isDefined(tarjeta))
				tarjeta.error = true;
		});
	};


	$scope.limpiarPreguntasErroneas = function () {
		angular.forEach($scope.data.list, function (tarjeta) {
			if (tarjeta.error)
				tarjeta.error = false;
			if (tarjeta.subniveles) {
				angular.forEach(tarjeta.subniveles, function (subnivel1) {
					if (subnivel1.error)
						subnivel1.error = false;
					if (subnivel1.subniveles) {
						angular.forEach(subnivel1.subniveles, function (subnivel2) {
							if (subnivel2.error)
								subnivel2.error = false;
						});
					}
				});
			}
		});
	};


	$scope.confirmarCumplimentacion = function () {
		$scope.limpiarPreguntasErroneas();
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas/ConfirmarCumplimentacion?id_ficha_tecnica=" + $scope.data.id_ficha_tecnica).then(function (r) {
			if ($scope.data.datos.ft_cabecera.estado == "O") $scope.data.datos.ft_cabecera.estado = "P";
			if ($scope.data.datos.ft_cabecera.estado == "Q") $scope.data.datos.ft_cabecera.estado = "R";
			ixStatusService.setResponse(r);
		}, function (error) {
			ixStatusService.setResponse(error);
			$scope.marcarPreguntasErroneas(error.data);
		});
	};


	$scope.imprimirFt = function () {
		var template = "app/FTBonpreu/ListadosFtBP/acciones/imprimir_ftbp_popup.html";
		var options = { controller: "ImprimirFTBPPopupController" };
		var selIdioma = $scope.data.datos.ft_cabecera.idioma;
		if ($scope.data.idioma)
			selIdioma = $scope.data.idioma;
		var params = { id_ficha_tecnica: $scope.data.id_ficha_tecnica, idioma: selIdioma, tipo: "FT_UNICA" };

		ixUtilsService.openModalV2(template, options, "small", params);
	}

	$scope.imprimirFtRevision = function () {
		var config = { responseType: 'arraybuffer' };
		$http.get(cfg.baseURL + "impresosBp/ImpresoRevisionFt/?idft=" + $scope.data.id_ficha_tecnica, config).then(function (response) {

			var file = new Blob([response.data], { type: 'application/pdf' });

			var filename = "ImpresoRevision_" + $scope.data.id_ficha_tecnica.replace("/", "-") + ".pdf";
			if (response.headers('Content-Disposition')) {
				filename = response.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
			}
			saveAs(file, filename);
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	}
	/* ***** FIN FUNCIONES ACCIONES ***** */

	/* ***** FUNCIONES NAVEGACION TARJETAS ***** */
	//Función recursiva para iterar lista de tarjetas y buscar en los títulos (YVES)
	var buscarEnSubniveles = function (el, modo) {
		var match = false;
		var resultado = [];
		if (el.subniveles) {
			resultado = el.subniveles.filter(function (e) {
				return ((e.subniveles) && buscarEnSubniveles(e, modo).length > 0) || $scope.filterAlgorithmSelector(e, modo);

			});
		}
		el.subniveles = resultado;
		return el.subniveles;
	};
	//FIN Función recursiva para iterar lista de tarjetas y buscar en los títulos (YVES)


	$scope.cambiarFicha = function (ficha_tecnica, activeTab) {
		var firstLoad = false;
		if (angular.isUndefined($scope.data.fullItemsList[ficha_tecnica]))
			firstLoad = true;

		$scope.data.activeTabFichaTecnica = activeTab;

		$scope.data.id_ficha_tecnica = ficha_tecnica;

		if (angular.isDefined($scope.data.fullItemsList[$scope.data.id_ficha_tecnica]))
			$scope.data.fullList = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica].tarjetas;
		else
			$scope.data.fullList = [];

		if (timer) { $timeout.cancel(timer); }
		timer = $timeout(function () {
			// Utilizamos el mismo timer, porque la primera vez ya se lanza una vez la carga desde el método actualizarListado, así la evitamos.
			getListElements();
		}, 1);

		var currentTabIdx = $scope.getCurrentPage();
		if (currentTabIdx != -1) {
			// Mantener la misma ficha seleccionada
			$timeout(function () {
				angular.element("div.listEditResult")[currentTabIdx].click();
				if (!firstLoad)
					$scope.refreshCurrentCardContent();
			}, 1);
		}
	};


	$scope.setDatosCabecera = function (data) {
		$scope.data.datos = {
			id: data.ft_cabecera.id,
			count_preguntas_obligatorias: data.count_preguntas_obligatorias,
			total_preguntas_obligatorias: data.total_preguntas_obligatorias,
			ft_cabecera: data.ft_cabecera,
			ft_ficheros_fichas_tecnicas: data.ft_ficheros_fichas_tecnicas,
			ft_ficheros_proveedores: data.ft_ficheros_proveedores,
			tiraje_etiquetas: data.tiraje_etiquetas,
			planificacion_analiticas: data.planificacion_analiticas,
			plantas_asociadas: data.plantas_asociadas,
			comentarios: data.comentarios,
			estado_traduccion: data.estado_traduccion,
			traducir_completa: data.traducir_completa,
			comprador: data.comprador
		};
	};


	$scope.filterAlgorithmSelector = function (e, modo) {
		if (modo == "PENDIENTES") {
			var busqueda = $scope.data.busqueda || "";
			return (
				((e.titulo1) && e.titulo1.toLowerCase().indexOf(busqueda.toLowerCase()) != -1) ||
				((e.titulo2) && e.titulo2.toLowerCase().indexOf(busqueda.toLowerCase()) != -1) ||
				((e.titulo2_valor) && e.titulo2_valor.toLowerCase().indexOf(busqueda.toLowerCase()) != -1) ||
				((e.titulo3) && e.titulo3.toLowerCase().indexOf(busqueda.toLowerCase()) != -1)) &&
				(parseInt(e.titulo4_valor) < parseInt(e.titulo4_valor2));
		}
		else {
			return (
				((e.titulo1) && e.titulo1.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				((e.titulo2) && e.titulo2.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				((e.titulo2_valor) && e.titulo2_valor.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				((e.titulo3) && e.titulo3.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1)
			);
		}
	};

	$scope.isFirst = function () {
		return ($scope.getCurrentPage() < 1);
	};

	$scope.isLast = function () {
		return ($scope.getCurrentPage() == angular.element("div.listEditResult").length - 1);
	};

	//¿Qué indices debo de poner para comentarios y log? (YVES - 2/12/2019)
	$scope.getCurrentPage = function () {
		var idx = -1;
		if ($scope.data.pantalla == "cabecera")
			idx = 0;
		else if ($scope.data.pantalla == "ficheros")
			idx = 1;
		else if ($scope.data.pantalla == "proveedor")
			idx = 2;
		else {
			var element = angular.element("div.listEditResult > div.card-selected");
			if (angular.isDefined(element[0])) {
				var contenedor = angular.element(element[0]).parent();
				idx = Array.from(angular.element("div.listEditResult")).indexOf(contenedor[0]);
			}

		}
		return idx;
	};

	$scope.selectPreviousPage = function () {
		var currentTabIdx = $scope.getCurrentPage();
		$timeout(function () {
			angular.element("div.listEditResult")[currentTabIdx - 1].click();
		}, 1);
	};

	$scope.selectCurrentPage = function () {
		var currentTabIdx = $scope.getCurrentPage();
		$timeout(function () {
			angular.element("div.listEditResult")[currentTabIdx].click();
		}, 1);
	};

	$scope.selectNextPage = function () {
		var currentTabIdx = $scope.getCurrentPage();
		$timeout(function () {
			angular.element("div.listEditResult")[currentTabIdx + 1].click();
		}, 1);
	};
	/* ***** FIN FUNCIONES NAVEGACION TARJETAS ***** */

	/* ***** FUNCIONES CARGAS DESPLEGABLES ***** */
	$scope.loadEstadosTraduccion = function (params) {
		return $http.post(cfg.baseURL + "ft_estados_traduccion/Search", params);
	}

	$scope.loadIdiomas = function () {
		var deferred = $q.defer();
		$timeout(function () {
			var list = [
				{ cod_idioma: "ca", nombre_idioma: "Catalá" },
				{ cod_idioma: "es", nombre_idioma: "Castellano" }
			];
			return deferred.resolve({ data: list });
		}, 1);
		return deferred.promise;

	}

	/* ***** FIN FUNCIONES CARGAS DESPLEGABLES ***** */
}]);

"use strict";

angular.module('FTBonpreuApp').controller('PaginaContactosController',['$scope', '$routeParams', 'ixStatusService', 'authService', function($scope, $routeParams, ixStatusService, authService){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  var currentLanguage = authService.authentication.language;

  if ($routeParams.productos == "MarcaPropiaFleca"){
    if (currentLanguage == "es")
      $scope.data.desc_prods = "PRODUCTOS MARCA PROPIA Y PANADERIA (Alimentación/Cosmética/Droguería/No Alimentación/Panadería)";
    else
      $scope.data.desc_prods = "PRODUCTES MARCA PROPIA I FLECA (Alimentació/Cosmètica/Drogueria/No alimentació/Fleca)";

    $scope.data.tel_contacto = "93 857 27 53";
    $scope.data.email_contacto = "CentralQualitatMarcaPropia@bonpreu.cat";
  }
  else { //($routeParams.productos == "Frescos")
    if (currentLanguage == "es")
      $scope.data.desc_prods = "PRODUCTOS FRESCOS (Carne/Fruta/Pescado)";
    else
      $scope.data.desc_prods = "PRODUCTES FRESCOS (Carn/Fruita/Peix)";

    $scope.data.tel_contacto = "93 826 85 97";
    $scope.data.email_contacto = "CentralQualitatAreaFrescos@bonpreu.cat";
  }

  $scope.status.editing = true;
}]);
/*global angular*/

angular.module('FTBonpreuApp').controller('AlarmaBP_Expiracion_CertificadosController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
  $scope.entity = "alarmabp_expiracion_certificadosVM";
  $scope.ocultaEditar = true;

  //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
  //$scope.acciones = [];
  $scope.acciones = [
      {
          title: 'Detalles proveedor',
          icon: 'fa-vcard',
          redirect: {
              template: 'MantenimientosBP/proveedores',
              atributos: ['proveedor'],
              atributosTitle: [],
              iconBox: 'perm_device_information',
              multiple: true
          }
      }
  ];
  $controller('GridEditorController', { $scope: $scope });

}]);

/*global angular*/

angular.module('FTBonpreuApp').controller('AlarmaBP_Estado_Fuera_PlazoController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
  $scope.entity = "alarmabp_estado_fuera_plazoVM";
  $scope.ocultaEditar = true;

  //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
  $scope.acciones = [
      {
          title: 'Datos Ficha Técnica',
          icon: 'fa-list',
          redirect: {
              template: 'FormularioFtBP/list',
              atributos: ['id_ficha_tecnica'],
              atributosTitle: [],
              iconBox: 'perm_device_information',
              multiple: true
          }
      }
  ];
  $controller('GridEditorController', { $scope: $scope });
  
}]);
/*global angular*/

angular.module('FTBonpreuApp').controller('AlarmaBP_Actualizacion_FTController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService, $log, $translate, ixCestaVehiculosService) {
  $scope.entity = "alarmabp_actualizacion_ftVM";
  $scope.ocultaEditar = true;

  //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
  $scope.acciones = [
      {
          title: 'Datos Ficha Técnica',
          icon: 'fa-list',
          redirect: {
              template: 'FormularioFtBP/list',
              atributos: ['id_ficha_tecnica'],
              atributosTitle: [],
              iconBox: 'perm_device_information',
              multiple: true
          }
      }
  ];
  $controller('GridEditorController', { $scope: $scope });

}]);
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module('FTBonpreuApp').directive('ftPreguntasBp', ['$http', '$compile', '$log', function ($http, $compile, $log) {
	return {
		restrict: 'E',
		scope: {
			preguntas: '=',
			data: '=?',
			preview: '=?',
			modoTraduccion: '=?',
			idioma: '=?',
			soloPreguntasPdtTraduccion: '=?'
		},
		//template: "<div>los datos padre son: {{ data | json }}</div>",
		link: function (scope, elem, attrs) {
			scope.getContainerElement = function () {
				return elem;
			};
			//iteramos el array de preguntas para crear el formulario.
			scope.preguntas.forEach(function (pregunta, idx) {
				scope.pregunta = pregunta;
				var separador_linea = pregunta.pregunta.separador_linea;
				elem.append($compile("<div class='row'><ft-pregunta-bp pregunta='preguntas[" + idx + "]' preview='preview' modo-traduccion='modoTraduccion' idioma='idioma' solo-preguntas-pdt-traduccion='soloPreguntasPdtTraduccion' data='data'></ft-pregunta-bp>" + ((separador_linea) ? "<hr style='clear:both; border-color:black' class='no-margin'/>" : "") + "</div>")(scope));
			});
		}
	}
}]);

angular.module('FTBonpreuApp').directive('ftPreguntaBp', ['$http', '$compile', '$log', '$q', '$translate', 'gridService', 'ixStatusService', 'cfg', 'ixUtilsService', '$timeout', '$rootScope', 'authService', 'authInterceptorService', 'ixWarningsService', function ($http, $compile, $log, $q, $translate, gridService, ixStatusService, cfg, ixUtilsService, $timeout, $rootScope, authService, authInterceptorService, ixWarningsService) {
	return {
		restrict: 'E',
		scope: {
			pregunta: '=',
			respuestas: '=?',
			data: '=?',
			preview: '=?',
			inPopup: '=?',
			modoTraduccion: '=?',
			idioma: '=?',
			soloPreguntasPdtTraduccion: '=?'
		},
		//template: "<div>los datos son: {{ pregunta | json }}</div>",
		link: function (scope, elem, attrs) {
			var ESTADO_PDT_APROVACION = 1;
			var ESTADO_CONFIRMADO = 2;
			var tiposValor = { TEXTO: "TEXTO", NUMERICO: "NUMERICO", DECIMAL: "DECIMAL", DICCIONARIO: "DICCIONARIO", SINO: "SI/NO", FECHA: "FECHA", AREA_TEXTO: "AREA_TEXTO", DICCIONARIO_MULTIPLE: "DICCIONARIO_MULTIPLE" };
			scope.status = {};
			if (scope.preview)
				scope.status.editing = true;
			else
				scope.status = ixStatusService.current;

			if (angular.isUndefined(scope.data))
				scope.data = {};

			scope.getUniqueID = function (idx, nombre) {
				var id = "";
				if (angular.isDefined(nombre)) {
					if (nombre == "obs")
						id = (scope.preview) ? scope.pregunta.pregunta.id_pregunta + "-" + nombre : scope.pregunta.respuestas[idx].observaciones;
					else
						id = (scope.preview) ? scope.pregunta.pregunta.id_pregunta + "-" + nombre : scope.pregunta.pregunta[nombre];
				}
				else
					id = (scope.preview) ? scope.pregunta.pregunta.id_pregunta : scope.pregunta.respuestas[idx].id;

				if (angular.isDefined(scope.componentesCount))
					id += "" + scope.componentesCount;
				return id;
			};

			scope.getCssClass = function () {
				var cssClassDimensions = 12;
				if (!scope.inPopup) {
					if (scope.pregunta.pregunta.preguntar_obs)
						cssClassDimensions = 6;

					if (scope.num_subpreguntas)
						cssClassDimensions = 12 / scope.num_subpreguntas;

					//el mínimo es un tercio del ancho por control.
					if (cssClassDimensions < 4)
						cssClassDimensions = 4;
				}
				scope.getCssControlesPregunta(cssClassDimensions, scope.creando_subpregunta);
				if ((scope.cuentaColMd + cssClassDimensions > 12)) {
					scope.cuentaColMd = 0;
					scope.salto_linea = true;
				}
				scope.cuentaColMd += cssClassDimensions;
				return "col-md-" + cssClassDimensions;
			};

			scope.getCssControlesPregunta = function (columnsContainer, subpregunta) {
				if (columnsContainer == 12) {
					scope.labelClass = "col-md-4";
					scope.inputClass = "col-md-6";
				}
				else if (columnsContainer == 6) {
					//					if (subpregunta)
					//						scope.labelClass = "col-md-4";
					//					else
					//						scope.labelClass = "col-md-8";
					//					scope.inputClass = "col-md-4";
					//Modificacion para hacer que el text-area o control que haya detras de la pregunta, sea igual de ancho que el textarea de observaciones.
					if (subpregunta) {
						scope.labelClass = "col-md-4";
						scope.inputClass = "col-md-7";
					}
					else {
						scope.labelClass = "col-md-8";
						scope.inputClass = "col-md-4";
					}
				}
				else if (columnsContainer == 4) {
					//calcular cuando tengamos un caso
					scope.labelClass = "col-md-4";
					scope.inputClass = "col-md-8";
				}
			};

			scope.multiplesElementosEnLaLinea = function () {
				var multiples = false;
				if (scope.pregunta.pregunta.preguntar_obs)
					multiples = true;
				if (scope.num_subpreguntas)
					multiples = true;
				return multiples;
			};

			//CONTROLES DE FORMULARIO INI
			scope.getHTMLTag = function (tipo_valor) {
				var tag;
				switch (tipo_valor) {
					case tiposValor.TEXTO:
					case tiposValor.NUMERICO:
					case tiposValor.DECIMAL:
						//tag = "ix-text";
						tag = "ix-text-area-ft";
						break;
					case tiposValor.AREA_TEXTO:
						tag = "ix-text-area-ft";
						break;
					case tiposValor.DICCIONARIO:
						tag = "ix-select-ft";
						break;
					case tiposValor.DICCIONARIO_MULTIPLE:
						tag = "ix-select-multiple-ft";
						break;
					case tiposValor.SINO:
						tag = "ft-nz-toggle";
						break;
					case tiposValor.FECHA:
						tag = "ix-date-ft";
						break;
				}
				return tag;
			};

			scope.buildControlObs = function (idx) {
				if (!scope.preview)
					scope.observaciones_original = scope.pregunta.respuestas[idx].observaciones;

				//YVES - 18/02/2022
				//Parche para hacer que se traduzca la etiqueta de Observaciones
				var etiqObs = $translate.instant('Observaciones');

				var prop = scope.getUniqueID(idx, "obs");
				var strEl = "";
				if (scope.preview)
					strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='data[\"" + prop + "\"]' name='" + etiqObs + "' ng-disabled='pregunta.pregunta.bloqueado || tienePerfilRestringido()' rows='3'></ix-text-area-ft></div>";
				else if (scope.modoTraduccion) {
					var propertyVisible = (scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";
					$log.log("buildControlObs(" + idx + ") -->");
					$log.log(scope.pregunta.respuestas_idioma[0]);
					$log.log(scope.pregunta.respuestas[0]);
					if (scope.pregunta.respuestas[0].observaciones)
						strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "].observaciones' name='" + etiqObs + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\"ix-text-area-ft\") || (!pregunta.pregunta.traducible) || (!pregunta.respuestas[" + idx + "].observaciones && pregunta.respuestas_idioma[" + idx + "].fecha_modif_observaciones == null)' placeholder='" + scope.pregunta.respuestas[0].observaciones + "' ix-focus-out='guardarObservaciones' rows='3' label-class='col-md-4' input-class='col-md-7'></ix-text-area-ft></div>";
					else
						strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "].observaciones' name='" + etiqObs + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\"ix-text-area-ft\") || (!pregunta.pregunta.traducible)' ix-focus-out='guardarObservaciones' rows='3' label-class='col-md-4' input-class='col-md-7'></ix-text-area-ft></div>";
				}
				else
					strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='pregunta.respuestas[" + idx + "].observaciones' name='" + etiqObs + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\"ix-text-area-ft\")' ix-focus-out='guardarObservaciones' rows='3' label-class='col-md-4' input-class='col-md-7'></ix-text-area-ft></div>";
				var el = $compile(strEl)(scope);
				return el;
			};

			scope.buildControlImg = function (idx) {
				var clave = "valor";
				scope.setValorOriginal(idx);

				var prop = scope.getUniqueID(idx);
				var pregunta = scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;

				var isRequired = 0;
				if (clave != "valor") {
					var propertyValidarSubpregunta = "validar_" + clave.replace("respuesta", "pregunta");
					isRequired = scope.pregunta.pregunta.obligatoria && scope.pregunta.pregunta[propertyValidarSubpregunta];
				}
				else {
					isRequired = scope.pregunta.pregunta.obligatoria;
				}

				var strEl = "";
				if (scope.preview)
					strEl = '<div class="row"><div class="' + scope.getCssClass() + '"><ft-nz-toggle class="margin" name="'+pregunta+'" icono="'+scope.pregunta.pregunta.imagen_base64+'" ng-model="data[\'' + prop + '\']" ng-disabled="pregunta.bloqueado || tienePerfilRestringido() || (modoTraduccion && !pregunta.pregunta.traducible)" style="margin-top:10px;"></ft-nz-toggle></div></div>';
				else {
					if (scope.modoTraduccion) {
						var propertyVisible = (scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";
						strEl += '<div class="' + scope.getCssClass() + '"><ft-nz-toggle class="margin" label-class="'+scope.labelClass+'" input-class="'+scope.inputClass+'" name="'+pregunta+'" icono="'+scope.pregunta.pregunta.imagen_base64+'" ng-model="pregunta[\'' + propertyVisible + '\'][' + idx + '].valor" ng-required="' + isRequired +'" ng-disabled="pregunta.respuestas[' + idx + '].bloqueado || tienePerfilRestringido()  || tieneLlamadasPendientes(pregunta.respuestas[' + idx + '].id,\'ft-nz-toggle\')|| (!pregunta.pregunta.traducible)" after-click="guardarTraduccion" style="margin-top:10px;"></ft-nz-toggle></div>';
					} else {
						strEl += '<div class="' + scope.getCssClass() + '"><ft-nz-toggle class="margin" label-class="'+scope.labelClass+'" input-class="'+scope.inputClass+'" name="'+pregunta+'" icono="'+scope.pregunta.pregunta.imagen_base64+'" ng-model="pregunta.respuestas[' + idx + '].valor" ng-required="' + isRequired +'" ng-disabled="pregunta.respuestas[' + idx + '].bloqueado || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[' + idx + '].id,\'ft-nz-toggle\')" after-click="guardarValor" ix-focus-out-param="valor" ix-focus-out-param-idx="' + idx + '"  style="margin-top:10px;"></ft-nz-toggle></div>';
					}
				}
				var el = $compile(strEl)(scope);
				return el;
			};

			scope.openPopupFicheros = function (id_ficha_tecnica, tipo) {
				var template = "app/FTBase/GestionFichasTecnicas/acciones/upload_file_popup.html";
				var optionsPopup = { controller: "UploadFilePopupController" };
				var paramsPopup = { tipo: tipo, id_ft: id_ficha_tecnica };
				var popup = ixUtilsService.openModalV2(template, optionsPopup, "small", paramsPopup);
				popup.then(function (data) {
					$rootScope.$broadcast("NUEVO_FICHERO", data.obj.Record);
				});
			};

			scope.openPopupDedependenciaEtiquetado = function (id_ficha_tecnica, id_pregunta, pregunta_formulario, bloquear_valor_b, idioma) {
				var templateDepEtiquetado = "app/FTBase/GestionFichasTecnicas/acciones/dependencia_etiquetado_popup.html";
				var pregunta_bloqueada = scope.pregunta.respuestas[0].bloqueado;
				var optionsPopupDepEtiquetado = { controller: "DependenciaEtiquetadoPopupController" };
				var paramsPopupDepEtiquetado = { id_ft: id_ficha_tecnica, id_pregunta: id_pregunta, pregunta_formulario: pregunta_formulario, bloquear_valor_b: bloquear_valor_b, pregunta_bloqueada: pregunta_bloqueada, modo_traduccion: scope.modoTraduccion, idioma: idioma, traducible: scope.pregunta.pregunta.traducible, pregunta: scope.pregunta };
				ixUtilsService.openModalV2(templateDepEtiquetado, optionsPopupDepEtiquetado, "medium", paramsPopupDepEtiquetado);
			};

			scope.setValorOriginal = function (idx, clave) {
				var propertyRespuesta = (scope.modoTraduccion && scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";

				if (angular.isDefined(clave)) {
					if (angular.isUndefined(scope["valor_original_" + clave])) {
						scope["valor_original_" + clave] = {};
					}
					scope["valor_original_" + clave][idx] = scope.pregunta[propertyRespuesta][idx][clave];
				}
				else {
					if (angular.isUndefined(scope.valor_original))
						scope.valor_original = {};
					scope.valor_original[idx] = scope.pregunta[propertyRespuesta][idx].valor;
				}
			};

			//			scope.esDiccionario = function(){
			//				return (scope.pregunta.pregunta.tipo_valor == tiposValor.DICCIONARIO || scope.pregunta.pregunta.tipo_valor == tiposValor.DICCIONARIO_MULTIPLE);
			//			};

			scope.sePuedeVisualizar = function (idx, clave) {
				var soloPdtTraduccion = scope.soloPreguntasPdtTraduccion;
				var propertyTraduccion = "traducible";
				if (clave != "valor")
					propertyTraduccion = clave.replace("sub_respuesta", "sub_pregunta") + "_traducible";

				//TODO: Yves agregar condición para verificar que la FT master no resulte modificada respecto al valor traducido
				if (soloPdtTraduccion)
					return (scope.pregunta.pregunta[propertyTraduccion]) && (scope.pregunta.respuestas[idx][clave] && !scope.pregunta.respuestas_idioma[idx][clave]);
				else
					return true;

				//Tenemos que devolver solo:
				//-Aquellas que sean traducibles y que el idioma master tenga valor pero no haya traducción. (YVES: agregar que el idioma master tenga valor, hay traducción, pero en el master haya habido modificación)
			};

			scope.textWithQuotes = function (text) {
				return text.replace(/'/g, "&apos;");
			};

			scope.buildControl = function (idx, clave, pregunta, tipo) {
				if (!scope.preview) {
					scope.setValorOriginal(idx, clave);//esto esta antes de la definicion la variable clave a proposito. Ya que hay veces que nos llega por parametro y veces que no. Queremos distinguir esos casos.
					if (angular.isUndefined(clave))
						clave = "valor";
				}
				var prop;
				if (angular.isDefined(clave))
					prop = scope.getUniqueID(idx, clave);
				else
					prop = scope.getUniqueID(idx);

				var tag;
				if (angular.isDefined(tipo))
					tag = scope.getHTMLTag(tipo);
				else
					tag = scope.getHTMLTag(scope.pregunta.pregunta.tipo_valor);

				if (angular.isUndefined(pregunta)) {
					if (scope.modoTraduccion) {
						pregunta = scope.pregunta.pregunta_idioma.pregunta || scope.pregunta.pregunta_idioma.pregunta_formulario || scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					}
					else {
						pregunta = scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					}
				}

				var strEl = "";
				pregunta = scope.textWithQuotes(pregunta);
				if (scope.preview)
					strEl = "<div class='" + scope.getCssClass() + "'><" + tag + " ng-model='data[\"" + prop + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ng-disabled='pregunta.pregunta.bloqueado || tienePerfilRestringido()' " + scope.addSpecificProperties(clave) + "></" + tag + "></div>";
				else {
					strEl = "<div class='" + scope.getCssClass() + "'>";
					if (scope.salto_linea) {
						scope.salto_linea = false;
						strEl = "<br style='clear:both;' />" + strEl;
					}

					var isRequired = 0;
					if (clave != "valor") {
						var propertyValidarSubpregunta = "validar_" + clave.replace("respuesta", "pregunta");
						isRequired = scope.pregunta.pregunta.obligatoria && scope.pregunta.pregunta[propertyValidarSubpregunta];
					}
					else {
						isRequired = scope.pregunta.pregunta.obligatoria;
					}

					if (scope.modoTraduccion) {
						if (scope.sePuedeVisualizar(idx, clave)) {
							var propertyVisible;
							if (clave == "valor") {
								propertyVisible = (scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";
								scope.se_puede_visualizar = true;
								strEl += "<" + tag + " ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ";
								strEl += "ng-disabled='(pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido() || (!pregunta.pregunta.traducible) || (pregunta.pregunta.tipo_valor != \"TEXTO\")) || (!pregunta.respuestas[" + idx + "].valor && pregunta.respuestas_idioma[" + idx + "].fecha_modif_valor == null) || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\""+tag+"\")'";
								strEl += " ix-focus-out='guardarTraduccion' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
							} else {
								var propertyTraduccion = clave;
								propertyTraduccion = clave.replace("sub_respuesta", "sub_pregunta");

								var propertyTraducible = propertyTraduccion + "_traducible";

								propertyVisible = (scope.pregunta.pregunta[propertyTraducible]) ? "respuestas_idioma" : "respuestas";

								var tipoValor = "tipo_valor_" + propertyTraduccion;

								//strEl += "<" + tag + " ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ";
								strEl += "<" + tag + " ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='" + isRequired + "' ";
								strEl += "ng-disabled='(pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido() || (!pregunta.pregunta[\"" + propertyTraducible + "\"])) || (pregunta.pregunta[\"" + tipoValor + "\"] != \"TEXTO\") || (!pregunta.respuestas[" + idx + "][\"" + clave + "\"] && pregunta.respuestas_idioma[" + idx + "][\"fecha_modif_" + clave + "\"] == null) || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\""+tag+"\")' ";
								strEl += "ix-focus-out='guardarTraduccion' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
							}
						} else if (clave == "valor") {
							scope.se_puede_visualizar = false;
						}
					}
					else {
						scope.se_puede_visualizar = true;

						if (tag == "ix-select-multiple-ft") {
							if (scope.pregunta.respuestas[idx][clave] && scope.pregunta.respuestas[idx][clave] != "")
								scope.pregunta.respuestas[idx][clave] = ixUtilsService.fromJson(scope.pregunta.respuestas[idx][clave]);
						}


						//strEl += "<" + tag + " ng-model='pregunta.respuestas[" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido()' ix-focus-out='guardarValor' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
						strEl += "<" + tag + " ng-model='pregunta.respuestas[" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='" + isRequired + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\""+tag+"\")' ix-focus-out='guardarValor' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
					}

					strEl += "</div>";

				}
				var el = $compile(strEl)(scope);
				return el;
			};

			//			scope.getSelected = function(idx, clave){//Esta funcion hace que cuando estemos en modo traducción, aparezca por defecto
			//				if(!scope.pregunta.respuestas_idioma[idx][clave]){
			//					scope.pregunta.respuestas_idioma[idx][clave] = scope.pregunta.respuestas[idx][clave];
			//					scope.setValorOriginal(idx, clave);
			//				}
			//			};

			scope.cuentaSubPreguntas = function () {
				var num = 0;
				if (scope.pregunta.pregunta.sub_pregunta1)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta2)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta3)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta4)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta5)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta6)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta7)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta8)
					num++;
				if (num > 0)
					num++;//sumamos uno para despues dividir el ancho para que quepan como minimo 3 controles por fila.
				return num;
			};

			scope.buildControlSubPreguntas = function (idx) {
				//var strEl = "";
				var propertyPregunta = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				for (var i = 1; i <= 8; i++) {
					if (scope.pregunta[propertyPregunta]["sub_pregunta" + i]) {
						scope.creando_subpregunta = true;
						elem.append(scope.buildControl(idx, "sub_respuesta" + i, scope.pregunta[propertyPregunta]["sub_pregunta" + i], scope.pregunta.pregunta["tipo_valor_sub_pregunta" + i]));
						scope.creando_subpregunta = false;
					}

				}
				//return strEl;
			};

			scope.guardarObservaciones = function () {

				var entity = (scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det";
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
				$log.log("guardamos solo si ha cambiado.");
				if (scope.observaciones_original != scope.pregunta[respuestasProperty][0].observaciones) {
					scope.observaciones_original = scope.pregunta[respuestasProperty][0].observaciones;
					$log.log("ha cambiado, guardamos.");
					$log.log(scope.pregunta);
					var data = [
						{
							op: "replace",
							path: "/observaciones",
							value: scope.pregunta[respuestasProperty][0].observaciones
						}
					];

					var pathParams = scope.pregunta[respuestasProperty][0].id;
					if (scope.modoTraduccion)
						pathParams += "/" + scope.pregunta[respuestasProperty][0].idioma;

					$http.put(cfg.baseURL + entity + "/" + pathParams, data);
				}
			};

			scope.guardarValor = function (event) {

				var entity = "extranet_fichas_tecnicas_det";
				var respuestaProp = "respuestas";

				scope.grabarValor(event, entity, respuestaProp);
			};

			scope.guardarTraduccion = function (event) {
				var entity = "extranet_fichas_tecnicas_det_idioma";
				var respuestaProp = "respuestas_idioma";

				scope.$broadcast("focusOut");

				scope.grabarValor(event, entity, respuestaProp);
			};

			scope.grabarValor = function (event, entity, respuestaProp) {
				if (!scope.inPopup) {
					var prop = event.data.prop;
					var idx = event.data.idx;
					var valor_original_prop = "valor_original";
					if (prop != "valor")
						valor_original_prop += "_" + prop;

					$log.log("guardamos solo si ha cambiado.");
					if (scope[valor_original_prop][idx] != scope.pregunta[respuestaProp][idx][prop]) {

						var auxValorOriginal = scope[valor_original_prop][idx];
						var nuevoValor = scope.pregunta[respuestaProp][idx][prop];

						scope[valor_original_prop][idx] = scope.pregunta[respuestaProp][idx][prop];
						$log.log("ha cambiado, guardamos.");
						$log.log(scope.pregunta);

						var valor = scope.pregunta[respuestaProp][idx][prop];
						if (angular.isArray(valor))
							valor = ixUtilsService.toJson(valor);

						var data = [
							{
								op: "replace",
								path: "/" + prop,
								value: valor
							}
						];
						var pathParams = scope.pregunta[respuestaProp][idx].id;
						if (scope.modoTraduccion)
							pathParams += "/" + scope.pregunta[respuestaProp][idx].idioma;

						$http.put(cfg.baseURL + entity + "/" + pathParams, data).then(function (response) {
							//Descomentar las siguientes lineas en el caso del cálculo automático de redondeos, valores por ración y valores energéticos para nutricionales
							//OJO: Hay un BUG que resolver en la función actualizarRespuestas, porque modifica el valor de la pregunta 828 (YVES 19/11/2020)
							/* START
							if (scope.pregunta.pregunta.id_pregunta == 828) {
								scope.actualizarGrids(777);
								scope.actualizarGrids(856);
							}
							END */

							// if (cfg.appCliente == "BONPREU") {
							// 	//Tablas de nutricionales y Vitaminas y minerales para fichas de ALIMENTACIÓN
							// 	if (scope.pregunta.pregunta.id_pregunta == 5083) {
							// 		scope.actualizarGrids(5084);
							// 		scope.actualizarGrids(5637);
							// 	}

							// 	//Tablas de nutricionales y Vitaminas y minerales para fichas de FRESCOS
							// 	if (scope.pregunta.pregunta.id_pregunta == 5791) {
							// 		scope.actualizarGrids(5792);
							// 		scope.actualizarGrids(5793);
							// 	}
							// }

							if (scope.modoTraduccion)
								scope.pregunta[respuestaProp][idx]["fecha_modif_" + prop] = null;
							ixStatusService.setResponse(response);
							$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION", { newValue: nuevoValor, oldValue: auxValorOriginal, pregunta: scope.pregunta.pregunta });
						}, function (err) {
							//Si diera error al guardar, conservamos el valor anterior.
							scope.pregunta[respuestaProp][idx][prop] = auxValorOriginal;
							ixStatusService.setResponse(err);
						});
					}
				}
			};
			/*
			scope.$watch("pregunta.valor", function(oldVal, newVal){
				$log.log("guardamos valor");
				$log.log(scope.pregunta);
				$log.log(oldVal);
				$log.log(newVal);
			});

			*/

			scope.loadValores = function (param, search, entity) {
				var deferr = $q.defer();
				var valores = [];
				var propertyPregunta = (scope.modoTraduccion && scope.pregunta.pregunta.traducible) ? "pregunta_idioma" : "pregunta";
				var propertyValores = "diccionario_valores";
				var propertyName = entity;
				if (propertyName.lastIndexOf("sub_pregunta") != -1) {
					propertyName = propertyName.substring(propertyName.indexOf("sub_pregunta"));
					propertyValores = "diccionario_" + propertyName + "_valores";
				}
				angular.forEach(scope.pregunta[propertyPregunta][propertyValores], function (valor) {
					valores.push({ codigo: valor, descripcion: valor });
				});
				deferr.resolve({ data: valores });
				return deferr.promise;
			};

			scope.addSpecificProperties = function (tipoProp, multiplesElementosEnLaLinea) {
				var nameProperty = "";
				var namePropertyOriginal = "";
				var numlineas = "1";

				if (angular.isUndefined(tipoProp) || tipoProp == "valor") {
					nameProperty = "valor";
					tipoProp = "tipo_valor";
					numlineas = scope.pregunta.pregunta.numlineas_texto_pregunta;
				}
				else if (tipoProp.lastIndexOf("sub_respuesta") != -1) {
					namePropertyOriginal = tipoProp;
					tipoProp = tipoProp.replace("sub_respuesta", "sub_pregunta");
					nameProperty = tipoProp;
					tipoProp = "tipo_valor_" + tipoProp;
					numlineas = scope.pregunta.pregunta["numlineas_texto_" + nameProperty];
				}
				var specificProperties = "";

				switch (scope.pregunta.pregunta[tipoProp]) {
					case tiposValor.TEXTO:

						specificProperties += "rows='" + numlineas + "' ";
						if (scope.modoTraduccion) {
							if (nameProperty == "valor") {
								specificProperties += "custom-hint='" + scope.pregunta.respuestas[0].valor + "' ng-class='icon-left' traducible='" + scope.pregunta.pregunta.traducible + "' confirmado='" + (!scope.pregunta.respuestas_idioma[0].fecha_modif_valor) + "' ";
							}
							//							else if(nameProperty == "observaciones"){
							//								specificProperties += "custom-hint='" + scope.pregunta.respuestas[0].observaciones + "' ng-class='icon-left' traducible='" + scope.pregunta.pregunta.traducible + "' confirmado='"+(!scope.pregunta.respuestas_idioma[0].fecha_modif_observaciones)+"' ";
							//							}
							else {
								specificProperties += "custom-hint='" + scope.pregunta.respuestas[0][namePropertyOriginal] + "' ng-class='icon-left' traducible='" + scope.pregunta.pregunta[nameProperty + "_traducible"] + "' confirmado='" + (!scope.pregunta.respuestas_idioma[0]["fecha_modif_" + namePropertyOriginal]) + "' ";
							}
						}
						break;
					case tiposValor.NUMERICO:
						specificProperties += "rows='1' ";
						specificProperties += "ix-number ";
						break;
					case tiposValor.DECIMAL:
						specificProperties += "rows='1' ";
						specificProperties += "ix-number ";
						specificProperties += "with-decimals='2' ";
						specificProperties += "comma-separator='true' ";
						break;
					case tiposValor.DICCIONARIO:
					case tiposValor.DICCIONARIO_MULTIPLE:
						scope.addNewElementsToDictionary(tipoProp);
						specificProperties += "entity='" + tipoProp + "' pk='codigo' desc='descripcion' load-function='loadValores' append-to-body='true' limit-to='9999' ";
						// specificProperties += "comma-separated='true' ";
						if (scope.modoTraduccion) {
							specificProperties += " keep-original-value='true' ";
						}
						break;
					case tiposValor.FECHA:
						specificProperties += "append-to-body='true' ";
						break;
					case tiposValor.SINO:
						specificProperties += ((scope.modoTraduccion) ? "after-click='guardarTraduccion' " : "after-click='guardarValor' ");
						if (multiplesElementosEnLaLinea)
							specificProperties += " text-max-width='true' ";
						//						else
						//							specificProperties += " label-class='col-md-5' ";
						break;
				}

				if (scope.modoTraduccion) {
					if (nameProperty == "valor" && scope.pregunta.pregunta.traducible && scope.pregunta.respuestas[0].valor)
						specificProperties += " placeholder='" + scope.pregunta.respuestas[0].valor + "' ";
					else if (scope.pregunta.pregunta[nameProperty + "_traducible"] && scope.pregunta.respuestas[0][namePropertyOriginal])
						specificProperties += " placeholder='" + scope.pregunta.respuestas[0][namePropertyOriginal] + "' ";
				}

				if (scope.pregunta.pregunta.ayuda_pregunta && !scope.inPopup) {
					// if (scope.modoTraduccion)
					// 	specificProperties += "ix-hint='" + scope.textWithQuotes(scope.pregunta.pregunta_idioma.ayuda_pregunta) + "'  float-left='true' ";
					// else
					// 	specificProperties += "ix-hint='" + scope.textWithQuotes(scope.pregunta.pregunta.ayuda_pregunta) + "'  float-left='true' ";
					//En scope.pregunta pregunta tendremos siempre el idioma seleccionado por el usuario
					specificProperties += "ix-hint='" + scope.textWithQuotes(scope.pregunta.pregunta.ayuda_pregunta) + "'  float-left='true' ";
				}


				specificProperties += " label-class='" + scope.labelClass + "' input-class='" + scope.inputClass + "' ";

				return specificProperties;
			}
			//CONTROLES DE FORMULARIO FIN

			//GRID INI
			scope.isRowSelectable = function (row) {
				return !row.entity.bloqueado;
			};

			scope.estaBloqueadoValor = function (cell) {
				return (scope.estaBloqueado(cell)) || scope.pregunta.pregunta.bloquear_valor_b;
			};

			scope.estaBloqueado = function (cell) {
				if (cell.col.field == "valor")
					return cell.row.entity.bloqueado || (scope.modoTraduccion && !scope.pregunta.pregunta.traducible);
				else {
					//miramos si la sub_pregunta esta bloqueada.
					var propertyFTPreguntas = cell.col.field.replace("respuesta", "pregunta");
					var propertyABuscar = "deshabilitar_" + propertyFTPreguntas;
					var propertyTraducible = propertyFTPreguntas + "_traducible";
					return (scope.pregunta.pregunta[propertyABuscar] == 1 || cell.row.entity.bloqueado) || (scope.modoTraduccion && !scope.pregunta.pregunta[propertyTraducible]);
				}
			};

			scope.getFakeMetadata = function () {
				var metadata = [{ Name: "id", NoVisible: true, Pk: true }];
				var auxTitle = scope.pregunta.pregunta.pregunta_formulario;
				if (scope.pregunta.pregunta.bucle == 1)
					auxTitle = scope.pregunta.pregunta.titulo_primera_columna;
				var valor = { Name: "valor", ColumnDescription: auxTitle, Type: "String", NoEditable: scope.estaBloqueadoValor, NoFilterable: true };
				scope.addSpecificControl(valor, scope.pregunta.pregunta.tipo_valor, scope.esGridJerarquico());
				metadata.push(valor);
				if (scope.pregunta.pregunta.sub_pregunta1) {
					var sub_pregunta1 = { Name: "sub_respuesta1", ColumnDescription: scope.pregunta.pregunta.sub_pregunta1, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta1, scope.pregunta.pregunta.tipo_valor_sub_pregunta1, scope.esGridJerarquico());
					metadata.push(sub_pregunta1);
				}
				if (scope.pregunta.pregunta.sub_pregunta2) {
					var sub_pregunta2 = { Name: "sub_respuesta2", ColumnDescription: scope.pregunta.pregunta.sub_pregunta2, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta2, scope.pregunta.pregunta.tipo_valor_sub_pregunta2, scope.esGridJerarquico());
					metadata.push(sub_pregunta2);
				}
				if (scope.pregunta.pregunta.sub_pregunta3) {
					var sub_pregunta3 = { Name: "sub_respuesta3", ColumnDescription: scope.pregunta.pregunta.sub_pregunta3, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta3, scope.pregunta.pregunta.tipo_valor_sub_pregunta3, scope.esGridJerarquico());
					metadata.push(sub_pregunta3);
				}
				if (scope.pregunta.pregunta.sub_pregunta4) {
					var sub_pregunta4 = { Name: "sub_respuesta4", ColumnDescription: scope.pregunta.pregunta.sub_pregunta4, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta4, scope.pregunta.pregunta.tipo_valor_sub_pregunta4, scope.esGridJerarquico());
					metadata.push(sub_pregunta4);
				}
				if (scope.pregunta.pregunta.sub_pregunta5) {
					var sub_pregunta5 = { Name: "sub_respuesta5", ColumnDescription: scope.pregunta.pregunta.sub_pregunta5, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta5, scope.pregunta.pregunta.tipo_valor_sub_pregunta5, scope.esGridJerarquico());
					metadata.push(sub_pregunta5);
				}
				if (scope.pregunta.pregunta.sub_pregunta6) {
					var sub_pregunta6 = { Name: "sub_respuesta6", ColumnDescription: scope.pregunta.pregunta.sub_pregunta6, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta6, scope.pregunta.pregunta.tipo_valor_sub_pregunta6, scope.esGridJerarquico());
					metadata.push(sub_pregunta6);
				}
				if (scope.pregunta.pregunta.sub_pregunta7) {
					var sub_pregunta7 = { Name: "sub_respuesta7", ColumnDescription: scope.pregunta.pregunta.sub_pregunta7, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta7, scope.pregunta.pregunta.tipo_valor_sub_pregunta7, scope.esGridJerarquico());
					metadata.push(sub_pregunta7);
				}
				if (scope.pregunta.pregunta.sub_pregunta8) {
					var sub_pregunta8 = { Name: "sub_respuesta8", ColumnDescription: scope.pregunta.pregunta.sub_pregunta8, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta8, scope.pregunta.pregunta.tipo_valor_sub_pregunta8, scope.esGridJerarquico());
					metadata.push(sub_pregunta8);
				}
				return metadata;
			};

			scope.addNewElementsToDictionary = function (prop) {
				var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
				var diccionarioProperty = "diccionario_valores";
				var valorProperty = "valor";
				if(prop.startsWith("tipo_valor_sub_pregunta")) {
					diccionarioProperty = prop.replace("tipo_valor_sub_","diccionario_sub_")+"_valores";
					valorProperty = prop.replace("tipo_valor_sub_pregunta","sub_respuesta");
				}

				scope.pregunta[respuestasProperty].forEach(function (respuesta) {					
					if (scope.pregunta[preguntaProperty][diccionarioProperty]) {
						if (angular.isArray(respuesta[valorProperty])) {
							respuesta[valorProperty].forEach(function (sub_respuesta) {
								if (scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(sub_respuesta) == -1) {
									scope.pregunta[preguntaProperty][diccionarioProperty].push(sub_respuesta);
								}
							});
						} else if(respuesta[valorProperty] && respuesta[valorProperty].indexOf(";")>=0 && scope.pregunta[preguntaProperty][prop] == "DICCIONARIO_MULTIPLE") {
							respuesta[valorProperty].split(";").forEach(function (sub_respuesta) {
								if (scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(sub_respuesta) == -1) {
									scope.pregunta[preguntaProperty][diccionarioProperty].push(sub_respuesta);
								}
							});
						} else if(respuesta[valorProperty] && respuesta[valorProperty].indexOf(",")>=0 && scope.pregunta[preguntaProperty][prop] == "DICCIONARIO_MULTIPLE") {
							respuesta[valorProperty].split(",").forEach(function (sub_respuesta) {
								if (scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(sub_respuesta) == -1) {
									scope.pregunta[preguntaProperty][diccionarioProperty].push(sub_respuesta);
								}
							});
						}
						else if (respuesta[valorProperty] && scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(respuesta[valorProperty]) == -1) {
							scope.pregunta[preguntaProperty][diccionarioProperty].push(respuesta[valorProperty]);
						}
					}
				});
		
			};

			scope.addSpecificControl = function (obj, tipo, esJerarquico) {
				var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";

				if (esJerarquico && scope.modoTraduccion && tipo == tiposValor.DICCIONARIO_MULTIPLE)
					tipo = tiposValor.TEXTO;

				if (tipo == tiposValor.TEXTO) {
					if (scope.modoTraduccion) {
						if (obj.Name == "valor" && scope.pregunta.pregunta.traducible) {
							obj.cellTemplate = "app/FTBase/views/ui-grid-cell-traduccion.html";
							obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
						} else {
							var nameColumn = obj.Name.replace("respuesta", "pregunta");
							if (scope.pregunta.pregunta[nameColumn + "_traducible"]) {
								obj.cellTemplate = "app/FTBase/views/ui-grid-cell-traduccion.html";
								obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
							}
						}
					} else {
						obj.Control = "List";
					}
				}

				if (tipo == tiposValor.SINO) {
					if (scope.modoTraduccion)
						obj.NoEditable = true;

					obj.Control = "CheckBox";
					obj.Type = "Int32";
					obj.ignoreCellModifications = true;
				}
				else if (tipo == tiposValor.DICCIONARIO || tipo == tiposValor.DICCIONARIO_MULTIPLE) {
					if (scope.modoTraduccion)
						obj.NoEditable = true;

					if (tipo == tiposValor.DICCIONARIO_MULTIPLE)
						obj.Control = "MultiBusqueda";

					switch (obj.Name) {
						case "valor":
							if (scope.pregunta[preguntaProperty].diccionario_valores) scope.addNewElementsToDictionary("tipo_valor");
							break;
						case "sub_respuesta1":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta1_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta1");
							break;
						case "sub_respuesta2":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta2_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta2");
							break;
						case "sub_respuesta3":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta3_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta3");
							break;
						case "sub_respuesta4":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta4_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta4");
							break;
						case "sub_respuesta5":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta5_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta5");
							break;
						case "sub_respuesta6":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta6_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta6");
							break;
						case "sub_respuesta7":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta6_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta7");
							break;
						case "sub_respuesta8":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta8_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta8");
							break;
					}

					if (esJerarquico && obj.Name == "valor")
						obj.ColumnFkDescription = "valor";

					obj.Search = {
						"KeyFields": [obj.Name],
						"LookUpTableName": "",
						"LookUpKeyFields": ["codigo"],
						"LookUpResultFields": ["codigo"],
						"LookUpTableAlias": "",
						"LookUpOrders": [{ "KeyField": "codigo", "Desc": false }],
						"LookUpConditions": []
					};
					obj.busquedaFunction = function (column, param, text) {
						var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
						var deferr = $q.defer();
						var valores = [];
						var diccionario_valores = [];
						if (scope.preview)
							diccionario_valores = scope.pregunta.pregunta.diccionario_valores;
						else {
							var fieldToSearch = ((column.Name == "valor") ? "" : column.Name.replace("respuesta", "pregunta"));
							fieldToSearch = "diccionario_" + fieldToSearch + ((fieldToSearch != "") ? "_" : "") + "valores";
							diccionario_valores = scope.pregunta[preguntaProperty][fieldToSearch];
						}

						if (text)
							diccionario_valores = diccionario_valores.filter(function (e) { return e.toLowerCase().indexOf(text.toLowerCase()) != -1; });

						angular.forEach(diccionario_valores, function (valor) {
							var item = { codigo: valor, descripcion: valor };
							if (column.ColumnFKDescription)
								item[column.ColumnFKDescription] = valor;

							valores.push(item);
						});
						deferr.resolve(valores);
						return deferr.promise;
					};
				}
				else if (tipo == tiposValor.FECHA)
					obj.Type = "DateTime";
				else if (tipo == tiposValor.DECIMAL) {
					obj.Type = "Decimal";
					obj.MaxLength = 11;
					obj.CommaSeparator = true; // Forzar cambio de . por , en la entrada de valores
				}
				else if (tipo == tiposValor.NUMERICO) {
					obj.Type = "Int32";
					obj.MaxLength = 11;
				}
			};

			scope.guardarDatosGrid = function (rowEntity, colDef, newValue, oldValue) {
				$log.log("guardaremos los datos del grid.",rowEntity,colDef,newValue,oldValue);
				var data = [
					{
						op: "replace",
						path: "/" + colDef.name,
						value: newValue
					}
				];

				var entity = ((scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det");
				var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";

				var pathParams = rowEntity.id;
				if (scope.modoTraduccion)
					pathParams += "/" + scope.pregunta.respuestas_idioma[0].idioma;

				rowEntity.editingCols=rowEntity.editingCols||[];
				rowEntity.editingCols.push(colDef.name);
				$http.put(cfg.baseURL + entity + "/" + pathParams, data).then(function (response) {
					var iCol = rowEntity.editingCols.indexOf(colDef.name);
					if(iCol>-1) {
						rowEntity.editingCols.splice(iCol);
					}
					if (!scope.modoTraduccion) {
						//Modificar propietats de la línea actual per el que arriva de l'API.

						//Modificar una pregunta pot fer que s'hagi de recarregar un altre.
						// if (cfg.appCliente == "EUROMADI") {
						// 	if (scope.pregunta[preguntaProperty].id_pregunta == 845)
						// 		scope.addToReload([780]);
						// }
						if (cfg.appCliente == "BONPREU") {
							if (scope.pregunta[preguntaProperty].id_pregunta == 5634)
								scope.addToReload([5102]);
							if (scope.pregunta[preguntaProperty].id_pregunta == 5794)
								scope.addToReload([5799]);
						}

						if (response.data.obj) {
							//Guardamos lo que devuelve la API pero si fueran booleanos, como viene como string lo pasamos a booleano.
							//OJO!!! Esto no muestra el valor en celdas numéricas en las cuales se quiera poner el valor 1 ó 0. Debe de sustituirse el valor sólo si la celda es de tipo Checkbox
							if (response.data.obj.Record[colDef.name] === "1" && colDef.control == "CheckBox") {
								rowEntity[colDef.name] = 1;
							}
							else if (response.data.obj.Record[colDef.name] === "0" && colDef.control == "CheckBox") {
								rowEntity[colDef.name] = 0;
							}
							else {
								rowEntity[colDef.name] = response.data.obj.Record[colDef.name];
							}
						}
						//En alguns casos (id_pregunta hardcoded), el grid s'haura de recarregar sencer.
						//Descomentar las siguientes lineas en el caso del cálculo automático de redondeos, valores por ración y valores energéticos para nutricionales
						/* START
						if (scope.pregunta[preguntaProperty].id_pregunta == 777) {
							scope.actualizarGrids(777, rowEntity.componente);
						}
						END */
						// if (cfg.appCliente == "BONPREU") {
						// 	//Tabla de nutricionales para fichas de ALIMENTACIÓN
						// 	if (scope.pregunta[preguntaProperty].id_pregunta == 5084) {
						// 		scope.actualizarGrids(5084, rowEntity.componente);
						// 	}
						// 	//Tabla de nutricionales para fichas de FRESCOS
						// 	if (scope.pregunta[preguntaProperty].id_pregunta == 5792) {
						// 		scope.actualizarGrids(5792, rowEntity.componente);
						// 	}
						// }
					} else {
						rowEntity["fecha_modif_" + colDef.name] = response.data.obj.Record["fecha_modif_" + colDef.name];
					}
					ixStatusService.setResponse(response);

				}, function (err) {
					//Si diera error al guardar, conservamos el valor anterior.
					rowEntity[colDef.name] = oldValue;
					ixStatusService.setResponse(err);
					var iCol = rowEntity.editingCols.indexOf(colDef.name);
					if(iCol>-1) {
						rowEntity.editingCols.splice(iCol);
					}
				});
			};

			scope.esGridJerarquico = function () {
				//var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				return scope.pregunta.pregunta.sub_bucle == 1;
			};

			scope.getEntityMaster = function (id) {
				return scope.pregunta.respuestas.find(function (e) { return e.id == id; });
			};

			scope.eliminarIngrediente = function (entity, grid) {
				//var gridRows = grid.rows.map(function(e){return e.entity;});
				var gridRows = grid.data;
				var pos = gridRows.indexOf(entity);
				var ingredienteSiguiente = gridRows[pos + 1];
				if (!ingredienteSiguiente) {
					//No hay más ingredientes, por lo tanto es ingrediente único
					scope.deleteRow({ grid: grid, row: entity });
				}
				else {
					if (ingredienteSiguiente["$$treeLevel"] > entity["$$treeLevel"]) {

						ixWarningsService.warningConfirmacion(scope, "¡Atención!  Se eliminarán todos los subingredientes ¿Deseas confirmar?", scope.deleteRow, undefined, { grid: grid, row: entity });
					}
					else {
						scope.deleteRow({ grid: grid, row: entity });
					}
				}
			};

			scope.abrirPopupAlimentacion = function (entity, grid, isNew) {
				var entityOriginal = angular.copy(entity);

				var templateURL = "app/FTBonpreu/views/grid_jerarquico_bp_add_row_popup.html";
				var optionsPopup = { controller: "GridJerarquicoBonpreuAddRowPopupController" };
				var paramsPopup = { entity: entity, pregunta: scope.pregunta, isNew: isNew, modoTraduccion: scope.modoTraduccion, datos_grid: grid.data };

				if (scope.modoTraduccion) {
					paramsPopup.entityMaster = scope.getEntityMaster(entity.id);
				}

				if (angular.isDefined(grid)) {
					paramsPopup.rowsGrid = (isNew) ? grid.data : [];
					paramsPopup.grid = grid;
					grid.ixRefreshGridDropDowns();
				}

				ixUtilsService.openModalV2(templateURL, optionsPopup, "medium", paramsPopup).then(function (response) {
					if (angular.isDefined(response)) {
						if (!isNew) {
							var changes = ixGetPatchOperations(entityOriginal, entity);
							var tabla = (scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det";
							var pathParams = entity.id;
							if (scope.modoTraduccion)
								pathParams += "/" + scope.pregunta.respuestas_idioma[0].idioma;

							$http.put(cfg.baseURL + tabla + "/" + pathParams, changes).then(function (response) {
								if (scope.modoTraduccion) {
									entity.fecha_modif_valor = response.data.obj.Record.fecha_modif_valor;
									entity.fecha_modif_sub_respuesta1 = response.data.obj.Record.fecha_modif_sub_respuesta1;
									entity.fecha_modif_sub_respuesta2 = response.data.obj.Record.fecha_modif_sub_respuesta2;
									entity.fecha_modif_sub_respuesta3 = response.data.obj.Record.fecha_modif_sub_respuesta3;
									entity.fecha_modif_sub_respuesta4 = response.data.obj.Record.fecha_modif_sub_respuesta4;
									entity.fecha_modif_sub_respuesta5 = response.data.obj.Record.fecha_modif_sub_respuesta5;
									entity.fecha_modif_sub_respuesta6 = response.data.obj.Record.fecha_modif_sub_respuesta6;
									entity.fecha_modif_sub_respuesta7 = response.data.obj.Record.fecha_modif_sub_respuesta7;
									entity.fecha_modif_sub_respuesta8 = response.data.obj.Record.fecha_modif_sub_respuesta8;
								}
							}, function (err) {
								entity.sub_respuesta1 = entityOriginal.sub_respuesta1;
								entity.sub_respuesta2 = entityOriginal.sub_respuesta2;
								entity.sub_respuesta3 = entityOriginal.sub_respuesta3;
								entity.sub_respuesta4 = entityOriginal.sub_respuesta4;
								entity.sub_respuesta5 = entityOriginal.sub_respuesta5;
								entity.sub_respuesta6 = entityOriginal.sub_respuesta6;
								entity.sub_respuesta7 = entityOriginal.sub_respuesta7;
								entity.sub_respuesta8 = entityOriginal.sub_respuesta8;
								ixStatusService.setResponse(err);
							});
							if (angular.isDefined(grid) && entity.valor!=entityOriginal.valor) {
								// Si cambia el valor debemos repintar la tabla entera porque sino no se refresca (no es editable)
								grid.ixRefreshGridDropDowns();
								//grid.visible = false;
								$timeout(function () {
									grid.gridApi.core.refresh();
									//grid.visible = true;
									//scope.buildGrid(grid.data, grid.gridProperty);
								}, 300);
							}
						}
					} else {
						scope.actualizarRespuestas(grid.data, grid.data[0].componente);
					}

					//Marcar la pregunta 845 para recargar.
					// if (cfg.appCliente == "EUROMADI"){
					// 	if (scope.pregunta.pregunta.id_pregunta == 767) {
					// 		scope.addToReload([845, 780]);
					// 	}
					// }
					if (cfg.appCliente == "BONPREU") {
						if (scope.pregunta.pregunta.id_pregunta == 5064) {
							scope.addToReload([5634, 5102]);
						}
						if (scope.pregunta.pregunta.id_pregunta == 5770) {
							scope.addToReload([5794, 5799]);
						}
					}
				});
			};

			scope.addToReload = function (listaPreguntas) {
				if (angular.isUndefined(scope.data.ToReload))
					scope.data.ToReload = {};

				angular.forEach(listaPreguntas, function (pregunta) {
					if (!scope.data.ToReload[pregunta])
						scope.data.ToReload[pregunta] = true;

				});
			};

			scope.addTreeLevel = function (respuestas) {
				angular.forEach(respuestas, function (respuesta) {
					respuesta["$$treeLevel"] = ((respuesta.orden_sub_bucle == 0) ? 0 : (!respuesta.orden_sub_sub_bucle) ? 1 : 2);
				});
			};

			scope.getCustomHint = function (row, col) {
				var respuestaOriginal = scope.pregunta.respuestas.find(function (e) { return e.id == row.entity.id; });
				if (angular.isDefined(respuestaOriginal))
					return respuestaOriginal[col.field];
				return "";
			};

			scope.changeCellValue = function (row, col, nuevoValor) {
				var respuesta = scope.pregunta.respuestas_idioma.find(function (e) { return e.id == row.entity.id; });
				respuesta[col.field] = nuevoValor;
			};

			scope.checkColState = function (row, col) {
				var estado = 0;

				//var respuestaOriginal = scope.pregunta.respuestas.find(function(e){ return e.id == row.entity.id});
				if (scope.pregunta.pregunta.traducible && col.field == "valor") {
					if (row.entity.fecha_modif_valor)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta1_traducible && col.field == "sub_respuesta1") {
					if (row.entity.fecha_modif_sub_respuesta1)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta2_traducible && col.field == "sub_respuesta2") {
					if (row.entity.fecha_modif_sub_respuesta2)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_PDT_APROVACION;
				}
				if (scope.pregunta.pregunta.sub_pregunta3_traducible && col.field == "sub_respuesta3") {
					if (row.entity.fecha_modif_sub_respuesta3)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta4_traducible && col.field == "sub_respuesta4") {
					if (row.entity.fecha_modif_sub_respuesta4)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta5_traducible && col.field == "sub_respuesta5") {
					if (row.entity.fecha_modif_sub_respuesta5)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta6_traducible && col.field == "sub_respuesta6") {
					if (row.entity.fecha_modif_sub_respuesta6)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta7_traducible && col.field == "sub_respuesta7") {
					if (row.entity.fecha_modif_sub_respuesta7)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta8_traducible && col.field == "sub_respuesta8") {
					if (row.entity.fecha_modif_sub_respuesta8)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				return estado;
			};

			scope.filtrarSoloPendientesTraduccion = function (respuestas) {
				var result = [];
				respuestas.forEach(function (respuesta) {
					//Devolver solo las que sean traducibles y que en master tengan valor pero en la traduccion no.
					var cumple = false;
					var configuracionPregunta = scope.pregunta.pregunta;
					var preguntaMaster = scope.pregunta.respuestas.find(function (e) { return e.id == respuesta.id });

					if (configuracionPregunta.traducible && (preguntaMaster.valor && !respuesta.valor))
						cumple = true;
					if (configuracionPregunta.sub_pregunta1_traducible && (preguntaMaster.sub_respuesta1 && !respuesta.sub_respuesta1))
						cumple = true;
					if (configuracionPregunta.sub_pregunta2_traducible && (preguntaMaster.sub_respuesta2 && !respuesta.sub_respuesta2))
						cumple = true;
					if (configuracionPregunta.sub_pregunta3_traducible && (preguntaMaster.sub_respuesta3 && !respuesta.sub_respuesta3))
						cumple = true;
					if (configuracionPregunta.sub_pregunta4_traducible && (preguntaMaster.sub_respuesta4 && !respuesta.sub_respuesta4))
						cumple = true;
					if (configuracionPregunta.sub_pregunta5_traducible && (preguntaMaster.sub_respuesta5 && !respuesta.sub_respuesta5))
						cumple = true;
					if (configuracionPregunta.sub_pregunta6_traducible && (preguntaMaster.sub_respuesta6 && !respuesta.sub_respuesta6))
						cumple = true;
					if (configuracionPregunta.sub_pregunta7_traducible && (preguntaMaster.sub_respuesta7 && !respuesta.sub_respuesta7))
						cumple = true;
					if (configuracionPregunta.sub_pregunta8_traducible && (preguntaMaster.sub_respuesta8 && !respuesta.sub_respuesta8))
						cumple = true;

					if (cumple)
						result.push(respuesta);
				});
				return result;
			};

			scope.buildGrid = function (respuestas, prop) {
				scope.gridManualLoad = true;
				//var prop = scope.getUniqueID(0);
				var gridName = prop;
				if (angular.isUndefined(prop)) {
					prop = scope.pregunta.pregunta.id_pregunta;
					if (scope.pregunta.pregunta.preguntar_componente) {
						if (angular.isUndefined(scope.contadorTablas)) {
							scope.contadorTablas = 0;
						}
						prop += "-" + scope.contadorTablas;
						scope.contadorTablas++;
					}
					gridName = "grid" + prop;
				}

				var metadata = scope.getFakeMetadata();
				if (!scope.data.grids) {
					scope.data.grids = {};
				}

				var strEl = "";

				if (!scope.data.grids[gridName]) {
					//scope.data.grids[gridName] = gridService.createGrid(scope, "testListado", {}, undefined);
					var lineasDefault = 3;
					if (angular.isDefined(respuestas)) {
						if (respuestas.length) {
							if (respuestas.length > 15)
								lineasDefault = 15;
							else
								lineasDefault = respuestas.length;
						}
					}

					var optionsGrid = { pruebaFT: true, checkboxTemplate: 'checkboxCellFT', minRowsToShow: lineasDefault,/* minRowsToShow: 100,*/ metadata: metadata, enableGridMenu: scope.tienePerfilAdminOProveedor(), isRowSelectable: scope.isRowSelectable, onCellEdit: ((!scope.preview) ? scope.guardarDatosGrid : undefined) };

					if (scope.modoTraduccion) {
						optionsGrid.rowTemplate = 'app/FTBase/views/ui-grid-row-ft.html';
						optionsGrid.checkColState = scope.checkColState;
						optionsGrid.getCustomHint = scope.getCustomHint;
					}

					var acciones = [];

					if (scope.tienePerfilAdmin()) {
						acciones.push({
							icon: "fa-lock",
							title: $translate.instant("Desbloquear"),
							visible: function (entity) {
								return scope.tienePerfilAdmin() && entity.bloqueado;
							},
							accion: function (entity) {
								entity.bloqueado = scope.switchBloqueado(entity.bloqueado);
								scope.changeLockGrid(entity);
							}
						});
						acciones.push({
							icon: "fa-unlock",
							title: $translate.instant("Bloquear"),
							visible: function (entity) {
								return scope.tienePerfilAdmin() && !entity.bloqueado;
							},
							accion: function (entity) {
								entity.bloqueado = scope.switchBloqueado(entity.bloqueado);
								scope.changeLockGrid(entity);
							}
						});
					}
					if (scope.esGridJerarquico()) {
						optionsGrid.enableCellEdit = !scope.tienePerfilRestringido();
						optionsGrid.keepFocusOnAddRow = true;
						var columnValor = optionsGrid.metadata.find(function (e) { return e.Name == "valor"; });
						columnValor.NoEditable = true;
						optionsGrid.showTreeExpandNoChildren = false;
						optionsGrid.afterDragRow = function (grid, item, from, to) {
							var nextItem = null;
							var bulkParam = {
								ToInsert: [],
								ToUpdate: [],
								ToDelete: []
							};

							var contador_primer_nivel = 1;
							var contador_segundo_nivel = 1;
							var contador_tercer_nivel = 1;

							angular.forEach(grid.data, function (row) {

								row.orden_bucle = contador_primer_nivel;
								var update = {
									PK: grid.buildPK(row),
									PocoToUpdate: [
										{
											value: row.orden_bucle,
											path: "/orden_bucle",
											op: "replace"
										}
									]
								}

								if (row["$$treeLevel"] == 0) {
									contador_primer_nivel++;
									if (contador_segundo_nivel > 1)
										contador_segundo_nivel = 1;
									if (contador_tercer_nivel > 1)
										contador_tercer_nivel = 1;
								}
								else if (row["$$treeLevel"] == 1) {
									row.orden_bucle--;
									row.orden_sub_bucle = contador_segundo_nivel;
									row.orden_tab = row.orden_sub_bucle;
									update.PocoToUpdate = [{ value: row.orden_bucle, path: "/orden_bucle", op: "replace" }, { value: row.orden_sub_bucle, path: "/orden_tab", op: "replace" }];
									contador_segundo_nivel++;
									if (contador_tercer_nivel > 1)
										contador_tercer_nivel = 1;
								}
								else {
									//row.orden_sub_bucle--;
									row.orden_bucle--;
									row.orden_sub_bucle = (contador_segundo_nivel - 1);
									row.orden_tab = row.orden_sub_bucle;
									row.orden_sub_sub_bucle = contador_tercer_nivel;
									row.orden_tab2 = row.orden_sub_sub_bucle;
									update.PocoToUpdate = [{ value: row.orden_bucle, path: "/orden_bucle", op: "replace" }, { value: row.orden_sub_bucle, path: "/orden_tab", op: "replace" }, { value: row.orden_sub_sub_bucle, path: "/orden_tab2", op: "replace" }];
									contador_tercer_nivel++;
								}

								bulkParam.ToUpdate.push(update);
							});

							var tabla = (scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det";

							$http.post(cfg.baseURL + tabla + "/UpdateBulk", bulkParam).then(function (response) {
								$log.log("After update bulk respuestas", response, respuestas);
							}, function (err) {
								$log.error("Error actualizando el orden de los ingredientes", err);
							});

						};

						if (scope.modoTraduccion)
							optionsGrid.rowTemplate = "app/FTBase/views/ui-grid-tree-row-traduccion.html";
						else
							optionsGrid.rowTemplate = "app/base/views/grid/ui-grid-tree-row.html";

						//Hacer push en acciones sólo para perfiles que pueden editar
						if (!scope.tienePerfilRestringido()) {
							acciones.push({
								icon: "fa-sort",
								title: $translate.instant("Ordenar filas"),
								visible: function (entity) {
									return !scope.modoTraduccion && scope.status.editing && !entity.bloqueado;
								},
								accion: function (entity) { return true; }
							});
							acciones.push({
								icon: "fa-pencil",
								title: $translate.instant("Editar"),
								visible: function (entity) {
									return (scope.status.editing && !entity.bloqueado) || (scope.status.editing && scope.modoTraduccion);
								},
								accion: function (entity, grid) {
									scope.abrirPopupAlimentacion(entity, grid.options);
								}
							});
							acciones.push({
								icon: "fa-trash",
								title: $translate.instant("Eliminar"),
								visible: function (entity) {
									return (scope.status.editing && !entity.bloqueado && !scope.modoTraduccion);
								},
								accion: function (entity) {
									scope.eliminarIngrediente(entity, scope.data.grids[gridName]);
								}
							});
						}

						scope.addTreeLevel(respuestas);
					}

					scope.data.grids[gridName] = gridService.createGrid(scope, 'ft_preguntagrid_' + scope.pregunta.pregunta.id_pregunta, optionsGrid);
					scope.data.grids[gridName].gridProperty = gridName;

					scope.data.grids[gridName].entity = "extranet_fichas_tecnicas_det";
					scope.data.grids[gridName].filtroExterno = [{ Field: "id_pregunta", Operator: CMP_EQ, Value: scope.pregunta.pregunta.id_pregunta }, { Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: scope.pregunta.respuestas[0].id_ficha_tecnica }];

					scope.data.grids[gridName].columnDefs = [];
					scope.data.grids[gridName].ixGetColsFromAPI();


					if (acciones.length > 0)
						scope.data.grids[gridName].drawExtraColumns([{ name: $translate.instant('Acciones'), type: 'detalle', allowCellFocus: false, width: 100, acciones: acciones }]);

				} else {
					scope.data.grids[gridName] = gridService.createGridFunctions(scope, scope.data.grids[gridName]);
					scope.data.grids[gridName].ixRestoreConfig();
				}
				
				// Bloqueamos la edición si hay alguna request peindiente en esa fila para la misma columna
				scope.data.grids[gridName].cellEditableCondition = function (cell) {
					if (cell.row.entity.bloqueado || (cell.row.entity.editingCols && cell.row.entity.editingCols.indexOf(cell.col.colDef.name)>=0)) {
						return false;
					}
					else {
						return !((typeof(cell.col.colDef.noeditable) == "function") ? cell.col.colDef.noeditable(cell) : cell.col.colDef.noeditable);
					}
				}


				if (scope.modoTraduccion && scope.soloPreguntasPdtTraduccion) {
					respuestas = scope.filtrarSoloPendientesTraduccion(respuestas);
				}

				if (respuestas.length > 0) {
					if (scope.data.grids[gridName].reloadData || ((angular.isDefined(scope.data.ToReload)) && scope.data.ToReload[scope.pregunta.pregunta.id_pregunta]))
						scope.data.grids[gridName].ixLoadInitialData().then(function (data) {
							scope.pregunta.respuestas = angular.copy(data);
							scope.data.grids[gridName].reloadData = false;
							if (scope.data.ToReload) {
								if (scope.data.ToReload[scope.pregunta.pregunta.id_pregunta])
									scope.data.ToReload[scope.pregunta.pregunta.id_pregunta] = false;
							}
						});
					else
						scope.data.grids[gridName].data = respuestas.sort(function (a, b) {
							if (a.orden_bucle > b.orden_bucle) return 1;
							if (a.orden_bucle < b.orden_bucle) return -1;
							if (a.orden_sub_bucle > b.orden_sub_bucle) return 1;
							if (a.orden_sub_bucle < b.orden_sub_bucle) return -1;
							if (a.orden_sub_sub_bucle > b.orden_sub_sub_bucle) return 1;
							if (a.orden_sub_sub_bucle < b.orden_sub_sub_bucle) return -1;
							return 0;
						});

					if (scope.esGridJerarquico())
						scope.data.grids[gridName].ixRefreshGridDropDowns();

					ixUtilsService.showGrid(scope.data.grids[gridName]);

					var pregunta = "";

					// if (scope.modoTraduccion) {
					// 	pregunta = scope.pregunta.pregunta_idioma.pregunta || scope.pregunta.pregunta_idioma.pregunta_formulario || scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					// }
					// else {
					// 	pregunta = scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					// }
					//En scope.pregunta.pregunta tendremos siempre las preguntas con el idioma seleccionado por el usuario
					pregunta = scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;

					if (respuestas[0].componente)
						strEl += '<div ng-if="elComponenteEsVisible(\'' + respuestas[0].componente + '\')">';

					if ((!scope.modoTraduccion) && scope.pregunta.pregunta.ayuda_pregunta)
						strEl += '<span ix-hint="' + scope.textWithQuotes(scope.pregunta.pregunta.ayuda_pregunta) + '">';
					else if ((scope.modoTraduccion) && scope.pregunta.pregunta_idioma.ayuda_pregunta)
						strEl += '<span ix-hint="' + scope.textWithQuotes(scope.pregunta.pregunta_idioma.ayuda_pregunta) + '">';
					else
						strEl += '<span>';

					strEl += '<label>' + pregunta + ((scope.pregunta.pregunta.obligatoria) ? '<i class="fa fa-asterisk" style="color:red"></i>' : '') + '</label>';
					strEl += '</span>';

					strEl += '<div class="btn-toolbar" style="display:inline-block;float:right;">';

					//botones add/remove
					if (!scope.pregunta.pregunta.bloquear_borrar_b && !scope.esGridJerarquico())
						strEl += '<button style="padding: 3px 6px; margin: 0;" class="btn btn-danger pull-right" role="button" data-ng-show="status.editing && !respuestasBloqueadas()" data-ng-disabled="data.grids[\'' + gridName + '\'].gridApi.selection.getSelectedRows().length==0 || tienePerfilRestringido() || (modoTraduccion)" data-ng-click="deleteSelectedRows(data.grids[\'' + gridName + '\'])" uib-tooltip="{{ \'Eliminar registros seleccionados\' }}" translate-attr="uibTooltip" style=""><i class="fa fa-trash-o"></i></button>';

					if (!scope.pregunta.pregunta.bloquear_insert_b)
						strEl += '<button style="padding: 3px 6px; margin: 0;" class="btn btn-primary pull-right" role="button" data-ng-show="status.editing && !respuestasBloqueadas()" data-ng-disabled="tienePerfilRestringido() || (modoTraduccion)" data-ng-click="addRow(data.grids[\'' + gridName + '\'])" uib-tooltip="{{ \'Nuevo\' }}" translate-attr="uibTooltip" style=""><i class="fa fa-plus"></i></button>';

					//grid html
					scope.data.grids[gridName].visible = true;

					// Establecemos el numdero de filas visibles igual a los datos que se mostrarán, para que no haya scroll en el grid.
					scope.data.grids[gridName].minRowsToShow= Math.max(scope.data.grids[gridName].data.length, 3) + 1;

					var styleHeight = "";

					// 3.2/3.11 COMPOSICION - Ingredientes : mostrar el grid a pantalla completa
					if(scope.pregunta.pregunta.id_pregunta==5064  
						|| scope.pregunta.pregunta.id_pregunta==5215
						|| scope.pregunta.pregunta.id_pregunta==5293
						|| scope.pregunta.pregunta.id_pregunta==5386
						|| scope.pregunta.pregunta.id_pregunta==5770
						|| scope.pregunta.pregunta.id_pregunta==8263
					) {  
						styleHeight = 'style="height: calc(100vh - 350px)"';
					}

					if (scope.esGridJerarquico())
						strEl += '</div><div ng-if="data.grids[\'' + gridName + '\'].visible" class="ui-grid" data-ui-grid="data.grids[\'' + gridName + '\']" '+styleHeight+' data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-validate data-ui-grid-tree-view ui-grid-draggable-rows ui-grid-clipboard data-ui-grid-exporter><div class="grid-loading" ng-if="data.grids[\'' + gridName + '\'].ixIsLoading"><a><i class="fa fa-circle-o-notch fa-spin"></i></a></div></div>';
					else
						strEl += '</div><div class="ui-grid" data-ui-grid="data.grids[\'' + gridName + '\']" '+styleHeight+' data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-validate ui-grid-clipboard data-ui-grid-exporter><div class="grid-loading" ng-if="data.grids[\'' + gridName + '\'].ixIsLoading"><a><i class="fa fa-circle-o-notch fa-spin"></i></a></div></div>';

					if (respuestas[0].componente)
						strEl += '</div>';

					/*} else {
						scope.data.grids[gridName] = gridService.createGridFunctions(scope, scope.data.grids[gridName]);
						//scope.data.grids[gridName].ixRestoreConfig();
					}
					*/

					if (scope.esGridJerarquico()) {
						$timeout(function () {
							scope.data.grids[gridName].ixEditar();
						}, 0);
					}

				}

				scope.se_puede_visualizar = true;

				var el = $compile(strEl)(scope);
				return el;
			};

			scope.respuestasBloqueadas = function () {
				var respuestasBloqueadas = scope.pregunta.respuestas.filter(function (e) { return e.bloqueado; });
				return (scope.pregunta.respuestas.length == respuestasBloqueadas.length);
			};

			scope.actualizarRespuestas = function (data, componente) {
				if (scope.pregunta.pregunta.preguntar_componente) {
					//TODO: Coger todas las preguntas del componente.

					var respuestasComponente = scope.pregunta.respuestas.filter(function (e) { return e.componente == componente; });
					if (respuestasComponente.length > 0) {
						var primerItemIdx = scope.pregunta.respuestas.indexOf(respuestasComponente[0]);
						scope.pregunta.respuestas.splice(primerItemIdx, respuestasComponente.length);

						for (var i = (data.length - 1); i >= 0; i--) {
							scope.pregunta.respuestas.splice(primerItemIdx, 0, data[i]);
						}

					} else {
						scope.pregunta.respuestas.push.apply(scope.pregunta.respuestas, data);
					}

				}
				else
					scope.pregunta.respuestas = data;
			};

			scope.actualizarGrids = function (idPregunta, componente) {
				var keyGrids = Object.keys(scope.data.grids).filter(function (e) { return e.indexOf("grid" + idPregunta + "-") != -1; });

				if (angular.isDefined(componente)) {
					//Dejar en keyGrids solo elemento con el ID que toque.
					keyGrids = keyGrids.filter(function (elem) {
						return scope.data.grids[elem].data[0].componente == componente
					});
				}
				angular.forEach(keyGrids, function (keyGrid) {
					var componenteIdx = undefined;
					if (keyGrid.lastIndexOf("-") != -1)
						componenteIdx = keyGrid.substr(keyGrid.lastIndexOf("-") + 1);

					var grid = scope.data.grids[keyGrid];
					if (angular.isDefined(grid)) {
						grid.reloadData = true;
						//grid.data = [];


						if (componenteIdx) {
							var fComponente = grid.filtroExterno.find(function (e) { return e.Field == "componente"; });
							if (angular.isUndefined(fComponente))
								grid.filtroExterno.push({ Field: "componente", Operator: CMP_EQ, Value: scope.$parent.componentesRespuestas[componenteIdx].nombre });
						}

						grid.ixLoadInitialData().then(function (data) {
							var componente = undefined;
							if (scope.$parent.componentesRespuestas && componenteIdx)
								componente = scope.$parent.componentesRespuestas[componenteIdx];

							scope.actualizarRespuestas(angular.copy(data), componente);
						});
					}
				});
			};

			scope.addRow = function (grid) {
				if (!scope.preview) {
					var data = {
						id_ficha_tecnica: scope.pregunta.respuestas[0].id_ficha_tecnica,
						id_pregunta: scope.pregunta.pregunta.id_pregunta,
						// componente: scope.pregunta.respuestas[0].componente//Se tendrá que poner el componente en el grid, para recuperarlo.
						componente: grid.data[0].componente
					};

					if (scope.esGridJerarquico()) {
						scope.abrirPopupAlimentacion(data, grid, true);
					}
					else {
						$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det", data).then(function (response) {
							grid.ixAddRow(response.data.obj.Record);
							//YVES: ¿Como Copiar datos recibidos?
							scope.actualizarRespuestas(grid.data, data.componente);
							//scope.pregunta.respuestas = grid.data;
							$timeout(function () {
								grid.gridApi.core.refresh();
							}, 300);
						}, function (err) {
							ixStatusService.setResponse(err);
						});
					}
				} else {
					grid.ixAddRow();
				}
			};

			scope.deleteRow = function (param) {
				var row = param.row;
				var grid = param.grid;
				if (!scope.preview) {
					var bulkParam = {
						ToInsert: [],
						ToUpdate: [],
						ToDelete: [row]
					};

					//$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/UpdateBulk", bulkParam).then(function (response) {
					$http.delete(cfg.baseURL + "extranet_fichas_tecnicas_det/" + row.id).then(function (response) {
						var indexDeletedRow = grid.data.indexOf(row);
						if (indexDeletedRow != grid.data.length - 1) {
							if (row["$$treeLevel"] == 0) {
								var subingredientes = grid.data.filter(function (e) { return (e["$$treeLevel"] == 1 && e.orden_bucle == row.orden_bucle && e.orden_sub_bucle > 0 && e.componente == row.componente) });
								grid.data.splice(indexDeletedRow, subingredientes.length + 1);
								grid.data.forEach(function (e) {
									if (grid.data.indexOf(e) >= indexDeletedRow) e.orden_bucle--;
								});
							}
							else if (row["$$treeLevel"] == 1) {
								var subsubingredientes = grid.data.filter(function (e) { return (e["$$treeLevel"] == 2 && e.orden_bucle == row.orden_bucle && e.orden_sub_bucle == row.orden_sub_bucle && e.orden_sub_sub_bucle > 0 && e.componente == row.componente) });
								grid.data.splice(indexDeletedRow, subsubingredientes.length + 1);
								grid.data.forEach(function (e) {
									if (grid.data.indexOf(e) >= indexDeletedRow && e.orden_bucle == row.orden_bucle) {
										if (angular.isDefined(e.orden_tab)) {
											e.orden_tab--;
											e.orden_sub_bucle = e.orden_tab;
										}
										if (angular.isDefined(e.orden_sub_bucle)) {
											e.orden_sub_bucle--;
											e.orden_tab = e.orden_sub_bucle;
										}
									}
								});
							}
							else { //row.$$treeLevel == 2
								grid.data.splice(indexDeletedRow, 1);
								grid.data.forEach(function (e) {
									if (grid.data.indexOf(e) >= indexDeletedRow && e.orden_bucle == row.orden_bucle && ((e.orden_sub_bucle == row.orden_sub_bucle) || (e.orden_tab == row.orden_tab2))) {
										if (angular.isDefined(e.orden_tab2)) {
											e.orden_tab2--;
											e.orden_sub_sub_bucle = e.orden_tab2;
										}
										if (angular.isDefined(e.orden_sub_sub_bucle)) {
											e.orden_sub_sub_bucle--;
											e.orden_tab2 = e.orden_sub_sub_bucle;
										}
									}
								});
							}
						}
						else {
							grid.data.splice(indexDeletedRow, 1);
						}

						if (grid.data.length == 0) {
							grid.ixLoadInitialData().then(function (data) {
								scope.pregunta.respuestas = angular.copy(data);
							});
						} else {
							//scope.pregunta.respuestas = grid.data;
							scope.actualizarRespuestas(grid.data, grid.data[0].componente)
						}
					}, function (err) {
						ixStatusService.setResponse(err);
					});
				} else {
					grid.ixDeleteSelectedRows();
				}

			};


			scope.deleteSelectedRows = function (grid) {
				if (!scope.preview) {
					var bulkParam = {
						ToInsert: [],
						ToUpdate: [],
						ToDelete: grid.gridApi.selection.getSelectedRows()
					};

					$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/UpdateBulk", bulkParam).then(function (response) {
						grid.ixDeleteSelectedRows();

						if (grid.data.length == 0) {
							//							grid.entity = "extranet_fichas_tecnicas_det";
							//							grid.filtroExterno = [{ Field: "id_pregunta", Operator: CMP_EQ, Value: scope.pregunta.pregunta.id_pregunta }, { Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: scope.pregunta.respuestas[0].id_ficha_tecnica } ];
							grid.ixLoadInitialData().then(function (data) {
								scope.pregunta.respuestas = angular.copy(data);
							});
						} else {
							//scope.pregunta.respuestas = grid.data;
							scope.actualizarRespuestas(grid.data, grid.data[0].componente)
						}
					}, function (err) {
						ixStatusService.setResponse(err);
					});
				} else {
					grid.ixDeleteSelectedRows();
				}
			};

			//GRID FIN

			//FUNCIONES POR COMPONENTES
			scope.showDetails = function (evt) {
				var textoComponenteClick = evt.target.innerHTML;

				scope.$parent.componentesRespuestas.forEach(function (panel) {
					panel.visible = false;
				});

				var panelComponente = scope.$parent.componentesRespuestas.find(function (e) { return e.nombre == textoComponenteClick; });

				var contentTarget = angular.element(evt.currentTarget).parent().find("div.content");
				if (contentTarget.hasClass("visible")) {
					contentTarget.removeClass("visible");
					panelComponente.visible = false;
				}
				else {
					angular.element(angular.element(angular.element(evt.currentTarget).parent()).parent()).children().children().removeClass("visible");
					contentTarget.addClass("visible");
					panelComponente.visible = true;
				}
			};
			//FIN FUNCIONES POR COMPONENTES

			scope.getComponentesRespuestas = function () {
				if (angular.isUndefined(scope.pregunta.panelesComponentes)) {
					scope.pregunta.panelesComponentes = [];
				}
				angular.forEach(scope.pregunta.respuestas, function (respuesta, idx) {
					var existe = scope.pregunta.panelesComponentes.find(function (e) { return e.nombre == respuesta.componente; });
					if (angular.isUndefined(existe)) {
						var panelComponente = { nombre: respuesta.componente, visible: ((idx == 0) ? true : false) };
						scope.pregunta.panelesComponentes.push(panelComponente);
					}
				});

				return scope.pregunta.panelesComponentes;
			};

			scope.elComponenteEsVisible = function (nombre) {
				var esVisible = false;

				if (angular.isDefined(scope.$parent.componentesRespuestas)) {
					var componente = scope.$parent.componentesRespuestas.find(function (e) { return e.nombre == nombre; });
					esVisible = componente.visible;
				}
				return esVisible;
			};

			scope.createPanels = function () {
				scope.$parent.componentesRespuestas = scope.getComponentesRespuestas();

				angular.forEach(scope.$parent.componentesRespuestas, function (componente, idx) {
					var accordion = "";
					if (scope.preview) {
						accordion = '<div class="card"><div class="title" ng-click="showDetails($event)">Componente A</div><div class="content detalles"></div></div>';
						elem.append($compile(accordion)(scope));

					} else if (angular.element(scope.$parent.getContainerElement()).find("div#componente" + scope.quitarespacios(componente.nombre)).length == 0) {
						//Creamos el accordion cuando no exista.
						accordion = '<div id="componente' + scope.quitarespacios(componente.nombre) + '" class="card"><div class="title" ng-click="showDetails($event)">' + componente.nombre + '</div><div class="content detalles';
						if (idx == 0)
							accordion += ' visible';

						accordion += '"><div></div></div></div>';
						elem.append($compile(accordion)(scope));
					}
				});
			};

			scope.quitarespacios = function (componente) {
				var remplazado = componente.split(" ").join("_").split(".").join("_");

				return remplazado;
			};

			scope.divComponente = function () {
				//return "div.content";
				return "div.content > div";
			};

			scope.createPreguntas = function (elem) {

				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";

				if (scope.pregunta.pregunta.preguntar_componente) {
					angular.forEach(scope.$parent.componentesRespuestas, function (componente) {
						var containerComponent;
						if (scope.preview)
							containerComponent = elem.find("div.card > " + scope.divComponente());
						else
							if (angular.element(elem).find("div#componente" + scope.quitarespacios(componente.nombre)).length == 1)
								containerComponent = angular.element(elem).find("div#componente" + scope.quitarespacios(componente.nombre) + " > " + scope.divComponente());
							else if (angular.element(scope.$parent.getContainerElement()).find("div#componente" + scope.quitarespacios(componente.nombre)).length == 1)
								containerComponent = angular.element(scope.$parent.getContainerElement()).find("div#componente" + scope.quitarespacios(componente.nombre) + " > " + scope.divComponente());

						if (angular.isUndefined(scope.pregunta.respuestasComponentes))
							scope.pregunta.respuestasComponentes = {};

						var respuestasComponente = scope.pregunta[respuestasProperty].filter(function (e) { return e.componente == componente.nombre; });

						if (scope.modoTraduccion) {
							//Estamos en un grid, si la columna no es traducible, mostaremos el valor original.
							respuestasComponente = scope.rellenarNoTraducibles(respuestasComponente);
						}

						scope.pregunta.respuestasComponentes[componente.nombre] = respuestasComponente;

						scope.createPregunta(scope.pregunta.respuestasComponentes[componente.nombre], containerComponent);
					});
					scope.createPreviewComponentes();
				} else {
					if (scope.modoTraduccion && scope.pregunta.pregunta.bucle == 1) {
						scope.pregunta.respuestas_idioma = scope.rellenarNoTraducibles(scope.pregunta.respuestas_idioma);
					}
					scope.createPregunta(scope.pregunta[respuestasProperty], elem);
				}
			};

			scope.rellenarNoTraducibles = function (respuestasComponente) {
				angular.forEach(respuestasComponente, function (respuesta) {

					var respuesta_original = scope.pregunta.respuestas.find(function (e) { return e.id == respuesta.id; });

					if (!respuesta.valor && !scope.pregunta.pregunta.traducible) {
						respuesta.valor = respuesta_original.valor;
					}
					if (!respuesta.sub_respuesta1 && !scope.pregunta.pregunta.sub_pregunta1_traducible) {
						respuesta.sub_respuesta1 = respuesta_original.sub_respuesta1;
					}
					if (!respuesta.sub_respuesta2 && !scope.pregunta.pregunta.sub_pregunta2_traducible) {
						respuesta.sub_respuesta2 = respuesta_original.sub_respuesta2;
					}
					if (!respuesta.sub_respuesta3 && !scope.pregunta.pregunta.sub_pregunta3_traducible) {
						respuesta.sub_respuesta3 = respuesta_original.sub_respuesta3;
					}
					if (!respuesta.sub_respuesta4 && !scope.pregunta.pregunta.sub_pregunta4_traducible) {
						respuesta.sub_respuesta4 = respuesta_original.sub_respuesta4;
					}
					if (!respuesta.sub_respuesta5 && !scope.pregunta.pregunta.sub_pregunta5_traducible) {
						respuesta.sub_respuesta5 = respuesta_original.sub_respuesta5;
					}
					if (!respuesta.sub_respuesta6 && !scope.pregunta.pregunta.sub_pregunta6_traducible) {
						respuesta.sub_respuesta6 = respuesta_original.sub_respuesta6;
					}
					if (!respuesta.sub_respuesta7 && !scope.pregunta.pregunta.sub_pregunta7_traducible) {
						respuesta.sub_respuesta7 = respuesta_original.sub_respuesta7;
					}
					if (!respuesta.sub_respuesta8 && !scope.pregunta.pregunta.sub_pregunta8_traducible) {
						respuesta.sub_respuesta8 = respuesta_original.sub_respuesta8;
					}
				});
				return respuestasComponente;
			}

			/*
			scope.agregarPropiedadesNecesariasComponente = function(trad, original){
				trad.orden_bucle = original.orden_bucle;
				trad.orden_sub_bucle = original.orden_sub_bucle;
				trad.orden_sub_sub_bucle = original.orden_sub_sub_bucle;
				trad.componente = original.componente;
			};
			*/

			scope.createPreviewComponentes = function () {
				if (scope.preview && scope.pregunta.pregunta.preguntar_componente) {
					scope.componentesCount = 1;
					elem = elem.parent().parent();

					var accordion = '<div class="card"><div class="title" ng-click="showDetails($event)">Componente B</div><div class="content detalles"></div></div>';
					elem.append($compile(accordion)(scope));
					elem = elem.find("div.card > " + scope.divComponente()).eq(scope.componentesCount);

					if (scope.pregunta.pregunta.bucle) {
						elem.append(scope.buildGrid());
					} else {
						if (scope.pregunta.pregunta.tiene_imagen)
							elem.append(scope.buildControlImg(0));
						else
							elem.append(scope.buildControl());
					}
					if (scope.pregunta.pregunta.preguntar_obs) {
						elem.append(scope.buildControlObs());
					}
				}

				if (scope.preview && scope.pregunta.pregunta.preguntar_componente) {
					scope.componentesCount = 2;
					elem = elem.parent().parent();

					accordion = '<div class="card"><div class="title" ng-click="showDetails($event)">Componente C</div><div class="content detalles"></div></div>';
					elem.append($compile(accordion)(scope));
					elem = elem.find("div.card > " + scope.divComponente()).eq(scope.componentesCount);

					if (scope.pregunta.pregunta.bucle) {
						elem.append(scope.buildGrid());
					} else {
						if (scope.pregunta.pregunta.tiene_imagen)
							elem.append(scope.buildControlImg(0));
						else
							elem.append(scope.buildControl());
					}
					if (scope.pregunta.pregunta.preguntar_obs) {
						elem.append(scope.buildControlObs());
					}
				}
			};

			scope.switchBloqueado = function (bloqueado) {
				if (bloqueado)
					bloqueado = 0;
				else
					bloqueado = 1;
				return bloqueado;
			};

			scope.changeLock = function () {

				scope.pregunta.respuestas[0].bloqueado = scope.switchBloqueado(scope.pregunta.respuestas[0].bloqueado);
				var data = [
					{
						op: "replace",
						path: "/bloqueado",
						value: scope.pregunta.respuestas[0].bloqueado
					}
				];
				$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/" + scope.pregunta.respuestas[0].id, data).then(function (response) {

				}, function (err) {
					scope.pregunta.respuestas[0].bloqueado = scope.switchBloqueado(scope.pregunta.respuestas[0].bloqueado);
				});
			};

			scope.changeLockGrid = function (entity) {
				var data = [
					{
						op: "replace",
						path: "/bloqueado",
						value: entity.bloqueado
					}
				];
				$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/" + entity.id, data).then(function (response) {

				}, function (err) {
					entity.bloqueado = scope.switchBloqueado(entity.bloqueado);
				});
			};

			scope.addAdjuntarFichero = function () {
				var lastDiv = elem.children("div").eq(elem.children("div").length - 1);
				if (lastDiv.find("div.form-group").length > 0)
					lastDiv = lastDiv.find("div.form-group");

				var strEl = '<a class="btn btn-primary" role="button" data-ng-click="openPopupFicheros(\'' + scope.pregunta.respuestas[0].id_ficha_tecnica + '\', \'ficheros_ft\')" uib-tooltip="{{ \'Subir fichero\' }}" tooltip-placement="bottom" translate-attr="uibTooltip" style=""><i class="fa fa-upload"></i></a>';
				var el = $compile(strEl)(scope);

				if (elem.children("div").length == 1 || (scope.num_subpreguntas > 0 || scope.pregunta.pregunta.preguntar_obs))
					lastDiv.append(el);
				else
					lastDiv.after(el);
			};

			scope.addDependenciaEtiquetado = function () {
				var lastDiv = elem.children("div").eq(elem.children("div").length - 1);
				if (lastDiv.find("div.form-group").length > 0)
					lastDiv = lastDiv.find("div.form-group");

				var strEl = '';

				if (scope.modoTraduccion) {
					var pregunta_formulario = scope.pregunta.pregunta_idioma.pregunta_formulario || scope.pregunta.pregunta.pregunta_formulario;
					strEl = '<button class="btn" ng-class="{ \'btn-primary\': pregunta.respuestas[0].contiene_info_etiquetado }" role="button" data-ng-disabled="tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[0].id) || (!pregunta.pregunta.traducible)" data-ng-click="openPopupDedependenciaEtiquetado(\'' + scope.pregunta.respuestas[0].id_ficha_tecnica + '\', ' + scope.pregunta.pregunta.id_pregunta + ', \'' + pregunta_formulario + '\', ' + scope.pregunta.pregunta.bloquear_valor_b + ',\'' + scope.pregunta.respuestas_idioma[0].idioma + '\')" uib-tooltip="{{ \'Dependencia etiquetado\' }}" tooltip-placement="bottom" translate-attr="uibTooltip" style=""><i class="fa fa-tag"></i></button>';
				}

				else
					strEl = '<button class="btn" ng-class="{ \'btn-primary\': pregunta.respuestas[0].contiene_info_etiquetado }" role="button" data-ng-disabled="tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[0].id)" data-ng-click="openPopupDedependenciaEtiquetado(\'' + scope.pregunta.respuestas[0].id_ficha_tecnica + '\', ' + scope.pregunta.pregunta.id_pregunta + ', \'' + scope.pregunta.pregunta.pregunta_formulario + '\', ' + scope.pregunta.pregunta.bloquear_valor_b + ')" uib-tooltip="{{ \'Dependencia etiquetado\' }}" tooltip-placement="bottom" translate-attr="uibTooltip" style=""><i class="fa fa-tag"></i></button>';

				var el = $compile(strEl)(scope);

				if (elem.children("div").length == 1 || (scope.num_subpreguntas > 0 || scope.pregunta.pregunta.preguntar_obs))
					lastDiv.append(el);
				else
					lastDiv.after(el);
			};

			scope.addLockAction = function (elem) {
				//El icono de bloquear/desbloquear lo pondremos al final de la pregunta.
				var lastDiv = elem.children("div").eq(elem.children("div").length - 1);
				if (lastDiv.find("div.form-group").length > 0)
					lastDiv = lastDiv.find("div.form-group");

				var strEl = "<i class='fa' ng-click='changeLock()' ng-attr-title='{{pregunta.pregunta.pregunta || pregunta.pregunta.pregunta_formulario}}' ng-class='{ \"fa-lock\": pregunta.respuestas[0].bloqueado, \"fa-unlock\": !pregunta.respuestas[0].bloqueado }' aria-hidden='true' ";

				strEl += " style='right: 5px;top: 6px;position: absolute;' ";

				strEl += "></i>";
				var el = $compile(strEl)(scope);
				lastDiv.append(el);
			};

			scope.tienePerfilAdmin = function () {
				return authService.tienePerfilAdmin() || authService.tienePerfilUserKey();
			};

			scope.tienePerfilAdminOProveedor = function () {
				var esProveedor = false;
				var perfilesUsuario = authService.perfilesUsuario();
				if (perfilesUsuario.indexOf("usr_proveedor") != -1) esProveedor = true;

				return authService.tienePerfilAdmin() || authService.tienePerfilUserKey() || esProveedor;
			};


			scope.tienePerfilRestringido = function () {
				var perfilRestringido = false;
				var perfilesUsuario = authService.perfilesUsuario();

				var perfilesRestringidos = ["usr_comprador", "usr_laboratorio", "usr_bp_consulta"];

				angular.forEach(perfilesUsuario, function (perfil) {
					if (perfilesRestringidos.indexOf(perfil) != -1)
						perfilRestringido = true;
				});

				return perfilRestringido;
			};

			scope.tieneLlamadasPendientes = function (idRespuesta, tag) {
				if(tag=="ix-select-ft") {
					return false; // Para los ix-select-ft no miramos si tiene llamadasPendientes para que no se haga un disabled, ya que le hace perder el focus y luego el ix-focus-out que graba el valor no se ejecuta
				}
				return authInterceptorService.tieneLlamadasPendientes(cfg.baseURL + "extranet_fichas_tecnicas_det/" + idRespuesta);
			};

			scope.createPregunta = function (respuestas, elem) {
				//&& scope.pregunta.pregunta.bucle == 0 (AGREGADO POR YVES)
				if (scope.hayQueRecargarPregunta()) {
					var param = buildIxSearch();
					param.Filters.push({ Field: "id_pregunta", Operator: CMP_EQ, Value: scope.pregunta.pregunta.id_pregunta });
					param.Filters.push({ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: scope.pregunta.respuestas[0].id_ficha_tecnica });

					$http.post(cfg.baseURL + "ft_data/GetRespuestas", param).then(function (response) {
						scope.pregunta.respuestas = response.data;
						if (angular.isDefined(respuestas))
							respuestas = scope.pregunta.respuestas;

						scope.montarControlPreguntas(respuestas, elem);
					});
				} else {
					scope.montarControlPreguntas(respuestas, elem);
				}
			};

			scope.hayQueRecargarPregunta = function () {
				var recargar = false;
				if (angular.isDefined(scope.data.ToReload)) {
					if (scope.data.ToReload[scope.pregunta.pregunta.id_pregunta])
						recargar = true;
				}
				return recargar;
			};

			scope.montarControlPreguntas = function (respuestas, elem) {
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
				if (scope.pregunta.pregunta.nota_pregunta) {
					if (scope.modoTraduccion)
						elem.append("<h5><b>" + scope.pregunta.pregunta_idioma.nota_pregunta + "</b></h5>");
					else
						elem.append("<h5><b>" + scope.pregunta.pregunta.nota_pregunta + "</b></h5>");
				}

				if (scope.pregunta.pregunta.bucle) {
					elem.append(scope.buildGrid(respuestas));
				} else {
					scope.num_subpreguntas = scope.cuentaSubPreguntas();
					scope.cuentaColMd = 0;
					angular.forEach(respuestas, function (respuesta) {
						var idx = scope.pregunta[respuestasProperty].indexOf(respuesta);

						if (!scope.inPopup) {
							if (scope.pregunta.pregunta.tiene_imagen)
								elem.append(scope.buildControlImg(idx));
							else
								elem.append(scope.buildControl(idx));
						}

						// if (scope.pregunta.pregunta.tiene_imagen)
						// 	elem.append(scope.buildControlImg(idx));

						if (scope.num_subpreguntas > 0) {
							scope.buildControlSubPreguntas(idx);
						}
					});
				}
				if (scope.pregunta.pregunta.preguntar_obs) {
					elem.append(scope.buildControlObs(0));
				}

				if (scope.pregunta.pregunta.adjuntar_fichero && !scope.preview)
					scope.addAdjuntarFichero();

				if (scope.pregunta.pregunta.dependencia_etiquetado && scope.se_puede_visualizar)
					scope.addDependenciaEtiquetado();

				if (!scope.pregunta.pregunta.bucle) {
					if (scope.tienePerfilAdmin() && !scope.inPopup && !scope.soloPreguntasPdtTraduccion)//Mirar si el usuario tiene perfil de ixnet y solo llamar la función si es así.
						scope.addLockAction(elem);
				}
			};

			//Creamos los controles necesarios:
			if (scope.pregunta.pregunta.preguntar_componente) {
				scope.createPanels();
			}
			scope.createPreguntas(elem);
		}
	}
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*eslint angular/window-service: 0*/
/*eslint angular/di: [2,"array"]*/
/*global angular */
/*global buildMenus */
/*global addToParamFilters */
/*global ACCION_EDITAR:true*/
/*global ACCION_EDITAR_POPUP:true*/
/*global CMP_EQ:true*/
/*global CMP_GT:true*/
/*global CMP_LT:true*/
/*global CMP_GTE:true*/
/*global CMP_LTE:true*/
/*global CMP_LIKER:true*/
/*global CMP_LIKEL:true*/
/*global CMP_LIKE:true */
/*global CMP_LIKENONE:true*/
/*global CMP_ISNULL:true*/
/*global NTPUSH_MANUAL:true*/
/*global NTPUSH_PLANTRAB:true*/
/*global NTPUSH_PLANCARGA:true*/
/*global DROPDOWN_CUSTOM_OPTION:true*/
/*global IxOperationModeBastidor:true*/
/*global convertDateStringsToDates*/
/*global skipValidationErrors*/
/*global deleteSkippedValidations*/
/*global showAngularStats*/
/*global saveAs*/
/*global ixMenuMoreFunction*/
/*global ixMenuMore*/
/*var gp4App = angular.module('gp4App', ['ng', 'ngAnimate', 'ui.bootstrap', 'ngRoute', 'textAngular', 'infinite-scroll', 'ivh.treeview', 'gp4Controllers', 'gp4Filters', 'gp4helpers', 'CostesEscala', 'Extranet', 'Global']);*/
(function() {
  angular.module('gp4App', ['ng', 'ngAnimate', 'ui.bootstrap', 'ngRoute', 'textAngular', 'infinite-scroll', 'ivh.treeview', 'ngScrollbars', 'gp4Controllers', 'gp4Filters', 'gp4helpers', 'pascalprecht.translate', 'angular-clipboard', 'angularBootstrapMaterial' ]);

  var translateProvider = null;
	
	ACCION_EDITAR = "EDITAR";
	ACCION_EDITAR_POPUP = "EDITAR_POPUP";

  CMP_EQ = 0;
  CMP_GT = 1;
  CMP_LT = 2;
  CMP_GTE = 3;
  CMP_LTE = 4;
  CMP_LIKER = 5;
  CMP_LIKEL = 6;
  CMP_LIKE = 7;
  CMP_LIKENONE = 8;
  CMP_ISNULL = 9;
	
	NTPUSH_MANUAL = 0;
	NTPUSH_PLANTRAB = 1;
	NTPUSH_PLANCARGA = 2;

	DROPDOWN_CUSTOM_OPTION = -1;

  IxOperationModeBastidor = {
    sinDefinir: 0,
    editarEntrada: 1,
    asignacion: 2,
    salida: 3,
    eliminarAsignacion: 4,
    eliminarSalida: 5,
    eliminarSalidaAsignacion: 6,
    planificarCarga: 7,
    noValidar: 8,
    editarBastidor: 9, 
    eliminarPuntoEntrega: 10, 
    editarSalida: 11, 
    asignarCamion: 12, 
    asignacion_destino_sec: 13
  };

  angular.module('gp4App').constant('k', {
    CMP: [{operator: 0, name: "Igual a", icon: "fa fa-fw flaticon-eq"},
          {operator: 1, name: "Superior a", icon: "fa fa-fw flaticon-gt"},
          {operator: 2, name: "Inferior a", icon: "fa fa-fw flaticon-lt"},
          {operator: 3, name: "Superior o igual a", icon: "fa fa-fw flaticon-gte"},
          {operator: 4, name: "Inferior o igual a", icon: "fa fa-fw flaticon-lte"},
          {operator: 5, name: "Empieza por", icon: "fa fa-fw flaticon-asterisk"},
          {operator: 6, name: "Contiene", icon: "fa fa-fw flaticon-asterisk"},
          {operator: 7, name: "Termina en", icon: "fa fa-fw flaticon-asterisk fa-rotate-90"},
          {operator: 8, name: "No contiene", icon: "fa fa-fw fa-exclamation"},
          {operator: 9, name: "Vacío", icon: "fa fa-fw fa-circle-o"},
          {operator: 10, name: "No Vacío", icon: "fa fa-fw fa-dot-circle-o"}
         ]
  });


  angular.module('gp4App').config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
    
    $routeProvider.when('/', { templateUrl: 'app/base/views/desktop.html', controller: 'DesktopController' })
      .when('/login', { templateUrl: 'app/base/views/login.html', controller: 'LoginController' })
      .when('/askEmail', { templateUrl: 'app/base/views/askEmail.html', controller: 'AskEmailController'})
      .when('/changePassword', { templateUrl: 'app/base/views/changePassword.html', controller: 'ChangePasswordController'})
			.when('/changePasswordCodigo', { templateUrl: 'app/base/views/changePasswordCodigoUser.html', controller: 'ChangePasswordCodigoUserController'})
      .when('/formularioAyuda', { templateUrl: 'app/base/views/formularioAyuda.html', controller: 'formularioAyudaController'})
      //Especiales de Administracion
      .when('/Administracion/:entity/list',{ templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/base/views"; } } })
      .when('/Administracion/api_usuarios/edit', { templateUrl: 'app/base/views/gridUsuarios.html', controller: 'GridUsuariosController'})
      .when('/Administracion/mis_listados_programados/edit', { templateUrl: 'app/base/views/gridEditor.html', controller: 'ListadosProgramadosListController',
                                                              resolve: {
                                                                entity: function($route){
                                                                  $route.current.params.entity = "listados_programados";
                                                                },
                                                                filterByUser: function($route){
                                                                  $route.current.params.filterByUser = true;
                                                                }
                                                              } })
      .when('/Administracion/listados_programados/edit', { templateUrl: 'app/base/views/listados_programados.html', controller: 'ListadosProgramadosListController',
                                                          resolve: {
                                                            entity: function($route){
                                                              $route.current.params.entity = "listados_programados";
                                                            },
                                                            filterByUser: function($route){
                                                              $route.current.params.filterByUser = false;
                                                            }
                                                          } })
      .when('/Administracion/api_traduction_msg/edit', { templateUrl: 'app/base/views/gridEditor.html', controller: 'GridTraduccionesController', resolve: { module: function($route){ $route.current.params.entity = "api_traduction_msg"; } } })
      .when('/Administracion/api_traduction_msg_gpmobile/edit', { templateUrl: 'app/base/views/gridEditor.html', controller: 'GridTraduccionesController', resolve: { module: function($route){ $route.current.params.entity = "api_traduction_msg_gpmobile"; } } })
      //Genericos
      .when('/Administracion/:entity/edit',{ templateUrl: 'app/base/views/gridEditor.html', controller: 'GridEditorController'})
      //.when('/api_usuarios/edit', { templateUrl: 'views/gridUsuarios.html', controller: 'GridUsuariosCtrl' })
      //.when('/:entity/edit', { templateUrl: 'views/gridEditor.html', controller: 'GridEditorCtrl' })
      //.when('/cliente/list', { templateUrl: 'views/clientes.html', controller: 'ClientesListCtrl' })
      //.when('/cliente/:id', { templateUrl: 'views/cliente.html', controller: 'ClienteCtrl' })
      //.when('/cliente', { templateUrl: 'views/cliente.html', controller: 'ClienteCtrl' })
      //.when('/marca/list', { templateUrl: 'views/marcas.html', controller: 'MarcasListCtrl' })
      //.when('/remvar', { templateUrl: 'remvar/process.html', controller: 'RemvarCtrl' })
      //.when('/:entity/list', { templateUrl: 'views/listEdit.html', controller: 'ListEditController' })
      //.when('/:entity/pivot', { templateUrl: 'views/pivot.html', controller: 'PivotCtrl' })
      //.when('/bastidores', { templateUrl: 'views/bastidores.html', controller: 'BastidoresListCtrl' })
      //.when('/bastidor/:grupo/:chasis/:movimiento', { templateUrl: 'views/bastidor.html', controller: 'BastidorCtrl' })
      .otherwise({redirectTo: '/'});
    $locationProvider.html5Mode(true).hashPrefix('!');
  }]);

  angular.module('gp4App').config(['$translateProvider', function ($translateProvider) {
    $translateProvider.useLoader('gp4TranslationsLoader');
    //$translateProvider.forceAsyncReload(true);
    $translateProvider.useSanitizeValueStrategy('sanitize');
    $translateProvider.useMissingTranslationHandler('gp4MissingTranslationHandler');
    $translateProvider.registerAvailableLanguageKeys(['es', 'ca', 'en', 'pt', 'es_EX', 'en_EX', 'ca_ES','fr'], {
      'es_EX': 'es_EX',
      'en_EX': 'en_EX',
      'ca_ES': 'ca_ES',
      'ca': 'es-ct',
			'pt_*': 'pt',
			'en_*': 'en',
			'fr_*': 'fr',
      '*': 'es'
    });
    var langKey = $translateProvider.determinePreferredLanguage();
    translateProvider = $translateProvider;
  }]);

  angular.module('gp4App').factory('gp4TranslationsLoader', ['$http','$q', 'cfg', 'authService', '$log', function gp4TranslationsLoaderFactory($http, $q, cfg,authService, $log) {
    return function (options) {
      authService.fillAuthData();
      var deferred = $q.defer();

      $log.log("FACTORY gp4TranslationsLoader",options, cfg);

      if(authService.authentication.isAuth) {
        /*var param = {
          Filters: [{Field:"idioma", Operator:CMP_EQ, Value:options.key}],
          OrderBy:[]
        };*/

        //$http.post(cfg.baseURL+'traduction_msg/Search?Page=1&ItemsPerPage=10000',param).then(function(response) {
        $http.get(cfg.baseURL+'api_traduction_msg/GetByLanguage?language='+options.key).then(function(response) {
          var tr = {};
          //response.data.Items.forEach(function(e){
          response.data.forEach(function(e){
            if(e.traduccion == "?"){
              tr[e.gestpark] = e.gestpark;
            } else {
              tr[e.gestpark] = e.traduccion;
            }

          });
          $log.log("Transltions",options.key,tr);
          deferred.resolve(tr);
        }).catch(function(e){
          $log.error("Error loading translations",options,e);
          deferred.reject(options.key);
        });
      } else {
        $log.log("not ready to load translations yet");
        deferred.reject(options.key);
      }

      return deferred.promise;
    };
  }]);

  angular.module('gp4App').factory('gp4MissingTranslationHandler', ['$http','cfg','$log','$translate',function gp4MissingTranslationHandlerFactory($http,cfg, $log, $translate) {
    return function(translationID, uses) {
        $log.log("add missing translation", translationID, uses);

        var translations = translateProvider.translations();
        translations[uses] = translations[uses] || {};
        translations[uses][translationID] = translationID;
        translateProvider.translations(translations);

        var missingEntry = {
            bd: cfg.bd,
            gestpark: translationID,
            idioma: uses,
            traduccion: "?"
        };

        $http.post(
            cfg.baseURL + 'api_traduction_msg/AddMissingTranslation',
            missingEntry
        );

        return translationID;
    };
  }]);

  angular.module('gp4App').factory('cfg',['$log', function cfgFactory($log) {
    //var stored = localStorage['gp4App.cfg'];
    var stored = sessionStorage['gp4App.cfg'];
    if(stored) {
			$log.log("Restoring cfg from session",stored);
			return angular.fromJson(stored);
    } else {
      $log.log("No cfg stored in session");
      return  {
				appURL: null,
        baseURL: null,
				modules: null,
        baseAuthURL: null,
        clientId: null,  // used in refresh_token
        pageSize: null,
        httpTimeout: null,
        logApiCalls: null,  // escribe por consola las request i responses de la api
        dateFormat: null,
        timeDiff: null
      };
    }
  }]);

	angular.module('gp4App').factory('ixReportURL',['$log', 'cfg', function ixReportURLFactory($log, cfg) {
		return  {
			//TODO: Anar omplint amb tots els impresos de la aplicació i defecte false.
			ALBARAN_SALIDA: false,
			ALBARAN_TRASLADO: false,
			IMPRESO_TALLER: false,

			getURL: function(report){
				var url = "impresos";
				if(this[report])
					return url + cfg.proyectoId;
				return url;
			}
		};
  }]);
	
  angular.module('gp4App').factory('ixAppScripts',['$log', function ixAppScriptsFactory($log){
		return {
			values: []
		};
	}]);

	angular.module('gp4App').factory('ixEdicionViajePopup',['$log', function ixEdicionViajePopupFactory($log){
		return {
			controladorExtra: ""
		};
	}]);
	
  angular.module('gp4App').factory('ixDatosCargaPopup',['$log', function ixDatosCargaPopupFactory($log){
		return {
			controladorExtra: ""
		};
	}]);
	
	angular.module('gp4App').factory('ixAccionCamionPopup',['$log', function ixAccionCamionPopupFactory($log){
		return {
			controladorExtra: ""
		};
	}]);
	
	angular.module('gp4App').factory('ixFichaBastidorPopup',['$log', function ixFichaBastidorPopupFactory($log) {
		return  {
			controlador: "FichaBastidorPopupController"
		};
  }]);

	angular.module('gp4App').factory('ixFichaOrdenTransportePopup',['$log', function ixFichaBastidorPopupFactory($log) {
		return  {
			controlador: "FichaOrdenTransportePopupController"
		};
  }]);

  angular.module('gp4App').factory('ixDetalleIncidenciaPopup',['$log', function ixDetalleIncidenciaPopupFactory($log) {
		return  {
			controlador: "DetalleIncidenciaPopupController"
		};
  }]);

  angular.module('gp4App').run(['$rootScope', 'cfg', 'msalAuthenticationService', 'authService', '$location', '$log', '$timeout', function ($rootScope, cfg, msalAuthenticationService, authService, $location, $log, $timeout) {
    // Configurem msal-browser per interceptar les crides de retorn a l'autenticació Azure, llegir el token i fer el login al backend
    function loadMSAL() {
      if(cfg.baseAuthURL){
        var msalService = msalAuthenticationService.getInstance(); 
        msalService.handleRedirectPromise().then(function(response) {
          if (!response) return;
            
          var account = msalService.getAllAccounts()[0];
          var formData = { userName: account.username, password: "kk", azureToken: response.idToken };

          // Backend login
          authService.login(formData).then(function (response) {
              $rootScope.$broadcast('userLoggedIn');
              $location.path('/');
          }, function (err) {
            $log.error("error login backend from MSAL handleRedirect", err);
            $location.path('/login');
          });
                      
        }).catch($log.error) ;
      } else {
        $log.log("reintento lectura cfg tras 1 sec");
        $timeout(loadMSAL,1000);
      }
    }
    loadMSAL();
    
  }]);

  angular.module('gp4App').run(['$rootScope', 'cfg', function ($rootScope, cfg) {
    //angular.extend(cfg, angular.fromJson(localStorage['gp4App.cfg']));
    angular.extend(cfg, angular.fromJson(sessionStorage['gp4App.cfg']));
    //Si la data d'expiració és inferior a ara, esborrem de localStorage per tornar al login.
    /*if(new Date().getTime() > localStorage['expirationTime']){
      delete localStorage['authorizationData'];
    }*/
  }]);

  //Sobreescrivim els separados de milers i decimals del locale actual. Està fent en-us per defecte.
  angular.module('gp4App').run(["$locale", function ($locale) {
    $locale.NUMBER_FORMATS.GROUP_SEP = ".";
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ",";
  }]);

    angular.module('gp4App').config(['$httpProvider',function ($httpProvider) {
      $httpProvider.interceptors.push('loadingInterceptor');
      $httpProvider.interceptors.push('authInterceptorService');

      $httpProvider.defaults.transformResponse.push(function(responseData){
          convertDateStringsToDates(responseData);
          return responseData;
      });
    }]);


  angular.module('gp4App').config(['$templateRequestProvider',function ($templateRequestProvider) {
      $templateRequestProvider.httpOptions({headers:{'Cache-Control':'no-cache'}});
  }]);

  angular.module('gp4App').factory('loadingInterceptor', ['$q', '$rootScope', function ($q, $rootScope) {

      var loading = 0;
      $rootScope.loading = false;

      return {
					getPendingRequests: function(){
						return loading;
					},
          request : function(config) {
              loading++;
              $rootScope.loading = true;
              $rootScope.$broadcast("loader_show");
              return config || $q.when(config);
          },
          response : function(response) {
              if((--loading) === 0) {
                  $rootScope.loading = false;
                  $rootScope.$broadcast("loader_hide");
              }
              return response || $q.when(response);
          },
          responseError : function(response) {
              if((--loading) === 0) {
                  $rootScope.loading = false;
                  $rootScope.$broadcast("loader_hide");
              }
              if(response.data instanceof ArrayBuffer){
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(response.data));
                var obj = angular.fromJson(decodedString);
                response.data = obj;
              }
              return $q.reject(response);
          }
      }
  }]);

  angular.module('gp4App').directive("ixLoader", [ function () {
      return function ($scope, element) {
          $scope.$on("loader_show", function () {
              return element.show();
          });
          return $scope.$on("loader_hide", function () {
              return element.hide();
          });
      };
  }]);


  angular.module('gp4App').directive("ixSplash", [ function () {
      return {
        //template: '<div class="splash" ng-cloak=""><div class="splash-content text-center"><h1>Cargando</h1><i class="fa fa-spinner fa-pulse"></i></div></div>',
        //template: '<div class="splash" ng-cloak=""><div class="splash-content text-center"><img src="assets/images/logogp_loading.png" /><br><br><i class="fa fa-cog fa-spin" style="font-size:60px;color:#b71c1c"></i></div></div>',
				template: '<div class="splash" ng-cloak=""><div class="splash-content text-center"><img src="assets/images/logogp-loading.png" /><br><br><i class="fa fa-circle-o-notch fa-spin ix-loading"></i></div></div>',
        link: function ($scope, element) {
          $scope.$on("splash_show", function () {
            element.parent().parent().addClass("splash-active");
						return element.show();	
          });
          return $scope.$on("splash_hide", function () {
            element.hide();
						return	element.parent().parent().removeClass("splash-active");
          });
        }
      }
  }]);



  angular.module('gp4App').controller('MainController', ['$rootScope', '$scope', '$location', '$log', '$http', '$timeout', '$uibModal', '$window', 'cfg', 'k', 'authService','$cacheFactory', '$templateRequest', 'ixStatusService', 'i18nService', '$interval', '$translate', 'ixCestaVehiculosService', 'ixUtilsService', '$injector',
    function($rootScope, $scope, $location, $log, $http, $timeout, $uibModal, $window, cfg, k, authService,$cacheFactory, $templateRequest, ixStatusService, i18nService, $interval, $translate, ixCestaVehiculosService, ixUtilsService, $injector) {
      
    $scope.cfg = cfg;
    $rootScope.ixCloseApp = function(){
			if(ixCestaVehiculosService.isShowing())
				ixCestaVehiculosService.emptyCesta();

      ixStatusService.closeApp(ixStatusService.current);
    };

    $rootScope.showGrid = function(grid){
      $timeout(function(){
        if((angular.isDefined(grid)) && angular.isDefined(grid.gridApi))
          grid.gridApi.core.handleWindowResize();
          //grid.gridApi.core.scrollTo(grid.data[0], grid.columnDefs[0]);
      },200);
    };

    $scope.getCurrentAppTitle = function(){
      var currentApp = "";

      if(ixStatusService.current != null){
        currentApp = ixStatusService.current.display;
      }
      
      if(!currentApp)
        return "";
      else
        return " | " + currentApp;
    };

    if(cfg.ngStats){
			showAngularStats({
				position: 'bottomright',
				logDigest: true,
				logWatches: true
			});
		}

    $scope.logOut = function () {
      //De moment no guardem res.
			$timeout(function(){
				authService.logOut();

        ixStatusService.availApps = [];
        $scope.menu = [];
        
        $location.path('/login');
			});
    }

		$scope.sinAplicacionAbiertas = function(){
			var aplicaciones_abiertas = ixStatusService.availApps.filter(function(e){ return e.open; });
			return (aplicaciones_abiertas.length == 0);
		};

    $scope.changeLanguage = function (langKey, startingApp) {
      if (angular.isUndefined(langKey) || langKey == "") langKey = cfg.defaultAppLanguage;
      if (!startingApp) // canviar idioma del usuario en API despues de canviar el idioma en el frontend.
        $http.post(cfg.baseURL + "api_usuarios/ChangeLanguage?Language=" + langKey, { Language: langKey });
      $translate.refresh(langKey);//Si no volem que cada cop que es canvia l'idioma es recarreguin les traduccions desde la api comentar aquesta línea.
      $translate.use(langKey).then(function () {
        // ui-grid utilitza el i18nService per imprimir els textos.
        var i18nLang = (langKey.indexOf('_') == -1) ? langKey : langKey.substr(0, langKey.indexOf('_'));
        //[04/05/2021] - Modificado porque la codificación del $translate service para el catalán (ca) no coincide con la codificación i18nService (es-ct)
        if (i18nLang == 'ca')
          i18nService.setCurrentLang('es-ct');
        else
          i18nService.setCurrentLang(i18nLang);
        if (angular.isDefined($scope.menu) && $scope.menu.length > 0) {
          $scope.calcMenuWidth();
        }
        $rootScope.$broadcast('gridsRefreshLanguage');
      });
    };

    $scope.calcMenuWidth = function () {
      $timeout(function () {
        //angular.element("#user-menu").smartmenus();
        angular.element("#user-menu").smartmenus('refresh').show();
        angular.element("#main-menu").smartmenus('refresh').show();
        ixMenuMoreFunction(jQuery);
        var smartmenus = angular.element("#main-menu").data('smartmenus');
        var ixMenuMoreExecute = ixMenuMore.bind(smartmenus);
        ixMenuMoreExecute(false);
      });
    };    

    $scope.go = function (path, pageAnimationClass) {
      if (typeof(pageAnimationClass) === 'undefined') { // Use a default, your choice
				//Ara tindrem per defecte la transició "ràpida" entre pantalles
				var pageAnimationSuffix = "-scale";
				if (angular.isDefined(cfg.pageAnimation) && cfg.pageAnimation != "")
					pageAnimationSuffix = "-" + cfg.pageAnimation;				
				
      	$rootScope.pageAnimationClass = 'page-animation-bottom' + pageAnimationSuffix;				
      }
      else { // Use the specified animation
          $rootScope.pageAnimationClass = pageAnimationClass;
      }
      if (path === 'back') { // Allow a 'back' keyword to go to previous page
          $window.history.back();
      }
      else { // Go to the specified path
          $location.path(path);
      }
    }
		
		$scope.sendNotification = function () {
			ixUtilsService.openDialogNotification(NTPUSH_MANUAL, null, "", "");
    };

    if(!cfg.baseURL) {
      $scope.logOut();
    }

		$scope.isLoggedIn = function(){
			return authService.authentication.isAuth;
		};

    $scope.$on('userLoggedIn', function () {

      $log.log("userLoggedIn "+cfg.appURL);

      if(cfg.appURL){
        var currentApp = $location.absUrl();
        if(currentApp.indexOf("login") != -1)
          currentApp = currentApp.substring(0, currentApp.indexOf("login"));
        if(currentApp.lastIndexOf("/") == currentApp.length - 1)
            currentApp = currentApp.substring(0, currentApp.length - 1);
  
        currentApp = currentApp.substring(currentApp.indexOf(cfg.appURL), cfg.appURL.length);
  
        if(currentApp == cfg.appURL){
          //Tant el GP4 com les Extranet permetràn programar llistats només si el valor d'aquesta estiqueta és 1.
          //if(angular.isUndefined($rootScope.ixPermiteProgramar)){
            /*ixUtilsService.checkPermission("PermiteProgramar").then(function(result){
              $rootScope.ixPermiteProgramar = result;
            });*/
          //}
          
          /*  BIOTECNAL 4/12/2025 - no se usan estas etiquetas
          ixUtilsService.checkMultiplePermission([ "PermiteProgramar", "EnviarNotificacionesPda" ]).then(function(result){
            $rootScope.ixPermiteProgramar = result[0];
            $rootScope.ixEnviarNotificacionesPda = result[1];							
          });
          */
  
          if(cfg.enablePTV){
            ixUtilsService.checkMultiplePermission([ "Lms_ptv_url_base", "LmsPtvApikey" ]).then(function(result){
              $rootScope.LmsPtvUrlBase = result[0];
              $rootScope.LmsPtvApikey = result[1];
            });
          }
  
          $scope.changeLanguage($scope.authentication.language, true);
          $scope.esExtranet = (cfg.clientId == "Extranet" || cfg.clientId == "ExtranetVideo" || cfg.clientId == 'Gestpark-Internet');
          cfg.minLengthBuscaChasis = cfg.minLengthBuscaChasis || 4;
          $scope.mostraBusquedaVIN = $scope.esExtranet;
          if($scope.esExtranet){
            //Sol·lució temporal per el problema de firewall d'extranet.
            //ixPing($interval, $http, cfg);
          }
          $http.get(cfg.baseURL+'api_usuarios/CurrentUser').then(function(response) {
            $scope.user = response.data.usuario;

            // Si mesesCaducidadPassword està definit, validem la fecha_modif_pwd de l'usuari
            if(cfg.mesesCaducidadPassword && cfg.mesesCaducidadPassword>0) {
              var caducidad = new Date();
              caducidad.setMonth(caducidad.getMonth-cfg.mesesCaducidadPassword);
              if(!response.data.usuario.fecha_modif_pwd || response.data.usuario.fecha_modif_pwd<caducidad) {
                $log.warn("El password no ha cambiado desde",response.data.usuario.fecha_modif_pwd,"caducidad establecida en meses",cfg.mesesCaducidadPassword)
                sessionStorage['force_reset_password'] = true;
                $location.path('/changePassword');
                return;
              }
            }

            // Si no tenemos email para ese usuario, pedirlo
            if(cfg.requerirEmails && !$scope.user.email) {
              $location.path("/askEmail");
            }

            //$scope.perfiles = response.data.perfiles;
            //Guardem el clientId que retorna la API.
            cfg.clientId = $scope.user.client_id;
            $scope.authentication.perfiles = response.data.perfiles;
            $scope.allowedMenus = response.data.menus;
            $scope.allowedMenusExtranet = response.data.menus_extranet;
            $rootScope.$broadcast('currentUserLoaded');
            //Carreguem les apps favorites.
            ixStatusService.load().then(function(favApps){
              $scope.favApps = favApps;
              $scope.menu = buildMenus();
              $scope.menu.splice(1);
              $scope.menu = $scope.menu.filter(hasPermission, "");
              if($scope.menu.length==1 && $scope.menu[0].children.length==1 && $scope.menu[0].children[0].children) {
                // si sólo hay un nodo en el primer nivel de menus, lo aplanamos
                $scope.menu[0].children = $scope.menu[0].children[0].children;
              }
              
              //comprobar si te punt de menú + Más, si el te eliminem:
              if(angular.element("ul.nav.navbar-nav > li > a.has-submenu").length > 1){
                var element = angular.element("ul.nav.navbar-nav > li > a.has-submenu")[0];
                angular.element(element).remove();
              }

              $timeout(function() {
                //angular.element("#user-menu").smartmenus();
                angular.element("#user-menu").smartmenus('refresh').show();
                angular.element("#main-menu").smartmenus('refresh').show();
                ixMenuMoreFunction(jQuery);
                var smartmenus = angular.element("#main-menu").data('smartmenus');
                var ixMenuMoreExecute = ixMenuMore.bind(smartmenus);
                ixMenuMoreExecute(false);
              });
            });
          }).catch(function(response){
            $log.error("error",response);
            $location.path('/login');
          });
        } else {
          authService.logOut();
          $location.path('/login');
        }
      }
    });

    $scope.$on('userLoggedOut', function(){
      $scope.logOut();
    });


    authService.fillAuthData();
    $scope.authentication = authService.authentication;
    if(!authService.authentication.isAuth) {
      $location.path('/login');
    }	else {
      $rootScope.$broadcast('userLoggedIn');
    }

    /** expose constants to view */
    $scope.k = k;


    $scope.openModal = function(template, scope, size) {
       return $uibModal.open({
            templateUrl: template,
            size: size || 'lg',
            scope: scope,
            backdrop: 'static',
            keyboard: false
          }).result;
    };

    $scope.openModalV2 = function(template, options, size, params) {
      var defaultOptions = {
        templateUrl: template,
        size: size || 'lg',
        backdrop: 'static',
        keyboard: false
      };
      if(angular.isDefined(options.scope)){
        defaultOptions.scope = options.scope;
        delete options.scope;
      }

			if(angular.isDefined(params)){
				if(angular.isUndefined(defaultOptions.resolve)){
					defaultOptions.resolve = {};
				}
				angular.forEach(params, function(value, key){
					defaultOptions.resolve[key] = function(){ return value; };
				});
			}

      angular.merge(defaultOptions, options);
	  if (options.returnInstance)							
		return $uibModal.open(defaultOptions);
	  else
      	return $uibModal.open(defaultOptions).result;      
    };

    function hasPermission(node) {
      var vm = this;
      if(node.children) {
        node.children = node.children.filter(hasPermission, vm + (angular.isDefined(node.display) ? "/" + node.display : ""));
        return node.children.length>0;
      } else {
        var pathApp = vm + "/"+node.display;
        if(node.href && ($scope.allowedMenus.indexOf(pathApp)!=-1 || $scope.authentication.perfiles.some(function(e){ return e.toUpperCase().indexOf("IXNET")!==-1;}))){
          var esFav = $scope.favApps.some(function(e){ return e.display === node.display && e.href === node.href; });
          if(esFav){ node.fav = true; }
            ixStatusService.availApps.unshift(angular.copy(node));
            return true;
        } else {
            return false;
        }
      }
    }


      $scope.setFocus = function(id) {
        $timeout(function() {
          var element = $window.document.getElementById(id);
          if(element){
            element.focus();
          }
        });
      };

      /* establece el focus en el primer elemento ng-invalid-XXXX visible */
      $scope.setFocusError = function(error) {
        $timeout(function() {
          var visibleInvalids = angular.element.find('.ng-invalid-'+error+':visible');
          if (angular.isDefined(visibleInvalids && visibleInvalids.length>1)){
            //console.log("setting focus to ", visibleInvalids[1]);
            visibleInvalids[1].focus();
          }
        },100);
        return;
      };

      $rootScope.numberOfErrors=function(form){
        var count = 0;
        if(form) {
          angular.forEach(Object.keys(form.$error), function(val){
            if(angular.isArray(form.$error[val]) && skipValidationErrors().indexOf(val) == -1) {//Mirem si té errors i si aquests no s'han d'ignorar.
              count += form.$error[val].length;
            }
          });
          (count == 0) ? form.$invalid = false : form.$invalid = true;
        }
        return count;
      };


    // for datepickers
    $scope.isOpen = {}
    $scope.switchOpen = function($event,name) {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.isOpen[name] = !$scope.isOpen[name];
    };

    /**
     * Funció per recuperar de forma asyncrona resultats per a uib-typeahead
     *
     * entity: nom de l'entitat a fer el Seaarch
     * fields: string or array[string] - nom dels camps de filtre
     * values: string or array[string] - valors per filtrar (es pot passar $viewValue)
     * cmps: int o arrat[int]  - comparadors a aplicar (Contatns CMP_*) [default: CMP_LIKE]
     * nots: bool o array[bool] - degar o no condicions [default: false]
     * orderBy: array[string] noms dels cams a ordenar (-desc) [default: el mateix que fields]
     *
     */
    $scope.typeahead = function(entity, fields, values, cmps, nots, orderBy) {

      var searchParam = {Filters:[]};

      if(fields.constructor === Array) {
        if (!cmps) cmps = [];
        if(!nots) nots=[];
        if (!orderBy) orderBy = fields;
        fields.forEach(function(f,i) {
          if (!cmps[i]) cmps[i] = CMP_LIKE;
          if(!nots[i]) nots[i]=false;

          searchParam.Filters.push({Field: fields[i], Value: values[i], Operator: cmps[i], Not: nots[i]})

        })
      } else {
        if (!cmps) cmps = CMP_LIKE;
        if(!nots) nots=false;
        if (!orderBy) orderBy = [fields];
        searchParam.Filters.push({Field: fields, Value: values, Operator: cmps, Not: nots})
      }
      searchParam.OrderBy = orderBy;

      return $http.post(cfg.baseURL+entity+'/Search?Page=1&ItemsPerPage=10', searchParam).then(function(response) {
        return response.data.Items;
        });
    };

    // Validators
    //$scope.validateIBAN = function(val){return !val || $window.IBAN.isValid(val)};
    $scope.validateTIME = function(val){
      var regex = /([01]\d|2[0-3]):([0-5]\d)/;
      return !val || regex.test(val);
    };

    //Per tancar campaneta despres de X segons:
    //TODO: S'hauria de crear una directiva per la campaneta i moure aquesta funció i la de numberOfErrors dintre de la directiva. D'aquesta manera podrem accedir a aquestes funcions.
    //desde popup, pantalla amb grid, etc.
    $rootScope.openIfChanges = function(form, status){
      if(form){
         var auxForm = {};
         Object.keys(form).forEach(function(key, val){
           if(key.lastIndexOf("$") == -1)
             auxForm[key] = form[key];
         });

         auxForm["$dirty"] = form["$dirty"];
         auxForm["$error"] = form["$error"];
         auxForm["$invalid"] = form["$invalid"];
         auxForm["$valid"] = form["$valid"];

        deleteSkippedValidations(auxForm.$error, skipValidationErrors());
        //Just acavem d'entrar a la pantalla o hem gravat a API. No mostrem el detall del warning.
        if(((status) && status.response) && status.response.data || !status.deleteEnabled){
          //$scope.oldForm = angular.copy(auxForm);
          $scope.oldForm = auxForm;
          $scope.showNotif = false;
          return false;
        }
        if(((angular.isDefined($scope.oldForm) && angular.isDefined(auxForm))) && angular.isDefined($scope.oldForm.$error) && !angular.equals(auxForm.$error, $scope.oldForm.$error)){
          $scope.showNotif = true;
          angular.forEach(Object.keys(auxForm.$error), function(error){//si hi ha menys errors no ensenyem la caixa.
            if(angular.isDefined(auxForm.$error[error]) && angular.isDefined($scope.oldForm.$error[error]) && auxForm.$error[error].length < $scope.oldForm.$error[error].length){
              $scope.showNotif = false;
            }
          });
          //$scope.oldForm = angular.copy(auxForm);
          $scope.oldForm = auxForm;
          if($scope.showNotif == true){
            $timeout(function(){
              $scope.showNotif = false;
            },3000);
          }
        }
        //$scope.oldForm = angular.copy(auxForm);
        $scope.oldForm = auxForm;
      }
      return true;
    };

    $rootScope.openIfError = function(status){
      if(status){
        if(status.response){
          if(status.response.data){
            if(((status.response.data.GlobalMessage != null)) && (status.response.data.GlobalMessage.ErrType) && status.response.data.GlobalMessage.ErrType == 2 && !angular.equals(status.response.data, $scope.oldStatus)){
              $scope.showErrorNotif = true;
            }
          }
          $scope.oldStatus = angular.copy(status.response.data);
        }
      }
      if($scope.showErrorNotif == true){
        $timeout(function(){
          $scope.showErrorNotif = false;
        },3000);
      }
      return true;
    };

    $scope.refreshSliders = function() {
      $timeout(function () {
        $log.log("Refreshing sliders");
        $scope.$broadcast('rzSliderForceRender');
      });
    };

    $scope.$on("$destroy", function() {
      $window.localStorage.clear();
      $scope.isDestroyed=true;
    });

    // helper & utility functions

    /** length of a dictionary */
    $scope.length = function(obj) {
          if(obj) {
              return Object.keys(obj).length;
          } else {
              return 0;
          }
    }

   }]);

  angular.module('gp4App').controller('LoginController', ['$rootScope', '$scope', '$location', 'authService', '$http', 'cfg', '$log', 'gridConfigService', 'gRecaptcha', '$timeout', '$injector', '$uibModal', 'ixStatusService', function ($rootScope, $scope, $location, authService, $http, cfg, $log, gridConfigService, gRecaptcha, $timeout, $injector, $uibModal, ixStatusService) {
    //$scope.timeDiffs = [];


		if(cfg.recaptchaToken)
			gRecaptcha.initialize({key: cfg.recaptchaToken});


    gridConfigService.clearGridMetadata();
    $scope.frameClass = 'page-login';
    $scope.loginData = {
      userName: authService.authentication.userName,
      password: "",
      domain: authService.authentication.domain,
      api: "",
      serverTimeZone: ""
    };

    $http.get('config.json').then(function(response) {
      var configData = response.data;
      if (!configData) {
        throw new Error('Config.json sin configurar');
      }
      else {
        $log.log("config.json loaded",configData);
        sessionStorage['gp4App.cfg'] = angular.toJson(cfg);
        $scope.allApis = configData;
        $scope.loginData.api = cfg;
        RefreshDominios();
        //Si nomes tenim una api a config.json la marquem.
        if(configData.length == 1){
          $scope.loginData.api = configData[0];
          $scope.ChangeAPI();
        }
      }
    });

    $scope.ChangeAPI = function () {
      $log.log("construyo objeto cfg con baseAuthUrl...",$scope.loginData.api);
      angular.extend(cfg, $scope.loginData.api);
      $log.log("cfg",cfg);
      sessionStorage['gp4App.cfg'] = angular.toJson(cfg);
      RefreshDominios();
			if(cfg.recaptchaToken)
				gRecaptcha.initialize({key: cfg.recaptchaToken});
      //$scope.timeDiffs = cfg.timeDiff;
      //if($scope.timeDiffs.length == 1){
        //$scope.loginData.timeDiff = $scope.timeDiffs[0];
      //}
    };

    $scope.message = authService.authentication.errorLogin;
    $scope.$on('login-error', function() {
        $scope.message = authService.authentication.errorLogin;
    });    

    $scope.compruebaCaracteresProhibidos = function(ev, campo){
      //Lista de carácteres prohibidos: no permita espacios, ni “–“,”/*”,”*/”,”;”, “//”)
      var ESPACIO = /(\s)/gm;
      var DOBLE_GUION = /(--)/gm;
      var BARRA_ASTERISCO = /(\/\*)/gm;
      var ASTERISCO_BARRA = /(\*\/)/gm;
      var PUNTO_COMA = /(;)/gm;
      var DOBLE_BARRA = /(\/\/)/gm;
      
      if(ESPACIO.test($scope.loginData[campo])){
        $scope.loginData[campo] = $scope.loginData[campo].replace(ESPACIO, "");
      }
      if(DOBLE_GUION.test($scope.loginData[campo])){
        $scope.loginData[campo] = $scope.loginData[campo].replace(DOBLE_GUION, "");
      }
      if(BARRA_ASTERISCO.test($scope.loginData[campo])){
        $scope.loginData[campo] = $scope.loginData[campo].replace(BARRA_ASTERISCO, "");
      }
      if(ASTERISCO_BARRA.test($scope.loginData[campo])){
        $scope.loginData[campo] = $scope.loginData[campo].replace(ASTERISCO_BARRA, "");
      }
      if(PUNTO_COMA.test($scope.loginData[campo])){
        $scope.loginData[campo] = $scope.loginData[campo].replace(PUNTO_COMA, "");
      }
      if(DOBLE_BARRA.test($scope.loginData[campo])){
        $scope.loginData[campo] = $scope.loginData[campo].replace(DOBLE_BARRA, "");
      }
    };

    $scope.login = function () {

			$scope.logueando = true;
			$scope.message = '';

			if(cfg.recaptchaToken){
				gRecaptcha.execute({action: 'submit'}).then(function (token) {
					// returns token from Google Recaptcha
					$scope.loginData.recaptchaToken = token;
					$scope.callLoginService();
				});
			} else {
				$scope.callLoginService();
			}
    };

    $scope.login2FA = function () {
			$scope.logueando = true;
			$scope.message = '';			
			//$scope.callLoginService();
      $log.log("using refresh_token to call 2FA");
      authService.login2FA($scope.loginData.token2fa).then(function(response){
        $log.log("login 2FA OK", response);
        $rootScope.$broadcast('userLoggedIn');
        if(angular.isDefined($scope.afterLoginCustom)) {
          $scope.afterLoginCustom();
        } else {
          $location.path('/');
        }
      }, function(e) {
        $log.error("refresh token failed", e);
        $scope.logueando = false;
        $scope.message = { error_description: "Token incorrecto" };
      });
    };

    $scope.loginWithMicrosoft = function(){
      $log.log("loginWithMicrosoft");
      $rootScope.loading = true;
      $injector.get("msalAuthenticationService").getInstance().loginRedirect({
        prompt: "select_account",
        scopes: ["openid", "profile", "email"]
      });
    };

		$scope.callLoginService = function(params){
      if(cfg.baseAuthURL){
        var loginData = params || $scope.loginData;
        authService.login(loginData).then(function (response) {
          if(response["2FA_required"] == "1") {
            //pedimos código de 2FA
            $log.log("login OK - asking for 2FA", response);
            $scope.logueando = false;
            $scope.request_token2fa = true;
          } else {
            $log.log("login OK", response);
            $rootScope.$broadcast('userLoggedIn');
            if(angular.isDefined($scope.afterLoginCustom)) {
              $scope.afterLoginCustom();
            } else {
              $location.path('/');
            }
          }
        },
        function (err) {
          $log.error("error login?", err);
          $scope.message = err;
        });
      } else {
        $log.log("reintento lectura cfg tras 1 sec");
        $timeout(function(){
          $scope.callLoginService(params);
        },1000);
      }
		};


    if (authService.authentication.isAuth) {
      $location.path('/');
    }

    function RefreshDominios () {
      if(cfg.clientId == "GPv4" || cfg.clientId == 'Gestpark-Intranet')
      {
        $http.get(cfg.baseURL + "api_dominios").then(function(response){
          $scope.allDomains = response.data.map(function(e){ return e.dominio; });
          if($scope.allDomains.length==1) {
            $scope.loginData.domain = $scope.allDomains[0];
          }
          else {
            $scope.loginData.domain = "";
          }
        });
      } else {
        $scope.allDomains = new Array();
      }
    }

    $scope.abrirResetPassword = function(){		
      var modalInstance = $uibModal.open({
        templateUrl: 'app/base/views/reset_password_popup.html',
        size: 'small',
        controller:['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
          $scope.status = { editing: true };
          $scope.data = { };
          $scope.message = "";
          $scope.message_error = "";
          /*$scope.save = function(){
            $uibModalInstance.close($scope.data);
          };*/
          $scope.$close = function () {
            $uibModalInstance.dismiss('cancel');
          };

          $scope.enviar_mail = function () {
            $scope.message = "";
            $scope.message_error = "";
            $http.post(cfg.baseURL + "api_usuarios/EnviarCodigoPorMail", $scope.data).then(function(r){
              //ixStatusService.setResponse(r);            
              $scope.message = "Se ha enviado un correo electrónico a la dirección: " + r.data.obj.Record.mail;
            }, function(err){
              ixStatusService.setResponse(err);
              $scope.message_error = err.data.GlobalMessage.Msg;						
            });					
          };

          $scope.reset_password = function () {
            $scope.message = "";
            $scope.message_error = "";
            $http.post(cfg.baseURL + "api_usuarios/ResetPasswordCodigo", $scope.data).then(function(r){
              //ixStatusService.setResponse(r);            
              $scope.message = "Se ha reseteado la contraseña.";
            }, function(err){
              ixStatusService.setResponse(err);
              $scope.message_error = err.data.GlobalMessage.Msg;						
            });							
          };
        }],
        backdrop: 'static',
        keyboard: false
      });

      modalInstance.result.then(function(response){
        //$scope.setFechaBajaAbiertas(true, response.fecha, response.hora);				
      });		
    };	
    
    $scope.afterLoginCustom = function () {		
      /*
      if($scope.loginData.userName.toUpperCase() == $scope.loginData.password.toUpperCase()) {									
        sessionStorage['force_reset_password'] = true;
        $location.path('/changePassword');					
      } else {
        $location.path('/');		
      }
      */
      $location.path('/');
    };

  }]);

  angular.module('gp4App').controller('AskEmailController', ['$rootScope', '$scope', '$location', 'authService', '$http', 'cfg', '$log', '$timeout', function ($rootScope, $scope, $location, authService, $http, cfg, $log, $timeout) {
		$scope.frameClass = 'page-login';
    $scope.data = {};

    $scope.skip = function () {      
      $location.path('/');
    };

    $scope.send = function () {
      if($scope.data.newpassword === $scope.data.repetir) {
        $http.post(cfg.baseURL+"api_usuarios/SetEmail",'"'+$scope.data.email+'"',{headers: {'Content-Type': 'application/json'}}).then(function (response) {
          $scope.message = response.data.GlobalMessage;
          if(response.data.Result) {
            $timeout(function() {$location.path('/');}, 2000);
          }
        }, function (err) {
          $scope.message = err.data.GlobalMessage || { Msg:err.statusText || ("Error "+err.status), Errtype: 1};
        });
      }
    };				
  }]);

  angular.module('gp4App').controller('ChangePasswordController', ['$rootScope', '$scope', '$location', 'authService', '$http', 'cfg', '$log', '$timeout', function ($rootScope, $scope, $location, authService, $http, cfg, $log, $timeout) {
		$scope.frameClass = 'page-login';

    $scope.valid = false;
    $scope.data = {};
    $scope.data.usuario = authService.authentication.userName;

    $scope.message = {Msg:"El password debe tener un mínimo de 8 carácteres, tiene que tener 1 mayúscula, 1 minúscula y 1 número como mínimo", ErrType:0};

    $scope.send = function () {
      if($scope.data.newpassword === $scope.data.repetir) {
        $http.post(cfg.baseURL+"api_usuarios/ChangePassword",$scope.data).then(function (response) {
          $scope.message = response.data.GlobalMessage;
          if(response.data.Result) {
						sessionStorage['force_reset_password'] = false;
            $timeout(function() {$location.path('/');}, 2000);
            $rootScope.$broadcast('userLoggedIn');
          }
        }, function (err) {
          $scope.message = err.data.GlobalMessage;
        });
      } else {
        $scope.message = {Msg:"Password no coincide", ErrType:2};
      }
    };				
  }]);

	angular.module('gp4App').controller('ChangePasswordCodigoUserController', ['$rootScope', '$scope', '$location', 'authService', '$http', 'cfg', '$log', '$timeout', function ($rootScope, $scope, $location, authService, $http, cfg, $log, $timeout) {
    $scope.frameClass = 'page-login';

    $scope.valid = false;
    $scope.data = {};
    $scope.data.usuario = atob($location.search().usuario);
		$scope.data.codigo = atob($location.search().codigo);

    $scope.message = {Msg:"El password debe tener un mínimo de 8 carácteres, contener 1 mayúscula, 1 minúscula y un número como mínimo ", ErrType:0};

    $scope.send = function () {
      if($scope.data.newpassword === $scope.data.repetir) {
				$http.get('config.json').then(function(response){
          var configData = response.data;
					if (!configData) {
						throw new Error('Config.json sin configurar');
					}
					else {									
						angular.extend(cfg, configData[0]);						
					}
					 
					$http.post(cfg.baseURL+"api_usuarios/ResetPasswordCodigo",$scope.data).then(function (response) {
						$scope.message = response.data.GlobalMessage;
						if(response.data.Result) {
							sessionStorage['force_reset_password'] = false;
              $scope.message = "Password cambiado correctamente";
							$timeout(function() {$location.path('/').search({force_reset_password: null, usuario: null, codigo: null});}, 2000);
						} else {
              $scope.message = response.GlobalMessage 
            }
					}, function (err) {
            if(!err.data) {
              $scope.message = {Msg: "Error inesperado, por favor pruébelo más tarde.", ErrType: 2}; 
            } else if(err.data.ExceptionMessage) {
              $scope.message = {Msg: err.data.ExceptionMessage, ErrType: 2}; 
            } else {
              $scope.message = err.data.GlobalMessage;
            }          				
    		  });
        });								
      } else {
        $scope.message = {Msg:"Password no coincide", ErrType:2};
      }
    };

  }]);

  /* ix-editable: Direciva de atributo. Añadida a un input hace que se active/desactive segín el estado editing del formulario */
  angular.module('gp4App').directive('ixEditable', [ function() {
      return {
          restrict: 'A',
          link: function (scope, element) {
              scope.$watch('editing', function() {
                  element[0].disabled = !scope.editing;
              });
          }
      };
    }]);

  /* ix-after-fixed-header: Directiva de atributo. Añade padding que queda debajo de un fixed header */
  angular.module('gp4App').directive('ixAfterFixedHeader', ['$window', '$timeout', function($window,$timeout) {
      return {
        link: function(scope, el) {

          $timeout(function() {
            var height = angular.element(".fixed").outerHeight();
            el.css({"padding-top":height+"px"});
            },1000);

          angular.element($window).on('resize', function() {
            var height = angular.element(".fixed").outerHeight();
            el.css({"padding-top":height+"px"});
  //		    	el.height(height);
          });
        }
      }
    }]);





  angular.element(document).find('head').prepend('<style type="text/css">input[ix-number] {text-align: right} input[ix-number]:focus {text-align: left}</style>');

  /**
   * Directive to jump to next control on Enter keypress (like Tab)
   * TODO: shift+Enter?
   */
  angular.module('gp4App').directive('input', [ function() {
    return function(scope, element, attrs) {
      element.on('keypress', function(e){
        var keyCode = (e.keyCode ? e.keyCode : e.which);
        //Si hi ha un checkbox i s'apreta espai el marquem
        //Comprovar perque no funciona.
        if (attrs.type === 'checkbox') {
          if(keyCode == 32){
            element.trigger('click');
            scope.$apply();
          }
        }
        if(keyCode==13) {  // focus to next input on keypress Enter
          var nextinput = angular.element(':input:not(textarea):visible:enabled:eq(' + (angular.element(':input:not(textarea):visible:enabled').index(element) + 1) + ')');
          if (nextinput && nextinput.length>0)
          {
						//Si l'element actual esta dintre d'un modal pero el seguent que hi ha al DOM esta fora no fem res.
						var estamosEnPopup = (element[0].closest('div.modal-body') !== null);
						var proximoElementoFueraDePopup = (nextinput[0].closest('div.modal-body') == null);
						if(estamosEnPopup && proximoElementoFueraDePopup)
							nextinput = angular.element('div.modal-body :input:not(textarea):visible:enabled:eq(0)');

						if(nextinput[0].closest('div.ui-grid-filter-container') == null)
							nextinput.focus();
						//els controls de grid, per exemple, la data, no possen el valor al fer intro si es fa el preventDefault.
						if(element[0].closest('div.ui-grid-cell') == null && element[0].closest('div.div-login') == null){
							e.preventDefault();
						}
						element.blur();
          }
        }
      });
    };
  }]);





  /* default options for ui.bootstrap.datepicker and ui.bootstrap.timepicker */
  angular.module('gp4App').config([ 'uibDatepickerConfig', 'uibDatepickerPopupConfig', 'uibTimepickerConfig', function(uibDatepickerConfig, uibDatepickerPopupConfig, uibTimepickerConfig) {
    uibDatepickerConfig.startingDay = 1;
    uibDatepickerConfig.showWeeks = true;
    uibDatepickerPopupConfig.datepickerPopup = "dd/MM/yyyy";

    uibTimepickerConfig.showMeridian = false;
    uibTimepickerConfig.showSpinners = false;
  }]);

  /* default options para angular-ivh-treeview */
  angular.module('gp4App').config(['ivhTreeviewOptionsProvider', function(ivhTreeviewOptionsProvider) {
    ivhTreeviewOptionsProvider.set({
      twistieExpandedTpl: '<i class="fa fa-fw fa-minus-square-o"></i>',
      twistieCollapsedTpl: '<i class="fa fa-fw fa-plus-square-o"></i>',
      twistieLeafTpl: '<i class="fa fa-fw"></i>'
    });
  }]);

  angular.module('gp4App').config(['$provide', function($provide){

    $provide.decorator('ivhTreeviewDirective', function($delegate) {
      var directive = $delegate[0];

      directive.template = [
        '<ul class="ivh-treeview">',
          '<li ng-repeat="child in root | ivhTreeviewAsArray | filter: trvw.getFilter() | limitTo:150"',
              'ng-hide="trvw.hasFilter() && !trvw.isVisible(child)"',
              'class="ivh-treeview-node"',
              'ng-class="{\'ivh-treeview-node-collapsed\': !trvw.isExpanded(child) && !trvw.isLeaf(child)}"',
              'ivh-treeview-node="child"',
              'ivh-treeview-depth="0">',
          '</li>',
        '</ul>'
      ].join('\n');
      return $delegate;
    });
  }]);

  angular.module('gp4App').config(['$provide', function($provide) {
    $provide.decorator('dateFilter', ['$delegate', 'cfg', 'moment', function($delegate, cfg, moment) {
      var srcFilter = $delegate;

      var extendsFilter = function() {
        var mainArguments = Array.prototype.slice.call(arguments);
        if(mainArguments.length == 2 && angular.isDefined(cfg.timeDiff) && cfg.timeDiff != "" && cfg.timeDiff != null && angular.isDefined(cfg.serverTimeZone)){
          var GMT = "+0100";
          if(angular.isDate(mainArguments[0])){

						//Provablement aixo estava abans de que el authInterceptorService envies les dates sense el temps. Ara ja no té sentit.
//						var datePickerTime = moment(mainArguments[0]).format("HH:mm");
//						var currentLocalTime = moment(new Date()).format("HH:mm");

//						if(datePickerTime == currentLocalTime){
//							mainArguments[0].setHours(0,0,0,0);
//						}

//            var horaServidor = moment(mainArguments[0]).tz(cfg.serverTimeZone);
//            GMT = horaServidor.format("ZZ");
          }
          //mainArguments.push(GMT);
					mainArguments.push(null);
        }
        var res = srcFilter.apply(this, mainArguments);
        return res;
      }

      return extendsFilter;
    }])
  }]);


  /*function MomentFactory($window) {
    if(!$window.moment){
      // If moment is not available you can now provide a
      // mock service, try to load it from somewhere else,
      // redirect the user to a dedicated error page, ...
    }
    return $window.moment;
  }*/

  // Define dependencies
  //MomentFactory.$inject = ['$window'];

  // Register factory
  //angular.module('gp4App').factory('moment', MomentFactory);

  angular.module('gp4App').factory('moment', [ '$window', function($window){
    if(!$window.moment){
      // If moment is not available you can now provide a
      // mock service, try to load it from somewhere else,
      // redirect the user to a dedicated error page, ...
    }
    return $window.moment;
  }]);

	angular.module('gp4App').factory('lodash', [ '$window', function($window){
    if(!$window._){
      // If moment is not available you can now provide a
      // mock service, try to load it from somewhere else,
      // redirect the user to a dedicated error page, ...
    }
    return $window._;
  }]);

  /* definim un decorator per sobreescriure uiGridCellNavService */
  angular.module('gp4App').config(['$provide', function($provide){
    $provide.decorator('uiGridCellNavService', [ '$delegate', 'uiGridConstants', 'uiGridCellNavConstants', 'ixStatusService','cfg', function ($delegate, uiGridConstants, uiGridCellNavConstants, ixStatusService, cfg) {
      //var getDirection = $delegate.getDirection;
      $delegate.getDirection = function (evt) {

        //Modificación biotecnal Ivan 2021/12/13
        if(angular.element(evt.currentTarget).parents().hasClass("gridResultados")){
          if (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey){
            return uiGridCellNavConstants.direction.UP;
          }
          else if (evt.keyCode === uiGridConstants.keymap.TAB && !evt.shiftKey){
            return uiGridCellNavConstants.direction.DOWN;
          }
        }

        // BIOTECNAL: si le damos la class "excelKeys" a un grid, permite bajar/subir de fila con ENTER y shift+ENTER igual que en Excel
        if(angular.element(evt.currentTarget).parents().hasClass("excelKeys")){
          if (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey){
            return uiGridCellNavConstants.direction.UP;
          }
          else if (evt.keyCode === uiGridConstants.keymap.ENTER && !evt.shiftKey){
            return uiGridCellNavConstants.direction.DOWN;
          }
        }


		if(cfg.gridNavMode == 1)
		{
			if (evt.keyCode !== uiGridConstants.keymap.LEFT && evt.keyCode !== uiGridConstants.keymap.RIGHT 
			&& evt.keyCode !== uiGridConstants.keymap.UP && evt.keyCode !== uiGridConstants.keymap.DOWN
			&& evt.keyCode !== uiGridConstants.keymap.TAB && evt.keyCode !== uiGridConstants.keymap.ENTER) {
				ixStatusService.current.ixCellNav = false;
			} 
			else if(evt.keyCode === uiGridConstants.keymap.TAB || evt.keyCode === uiGridConstants.keymap.ENTER || evt.keyCode === uiGridConstants.keymap.UP && evt.keyCode === uiGridConstants.keymap.DOWN){
				ixStatusService.current.ixCellNav = true;
			}
		} else {
			ixStatusService.current.ixCellNav = false;
		}
		  
        if ((evt.keyCode === uiGridConstants.keymap.LEFT && (!ixStatusService.current.editing || ixStatusService.current.ixCellNav)) ||
          (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey)) {		  
          return uiGridCellNavConstants.direction.LEFT;
        }
        if ((evt.keyCode === uiGridConstants.keymap.RIGHT && (!ixStatusService.current.editing || ixStatusService.current.ixCellNav)) ||
          (evt.keyCode === uiGridConstants.keymap.TAB || evt.keyCode === uiGridConstants.keymap.ENTER)) {			
          return uiGridCellNavConstants.direction.RIGHT;
        }

        if (evt.keyCode === uiGridConstants.keymap.UP ||
          (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey) ) {
          return uiGridCellNavConstants.direction.UP;
        }

        if (evt.keyCode === uiGridConstants.keymap.PG_UP){
          return uiGridCellNavConstants.direction.PG_UP;
        }
        // delete listener for key ENTER
        if (evt.keyCode === uiGridConstants.keymap.DOWN) {
          return uiGridCellNavConstants.direction.DOWN;
        }
        // original code
        /*if (evt.keyCode === uiGridConstants.keymap.DOWN ||
          evt.keyCode === uiGridConstants.keymap.ENTER) {
          return uiGridCellNavConstants.direction.DOWN;
        }*/

        if (evt.keyCode === uiGridConstants.keymap.PG_DOWN){
          return uiGridCellNavConstants.direction.PG_DOWN;
        }

        return null;
      };
      return $delegate;
    }]);
  }]);

  /* definim un decorator per fer que si escrivim una lletra mentre tenim el dropdown sel·leccionat, aquest es desplegui filtrant per aquesta lletra. */
  angular.module('gp4App').config(['$provide', function($provide){
    $provide.decorator('uiGridEditService', [ '$delegate', 'uiGridConstants', 'ixStatusService', '$rootScope', '$timeout', function ($delegate, uiGridConstants, ixStatusService, $rootScope, $timeout) {
      $delegate.isStartEditKey = function (evt) {
        if(evt.ctrlKey){
          if(evt.keyCode == 86){
            return true;
          }
          return null;
        } else if ((evt.keyCode >= 48 && evt.keyCode <= 57) || (evt.keyCode >= 65 && evt.keyCode <= 90) || (evt.keyCode >= 96 && evt.keyCode <= 122)) {
          if($rootScope.typedText)
            $rootScope.typedText = $rootScope.typedText + evt.key;
          else
            $rootScope.typedText = evt.key;
          return true;
        } else if(evt.keyCode == 32){//espai
          return true;
        }
        return null;
      };
      return $delegate;
    }]);
  }]);

	//decorem el $http per codificar tots els caràcters especials que viatgin a la url (excluint la query string), excepte [, / ? : & = + $ #].
	//Si es volguessin codificar més, fer-ho concatenant .replace.
//	angular.module('gp4App').config(['$provide', function($provide){
//		$provide.decorator('$httpBackend', [ '$delegate', '$sanitize', function ($delegate, $sanitize) {
//				var decoratedHttpBackend = function (method, url, data, callback, headers, timeout, withCredentials, responseType) {
//					var url_without_query_string = url;
//					var query_string = "";
//					if(url.lastIndexOf("?") != -1){
//						url_without_query_string = url_without_query_string.substr(0, url.lastIndexOf("?"));
//						query_string = url.substr(url.lastIndexOf("?"));
//					}
//
//					url_without_query_string = encodeURI( url_without_query_string ).replace(/[!'()]/g, escape).replace(/\*/g, "%2A").replace(/\@/g, "%40");
//
//					url = url_without_query_string + query_string;
//
//					return $delegate.call(this, method, url, data, callback, headers, timeout, withCredentials, responseType);
//				};
//
//				for (var key in $delegate) {
//					if ($delegate.hasOwnProperty(key)) {
//						decoratedHttpBackend[key] = $delegate[key];
//					}
//				}
//				return decoratedHttpBackend;
//		}]);
//  }]);

  /* diem que el tema per defecte per el ui-select es el select2 */
  angular.module('gp4App').config(['uiSelectConfig', function(uiSelectConfig) {
    uiSelectConfig.theme = 'select2';
  }]);

  angular.module('gp4App').config([ 'pdfjsViewerConfigProvider', function(pdfjsViewerConfigProvider) {
		
		// Ruta para pdfs
		var pdfPath = 'assets/pdf.js-viewer/pdf.worker.js';
		// Ruta del navegador
		var url = new URL(window.location.href);
		// Si es local añado la barra
		if(url.pathname === '/'){
			pdfPath = '/' + pdfPath;
		}
		
    pdfjsViewerConfigProvider.setWorkerSrc(pdfPath);
  }]);


  angular.module('gp4App').run(function($templateCache, $window, $rootScope,uiGridEditConstants,ixStatusService, cfg, $location) {
    //Al sobreescriure els templates del check de sel·lecció de row, si aquest conté un control, la grid no creix correctament al aplicar filtres.
    /*$templateCache.put('ui-grid/selectionRowHeaderButtons',
      "<div class=\"ui-grid-selection-row-header-buttons \" ng-class=\"{'ui-grid-row-selected': row.isSelected}\"><div class=\"checkbox\" abm-checkbox style=\"padding: 0px;\"><input style=\"margin: 0; vertical-align: middle\" type=\"checkbox\" ng-model=\"row.isSelected\" ng-click=\"row.isSelected=!row.isSelected;selectButtonClick(row, $event)\">&nbsp;</div></div>"
    );*/
    /*$templateCache.put('ui-grid/selectionSelectAllButtons',
      "<div class=\"ui-grid-selection-row-header-buttons \" ng-class=\"{'ui-grid-all-selected': grid.selection.selectAll}\" ng-if=\"grid.options.enableSelectAll\"><div class=\"checkbox\" abm-checkbox style=\"margin-left: 3px;margin-top: -3px;\"><input style=\"margin: 0; vertical-align: middle\" type=\"checkbox\" ng-model=\"grid.selection.selectAll\" ng-click=\"grid.selection.selectAll=!grid.selection.selectAll;headerButtonClick($event)\"></div></div>"
    );*/

    $templateCache.put("TEMA_GRID/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
    $templateCache.put("TEMA_GRID/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
    $templateCache.put("select2/no-choice.tpl.html","<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
    $templateCache.put("TEMA_GRID/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
    $templateCache.put("TEMA_GRID/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");

    $templateCache.put("TEMA_GRID/match.tpl.html","<div class=\"ui-grid-cell\"><div class=\"ui-grid-cell-contents\" ng-click=\"$select.toggle($event)\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></div></div>");


    $templateCache.put('checkboxCell', '<div class="checkbox" abm-checkbox><input type="checkbox" ng-checked="COL_FIELD" ng-model="MODEL_COL_FIELD" ix-ui-grid-checkbox ng-disabled="$parent.$parent.grid.api.ix.disableField($parent.$parent, col)" ng-click="checkboxClick($parent.$parent, $parent.$parent.col)"></div>');
    $templateCache.put('checkboxCellFT', '<div class="checkbox" abm-checkbox><input type="checkbox" ng-checked="{{ COL_FIELD == 1 }}" ng-model="MODEL_COL_FIELD" ix-ui-grid-checkbox ng-disabled="$parent.$parent.grid.api.ix.disableField($parent.$parent, col)" ng-click="checkboxClick($parent.$parent, $parent.$parent.col)"></div>');
    //$templateCache.put('checkboxEditCell', '<div class="ix-cell-focus checkbox" abm-checkbox><input type="checkbox" ng-model="MODEL_COL_FIELD" ix-ui-grid-checkbox ng-checked="COL_FIELD" ng-disabled="$parent.$parent.grid.api.ix.disableField($parent.$parent, col)" ng-click="$parent.$parent.grid.api.ix.checkboxClick($parent.$parent, $parent.$parent.col)"></div>');


		//$templateCache.put('checkboxCell', '<div class="checkbox" abm-checkbox><input type="checkbox" ng-checked="COL_FIELD" ng-model="MODEL_COL_FIELD" ng-disabled="!$parent.$parent.grid.api.ix.status.editing || $parent.col.colDef.noeditable || $parent.$parent.row.entity.obligatorio || $parent.$parent.grid.api.ix.disableField($parent, col)" ng-click="$parent.$parent.grid.api.ix.checkboxClick($parent.$parent.$parent.$parent.$parent, $parent.$parent.col)"></div>');
    //$templateCache.put('checkboxEditCell', '<div class="ix-cell-focus checkbox" abm-checkbox><input type="checkbox" ng-model="MODEL_COL_FIELD" ix-ui-grid-checkbox ng-checked="COL_FIELD" ng-click="$parent.$parent.grid.api.ix.checkboxClick($parent.$parent.$parent.$parent.$parent, $parent.$parent.col)"></div>');
    $templateCache.put('iconCell', '<div ng-dblclick="$parent.grid.api.ix.showPopup($parent, col, $event)" class ="ui-grid-cell-contents"><i ng-click="$parent.grid.api.ix.showPopup($parent, col)" class="fa fa-fw fa-edit"></i></div>');
    $templateCache.put('listCellNormal', '<div class=\"ui-grid-cell-contents\" title=\"MODEL_COL_FIELD\"><textarea style=\"border: 0; width: 100%; height: 100%">{{MODEL_COL_FIELD CUSTOM_FILTERS}}</textarea></div>');
    // BIOTECNAL: afegim un ng-style perque el textarea s'adapti al rowHeight del grid
    $templateCache.put('listCell', '<form class=""><textarea ui-grid-editor ng-model="MODEL_COL_FIELD" ng-style=\"{height: (col.grid.options.rowHeight - 1) + \'px\'}\" style=\"width: 100%; overflow: auto;">{{MODEL_COL_FIELD CUSTOM_FILTERS}}</textarea></form>');
    $templateCache.put('listCellFT', '<form class=""><textarea autosize ui-grid-editor ng-model="MODEL_COL_FIELD" ng-style=\"{height: (col.grid.options.rowHeight - 1) + \'px\'}\" style=\"width: 100%; overflow: hidden;">{{MODEL_COL_FIELD CUSTOM_FILTERS}}</textarea></form>');
    //Arnau: Aquests 3 radio a continuació són de la Extranet. Moure-ho en quan tinguem els paquets de bower.
    $templateCache.put('radioPeticioTransportCell', '<input type="radio" ng-model="$parent.grid.appScope.idDestino" ng-value="$parent.row.entity.destino" ng-disabled="!$parent.grid.api.ix.status.editing || col.colDef.noeditable || $parent.row.entity.obligatorio" ng-change="$parent.grid.appScope.setValue(\'idDestino\', $parent.row.entity.destino)" />');
    $templateCache.put('radioPeticioTransportDistCell', '<input type="radio" ng-show="$parent.grid.appScope.idDestino == $parent.row.entity.destino" ng-model="$parent.grid.appScope.distribucionRecojo" value="D" ng-disabled="!$parent.grid.api.ix.status.editing || col.colDef.noeditable || $parent.row.entity.obligatorio" ng-change="$parent.grid.appScope.setValue(\'distribucionRecojo\', $parent.grid.appScope.distribucionRecojo)" />');
    $templateCache.put('radioPeticioTransportRecCell', '<input type="radio" ng-show="$parent.grid.appScope.idDestino == $parent.row.entity.destino" ng-model="$parent.grid.appScope.distribucionRecojo" value="R" ng-disabled="!$parent.grid.api.ix.status.editing || col.colDef.noeditable || $parent.row.entity.obligatorio" ng-change="$parent.grid.appScope.setValue(\'distribucionRecojo\', $parent.grid.appScope.distribucionRecojo)" />');


    //Grid
    $templateCache.put('app/base/views/grid/ixGridProgress', '<div class="ui-grid-cell-contents" title="TOOLTIP"><uib-progressbar value="COL_FIELD" type="danger" animate="false"></uib-progressbar></div>');
    $templateCache.put('app/base/views/grid/uiGridSortableCell', '<div><div class="ui-grid-cell-contents" ng-click="grid.appScope.orderInRow(grid, row, col)" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}} <i ng-class="{ \'ui-grid-icon-up-dir\': row.entity.orderby == \'asc\', \'ui-grid-icon-down-dir\': row.entity.orderby == \'desc\' }"><sub ui-grid-visible="grid.appScope.isSortPriorityVisible(grid, row, col)" class="ui-grid-sort-priority-number">{{row.priority + 1}}</sub></i></div></div>');

		$templateCache.put('app/base/views/helpers_templates/ixGridColor', '<div class="ui-grid-cell-contents" title="TOOLTIP" ix-ui-color-grid-cell ng-model="MODEL_COL_FIELD" col="col"></div>');


    var windowElement = angular.element($window);
    windowElement.on('beforeunload', function (event) {
      // Si tenemos alguna aplicacion abierta en modo edicion avisamos
      if(ixStatusService.availApps.filter(function(app) {return app.editing}).length>0) {
        event.preventDefault();
      }
    });

    var deregisterationCallback = $rootScope.$on('$locationChangeStart', function( event, next, current, newState, oldState) {
      //La idea final és guardar a localStorage l'objecte actual per id, el ixStatusService haurà de recuperar del localStorage.
      //Guardo la info actual i el path de la vista on anirem, per tant, ixStatusService hauria de agafar la info guardada amb el valor de next.
      //Per el que sigui, això no acaba de funcionar, ho comento i al fer F5 simplement redirecciono al desktop.
      /*localStorage.setItem(current, JSON.stringify(ixStatusService.current));
      localStorage.setItem("getview", next);*/
      if($location.path().lastIndexOf('/') == 0){
        $rootScope.fromDesktop = true;
      }
      if(next === current && (((newState != oldState)))){
        event.defaultPrevented = true;//NO naveguem
        return;//sortim de la funcio
      }
      if(next === current && $location.path() !== "/" && $location.path() !== "/login"){
        $location.path("/");
      } else {								
//				if($location.path() !== "/login" && (typeof(sessionStorage['force_reset_password']) == "string" && sessionStorage['force_reset_password'] == "true") 
//					 || (typeof(sessionStorage['force_reset_password']) == "boolean" && sessionStorage['force_reset_password'])) {
//					$location.path('/changePassword');
				if(current.indexOf('changePasswordCodigo') > -1){
					if (current.indexOf('force_reset_password') > -1 && $location.search().force_reset_password == "1"){															
						$location.path('/changePasswordCodigo').search({force_reset_password: 1, usuario: $location.search().usuario, codigo: $location.search().codigo});
					}
				} else if($location.path() === "/") { 
					var pageAnimationSuffix = ""; 
					if (angular.isDefined(cfg.pageAnimation) && cfg.pageAnimation != "")
						pageAnimationSuffix = "-" + cfg.pageAnimation;

					$rootScope.pageAnimationClass = 'page-animation-bottom' + pageAnimationSuffix; 					
				}
			}
      
    });

    $rootScope.$on('$destroy', deregisterationCallback);


  });



  angular.module('gp4App').directive('ixMenu33', [ function() {
    return {
      restrict: "E",
      replace: true,
      scope: {
        menu: '=',
        subMenu: '=?'
      },
			template: '<ul class="dropdown-menu"><ix-menu-item33 ng-repeat="item in menu.children" item="item" sub-menu="subMenu"></ix-menu-item33></ul>'
      //template: '<ul class="dropdown-menu"><ix-sub-menu-item33 ng-repeat="item in menu.children" item="item">{{item.display}}</ix-sub-menu-item33></ul>'
    };
  }]);

  angular.module('gp4App').directive('ixMenuItem33', ['$compile','ixStatusService', '$log', '$timeout', function ($compile,ixStatusService, $log, $timeout) {
    return {
      restrict: "E",
      replace: true,
      scope: {
        item: "=",
        subMenu: '@?'
      },
      //template: '<li><a ng-href="{{item.href}}"><i data-ng-class="item.icon" class="fa fa-fw"></i> {{item.display}}<span class="caret" ng-if="item.children.length>0"></span></a></li>',
			template: '<li><a ng-href="{{::item.href}}"><i ng-if="!item.customType" class="material-icons">{{::item.icon}}</i><img ng-if="item.customType" class="material-icons" ng-src="{{::item.icon}}"> <translate>{{::item.display}}</translate><span class="caret" ng-if="item.children.length>0"></span></a></li>',
      link: function (scope, element) {
        if (angular.isArray(scope.item.children)) {
          if(scope.subMenu){
            element.bind('click', function (ev, elem) { 
              ev.stopPropagation(); 
            });  
          }
          
          element.append("<ix-menu33 menu='item' sub-menu='true'></ix-menu33>");
          $compile(element.contents())(scope);
        } else {
          element.bind('click', function (ev) {
            $timeout(function(){
              ixStatusService.openApp(scope.item);
            },100);
            ev.preventDefault();
            angular.element("#main-menu").smartmenus('refresh').hide();
            angular.element("#main-menu").smartmenus('refresh').show();
           // Biotecnal: tancar el navBar
            var parent = scope;
            while (parent && parent.$parent) {
                parent = parent.$parent;
                if (parent.hasOwnProperty('navbarOpen')) {
                    parent.navbarOpen = false;
                    parent.$applyAsync();
                    break;
                }
            }

          });
        }
      }
    };
  }]);

  angular.module('gp4App').directive('ixMoreMenuBtn', ['ixStatusService', 'ixMoreMenuService', function(ixStatusService, ixMoreMenuService){
    return {
      restrict: 'E',
      replace: true,
      scope: {
        item: '='
      },
      template: '<button count="{{ numberApps() }}">more {{ numberApps() }}</button>',
      link: function(scope, element){
        scope.numberApps = function(){
          return ixMoreMenuService.getNumberMenus();
        };
      }
    }
  }]);

	angular.module('gp4App').directive('ixSubMenu33', [ function() {
    return {
      restrict: "E",
      replace: true,
      scope: {
        menu: '='
      },
      template: '<ul class="dropdown-menu"><ix-sub-menu-item33 ng-repeat="item in menu.children" item="item">{{::item.display}}</ix-sub-menu-item33></ul>'
    };
  }]);

	angular.module('gp4App').directive('ixSubMenuItem33', ['$compile','ixStatusService', '$log', function ($compile,ixStatusService, $log) {
    return {
      restrict: "E",
      replace: true,
      scope: {
        item: "="
      },
      template: '<li ng-class="{\'dropdown dropdown-submenu\':haveChildren()}" ng-click="openSubMenu($event)"><a  class="dropdown-toggle" data-toggle="dropdown" ng-href="{{item.href}}"><i data-ng-class="item.icon" class="fa fa-fw"></i> {{item.display}}</a></li>', 			
      link: function (scope, element) {
				scope.haveChildren = function() {
					return angular.isArray(scope.item.children);
				}
				scope.openSubMenu = function($event) {
					$event.preventDefault();
					$event.stopPropagation();
					element.siblings().removeClass('open');
					element.toggleClass('open');
				}
				if (angular.isArray(scope.item.children)) {
          element.append("<ix-sub-menu33 menu='item'></ix-sub-menu33>");
          $compile(element.contents())(scope);
        } else {
          element.bind('click', function () {
            ixStatusService.openApp(scope.item);
          });
        }
      }
    };
  }]);

  angular.module('gp4App').directive('ixToolBar', [ "$http", "cfg", "ixStatusService", function($http, cfg, ixStatusService) {
    return {
      restrict: "E",
      replace: true,
      scope: true,
      transclude: true,
      templateUrl: 'app/base/views/framework_templates/ixToolBar.html',
      link: function(scope, elem, attrs){
        scope.hideHeader = false;
        scope.hideButtons = false;
        scope.specialToolBar = false;
        if(angular.isDefined(attrs.hideheader) && attrs.hideheader == "true"){
          scope.hideHeader = true;
        }
        if(angular.isDefined(attrs.hidebuttons) && attrs.hidebuttons == "true"){
          scope.hideButtons = true;
        }
        if(angular.isDefined(attrs.specialToolBar) && attrs.specialToolBar == "true"){
          scope.specialToolBar = true;
        }
        //open popup
        scope.openPopup = function(responseData){
          scope.openModal("app/base/views/framework_templates/ixErrorsPopup.html", scope, "small");
        };
        scope.downloadTxt = function(responseData){
          var errorsTxt = "";
          angular.forEach(scope.status.response.data.Errors, function(err){
            if(angular.isDefined(err) && err != null)
              errorsTxt += err.Msg+"\r\n";
          });
          if((angular.isDefined(scope.status.response.data.obj)) && scope.status.response.data.obj.Errors){
            angular.forEach(scope.status.response.data.obj.Errors, function(err){
              if(angular.isDefined(err) && err != null)
                errorsTxt += err.Msg+"\r\n";
            });
          }
          angular.forEach(scope.status.response.data.Inserted, function(ins){
            angular.forEach(ins.Errors, function(err){
              if(angular.isDefined(err) && err != null)
                errorsTxt += err.Msg+"\r\n";
            });
          });
          angular.forEach(scope.status.response.data.Updated, function(upd){
            angular.forEach(upd.Errors, function(err){
              if(angular.isDefined(err) && err != null)
                errorsTxt += err.Msg+"\r\n";
            });
          });
          angular.forEach(scope.status.response.data.Deleted, function(del){
            angular.forEach(del.Errors, function(err){
              if(angular.isDefined(err) && err != null)
                errorsTxt += err.Msg+"\r\n";
            });
          });
          angular.forEach(scope.status.response.data.Processed, function(proc){
            angular.forEach(proc.Errors, function(err){
              if(angular.isDefined(err) && err != null)
                errorsTxt += err.Msg+"\r\n";
            });
          });

          var nombrePantalla = scope.status.display.split(" ").join("_");
          var data = new Blob([errorsTxt], { type: 'text/plain;charset=utf-8' });
          saveAs(data, "errores_"+nombrePantalla+".txt");
        };

        scope.downloadExcel = function(jsonError){
          var url = "";
          if(angular.isArray(angular.fromJson(jsonError)))
            url = "Download";
          else
            url = "DownloadSingle";
          var config = {responseType:"arraybuffer"};
          $http.post(cfg.baseURL + 'json_to_excel/' + url, jsonError, config).then(function(r){
            var file = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
            var filename = "error.xlsx";
            if(r.headers('Content-Disposition')) {
              filename = r.headers('Content-Disposition').split("=")[1];
            }
            saveAs(file, filename);
          }, function(err){
            ixStatusService.setResponse(err);
          });
        };
      }
    };
  }]);


  angular.module('gp4App').directive('ixGridToolBar', [ function() {
    return {
      restrict: "E",
      replace: true,
      scope: true,
      templateUrl: 'app/base/views/framework_templates/ixGridToolBar.html'
    };
  }]);
  
  angular.module('gp4App').directive('ixPopupToolBar', [ '$parse', function($parse) {
    return {
      restrict: "E",
      replace: true,
      scope: true,
      transclude: true,
      templateUrl: 'app/base/views/framework_templates/ixPopupToolBar.html',
      link: function(scope, elem, attrs){
        (attrs.titleLeft) ? scope.titleLeft = attrs.titleLeft : scope.titleLeft = "";
        (attrs.subtitleLeft) ? scope.subtitleLeft = attrs.subtitleLeft : scope.subtitleLeft = "";
        (attrs.titleCenter) ? scope.titleCenter = attrs.titleCenter : scope.titleCenter = "";
        (attrs.subtitleCenter) ? scope.subtitleCenter = attrs.subtitleCenter : scope.subtitleCenter = "";
        if(angular.isDefined(attrs.okBtnText)) scope.okBtnText = attrs.okBtnText;
        if(angular.isDefined(attrs.closeBtnText)) scope.closeBtnText = attrs.closeBtnText;

        if(angular.isDefined(attrs.hideAll)) scope.hideAll = true;

        if(attrs.titleLeftParam){
          scope.$watch(attrs.titleLeftParam, function(val){
            scope.titleLeftParam = val;
          });
        } else {
          scope.titleLeftParam = "";
        }

        if(attrs.titleCenterParam){
          scope.$watch(attrs.titleCenterParam, function(val){
            scope.titleCenterParam = val;
          });
        } else {
          scope.titleCenterParam = "";
        }
   
        if(attrs.subtitleLeftParam){
          scope.$watch(attrs.subtitleLeftParam, function(val){
            scope.subtitleLeftParam = val;
          });
        } else {
          scope.subtitleLeftParam = "";
        }

        if(attrs.subtitleCenterParam){
          scope.$watch(attrs.subtitleCenterParam, function(val){
            scope.subtitleCenterParam = val;
          });
        } else {
          scope.subtitleCenterParam = "";
        }


      }
    };
  }]);

  angular.module('gp4App').directive('ixCestaVehiculos', [ 'ixCestaVehiculosService', 'ixStatusService', 'cfg', function(ixCestaVehiculosService, ixStatusService, cfg){
    return {
      restrict: "E",
      replace: true,
      template: '<a ng-show="isVisible()" ng-click="openPopup()"><i class="fa fa-car fa-lg"></i><span class="badge">{{ cesta.getCount() }}</span></a>',
      link: function(scope){

        scope.cesta = ixCestaVehiculosService;

        scope.openPopup = function(){
          if(!ixStatusService.current.bloquearCesta){
            //Agafem l'array i substituim totes les comes per salts de linea. El textarea fa ús d'aquesta variable.
            scope.vehiculos = [];
            if(angular.isDefined(ixCestaVehiculosService.getCesta().items)){
              var cesta = ixCestaVehiculosService.getCesta();
              scope.vehiculos = cesta.items.toString().replace(/,/g , "\n");
              scope.campo = cesta.campo;
              scope.terminacion = cesta.terminacion;
              scope.excluir = cesta.excluir;
              scope.cortar = cesta.cortar;
              scope.clientId = cfg.clientId;
            }
            scope.openModal('app/base/views/helpers_templates/ixCestaVehiculosModal.html', scope, 'med').then(function(){
              ixCestaVehiculosService.saveCesta({items: scope.vehiculos, campo: scope.campo, terminacion: scope.terminacion, cortar: scope.cortar, excluir: scope.excluir });
              var options = ixCestaVehiculosService.getOptions();
              if(ixStatusService.current.data != null && options.requestDataAfterSave !== false){
                if(angular.isDefined(options.actionFunction) && angular.isFunction(options.actionFunction)){
                  options.actionFunction();
                }
                else if(angular.isDefined(options.actionGrid) && angular.isFunction(options.actionGrid)){
                  options.actionGrid().ixLoadInitialData();
                } else {
                  ixStatusService.current.data.grid.ixLoadInitialData();
                }
              }

            });
          }
          
        }

        scope.vaciarCesta = function(){
          scope.vehiculos = ixCestaVehiculosService.emptyCesta().items;
        }

        scope.isVisible = function(){
          return ixCestaVehiculosService.isShowing();
        }
      }
    }
  }]);

  angular.module('gp4App').directive('ixBuscaFichaBastidor', [ '$http', '$uibModal', 'cfg', 'ixUtilsService', 'ixFichaBastidorPopup', '$location', '$timeout', 
  'ixStatusService', 'ixFichaOrdenTransportePopup', 'authService', '$q', function($http, $uibModal, cfg, ixUtilsService, ixFichaBastidorPopup, $location, $timeout, 
    ixStatusService, ixFichaOrdenTransportePopup, authService, $q){
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      minLength: '@?',
      template: '@',
			templateOrdenTransporte: '@?'
    },
    templateUrl: 'app/base/views/helpers_templates/ixBuscaFichaBastidor.html',
    link: function(scope, elem, attrs){

      var cancellerCompleteLoad;

			ixUtilsService.checkPermission("VerGrupoBusquedaVin").then(function(data){
				scope.ver_grupo = data;
			});
      scope.buscar = function(){

				var tieneModuloLMS = authService.tieneModuloLMS();
        scope.listItems = [];
				if(tieneModuloLMS){
					scope.listItemsConjunto = [];
					scope.listItemsOrdenesTransporte = [];
				}

        if(scope.filtreVIN && scope.filtreVIN.length >= scope.minLength){
          var params = {Filters: [], OrderBy: []};
          params.Filters.push({ Field: "chasis", Value: scope.filtreVIN, Operator: CMP_LIKE, Skip: true });
					params.Filters.push({ Field: "matricula", Value: scope.filtreVIN, Operator: CMP_LIKE, Or: true, Skip: true });

          var gp4Url = "select_bastidor/Search";
          var extranetUrl = "bastidores/GetList";


          if(angular.isDefined(cancellerCompleteLoad)){
            cancellerCompleteLoad.resolve();
          }
          cancellerCompleteLoad = $q.defer();

					var url = "";
					if(cfg.clientId == "Extranet" || cfg.clientId == "ExtranetVideo" || cfg.clientId == "Gestpark-Internet"){
						url = extranetUrl;
						params.OrderBy = [ "-FechaEntrada", "VIN", "Matricula" ];
					} else {
						url = gp4Url;
						params.OrderBy = [ "-fecha_ent", "vin", "matricula" ];
					}

          var requestCampa = $http({
            url: cfg.baseURL + url,
            data: params,
            timeout: cancellerCompleteLoad.promise,
            method: "POST"
          });
          //$http.post(cfg.baseURL + url, params).then(function(response){
          requestCampa.then(function(response){
            scope.listItems = response.data.Items;
            convertDateStringsToDates(scope.listItems);
          });

					//TODO: Ver como se puede especializar, es una llamada que solo tendrá que hacer GP4.
					if(tieneModuloLMS){
						var paramsConjunto = {Filters: [], OrderBy: []};
						paramsConjunto.Filters.push({ Field: "google", Value: scope.filtreVIN, Operator: CMP_LIKE, Skip: true });

            var requestLMSConjunto = $http({
              url: cfg.baseURL + "select_conjunto/Search",
              data: paramsConjunto,
              timeout: cancellerCompleteLoad.promise,
              method: "POST"
            });
						//$http.post(cfg.baseURL + "select_conjunto/Search", paramsConjunto).then(function(response){
            requestLMSConjunto.then(function(response){
							scope.listItemsConjunto = response.data.Items;
							convertDateStringsToDates(scope.listItemsConjunto);
						});

						var paramsOrdenesTransporte = {Filters: [], OrderBy: []};
						paramsOrdenesTransporte.Filters.push({ Field: "google", Value: scope.filtreVIN, Operator: CMP_LIKE, Skip: true });

            var requestLMSOrdenesTransporte = $http({
              url: cfg.baseURL + "select_ordenes_transporte/Search",
              data: paramsOrdenesTransporte,
              timeout: cancellerCompleteLoad.promise,
              method: "POST"
            });

            requestLMSOrdenesTransporte.then(function(response){
						//$http.post(cfg.baseURL + "select_ordenes_transporte/Search", paramsOrdenesTransporte).then(function(response){
							scope.listItemsOrdenesTransporte = response.data.Items;
							convertDateStringsToDates(scope.listItemsOrdenesTransporte);
						});
					}
        }
      }
      /*scope.abrirCerrar = function(abrir){
        scope.abrir = abrir;
      }*/

      scope.clearSearch = function(){
        scope.filtreVIN = "";
      }

      scope.open = function(item){
        //scope.abrirCerrar(false);
        scope.title = "Ficha bastidor";
        scope.VIN = item.VIN || item.vin;
				scope.Matricula = item.Matricula || item.matricula;
        scope.Grupo = item.Grupo || item.grupo;
        scope.Movimiento = item.Movimiento || item.movimiento;
        scope.Marca = item.Marca;
        scope.Modelo = item.Modelo;
        scope.FechaEntrada = item.FechaEntrada;
        scope.FechaSalida = item.FechaSalida;
        scope.Cliente = item.Cliente;
        scope.Clientenombre = item.Clientenombre;
        scope.Cuenta = item.Cuenta;
        scope.Cuentanombre = item.Cuentanombre;
        if(angular.isDefined(item.estado_gp)){
          scope.estado_gp = item.estado_gp;
        }
        if(angular.isDefined(item.estado_personalizado)){
          scope.estado_personalizado = item.estado_personalizado;
					scope.estado_gp += " - " + item.estado_personalizado;
        }


				var optionsPopup = { controller: ixFichaBastidorPopup.controlador };
				var paramsPopup = { title: scope.title, VIN: scope.VIN, Matricula: scope.Matricula, Grupo: scope.Grupo, Movimiento: scope.Movimiento, Marca: scope.Marca, Modelo: scope.Modelo, FechaEntrada: scope.FechaEntrada, FechaSalida: scope.FechaSalida, estado_gp: scope.estado_gp, estado_personalizado: scope.estado_personalizado, Cliente: scope.Cliente, Cuenta: scope.Cuenta };

				ixUtilsService.openModalV2(scope.template, optionsPopup, "big", paramsPopup);

        scope.filtreVIN = "";
      }

			scope.openFichaCamion = function(item){
				var atributos = {};
				var atributosTitleObj = {};
				var displayAttr = "";
				var app = {};
				var claves = Object.keys(atributos);
				app.icon = "local_shipping";
				app.display = "Ficha Camion";
				app.groupname = item.conjunto;
				app.href = "FichaCamion";
				app.atributos = "conjunto=" + item.conjunto;
				if($location.path() != "/")
					app.onCloseGoToPrev = true;
				$timeout(function(){
					ixStatusService.openApp(app).bind(ixStatusService);
				},1);

				scope.filtreVIN = "";
			};

			scope.openFichaOrdenTransporte = function(item){
				//scope.abrirCerrar(false);
        scope.title = "Ficha orden transporte";
				scope.contador = item.contador;
				scope.numero_tramo = item.numero_tramo;
				scope.planificacion = item.planificacion;
        scope.VIN = item.chasis;
				scope.Matricula = item.matricula;
        scope.Grupo = item.grupo;
        scope.Marca = item.marca;
        scope.Modelo = item.modelo;
        scope.FechaSalida = item.fecha_salida;
        scope.FechaDescarga = item.fecha_descarga;
        if(angular.isDefined(item.estado)){
          scope.estado = item.estado;
        }

				var optionsPopup = { controller: ixFichaOrdenTransportePopup.controlador };
				var paramsPopup = { title: scope.title, contador: scope.contador, numero_tramo: scope.numero_tramo, planificacion: scope.planificacion, VIN: scope.VIN, Matricula: scope.Matricula, Grupo: scope.Grupo, Movimiento: scope.Movimiento, Marca: scope.Marca, Modelo: scope.Modelo, FechaSalida: scope.FechaSalida, FechaDescarga: scope.FechaDescarga, estado: scope.estado };

				ixUtilsService.openModalV2(scope.templateOrdenTransporte, optionsPopup, "big", paramsPopup);

        scope.filtreVIN = "";
			};

      scope.$watch('filtreVIN', function(){
        scope.buscar();
      });
    }
  }
}]);

angular.module('gp4App').directive("onReadFile", [ '$parse', function ($parse) {
  return {
      restrict: 'A',
      scope: false,
      link: function(scope, element, attrs) {
          element.bind('change', function(e) {
              
              var onFileReadFn = $parse(attrs.onReadFile);
              var reader = new FileReader();
              
              reader.onload = function() {
                  var fileContents = reader.result;
                  // invoke parsed function on scope
                  // special syntax for passing in data
                  // to named parameters
                  // in the parsed function
                  // we are providing a value for the property 'contents'
                  // in the scope we pass in to the function
                  scope.$apply(function() {
                      onFileReadFn(scope, {
                          'contents' : fileContents
                      });
                  });
              };
              reader.readAsText(element[0].files[0]);
          });
      }
  };
}]);
  //scrollbars

  angular.module('gp4App').config(['ScrollBarsProvider',function (ScrollBarsProvider) {
    ScrollBarsProvider.defaults = {
      scrollButtons: {
        scrollAmount: 'auto', // scroll amount when button pressed
        enable: false // enable scrolling buttons by default
      },
      axis: 'y', // enable 2 axis scrollbars by default
      autoHideScrollbar: false,
      theme: 'gp4',
      advanced:{
        updateOnContentResize: true
      }
    };
  }]);
})();

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
"use strict"

angular.module('FTBonpreuApp')
.config(['$routeProvider', function ($routeProvider) {
  $routeProvider
    .when('/MantenimientosBP/:entity', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBonpreu/MantenimientosBP"; } } })
    .when('/ListadosFtBP/Listado_ficheros_proveedores', {templateUrl: 'app/FTBonpreu/ListadosFtBP/listado_ficheros_proveedores_bp.html', controller: 'ListadoFicherosProveedoresBPController'})
    .when('/ListadosFtBP/Listado_Ft_Bp', { templateUrl: 'app/FTBonpreu/ListadosFtBP/listado_ft_bp.html', controller: 'Listado_Ft_BpController'})
    .when('/ListadosFtBP/Tirajes_Etiquetado', { templateUrl: 'app/FTBonpreu/ListadosFtBP/lista_tirajes_etiquetado.html', controller: 'TirajesEtiquetadoController'})
    .when('/ListadosFtBP/Listado_ficheros_ft', {templateUrl: 'app/FTBonpreu/ListadosFtBP/listado_ficheros_ft_bp.html', controller: 'ListadoFicherosFtBPController'})
    .when('/ListadosFtBP/Listado_proveedores', {templateUrl: 'app/FTBonpreu/ListadosFtBP/listado_proveedores_bp.html', controller: 'ListadoProveedoresBPController'})
    .when('/ListadosFtBP/Listado_empresas_plantas', {templateUrl: 'app/FTBonpreu/ListadosFtBP/listado_empresas_plantas_bp.html', controller: 'ListadoEmpresasPlantasBPController'})
    .when('/ListadosFtBP/Listado_plantas_productos', {templateUrl: 'app/FTBonpreu/ListadosFtBP/listado_plantas_productos_bp.html', controller: 'ListadoPlantasProductosBPController'})
    .when('/ListadosFTBP/Busqueda_Avanzada', { templateUrl: 'app/FTBonpreu/ListadosFtBP/busqueda_avanzada_bp.html', controller: 'Busqueda_AvanzadaBPController'})
    .when('/FormularioFtBP/list',{ templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBonpreu"; }, entity: function($route) { $route.current.params.entity = "FormularioFtBP"; } } })
    .when('/Recepcion/Configuracion', { templateUrl: 'app/FTBonpreu/Recepcion/Configuracion/configPreguntasRecepcion.html', controller: 'ConfigPreguntasRecepcionController' })
    .when('/Recepcion/ListadoProductos', { templateUrl: 'app/FTBonpreu/Recepcion/ListadoProductos/listadoProductosRecepcion.html', controller: 'ListadoProductosRecepcionController' })
    .when('/Recepcion/Vista', { templateUrl: 'app/FTBonpreu/Recepcion/vistaRecepcion.html', controller: 'VistaRecepcionController' })
    //.when('/Recepcion/Vista', { templateUrl: 'app/FTBonpreu/Recepcion/recepcionForm.html', controller: 'FormRecepcionController' })
    .when('/GestionAnaliticasBP/Listado_planificacion_analiticas', { templateUrl: 'app/FTBonpreu/GestionAnaliticasBP/listado_plan_analiticas_bp.html', controller: 'ListadoPlanificacionController' })
    .when('/GestionAnaliticasBP/Listado_resultados_analisis', { templateUrl: 'app/FTBonpreu/GestionAnaliticasBP/listado_resultados_analisis.html', controller: 'ListadoResultadosAnalisisController', resolve: { module: function($route) { $route.current.params.moule = "app/FTBonpreu/GestionAnaliticasBP"; } } })
    .when('/GestionAnaliticasBP/Listado_nc_analisis', { templateUrl: 'app/FTBonpreu/GestionAnaliticasBP/listado_nc_analiticas.html', controller: 'ListadoNcAnalisisController' })
    .when('/GestionAnaliticasBP/Carga_masiva', { templateUrl: 'app/FTBonpreu/GestionAnaliticasBP/carga_masiva_planificacion_analiticas_ft.html', controller: 'CargaMasivaPlanificacionesAnaliticasFTController'})
    .when('/Contactos/:productos', { templateUrl: 'app/FTBonpreu/Contactos/pagina_contacto.html', controller: 'PaginaContactosController'})
    //Para extraer
    //.when('/ayuda',{templateUrl:'app/Global/Administracion/ArchivosAyuda/archivos_ayuda.html', controller:'ArchivosAyudaController'})

    // .when('/ayuda', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBonpreu/Manuales"; $route.current.params.entity = "ayuda"; $route.current.params.readOnly = true; } } })
    // .when('/Administracion/archivos_ayuda',{templateUrl:'app/Global/Administracion/ArchivosAyuda/archivos_ayuda.html', controller:'ArchivosAyudaController'})
    .when('/ayuda',{templateUrl:'app/FTBonpreu/Manuales/ArchivosAyuda/archivos_ayuda.html', controller:'ArchivosAyudaController'})

    //Listados Alarmas
    .when('/ListadosAlarmas/estado_fuera_plazo', { templateUrl: 'app/base/views/gridEditor.html', controller: 'AlarmaBP_Estado_Fuera_PlazoController' })
    .when('/ListadosAlarmas/expiracion_certificados', { templateUrl: 'app/base/views/gridEditor.html', controller: 'AlarmaBP_Expiracion_CertificadosController' })
    .when('/ListadosAlarmas/actualizacion_ft', { templateUrl: 'app/base/views/gridEditor.html', controller: 'AlarmaBP_Actualizacion_FTController' })
}]);

angular.module('FTBonpreuApp').constant('idiomasFTBP', [
	{
		codigo: "ca",
		descripcion: "Catalán",
		icon: "assets/images/flags/catalonia.png"
	},
	{
		codigo: "es",
		descripcion: "Castellano",
		icon: "assets/images/flags/es.png"
	}
]);

angular.module('gp4App').requires.push("FTBonpreuApp");

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
"use strict"

angular.module('FTBase', ['gp4Controllers', 'pdfjsViewer', 'nzToggle' ])
.config(['$routeProvider', function ($routeProvider) {
	$routeProvider
    //
		//.when('/FTBase/Listado1',{templateUrl:'app/base/views/gridEditor.html', controller:'FichasTecnicasAgrupacionController'})

		.when('/herramientas/cambioestadomasivo', { templateUrl: 'app/FTBase/Herramientas/cambio_estado_masivo.html', controller: 'CambioEstadoMasivoController' })
		.when('/herramientas/cambioeancodinternomasivo', { templateUrl: 'app/FTBase/Herramientas/eans_cod_interno_masivo.html', controller: 'EansCodInternoMasivoController' })

		//Configuración FT
		.when('/ConfiguracionPreguntas/ft_preguntas', { templateUrl: 'app/base/views/gridEditor.html', controller: 'ConfigPreguntasController' })
		.when('/ConfiguracionPreguntas/:entity', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBase/ConfiguracionPreguntas"; } } })

		//Mantenimientos
		.when('/Mantenimientos/:entity/:id', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBase/Mantenimientos"; } } })
		.when('/Mantenimientos/:entity', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBase/Mantenimientos"; } } })
		.when('/MantenimientosEuromadi/:entity', { templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBase/MantenimientosEuromadi"; } } })

		//Listados
		.when('/ListadosFT/Listado_Ft', { templateUrl: 'app/FTBase/ListadosFT/listado_ft.html', controller: 'Listado_FtController'})
		.when('/ListadosFT/Listado_ProductosFt', { templateUrl: 'app/FTBase/ListadosFT/listado_productos_ft.html', controller: 'Listado_Productos_FtController'})
		.when('/ListadosFT/Listado_Productos_Marca', { templateUrl: 'app/FTBase/ListadosFT/listado_productos_marca.html', controller: 'Listado_Productos_MarcaController'})
		.when('/ListadosFT/Listado_Proveedores_Ficheros', { templateUrl: 'app/FTBase/ListadosFT/listado_proveedores_ficheros.html', controller: 'Listado_Proveedores_FicherosController'})
		.when('/ListadosFT/Listado_Ft_Fotos_Producto', { templateUrl: 'app/FTBase/ListadosFT/listado_ft_fotos_producto.html', controller: 'Listado_Ft_Fotos_ProductoController'})
		.when('/GestionFichasTecnicas/list',{ templateUrl: 'app/base/views/listEdit.html', controller: 'ListEditController', resolve: { module: function($route) { $route.current.params.module = "app/FTBase"; }, entity: function($route) { $route.current.params.entity = "GestionFichasTecnicas"; } }})
		.when('/ListadosFT/Busqueda_Avanzada', { templateUrl: 'app/FTBase/ListadosFT/busqueda_avanzada.html', controller: 'Busqueda_AvanzadaController'})
		.when('/ListadosFT/Control_presencia_fotos', { templateUrl: 'app/FTBase/ListadosFT/control_presencia_fotos.html', controller: 'Control_presencia_fotosController'})
		.when('/ListadosFT/Listado_analiticas_ft', { templateUrl: 'app/FTBase/ListadosFT/listado_analiticas_ft.html', controller: 'Listado_Analiticas_FTController'})
		.when('/ListadosFT/Descarga_informes_analiticas', { templateUrl: 'app/FTBase/ListadosFT/descarga_informes_analiticas.html', controller: 'Descarga_Informes_AnaliticasController'})
		.when('/Integraciones/Planificaciones_analiticas', { templateUrl: 'app/FTBase/Integraciones/Planificaciones_analiticas/planificacion_analiticas.html', controller: 'PlanificacionAnaliticasController'})
		.when('/ListadosFT/Listado_cambio_estados_ft', { templateUrl: 'app/FTBase/ListadosFT/listado_cambio_estados_ft.html', controller: 'Listado_Cambio_Estados_FtController'})
		.when('/ListadosFT/Listado_control_envio_obs_alergenos_app', {templateUrl: 'app/FTBase/ListadosFT/listado_control_envio_obs_alergenos_app.html', controller: 'Listado_control_envio_obs_alergenos_appController'})
		.when('/ListadosFT/Listado_Fichas_Seguridad', {templateUrl: 'app/FTBase/ListadosFT/listado_emd_fichas_seguridad.html', controller: 'Listado_emd_fichas_seguridadController'})
		.when('/ListadosFt/Carga_Ficheros_FT', {templateUrl: 'app/FTBase/ListadosFT/carga_ficheros_ft.html', controller: 'CargaFicherosFtController'})
		//Versión usando gridEditor.html
		//.when('/HomologacionPlantas/Listado_control_homologacion', { templateUrl: 'app/base/views/gridEditor.html', controller: 'ListadoControlHomologacionController'})
		//Versión con propria página HTML
		.when('/HomologacionPlantas/Listado_control_homologacion', { templateUrl: 'app/FTBase/HomologacionPlantas/listado_control_homologacion.html', controller: 'ListadoControlHomologacionController'})
		.when('/HomologacionPlantas/Listado_resumen_homologacion', { templateUrl: 'app/FTBase/HomologacionPlantas/listado_resumen_homologacion.html', controller: 'ListadoResumenHomologacionController'})

		//Contratos
		.when('/Contratos/extranet_fichas_tecnicas_contratos', { templateUrl: 'app/base/views/gridEditor.html', controller: 'ListaContratosFtController' })

		//Dashboards
		.when('/Dashboards/Dashboard', { templateUrl: 'app/FTBase/Dashboards/Dashboard/dashboard.html', controller: 'DashboardFTController'} )

		//Alarmas
		.when('/Alarmas/estado_fuera_plazo', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Estado_Fuera_PlazoController' })
		.when('/Alarmas/expiracion_certificados', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Expiracion_CertificadosController' })
		.when('/Alarmas/actualizacion_ft', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Actualizacion_FTController' })
		.when('/Alarmas/verificacion_ingredientes', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Verificacion_IngredientesController' })
		.when('/Alarmas/certificados_ficheros', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Certificados_FicherosController' })
		.when('/Alarmas/ingredientes_monitorizar', { templateUrl: 'app/base/views/gridEditor.html', controller: 'Alarma_Ingredientes_MonitorizarController' })
		.when('/Alarmas/ft_revision_propietario', { templateUrl: 'app/base/views/gridEditor.html', controller: 'AlarmaFtRevisionaPropietarioController' })


	;
}]);

angular.module('FTBase').config([ 'pdfjsViewerConfigProvider', function(pdfjsViewerConfigProvider) {
  pdfjsViewerConfigProvider.setWorkerSrc("/assets/pdf.js-viewer/pdf.worker.js");
}]);

angular.module('FTBase').constant('idiomasFT', [
	{
		codigo: "es",
		descripcion: "Español",
		icon: "assets/images/flags/es.png"
	},
	{
		codigo: "pt",
		descripcion: "Portugués",
		icon: "assets/images/flags/pt.png"
	}
]);

angular.module('gp4App').requires.push("FTBase");

/*global ixGetPatchOperations*/
"use strict";

angular.module('FTBase').controller("TiposAuditoriasPlantasController", [ '$scope', '$http', 'cfg', 'ixStatusService', 'ixWarningsService', function($scope, $http, cfg, ixStatusService, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if (!$scope.data.metadataForm)
    $scope.loadMetadata("tipos_auditorias_plantas");

  $scope.data.pk = "id";
  $scope.data.showAsID = "descripcion";
  $scope.data.useModel = true;
  $scope.data.fieldsToFilter = [ "descripcion", "ccp.categoria" ];
  $scope.data.fieldsToOrderBy = [ "descripcion DESC" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "0";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };


  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_auditorias_plantas/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

	$scope.actualizarListado();

  $scope.ixGuardar = function(){
    var data = {};

    if ($scope.data.datos.isNew){
      data.nuevoTipo = $scope.data.datos;
      //Crear nuevo tipo auditoría
      $http.post(cfg.baseURL + "tipos_auditorias_plantas", data.nuevoTipo).then(function(response){
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(response);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar tipo auditoría
      data.tipoAuditoria = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      $http.put(cfg.baseURL + "tipos_auditorias_plantas/" + $scope.data.datos[$scope.data.pk], data.tipoAuditoria).then(function(response){
        ixStatusService.setResponse(response);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
  };

	$scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo auditoría " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	};

	var accionEliminar = function(){
		$http.delete(cfg.baseURL + "tipos_auditorias_plantas/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	};

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("TiposFicherosCertificadosAuditoriasController", ['$scope', '$http', '$routeParams', 'cfg', 'ixStatusService', 'ixUtilsService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, cfg, ixStatusService, ixUtilsService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_fichero_proveedor");
  }
  $scope.data.pk = "id";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_fichero_proveedor/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoLaboratorio = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_fichero_proveedor", data.nuevoLaboratorio).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.laboratorio = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_fichero_proveedor/' + $scope.data.datos[$scope.data.pk], data.laboratorio).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo fichero " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_fichero_proveedor/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }
  
  // $scope.openPopupTraduccion = function(v){
	// 	var template = "app/FTBase/Mantenimientos/tipos_fichero_proveedor/traducciones_tipos_fichero_proveedor.html";
	// 	var optionsPopup = { controller: "TraduccionesTiposFicheroProveedorController" };
	// 	var paramsPopup = { id: $scope.data.datos.id, descripcion: $scope.data.datos.descripcion };
	// 	var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
	// 	popup.then(function (data) {
	// 	});
  // }

}]);

/*global ixGetPatchOperations*/
"use strict";

angular.module('FTBase').controller("CategoriasCertificacionesProveedorController", [ '$scope', '$http', 'cfg', 'ixStatusService', 'ixWarningsService', function($scope, $http, cfg, ixStatusService, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if (!$scope.data.metadataForm)
    $scope.loadMetadata("categorias_certificaciones_proveedores");

  $scope.data.pk = "id";
  $scope.data.showAsID = "categoria";
  $scope.data.useModel = true;
  $scope.data.fieldsToFilter = [ "categoria" ];
  $scope.data.fieldsToOrderBy = [ "categoria" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "0";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };


  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "categorias_certificaciones_proveedores/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

	$scope.actualizarListado();

  $scope.ixGuardar = function(){
    var data = {};

    if ($scope.data.datos.isNew){
      data.nuevaCategoria = $scope.data.datos;
      //Crear nueva categoría
      $http.post(cfg.baseURL + "categorias_certificaciones_proveedores", data.nuevaCategoria).then(function(response){
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(response);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar categoria
      data.categoria = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      $http.put(cfg.baseURL + "categorias_certificaciones_proveedores/" + $scope.data.datos[$scope.data.pk], data.categoria).then(function(response){
        ixStatusService.setResponse(response);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
  };

	$scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar la categoría " + $scope.data.datos.categoria + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	};

	var accionEliminar = function(){
		$http.delete(cfg.baseURL + "categorias_certificaciones_proveedores/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	};

}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('TraduccionesTiposFicheroProveedorController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', function ($scope, cfg, gridService, $http, ixStatusService, authService, $q) {
	$scope.status = {
		editing: true
	};

	$scope.id = $scope.$resolve.id;
  $scope.descripcion = $scope.$resolve.descripcion;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.id = $scope.id;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_tipos_fichero_proveedor', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "tipos_fichero_proveedor_idioma");
      filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }
}]);
/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("TiposFicheroProveedorController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'ixStatusService', 'ixUtilsService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, ixStatusService, ixUtilsService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_fichero_proveedor");
  }
  $scope.data.pk = "id";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_fichero_proveedor/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoLaboratorio = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_fichero_proveedor", data.nuevoLaboratorio).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.laboratorio = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_fichero_proveedor/' + $scope.data.datos[$scope.data.pk], data.laboratorio).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo fichero " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_fichero_proveedor/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }
  
  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/Mantenimientos/tipos_fichero_proveedor/traducciones_tipos_fichero_proveedor.html";
		var optionsPopup = { controller: "TraduccionesTiposFicheroProveedorController" };
		var paramsPopup = { id: $scope.data.datos.id, descripcion: $scope.data.datos.descripcion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  }

}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('TraduccionesTiposFicheroLaboratorioController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', function ($scope, cfg, gridService, $http, ixStatusService, authService, $q) {
	$scope.status = {
		editing: true
	};

	$scope.id = $scope.$resolve.id;
  $scope.descripcion = $scope.$resolve.descripcion;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.id = $scope.id;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_tipos_fichero_laboratorio', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "tipos_fichero_laboratorio_idioma");
      filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }
}]);
/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("TiposFicheroLaboratorioController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'ixStatusService', 'ixUtilsService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, ixStatusService, ixUtilsService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_fichero_laboratorio");
  }
  $scope.data.pk = "id";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_fichero_laboratorio/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoTipo = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_fichero_laboratorio", data.nuevoTipo).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.updTipo = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_fichero_laboratorio/' + $scope.data.datos[$scope.data.pk], data.updTipo).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo fichero " + $scope.data.datos.descripcion + ", desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_fichero_laboratorio/" + $scope.data.datos[$scope.data.pk]).then(function(r){
			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }
  
  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/Mantenimientos/tipos_fichero_laboratorio/traducciones_tipos_fichero_laboratorio.html";
		var optionsPopup = { controller: "TraduccionesTiposFicheroLaboratorioController" };
		var paramsPopup = { id: $scope.data.datos.id, descripcion: $scope.data.datos.descripcion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  }

}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('TraduccionesTiposFicheroFtController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', function ($scope, cfg, gridService, $http, ixStatusService, authService, $q) {
	$scope.status = {
		editing: true
	};

	$scope.id = $scope.$resolve.id;
  $scope.descripcion = $scope.$resolve.descripcion;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.id = $scope.id;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_tipos_fichero_ft', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "tipos_fichero_ft_idioma");
      filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }
}]);
/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("TiposFicheroFtController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'ixUtilsService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, ixUtilsService, gridService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_fichero_ft");
  }
  $scope.data.pk = "id";
	$scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_fichero_ft/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoTipo = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_fichero_ft", data.nuevoTipo).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.laboratorio = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_fichero_ft/' + $scope.data.datos[$scope.data.pk], data.laboratorio).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo fichero " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_fichero_ft/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }
  
  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/Mantenimientos/tipos_fichero_ft/traducciones_tipos_fichero_ft.html";
		var optionsPopup = { controller: "TraduccionesTiposFicheroFtController" };
		var paramsPopup = { id: $scope.data.datos.id, descripcion: $scope.data.datos.descripcion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  }


  }]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("TiposCertificadosProveedorController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_certificados_proveedor");
  }
  $scope.data.pk = "id";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_certificados_proveedor/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoTipo = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_certificados_proveedor", data.nuevoTipo).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.tipo = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_certificados_proveedor/' + $scope.data.datos[$scope.data.pk], data.tipo).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo certificado " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_certificados_proveedor/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

  }]);

/*global CMP_EQ*/
"use strict"

angular.module('FTBase').controller("TraduccionesTiposAnalisisController", ['$scope', 'gridService', function($scope, gridService){
	$scope.status = {
		editing: true
	};

  $scope.id = $scope.$resolve.id;
  $scope.descripcion = $scope.$resolve.descripcion;

  /* FUNCTIONS */
  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_analisis', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "tipos_analisis_idioma");
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
    }

    filtroEstado = filtroEstado = [{ Field: 'id', Value: $scope.id, Operator: CMP_EQ}];
    $scope.grid.filtroExterno = filtroEstado;
    $scope.grid.ixLoadInitialData();
  };


  $scope.addRow = function(){
    var nuevo = {};
    nuevo.id = $scope.id;
    $scope.grid.ixAddRow(nuevo);
  };


  $scope.crearGrid();


  $scope.save = function(){
    $scope.grid.ixGuardar();
  };


  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  };

	$scope.$on("$destroy", function() {
		if(angular.isDefined($scope.grid))
			$scope.grid.ixSaveConfig();
		$scope.isDestroyed=true;
	});

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
"use strict"

angular.module('FTBase').controller("TiposAnalisisController", ['$scope', '$http', '$translate', 'cfg', 'ixStatusService', 'ixUtilsService', 'ixWarningsService', '$log', function($scope, $http, $translate, cfg, ixStatusService, ixUtilsService, ixWarningsService, $log){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("tipos_analisis");
  }

  $scope.data.pk = "id";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.actualizarListado();

  /* FUNCTIONS */
  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };


  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "tipos_analisis/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);


  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoTipo = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "tipos_analisis", data.nuevoTipo).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } 
    else {
      //Editar tipo.
      data.updTipo = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'tipos_analisis/' + $scope.data.datos[$scope.data.pk], data.updTipo).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };


  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el tipo de análisis " + $scope.data.datos.descripcion + ", desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	};


	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "tipos_analisis/" + $scope.data.datos[$scope.data.pk]).then(function(r){
			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  };


  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/Mantenimientos/tipos_analisis/traducciones_tipos_analisis.html";
		var optionsPopup = { controller: "TraduccionesTiposAnalisisController" };
		var paramsPopup = { id: $scope.data.datos.id, descripcion: $scope.data.datos.descripcion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  };

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_ISNULL*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
/*global saveAs*/


angular.module('FTBase').controller("ProveedoresController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$location', '$timeout', '$log', '$q', 'ixUtilsService', 'ixWarningsService', 'authService', '$translate', '$ngConfirm', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $location, $timeout, $log, $q, ixUtilsService, ixWarningsService, authService, $translate, $ngConfirm) {

	$scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;
	$scope.isUserKeyBiotecnal = false;

	var usuario = authService.authentication.userName;
	$http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
		$scope.extranetUser = response.data;
		if ($scope.extranetUser.cliente != null) {
			$scope.ixEditar = undefined;
			$scope.status.editing = false;
			$scope.$parent.$parent.$parent.addNewItem = undefined;
		}
		if ($scope.extranetUser.proveedor != null) {
			$scope.blockMainDetails = true;
			$scope.$parent.$parent.$parent.addNewItem = undefined;
			$scope.data.ocultaExportarList = true;
		}
		if ($scope.extranetUser.cliente == null && $scope.extranetUser.proveedor == null && $scope.extranetUser.laboratorio == null) {
			$scope.isUserKeyBiotecnal = true;
		}
	}, function (error) {
		ixStatusService.setResponse(error);
	});

	if (!$scope.data.metadataForm) {
		$scope.loadMetadata("proveedores");
	}

	if (!$scope.data.activeTab) {
		$scope.data.activeTab = 0;
	}

	$scope.data.pk = "proveedor";
	$scope.data.useModel = true;
	$scope.data.fieldsToOrderBy = ["nombre ASC"];
	if(cfg.appCliente == "ALCAMPO"){
		$scope.data.fieldsToFilter = ["nombre","codigo"];
	}
	else{
		$scope.data.fieldsToFilter = ["nombre"];
	}
	

	$scope.$parent.filters[0].onNew = function () {
		var nuevo = {};
		nuevo[$scope.data.pk] = "0";
		nuevo.isNew = true;
		$scope.data.datos = {};
		$scope.data.datos = nuevo;

		// $scope.crearGridCertificadosProveedor();
		$scope.crearGridFabricantes();
		$scope.crearGridPlantasFabricantes();
		$scope.crearGridProductos();
		$scope.crearGridFicheros();
		$scope.crearGridAuditorias();

		return nuevo;
	};

	$scope.$watch('current', function (current) {
		// if ($scope.data.cancelEdit) {
		// 	$scope.data.cancelEdit = false;
		// }
		if (!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
			$http.get(cfg.baseURL + "proveedores/" + current[$scope.data.pk]).then(function (response) {

				$scope.data.datos = response.data;
				$scope.data.datosOriginales = angular.copy(response.data);

				// $scope.crearGridCertificadosProveedor();
				$scope.crearGridFabricantes();
				$scope.crearGridPlantasFabricantes();
				$scope.crearGridProductos();
				$scope.crearGridFicheros();
				$scope.crearGridAuditorias();

			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
	}, true);

	//Preguntar a Arnau si es correcto mantener las lineas 81-84
	if (angular.isDefined($routeParams.id)) {
		$scope.current = {};
		$scope.current[$scope.data.pk] = $routeParams.id;
	}
	if (angular.isDefined($routeParams.proveedor)) {
		$scope.current = {};
		$scope.current[$scope.data.pk] = $routeParams.proveedor;
	}

	$scope.actualizarListado();

	$scope.ixGuardar = function () {
		var data = {};
		if ($scope.data.datos.isNew) {
			data.nuevoProveedor = $scope.data.datos;
			//data.nuevosCertificados = $scope.data.gridCertificadosProveedor.data;

			$http.post(cfg.baseURL + "proveedores", $scope.data.datos).then(function (r) {
				//$http.post(cfg.baseURL + "proveedores/PostProveedor", data).then(function (r) {
				delete $scope.data.datos.isNew;
				ixStatusService.setResponse(r);
				ixStatusService.setEditing(false);
				//$scope.ixCancelEdit();
				// if ($scope.data.gridCertificadosProveedor.gridApi)
				// 	$scope.data.gridCertificadosProveedor.clearGridAfterSave();
				$scope.data.datos.proveedor = r.data.obj.Record.proveedor;
				// $scope.data.gridCertificadosProveedor.filtroExterno = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }, { Field: 'fabricante', Value: null, Operator: CMP_ISNULL }, { Field: 'planta', Value: null, Operator: CMP_ISNULL }];
			}, function (error) {
				ixStatusService.setResponse(error);
			});

		} else {
			//Editar proveedor.
			data.jpdProveedor = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

			//data.ubpCertificados = $scope.data.gridCertificadosProveedor.ixGetBulkParam();
			data.ubpFabricantes = $scope.data.gridFabricantes.ixGetBulkParam();
			data.ubpPlantas = $scope.data.gridFabricantesPlantas.ixGetBulkParam();
			data.ubpFicheros = $scope.data.gridFicheros.ixGetBulkParam();

			$http.put(cfg.baseURL + "proveedores/PutProveedor/" + $scope.data.datos.proveedor, data).then(function (r) {
				ixStatusService.setResponse(r);
				ixStatusService.setEditing(false);

				if ($scope.data.gridFabricantes.gridApi)
					$scope.data.gridFabricantes.clearGridAfterSave();
				if ($scope.data.gridFabricantesPlantas.gridApi)
					$scope.data.gridFabricantesPlantas.clearGridAfterSave();
				// if ($scope.data.gridCertificadosProveedor.gridApi)
				// 	$scope.data.gridCertificadosProveedor.clearGridAfterSave();
				if ($scope.data.gridFicheros.gridApi)
					$scope.data.gridFicheros.clearGridAfterSave();

				$scope.ixCancelEdit();
			}, function (error) {
				ixStatusService.setResponse(error);
			});

		}
	};

	$scope.ixDeleteSelectedRows = function () {
		var frase = "¿Se va a eliminar el proveedor " + $scope.data.datos.nombre + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope, frase, accionEliminar);
	}

	var accionEliminar = function () {
		$http.delete(cfg.baseURL + "proveedores/" + $scope.data.datos[$scope.data.pk]).then(function (r) {
			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);

			$scope.data.datos = {};
			$scope.data.gridFabricantes.data = {};
			// $scope.data.gridCertificadosProveedor.data = {};
			$scope.data.gridFicheros.data = {};

			$scope.ixCancelEdit();
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	}

	$scope.abrirPopupProducto = function (entity, idioma, modo_traduccion) {
		var app = {};
		app.icon = 'perm_device_information';
  
		if (angular.isArray(entity)) {
  
		  var id_fichas_tecnicas = entity.map(function (e) { return e.ft; });
  
		  app.display = 'Datos Ficha Técnica';
		  app.href = "GestionFichasTecnicas/list";
		  app.atributos = { id_fichas_tecnicas: id_fichas_tecnicas,pantalla: "Mantenimientos/proveedores" };
		  app.multiple = true;
		  app.atributos.idioma = idioma;
		} else {
		  if ((entity.idioma) && entity.idioma != idioma)
			app.display = 'Modo Traducción ' + idioma.toUpperCase();
		  else
			app.display = 'Datos Ficha Técnica';
  
		  app.href = "GestionFichasTecnicas/list";
		  app.atributos = { id_ficha_tecnica: entity.ft,pantalla: "Mantenimientos/proveedores" };
		  app.multiple = true;
  
		  if ((entity.idioma) && entity.idioma != idioma) {
			app.atributos.idioma = idioma;
		  }
		}
  
		if (angular.isDefined($scope.informativeDialog))
		  $scope.informativeDialog.close();
  
		ixStatusService.openApp.bind(ixStatusService)(app);
	  };

	  $scope.displayInformationPopup = function () {
		$scope.informativeDialog = $ngConfirm({
		  icon: 'fa fa-info',
		  title: '<translate>Información</translate>',
		  content: '<translate>Se está generando la estructura necesaria para realizar la traducción. Cuándo haya terminado serás redireccionado al modo traducción de la ficha técnica.<translate>',
		  scope: $scope,
		  buttons: {
			close: {
			  text: "Cerrar"
			}
		  }
		});
	  };

	  $scope.crearTraduccionesFaltantes = function (id_ficha_tecnica, idioma) {
		$scope.displayInformationPopup();
		return $http.post(cfg.baseURL + "extranet_fichas_tecnicas_idioma/CreateTraduccionesFaltantes?id=" + id_ficha_tecnica + "&idioma=" + idioma);
	  };

	$scope.changeTab = function (tabIdx) {
		if (angular.isDefined($scope.data.gridFabricantes) && $scope.data.activeTab == 1) {
			$scope.data.gridFabricantes.ixSaveConfig();
		}
		else if (angular.isDefined($scope.data.gridFabricantesPlantas) && $scope.data.activeTab == 2) {
			$scope.data.gridFabricantesPlantas.ixSaveConfig();
		}
		else if (angular.isDefined($scope.data.gridFicheros) && $scope.data.activeTab == 3) {
			$scope.data.gridFicheros.ixSaveConfig();
		}
		else if (angular.isDefined($scope.data.gridAuditorias) && $scope.data.activeTab == 4) {
			$scope.data.gridAuditorias.ixSaveConfig();
		}
		else if (angular.isDefined($scope.data.gridProductos) && $scope.data.activeTab == 5) {
			$scope.data.gridProductos.ixSaveConfig();
		}
		$scope.data.activeTab = tabIdx;
		// switch (tabIdx) {
		// 	case 2:
		// 		//$scope.crearGridFabricantes();
		// 		break;
		// }

		switch(tabIdx){
			case 1:
				$timeout(function(){
					$scope.data.gridFabricantes && $scope.data.gridFabricantes.gridApi && 
					$scope.data.gridFabricantes.gridApi.core.handleWindowResize();
				},300);
				break;
			case 2:
				$timeout(function(){
					$scope.data.gridFabricantesPlantas && $scope.data.gridFabricantesPlantas.gridApi && 
					$scope.data.gridFabricantesPlantas.gridApi.core.handleWindowResize();
				},300);
				break;
			case 3:
				$timeout(function(){
					$scope.data.gridFicheros && $scope.data.gridFicheros.gridApi && 
					$scope.data.gridFicheros.gridApi.core.handleWindowResize();
				},300);
				break;
			case 4:
				$timeout(function(){
					$scope.data.gridAuditorias && $scope.data.gridAuditorias.gridApi && 
					$scope.data.gridAuditorias.gridApi.core.handleWindowResize();
					// Workaround para Chrome. (FF y Edge funcionan correctamente)
					// Este ui-grid dentro del uib-tab la tabla del grid queda invisible al cambiar de tab
					// hasta que Chrome fuerza un repaint (scroll, resize columna, etc).
					angular.element('.ui-grid-header-cell-label').first().css('display', 'block');
				},300);
				break;
			case 5:
				$timeout(function(){
					$scope.data.gridProductos && $scope.data.gridProductos.gridApi && 
					$scope.data.gridProductos.gridApi.core.handleWindowResize();
				},300);
				break;
		}
		
	};

	$scope.crearGridAuditorias = function () {
		var metadata = [];
		var acciones = [
			{
			  title: "Descargar documentos",
			  icon: "fa-download",
			  visible: function (entity) {
				return entity.existen_docs > 0;
			  },
			  accion: function (entity) {
				$scope.downloadFile(entity, 'AUDITORIAS',false);
			  }
			},
			{
			  title: 'Visualizar/Editar Auditoría',
			  icon: 'fa-pencil-square-o',
			  accion: function (entity) {
				var templateURL = "app/FTBase/HomologacionPlantas/editar_auditoria_planta.html";
				var optionsPopup = { controller: "DetallesAuditoriaPlantaController" };
				var paramsPopup = { datosAuditoria: entity, isNew: false,bPantallaProveedor:true,id_proveedor:$scope.data.datos[$scope.data.pk] };
				ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function (response) {
				  if (response){
					$scope.data.gridAuditorias.filtroExterno = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true  }];
					$scope.data.gridAuditorias.ixLoadInitialData();
				  }
				});
			  }
			},
			{
			  title: 'Archivar auditoría',
			  icon: 'fa-archive',
			  visible: function (entity) {
				return (entity.archivada == 0);
			  },
			  accion: function (entity) {
				var param = [];
				param.push({
				  value: 1,
				  path: "/archivada",
				  op: "replace"
				});
  
				$http.put(cfg.baseURL + "auditorias_plantas/" + entity.id, param).then(function (response) {
				  $scope.data.gridAuditorias.ixLoadInitialData();
				  ixStatusService.setResponse(response);
				},
				  function (error) {
					ixStatusService.setResponse(error);
				  });
			  }
			},
			{
			  title: 'Marcar verificado',
			  icon: 'fa-check-square-o',
			  visible: function (entity) {
				return entity.verificacion == 0;
			  },
			  accion: function (entity) {
				var table = "auditorias_plantas";
  
				var param = [];
				param.push({
				  value: 1,
				  path: "/verificacion",
				  op: "replace"
				});
  
				$http.put(cfg.baseURL + table + "/" + entity.id, param).then(function (response) {
				  $scope.data.gridAuditorias.ixLoadInitialData();
				  ixStatusService.setResponse(response);
				},
				  function (error) {
					ixStatusService.setResponse(error);
				  });
			  }
			},
			{
			  title: 'Eliminar auditoría',
			  icon: 'fa-trash',
			  visible: function (entity) {
				return (authService.tienePerfilAdmin() || authService.tienePerfilUserKey());
			  },
			  accion: function (entity) {
				$scope.eliminarAuditoriaPlanta(entity);
			  }
			}
		  ];

		  if(cfg.appCliente == "ALCAMPO"){
			metadata.push({ Name: "verificacion", NoVisible: true });
			metadata.push({ Name: "proxima_auditoria", NoVisible: true });
			metadata.push({ Name: "fecha_limite", NoVisible: false });
		  }
		var filtroAuditorias = [];
		if (!$scope.data.gridAuditorias) {
			$scope.data.gridAuditorias = gridService.createGrid($scope, 'gnet_grid_proveedores_auditorias', { minRowsToShow: 5, metadata: metadata}, "auditoria_proveedorVM", [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
			filtroAuditorias = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true  }];
			$scope.data.gridAuditorias.filtroExterno = filtroAuditorias;
			$scope.data.gridAuditorias.ixLoadInitialData();
		} else {
			$scope.data.gridAuditorias = gridService.createGridFunctions($scope, $scope.data.gridAuditorias);
			$scope.data.gridAuditorias.ixRestoreConfig();
			filtroAuditorias = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true  }];
			$scope.data.gridAuditorias.filtroExterno = filtroAuditorias;
			$scope.data.gridAuditorias.ixLoadInitialData();
		}
	}


	$scope.crearGridFabricantes = function () {
		var metadata = [];
		var filtroFabricantes = [];
		if (!$scope.data.gridFabricantes) {
			var acciones = [
				{
					icon: "fa-search",
					title: "Fabricante",
					visible: function (entity) {
						return true;//!$scope.data.datos.isNew;
					},
					accion: function (entity) {
						abrirPopupFabricante(entity, false);
					}
				}
			];
			$scope.data.gridFabricantes = gridService.createGrid($scope, 'gnet_grid_proveedores_fabricantes', { minRowsToShow: 5, metadata: metadata/*, showOnlyDescribedCols: [ "centro"]*/ }, "fabricantes", [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
			filtroFabricantes = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFabricantes.filtroExterno = filtroFabricantes;
			$scope.data.gridFabricantes.ixLoadInitialData();
		} else {
			$scope.data.gridFabricantes = gridService.createGridFunctions($scope, $scope.data.gridFabricantes);
			$scope.data.gridFabricantes.ixRestoreConfig();
			filtroFabricantes = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFabricantes.filtroExterno = filtroFabricantes;
			$scope.data.gridFabricantes.ixLoadInitialData();
		}
	}

	$scope.esVigente = function(fechaCaducidad) {
		if (!fechaCaducidad) {
			return true;
		}
		
		var fechaLimite = new Date(fechaCaducidad);
		var hoy = new Date();
		
		fechaLimite.setHours(0, 0, 0, 0);
		hoy.setHours(0, 0, 0, 0);
		
		return fechaLimite >= hoy;
	};

	$scope.crearGridPlantasFabricantes = function () {
		var metadata = [];
		var filtroFabricantesPlantas = [];
		if (!$scope.data.gridFabricantesPlantas) {
			var acciones = [
				{
					icon: "fa-search",
					title: "Planta",
					visible: function (entity) {
						return true;
					},
					accion: function (entity) {
						abrirPopupPlantaFabricante(entity, false);
					}
				}
			];
			if(cfg.appCliente == "ALCAMPO"){
				metadata.push({ Name: "razon_social", NoVisible: true });
			}
			var rowTemplate2 = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': (row.entity.baja == 1), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
			$scope.data.gridFabricantesPlantas = gridService.createGrid($scope, 'gnet_grid_proveedores_plantas_fabricantes', { minRowsToShow: 5, metadata: metadata/*, showOnlyDescribedCols: [ "centro"]*/ }, "plantas_proveedorVM", [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
			$scope.data.gridFabricantesPlantas.rowTemplate = rowTemplate2;
			filtroFabricantesPlantas = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true }];
			$scope.data.gridFabricantesPlantas.filtroExterno = filtroFabricantesPlantas;
			$scope.data.gridFabricantesPlantas.ixLoadInitialData();
		} else {
			$scope.data.gridFabricantesPlantas = gridService.createGridFunctions($scope, $scope.data.gridFabricantesPlantas);
			$scope.data.gridFabricantesPlantas.ixRestoreConfig();
			filtroFabricantesPlantas = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true }];
			$scope.data.gridFabricantesPlantas.filtroExterno = filtroFabricantesPlantas;
			$scope.data.gridFabricantesPlantas.ixLoadInitialData();
		}
	}

	$scope.crearGridProductos = function () {
		var metadata = [];
		var filtroProductos = [];
		var accionesProductos = [
			{
				titleFunction: function (entity) {
				  var title = $translate.instant("Datos Ficha Técnica");
				  if ((entity.idioma) && entity.idioma.toUpperCase() != "ES")
					title = $translate.instant("Modo Traducción");
				  return title;
				},
				icon: 'assets/images/flags/es.png',
				customType: true,
				getStyle: function (entity) {
				  return {
					"position": "relative",
					"top": "-1px",
					"margin": "0 3px"
				  };
				},
				visible: function (entity) {
				  if (angular.isDefined(entity)) {
					if (entity.idioma == null) return false;
					return entity.traducible || entity.idioma.toUpperCase() == "ES";
				  }
	
				  return true;
				},
				accion: function (entity) {
				  var idiomaDistinto = ((entity.idioma) && entity.idioma.toUpperCase() != "ES");
				  if (idiomaDistinto && entity.traducible) {
					$scope.crearTraduccionesFaltantes(entity.ft, "es").then(function (response) {
					  if (response.data) {
						if (response.data.Result)
						  $scope.abrirPopupProducto(entity, "es");
					  }
					}, function (err) {
					  ixStatusService.setResponse(err);
					});
				  } else
					$scope.abrirPopupProducto(entity, "es");
				}
			  },
			  {
				titleFunction: function (entity) {
				  var title = $translate.instant("Datos Ficha Técnica");
				  if ((entity.idioma) && entity.idioma.toUpperCase() != "PT")
					title = $translate.instant("Modo Traducción");
				  return title;
				},
				icon: 'assets/images/flags/pt.png',
				customType: true,
				getStyle: function (entity) {
				  return {
					"position": "relative",
					"top": "-1px",
					"margin": "0 3px"
				  };
				},
				visible: function (entity) {
				  if (angular.isDefined(entity)) {
					if (entity.idioma == null) return false;
					return entity.traducible || entity.idioma.toUpperCase() == "PT";
				  }
				  return false;
				},
				accion: function (entity) {
				  var idiomaDistinto = (entity.idioma.toUpperCase() != "PT");
				  if (idiomaDistinto && entity.traducible) {
					$scope.crearTraduccionesFaltantes(entity.ft, "pt").then(function (response) {
					  if (response.data) {
						if (response.data.Result)
						  $scope.abrirPopupProducto(entity, "pt");
					  }
					}, function (err) {
					  ixStatusService.setResponse(err);
					});
				  } else
					$scope.abrirPopupProducto(entity, "pt");
				}
			  }
		];
		if (!$scope.data.gridProductos) {
			if(cfg.appCliente == "ALCAMPO"){
				metadata.push({ Name: "mercado", NoVisible: false });
				metadata.push({ Name: "marca", NoVisible: false });
			}
			$scope.data.gridProductos = gridService.createGrid($scope, 'gnet_grid_productos', { minRowsToShow: 5, metadata: metadata/*, showOnlyDescribedCols: [ "centro"]*/ }, "productos_proveedorVM",[{ name: 'Acciones', type: 'detalle', acciones: accionesProductos }]);
			filtroProductos = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true }];
			$scope.data.gridProductos.filtroExterno = filtroProductos;
			$scope.data.gridProductos.ixLoadInitialData();
		} else {
			$scope.data.gridProductos = gridService.createGridFunctions($scope, $scope.data.gridProductos);
			$scope.data.gridProductos.ixRestoreConfig();
			filtroProductos = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true }];
			$scope.data.gridProductos.filtroExterno = filtroProductos;
			$scope.data.gridProductos.ixLoadInitialData();
		}
	}

	$scope.crearGridFicheros = function () {
		var metadata = [
			{ Name: 'archivo', NoEditable: true },
			{ Name: 'tipo', NoEditable: true },
			// { Name: 'inicio_validez', NoEditable: true },
			// { Name: 'fecha_caducidad', NoEditable: true },
			{ Name: 'archivado', NoEditable: !$scope.isUserKeyBiotecnal }
		];
		var filtroFicheros = [];
		if (!$scope.data.gridFicheros) {
			var acciones = [
				{
					title: "Previsualizar PDF",
					icon: "fa-file-pdf-o",
					visible: function (entity) {
						return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
					},
					accion: function (entity) {
						var tabla = "proveedores_ficheros";
						$http({
							method: 'post',
							url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
							headers: {},
							responseType: 'arraybuffer'
						}).then(function (r) {
							$scope.selectedPDF = new Uint8Array(r.data);
							$scope.idFicheroPreview = entity.id;
							var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
							ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
						},
							function (err) {
								ixStatusService.setResponse(err);
							});
					}
				},
				{
					title: "Previsualizar Imagen",
					icon: "fa-file-image-o",
					visible: function (entity) {
						return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
					},
					accion: function (entity) {
						var tabla = "proveedores_ficheros";
						$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
							$scope.selectedImage = r.data;
							$scope.idFicheroPreview = entity.id;
							var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
							ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
						},
							function (err) {
								ixStatusService.setResponse(err);
							});
					}
				},
				{
					title: "Descargar fichero",
					icon: "fa-download",
					visible: function (entity) {
						return entity.archivo;
					},
					accion: function (entity) {
						var esProveedor = angular.isDefined(entity.proveedor);
						$scope.downloadFile(entity,'FICHEROS', esProveedor);
					}
				},
				{
					icon: "fa-retweet",
					title: "Sustituir/Actualizar",
					visible: function (entity) {
						return (entity.archivado == 0);
					},
					accion: function (entity) {
						$scope.sustituirFicheros(entity);
					}
				}
			];
			var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-alarm': !(grid.appScope.esVigente(row.entity.fecha_caducidad)), 'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
			if(cfg.appCliente == "ALCAMPO"){
				metadata.push({ Name: "comentarios", NoVisible: false });
				metadata.push({ Name: "resultado", NoVisible: false });
			}
			$scope.data.gridFicheros = gridService.createGrid($scope, 'gnet_grid_proveedores_ficheros', { minRowsToShow: 5, metadata: metadata/*, showOnlyDescribedCols: [ "centro"]*/ }, "proveedores_ficheros", [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
			$scope.data.gridFicheros.rowTemplate = rowTemplate;	
			filtroFicheros = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFicheros.filtroExterno = filtroFicheros;
			$scope.data.gridFicheros.ixLoadInitialData();
		} else {
			$scope.data.gridFicheros = gridService.createGridFunctions($scope, $scope.data.gridFicheros);
			$scope.data.gridFicheros.ixRestoreConfig();
			filtroFicheros = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
			$scope.data.gridFicheros.filtroExterno = filtroFicheros;
			$scope.data.gridFicheros.ixLoadInitialData();
		}
	}

	$scope.deleteSelectedRows = function (grid) {
		// if (grid.gridName == "gnet_grid_proveedores_fabricantes")
		// 	grid.ixDeleteSelectedRows(); //¿Poner Alerta de eliminación?
		// 	else
		var warningSentence = "";
		if (grid.entity == 'fabricantes') {
			warningSentence = "ATENCIÓN: Se eliminaran los fabricantes seleccionados. ¿Se desea continuar?";
			ixWarningsService.warningConfirmacion($scope, warningSentence, confirmaEliminar, undefined, grid);
		}
		else if (grid.entity == 'plantas_proveedorVM') {
			warningSentence = "ATENCIÓN: Se eliminaran las plantas seleccionadas con todos los documentos y auditorías asociados. ¿Se desea continuar?";
			ixWarningsService.warningConfirmacion($scope, warningSentence, confirmaEliminar, undefined, grid);
		}
	};
	var confirmaEliminar = function (grid) {
		grid.ixDeleteSelectedRows();
	};

	$scope.addRow = function (grid, item) {
		var nuevo = item || {};

		if (grid.entity == 'fabricantes') {
			nuevo.proveedor = $scope.data.datos.proveedor;
			abrirPopupFabricante(nuevo, true);
			grid.ixAddRow(nuevo);
		}
		else if (grid.entity == 'plantas_proveedorVM') {
			abrirPopupPlantaFabricante(nuevo, true);
		}
		// if (grid.entity == 'proveedores_certificados') {
		// 	nuevo.id = 0;
		// }
	};

	$scope.addFicheros = function () {
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
		var controllerName = "UploadFilePopupProveedoresController";
		var optionsPopupFicheros = {
			controller: controllerName
		};
		var id_fabricante = 0;
		var bIsOneFabricante = false;
		if($scope.data.gridFabricantes.data.length == 1)
		{
			id_fabricante = $scope.data.gridFabricantes.data[0].fabricante;
			bIsOneFabricante = true;
		} 
		var params = { "id_proveedor": $scope.data.datos.proveedor,"fabricante": id_fabricante,"bIsOneFabricante": bIsOneFabricante };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
		modalInstance.then(function (resp) {
			// Recargar grid de ficheros
			$scope.data.gridFicheros.ixLoadInitialData();
		});
	};


	$scope.sustituirFicheros = function (entity) {
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
		var controllerName = "UploadFilePopupProveedoresController";
		var optionsPopupFicheros = {
			controller: controllerName
		};
		var bIsOneFabricante = false;
		if($scope.data.gridFabricantes.data.length == 1)
		{
			bIsOneFabricante = true;
		} 
		var params = {
			"id_proveedor": $scope.data.datos.proveedor,
			"grupo": entity.grupo,
			"fabricante": entity.fabricante,
			"planta": entity.planta,
			"sustituir": entity.id,
			"tipoFichero": entity.tipo,
			"alcance": entity.alcance
		};
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
		modalInstance.then(function (resp) {
			// Recargar grid de ficheros
			$scope.data.gridFicheros.ixLoadInitialData();
		});
	};

	var abrirPopupFabricante = function (entity, isNew) {
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/fabricantesPopup.html";
		var controllerName = "FabricantesPopupController";
		var optionsPopupFabricante = {
			controller: controllerName,
			resolve: {
				clickedItem: function () {
					return entity;
				},
				isNew: function () {
					return isNew;
				}
			}
		};
		var params = { "clickedItem": entity, "isNew": isNew, "bloqueado": $scope.data.datos.fabricantes_bloqueado, "extranetUser": $scope.extranetUser, "statusEditingoriginal": $scope.status.editing };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFabricante, 'medium', params);
		var statusEditingOriginal = $scope.status.editing;
		modalInstance.then(function (resp) {
			if (resp.dataModified) {
				$scope.data.gridFabricantes.ixLoadInitialData();
				$scope.data.gridFabricantesPlantas.ixLoadInitialData();
				$scope.data.gridFicheros.ixLoadInitialData();
			}
			//Ripristinar $scope.status.editing original
			$scope.status.editing = statusEditingOriginal;
		});
	};

	var abrirPopupPlantaFabricante = function (entity, isNew) {
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/plantasPopup.html";
		var controllerName = "PlantasPopupController";
		var optionsPopupPlantas = {
			controller: controllerName,
			resolve: {
				clickedItem: function () {
					return entity;
				},
				isNew: function () {
					return isNew;
				}
			}
		};
		var id_fabricante = 0;
		var bIsOneFabricante = false;
		if($scope.data.gridFabricantes.data.length == 1)
		{
			id_fabricante = $scope.data.gridFabricantes.data[0].fabricante;
			bIsOneFabricante = true;
		} 
		var params = { "clickedItem": entity, "isNew": isNew, "fabricante": id_fabricante,"bIsOneFabricante": bIsOneFabricante ,"extranetUser": $scope.extranetUser, "bloqueado": $scope.data.datos.bloqueado,"proveedor": $scope.data.datos[$scope.data.pk],"lstProductos":$scope.data.gridProductos.data };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupPlantas, 'medium', params);
		modalInstance.then(function (resp) {	
			if (resp.dataModified) {
				$scope.data.gridFabricantesPlantas.filtroExterno = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true }];
				$scope.data.gridFabricantesPlantas.ixLoadInitialData();
			}
			$scope.dataModified = resp.dataModified;
		});
	};

	var checkDifferences = function (entity, property, finalValue, originalValue) {
		if (finalValue != originalValue) {
			if (angular.isUndefined(entity.modifiedValues)) entity.modifiedValues = [];
			if (entity.modifiedValues.indexOf(property) == -1)
				entity.modifiedValues.push(property);
		}
	};

	//Aplica los cambios en la row de fabricante añadiendole los cambios al array "modifiedValues" que luego utilizara el ixGetBulkParam para crear el item de updatebulk.
	var modificacionFabricante = function (entity, resp) {
		checkDifferences(entity, "razon_social", entity.razon_social, resp.razon_social);
		checkDifferences(entity, "cif", entity.cif, resp.cif);
		checkDifferences(entity, "direccion", entity.direccion, resp.direccion);
		checkDifferences(entity, "cp", entity.cp, resp.cp);
		checkDifferences(entity, "localidad", entity.localidad, resp.localidad);
		checkDifferences(entity, "provincia", entity.provincia, resp.provincia);
		checkDifferences(entity, "pais", entity.pais, resp.pais);
		checkDifferences(entity, "telefono", entity.telefono, resp.telefono);
		checkDifferences(entity, "fax", entity.fax, resp.fax);
		checkDifferences(entity, "email", entity.email, resp.email);
		checkDifferences(entity, "reg_sanitario", entity.reg_sanitario, resp.reg_sanitario);
		checkDifferences(entity, "acreditaciones_certificados", entity.acreditaciones_certificados, resp.acreditaciones_certificados);
	};


	var modifiedBulkParam = function (gridOptions) {
		var bulkParam = {
			ToInsert: [],
			ToUpdate: [],
			ToDelete: []
		};

		if (gridOptions.gridApi) {
			var dirtyRows = gridOptions.gridApi.rowEdit.getDirtyRows();
			dirtyRows.forEach(function (row) {
				// if(row.entity.manuallyAdded) delete row.entity.manuallyAdded;
				if (gridOptions.insertedRows.indexOf(row.entity) >= 0) {
					// delete(row.entity.isNew);
					bulkParam.ToInsert.push(row.entity);
				} else {
					bulkParam.ToUpdate.push({
						PK: gridOptions.buildPK(row.entity),
						PocoToUpdate: gridOptions.getPatchOperations(row.entity)
					});
				}
			});
			gridOptions.deletedRows.forEach(function (data) {
				bulkParam.ToDelete.push(gridOptions.buildPK(data));
			});
		}

		return bulkParam;
	}

	$scope.ixCancelEdit = function () {
		if (angular.isDefined($scope.data.gridFabricantes.gridApi))
			$scope.data.gridFabricantes.clearGridAfterSave();
		if (angular.isDefined($scope.data.gridFabricantesPlantas.gridApi))
			$scope.data.gridFabricantesPlantas.clearGridAfterSave();
		$scope.$parent.ixCancelEdit();
	}

	$scope.nuevoProducto = function () {
		var templateURL = "app/FTBase/Mantenimientos/proveedores/modales/nuevo_producto_planta_popup.html";
		var optionsPopup = { controller: "NuevoProductoPlantaPopupController" };
		var paramsPopup = { id_proveedor:$scope.data.datos[$scope.data.pk]};
		ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function (response) {
		  if (response){
			$scope.data.gridProductos.filtroExterno = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true }];
			$scope.data.gridProductos.ixLoadInitialData();
		  }
		});
	  };

	$scope.openEditAuditoria = function () {
		var templateURL = "app/FTBase/HomologacionPlantas/editar_auditoria_planta.html";
		var optionsPopup = { controller: "DetallesAuditoriaPlantaController" };
		var paramsPopup = { datosAuditoria: undefined, isNew: true,bPantallaProveedor:true,id_proveedor:$scope.data.datos[$scope.data.pk]};
		ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function (response) {
		  if (response){
			$scope.data.gridAuditorias.filtroExterno = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true  }];
			$scope.data.gridAuditorias.ixLoadInitialData();
		  }
		});
	  };

	$scope.eliminarAuditoriaPlanta = function (aud) {
		$http.delete(cfg.baseURL + 'auditorias_plantas/' + aud.id).then(function (response) {
			$scope.data.gridAuditorias.filtroExterno = [{ Field: 'proveedor', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, skip: true  }];
		  $scope.data.gridAuditorias.ixLoadInitialData();
		  ixStatusService.setResponse(response);
		},
		  function (error) {
			ixStatusService.setResponse(error);
		  });
	  };

	$scope.downloadFile = function (item,grupo ,esProveedor) {
		if(grupo == 'AUDITORIAS'){
			$http({
				method: 'post',
				url: cfg.baseURL + 'auditorias_plantas_documentos/DownloadDocumentos/' + item.id,
				headers: {},
				responseType: 'arraybuffer'
			  }).then(function (r) {
				var file = new Blob([r.data], { type: r.headers('Content-type') });
	  
				var filename = "DocumentosAuditoriaPlanta_" + item.nombre_planta + ".zip";
				if (r.headers('Content-Disposition')) {
				  filename = r.headers('Content-Disposition').split("=")[1];
				}
				saveAs(file, filename);
			  },
				function (err) {
				  ixStatusService.setResponse(err);
				});
		}else{
			var entity = (esProveedor) ? "proveedores_ficheros" : "fichas_tecnicas_ficheros";
			$http({
				method: 'post',
				url: cfg.baseURL + entity + '/DownloadFile?id=' + item.id,
				headers: { 'Content-type': 'application/pdf' },
				responseType: 'arraybuffer'
			}).then(function (r) {
				var file = new Blob([r.data], { type: r.headers('Content-type') });
	
				var filename = $scope.entity + ".pdf";
				if (r.headers('Content-Disposition')) {
					filename = r.headers('Content-Disposition').split("=")[1];
				}
				saveAs(file, filename);
			},
				function (err) {
					ixStatusService.setResponse(err);
				});
		}
	};

	$scope.$on("$destroy", function() {
		if(angular.isDefined($scope.data.gridFabricantes))
			$scope.data.gridFabricantes.ixSaveConfig();
		if(angular.isDefined($scope.data.gridFabricantesPlantas))
			$scope.data.gridFabricantesPlantas.ixSaveConfig();
		$scope.isDestroyed=true;
	});

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller("LaboratoriosController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'ixUtilsService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, ixUtilsService, gridService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if (!$scope.data.metadataForm) {
    $scope.loadMetadata("laboratorios");
  }

  if (!$scope.data.activeTab) {
    $scope.data.activeTab = 0;
  }

  $scope.data.pk = "id_laboratorio";
  $scope.data.showAsID = "nombre";
  $scope.data.useModel = true;
  $scope.data.fieldsToFilter = ["nombre"];
  $scope.data.fieldsToOrderBy = ["nombre"];

  $scope.$parent.filters[0].onNew = function () {
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;

    $scope.crearGridContactos();
    $scope.crearGridFicheros();

    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if ($scope.data.cancelEdit) {
      $scope.data.cancelEdit = false;
    }
    if (!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
    else {
      if (angular.isDefined($scope.data.activeTab)) {
        switch ($scope.data.activeTab) {
          case 0:
            if (angular.isDefined($scope.data.gridContactos)) $scope.data.gridContactos.ixSaveConfig();
            break;
          case 1:
            if (angular.isDefined($scope.data.gridFicheros)) $scope.data.gridFicheros.ixSaveConfig();
            break;
        }
      }

      $http.get(cfg.baseURL + "laboratorios/" + current[$scope.data.pk]).then(function (response) {

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

        $scope.crearGridContactos();
        $scope.crearGridFicheros();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  }, true);

  $scope.actualizarListado();

  $scope.changeTab = function (tabIdx) {
    if (angular.isDefined($scope.data.gridContactos) && $scope.data.activeTab == 0)
      $scope.data.gridContactos.ixSaveConfig();
    if (angular.isDefined($scope.data.gridFicheros) && $scope.data.activeTab == 1)
      $scope.data.gridFicheros.ixSaveConfig();

    $scope.data.activeTab = tabIdx;

    if (angular.isDefined($scope.data.gridContactos) && $scope.data.activeTab == 0)
      $scope.data.gridContactos.ixRestoreConfig();
    if (angular.isDefined($scope.data.gridFicheros) && $scope.data.activeTab == 1)
      $scope.data.gridFicheros.ixRestoreConfig();
  };


  $scope.crearGridContactos = function () {
    var metadata = [];

    if (!$scope.data.gridContactos) {
      $scope.data.gridContactos = gridService.createGrid($scope, 'gnet_grid_contactoslab', { minRowsToShow: 5, metadata: metadata }, "laboratorios_contactos");
      // $scope.data.gridContactos.filtroExterno = [ { Field: 'laboratorio', Value: $scope.data.datos.id_laboratorio, Operator: CMP_EQ }];
      // $scope.data.gridContactos.ixLoadInitialData();
    }
    else {
      $scope.data.gridContactos = gridService.createGridFunctions($scope, $scope.data.gridContactos);
      $scope.data.gridContactos.ixRestoreConfig();
    }

    $scope.data.gridContactos.filtroExterno = [{ Field: 'laboratorio', Value: $scope.data.datos.id_laboratorio, Operator: CMP_EQ }];
    $scope.data.gridContactos.ixLoadInitialData();
  };


  $scope.addRowContactos = function () {
    var nuevo = {};
    nuevo.laboratorio = $scope.data.datos.id_laboratorio;
    $scope.data.gridContactos.ixAddRow(nuevo);
  };


  $scope.addFicherosPopup = function () {
    var urlTemplate = "app/FTBase/Mantenimientos/laboratorios/modales/popupFicheroLaboratorio.html";
    var controllerName = "PopupFicheroLaboratorioController";
    var optionsPopupFicheros = {
      controller: controllerName
    };
    var params = { "idFichero": 0, "idLab": $scope.data.datos.id_laboratorio, "mantenimiento_lab": true };
    var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
    modalInstance.then(function (resp) {
      if (resp) {
        // Recargar grid de ficheros
        $scope.data.gridFicheros.ixLoadInitialData();
      }
    });

  };


  $scope.deleteSelectedRows = function (grid) {
    grid.ixDeleteSelectedRows();
  };


  $scope.crearGridFicheros = function () {
    var metadata = [];
    var acciones = [
      {
        title: "Descargar fichero",
        icon: "fa-download",
        accion: function (entity) {
          downloadFile(entity);
        }
      }
    ];

    if (!$scope.data.gridFicheros) {
      $scope.data.gridFicheros = gridService.createGrid($scope, 'gnet_grid_ficheroslab', { enableCellEdit: false, compruebaAlarmaFunc: $scope.compruebaCaducidadFichero, minRowsToShow: 5, metadata: metadata }, "laboratorios_ficheros", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }]);
    }
    else {
      $scope.data.gridFicheros = gridService.createGridFunctions($scope, $scope.data.gridFicheros);
      $scope.data.gridFicheros.ixRestoreConfig();
    }

    $scope.data.gridFicheros.filtroExterno = [{ Field: 'laboratorio', Value: $scope.data.datos.id_laboratorio, Operator: CMP_EQ }];
    $scope.data.gridFicheros.ixLoadInitialData();
  };

  $scope.compruebaCaducidadFichero = function (row) {
    if (row.entity.fecha_caducidad)
      return row.entity.fecha_caducidad < Date.now();
    else
      return false;

  };


  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoLaboratorio = $scope.data.datos;

      //Crear nuevo laboratorio.
      $http.post(cfg.baseURL + "laboratorios", data.nuevoLaboratorio).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
        $scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar laboratorio.
      data.jpdLaboratorio = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      if ($scope.data.gridContactos) data.ubpContactos = $scope.data.gridContactos.ixGetBulkParam();
      if ($scope.data.gridFicheros) data.ubpFicheros = $scope.data.gridFicheros.ixGetBulkParam();

      $http.put(cfg.baseURL + 'laboratorios/Modificalaboratorio/' + $scope.data.datos[$scope.data.pk], data).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        if ($scope.data.gridContactos)
          $scope.data.gridContactos.clearGridAfterSave();
        if ($scope.data.gridFicheros)
          $scope.data.gridFicheros.clearGridAfterSave();
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function () {
    var frase = "¿Se va a eliminar el laboratorio " + $scope.data.datos.nombre + " , desea continuar?";
    ixWarningsService.warningConfirmacion($scope, frase, accionEliminar);
  }

  var downloadFile = function (entity) {
    $http({
      method: 'post',
      url: cfg.baseURL + 'laboratorios_ficheros/DownloadFile?id=' + entity.id,
      headers: { 'Content-type': 'application/pdf' },
      responseType: 'arraybuffer'
    }).then(function (r) {
      var file = new Blob([r.data], { type: r.headers('Content-type') });

      var filename = entity.archivo + ".pdf";
      if (r.headers('Content-Disposition')) {
        filename = r.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    },
      function (err) {
        ixStatusService.setResponse(err);
      });
  };


  var accionEliminar = function () {
    $http.delete(cfg.baseURL + "laboratorios/" + $scope.data.datos[$scope.data.pk]).then(function (r) {

      ixStatusService.setResponse(r);
      ixStatusService.setEditing(false);
      $scope.data.datos = {};
      $scope.ixCancelEdit();
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  }

  $scope.$on("$destroy", function () {
    if (angular.isDefined($scope.data.gridContactos))
      $scope.data.gridContactos.ixSaveConfig();

    if (angular.isDefined($scope.data.gridFicheros))
      $scope.data.gridFicheros.ixSaveConfig();

    $scope.isDestroyed = true;
  });


}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('TraduccionesFtEstadosController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', function ($scope, cfg, gridService, $http, ixStatusService, authService, $q) {
	$scope.status = {
		editing: true
	};

	$scope.cod_estado = $scope.$resolve.cod_estado;
  $scope.descripcion = $scope.$resolve.descripcion;
  $scope.posicion = $scope.$resolve.posicion;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.codigo = $scope.cod_estado;
    nuevo.posicion = $scope.posicion;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_estados', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "ft_estados_idioma");
      filtroEstado = [{ Field: 'codigo', Value: $scope.cod_estado, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'codigo', Value: $scope.cod_estado, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }

	$scope.$on("$destroy", function() {
		$scope.grid.ixSaveConfig();
		$scope.isDestroyed=true;
	});
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("Ft_EstadosController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', 'ixUtilsService', function ($scope, $http, $routeParams, $translate, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, ixWarningsService, ixUtilsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  //$scope.$parent.$parent.$parent.buscar = "ft_estados";//nombre de la clase que hay que utilizar para cargar el grid de resultados.

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("ft_estados");
  }
  $scope.data.pk = "codigo";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "codigo", "descripcion" ];
  $scope.data.fieldsToOrderBy = ["posicion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "ft_estados/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      //data = ViewBuilderService.getChangesTables();
      data.nuevoEstado = $scope.data.datos;

      //Crear nueva marca.
      $http.post(cfg.baseURL + "ft_estados", data.nuevoEstado).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar estado.
      data.estado = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'ft_estados/' + $scope.data.datos[$scope.data.pk], data.estado).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el estado " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "ft_estados/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

  $scope.openPopupTraduccion = function(cod){
    $log.log(cod);
		var template = "app/FTBase/Mantenimientos/ft_estados/traducciones_ft_estados.html";
		var optionsPopup = { controller: "TraduccionesFtEstadosController" };
		var paramsPopup = { cod_estado: $scope.data.datos.codigo, descripcion: $scope.data.datos.descripcion, posicion: $scope.data.datos.posicion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  }
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("Extranet_MarcasController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, ixWarningsService) {

	$scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("extranet_marcas");
  }

  $scope.data.pk = "id";
	$scope.data.showAsID = "marca";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "marca", "propietarionombre" ];
  $scope.data.fieldsToOrderBy = ["marca"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "0";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "extranet_marcas/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

	$scope.actualizarListado();

	$scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      //data = ViewBuilderService.getChangesTables();
      data.nuevaMarca = $scope.data.datos;

      //Crear nueva marca.
      $http.post(cfg.baseURL + "extranet_marcas", data.nuevaMarca).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar marca.
      data.marca = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'extranet_marcas/' + $scope.data.datos[$scope.data.pk], data.marca).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

	$scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar la marca " + $scope.data.datos.marca + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
		$http.delete(cfg.baseURL + "extranet_marcas/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("DiccionariosController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("diccionarios");
  }
  $scope.data.pk = "diccionario";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "descripcion" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;

    $scope.crearGridDiccionariosValores();

    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "diccionarios/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

        $scope.crearGridDiccionariosValores();

        // var filtroDiccionariosValores = [{ Field: 'diccionario', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
        // $scope.data.gridDiccionariosValores.filtroExterno = filtroDiccionariosValores;
        // $scope.data.gridDiccionariosValores.ixLoadInitialData();

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    $scope.actualizarPosiciones();
    var data = {};
    if ($scope.data.datos.isNew) {
      //Crear nuevo diccionario.
      data.nuevoDiccionario = $scope.data.datos;
      data.ubpValores = $scope.data.gridDiccionariosValores.ixGetBulkParam();

      $http.post(cfg.baseURL + "diccionarios/PostDiccionario", data).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
        $scope.data.gridDiccionariosValores.clearGridAfterSave();
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar diccionario.
      data.jpdDiccionario = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      data.ubpValores = $scope.data.gridDiccionariosValores.ixGetBulkParam();

      $http.put(cfg.baseURL + 'diccionarios/PutDiccionario/' + $scope.data.datos[$scope.data.pk], data).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.data.gridDiccionariosValores.clearGridAfterSave();
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixCancelEdit = function(){
    $scope.$parent.ixCancelEdit();
    $scope.data.gridDiccionariosValores.clearGridAfterSave();
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el diccionario " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "diccionarios/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
      $scope.data.gridDiccionariosValores.clearGridAfterSave(true);
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

	$scope.deleteSelectedRows = function(grid){
		grid.ixDeleteSelectedRows();
  };

	$scope.addRow = function(grid, item){
		var nuevo = item || {};

		nuevo.diccionario = $scope.data.datos.diccionario;
		grid.ixAddRow(nuevo);
  };






  $scope.crearGridDiccionariosValores = function(){
    if(!$scope.data.gridDiccionariosValores){
      var metadata = [];
      var filtroDiccionariosValores = [];
      var acciones = [
        {
          icon: "fa-arrows-alt",
          title: "Ordenar filas",
          visible: function(entity){
            return $scope.status.editing;
          },
          accion: function(entity){ return true; }
        }
      ];
      var extraColumns = [{ name: 'Acciones', type: 'detalle', allowCellFocus: false, width: 100, acciones: acciones }];
      $scope.data.gridDiccionariosValores = gridService.createGrid($scope, 'gnet_grid_diccionarios_valores', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: false, metadata: metadata/*, showOnlyDescribedCols: [ "centro"]*/ }, "diccionarios_valores",  extraColumns);
      filtroDiccionariosValores = [{ Field: 'diccionario', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, Skip: true }];
      $scope.data.gridDiccionariosValores.filtroExterno = filtroDiccionariosValores;
      $scope.data.gridDiccionariosValores.ixLoadInitialData();
      //$scope.data.gridDiccionariosValores.drawExtraColumns(extraColumns);
    } else {
      $scope.data.gridDiccionariosValores = gridService.createGridFunctions($scope, $scope.data.gridDiccionariosValores);
      $scope.data.gridDiccionariosValores.ixRestoreConfig();
      filtroDiccionariosValores = [{ Field: 'diccionario', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ, Skip: true }];
      $scope.data.gridDiccionariosValores.filtroExterno = filtroDiccionariosValores;
      $scope.data.gridDiccionariosValores.ixLoadInitialData();
    }
  }

  $scope.crearGridDiccionariosValores();

    $scope.actualizarPosiciones = function(){
      $scope.data.gridDiccionariosValores.data.forEach(function(element,index){

        if(!element.isNew){
          if(element.posicion != index + 1){
            element.posicion = index + 1;
            if(angular.isUndefined(element.modifiedValues)) element.modifiedValues = [];
            if(element.modifiedValues.indexOf("posicion") == -1)
      				element.modifiedValues.push("posicion");
            $scope.data.gridDiccionariosValores.gridApi.rowEdit.setRowsDirty([element]);
          }
        }else{
          element.posicion = index + 1;
        }

      })
    }


  $scope.ordenarValores = function(){
    function compare( a, b ) {
      if ( a.valor < b.valor ){
        return -1;
      }
      if ( a.valor > b.valor ){
        return 1;
      }
      return 0;
    }

    $scope.data.gridDiccionariosValores.data.sort( compare );
  }

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

  angular.module('FTBase').controller("DiccionariosController", ['$scope', '$http', '$translate', 'cfg', 'ixStatusService', 'gridService', 'ixWarningsService', function ($scope, $http, $translate, cfg, ixStatusService, gridService, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("diccionarios");
  }
  $scope.data.pk = "diccionario";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "descripcion" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = undefined;
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;

    $scope.crearGridDiccionariosValores();

    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "diccionarios/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

        $scope.crearGridDiccionariosValores();
      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    $scope.actualizarPosiciones();
    var data = {};
    if ($scope.data.datos.isNew) {
      //Crear nuevo diccionario.
      data.nuevoDiccionario = $scope.data.datos;
      data.ubpValores = $scope.data.gridDiccionariosValores.ixGetBulkParam();

      $http.post(cfg.baseURL + "diccionarios/PostDiccionario", data).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
        $scope.data.gridDiccionariosValores.clearGridAfterSave();
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar diccionario.
      data.jpdDiccionario = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      data.ubpValores = $scope.data.gridDiccionariosValores.ixGetBulkParam();

      $http.put(cfg.baseURL + 'diccionarios/PutDiccionario/' + $scope.data.datos[$scope.data.pk], data).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.data.gridDiccionariosValores.clearGridAfterSave();
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.ixCancelEdit = function(){
    $scope.$parent.ixCancelEdit();
    $scope.data.gridDiccionariosValores.clearGridAfterSave();
  };

  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el diccionario " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "diccionarios/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
      $scope.data.gridDiccionariosValores.clearGridAfterSave(true);
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

	$scope.deleteSelectedRows = function(grid){
		grid.ixDeleteSelectedRows();
  };

	$scope.addRow = function(grid, item){
		var nuevo = item || {};

		nuevo.diccionario = $scope.data.datos.diccionario;
		grid.ixAddRow(nuevo);
  };


  $scope.crearGridDiccionariosValores = function(){
    if(!$scope.data.gridDiccionariosValores){
      var metadata = [];
      var filtroDiccionariosValores = [];
      var acciones = [
        {
          icon: "fa-arrows-alt",
          title: $translate.instant("Ordenar filas"),
          visible: function(entity){
            return $scope.status.editing;
          },
          accion: function(entity){ return true; }
        }
      ];
      var extraColumns = [{ name: $translate.instant('Acciones'), type: 'detalle', allowCellFocus: false, width: 100, acciones: acciones }];
      $scope.data.gridDiccionariosValores = gridService.createGrid($scope, 'gnet_grid_diccionarios_valores', { minRowsToShow: 20, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: false, metadata: metadata/*, showOnlyDescribedCols: [ "centro"]*/ }, "valores_diccionariosVM",  extraColumns);
      filtroDiccionariosValores = [{ Field: 'diccionario', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
      $scope.data.gridDiccionariosValores.filtroExterno = filtroDiccionariosValores;
      $scope.data.gridDiccionariosValores.ixLoadInitialData();
      //$scope.data.gridDiccionariosValores.drawExtraColumns(extraColumns);
    } else {
      $scope.data.gridDiccionariosValores = gridService.createGridFunctions($scope, $scope.data.gridDiccionariosValores);
      $scope.data.gridDiccionariosValores.ixRestoreConfig();
      filtroDiccionariosValores = [{ Field: 'diccionario', Value: $scope.data.datos[$scope.data.pk], Operator: CMP_EQ }];
      $scope.data.gridDiccionariosValores.filtroExterno = filtroDiccionariosValores;
      $scope.data.gridDiccionariosValores.ixLoadInitialData();
    }
  }

  $scope.crearGridDiccionariosValores();

    $scope.actualizarPosiciones = function(){
      $scope.data.gridDiccionariosValores.data.forEach(function(element,index){

        if(!element.isNew){
          if(element.posicion != index + 1){
            element.posicion = index + 1;
            if(angular.isUndefined(element.modifiedValues)) element.modifiedValues = [];
            if(element.modifiedValues.indexOf("posicion") == -1)
      				element.modifiedValues.push("posicion");
            $scope.data.gridDiccionariosValores.gridApi.rowEdit.setRowsDirty([element]);
          }
        }else{
          element.posicion = index + 1;
        }

      })
    }


  $scope.ordenarValores = function(){
    function compare( a, b ) {
      if ( a.valor < b.valor ){
        return -1;
      }
      if ( a.valor > b.valor ){
        return 1;
      }
      return 0;
    }

    $scope.data.gridDiccionariosValores.data.sort( compare );
  }

	$scope.$on("$destroy", function() {
		$scope.data.gridDiccionariosValores.ixSaveConfig();
		$scope.isDestroyed=true;
	});

}]);

/*global CMP_EQ*/

angular.module('FTBase').controller('TraduccionesDepartamentosController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'ixUtilsService', function ($scope, cfg, gridService, $http, ixStatusService, ixUtilsService) {
	$scope.status = {
		editing: true
	};

	$scope.id = $scope.$resolve.id;
  $scope.descripcion = $scope.$resolve.descripcion;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.id = $scope.id;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_departamentos', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "departamentos_idioma");
      filtroEstado = [{ Field: 'codigo', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'codigo', Value: $scope.id, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }

	$scope.$on("$destroy", function() {
		$scope.grid.ixSaveConfig();
		$scope.isDestroyed=true;
	});
}]);

/*global ixGetPatchOperations*/
"use strict";

angular.module('FTBase').controller("DepartamentosController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'ixStatusService', 'ixUtilsService', '$timeout', '$log', '$q', 'ixWarningsService', function ($scope, $http, $routeParams, $translate, cfg, ixStatusService, ixUtilsService, $timeout, $log, $q, ixWarningsService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("departamentos");
  }
  $scope.data.pk = "codigo";
  $scope.data.showAsID = "descripcion";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = ["descripcion"];
  $scope.data.fieldsToOrderBy = ["descripcion"];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "departamentos/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

  $scope.actualizarListado();

  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      data.nuevoDepartamento = $scope.data.datos;

      //Crear nuevo tipo.
      $http.post(cfg.baseURL + "departamentos", data.nuevoDepartamento).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar tipo.
      data.laboratorio = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'departamentos/' + $scope.data.datos[$scope.data.pk], data.laboratorio).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
        $scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };


  $scope.ixDeleteSelectedRows = function(){
		var frase = "¿Se va a eliminar el área " + $scope.data.datos.descripcion + " , desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	};


	var accionEliminar = function(){
    $http.delete(cfg.baseURL + "departamentos/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
  };


  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/Mantenimientos/departamentos/traducciones_departamentos.html";
		var optionsPopup = { controller: "TraduccionesDepartamentosController" };
		var paramsPopup = { id: $scope.data.datos.codigo, descripcion: $scope.data.datos.descripcion };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  };


}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("CompradoresController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', '$ngConfirm', 'ixWarningsService',  function ($scope, $http, $routeParams, $translate, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q, $ngConfirm, ixWarningsService) {

	$scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("compradores");
  }

  $scope.data.pk = "id";
	$scope.data.showAsID = "nombre";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "nombre" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "0";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "compradores/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

	$scope.actualizarListado();

	$scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos[$scope.data.pk] == "0") {
      //data = ViewBuilderService.getChangesTables();
      data.nuevoComprador = $scope.data.datos;

      //Crear nuevo comprador.
      $http.post(cfg.baseURL + "compradores", data.nuevoComprador).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar comprador.
      data.comprador = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'compradores/' + $scope.data.datos[$scope.data.pk], data.comprador).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };

	$scope.ixDeleteSelectedRows = function(){
		var frase = "Se va a eliminar el comprador " + $scope.data.datos.nombre + " ¿Desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

	var accionEliminar = function(){
		$http.delete(cfg.baseURL + "compradores/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("ClientesController", ['$scope', '$http', '$routeParams', '$translate', 'cfg', 'ixStatusService', 'ixUtilsService', '$timeout', '$log', '$q', 'ixWarningsService',  function ($scope, $http, $routeParams, $translate, cfg, ixStatusService, ixUtilsService, $timeout, $log, $q, ixWarningsService) {

	$scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.ixEditarTooltip = $translate.instant('Cambia a modo edición');
  $scope.ixGuardarTooltip = $translate.instant('Guardar cambios');

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("clientes");
  }

  $scope.data.pk = "cliente";
	$scope.data.showAsID = "nombre";
	$scope.data.useModel = true;
	$scope.data.fieldsToFilter = [ "referencia", "nombre" ];
  $scope.data.marcas_extra = [];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "0";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }
		if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) return;
		else {
      $http.get(cfg.baseURL + "clientes/"+current[$scope.data.pk]).then(function(response){

        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);

        //Obtengo la lista de marcas de otros clientes que están permitidas
        $http.get(cfg.baseURL + "clientes/GetMarcasExtra/"+current[$scope.data.pk]).then(function(response){
          $scope.data.marcas_extra = response.data;
          //TODO: Copiar valores originales para verificar si se hacen cambios
        }, function(error){
          ixStatusService.setResponse(error);
        });

      }, function(error){
        ixStatusService.setResponse(error);
      });
		}
	}, true);

	$scope.actualizarListado();

	$scope.ixGuardarOLD = function () {
    var data = {};
    if ($scope.data.datos[$scope.data.pk] == "0") {
      data.nuevoCliente = $scope.data.datos;

      //Crear nuevo cliente.
      $http.post(cfg.baseURL + "clientes", data.nuevoCliente).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    } else {
      //Editar cliente.
      data.cliente = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);

      $http.put(cfg.baseURL + 'clientes/' + $scope.data.datos[$scope.data.pk], data.cliente).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  };


  $scope.ixGuardar = function (){
    var data = {};
    if ($scope.data.datos[$scope.data.pk] == "0") {
      data.nuevoCliente = $scope.data.datos;

      //Crear nuevo cliente.
      $http.post(cfg.baseURL + "clientes", data.nuevoCliente).then(function (r) {
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
				$scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar cliente.
      data.id_cliente = $scope.data.datos.cliente;
      data.upd_cliente = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      data.marcas_permitidas = $scope.data.marcas_extra;

      $http.put(cfg.baseURL + "clientes/ModificarInfoClente", data).then(function(r){
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        //TODO: ¿Actualizar $scope.data.marcas_extra?
        ixStatusService.setEditing(false);
				$scope.actualizarListado(true);
      }, function(error){

      });
    }
  };



	$scope.ixDeleteSelectedRows = function(){
		var frase = "Se va a eliminar el cliente " + $scope.data.datos.nombre + " ¿Desea continuar?";
		ixWarningsService.warningConfirmacion($scope,frase,accionEliminar);
	}

  $scope.loadMarcas = function(params){
    //params.Filters.push({ field: 'propietario', value: $scope.data.datos.cliente, op: '0', not: true });
    return $http.post(cfg.baseURL + "extranet_marcas/SearchFromOtherOwners", params);
  };


	var accionEliminar = function(){
		$http.delete(cfg.baseURL + "clientes/" + $scope.data.datos[$scope.data.pk]).then(function(r){

			ixStatusService.setResponse(r);
			ixStatusService.setEditing(false);
			$scope.data.datos = {};
			$scope.ixCancelEdit();
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

}]);

"use strict";

angular.module("FTBase").controller("UploadDocumentoAuditoriaPlantaController", ['$scope', '$uibModalInstance', '$http', 'cfg', 'ixStatusService', 'Upload', function($scope, $uibModalInstance, $http, cfg, ixStatusService, Upload) {
  $scope.status = ixStatusService.current;
  $scope.data = {id_planta: $scope.$resolve.id_planta, id_auditoria: $scope.$resolve.id_auditoria };
  $scope.fileUploaded = false; //El volver a la pantalla de llamada esta variable me permitirá señalar si se ha cargado algún archivo nuevo o no

  ixStatusService.setEditing(true); //Siempre se podrá añadir fichero

  $scope.save = function(){
    var fileNames = [];
    angular.forEach($scope.data.archivosToUpload, function (elem) {
      fileNames.push(elem.name);
    });

    $http.post(cfg.baseURL + 'auditorias_plantas_documentos/CanUpload/' + $scope.data.id_planta + '/' + $scope.data.id_auditoria, fileNames).then(function(response){
      var upload = Upload.upload({
        url: cfg.baseURL + "auditorias_plantas_documentos/UploadAndCreate",
        data: {
          file: $scope.data.archivosToUpload,
          id_planta: $scope.data.id_planta,
          id_auditoria: $scope.data.id_auditoria
        },
        dataType: 'json'
      });

      upload.then(function(resp){
        delete $scope.data.ixProgress;
        ixStatusService.setResponse(response);
        $uibModalInstance.close(true);
      },
      function(err){
        delete $scope.data.ixProgress;
        ixStatusService.setResponse(err);
      },
      function(evt){
        $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });
    },
    function(error){
      ixStatusService.setResponse(error);
    });
  };

  $scope.$dismiss = function () {
		$uibModalInstance.close(false);
	};
}]);
angular.module('FTBase').controller('SubirFotoProductoPopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService){
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
	$scope.status = { editing: true };
	$scope.data = {};

	$scope.save = function(){
		var fileNames = [];
		angular.forEach($scope.archivosToUpload, function(fileToUpload){
			fileNames.push(fileToUpload.name);
		});

		$http.post(cfg.baseURL + "ft_fotos_productos/CanUpload", fileNames).then(function(response){
			if(response.data.GlobalMessage.ErrType == 0){
				$scope.data.uploadingFile = true;
				var upload = Upload.upload({
					url: cfg.baseURL + "ft_fotos_productos/UploadAndCreate",
					data: {
						file: $scope.archivosToUpload
					},
					dataType: 'json'
				});

				upload.then(function(response){
					if(response.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
						ixStatusService.setResponse(response);
						$scope.status.editing = false;
						$uibModalInstance.close($scope.data);
					}
				}, function(response){
					if(response.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
						$scope.erroresUpload = response.data.obj.Errors;
					}
				}, function(evt){
					$scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			}
			else {
				ixStatusService.setResponse(response);
			}
		}, function(err){
			ixStatusService.setResponse(err);
		});

	};

	$scope.$close = function(){
		$uibModalInstance.dismiss('cancel');
	}

	$scope.$dismiss = function(){
		$uibModalInstance.close({});
	}

}]);

/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global buildIxSearch*/
/*global CMP_GTE*/
/*global saveAs*/

angular.module('FTBase').controller('AnaliticaFTPopupController', ['$scope', 'cfg', '$http', 'gridService', 'ixUtilsService', '$uibModalInstance', 'ixStatusService', '$q', '$timeout', 'Upload', '$ngConfirm', '$translate', function ($scope, cfg, $http, gridService, ixUtilsService, $uibModalInstance, ixStatusService, $q, $timeout, Upload, $ngConfirm, $translate) {
    $scope.status = ixStatusService.current;
    $scope.status.editing = true;
    $scope.data = {};
    $scope.data.datos = {};
    $scope.datos_modificados = false;

    $scope.loadValoresResultados = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "CORRECTO" },
                { valor: "INCORRECTO" },
                { valor: "NO CONFORME" }
            ];

            if ($scope.data.datos.tipo_analisis == 5) { //SOMMELIER
                //Agrego respuestas adicionales
                list.push({ valor: "ACEPTABLE" });
                list.push({ valor: "NOTABLE" });
                list.push({ valor: "EXCELENTE" });
            }

            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresRevisionNutriscore = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "Correcto" },
                { valor: "Incorrecto" },
                { valor: "No lo tiene en etiquetado" },
                { valor: "No aparece en FT" },
                { valor: "N/A" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresPuntuacionNutriscore = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "A" },
                { valor: "B" },
                { valor: "C" },
                { valor: "D" },
                { valor: "E" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.load_desviaciones_analiticas = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { descripcion: "FISICAS: Peso/Volumen" },
                { descripcion: "FISICAS: Categoría comercial" },
                { descripcion: "FISICAS: Otras" },
                { descripcion: "QUIMICAS" },
                { descripcion: "MICROBIOLOGICAS" },
                { descripcion: "ORGANOLEPTICAS" }
            ];
            return deferred.resolve({ data: list });
        }, 1);
        return deferred.promise;
    }

    $scope.load_acciones_correctoras = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { descripcion: "Análisis Extra del parámetro afectado" },
                { descripcion: "Baja de la referencia" },
                { descripcion: "Se realiza un cambio especificaciones ficha técnica" },
                { descripcion: "Otros" }
            ];
            return deferred.resolve({ data: list });
        }, 1);
        return deferred.promise;
    }

    $scope.load_desviaciones_etiquetados = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { descripcion: "MARCADO DE FECHAS" },
                { descripcion: "DECLARACIONES INCORRECTAS" },
                { descripcion: "CAMPO VISUAL" },
                { descripcion: "NUTRICIONALES E INGESTA DE REFERENCIA" },
                { descripcion: "ALTURA TEXTOS Y/O CIFRAS" },
                { descripcion: "DECLARACIONES ENGAÑOSAS" },
                { descripcion: "ALERGENOS" },
                { descripcion: "OTRAS" }
            ];
            return deferred.resolve({ data: list });
        }, 1);
        return deferred.promise;
    }

    $scope.load_valores_revision_online = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { descripcion: "Correcto" },
                { descripcion: "En web aparece foto front+traser" },
                { descripcion: "NC condiciones de conservación" },
                { descripcion: "NC info nutricional obligatoria" },
                { descripcion: "NC lista de ingredientes" },
                { descripcion: "NC nombre del fabricante" },
                { descripcion: "NC peso" },
                { descripcion: "No localizado producto en la web" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresEstadosIncidencia = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "ANULADO" },
                { valor: "PRODUCTO NO LOCALIZADO" },
                { valor: "APLAZADO" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresTiposEstudio = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "Sensorial" },
                { valor: "FQ" },
                { valor: "Expertos" },
                { valor: "Prueba funcional" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresCategorizaciones = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "Igual" },
                { valor: "Mejor" },
                { valor: "Aceptabilidad" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresPerfilesNutricionales = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: "Sin diferencias" },
                { valor: "Con diferencias" },
                { valor: "No aplica" }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.loadValoresPuntuacionVinos = function () {
        var deferred = $q.defer();
        $timeout(function () {
            var list = [
                { valor: 0.0 },
                { valor: 0.5 },
                { valor: 1.0 },
                { valor: 1.5 },
                { valor: 2.0 },
                { valor: 2.5 },
                { valor: 3.0 },
                { valor: 3.5 },
                { valor: 4.0 },
                { valor: 4.5 },
                { valor: 5.0 }
            ];
            return deferred.resolve({ data: list });
        }, 1);

        return deferred.promise;
    };

    $scope.cleanValues = function (entity) {
        if ($scope.data.datos.tipo_analisis == 3 && entity.valor == "INCORRECTO") $scope.data.datos.categorizacion = null;
    };

    if (!$scope.$resolve.is_new) {
        $http.get(cfg.baseURL + "ft_analiticas/" + $scope.$resolve.id_ft).then(function (response) {
            $scope.data.datos = response.data;
            $scope.data.datos.marca_desc = $scope.$resolve.marca;
            $scope.data.datos.proveedor = $scope.$resolve.proveedor;
            $scope.data.datos.cod_interno = $scope.$resolve.cod_interno;
            $scope.data.datos.denominacion = $scope.$resolve.titulo;
            // $scope.data.datos.ano_planificacion = $scope.data.datos.año_planificacion;

            $scope.data.datos_originales = angular.copy($scope.data.datos);

            //Convertir todos los campos que se separan por punto y coma a array (estos se volveran separar por ; al guardar los datos)
            if ($scope.data.datos.desviacion_analisis) {

                $scope.data.datos.desviacion_analisis = $scope.data.datos.desviacion_analisis.split(';').map(function (x) {
                    return { "descripcion": x };
                });
            }
            if ($scope.data.datos.acciones_analisis) {
                $scope.data.datos.acciones_analisis = $scope.data.datos.acciones_analisis.split(';').map(function (x) {
                    return { "descripcion": x };
                });
            }
            if ($scope.data.datos.desviacion_etiquetado) {
                $scope.data.datos.desviacion_etiquetado = $scope.data.datos.desviacion_etiquetado.split(';').map(function (x) {
                    return { "descripcion": x };
                });
            }
            if ($scope.data.datos.revision_online && ($scope.data.datos.estado == 'PLANIFICADO' || $scope.data.datos.estado == 'EN CORRECCION')) {
                $scope.data.datos.revision_online = $scope.data.datos.revision_online.split(';').map(function (x) {
                    return { "descripcion": x };
                });
            }
        }, function (error) {
            ixStatusService.setResponse(error);
        });
    }

    $scope.definirSave = function () {
        $scope.save = function () {
            var resultCabecera = $scope.validarCabecera();

            if (resultCabecera) {
                $ngConfirm(resultCabecera);
                return;
            }

            //Pasar los campos que son arrays a separados por punto y coma de nuevo
            separarArraysPuntoYComa();

            // $scope.data.datos.año_planificacion = $scope.data.datos.ano_planificacion;

            if ($scope.$resolve.is_new) {
                $scope.data.datos.estado = "PLANIFICADO";
                $http.post(cfg.baseURL + "ft_analiticas", $scope.data.datos).then(function (response) {
                    $scope.$resolve.is_new = false;
                    $scope.data.datos = response.data.obj.Record;
                    // $scope.data.datos['año_planificacion'] = $scope.data.datos.año_planificacion;
                    $scope.datos_modificados = true;
                    ixStatusService.setResponse(response);
                }, function (err) {
                    ixStatusService.setResponse(err);
                });
            }
            else {
                var jsonPatch = ixGetPatchOperations($scope.data.datos_originales, $scope.data.datos);
                $http.put(cfg.baseURL + "ft_analiticas/" + $scope.data.datos.id, jsonPatch).then(function (response) {
                    $scope.datos_modificados = true;
                    $uibModalInstance.close($scope.datos_modificados);
                }, function (err) {
                    ixStatusService.setResponse(err);
                });
            }
        }
    }

    if (!$scope.$resolve.is_new)
        $scope.definirSave();

    $scope.validarCabecera = function () {
        if (!$scope.data.datos.id_laboratorio || !$scope.data.datos.mes_planificacion || !$scope.data.datos['año_planificacion'] || !$scope.data.datos.tipo_analisis)
            return "Es obligatorio llenar todos los campos de la cabecera";

        if ($scope.data.datos.tipo_analisis == 2) {
            if (!$scope.data.datos.parametro || !$scope.data.datos.num_unidades)
                return "Es obligatorio llenar todos los campos de la cabecera";
        }
        return null;
    }

    $scope.validarResultados = function () {

        // if (!$scope.data.datos.fecha_realizacion)
        //     return "La fecha de análisis es obligatoria";
        if (!$scope.data.datos.ref_analisis)
            return "La referéncia de análisis es obligatoria";

        if (!$scope.data.datos.resultado_analisis && !$scope.data.datos.resultado_etiquetado)
            return "Se debe de seleccionar al menos un resultado (analítica o etiquetado)";

        if ($scope.data.datos.resultado_analisis) {
            // if($scope.data.datos.resultado_analisis != "CORRECTO"){ 
            //yves -mayo 2023: Cambio la condición para permitir que se finalicen análisis de tipo SOMMELIER con valores ACEPTABLE, NOTABLE, EXCELENTE
            if ($scope.data.datos.resultado_analisis == "INCORRECTO" || $scope.data.datos.resultado_analisis == "NO CONFORME") {
                if (!$scope.data.datos.desviacion_analisis)
                    return "Cuando el resultado analítica no es CORRECTO es necesario especificar las desviaciones";
                if (!$scope.data.datos.descripcion_desviacion_analisis)
                    return "Cuando el resultado analítica no es CORRECTO es necesario cumplimentar la descripción detallada de las desviaciones";
            }
            if ($scope.data.datos.resultado_analisis == "INCORRECTO" && !$scope.data.datos.acciones_analisis)
                return "Cuando el resultado analítica es INCORRECTO es necesario especificar las acciones correctoras";

        }

        if ($scope.data.datos.resultado_etiquetado) {
            if ($scope.data.datos.resultado_etiquetado == "INCORRECTO") {
                if (!$scope.data.datos.desviacion_etiquetado)
                    return "Cuando el resultado etiquetado no es CORRECTO es necesario especificar las desviaciones";
                if (!$scope.data.datos.descripcion_desviacion_etiquetado)
                    return "Cuando el resultado etiquetado no es CORRECTO es necesario cumplimentar la descripción detallada de las desviaciones";
            }
        }

        var posicionamiento = false;
        var analisis = false;
        var etiquetado = false;
        angular.forEach($scope.data.griddocumentos.data, function (value, key) {
            if (value.tipo == 3) {
                posicionamiento = true;
            } else if (value.tipo == 1) {
                analisis = true;
            } else if (value.tipo == 2) {
                etiquetado = true;
            }
        });

        if ($scope.data.datos.tipo_analisis == 3) {
            if (!posicionamiento)
                return "Es obligatorio subir un informe de posicionamiento";
        } else {
            if ($scope.data.datos.resultado_analisis && !analisis)
                return "Es obligatorio subir un informe de análisis";
            if ($scope.data.datos.resultado_etiquetado) {
                if (!$scope.data.datos.resultado_analisis && !etiquetado)
                    return "Es obligatorio subir un informe de etiquetado";
            }
        }

        return null;

    }

    $scope.finalizar = function () {
        var returnedValue = $scope.validarResultados();
        if (returnedValue) {
            $ngConfirm(returnedValue);
            return;
        }

        $scope.data.datos.fecha_finalizacion = new Date();
        if ($scope.data.datos.estado == "PLANIFICADO") {
            $scope.data.datos.estado = "FINALIZADO";
        }
        if ($scope.data.datos.estado == "EN CORRECCION") {
            $scope.data.datos.estado = "FINALIZADO-CORREGIDO";
        }

        $scope.save();
    }

    var separarArraysPuntoYComa = function () {
        //Se crea un string con los valores separados por ';' para guardarlos en DB
        //Desviacion analisis
        var separados = "";
        if ($scope.data.datos.desviacion_analisis) {
            $scope.data.datos.desviacion_analisis.forEach(function (element) {
                if (separados == "") {
                    if (element.descripcion)
                        separados = element.descripcion;
                    else
                        separados = element;
                }
                else {
                    if (element.descripcion)
                        separados += ";" + element.descripcion;
                    else
                        separados += ";" + element;
                }
            });
            $scope.data.datos.desviacion_analisis = separados;
        }
        //Acciones analisis
        separados = "";
        if ($scope.data.datos.acciones_analisis) {
            $scope.data.datos.acciones_analisis.forEach(function (element) {
                if (separados == "") {
                    if (element.descripcion)
                        separados = element.descripcion;
                    else
                        separados = element;
                }
                else {
                    if (element.descripcion)
                        separados += ";" + element.descripcion;
                    else
                        separados += ";" + element;
                }
            });
            $scope.data.datos.acciones_analisis = separados;
        }
        //Desviacion etiquetado
        separados = "";
        if ($scope.data.datos.desviacion_etiquetado) {
            $scope.data.datos.desviacion_etiquetado.forEach(function (element) {
                if (separados == "") {
                    if (element.descripcion)
                        separados = element.descripcion;
                    else
                        separados = element;
                }
                else {
                    if (element.descripcion)
                        separados += ";" + element.descripcion;
                    else
                        separados += ";" + element;
                }
            });
            $scope.data.datos.desviacion_etiquetado = separados;
        }
        //Revisión Online
        separados = "";
        if ($scope.data.datos.revision_online) {
            $scope.data.datos.revision_online.forEach(function (element) {
                if (separados == "") {
                    if (element.descripcion)
                        separados = element.descripcion;
                    else
                        separados = element;
                }
                else {
                    if (element.descripcion)
                        separados += ";" + element.descripcion;
                    else
                        separados += ";" + element;
                }
            });
            $scope.data.datos.revision_online = separados;
        }
    }

    $scope.cargarCamposLectura = function () {
        if ($scope.data.datos.id_ficha_tecnica && $scope.data.datos.ean) {
            var param = {};
            param.Filters = [];
            param.Filters.push({ Field: 'id_ficha_tecnica', Value: $scope.data.datos.id_ficha_tecnica, Operator: CMP_EQ });
            param.Filters.push({ Field: 'ean', Value: $scope.data.datos.ean, Operator: CMP_EQ });
            $http.post(cfg.baseURL + "listado_productos_analiticasFtVM/Search", param).then(function (response) {
                $scope.data.datos.marca_desc = response.data.Items[0].nombre_marca;
                $scope.data.datos.proveedor = response.data.Items[0].nombre_proveedor;
                $scope.data.datos.cod_interno = response.data.Items[0].cod_interno;
                $scope.data.datos.denominacion = response.data.Items[0].titulo;
                $scope.definirSave();
            }, function (error) {
                ixStatusService.setResponse(error);
            });
        }
    }

    if (!$scope.$resolve.is_new) {
        if (!$scope.data.griddocumentos) {
            var acciones = [
                {
                    title: $translate.instant("Descargar fichero"),
                    icon: "fa-download",
                    accion: function (entity) {
                        $scope.downloadDocFile(entity);
                    }
                }
            ];
            var param = buildIxSearch();
            param.Filters.push({ Field: 'id_analisis', Operator: CMP_EQ, Value: $scope.$resolve.id_ft })

            $scope.data.griddocumentos = gridService.createGrid($scope, 'gnet_grid_boletines_analisis_euromadi', {metadata: [], minRowsToShow: 5}, "boletines_analisis_euromadi", [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
            $scope.data.griddocumentos.filtroExterno = param.Filters;

        } else {
            $scope.data.griddocumentos = gridService.createGridFunctions($scope, $scope.data.griddocumentos);
            $scope.data.griddocumentos.ixRestoreConfig();
        }
    }

    $scope.addRow = function (grid, item) {
        var nuevo = item || {};

        if (grid.entity == 'boletines_analisis_euromadi') {
            nuevo.id_analisis = $scope.$resolve.id_ft;
            abrirPopupDocumento(nuevo);
        }
    };

    var abrirPopupDocumento = function (nuevo) {
        var template = "app/FTBase/ListadosFT/acciones/add_documentos_analitica_ft_popup.html";
        var options = { controller: "AddDocumentosAnaliticaFtPopupController" };
        var params = { id_analisis: $scope.$resolve.id_ft, tipo_analisis: $scope.data.datos.tipo_analisis };
        ixUtilsService.openModalV2(template, options, "small", params).then(function (response) {
            if (response) {
                $scope.data.griddocumentos.ixAddRow(nuevo);
                $scope.data.griddocumentos.ixLoadInitialData();
                $scope.datos_modificados = true;
            }
        });
    };

    $scope.downloadDocFile = function (entity) {
        $http({
            method: 'post',
            url: cfg.baseURL + 'boletines_analisis_euromadi/DownloadFile?id=' + entity.id,
            headers: {},
            responseType: 'arraybuffer'
        }).then(function (r) {
            var mimetype = r.headers('Content-type');
            var file = new Blob([r.data], { type: mimetype });

            var filename = entity.archivo;
            if (r.headers('Content-Disposition')) {
                filename = r.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
            }
            saveAs(file, filename);
        }, function (err) {
            ixStatusService.setResponse(err);
        });
    };

    $scope.deleteSelectedRows = function (grid) {
        if (grid.entity == "boletines_analisis_euromadi") {
            var lineasSeleccionadas = grid.gridApi.selection.getSelectedRows();
            $http.post(cfg.baseURL + "boletines_analisis_euromadi/DeleteBulk", lineasSeleccionadas).then(function (response) {
                if (response) {
                    $scope.data.griddocumentos.ixLoadInitialData();
                    ixStatusService.setResponse(response);
                    $scope.datos_modificados = true;
                }
            },
                function (error) {
                    ixStatusService.setResponse(error);
                });
        }
    };


    $scope.mostrarCamposExtaordinarios = function () {
        if ($scope.data.datos.tipo_analisis.descripcion == "EXTRAORDINARIO")
            return true;
        else
            return false;
    }

    $scope.deshabilitarResultados = function () {
        if (!$scope.$resolve.extranetUser.laboratorio || $scope.data.datos.estado == 'FINALIZADO' || $scope.data.datos.estado == 'FINALIZADO-CORREGIDO' || $scope.data.datos.estado == 'CORREGIDO')
            return true;
        else
            return false;
    }

    $scope.$dismiss = function () {
        $uibModalInstance.close($scope.datos_modificados);
        if (angular.isDefined($scope.data.griddocumentos)) {
            $scope.data.griddocumentos.ixSaveConfig();
        }
    }

    $scope.$on("$destroy", function () {
        if (angular.isDefined($scope.data.griddocumentos)) {
            $scope.data.griddocumentos.ixSaveConfig();
        }
        $scope.isDestroyed = true;
    });

}]);

angular.module('FTBase').controller('VersionarMasivamentePopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService){
	$scope.status = { editing: true };
	$scope.data = {};
    $scope.data.id_ficha_tecnicas = $scope.$resolve.id_ficha_tecnicas;

	$scope.save = function(){
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas/VersionarFTMasivamente" , $scope.data).then(function(response){
			$uibModalInstance.close(response);
		}, function(err){
			ixStatusService.setResponse(err);
		});

	};

	$scope.$close = function(){
		$uibModalInstance.dismiss('cancel');
	}

	$scope.$dismiss = function(){
		$uibModalInstance.close();
	}

}]);

/*global saveAs*/
angular.module('FTBase').controller('ImprimirFTPopupController', [ "$scope", "$uibModalInstance", "$http", "cfg", "ixStatusService", "idiomasFT", 'authService', function($scope, $uibModalInstance, $http, cfg, ixStatusService, idiomasFT, authService){

	$scope.status = { editing: true };

	$scope.traducible = $scope.$resolve.traducible;

	var tipo = $scope.$resolve.tipo;
	var id_ficha_tecnica = $scope.$resolve.id_ficha_tecnica;
	var ean = $scope.$resolve.ean;
	var lista_productos = $scope.$resolve.lista_productos;
	
	$scope.datos = {};
	$scope.datos.tipo_doc = "PDF"; //Por algún motivo no le gustaba $scope.tipo_doc
	$scope.reducida = 0;
	
	$scope.idiomas = idiomasFT.map(function(e){ return { value: e.codigo, text: e.descripcion, icon: e.icon }});
	$scope.idioma = null;

	var usuario = authService.authentication.userName;
	//Get condition user
  $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
    $scope.extranetUser = response.data;
  }, function (error) {
    ixStatusService.setResponse(error);
  });

	$scope.okBtnText = "Descargar";
	$scope.save = function(){
		if(tipo == "FT"){
			$scope.imprimirFt();
		} else if(tipo == "FT_PRODUCTO"){
			$scope.imprimirFtProducto();
		} else if(tipo == "FT_PRODUCTO_MASIVA"){
			$scope.impresionMasivaFT();
		}
	};

	
	$scope.imprimirFt = function(){
		var path = cfg.baseURL + "impresos/impresoFT/?idft=" + id_ficha_tecnica + "&docformat="+ $scope.datos.tipo_doc + "&reducido=" + $scope.reducida;
		if($scope.idioma)
			path+= "&idioma="+$scope.idioma;

		var config = {responseType: 'arraybuffer'};

		$http.get(path, config).then(function(response){

			var file = new Blob([response.data], { type: 'application/zip'});

			var filename = "ImpresosFichaTecnica_" + id_ficha_tecnica.replace("/","-") +".zip";
			if(response.headers('Content-Disposition')) {
				filename = response.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function(error){
			ixStatusService.setResponse(error);
		});
	};
	
	$scope.imprimirFtProducto = function () {
		var path = cfg.baseURL + "impresos/ImpresoProducto/?idft=" + id_ficha_tecnica + "&ean=" + ean + "&docformat=" + $scope.datos.tipo_doc + "&reducido=" + $scope.reducida; 
		if($scope.idioma)
			path+= "&idioma="+$scope.idioma;

    var config = { responseType: 'arraybuffer' };
    $http.get(path, config).then(function (response) {
      var file;
			var filename = ean + "_" + id_ficha_tecnica.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'-');

      if ($scope.datos.tipo_doc == "PDF") {
        file = new Blob([response.data], { type: 'application/pdf' });
        filename = filename + ".pdf";
      }
      else {
        file = new Blob([response.data], { type: 'application/ms-word' });
        filename = filename + ".doc";
      }
      if (response.headers('Content-Disposition')) {
        // filename = response.headers('Content-Disposition').split("=")[1];
				filename = response.headers('Content-Disposition').split(";")[1].trim().split('=')[1].replace(/"/g, '');
      }

      saveAs(file, filename);
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  };
	
	$scope.impresionMasivaFT = function () {
    var params = { docformat: $scope.datos.tipo_doc, reducido: $scope.reducida };
		if($scope.idioma)
			params.idioma = $scope.idioma;

    params.lista_productos = lista_productos;

    var config = { responseType: 'arraybuffer' };

    $http.post(cfg.baseURL + "impresos/ImpresionMasivaProductos", params, config).then(function (response) {
      var file = new Blob([response.data], { type: 'application/zip' });

      var filename = "ft_analiticas.zip";
      if (response.headers('Content-Disposition')) {
        filename = response.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    }, function (error) {
      ixStatusService.setResponse(error);
    });

  }
}]);

angular.module('FTBase').controller('DesbloquearMasivamentePopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', '$q', '$timeout', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService, $q, $timeout){
	$scope.status = { editing: true };
	$scope.data = {};
    $scope.data.id_ficha_tecnicas = $scope.$resolve.id_ficha_tecnicas;
    $scope.tipoFT = $scope.$resolve.tipoFT;

    $scope.loadBloquearDesbloquear = function () {
		var deferred = $q.defer();
		$timeout(function () {
			var list = [];
			list.push({ id: 1, nombre: "Bloquear"});
			list.push({ id: 0, nombre: "Desbloquear" });
			return deferred.resolve({ data: list });
		}, 1);
		return deferred.promise;
	};

	$scope.save = function(){
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/DesbloquearFTMasivamente" , $scope.data).then(function(response){
			$uibModalInstance.close(response);
		}, function(err){
			ixStatusService.setResponse(err);
		});
	};

	$scope.$close = function(){
		$uibModalInstance.dismiss('cancel');
	}

	$scope.$dismiss = function(){
		$uibModalInstance.close();
	}

}]);

angular.module('FTBase').controller('CopiarFotoProductoPopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', '$ngConfirm', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService, $ngConfirm){
	$scope.status = { editing: true };
	$scope.data = {};
	$scope.data.eanorigen =$scope.$resolve.eanorigen;

	$scope.save = function(checkdata){
		var warning = true;
    	if (angular.isDefined(checkdata) && checkdata == false) warning = false;
		$http.post(cfg.baseURL + "ft_fotos_productos/CopiarFotoProducto?eandestino="+ $scope.datos.eannuevo+ "&warning=" + warning +"&eanorigen="+ $scope.data.eanorigen).then(function(response){
			ixStatusService.setResponse(response);
			$uibModalInstance.close({});
		}, function(err){
			if (err.data.GlobalMessage.ErrType == 1){
				$ngConfirm({
				  icon: 'fa fa-warning',
				  title: 'Aviso',
				  content: err.data.GlobalMessage.Msg ,
				  scope: $scope,
				  closeIcon: false,
				  buttons: {
					ok: {
					  text: "Continuar",
					  btnClass: 'btn-ix-green',
					  show: 'true',
					  keys: ['enter'], 
					  action: function(scope){
						$scope.save(false);
						return true;
					  }
					},
					cancelar: {
					  text: "Cancelar",
					  btnClass: 'btn-ix-green',
					  show: 'true',
					  action: function(scope){
						return true;
					  }
					}
				  }
				});
			  }
			  else
				ixStatusService.setResponse(err);
		});
	};

	$scope.$close = function(){
		$uibModalInstance.dismiss('cancel');
	}

	$scope.$dismiss = function(){
		$uibModalInstance.close({});
	}
}]);

angular.module('FTBase').controller('AddFtPopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'ixStatusService', '$q', 'idiomasFT', function($scope, cfg, $http, $uibModalInstance, ixStatusService, $q, idiomasFT){
  $scope.status = {editing: true};
  // $scope.newIdFicha;

	$scope.loadIdiomas = function(param){
		var deferral = $q.defer();
    deferral.resolve({
        data: idiomasFT
    });
    return deferral.promise;
	};

  $scope.save = function(){
    //Crear nueva FT.
    $http.post(cfg.baseURL + "extranet_fichas_tecnicas", $scope.nuevaft).then(function (r) {
      ixStatusService.setResponse(r);
      // $scope.ixCancelEdit();
      $scope.newIdFicha = r.data.obj.Record.id;
      $uibModalInstance.close(r.data.obj.Record.id);
      //Abro nueva FT generada
    },
    function (error) {
      ixStatusService.setResponse(error);
    });
  }

  // $scope.$close = function () {
	// 	$uibModalInstance.dismiss('cancel');
	// };
  //
  // $scope.dismiss = function(){
  //   $uibModalInstance.close({ response: $scope.newIdFicha });
  // }
}]);

/*global angular*/
/*global buildIxSearch*/
/*global CMP_EQ*/
/*global saveAs*/
/*global ixGetPatchOperations*/
"use strict"

angular.module("FTBase").controller("AddDocumentosAnaliticaFtPopupController", ['$scope', '$uibModalInstance', '$http', 'cfg', 'gridService', '$filter', 'ixStatusService', 'ixUtilsService', '$q', '$timeout', 'Upload', '$translate', 'authService', function ($scope, $uibModalInstance, $http, cfg, gridService, $filter, ixStatusService, ixUtilsService, $q, $timeout, Upload, $translate, authService) {

    $scope.status = ixStatusService.current;
    $scope.status.editing = true;
    $scope.data = {};
    $scope.data.tipo_analisis = $scope.$resolve.tipo_analisis;
    $scope.data.id_analisis = $scope.$resolve.id_analisis;
    $scope.fileUploaded = false;

    $scope.save = function () {
        var fileNames = [];
        angular.forEach($scope.data.filesToUpload, function (elem) {
            fileNames.push(elem.name);
        });


        $http.post(cfg.baseURL + "ft_analiticas/CanUpload/" + $scope.data.id_analisis + "/" + $scope.data.datos.tipo, fileNames).then(function (response) {
            if (response.data.GlobalMessage.ErrType == 0) {
                var upload = Upload.upload({
                    url: cfg.baseURL + "ft_analiticas/UploadAndCreate/" + $scope.data.id_analisis + "/" + $scope.data.datos.tipo,
                    data: { file: $scope.data.filesToUpload },
                    dataType: 'json'
                });

                upload.then(function (response) {
                    if (response.data) {
                        delete $scope.ixProgress;
                        $scope.fileUploaded = true;
                        $scope.data.filesToUpload = null
                        $scope.data.datos.tipo = null
                    }
                }, function (error) {
                    delete $scope.data.ixProgress;
                    ixStatusService.setResponse(error);
                }, function (evt) {
                    // Math.min is to fix IE which reports 200% sometimes
                    //file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                    $scope.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            } else {
                ixStatusService.setResponse(response);
            }
        }, function (err) {
            ixStatusService.setResponse(err);
        });
    }

    $scope.$dismiss = function () {
        $uibModalInstance.close($scope.fileUploaded);
    };


}]);
angular.module('FTBase').controller('PlanificacionAnaliticasController', [ '$scope', 'ixStatusService', 'cfg', '$http', 'ixUtilsService', '$timeout', '$document', 'apiHubService', function($scope, ixStatusService, cfg, $http, ixUtilsService, $timeout, $document, apiHubService){
	$scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

	//GestPark ofrece la opción de simular. De momento solo actualizaremos.
	$scope.operaciones = { SIMULAR: 1, ACTUALIZAR: 2 };

	$scope.init = function(){

		$scope.ixEditar = function(){
			ixStatusService.setEditing(true);
			$scope.renderExcelTable();
		};

		$scope.ixCancelEdit = function(){
			$scope.data.excelData = [];
		};

		///////////////////////Funciones excel////////////////////////////

		$scope.heightStyle = {'height': 'calc(100vh - 420px)'};

		$scope.data.excelData = [];

		// Columnas del excel a mostrar
		var buildExcelCols = function(){
			return [
				{title: 'FT', readOnly: false, width: 100 },
				{title: 'EAN', readOnly: false, width: 100 },
				{title: 'LABORATORIO', readOnly: false, width: 110 },
				{title: 'MES', readOnly: false, width: 80 },
				{title: 'AÑO', readOnly: false, width: 80 },
				{title: 'TIPO ANALISIS', readOnly: false, width: 110 },
				{title: 'PARAMETRO', readOnly: false, width: 110 },
				{title: 'UNIDADES', readOnly: false, width: 110 }
			];
		};

		$scope.excelsettings = {
			contextMenu: ['row_above', 'row_below', 'remove_row'],
			minSpareRows: 1
		};

		// Excel
		$scope.renderExcelTable = function(){
			$timeout(function(){
				var hotDiv=angular.element("hot-table");
				if(hotDiv.isolateScope()){
					var hotInstance=hotDiv.isolateScope().hotInstance;

					var element = angular.element($document.find('#hot-container'));
					var height = element[0].offsetHeight;
					hotInstance.updateSettings({
						height: height,
						cells: function (row, col, prop) {
							var cellProperties = {};
							cellProperties.readOnly = !$scope.status.editing;
							return cellProperties;
						}
					});
					hotInstance.render();
				}
			},5);
		};



		// Columnas que va a mostra el excel (Requerido, si no se instancian no muestra nada)
		$scope.data.excelcolumns = buildExcelCols();

		// Color de las celdas en función de errores o no
		$scope.rendererColor = function(hotInstance, TD, row, col, prop, value, cellProperties) {
				TD.style.backgroundColor = value;
				TD.innerHTML = "";
			};

		var showErrorsInExcel = function(dataResult){
				$scope.data.excelDataErrors = [];
				$scope.data.lineasConError = [];
				$scope.data.lineasOK = 0;
				$scope.data.lineasConflicto = 0;
				$scope.data.lineasError = 0;
				angular.forEach(dataResult, function(data, i){
					var lineaOk = true;
					var results = [];

					if(data.ErrType == 2 || data.ErrType == 1)
						results.push(data.Msg);

					if(results.length == 0){
						results.push("OK");
					}

					var codigoColor;
					var errorMsg = {};
					if(data.ErrType == 0){
						codigoColor = "#008000";
						$scope.data.lineasOK++;
					} else if(data.ErrType == 2){
						lineaOk = false;
						codigoColor = "#FF0000";
						$scope.data.lineasError++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);

					} else if(data.ErrType == 1){
						lineaOk = true;
						codigoColor = "#FF9912";
						$scope.data.lineasConflicto++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);
					}

					if(ixUtilsService.isNotEmptyObject($scope.data.excelData[i])){
						$scope.data.excelData[i]["resultado_color"] = codigoColor;
						$scope.data.excelData[i]["resultado_msg"] = results.join("\n");
					}

					if(!lineaOk){
						$scope.data.lineasConError.push($scope.data.excelData[i]);
					}
				});
			};

		function trackUpdateJobProgress(job) {
				$scope.data.showResults = false;
				$scope.data.excelDataErrors = [];
				$scope.data.actualizando = true;
				$scope.$emit("loader_show");
				setProgressBarWidth(1);
				var hubProxy = apiHubService("ixJobHub", job);

				hubProxy.on('progressChanged', function (progress) {
					setProgressBarWidth(progress);
				});

				hubProxy.on('jobResult', function (result) {
					showErrorsInExcel(result.DetalleErrores);
				});

				hubProxy.on('jobCompleted', function (jobId) {
					$scope.data.showResults = true;
					$scope.$emit("loader_hide");

	//				if($scope.operacion == $scope.operaciones.ACTUALIZAR){
						if($scope.data.lineasConError.length > 0){
							$scope.data.mostrarBtnContinuarTraspaso = false;
							$scope.data.mostrarBtnContinuarErroneas = true;
						}
						else {
							$scope.data.mostrarBtnContinuarTraspaso = true;
							$scope.data.mostrarBtnContinuarErroneas = false;
						}

						$scope.hideCancelOnFilter = true;
						$scope.data.updatedTransfered = true;
	//				}

					hubProxy.closeConnection(hubProxy.getConnection());

					var msg = "";

	//				if($scope.operacion == $scope.operaciones.SIMULAR){
	//					msg = "Simulación terminada. Registros correctos: " + $scope.data.lineasOK;
	//				} else {
					msg = "Registros actualizados: " + $scope.data.lineasOK;
	//				}
					var responseObj = {
						status:200,
						data: {
							Result: true,
							GlobalMessage: {
								ErrType:0,
								Msg: msg,
								Property:null,
								TypeOfError:0
							}
						}
					};

					ixStatusService.setResponse(responseObj);
					$scope.data.showResults = true;
					$timeout(function() { delete($scope.data.ixProgress); }, 1000);
				});
			}

			function setProgressBarWidth(progress) {
				$scope.data.ixProgress = progress;
			}

			$scope.ixGuardar = function(){
				$scope.operacion = $scope.operaciones.ACTUALIZAR;
				var planificaciones = [];
				angular.forEach($scope.data.excelData, function(item){
					var plan = ObjKeyRename(item, {"0":"ft", "1":"ean", "2":"laboratorio", "3":"mes", "4":"año", "5":"tipo_analisis", "6":"parametro", "7":"unidades"});
					planificaciones.push(plan);
				});

				//var data = ixUtilsService.toJson($scope.data.excelData);
				var data = ixUtilsService.toJson(planificaciones);
				$http.post(cfg.baseURL + "ft_analiticas/TrapasoDatos?operacion="+$scope.operacion, data).then(function (r) {
					trackUpdateJobProgress(r.data);
				}, function(error){
					ixStatusService.setResponse(error);
				});
		};
	///////////////////////Fin Funciones excel////////////////////////////

	//================================================
	// Rename Objet's Keys [Copy]
	//   src : object - source obj
	//   map : object - rename map
	//           {"old1":"new1", "old2":"new2", ...}
	//================================================
	function ObjKeyRename(src, map) {
	    var dst = {};
	    // src --> dst (copy)
	    for(var key in src){
	        if(key in map)
	            // rename key
	            dst[map[key]] = src[key];
	        else
	            // same key
	            dst[key] = src[key];
	    }
	    return dst;
	}

	//================================================
	// Rename Objet's Keys [Direct]
	//   src : object - source obj
	//   map : object - rename map
	//           {"old1":"new1", "old2":"new2", ...}
	//================================================
	function ObjKeyRename2(src, map) {
	    var dst = {};
	    // src --> dst
	    for(var key in src){
	        if(key in map)
	            // rename key
	            dst[map[key]] = src[key];
	        else
	            // same key
	            dst[key] = src[key];
	    }
	    // clear src
	    for(var key2 in src){
	        delete src[key2];
	    }
	    // dst --> src
	    for(var key3 in dst){
	        src[key3] = dst[key3];
	    }
	}

		$scope.$on("$destroy", function() {
			$scope.isDestroyed=true;
		});
	}

}]);

/*jslint browser: true, white: true, plusplus: true, node:true*/
/*eslint angular/di: [2,"array"]*/
/*global CMP_EQ */
/*global CMP_GT */
/*global CMP_LT */
/*global CMP_GTE */
/*global CMP_LTE */
/*global CMP_LIKER */
/*global CMP_LIKEL */
/*global CMP_LIKE */
/*global CMP_LIKENONE */
/*global CMP_ISNULL */
(function() {
  'use strict';


  angular.module('gp4Controllers', ['ui.grid', 'ui.grid.edit', 'ui.grid.rowEdit', 'ui.grid.cellNav', 'ui.grid.resizeColumns', 'ui.grid.moveColumns', 'ui.grid.pinning', 'ui.grid.infiniteScroll', 'ui.grid.selection', 'ui.grid.saveState', 'ui.grid.autoResize', 'ui.mask', 'ui.validate', 'ui.select', 'ngSanitize', 'rzModule', 'chart.js', 'ui.layout', 'ui.grid.exporter', 'ui.grid.validate', 'ui.grid.draggable-rows', 'com.2fdevs.videogular', 'com.2fdevs.videogular.plugins.controls','com.2fdevs.videogular.plugins.overlayplay','com.2fdevs.videogular.plugins.poster', 'rzModule', 'nvd3', 'gridster', 'ngFileUpload', 'cp.ngConfirm', 'pdfjsViewer', 'angular-virtual-select', 'FBAngular', 'fayzaan.gRecaptcha.v3']);





  angular.module('gp4Controllers').controller('EditorController', [ '$scope', '$rootScope', '$http', 'cfg', '$window' ], function($scope, $rootScope, $http, cfg, $window) {

      // Obtener metadata de backend (TODO: cache)
      $http.get(cfg.baseURL+"metadata/"+$scope.entity).then(function(r){
          $scope.metadata = r.data;
          if($scope.gridOptions) {
              $scope.gridOptions.columnDefs = [];
              $scope.metadata.forEach(function(x){
                  //$scope.gridOptions.columnDefs.push({field:x.Name, type: convertFromServerType(x.Type)});
              });
          }
      });


    $scope.editar = function() {
      // TODO: crear un bloqueo
      $scope.bloqueo = {user : $rootScope.user,  ts : new Date(), app: $rootScope.currentApp};
      $scope.editing = true;
      $scope.editing = true;
    };

    $scope.cancelEdit = function() {
      // TODO: confirmació si dirty i eliminar bloqueig al server
      $scope.bloqueo = null;
      $scope.editing = false;
      $rootScope.editing = false;

      //TODO: restaurar si tenim copia original
      // $scope.model = angular.copy($scopy.originalModel);
      // $scope.editForm.$setPristine();
      // ... per guardar copia original
      // $scope.originalModel = angular.copy($scope.model);
    };

    $scope.newIncidencia = {};

    $scope.addIncidencia = function() {

      $scope.incidencias = $scope.incidencias || [];
      var newIncidencia = {};
      newIncidencia.time = new Date();
      newIncidencia.user = $rootScope.user;
      newIncidencia.text = $scope.newIncidencia.text;
      $scope.incidencias.push(newIncidencia);
      delete $scope.newIncidencia.text;
    };

    $scope.$on('$locationChangeStart', function( event ) {
      if($scope.editing) {
        // TODO: check if formObj.$pristine === false
        var answer = $window.confirm("Are you sure you want to leave this page? \n(all changed data will be lost)");
        if (!answer) {
          event.preventDefault();
        }
      }
    });

  } )


  angular.module('gp4Controllers').controller('ListController', ['$scope', '$rootScope', '$http', 'cfg', function($scope, $rootScope, $http, cfg) {
    $scope.search = {};
    $scope.items = [];
    $scope.page = 1;

    $scope.clearItems = function() {
      $scope.items = [];
      $scope.page = 1;
    };

    $scope.orderBy = [];
    $scope.setOrderBy = function(field, event) {
      if($scope.orderBy.indexOf(field)>=0) {
        $scope.orderBy[$scope.orderBy.indexOf(field)]="-"+field;
      } else if ($scope.orderBy.indexOf("-"+field)>=0) {
        $scope.orderBy.splice($scope.orderBy.indexOf("-"+field),1);
      } else {
        if(event.ctrlKey) {
          $scope.orderBy = $scope.orderBy.concat(field);
        } else {
          $scope.orderBy = [field];
        }
      }
      $scope.clearItems();
      $scope.loadMore();
    };

    $scope.loadMore = function() {

          var searchParam = $scope.buildSearchParam();
      searchParam.OrderBy = $scope.orderBy;

      $http.post(cfg.baseURL+$scope.entity+'/Search?Page='+$scope.page, searchParam).then(function(response) {
        $scope.items = $scope.items.concat(response.data.Items);
        $scope.page++;
      }, function(response){
        $scope.response = response;
      });
    };


  }])


  angular.module('gp4Controllers').controller('SetOrderByController', ['$scope', '$uibModalInstance', 'filter', function($scope, $uibModalInstance,filter) {
      $scope.filter = filter;
      $scope.orderBy = filter.search.OrderBy;

      $scope.ok = function() {
          $uibModalInstance.close($scope.orderBy);
      };

  }])


  angular.module('gp4Controllers').controller('ClientesListController', ['$scope','$controller', function($scope, $controller) {
    $scope.entity = "clientes";
    $controller('ListController', {$scope: $scope});

    $scope.columns = [{name:"cliente",class:"col-lg-1"},
                  {name:"nombre",class:"col-lg-4"},
                  {name:"nif",class:"col-lg-1"},
                  {name:"direccion",class:"col-lg-3"},
                  {name:"cpostal",class:"col-lg-1"},
                  {name:"poblacion",class:"col-lg-2"}
                  ];

    $scope.buildSearchParam = function() {
      return {Filters:[{Field:"nombre", Value:$scope.search.nombre, Operator: 6, Not: false}]};
    }


  }])

  angular.module('gp4Controllers').controller('MarcasListController', ['$scope','$controller', function($scope, $controller) {
    $controller('ListController', {$scope: $scope});

    $scope.entity="marcas";
    $scope.columns = [{name:"marca",class:"col-lg-2"},{name:"nombre",class:"col-lg-4"},{name:"activo",class:"col-lg-1"},{name:"color",class:"col-lg-1"}];

    $scope.buildSearchParam = function() {
      return {Filters:[{Field:"nombre", Value:$scope.search.nombre, Operator: 6, Not: false}]};
    };

  }])


  angular.module('gp4Controllers').controller('ClienteController', ['$scope', '$rootScope', '$controller', '$routeParams', '$http', 'uiGridConstants', 'cfg'], function($scope, $rootScope, $controller, $routeParams, $http, uiGridConstants, cfg) {
    $scope.entity = "clientes";
    $controller('EditorController', {$scope: $scope});

    if($routeParams.id) {

      // TODO: reload app from ws
      $scope.status.setTitle("cliente "+$routeParams.id);

      $http.get(cfg.baseURL+'clientes/'+$routeParams.id).then(function(response) {
        $scope.cliente = response.data;

        // TODO: remove hardcoded values for demo
        $scope.cliente.limiteInferior=30;
        $scope.cliente.limiteSuperior=70;
        $scope.cliente.prioridad=1;
        $scope.cliente.agudos=3;
        $scope.cliente.medios=6;
        $scope.cliente.graves=4;


        $scope.status.setTitle($scope.cliente.nombre);

        $http.post(cfg.baseURL+'clientes_cue/Search',{"Filters": [{"Field": "cliente","Value": $routeParams.id,"Operator": 0,"Not": false}],"OrderBy": ["cuenta"]}).then(function(response) {
          $scope.numCuentas = response.data.Items.length;
        },function(response){
          $scope.response = response;
        });

        $http.get(cfg.baseURL+'barcos').then(function(response) {
          $scope.allBarcos = response.data;
        },function(response){
          $scope.response = response;
        });


      },function(response){
        $scope.response = response;
      });


    } else {
      $scope.editing=true;
      $rootScope.editing=true;
    }


    $scope.guardar = function() {
      $http.put(cfg.baseURL+'clientes/'+$scope.cliente.cliente, $scope.cliente).then(function(response) {
        $scope.response = response;
        $scope.bloqueo = null;
        $scope.editing = false;
      },function(response){
        $scope.response = response;
      });
    };



  })






  angular.module('gp4Controllers').controller('BastidorController', ['$scope', '$rootScope', '$controller', '$routeParams', '$http', 'uiGridConstants', 'cfg'], function($scope, $rootScope, $controller, $routeParams, $http, uiGridConstants, cfg) {
    $controller('EditorController', {$scope: $scope});

    $scope.gridOptions = {enableHorizontalScrollbar : 0};
    $scope.gridOptions.columnDefs = [
      {name:"tipo",width:"6%", enableColumnMenu: false},
      {name:"grupo", enableColumnMenu: false},
      {name:"movimiento",width:"6%", enableColumnMenu: false},
      {name:"entrada", enableColumnMenu: false},
      {name:"salida", enableColumnMenu: false},
      {name:"cliente", enableColumnMenu: false},
      {name:"operacion", enableColumnMenu: false}
    ];

    $scope.grupo = $routeParams.grupo;
    $scope.chasis = $routeParams.chasis;
    $scope.movimiento = $routeParams.movimiento;

    var searchParam = {
      "Filters": [
        {"Field": "grupo", "Value": $routeParams.grupo, "Operator": 0, "Not": true},
        {"Field": "chasis", "Value": $routeParams.chasis, "Operator": 0, "Not": true},
        {"Field": "movimiento", "Value": $routeParams.movimiento, "Operator": 0, "Not": true}
      ],
      "OrderBy": [
        "grupo","chasis","movimiento"
      ]
    }

    $http.post(cfg.baseURL+'bastidores/Search',searchParam).then(function(response) {
      $scope.gridOptions.data = response.data.Items;
    },function(response){
      $scope.response = response;
    });






  })


  angular.module('gp4Controllers').controller('BastidoresListController', ['$scope', '$rootScope', '$http', 'uiGridConstants', '$timeout', '$q', 'cfg'], function($scope, $rootScope, $http, uiGridConstants, $timeout, $q, cfg) {
    $scope.data = [];
    $scope.firstPage = 0;
    $scope.lastPage = 0;

    $http.get(cfg.baseURL+'bastidores/ListadoGrupoChasis?page=1&itemsPerPage='+cfg.pageSize).then(function(response) {
      $scope.gridOptions.data = response.data.Items;
      $scope.firstPage++;
      $scope.lastPage++;
      $timeout(function() {
        $scope.gridApi.infiniteScroll.resetScroll( false,  response.data.CurrentPage < response.data.TotalPages );
      });
    },function(response){
      $scope.response = response;
    });

    $scope.gridOptions = {
      enableFiltering: true,
      showGridFooter: true,
      enableGridMenu: true,
      enableCellEdit: true,
      infiniteScrollRowsFromEnd: 40,
          infiniteScrollUp: true,
          infiniteScrollDown: true,
        columnDefs : [{name:'grupo'},{name:'chasis'},{name:'movimiento'}],
          onRegisterApi: function(gridApi){
            gridApi.infiniteScroll.on.needLoadMoreData($scope, $scope.getDataDown);
            gridApi.infiniteScroll.on.needLoadMoreDataTop($scope, $scope.getDataUp);
            $scope.gridApi = gridApi;
          }
    }

      $scope.toggleFiltering = function(){
        $scope.gridOptions.enableFiltering = !$scope.gridOptions.enableFiltering;
        $scope.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
      };


      /*$scope.getDataDown = function() {
          var promise = $q.defer();
          //url, pageSize,... no estan definides
          /*$http.get(url+"?page="+($scope.lastPage+1)+"&itemsPerPage="+pageSize).then(function(response) {
            $scope.lastPage++;
            $scope.gridApi.infiniteScroll.saveScrollPercentage();
            $scope.data = $scope.data.concat(response.data.Items);
            $scope.gridApi.infiniteScroll.dataLoaded($scope.firstPage > 1, response.data.CurrentPage < response.data.TotalPages ).then(function() {$scope.discardData('top');}).then(function() {
              promise.resolve();
            });
          },function(response) {
            $scope.gridApi.infiniteScroll.dataLoaded();
            promise.reject();
          });
          return promise.promise;
        };*/

    /*$scope.getDataUp = function() {
      var promise = $q.defer();
      //url, pageSize,... no estan definides
      /*$http.get(url+"?page="+($scope.firstPage-1)+"&itemsPerPage="+pageSize).then(function(response) {
              $scope.firstPage--;
              $scope.gridApi.infiniteScroll.saveScrollPercentage();
              $scope.data = response.data.Items.concat($scope.data);
              $scope.gridApi.infiniteScroll.dataLoaded($scope.firstPage > 1, response.data.CurrentPage < response.data.TotalPages).then(function() {$scope.discardData('bottom');}).then(function() {
                promise.resolve();
              });
            },function(response) {
              $scope.gridApi.infiniteScroll.dataLoaded();
              promise.reject();
            });
            return promise.promise;
          };*/
    /*$scope.discardData = function(direction) {
      //pageSize,... no estan definides
      if($scope.lastPage - $scope.firstPage > 3) {
        $scope.gridApi.infiniteScroll.saveScrollPercentage();
        if(direction==='top') {
          $scope.data = $scope.data.slice(pageSize);
          $scope.firstPage++;
             $timeout(function() {
                   // wait for grid to ingest data changes
                   $scope.gridApi.infiniteScroll.dataRemovedBottom($scope.firstPage > 1, true);
             });

        } else {
          $scope.data = $scope.data.slice(0, pageSize*4);
          $scope.lastPage--;
             $timeout(function() {
                   // wait for grid to ingest data changes
                   $scope.gridApi.infiniteScroll.dataRemovedBottom($scope.firstPage > 1, true);
             });
        }
      }
    }*/

  })

  angular.module('gp4Controllers').controller("ChartController", [ '$scope' ], function ($scope) {
      $scope.labels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012','2013','2014','2015'];
      $scope.series = ['Series A', 'Series B'];

      $scope.data = [
        [65, 59, 80, 81, 56, 55, 40, 44, 60, 77],
        [28, 48, 40, 19, 86, 27, 90, 80, 75, 88]
      ];


      $scope.pielabels = ["Download Sales", "In-Store Sales", "Mail-Order Sales"];
      $scope.piedata = [300, 500, 100];


  })

  angular.module('gp4Controllers').controller("PivotController", ['$scope','$http','$routeParams','cfg', '$log',function ($scope,$http,$routeParams,cfg, $log) {
    $scope.entity = $routeParams.entity;

    $scope.renderers = $.pivotUtilities;

    $log.log("calling api");
    $http.get(cfg.baseURL+$scope.entity).then(function(r) {
      $log.log("api called");
      $scope.pivotData = r.data;
      var derivers = $.pivotUtilities.derivers;
          angular.element("#pivotTableOutput").pivotUI($scope.pivotData, {
              rows: [],
              cols: [],
              renderers : $.extend($.pivotUtilities.renderers,$.pivotUtilities.d3_renderers,$.pivotUtilities.c3_renderers, $.pivotUtilities.export_renderers),
              rendererName: "Table"
          });
    });

  }]);
})();

/*global convertDateStringsToDates*/
/*global d3*/
/*global buildIxSearch*/
/*global saveAs*/
angular.module('gp4Controllers').factory('DataService', [ '$timeout', '$http', 'cfg', 'gridService', '$filter', function($timeout, $http, cfg, gridService, $filter) {
	var DataService = {
  
	  getCharts: getCharts,
	  updateChart: updateChart,
	  showWidget: showWidget,
	  exportWidget: exportWidget,
	  loadWidget: loadWidget,
		  getWidgetColorsByValue: getWidgetColorsByValue,
  
	  lineChart: {
		options: lineChartOptions,
		data: lineChartData
	  },
	  multiBarChart: {
		options: multiBarChartOptions,
		data: multiBarChartData
	  },
		  multiBarValuesChart: {
		options: multiBarValuesChartOptions,
		data: multiBarValuesChartData
	  },
		  multiChart: {
			  options: multiChartOptions,
			  data: multiChartData
		  },
	  multiBarHorizontalChart: {
		options: multiBarHorizontalChartOptions,
		data: multiBarHorizontalChartData
	  },
		  multiBarHorizontalValuesChart: {
		options: multiBarHorizontalValuesChartOptions,
		data: multiBarHorizontalValuesChartData
	  },
	  pieChart: {
		options: pieChartOptions,
		data: pieChartData
	  },
	  donutChart: {
		options: donutChartOptions,
		data: donutChartData
	  }
	};
  
	return DataService;
  
  
	function getCharts(modulo){
	  return $http.get(cfg.baseURL + "api_dashboard/GetMultiple/"+modulo).then(function(response){
		return response.data;
	  });
	}
  
	function updateChart(modulo, nombre, filtros){
	  var param = buildIxSearch();
		  filtros.forEach(function(filtro){
			  if(angular.isUndefined(filtro.value))
				  filtro.value = null;
		  });
	  param.Filters = filtros;
	  return $http.post(cfg.baseURL + "api_dashboard/GetSingle/"+modulo+"?nombre="+nombre, param).then(function(response){
		return response.data;
	  });
	}
  
	  function convertToIxSearchParameterFilter(filtros){
		  var IxSearchParamFilter = [];
		  angular.forEach(filtros, function(filtro){
  
			  if(filtro.tipo != "periodo")
				  convertDateStringsToDates(filtro);
  
		if(filtro.value == "") filtro.value = null;
			  if(angular.isDate(filtro.value)){
				  IxSearchParamFilter.push({field: filtro.name, value: $filter("date")(filtro.value, "yyyyMMdd") });
			  }
		else if(angular.isArray(filtro.value)){
		  IxSearchParamFilter.push({ field: filtro.name, value: filtro.value.join() });
		} else {
		  IxSearchParamFilter.push({ field: filtro.name, value: filtro.value });
		}
	  });
		  return IxSearchParamFilter;
	  }
  
	  function exportWidget(modulo, nombre, filtrosWidget){
		  var param = buildIxSearch();
		  filtrosWidget = convertToIxSearchParameterFilter(filtrosWidget);
		  filtrosWidget.forEach(function(filtro){
			  if(angular.isUndefined(filtro.value))
				  filtro.value = null;
		  });
	  param.Filters = filtrosWidget;
  
  
		  var config = {responseType:"arraybuffer"};
		  return $http.post(cfg.baseURL + "api_dashboard/Excel/"+modulo+"?nombre="+nombre, param, config).then(function(r){
		var file = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
			  var filename = nombre + ".xlsx";
			  if(r.headers('Content-Disposition')) {
				  filename = r.headers('Content-Disposition').split("=")[1];
			  }
			  saveAs(file, filename);
	  });
	  }
  
	  function moverEtiquetasEjeX(){
		  d3.selectAll('.dashboard-show-values .nv-x.nv-axis.nvd3-svg .tick').each(function(tick){
			  tick = d3.select(this);
			  var curAttribute = tick.attr('transform');
			  var valoresTransform = curAttribute.substr(curAttribute.lastIndexOf('(')+1, (curAttribute.lastIndexOf(')') - curAttribute.lastIndexOf('(')) - 1);
			  valoresTransform = valoresTransform.split(',');
			  var primerValorTransform = parseFloat(valoresTransform[0]);
			  var segundoValorTransform = valoresTransform[1];
  
			  var incremento = 30;
  
			  tick.attr('transform', 'translate('+ (primerValorTransform + incremento) +', ' + segundoValorTransform + ')');
		  });
  
		  var minTick = d3.select('.dashboard-show-values .nv-x.nv-axis.nvd3-svg .nv-axisMaxMin.nv-axisMaxMin-x.nv-axisMin-x');
		  minTick.attr('transform', 'translate(33, 0)');
  
		  var maxTick = d3.select('.dashboard-show-values .nv-x.nv-axis.nvd3-svg .nv-axisMaxMin.nv-axisMaxMin-x.nv-axisMax-x');
		  maxTick.attr('transform', 'translate(1767, 0)');
	  }
  
	function loadWidget(scope, modulo, widget) {
	  var filtros = convertToIxSearchParameterFilter(widget.filtros);
	  updateChart(modulo, widget.dataSource, filtros).then(function(response){
		widget.results = response.results;
		widget.tipo = (response.tipo.toUpperCase() != "GRAFICA") ? response.tipo.toLowerCase() : (widget.tipo || response.tipo.toLowerCase());
		if(response.colores)
		  widget.colores = response.colores;
  
		showWidget(scope, widget);
	  });
	}
  
	function showWidget(scope, widget){
	  var filtros = convertToIxSearchParameterFilter(widget.filtros);
	  if(widget.tipo == "medidor_radial") widget.tipo = "donutChart";
			if(widget.tipo == "tabla") widget.tipo = "grid";
	  if(widget.tipo == 'grid'){
				var metadata = (widget.grid) ? widget.grid.metadata : [];
  
				if(widget.results[0]){
					metadata = Object.keys(widget.results[0]).map(function(e,i){
						if(i>0){
							var colType = "";
							var rowValue = widget.results.find(function(row){ return row[e] != null; });
							if(angular.isUndefined(rowValue))
								colType = "string";
							else {
								var columnValue = rowValue[e];
								if(angular.isNumber(columnValue)){
									if(columnValue.toString().lastIndexOf('.') != -1){
										colType = "Decimal";
									} else {
										colType = "Int32";
									}
								} else if(angular.isDate(columnValue)){
									colType = "DateTime";
								} else {
									colType = "string";
								}
							}
  
							var columnsTotalizar = [];
							if(widget.totales != null) columnsTotalizar = widget.totales.split(",");
  
							if(columnsTotalizar.indexOf((i+1)+"") != -1){
								return { Name: e, Type: colType, SumColumn: true };
							} else {
								return { Name: e, Type: colType };
							}
  
						} else {
								return {Name: e, Type: (angular.isDate(widget.results[0][e]) ? "DateTime" : "") };
						}
					});
				}
  
		//Crear una grid amb les dades que tenim i les propietats de l'objecte com a capçaleres (totes de tipus int).
				if(!widget.grid)
			widget.grid = gridService.createGrid(scope, "Dashboard_"+widget.dataSource+"_grid", { enableCellEdit: false, enableRowSelection: false, enableRowHeaderSelection: false, showColumnFooter: true, metadata: metadata });
				else {
					widget.grid.ixSaveConfig();
					widget.grid.metadata = metadata;
					widget.grid = gridService.createGridFunctions(scope, widget.grid);
					widget.grid.ixColDefCreated = false;
					widget.grid.ixRestoreConfig();
				}
  
  
		widget.grid.columnDefs = [];
		widget.grid.ixGetColsFromAPI();
		widget.grid.data = widget.results;
	  } else {
		//update with new options and data
		if (widget.tipo){
			if(widget.tipo == "multiBarChart" && widget.invertir_bar_lin){
				
				widget.chart.options = DataService["multiChart"].options(undefined, undefined, widget.invertir_bar_lin);
				widget.chart.data = DataService["multiChart"].data(widget.results, filtros, widget.mostrar, widget.invertir_bar_lin);
			}
			else {
				widget.chart.options = DataService[widget.tipo].options(undefined, undefined, widget.invertir_bar_lin);
				if(widget.colores)
					widget.chart.options.chart.color = angular.fromJson(widget.colores);
				else {
					if((angular.isDefined(widget.results)) && angular.isDefined(widget.results[0])){
						var objectKeys = Object.keys(widget.results[0]);
						var region = objectKeys.find(function(e,i){ return i==0; });
						widget.chart.options.chart.color = DataService.getWidgetColorsByValue(widget.results, region);
					}
				}
  
				  widget.chart.data = DataService[widget.tipo].data(widget.results, filtros, widget.mostrar, widget.invertir_bar_lin);
			}
  
		  //Serveix per desmarcar aquells valors que s'hagin guardat com a desmarcats a la llegenda.
		  angular.forEach(widget.disableds, function(disabled){
			var toDisable = widget.chart.data.find(function(e){ return e.key == disabled;});
			if(angular.isDefined(toDisable)) toDisable.disabled = true;
		  });
  
		  angular.merge(widget.chart.options.chart, widget.storedOptions);
  
		  //El nom de l'eix X és sempre el nom de la primera propietat que ve de la API.
		  widget.ejeX;
		  widget.valoresEjeY;
		  if(angular.isDefined(widget.results[0])){
			objectKeys = Object.keys(widget.results[0]);
			widget.ejeX = objectKeys.find(function(e,i){return i==0;});
						widget.valoresEjeY = objectKeys.filter(function(e,i){return i!==0;});
		  }
  
		  //Agafem la label més llarga per calcular el marge que deixarem.
		  var lengthX = 0;
					var lengthY = 0;
		  widget.results.forEach(function(result){
			var ejeXString = result[widget.ejeX] + "";
  
			if(ejeXString.length > lengthX)
			  lengthX = ejeXString.length;
						widget.valoresEjeY.forEach(function(ejeY){
							var ejeYString = result[ejeY] + "";
  
							if(ejeYString.length > lengthY)
								lengthY = ejeYString.length;
						});
		  });
					if(widget.tipo == 'multiBarHorizontalChart'){
						lengthY = (lengthX * 6) + 10;
						lengthX = 0;
						if(widget.chart.options.chart.margin.left < lengthY)
				widget.chart.options.chart.margin.left = lengthY;
					}
		  else if(widget.tipo == 'lineChart' || widget.tipo == 'multiBarChart'){
			lengthY = lengthY * 6;
						lengthX = lengthX * 6;
  
						if(widget.chart.options.chart.margin.left < lengthY)
				widget.chart.options.chart.margin.left = lengthY;
		  } else {
			lengthX = lengthX * 4;
		  }
					if(widget.chart.options.chart.margin.bottom < lengthX)
						widget.chart.options.chart.margin.bottom = lengthX;
  
  
		  if(widget.tipo == 'lineChart'/* || widget.tipo == 'multiBarChart'*/){
			widget.chart.options.chart.x = function(d){ if(angular.isDefined(d)) return d.x; };
			widget.chart.options.chart.xAxis.tickValues = function(d){
			  var values=[];
			  widget.results.map(function(v,i){
				values.push(i);
			  })
			  return values
			};
  
			widget.chart.options.chart.xAxis.tickFormat = function(d) {
			  var label = "";
			  if(angular.isDefined(widget.results[d-1]))
				label = widget.results[d-1][widget.ejeX];
			  return label;
			};
		  } else if(widget.tipo != 'pieChart') {
			widget.chart.options.chart.x = function(d){ if(angular.isDefined(d)) return d.x; };
			if(angular.isDefined(widget.chart.options.chart.xAxis)){
  
							if(widget.chart.options.chart.type == "multiChart" || widget.chart.options.chart.labelAsMultiChart){
								widget.chart.options.chart.xAxis.tickFormat = function(d) {
									return widget.chart.data[0].values[d-1].xLabel;
								};
							}
							else {
								widget.chart.options.chart.xAxis.tickFormat = function(d) {
					var label = d;
					return label;
								};
							}
			}
		  }
		  if(widget.tipo != 'pieChart' && angular.isDefined(widget.chart.options.chart.xAxis)) widget.chart.options.chart.xAxis.axisLabel = widget.ejeX;
  
		}
		//update new chart
		$timeout(function(){
		  widget.chart.api.update();
		},600);
	  }
	}
  
	  /**
	   *  Data & Options Generators
	   */
	  function lineChartOptions(xAxisLabel, yAxisLabel) {
		var options = {
				  chart: {
					  //type: 'lineChart',
					  type: 'multiChart',
					  reduceXTicks: false,
					  margin : {
							  top: 40,
							  right: 20,
							  bottom: 40,
							  left: 55
					  },
					  x: function(d){ return d.x; },
					  y: function(d){ return d.y; },
					  useInteractiveGuideline: true,
					  xAxis: {
						  showMaxMin: true,
						  rotateLabels: -25,
						  axisLabel: xAxisLabel || 'Concesionario',
						  axisLabelDistance: -5,
						  tickFormat: function(d){
							  return d;
						  }
					  },
					  /*yAxis: {
						  axisLabel: yAxisLabel || 'Cantidad',
						  tickFormat: function(d){
							  return d3.format('.02f')(d);
						  },
						  axisLabelDistance: -10
					  },*/
					  yAxis1: {
						  axisLabel: yAxisLabel || 'Cantidad',
						  tickFormat: function(d){
							  return d3.format('.02f')(d);
						  },
						  axisLabelDistance: -10
					  },
					  /*yAxis2: {
						  axisLabel: yAxisLabel || 'Cantidad',
						  tickFormat: function(d){
							  return d3.format('.02f')(d);
						  },
						  axisLabelDistance: -10
					  },*/
					  showLegend: true,
					  lines: {
						  forceY: [0]
					  }
				  }
		  };
  
		  options.class = "dashboard-show-values";
  
		  getWidgetColors(options);
  
		  return options;
	  }
	  function lineChartData(data, filtros, mostrar, invertir_bar_lin) {
	  var objectKeys = [];
  
	  if(angular.isDefined(data[0])){
		objectKeys = Object.keys(data[0]);
	  }
  
	  var linesKey = [];
	  var linesData = [];
	  filtros = getVisibleColumns(data, mostrar);
	  angular.forEach(objectKeys, function(key){
		var i = 0;
		filtros.forEach(function(filtro){
		  i++;
		  if(filtro == key){
			var i = 0;
			linesKey.push(filtro);
			linesData.push(data.map(function(e){ i++; return {x: i, y: e[key] }; }));
		  }
		});
	  });
  
	  var chartData = [];
  
	  for(var i = 0; i < linesKey.length; i++){
			  chartData.push({ values: linesData[i], key: linesKey[i], yAxis: 1, type: (hayQueInvertir(objectKeys, invertir_bar_lin, linesKey[i])) ? "bar" : "line" });
	  }
  
	  $timeout(function(){
		  mostrarValoresEnWidget();
	  },500);
  
	  return chartData;
	  }
  
	  function multiChartOptions(xAxisLabel, yAxisLabel) {
		  //A SUBSTITUIR
		  var options = {
				  chart: {
					  type: 'multiChart',
					  reduceXTicks: false,
					  margin : {
							  top: 40,
							  right: 20,
							  bottom: 50,
							  left: 55
					  },
					  clipEdge: true,
					  duration: 500,
					  stacked: true,
					  controlLabels: {
						  grouped: "Agrupado",
						  stacked: "Apilado"
					  },
					  x: function(d){ return d.x; },
					  y: function(d){ return d.y; },
					  useInteractiveGuideline: true,
					  xAxis: {
						  showMaxMin: true,
						  rotateLabels: -25,
						  axisLabel: xAxisLabel || 'Concesionario',
						  axisLabelDistance: -5,
						  tickFormat: function(d){
							  return d;
						  }
					  },
					  yAxis1: {
						  axisLabel: yAxisLabel || 'Cantidad',
						  tickFormat: function(d){
							  return d3.format('.02f')(d);
						  },
						  axisLabelDistance: -10
					  },
					  showLegend: true,
					  lines: {
						  forceY: [0]
					  }
				  }
		  };
  
		  getWidgetColors(options);
  
		  return options;
	  }
  
	  function multiChartData(data, filtros, mostrar, invertir_bar_lin) {
		  var objectKeys = [];
  
	  if(angular.isDefined(data[0])){
		objectKeys = Object.keys(data[0]);
	  }
  
	  var linesKey = [];
	  var linesData = [];
	  //filtros = objectKeys.filter(function(e,i){ return i!==0;});
	  filtros = getVisibleColumns(data, mostrar);
		  var region = objectKeys.find(function(e,i){ return i==0; });
	  angular.forEach(objectKeys, function(key){
			  var i = 0;
		filtros.forEach(function(filtro){
				  i++;
		  if(filtro == key){
					  var i = 0;
			linesKey.push(filtro);
					  linesData.push(data.map(function(e){ i++; return {x: i, y: e[key], xLabel: e[region] }; }));
		  }
		});
		  });
  
	  var chartData = [];
  
	  for(var i = 0; i < linesKey.length; i++){
		//chartData.push({ values: linesData[i], key: linesKey[i], area: true });
			  //chartData.push({ values: linesData[i], key: linesKey[i], type: (linesKey[i].indexOf("limite") != -1) ? "line" : "area" });
			  chartData.push({ values: linesData[i], key: linesKey[i], yAxis: 1, type: (hayQueInvertir(objectKeys, invertir_bar_lin, linesKey[i])) ? "line" : "bar" });
	  }
  
	  return chartData;
  
	  }
  
	  function multiBarChartOptions(xAxisLabel, yAxisLabel) {
		var options = {
				  chart: {
						  type: 'multiBarChart',
						  //height: 450,
						  reduceXTicks: false,
						  margin : {
								  top: 20,
								  right: 20,
								  bottom: 50,
								  left: 100
						  },
						  clipEdge: true,
						  duration: 500,
						  stacked: true,
						  controlLabels: {
							  grouped: "Agrupado",
							  stacked: "Apilado"
						  },
						  xAxis: {
							  rotateLabels: -25,
							  axisLabel: xAxisLabel || 'Concesionario',
							  showMaxMin: false,
							  tickFormat: function(d){
								  if(angular.isNumber(d))
									  return d3.format(',f')(d);
								  else
									  return d;
							  }
						  },
						  yAxis: {
								  axisLabel: yAxisLabel || 'Cantidad',
								  axisLabelDistance: -20,
								  tickFormat: function(d){
									  //return d3.format(',.1f')(d);
									  return d3.format('.02f')(d);
								  }
						  }
				  }
		  };
  
		  getWidgetColors(options);
  
		  return options;
	  }
	  function multiBarChartData(data, filtros, mostrar, invertir_bar_lin) {
	  var objectKeys = [];
  
	  if(angular.isDefined(data[0])){
		objectKeys = Object.keys(data[0]);
	  }
  
	  var linesKey = [];
	  var linesData = [];
	  filtros = getVisibleColumns(data, mostrar);
	  var region = objectKeys.find(function(e,i){ return i==0; });
	  angular.forEach(objectKeys, function(key){
			  var i = 0;
		filtros.forEach(function(filtro){
				  i++;
		  if(filtro == key){
					  var i = 0;
			linesKey.push(filtro);
					  linesData.push(data.map(function(e){ return {x: e[region], y: (angular.isDefined(e[key]) ? e[key] : 0) }; }));
		  }
		});
	  });
  
	  var chartData = [];
  
	  for(var i = 0; i < linesKey.length; i++){
		chartData.push({ values: linesData[i], key: linesKey[i], area: true });
	  }
  
	  mostrarValoresEnWidget();
  
	  return chartData;
	  }
	  //
	  function multiBarValuesChartOptions(xAxisLabel, yAxisLabel, invertir_bar_lin){
		  var options;
		  if(invertir_bar_lin == null){
			  options = multiBarChartOptions(xAxisLabel, yAxisLabel);
			  options.chart.labelAsMultiChart = true;
		  }
		  else
			  options = multiChartOptions(xAxisLabel, yAxisLabel);
  
		  options.class = "dashboard-show-values";
		  return options;
	  }
  
	  function mostrarValoresEnWidget(){
		  d3.selectAll('.dashboard-show-values .nv-multibar .nv-group').each(function(group){
			  var g = d3.select(this);
  
			  // Remove previous labels if there is any
			  g.selectAll('text').remove();
			  g.selectAll('.nv-bar').each(function(bar){
				  var b = d3.select(this);
				  var barWidth = b.attr('width');
				  var barHeight = b.attr('height');
  
				  g.append('text')
					  // Transforms shift the origin point then the x and y of the bar
					  // is altered by this transform. In order to align the labels
					  // we need to apply this transform to those.
					  .attr('transform', b.attr('transform'))
					  .text(function(){
						  // No decimals format and eliminate zero values
						  if (bar.y === 0) {
							  return;
						  }
						  return parseFloat(bar.y).toFixed(2);
					  })
					  .attr('y', function(){
						  // Center label vertically
						  var height = this.getBBox().height;
						  return parseFloat(b.attr('y')) + 15;
					  })
					  .attr('x', function(){
						  // Center label horizontally
						  var width = this.getBBox().width;
						  return parseFloat(b.attr('x')) + (parseFloat(barWidth) / 2) - (width / 2);
					  })
					  .style("stroke","black")
					  .attr('class', 'bar-values');
			  });
		  });
	  }
  
	  function multiBarValuesChartData(data, filtros, mostrar, invertir_bar_lin){
		  $timeout(function () {
			  mostrarValoresEnWidget();
		  }, 800);
		  return multiChartData(data, filtros, mostrar, invertir_bar_lin);
	  }
  
	function multiBarHorizontalChartOptions(xAxisLabel, yAxisLabel) {
		var options = {
		chart: {
		  type: 'multiBarHorizontalChart',
		  //height: 450,
		  margin : {
			  top: 20,
			  right: 20,
			  bottom: 45,
			  left: 150
		  },
		  clipEdge: true,
		  duration: 500,
		  stacked: true,
		  controlLabels: {
			grouped: "Agrupado",
			stacked: "Apilado"
		  },
		  xAxis: {
			axisLabel: xAxisLabel || 'Mes',
			rotateLabels: -25,
			showMaxMin: false,
			tickFormat: function(d){
			  return d3.format(',f')(d);
			}
		  },
		  yAxis: {
			axisLabel: yAxisLabel || 'Cantidad',
			axisLabelDistance: -20,
			tickFormat: function(d){
			  //return d3.format(',.1f')(d);
						  return d3.format('.02f')(d);
			}
		  }
		}
	  };
  
		  getWidgetColors(options);
  
		  return options;
	  }
	  function multiBarHorizontalChartData(data, filtros, mostrar, invertir_bar_lin) {
	  var objectKeys = [];
  
	  if(angular.isDefined(data[0])){
		objectKeys = Object.keys(data[0]);
	  }
	  var linesKey = [];
	  var linesData = [];
	  filtros = getVisibleColumns(data, mostrar);
  
	  var region = objectKeys.find(function(e,i){ return i==0; });
	  angular.forEach(objectKeys, function(key){
		filtros.forEach(function(filtro){
		  //if(filtro.field == key && (angular.isDefined(filtro.value) && filtro.value != null)){
		  if(filtro == key){
			//linesKey.push(filtro.value);
			linesKey.push(filtro);
			linesData.push(data.map(function(e){ return {x: e[region], y: (angular.isDefined(e[key]) ? e[key] : 0) }; }));
		  }
		});
	  });
  
	  var chartData = [];
  
	  for(var i = 0; i < linesKey.length; i++){
			  if(!hayQueInvertir(objectKeys, invertir_bar_lin, linesKey[i]))
			chartData.push({ values: linesData[i], key: linesKey[i], area: true });
	  }
  
	  return chartData;
	  }
  
	  function multiBarHorizontalValuesChartOptions(xAxisLabel, yAxisLabel) {
		  var options = multiBarHorizontalChartOptions(xAxisLabel, yAxisLabel);
  
		  options.chart.stacked = false;
		  options.chart.showControls = false;
		  options.chart.showValues = true;
  
		  getWidgetColors(options);
  
		  return options;
	  }
  
	  function multiBarHorizontalValuesChartData(data, filtros, mostrar, invertir_bar_lin) {
	  return multiBarHorizontalChartData(data, filtros, mostrar, invertir_bar_lin);
	  }
  
	function pieChartOptions() {
	  var options = {
				  chart: {
						  type: 'pieChart',
						  margin : {
								  top: 30,
								  right: 0,
								  bottom: 0,
								  left: 0
						  },
						  x: function(d){return d.key;},
						  y: function(d){return d.y;},
						  showLabels: true,
						  duration: 500,
						  labelThreshold: 0.01,
						  labelSunbeamLayout: true,
						  showLegend: true,
						  labelType: function(d){
							  var percent = (d.endAngle - d.startAngle) / (2 * Math.PI);
							  return d.data.key + " - " + d3.format('.2%')(percent);
						  }
				  }
		  };
  
		  getWidgetColors(options);
  
		  return options;
	}
	function pieChartData(data, filtros, mostrar, invertir_bar_lin) {
	  var datos = [];
	  if((angular.isDefined(data)) && angular.isDefined(data[0])){
		var objectKeys = Object.keys(data[0]);
		var region = objectKeys.find(function(e,i){ return i==0; });
		var lastAttrName = "";
		if(angular.isDefined(mostrar)){
		  var camposAMostrar = mostrar.split(",");
		  lastAttrName = objectKeys[camposAMostrar.length-1];
		} else {
		  lastAttrName = objectKeys[objectKeys.length-1];
		}
		angular.forEach(data, function(value){
		  datos.push({"key": value[region], "y": value[lastAttrName] });
		});
	  }
	  return datos;
	}
  
	function donutChartOptions() {
	  var options = {
		chart: {
		  "type": "pieChart",
		  "height": 450,
		  "donut": true,
		  "showLabels": true,
		  x: function(d){ return d.key; },
		  y: function(d){ return d.y; },
		  "pie": {
			startAngle: function (d) { return d.startAngle/2 -Math.PI/2 },
			endAngle: function (d) { return d.endAngle/2 -Math.PI/2 }
		  },
		  "duration": 500,
		  /*"legend": {
			"margin": {
			  "top": 5,
			  "right": 140,
			  "bottom": 5,
			  "left": 0
			}
		  }*/
		  showLegend: true
		}
	  };
  
		  getWidgetColors(options);
  
		  return options;
	}
	function donutChartData(data) {
  
	  var datos = [];
	  if((angular.isDefined(data)) && angular.isDefined(data[0])){
		angular.forEach(data[0], function(value, key){
		  datos.push({"key": key, "y": value });
		});
	  }
	  return datos;
  
	  /*return [
			  {
				  key: "One",
				  y: 5
			  },
			  {
				  key: "Two",
				  y: 2
			  },
			  {
				  key: "Three",
				  y: 9
			  },
			  {
				  key: "Four",
				  y: 7
			  },
			  {
				  key: "Five",
				  y: 4
			  },
			  {
				  key: "Six",
				  y: 3
			  },
			  {
				  key: "Seven",
				  y: 5
			  }
		  ];*/
	}
  
	function getVisibleColumns(data, visibles){
	  var visibleColumns = [];
	  var objectKeys = [];
	  if(angular.isDefined(data[0])){
		objectKeys = Object.keys(data[0]);
	  }
	  visibleColumns = objectKeys.filter(function(e,i){
		if(angular.isDefined(visibles) && visibles != null){
		  var visiblesIndex = visibles.split(",");
		  return (i !== 0) && visiblesIndex.indexOf((i+1)+"") != -1;
		} else {
		  return (i !== 0);
		}
	  });
	  return visibleColumns;
	}
  
	  function getWidgetColorsByValue(values, key){
		  var colores = undefined;
		  angular.forEach(cfg.dashboard_colors_by_key, function(color){
			  if(angular.isObject(color)){
				  if(angular.isUndefined(colores)){
					  colores = [];
					  var pos = 0;
					  for(var i = 0; i < values.length; i++){
						  if(pos == cfg.dashboard_colors.length)
							  pos = 0;
  
						  colores.push(cfg.dashboard_colors[pos]);
						  pos++;
					  }
				  }
				  var clave = Object.keys(color);
				  clave = clave[0];
  
				  var coincidencia = values.find(function(e){
					  if(angular.isDefined(e[key]))
						  return e[key].toString().toUpperCase() == clave.toUpperCase();
					  else
						  return undefined;
				  });
				  if(angular.isUndefined(coincidencia)){
					  //Busco per nom de propietat dintre de la llista.
					  //aixo es util quan el eix X no conte el valor, si no que ve com a propietat
					  var keysInValues = Object.keys(values[0]);
					  coincidencia = keysInValues.find(function(e){
						  return e.toString().toUpperCase() == clave.toUpperCase();
					  });
				  }
  
				  if(angular.isDefined(coincidencia)){
					  var posicion = values.indexOf(coincidencia);
					  if(posicion == -1)
						  posicion = (keysInValues.indexOf(coincidencia) - 1);
					  if(posicion != -1)
						  colores[posicion] = color[clave];
				  }
			  }
		  });
		  return colores;
	  }
  
  
	  function hayQueInvertir(keyNames, invertir_bar_lin, nameField){
		  var result = false;
		  if(invertir_bar_lin){
			  var idxInvertirArr = invertir_bar_lin.split(",");
			  var idxColumn = keyNames.indexOf(nameField) + 1;
			  result = (idxInvertirArr.indexOf(idxColumn.toString()) != -1);
		  }
		  return result;
	  }
  
	  function getWidgetColors(options){
		  if(angular.isDefined(cfg.dashboard_colors))
			  options.chart.color = angular.copy(cfg.dashboard_colors);
	  }
  
  }]);
  
angular.module("FTBase").controller("SettingsAnimacionPopupController", [ "$scope", "$uibModalInstance", function($scope, $uibModalInstance){
    $scope.status = { editing: true };
    $scope.save = function(){
        $uibModalInstance.close({ animacion_segundos: $scope.animacion_segundos });
    };
}]);
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module('gp4Controllers').controller('DashboardController', [ '$scope', 'ixStatusService', 'DataService', '$timeout', '$uibModal', '$q', 'gridService', '$http', 'cfg', 'authService', '$filter', 'ixUtilsService', 'Fullscreen', '$interval', function($scope, ixStatusService, DataService, $timeout, $uibModal, $q, gridService, $http, cfg, authService, $filter, ixUtilsService, Fullscreen, $interval){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.data.fullScreenDashboard = false;
	$scope.cfg = cfg;
  $scope.cancellerAnimationTimer;
  if(angular.isUndefined($scope.activeRow))
    $scope.activeRow = 0;

  $scope.init = function(){

		//Comprobar si el usuario tiene permiso para crear, editar y eliminar dashboards.
		ixUtilsService.checkPermission("DashboardsEdit").then(function(data){
			$scope.data.dashboardsEdit = data;
			if(data > 0){
				$scope.ixAddRow = function(){
					$scope.data = { dashboardsEdit: $scope.data.dashboardsEdit };
					$scope.data.isNew = true;
					$scope.ixEditar();
				};
				$scope.ixEditar = function(){
					$scope.gridsterOptions.draggable.enabled = true;
					$scope.gridsterOptions.resizable.enabled = true;
					ixStatusService.setEditing(true);
				};
				$scope.ixGuardar = function(){
					if($scope.data.dashboard.ToDelete == true){
						$http.delete(cfg.baseURL + "fend_config_dashboards/DeleteDashboard?usuario="+authService.authentication.userName+"&modulo="+$scope.modulo+"&id="+$scope.data.filtro.id).then(function(response){
							$scope.data.dashboard = {};
							ixStatusService.setResponse(response);
							ixStatusService.setEditing(false);
							$scope.data.isNew = false;
							$scope.status.filtered = false;
						}, function(error){
							ixStatusService.setResponse(error);
						});
					} else {
						var obj = {};
						obj.id = $scope.data.filtro.id;
						obj.clave = $scope.data.filtro.nombre_dashboard;
						obj.grupo = $scope.data.filtro.grupo;
						obj.nivel_acceso = $scope.data.filtro.nivel_acceso;
						obj.desktop = $scope.data.filtro.desktop;
						obj.modulo = $scope.modulo;
						var widgetsWithDataSource = $scope.data.dashboard.widgets.filter(function(e){ return angular.isDefined(e.dataSource); });
						obj.valor = angular.toJson(widgetsWithDataSource.map(function(e){
							var widgetObj = { col: e.col, dataSource: e.dataSource, filtros: e.filtros, row: e.row, tipo: e.tipo, titulo: e.titulo, subtitulo: e.subtitulo, totales: e.totales, mostrar: e.mostrar, invertir_bar_lin: e.invertir_bar_lin, explicativo: e.explicativo, colores: e.colores };
							if(angular.isDefined(e.chart) && angular.isDefined(e.chart.data)) widgetObj.disableds = e.chart.data.filter(function(e){ return e.disabled == true;}).map(function(e){ return e.key; });
							if(angular.isDefined(e.sizeX)) widgetObj.sizeX = e.sizeX;
							if(angular.isDefined(e.sizeY)) widgetObj.sizeY = e.sizeY;



							widgetObj.storedOptions = {};
							if(((angular.isDefined(e.chart)) && ((e.chart.api.getScope()).chart != null)) && angular.isDefined((e.chart.api.getScope()).chart.stacked)){
								if((e.chart.api.getScope()).chart.stacked()){
									widgetObj.storedOptions.stacked = true;
									widgetObj.storedOptions.grouped = false;
								} else {
									widgetObj.storedOptions.stacked = false;
									widgetObj.storedOptions.grouped = true;
								}
							}
							return widgetObj;
						}));
						var url = "";

						if(angular.isUndefined(obj.id)) obj.id = null;
						var usuario = "";
						if($scope.data.filtro.usuario)
							usuario = $scope.data.filtro.usuario;
						var perfil = "";
						if($scope.data.filtro.perfil)
							perfil = $scope.data.filtro.perfil;

						if($scope.data.filtro.nivel_acceso == "u"){
							$scope.data.filtro.perfil = '';
							url = cfg.baseURL+"fend_config_dashboards/usuario?usuario="+usuario+"&perfil="+perfil+"&clave="+encodeURIComponent(obj.clave.trim())+"&id="+obj.id+"&modulo="+$scope.modulo+"&desktop="+$scope.data.filtro.desktop+"&grupo="+$scope.data.filtro.grupo;
						} else if($scope.data.filtro.nivel_acceso == "p"){
							url = cfg.baseURL+"fend_config_dashboards/perfil?usuario="+usuario+"&perfil="+perfil+"&clave="+encodeURIComponent(obj.clave.trim())+"&id="+obj.id+"&modulo="+$scope.modulo+"&desktop="+$scope.data.filtro.desktop+"&grupo="+$scope.data.filtro.grupo;
						} else {
							url = cfg.baseURL+"fend_config_dashboards/global?usuario="+usuario+"&perfil="+perfil+"&clave="+encodeURIComponent(obj.clave.trim())+"&id="+obj.id+"&modulo="+$scope.modulo+"&desktop="+$scope.data.filtro.desktop+"&grupo="+$scope.data.filtro.grupo;
						}


						$http({
							url: url,
							method: "POST",
							data: obj.valor
						}).then(function(response){
							$scope.data.dashboard = {};
							ixStatusService.setResponse(response);
							ixStatusService.setEditing(false);
							$scope.data.isNew = false;
							$scope.status.filtered = false;
						});
					}

				};
			}
		});

    $scope.gridManualLoad = true;
    $scope.filterStatus = { isCollapsed: true };

    $scope.gridsterOptions = {
      margins: [20, 20],
      columns: 4,
      mobileModeEnabled: false,
      draggable: {
        enabled: false,
        handle: '.box-header'
      },
      resizable: {
        enabled: false,
        handles: ['n', 'e', 's', 'w', 'ne', 'se', 'sw', 'nw'],

        // optional callback fired when resize is started
        start: function(event, $element, widget) {},
        // optional callback fired when item is resized,
        resize: function(event, $element, widget) {
          if (widget.chart.api) widget.chart.api.update();
        },

        // optional callback fired when item is finished resizing
        stop: function(event, $element, widget) {
          $timeout(function(){
            if (widget.chart.api) widget.chart.api.update();
          },400)
        }
      }
    };

    // We want to manually handle `window.resize` event in each directive.
    // So that we emulate `resize` event using $broadcast method and internally subscribe to this event in each directive
    // Define event handler
    $scope.events = {
      resize: function(e, scope){
        $timeout(function(){
          scope.api.update()
        },200)
      }
    };
    angular.element(window).on('resize', function(e){
      $scope.$broadcast('resize');
    });

    // We want to hide the charts until the grid will be created and all widths and heights will be defined.
    // So that use `visible` property in config attribute
    $scope.config = {
      visible: false
    };
    $timeout(function(){
      $scope.config.visible = true;
    }, 200);




    $scope.addWidget = function(){
      if(angular.isUndefined($scope.data.dashboard)) $scope.data.dashboard = {};
      if(angular.isUndefined($scope.data.dashboard.widgets)) $scope.data.dashboard.widgets = [];
      $scope.data.dashboard.widgets.push({ isNew: true });
    };

		$scope.onSelectDashboard = function(entity){
			$scope.data.filtro.grupo = entity.grupo;
			$scope.data.filtro.nivel_acceso = entity.nivel_acceso;
			$scope.data.filtro.desktop = entity.desktop;
			$scope.data.filtro.usuario = entity.usuario;
			$scope.data.filtro.perfil = entity.perfil;
		};

    $scope.ixFiltrar = function(){
      $scope.status.filtered = true;

      //Fem un get del llistat per tenir tota la info actualitzada.

      $http.get(cfg.baseURL + "fend_config_dashboards/usuario?usuario="+authService.authentication.userName+"&id="+$scope.data.filtro.id).then(function(response){
        if(angular.isUndefined($scope.data.dashboard)) $scope.data.dashboard = {};
        $scope.data.dashboard.widgets = angular.fromJson(response.data.valor);
        $scope.data.dashboardOriginal = angular.copy($scope.data.dashboard);
        $scope.data.filtro.nombre_dashboard = response.data.clave;
        $scope.data.filtro.grupo = response.data.grupo;
        $scope.data.filtro.nivel_acceso = response.data.nivel_acceso;
        $scope.data.filtro.desktop = response.data.desktop || 0;
        $scope.data.filtro.usuario = response.data.usuario;
        $scope.data.filtro.perfil = response.data.perfil;
        $scope.max_row = Math.max.apply(Math, $scope.data.dashboard.widgets.map(function(e) { return e.row; }));

        
        $scope.cargarWidgets();
      });
    };

    $scope.refresh = function(){
      //$timeout(function(){
        for(var i = 0; i < $scope.data.dashboard.widgets.length; i++){
          var widget = $scope.data.dashboard.widgets[i];
          var copia_widgets_originales = angular.copy($scope.data.dashboardOriginal.widgets);

          var widgetOriginal = copia_widgets_originales.find(function(e){ return e.titulo == widget.titulo && 
            e.subtitulo == widget.subtitulo && 
            e.tipo == widget.tipo &&
            e.col == widget.col; });

          if(widgetOriginal.row == $scope.activeRow)
            widget.visible_animacion = true;
          else 
            widget.visible_animacion = false;
        }
      //},1000);
    };

    $scope.siguienteFilaDashboard = function(){
      if(angular.isUndefined($scope.activeRow))
      $scope.activeRow = 0;
      else {
        if($scope.activeRow >= $scope.max_row)
          $scope.activeRow = 0;
        else
          $scope.activeRow++;
      }
      var widgetsEnRow = $scope.data.dashboardOriginal.widgets.filter(function(e){ return e.row == $scope.activeRow; });
      if(widgetsEnRow.length > 0)
        return $scope.activeRow;
      else
        return $scope.siguienteFilaDashboard();
    };

    $scope.cargarWidgetsAnimacion = function(){
      if($scope.data.fullScreenDashboard){
          if($scope.activeRow >= $scope.max_row)
            $scope.activeRow = 0;
          else
            $scope.activeRow = $scope.siguienteFilaDashboard();  
        // //$scope.data.dashboard.widgets = angular.copy($scope.data.dashboardOriginal.widgets);
        // console.log($scope.data.dashboard.widgets.map(function(e){ return e.row; }));
        // console.log($scope.data.dashboard.widgets);
        // console.log($scope.max_row);
        // console.log($scope.activeRow);

        $scope.refresh();

        var maxRow = 0;
        angular.forEach($scope.data.dashboard.widgets, function(widget){
          if(maxRow < widget.row)
            maxRow = widget.row;
        });
        
        if(angular.isDefined($scope.rowObjetivo))
          $scope.cargarWidgets($scope.rowObjetivo);

        angular.forEach($scope.data.dashboard.widgets, function(widget){
          if(widget.row == $scope.activeRow)
            DataService.showWidget($scope, widget);
        });

        $scope.rowObjetivo = $scope.activeRow;
      }
    };

		$scope.cargarWidgets = function(row){

      if(angular.isDefined(row)){
        angular.forEach($scope.data.dashboard.widgets, function(widget){
          if(widget.row == row)
            DataService.loadWidget($scope, $scope.modulo, widget);
        });

      } else {
        angular.forEach($scope.data.dashboard.widgets, function(widget){
          DataService.loadWidget($scope, $scope.modulo, widget);
        });
      }
      
		};

    $scope.settingsAnimacionPopup = function(){
      var template = "app/FTBase/Dashboards/Dashboard/settings_animacion_popup.html";
      var options = { controller: "SettingsAnimacionPopupController" };
      ixUtilsService.openModalV2(template, options, "small").then(function(response){
        if(response.animacion_segundos){
          $scope.animacion_segundos = response.animacion_segundos;
          $scope.data.fullScreenDashboard = true;
          //TODO: Meter la carga en pantalla completa e ir pasando.
          //Timer para ir llamando a cargarWidgets de forma recursiva.
          $scope.cargarWidgetsAnimacion();
          //$scope.data.dashboard.widgetsOriginales = angular.copy($scope.data.dashboard.widgets);
        }
      });
    };

    $scope.$watch('data.fullScreenDashboard', function(newVal, oldVal){
      if(angular.isDefined(newVal)){
        if(newVal){
          //Definir timer para ir cambiando de mapa.
          $scope.cancellerAnimationTimer = $interval(function(){
            

            $scope.cargarWidgetsAnimacion();
          }, $scope.animacion_segundos * 1000);
        }
        else {
          //Hacer cancel del timer.
          if(angular.isDefined($scope.cancellerAnimationTimer))
            $interval.cancel($scope.cancellerAnimationTimer);
        }
      }
    });

    // $scope.myFilter = function(item){
    //   if(angular.isDefined($scope.activeRow)){
    //     //if(item.row == $scope.activeRow)
    //       //return false;
    //     //else
    //       //return false;
    //       return (item.row == $scope.activeRow);
    //   }
    //   else
    //     return true;
    // };


    $scope.ixCancelEdit = function(){
      if($scope.data.isNew){
        $scope.data.isNew = false;
        ixStatusService.setEditing(false);
      }
      if($scope.status.editing){
        $scope.gridsterOptions.draggable.enabled = false;
        $scope.gridsterOptions.resizable.enabled = false;
        ixStatusService.setEditing(false);
        if((angular.isDefined($scope.data.dashboardOriginal)) && angular.isDefined($scope.data.dashboardOriginal.widgets)){
          angular.forEach($scope.data.dashboardOriginal.widgets, function(widget){
            DataService.loadWidget($scope, $scope.modulo, widget);
          });
        }

      } else {
        $scope.data.fullScreenDashboard = false;
        $scope.status.filtered = false;
        $scope.data.dashboard = {};
        $scope.activeRow = undefined;
      }
    };

    $scope.ixDeleteSelectedRows = function(){
      $scope.data.dashboard.ToDelete = true;
    };

    $scope.numberOfChanges = function(){
      return (($scope.data.dashboard) && $scope.data.dashboard.ToDelete) ? 1 : undefined;
    };

    $scope.openSettings = function(widget){
      var modalInstance = $uibModal.open({
        //scope: $scope,
        templateUrl: 'app/FTBase/Dashboards/Dashboard/widget_settings_popup.html',
        controller:['$scope', '$timeout', '$uibModalInstance', 'widget', 'modulo', 'isEditing', function ($scope, $timeout, $uibModalInstance, widget, modulo, isEditing) {
					$scope.modulo = modulo;
					$scope.isEditing = isEditing;
          $scope.status = { editing: true };
          $scope.ixCancelEdit = undefined;
          $scope.ixAddRow = undefined;
          $scope.formSettings = {
            titulo: widget.titulo,
            subtitulo: widget.subtitulo,
            dataSource: widget.dataSource,
            tipo: widget.tipo,
            filtros: widget.filtros,
            mostrar: widget.mostrar,
						invertir_bar_lin: widget.invertir_bar_lin,
            totales: widget.totales,
            explicativo: widget.explicativo,
						colores: widget.colores
          };


          //$scope.$watch("dataSourceObj", function(newValue,oldValue){
					$scope.onSelectDataSource = function(newValue){
            if(angular.isDefined(newValue) && !angular.equals(newValue, $scope.oldDataSourceObj)){
							$scope.dataSourceObj = newValue;
							$scope.buildFilters($scope.oldDataSourceObj);
							$scope.oldDataSourceObj = newValue;
						}
          //});
					};

          $scope.buildFilters = function(oldValue){
            if(angular.isDefined($scope.dataSourceObj)){
              if(angular.isUndefined($scope.formSettings.titulo) || $scope.formSettings.titulo == "" || ((angular.isDefined(oldValue)) && oldValue.subtitulo === $scope.formSettings.subtitulo)) $scope.formSettings.titulo = $scope.dataSourceObj.titulo;
              if(angular.isUndefined($scope.formSettings.subtitulo) || $scope.formSettings.subtitulo == "" || ((angular.isDefined(oldValue)) && oldValue.subtitulo === $scope.formSettings.subtitulo)) $scope.formSettings.subtitulo = $scope.dataSourceObj.subtitulo;
              $scope.formSettings.mostrar = $scope.dataSourceObj.mostrar;
							$scope.formSettings.invertir_bar_lin = $scope.dataSourceObj.invertir_bar_lin;
              $scope.formSettings.totales = $scope.dataSourceObj.totales;
              $scope.formSettings.explicativo = $scope.dataSourceObj.explicativo;
							$scope.formSettings.colores = $scope.dataSourceObj.colores;
              //Construim filtres del widget.
              if(angular.isDefined(oldValue) || angular.isUndefined($scope.formSettings.filtros)){
                $scope.formSettings.filtros = [];
                var filtros = $scope.dataSourceObj.filtros.split(",");
                angular.forEach(filtros, function(filtro, i){
                  var filterInfo = filtro.split("$");
                  var tipo = "";
                  var multiple = false;
                  if(filterInfo[0].lastIndexOf("anyo") != -1) tipo = "anyo";
                  else if(filterInfo[0].lastIndexOf("mes") != -1) tipo = "mes";
                  else if(filterInfo[0].lastIndexOf("periodo") != -1) tipo = "periodo";
                  else if(filterInfo[0].lastIndexOf("texto") != -1) tipo = "texto";
									else if(filterInfo[0].lastIndexOf("zonas") != -1) tipo = "texto";
									else if(filterInfo[0].lastIndexOf("modos") != -1) tipo = "texto";
									else if(filterInfo[0].lastIndexOf("fecha") != -1) tipo = "fecha";
                  else tipo = "busqueda";

                  if(filterInfo[0].lastIndexOf('*') != -1){
                    filterInfo[0] = filterInfo[0].replace("*", "");
                    multiple = true;
                  }


                  $scope.formSettings.filtros.push({ name: filterInfo[0], visibleText: filterInfo[1], tipo: tipo, multiple: multiple });
                });
                //$scope.$apply();
              }
            }
          };

					$scope.loadClientesCuenta = function(param){
						return $http.post(cfg.baseURL + "search_ref_clientes/Search?ItemsPerPage=9999", param);
					};
					$scope.loadClientesCuentaMin = function(param){
						return $http.post(cfg.baseURL + "search_ref_clientes/Search?ItemsPerPage=10", param);
					};
					$scope.loadZonasDistinct = function(param){
						return $http.post(cfg.baseURL + "zonas/Search?ItemsPerPage=9999", param).then(function(response){
							var registrosAgrupados = $filter("groupBy")(response.data.Items, "zona");
							var keys = Object.keys(registrosAgrupados);
							var listZonas = [];
							angular.forEach(keys, function(zona){
								listZonas.push({ zona: zona });
							});
							return { data: listZonas };
						});
					};

          $scope.save = function(){
            angular.extend(widget, $scope.formSettings);
            $uibModalInstance.close(widget);
          };

          $scope.loadDataSources = function(){
            var param = { Fields: [ { Field: "nombre" }, { Field: "tipo" }, { Field: "filtros" }, { Field: "titulo" }, { Field: "subtitulo" }, { Field: "totales" }, { Field: "mostrar" }, { Field: "invertir_bar_lin" }, { Field: "explicativo" }, { Field: "colores" } ], Selection: buildIxSearch() };
            param.Selection.Filters.push({ Field: "modulo", Value: modulo, Operator: CMP_EQ });
            return $http.post(cfg.baseURL + "api_dashboard/SelectAndProject", param);
          };

          $scope.loadChartTypes = function(){
            var deferr = $q.defer();

            if(widget.tipo != "medidor_radial"){
              $timeout(function(){
                deferr.resolve({data: [ { tipo: 'lineChart', nombre: 'Gráfica lineas'}, { tipo: 'pieChart', nombre: 'Gráfico pastel' }, { tipo: 'multiBarChart', nombre: 'Gráfico barras múltiples verticales' },{ tipo: 'multiBarValuesChart', nombre: 'Gráfico barras múltiples verticales con valor' }, { tipo: 'multiBarHorizontalChart', nombre: 'Gráfico barras múltiples horizontales' }, { tipo: 'multiBarHorizontalValuesChart', nombre: 'Gráfico barras múltiples horizontales con valor' }, { tipo: 'grid', nombre: 'Tabla' } ] });
              },1);
            }
            return deferr.promise;
          };
        }],
        backdrop: 'static',
        keyboard: false,
        resolve: {
          widget: function() {
            return widget;
          },
          modulo: function(){
            return $scope.modulo;
          },
					isEditing: function(){
						return $scope.status.editing;
					}
        }
      });

      modalInstance.result.then(function(widget){
        if(angular.isDefined(widget)){
            DataService.loadWidget($scope, $scope.modulo, widget);
        }
      });
    };

		$scope.exportWidget = function(widget){
			DataService.exportWidget($scope.modulo, widget.dataSource, widget.filtros);
		};

    $scope.remove = function(widget){
      $scope.data.dashboard.widgets.splice($scope.data.dashboard.widgets.indexOf(widget), 1);
    };
  }

  $scope.loadDashboardsUsuario = function(){
    return $http.get(cfg.baseURL + "fend_config_dashboards/dashboards_usuario?usuario="+authService.authentication.userName+"&modulo="+$scope.modulo).then(function(response){
      var result = [];
      if(response.data != null){
				angular.forEach(response.data, function(data){
					if(data.nivel_acceso == "p")
						data.asignado_a = "perfil " + data.perfil;
					else if(data.nivel_acceso == "u")
						data.asignado_a = "usuario " + data.usuario;
				});
        result = response;
      }
      return result;
    }, function(err){
      ixStatusService.setResponse(err);
    });
  };

  $scope.loadNivelesAcceso = function () {
    var deferral = $q.defer();
    deferral.resolve({
        data: [{acceso: 'u', nombre: 'Usuario'}, {acceso: 'p', nombre: 'Perfil'}, {acceso: 't', nombre: 'Todos'}]
    });
    return deferral.promise;
  };  


}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('TraduccionesFtVersionesController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', function ($scope, cfg, gridService, $http, ixStatusService, authService, $q) {
	$scope.status = {
		editing: true
	};

	$scope.version = $scope.$resolve.version;
  $scope.nombre = $scope.$resolve.nombre;

  $scope.addRow = function(){
    var nuevo = {};
    nuevo.version = $scope.version;
    $scope.grid.ixAddRow(nuevo);
  }

  $scope.crearGrid = function(){
    if (!$scope.grid){
      var metadata = [];
      var filtroEstado = [];
      var acciones = [];

      $scope.grid = gridService.createGrid($scope, 'gnet_grid_traducciones_versiones', { minRowsToShow: 15, rowHeight: 30, enableCellEdit: true, enableFiltering: true, enableSorting: true, metadata: metadata }, "ft_versiones_idioma");
      filtroEstado = [{ Field: 'version', Value: $scope.version, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
    else {
      $scope.grid = gridService.createGridFunctions($scope, $scope.grid);
      $scope.grid.ixRestoreConfig();
      filtroEstado = filtroEstado = [{ Field: 'version', Value: $scope.version, Operator: CMP_EQ}];
      $scope.grid.filtroExterno = filtroEstado;
      $scope.grid.ixLoadInitialData();
    }
  }

  $scope.crearGrid();

  $scope.save = function(){
    $scope.grid.ixGuardar();
  }

  $scope.deleteSelectedRows = function(grid) {
    grid.ixDeleteSelectedRows();
  }

	$scope.$on("$destroy", function() {
		$scope.grid.ixSaveConfig();
		$scope.isDestroyed=true;
	});
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

//angular.module('FTBase').controller("Ft_VersionesController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'ixUtilsService', 'gridService', '$timeout', '$log', '$q', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, ixUtilsService, gridService, $timeout, $log, $q) {
angular.module('FTBase').controller("Ft_VersionesController", ['$scope', '$http', 'cfg', 'ixStatusService', 'ixUtilsService', '$log', function ($scope, $http, cfg, ixStatusService, ixUtilsService, $log) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("ft_versiones");
  }

  $scope.data.pk = "version";
  $scope.data.useModel = true;
  $scope.data.fieldsToFilter = [ "version", "nombre" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }

    if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) {
      return;
    }
    else {
      $http.get(cfg.baseURL + "ft_versiones/"+current[$scope.data.pk]).then(function(response){
        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);
      }, function(error){
        ixStatusService.setResponse(error);
      });
    }
  }, true);

  $scope.actualizarListado();

  /* ***** FUNCTION: IXGUARDAR ***** */
  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      //Crear nuevo tipo_ft
      data.nuevotipo = $scope.data.datos;
      $http.post(cfg.baseURL + "ft_versiones", data.nuevotipo).then(function (r){
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
        $scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar tipo_ft.
      data.tipo_ft = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      $http.put(cfg.baseURL + 'ft_versiones/' + $scope.data.datos[$scope.data.pk], data.tipo_ft).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  }

  /* ***** FUNCTION: IXDELETESELECTEDROWS ***** */
  $scope.ixDeleteSelectedRows = function() {
    $http.delete(cfg.baseURL + "ft_versiones/" + $scope.data.datos[$scope.data.pk]).then(function(r) {
      ixStatusService.setResponse(r);
      ixStatusService.setEditing(false);
      $scope.data.datos = {};
      $scope.ixCancelEdit();
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  }

  $scope.openPopupTraduccion = function(v){
		var template = "app/FTBase/ConfiguracionPreguntas/ft_versiones/traducciones_ft_versiones.html";
		var optionsPopup = { controller: "TraduccionesFtVersionesController" };
		var paramsPopup = { version: $scope.data.datos.version, nombre: $scope.data.datos.nombre };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
		popup.then(function (data) {
		});
  }
}]);

angular.module('FTBase').controller('ConfigPreguntasController', [ '$scope', '$controller', 'ixUtilsService', '$http', 'cfg', 'ixStatusService', function($scope, $controller, ixUtilsService, $http, cfg, ixStatusService){
	$scope.entity = "ft_preguntas";
	//$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
	$scope.acciones = [
		{
			title: "Previsualizar pregunta",
			icon: "fa-search",
			accion: function(entity){
				var templateURL = "app/FTBase/ConfiguracionPreguntas/ft_preguntas/acciones/previsualizar_pregunta_popup.html";
				var optionsPopup = { controller: "PrevisualizarPreguntaPopupController" };
				var paramsPopup = { pregunta: entity };

				ixUtilsService.openModalV2(templateURL, optionsPopup, "medium", paramsPopup);
			}
		},
		{
			title: "Editar pregunta",
			icon: "fa-pencil",
			accion: function(entity){
				var templateURL = "app/FTBase/ConfiguracionPreguntas/ft_preguntas/acciones/editar_pregunta_popup.html";
				var optionsPopup = { controller: "EditarPreguntaPopupController" };
				var paramsPopup = { pregunta: entity, isNew : false };

				var popup = $scope.openModalV2(templateURL, optionsPopup, "medium", paramsPopup);
				popup.then(function(data){
					$scope.data.grid.ixLoadInitialData();
				});
			}
		}
	];

	$scope.ixAddRow = function(){

		var nuevaPregunta = {};
		$http.post(cfg.baseURL + "ft_preguntas", nuevaPregunta).then(function (r) {

			var templateURL = "app/FTBase/ConfiguracionPreguntas/ft_preguntas/acciones/editar_pregunta_popup.html";
			var optionsPopup = { controller: "EditarPreguntaPopupController" };
			var paramsPopup = { pregunta: r.data.obj.Record, isNew : true };

			var popup = $scope.openModalV2(templateURL, optionsPopup, "medium", paramsPopup);
			popup.then(function(data){
				$scope.data.grid.ixLoadInitialData();
			});
	
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		
	}
	$controller('GridEditorController', { $scope: $scope });
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global buildIxSearch*/
/*global checkPermission*/
"use strict";

angular.module('FTBase').controller("Ft_NivelesController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', '$log', '$q', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, $log, $q) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  if(!$scope.data.metadataForm){
    $scope.loadMetadata("ft_niveles");
  }

  $scope.data.pk = "nivel";
  $scope.data.useModel = true;
  $scope.data.fieldsToFilter = [ "nombre", "version", "nivel1", "nivel2" ];

  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo[$scope.data.pk] = "";
    nuevo.isNew = true;
    $scope.data.datos = {};
    $scope.data.datos = nuevo;
    return nuevo;
  };

  $scope.$watch('current', function (current) {
    if($scope.data.cancelEdit){
      $scope.data.cancelEdit = false;
    }

    if(!current || current[$scope.data.pk] == undefined || Object.keys(current).length == 0 || current.isNew == true) {
      return;
    }
    else {
      $http.get(cfg.baseURL + "ft_niveles/"+current[$scope.data.pk]).then(function(response){
        $scope.data.datos = response.data;
        $scope.data.datosOriginales = angular.copy(response.data);
      }, function(error){
        ixStatusService.setResponse(error);
      });
    }
  }, true);

  $scope.actualizarListado();

  /* ***** FUNCTION: IXGUARDAR ***** */
  $scope.ixGuardar = function () {
    var data = {};
    if ($scope.data.datos.isNew) {
      //Crear nuevo nivel
      data.nuevonivel = $scope.data.datos;
      $http.post(cfg.baseURL + "ft_niveles", data.nuevonivel).then(function (r){
        delete $scope.data.datos.isNew;
        ixStatusService.setResponse(r);
        ixStatusService.setEditing(false);
        $scope.ixCancelEdit();
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar nivel.
      data.nivel = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      $http.put(cfg.baseURL + 'ft_niveles/' + $scope.data.datos[$scope.data.pk], data.nivel).then(function (r) {
        ixStatusService.setResponse(r);
        $scope.data.datosOriginales = angular.copy($scope.data.datos);
        ixStatusService.setEditing(false);
      }, function (error) {
        ixStatusService.setResponse(error);
      });
    }
  }

  /* ***** FUNCTION: IXDELETESELECTEDROWS ***** */
  $scope.ixDeleteSelectedRows = function() {
    $http.delete(cfg.baseURL + "ft_niveles/" + $scope.data.datos[$scope.data.pk]).then(function(r) {
      ixStatusService.setResponse(r);
      ixStatusService.setEditing(false);
      $scope.data.datos = {};
      $scope.ixCancelEdit();
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  }
}]);

angular.module('FTBase').controller('UploadFilePopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', '$log', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, $log, Upload, ixStatusService){
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
	$scope.tipo = $scope.$resolve.tipo;
	$scope.id_ficha_tecnica = $scope.$resolve.id_ft;
	$scope.status = { editing: true };
	$scope.data = {};
	$scope.especificar_producto = undefined;
	$scope.caducidad_obligatoria = undefined;

	$scope.tipoArchivoSeleccionado = function(entity){
		if (entity){
			$scope.especificar_producto = entity.especificar_producto;
			$scope.caducidad_obligatoria = entity.caducidad_obligatoria;
		}
		else {
			$scope.especificar_producto = undefined;
			$scope.caducidad_obligatoria = undefined;
		}
	};


	$scope.save = function(){
		var fileNames = [];
		angular.forEach($scope.archivosToUpload, function(fileToUpload){
			fileNames.push(fileToUpload.name);
		});

		$http.post(cfg.baseURL + "fichas_tecnicas_ficheros/CanUpload?id_ficha_tecnica="+$scope.id_ficha_tecnica, fileNames).then(function(response){
			if(response.data.GlobalMessage.ErrType == 0){
				$scope.data.uploadingFile = true;
				var strProductosSeleccionados = "";
				if ($scope.productoSeleccionado)
					strProductosSeleccionados = $scope.productoSeleccionado.join();
				var upload = Upload.upload({
					url: cfg.baseURL + "fichas_tecnicas_ficheros/UploadAndCreate",
					data: {
						file: $scope.archivosToUpload,
						id_ficha_tecnica: $scope.id_ficha_tecnica,
						tipo: $scope.tipoSeleccionadoFt,
						fecha_caducidad: $scope.fechaCaducidad,
						inicio_validez: $scope.inicioValidez,
						id_producto: strProductosSeleccionados
					},
					dataType: 'json'
				});

				upload.then(function(response){
					if(response.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
						ixStatusService.setResponse(response);
						$scope.status.editing = false;
						$uibModalInstance.close(response.data);
					}
				}, function(response){
					if(response.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
					}
				}, function(evt){
					$scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			}
			else {
				ixStatusService.setResponse(response);
			}
		}, function(err){
			ixStatusService.setResponse(err);
		});

		// $uibModalInstance.close($scope.data);
	};

	$scope.$close = function () {
		$scope.status.editing = false;
		$uibModalInstance.dismiss('cancel');
	};
	// $scope.getTiposFichero = function(){
	// 	var method;
	// 	if($scope.tipo == "ficheros_ft")
	// 		method = "tipos_fichero_ft";
	// 	else
	// 		method = "tipos_fichero_proveedor";
	//
	// 	return $http.get(cfg.baseURL + method);
	// };
	// $scope.$close = function () {
	// 	$scope.status.editing = false;
	// 	$uibModalInstance.dismiss('cancel');
	// };

	// $scope.hideTipoFicheroFt = function(){
	// 	if($scope.tipo == "ficheros_ft"){
	// 		return false;
	// 	}
	// 	else {
	// 		return true;
	// 	}
	// };
	//
	// $scope.hideTipoFicheroProveedor = function(){
	// 	if($scope.tipo == "proveedor"){
	// 		return false;
	// 	}
	// 	else {
	// 		return true;
	// 	}
	// };

}]);

angular.module('FTBase').controller('DuplicarFtPopupController', [ '$scope', '$http', '$ngConfirm', 'cfg', '$uibModalInstance', 'ixStatusService', function($scope, $http, $ngConfirm, cfg, $uibModalInstance, ixStatusService){
  $scope.status = ixStatusService.current;
	$scope.status.editing = true;
  $scope.okBtnText = "Confirmar";
  $scope.ft_origen = $scope.$resolve.ft_origen;
  $scope.version = $scope.$resolve.ft_tipo;
  $scope.nivel_duplicar =  $scope.$resolve.niveles;
  if ($scope.nivel_duplicar == 0) {
    $scope.nivel1 = 0;
    $scope.nivel2 = 0;
  }
  else if ($scope.nivel_duplicar == 1) {
    $scope.nivel2 = 0;
  }

  $scope.save = function(checkdata){
    if (!$scope.nivel1) $scope.nivel1 = 0;
    if (!$scope.nivel2) $scope.nivel2 = 0;

    var warning = true;
    if (angular.isDefined(checkdata) && checkdata == false) warning = false;
    $http.put(cfg.baseURL + "extranet_fichas_tecnicas/DuplicarFT?ft_origen=" + $scope.$resolve.ft_origen + "&ft_destino=" + $scope.ft_destino + "&nivel1=" + $scope.nivel1 + "&nivel2=" + $scope.nivel2 + "&warning=" + warning).then(function(response){
			ixStatusService.setResponse(response);
  	}, function(err){
      if (err.data.GlobalMessage.ErrType == 1){
        $ngConfirm({
          icon: 'fa fa-warning',
          title: 'Aviso',
          content: err.data.GlobalMessage.Msg + ' ¿Desea continuar la operación?',
          scope: $scope,
          closeIcon: false,
          buttons: {
            ok: {
              text: "Continuar",
              btnClass: 'btn-ix-green',
              show: 'true',
              keys: ['enter'], // will trigger when enter is pressed
              action: function(scope){
                $scope.save(false);
                return true;
              }
            },
            cancelar: {
              text: "Cancelar",
              btnClass: 'btn-ix-green',
              show: 'true',
              action: function(scope){
                return true;
              }
            }
          }
        });
      }
      else
  		  ixStatusService.setResponse(err);
  	});

  }
}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('DependenciaEtiquetadoPopupController', ['$scope', 'cfg', 'gridService', '$http', 'ixStatusService', 'authService', '$q', 'ixUtilsService', '$filter', '$timeout', 
function ($scope, cfg, gridService, $http, ixStatusService, authService, $q, ixUtilsService, $filter, $timeout) {
	$scope.tienePerfilRestringido = function () {
		var perfilRestringido = false;
		var perfilesUsuario = authService.perfilesUsuario();

		var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];

		angular.forEach(perfilesUsuario, function (perfil) {
			if (perfilesRestringidos.indexOf(perfil) != -1)
				perfilRestringido = true;
		});

		return perfilRestringido;
	};

	if(!$scope.tienePerfilRestringido()) {
		$scope.status = {
			editing: true
		};
	}else{
		$scope.status = {
			editing: false
		};
	}

	$scope.id_ficha_tecnica = $scope.$resolve.id_ft;
	$scope.id_pregunta = $scope.$resolve.id_pregunta;
	$scope.pregunta_formulario = $scope.$resolve.pregunta_formulario;
	$scope.bloquear_valor_b = $scope.$resolve.bloquear_valor_b;
	$scope.pregunta_bloqueada = $scope.$resolve.pregunta_bloqueada;
	$scope.modoTraduccion = $scope.$resolve.modo_traduccion;
	$scope.idioma = $scope.$resolve.idioma;
	$scope.traducible = $scope.$resolve.traducible;
	$scope.tablaEnvases = $scope.$resolve.tablaEnvases;
	$scope.pregunta = $scope.$resolve.pregunta;
	$scope.componente = $scope.$resolve.componente; //Me permitirá filtrar sólo por el eventuual componente

	if ($scope.pregunta.pregunta.bucle)
		$scope.activeTabDependenciaEtiquetado = 0;

	var acciones = [];

	$scope.tienePerfilAdmin = function () {
		return authService.tienePerfilAdmin();
	};

	$scope.esGridJerarquico = function () {
		return $scope.tablaEnvases;
	};

	if ($scope.tienePerfilAdmin()) {
		acciones.push({
			icon: "fa-lock",
			title: "Desbloquear",
			visible: function (entity) {
				return $scope.tienePerfilAdmin() && entity.bloqueado;
			},
			accion: function (entity) {
				entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
				$scope.changeLockGrid(entity);
			}
		});
		acciones.push({
			icon: "fa-unlock",
			title: "Bloquear",
			visible: function (entity) {
				return $scope.tienePerfilAdmin() && !entity.bloqueado;
			},
			accion: function (entity) {
				entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
				$scope.changeLockGrid(entity);
			}
		});
	}

	if($scope.esGridJerarquico()){


		$scope.actualizarGridsSinComponente = function (grid) {
			grid.reloadData = true;

			grid.ixLoadInitialData().then(function (data) {
				$scope.addTreeLevel(grid.data);
				grid.data = $scope.sortGridData(grid.data);
				
				
				$timeout(function(){
					grid.reloadData = false;
					if (grid.gridApi.treeBase){
						grid.gridApi.treeBase.expandAllRows();
					}
					grid.gridApi.core.refresh();
					ixUtilsService.showGrid(grid);
				},300);
			});
		};


		acciones.push({
			icon: "fa-plus",
			title: "Agregar elemento mismo nivel",
			visible: function (entity) {
				if (entity["$$treeLevel"] > 0) {
					var target = $scope.getTargetGrid();
					var respuestas_sn = target.grid.data.filter(function(item){
						return item.orden_bucle === entity.orden_bucle;
					});
					var max_index = respuestas_sn.sort(function(a,b){
						return parseInt(b.orden_tab) - parseInt(a.orden_tab);
					});
					return (entity.orden_tab === max_index[0].orden_tab);
				} 
				else
					return false;
			},
			accion: function (entity, grid) {
				$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/AgregarElementoSubNivel/" + entity.id).then(function (response) {
					var ftd = response.data.obj.Record;
					ftd.orden_sub_bucle = ftd.orden_tab;
					ftd.orden_sub_sub_bucle = ftd.orden_tab2;

					grid.options.ixAddRow(ftd);
					var target = $scope.getTargetGrid();
					$scope.actualizarGridsSinComponente(target.grid);
					// $timeout(function () {
					// 	grid.gridApi.core.refresh();
					// }, 300);
				},
				function(error){
				});
			}
		});
		acciones.push({
			icon: "fa-trash",
			title: "Eliminar línea",
			visible: function(entity){
				return true;
			},
			accion: function(entity, grid){
				var row = entity;
				$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/EliminarElementoTablaJerarquicaSimple/" + entity.id).then(function(response){
					var target = $scope.getTargetGrid();
					$scope.actualizarGridsSinComponente(target.grid);
					$timeout(function () {
						grid.gridApi.core.refresh();
					}, 300);

				},
				function(error){
					ixStatusService.setResponse(error);
				});
			}
		});
	}


	$scope.switchBloqueado = function (bloqueado) {
		if (bloqueado)
			bloqueado = 0;
		else
			bloqueado = 1;
		return bloqueado;
	};


	$scope.changeLockGrid = function (entity) {
		var data = [
			{
				op: "replace",
				path: "/bloqueado",
				value: entity.bloqueado
			}
		];
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/" + entity.id, data).then(function (response) {

		}, function (err) {
			entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
		});
	};


	if (!$scope.pregunta_bloqueada) {
		$scope.save = function () {
			var target = $scope.getTargetGrid();
			target.grid.ixGuardar().then(function (response) {
				$scope.status.editing = true;
				ixStatusService.setEditing(true);
				$scope.pregunta.respuestas[0].contiene_info_etiquetado = target.grid.data.length > 0;
			});
		};
	}

	//////////////////////REUTILIZADO DE helpers.js. Si no presenta cambios pasar a un service/////////////////////////////////
	$scope.addNewElementsToDictionary = function () {
		//TODO: Descomentar y probar funcionamiento

		// var preguntaProperty = ($scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
		// var respuestasProperty = ($scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
		//
		// //Para etiquetado por marca siempre agregaremos simplemente valores
		// $scope.pregunta[respuestasProperty].forEach(function(respuesta){
		// 	if ($scope.pregunta[preguntaProperty].diccionario_valores){
		// 		if($scope.pregunta[preguntaProperty].diccionario_valores.indexOf(respuesta.valor) == -1)
		// 			$scope.pregunta[preguntaProperty].diccionario_valores.push(respuesta.valor);
		// 	}
		// }
	};

	var tiposValor = { TEXTO: "TEXTO", NUMERICO: "NUMERICO", DECIMAL: "DECIMAL", DICCIONARIO: "DICCIONARIO", SINO: "SI/NO", FECHA: "FECHA", AREA_TEXTO: "AREA_TEXTO", DICCIONARIO_MULTIPLE: "DICCIONARIO_MULTIPLE" };

	$scope.addSpecificControl = function (obj, tipo, esJerarquico) {
		var preguntaProperty = ($scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
		var respuestasProperty = ($scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";

		if (esJerarquico && $scope.modoTraduccion && tipo == tiposValor.DICCIONARIO_MULTIPLE)
			tipo = tiposValor.TEXTO;

		if ($scope.modoTraduccion && tipo == tiposValor.TEXTO) {
			if (obj.Name == "valor" && $scope.pregunta.pregunta.traducible) {
				obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
			} else {
				var nameColumn = obj.Name.replace("respuesta", "pregunta");
				if ($scope.pregunta[nameColumn + "_traducible"])
					//obj.cellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
					obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
			}
		}

		if (tipo == tiposValor.SINO) {
			if ($scope.modoTraduccion)
				obj.NoEditable = true;

			obj.Control = "CheckBox";
			obj.ignoreCellModifications = true;
		}
		else if (tipo == tiposValor.DICCIONARIO || tipo == tiposValor.DICCIONARIO_MULTIPLE) {
			if ($scope.modoTraduccion)
				obj.NoEditable = true;

			if (tipo == tiposValor.DICCIONARIO_MULTIPLE)
				obj.Control = "MultiBusqueda";

			if ($scope.pregunta[respuestasProperty][0].componente && $scope.pregunta[preguntaProperty].diccionario_valores) {
				$scope.addNewElementsToDictionary();
			}
			if (esJerarquico && obj.Name == "valor")
				obj.ColumnFkDescription = "valor";

			obj.Search = {
				"KeyFields": [obj.Name],
				"LookUpTableName": "",
				"LookUpKeyFields": ["codigo"],
				"LookUpResultFields": ["descripcion", "codigo"],
				"LookUpTableAlias": "",
				"LookUpOrders": [{ "KeyField": "descripcion", "Desc": false }],
				"LookUpConditions": []
			};
			obj.busquedaFunction = function (column, param, text) {
				var preguntaProperty = ($scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				var deferr = $q.defer();
				var valores = [];
				var diccionario_valores = [];
				if ($scope.preview)
					diccionario_valores = $scope.pregunta.pregunta.diccionario_valores;
				else {
					var fieldToSearch = ((column.Name == "valor") ? "" : column.Name.replace("respuesta", "pregunta"));
					fieldToSearch = "diccionario_" + fieldToSearch + ((fieldToSearch != "") ? "_" : "") + "valores";
					diccionario_valores = $scope.pregunta[preguntaProperty][fieldToSearch];
				}

				if (text)
					diccionario_valores = diccionario_valores.filter(function (e) { return e.toLowerCase().indexOf(text.toLowerCase()) != -1; });

				angular.forEach(diccionario_valores, function (valor) {
					var item = { codigo: valor, descripcion: valor };
					if (column.ColumnFKDescription)
						item[column.ColumnFKDescription] = valor;

					valores.push(item);
				});
				deferr.resolve(valores);
				return deferr.promise;
			};
		}
		else if (tipo == tiposValor.FECHA)
			obj.Type = "DateTime";
		else if (tipo == tiposValor.DECIMAL) {
			obj.Type = "Decimal";
			obj.CommaSeparator = true;
			obj.MaxLength = 11;
		}
		else if (tipo == tiposValor.NUMERICO) {
			obj.Type = "Int32";
			obj.MaxLength = 11;
		}
	};


	$scope.getFakeMetadata = function () {
		var metadata = [];
		metadata.push({ Name: "id", NoVisible: true, Pk: true });
		var valor = { Name: "valor", ColumnDescription: $scope.pregunta_formulario, Type: "String", NoEditable: $scope.estaBloqueadoValor, NoFilterable: true };
		$scope.addSpecificControl(valor, $scope.pregunta.pregunta.tipo_valor, $scope.esGridJerarquico());
		metadata.push(valor);
		if ($scope.pregunta.pregunta.sub_pregunta1) {
			var sub_pregunta1 = { Name: "sub_respuesta1", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta1, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta1, $scope.pregunta.pregunta.tipo_valor_sub_pregunta1, $scope.esGridJerarquico());
			metadata.push(sub_pregunta1);
		}
		if ($scope.pregunta.pregunta.sub_pregunta2) {
			var sub_pregunta2 = { Name: "sub_respuesta2", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta2, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta2, $scope.pregunta.pregunta.tipo_valor_sub_pregunta2, $scope.esGridJerarquico());
			metadata.push(sub_pregunta2);
		}
		if ($scope.pregunta.pregunta.sub_pregunta3) {
			var sub_pregunta3 = { Name: "sub_respuesta3", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta3, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta3, $scope.pregunta.pregunta.tipo_valor_sub_pregunta3, $scope.esGridJerarquico());
			metadata.push(sub_pregunta3);
		}
		if ($scope.pregunta.pregunta.sub_pregunta4) {
			var sub_pregunta4 = { Name: "sub_respuesta4", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta4, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta4, $scope.pregunta.pregunta.tipo_valor_sub_pregunta4, $scope.esGridJerarquico());
			metadata.push(sub_pregunta4);
		}
		if ($scope.pregunta.pregunta.sub_pregunta5) {
			var sub_pregunta5 = { Name: "sub_respuesta5", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta5, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta5, $scope.pregunta.pregunta.tipo_valor_sub_pregunta5, $scope.esGridJerarquico());
			metadata.push(sub_pregunta5);
		}
		if ($scope.pregunta.pregunta.sub_pregunta6) {
			var sub_pregunta6 = { Name: "sub_respuesta6", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta6, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta6, $scope.pregunta.pregunta.tipo_valor_sub_pregunta6, $scope.esGridJerarquico());
			metadata.push(sub_pregunta6);
		}
		if ($scope.pregunta.pregunta.sub_pregunta7) {
			var sub_pregunta7 = { Name: "sub_respuesta7", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta7, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta7, $scope.pregunta.pregunta.tipo_valor_sub_pregunta7, $scope.esGridJerarquico());
			metadata.push(sub_pregunta7);
		}
		if ($scope.pregunta.pregunta.sub_pregunta8) {
			var sub_pregunta8 = { Name: "sub_respuesta8", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta8, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta8, $scope.pregunta.pregunta.tipo_valor_sub_pregunta8, $scope.esGridJerarquico());
			metadata.push(sub_pregunta8);
		}
		if ($scope.pregunta.pregunta.sub_pregunta9) {
			var sub_pregunta9 = { Name: "sub_respuesta9", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta9, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta9, $scope.pregunta.pregunta.tipo_valor_sub_pregunta9, $scope.esGridJerarquico());
			metadata.push(sub_pregunta9);
		}
		if ($scope.pregunta.pregunta.sub_pregunta10) {
			var sub_pregunta10 = { Name: "sub_respuesta10", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta10, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta10, $scope.pregunta.pregunta.tipo_valor_sub_pregunta10, $scope.esGridJerarquico());
			metadata.push(sub_pregunta10);
		}
		if ($scope.pregunta.pregunta.sub_pregunta11) {
			var sub_pregunta11 = { Name: "sub_respuesta11", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta11, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta11, $scope.pregunta.pregunta.tipo_valor_sub_pregunta11, $scope.esGridJerarquico());
			metadata.push(sub_pregunta11);
		}
		if ($scope.pregunta.pregunta.sub_pregunta12) {
			var sub_pregunta12 = { Name: "sub_respuesta12", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta12, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta12, $scope.pregunta.pregunta.tipo_valor_sub_pregunta12, $scope.esGridJerarquico());
			metadata.push(sub_pregunta12);
		}
		if ($scope.pregunta.pregunta.sub_pregunta13) {
			var sub_pregunta13 = { Name: "sub_respuesta13", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta13, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta13, $scope.pregunta.pregunta.tipo_valor_sub_pregunta13, $scope.esGridJerarquico());
			metadata.push(sub_pregunta13);
		}
		if ($scope.pregunta.pregunta.sub_pregunta14) {
			var sub_pregunta14 = { Name: "sub_respuesta14", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta14, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta14, $scope.pregunta.pregunta.tipo_valor_sub_pregunta14, $scope.esGridJerarquico());
			metadata.push(sub_pregunta14);
		}

		return metadata;
	};

	$scope.getTabs = function () {
		$scope.tabs = undefined;
		if ($scope.pregunta.pregunta.bucle) {
			$http.get(cfg.baseURL + "ft_productos?id_ficha_tecnica=" + $scope.id_ficha_tecnica).then(function (response) {
				if (response.data) {
					if(response.data.length > 0){
						$scope.tabs = [];
						for (var i = 0; i < response.data.length; i++) {
							$scope.tabs.push({ index: i, valor: response.data[i].marca, nombre: response.data[i].marcanombre });
						}
						$scope.buildGrid($scope.tabs[0]);
					} else
						$scope.buildGrid();
				}
			});
		}
	};


	$scope.cambiarTabDependenciaEtiquetado = function (tab, index) {
		var target = $scope.getTargetGrid();
		target.grid.ixSaveConfig();
		$scope.activeTabDependenciaEtiquetado = index;
		$scope.buildGrid(tab);
	};

	////////////////////////////////////////////////////////////////////////////////

	$scope.deleteSelectedRows = function (grid) {
		grid.ixDeleteSelectedRows();
	};

	$scope.estaBloqueadoValor = function (cell) {
		return ($scope.estaBloqueado(cell)) || $scope.bloquear_valor_b;
	};

	$scope.estaBloqueado = function (cell) {
		return cell.row.entity.bloqueado;
	};

	$scope.noTraducible = function () {
		return $scope.traducible != 1;
	};

	$scope.getCustomHint = function (row, col) {
		return row.entity.valor_original;
	};


	$scope.buildMarcaColumn = function () {
		return {
			Name: "marca",
			NoEditable: $scope.estaBloqueadoValor,
			Required: true,
			overridePreloadedOptions: true,
			busquedaFunction: function (column, param, text, row, config) {
				return $http.get(cfg.baseURL + "ft_productos?id_ficha_tecnica=" + $scope.id_ficha_tecnica).then(function (response) {
					response.data.forEach(function (data) {
						data.id = data.marca;
						data.marca = data.marcanombre;
					});
					return response.data;
				});
			}
		};
	};

	$scope.buildComponenteColumn = function() {
		return {
			Name: "componente",
			NoEditable: true,
			Required: true,
			overridePreloadedOptions: true			
		};
	};


	var calcularOrdenBucle = function (rowEntity, colDef, newValue, oldValue) {
		if (colDef.field == "marca") {
			var marca = newValue;
			var target = $scope.getTargetGrid();
			var lineasConLaMarca = target.grid.data.filter(function (e) { return e.marca == marca; });
			rowEntity.orden_bucle = (lineasConLaMarca.length);
			if (!rowEntity.modifiedValues)
				rowEntity.modifiedValues = [];
			if (rowEntity.modifiedValues.indexOf("orden_bucle") == -1)
				rowEntity.modifiedValues.push("orden_bucle");

			//Recalculamos ordenes bucle de la marca anterior, para no dejar huecos.
			if (oldValue) {
				var marcaAnterior = oldValue;
				var lineasConMarcaAnterior = target.grid.data.filter(function (e) { return e.marca == marcaAnterior; });
				lineasConMarcaAnterior.forEach(function (linea, idx) {
					var currentOrdenBucle = linea.orden_bucle;
					linea.orden_bucle = (idx + 1);
					if (currentOrdenBucle != linea.orden_bucle) {
						if (!linea.modifiedValues)
							linea.modifiedValues = [];
						if (linea.modifiedValues.indexOf("orden_bucle") == -1)
							linea.modifiedValues.push("orden_bucle");
						target.grid.gridApi.rowEdit.setRowsDirty([linea]);
					}
				});
			}
		}
	};


	$scope.getTargetGrid = function () {
		var target = null;
		if (angular.isDefined($scope.tabs)) {
			target = $scope.tabs[$scope.activeTabDependenciaEtiquetado];
		}
		else {
			target = $scope;
		}

		return target;
	};

	$scope.estaBloqueado = function (cell) {
		if (cell.col.field == "valor")
			return cell.row.entity.bloqueado || ($scope.modoTraduccion && !$scope.traducible);
		else {
			//miramos si la sub_pregunta esta bloqueada.
			var propertyFTPreguntas = cell.col.field.replace("respuesta", "pregunta");
			var propertyABuscar = "deshabilitar_" + propertyFTPreguntas;
			var propertyTraducible = propertyFTPreguntas + "_traducible";
			return ($scope.pregunta[propertyABuscar] == 1 || cell.row.entity.bloqueado) || ($scope.modoTraduccion && !$scope.pregunta[propertyTraducible]);
		}
	};

	$scope.edicionGridEnvase = function(cell){
		var nivel = cell.row.entity["$$treeLevel"];
		//Puede ser nivel 0 o 1. El 0 es linea principal y 1 linea interna.
		var celdas_editables = [];
		if (nivel == 0) {//Nivel principal se puede editar todo menos celdas calculadas 6 y 8.
			celdas_editables = ["VALOR", "SUB_RESPUESTA1", "SUB_RESPUESTA2", "SUB_RESPUESTA3", "SUB_RESPUESTA4", "SUB_RESPUESTA5", "SUB_RESPUESTA7", "SUB_RESPUESTA9", "SUB_RESPUESTA10", "SUB_RESPUESTA11", "SUB_RESPUESTA12", "SUB_RESPUESTA13", "SUB_RESPUESTA14"];
			
			if (celdas_editables.indexOf(cell.col.colDef.name.toUpperCase()) != -1)
				return !$scope.estaBloqueado(cell);
			else
				return false;
		}
		else {
			celdas_editables = ["SUB_RESPUESTA4", "SUB_RESPUESTA5", "SUB_RESPUESTA7", "SUB_RESPUESTA9", "SUB_RESPUESTA10", "SUB_RESPUESTA11", "SUB_RESPUESTA12", "SUB_RESPUESTA13", "SUB_RESPUESTA14"];
			if (celdas_editables.indexOf(cell.col.colDef.name.toUpperCase()) != -1)
				return !$scope.estaBloqueado(cell);
			else
				return false;
		}
	};
	

	$scope.buildGrid = function (tab) {
		var target = $scope.getTargetGrid();

		var metadata = $scope.getFakeMetadata();

		if (!$scope.modoTraduccion) {
			metadata.push($scope.buildMarcaColumn());
			//metadata.push($scope.buildComponenteColumn());
			$scope.showOnlyDescribedCols = metadata.filter(function (e) { return e.Name != "id"; }).map(function (e) { return e.Name; });

			if ($scope.pregunta.pregunta.bucle)
				$scope.showOnlyDescribedCols.push("orden_bucle");
			// if ($scope.pregunta.pregunta.sub_bucle)
			// 	$scope.showOnlyDescribedCols.push("orden_tab");

			if (angular.isUndefined(target.grid)) {


				var gridOptions = {
					enableRowSelection: (angular.isUndefined($scope.modoTraduccion)),
					enableRowHeaderSelection: (angular.isUndefined($scope.modoTraduccion)),
					enableCellEdit: (angular.isUndefined($scope.modoTraduccion) && !$scope.pregunta_bloqueada),
					metadata: metadata,
					onCellEdit: $scope.pregunta.pregunta.bucle ? calcularOrdenBucle : undefined,
					showOnlyDescribedCols: $scope.showOnlyDescribedCols,
					ixLoadInitialDataAction: "PreguntasDependenciaEtiquetado"
				};

				if($scope.esGridJerarquico()){
					gridOptions.showTreeExpandNoChildren = false;
					gridOptions.rowTemplate = "app/base/views/grid/ui-grid-tree-row.html";
					if ($scope.tablaEnvases) gridOptions.pruebaFT = true;
				}
					

				target.grid = gridService.createGrid($scope, "ft_dependencia_etiquetadoGrid_" + $scope.id_pregunta, gridOptions, 
				"extranet_fichas_tecnicas_det", (acciones.length > 0) ? [{
					name: 'Acciones',
					type: 'detalle',
					allowCellFocus: false,
					width: 100,
					acciones: acciones
				}] : undefined);
			}
			else {
				target.grid = gridService.createGridFunctions($scope, target.grid);
				target.grid.ixRestoreConfig();
			}
		} else {
			if (angular.isUndefined(target.grid)) {
				target.grid = gridService.createGrid($scope, "ft_dependencia_etiquetado_idiomaGrid_" + $scope.id_pregunta, {
					enableRowSelection: false,
					enableRowHeaderSelection: false,
					metadata: metadata,
					getCustomHint: $scope.getCustomHint
				}, "dependencia_etiquetado_idiomaVM", (acciones.length > 0) ? [{
					name: 'Acciones',
					type: 'detalle',
					allowCellFocus: false,
					width: 100,
					acciones: acciones
				}] : undefined);
			}
			else {
				target.grid = gridService.createGridFunctions($scope, target.grid);
				target.grid.ixRestoreConfig();
			}
			target.grid.entity = "dependencia_etiquetado_idioma";
		}

		if ($scope.tablaEnvases)
			target.grid.cellEditableCondition = $scope.edicionGridEnvase;

		target.grid.filtroExterno = [{
			Field: "id_ficha_tecnica",
			Operator: CMP_EQ,
			Value: $scope.id_ficha_tecnica
		}, {
			Field: "id_pregunta",
			Operator: CMP_EQ,
			Value: $scope.id_pregunta
		}];

		if ($scope.pregunta.pregunta.bucle) {
			//Agregar filtro para la marca
			var tabul = $scope.tabs.find(function (e) { return e.index == $scope.activeTabDependenciaEtiquetado; });
			if (angular.isDefined(tabul)) {
				target.grid.filtroExterno.push({
					Field: "marca",
					Operator: CMP_EQ,
					Value: tabul.valor
				});
			}
		}

		if (angular.isDefined($scope.componente)){
			target.grid.filtroExterno.push({
				Field: "componente",
				Operator: CMP_EQ,
				Value: $scope.componente
			});
		}

		if ($scope.modoTraduccion) {
			target.grid.filtroExterno.push({
				Field: "idioma",
				Operator: CMP_EQ,
				Value: $scope.idioma
			});
		}

		target.grid.ixGetBulkParam = function () {
			var bulkParam = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};

			if (target.grid.gridApi) {
				var dirtyRows = target.grid.gridApi.rowEdit.getDirtyRows();
				dirtyRows.forEach(function (row) {
					if (row.entity.manuallyAdded) delete row.entity.manuallyAdded;
					if (target.grid.insertedRows.indexOf(row.entity) >= 0) {
						delete (row.entity.isNew);
						bulkParam.ToInsert.push(row.entity);
					} else {
						bulkParam.ToUpdate.push({
							PK: target.grid.buildPK(row.entity),
							PocoToUpdate: target.grid.getPatchOperations(row.entity)
						});
					}
				});
				target.grid.deletedRows.forEach(function (data) {
					var toDelete = target.grid.buildPK(data);
					//toDelete.disable_before_after = true;
					bulkParam.ToDelete.push(toDelete);
				});
			}

			return bulkParam;
		};
	};

	$scope.addRow = function(grid){
		var respuestasProperty = ($scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
		var componente = $scope.pregunta[respuestasProperty][0].componente;
		var newEntity = { componente: componente};
		if($scope.esGridJerarquico())
			newEntity["$$treeLevel"] = 0;
		grid.ixAddRow(newEntity);
		/* Código original (tal vez no usado/ejecutado porque en html: data-ng-click="grid.ixAddRow()") */
		// var newEntity = {};
		// if($scope.esGridJerarquico())
		// 	newEntity["$$treeLevel"] = 0;

		// grid.ixAddRow(newEntity);
	};

	$scope.addTreeLevel = function (respuestas) {
		angular.forEach(respuestas, function (respuesta) {
			respuesta["$$treeLevel"] = ((respuesta.orden_sub_bucle == 0 || respuesta.orden_tab == 0) ? 0 : (!respuesta.orden_sub_sub_bucle && !respuesta.orden_tab2) ? 1 : 2);
		});
	};

	$scope.sortGridData = function(data){
		data = $filter('orderBy')(data, ['orden_bucle', 'orden_sub_bucle']);
		return data;
	};

	if ($scope.pregunta.pregunta.bucle)
		$scope.getTabs();
	else
		$scope.buildGrid();

	if($scope.tablaEnvases){
		$scope.$on("gridLoaded", function(){
			var target = $scope.getTargetGrid();
			$scope.addTreeLevel(target.grid.data);
			target.grid.data = $scope.sortGridData(target.grid.data)
		});
	}

}]);

/*global CMP_EQ*/

//Este controlador es únicamente para la pantalla del popup para entrar los valores por etiquetado de las tablas de nutricionales y vitaminas y minerales.
angular.module("FTBase").controller('DependenciaEtiquetadoNutricionalesPopupController', ['$scope', '$http', '$q', '$log', 'cfg', 'authService', 'gridService', 'ixStatusService', function ($scope, $http, $q, $log, cfg, authService, gridService, ixStatusService) {
	$scope.tienePerfilRestringido = function () {
		var perfilRestringido = false;
		var perfilesUsuario = authService.perfilesUsuario();

		var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];

		angular.forEach(perfilesUsuario, function (perfil) {
			if (perfilesRestringidos.indexOf(perfil) != -1)
				perfilRestringido = true;
		});

		return perfilRestringido;
	};

	if(!$scope.tienePerfilRestringido()) {
		$scope.status = {
			editing: true
		};
	}else{
		$scope.status = {
			editing: false
		};
	}

	$scope.id_ficha_tecnica = $scope.$resolve.id_ft;
	$scope.id_pregunta = $scope.$resolve.id_pregunta;
	$scope.pregunta_formulario = $scope.$resolve.pregunta_formulario;
	$scope.bloquear_valor_b = $scope.$resolve.bloquear_valor_b;
	$scope.pregunta_bloqueada = $scope.$resolve.pregunta_bloqueada;
	$scope.modoTraduccion = $scope.$resolve.modo_traduccion;
	$scope.idioma = $scope.$resolve.idioma;
	$scope.traducible = $scope.$resolve.traducible;

	$scope.pregunta = $scope.$resolve.pregunta;

	$scope.activeTabDependenciaEtiquetado = 0;

	var tiposValor = { TEXTO: "TEXTO", NUMERICO: "NUMERICO", DECIMAL: "DECIMAL", DICCIONARIO: "DICCIONARIO", SINO: "SI/NO", FECHA: "FECHA", AREA_TEXTO: "AREA_TEXTO", DICCIONARIO_MULTIPLE: "DICCIONARIO_MULTIPLE" };

	///////////////////////// FUNCIONES ////////////////////////////////////////////
	$scope.tienePerfilAdmin = function () {
		return authService.tienePerfilAdmin();
	};

	$scope.switchBloqueado = function (bloqueado) {
		if (bloqueado)
			bloqueado = 0;
		else
			bloqueado = 1;
		return bloqueado;
	};

	$scope.changeLockGrid = function (entity) {
		var data = [
			{
				op: "replace",
				path: "/bloqueado",
				value: entity.bloqueado
			}
		];
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/" + entity.id, data).then(function (response) {

		}, function (err) {
			entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
		});
	};

	$scope.getTabs = function () {
		$scope.tabs = undefined;

		$http.get(cfg.baseURL + "ft_productos?id_ficha_tecnica=" + $scope.id_ficha_tecnica).then(function (response) {
			if (response.data) {
				if (response.data.length > 0) {
					$scope.tabs = [];
					for (var i = 0; i < response.data.length; i++) {
						$scope.tabs.push({ index: i, valor: response.data[i].marca, nombre: response.data[i].marcanombre });
					}
					$scope.buildGrid($scope.tabs[0]);
				} else
					$scope.buildGrid();
			}
		});
	};

	$scope.getTargetGrid = function () {
		var target = null;
		if (angular.isDefined($scope.tabs)) {
			target = $scope.tabs[$scope.activeTabDependenciaEtiquetado];
		}

		return target;
	};


	$scope.addNewElementsToDictionary = function () {

	};


	$scope.buildMarcaColumn = function () {
		return {
			Name: "marca",
			NoEditable: $scope.estaBloqueadoValor,
			Required: true,
			overridePreloadedOptions: true,
			busquedaFunction: function (column, param, text, row, config) {
				return $http.get(cfg.baseURL + "ft_productos?id_ficha_tecnica=" + $scope.id_ficha_tecnica).then(function (response) {
					response.data.forEach(function (data) {
						data.id = data.marca;
						data.marca = data.marcanombre;
					});
					return response.data;
				});
			}
		};
	};


	$scope.addSpecificControl = function (obj, tipo) {
		var preguntaProperty = ($scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
		var respuestasProperty = ($scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";

		if ($scope.modoTraduccion) {
			tipo = tiposValor.TEXTO;
			if (obj.Name == "valor" && $scope.pregunta.pregunta.traducible) {
				obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
			}
			else {
				var nameColumn = obj.Name.replace("respuesta", "pregunta");
				if ($scope.pregunta[nameColumn + "_traducible"])
					obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
			}
		}

		if (tipo == tiposValor.SINO) {
			if ($scope.modoTraduccion)
				obj.NoEditable = true;

			obj.Control = "CheckBox";
			obj.ignoreCellModifications = true;
		}
		else if (tipo == tiposValor.DICCIONARIO) {
			if ($scope.modoTraduccion)
				obj.NoEditable = true;

			if ($scope.pregunta[respuestasProperty][0].componente && $scope.pregunta[preguntaProperty].diccionario_valores) {
				$scope.addNewElementsToDictionary();
			}
			if (obj.Name == "valor")
				obj.ColumnFkDescription = "valor";

			obj.Search = {
				"KeyFields": [obj.Name],
				"LookUpTableName": "",
				"LookUpKeyFields": ["codigo"],
				"LookUpResultFields": ["descripcion", "codigo"],
				"LookUpTableAlias": "",
				"LookUpOrders": [{ "KeyField": "descripcion", "Desc": false }],
				"LookUpConditions": []
			};

			obj.busquedaFunction = function (column, param, text) {
				var preguntaProperty = ($scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				var deferr = $q.defer();
				var valores = [];
				var diccionario_valores = [];

				if ($scope.preview)
					diccionario_valores = $scope.pregunta.pregunta.diccionario_valores;
				else {
					var fieldToSearch = ((column.Name == "valor") ? "" : column.Name.replace("respuesta", "pregunta"));
					fieldToSearch = "diccionario_" + fieldToSearch + ((fieldToSearch != "") ? "_" : "") + "valores";
					diccionario_valores = $scope.pregunta[preguntaProperty][fieldToSearch];
				}

				if (text)
					diccionario_valores = diccionario_valores.filter(function (e) { return e.toLowerCase().indexOf(text.toLowerCase()) != -1; });

				angular.forEach(diccionario_valores, function (valor) {
					var item = { codigo: valor, descripcion: valor };
					if (column.ColumnFKDescription)
						item[column.ColumnFKDescription] = valor;

					valores.push(item);
				});

				deferr.resolve(valores);
				return deferr.promise;
			}
		}
		else if (tipo == tiposValor.FECHA)
			obj.Type = "DateTime";
		else if (tipo == tiposValor.DECIMAL) {
			obj.Type = "Decimal";
			obj.CommaSeparator = true;
			obj.MaxLength = 11;
		}
		else if (tipo == tiposValor.NUMERICO) {
			obj.Type = "Int32";
			obj.MaxLength = 11;
		}
	};


	$scope.getFakeMetadata = function () {
		var metadata = [];
		metadata.push({ Name: "id", NoVisible: true, Pk: true });
		var valor = { Name: "valor", ColumnDescription: $scope.pregunta_formulario, Type: "String", NoEditable: true, NoFilterable: true };
		$scope.addSpecificControl(valor, $scope.pregunta.pregunta.tipo_valor);
		metadata.push(valor);
		if ($scope.pregunta.pregunta.sub_pregunta1) {
			var sub_pregunta1 = { Name: "sub_respuesta1", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta1, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta1, $scope.pregunta.pregunta.tipo_valor_sub_pregunta1);
			metadata.push(sub_pregunta1);
		}
		if ($scope.pregunta.pregunta.sub_pregunta2) {
			var sub_pregunta2 = { Name: "sub_respuesta2", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta2, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta2, $scope.pregunta.pregunta.tipo_valor_sub_pregunta2);
			metadata.push(sub_pregunta2);
		}
		if ($scope.pregunta.pregunta.sub_pregunta3) {
			var sub_pregunta3 = { Name: "sub_respuesta3", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta3, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta3, $scope.pregunta.pregunta.tipo_valor_sub_pregunta3);
			metadata.push(sub_pregunta3);
		}
		if ($scope.pregunta.pregunta.sub_pregunta4) {
			var sub_pregunta4 = { Name: "sub_respuesta4", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta4, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta4, $scope.pregunta.pregunta.tipo_valor_sub_pregunta4);
			metadata.push(sub_pregunta4);
		}
		if ($scope.pregunta.pregunta.sub_pregunta5) {
			var sub_pregunta5 = { Name: "sub_respuesta5", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta5, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta5, $scope.pregunta.pregunta.tipo_valor_sub_pregunta5);
			metadata.push(sub_pregunta5);
		}
		if ($scope.pregunta.pregunta.sub_pregunta6) {
			var sub_pregunta6 = { Name: "sub_respuesta6", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta6, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta6, $scope.pregunta.pregunta.tipo_valor_sub_pregunta6);
			metadata.push(sub_pregunta6);
		}
		if ($scope.pregunta.pregunta.sub_pregunta7) {
			var sub_pregunta7 = { Name: "sub_respuesta7", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta7, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta7, $scope.pregunta.pregunta.tipo_valor_sub_pregunta7);
			metadata.push(sub_pregunta7);
		}
		if ($scope.pregunta.pregunta.sub_pregunta8) {
			var sub_pregunta8 = { Name: "sub_respuesta8", ColumnDescription: $scope.pregunta.pregunta.sub_pregunta8, Type: "String", NoEditable: $scope.estaBloqueado, NoFilterable: true };
			$scope.addSpecificControl(sub_pregunta8, $scope.pregunta.pregunta.tipo_valor_sub_pregunta8);
			metadata.push(sub_pregunta8);
		}

		return metadata;
	};


	var calcularOrdenBucle = function (rowEntity, colDef, newValue, oldValue){
		if (colDef.field == "marca") {
			var marca = newValue;
			var target = $scope.getTargetGrid();
			var lineasConLaMarca = target.grid.data.filter(function (e) { return e.marca == marca; });
			rowEntity.orden_bucle = (lineasConLaMarca.length);
			if (!rowEntity.modifiedValues)
				rowEntity.modifiedValues = [];
			if (rowEntity.modifiedValues.indexOf("orden_bucle") == -1)
				rowEntity.modifiedValues.push("orden_bucle");

			//Recalculamos ordenes bucle de la marca anterior, para no dejar huecos.
			if (oldValue) {
				var marcaAnterior = oldValue;
				var lineasConMarcaAnterior = target.grid.data.filter(function (e) { return e.marca == marcaAnterior; });
				lineasConMarcaAnterior.forEach(function (linea, idx) {
					var currentOrdenBucle = linea.orden_bucle;
					linea.orden_bucle = (idx + 1);
					if (currentOrdenBucle != linea.orden_bucle) {
						if (!linea.modifiedValues)
							linea.modifiedValues = [];
						if (linea.modifiedValues.indexOf("orden_bucle") == -1)
							linea.modifiedValues.push("orden_bucle");
						target.grid.gridApi.rowEdit.setRowsDirty([linea]);
					}
				});
			}
		}
	};


	$scope.buildGrid = function (tab) {
		var target = $scope.getTargetGrid();

		var metadata = $scope.getFakeMetadata();

		//Indicar las columnas que queramos ocultar o hacer no editables
		metadata.push({ Name: "orden_bucle", NoVisible: true });
		metadata.push({ Name: "marca", NoVisible: true });

		if (!$scope.modoTraduccion) {
			metadata.push($scope.buildMarcaColumn());

			$scope.showOnlyDescribedCols = metadata.filter(function (e) { return e.Name != "id"; }).map(function (e) { return e.Name; });

			if ($scope.pregunta.pregunta.bucle)
				$scope.showOnlyDescribedCols.push("orden_bucle");

			if (angular.isUndefined(target.grid)) {
				target.grid = gridService.createGrid($scope, "ft_dependencia_etiquetadoGrid_" + $scope.id_pregunta, {
					enableCellEdit: (angular.isUndefined($scope.modoTraduccion) && !$scope.pregunta_bloqueada),
					enableRowSelection: false, 
                	enableRowHeaderSelection: false,
					metadata: metadata,
					onCellEdit: $scope.pregunta.pregunta.bucle ? calcularOrdenBucle : undefined,
					showOnlyDescribedCols: $scope.showOnlyDescribedCols,
					ixLoadInitialDataAction: "PreguntasDependenciaEtiquetado"
				}, "extranet_fichas_tecnicas_det", (acciones.length > 0) ? [{
					name: 'Acciones',
					type: 'detalle',
					allowCellFocus: false,
					width: 100,
					acciones: acciones
				}] : undefined);
			}
			else {
				target.grid = gridService.createGridFunctions($scope, target.grid);
				target.grid.ixRestoreConfig();
			}
		}
		else {
			if (angular.isUndefined(target.grid)) {
				target.grid = gridService.createGrid($scope, "ft_dependencia_etiquetado_idiomaGrid_" + $scope.id_pregunta, {
					enableRowSelection: false,
					enableRowHeaderSelection: false,
					metadata: metadata,
					getCustomHint: $scope.getCustomHint
				}, "dependencia_etiquetado_idiomaVM", (acciones.length > 0) ? [{
					name: 'Acciones',
					type: 'detalle',
					allowCellFocus: false,
					width: 100,
					acciones: acciones
				}] : undefined);
			}
			else {
				target.grid = gridService.createGridFunctions($scope, target.grid);
				target.grid.ixRestoreConfig();
			}
			target.grid.entity = "dependencia_etiquetado_idioma";
		}

		target.grid.filtroExterno = [{
			Field: "id_ficha_tecnica",
			Operator: CMP_EQ,
			Value: $scope.id_ficha_tecnica
		}, {
			Field: "id_pregunta",
			Operator: CMP_EQ,
			Value: $scope.id_pregunta
		}];

		//Agregar filtro para la marca
		var tabul = $scope.tabs.find(function (e) { return e.index == $scope.activeTabDependenciaEtiquetado; });
		if (angular.isDefined(tabul)) {
			target.grid.filtroExterno.push({
				Field: "marca",
				Operator: CMP_EQ,
				Value: tabul.valor
			});
		}

		if ($scope.modoTraduccion) {
			target.grid.filtroExterno.push({
				Field: "idioma",
				Operator: CMP_EQ,
				Value: $scope.idioma
			});
		}

		target.grid.ixGetBulkParam = function () {
			var bulkParam = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};

			if (target.grid.gridApi) {
				var dirtyRows = target.grid.gridApi.rowEdit.getDirtyRows();
				dirtyRows.forEach(function (row) {
					if (row.entity.manuallyAdded) delete row.entity.manuallyAdded;
					if (target.grid.insertedRows.indexOf(row.entity) >= 0) {
						delete (row.entity.isNew);
						bulkParam.ToInsert.push(row.entity);
					} else {
						bulkParam.ToUpdate.push({
							PK: target.grid.buildPK(row.entity),
							PocoToUpdate: target.grid.getPatchOperations(row.entity)
						});
					}
				});
				target.grid.deletedRows.forEach(function (data) {
					var toDelete = target.grid.buildPK(data);
					toDelete.disable_before_after = true;
					bulkParam.ToDelete.push(toDelete);
				});
			}

			return bulkParam;
		};
	};


	$scope.cambiarTabDependenciaEtiquetado = function (tab, index) {
		var target = $scope.getTargetGrid();
		target.grid.ixSaveConfig();
		$scope.activeTabDependenciaEtiquetado = index;
		$scope.buildGrid(tab);
	};


	$scope.addNutricionales = function(t, idx){
		$log.log("addNutricionales");
		var componente = $scope.pregunta.respuestas[0].componente;
		if (angular.isUndefined($scope.idioma)){
			$scope.idioma = "es";
		}

		var request_data = {
			id_ft: $scope.id_ficha_tecnica,
			id_pregunta: $scope.id_pregunta,
			componente: componente,
			id_marca: t.valor,
			idioma: $scope.idioma
		};

		$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/AgregarNutricionalesMarca", request_data).then(function(response){
			$log.log(response);
			$scope.registrosCreados = true;
			var target = $scope.getTargetGrid();
			angular.forEach(response.data.Inserted, function(nueva_linea){
				nueva_linea.Record.manuallyAdded = true;
				target.grid.ixAddRow(nueva_linea.Record);
			});
			//Limpio insertedRows para evitar que al editar se agreguen nuevas lineas (la función getDirtyRows no tiene que pescarlas)
			target.grid.insertedRows = [];
		},
		function(error){
			$scope.status.response = error;
		});
	};


	$scope.deleteNutricionales = function(grid){
		$log.log("deleteNutricionales");
		var listaIdFtDet = grid.data.map(function (d) {
			return d.id;
		});

		$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/EliminarNutricionalesMarca", listaIdFtDet).then(function(response){
			$log.log(response);
			$scope.registrosCreados = false;
			if(response.data.Result){
				grid.data = [];
			}
			$scope.status.response = response;
		},
		function(error){
			$scope.status.response = error;
		});
	};


	///////////////////////// FIN FUNCIONES ////////////////////////////////////////////  


	if (!$scope.pregunta_bloqueada) {
		$scope.save = function () {
			var target = $scope.getTargetGrid();
			if (target) {
				target.grid.ixGuardar().then(function (response) {
					$scope.status.editing = true;
					ixStatusService.setEditing(true);
					$scope.pregunta.respuestas[0].contiene_info_etiquetado = target.grid.data.length > 0;
				});
			}
		};
	}

	var acciones = [];

	if ($scope.tienePerfilAdmin()) {
		acciones.push({
			icon: "fa-lock",
			title: "Desbloquear",
			visible: function (entity) {
				return $scope.tienePerfilAdmin() && entity.bloqueado;
			},
			accion: function (entity) {
				entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
				$scope.changeLockGrid(entity);
			}
		});
		acciones.push({
			icon: "fa-unlock",
			title: "Bloquear",
			visible: function (entity) {
				return $scope.tienePerfilAdmin() && !entity.bloqueado;
			},
			accion: function (entity) {
				entity.bloqueado = $scope.switchBloqueado(entity.bloqueado);
				$scope.changeLockGrid(entity);
			}
		});
	}

	$scope.getTabs();
}]);
angular.module('FTBase').controller('DatosFabricantePopupController', [ '$scope', '$http', 'cfg', '$uibModalInstance', 'ixStatusService', function($scope, $http, cfg, $uibModalInstance, ixStatusService){
	$scope.status = { editing: false };
	$http.get(cfg.baseURL + "fabricantes/" + $scope.$resolve.fabricante).then(function(response){
		$scope.datos_fabricante = response.data;
	}, function(err){
		ixStatusService.setResponse(err);
	});
}]);

angular.module('FTBase').controller('AddElementosSaludablesPopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService){
	$scope.listOfValues = angular.copy($scope.$resolve.listelements);
	$scope.status = { editing: true };
	$scope.data = {};
	$scope.save = function(){
		var selecteds = $scope.listOfValues.filter(function(e){ return e.selected; });
		$uibModalInstance.close({ rows: selecteds });
	};
	$scope.$close = function () {
		$scope.status.editing = false;
		$uibModalInstance.dismiss('cancel');
	};
}]);

angular.module('FTBase').controller('GridJerarquicoAddRowPopupController', ['$scope', '$uibModalInstance', 'ixStatusService', 'ixUtilsService', '$q', 'ivhTreeviewMgr', '$http', 'cfg', '$timeout', '$rootScope', function ($scope, $uibModalInstance, ixStatusService, ixUtilsService, $q, ivhTreeviewMgr, $http, cfg, $timeout, $rootScope) {
	$scope.status = { editing: true };

	$scope.entity = $scope.$resolve.entity;
	$scope.entityMaster = $scope.$resolve.entityMaster;
	$scope.entityOriginal = angular.copy($scope.entity);
	$scope.modoTraduccion = $scope.$resolve.modoTraduccion;

	$scope.pregunta = { pregunta: angular.copy($scope.$resolve.pregunta.pregunta), respuestas: [$scope.entity] };
	if ($scope.modoTraduccion) {
		$scope.pregunta.respuestas = [$scope.entityMaster];
		$scope.pregunta.pregunta_idioma = angular.copy($scope.$resolve.pregunta.pregunta_idioma);
		$scope.pregunta.respuestas_idioma = [$scope.entity];
	}


	//$scope.pregunta = { pregunta: angular.copy($scope.$resolve.pregunta.pregunta), respuestas: angular.copy($scope.$resolve.pregunta.respuestas) };
	$scope.pregunta.pregunta.bucle = 0;
	$scope.pregunta.pregunta.sub_bucle = 0;
	$scope.pregunta.pregunta.preguntar_componente = 0;

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta1 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta1 && !angular.isArray($scope.entity.sub_respuesta1))
		$scope.entity.sub_respuesta1 = $scope.entity.sub_respuesta1.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta2 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta2 && !angular.isArray($scope.entity.sub_respuesta2))
		$scope.entity.sub_respuesta2 = $scope.entity.sub_respuesta2.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta3 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta3 && !angular.isArray($scope.entity.sub_respuesta3))
		$scope.entity.sub_respuesta3 = $scope.entity.sub_respuesta3.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta4 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta4 && !angular.isArray($scope.entity.sub_respuesta4))
		$scope.entity.sub_respuesta4 = $scope.entity.sub_respuesta4.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta5 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta5 && !angular.isArray($scope.entity.sub_respuesta5))
		$scope.entity.sub_respuesta5 = $scope.entity.sub_respuesta5.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta6 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta6 && !angular.isArray($scope.entity.sub_respuesta6))
		$scope.entity.sub_respuesta6 = $scope.entity.sub_respuesta6.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta7 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta7 && !angular.isArray($scope.entity.sub_respuesta7))
		$scope.entity.sub_respuesta7 = $scope.entity.sub_respuesta7.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta8 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta8 && !angular.isArray($scope.entity.sub_respuesta8))
		$scope.entity.sub_respuesta8 = $scope.entity.sub_respuesta8.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta9 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta9 && !angular.isArray($scope.entity.sub_respuesta9))
		$scope.entity.sub_respuesta9 = $scope.entity.sub_respuesta9.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta10 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta10 && !angular.isArray($scope.entity.sub_respuesta10))
		$scope.entity.sub_respuesta10 = $scope.entity.sub_respuesta10.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta10 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta10 && !angular.isArray($scope.entity.sub_respuesta10))
		$scope.entity.sub_respuesta10 = $scope.entity.sub_respuesta10.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta11 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta11 && !angular.isArray($scope.entity.sub_respuesta11))
		$scope.entity.sub_respuesta11 = $scope.entity.sub_respuesta11.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta12 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta12 && !angular.isArray($scope.entity.sub_respuesta12))
		$scope.entity.sub_respuesta12 = $scope.entity.sub_respuesta12.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta13 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta13 && !angular.isArray($scope.entity.sub_respuesta13))
		$scope.entity.sub_respuesta13 = $scope.entity.sub_respuesta13.replaceAll(";",",").split(",");

	if ($scope.pregunta.pregunta.tipo_valor_sub_pregunta14 == "DICCIONARIO_MULTIPLE" && $scope.entity.sub_respuesta14 && !angular.isArray($scope.entity.sub_respuesta14))
		$scope.entity.sub_respuesta14 = $scope.entity.sub_respuesta14.replaceAll(";",",").split(",");

	$scope.rowsGrid = $scope.$resolve.rowsGrid || [];
	$scope.isNew = $scope.$resolve.isNew;
	$scope.grid = $scope.$resolve.grid;

	$scope.clearEmptyRow = function () {
		var emptyRow = $scope.grid.data.find(function (e) { return !e.valor && !e.sub_respuesta1 && !e.sub_respuesta2 && !e.sub_respuesta3 && !e.sub_respuesta4 && !e.sub_respuesta5 && !e.sub_respuesta6 && !e.sub_respuesta7 && !e.sub_respuesta8 && !e.sub_respuesta9 && !e.sub_respuesta10 && !e.sub_respuesta11 && !e.sub_respuesta12 && !e.sub_respuesta13 && !e.sub_respuesta14; });
		if (angular.isDefined(emptyRow)) {
			$scope.grid.data.splice($scope.grid.data.indexOf(emptyRow), 1);
		}
	};

	$scope.resetForm = function () {
		$scope.searchtext = "";
		$scope.entity.orden_bucle = "";
		$scope.entity.valor = "";
		$scope.entity.sub_respuesta1 = "";
		$scope.entity.sub_respuesta2 = null;
		$scope.entity.sub_respuesta3 = null;
		$scope.entity.sub_respuesta4 = "";
		$scope.entity.sub_respuesta5 = "";
		$scope.entity.sub_respuesta6 = "";
		$scope.entity.sub_respuesta7 = "";
		$scope.entity.sub_respuesta8 = "";
		$scope.entity.sub_respuesta9 = "";
		$scope.entity.sub_respuesta10 = "";
		$scope.entity.sub_respuesta11 = "";
		$scope.entity.sub_respuesta12 = "";
		$scope.entity.sub_respuesta13 = "";
		$scope.entity.sub_respuesta14 = "";

		ivhTreeviewMgr.deselectAll($scope.listOfValues);
		$scope.reloadDropdown();
	};
	$scope.reloadDropdown = function () {
		$scope.reload = true;
		$timeout(function () {
			$scope.reload = false;
		}, 1);
	};
	$scope.cargarValoresNivel = function () {
		var deferr = $q.defer();

		var ingredientesPrincipales = [{ codigo: 0, descripcion: "Ingrediente Principal" }];

		$scope.rowsGrid.filter(function (e) { return (e["$$treeLevel"] == 0 || e["$$treeLevel"] == 1) && (e.valor); }).forEach(function (row, idx) {
			var orden_sub_bucle = row.orden_sub_bucle || row.orden_tab;
			ingredientesPrincipales.push({ codigo: row.orden_bucle + "-" + orden_sub_bucle, descripcion: row.valor });
		});

		deferr.resolve({ data: ingredientesPrincipales });
		return deferr.promise;
	};

	$scope.$watch('searchtext', function (newVal, oldVal) {
		$scope.changeSelectionIfItemMatching();
	});

	$scope.changeSelectionIfItemMatching = function () {
		if ($scope.searchtext) {
			var matchingItem = $scope.listOfValues.find(function (e) { return e.id.toString().toUpperCase().toString() == $scope.searchtext.toUpperCase() });
			ivhTreeviewMgr.selectAll($scope.listOfValues);
			ivhTreeviewMgr.deselectAll($scope.listOfValues);
			//			if(angular.isDefined(matchingItem)){
			//				ivhTreeviewMgr.select($scope.listOfValues, matchingItem);
			//			} else {
			//				ivhTreeviewMgr.select($scope.listOfValues, $scope.listOfValues.find(function(e){ return e.id === 0; }));
			//			}
			$scope.entity.valor = $scope.searchtext;
		}
	};


	$scope.filterItems = function (node) {
		return (node.id == 0) || ixUtilsService.comparar(node.id,$scope.searchtext)>=0;
	};

	var getListIngredientesDiccionario = function () {
		var lista = [{ id: 0, label: "Crear ingrediente", selected: 0 }];
		if ($scope.pregunta.pregunta.diccionario_valores) {
			$scope.pregunta.pregunta.diccionario_valores.forEach(function (valor) {
				if (valor != null)
					lista.push({ id: valor, label: valor, selected: 0 });
			});
		}
		return lista;
	};

	$scope.listOfValues = getListIngredientesDiccionario();

	$scope.selectionChanged = function (ivhNode, ivhIsSelected, ivhTree) {
		$scope.entity.valor = null;
		if (ivhIsSelected) {
			ivhTreeviewMgr.selectAll($scope.listOfValues);
			ivhTreeviewMgr.deselectAll($scope.listOfValues);
			ivhTreeviewMgr.selectEach(ivhTree, [ivhNode]);

			if (ivhNode.id == 0) {
				$scope.entity.valor = $scope.searchtext;
			} else {
				$scope.entity.valor = ivhNode.label;
				$scope.searchtext = $scope.entity.valor;
			}
		}
		else
			$scope.searchtext = "";
	};

	var getMaxOrdenBucle = function () {
		var max_orden_bucle = 0;
		$scope.rowsGrid.filter(function (e) { return (e.orden_sub_bucle === 0 || e.orden_tab === 0) && e.valor; }).forEach(function (nivel_principal) {
			if (max_orden_bucle < nivel_principal.orden_bucle)
				max_orden_bucle = nivel_principal.orden_bucle;
		});
		return max_orden_bucle;
	};
	$scope.save = function () {
		if ($scope.rowsGrid.length > 0) {
			if ($scope.entity.orden_bucle == 0) {
				//Get max orden_bucle and sum 1.
				$scope.entity.orden_bucle = getMaxOrdenBucle() + 1;
				$scope.entity.orden_tab = 0;
			} else {
				var partsCodigo = $scope.entity.orden_bucle.split("-");
				var orden_bucle = parseInt(partsCodigo[0]);
				$scope.entity.orden_bucle = orden_bucle;
				var orden_sub_bucle = parseInt(partsCodigo[1]);
				if (isNaN(orden_sub_bucle))
					orden_sub_bucle = 0;
				if (orden_sub_bucle == 0) {
					$scope.entity.orden_tab = ($scope.rowsGrid.filter(function (e) { return e.orden_bucle == orden_bucle && (e.orden_sub_bucle > 0 || e.orden_tab > 0) && (!e.orden_tab2 && !e.orden_sub_sub_bucle); }).length) + 1;
					$scope.entity.orden_tab2 = 0;
				} else {
					$scope.entity.orden_tab = orden_sub_bucle;
					$scope.entity.orden_tab2 = ($scope.rowsGrid.filter(function (e) { return e.orden_bucle == orden_bucle && (e.orden_sub_bucle == orden_sub_bucle || e.orden_tab == orden_sub_bucle) && (e.orden_sub_sub_bucle > 0 || e.orden_tab2 > 0); }).length) + 1;
				}
			}
		}

		$scope.transformListsToStrings();

		if ($scope.isNew) {
			$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det", $scope.entity).then(function (response) {
				//Marcar la pregunta 702 para recargar.
				if ($scope.pregunta.pregunta.id_pregunta == 64)
					ixStatusService.current.data.ToReload = { 702: true };
				$scope.clearEmptyRow();
				$scope.resetForm();
				ixStatusService.setResponse(response);
				response.data.obj.Record["$$treeLevel"] = ((response.data.obj.Record.orden_tab == 0) ? 0 : (!response.data.obj.Record.orden_tab2) ? 1 : 2);
				$scope.grid.ixAddRow(response.data.obj.Record);
				$timeout(function () {
					if ($scope.grid.data[$scope.grid.data.length - 1].orden_tab >= 1) {
						var addedRow = $scope.grid.data.splice($scope.grid.data.length - 1, 1);
						addedRow = addedRow[0];
						addedRow.orden_sub_bucle = addedRow.orden_tab;
						addedRow.orden_sub_sub_bucle = addedRow.orden_tab2;

						var itemsNivel2 = $scope.grid.data.filter(function (e) { return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle > 0 && (!e.orden_sub_sub_bucle); });//sub ingredientes
						var itemsNivel3 = [];//sub sub ingredientes
						var previousItem = null;
						if (itemsNivel2.length > 0) {
							if (addedRow.orden_sub_sub_bucle >= 1) {
								previousItem = $scope.grid.data.find(function (e) { return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle == (addedRow.orden_sub_bucle); });//ingrediente contenedor
								itemsNivel3 = $scope.grid.data.filter(function (e) { return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle == addedRow.orden_sub_bucle && (e.orden_sub_sub_bucle > 0); });//sub sub ingredientes
							}
							else {
								previousItem = $scope.grid.data.find(function (e) { return e.orden_bucle == addedRow.orden_bucle && e.orden_sub_bucle == (addedRow.orden_sub_bucle - 1); });
								itemsNivel3 = $scope.grid.data.filter(function (e) { return e.orden_bucle == previousItem.orden_bucle && e.orden_sub_bucle == previousItem.orden_sub_bucle && e.orden_sub_sub_bucle > 0; });//sub sub ingredientes del anterior
							}


						}
						else
							previousItem = $scope.grid.data.find(function (e) { return e.orden_bucle == addedRow.orden_bucle; });

						var indexPreviousItem = $scope.grid.data.indexOf(previousItem);
						$scope.grid.data.splice((indexPreviousItem + 1 + itemsNivel3.length), 0, addedRow);
					}
				}, 250);

				$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: response.data.obj.Record.valor, oldValue: undefined, pregunta: $scope.pregunta, tipo_modificacion: "Add" });

			}, function (err) {
				ixStatusService.setResponse(err);
			});
		} else {
			$uibModalInstance.close($scope.entity);
		}

	};

	$scope.transformListsToStrings = function () {
		if ($scope.entity.sub_respuesta1 && angular.isArray($scope.entity.sub_respuesta1))
			$scope.entity.sub_respuesta1 = $scope.entity.sub_respuesta1.join(",");

		if ($scope.entity.sub_respuesta2 && angular.isArray($scope.entity.sub_respuesta2))
			$scope.entity.sub_respuesta2 = $scope.entity.sub_respuesta2.join(",");

		if ($scope.entity.sub_respuesta3 && angular.isArray($scope.entity.sub_respuesta3))
			$scope.entity.sub_respuesta3 = $scope.entity.sub_respuesta3.join(",");

		if ($scope.entity.sub_respuesta4 && angular.isArray($scope.entity.sub_respuesta4))
			$scope.entity.sub_respuesta4 = $scope.entity.sub_respuesta4.join(",");

		if ($scope.entity.sub_respuesta5 && angular.isArray($scope.entity.sub_respuesta5))
			$scope.entity.sub_respuesta5 = $scope.entity.sub_respuesta5.join(",");

		if ($scope.entity.sub_respuesta6 && angular.isArray($scope.entity.sub_respuesta6))
			$scope.entity.sub_respuesta6 = $scope.entity.sub_respuesta6.join(",");

		if ($scope.entity.sub_respuesta7 && angular.isArray($scope.entity.sub_respuesta7))
			$scope.entity.sub_respuesta7 = $scope.entity.sub_respuesta7.join(",");

		if ($scope.entity.sub_respuesta8 && angular.isArray($scope.entity.sub_respuesta8))
			$scope.entity.sub_respuesta8 = $scope.entity.sub_respuesta8.join(",");
	};

	$scope.$dismiss = function () {
		$scope.entity.orden_bucle = $scope.entityOriginal.orden_bucle;
		$scope.entity.valor = $scope.entityOriginal.valor;
		$scope.entity.sub_respuesta1 = $scope.entityOriginal.sub_respuesta1;
		$scope.entity.sub_respuesta2 = $scope.entityOriginal.sub_respuesta2;
		$scope.entity.sub_respuesta3 = $scope.entityOriginal.sub_respuesta3;
		$scope.entity.sub_respuesta4 = $scope.entityOriginal.sub_respuesta4;
		$scope.entity.sub_respuesta5 = $scope.entityOriginal.sub_respuesta5;
		$scope.entity.sub_respuesta6 = $scope.entityOriginal.sub_respuesta6;
		$scope.entity.sub_respuesta7 = $scope.entityOriginal.sub_respuesta7;
		$scope.entity.sub_respuesta8 = $scope.entityOriginal.sub_respuesta8;
		$scope.entity.sub_respuesta9 = $scope.entityOriginal.sub_respuesta9;
		$scope.entity.sub_respuesta10 = $scope.entityOriginal.sub_respuesta10;
		$scope.entity.sub_respuesta11 = $scope.entityOriginal.sub_respuesta11;
		$scope.entity.sub_respuesta12 = $scope.entityOriginal.sub_respuesta12;
		$scope.entity.sub_respuesta13 = $scope.entityOriginal.sub_respuesta13;
		$scope.entity.sub_respuesta14 = $scope.entityOriginal.sub_respuesta14;

		if ($scope.entity.sub_respuesta1 && angular.isArray($scope.entity.sub_respuesta1))
			$scope.entity.sub_respuesta1 = $scope.entity.sub_respuesta1.join(",");

		if ($scope.entity.sub_respuesta2 && angular.isArray($scope.entity.sub_respuesta2))
			$scope.entity.sub_respuesta2 = $scope.entity.sub_respuesta2.join(",");

		if ($scope.entity.sub_respuesta3 && angular.isArray($scope.entity.sub_respuesta3))
			$scope.entity.sub_respuesta3 = $scope.entity.sub_respuesta3.join(",");

		if ($scope.entity.sub_respuesta4 && angular.isArray($scope.entity.sub_respuesta4))
			$scope.entity.sub_respuesta4 = $scope.entity.sub_respuesta4.join(",");

		if ($scope.entity.sub_respuesta5 && angular.isArray($scope.entity.sub_respuesta5))
			$scope.entity.sub_respuesta5 = $scope.entity.sub_respuesta5.join(",");

		if ($scope.entity.sub_respuesta6 && angular.isArray($scope.entity.sub_respuesta6))
			$scope.entity.sub_respuesta6 = $scope.entity.sub_respuesta6.join(",");

		if ($scope.entity.sub_respuesta7 && angular.isArray($scope.entity.sub_respuesta7))
			$scope.entity.sub_respuesta7 = $scope.entity.sub_respuesta7.join(",");

		if ($scope.entity.sub_respuesta8 && angular.isArray($scope.entity.sub_respuesta8))
			$scope.entity.sub_respuesta8 = $scope.entity.sub_respuesta8.join(",");

		if ($scope.entity.sub_respuesta9 && angular.isArray($scope.entity.sub_respuesta9))
			$scope.entity.sub_respuesta9 = $scope.entity.sub_respuesta9.join(",");

		if ($scope.entity.sub_respuesta10 && angular.isArray($scope.entity.sub_respuesta10))
			$scope.entity.sub_respuesta10 = $scope.entity.sub_respuesta10.join(",");

		if ($scope.entity.sub_respuesta11 && angular.isArray($scope.entity.sub_respuesta11))
			$scope.entity.sub_respuesta11 = $scope.entity.sub_respuesta11.join(",");

		if ($scope.entity.sub_respuesta12 && angular.isArray($scope.entity.sub_respuesta12))
			$scope.entity.sub_respuesta12 = $scope.entity.sub_respuesta12.join(",");

		if ($scope.entity.sub_respuesta13 && angular.isArray($scope.entity.sub_respuesta13))
			$scope.entity.sub_respuesta13 = $scope.entity.sub_respuesta13.join(",");
			
		if ($scope.entity.sub_respuesta14 && angular.isArray($scope.entity.sub_respuesta14))
			$scope.entity.sub_respuesta14 = $scope.entity.sub_respuesta14.join(",");

		$uibModalInstance.close();
	};

}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/

"use strict";

angular.module('FTBase').controller('Listado_Proveedores_FicherosController', ['$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', '$location', 'authService', function ($scope, ixUtilsService, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, $location, authService) {

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    $scope.status.editing = false;

    //$scope.gridManualLoad = true;

    if (!$scope.data.filtro) $scope.data.filtro = {};
    $scope.data.filtro.vigentes = true;

    /* ***** FUNCTION: INIT ***** */
    $scope.init = function () {
        // $scope.ixEditar = function () {
        //     ixStatusService.setEditing(true);
        // };

        //Cargar grid
        var acciones = [
            {
                title: "Previsualizar PDF",
                icon: "fa-file-pdf-o",
                visible: function (entity) {
                    return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
                },
                accion: function (entity) {
                    var tabla = "proveedores_ficheros";
                    $http({
                        method: 'post',
                        url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
                        headers: {},
                        responseType: 'arraybuffer'
                    }).then(function (r) {
                        $scope.selectedPDF = new Uint8Array(r.data);
                        $scope.idFicheroPreview = entity.id;
                        var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
                        ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
                    },
                        function (err) {
                            ixStatusService.setResponse(err);
                        });
                }
            },
            {
                title: "Previsualizar Imagen",
                icon: "fa-file-image-o",
                visible: function (entity) {
                    return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
                },
                accion: function (entity) {
                    var tabla = $scope.getEntity();
                    $http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
                        $scope.selectedImage = r.data;
                        $scope.idFicheroPreview = entity.id;
                        var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
                        ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
                    },
                        function (err) {
                            ixStatusService.setResponse(err);
                        });
                }
            },
            {
                title: "Descargar fichero",
                icon: "fa-download",
                visible: function (entity) {
                    return entity.archivo;
                },
                accion: function (entity) {
                    var esProveedor = angular.isDefined(entity.proveedor);
                    $scope.downloadFile(entity.id, esProveedor);
                }
            }
        ];
        if (!$scope.data.gridProveedoresFicheros) {
            $scope.data.gridProveedoresFicheros = gridService.createGrid($scope, 'proveedores_ficheros_grid', { enableCellEdit: true, ixGuardarAction: "ActualizarComentarioVerificacion" }, 'listado_proveedores_ficherosVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
        } else {
            $scope.data.gridProveedoresFicheros = gridService.createGridFunctions($scope, $scope.data.gridProveedoresFicheros);
            $scope.data.gridProveedoresFicheros.ixRestoreConfig();
        }

        var usuario = authService.authentication.userName;

        $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
            //asignar cliente
            $scope.extranetUser = response.data;
            //En funcion de si es cliente o no aplicamos el filtro de cliente o no
            if ($scope.extranetUser.cliente != null) {
                $scope.data.filtro.cliente = $scope.extranetUser.cliente;
                $scope.data.gridProveedoresFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes']);
                $scope.data.gridProveedoresFicheros.ixLoadInitialData();
            }
            else {
                $scope.data.gridProveedoresFicheros.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }]
                $scope.data.gridProveedoresFicheros.ixLoadInitialData();
            }

            $scope.ixDownloadExcel = $scope.data.gridProveedoresFicheros.ixDownloadExcel;
        }, function (error) {
            ixStatusService.setResponse(error);
        });

        if ($scope.data.gridProveedoresFicheros) {
            $scope.data.gridProveedoresFicheros = gridService.createGridFunctions($scope, $scope.data.gridProveedoresFicheros);
            $scope.data.gridProveedoresFicheros.ixRestoreConfig();
        }

        $scope.downloadFile = function (id) {
            var entity = "proveedores_ficheros";
            $http({
                method: 'post',
                url: cfg.baseURL + entity + '/DownloadFile?id=' + id,
                headers: { 'Content-type': 'application/pdf' },
                responseType: 'arraybuffer'
            }).then(function (r) {
                var file = new Blob([r.data], { type: r.headers('Content-type') });

                var filename = $scope.entity + ".pdf";
                if (r.headers('Content-Disposition')) {
                    filename = r.headers('Content-Disposition').split("=")[1];
                }
                saveAs(file, filename);
            },
                function (err) {
                    ixStatusService.setResponse(err);
                });
        };

        $scope.downloadMultiFile = function () {
            var lineasSeleccionadas = $scope.data.gridProveedoresFicheros.gridApi.selection.getSelectedRows();
            var lista = [];
            lineasSeleccionadas.forEach(function(row){
                lista.push(row.id);
            });

            var config = { responseType: 'arraybuffer' };
            $http.post(cfg.baseURL + "proveedores_ficheros/DescargaMultiple", lista, config).then(function (response) {
                var file = new Blob([response.data], { type: 'application/zip' });
            
                  var filename = "ficheros_ft.zip";
                  if (response.headers('Content-Disposition')) {
                    filename = response.headers('Content-Disposition').split("=")[1];
                  }
                  saveAs(file, filename);
            },
            function (err) {
                    ixStatusService.setResponse(err);
                });
        };


        /* **** FUNCTION: IXFILTRAR **** */
        $scope.ixFiltrar = function () {
            var usuario = authService.authentication.userName;

            $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
                //asignar cliente
                $scope.extranetUser = response.data;
                //En funcion de si es cliente o no aplicamos el filtro de cliente o no
                if ($scope.extranetUser.cliente != null) {
                    $scope.data.filtro.cliente = $scope.extranetUser.cliente;
                    $scope.data.gridProveedoresFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes']);
                    $scope.data.gridProveedoresFicheros.ixLoadInitialData();
                }
                else {
                    $scope.data.gridProveedoresFicheros.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }]
                    $scope.data.gridProveedoresFicheros.ixLoadInitialData();
                }

                $scope.ixDownloadExcel = $scope.data.gridProveedoresFicheros.ixDownloadExcel;
            }, function (error) {
                ixStatusService.setResponse(error);
            });
        }

        $scope.ixEditar = $scope.data.gridProveedoresFicheros.ixEditar;
        // $scope.ixCancelEdit = function () {
        //     $scope.data.gridProveedoresFicheros.ixCancelEdit();
        //     ixStatusService.setEditing(false);
        // };

        $scope.ixCancelEdit = $scope.data.gridProveedoresFicheros.ixCancelEdit;

        /* *** FUNCTION IXGUARDAR **** */
        $scope.ixGuardar = $scope.data.gridProveedoresFicheros.ixGuardar;
        // $scope.ixGuardar = function(){
        //     var bulkParam = $scope.data.gridProveedoresFicheros.ixGetBulkParam();

        //     $http.put(cfg.baseURL + "listado_proveedores_ficherosVM/ActualizarComentarioVerificacion",bulkParam).then(function(r){
        //         ixStatusService.setResponse(r);
        //         $scope.data.gridProveedoresFicheros.clearGridAfterSave();
        //     },function(error){
        //         ixStatusService.setResponse(error);
        //     });


        //     // $scope.data.gridProveedoresFicheros.insertedRows = [];
        //     // $scope.data.gridProveedoresFicheros.deletedRows = [];
        //     // $scope.data.gridProveedoresFicheros.updatedRows = [];
        //     ixStatusService.setEditing(false);
        // }
    }

    $scope.$on('destroy', function () {
        if ($scope.data.gridProveedoresFicheros)
            $scope.data.gridProveedoresFicheros.ixSaveConfig();
    });
}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
"use strict";

angular.module('FTBase').controller('Listado_Productos_MarcaController', ['$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', '$location', 'authService', function ($scope, ixUtilsService, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, $location, authService) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.extranetUser = {};
  $scope.extranetUser.cliente = null;


  $scope.gridManualLoad = true;

  if (!$scope.data.filtro) $scope.data.filtro = {};

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {


    var usuario = authService.authentication.userName;

    $scope.esClienteDM = function () {
      if ($scope.extranetUser.cliente == 1031 && !$scope.esPerfilVisitante())
        return true;
      else
        return false;
    };


    $scope.tienePerfilAdmin = authService.tienePerfilAdmin;
    // $scope.esCliente = function (cell) {
    //   if ($scope.extranetUser.cliente)
    //     return true;
    //   else
    //     return false;
    // }

    $scope.esPerfilVisitante = function () {
      var esVisitante = false;
      var perfilesUsuario = authService.perfilesUsuario();

      angular.forEach(perfilesUsuario, function (perfil) {
        if (perfil == "usr_visitante")
          esVisitante = true;
      });
      return esVisitante;
    }

    $scope.filterStatus = { isCollapsed: true };

    if (!$scope.data.gridProductosMarca) {
      var acciones = [
      ];
      var metadata = [

      ];

      $scope.data.gridProductosMarca = gridService.createGrid($scope, 'productos_marca_grid', { metadata: metadata, enableCellEdit: false }, 'listado_productos_marcaVM'/*, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]*/);
    }
    else {
      $scope.data.gridProductosMarca = gridService.createGridFunctions($scope, $scope.data.gridProductosMarca);
      $scope.data.gridProductosMarca.ixRestoreConfig();
    }

    $scope.ixDownloadExcel = $scope.data.gridProductosMarca.ixDownloadExcel;

    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.extranetUser = response.data;
      if ($scope.extranetUser.cliente != null || $scope.esPerfilVisitante()) {
        $scope.filterStatus.isCollapsed = false;
        if ($scope.extranetUser.cliente != null)
          $scope.data.filtro.propietario = $scope.extranetUser.cliente;
        $scope.ixFiltrar();
      }
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.$on("$destroy", function () {
      $scope.data.gridProductosMarca.ixSaveConfig();
      $scope.isDestroyed = true;
    });

  }

  /* **** FUNCTION: IXFILTRAR **** */
  $scope.ixFiltrar = function () {
    $scope.filterStatus.isCollapsed = true;
    $scope.data.gridProductosMarca.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["propietario", "asociados"]);
    $scope.data.gridProductosMarca.ixLoadInitialData();

    $scope.status.filtered = false;
  }

  $scope.calcularAlturaDisponible = function () {
    var css = {};
    if ($scope.filterStatus.isCollapsed) {
      var alturaCortinaFiltros = angular.element('.ixFilter')[0].offsetHeight;
      css.height = 'calc(100vh - ' + (180 + alturaCortinaFiltros) + 'px)';
    }
    else
      css.height = 'calc(100vh - 220px)';
    return css;
  };

  $scope.$watch('data.filtro', function () {
    if ($scope.data.gridProductosMarca)
      ixUtilsService.showGrid($scope.data.gridProductosMarca);
  });

}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller('Listado_Productos_FtController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'authService', 'ixUtilsService', '$translate', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, authService, ixUtilsService, $translate) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.data.activeTab = 0;

  $scope.gridManualLoad = true;

  $scope.ocultarSelAsociados = true;

  if (!$scope.data.filtro) $scope.data.filtro = {};

  if (angular.isUndefined($scope.filterStatus))
    $scope.filterStatus = { isCollapsed: true };

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {

    var usuario = authService.authentication.userName;

    //Get condition user
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.data.extranetUser = response.data;
      //El selector de cliente asociado será solo visible para DM y Biotecnal
      if ($scope.data.extranetUser.cliente == 1031 || !($scope.data.extranetUser.laboratorio || $scope.data.extranetUser.proveedor || $scope.data.extranetUser.cliente))
        $scope.ocultarSelAsociados = false;
      if ($scope.data.extranetUser.proveedor || $scope.data.extranetUser.laboratorio || $scope.modificacionesRestringidas()) {
        //El botón editar se muestra sólo en el caso de usuarios cliente o admin
        //nop
      }
      else {
        $scope.ixEditar = function () {
          ixStatusService.setEditing(true);
        };
      }
      $scope.cargarGrid();
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.displayInformationPopup = function () {
      $scope.informativeDialog = $ngConfirm({
        icon: 'fa fa-info',
        title: '<translate>Información</translate>',
        content: '<translate>Se está generando la estructura necesaria para realizar la traducción. Cuándo haya terminado serás redireccionado al modo traducción de la ficha técnica.<translate>',
        scope: $scope,
        buttons: {
          close: {
            text: "Cerrar"
          }
        }
      });
    };

    $scope.crearTraduccionesFaltantes = function (id_ficha_tecnica, idioma) {
      $scope.displayInformationPopup();
      return $http.post(cfg.baseURL + "extranet_fichas_tecnicas_idioma/CreateTraduccionesFaltantes?id=" + id_ficha_tecnica + "&idioma=" + idioma);
    };

    $scope.openAppFT = function (entity, idioma, modo_traduccion) {
      var app = {};
      app.icon = 'perm_device_information';

      if ((entity.idioma) && entity.idioma != idioma)
        app.display = 'Modo Traducción ' + idioma.toUpperCase();
      else
        app.display = 'Datos Ficha Técnica';

      app.href = "GestionFichasTecnicas/list";
      app.atributos = { id_ficha_tecnica: entity.id_ficha_tecnica,pantalla: "ListadosFT/Listado_ProductosFt"  };
      app.multiple = true;

      if ((entity.idioma) && entity.idioma != idioma) {
        app.atributos.idioma = idioma;
      }

      if (angular.isDefined($scope.informativeDialog))
        $scope.informativeDialog.close();

      ixStatusService.openApp(app).bind(ixStatusService);
    };

    $scope.cargarGrid = function () {
      var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-ok': (col.colDef.field == 'revision_etiquetado' && row.entity.revision_etiquetado == 'OK'), 'row-alarm': (col.colDef.field == 'revision_etiquetado' && row.entity.revision_etiquetado == 'PENDIENTE'),'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
      if (!$scope.data.gridProductosFt) {
        var acciones = [
          {
            titleFunction: function (entity) {
              var title = $translate.instant("Datos Ficha Técnica");
              if ((entity.idioma) && entity.idioma.toUpperCase() != "ES")
                title = $translate.instant("Modo Traducción");
              return title;
            },
            icon: 'assets/images/flags/es.png',
            customType: true,
            getStyle: function (entity) {
              return {
                "position": "relative",
                "top": "-1px",
                "margin": "0 3px"
              };
            },
            visible: function (entity) {
              if (angular.isDefined(entity)) {
                if (entity.idioma == null) return false;
                return entity.traducible || entity.idioma.toUpperCase() == "ES";
              }
              return false;
            },
            accion: function (entity) {
              var idiomaDistinto = ((entity.idioma) && entity.idioma.toUpperCase() != "ES");
              if (idiomaDistinto && entity.traducible) {
                $scope.crearTraduccionesFaltantes(entity.id_ficha_tecnica, "es").then(function (response) {
                  if (response.data) {
                    if (response.data.Result)
                      $scope.openAppFT(entity, "es");
                  }
                }, function (err) {
                  ixStatusService.setResponse(err);
                });
              } else
                $scope.openAppFT(entity, "es");
            }
          },
          {
            titleFunction: function (entity) {
              var title = "Datos Ficha Técnica";
              if ((entity.idioma) && entity.idioma.toUpperCase() != "PT")
                title = $translate.instant("Modo Traducción");
              return title;
            },
            icon: 'assets/images/flags/pt.png',
            customType: true,
            getStyle: function (entity) {
              return {
                "position": "relative",
                "top": "-1px",
                "margin": "0 3px"
              };
            },
            visible: function (entity) {
              if (angular.isDefined(entity)) {
                if (entity.idioma == null) return false;
                return entity.traducible || entity.idioma.toUpperCase() == "PT";
              }
              return false;
            },
            accion: function (entity) {
              var idiomaDistinto = (entity.idioma.toUpperCase() != "PT");
              if (idiomaDistinto && entity.traducible) {
                $scope.crearTraduccionesFaltantes(entity.id_ficha_tecnica, "pt").then(function (response) {
                  if (response.data) {
                    if (response.data.Result)
                      $scope.openAppFT(entity, "pt");
                  }
                }, function (err) {
                  ixStatusService.setResponse(err);
                });
              } else
                $scope.openAppFT(entity, "pt");
            }
          },
          {
            title: 'Descargar Ficha Técnica',
            icon: 'fa-download',
            visible: function (entity) {
              return !$scope.esPerfilLaboratorio();
            },
            accion: function (entity) {
              var template = "app/FTBase/ListadosFT/acciones/imprimir_ft_popup.html";
              var options = { controller: "ImprimirFTPopupController" };
              var params = { tipo: "FT_PRODUCTO", traducible: entity.traducible, id_ficha_tecnica: entity.id_ficha_tecnica, ean: entity.ean };

              ixUtilsService.openModalV2(template, options, "small", params);
            }
          }
        ];
        var metadata = [
          {
            Name: "estado_envio_datos_aecoc",
            NoVisible: ($scope.data.extranetUser.laboratorio)
          },
          {
            Name: "fecha_envio_datos_aecoc",
            NoVisible: ($scope.data.extranetUser.laboratorio)
          },
          {
            Name: "ultimo_comentario",
            NoVisible: ($scope.data.extranetUser.laboratorio)
          },
          {
            Name: "publicar_aecoc",
            NoVisible: ($scope.modificacionesRestringidas())
          },
          {
            Name: "marcas_asociadas",
            NoVisible: ($scope.modificacionesRestringidas())
          },
          {
            Name: "revision_etiquetado",
            NoVisible: (!$scope.tieneRevisionEtiquetadoRestringido())
          }
        ];

        $scope.data.gridProductosFt = gridService.createGrid($scope, 'productosftGrid', { metadata: metadata }, 'listado_productosVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
        $scope.data.gridProductosFt.rowTemplate = rowTemplate;
        $scope.numberOfChanges = angular.isUndefined($scope.numberOfChanges) ? $scope.data.gridProductosFt.numberOfChanges : $scope.numberOfChanges;//podem sobreescriure la funció.
      }
      else {
        $scope.data.gridProductosFt = gridService.createGridFunctions($scope, $scope.data.gridProductosFt);
        $scope.data.gridProductosFt.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.gridProductosFt.ixDownloadExcel;
    }

    $scope.ixGuardar = function () {
      var bulkParam = $scope.data.gridProductosFt.ixGetBulkParam();

      $http.put(cfg.baseURL + "listado_productosVM/MarcarEnvioAecoc", bulkParam).then(function (r) {
        ixStatusService.setResponse(r);
      }, function (error) {
        ixStatusService.setResponse(error);
      });

      ixStatusService.setEditing(false);
    };

    $scope.ixCancelEdit = function () {
      $scope.data.gridProductosFt.ixCancelEdit();
      ixStatusService.setEditing(false);
    };

    $scope.$on("$destroy", function () {
      $scope.data.gridProductosFt.ixSaveConfig();
    });
  }

  $scope.tieneRevisionEtiquetadoRestringido = function () {
    var tiene = false;
    var perfilesUsuario = authService.authentication.perfiles;
    for (var i = 0; i < perfilesUsuario.length; i++) {
        var perfil = perfilesUsuario[i];
        tiene = (perfil.indexOf("usr_cliente") != -1 || perfil.indexOf("ixnet") != -1);
        if (tiene)
            break;
    }
    return tiene;
	};

  $scope.esPerfilVisitante = function () {
    var esVisitante = false;
    var perfilesUsuario = authService.perfilesUsuario();

    angular.forEach(perfilesUsuario, function (perfil) {
      if (perfil == "usr_visitante")
        esVisitante = true;
    });
    return esVisitante;
  }

  $scope.esPerfilLaboratorio = function() {
    var esLaboratorio = false;
    var perfilesUsuario = authService.perfilesUsuario();
    angular.forEach(perfilesUsuario, function (perfil) {
      if (perfil == "usr_laboratorio")
      esLaboratorio = true;
    });
    return esLaboratorio;
  };

  $scope.esPerfilExport = function () {
    var esVisitante = false;
    var perfilesUsuario = authService.perfilesUsuario();

    angular.forEach(perfilesUsuario, function (perfil) {
      if (perfil == "usr_export")
        esVisitante = true;
    });
    return esVisitante;
  }

  $scope.modificacionesRestringidas = function () {
    var blockEditAndSensibleInfo = false;
    var perfilesUsuario = authService.perfilesUsuario();

    angular.forEach(perfilesUsuario, function (perfil) {
      if (perfil == "usr_visitante" || perfil == "usr_export" || perfil == "usr_laboratorio")
        blockEditAndSensibleInfo = true;
    });
    return blockEditAndSensibleInfo;
  }

  /* **** FUNCTION: IXFILTRAR **** */
  $scope.ixFiltrar = function () {
    angular.forEach($scope.data.filtro, function(value,key){
      if(value == null || value == undefined || value=="")
        delete $scope.data.filtro[key];
    });
    $scope.filterStatus.isCollapsed = true;

    if (!$scope.data.filtro.estado || $scope.data.filtro.estado.length == 0) {
      $scope.data.filtro.estado = ["O", "R", "A", "P", "S"];
    }

    if ($scope.data.extranetUser.laboratorio) {
      if ($scope.data.filtro.estado) {
        $scope.data.filtro.estado = $scope.data.filtro.estado.filter(function (x) { return x != "X" });
      }
    }

    $scope.data.gridProductosFt.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["tipo_ft", "estado", "marca", "proveedor", "busqueda_generica", "asociados", "exclusivas"]);
    $scope.data.gridProductosFt.ixLoadInitialData().then(function (response) {
      $scope.drawPivotProductosFt();

      if ($scope.data.activeTab == 1) {
        $timeout(function () {
          $scope.changeTab(1);
        }, 1);
      }
    });

    $scope.status.filtered = true;
  }

  if ($scope.status.filtered)
    $scope.ixFiltrar();

  /* ***** FUNCTION: CHANGETAB ***** */
  $scope.changeTab = function (idxTab) {
    $scope.data.activeTab = idxTab;
    switch (idxTab) {
      case 0:
        $timeout(function () {
          $scope.showGrid($scope.data.gridProductosFt);
        }, 400);
        break;
      case 1:
        $scope.drawPivotProductosFt();
        break;
      default:
        break;
    }
  }

  /* ***** FUNCTION: DRAWPIVOTFICHASTECNICAS ***** */
  $scope.drawPivotProductosFt = function () {
    $timeout(function () {
      var filteredRows = $scope.data.gridProductosFt.gridApi.grid.getVisibleRows().map(function (e) { return angular.copy(e.entity); });
      angular.forEach(filteredRows, function (row) {
        if (row.estado == null) {
          row.estado = "SIN ESTADO";
        }
        if (row.tipo_ft == null) {
          row.tipo_ft = "TIPO DESCONOCIDO";
        }
      });
      $scope.drawPivot("#pivotProductosFt", filteredRows, { rows: ["nombre_estado"], cols: ["descripcion_tipo_ft"] });
    }, 1);
  }

  /* ***** FUNCTION: DRAWPIVOT ***** */
  $scope.drawPivot = function (tagId, data, pivotOptionsOverride) {
    $scope.renderers = $.pivotUtilities;
    $scope.pivotData = data;
    var pivotOptionsDefault = {
      rows: [],
      cols: [],
      renderers: $.extend($.pivotUtilities.renderers, $.pivotUtilities.d3_renderers, $.pivotUtilities.c3_renderers, $.pivotUtilities.export_renderers),
      rendererName: "Table",
      derivedAttributes: addDateDeriveds(cfg, $filter, $.pivotUtilities.derivers, data)
    };

    var pivotOptions = angular.merge(pivotOptionsDefault, pivotOptionsOverride);
    angular.element(tagId).pivotUI($scope.pivotData, pivotOptions, false, "es");
  }
  //TODO: impresionMasivaFT seguramente se tiene que pasar dentro del ImprimirFTPopupController.
  //  $scope.impresionMasivaFT = function (docformat, reducido) {
  //    var params = { docformat: docformat, reducido: reducido };
  //
  //    var lista_productos = [];
  //
  //    $scope.data.gridProductosFt.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
  //      var nuevoProducto = { id_ft: row.id_ficha_tecnica, ean: row.ean };
  //      lista_productos.push(nuevoProducto);
  //    });
  //
  //    params.lista_productos = lista_productos;
  //
  //    var config = { responseType: 'arraybuffer' };
  //
  //    $http.post(cfg.baseURL + "impresos/ImpresionMasivaProductos", params, config).then(function (response) {
  //      var file = new Blob([response.data], { type: 'application/zip' });
  //
  //      var filename = "ft_analiticas.zip";
  //      if (response.headers('Content-Disposition')) {
  //        filename = response.headers('Content-Disposition').split("=")[1];
  //      }
  //      saveAs(file, filename);
  //    }, function (error) {
  //      ixStatusService.setResponse(error);
  //    });
  //
  //  }

  $scope.impresionMasivaFT = function () {
    var template = "app/FTBase/ListadosFT/acciones/imprimir_ft_popup.html";
    var options = { controller: "ImprimirFTPopupController" };
    var params = { tipo: "FT_PRODUCTO_MASIVA" };

    var lista_productos = [];

    var traducible = 1;

    $scope.data.gridProductosFt.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
      var nuevoProducto = { id_ft: row.id_ficha_tecnica, ean: row.ean };
      if (row.traducible != 1) traducible = 0;
      lista_productos.push(nuevoProducto);
    });

    params.traducible = traducible;
    params.lista_productos = lista_productos;

    if (lista_productos.length > 0)
      ixUtilsService.openModalV2(template, options, "small", params);
  };

  $scope.seleccionarRowsVisibles = function () {
    $scope.data.gridProductosFt.gridApi.grid.getVisibleRows().forEach(function (row) {
      row.entity.Selector = true;
    });
  }

  $scope.desSeleccionarRows = function () {
    $scope.data.gridProductosFt.data.forEach(function (row) {
      row.Selector = false;
    });
  }

}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
/*global CMP_GTE*/
/*global CMP_LT*/
/*global moment*/

"use strict";

angular.module('FTBase').controller('Listado_Ft_Fotos_ProductoController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'ixUtilsService', 'ixWarningsService', 'authService', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, ixUtilsService, ixWarningsService, authService) {

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    $scope.status.editing = false;

    if (!$scope.data.filtro) $scope.data.filtro = {};

    /* ***** FUNCTION: INIT ***** */
    $scope.init = function () {
        $scope.filterStatus = { isCollapsed: true };

        $scope.data.filtro.fecha_inicio = new Date('2018-08-01'); // moment().add(-3, 'months').startOf("month")._d;
        $scope.data.filtro.fecha_fin = moment()._d;

        var usuario = authService.authentication.userName;
        $scope.hideLoadFotos = authService.authentication.perfiles.some(function (e) { return e.toUpperCase().indexOf("USR_VISITANTE") !== -1; });

        $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
            $scope.extranetUser = response.data;

            if ($scope.extranetUser.cliente) {
                if ($scope.extranetUser.cliente == 1031)
                    $scope.esAdminODM = true;
                else
                    $scope.esAdminODM = false;
            }
            else {
                if (!$scope.extranetUser.laboratorio && !$scope.extranetUser.proveedor)
                    $scope.esAdminODM = true;
                else
                    $scope.esAdminODM = false;
            }

        }, function (error) {
            ixStatusService.setResponse(error);
        });

        $scope.cargarGrid = function () {
            var fecha_fin = new Date($scope.data.filtro.fecha_fin);
            fecha_fin.setDate(fecha_fin.getDate() + 1);
            fecha_fin.setHours(0, 0, 0, 0);
            if (!$scope.data.gridft_fotos_producto) {
                var acciones = [
                    {
                        title: 'Descargar fichero',
                        icon: 'fa-download',
                        accion: function (entity) {
                            $http({
                                method: 'post',
                                url: cfg.baseURL + 'ft_fotos_productos/DownloadFile?archivo_imagen=' + entity.archivo_imagen,
                                headers: { 'Content-type': 'image/jpg' },
                                responseType: 'arraybuffer'
                            }).then(function (r) {
                                var file = new Blob([r.data], { type: r.headers('Content-type') });

                                var filename = $scope.entity + ".jpg";
                                if (r.headers('Content-Disposition')) {
                                    filename = r.headers('Content-Disposition').split("=")[1];
                                }
                                saveAs(file, filename);
                            },
                                function (err) {
                                    ixStatusService.setResponse(err);
                                });
                        }
                    },
                    {
                        title: 'Eliminar imagen',
                        icon: 'fa-trash',
                        accion: function (entity) {
                            ixWarningsService.warningConfirmacion($scope, "Eliminar la imagen " + entity.archivo_imagen, $scope.eliminarImagen, undefined, entity.archivo_imagen);
                        }
                    },
                    {
                        title: 'Copiar imagen',
                        icon: 'fa-copy',
                        accion: function (entity) {
                            $scope.abrirPopupCopiarFotos(entity);
                        }
                    },
                    {
                        title: 'Asignar como principal',
                        icon: 'fa-star',
                        visible: function (entity) {
                            return !entity.principal;
                        },
                        accion: function (entity) {
                            ixWarningsService.warningConfirmacion($scope, "Marcar la imagen " + entity.archivo_imagen + " como principal?", $scope.marcarPrincipal, undefined, entity.archivo_imagen);
                        }
                    }
                ];
                var metadata = [
                    {
                        Name: "estado_envio_ftp"
                        ,
                        NoVisible: !$scope.esAdminODM
                    },
                    {
                        Name: "fecha_envio_ftp"
                        ,
                        NoVisible: !$scope.esAdminODM
                    }
                ];

                $scope.data.gridft_fotos_producto = gridService.createGrid($scope, 'ft_fotos_productoGrid', { metadata: metadata }, 'listado_ft_fotos_productoVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
                $scope.data.gridft_fotos_producto.filtroExterno = [{ Field: "fecha_carga", Operator: CMP_GTE, Value: $scope.data.filtro.fecha_inicio }, { Field: "fecha_carga", Operator: CMP_LT, Value: fecha_fin }, { Field: "busqueda_generica", Value: $scope.data.filtro.busqueda_generica, skip: true }];
            }
            else {
                $scope.data.gridft_fotos_producto = gridService.createGridFunctions($scope, $scope.data.gridft_fotos_producto);
                $scope.data.gridft_fotos_producto.ixRestoreConfig();
                $scope.data.gridft_fotos_producto.filtroExterno = [{ Field: "fecha_carga", Operator: CMP_GTE, Value: $scope.data.filtro.fecha_inicio }, { Field: "fecha_carga", Operator: CMP_LT, Value: fecha_fin }, { Field: "busqueda_generica", Value: $scope.data.filtro.busqueda_generica, skip: true }];
                $scope.data.gridft_fotos_producto.ixLoadInitialData();
            }

            $scope.ixDownloadExcel = $scope.data.gridft_fotos_producto.ixDownloadExcel;
        }

        $scope.ixFiltrar = function () {
            $scope.cargarGrid();
            // $scope.status.editing = true;
        }

        $scope.ocultaGuardar = true;

        $scope.ixCancelEdit = function () {
            $scope.data.gridft_fotos_producto.data = [];
            $scope.status.editing = false;
        };

        $scope.abrirPopupSubirFotos = function () {
            var template = "app/FTBase/ListadosFT/acciones/subir_foto_producto_popup.html";
            var optionsPopup = { controller: "SubirFotoProductoPopupController" };
            var modalSubirFotos = ixUtilsService.openModalV2(template, optionsPopup, "small");
            modalSubirFotos.then(function (response) {
                $scope.data.gridft_fotos_producto.ixLoadInitialData();
            });
        };

        $scope.abrirPopupCopiarFotos = function (entity) {
            var template = "app/FTBase/ListadosFT/acciones/copiar_foto_producto_popup.html";
            var optionsPopup = { controller: "CopiarFotoProductoPopupController" };
            var params = { eanorigen: entity.ean };
            var modalCopiarFotos = ixUtilsService.openModalV2(template, optionsPopup, "small",params);
            modalCopiarFotos.then(function (response) {
                $scope.data.gridft_fotos_producto.ixLoadInitialData();
            });
        };

        $scope.marcarPrincipal = function (nombreArchivo) {
            $http.post(cfg.baseURL + "ft_fotos_productos/MarcarPrincipal?nombreArchivo=" + nombreArchivo).then(function (response) {
                $scope.data.gridft_fotos_producto.ixLoadInitialData();
            }, function (err) {
                ixStatusService.setResponse(err);
            });
        };

        $scope.eliminarImagen = function (nombreArchivo) {
            $http.post(cfg.baseURL + "ft_fotos_productos/EliminarImagen?nombreArchivo=" + nombreArchivo).then(function (response) {
                $scope.data.gridft_fotos_producto.ixLoadInitialData();
            }, function (err) {
                ixStatusService.setResponse(err);
            });
        };

        $scope.selectVisibleRows = function () {
            $scope.data.gridft_fotos_producto.gridApi.grid.getVisibleRows().forEach(function (row) {
                row.entity.Selector = true;
            });
        };

        $scope.cleanSelectedRows = function () {
            $scope.data.gridft_fotos_producto.data.forEach(function (row) {
                row.Selector = false;
            });
        };

        $scope.getVisibleRows = function () {
            var selectedRows = [];
            if (angular.isDefined($scope.data.gridft_fotos_producto)) {
                selectedRows = $scope.data.gridft_fotos_producto.data.filter(function (e) { return e.Sel; });
            }
            return selectedRows;
        };

        $scope.downloadSelectedPictures = function () {
            var lista = [];
            $scope.data.gridft_fotos_producto.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
                lista.push(row.archivo_imagen);
            });

            if (lista.length > 0) {
                var config = { responseType: 'arraybuffer' };
                $http.post(cfg.baseURL + "ft_fotos_productos/DownloadMultipleFiles", lista, config).then(function(response){
                    var file = new Blob([response.data], { type: response.headers('Content-type') });

                    var filename = "data.zip";
                    if (response.headers('Content-Disposition')) {
                        filename = response.headers('Content-Disposition').split("=")[1];
                    }
                    saveAs(file, filename);
                },
                function(error){
                    ixStatusService.setResponse(error);
                });
            }
        };

        $scope.$on("$destroy", function () {
            $scope.data.gridft_fotos_producto.ixSaveConfig();
            $scope.isDestroyed = true;
        });

    }

}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller('Listado_FtController', ['$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', '$location', 'authService', '$translate', function ($scope, ixUtilsService, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, $location, authService, $translate) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.data.activeTab = 0;

  $scope.gridManualLoad = true;

  $scope.ocultarSelAsociados = true;


  if (!$scope.data.filtro) $scope.data.filtro = {};

  if (angular.isUndefined($scope.filterStatus))
    $scope.filterStatus = { isCollapsed: true };

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {

    var usuario = authService.authentication.userName;

    $scope.esProveedor = function (cell) {
      if ($scope.extranetUser.proveedor)
        return true;
      else
        return false;
    }

    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.extranetUser = response.data;
      if ($scope.extranetUser.laboratorio || $scope.extranetUser.proveedor || $scope.extranetUser.cliente) {
        $scope.ocultaEditar = true;
      }

      //El selector de cliente asociado será solo visible para DM y Biotecnal
      if ($scope.extranetUser.cliente == 1031 || !($scope.extranetUser.laboratorio || $scope.extranetUser.proveedor || $scope.extranetUser.cliente))
        $scope.ocultarSelAsociados = false;
      if ($scope.extranetUser.proveedor != null) {
        $scope.data.filtro.proveedor = $scope.extranetUser.proveedor;
        $scope.ixDeleteSelectedRows = undefined;
        $scope.cargarGrid();
        $scope.data.filtro.estado = ['A', 'O', 'P', 'R', 'S'];
        $scope.data.gridFichasTecnicas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["tipo_ft", "estado", "marca", "proveedor", "busqueda_generica", "asociados"]);
        $scope.status.filtered = true;
        $scope.data.gridFichasTecnicas.ixLoadInitialData();
      }
      else {
        $scope.cargarGrid();
      }
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.displayInformationPopup = function () {
      $scope.informativeDialog = $ngConfirm({
        icon: 'fa fa-info',
        title: '<translate>Información</translate>',
        content: '<translate>Se está generando la estructura necesaria para realizar la traducción. Cuándo haya terminado serás redireccionado al modo traducción de la ficha técnica.<translate>',
        scope: $scope,
        buttons: {
          close: {
            text: "Cerrar"
          }
        }
      });
    };

    $scope.crearTraduccionesFaltantes = function (id_ficha_tecnica, idioma) {
      $scope.displayInformationPopup();
      return $http.post(cfg.baseURL + "extranet_fichas_tecnicas_idioma/CreateTraduccionesFaltantes?id=" + id_ficha_tecnica + "&idioma=" + idioma);
    };

    $scope.openAppFT = function (entity, idioma, modo_traduccion) {
      var app = {};
      app.icon = 'perm_device_information';

      if (angular.isArray(entity)) {

        var id_fichas_tecnicas = entity.map(function (e) { return e.id_ficha_tecnica; });

        app.display = 'Datos Ficha Técnica';
        app.href = "GestionFichasTecnicas/list";
        app.atributos = { id_fichas_tecnicas: id_fichas_tecnicas,pantalla: "ListadosFT/Listado_Ft" };
        app.multiple = true;
        app.atributos.idioma = idioma;
      } else {
        if ((entity.idioma) && entity.idioma != idioma)
          app.display = 'Modo Traducción ' + idioma.toUpperCase();
        else
          app.display = 'Datos Ficha Técnica';

        app.href = "GestionFichasTecnicas/list";
        app.atributos = { id_ficha_tecnica: entity.id_ficha_tecnica,pantalla: "ListadosFT/Listado_Ft" };
        app.multiple = true;

        if ((entity.idioma) && entity.idioma != idioma) {
          app.atributos.idioma = idioma;
        }
      }

      if (angular.isDefined($scope.informativeDialog))
        $scope.informativeDialog.close();

      ixStatusService.openApp.bind(ixStatusService)(app);
    };

    $scope.tienePerfilAdmin = authService.tienePerfilAdmin;

    $scope.cargarGrid = function () {
      var rowTemplate = "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'row-ok': (col.colDef.field == 'revision_etiquetado' && row.entity.revision_etiquetado == 'OK'), 'row-alarm': (col.colDef.field == 'revision_etiquetado' && row.entity.revision_etiquetado == 'PENDIENTE'),'ui-grid-row-header-cell': col.isRowHeader, 'left-markup': grid.appScope.leftMarkup(), 'highlight': row.estaSeleccionado == true, 'CellRequired': ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
      if (!$scope.data.gridFichasTecnicas) {
        var acciones = [
          {
            titleFunction: function (entity) {
              var title = $translate.instant("Datos Ficha Técnica");
              if ((entity.idioma) && entity.idioma.toUpperCase() != "ES")
                title = $translate.instant("Modo Traducción");
              return title;
            },
            icon: 'assets/images/flags/es.png',
            customType: true,
            getStyle: function (entity) {
              return {
                "position": "relative",
                "top": "-1px",
                "margin": "0 3px"
              };
            },
            visible: function (entity) {
              if (angular.isDefined(entity)) {
                if (entity.idioma == null) return false;
                return entity.traducible || entity.idioma.toUpperCase() == "ES";
              }

              return false;
            },
            accion: function (entity) {
              var idiomaDistinto = ((entity.idioma) && entity.idioma.toUpperCase() != "ES");
              if (idiomaDistinto && entity.traducible) {
                $scope.crearTraduccionesFaltantes(entity.id_ficha_tecnica, "es").then(function (response) {
                  if (response.data) {
                    if (response.data.Result)
                      $scope.openAppFT(entity, "es");
                  }
                }, function (err) {
                  ixStatusService.setResponse(err);
                });
              } else
                $scope.openAppFT(entity, "es");
            }
          },
          {
            titleFunction: function (entity) {
              var title = $translate.instant("Datos Ficha Técnica");
              if ((entity.idioma) && entity.idioma.toUpperCase() != "PT")
                title = $translate.instant("Modo Traducción");
              return title;
            },
            icon: 'assets/images/flags/pt.png',
            customType: true,
            getStyle: function (entity) {
              return {
                "position": "relative",
                "top": "-1px",
                "margin": "0 3px"
              };
            },
            visible: function (entity) {
              if (angular.isDefined(entity)) {
                if (entity.idioma == null) return false;
                return entity.traducible || entity.idioma.toUpperCase() == "PT";
              }
              return false;
            },
            accion: function (entity) {
              var idiomaDistinto = (entity.idioma.toUpperCase() != "PT");
              if (idiomaDistinto && entity.traducible) {
                $scope.crearTraduccionesFaltantes(entity.id_ficha_tecnica, "pt").then(function (response) {
                  if (response.data) {
                    if (response.data.Result)
                      $scope.openAppFT(entity, "pt");
                  }
                }, function (err) {
                  ixStatusService.setResponse(err);
                });
              } else
                $scope.openAppFT(entity, "pt");
            }
          },
          {
            title: 'Descargar Ficha Técnica',
            icon: 'fa-download',
            accion: function (entity) {
              var template = "app/FTBase/ListadosFT/acciones/imprimir_ft_popup.html";
              var options = { controller: "ImprimirFTPopupController" };
              var params = { tipo: "FT", traducible: entity.traducible, id_ficha_tecnica: entity.id_ficha_tecnica };

              ixUtilsService.openModalV2(template, options, "small", params);
            }
          }
        ];
        var metadata = [
          {
            Name: "revision_inicial",
            NoVisible: ($scope.extranetUser.cliente || $scope.extranetUser.laboratorio || $scope.extranetUser.proveedor)
          },
          {
            Name: "revision_final",
            NoVisible: ($scope.extranetUser.cliente || $scope.extranetUser.laboratorio || $scope.extranetUser.proveedor)
          },
          {
            Name: "notificacion_proveedor",
            NoVisible: ($scope.extranetUser.cliente || $scope.extranetUser.laboratorio || $scope.extranetUser.proveedor)
          },
          {
            Name: "ultimo_comentario",
            NoVisible: ($scope.extranetUser.laboratorio || $scope.extranetUser.proveedor)
          },
          {
            Name: "ultimo_estado_prov_ok_fecha",
            NoVisible: (!$scope.tienePerfilAdmin())
          },
          {
            Name: "ultimo_comentario_interno",
            NoVisible: (!$scope.tienePerfilAdmin())
          },
          {
            Name: "revisor_FT",
            NoVisible: (!$scope.tienePerfilAdmin())
          }
          ,
          {
            Name: "revision_etiquetado",
            NoVisible: (!$scope.tieneRevisionEtiquetadoRestringido())
          }
        ];

        if(cfg.appCliente == "ALCAMPO"){
          metadata.push({ Name: "mercado", NoVisible: false });
          metadata.push({ Name: "cumplimentada", NoVisible: true });
          metadata.push({ Name: "desc_estado", NoVisible: true });
          metadata.push({ Name: "fecha", NoVisible: true });
          metadata.push({ Name: "fecha_aprobada", NoVisible: true });
          metadata.push({ Name: "fecha_revision", NoVisible: true });
          metadata.push({ Name: "revisor_FT", NoVisible: true });
        }

        $scope.data.gridFichasTecnicas = gridService.createGrid($scope, 'ftGrid', { metadata: metadata, enableCellEdit: false }, 'listado_ftVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }, { name: 'Sel', type: 'CheckBox', NoEditable: function () { return false; } }]);
        $scope.data.gridFichasTecnicas.rowTemplate = rowTemplate;
        //$scope.data.gridFichasTecnicas.onRegisterApi($scope.gridApi);
        //$scope.data.gridFichasTecnicas.gridApi.core.refresh();
      }
      else {
        $scope.data.gridFichasTecnicas = gridService.createGridFunctions($scope, $scope.data.gridFichasTecnicas);
        $scope.data.gridFichasTecnicas.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.gridFichasTecnicas.ixDownloadExcel;
    }
  } //END INIT function

  $scope.tieneRevisionEtiquetadoRestringido = function () {
    var tiene = false;
    var perfilesUsuario = authService.authentication.perfiles;
    for (var i = 0; i < perfilesUsuario.length; i++) {
        var perfil = perfilesUsuario[i];
        tiene = (perfil.indexOf("usr_cliente") != -1 || perfil.indexOf("ixnet") != -1);
        if (tiene)
            break;
    }
    return tiene;
	};

  /* **** FUNCTION: IXFILTRAR **** */
  $scope.ixFiltrar = function () {
    angular.forEach($scope.data.filtro, function(value,key){
      if(value == null || value == undefined || value =="")
        delete $scope.data.filtro[key];
    });
    $scope.filterStatus.isCollapsed = true;
    if (!$scope.data.filtro.estado || $scope.data.filtro.estado.length == 0) { //$scope.isEmpty($scope.data.filtro)
      $scope.data.filtro.estado = ['A', 'O', 'P', 'R', 'S'];
    }
    $scope.data.gridFichasTecnicas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["tipo_ft", "estado", "marca", "proveedor", "busqueda_generica", "asociados"]);
    $scope.data.gridFichasTecnicas.ixLoadInitialData().then(function (response) {
      $scope.drawPivotFichasTecnicas();

      if ($scope.data.activeTab == 1) {
        $timeout(function () {
          $scope.changeTab(1);
        }, 1);
      }
    });

    $scope.status.filtered = true;
  }

  if ($scope.status.filtered)
    $scope.ixFiltrar();

  /* ***** FINCTION: ISEMPTY  ***** */
  $scope.isEmpty = function (obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }

    return true;
  };


  $scope.getSelectedRows = function () {
    var selectedRows = [];
    if (angular.isDefined($scope.data.gridFichasTecnicas)) {
      selectedRows = $scope.data.gridFichasTecnicas.data.filter(function (e) { return e.Sel; });
    }
    return selectedRows;
  };
  $scope.abrirMultiplesFichasTecnicas = function () {
    var fichas_tecnicas = $scope.getSelectedRows();
    if (fichas_tecnicas.length > 0)
      $scope.openAppFT(fichas_tecnicas);
  };

  /* ***** FUNCTION: CHANGETAB ***** */
  $scope.changeTab = function (idxTab) {
    $scope.data.activeTab = idxTab;
    switch (idxTab) {
      case 0:
        $timeout(function () {
          $scope.showGrid($scope.data.gridFichasTecnicas);
        }, 400);
        break;
      case 1:
        $scope.drawPivotFichasTecnicas();
        break;
      default:
        break;
    }
  }

  /* ***** FUNCTION: DRAWPIVOTFICHASTECNICAS ***** */
  $scope.drawPivotFichasTecnicas = function () {
    $timeout(function () {
      var filteredRows = $scope.data.gridFichasTecnicas.gridApi.grid.getVisibleRows().map(function (e) { return angular.copy(e.entity); });
      angular.forEach(filteredRows, function (row) {
        if (row.estado == null) {
          row.estado = "SIN ESTADO";
        }
        if (row.tipo_ft == null) {
          row.tipo_ft = "TIPO DESCONOCIDO";
        }
      });
      $scope.drawPivot("#pivotFichasTecnicas", filteredRows, { rows: ["desc_estado"], cols: ["tipo_ft"] });
    }, 1);
  }

  /* ***** FUNCTION: DRAWPIVOT ***** */
  $scope.drawPivot = function (tagId, data, pivotOptionsOverride) {
    $scope.renderers = $.pivotUtilities;
    $scope.pivotData = data;
    var pivotOptionsDefault = {
      rows: [],
      cols: [],
      renderers: $.extend($.pivotUtilities.renderers, $.pivotUtilities.d3_renderers, $.pivotUtilities.c3_renderers, $.pivotUtilities.export_renderers),
      rendererName: "Table",
      derivedAttributes: addDateDeriveds(cfg, $filter, $.pivotUtilities.derivers, data)
    };

    var pivotOptions = angular.merge(pivotOptionsDefault, pivotOptionsOverride);
    angular.element(tagId).pivotUI($scope.pivotData, pivotOptions, false, "es");
  }

  /* ***** FUNTION: OPEN POPUP TO ADD A BRAND NEW FT ***** */
  $scope.openAddFtPopup = function () {
    var template = "app/FTBase/ListadosFT/acciones/add_ft_popup.html";
    var optionsPopup = { controller: "AddFtPopupController" };
    var modalAdd = ixUtilsService.openModalV2(template, optionsPopup, "small");
    modalAdd.then(function (response) {
      $log.log(response);
      if (response) {
        var app = {};
        app.icon = "list";
        app.display = "Ficha técnica";
        app.href = "GestionFichasTecnicas/list";
        app.atributos = { id_ficha_tecnica: response };
        $timeout(function () {
          ixStatusService.openApp(app).bind(ixStatusService);
        }, 1);
      }
    });
  }

  $scope.ixEditar = function () {
    //$scope.status.editing = true;
    ixStatusService.setEditing(true);
  }

  $scope.ixCancelEdit = function () {
    $scope.data.gridFichasTecnicas.ixCancelEdit();
  }

  $scope.ixDeleteSelectedRows = function () {
    $scope.data.gridFichasTecnicas.ixDeleteSelectedRows();
  }

  $scope.ixGuardar = function () {
    $scope.data.gridFichasTecnicas.ixGuardar();
  }

  $scope.EliminarFtObsoletas = function () {
    $log.log("EliminarFtObsoletas llamada...");
    $http.get(cfg.baseURL + "extranet_fichas_tecnicas/EliminarFTObsoletas").then(function (response) {
      $log.log(response);
    },
      function (error) {
        $log.error(error);
      });
  }

  $scope.Herramientas = function () {
    var tipo = "";
    var unico = true;
    if ($scope.data.gridFichasTecnicas && $scope.data.gridFichasTecnicas.gridApi ) {
        var selectedRows = $scope.data.gridFichasTecnicas.gridApi.selection.getSelectedRows();
        selectedRows.forEach(function (row) {
          if (tipo != row.tipo_ft && (tipo || tipo.trim().length > 0)) unico = false;
          tipo = row.tipo_ft;
        })
    }
    return unico;
  }

  $scope.VersionarMasivamente = function () {
    var selectedRows = $scope.data.gridFichasTecnicas.gridApi.selection.getSelectedRows();
    var id_ficha_tecnicas = [];
    selectedRows.forEach(function (row) {
      id_ficha_tecnicas.push(row.id_ficha_tecnica)
    })

    var template = "app/FTBase/ListadosFT/acciones/versionar_masivamente_popup.html";
    var options = { controller: "VersionarMasivamentePopupController" };
    var params = { id_ficha_tecnicas: id_ficha_tecnicas };
    ixUtilsService.openModalV2(template, options, "small", params).then(function (response) {
      var responseObj = {
        status: 200,
        data: {
          Result: true,
          GlobalMessage: {
            ErrType: 0,
            Msg: response.data,
            Property: null,
            TypeOfError: 0
          }
        }
      }
      $ngConfirm({
        title: "Versionar masivamente",
        content: responseObj.data.GlobalMessage.Msg.replace(/\r\n/g, '<br>')
      });
      ixStatusService.setResponse(responseObj);
    });
  };

  $scope.DesbloquearMasivamente = function () {
    var selectedRows = $scope.data.gridFichasTecnicas.gridApi.selection.getSelectedRows();
    var id_ficha_tecnicas = [];
    selectedRows.forEach(function (row) {
      id_ficha_tecnicas.push(row.id_ficha_tecnica)
    })
    var nombretipo = selectedRows[0].tipo_ft;
    var params = buildIxSearch();
    params.Filters.push({ Field: "nombre", Value: nombretipo, Operator: CMP_EQ });
    $http.post(cfg.baseURL + "ft_versiones/Search", params).then(function (response) {
      if (response.data.Items.length == 0 || response.data.Items.length > 1) {
        var responseObj = {
          status: 400,
          data: {
            Result: true,
            GlobalMessage: {
              ErrType: 0,
              Msg: "El tipo de versión no existe o existe más de uno con el mismo nombre.",
              Property: null,
              TypeOfError: 0
            }
          }
        }
        ixStatusService.setResponse(responseObj);
      } else {
        var template = "app/FTBase/ListadosFT/acciones/desbloquear_masivamente_popup.html";
        var options = { controller: "DesbloquearMasivamentePopupController" };
        var params = { id_ficha_tecnicas: id_ficha_tecnicas, tipoFT: response.data.Items[0].version };
        ixUtilsService.openModalV2(template, options, "small", params).then(function (response) {
          var responseObj = {
            status: 200,
            data: {
              Result: true,
              GlobalMessage: {
                ErrType: 0,
                Msg: response.data.replace(/\r\n/g, '<br>'),
                Property: null,
                TypeOfError: 0
              }
            }
          }
          $ngConfirm({
            title: "Bloquear/Desbloquear masivamente",
            content: responseObj.data.GlobalMessage.Msg
          });
          ixStatusService.setResponse(responseObj);
        });
      }
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  };

  $scope.$on("$destroy", function () {
    $scope.data.gridFichasTecnicas.ixSaveConfig();
  });
}]);

/*global ixFiltersToArray*/
/*global saveAs*/

angular.module('FTBase').controller('Listado_emd_fichas_seguridadController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'authService', 'ixUtilsService','$translate', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, authService, ixUtilsService, $translate) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;

  $scope.ocultarSelAsociados = true;
  if (!$scope.data.filtro) $scope.data.filtro = {};

  if(angular.isUndefined($scope.filterStatus))
		$scope.filterStatus = { isCollapsed: true };

    /* ***** FUNCTION: INIT ***** */
  $scope.init = function (){
    var usuario = authService.authentication.userName;

    $scope.data.filtro.vigentes = true;

    //Get condition user
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.data.extranetUser = response.data;
      //El selector de cliente asociado será solo visible para DM y Biotecnal
      if ($scope.data.extranetUser.cliente == 1031 || !($scope.data.extranetUser.laboratorio || $scope.data.extranetUser.proveedor || $scope.data.extranetUser.cliente))
        $scope.ocultarSelAsociados = false;

      $scope.cargarGrid();
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.cargarGrid = function (){
      if (!$scope.data.gridFicheros){
        var acciones = [
          {
            title: "Previsualizar PDF",
            icon: "fa-file-pdf-o",
            visible: function (entity) {
              return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
            },
            accion: function (entity) {
              $http({
                method: 'post',
                url: cfg.baseURL + 'fichas_tecnicas_ficheros/DownloadFile?id=' + entity.id,
                headers: {},
                responseType: 'arraybuffer'
              }).then(function (r) {
                $scope.selectedPDF = new Uint8Array(r.data);
                $scope.idFicheroPreview = entity.id;
                var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
                ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
              },
                function (err) {
                  ixStatusService.setResponse(err);
                });
            }
          },
          {
            title: 'Descargar informes',
            icon: 'fa-download',
            visible: function (entity) {
              return true;
            },
            accion: function (entity) {
                $scope.descargarArchivo(entity.id);
            }
          }
        ];
        var metadata = [];

        $scope.data.gridFicheros = gridService.createGrid($scope, 'ficherosSeguridadGrid', { metadata: metadata }, 'listado_euromadi_fichas_seguridadVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
        $scope.data.gridFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["vigentes", "exclusivas", "proveedores", "tipos_ficheros", "asociados"]);
      }
      else {
        $scope.data.gridFicheros = gridService.createGridFunctions($scope, $scope.data.gridFicheros);
      }

      $scope.ixDownloadExcel = $scope.data.gridFicheros.ixDownloadExcel;
      $scope.data.gridFicheros.ixLoadInitialData();
    };

  };

  // if($scope.status.filtered)
  //   $scope.ixFiltrar();

  /* **** FUNCTION: IXFILTRAR **** */
  $scope.ixFiltrar = function () {
    $scope.filterStatus.isCollapsed = true;

    $scope.data.gridFicheros.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["vigentes", "exclusivas", "proveedores", "tipos_ficheros", "asociados"]);
    $scope.data.gridFicheros.ixLoadInitialData();

    $scope.status.filtered = false;
  };

  $scope.descargarArchivo = function(idf){
    $http({
			method: 'post',
			url: cfg.baseURL + 'fichas_tecnicas_ficheros/DownloadFile?id=' + idf,
			headers: { 'Content-type': 'application/pdf' },
			responseType: 'arraybuffer'
		}).then(function (r) {
			var file = new Blob([r.data], { type: r.headers('Content-type') });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		},
			function (err) {
				ixStatusService.setResponse(err);
			});
  };


  $scope.seleccionarRowsVisibles = function () {
    $scope.data.gridFicheros.gridApi.grid.getVisibleRows().forEach(function (row) {
      row.entity.Selector = true;
    });
  };


  $scope.borrarSeleccionRows = function () {
    $scope.data.gridFicheros.data.forEach(function (row) {
      row.Selector = false;
    });
  };


  $scope.descargaMasivaArchivos = function () {
    var lista = [];

    $scope.data.gridFicheros.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
      lista.push(row.id);
    });

    var config = { responseType: 'arraybuffer' };

    $http.post(cfg.baseURL + "fichas_tecnicas_ficheros/DescargaMultiple", lista, config).then(function (response) {
      var file = new Blob([response.data], { type: 'application/zip' });

      var filename = "ficheros_ft.zip";
      if (response.headers('Content-Disposition')) {
        filename = response.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    }, function (error) {
      ixStatusService.setResponse(error);
    });
  };


}]);
/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller('Listado_control_envio_obs_alergenos_appController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'ixUtilsService', 'ixWarningsService', 'authService', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, ixUtilsService, ixWarningsService, authService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  // $scope.status.editing = false;

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function (){
    $scope.cargarGrid = function (){
      if (!$scope.data.grid_envio_obs){
        // var acciones = [];
        // var metadata = [];
        $scope.data.grid_envio_obs = gridService.createGrid($scope, 'control_envio_obs_appGrid', {}, 'list_envio_obs_alergenosVM' /*, [{ name: 'Acciones', type: 'detalle', acciones: acciones }] */);
        $scope.numberOfChanges = angular.isUndefined($scope.numberOfChanges) ? $scope.data.grid_envio_obs.numberOfChanges : $scope.numberOfChanges;//podem sobreescriure la funció.
      }
      else{
        $scope.data.grid_envio_obs = gridService.createGridFunctions($scope, $scope.data.grid_envio_obs);
        $scope.data.grid_envio_obs.ixRestoreConfig();
      }

      $scope.ixEditar = function(){
      		ixStatusService.setEditing(true);
    	};

      $scope.ixGuardar = function(){
        var bulkParam = $scope.data.grid_envio_obs.ixGetBulkParam();

        $http.put(cfg.baseURL + "list_envio_obs_alergenosVM/MarcarEnvioObs",bulkParam).then(function(r){
          ixStatusService.setResponse(r);
        },function(error){
          ixStatusService.setResponse(error);
        });

        ixStatusService.setEditing(false);
      };

      $scope.ixCancelEdit = function(){
        $scope.data.grid_envio_obs.ixCancelEdit();
        ixStatusService.setEditing(false);
      };


      // $scope.ixDownloadExcel = $scope.data.grid_envio_obs.ixDownloadExcel;
    };

    $scope.cargarGrid();

		$scope.$on("$destroy", function() {
			$scope.data.grid_envio_obs.ixSaveConfig();
			$scope.isDestroyed=true;
		});
  };

}]);

/*global ixFiltersToArray*/
"use strict";

//[ '$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', '$location', 'authService', function($scope, ixUtilsService, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, $location, authService){
angular.module('FTBase').controller('Listado_Cambio_Estados_FtController', [ '$scope', 'ixUtilsService', 'ixStatusService', 'gridService', 'cfg', 'authService', '$http', '$filter', '$log', function($scope, ixUtilsService, ixStatusService, gridService, cfg, authService, $http, $filter, $log){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.gridManualLoad = true;
  if(!$scope.data.filtro) $scope.data.filtro = {};

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function(){
    var usuario = authService.authentication.userName;

    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function(response){
      $scope.extranetUser = response.data;
    }, function(error){
      ixStatusService.setResponse(error);
    });

    $scope.filterStatus = { isCollapsed: true };

    $scope.cargarGrid = function(){
      if (!$scope.data.gridCambioEstadosFt){
				//Si no hay acciones, no hay acciones...
//        var acciones = [];
//        var metadata = [];

        $scope.data.gridCambioEstadosFt = gridService.createGrid($scope, 'cambiosEstadosFtGrid', {}, 'listado_cambio_estadosFtVM'/*, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]*/);
      }
      else {
        $scope.data.gridCambioEstadosFt = gridService.createGridFunctions($scope, $scope.data.gridCambioEstadosFt);
        $scope.data.gridCambioEstadosFt.ixRestoreConfig();
      }
    };

    $scope.cargarGrid();
    $scope.ixDownloadExcel = $scope.data.gridCambioEstadosFt.ixDownloadExcel;

		$scope.$on("$destroy", function() {
			$scope.data.gridCambioEstadosFt.ixSaveConfig();
			$scope.isDestroyed=true;
		});
  }
  /* ***** END FUNCTION: INIT ***** */

  /* ***** FUNCTION: IXFILTRAR ***** */
  $scope.ixFiltrar = function() {
    $scope.filterStatus.isCollapsed = true;
    $scope.data.gridCambioEstadosFt.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["proveedor", "fecha_inicio","fecha_fin" ]);
    $scope.data.gridCambioEstadosFt.ixLoadInitialData();

    // $scope.showGrid($scope.data.gridCambioEstadosFt);

    $scope.status.filtered = false;
  }
  /* ***** END FUNCTION: IXFILTRAR ***** */
}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
/*global moment*/
"use strict";

angular.module('FTBase').controller('Listado_Analiticas_FTController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', '$log', '$ngConfirm', 'ixUtilsService', 'ixWarningsService', 'authService', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, $log, $ngConfirm, ixUtilsService, ixWarningsService, authService) {

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    $scope.status.editing = false;
    $scope.gridManualLoad = true;

    $scope.ocultarSelAsociados = true;

    var current_year = moment().format('YYYY');
    if (!$scope.data.filtro) $scope.data.filtro = {
        start_month: 1,
        start_year: current_year
    };

    /* ***** FUNCTION: INIT ***** */
    $scope.init = function () {

        var usuario = authService.authentication.userName;

        $scope.esAdmin = function () {
            if ($scope.extranetUser.cliente || $scope.extranetUser.laboratorio || $scope.extranetUser.proveedor)
                return false;
            else
                return true;
        }

        $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
            $scope.extranetUser = response.data;
            //El selector de cliente asociado será solo visible para DM y Biotecnal
            if ($scope.extranetUser.cliente == 1031 || !($scope.extranetUser.laboratorio || $scope.extranetUser.proveedor || $scope.extranetUser.cliente))
                $scope.ocultarSelAsociados = false;
            $scope.cargarGrid();
        }, function (error) {
            ixStatusService.setResponse(error);
        });

        $scope.filterStatus = { isCollapsed: true };

        if ($scope.data.gridft_analiticas)
            $scope.ixDownloadExcel = $scope.data.gridft_analiticas.ixDownloadExcel;

        $scope.cargarGrid = function () {
            if (!$scope.data.gridft_analiticas) {
                var acciones = [
                    {
                        title: 'Ver editar',
                        icon: 'fa-pencil',
                        visible: function (entity) {
                            return true;
                        },
                        accion: function (entity) {
                            $scope.abrirPopupAnalitica(false, entity.id, entity.marca, entity.proveedor, entity.titulo, entity.cod_interno, entity.fecha_realizacion, entity.informe_analisis, entity.informe_etiquetado, entity.informe_posicionamiento);
                            $scope.data.gridft_analiticas.ixSaveConfig();
                        }
                    },
                    {
                        title: 'Descargar informes',
                        icon: 'fa-download',
                        visible: function (entity) {
                            return $scope.tieneFichero(entity);
                        },
                        accion: function (entity) {
                            $scope.descargarArchivos(entity.id);
                        }
                    },
                    {
                        title: 'Corregir analitica',
                        icon: 'fa-check',
                        visible: function (entity) {
                            return $scope.extranetUser.laboratorio && entity.estado == "FINALIZADO";
                        },
                        accion: function (entity) {
                            $scope.corregirAnalitica(entity.id);
                        }
                    },
                    {
                        title: 'Reactivar',
                        icon: 'fa-undo',
                        visible: function (entity) {
                            return ($scope.esAdmin() && (entity.estado == "FINALIZADO" || entity.estado == "FINALIZADO-CORREGIDO"));
                        },
                        accion: function (entity) {
                            $scope.reactivarAnalitica(entity.id);
                        }
                    },
                    {
                        title: 'Eliminar analitica',
                        icon: 'fa-trash',
                        visible: function (entity) {
                            return ($scope.esAdmin() && (entity.estado != "FINALIZADO" && entity.estado != "FINALIZADO-CORREGIDO")) || ($scope.extranetUser.cliente && entity.estado == 'PLANIFICADO');
                        },
                        accion: function (entity) {
                            $scope.eliminarAnalitica(entity.id);
                        }
                    }
                ];
                var metadata = [
                ];

                $scope.data.gridft_analiticas = gridService.createGrid($scope, 'ft_analiticas_grid', {}, 'listado_analiticas_ftVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
                $scope.ixDownloadExcel = $scope.data.gridft_analiticas.ixDownloadExcel;

                if ($scope.extranetUser.laboratorio)
                    $scope.data.filtro.id_laboratorio = $scope.extranetUser.laboratorio;
                //$scope.data.gridft_analiticas.filtroExterno = [{ Field: "id_laboratorio", Value: $scope.extranetUser.laboratorio, Operator: CMP_EQ }];
                $scope.data.gridft_analiticas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["start_month", "start_year", "end_month", "end_year", "busqueda_generica", "asociados", "exclusivas"]);
            }
            else {
                $scope.data.gridft_analiticas = gridService.createGridFunctions($scope, $scope.data.gridft_analiticas);
                $scope.data.gridft_analiticas.ixRestoreConfig();
            }

            $scope.data.gridft_analiticas.ixLoadInitialData();
        }

        $scope.tieneFichero = function (entity) {
            if (entity.num_boletines > 0)
                return true;
            else
                return false;
        }

        $scope.abrirPopupAnalitica = function (is_new, id_ft, marca, proveedor, titulo, cod_interno, fecha) {
            var template = "app/FTBase/ListadosFT/acciones/analitica_ft_popup.html";
            var optionsPopup = { controller: "AnaliticaFTPopupController" };

            var params = { "is_new": is_new, "id_ft": id_ft, "marca": marca, "proveedor": proveedor, "titulo": titulo, "cod_interno": cod_interno, "extranetUser": $scope.extranetUser, "fecha": fecha };
            var modalAnaliticaFT = ixUtilsService.openModalV2(template, optionsPopup, "medium", params);
            modalAnaliticaFT.then(function (response) {
                if (response)
                    $scope.cargarGrid();
                ixStatusService.setEditing(false);
            });
        }

        $scope.descargarArchivos = function (id) {
            var config = { responseType: 'arraybuffer' };
            $http.get(cfg.baseURL + "boletines_analisis_euromadi/DownloadFiles/" + id, config).then(function (response) {
                var mimetype = response.headers('Content-type');
                var file = new Blob([response.data], { type: mimetype });

                var filename = "ft_analiticas.zip";
                if (response.headers('Content-Disposition')) {
                    filename = response.headers('Content-Disposition').split("=")[1];
                }
                saveAs(file, filename);
            }, function (error) {
                ixStatusService.setResponse(error);
            });
        }

        $scope.corregirAnalitica = function (id) {
            $http.post(cfg.baseURL + "ft_analiticas/CorregirAnalitica/" + id).then(function (response) {
                $scope.cargarGrid();
            }, function (err) {
                ixStatusService.setResponse(err);
            });
        }

        $scope.eliminarAnalitica = function (id) {
            $http.delete(cfg.baseURL + "ft_analiticas/" + id).then(function (response) {
                $scope.cargarGrid();

            }, function (err) {
                ixStatusService.setResponse(err);
            });
        }

        $scope.reactivarAnalitica = function (id) {
            $http.post(cfg.baseURL + "ft_analiticas/ReactivarAnalitica/" + id).then(function (response) {
                $scope.cargarGrid();
            }, function (err) {
                ixStatusService.setResponse(err);
            });
        };


        $scope.$on("$destroy", function () {
            $scope.data.gridft_analiticas.ixSaveConfig();
            $scope.isDestroyed = true;
        });
    } //END INIT function

    $scope.ixFiltrar = function () {
        $scope.filterStatus.isCollapsed = true;
        if ($scope.extranetUser.laboratorio)
            $scope.data.filtro.id_laboratorio = $scope.extranetUser.laboratorio;
        //$scope.data.gridft_analiticas.filtroExterno = [{ Field: "id_laboratorio", Value: $scope.extranetUser.laboratorio, Operator: CMP_EQ }];
        $scope.data.gridft_analiticas.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["start_month", "start_year", "end_month", "end_year", "busqueda_generica", "asociados", "exclusivas"]);
        $scope.data.gridft_analiticas.ixLoadInitialData();

        $scope.status.filtered = false;
    }
    // $scope.$on("$destroy", function() {
    //   $scope.data.gridft_analiticas.ixSaveConfig();
    //   $scope.isDestroyed=true;
    // });

}]);

/*global saveAs*/

angular.module('FTBase').controller('Descarga_Informes_AnaliticasController', ['$scope', 'ixStatusService', 'cfg', '$http', 'ixUtilsService', 'authService', function ($scope, ixStatusService, cfg, $http, ixUtilsService, authService) {

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    $scope.data.checkInformesEnsayo = true;
    $scope.data.checkInformesEtiquetado = true;
    $scope.data.checkInformesPosicionamiento = true;

    $scope.status.editing = false;


    $scope.descargarInformes = function () {
        var listaEans = $scope.data.listEans.split('\n');
        var config = { responseType: 'arraybuffer' };
        var params = {
            lista_eans: listaEans,
            fecha_inicio: $scope.data.fecha_inicio,
            fecha_fin: $scope.data.fecha_fin,
            check_analitica: $scope.data.checkInformesEnsayo,
            check_etiquetado: $scope.data.checkInformesEtiquetado,
            check_posicionamiento: $scope.data.checkInformesPosicionamiento
        }
        $http.post(cfg.baseURL + "ft_analiticas/DescargarEans", params, config).then(function (response) {

            var file = new Blob([response.data], { type: 'application/zip' });

            var filename = "ft_analiticas.zip";
            if (response.headers('Content-Disposition')) {
                filename = response.headers('Content-Disposition').split("=")[1];
            }
            saveAs(file, filename);
        }, function (error) {
            ixStatusService.setResponse(error);
        });

    }
}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller('Control_presencia_fotosController', ['$scope', 'ixStatusService', 'gridService', 'cfg', '$http', '$filter', '$q', '$timeout', '$compile', 'authService', function ($scope, ixStatusService, gridService, cfg, $http, $filter, $q, $timeout, $compile, authService) {

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    /* ***** FUNCTION: INIT ***** */
    $scope.init = function () {
        if (!$scope.data.filtro) $scope.data.filtro = {};
        $scope.data.filtro.ft_activas = true;
        $scope.filterStatus = { isCollapsed: false };

        $scope.esAdminODM = false;

        var usuario = authService.authentication.userName;

        $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
            $scope.extranetUser = response.data;

            if ($scope.extranetUser.cliente) {
                if ($scope.extranetUser.cliente == 1031)
                    $scope.esAdminODM = true;
                else
                    $scope.esAdminODM = false;
            }
            else {
                if (!$scope.extranetUser.laboratorio && !$scope.extranetUser.proveedor)
                    $scope.esAdminODM = true;
                else
                    $scope.esAdminODM = false;
            }

            $scope.cargarGrid();
        }, function (error) {
            ixStatusService.setResponse(error);
        });

        $scope.cargarGrid = function () {

            if (!$scope.data.grid_control_fotos) {
                var acciones = [];
                var metadata = [
                    {
                        Name: "estado_envio_ftp"
                        ,
                        NoVisible: !$scope.esAdminODM
                    },
                    {
                        Name: "fecha_envio_ftp"
                        ,
                        NoVisible: !$scope.esAdminODM
                    }

                ];

                $scope.data.grid_control_fotos = gridService.createGrid($scope, 'control_fotos_grid', { metadata: metadata }, 'control_presencia_fotosVM'/*, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]*/);
            }
            else {
                $scope.data.grid_control_fotos = gridService.createGridFunctions($scope, $scope.data.grid_control_fotos);
                $scope.data.grid_control_fotos.ixRestoreConfig();
            }

            $scope.data.grid_control_fotos.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['ft_activas']);
            $scope.ixDownloadExcel = $scope.data.grid_control_fotos.ixDownloadExcel;
        }

        $scope.ixFiltrar = function () {
            $scope.data.grid_control_fotos.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['ft_activas']);
            $scope.data.grid_control_fotos.ixLoadInitialData();
        };

        $scope.$on("$destroy", function () {
            $scope.data.grid_control_fotos.ixSaveConfig();
            $scope.isDestroyed = true;
        });

    }

}]);

/*global ixFiltersToArray*/
/*global CMP_EQ*/
"use strict";

angular.module('FTBase').controller('CargaFicherosFtController', ['$scope', '$http', '$filter', '$log', 'ixStatusService', 'gridService', 'cfg', 'authService', 'Upload', function ($scope, $http, $filter, $log, ixStatusService, gridService, cfg, authService, Upload) {

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;

  $scope.seleccion = {};
  $scope.proveedor = undefined;
  $scope.caducidad_obligatoria = undefined;

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function () {
    var usuario = authService.authentication.userName;
    //Get condition user
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
      $scope.data.extranetUser = response.data;
      //Esta pantalla es visible sólo para proveedores
      if ($scope.data.extranetUser.proveedor)
        $scope.proveedor = $scope.data.extranetUser.proveedor;
      // else
      //   $scope.proveedor = 0;

      //if (angular.isDefined($scope.proveedor))
      $scope.cargarGrid();
    }, function (error) {
      ixStatusService.setResponse(error);
    });

    $scope.cargarGrid = function (){
      if (!$scope.data.gridProductosFt){
        var acciones = [];
        var metadata = [
          {
            Name: "marcas_todas",
            NoVisible: true
          },
          {
            Name: "fecha_aprobada",
            NoVisible: true
          },
          {
            Name: "fecha_revision",
            NoVisible: true
          },
          {
            Name: "cumplimentada",
            NoVisible: true
          },
          {
            Name: "estado_envio_datos_aecoc",
            NoVisible: true
          },
          {
            Name: "fecha_envio_datos_aecoc",
            NoVisible: true
          },
          {
            Name: "ultimo_comentario",
            NoVisible: true
          },
          {
            Name: "publicar_aecoc",
            NoVisible: true
          },
          {
            Name: "marcas_asociadas",
            NoVisible: true
          },
          {
            Name: "revision_etiquetado",
            NoVisible: (!$scope.tieneRevisionEtiquetadoRestringido())
          }
        ];  

        //$scope.data.gridProductosFt = gridService.createGrid($scope, 'CargaFicherosFtGrid', { metadata: metadata }, 'listado_productosVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }, { name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
        $scope.data.gridProductosFt = gridService.createGrid($scope, 'CargaFicherosFtGrid', { metadata: metadata }, 'listado_productosVM', [{ name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
      }
      else {
        $scope.data.gridProductosFt = gridService.createGridFunctions($scope, $scope.data.gridProductosFt);
        $scope.data.gridProductosFt.ixRestoreConfig();
      }

      $scope.data.filtro = {};
      $scope.data.filtro.estado = ["O", "R", "A", "P", "S"];
      if (angular.isDefined($scope.proveedor))
        $scope.data.filtro.proveedor = $scope.proveedor;

      $scope.data.gridProductosFt.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["tipo_ft", "estado", "marca", "proveedor", "busqueda_generica", "asociados", "exclusivas"]);
    };
  };

  $scope.tienePresentacionProductoRestringido = function () {
    var tiene = false;
    var perfilesUsuario = authService.authentication.perfiles;
    for (var i = 0; i < perfilesUsuario.length; i++) {
        var perfil = perfilesUsuario[i];
        tiene = (perfil.indexOf("usr_proveedor") != -1);
        if (tiene)
            break;
    }
    return tiene;
	};

  $scope.loadTiposFicheroFT = function (params, search) {
		if($scope.tienePresentacionProductoRestringido()) params.Filters.push({ Field: 'id', value: 28, "Operator": CMP_EQ, not: true });
		return $http.post(cfg.baseURL + "tipos_fichero_ft/Search?ItemsPerPage=150", params);
	  }

  $scope.tieneRevisionEtiquetadoRestringido = function () {
    var tiene = false;
    var perfilesUsuario = authService.authentication.perfiles;
    for (var i = 0; i < perfilesUsuario.length; i++) {
        var perfil = perfilesUsuario[i];
        tiene = (perfil.indexOf("usr_cliente") != -1 || perfil.indexOf("ixnet") != -1);
        if (tiene)
            break;
    }
    return tiene;
	};

  $scope.tipoArchivoSeleccionado = function(entity){
		if (entity){
			$scope.especificar_producto = entity.especificar_producto;
			$scope.caducidad_obligatoria = entity.caducidad_obligatoria;
		}
		else {
			$scope.especificar_producto = undefined;
			$scope.caducidad_obligatoria = undefined;
		}
	};

  $scope.seleccionarRowsVisibles = function(){
    $scope.data.gridProductosFt.gridApi.grid.getVisibleRows().forEach(function(row){
      row.entity.Selector = true;
    });
  };

  $scope.desSeleccionarRows = function(){
    $scope.data.gridProductosFt.data.forEach(function(row){
      row.Selector = false;
    });
  };

  $scope.guardarFichero = function(){
    var fileNames = [];
		angular.forEach($scope.seleccion.archivosToUpload, function(fileToUpload){
			fileNames.push(fileToUpload.name);
		});

    $log.log("Tipo: " + $scope.seleccion.tipoSeleccionadoFt);
    $log.log("Inicio validez: " + $scope.seleccion.inicioValidez);
    $log.log("Caducidad: " + $scope.seleccion.fechaCaducidad);

    var lista_ft = [];
    var lista_productos = [];
    $scope.data.gridProductosFt.data.filter(function (row) { return row.Selector == true; }).forEach(function (row) {
      lista_ft.push(row.id_ficha_tecnica);
      //var prod = { id_ft: row.id_ficha_tecnica, id_producto: row.id_producto };
      lista_productos.push(row.id_producto);
    });

    $log.log(lista_ft);
    $log.log(lista_productos);

    var data = { filename: fileNames[0], detalles: [] };
    for (var i = 0; i < lista_ft.length; i++)
    {
      data.detalles.push({ id_ficha_tecnica: lista_ft[i], id_producto: lista_productos[i], tipo: $scope.seleccion.tipoSeleccionadoFt, fecha_caducidad: $scope.seleccion.fechaCaducidad, inicio_validez: $scope.seleccion.fechaCaducidad });
    }

    $http.post(cfg.baseURL + "fichas_tecnicas_ficheros/CanUploadMultiple", data).then(function(response){
      var strListaFt = lista_ft.join();
      var strListaProductos = lista_productos.join();
      if(response.data.GlobalMessage.ErrType == 0){
        $scope.data.uploadingFile = true;
        var upload = Upload.upload({
          url: cfg.baseURL + "fichas_tecnicas_ficheros/UploadAndCreateMultiple",
          data: {
            file: $scope.seleccion.archivosToUpload,
            ids_ficha_tecnica: strListaFt,
            ids_productos: strListaProductos,
            tipo: $scope.seleccion.tipoSeleccionadoFt,
            fecha_caducidad: $scope.seleccion.fechaCaducidad,
            inicio_validez: $scope.seleccion.inicioValidez
          },
          dataType: 'json'
        });

        upload.then(function(response){
          if(response.data){
            delete $scope.data.ixProgress;
            $scope.data.uploadingFile = false;
						ixStatusService.setResponse(response);
            //$scope.status.editing = false;
          }
        },
        function(err){
          if(err.data){
						delete $scope.data.ixProgress;
						$scope.data.uploadingFile = false;
            ixStatusService.setResponse(err);
					}
        },
        function(evt){
          $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
      else {
        ixStatusService.setResponse(response);
      }
    },
    function(err){
      ixStatusService.setResponse(err);
    });
  };


}]);
/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global buildIxSearch*/
/*global addDateDeriveds*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
/*global checkPermission*/
/*global CMP_LIKE*/
/*global saveAs */
"use strict";

angular.module('FTBase').controller('Busqueda_AvanzadaController', [ '$scope', '$http', '$filter', 'cfg', 'ixStatusService', 'gridService', 'authService', function($scope, $http, $filter, cfg, ixStatusService, gridService, authService){

  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;

  $scope.status.editing = false;
  $scope.data.activeTab = 0;

  var imprimirExcel = function(id_pregunta){
    var param = {};
    param.Selection = {};
    param.Selection.Filters = [{Field: 'id_pregunta', Value: id_pregunta, Operator: CMP_EQ, Skip:true}];
    if ($scope.data.filtro.asociados){
      if ($scope.data.filtro.asociados.length > 0){
        var lista_asociados = ixFiltersToArray($scope.data.filtro, $filter, undefined, ["asociados" ]);
        for(var i = 0; i < lista_asociados.length ; i++)
          param.Selection.Filters.push(lista_asociados[i]);
        }
    }

    param.Fields = [
      {Field: 'FichaTecnica'},
      {Field: 'titulo'},
      {Field: 'Proveedor'},
      {Field: 'Cod_Interno'},
      {Field: 'Cod_Interno_Asociados'},
      {Field: 'ean'},
      {Field: 'Marca'},
      {Field: 'MarcasAsociadas'},
      {Field: 'estado'},
      {Field: 'componente'},
      {Field: 'orden_n1'},
      {Field: 'orden_n2'},
      {Field: 'orden_n3'},
      {Field: 'ft_pregunta_informe'},
      {Field: 'marca_etiquetado'},
      {Field: 'observaciones'},
      {Field: 'sub_respuesta1'},
      {Field: 'sub_respuesta2'},
      {Field: 'sub_respuesta3'},
      {Field: 'sub_respuesta4'},
      {Field: 'sub_respuesta5'},
      {Field: 'sub_respuesta6'},
      {Field: 'sub_respuesta7'},
      {Field: 'sub_respuesta8'},
      {Field: 'sub_respuesta9'},
      {Field: 'sub_respuesta10'},
      {Field: 'sub_respuesta11'},
      {Field: 'sub_respuesta12'},
      {Field: 'sub_respuesta13'},
      {Field: 'sub_respuesta14'}
    ];
    var config = {responseType:"arraybuffer"};


    $http.post(cfg.baseURL +'listado_busqueda_avanzadaVM' + '/Excel' , param, config).then(function(r){
      var file = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      var filename = "listado" + $filter('date')(new Date(), 'HHmmss', null) + ".xlsx";

      if(r.headers('Content-Disposition')) {
        var nameFromServer = r.headers('Content-Disposition').split("=")[1];
        if(nameFromServer != "null.xlsx"){
          filename = nameFromServer;
        }
      }

      saveAs(file, filename);
    }, function(err){
      ixStatusService.setResponse(err);
    });
  }

  /* ***** FUNCTION: INIT ***** */
  $scope.init = function(){
    $scope.filterStatus = { isCollapsed: false };
    if(!$scope.data.filtro) $scope.data.filtro = {};
    $scope.ocultarSelAsociados = true;

    var usuario = authService.authentication.userName;
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function(response){
      var extranetUser = response.data;
      if (extranetUser.cliente == 1031 || !(extranetUser.laboratorio || extranetUser.proveedor || extranetUser.cliente))
        $scope.ocultarSelAsociados = false;

    }, function(error){
      ixStatusService.setResponse(error);
    });

    if (!$scope.data.gridBusqueda){
      var acciones = [
        {
          title: 'Imprimir excel',
          icon: 'fa-list',
          accion: function(entity){
  					imprimirExcel(entity.id_pregunta);
  				}
        }
      ];
      var metadata = [];

      $scope.data.gridBusqueda = gridService.createGrid($scope, 'gestornet_grid_busqueda_avanzada', { }, 'list_preguntas_busqueda_avanzadaVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
    }
    else {
      $scope.data.gridBusqueda = gridService.createGridFunctions($scope, $scope.data.gridBusqueda);
      $scope.data.gridBusqueda.ixRestoreConfig();
    }

		$scope.$on("$destroy", function() {
			$scope.data.gridBusqueda.ixSaveConfig();
			$scope.isDestroyed=true;
		});
  }


}]);

/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global saveAs*/
"use strict"

angular.module('FTBase').controller('ListadoResumenHomologacionController', ['$scope', '$http', '$filter', 'cfg', 'gridService', 'ixStatusService', 'ixUtilsService', 'authService', function($scope, $http, $filter, cfg, gridService, ixStatusService, ixUtilsService, authService){
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;
  $scope.filterStatus = { isCollapsed: false };
  if (!$scope.data.filtro) $scope.data.filtro = {};
  $scope.data.filtro.vigentes = 1;
  $scope.data.filtro.solo_exclusivas = 0;

  $scope.init = function (){

    $scope.cargarGrid = function (){
      if (!$scope.data.grid_resumen_homologacion){
        var acciones = [
          {
            title: "Descargar ficheros",
            icon: "fa-file-pdf-o",
            visible: function(entity){
              if (entity.seg_alim_id_fichero == 0 && entity.social_id_fichero == 0 && entity.med_amb_id_fichero == 0)
                return false;
              else
                return true;
            },
            accion: function(entity){
              var lista = [];
              if (entity.seg_alim_id_fichero != 0) lista.push(entity.seg_alim_id_fichero);
              if (entity.social_id_fichero != 0) lista.push(entity.social_id_fichero);
              if (entity.med_amb_id_fichero != 0) lista.push(entity.med_amb_id_fichero);

              if (lista.length > 0){
                var config = { responseType: 'arraybuffer' };
                $http.post(cfg.baseURL + "proveedores_ficheros/DescargaMultiple", lista, config).then(function (response) {
                  var file = new Blob([response.data], { type: 'application/zip' });
            
                  var filename = "ficheros_ft.zip";
                  if (response.headers('Content-Disposition')) {
                    filename = response.headers('Content-Disposition').split("=")[1];
                  }
                  saveAs(file, filename);
                }, function (error) {
                  ixStatusService.setResponse(error);
                });
              }
            }
          }
        ];
        var metadata = [];
        if(cfg.appCliente == "ALCAMPO"){
          metadata.push({ Name: "codigo", NoVisible: false });
          metadata.push({ Name: "seg_alim_calidad", ColumnDescription: "Tecnica - Calidad" });
          metadata.push({ Name: "seg_alim_fecha", ColumnDescription: "Tecnica - Fecha caducidad/realización" });
          metadata.push({ Name: "seg_alim_alcance", ColumnDescription: "Tecnica - Alcance" });
          metadata.push({ Name: "seg_alim_laboratorio", ColumnDescription: "Tecnica - Laboratorio" });
          metadata.push({ Name: "seg_alim_resultado", ColumnDescription: "Tecnica - Resultado" });
          metadata.push({ Name: "seg_alim_estado", ColumnDescription: "Tecnica - Estado" });
          metadata.push({ Name: "seg_alim_verificacion", ColumnDescription: "Tecnica - Verificacion" });
          metadata.push({ Name: "seg_alim_comentarios", ColumnDescription: "Tecnica - Comentarios" });
          metadata.push({ Name: "seg_alim_proxima_auditoria", ColumnDescription: "Tecnica - Proxima Auditoria" });
          metadata.push({ Name: "fecha_alta_proveedor", NoVisible: false });
          metadata.push({ Name: "mercados", NoVisible: false });
          metadata.push({ Name: "social_verificacion", NoVisible: true });
          metadata.push({ Name: "medio_ambiente_verificacion", NoVisible: true });
          metadata.push({ Name: "seg_alim_verificacion", NoVisible: true });
          metadata.push({ Name: "fecha_limite_tecnica", NoVisible: false });
          metadata.push({ Name: "fecha_limite_social", NoVisible: false });
          metadata.push({ Name: "fecha_limite_med_amb", NoVisible: false });
          metadata.push({ Name: "medio_ambiente_proxima_auditoria", NoVisible: true });
          metadata.push({ Name: "social_proxima_auditoria", NoVisible: true });
          metadata.push({ Name: "seg_alim_proxima_auditoria", NoVisible: true });
        }

        $scope.data.grid_resumen_homologacion = gridService.createGrid($scope, 'resumen_homologacion_grid', {metadata: metadata}, 'listado_homologacion_plantas_resumenVM', [ { name: 'Acciones', type: 'detalle', acciones: acciones },{ name: 'Selector', type: 'CheckBox', NoEditable: function () { return false; } }]);
      }
      else {
        $scope.data.grid_resumen_homologacion = gridService.createGridFunctions($scope, $scope.data.grid_resumen_homologacion);
        $scope.data.grid_resumen_homologacion.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.grid_resumen_homologacion.ixDownloadExcel;

      if ($scope.data.extranetUser.cliente != null){
        //$scope.data.filtro.cliente = $scope.data.extranetUser.cliente;
        $scope.data.grid_resumen_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes', 'solo_exclusivas']);
      }
      else {
        $scope.data.grid_resumen_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['vigentes','solo_exclusivas']);
      }
      
      $scope.data.grid_resumen_homologacion.ixLoadInitialData();
    };

    $scope.ixFiltrar = function (){
      if ($scope.data.extranetUser.cliente != null){
        //$scope.data.filtro.cliente = $scope.data.extranetUser.cliente;
        $scope.data.grid_resumen_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes','solo_exclusivas']);
      }
      else {
        $scope.data.grid_resumen_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['vigentes','solo_exclusivas']);
      }
      //$scope.data.grid_resumen_homologacion.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }]
      $scope.data.grid_resumen_homologacion.ixLoadInitialData();
    };
    
    var usuario = authService.authentication.userName;
    $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function(response){
      $scope.data.extranetUser = response.data;
      $scope.data.filtro.cliente = $scope.data.extranetUser.cliente;
      $scope.cargarGrid();
    },
    function(error){
      ixStatusService.setResponse(error);
    });
  };

  $scope.seleccionarRowsVisibles = function(){
    $scope.data.grid_resumen_homologacion.gridApi.grid.getVisibleRows().forEach(function(row){
      row.entity.Selector = true;
    });
  };

  $scope.desSeleccionarRows = function(){
    $scope.data.grid_resumen_homologacion.data.forEach(function(row){
      row.Selector = false;
    });
  };

  $scope.descargarFicherosSeleccionados = function(){
    var lista = [];
    $scope.data.grid_resumen_homologacion.data.filter(function(row){ return row.Selector == true; }).forEach(function(row){
      if (row.seg_alim_id_fichero != 0) lista.push(row.seg_alim_id_fichero);
      if (row.social_id_fichero != 0) lista.push(row.social_id_fichero);
      if (row.med_amb_id_fichero != 0) lista.push(row.med_amb_id_fichero);
    });

    if (lista.length > 0){
      var config = { responseType: 'arraybuffer' };
      $http.post(cfg.baseURL + "proveedores_ficheros/DescargaMultiple", lista, config).then(function (response) {
        var file = new Blob([response.data], { type: 'application/zip' });
  
        var filename = "ficheros_ft.zip";
        if (response.headers('Content-Disposition')) {
          filename = response.headers('Content-Disposition').split("=")[1];
        }
        saveAs(file, filename);
      }, function (error) {
        ixStatusService.setResponse(error);
      });    }
  };

  $scope.$on("$destroy", function() {
		$scope.data.grid_resumen_homologacion.ixSaveConfig();
		$scope.isDestroyed=true;
	});

}]);
/*global CMP_EQ*/
/*global ixFiltersToArray*/
/*global saveAs*/
"use strict"

/* Versión usando gridEditor.html */
/*
angular.module('FTBase').controller('ListadoControlHomologacionController', [ '$scope', '$controller', '$http', 'cfg', 'ixStatusService', 'ixUtilsService', '$log', function($scope, $controller, $http, cfg, ixStatusService, ixUtilsService, $log) {
  $scope.entity = "listado_homologacion_proveedoresVM";

  $scope.acciones = [
    {
      title: 'Visualizar/Editar Auditoría',
      icon: 'fa-pencil-square-o',
      visible: function(entity){
        return entity.grupo == 'AUDITORIAS';
      },
      accion: function(entity){
        var templateURL = "app/FTBase/HomologacionPlantas/editar_auditoria_planta.html";
        var optionsPopup = { controller: "DetallesAuditoriaPlantaController" };
        var paramsPopup = { datosAuditoria: entity, isNew: false };
        ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function(response){
          if (response) $scope.data.grid.ixLoadInitialData();
        });
      }
    }
  ];

  //Crear nueva auditoría
  $scope.ixAddRow = function(){
    var templateURL = "app/FTBase/HomologacionPlantas/editar_auditoria_planta.html";
    var optionsPopup = { controller: "DetallesAuditoriaPlantaController" };
    var paramsPopup = { datosAuditoria: undefined, isNew: true };
    ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function(response){
      if (response) $scope.data.grid.ixLoadInitialData();
    });
  };


  $scope.ixGuardar = function(){
    //Habrá sólo lineas eliminadas
    $log.log("Llamada ixGuardar lista control homologaciones");
  };


  $controller('GridEditorController', { $scope: $scope });
}]);
*/

/* Versión con propria página HTML */
angular.module('FTBase').controller('ListadoControlHomologacionController', ['$scope', '$http', '$filter', '$log', 'cfg', 'gridService', 'ixStatusService', 'ixUtilsService', 'authService', function ($scope, $http, $filter, $log, cfg, gridService, ixStatusService, ixUtilsService, authService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.status.editing = false;
  $scope.filterStatus = { isCollapsed: false };
  if (!$scope.data.filtro) $scope.data.filtro = {};
  $scope.data.filtro.vigentes = true;

  $scope.init = function () {
    $scope.cargarGrid = function () {
      if (!$scope.data.grid_control_homologacion) {
        var acciones = [
          {
            title: "Previsualizar PDF",
            icon: "fa-file-pdf-o",
            visible: function (entity) {
              return entity.grupo == 'CERTIFICADOS';
            },
            accion: function (entity) {
              var tabla = "proveedores_ficheros";
              $http({
                method: 'post',
                url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
                headers: {},
                responseType: 'arraybuffer'
              }).then(function (r) {
                $scope.selectedPDF = new Uint8Array(r.data);
                $scope.idFicheroPreview = entity.id;
                var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
                ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
              },
                function (err) {
                  ixStatusService.setResponse(err);
                });
            }
          },
          {
            title: "Descargar fichero",
            icon: "fa-download",
            visible: function (entity) {
              return entity.grupo == 'CERTIFICADOS';
            },
            accion: function (entity) {
              $scope.downloadFile(entity, 'CERTIFICADOS');
            }
          },
          {
            title: "Descargar documentos",
            icon: "fa-download",
            visible: function (entity) {
              return entity.grupo == 'AUDITORIAS' && entity.existen_docs > 0;
            },
            accion: function (entity) {
              $scope.downloadFile(entity, 'AUDITORIAS');
            }
          },
          {
            title: 'Visualizar/Editar Auditoría',
            icon: 'fa-pencil-square-o',
            visible: function (entity) {
              return entity.grupo == 'AUDITORIAS';
            },
            accion: function (entity) {
              var templateURL = "app/FTBase/HomologacionPlantas/editar_auditoria_planta.html";
              var optionsPopup = { controller: "DetallesAuditoriaPlantaController" };
              var paramsPopup = { datosAuditoria: entity, isNew: false,bPantallaProveedor:false };
              ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function (response) {
                $scope.status.editing = false;
                if (response) $scope.data.grid_control_homologacion.ixLoadInitialData();
              });
            }
          },
          {
            title: 'Archivar auditoría',
            icon: 'fa-archive',
            visible: function (entity) {
              return (entity.grupo == 'AUDITORIAS' && entity.archivada == 0);
            },
            accion: function (entity) {
              var param = [];
              param.push({
                value: 1,
                path: "/archivada",
                op: "replace"
              });

              $http.put(cfg.baseURL + "auditorias_plantas/" + entity.id, param).then(function (response) {
                $scope.data.grid_control_homologacion.ixLoadInitialData();
              },
                function (error) {
                  ixStatusService.setResponse(error);
                });
            }
          },
          {
            title: 'Marcar verificado',
            icon: 'fa-check-square-o',
            visible: function (entity) {
              return entity.verificacion == 0;
            },
            accion: function (entity) {
              var table = "";
              if (entity.grupo == 'AUDITORIAS')
                table = "auditorias_plantas";
              else //CERTIFICADOS
                table = "proveedores_ficheros";

              var param = [];
              param.push({
                value: 1,
                path: "/verificacion",
                op: "replace"
              });

              $http.put(cfg.baseURL + table + "/" + entity.id, param).then(function (response) {
                $scope.data.grid_control_homologacion.ixLoadInitialData();
              },
                function (error) {
                  ixStatusService.setResponse(error);
                });
            }
          },
          {
            title: 'Eliminar auditoría',
            icon: 'fa-trash',
            visible: function (entity) {
              return entity.grupo == 'AUDITORIAS' && (authService.tienePerfilAdmin() || authService.tienePerfilUserKey());
            },
            accion: function (entity) {
              $scope.eliminarAuditoriaPlanta(entity);
            }
          }
        ];
        var metadata = [];
        if(cfg.appCliente == "ALCAMPO"){
          metadata.push({ Name: "codigo", NoVisible: false });
        }

        $scope.data.grid_control_homologacion = gridService.createGrid($scope, 'control_homologacion_grid', { metadata: metadata }, 'listado_homologacion_proveedoresVM', [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
      }
      else {
        $scope.data.grid_control_homologacion = gridService.createGridFunctions($scope, $scope.data.grid_control_homologacion);
        $scope.data.grid_control_homologacion.ixRestoreConfig();
      }

      $scope.ixDownloadExcel = $scope.data.grid_control_homologacion.ixDownloadExcel;

      var usuario = authService.authentication.userName;
      $http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
        //asignar cliente
        $scope.data.extranetUser = response.data;
        //En funcion de si es cliente o no aplicamos el filtro de cliente o no
        if ($scope.data.extranetUser.cliente != null) {
          $scope.data.filtro.cliente = $scope.data.extranetUser.cliente;
          $scope.data.grid_control_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes']);
          $scope.data.grid_control_homologacion.ixLoadInitialData();
        }
        else {
          $scope.data.grid_control_homologacion.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }];
          $scope.data.grid_control_homologacion.ixLoadInitialData();
        }
      },
        function (error) {
          ixStatusService.setResponse(error);
        });
    };

    $scope.ixFiltrar = function () {
      if ($scope.data.extranetUser.cliente != null) {
        $scope.data.filtro.cliente = $scope.data.extranetUser.cliente;
        $scope.data.grid_control_homologacion.filtroExterno = ixFiltersToArray($scope.data.filtro, $filter, undefined, ['cliente', 'vigentes']);
        $scope.data.grid_control_homologacion.ixLoadInitialData();
      }
      else {
        $scope.data.grid_control_homologacion.filtroExterno = [{ Field: "vigentes", OPerator: CMP_EQ, Value: $scope.data.filtro.vigentes, Skip: true }]
        $scope.data.grid_control_homologacion.ixLoadInitialData();
      }
    };

    $scope.openEditAuditoria = function () {
      var templateURL = "app/FTBase/HomologacionPlantas/editar_auditoria_planta.html";
      var optionsPopup = { controller: "DetallesAuditoriaPlantaController" };
      var paramsPopup = { datosAuditoria: undefined, isNew: true,bPantallaProveedor:false };
      ixUtilsService.openModalV2(templateURL, optionsPopup, "small", paramsPopup).then(function (response) {
        $scope.status.editing = false;
        $log.log("openEditAuditoria Reset Status.Editing");
        if (response)
          $scope.data.grid_control_homologacion.ixLoadInitialData();
      });
    };

    ixUtilsService.checkPermission("SubirHomologacionPlanta").then(function(response){
      $scope.data.permisoSubirCertificado = response;
      if($scope.data.permisoSubirCertificado){
        $scope.openCertificado = function(){
          var templateURL = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
          var controllerName = "UploadFilePopupProveedoresController";
          var optionsPopupFicheros = {
            controller: controllerName
          };
          var params = {"soloHayPlantaPuesta": true};
          var modalInstance = ixUtilsService.openModalV2(templateURL, optionsPopupFicheros, 'medium',params);
          modalInstance.then(function (resp){
            $scope.status.editing = false;
            $log.log("openEditAuditoria Reset Status.Editing");
            if (resp)
              $scope.data.grid_control_homologacion.ixLoadInitialData();
          })
        }
      }
    })

    
    


    $scope.downloadFile = function (entity, grupo) {
      if (grupo == 'CERTIFICADOS') {
        $http({
          method: 'post',
          url: cfg.baseURL + 'proveedores_ficheros/DownloadFile?id=' + entity.id,
          headers: {},
          responseType: 'arraybuffer'
        }).then(function (r) {
          var file = new Blob([r.data], { type: r.headers('Content-type') });

          var filename = "Certificado " + entity.tipo + ".pdf";
          if (r.headers('Content-Disposition')) {
            filename = r.headers('Content-Disposition').split("=")[1];
          }
          saveAs(file, filename);
        },
          function (err) {
            ixStatusService.setResponse(err);
          });
      }
      else { // grupo == 'AUDITORIAS'
        $http({
          method: 'post',
          url: cfg.baseURL + 'auditorias_plantas_documentos/DownloadDocumentos/' + entity.id,
          headers: {},
          responseType: 'arraybuffer'
        }).then(function (r) {
          var file = new Blob([r.data], { type: r.headers('Content-type') });

          var filename = "DocumentosAuditoriaPlanta_" + entity.nombre_planta + ".zip";
          if (r.headers('Content-Disposition')) {
            filename = r.headers('Content-Disposition').split("=")[1];
          }
          saveAs(file, filename);
        },
          function (err) {
            ixStatusService.setResponse(err);
          });
      }
    };

    $scope.cargarGrid();
  };

  $scope.eliminarAuditoriaPlanta = function (aud) {
    $http.delete(cfg.baseURL + 'auditorias_plantas/' + aud.id).then(function (response) {
      $scope.data.grid_control_homologacion.ixLoadInitialData();
      ixStatusService.setResponse(response);
    },
      function (error) {
        ixStatusService.setResponse(error);
      });
  };

  $scope.$on("$destroy", function () {
    $scope.data.grid_control_homologacion.ixSaveConfig();
    $scope.isDestroyed = true;
  });


}]);


/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global saveAs*/
"use strict";

angular.module('FTBase').controller('DetallesAuditoriaPlantaController', ['$scope', '$http', '$uibModalInstance', '$q', '$timeout', '$translate', '$log', 'cfg', 'ixStatusService', 'ixUtilsService', 'gridService', 'Upload', function($scope, $http, $uibModalInstance, $q, $timeout, $translate, $log, cfg, ixStatusService, ixUtilsService, gridService, Upload){
  $scope.status = ixStatusService.current;
	$scope.data = {};
  $scope.data.updated = false;

  $scope.data.isNew = $scope.$resolve.isNew;
  $scope.data.datosAuditoria = $scope.$resolve.datosAuditoria;
  //El config no esta disponible porque es un pop up.
  $scope.appCliente = cfg.appCliente;
  if (angular.isDefined($scope.data.datosAuditoria)){
    if ($scope.data.datosAuditoria.archivada)
      $scope.status.editing = false;
    else
      $scope.status.editing = true;
  }
  else{
    $scope.status.editing = true;
  }
  $scope.bPantallaProveedor = $scope.$resolve.bPantallaProveedor;
  if($scope.bPantallaProveedor == true)$scope.data.proveedor = $scope.$resolve.id_proveedor;

  var buildGridDocs = function() {
    if (!$scope.data.gridDocs){
      var acciones = [
        {
          title: $translate.instant("Descargar fichero"),
          icon: "fa-download",
          visible: function (entity) {
            return entity.nombre_archivo;
          },
          accion: function (entity) {
            $scope.downloadFile(entity);
          }
        }
      ];
      //ar metadata = [];

      $scope.data.gridDocs = gridService.createGrid($scope, "grid_documentos_auditoria_planta", { minRowsToShow: 3, enableCellEdit: false, showOnlyDescribedCols: ["nombre_archivo"]}, "auditorias_plantas_documentos", [{ name: $translate.instant('Acciones'), type: 'detalle', acciones: acciones }])
      $scope.data.gridDocs.filtroExterno = [{ Field: "auditoria_planta", Operator: CMP_EQ, Value: $scope.data.datos.id }];
      $scope.data.gridDocs.ixLoadInitialData();
    }
    else {
      $scope.data.gridDocs = gridService.createGridFunctions($scope, $scope.data.gridBoletines);
      $scope.data.gridDocs.ixRestoreConfig();
    }
  };
    

  if (!$scope.data.isNew){
    $scope.data.datos = {};
    $scope.data.datos.id = $scope.data.datosAuditoria.id;
    $scope.data.proveedor = $scope.data.datosAuditoria.id_proveedor;
    $scope.data.datos.planta = $scope.data.datosAuditoria.id_planta;
    $scope.data.categoria = $scope.data.datosAuditoria.id_categoria;
    $scope.data.datos.tipo = $scope.data.datosAuditoria.id_tipo;
    $scope.data.datos.alcance = $scope.data.datosAuditoria.alcance;
    $scope.data.datos.fecha_realizacion = $scope.data.datosAuditoria.fecha_caducidad_realizacion;
    $scope.data.datos.laboratorio = $scope.data.datosAuditoria.id_laboratorio;
    $scope.data.datos.resultado_auditoria = $scope.data.datosAuditoria.resultado_auditoria;
    $scope.data.datos.estado_resultado = $scope.data.datosAuditoria.estado;
    $scope.data.datos.comentarios = $scope.data.datosAuditoria.comentarios;
    $scope.data.datos.verificacion = $scope.data.datosAuditoria.verificacion;
    $scope.data.datos.proxima_auditoria = $scope.data.datosAuditoria.proxima_auditoria;

    var fechaOriginal = new Date($scope.data.datos.fecha_realizacion); 
    fechaOriginal.setFullYear(fechaOriginal.getFullYear() + $scope.data.datosAuditoria.anos_vigencia);
    $scope.fecha_limite =  fechaOriginal;

    $scope.data.datosOriginales = angular.copy($scope.data.datos);

    buildGridDocs();
  }

  $scope.cargarPlantasProveedor = function(){
    $log.log($scope.data.proveedor);
    return $http.post(cfg.baseURL + "plantas/ListPorProveedor/" + $scope.data.proveedor);
  };

  $scope.limpiarPlanta = function(){
    $scope.data.datos.planta = undefined;
  };

  $scope.actualizarProxAuditoria = function (vaciarCampos) {
    //Se calcula la fecha de próxima auditoría sólo para auditorías que las tengan previamente indicadas.
    if(vaciarCampos == true){
      $scope.data.datos.proxima_auditoria = null;
      $scope.fecha_limite = null;
    }
    else if($scope.ano_vigencia && $scope.data.datos.fecha_realizacion)
      {
        var year = $scope.data.datos.fecha_realizacion.getFullYear();
        
        $scope.data.datos.proxima_auditoria = year + $scope.ano_vigencia;

        var fechaOriginal = new Date($scope.data.datos.fecha_realizacion); 
        fechaOriginal.setFullYear(fechaOriginal.getFullYear() + $scope.ano_vigencia);
        $scope.fecha_limite =  fechaOriginal;
      }
  };

  $scope.selectTipoAuditoria = function (entity, value) {
    $scope.ano_vigencia = entity.anos_vigencia;
    var vaciarCampos = !$scope.ano_vigencia;
    $scope.actualizarProxAuditoria(vaciarCampos);
  };

  $scope.$watchGroup(['data.datos.fecha_realizacion','data.categoria'], function(newValue,oldValue){
    if (newValue!=oldValue){
      var vaciarCampos = ((newValue[1] != oldValue[1]) || !newValue[0]);
      $scope.actualizarProxAuditoria(vaciarCampos);
    }
  })

  $scope.save = function(){
    if ($scope.data.isNew){
      //Agregar nueva auditoría
      var nuevaAuditoria = {};

      nuevaAuditoria = $scope.data.datos;
      $http.post(cfg.baseURL + "auditorias_plantas", nuevaAuditoria).then(function(response){
        var fileNames = [];
		    angular.forEach($scope.data.archivosToUpload, function(fileToUpload){
			    fileNames.push(fileToUpload.name);
		    });

        $http.post(cfg.baseURL + "auditorias_plantas_documentos/CanUpload/" + $scope.data.datos.planta + "/" + response.data.obj.Record.id, fileNames).then(function(resp){
          $log.log(resp);
          if(response.data.GlobalMessage.ErrType == 0){
            $scope.data.uploadingFile = true;
            var upload = Upload.upload({
              url: cfg.baseURL + "auditorias_plantas_documentos/UploadAndCreate",
              data: {
                file: $scope.data.archivosToUpload,
                id_planta: $scope.data.datos.planta,
                id_auditoria: response.data.obj.Record.id
              },
              dataType: 'json'
            });

            upload.then(function(r){
              if(r.data){
                delete $scope.data.ixProgress;
                $scope.data.uploadingFile = false;
                ixStatusService.setResponse(response);
                $scope.status.editing = false;
                $scope.data.updated = true;
                $uibModalInstance.close($scope.data.updated);
              }
            },
            function(e){
              if(e.data){
                delete $scope.data.ixProgress;
                $scope.data.uploadingFile = false;
              }
            },
            function(evt){
              $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
          }
          else {
            ixStatusService.setResponse(resp);
          }
        },
        function(err){
          ixStatusService.setResponse(err);
        });
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
    else {
      //Editar auditoría
      var param = {};
      param = ixGetPatchOperations($scope.data.datosOriginales, $scope.data.datos);
      var cambio =  param.find(function(e) { return e.path == '/proxima_auditoria'});
       if (cambio){
        if (angular.isString(cambio.value)){
          cambio.value = cambio.value.replace('.','');
        }
      } 

      $http.put(cfg.baseURL + "auditorias_plantas/" + $scope.data.datos.id, param).then(function(response){
        ixStatusService.setResponse(response);
        $scope.data.updated = true;
        $uibModalInstance.close($scope.data.updated);
      },
      function(error){
        ixStatusService.setResponse(error);
      });
    }
  }; 

  $scope.deleteSelectedDocs = function(){
    $scope.data.gridDocs.ixDeleteSelectedRows();
    var dataToDel = $scope.data.gridDocs.ixGetBulkParam();
    $http.post(cfg.baseURL + "auditorias_plantas_documentos/UpdateBulk", dataToDel).then(function (response) {
      $scope.data.updated = true;
      ixStatusService.setResponse(response);
      $scope.data.updated = true;
    },
      function (error) {
        ixStatusService.setResponse(error);
      });
  };

  $scope.addDoc = function(){
    var urlTemplate = "app/FTBase/HomologacionPlantas/modales/uploadDocumentoAuditoriaPlanta.html";
    var optionsPopupDocs = { controller: "UploadDocumentoAuditoriaPlantaController" };
    var params = { id_planta: $scope.data.datos.planta, id_auditoria: $scope.data.datosAuditoria.id };
    var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupDocs, 'small', params);
    modalInstance.then(function(resp){
      //Si se han agregado documentos, actualizar el grid
      if (resp) {
        $scope.data.gridDocs.ixLoadInitialData();
        $scope.data.updated = true;
      }
    });
  };

  $scope.downloadFile = function(entity){
    $http({
      method: 'post',
      url: cfg.baseURL + 'auditorias_plantas_documentos/DownloadDocumento/' + entity.id,
      headers: {},
      responseType: 'arraybuffer'
    }).then(function(r){
      var file = new Blob([r.data], { type: r.headers('Content-type') });
      var filename = "DocumentoAuditoria.pdf";
      if (r.headers('Content-Disposition')) {
        filename = r.headers('Content-Disposition').split("=")[1];
      }
      saveAs(file, filename);
    },
    function(err){
      ixStatusService.setResponse(err);
    });
  };

  $scope.$dismiss = function(){
    $uibModalInstance.close($scope.data.updated);
  };
}]);
angular.module('FTBase').controller('EansCodInternoMasivoController', ['$scope', 'ixStatusService', 'cfg', '$http', 'ixUtilsService', '$timeout', '$document', 'apiHubService', function ($scope, ixStatusService, cfg, $http, ixUtilsService, $timeout, $document, apiHubService) {
    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    //GestPark ofrece la opción de simular. De momento solo actualizaremos.
    $scope.operaciones = { SIMULAR: 1, ACTUALIZAR: 2 };

    $scope.init = function(){
        $scope.ixEditar = function(){
			ixStatusService.setEditing(true);
			$scope.renderExcelTable();
		};

		$scope.ixCancelEdit = function(){
			$scope.data.excelData = [];
		};

		///////////////////////Funciones excel////////////////////////////

		$scope.heightStyle = {'height': 'calc(100vh - 420px)'};

		$scope.data.excelData = [];

		// Columnas del excel a mostrar
		var buildExcelCols = function(){
			return [
				{title: 'FT', readOnly: false, width: 150 },
				{title: 'EAN ACTUAL', readOnly: false, width: 150 },
                {title: 'EAN NUEVO', readOnly: false, width: 150 },
				{title: 'COD INTERNO', readOnly: false, width: 150}
			];
		};

		$scope.excelsettings = {
			contextMenu: ['row_above', 'row_below', 'remove_row'],
			minSpareRows: 1
		};

		// Excel
		$scope.renderExcelTable = function(){
			$timeout(function(){
				var hotDiv=angular.element("hot-table");
				if(hotDiv.isolateScope()){
					var hotInstance=hotDiv.isolateScope().hotInstance;

					var element = angular.element($document.find('#hot-container'));
					var height = element[0].offsetHeight;
					hotInstance.updateSettings({
						height: height,
						cells: function (row, col, prop) {
							var cellProperties = {};
							cellProperties.readOnly = !$scope.status.editing;
							return cellProperties;
						}
					});
					hotInstance.render();
				}
			},5);
		};



		// Columnas que va a mostra el excel (Requerido, si no se instancian no muestra nada)
		$scope.data.excelcolumns = buildExcelCols();

		// Color de las celdas en función de errores o no
		$scope.rendererColor = function(hotInstance, TD, row, col, prop, value, cellProperties) {
				TD.style.backgroundColor = value;
				TD.innerHTML = "";
			};

		var showErrorsInExcel = function(dataResult){
				$scope.data.excelDataErrors = [];
				$scope.data.lineasConError = [];
				$scope.data.lineasOK = 0;
				$scope.data.lineasConflicto = 0;
				$scope.data.lineasError = 0;
				angular.forEach(dataResult, function(data, i){
					var lineaOk = true;
					var results = [];

					if(data.ErrType == 2 || data.ErrType == 1)
						results.push(data.Msg);

					if(results.length == 0){
						results.push("OK");
					}

					var codigoColor;
					var errorMsg = {};
					if(data.ErrType == 0){
						codigoColor = "#008000";
						$scope.data.lineasOK++;
					} else if(data.ErrType == 2){
						lineaOk = false;
						codigoColor = "#FF0000";
						$scope.data.lineasError++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);

					} else if(data.ErrType == 1){
						lineaOk = true;
						codigoColor = "#FF9912";
						$scope.data.lineasConflicto++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);
					}

					if(ixUtilsService.isNotEmptyObject($scope.data.excelData[i])){
						$scope.data.excelData[i]["resultado_color"] = codigoColor;
						$scope.data.excelData[i]["resultado_msg"] = results.join("\n");
					}

					if(!lineaOk){
						$scope.data.lineasConError.push($scope.data.excelData[i]);
					}
				});
			};

		function trackUpdateJobProgress(job) {
				$scope.data.showResults = false;
				$scope.data.excelDataErrors = [];
				$scope.data.actualizando = true;
				$scope.$emit("loader_show");
				setProgressBarWidth(1);
				var hubProxy = apiHubService("ixJobHub", job);

				hubProxy.on('progressChanged', function (progress) {
					setProgressBarWidth(progress);
				});

				hubProxy.on('jobResult', function (result) {
					showErrorsInExcel(result.DetalleErrores);
				});

				hubProxy.on('jobCompleted', function (jobId) {
					$scope.data.showResults = true;
					$scope.$emit("loader_hide");

	//				if($scope.operacion == $scope.operaciones.ACTUALIZAR){
						if($scope.data.lineasConError.length > 0){
							$scope.data.mostrarBtnContinuarTraspaso = false;
							$scope.data.mostrarBtnContinuarErroneas = true;
						}
						else {
							$scope.data.mostrarBtnContinuarTraspaso = true;
							$scope.data.mostrarBtnContinuarErroneas = false;
						}

						$scope.hideCancelOnFilter = true;
						$scope.data.updatedTransfered = true;
	//				}

					hubProxy.closeConnection(hubProxy.getConnection());

					var msg = "";

	//				if($scope.operacion == $scope.operaciones.SIMULAR){
	//					msg = "Simulación terminada. Registros correctos: " + $scope.data.lineasOK;
	//				} else {
					msg = "Registros actualizados: " + $scope.data.lineasOK;
	//				}
					var responseObj = {
						status:200,
						data: {
							Result: true,
							GlobalMessage: {
								ErrType:0,
								Msg: msg,
								Property:null,
								TypeOfError:0
							}
						}
					};

					ixStatusService.setResponse(responseObj);
					$scope.data.showResults = true;
					$timeout(function() { delete($scope.data.ixProgress); }, 1000);
				});
			}

			function setProgressBarWidth(progress) {
				$scope.data.ixProgress = progress;
			}

			$scope.ixGuardar = function(){
				$scope.operacion = $scope.operaciones.ACTUALIZAR;
				var planificaciones = [];
				angular.forEach($scope.data.excelData, function(item){
					var plan = ObjKeyRename(item, {"0":"ft", "1":"ean_antiguo", "2":"ean_nuevo", "3":"cod_interno"});
					planificaciones.push(plan);
				});

				//var data = ixUtilsService.toJson($scope.data.excelData);
				var data = ixUtilsService.toJson(planificaciones);
				$http.post(cfg.baseURL + "fichas_tecnicas_productos/EansCodInternoMasivo?operacion="+$scope.operacion, data).then(function (r) {
					trackUpdateJobProgress(r.data);
				}, function(error){
					ixStatusService.setResponse(error);
				});
		};
	///////////////////////Fin Funciones excel////////////////////////////

	//================================================
	// Rename Objet's Keys [Copy]
	//   src : object - source obj
	//   map : object - rename map
	//           {"old1":"new1", "old2":"new2", ...}
	//================================================
	function ObjKeyRename(src, map) {
	    var dst = {};
	    // src --> dst (copy)
	    for(var key in src){
	        if(key in map)
	            // rename key
	            dst[map[key]] = src[key];
	        else
	            // same key
	            dst[key] = src[key];
	    }
	    return dst;
	}


		$scope.$on("$destroy", function() {
			$scope.isDestroyed=true;
		});
    }

}]);
angular.module('FTBase').controller('CambioEstadoMasivoController', ['$scope', 'ixStatusService', 'cfg', '$http', 'ixUtilsService', '$timeout', '$document', 'apiHubService', function ($scope, ixStatusService, cfg, $http, ixUtilsService, $timeout, $document, apiHubService) {
    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;

    //GestPark ofrece la opción de simular. De momento solo actualizaremos.
    $scope.operaciones = { SIMULAR: 1, ACTUALIZAR: 2 };

    $scope.init = function(){
        $scope.ixEditar = function(){
			ixStatusService.setEditing(true);
			$scope.renderExcelTable();
		};

		$scope.ixCancelEdit = function(){
			$scope.data.excelData = [];
		};

		///////////////////////Funciones excel////////////////////////////

		$scope.heightStyle = {'height': 'calc(100vh - 420px)'};

		$scope.data.excelData = [];

		// Columnas del excel a mostrar
		var buildExcelCols = function(){
			return [
				{title: 'FT', readOnly: false, width: 100 },
				{title: 'ESTADO', readOnly: false, width: 100 },
				{title: 'COMENTARIO CAMBIO ESTADO', readOnly: false, width: 250},
				{title: 'COMENTARIO BAJA VERSION ANTERIOR', readOnly: false, width: 250 },
				{title: 'FECHA', readOnly: false, width: 150,type:"date",value:'date', dateFormat:"DD/MM/YYYY",correctFormat: true,allowInvalid: false }
			];
		};

		$scope.excelsettings = {
			contextMenu: ['row_above', 'row_below', 'remove_row'],
			minSpareRows: 1
		};

		// Excel
		$scope.renderExcelTable = function(){
			$timeout(function(){
				var hotDiv=angular.element("hot-table");
				if(hotDiv.isolateScope()){
					var hotInstance=hotDiv.isolateScope().hotInstance;

					var element = angular.element($document.find('#hot-container'));
					var height = element[0].offsetHeight;
					hotInstance.updateSettings({
						height: height,
						cells: function (row, col, prop) {
							var cellProperties = {};
							cellProperties.readOnly = !$scope.status.editing;
							return cellProperties;
						}
					});
					hotInstance.render();
				}
			},5);
		};



		// Columnas que va a mostra el excel (Requerido, si no se instancian no muestra nada)
		$scope.data.excelcolumns = buildExcelCols();

		// Color de las celdas en función de errores o no
		$scope.rendererColor = function(hotInstance, TD, row, col, prop, value, cellProperties) {
				TD.style.backgroundColor = value;
				TD.innerHTML = "";
			};

		var showErrorsInExcel = function(dataResult){
				$scope.data.excelDataErrors = [];
				$scope.data.lineasConError = [];
				$scope.data.lineasOK = 0;
				$scope.data.lineasConflicto = 0;
				$scope.data.lineasError = 0;
				angular.forEach(dataResult, function(data, i){
					var lineaOk = true;
					var results = [];

					if(data.ErrType == 2 || data.ErrType == 1)
						results.push(data.Msg);

					if(results.length == 0){
						results.push("OK");
					}

					var codigoColor;
					var errorMsg = {};
					if(data.ErrType == 0){
						codigoColor = "#008000";
						$scope.data.lineasOK++;
					} else if(data.ErrType == 2){
						lineaOk = false;
						codigoColor = "#FF0000";
						$scope.data.lineasError++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);

					} else if(data.ErrType == 1){
						lineaOk = true;
						codigoColor = "#FF9912";
						$scope.data.lineasConflicto++;
						errorMsg = { error: data.Msg, total: 1 };
						$scope.data.excelDataErrors.push(errorMsg);
					}

					if(ixUtilsService.isNotEmptyObject($scope.data.excelData[i])){
						$scope.data.excelData[i]["resultado_color"] = codigoColor;
						$scope.data.excelData[i]["resultado_msg"] = results.join("\n");
					}

					if(!lineaOk){
						$scope.data.lineasConError.push($scope.data.excelData[i]);
					}
				});
			};

		function trackUpdateJobProgress(job) {
				$scope.data.showResults = false;
				$scope.data.excelDataErrors = [];
				$scope.data.actualizando = true;
				$scope.$emit("loader_show");
				setProgressBarWidth(1);
				var hubProxy = apiHubService("ixJobHub", job);

				hubProxy.on('progressChanged', function (progress) {
					setProgressBarWidth(progress);
				});

				hubProxy.on('jobResult', function (result) {
					showErrorsInExcel(result.DetalleErrores);
				});

				hubProxy.on('jobCompleted', function (jobId) {
					$scope.data.showResults = true;
					$scope.$emit("loader_hide");

	//				if($scope.operacion == $scope.operaciones.ACTUALIZAR){
						if($scope.data.lineasConError.length > 0){
							$scope.data.mostrarBtnContinuarTraspaso = false;
							$scope.data.mostrarBtnContinuarErroneas = true;
						}
						else {
							$scope.data.mostrarBtnContinuarTraspaso = true;
							$scope.data.mostrarBtnContinuarErroneas = false;
						}

						$scope.hideCancelOnFilter = true;
						$scope.data.updatedTransfered = true;
	//				}

					hubProxy.closeConnection(hubProxy.getConnection());

					var msg = "";

	//				if($scope.operacion == $scope.operaciones.SIMULAR){
	//					msg = "Simulación terminada. Registros correctos: " + $scope.data.lineasOK;
	//				} else {
					msg = "Registros actualizados: " + $scope.data.lineasOK;
	//				}
					var responseObj = {
						status:200,
						data: {
							Result: true,
							GlobalMessage: {
								ErrType:0,
								Msg: msg,
								Property:null,
								TypeOfError:0
							}
						}
					};

					ixStatusService.setResponse(responseObj);
					$scope.data.showResults = true;
					$timeout(function() { delete($scope.data.ixProgress); }, 1000);
				});
			}

			function setProgressBarWidth(progress) {
				$scope.data.ixProgress = progress;
			}

			$scope.ixGuardar = function(){
				$scope.operacion = $scope.operaciones.ACTUALIZAR;
				var planificaciones = [];
				angular.forEach($scope.data.excelData, function(item){
					var plan = ObjKeyRename(item, {"0":"ft", "1":"estado", "2":"coment_alta", "3":"coment_baja", "4":"fecha_aprobacion"});
					planificaciones.push(plan);
				});

				//var data = ixUtilsService.toJson($scope.data.excelData);
				var data = ixUtilsService.toJson(planificaciones);
				$http.post(cfg.baseURL + "extranet_fichas_tecnicas/CambioEstadoMasivo?operacion="+$scope.operacion, data).then(function (r) {
					trackUpdateJobProgress(r.data);
				}, function(error){
					ixStatusService.setResponse(error);
				});
		};
	///////////////////////Fin Funciones excel////////////////////////////

	//================================================
	// Rename Objet's Keys [Copy]
	//   src : object - source obj
	//   map : object - rename map
	//           {"old1":"new1", "old2":"new2", ...}
	//================================================
	function ObjKeyRename(src, map) {
	    var dst = {};
	    // src --> dst (copy)
	    for(var key in src){
	        if(key in map)
	            // rename key
				if(key == "4"){
					var fechacasteada = src[key].split("/");
	            	dst[map[key]] = new Date(parseInt(fechacasteada[2])+ "/" + parseInt(fechacasteada[1])+"/"+parseInt((fechacasteada[0])));
				}
				else dst[map[key]] = src[key];
	        else
	            // same key
				if(key == "4"){
					var fechacast = src[key].split("/");
	            	dst[map[key]] = new Date(parseInt(fechacast[2])+ "/" + parseInt(fechacast[1])+"/"+parseInt((fechacast[0])));
				}
				else dst[key] = src[key];
	    }
	    return dst;
	}

		$scope.$on("$destroy", function() {
			$scope.isDestroyed=true;
		});
    }

}]);
angular.module('FTBase')
.controller('DashboardFTController', [ '$scope', '$controller', function($scope, $controller){
  $scope.modulo = "fichas_tecnicas";
  $controller('DashboardController', { $scope: $scope});
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
/*eslint angular/no-private-call: 0*/
/*eslint angular/document-service: 0*/
/*global angular */
/*global convertDateStringsToDates*/
/*global ixGetPatchOperations*/
/*global saveAs*/
/*global CMP_EQ*/
/*global buildIxSearch*/
"use strict";

angular.module('FTBase').controller("GestionFichasTecnicasController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', 'gridService', '$timeout', 'ViewBuilderService', '$q', 'ixUtilsService', '$location', '$compile', '$log', '$window', '$rootScope', 'authService', '$filter', '$ngConfirm', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, gridService, $timeout, ViewBuilderService, $q, ixUtilsService, $location, $compile, $log, $window, $rootScope, authService, $filter, $ngConfirm) {
	$scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

	var usuario = authService.authentication.userName;

	if (angular.isUndefined($scope.data.fullItemsList))
		$scope.data.fullItemsList = {};

	$scope.data.firstLoad = true;

	$http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
		$scope.extranetUser = response.data;
		if ($scope.extranetUser.proveedor != null) {
			$scope.ixEditar = undefined;
			$scope.status.editing = false;
		}
		//if ($scope.pantallaBasePorProducto())
		//	$scope.status.onCloseGoTo = "ListadosFT/Listado_ProductosFt";
		//else
			//$scope.status.onCloseGoTo = "ListadosFT/Listado_Ft";
		$scope.status.onCloseGoTo = $scope.status.atributos.pantalla ;
	}, function (error) {
		ixStatusService.setResponse(error);
	});

	$scope.scrollBarConfig = {
		//		callbacks: {
		//			onTotalScrollBack:function(){
		//				$log.log("Scroll arriba del todo, cargar previa.");
		//				$scope.selectPreviousPage();
		//			},
		//			onTotalScroll:function(){
		//				$log.log("Scrolled abajo del todo, carga siguiente.");
		//				$scope.selectNextPage();
		//			}
		//		}
	};

	$scope.duplicarFt = function (n) {
		var template = "app/FTBase/GestionFichasTecnicas/acciones/duplicarFT_popup.html";
		var optionsPopup = { controller: "DuplicarFtPopupController" };
		var paramsPopup = { ft_origen: $scope.data.id_ficha_tecnica, ft_tipo: $scope.data.datos.ft_cabecera.ft_version, niveles: n };
		ixUtilsService.openModalV2(template, optionsPopup, "small", paramsPopup);
	};

	$scope.versionarFt = function () {
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas/VersionarFT?ft_origen=" + $scope.data.id_ficha_tecnica).then(function (response) {
			ixStatusService.setResponse(response);
		}, function (err) {
			ixStatusService.setResponse(err);
		});
	};

	$scope.imprimirFt = function (tipo_doc, reducida) {
		var config = { responseType: 'arraybuffer' };
		$http.get(cfg.baseURL + "impresos/impresoFT/?idft=" + $scope.data.id_ficha_tecnica + "&docformat=" + tipo_doc + "&reducido=" + reducida, config).then(function (response) {

			var file = new Blob([response.data], { type: 'application/zip' });

			var filename = "ImpresosFichaTecnica_" + $scope.data.id_ficha_tecnica.replace("/", "-") + ".zip";
			if (response.headers('Content-Disposition')) {
				filename = response.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	};

	$scope.imprimirFtRevision = function () {
		var config = { responseType: 'arraybuffer' };
		$http.get(cfg.baseURL + "impresos/ImpresoRevisionFT/?idft=" + $scope.data.id_ficha_tecnica, config).then(function (response) {

			var file = new Blob([response.data], { type: 'application/pdf' });

			var filename = "ImpresoRevision_" + $scope.data.id_ficha_tecnica.replace("/", "-") + ".pdf";
			if (response.headers('Content-Disposition')) {
				filename = response.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	};

	$scope.isFirst = function () {
		return ($scope.getCurrentPage() < 1);
	};

	$scope.isLast = function () {
		return ($scope.getCurrentPage() == angular.element("div.listEditResult").length - 1);
	};

	//¿Qué indices debo de poner para comentarios y log? (YVES - 2/12/2019)
	$scope.getCurrentPage = function () {
		var idx = -1;
		if ($scope.data.pantalla == "cabecera")
			idx = 0;
		else if ($scope.data.pantalla == "ficheros")
			idx = 1;
		else if ($scope.data.pantalla == "proveedor")
			idx = 2;
		else {
			var element = angular.element("div.listEditResult.bg-info");
			if (angular.isDefined(element[0]))
				idx = Array.from(angular.element("div.listEditResult")).indexOf(element[0]);
		}
		return idx;
	};

	$scope.selectPreviousPage = function () {
		var currentTabIdx = $scope.getCurrentPage();
		$scope.fromBtn = true;
		$timeout(function () {
			angular.element("div.listEditResult")[currentTabIdx - 1].click();
		}, 1);
	};

	$scope.selectNextPage = function () {
		var currentTabIdx = $scope.getCurrentPage();
		$scope.fromBtn = true;
		$timeout(function () {
			angular.element("div.listEditResult")[currentTabIdx + 1].click();
		}, 1);
	};

	$scope.$parent.$parent.$parent.changeWhileEditing = true;

	if (angular.isDefined($routeParams.id_fichas_tecnicas)) {
		$scope.data.id_fichas_tecnicas = $routeParams.id_fichas_tecnicas;
		$scope.data.id_ficha_tecnica = $scope.data.id_fichas_tecnicas[0];
	}
	else
		$scope.data.id_ficha_tecnica = $routeParams.id_ficha_tecnica;

	if ($routeParams.idioma) {
		$scope.data.idioma = $routeParams.idioma;
		$scope.data.modoTraduccion = true;
	}

	convertDateStringsToDates($scope.miFt);

	$scope.data.activeTabFicheros = 0;
	$scope.data.activeTabComentarios = 0;

	$scope.data.ixReadOnly = true;
	$scope.gridManualLoad = true;

	var timer;
	var lastBusqueda = "";

	$scope.TARJETA_CREMA = 'rgb(248, 203, 173)';
	$scope.TARJETA_VERDE = 'rgb(255, 255, 255)'; // 'rgb(169, 209, 142)';
	$scope.TARJETA_VERDE_OSCURO = 'rgb(4, 180, 49)';
	$scope.TARJETA_AZUL = 'rgb(180, 199, 231)';

	$scope.data.pk = "id";
	$scope.data.tituloCabecera = "ficha";

	$scope.$parent.$parent.$parent.ixCancelEdit = function () {
		//FUNCION CUSTOM
		delete ixStatusService.current.response; //?
		//Volver a poner datos cabecera como estaban
		$scope.data.datos.ft_cabecera = angular.copy($scope.data.ft_cabecera_original);
		//TODO: volver a poner grids tal y como estaban
		$scope.data.gridProductosFT.ixCancelEdit(true);
		if (angular.isDefined($scope.data.gridComentariosFt)){
			$scope.data.gridComentariosFt.ixCancelEdit();
			$scope.data.gridComentariosFt.ixLoadInitialData();
		}
		if (angular.isDefined($scope.data.gridComentariosInternosFt)){
			$scope.data.gridComentariosInternosFt.ixCancelEdit();
			$scope.data.gridComentariosInternosFt.ixLoadInitialData();
		}

		ixStatusService.setEditing(false);
	};

	$scope.ixGuardar = function () {
		$log.log("guardar datos");
		var param = {};
		param.jpdFichaTecnica = ixGetPatchOperations($scope.data.ft_cabecera_original, $scope.data.datos.ft_cabecera);
		param.traducir_completa = null;
		if ($scope.data.gridProductosFT) param.ubpProductos = $scope.data.gridProductosFT.ixGetBulkParam();
		//param.ubpFicherosFichaTecnica = $scope.data.gridFicherosFT.ixGetBulkParam();
		param.ubpComentariosFichaTecnica = {
			ToDelete: [],
			ToInsert: [],
			ToUpdate: []
		};
		if ($scope.data.gridComentariosFt){
			var bulkComentarios = $scope.data.gridComentariosFt.ixGetBulkParam();
	
			param.ubpComentariosFichaTecnica.ToDelete = param.ubpComentariosFichaTecnica.ToDelete.concat(bulkComentarios.ToDelete || []);
			param.ubpComentariosFichaTecnica.ToInsert = param.ubpComentariosFichaTecnica.ToInsert.concat(bulkComentarios.ToInsert || []);
			param.ubpComentariosFichaTecnica.ToUpdate = param.ubpComentariosFichaTecnica.ToUpdate.concat(bulkComentarios.ToUpdate || []);
		}
		if ($scope.data.gridComentariosInternosFt){
			var bulkComentariosInternos = $scope.data.gridComentariosInternosFt.ixGetBulkParam();
	
			param.ubpComentariosFichaTecnica.ToDelete = param.ubpComentariosFichaTecnica.ToDelete.concat(bulkComentariosInternos.ToDelete || []);
			param.ubpComentariosFichaTecnica.ToInsert = param.ubpComentariosFichaTecnica.ToInsert.concat(bulkComentariosInternos.ToInsert || []);
			param.ubpComentariosFichaTecnica.ToUpdate = param.ubpComentariosFichaTecnica.ToUpdate.concat(bulkComentariosInternos.ToUpdate || []);
		}

		var path = cfg.baseURL + "extranet_fichas_tecnicas/PutFichaTecnica?id_ficha=" + $scope.data.id_ficha_tecnica;

		if ($scope.data.modoTraduccion) {
			// path = cfg.baseURL + "extranet_fichas_tecnicas_idioma/" + $scope.data.id_ficha_tecnica + "/" + $scope.data.idioma;
			path = cfg.baseURL + "extranet_fichas_tecnicas_idioma/PutFichaTecnicaIdioma?id=" + $scope.data.id_ficha_tecnica + "&idioma=" + $scope.data.idioma;
			if ($scope.data.estado_traduccion_original != $scope.data.datos.estado_traduccion)
				param.jpdFichaTecnica.push({
					value: $scope.data.datos.estado_traduccion,
					path: "/estado",
					op: "replace"
				});
			param = param.jpdFichaTecnica;
		}
		else {
			//Si ha cambiado la opción de traducir completa, paso la información
			param.traducir_completa = $scope.data.datos.traducir_completa;
		}

		$http.put(path, param).then(function (r) {
			ixStatusService.setResponse(r);
			//Si he modificado el estado de bloqueo para la tarjeta proveedores debo actualizar el bloqueo general
			$scope.verificarBloqueoTodaFt();
			
			if ($scope.data.modoTraduccion) {
				$scope.data.estado_traduccion_original = r.data.obj.Record.estado;
			}
			else {
				$scope.data.traducir_completa_original = $scope.data.datos.traducir_completa;
				$scope.data.datos.ft_cabecera = r.data.obj.Record;
				$scope.data.ft_cabecera_original = angular.copy($scope.data.datos.ft_cabecera);
			}
			$scope.data.gridProductosFT.clearGridAfterSave();
			$scope.data.gridProductosFT.ixLoadInitialData();
			ixStatusService.setEditing(false);
			if ($scope.data.forzarCargaGridFicherosProveedor) {
				if ($scope.data.gridFicherosProveedor) $scope.data.gridFicherosProveedor.ixLoadInitialData();
				//YVES, queda por terminar la recarga, comenta la linea que sobreescribe el ixLoadInitialData de gridPlantasFabricante y haz que se llame la función que has preparado.
				if ($scope.data.gridPlantasFabricante) $scope.data.gridPlantasFabricante.ixLoadInitialData();
			}
			if ($scope.data.gridComentariosFt){
				$scope.data.gridComentariosFt.clearGridAfterSave();
				$scope.data.gridComentariosFt.ixLoadInitialData();
			}
			if ($scope.data.gridComentariosInternosFt && $scope.tienePerfilAdmin()){
				$scope.data.gridComentariosInternosFt.clearGridAfterSave();
				$scope.data.gridComentariosInternosFt.ixLoadInitialData();
			}
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	};

	$scope.getFocusedRow = function () {
		var ingredienteFocus = "";
		if ($scope.data.gridJerarquico.gridApi) {
			var focusedCell = $scope.data.gridJerarquico.gridApi.cellNav.getFocusedCell();
			if (focusedCell) {
				var row = focusedCell.row;
				ingredienteFocus = row.entity.ingredientes;
			}
		}
		return ingredienteFocus;
	};

	$scope.addRow = function (grid) {
		grid.ixAddRow();
	};

	$scope.addRowComentarioFt = function (grid,es_Interno) {
		var nuevo = {};
		nuevo.idficha = $scope.data.datos.ft_cabecera.id;
		nuevo.usu = 0;
		nuevo.es_Interno = es_Interno;
		grid.ixAddRow(nuevo);
	}


	$scope.addRowFromList = function (grid) {
		var template = "app/FTBase/GestionFichasTecnicas/acciones/add_elementos_saludables_popup.html";
		var optionsPopup = { controller: "AddElementosSaludablesPopupController" };
		var params = { listelements: $scope.listaElementosSaludables };
		ixUtilsService.openModalV2(template, optionsPopup, "small", params).then(function (response) {
			angular.forEach(response.rows, function (row) {
				var existeElemento = grid.data.find(function (e) { return e.propiedad_saludable == row.label; });

				if (angular.isUndefined(existeElemento))
					grid.ixAddRow({ propiedad_saludable: row.label });
			});
		});
	};

	$scope.openPopupFicheros = function (grid, tipo) {
		var template = "app/FTBase/GestionFichasTecnicas/acciones/upload_file_popup.html";
		var optionsPopup = { controller: "UploadFilePopupController" };
		var paramsPopup = { tipo: tipo, id_ft: $scope.data.id_ficha_tecnica };
		var popup = ixUtilsService.openModalV2(template, optionsPopup, "small", paramsPopup);
		popup.then(function (data) {
			if (tipo != "ficheros_ft") {
				grid.ixAddRow(data.obj.Record);
			}
			else {
				//recargar grid ficheros

				$http.post(cfg.baseURL + "fichas_tecnicas_ficheros/SearchByIdFt?id_ft=" + $scope.data.id_ficha_tecnica).then(function (response) {
					$scope.data.datos.ft_ficheros_fichas_tecnicas = response.data;
					$scope.data.fullItemsList[$scope.data.id_ficha_tecnica].ft_ficheros_fichas_tecnicas = $scope.data.datos.ft_ficheros_fichas_tecnicas;
					grid.ixLoadInitialData();
				},
					function (error) {
						$log.log("ERROR Popup Ficheros: ", error);
					});
			}
		});
	};

	$scope.$parent.$parent.$parent.tienePerfilAdmin = authService.tienePerfilAdmin;

	$scope.bloquearTodasPreguntasFt = function (bulkUpdateTotal, bloquear) {
		if (angular.isUndefined(bulkUpdateTotal)) {
			bulkUpdateTotal = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
		}

		angular.forEach($scope.data.list, function (item) {
			var itemsToSkip = ["home", "paperclip", "industry", "comments", "database"];
			if (!itemsToSkip.includes(item.icono)) {
				var bulkUpdate = $scope.bloquearRecursivamente(bulkUpdate, $scope.getObjSeleccionado(item), bloquear);
				$scope.bloquearRecursivamente(undefined, item, bloquear);
				bulkUpdateTotal.ToUpdate = bulkUpdateTotal.ToUpdate.concat(bulkUpdate.ToUpdate);
			}
		});

		return bulkUpdateTotal;
	};

	$scope.verificarBloqueoTarjetasPadre = function (item) {
		if (item.nivel2) {
			var tarjetaPadre = $scope.data.list.find(function (n) { return n.nivel1 == item.nivel1 && !n.nivel2; });
			var setBloqueo = 1;
			angular.forEach(tarjetaPadre.subniveles, function (t) {
				if (t.bloqueado == 0) setBloqueo = 0;
			});
			tarjetaPadre.bloqueado = setBloqueo;
		}
	};


	$scope.verificarBloqueoTodaFt = function () {
		var itemsToSkip = ["home", "paperclip", "industry", "comments", "database"];
		var tarjetaHome = $scope.data.list.find(function (n) { return n.icono == "home"; });
		var setBloqueo = 1;
		angular.forEach($scope.data.list, function (item) {
			if (!itemsToSkip.includes(item.icono)) {
				if (item.bloqueado == 0) setBloqueo = 0;
			}
		});

		tarjetaHome.bloqueado = setBloqueo && $scope.data.datos.ft_cabecera.bloqueo_datos_proveedor;
		tarjetaHome.bloqueado = setBloqueo && $scope.data.datos.ft_cabecera.bloqueo_datos_ficheros;
	};

	$scope.$parent.$parent.$parent.bloquearPreguntas = function (ev, item, bloquear) {
		ev.stopPropagation();
		if (item.icono == 'home') {
			//Bloqueo total de la ficha técnica
			$log.log("Bloquear todas las preguntas FT");
			item.bloqueado = bloquear;
			//BLOQUEAR/DESBLOQUEAR Tarjeta Proveedores
			//TODO
			if (bloquear){
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 1;
				$scope.data.datos.ft_cabecera.bloqueo_datos_ficheros = 1;
			}
			else{
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 0;
				$scope.data.datos.ft_cabecera.bloqueo_datos_ficheros = 0;
			}
				

			var tarjetaProveedores = $scope.data.list.find(function (n) { return n.icono == "industry"; });
			tarjetaProveedores.bloqueado = bloquear;
			var tarjetaFicheros = $scope.data.list.find(function (n) { return n.icono == "paperclip"; });
			tarjetaFicheros.bloqueado = bloquear;
			$scope.ixGuardar();

			//BLOQUEO/DESBLOQUEO Preguntas
			var bulkUpdateTotal = $scope.bloquearTodasPreguntasFt(bulkUpdateTotal, bloquear);
			$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/UpdateBulk", bulkUpdateTotal).then(function (response) {
				ixStatusService.setResponse(response);
			}, function (err) {
				ixStatusService.setResponse(err);
				item.bloqueado = !bloquear;
				$scope.bloquearTodasPreguntasFt(bulkUpdateTotal, !bloquear);
			});
		}
		else if (item.icono == 'paperclip') {
			$log.log("Bloquear datos ficheros (TODO)");
			if (bloquear)
				$scope.data.datos.ft_cabecera.bloqueo_datos_ficheros = 1;
			else
				$scope.data.datos.ft_cabecera.bloqueo_datos_ficheros = 0;
			item.bloqueado = bloquear;
			$scope.ixGuardar();
		}
		else if (item.icono == 'industry') {
			$log.log("Bloquear datos plantas-fabricantes (TODO)");
			if (bloquear)
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 1;
			else
				$scope.data.datos.ft_cabecera.bloqueo_datos_proveedor = 0;
			item.bloqueado = bloquear;
			$scope.ixGuardar();
		}
		else { //Tarjetas preguntas
			var bulkUpdate = $scope.bloquearRecursivamente(bulkUpdate, $scope.getObjSeleccionado(item), bloquear);
			$scope.bloquearRecursivamente(undefined, item, bloquear);
			$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/UpdateBulk", bulkUpdate).then(function (response) {
				ixStatusService.setResponse(response);
				$scope.verificarBloqueoTarjetasPadre(item);
				$scope.verificarBloqueoTodaFt();
			}, function (err) {
				ixStatusService.setResponse(err);
				$scope.bloquearRecursivamente(bulkUpdate, item, !bloquear);
				$scope.bloquearRecursivamente(undefined, $scope.getObjSeleccionado(item), !bloquear);
			});
		}
	};

	$scope.getObjSeleccionado = function (item) {
		var ficha_tecnica = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica];

		if (angular.isDefined(ficha_tecnica)) {
			var obj_seleccionado = ficha_tecnica.tarjetas.find(function (e) { return e.nivel1 == item.nivel1 });
			if (item.nivel2)
				obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel2 == item.nivel2 });
			if (item.nivel3)
				obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel3 == item.nivel3 });

			item = obj_seleccionado;
		}

		return item;
	};


	$scope.bloquearRecursivamente = function (bulkUpdate, item, bloquear) {
		//bloqueamos tarjeta.
		item.bloqueado = bloquear;
		if (angular.isUndefined(bulkUpdate)) {
			bulkUpdate = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			}
		}
		angular.forEach(item.subniveles, function (subnivel) {
			$scope.bloquearRecursivamente(bulkUpdate, subnivel, bloquear);
		});
		angular.forEach(item.preguntas, function (pregunta) {
			angular.forEach(pregunta.respuestas, function (respuesta) {
				//bloquemos todas las preguntas de la tarjeta.
				respuesta.bloqueado = bloquear;
				bulkUpdate.ToUpdate.push({
					PK: { id: respuesta.id },
					PocoToUpdate: [
						{
							value: item.bloqueado,
							path: "/bloqueado",
							op: "replace"
						},
						{
							value: true,
							path: "/disable_before_after",
							op: "replace"
						}
					]
				});
			});
		});
		return bulkUpdate;
	};
	$scope.$on('NUEVO_FICHERO', function (event, data) {
		//TODO: Cargar todos los nuevos ficheros (en caso de asociación con más productos)
		if (angular.isDefined($scope.data.gridFicherosFT))
			$scope.data.gridFicherosFT.ixAddRow(data);
		else
			$scope.data.datos.ft_ficheros_fichas_tecnicas.push(data);
	});

	$scope.refreshCurrentCardContent = function () {
		var aux = angular.copy($scope.data.currentPreguntasTab);
		$scope.data.currentPreguntasTab = "";
		$timeout(function () {
			$scope.data.currentPreguntasTab = aux;
		}, 0);
	};

	//Solo se utiliza en el modo traduccion
	$scope.soloPreguntasPdt = function () {
		$scope.data.solo_preguntas_pdt = true;
		$scope.refreshCurrentCardContent();
		getListElements("PENDIENTES");
	};

	//Solo se utiliza en el modo traduccion pero se podría usar en ambos modos.
	$scope.soloCardsPdt = function () {
		$scope.data.solo_preguntas_pdt = false;
		$scope.refreshCurrentCardContent();
		getListElements("PENDIENTES");
	};

	$scope.verTodasCards = function () {
		$scope.data.solo_preguntas_pdt = false;
		$scope.refreshCurrentCardContent();
		getListElements();
	};

	$scope.$on('RECALCULAR_CUMPLIMENTACION', function (event, data) {
		//identificar tarjeta con los niveles e ir decrementando.
		var incrementar = null;
		if (data.newValue && !data.oldValue) {
			//incrementar uno
			incrementar = true;
			$scope.data.list[0].titulo4_valor = 1;
		} else if (!data.newValue && data.oldValue) {
			//decrementar uno.
			incrementar = false;
			$scope.data.list[0].titulo4_valor = 0;
		}

		if (incrementar != null) {
			var currentPreguntaParts = $scope.data.currentPreguntasTab.split("-");

			var tarjetaNivel1 = undefined;
			var tarjetaNivel2 = undefined;
			var tarjetaNivel3 = undefined;

			tarjetaNivel1 = $scope.data.list.find(function (e) { return e.nivel1 == currentPreguntaParts[0]; });
			if (currentPreguntaParts[1] && tarjetaNivel1 && tarjetaNivel1.subniveles) {
				tarjetaNivel2 = tarjetaNivel1.subniveles.find(function (e) { return e.nivel2 == currentPreguntaParts[1]; });
				if (currentPreguntaParts[2] && tarjetaNivel2 && tarjetaNivel2.subniveles)
					tarjetaNivel3 = tarjetaNivel2.subniveles.find(function (e) { return e.nivel3 == currentPreguntaParts[2]; });
			}

			if (angular.isDefined(tarjetaNivel1)) {
				if (incrementar)
					tarjetaNivel1.titulo4_valor++;
				else
					tarjetaNivel1.titulo4_valor--;
			}
			if (angular.isDefined(tarjetaNivel2)) {
				if (incrementar)
					tarjetaNivel2.titulo4_valor++;
				else
					tarjetaNivel2.titulo4_valor--;
			}
			if (angular.isDefined(tarjetaNivel3)) {
				if (incrementar)
					tarjetaNivel3.titulo4_valor++;
				else
					tarjetaNivel3.titulo4_valor--;
			}

			$scope.calcularPorcentajeCumplimentacion();
			/*if (data.pregunta.obligatoria) {
				if (incrementar)
					$scope.data.datos.count_preguntas_obligatorias++
				else
					$scope.data.datos.count_preguntas_obligatorias--;
				$scope.calcularPorcentajeCumplimentacionObligatoria();
			}*/
		}
	});

	$scope.$on('RECALCULAR_CUMPLIMENTACION_GRID', function (event, data) {
		var currentPreguntaParts = $scope.data.currentPreguntasTab.split("-");

		var tarjetaNivel1 = undefined;
		var tarjetaNivel2 = undefined;
		var tarjetaNivel3 = undefined;

		tarjetaNivel1 = $scope.data.list.find(function (e) { return e.nivel1 == currentPreguntaParts[0]; });
		if (currentPreguntaParts[1] && tarjetaNivel1 && tarjetaNivel1.subniveles) {
			tarjetaNivel2 = tarjetaNivel1.subniveles.find(function (e) { return e.nivel2 == currentPreguntaParts[1]; });
			if (currentPreguntaParts[2] && tarjetaNivel2 && tarjetaNivel2.subniveles)
				tarjetaNivel3 = tarjetaNivel2.subniveles.find(function (e) { return e.nivel3 == currentPreguntaParts[2]; });
		}

		if (data.tipo_modificacion == "Add" || data.tipo_modificacion == "Delete") {
			var incrementar = false;
			if (data.tipo_modificacion == "Add") incrementar = true;

			if (angular.isDefined(tarjetaNivel1)) {
				if (incrementar) {
					if (data.newValue) tarjetaNivel1.titulo4_valor++;
					tarjetaNivel1.titulo4_valor2++;
				}
				else {
					if (tarjetaNivel1.titulo4_valor > 0) tarjetaNivel1.titulo4_valor--;
					tarjetaNivel1.titulo4_valor2--;
				}
			}
			if (angular.isDefined(tarjetaNivel2)) {
				if (incrementar) {
					if (data.newValue) tarjetaNivel2.titulo4_valor++;
					tarjetaNivel2.titulo4_valor2++;
				}
				else {
					if (tarjetaNivel2.titulo4_valor > 0) tarjetaNivel2.titulo4_valor--;
					tarjetaNivel2.titulo4_valor2--;
				}
			}
			if (angular.isDefined(tarjetaNivel3)) {
				if (incrementar) {
					if (data.newValue) tarjetaNivel3.titulo4_valor++;
					tarjetaNivel3.titulo4_valor2++;
				}
				else {
					if (tarjetaNivel3.titulo4_valor > 0) tarjetaNivel3.titulo4_valor--;
					tarjetaNivel3.titulo4_valor2--;
				}
			}

			$scope.calcularPorcentajeCumplimentacion();
		} else {
			var incrementarTodo = true;

			var tarjetaNivel1Full = undefined;
			var tarjetaNivel2Full = undefined;
			var tarjetaNivel3Full = undefined;

			tarjetaNivel1Full = $scope.data.fullList.find(function (e) { return e.nivel1 == currentPreguntaParts[0]; });
			if (currentPreguntaParts[1] && tarjetaNivel1 && tarjetaNivel1.subniveles) {
				tarjetaNivel2Full = tarjetaNivel1.subniveles.find(function (e) { return e.nivel2 == currentPreguntaParts[1]; });
				if (currentPreguntaParts[2] && tarjetaNivel2 && tarjetaNivel2.subniveles)
					tarjetaNivel3Full = tarjetaNivel2.subniveles.find(function (e) { return e.nivel3 == currentPreguntaParts[2]; });
			}
			var pregunta = {};

			if (angular.isDefined(tarjetaNivel3Full)) {
				for (var tn3 = 0; tn3 < tarjetaNivel3Full.preguntas.length; tn3++) {
					pregunta = tarjetaNivel3Full.preguntas[tn3].pregunta;

					if (pregunta.id_pregunta == data.pregunta.id_pregunta && pregunta.orden_bucle == data.pregunta.orden_bucle) {
						if (pregunta.resultados_fijos == 1) incrementarTodo = false;
						else incrementarTodo = $scope.IsCompleted(pregunta, data.pregunta);
						break;
					}
				}
			}
			else if (angular.isDefined(tarjetaNivel2Full)) {
				for (var tn2 = 0; tn2 < tarjetaNivel2Full.preguntas.length; tn2++) {
					pregunta = tarjetaNivel2Full.preguntas[tn2].pregunta;

					if (pregunta.id_pregunta == data.pregunta.id_pregunta && pregunta.orden_bucle == data.pregunta.orden_bucle) {
						if (pregunta.resultados_fijos == 1) incrementarTodo = false;
						else incrementarTodo = $scope.IsCompleted(pregunta, data.pregunta);
						break;
					}
				}
			}
			else if (angular.isDefined(tarjetaNivel1Full)) {
				for (var tn1 = 0; tn1 < tarjetaNivel1Full.preguntas.length; tn1++) {
					pregunta = tarjetaNivel1Full.preguntas[tn1].pregunta;

					if (pregunta.id_pregunta == data.pregunta.id_pregunta && pregunta.orden_bucle == data.pregunta.orden_bucle) {
						if (pregunta.resultados_fijos == 1) incrementarTodo = false;
						else incrementarTodo = $scope.IsCompleted(pregunta, data.pregunta);
						break;
					}
				}
			}

			if (incrementarTodo) {
				if (angular.isDefined(tarjetaNivel1)) {
					tarjetaNivel1.titulo4_valor++;
				}
				if (angular.isDefined(tarjetaNivel2)) {
					tarjetaNivel2.titulo4_valor++;
				}
				if (angular.isDefined(tarjetaNivel3)) {
					tarjetaNivel3.titulo4_valor++;
				}
			}

			$scope.calcularPorcentajeCumplimentacion();
		}
	});

	$scope.calcularPorcentajeCumplimentacion = function () {
		var cumplimentadas = 0;
		var cumplimentadasObligatorias = 0;
		var totalPreguntas = 0;
		var totalPreguntasObligatorias = 0;

		var tarjetasPreguntas = $scope.data.fullList.filter(function (e) { return e.nivel1 != null; });
		for (var i = 0; i < tarjetasPreguntas.length; i++) {
			var tarjeta = tarjetasPreguntas[i];
			for (var j = 0; j < tarjeta.subniveles.length; j++) {
				var subniveles = tarjeta.subniveles[j];
				if (subniveles.preguntas == null) {
					for (var k = 0; k < subniveles.subniveles.length; k++) {
						var subsubnivel = subniveles.subniveles[k];
						for (var y = 0; y < subsubnivel.preguntas.length; y++) {
							var preguntasub = subsubnivel.preguntas[y];
							for (var x = 0; x < preguntasub.respuestas.length; x++) {
								var respuestasub = preguntasub.respuestas[x];
								totalPreguntas++;
								if ($scope.IsCompleted(preguntasub.pregunta, respuestasub)) cumplimentadas++;
								if (preguntasub.pregunta.obligatoria == 1) {
									if ($scope.IsCompleted(preguntasub.pregunta, respuestasub)) {
										cumplimentadasObligatorias++;
									}
									totalPreguntasObligatorias++;
								}
							}
						}
					}
				}
				else {
					for (var z = 0; z < subniveles.preguntas.length; z++) {
						var pregunta = subniveles.preguntas[z];
						for (var r = 0; r < pregunta.respuestas.length; r++) {
							var respuesta = pregunta.respuestas[r];
							totalPreguntas++;
							if ($scope.IsCompleted(pregunta.pregunta, respuesta)) cumplimentadas++;
							if (pregunta.pregunta.obligatoria == 1) {
								if ($scope.IsCompleted(pregunta.pregunta, respuesta)) {
									cumplimentadasObligatorias++;
								}
								totalPreguntasObligatorias++;
							}
						}
					}
				}
			}
		}
		$scope.data.list[0].titulo4_valor = $filter("number")(((cumplimentadas / totalPreguntas) * 100), 0);
		$scope.data.list[0].titulo5_valor = $filter("number")(((cumplimentadasObligatorias / totalPreguntasObligatorias) * 100), 0);
	};

	/*$scope.calcularPorcentajeCumplimentacionObligatoria = function () {
		$scope.data.list[0].titulo5_valor = $filter("number")((($scope.data.datos.count_preguntas_obligatorias / $scope.data.datos.total_preguntas_obligatorias) * 100), 0);
	};*/

	$scope.IsCompleted = function (ftp, eftd) {
		var answer_complete = true;
		if (ftp.id_pregunta == 1160 || ftp.id_pregunta == 1168 || ftp.id_pregunta == 1173 || ftp.id_pregunta == 1178) {
			answer_complete = answer_complete && (eftd.valor == null || eftd.valor == '');

			if (ftp.validar_sub_pregunta1 == 1) answer_complete = answer_complete && (eftd.sub_respuesta1 != null && eftd.sub_respuesta1 != '');
			if (ftp.validar_sub_pregunta2 == 1) answer_complete = answer_complete && (eftd.sub_respuesta2 != null && eftd.sub_respuesta2 != '');
			if (ftp.validar_sub_pregunta3 == 1) answer_complete = answer_complete && (eftd.sub_respuesta3 != null && eftd.sub_respuesta3 != '');

			if (eftd.sub_respuesta3 != null && eftd.sub_respuesta3 != '') {
				if (eftd.sub_respuesta3 === "No") {
					if (ftp.validar_sub_pregunta4 == 1) answer_complete = answer_complete && (eftd.sub_respuesta4 != null && eftd.sub_respuesta4 != '');
					if (ftp.validar_sub_pregunta5 == 1) answer_complete = answer_complete && (eftd.sub_respuesta5 != null && eftd.sub_respuesta5 != '');
					if (ftp.validar_sub_pregunta6 == 1) answer_complete = answer_complete && (eftd.sub_respuesta6 != null && eftd.sub_respuesta6 != '');
					if (ftp.validar_sub_pregunta7 == 1) answer_complete = answer_complete && (eftd.sub_respuesta7 != null && eftd.sub_respuesta7 != '');
					if (ftp.validar_sub_pregunta8 == 1) answer_complete = answer_complete && (eftd.sub_respuesta8 != null && eftd.sub_respuesta8 != '');
					if (ftp.validar_sub_pregunta9 == 1) answer_complete = answer_complete && (eftd.sub_respuesta9 != null && eftd.sub_respuesta9 != '');
					if (ftp.validar_sub_pregunta10 == 1) answer_complete = answer_complete && (eftd.sub_respuesta10 != null && eftd.sub_respuesta10 != '');
					if (ftp.validar_sub_pregunta11 == 1) answer_complete = answer_complete && (eftd.sub_respuesta11 != null && eftd.sub_respuesta11 != '');
					if (ftp.validar_sub_pregunta12 == 1) answer_complete = answer_complete && (eftd.sub_respuesta12 != null && eftd.sub_respuesta12 != '');
					if (ftp.validar_sub_pregunta13 == 1) answer_complete = answer_complete && (eftd.sub_respuesta13 != null && eftd.sub_respuesta13 != '');
					if (ftp.validar_sub_pregunta14 == 1) answer_complete = answer_complete && (eftd.sub_respuesta14 != null && eftd.sub_respuesta14 != '');
				}
			}
			else {
				answer_complete = false;
			}

			return answer_complete;
		}

		answer_complete = answer_complete && (eftd.valor != null && eftd.valor != '');

		if (ftp.validar_sub_pregunta1 == 1
			&& !(ftp.id_pregunta == 777 && (eftd.orden_bucle.Value == 5 || eftd.orden_bucle.Value == 6 || eftd.orden_bucle.Value == 9 || eftd.orden_bucle.Value == 10 || eftd.orden_bucle.Value == 11)))
			answer_complete = answer_complete && (eftd.sub_respuesta1 != null && eftd.sub_respuesta1 != '');

		if (ftp.validar_sub_pregunta2 == 1) answer_complete = answer_complete && (eftd.sub_respuesta2 != null && eftd.sub_respuesta2 != '');
		if (ftp.validar_sub_pregunta3 == 1) answer_complete = answer_complete && (eftd.sub_respuesta3 != null && eftd.sub_respuesta3 != '');
		if (ftp.validar_sub_pregunta4 == 1) answer_complete = answer_complete && (eftd.sub_respuesta4 != null && eftd.sub_respuesta4 != '');
		if (ftp.validar_sub_pregunta5 == 1) answer_complete = answer_complete && (eftd.sub_respuesta5 != null && eftd.sub_respuesta5 != '');
		if (ftp.validar_sub_pregunta6 == 1) answer_complete = answer_complete && (eftd.sub_respuesta6 != null && eftd.sub_respuesta6 != '');
		if (ftp.validar_sub_pregunta7 == 1) answer_complete = answer_complete && (eftd.sub_respuesta7 != null && eftd.sub_respuesta7 != '');
		if (ftp.validar_sub_pregunta8 == 1) answer_complete = answer_complete && (eftd.sub_respuesta8 != null && eftd.sub_respuesta8 != '');
		if (ftp.validar_sub_pregunta9 == 1) answer_complete = answer_complete && (eftd.sub_respuesta9 != null && eftd.sub_respuesta9 != '');
		if (ftp.validar_sub_pregunta10 == 1) answer_complete = answer_complete && (eftd.sub_respuesta10 != null && eftd.sub_respuesta10 != '');
		if (ftp.validar_sub_pregunta11 == 1) answer_complete = answer_complete && (eftd.sub_respuesta11 != null && eftd.sub_respuesta11 != '');
		if (ftp.validar_sub_pregunta12 == 1) answer_complete = answer_complete && (eftd.sub_respuesta12 != null && eftd.sub_respuesta12 != '');
		if (ftp.validar_sub_pregunta13 == 1) answer_complete = answer_complete && (eftd.sub_respuesta13 != null && eftd.sub_respuesta13 != '');
		if (ftp.validar_sub_pregunta14 == 1) answer_complete = answer_complete && (eftd.sub_respuesta14 != null && eftd.sub_respuesta14 != '');

		return answer_complete;

	}

	$scope.addRowFocus = function (grid, subcategoria) {
		if ((!subcategoria) || (subcategoria && !$scope.condicionSubcategoria($scope.data.gridJerarquico))) {
			var focusedCell = grid.gridApi.cellNav.getFocusedCell();
			var newRow = {};
			if (focusedCell && subcategoria) {
				var row = focusedCell.row;
				if (grid.data.indexOf(row.entity) != -1) {
					newRow.$$treeLevel = row.entity.$$treeLevel;
				}

				if (subcategoria) {
					newRow.$$treeLevel++;
					newRow.manuallyAdded = true;
				}

			} else {
				newRow.$$treeLevel = 0;
			}
			grid.ixAddRow(newRow);
			if ((focusedCell) && subcategoria) {
				if (row.treeNode.state == "collapsed") {
					$scope.expandGroup(row);
				}
				$scope.moveNewRowIntoGroup(grid, row);
			}
		}
	};

	$scope.expandGroup = function (row) {
		row.treeNode.state = "expanded";
	}

	$scope.deleteSelectedRows = function (grid, guardarCambios) {
		grid.ixDeleteSelectedRows();
		if (guardarCambios) {
			grid.ixGuardar();
		}
	};

	$scope.condicionSubcategoria = function (grid) {
		var disabled = false;
		if (grid.gridApi) {
			var focusedCell = grid.gridApi.cellNav.getFocusedCell();
			if (!focusedCell)
				disabled = true;
			else if (focusedCell.row.entity.$$treeLevel == 2)
				disabled = true;
		}
		return disabled;
	};

	$scope.deleteSelectedRowsJerarquico = function (grid) {
		$scope.selectChildrenRows();
		grid.ixDeleteSelectedRows();
	};

	$scope.moveNewRowIntoGroup = function (grid, row) {
		var newRow = grid.data[grid.data.length - 1];
		var from = grid.data.indexOf(row.entity);
		var to = from;
		while ((grid.data[to + 1]) && grid.data[to + 1].$$treeLevel > row.entity.$$treeLevel) {
			to++;
		}
		grid.data.splice(grid.data.length - 1, 1);
		grid.data.splice((to + 1), 0, newRow);
	};

	//sobreescrita la función
	$scope.$parent.$parent.$parent.cargarGrid = function () {
		var meta = [
			{ Name: 'categoria', Type: "string" },
			{ Name: 'subcategoria', Type: "string" },
			{ Name: 'nc', Type: "numeric", ColumnDescription: "% No conformidad" },
			{ Name: 'alarma', Type: "numeric", ColumnDescription: "Alarma", Control: "CheckBox" }

		];
		$scope.data.grid = gridService.createGrid($scope, "Mant_GestionFichasTecnicaGrid", { minWidth: 75, minRowsToShow: 5, enableCellEdit: false, enableFiltering: true, loadItemWhenSelect: true, metadata: meta });
		$scope.data.grid.columnDefs = [];
		$scope.data.grid.ixGetColsFromAPI();
		$scope.data.grid.data = getListElements();
	};

	$scope.marcarRecargaFicherosProveedor = function () {
		$scope.data.forzarCargaGridFicherosProveedor = true;
	};

	$scope.changeTabFicheros = function (idxTab) {
		$scope.data.activeTabFicheros = idxTab;
		switch (idxTab) {
			case 0:
				$scope.data.gridFicherosTab = 0;
				ixUtilsService.showGrid($scope.data.gridFicherosFT);
				break;
			case 1:
				//TODO: Redraw pivot:
				$scope.data.gridFicherosTab = 1;
				if (angular.isDefined($scope.data.gridFicherosProveedor))
					ixUtilsService.showGrid($scope.data.gridFicherosProveedor);
				else
					buildGridFicherosProveedor();
				if ($scope.data.forzarCargaGridFicherosProveedor) {
					$scope.data.forzarCargaGridFicherosProveedor = false;
					$scope.data.gridFicherosProveedor.ixLoadInitialData();
				}
				break;
			default:
				break;
		}
	};

	$scope.changeTabComentarios = function (idxTab) {
		$scope.data.activeTabComentarios = idxTab;
		switch (idxTab) {
			case 0:
				if (angular.isDefined($scope.data.gridComentariosFt)) {
					ixUtilsService.showGrid($scope.data.gridComentariosFt);
				} else {
					buildGridComentariosFt();
				}
				break;
			case 1:
				if (angular.isDefined($scope.data.gridComentariosInternosFt))
					ixUtilsService.showGrid($scope.data.gridComentariosInternosFt);
				else
					buildGridComentariosInternosFt();
				break;
			default:
				break;
		}
	};

	//Función recursiva para iterar lista de tarjetas y buscar en los títulos (YVES)
	var buscarEnSubniveles = function (el, modo) {
		var match = false;
		var resultado = [];
		if (el.subniveles) {
			/* PRUEBA YVES PARA BUSCAR EN TARJETAS SUBNIVELES */
			resultado = el.subniveles.filter(function (e) {
				//				return ((e.titulo1) && e.titulo1.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				//					((e.titulo2) && e.titulo2.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				//					((e.titulo2_valor) && e.titulo2_valor.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				//					((e.titulo3) && e.titulo3.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
				//					((e.subniveles) && buscarEnSubniveles(e).length > 0);
				return ((e.subniveles) && buscarEnSubniveles(e, modo).length > 0) || $scope.filterAlgorithmSelector(e, modo);

			});
			/* FIN PRUEBA YVES PARA BUSCAR EN TARJETAS SUBNIVELES */
		}
		el.subniveles = resultado;
		return el.subniveles;
	};
	//FIN Función recursiva para iterar lista de tarjetas y buscar en los títulos (YVES)

	$scope.cambiarFicha = function (ficha_tecnica, activeTab) {
		var firstLoad = false;
		if (angular.isUndefined($scope.data.fullItemsList[ficha_tecnica]))
			firstLoad = true;

		$scope.data.activeTabFichaTecnica = activeTab;

		$scope.data.id_ficha_tecnica = ficha_tecnica;

		if (angular.isDefined($scope.data.fullItemsList[$scope.data.id_ficha_tecnica]))
			$scope.data.fullList = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica].tarjetas;
		else
			$scope.data.fullList = [];

		getListElements();
		var currentTabIdx = $scope.getCurrentPage();
		$scope.fromBtn = true;
		$timeout(function () {
			angular.element("div.listEditResult")[currentTabIdx].click();
			if (!firstLoad)
				$scope.refreshCurrentCardContent();
		}, 1);
	}

	$scope.setDatosCabecera = function (data) {
		$scope.data.datos = {
			id: data.ft_cabecera.id,
			count_preguntas_obligatorias: data.count_preguntas_obligatorias,
			total_preguntas_obligatorias: data.total_preguntas_obligatorias,
			ft_cabecera: data.ft_cabecera,
			ft_ficheros_fichas_tecnicas: data.ft_ficheros_fichas_tecnicas,
			ft_ficheros_proveedores: data.ft_ficheros_proveedores,
			ft_productos: data.ft_productos,
			plantas_asociadas: data.plantas_asociadas,
			comentarios: data.comentarios,
			estado_traduccion: data.estado_traduccion,
			traducir_completa: data.traducir_completa
		};
	};

	//Sobreescrita la función ya que no vamos a acceder API para cargar los datos.
	var getListElements = function (modo) {
		if (angular.isUndefined($scope.data.fullList))
			$scope.data.fullList = [];
		var list = [];
		if ($scope.data.fullList.length == 0) {
			var path = cfg.baseURL + "ft_data?id_ft=" + $scope.data.id_ficha_tecnica;
			if ($scope.data.idioma)
				path += "&idioma_traduccion=" + $scope.data.idioma;

			$http.get(path).then(function (response) {
				$scope.data.fullItemsList[$scope.data.id_ficha_tecnica] = response.data;
				$scope.data.fullList = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica].tarjetas;

				$scope.excluirTarjetasRestringidas();

				list = angular.copy($scope.data.fullList);
				$scope.setDatosCabecera($scope.data.fullItemsList[$scope.data.id_ficha_tecnica]);

				$scope.data.ft_cabecera_original = angular.copy($scope.data.datos.ft_cabecera);
				$scope.data.ft_productos_original = angular.copy($scope.data.datos.ft_productos);
				if ($scope.data.modoTraduccion) {
					$scope.data.estado_traduccion_original = $scope.data.datos.estado_traduccion;
				}
				else {
					$scope.data.traducir_completa_original = $scope.data.datos.traducir_completa;
				}
				$scope.data.datos.comentariosInternos = angular.copy(response.data.comentariosInternos);

				if ($scope.data.busqueda || angular.isDefined(modo)) {
					list = list.filter(function (e) {
						//						return (
						//						((e.titulo1) && e.titulo1.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
						//						((e.titulo2) && e.titulo2.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
						//						((e.titulo2_valor) && e.titulo2_valor.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
						//						((e.subniveles) && buscarEnSubniveles(e).length > 0)
						//						);
						return ((e.subniveles) && buscarEnSubniveles(e, modo).length > 0) || $scope.filterAlgorithmSelector(e, modo);
					});
				}
				$scope.data.list = list;
				$scope.data.loaded = true;
				if ($scope.data.firstLoad) {
					$timeout(function () {
						$scope.selectNextPage();
					},300);
					$scope.data.firstLoad = false;
				}

			});
		} else {
			$scope.setDatosCabecera($scope.data.fullItemsList[$scope.data.id_ficha_tecnica]);
			list = angular.copy($scope.data.fullList);
			if ($scope.data.busqueda || angular.isDefined(modo))
				list = list.filter(function (e) {
					//						return (
					//						((e.titulo1) && e.titulo1.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
					//						((e.titulo2) && e.titulo2.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
					//						((e.titulo2_valor) && e.titulo2_valor.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1) ||
					//						((e.subniveles) && buscarEnSubniveles(e).length > 0)
					//					);
					return ((e.subniveles) && buscarEnSubniveles(e, modo).length > 0) || $scope.filterAlgorithmSelector(e, modo);
				});
			$scope.data.list = list;
		}
	};

	$scope.filterAlgorithmSelector = function (e, modo) {
		var busqueda = $scope.data.busqueda || "";
		if (modo == "PENDIENTES") {
			return (
				(ixUtilsService.comparar(e.titulo1, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo2, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo2_valor, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo3, busqueda) != -1)) &&
				(parseInt(e.titulo4_valor) < parseInt(e.titulo4_valor2));
		}
		else {
			return (
				(ixUtilsService.comparar(e.titulo1, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo2, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo2_valor, busqueda) != -1) ||
				(ixUtilsService.comparar(e.titulo3, busqueda) != -1)
				//((e.subniveles) && buscarEnSubniveles(e).length > 0)
			);
		}
	};

	$scope.listaElementosSaludables = [
		{ id: 1, label: "Light Azúcar", selected: 0 },
		{ id: 2, label: "Light Grasa", selected: 0 },
		{ id: 3, label: "Sin azúcaras añadidos. Contiene azúcaras naturalmente presentes", selected: 0 },
		{ id: 4, label: "Sin lactosa", selected: 0 }
	];

	$scope.$parent.$parent.$parent.actualizarListado = function (forzarActualizacion) {
		if (angular.isUndefined($scope.data.list) || forzarActualizacion) {
			$scope.data.list = [];
			$scope.data.loaded = false;
		}
		if (timer) { $timeout.cancel(timer); }
		timer = $timeout(function () {
			getListElements();
			/*
			$scope.data.list = getListElements();
			if($scope.data.busqueda)
				$scope.data.list = $scope.data.list.filter(function(e){ return (
					e.nivel1nombre.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1 ||
					e.nivel2nombre.toLowerCase().indexOf($scope.data.busqueda.toLowerCase()) != -1);
																															});
			$scope.data.loaded = true;
			*/
		}, 350);
		lastBusqueda = $scope.data.busqueda;
	};

	$scope.tieneCabeceraNoVisible = function () {
		var perfilesRestringidos = ["usr_laboratorio", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};

	$scope.tieneFicherosNoVisible = function () {
		var perfilesRestringidos = ["usr_laboratorio", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};

	$scope.compruebaRestricciones = function (perfilesRestringidos) {
		var perfilRestringido = false;
		var perfilesUsuario = authService.perfilesUsuario();

		angular.forEach(perfilesUsuario, function (perfil) {
			if (perfilesRestringidos.indexOf(perfil) != -1)
				perfilRestringido = true;
		});
		return perfilRestringido;
	}

	$scope.guardarConfigGridsActivos = function () {
		var num_card_activa = ixStatusService.current.data.currentPreguntasTab;
		if (num_card_activa) {
			var ajuste_tarjetas = 0; //Sirve para ajustar indice de tarjetas visibles y evitar errores para perfiles que no visualizan algunas tarjetas
			if ($scope.tieneCabeceraNoVisible()) ajuste_tarjetas++;
			if ($scope.tieneFicherosNoVisible()) ajuste_tarjetas++;
			var partes_card_activa = num_card_activa.split('-');
			var card_activa = undefined;

			if (partes_card_activa[0] != "null") {
				card_activa = ixStatusService.current.data.list[parseInt(partes_card_activa[0]) + 1 - ajuste_tarjetas];
				if (partes_card_activa[1] != "null") {
					card_activa = card_activa.subniveles[parseInt(partes_card_activa[1]) - 1];
					if (partes_card_activa[2] != "null") {
						card_activa = card_activa.subniveles[parseInt(partes_card_activa[2]) - 1];
					}
				}
			}

			if (angular.isDefined(card_activa)) {
				var preguntas_grid = card_activa.preguntas.filter(function (e) { return e.pregunta.bucle; });
				angular.forEach(preguntas_grid, function (pregunta_grid) {
					if (angular.isDefined(ixStatusService.current.data.grids)) {
						angular.forEach(Object.keys(ixStatusService.current.data.grids), function (key, idx) {
							if (key.lastIndexOf("grid" + pregunta_grid.pregunta.id_pregunta) != -1) {
								ixStatusService.current.data.grids[key].ixSaveConfig();
							}
						});
					}
				});
			}
		}
	};


	$scope.$parent.$parent.$parent.selectItem = function (item, evt) {

		if (!ixStatusService.current.editing && !ixStatusService.current.filtered || $scope.changeWhileEditing) {
			$log.log("selectItem");
			$log.log(item);
			if (!item.subniveles) {
				$log.log("no tiene detalles, cargamos pantalla");
				$scope.guardarConfigGridsActivos();
				var currentCard = item.icono;
				// var idxCard = $scope.data.list.indexOf(item);
				if (currentCard == "home") {
					$scope.ocultaGuardar = false;
					$scope.ocultaEditar = false;
					if (!$scope.tienePerfilAdmin())
						ixStatusService.setEditing(false);
					//Cabecera.
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "cabecera";
					buildGridProductos();
				} else if (currentCard == "paperclip") {
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					//Ficheros.
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "ficheros";
					buildGridFicherosFT();
				} else if (currentCard == "industry") {
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					//Datos proveedor.
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "proveedor";
					buildGridListaPlantasFabricante();
				} else if (currentCard == "comments") {
					$scope.ocultaGuardar = false;
					$scope.ocultaEditar = false;
					//Comentarios
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "comentarios";
					buildGridComentariosFt();
				} else if (currentCard == "database") {
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					//Log de cambios
					$scope.data.currentPreguntasTab = null;
					$scope.data.pantalla = "log";
					buildGridCambioDatosFt();
				} else {
					$scope.ocultaGuardar = true;
					$scope.ocultaEditar = true;
					ixStatusService.setEditing(true);
					//Cargar dinámicamente:
					$scope.data.pantalla = "preguntas";


					$scope.data.currentPreguntasTab = item.nivel1 + "-" + item.nivel2 + "-" + item.nivel3;

					var ficha_tecnica = $scope.data.fullItemsList[$scope.data.id_ficha_tecnica];

					if (angular.isDefined(ficha_tecnica)) {
						var obj_seleccionado = ficha_tecnica.tarjetas.find(function (e) { return e.nivel1 == item.nivel1; });
						if (item.nivel2)
							obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel2 == item.nivel2 });
						if (item.nivel3)
							obj_seleccionado = obj_seleccionado.subniveles.find(function (e) { return e.nivel3 == item.nivel3 });

						$scope.data.selectedItem = obj_seleccionado;
					} else {
						$scope.data.selectedItem = item;
					}
					// $log.log("Element: " + "#preguntas" + $scope.data.currentPreguntasTab);
					// $log.log(angular.element('#preguntas' + $scope.data.currentPreguntasTab));
					// $log.log("Length element: " + angular.element('#preguntas' + $scope.data.currentPreguntasTab).length);
					if (angular.element('#preguntas' + $scope.data.currentPreguntasTab).length == 0) {
						$timeout(function () {
							$log.log("Append ft_preguntas...");
							$log.log(angular.element("form"));
							//$log.log($scope.data.selectedItem.preguntas);
							if ($scope.data.modoTraduccion) {
								angular.element("form").append($compile("<div ng-show='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")' id='preguntas" + $scope.data.currentPreguntasTab + "'><div ng-if='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")'><ft-titulo item='data.selectedItem'></ft-titulo><ft-preguntas preguntas='data.selectedItem.preguntas' data='data' modo-traduccion='true' solo-preguntas-pdt-traduccion='data.solo_preguntas_pdt'></ft-preguntas></div></div>")($scope));
							} else {
								angular.element("form").append($compile("<div ng-show='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")' id='preguntas" + $scope.data.currentPreguntasTab + "'><div ng-if='isShowing(\"preguntas" + $scope.data.currentPreguntasTab + "\")'><ft-titulo item='data.selectedItem'></ft-titulo><ft-preguntas preguntas='data.selectedItem.preguntas' data='data'></ft-preguntas></div></div>")($scope));
							}
						}, 200);
					}
				}
			} else {
				$log.log("que se vean/oculten todas las cards que tiene por debajo.");
				$scope.data.pantalla = "";
				angular.forEach(item.subniveles, function (detalle) {
					if ($scope.fromBtn) {
						detalle.visible = true;
					} else {
						detalle.visible = !detalle.visible;
					}

				});
				$scope.fromBtn = false;
			}

			$scope.$parent.$parent.$parent.current = item;

			//$scope.current = angular.merge($scope.current, item);
		}
	};

	if ($scope.data.pantalla == "preguntas") {
		$scope.selectItem($scope.data.selectedItem);
	}

	$scope.isShowing = function (id) {
		return ("preguntas" + $scope.data.currentPreguntasTab) == id;
	};

	var buildGridProductos = function () {

		var metadata = [
			{
				Name: "id_producto",
				Pk: true
			},
			{
				Name: "ean",
				NoEditable: function (cell) { return cell.row.entity["ean"] && !cell.row.entity["ean"].includes("PTE"); }
			},
			{
				Name: "marca",
				copySelectedValues: ["propietario"]
			}
		];

		if (!$scope.data.gridProductosFT) {
			$scope.data.gridProductosFT = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridProductosFT", { disableFiltering: true, enableFiltering: false, enableSorting: false, minRowsToShow: 5, metadata: metadata }, "ft_productosVM");
			//$scope.data.gridProductosFT.data = angular.copy($scope.data.datos.ft_productos);
			$scope.data.gridProductosFT.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridProductosFT.gridApi) {
					var doit = true;
					if ($scope.data.gridProductosFT.deletedRows.length + $scope.data.gridProductosFT.insertedRows.length + $scope.data.gridProductosFT.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridProductosFT.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridProductosFT.deletedRows = [];
						$scope.data.gridProductosFT.insertedRows = [];
						$scope.data.gridProductosFT.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridProductosFT.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridProductosFT.gridApi.rowEdit.setRowsClean(dataRows);

						$scope.data.gridProductosFT.data = angular.copy($scope.data.ft_productos_original);

						if (!$scope.data.gridProductosFT.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridProductosFT.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridProductosFT.originalGridOrder)) {
							$scope.data.gridProductosFT.applyOriginallySortedColumns();
						}
						$scope.data.gridProductosFT.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
					}
				}
			}
		} else {
			$scope.data.gridProductosFT = gridService.createGridFunctions($scope, $scope.data.gridProductosFT);
			$scope.data.gridProductosFT.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridProductosFT.gridApi) {
					var doit = true;
					if ($scope.data.gridProductosFT.deletedRows.length + $scope.data.gridProductosFT.insertedRows.length + $scope.data.gridProductosFT.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridProductosFT.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridProductosFT.deletedRows = [];
						$scope.data.gridProductosFT.insertedRows = [];
						$scope.data.gridProductosFT.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridProductosFT.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridProductosFT.gridApi.rowEdit.setRowsClean(dataRows);

						$scope.data.gridProductosFT.data = angular.copy($scope.data.ft_productos_original);

						if (!$scope.data.gridProductosFT.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridProductosFT.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridProductosFT.originalGridOrder)) {
							$scope.data.gridProductosFT.applyOriginallySortedColumns();
						}
						$scope.data.gridProductosFT.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);

					}
				}
			}
			$scope.data.gridProductosFT.ixRestoreConfig();
		}
		$scope.data.gridProductosFT.ixLoadInitialData = function () { return true; };
	};

	$scope.accionesGridFicheros = [
		{
			title: "Previsualizar PDF",
			icon: "fa-file-pdf-o",
			visible: function (entity) {
				return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
			},
			accion: function (entity) {
				var tabla = $scope.getEntity();
				$http({
					method: 'post',
					url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
					headers: {},
					responseType: 'arraybuffer'
				}).then(function (r) {
					$scope.selectedPDF = new Uint8Array(r.data);
					$scope.idFicheroPreview = entity.id;
					var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
					ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
				},
					function (err) {
						ixStatusService.setResponse(err);
					});
			}
		},
		{
			title: "Previsualizar Imagen",
			icon: "fa-file-image-o",
			visible: function (entity) {
				return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
			},
			accion: function (entity) {
				var tabla = $scope.getEntity();
				$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
					//$scope.selectedImage = new Uint8Array(r.data);
					$scope.selectedImage = r.data;
					$scope.idFicheroPreview = entity.id;
					var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
					ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
				},
					function (err) {
						ixStatusService.setResponse(err);
					});
			}
		},
		{
			title: "Descargar fichero",
			icon: "fa-download",
			visible: function (entity) {
				return entity.archivo;
			},
			accion: function (entity) {
				$scope.downloadFile(entity);
			}
		}
	];

	var buildGridFicherosFT = function () {

		$scope.extraColumnsGrid = [{ name: 'Acciones', type: 'detalle', allowCellFocus: false, width: 100, acciones: $scope.accionesGridFicheros }];

		if (!$scope.data.gridFicherosFT) {
			var metadata = [
				{ Name: 'id', NoVisible: true },
				{ Name: 'id_ficha_tecnica', NoVisible: true },
				{ Name: 'ruta_raiz', NoVisible: true },
				{ Name: 'ruta_relativa', NoVisible: true },
				{ Name: 'version', NoVisible: true },
				{ Name: 'en_impreso', NoVisible: true }
			];
			$scope.data.gridFicherosFT = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridFicherosFT", { minRowsToShow: 10, enableCellEdit: false, disableFiltering: true, enableFiltering: false, enableSorting: false, metadata: metadata }, "fichas_tecnicas_ficheros", $scope.extraColumnsGrid);
			$scope.data.gridFicherosFT.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }];
			$scope.data.gridFicherosFT.data = $scope.data.datos.ft_ficheros_fichas_tecnicas;
		} else {
			$scope.data.gridFicherosFT = gridService.createGridFunctions($scope, $scope.data.gridFicherosFT);
			$scope.data.gridFicherosFT.ixRestoreConfig();
		}
	};

	$scope.getEntity = function () {
		return ($scope.data.gridFicherosTab) ? "proveedores_ficheros" : "fichas_tecnicas_ficheros";
	};

	$scope.downloadFile = function (entity) {
		var id = entity.id;
		var tabla = $scope.getEntity();
		$http({
			method: 'post',
			url: cfg.baseURL + tabla + '/DownloadFile?id=' + id,
			headers: { 'Content-type': 'application/pdf' },
			responseType: 'arraybuffer'
		}).then(function (r) {
			var file = new Blob([r.data], { type: r.headers('Content-type') });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		},
			function (err) {
				ixStatusService.setResponse(err);
			});
	};

	var buildGridFicherosProveedor = function () {

		$scope.extraColumnsGrid = [{ name: 'Acciones', type: 'detalle', allowCellFocus: false, width: 100, acciones: $scope.accionesGridFicheros }];

		if (!$scope.data.gridFicherosProveedor) {
			var metadata = [
				{ Name: 'tipo', NoVisible: true },
				//{ Name: 'grupo', NoVisible: true},
				{ Name: 'fabricante', NoVisible: true },
				{ Name: 'planta', NoVisible: true },
				{ Name: 'ruta_relativa', NoVisible: true }
			];
			$scope.data.gridFicherosProveedor = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridFicherosProveedor", { minRowsToShow: 10, enableCellEdit: false, disableFiltering: true, enableFiltering: false, enableSorting: false, metadata: metadata, ixLoadInitialDataAction: "SearchCustom" }, "proveedores_ficheros", $scope.extraColumnsGrid);
			$scope.data.gridFicherosProveedor.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }];
		} else {
			$scope.data.gridFicherosProveedor = gridService.createGridFunctions($scope, $scope.data.gridFicherosProveedor);
			$scope.data.gridFicherosProveedor.ixRestoreConfig();
		}
		//$scope.data.gridFicherosProveedor.ixLoadInitialData = function(){ return true; };
	};

	var buildGridListaPlantasFabricante = function () {

		var acciones = [
			{
				title: 'Datos de fabricante',
				icon: "fa-industry",
				accion: function (entity) {
					var template = "app/FTBase/GestionFichasTecnicas/acciones/datos_fabricante_popup.html";
					var optionsPopup = { controller: "DatosFabricantePopupController" };
					var paramsPopup = { fabricante: entity.fabricante };
					ixUtilsService.openModalV2(template, optionsPopup, "medium", paramsPopup);
				}
			},
			{
				title: 'Datos de planta',
				icon: "fa-building",
				accion: function (entity) {
					var template = "app/FTBase/GestionFichasTecnicas/acciones/datos_planta_popup.html";
					var optionsPopup = {
						controller: ['$scope', '$http', 'cfg', '$uibModalInstance', 'ixStatusService', function ($scope, $http, cfg, $uibModalInstance, ixStatusService) {
							$scope.status = { editing: false };
							$scope.data = {};
							$http.get(cfg.baseURL + "plantas/" + $scope.$resolve.planta).then(function (response) {
								$scope.datos_planta = response.data;
							}, function (err) {
								ixStatusService.setResponse(err);
							});
						}]
					};
					var params = { planta: entity.planta };
					// $scope.planta_nombre = entity.planta_nombre;
					ixUtilsService.openModalV2(template, optionsPopup, "medium", params);
				}
			}
		];

		$scope.extraColumnsGrid = [{ name: 'Acciones', type: 'detalle', width: 100, acciones: acciones }];

		if (!$scope.data.gridPlantasFabricante) {
			var metadata = [
				{ Name: 'asociado', Type: "Int32", Control: "CheckBox",NoEditable: function () { return $scope.tieneCabeceraRestringida() || $scope.data.datos.ft_cabecera.bloqueo_datos_proveedor; } },
				{ Name: 'razon_social', ColumnDescription: 'Fabricante', Type: "string", NoEditable: true },
				{ Name: 'cif', ColumnDescription: 'CIF Fabricante', Type: "string", NoEditable: true },
				{ Name: 'nombre_planta', ColumnDescription: 'Planta', Type: "string", NoEditable: true },
				{ Name: 'fabricante', Pk: true, NoVisible: true },
				{ Name: 'planta', Pk: true, NoVisible: true }
			];

			$scope.data.gridPlantasFabricante = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridPlantasFabricante", { minRowsToShow: 10, enableCellEdit: true, onCellEdit: asociarPlantaFt, disableFiltering: true, enableFiltering: false, enableSorting: false, metadata: metadata });
			$scope.data.gridPlantasFabricante.columnDefs = [];
			$scope.data.gridPlantasFabricante.cellEditableCondition = function (cell) {
				return !cell.col.colDef.noeditable();
			};

			//$scope.data.gridPlantasFabricante = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridPlantasFabricante",  { minRowsToShow: 10, disableFiltering: true, enableFiltering: false, enableSorting: false }, "ft_plantas_asociadasVM");
			// $timeout(function(){
			// 		$scope.data.gridPlantasFabricante.data = $scope.data.datos.plantas_asociadas;
			// },1);
			$scope.data.gridPlantasFabricante.drawExtraColumns($scope.extraColumnsGrid);
			$scope.data.gridPlantasFabricante.ixGetColsFromAPI();


			//$scope.data.gridPlantasFabricante.data = angular.copy($scope.list_plantas_fabricante);
			//me queda la info de las plantas.

		} else {
			$scope.data.gridPlantasFabricante = gridService.createGridFunctions($scope, $scope.data.gridPlantasFabricante);
			$scope.data.gridPlantasFabricante.cellEditableCondition = function (cell) {
				return !cell.col.colDef.noeditable();
			};
			$scope.data.gridPlantasFabricante.ixRestoreConfig();
		}
		$scope.data.gridPlantasFabricante.ixLoadInitialData = function () {
			$http.get(cfg.baseURL + "ft_data/GetPlantasAsociadas?id_ft=" + $scope.data.id_ficha_tecnica).then(function (response) {
				$scope.data.datos.plantas_asociadas = response.data;
				$scope.data.gridPlantasFabricante.data = $scope.data.datos.plantas_asociadas;

				return true;
			}, function (error) {
				ixStatusService.setResponse(error);
			});

		};

		$scope.data.gridPlantasFabricante.ixLoadInitialData();
	};

	var asociarPlantaFt = function (rowEntity, colDef, newValue, oldValue) {
		$log.log("Llamada función asociarPlantaFt");
		$log.log(rowEntity);
		$log.log(colDef);
		$log.log(newValue);
		$log.log(oldValue);

		$scope.data.forzarCargaGridFicherosProveedor = true;

		var param = {
			id_ficha_tecnica: $scope.data.id_ficha_tecnica,
			fabricante: rowEntity.fabricante,
			planta: rowEntity.planta,
			asociado: newValue
		};
		$http.put(cfg.baseURL + "fichas_tecnicas_plantas_asociadas/PutAsociaPlantasFt", param).then(function (r) {
			ixStatusService.setResponse(r);
		}, function (error) {
			rowEntity.asociado = rowEntity.asociado == 0 ? 1 : 0;
			ixStatusService.setResponse(error);
		});
	};

	var buildGridComentariosFt = function () {
		if (!$scope.data.gridComentariosFt) {
			var metadata = [
				{ Name: 'idcomentario', NoVisible: true },
				{ Name: 'idficha', NoVisible: true },
				{ Name: 'fecha', NoEditable: false },
				{ Name: 'usu', NoVisible: true },
				{ Name: 'comentario', NoEditable: false },
				{ Name: 'ruta_archivo', NoVisible: true },
				{ Name: 'es_Interno', NoVisible: true },
				{ Name: 'usuario', NoVisible: true },
				{ Name: 'ubicacion', NoVisible: true }
			];
			$scope.data.gridComentariosFt = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridComentariosFt", { minRowsToShow: 10, enableCellEdit: true, disableFiltering: true, enableFiltering: false, enableSorting: true, metadata: metadata }, "ft_comentarios");
			$scope.data.gridComentariosFt.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridComentariosFt.gridApi) {
					var doit = true;
					if ($scope.data.gridComentariosFt.deletedRows.length + $scope.data.gridComentariosFt.insertedRows.length + $scope.data.gridComentariosFt.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridComentariosFt.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridComentariosFt.deletedRows = [];
						$scope.data.gridComentariosFt.insertedRows = [];
						$scope.data.gridComentariosFt.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridComentariosFt.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridComentariosFt.gridApi.rowEdit.setRowsClean(dataRows);

						if (!$scope.data.gridComentariosFt.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridComentariosFt.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridComentariosFt.originalGridOrder)) {
							$scope.data.gridComentariosFt.applyOriginallySortedColumns();
						}
						$scope.data.gridComentariosFt.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
					}
				}
			}
		} else {
			$scope.data.gridComentariosFt = gridService.createGridFunctions($scope, $scope.data.gridComentariosFt);
			$scope.data.gridComentariosFt.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridComentariosFt.gridApi) {
					var doit = true;
					if ($scope.data.gridComentariosFt.deletedRows.length + $scope.data.gridComentariosFt.insertedRows.length + $scope.data.gridComentariosFt.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridComentariosFt.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridComentariosFt.deletedRows = [];
						$scope.data.gridComentariosFt.insertedRows = [];
						$scope.data.gridComentariosFt.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridComentariosFt.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridComentariosFt.gridApi.rowEdit.setRowsClean(dataRows);

						if (!$scope.data.gridComentariosFt.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridComentariosFt.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridComentariosFt.originalGridOrder)) {
							$scope.data.gridComentariosFt.applyOriginallySortedColumns();
						}
						$scope.data.gridComentariosFt.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
					}
				}
			}
			$scope.data.gridComentariosFt.ixRestoreConfig();
			if($scope.data.datos.comentarios.length > 0){
				$scope.data.gridComentariosFt.data = $scope.data.datos.comentarios;
			}
			else{
				$scope.data.gridComentariosFt.data = [];
			}
		}
		$scope.data.gridComentariosFt.ixLoadInitialData = function () {
			var param = buildIxSearch();
			param.Filters.push({ Field: "es_Interno", Operator: CMP_EQ, Value: 0 });
			param.Filters.push({ Field: "idficha", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica });
			$http.post(cfg.baseURL + "ft_comentarios/Search", param).then(function (response) {
				$scope.data.datos.comentarios = response.data.Items;
				$scope.data.gridComentariosFt.data = response.data.Items;
				return true;
			}, function (error) {
				ixStatusService.setResponse(error);
			});

		};
	};

	var buildGridComentariosInternosFt = function () {
		if (!$scope.data.gridComentariosInternosFt) {
			var metadata = [
				{ Name: 'idcomentario', NoVisible: true },
				{ Name: 'idficha', NoVisible: true },
				{ Name: 'fecha', NoEditable: false },
				{ Name: 'usu', NoVisible: true },
				{ Name: 'comentario', NoEditable: false },
				{ Name: 'ruta_archivo', NoVisible: true },
				{ Name: 'es_Interno', NoVisible: true },
				{ Name: 'usuario', NoVisible: true },
				{ Name: 'ubicacion', NoVisible: true }
			];
			$scope.data.gridComentariosInternosFt = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridComentariosInternosFt", { minRowsToShow: 10, enableCellEdit: true, disableFiltering: true, enableFiltering: false, enableSorting: true, metadata: metadata }, "ft_comentarios");
			if($scope.data.datos.comentariosInternos.length > 0){
				$scope.data.gridComentariosInternosFt.data = $scope.data.datos.comentariosInternos;
			}
			else{
				$scope.data.gridComentariosInternosFt.data = [];
			}
			$scope.data.gridComentariosInternosFt.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridComentariosInternosFt.gridApi) {
					var doit = true;
					if ($scope.data.gridComentariosInternosFt.deletedRows.length + $scope.data.gridComentariosInternosFt.insertedRows.length + $scope.data.gridComentariosInternosFt.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridComentariosInternosFt.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridComentariosInternosFt.deletedRows = [];
						$scope.data.gridComentariosInternosFt.insertedRows = [];
						$scope.data.gridComentariosInternosFt.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridComentariosInternosFt.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridComentariosInternosFt.gridApi.rowEdit.setRowsClean(dataRows);

						if (!$scope.data.gridComentariosInternosFt.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridComentariosInternosFt.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridComentariosInternosFt.originalGridOrder)) {
							$scope.data.gridComentariosInternosFt.applyOriginallySortedColumns();
						}
						$scope.data.gridComentariosInternosFt.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
					}

				}
			}
		} else {
			$scope.data.gridComentariosInternosFt = gridService.createGridFunctions($scope, $scope.data.gridComentariosInternosFt);
			$scope.data.gridComentariosInternosFt.ixRestoreConfig();
			$scope.data.gridComentariosInternosFt.ixCancelEdit = function (emptyTable, force) {
				if ($scope.data.gridComentariosInternosFt.gridApi) {
					var doit = true;
					if ($scope.data.gridComentariosInternosFt.deletedRows.length + $scope.data.gridComentariosInternosFt.insertedRows.length + $scope.data.gridComentariosInternosFt.gridApi.rowEdit.getDirtyRows().length > 0 && !force) {
						doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
					}
					if (doit || force) {
						$scope.data.gridComentariosInternosFt.clearFocus();
						delete (ixStatusService.current.response);
						$scope.data.gridComentariosInternosFt.deletedRows = [];
						$scope.data.gridComentariosInternosFt.insertedRows = [];
						$scope.data.gridComentariosInternosFt.gridStatus = { $invalid: false, $error: {} };

						var dataRows = $scope.data.gridComentariosInternosFt.gridApi.rowEdit.getDirtyRows().map(function (gridRow) { return gridRow.entity; });
						$scope.data.gridComentariosInternosFt.gridApi.rowEdit.setRowsClean(dataRows);

						if (!$scope.data.gridComentariosInternosFt.keepSortingEditing) {
							// Rehabilitar ordenacion al finalizar la edición
							$scope.data.gridComentariosInternosFt.enableSorting = true;
						}
						if (angular.isDefined($scope.data.gridComentariosInternosFt.originalGridOrder)) {
							$scope.data.gridComentariosInternosFt.applyOriginallySortedColumns();
						}
						$scope.data.gridComentariosInternosFt.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
					}

				}
			}
			if($scope.data.datos.comentariosInternos.length > 0){
				$scope.data.gridComentariosInternosFt.data = $scope.data.datos.comentariosInternos;
			}
			else{
				$scope.data.gridComentariosInternosFt.data = [];
			}
		}

		$scope.data.gridComentariosInternosFt.ixLoadInitialData = function () {
			var param = buildIxSearch();
			param.Filters.push({ Field: "es_Interno", Operator: CMP_EQ, Value: 1 });
			param.Filters.push({ Field: "idficha", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica });
			$http.post(cfg.baseURL + "ft_comentarios/Search", param).then(function (response) {
				$scope.data.datos.comentariosInternos = response.data.Items;
				$scope.data.gridComentariosInternosFt.data = response.data.Items;
				return true;
			}, function (error) {
				ixStatusService.setResponse(error);
			});

		};
	};

	var buildGridCambioDatosFt = function () {
		if (!$scope.data.gridCambioDatosFt) {
			var metadata = [
				{
					Name: "fecha",
					Sort: {
						direction: uiGridConstants.DESC,
						ignoreSort: false,
						priority: 0
					}
				},
				{
					Name: "hora",
					Sort: {
						direction: uiGridConstants.DESC,
						ignoreSort: false,
						priority: 1
					}
				},
				{
					Name: "id",
					Sort: {
						direction: uiGridConstants.DESC,
						ignoreSort: false,
						priority: 2
					}
				}
			];
			$scope.data.gridCambioDatosFt = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridLogAuditoriasFt", { minRowsToShow: 20, enableCellEdit: false, enableSorting: true, metadata: metadata }, "listado_log_auditoriasFtVM");
			$scope.data.gridCambioDatosFt.filtroExterno = [{ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica }]
		}

		$scope.data.gridCambioDatosFt.ixLoadInitialData = function () {
			var param = buildIxSearch();
			//param.Filters.push({ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: $scope.data.id_ficha_tecnica });
			param.Filters = $scope.data.gridCambioDatosFt.filtroExterno;
			$http.post(cfg.baseURL + "listado_log_auditoriasFtVM/Search", param).then(function (response) {
				$scope.data.gridCambioDatosFt.data = response.data.Items;
			}, function (error) {
				ixStatusService.setResponse(error);
			});

			return true;
		};

		$scope.data.gridCambioDatosFt.ixLoadInitialData();

	};

	$scope.descargarExcelLog = function () {
		$scope.data.gridCambioDatosFt.ixDownloadExcel();
	};

	/*
	var buildGridLista = function () {
		if (!$scope.data.gridLista) {
			var metadata = [
				{ Name: 'propiedad_saludable', Type: "string" }
			];
			$scope.data.gridLista = gridService.createGrid($scope, "Mant_GestFichaTecnicaGridNormal", { minRowsToShow: 8, enableCellEdit: false, disableFiltering: true, enableFiltering: false, enableSorting: false, metadata: metadata });
			$scope.data.gridLista.columnDefs = [];
			//$scope.data.gridLista.drawExtraColumns($scope.extraColumnsGrid);
			$scope.data.gridLista.ixGetColsFromAPI();
			$scope.data.gridLista.data = $scope.data.datos.detalle.elementos_saludables;

			$scope.refreshDemoGridDropdowns($scope.data.gridLista);
		} else {
			$scope.data.gridLista = gridService.createGridFunctions($scope, $scope.data.gridLista);
			$scope.data.gridLista.ixRestoreConfig();
		}
	};
*/
	$scope.openProveedor = function () {
		var app = {};
		app.icon = "people";
		app.display = "Proveedores";
		app.href = "Mantenimientos/proveedores/" + $scope.data.datos.ft_cabecera.proveedor;
		$timeout(function () {
			ixStatusService.openApp(app).bind(ixStatusService);
		}, 1);
	}

	$scope.refreshDemoGridDropdowns = function (grid) {
		angular.forEach(grid.data, function (row) {
			var columnFKDescs = grid.columnDefs.filter(function (e) { return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });
			angular.forEach(columnFKDescs, function (columnFKDesc) {
				columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
			});
		});
	};

	/* ***** FUNCIONES CONSTRUCCION GRID ***** */

	if (!$scope.data.list) {
		$scope.$parent.$parent.$parent.actualizarListado();
	}

	$scope.restoreConfigCreatedGrids = function () {
		if ($scope.data.gridProductosFT)
			$scope.data.gridProductosFT.ixRestoreConfig();
		if ($scope.data.gridFicherosFT)
			$scope.data.gridFicherosFT.ixRestoreConfig();
		if ($scope.data.gridFicherosProveedor)
			$scope.data.gridFicherosProveedor.ixRestoreConfig();
		if ($scope.data.gridPlantasFabricante)
			$scope.data.gridPlantasFabricante.ixRestoreConfig();
	};

	$scope.restoreConfigCreatedGrids();

	$scope.saveConfigCreatedGrids = function () {
		if ($scope.data.gridProductosFT)
			$scope.data.gridProductosFT.ixSaveConfig();
		if ($scope.data.gridFicherosFT)
			$scope.data.gridFicherosFT.ixSaveConfig();
		if ($scope.data.gridFicherosProveedor)
			$scope.data.gridFicherosProveedor.ixSaveConfig();
		if ($scope.data.gridPlantasFabricante)
			$scope.data.gridPlantasFabricante.ixSaveConfig();
	};

	$scope.$on('metadataLoaded', function () {
		$timeout(function () {
			if ($scope.data.pantalla == "cabecera") {
				$scope.data.gridProductosFT.data = angular.copy($scope.data.ft_productos_original);
				$scope.data.gridProductosFT.ixRefreshGridDropDowns();
			} else if ($scope.data.pantalla == "ficheros") {
				$scope.data.gridFicherosFT.data = $scope.data.datos.ft_ficheros_fichas_tecnicas;
				if (angular.isDefined($scope.data.gridFicherosProveedor))
					$scope.data.gridFicherosProveedor.data = $scope.data.datos.ft_ficheros_proveedores;
			} else if ($scope.data.pantalla == "proveedor") {
				$scope.data.gridPlantasFabricante.data = $scope.data.datos.plantas_asociadas;
			} else if ($scope.data.pantalla == "comentarios") {
				if($scope.data.datos.comentarios.length > 0){
					$scope.data.gridComentariosFt.data = $scope.data.datos.comentarios;
				}else{
					$scope.data.gridComentariosFt.data = [];
				}
				if($scope.data.datos.comentariosInternos.length > 0){
					$scope.data.gridComentariosInternosFt.data = $scope.data.datos.comentariosInternos;
				}else{
					$scope.data.gridComentariosInternosFt.data = [];
				}
			}
		}, 300);
	});

	$scope.limpiarPreguntasErroneas = function () {
		angular.forEach($scope.data.list, function (tarjeta) {
			if (tarjeta.error)
				tarjeta.error = false;
			if (tarjeta.subniveles) {
				angular.forEach(tarjeta.subniveles, function (subnivel1) {
					if (subnivel1.error)
						subnivel1.error = false;
					if (subnivel1.subniveles) {
						angular.forEach(subnivel1.subniveles, function (subnivel2) {
							if (subnivel2.error)
								subnivel2.error = false;
						});
					}
				});
			}
		});
	};

	$scope.marcarPreguntasErroneas = function (error) {
		var erroresTarjetas = error.obj.Errors;
		angular.forEach(erroresTarjetas, function (errorTarjetaCab) {
			var errorTarjetaDet = errorTarjetaCab.Values;
			if (errorTarjetaDet) {
				var tarjeta = $scope.data.list.find(function (e) { return e.nivel1 == errorTarjetaDet[0].nivel1; });
				tarjeta.visible = true;
				if (errorTarjetaDet[0].nivel2) {
					if (tarjeta.subniveles)
						tarjeta.subniveles.forEach(function (x) { x.visible = true; });
					tarjeta = tarjeta.subniveles.find(function (e) { return e.nivel2 == errorTarjetaDet[0].nivel2; });
					if (errorTarjetaDet[0].nivel3) {
						if (tarjeta.subniveles)
							tarjeta.subniveles.forEach(function (x) { x.visible = true; });
						tarjeta = tarjeta.subniveles.find(function (e) { return e.nivel3 == errorTarjetaDet[0].nivel3; });
					}
				}
			}

			if (angular.isDefined(tarjeta))
				tarjeta.error = true;
		});
	};

	$scope.pantallaBasePorProducto = function () {
		var perfilesRestringidos = ["usr_laboratorio", "usr_visitante", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	}
		;
	$scope.tieneCabeceraRestringida = function () {
		//var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_proveedor", "usr_visitante", "usr_export"];
		var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};

	$scope.tienePerfilRestringido = function () {
		var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};

	// $scope.tieneAccionesRestringidas = function () {
	// 	var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];
	// 	return $scope.compruebaRestricciones(perfilesRestringidos);
	// };

	$scope.tieneTarjetasRestringidas = function () {
		var perfilesRestringidos = ["usr_laboratorio", "usr_proveedor", "usr_export"];
		return $scope.compruebaRestricciones(perfilesRestringidos);
	};


	$scope.excluirTarjetasRestringidas = function () {
		//ATENCION: Para "localizar" las tarjetas usamos el atributo icono para evitar depender de la traducción
		//Escondo las tarjetas comentarios y log cambios si estoy en modalidad traducción o si el usuario tieneTarjetasRestringidas
		if ($scope.tieneTarjetasRestringidas() || $scope.data.modoTraduccion) {
			//var tarjetaComentarios = $scope.data.fullList.find(function(e){ return e.titulo1 == "COMENTARIOS"; });
			var tarjetaComentarios = $scope.data.fullList.find(function (e) { return e.icono == "comments"; });
			if (angular.isDefined(tarjetaComentarios)) {
				$scope.data.fullList.splice($scope.data.fullList.indexOf(tarjetaComentarios), 1);
			}

			//var tarjetaLogCambios = $scope.data.fullList.find(function(e){ return e.titulo1 == "LOG CAMBIOS"; });
			var tarjetaLogCambios = $scope.data.fullList.find(function (e) { return e.icono == "database"; });
			if (angular.isDefined(tarjetaLogCambios)) {
				$scope.data.fullList.splice($scope.data.fullList.indexOf(tarjetaLogCambios), 1);
			}
		}

		if ($scope.tieneCabeceraNoVisible()) {
			var tarjetaCabecera = $scope.data.fullList.find(function (e) { return e.icono == "home"; });
			if (angular.isDefined(tarjetaCabecera)) {
				$scope.data.fullList.splice($scope.data.fullList.indexOf(tarjetaCabecera), 1);
			}
		}

		if ($scope.tieneFicherosNoVisible()) {
			//var tarjetaFicheros = $scope.data.fullList.find(function(e){ return e.titulo1 == "FICHEROS"; });
			var tarjetaFicheros = $scope.data.fullList.find(function (e) { return e.icono == "paperclip"; });
			if (angular.isDefined(tarjetaFicheros)) {
				$scope.data.fullList.splice($scope.data.fullList.indexOf(tarjetaFicheros), 1);
			}
		}
	};

	$scope.permiteControlTransformacion = function () {
		if ($scope.data.datos.ft_cabecera) {
			if ($scope.data.datos.ft_cabecera.estado == 'T' && (!$scope.extranetUser.laboratorio && !$scope.extranetUser.proveedor && !$scope.extranetUser.cliente))
				return true;
			else
				return false;
		}
		else {
			return false;
		}
	};

	$scope.permiteImprimirFtRevision = function () {
		if ($scope.data.datos.ft_cabecera) {
			if ($scope.data.datos.ft_cabecera.ft_version == 5 && (!$scope.extranetUser.laboratorio && !$scope.extranetUser.proveedor && !$scope.extranetUser.cliente))
				return true;
			else
				return false;
		}
		else
			return false;
	};

	if ($scope.tienePerfilRestringido()) {
		$scope.ixEditar = undefined;
		$scope.ixGuardar = undefined;
	}


	//Sobreescribo la función ixCloseApp para poder realizar el cálculo de los porcentajes de cumplimentación
	//La llamada se ejecuta al hacer click en el botón CERRAR de la app
	$scope.ixCloseApp = function () {
		$scope.isDestroyedFT = true;
		$http.put(cfg.baseURL + 'extranet_fichas_tecnicas/ActualizarPorcentajesCumplimentacion?id_ficha_tecnica=' + $scope.data.id_ficha_tecnica).then(function (response) {
			ixStatusService.closeApp(ixStatusService.current);
		},
			function (error) {
				$log.log("Error al registrar Porcentajes cumplimentación");
				$log.log(error);
				ixStatusService.closeApp(ixStatusService.current);
			});
	};

	//Se ejecuta al cerrar la App desde el botón CERRAR o al pasar a otras App
	$scope.$on("$destroy", function () {
		if (!$scope.isDestroyedFT) {
			$http.put(cfg.baseURL + 'extranet_fichas_tecnicas/ActualizarPorcentajesCumplimentacion?id_ficha_tecnica=' + $scope.data.id_ficha_tecnica).then(function (response) {
				$scope.saveConfigCreatedGrids();
			},
				function (error) {
					$log.log("Error al registrar Porcentajes cumplimentación");
					$log.log(error);
					$scope.saveConfigCreatedGrids();
				});
		}
		else {
			$scope.saveConfigCreatedGrids();
		}

	});

	$scope.control_errores_transformacion = function () {
		var param = { Selection: { Filters: [], OrderBy: [] }, Fields: [] };
		//Agregar columnas
		param.Fields.push({ Field: 'id_ficha_tecnica' });
		param.Fields.push({ Field: 'nivel1' });
		param.Fields.push({ Field: 'nivel2' });
		param.Fields.push({ Field: 'nivel3' });
		param.Fields.push({ Field: 'id_pregunta' });
		param.Fields.push({ Field: 'pregunta' });
		param.Fields.push({ Field: 'componente' });
		param.Fields.push({ Field: 'orden_bucle' });
		param.Fields.push({ Field: 'orden_tab' });
		param.Fields.push({ Field: 'orden_tab2' });
		param.Fields.push({ Field: 'posicion' });
		param.Fields.push({ Field: 'valor' });
		param.Fields.push({ Field: 'error_desc' });
		//Agregar filtros
		param.Selection.Filters.push({ Field: 'version', Value: $scope.data.datos.ft_cabecera.ft_version, Operator: CMP_EQ, Skip: 1 });
		param.Selection.Filters.push({ Field: 'id_ft', Value: $scope.data.id_ficha_tecnica, Operator: CMP_EQ, Skip: 1 });

		var config = { responseType: "arraybuffer" };
		$http.post(cfg.baseURL + 'control_errores_transformacion/Excel', param, config).then(function (r) {
			var file = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			var filename = 'ControlErrorestransformacion_' + $scope.data.id_ficha_tecnica.replace("/", "-") + ".xlsx";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		});
	};

	$scope.confirmarCumplimentacion = function () {
		$scope.limpiarPreguntasErroneas();
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas/ConfirmarCumplimentacion?id_ficha_tecnica=" + $scope.data.id_ficha_tecnica).then(function (r) {
			ixStatusService.setResponse(r);
			$scope.data.datos.ft_cabecera = r.data.obj.Record;
		}, function (error) {
			var errors = error.data.obj.Errors;
			var contentMsg = errors.map(function (e) { return e.Msg; }).join('<br/>')
			error.data.obj.Errors = error.data.obj.Errors.map(function (e) { return angular.extend({}, e, { Msg: e.Msg.replace(/<[^>]*>/g, '') }); });
			$ngConfirm({
				title: "<span style=\"color:red;\">Errores al finalizar FT, por favor contactad con Biotecnal al Tel: 93.721.12.55 </span>",
				content: contentMsg
			});
			ixStatusService.setResponse(error);
			$scope.marcarPreguntasErroneas(error.data);
		});
	}

	$scope.cambioEstadoTraduccion = function (nuevoEstado) {
		var changes = ixGetPatchOperations({ estado: '' }, { estado: nuevoEstado });
		$http.put(cfg.baseURL + "extranet_fichas_tecnicas_idioma/" + $scope.data.id_ficha_tecnica + "/" + $scope.data.idioma, changes).then(function (r) {
			ixStatusService.setResponse(r);
			$scope.data.datos.estado_traduccion = nuevoEstado;
		}, function (error) {
			ixStatusService.setResponse(error);
			$scope.marcarPreguntasErroneas(error.data);
		});
	}

	$scope.loadEstadosTraduccion = function (params) {
		if ($scope.data.datos.traducir_completa == 1) {
			params.Filters.push({ field: 'codigo', value: 'V', op: '0', not: true });
		}
		else {
			params.Filters.push({ field: 'codigo', value: 'W', op: '0', not: true });
		}
		return $http.post(cfg.baseURL + "ft_estados_traduccion/Search", params);
	}

	$scope.loadRevisionEtiquetado = function (params) {
		var deferred = $q.defer();
		$timeout(function () {
			var list = [];
			list.push({ descripcion: "OK" });
			list.push({ descripcion: "PENDIENTE" });
			return deferred.resolve({ data: list });
		}, 1);
		return deferred.promise;
	}
	// $scope.guardarProveedores = function(){
	// 	$log.log("Guardando proveedores");
	// 	console.log($scope.data.gridPlantasFabricante.ixGetBulkParam());
	// }

}]);

/*global saveAs*/

angular.module('FTBase').controller('ListaContratosFtController',['$scope', '$controller', 'ixUtilsService', '$http', 'cfg', 'ixStatusService', function($scope, $controller,  ixUtilsService, $http, cfg, ixStatusService){
    $scope.entity = "extranet_fichas_tecnicas_contratos";
    //, 'ixUtilsService', '$http', 'cfg', 'ixStatusService'
    //,  ixUtilsService, $http, cfg, ixStatusService
    $scope.acciones = [
      {
        title: 'Ver contrato',
        icon: 'fa-search',
        accion: function(entity){
          var templateURL = "app/FTBase/Contratos/detalles_contrato_ft.html";
          var optionsPopup = { controller: "DetallesContratoFtController" };
          var paramsPopup = { contrato: entity, is_new: false };
          ixUtilsService.openModalV2(templateURL, optionsPopup, "medium", paramsPopup).then(function(response){
            if (response){
              $scope.data.grid.ixLoadInitialData();
            }
          });
        }
      },
      {
        title: 'Imprimir',
        icon: 'fa-print',
        accion: function(entity){
          var config = {responseType: 'arraybuffer'};
          $http.get(cfg.baseURL + "impresos/ImpresoContrato/?idcontrato=" + entity.idcontrato + "&docformat=PDF",config).then(function(response){
            var filename = "Contrato_" + entity.idcontrato + ".pdf";
            var file = new Blob([response.data], { type: 'application/pdf' });

            if (response.headers('Content-Disposition')) {
              filename = response.headers('Content-Disposition').split("=")[1];
            }

            saveAs(file, filename);
          }, function(error){
            ixStatusService.setResponse(error);
          });
        }
      }
    ];

    $scope.ixAddRow = function(){
      var templateURL = "app/FTBase/Contratos/detalles_contrato_ft.html";
      var optionsPopup = { controller: "DetallesContratoFtController" };
      var paramsPopup = { contrato: {}, is_new: true };
      ixUtilsService.openModalV2(templateURL, optionsPopup, "medium", paramsPopup).then(function(response){
        if (response){
          $scope.data.grid.ixLoadInitialData();
        }
      });
    };

    $controller('GridEditorController', { $scope: $scope });
}]);

/*global CMP_EQ*/
/*global CMP_ISNULL:true*/
/*global ixGetPatchOperations*/
"use strict";

angular.module('FTBase').controller('DetallesContratoFtController', ['$scope', 'cfg', 'ixStatusService', 'gridService', '$http', '$timeout','$log','$uibModalInstance', function($scope, cfg, ixStatusService, gridService, $http, $timeout, $log, $uibModalInstance){
  $scope.status = { editing: true };
	$scope.data = ixStatusService.current.data;
  // ixStatusService.setEditing(true);

  $scope.contrato  = angular.copy($scope.$resolve.contrato);
  $scope.contrato_original = angular.copy($scope.contrato);
  $scope.is_new = $scope.$resolve.is_new;
  $scope.data_updated = false;

  // $scope.$on('metadataLoaded', function(){
  //   $timeout(function(){
  //     $scope.data.gridFt.ixRefreshGridDropDowns();
  //   }, 300);
  // });

  $scope.loadFt = function (param){
  //   // debugger;
  //   param = buildIxSearch();
    param.Filters.push({ Field: "proveedor", Value: $scope.contrato.proveedor, Operator: CMP_EQ });
    param.Filters.push({ Field: "idcontrato", Value:"", Operator: CMP_ISNULL });

    return $http.post(cfg.baseURL + "extranet_fichas_tecnicas/Search", param);
  };

  $scope.loadDetFt = function(entity){
    if (angular.isDefined(entity))
      $scope.titulo_ft = entity.titulo;
  };

  if(!$scope.data.gridFt){
    $scope.data.gridFt = gridService.createGrid($scope, "Mant_gridFtContratosDet",  { enableCellEdit: false, disableFiltering: true, enableFiltering: false, enableSorting: false, minRowsToShow: 5, showOnlyDescribedCols: [ "id", "titulo" ] }, "extranet_fichas_tecnicas");
  }
  else {
    $scope.data.gridFt = gridService.createGridFunctions($scope, $scope.data.gridFt);
    $scope.data.gridFt.ixRestoreConfig();
  }

  $scope.data.gridFt.filtroExterno = [{ Field:"idcontrato", Operator: CMP_EQ, Value: $scope.contrato.idcontrato }]
  $scope.data.gridFt.ixLoadInitialData();

  $scope.save = function(){
    $log.log("Saving...");
    var param = {};
    if ($scope.is_new){
      $log.log("... new");
      param.nuevo_contrato = $scope.contrato;
      $log.log($scope.data.gridFt.data);
      param.fichas_tecnicas = $scope.data.gridFt.data;
      $http.post(cfg.baseURL + "extranet_fichas_tecnicas_contratos/PostContrato", param).then(function(response){
        ixStatusService.setResponse(response);
        $scope.data.gridFt.ixLoadInitialData();
        $scope.data_updated = true;
      }, function(error){
        ixStatusService.setResponse(error);
      });
    }else {
      $log.log("... update");
  		param.jpdContrato = ixGetPatchOperations($scope.contrato_original, $scope.contrato);
      param.ubpFichas = $scope.data.gridFt.ixGetBulkParam();
      $http.put(cfg.baseURL + "extranet_fichas_tecnicas_contratos/PutContrato/" + $scope.contrato.idcontrato, param).then(function(response){
        ixStatusService.setResponse(response);
        $scope.data.gridFt.ixLoadInitialData();
        $scope.data_updated = true;
      },function(error){
        ixStatusService.setResponse(error);
      });
    }
  };

  $scope.addRow = function(grid){
    // grid.ixAddRow();
    $log.log("addRow");
    if ($scope.ft_add){
      var nr = { id: $scope.ft_add, titulo: $scope.titulo_ft };
      grid.ixAddRow(nr);
      $timeout(function(){
        grid.gridApi.rowEdit.setRowsDirty([nr]);
      },1);
    }
  };

  $scope.deleteSelectedRows = function(grid){
		grid.ixDeleteSelectedRows();
  };

  $scope.$dismiss = function(){
    $uibModalInstance.close($scope.data_updated);
  };

	$scope.$on("$destroy", function() {
		$scope.data.gridFt.ixSaveConfig();
		$scope.isDestroyed=true;
	});

}]);

/*global angular*/

angular.module('FTBase').controller('Alarma_Verificacion_IngredientesController', ['$scope', '$controller', '$http', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', 'ixWarningsService', '$log', '$translate', function ($scope, $controller, $http, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService, ixWarningsService, $log, $translate) {
    $scope.entity = "alarma_verificacion_nuevo_ingredienteVM";
    $scope.ocultaEditar = true;

    var perfilesUsuario = authService.perfilesUsuario();
    $scope.allow2delete = false;
    angular.forEach(perfilesUsuario, function(perfil){
        if (perfil == "ixnet" || perfil == "usr_bio_userkey")
        $scope.allow2delete = true;
    });

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    $scope.acciones = [
        {
            title: 'Datos Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'GestionFichasTecnicas/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            },
            visible: function(){
                return cfg.appCliente == "EUROMADI";
            }
        },
        {
            title: 'Formulario Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'FormularioFtBP/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            },
            visible: function(){
                return cfg.appCliente == "BONPREU";
            }
        },
        {
            title: 'Eliminar',
            icon: 'fa-trash',
            accion: function(entity){
                ixWarningsService.warningConfirmacion($scope, "¡Atención!  Se eliminará la alarma seleccionada ¿Deseas confirmar?", $scope.eliminarAlarmaIngrediente, undefined, entity);
            },
            visible: function(){
                return $scope.allow2delete;
            }
        }
    ];

    $scope.eliminarAlarmaIngrediente = function(entity){
        $http.delete(cfg.baseURL + "diccionario_valores_por_validar/" + entity.id).then(function(response){
            ixStatusService.setResponse(response);
            $scope.data.grid.ixLoadInitialData();
        },
        function(error){
            ixStatusService.setResponse(error);
        });
    };

    $controller('GridEditorController', { $scope: $scope });

}]);
/*global angular*/

angular.module('FTBase').controller('Alarma_Ingredientes_MonitorizarController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
    $scope.entity = "alarma_ingredientes_monitorizarVM";
    $scope.ocultaEditar = true;

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    $scope.acciones = [
        {
            title: 'Datos Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'GestionFichasTecnicas/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            }
        }
    ];
    $controller('GridEditorController', { $scope: $scope });
    
}]);
/*global angular*/
/*global CMP_EQ*/

angular.module('FTBase').controller('AlarmaFtRevisionaPropietarioController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', 'ixUtilsService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService, $log, $translate, ixCestaVehiculosService, ixUtilsService) {
  $scope.entity = "listado_ftVM";
  $scope.ocultaEditar = true;
  

  // $scope.metadata = [
  //   { Name: 'revision_inicial',  NoVisible: true},
  //   { Name: 'revision_final', NoVisible: true},
  //   { Name: 'notificacion_proveedor', NoVisible: true}
  // ];
  $scope.gridOptions = { showOnlyDescribedCols: [ "id_ficha_tecnica", "tipo_ft", "titulo", "nombre_proveedor", "eans", "cod_internos", "marcas", "familia", "desc_estado", "fecha", "fecha_aprobada", "fecha_revision", "fecha_baja", "num_ficheros", "ultimo_comentario", "analisis_anyo_vigente", "analisis_anyo_proximo", "traducible", "estado_traduccion", "idioma" ] };
  $scope.filtroExterno =  [{ Field: "estado", Operator: CMP_EQ, Value: "S" }];

  $scope.acciones = [
      {
          title: 'Datos Ficha Técnica',
          icon: 'fa-list',
          redirect: {
              template: 'GestionFichasTecnicas/list',
              atributos: ['id_ficha_tecnica'],
              atributosTitle: [],
              iconBox: 'perm_device_information',
              multiple: true
          }
      },
      {
        title: 'Descargar Ficha Técnica',
        icon: 'fa-download',
        accion: function(entity){
          var template = "app/FTBase/ListadosFT/acciones/imprimir_ft_popup.html";
          var options = { controller: "ImprimirFTPopupController" };
          var params = { tipo: "FT", traducible: entity.traducible, id_ficha_tecnica: entity.id_ficha_tecnica };

          ixUtilsService.openModalV2(template, options, "small", params);
        }     
      }
  ];
  $controller('GridEditorController', { $scope: $scope });

}]);
/*global angular*/

angular.module('FTBase').controller('Alarma_Expiracion_CertificadosController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
    $scope.entity = "alarma_expiracion_certificadosVM";
    $scope.ocultaEditar = true;

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    //$scope.acciones = [];
    $scope.acciones = [
        {
            title: 'Detalles proveedor',
            icon: 'fa-vcard',
            redirect: {
                template: 'Mantenimientos/proveedores',
                atributos: ['proveedor'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            }
        }
    ];
    $controller('GridEditorController', { $scope: $scope });

}]);

/*global angular*/

angular.module('FTBase').controller('Alarma_Estado_Fuera_PlazoController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
    $scope.entity = "alarma_estado_fuera_plazoVM";
    $scope.ocultaEditar = true;

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    $scope.acciones = [
        {
            title: 'Datos Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'GestionFichasTecnicas/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            }
        }
    ];
    $controller('GridEditorController', { $scope: $scope });
    
}]);
/*global angular*/

angular.module('FTBase').controller('Alarma_Certificados_FicherosController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
    $scope.entity = "alarma_certificado_ficherosVM";
    $scope.ocultaEditar = true;

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    $scope.acciones = [
        {
            title: 'Datos Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'GestionFichasTecnicas/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            }
        }
    ];
    $controller('GridEditorController', { $scope: $scope });
    
}]);
/*global angular*/

angular.module('FTBase').controller('Alarma_Actualizacion_FTController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService, $log, $translate, ixCestaVehiculosService) {
    $scope.entity = "alarma_actualizacion_ftVM";
    $scope.ocultaEditar = true;

    //$scope.gridOptions = { showOnlyDescribedCols: [ "codigo", "nombre", "iniciales", "email", "fecha_baja", "delegacion" ] };
    $scope.acciones = [
        {
            title: 'Datos Ficha Técnica',
            icon: 'fa-list',
            redirect: {
                template: 'GestionFichasTecnicas/list',
                atributos: ['id_ficha_tecnica'],
                atributosTitle: [],
                iconBox: 'perm_device_information',
                multiple: true
            }
        }
    ];
    $controller('GridEditorController', { $scope: $scope });

}]);
/*global ixGetPatchOperations*/
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module('FTBase').directive('ftPreguntas', ['$http', '$compile', '$log', function ($http, $compile, $log) {
	return {
		restrict: 'E',
		scope: {
			preguntas: '=',
			data: '=?',
			preview: '=?',
			modoTraduccion: '=?',
			idioma: '=?',
			soloPreguntasPdtTraduccion: '=?'
		},
		//template: "<div>los datos padre son: {{ data | json }}</div>",
		link: function (scope, elem, attrs) {
			scope.getContainerElement = function () {
				return elem;
			};
			//iteramos el array de preguntas para crear el formulario.
			scope.preguntas.forEach(function (pregunta, idx) {
				scope.pregunta = pregunta;
				var separador_linea = pregunta.pregunta.separador_linea;
				elem.append($compile("<div class='row'><ft-pregunta pregunta='preguntas[" + idx + "]' preview='preview' modo-traduccion='modoTraduccion' idioma='idioma' solo-preguntas-pdt-traduccion='soloPreguntasPdtTraduccion' data='data'></ft-pregunta>" + ((separador_linea) ? "<hr style='clear:both; border-color:black' class='no-margin'/>" : "") + "</div>")(scope));
			});
		}
	}
}]);

angular.module('FTBase').directive('ftPregunta', ['$http', '$compile', '$filter', '$log', '$q', 'gridService', 'ixStatusService', 'cfg', 'ixUtilsService', '$timeout', '$rootScope', 'authService', 'authInterceptorService', 'ixWarningsService', '$ngConfirm', function ($http, $compile, $filter, $log, $q, gridService, ixStatusService, cfg, ixUtilsService, $timeout, $rootScope, authService, authInterceptorService, ixWarningsService, $ngConfirm) {
	return {
		restrict: 'E',
		scope: {
			pregunta: '=',
			respuestas: '=?',
			data: '=?',
			preview: '=?',
			inPopup: '=?',
			modoTraduccion: '=?',
			idioma: '=?',
			soloPreguntasPdtTraduccion: '=?'
		},
		//template: "<div>los datos son: {{ pregunta | json }}</div>",
		link: function (scope, elem, attrs) {
			var ESTADO_PDT_APROVACION = 1;
			var ESTADO_CONFIRMADO = 2;
			var tiposValor = { TEXTO: "TEXTO", NUMERICO: "NUMERICO", DECIMAL: "DECIMAL", DICCIONARIO: "DICCIONARIO", SINO: "SI/NO", FECHA: "FECHA", AREA_TEXTO: "AREA_TEXTO", DICCIONARIO_MULTIPLE: "DICCIONARIO_MULTIPLE" };
			scope.status = {};
			if (scope.preview)
				scope.status.editing = true;
			else
				scope.status = ixStatusService.current;
				

			if (angular.isUndefined(scope.data))
				scope.data = {};

			scope.getUniqueID = function (idx, nombre) {
				var id = "";
				if (angular.isDefined(nombre)) {
					if (nombre == "obs")
						id = (scope.preview) ? scope.pregunta.pregunta.id_pregunta + "-" + nombre : scope.pregunta.respuestas[idx].observaciones;
					else
						id = (scope.preview) ? scope.pregunta.pregunta.id_pregunta + "-" + nombre : scope.pregunta.pregunta[nombre];
				}
				else
					id = (scope.preview) ? scope.pregunta.pregunta.id_pregunta : scope.pregunta.respuestas[idx].id;

				if (angular.isDefined(scope.componentesCount))
					id += "" + scope.componentesCount;
				return id;
			};

			scope.getCssClass = function () {
				var cssClassDimensions = 12;
				if (!scope.inPopup) {
					if (scope.pregunta.pregunta.preguntar_obs)
						cssClassDimensions = 6;

					if (scope.num_subpreguntas)
						cssClassDimensions = 12 / scope.num_subpreguntas;

					//el mínimo es un tercio del ancho por control.
					if (cssClassDimensions < 4)
						cssClassDimensions = 4;
				}
				scope.getCssControlesPregunta(cssClassDimensions, scope.creando_subpregunta);
				return "col-md-" + cssClassDimensions;
			};

			scope.getCssControlesPregunta = function (columnsContainer, subpregunta) {
				if (columnsContainer == 12) {
					scope.labelClass = "col-md-4";
					scope.inputClass = "col-md-6";
				}
				else if (columnsContainer == 6) {
					if (subpregunta)
						scope.labelClass = "col-md-4";
					else
						scope.labelClass = "col-md-8";
					scope.inputClass = "col-md-4";
				}
				else if (columnsContainer == 4) {
					//calcular cuando tengamos un caso
					scope.labelClass = "col-md-4";
					scope.inputClass = "col-md-8";
				}
			};

			scope.multiplesElementosEnLaLinea = function () {
				var multiples = false;
				if (scope.pregunta.pregunta.preguntar_obs)
					multiples = true;
				if (scope.num_subpreguntas)
					multiples = true;
				return multiples;
			};

			//CONTROLES DE FORMULARIO INI
			scope.getHTMLTag = function (tipo_valor) {
				var tag;
				switch (tipo_valor) {
					case tiposValor.TEXTO:
					case tiposValor.NUMERICO:
					case tiposValor.DECIMAL:
						//tag = "ix-text";
						tag = "ix-text-area-ft";
						break;
					case tiposValor.AREA_TEXTO:
						tag = "ix-text-area-ft";
						break;
					case tiposValor.DICCIONARIO:
						tag = "ix-select-ft";
						break;
					case tiposValor.DICCIONARIO_MULTIPLE:
						tag = "ix-select-multiple-ft";
						break;
					case tiposValor.SINO:
						tag = "ft-nz-toggle";
						break;
					case tiposValor.FECHA:
						tag = "ix-date-ft";
						break;
				}
				return tag;
			};

			scope.buildControlObs = function (idx) {
				if (!scope.preview)
					scope.observaciones_original = scope.pregunta.respuestas[idx].observaciones;

				//YVES - 18/02/2022
				//Parche para hacer que se traduzca la etiqueta de Observaciones
				var etiqObs = "Observaciones";
				if (scope.idioma == "ca") etiqObs = "Observacions";
				if (scope.idioma == "pt") etiqObs = "Observações";

				var prop = scope.getUniqueID(idx, "obs");
				var strEl = "";
				if (scope.preview)
					strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='data[\"" + prop + "\"]' name='" + etiqObs + "' ng-disabled='pregunta.pregunta.bloqueado || tienePerfilRestringido()' rows='3'></ix-text-area-ft></div>";
				else if (scope.modoTraduccion) {
					var propertyVisible = (scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";
					$log.log("buildControlObs(" + idx + ") -->");
					$log.log(scope.pregunta.respuestas_idioma[0]);
					$log.log(scope.pregunta.respuestas[0]);
					if (scope.pregunta.respuestas[0].observaciones)
						strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "].observaciones' name='" + etiqObs + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\"ix-text-area\") || (!pregunta.pregunta.traducible) || (!pregunta.respuestas[" + idx + "].observaciones && pregunta.respuestas_idioma[" + idx + "].fecha_modif_observaciones == null)' placeholder='" + scope.pregunta.respuestas[0].observaciones + "' ix-focus-out='guardarObservaciones' rows='3' label-class='col-md-4' input-class='col-md-7'></ix-text-area-ft></div>";
					else
						strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "].observaciones' name='" + etiqObs + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\"ix-text-area\") || (!pregunta.pregunta.traducible)' ix-focus-out='guardarObservaciones' rows='3' label-class='col-md-4' input-class='col-md-7'></ix-text-area-ft></div>";
				}
				else
					strEl = "<div class='col-md-6'><ix-text-area-ft ng-model='pregunta.respuestas[" + idx + "].observaciones' name='" + etiqObs + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\"ix-text-area\")' ix-focus-out='guardarObservaciones' rows='3' label-class='col-md-4' input-class='col-md-7'></ix-text-area-ft></div>";
				var el = $compile(strEl)(scope);
				return el;
			};

			scope.buildControlImg = function (idx) {
				var clave = "valor";
				scope.setValorOriginal(idx);

				var prop = scope.getUniqueID(idx);
				var pregunta = scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;

				var isRequired = 0;
				if (clave != "valor") {
					var propertyValidarSubpregunta = "validar_" + clave.replace("respuesta", "pregunta");
					isRequired = scope.pregunta.pregunta.obligatoria && scope.pregunta.pregunta[propertyValidarSubpregunta];
				}
				else {
					isRequired = scope.pregunta.pregunta.obligatoria;
				}				

				var strEl = "";
				if (scope.preview)
					strEl = '<div class="row"><div class="' + scope.getCssClass() + '"><ft-nz-toggle class="margin" name="'+pregunta+'" icono="'+scope.pregunta.pregunta.imagen_base64+'" ng-model="data[\'' + prop + '\']" ng-disabled="pregunta.bloqueado || tienePerfilRestringido() || (modoTraduccion && !pregunta.pregunta.traducible)" style="margin-top:10px;"></ft-nz-toggle></div></div>';
				else {
					if (scope.modoTraduccion) {
						var propertyVisible = (scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";
						strEl += '<div class="' + scope.getCssClass() + '"><ft-nz-toggle class="margin" label-class="'+scope.labelClass+'" input-class="'+scope.inputClass+'" name="'+pregunta+'" icono="'+scope.pregunta.pregunta.imagen_base64+'" ng-model="pregunta[\'' + propertyVisible + '\'][' + idx + '].valor" ng-required="' + isRequired +'" ng-disabled="pregunta.respuestas[' + idx + '].bloqueado || tienePerfilRestringido()  || tieneLlamadasPendientes(pregunta.respuestas[' + idx + '].id,\'ft-nz-toggle\')|| (!pregunta.pregunta.traducible)" after-click="guardarTraduccion" style="margin-top:10px;"></ft-nz-toggle></div>';
					} else {
						strEl += '<div class="' + scope.getCssClass() + '"><ft-nz-toggle class="margin" label-class="'+scope.labelClass+'" input-class="'+scope.inputClass+'" name="'+pregunta+'" icono="'+scope.pregunta.pregunta.imagen_base64+'" ng-model="pregunta.respuestas[' + idx + '].valor" ng-required="' + isRequired +'" ng-disabled="pregunta.respuestas[' + idx + '].bloqueado || tienePerfilRestringido()  || tieneLlamadasPendientes(pregunta.respuestas[' + idx + '].id,\'ft-nz-toggle\')" after-click="guardarValor" ix-focus-out-param="valor" ix-focus-out-param-idx="' + idx + '"  style="margin-top:10px;"></ft-nz-toggle></div>';
					}
				}
				var el = $compile(strEl)(scope);
				return el;
			};

			scope.openPopupFicheros = function (id_ficha_tecnica, tipo) {
				var template = "app/FTBase/GestionFichasTecnicas/acciones/upload_file_popup.html";
				var optionsPopup = { controller: "UploadFilePopupController" };
				var paramsPopup = { tipo: tipo, id_ft: id_ficha_tecnica };
				var popup = ixUtilsService.openModalV2(template, optionsPopup, "small", paramsPopup);
				popup.then(function (data) {
					$rootScope.$broadcast("NUEVO_FICHERO", data.obj.Record);
				});
			};

			scope.openPopupDedependenciaEtiquetado = function (id_ficha_tecnica, id_pregunta, pregunta_formulario, bloquear_valor_b, idioma, desc_componente) {

				var templateDepEtiquetado = "";
				var optionsPopupDepEtiquetado = {};
				var esTablaEnvases = false;
				if (id_pregunta == 777 || id_pregunta == 856 || id_pregunta == 1189 || id_pregunta == 1192){
					templateDepEtiquetado = "app/FTBase/GestionFichasTecnicas/acciones/dependencia_etiquetado_nutricionales_popup.html";
					optionsPopupDepEtiquetado.controller = "DependenciaEtiquetadoNutricionalesPopupController";
				}
				else{
					templateDepEtiquetado = "app/FTBase/GestionFichasTecnicas/acciones/dependencia_etiquetado_popup.html";
					optionsPopupDepEtiquetado.controller = "DependenciaEtiquetadoPopupController";
					if (id_pregunta == 1160 || id_pregunta == 1168 || id_pregunta == 1173 || id_pregunta == 1178){
						esTablaEnvases = true;
					}
				}
				
				var pregunta_bloqueada = scope.pregunta.respuestas[0].bloqueado;
				var paramsPopupDepEtiquetado = { id_ft: id_ficha_tecnica, id_pregunta: id_pregunta, pregunta_formulario: pregunta_formulario, bloquear_valor_b: bloquear_valor_b, pregunta_bloqueada: pregunta_bloqueada, modo_traduccion: scope.modoTraduccion, idioma: idioma, traducible: scope.pregunta.pregunta.traducible, pregunta: scope.pregunta, tablaEnvases: esTablaEnvases, componente: desc_componente};
				ixUtilsService.openModalV2(templateDepEtiquetado, optionsPopupDepEtiquetado, "medium", paramsPopupDepEtiquetado);
			};

			scope.setValorOriginal = function (idx, clave) {
				var propertyRespuesta = (scope.modoTraduccion && scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";

				if (angular.isDefined(clave)) {
					if (angular.isUndefined(scope["valor_original_" + clave])) {
						scope["valor_original_" + clave] = {};
					}
					scope["valor_original_" + clave][idx] = scope.pregunta[propertyRespuesta][idx][clave];
				}
				else {
					if (angular.isUndefined(scope.valor_original))
						scope.valor_original = {};
					scope.valor_original[idx] = scope.pregunta[propertyRespuesta][idx].valor;
				}
			};

			//			scope.esDiccionario = function(){
			//				return (scope.pregunta.pregunta.tipo_valor == tiposValor.DICCIONARIO || scope.pregunta.pregunta.tipo_valor == tiposValor.DICCIONARIO_MULTIPLE);
			//			};

			scope.sePuedeVisualizar = function (idx, clave) {
				var soloPdtTraduccion = scope.soloPreguntasPdtTraduccion;
				var propertyTraduccion = "traducible";
				if (clave != "valor")
					propertyTraduccion = clave.replace("sub_respuesta", "sub_pregunta") + "_traducible";

				//TODO: Yves agregar condición para verificar que la FT master no resulte modificada respecto al valor traducido
				if (soloPdtTraduccion)
					return (scope.pregunta.pregunta[propertyTraduccion]) && (scope.pregunta.respuestas[idx][clave] && !scope.pregunta.respuestas_idioma[idx][clave]);
				else
					return true;

				//Tenemos que devolver solo:
				//-Aquellas que sean traducibles y que el idioma master tenga valor pero no haya traducción. (YVES: agregar que el idioma master tenga valor, hay traducción, pero en el master haya habido modificación)
			};

			scope.textWithQuotes = function (text) {
				return text.replace(/'/g, "&apos;");
			};

			scope.buildControl = function (idx, clave, pregunta, tipo) {
				if (!scope.preview) {
					scope.setValorOriginal(idx, clave);//esto esta antes de la definicion la variable clave a proposito. Ya que hay veces que nos llega por parametro y veces que no. Queremos distinguir esos casos.
					if (angular.isUndefined(clave))
						clave = "valor";
				}
				var prop;
				if (angular.isDefined(clave))
					prop = scope.getUniqueID(idx, clave);
				else
					prop = scope.getUniqueID(idx);

				var tag;
				if (angular.isDefined(tipo))
					tag = scope.getHTMLTag(tipo);
				else
					tag = scope.getHTMLTag(scope.pregunta.pregunta.tipo_valor);

				if (angular.isUndefined(pregunta)) {
					if (scope.modoTraduccion) {
						pregunta = scope.pregunta.pregunta_idioma.pregunta || scope.pregunta.pregunta_idioma.pregunta_formulario || scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					}
					else {
						pregunta = scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					}
				}

				var strEl = "";
				pregunta = scope.textWithQuotes(pregunta);
				if (scope.preview)
					strEl = "<div class='" + scope.getCssClass() + "'><" + tag + " ng-model='data[\"" + prop + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ng-disabled='pregunta.pregunta.bloqueado || tienePerfilRestringido()' " + scope.addSpecificProperties(clave) + "></" + tag + "></div>";
				else {
					strEl = "<div class='" + scope.getCssClass() + "'>";

					var isRequired = 0;
					if (clave != "valor") {
						var propertyValidarSubpregunta = "validar_" + clave.replace("respuesta", "pregunta");
						isRequired = scope.pregunta.pregunta.obligatoria && scope.pregunta.pregunta[propertyValidarSubpregunta];
					}
					else {
						isRequired = scope.pregunta.pregunta.obligatoria;
					}

					if (scope.modoTraduccion) {
						if (scope.sePuedeVisualizar(idx, clave)) {
							var propertyVisible;
							if (clave == "valor") {
								propertyVisible = (scope.pregunta.pregunta.traducible) ? "respuestas_idioma" : "respuestas";
								scope.se_puede_visualizar = true;
								strEl += "<" + tag + " ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ";
								strEl += "ng-disabled='(pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido() || (!pregunta.pregunta.traducible) || (pregunta.pregunta.tipo_valor != \"TEXTO\")) || (!pregunta.respuestas[" + idx + "].valor && pregunta.respuestas_idioma[" + idx + "].fecha_modif_valor == null) || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\""+tag+"\")'";
								strEl += " ix-focus-out='guardarTraduccion' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
							} else {
								var propertyTraduccion = clave;
								propertyTraduccion = clave.replace("sub_respuesta", "sub_pregunta");

								var propertyTraducible = propertyTraduccion + "_traducible";

								propertyVisible = (scope.pregunta.pregunta[propertyTraducible]) ? "respuestas_idioma" : "respuestas";

								var tipoValor = "tipo_valor_" + propertyTraduccion;

								//strEl += "<" + tag + " ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ";
								strEl += "<" + tag + " ng-model='pregunta[\"" + propertyVisible + "\"][" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='" + isRequired + "' ";
								strEl += "ng-disabled='(pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido() || (!pregunta.pregunta[\"" + propertyTraducible + "\"])) || (pregunta.pregunta[\"" + tipoValor + "\"] != \"TEXTO\") || (!pregunta.respuestas[" + idx + "][\"" + clave + "\"] && pregunta.respuestas_idioma[" + idx + "][\"fecha_modif_" + clave + "\"] == null) || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\""+tag+"\")' ";
								strEl += "ix-focus-out='guardarTraduccion' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
							}
						} else if (clave == "valor") {
							scope.se_puede_visualizar = false;
						}
					}
					else {
						scope.se_puede_visualizar = true;

						if (tag == "ix-select-multiple-ft" && scope.pregunta.respuestas[idx][clave] != "")
							scope.pregunta.respuestas[idx][clave] = ixUtilsService.fromJson(scope.pregunta.respuestas[idx][clave]);

						//strEl += "<" + tag + " ng-model='pregunta.respuestas[" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='pregunta.pregunta.obligatoria' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido()' ix-focus-out='guardarValor' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
						strEl += "<" + tag + " ng-model='pregunta.respuestas[" + idx + "][\"" + clave + "\"]' name='" + pregunta + "' ng-required='" + isRequired + "' ng-disabled='pregunta.respuestas[" + idx + "].bloqueado || !status.editing || tienePerfilRestringido() || tieneLlamadasPendientes(pregunta.respuestas[" + idx + "].id,\""+tag+"\")' ix-focus-out='guardarValor' ix-focus-out-param='" + clave + "' ix-focus-out-param-idx='" + idx + "' " + scope.addSpecificProperties(clave, scope.multiplesElementosEnLaLinea()) + "></" + tag + ">";
					}

					strEl += "</div>";

				}
				var el = $compile(strEl)(scope);
				return el;
			};

			//			scope.getSelected = function(idx, clave){//Esta funcion hace que cuando estemos en modo traducción, aparezca por defecto
			//				if(!scope.pregunta.respuestas_idioma[idx][clave]){
			//					scope.pregunta.respuestas_idioma[idx][clave] = scope.pregunta.respuestas[idx][clave];
			//					scope.setValorOriginal(idx, clave);
			//				}
			//			};

			scope.cuentaSubPreguntas = function () {
				var num = 0;
				if (scope.pregunta.pregunta.sub_pregunta1)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta2)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta3)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta4)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta5)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta6)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta7)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta8)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta9)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta10)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta11)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta12)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta13)
					num++;
				if (scope.pregunta.pregunta.sub_pregunta14)
					num++;
				if (num > 0)
					num++;//sumamos uno para despues dividir el ancho para que quepan como minimo 3 controles por fila.
				return num;
			};

			scope.buildControlSubPreguntas = function (idx) {
				//var strEl = "";
				var propertyPregunta = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				for (var i = 1; i <= 14; i++) {
					if (scope.pregunta[propertyPregunta]["sub_pregunta" + i]) {
						scope.creando_subpregunta = true;
						elem.append(scope.buildControl(idx, "sub_respuesta" + i, scope.pregunta[propertyPregunta]["sub_pregunta" + i], scope.pregunta.pregunta["tipo_valor_sub_pregunta" + i]));
						scope.creando_subpregunta = false;
					}

				}
				//return strEl;
			};

			scope.guardarObservaciones = function () {

				var entity = (scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det";
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
				$log.log("guardamos solo si ha cambiado.");
				if (scope.observaciones_original != scope.pregunta[respuestasProperty][0].observaciones) {
					scope.observaciones_original = scope.pregunta[respuestasProperty][0].observaciones;
					$log.log("ha cambiado, guardamos.");
					$log.log(scope.pregunta);
					var data = [
						{
							op: "replace",
							path: "/observaciones",
							value: scope.pregunta[respuestasProperty][0].observaciones
						}
					];

					var pathParams = scope.pregunta[respuestasProperty][0].id;
					if (scope.modoTraduccion)
						pathParams += "/" + scope.pregunta[respuestasProperty][0].idioma;

					$http.put(cfg.baseURL + entity + "/" + pathParams, data);
				}
			};

			scope.guardarValor = function (event) {

				var entity = "extranet_fichas_tecnicas_det";
				var respuestaProp = "respuestas";

				scope.grabarValor(event, entity, respuestaProp);
			};

			scope.guardarTraduccion = function (event) {
				var entity = "extranet_fichas_tecnicas_det_idioma";
				var respuestaProp = "respuestas_idioma";

				scope.$broadcast("focusOut");

				scope.grabarValor(event, entity, respuestaProp);
			};

			scope.grabarValor = function (event, entity, respuestaProp) {
				if (!scope.inPopup) {
					var prop = event.data.prop;
					var idx = event.data.idx;
					var valor_original_prop = "valor_original";
					if (prop != "valor")
						valor_original_prop += "_" + prop;

					$log.log("guardamos solo si ha cambiado.");
					if (scope[valor_original_prop][idx] != scope.pregunta[respuestaProp][idx][prop]) {

						var auxValorOriginal = scope[valor_original_prop][idx];
						var nuevoValor = scope.pregunta[respuestaProp][idx][prop];

						scope[valor_original_prop][idx] = scope.pregunta[respuestaProp][idx][prop];
						$log.log("ha cambiado, guardamos.");
						$log.log(scope.pregunta);

						var valor = scope.pregunta[respuestaProp][idx][prop];
						if (angular.isArray(valor))
							valor = ixUtilsService.toJson(valor);

						var data = [
							{
								op: "replace",
								path: "/" + prop,
								value: valor
							}
						];
						var pathParams = scope.pregunta[respuestaProp][idx].id;
						if (scope.modoTraduccion)
							pathParams += "/" + scope.pregunta[respuestaProp][idx].idioma;

						$http.put(cfg.baseURL + entity + "/" + pathParams, data).then(function (response) {
							//Descomentar las siguientes lineas en el caso del cálculo automático de redondeos, valores por ración y valores energéticos para nutricionales
							//OJO: Hay un BUG que resolver en la función actualizarRespuestas, porque modifica el valor de la pregunta 828 (YVES 19/11/2020)
							/* START
							if (scope.pregunta.pregunta.id_pregunta == 828) {
								scope.actualizarGrids(777);
								scope.actualizarGrids(856);
							}
							END */
							// if (cfg.appCliente == "EUROMADI") {
							// 	if (scope.pregunta.pregunta.id_pregunta == 855){
							// 		scope.actualizarGrids(855);
							// 	}
							// }
							// if (cfg.appCliente == "BONPREU") {
							// 	//Tablas de nutricionales y Vitaminas y minerales para fichas de ALIMENTACIÓN
							// 	if (scope.pregunta.pregunta.id_pregunta == 5083) {
							// 		scope.actualizarGrids(5084);
							// 		scope.actualizarGrids(5637);
							// 	}

							// 	//Tablas de nutricionales y Vitaminas y minerales para fichas de FRESCOS
							// 	if (scope.pregunta.pregunta.id_pregunta == 5791) {
							// 		scope.actualizarGrids(5792);
							// 		scope.actualizarGrids(5793);
							// 	}
							// }

							if (scope.modoTraduccion)
								scope.pregunta[respuestaProp][idx]["fecha_modif_" + prop] = null;
							ixStatusService.setResponse(response);
							$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION", { newValue: nuevoValor, oldValue: auxValorOriginal, pregunta: scope.pregunta.pregunta });
						}, function (err) {
							//Si diera error al guardar, conservamos el valor anterior.
							scope.pregunta[respuestaProp][idx][prop] = auxValorOriginal;
							ixStatusService.setResponse(err);
						});
					}
				}
			};

			scope.loadValores = function (param, search, entity) {
				var deferr = $q.defer();
				var valores = [];
				var propertyPregunta = (scope.modoTraduccion && scope.pregunta.pregunta.traducible) ? "pregunta_idioma" : "pregunta";
				var propertyValores = "diccionario_valores";
				var propertyName = entity;
				if (propertyName.lastIndexOf("sub_pregunta") != -1) {
					propertyName = propertyName.substring(propertyName.indexOf("sub_pregunta"));
					propertyValores = "diccionario_" + propertyName + "_valores";
				}
				angular.forEach(scope.pregunta[propertyPregunta][propertyValores], function (valor) {
					valores.push({ codigo: valor, descripcion: valor });
				});
				deferr.resolve({ data: valores });
				return deferr.promise;
			};

			scope.addSpecificProperties = function (tipoProp, multiplesElementosEnLaLinea) {
				var nameProperty = "";
				var namePropertyOriginal = "";
				var numlineas = "1";

				if (angular.isUndefined(tipoProp) || tipoProp == "valor") {
					nameProperty = "valor";
					tipoProp = "tipo_valor";
					numlineas = scope.pregunta.pregunta.numlineas_texto_pregunta;
				}
				else if (tipoProp.lastIndexOf("sub_respuesta") != -1) {
					namePropertyOriginal = tipoProp;
					tipoProp = tipoProp.replace("sub_respuesta", "sub_pregunta");
					nameProperty = tipoProp;
					tipoProp = "tipo_valor_" + tipoProp;
					numlineas = scope.pregunta.pregunta["numlineas_texto_" + nameProperty];
				}
				var specificProperties = "";

				switch (scope.pregunta.pregunta[tipoProp]) {
					case tiposValor.TEXTO:

						specificProperties += "rows='" + numlineas + "' ";
						if (scope.modoTraduccion) {
							if (nameProperty == "valor") {
								specificProperties += "custom-hint='" + scope.pregunta.respuestas[0].valor + "' ng-class='icon-left' traducible='" + scope.pregunta.pregunta.traducible + "' confirmado='" + (!scope.pregunta.respuestas_idioma[0].fecha_modif_valor) + "' ";
							}
							else {
								specificProperties += "custom-hint='" + scope.pregunta.respuestas[0][namePropertyOriginal] + "' ng-class='icon-left' traducible='" + scope.pregunta.pregunta[nameProperty + "_traducible"] + "' confirmado='" + (!scope.pregunta.respuestas_idioma[0]["fecha_modif_" + namePropertyOriginal]) + "' ";
							}
						}
						break;
					case tiposValor.NUMERICO:
						specificProperties += "rows='1' ";
						specificProperties += "ix-number ";
						break;
					case tiposValor.DECIMAL:
						specificProperties += "rows='1' ";
						specificProperties += "ix-number ";
						specificProperties += "with-decimals='2' ";
						specificProperties += "comma-separator='true' ";
						break;
					case tiposValor.DICCIONARIO:
					case tiposValor.DICCIONARIO_MULTIPLE:
						scope.addNewElementsToDictionary(tipoProp);
						specificProperties += "entity='" + tipoProp + "' pk='codigo' desc='descripcion' load-function='loadValores' append-to-body='true' limit-to='9999' ";
						if (scope.modoTraduccion) {
							specificProperties += " keep-original-value='true' ";
						}
						break;
					case tiposValor.FECHA:
						specificProperties += "append-to-body='true' ";
						break;
					case tiposValor.SINO:
						specificProperties += ((scope.modoTraduccion) ? "after-click='guardarTraduccion' " : "after-click='guardarValor' ");
						if (multiplesElementosEnLaLinea)
							specificProperties += " text-max-width='true' ";
						break;
				}

				if (scope.modoTraduccion) {
					if (nameProperty == "valor" && scope.pregunta.pregunta.traducible && scope.pregunta.respuestas[0].valor)
						specificProperties += " placeholder='" + scope.pregunta.respuestas[0].valor + "' ";
					else if (scope.pregunta.pregunta[nameProperty + "_traducible"] && scope.pregunta.respuestas[0][namePropertyOriginal])
						specificProperties += " placeholder='" + scope.pregunta.respuestas[0][namePropertyOriginal] + "' ";
				}

				if (scope.pregunta.pregunta.ayuda_pregunta && !scope.inPopup) {
					if (scope.modoTraduccion)
						specificProperties += "ix-hint='" + scope.textWithQuotes(scope.pregunta.pregunta_idioma.ayuda_pregunta) + "'  float-left='true' ";
					else
						specificProperties += "ix-hint='" + scope.textWithQuotes(scope.pregunta.pregunta.ayuda_pregunta) + "'  float-left='true' ";
				}


				specificProperties += " label-class='" + scope.labelClass + "' input-class='" + scope.inputClass + "' ";

				return specificProperties;
			}
			//CONTROLES DE FORMULARIO FIN

			//GRID INI
			scope.isRowSelectable = function (row) {
				return !row.entity.bloqueado;
			};

			scope.estaBloqueadoValor = function (cell) {
				return (scope.estaBloqueado(cell)) || scope.pregunta.pregunta.bloquear_valor_b || scope.tienePerfilRestringido();
			};

			scope.estaBloqueado = function (cell) {
				if (cell.col.field == "valor")
					return cell.row.entity.bloqueado || (scope.modoTraduccion && !scope.pregunta.pregunta.traducible) || scope.tienePerfilRestringido();
				else {
					//miramos si la sub_pregunta esta bloqueada.
					var propertyFTPreguntas = cell.col.field.replace("respuesta", "pregunta");
					var propertyABuscar = "deshabilitar_" + propertyFTPreguntas;
					var propertyTraducible = propertyFTPreguntas + "_traducible";
					return (scope.pregunta.pregunta[propertyABuscar] == 1 || cell.row.entity.bloqueado) || (scope.modoTraduccion && !scope.pregunta.pregunta[propertyTraducible]) || scope.tienePerfilRestringido();
				}
			};

			scope.getFakeMetadata = function () {
				var metadata = [{ Name: "id", NoVisible: true, Pk: true }];
				var auxTitle = scope.pregunta.pregunta.pregunta_formulario;
				if (scope.pregunta.pregunta.bucle == 1)
					auxTitle = scope.pregunta.pregunta.titulo_primera_columna;
				var valor = { Name: "valor", ColumnDescription: auxTitle, Type: "String", NoEditable: scope.estaBloqueadoValor, NoFilterable: true };
				scope.addSpecificControl(valor, scope.pregunta.pregunta.tipo_valor, scope.esGridJerarquico());
				metadata.push(valor);
				if (scope.pregunta.pregunta.sub_pregunta1) {
					var sub_pregunta1 = { Name: "sub_respuesta1", ColumnDescription: scope.pregunta.pregunta.sub_pregunta1, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta1, scope.pregunta.pregunta.tipo_valor_sub_pregunta1, scope.esGridJerarquico());
					metadata.push(sub_pregunta1);
				}
				if (scope.pregunta.pregunta.sub_pregunta2) {
					var sub_pregunta2 = { Name: "sub_respuesta2", ColumnDescription: scope.pregunta.pregunta.sub_pregunta2, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta2, scope.pregunta.pregunta.tipo_valor_sub_pregunta2, scope.esGridJerarquico());
					metadata.push(sub_pregunta2);
				}
				if (scope.pregunta.pregunta.sub_pregunta3) {
					var sub_pregunta3 = { Name: "sub_respuesta3", ColumnDescription: scope.pregunta.pregunta.sub_pregunta3, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta3, scope.pregunta.pregunta.tipo_valor_sub_pregunta3, scope.esGridJerarquico());
					metadata.push(sub_pregunta3);
				}
				if (scope.pregunta.pregunta.sub_pregunta4) {
					var sub_pregunta4 = { Name: "sub_respuesta4", ColumnDescription: scope.pregunta.pregunta.sub_pregunta4, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta4, scope.pregunta.pregunta.tipo_valor_sub_pregunta4, scope.esGridJerarquico());
					metadata.push(sub_pregunta4);
				}
				if (scope.pregunta.pregunta.sub_pregunta5) {
					var sub_pregunta5 = { Name: "sub_respuesta5", ColumnDescription: scope.pregunta.pregunta.sub_pregunta5, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta5, scope.pregunta.pregunta.tipo_valor_sub_pregunta5, scope.esGridJerarquico());
					metadata.push(sub_pregunta5);
				}
				if (scope.pregunta.pregunta.sub_pregunta6) {
					var sub_pregunta6 = { Name: "sub_respuesta6", ColumnDescription: scope.pregunta.pregunta.sub_pregunta6, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta6, scope.pregunta.pregunta.tipo_valor_sub_pregunta6, scope.esGridJerarquico());
					metadata.push(sub_pregunta6);
				}
				if (scope.pregunta.pregunta.sub_pregunta7) {
					var sub_pregunta7 = { Name: "sub_respuesta7", ColumnDescription: scope.pregunta.pregunta.sub_pregunta7, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta7, scope.pregunta.pregunta.tipo_valor_sub_pregunta7, scope.esGridJerarquico());
					metadata.push(sub_pregunta7);
				}
				if (scope.pregunta.pregunta.sub_pregunta8) {
					var sub_pregunta8 = { Name: "sub_respuesta8", ColumnDescription: scope.pregunta.pregunta.sub_pregunta8, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta8, scope.pregunta.pregunta.tipo_valor_sub_pregunta8, scope.esGridJerarquico());
					metadata.push(sub_pregunta8);
				}
				if (scope.pregunta.pregunta.sub_pregunta9) {
					var sub_pregunta9 = { Name: "sub_respuesta9", ColumnDescription: scope.pregunta.pregunta.sub_pregunta9, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta9, scope.pregunta.pregunta.tipo_valor_sub_pregunta9, scope.esGridJerarquico());
					metadata.push(sub_pregunta9);
				}
				if (scope.pregunta.pregunta.sub_pregunta10) {
					var sub_pregunta10 = { Name: "sub_respuesta10", ColumnDescription: scope.pregunta.pregunta.sub_pregunta10, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta10, scope.pregunta.pregunta.tipo_valor_sub_pregunta10, scope.esGridJerarquico());
					metadata.push(sub_pregunta10);
				}
				if (scope.pregunta.pregunta.sub_pregunta11) {
					var sub_pregunta11 = { Name: "sub_respuesta11", ColumnDescription: scope.pregunta.pregunta.sub_pregunta11, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta11, scope.pregunta.pregunta.tipo_valor_sub_pregunta11, scope.esGridJerarquico());
					metadata.push(sub_pregunta11);
				}
				if (scope.pregunta.pregunta.sub_pregunta12) {
					var sub_pregunta12 = { Name: "sub_respuesta12", ColumnDescription: scope.pregunta.pregunta.sub_pregunta12, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta12, scope.pregunta.pregunta.tipo_valor_sub_pregunta12, scope.esGridJerarquico());
					metadata.push(sub_pregunta12);
				}
				if (scope.pregunta.pregunta.sub_pregunta13) {
					var sub_pregunta13 = { Name: "sub_respuesta13", ColumnDescription: scope.pregunta.pregunta.sub_pregunta13, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta13, scope.pregunta.pregunta.tipo_valor_sub_pregunta13, scope.esGridJerarquico());
					metadata.push(sub_pregunta13);
				}
				if (scope.pregunta.pregunta.sub_pregunta14) {
					var sub_pregunta14 = { Name: "sub_respuesta14", ColumnDescription: scope.pregunta.pregunta.sub_pregunta14, Type: "String", NoEditable: scope.estaBloqueado, NoFilterable: true };
					scope.addSpecificControl(sub_pregunta14, scope.pregunta.pregunta.tipo_valor_sub_pregunta14, scope.esGridJerarquico());
					metadata.push(sub_pregunta14);
				}
				return metadata;
			};

			scope.addNewElementsToDictionary = function (prop) {
				var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
				var diccionarioProperty = "diccionario_valores";
				var valorProperty = "valor";
				if(prop.startsWith("tipo_valor_sub_pregunta")) {
					diccionarioProperty = prop.replace("tipo_valor_sub_","diccionario_sub_")+"_valores";
					valorProperty = prop.replace("tipo_valor_sub_pregunta","sub_respuesta");
				}

				scope.pregunta[respuestasProperty].forEach(function (respuesta) {					
					if (scope.pregunta[preguntaProperty][diccionarioProperty]) {
						if (angular.isArray(respuesta[valorProperty])) {
							respuesta[valorProperty].forEach(function (sub_respuesta) {
								if (scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(sub_respuesta) == -1) {
									scope.pregunta[preguntaProperty][diccionarioProperty].push(sub_respuesta);
								}
							});
						} else if(respuesta[valorProperty] && respuesta[valorProperty].indexOf(";")>=0) {
								respuesta[valorProperty].split(";").forEach(function (sub_respuesta) {
								if (scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(sub_respuesta) == -1) {
									scope.pregunta[preguntaProperty][diccionarioProperty].push(sub_respuesta);
								}
							});
						} else if(respuesta[valorProperty] && respuesta[valorProperty].indexOf(",")>=0) {
							respuesta[valorProperty].split(",").forEach(function (sub_respuesta) {
								if (scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(sub_respuesta) == -1) {
									scope.pregunta[preguntaProperty][diccionarioProperty].push(sub_respuesta);
								}
							});
						}
						else if (respuesta[valorProperty] && scope.pregunta[preguntaProperty][diccionarioProperty].indexOf(respuesta[valorProperty]) == -1) {
							scope.pregunta[preguntaProperty][diccionarioProperty].push(respuesta[valorProperty]);
						}
					}
				});
		
			};

			scope.addSpecificControl = function (obj, tipo, esJerarquico) {
				var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";

				if (esJerarquico && scope.modoTraduccion && tipo == tiposValor.DICCIONARIO_MULTIPLE)
					tipo = tiposValor.TEXTO;

				if (tipo == tiposValor.TEXTO) {
					if (scope.modoTraduccion) {
						if (obj.Name == "valor" && scope.pregunta.pregunta.traducible) {
							obj.cellTemplate = "app/FTBase/views/ui-grid-cell-traduccion.html";
							obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
						} else {
							var nameColumn = obj.Name.replace("respuesta", "pregunta");
							if (scope.pregunta.pregunta[nameColumn + "_traducible"]) {
								obj.cellTemplate = "app/FTBase/views/ui-grid-cell-traduccion.html";
								obj.editableCellTemplate = "app/FTBase/views/ui-grid-cell-editor-traduccion.html";
							}
						}
					} else {
						obj.Control = "List";
					}
				}

				if (tipo == tiposValor.SINO) {
					if (scope.modoTraduccion)
						obj.NoEditable = true;

					obj.Control = "CheckBox";
					obj.Type = "Int32";
					obj.ignoreCellModifications = true;
				}
				else if (tipo == tiposValor.DICCIONARIO || tipo == tiposValor.DICCIONARIO_MULTIPLE) {
					if (scope.modoTraduccion)
						obj.NoEditable = true;

					if (tipo == tiposValor.DICCIONARIO_MULTIPLE)
						obj.Control = "MultiBusqueda";

					switch (obj.Name) {
						case "valor":
							if (scope.pregunta[preguntaProperty].diccionario_valores) scope.addNewElementsToDictionary("tipo_valor");
							break;
						case "sub_respuesta1":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta1_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta1");
							break;
						case "sub_respuesta2":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta2_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta2");
							break;
						case "sub_respuesta3":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta3_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta3");
							break;
						case "sub_respuesta4":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta4_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta4");
							break;
						case "sub_respuesta5":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta5_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta5");
							break;
						case "sub_respuesta6":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta6_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta6");
							break;
						case "sub_respuesta7":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta6_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta7");
							break;
						case "sub_respuesta8":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta8_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta8");
							break;
						case "sub_respuesta9":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta9_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta9");
							break;
						case "sub_respuesta10":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta10_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta10");
							break;
						case "sub_respuesta11":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta11_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta11");
							break;
						case "sub_respuesta12":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta12_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta12");
							break;
						case "sub_respuesta13":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta13_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta13");
							break;
						case "sub_respuesta14":
							if (scope.pregunta[preguntaProperty].diccionario_sub_pregunta14_valores) scope.addNewElementsToDictionary("tipo_valor_sub_pregunta14");
							break;
					}

					if (esJerarquico && obj.Name == "valor")
						obj.ColumnFkDescription = "valor";

					obj.Search = {
						"KeyFields": [obj.Name],
						"LookUpTableName": "",
						"LookUpKeyFields": ["codigo"],
						"LookUpResultFields": ["codigo"],
						"LookUpTableAlias": "",
						"LookUpOrders": [{ "KeyField": "codigo", "Desc": false }],
						"LookUpConditions": []
					};
					obj.busquedaFunction = function (column, param, text) {
						var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";
						var deferr = $q.defer();
						var valores = [];
						var diccionario_valores = [];
						if (scope.preview)
							diccionario_valores = scope.pregunta.pregunta.diccionario_valores;
						else {
							var fieldToSearch = ((column.Name == "valor") ? "" : column.Name.replace("respuesta", "pregunta"));
							fieldToSearch = "diccionario_" + fieldToSearch + ((fieldToSearch != "") ? "_" : "") + "valores";
							diccionario_valores = scope.pregunta[preguntaProperty][fieldToSearch];
						}

						if (text)
							diccionario_valores = diccionario_valores.filter(function (e) { return e.toLowerCase().indexOf(text.toLowerCase()) != -1; });

						angular.forEach(diccionario_valores, function (valor) {
							var item = { codigo: valor, descripcion: valor };
							if (column.ColumnFKDescription)
								item[column.ColumnFKDescription] = valor;

							valores.push(item);
						});
						deferr.resolve(valores);
						return deferr.promise;
					};
				}
				else if (tipo == tiposValor.FECHA)
					obj.Type = "DateTime";
				else if (tipo == tiposValor.DECIMAL) {
					obj.Type = "Decimal";
					obj.MaxLength = 11;
					obj.CommaSeparator = true; // Forzar cambio de . por , en la entrada de valores
				}
				else if (tipo == tiposValor.NUMERICO) {
					obj.Type = "Int32";
					obj.MaxLength = 11;
				}
			};

			scope.guardarDatosGrid = function (rowEntity, colDef, newValue, oldValue) {
				// $log.log("guardaremos los datos del grid.");
				// $log.log(rowEntity);
				// $log.log(colDef);
				// $log.log(newValue);
				// $log.log(oldValue);
				var data = [
					{
						op: "replace",
						path: "/" + colDef.name,
						value: newValue
					}
				];

				var entity = ((scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det");
				var preguntaProperty = (scope.modoTraduccion) ? "pregunta_idioma" : "pregunta";

				var pathParams = rowEntity.id;
				if (scope.modoTraduccion)
					pathParams += "/" + scope.pregunta.respuestas_idioma[0].idioma;

				rowEntity.editingCols=rowEntity.editingCols||[];
				rowEntity.editingCols.push(colDef.name);
				$http.put(cfg.baseURL + entity + "/" + pathParams, data).then(function (response) {
					var iCol = rowEntity.editingCols.indexOf(colDef.name);
					if(iCol>-1) {
						rowEntity.editingCols.splice(iCol);
					}
					if (!scope.modoTraduccion) {
						//Modificar propietats de la línea actual per el que arriva de l'API.

						//Modificar una pregunta pot fer que s'hagi de recarregar un altre.
						if (cfg.appCliente == "EUROMADI") {
							if (scope.pregunta[preguntaProperty].id_pregunta == 845)
								scope.addToReload([780]);
						}
						if (cfg.appCliente == "BONPREU") {
							if (scope.pregunta[preguntaProperty].id_pregunta == 5634)
								scope.addToReload([5102]);
							if (scope.pregunta[preguntaProperty].id_pregunta == 5794)
								scope.addToReload([5799]);
						}

						if (response.data.obj) {
							//Guardamos lo que devuelve la API pero si fueran booleanos, como viene como string lo pasamos a booleano.
							//OJO!!! Esto no muestra el valor en celdas numéricas en las cuales se quiera poner el valor 1 ó 0. Debe de sustituirse el valor sólo si la celda es de tipo Checkbox
							if (response.data.obj.Record[colDef.name] === "1" && colDef.control == "CheckBox") {
								rowEntity[colDef.name] = 1;
							}
							else if (response.data.obj.Record[colDef.name] === "0" && colDef.control == "CheckBox") {
								rowEntity[colDef.name] = 0;
							}
							else {
								rowEntity[colDef.name] = response.data.obj.Record[colDef.name];
							}

						}
						//En alguns casos (id_pregunta hardcoded), el grid s'haura de recarregar sencer.
						//Descomentar las siguientes lineas en el caso del cálculo automático de redondeos, valores por ración y valores energéticos para nutricionales
						/* START
						if (scope.pregunta[preguntaProperty].id_pregunta == 777) {
							scope.actualizarGrids(777, rowEntity.componente);
						}
						END */
						if ((scope.pregunta[preguntaProperty].id_pregunta == 1160 || scope.pregunta[preguntaProperty].id_pregunta == 1168 || scope.pregunta[preguntaProperty].id_pregunta == 1173 || scope.pregunta[preguntaProperty].id_pregunta == 1178) 
							&& cfg.appCliente == "EUROMADI") {
							if (colDef.name == "sub_respuesta3")
								scope.actualizarGridsSinComponente(scope.pregunta[preguntaProperty].id_pregunta);
							// Actualiamos la los valores de rowEntity porque el grid tiene columnas con valores calculados en backend
							if(response.data.obj) {
								var grid = scope.data.grids["grid"+scope.pregunta[preguntaProperty].id_pregunta];
								Object.keys(response.data.obj.Record).forEach(function(key){
									var colDef = grid.columnDefs.find(function(cd){cd.field==key})
									if (colDef && response.data.obj.Record[colDef.name] === "1" && colDef.control == "CheckBox") {
										rowEntity[colDef.name] = 1;
									}
									else if (colDef && response.data.obj.Record[colDef.name] === "0" && colDef.control == "CheckBox") {
										rowEntity[colDef.name] = 0;
									}
									else {
										rowEntity[key] = response.data.obj.Record[key];
									}									
								})
							}
						}

						// if (cfg.appCliente == "BONPREU") {
						// 	//Tabla de nutricionales para fichas de ALIMENTACIÓN
						// 	if (scope.pregunta[preguntaProperty].id_pregunta == 5084) {
						// 		scope.actualizarGrids(5084, rowEntity.componente);
						// 	}
						// 	//Tabla de nutricionales para fichas de FRESCOS
						// 	if (scope.pregunta[preguntaProperty].id_pregunta == 5792) {
						// 		scope.actualizarGrids(5792, rowEntity.componente);
						// 	}
						// }
					} else {
						rowEntity["fecha_modif_"+colDef.name] = response.data.obj.Record["fecha_modif_"+colDef.name];
					}

					$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: newValue, oldValue: oldValue, pregunta: response.data.obj.Record, tipo_modificacion: "Update" });
					ixStatusService.setResponse(response);
				}, function (err) {
					//Si diera error al guardar, conservamos el valor anterior.
					rowEntity[colDef.name] = oldValue;
					ixStatusService.setResponse(err);
					var iCol = rowEntity.editingCols.indexOf(colDef.name);
					if(iCol>-1) {
						rowEntity.editingCols.splice(iCol);
					}
				});
			};

			scope.esGridJerarquico = function () {
				return scope.pregunta.pregunta.sub_bucle == 1;
			};

			scope.getEntityMaster = function (id) {
				return scope.pregunta.respuestas.find(function (e) { return e.id == id; });
			};

			scope.eliminarIngrediente = function (entity, grid) {
				//var gridRows = grid.rows.map(function(e){return e.entity;});
				var gridRows = grid.data;
				var pos = gridRows.indexOf(entity);
				var ingredienteSiguiente = gridRows[pos + 1];
				if (!ingredienteSiguiente) {
					//No hay más ingredientes, por lo tanto es ingrediente único
					scope.deleteRow({ grid: grid, row: entity });
				}
				else {
					if (ingredienteSiguiente["$$treeLevel"] > entity["$$treeLevel"]) {

						ixWarningsService.warningConfirmacion(scope, "¡Atención!  Se eliminarán todos los subingredientes ¿Deseas confirmar?", scope.deleteRow, undefined, { grid: grid, row: entity });
					}
					else {
						scope.deleteRow({ grid: grid, row: entity });
					}
				}
			};

			scope.abrirPopupAlimentacion = function (entity, grid, isNew) {
				var entityOriginal = angular.copy(entity);

				var templateURL = "app/FTBase/views/grid_jerarquico_add_row_popup.html";
				var optionsPopup = { controller: "GridJerarquicoAddRowPopupController" };
				var paramsPopup = { entity: entity, pregunta: scope.pregunta, isNew: isNew, modoTraduccion: scope.modoTraduccion };

				if (scope.modoTraduccion) {
					paramsPopup.entityMaster = scope.getEntityMaster(entity.id);
				}

				if (angular.isDefined(grid)) {
					paramsPopup.rowsGrid = (isNew) ? grid.data : [];
					paramsPopup.grid = grid;
					grid.ixRefreshGridDropDowns();
				}

				ixUtilsService.openModalV2(templateURL, optionsPopup, "medium", paramsPopup).then(function (response) {
					if (angular.isDefined(response)) {
						if (!isNew) {
							var changes = ixGetPatchOperations(entityOriginal, entity);
							var tabla = (scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det";
							var pathParams = entity.id;
							if (scope.modoTraduccion)
								pathParams += "/" + scope.pregunta.respuestas_idioma[0].idioma;

							$http.put(cfg.baseURL + tabla + "/" + pathParams, changes).then(function (response) {
								if (scope.modoTraduccion) {
									entity.fecha_modif_valor = response.data.obj.Record.fecha_modif_valor;
									entity.fecha_modif_sub_respuesta1 = response.data.obj.Record.fecha_modif_sub_respuesta1;
									entity.fecha_modif_sub_respuesta2 = response.data.obj.Record.fecha_modif_sub_respuesta2;
									entity.fecha_modif_sub_respuesta3 = response.data.obj.Record.fecha_modif_sub_respuesta3;
									entity.fecha_modif_sub_respuesta4 = response.data.obj.Record.fecha_modif_sub_respuesta4;
									entity.fecha_modif_sub_respuesta5 = response.data.obj.Record.fecha_modif_sub_respuesta5;
									entity.fecha_modif_sub_respuesta6 = response.data.obj.Record.fecha_modif_sub_respuesta6;
									entity.fecha_modif_sub_respuesta7 = response.data.obj.Record.fecha_modif_sub_respuesta7;
									entity.fecha_modif_sub_respuesta8 = response.data.obj.Record.fecha_modif_sub_respuesta8;
									entity.fecha_modif_sub_respuesta9 = response.data.obj.Record.fecha_modif_sub_respuesta9;
									entity.fecha_modif_sub_respuesta10 = response.data.obj.Record.fecha_modif_sub_respuesta10;
									entity.fecha_modif_sub_respuesta11 = response.data.obj.Record.fecha_modif_sub_respuesta11;
									entity.fecha_modif_sub_respuesta12 = response.data.obj.Record.fecha_modif_sub_respuesta12;
									entity.fecha_modif_sub_respuesta13 = response.data.obj.Record.fecha_modif_sub_respuesta13;
									entity.fecha_modif_sub_respuesta14 = response.data.obj.Record.fecha_modif_sub_respuesta14;
								}
								$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: response.data.obj.Record.valor, oldValue: undefined, pregunta: scope.pregunta.pregunta, tipo_modificacion: "Update" });
							}, function (err) {
								//console.error("Response put ERROR",err);
								entity.sub_respuesta1 = entityOriginal.sub_respuesta1;
								entity.sub_respuesta2 = entityOriginal.sub_respuesta2;
								entity.sub_respuesta3 = entityOriginal.sub_respuesta3;
								entity.sub_respuesta4 = entityOriginal.sub_respuesta4;
								entity.sub_respuesta5 = entityOriginal.sub_respuesta5;
								entity.sub_respuesta6 = entityOriginal.sub_respuesta6;
								entity.sub_respuesta7 = entityOriginal.sub_respuesta7;
								entity.sub_respuesta8 = entityOriginal.sub_respuesta8;
								entity.sub_respuesta9 = entityOriginal.sub_respuesta9;
								entity.sub_respuesta10 = entityOriginal.sub_respuesta10;
								entity.sub_respuesta11 = entityOriginal.sub_respuesta11;
								entity.sub_respuesta12 = entityOriginal.sub_respuesta12;
								entity.sub_respuesta13 = entityOriginal.sub_respuesta13;
								entity.sub_respuesta14 = entityOriginal.sub_respuesta14;
								ixStatusService.setResponse(err);
							});
							if (angular.isDefined(grid) && entity.valor!=entityOriginal.valor) {
								// Si cambia el valor debemos repintar la tabla entera porque sino no se refresca (no es editable)
								grid.ixRefreshGridDropDowns();
								$timeout(function () {
									grid.gridApi.core.refresh();
								}, 300);
							}
						}
					} else {
						scope.actualizarRespuestas(grid.data, grid.data[0].componente, grid);
					}

					//Marcar la pregunta 845 para recargar.
					if (scope.pregunta.pregunta.id_pregunta == 767) {
						scope.addToReload([845, 780]);
					}
				});
			};

			scope.addToReload = function (listaPreguntas) {
				if (angular.isUndefined(scope.data.ToReload))
					scope.data.ToReload = {};

				angular.forEach(listaPreguntas, function (pregunta) {
					if (!scope.data.ToReload[pregunta])
						scope.data.ToReload[pregunta] = true;

				});
			};

			scope.addTreeLevel = function (respuestas) {
				// $timeout(function(){
				// 	angular.forEach(respuestas, function (respuesta) {
				// 		respuesta["$$treeLevel"] = ((respuesta.orden_sub_bucle == 0 || respuesta.orden_tab == 0) ? 0 : (!respuesta.orden_sub_sub_bucle && !respuesta.orden_tab2) ? 1 : 2);
				// 	});
				// 	},1);
					angular.forEach(respuestas, function (respuesta) {
						respuesta["$$treeLevel"] = ((respuesta.orden_sub_bucle == 0 || respuesta.orden_tab == 0) ? 0 : (!respuesta.orden_sub_sub_bucle && !respuesta.orden_tab2) ? 1 : 2);
					});
			};

			scope.getCustomHint = function (row, col) {
				var respuestaOriginal = scope.pregunta.respuestas.find(function (e) { return e.id == row.entity.id; });
				if (angular.isDefined(respuestaOriginal))
					return respuestaOriginal[col.field];
				return "";
			};

			scope.changeCellValue = function (row, col, nuevoValor) {
				var respuesta = scope.pregunta.respuestas_idioma.find(function (e) { return e.id == row.entity.id; });
				respuesta[col.field] = nuevoValor;
			};

			scope.checkColState = function (row, col) {
				var estado = 0;

				if (scope.pregunta.pregunta.traducible && col.field == "valor") {
					if (row.entity.fecha_modif_valor)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta1_traducible && col.field == "sub_respuesta1") {
					if (row.entity.fecha_modif_sub_respuesta1)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta2_traducible && col.field == "sub_respuesta2") {
					if (row.entity.fecha_modif_sub_respuesta2)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_PDT_APROVACION;
				}
				if (scope.pregunta.pregunta.sub_pregunta3_traducible && col.field == "sub_respuesta3") {
					if (row.entity.fecha_modif_sub_respuesta3)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta4_traducible && col.field == "sub_respuesta4") {
					if (row.entity.fecha_modif_sub_respuesta4)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta5_traducible && col.field == "sub_respuesta5") {
					if (row.entity.fecha_modif_sub_respuesta5)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta6_traducible && col.field == "sub_respuesta6") {
					if (row.entity.fecha_modif_sub_respuesta6)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta7_traducible && col.field == "sub_respuesta7") {
					if (row.entity.fecha_modif_sub_respuesta7)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta8_traducible && col.field == "sub_respuesta8") {
					if (row.entity.fecha_modif_sub_respuesta8)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta9_traducible && col.field == "sub_respuesta9") {
					if (row.entity.fecha_modif_sub_respuesta9)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta10_traducible && col.field == "sub_respuesta10") {
					if (row.entity.fecha_modif_sub_respuesta10)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta11_traducible && col.field == "sub_respuesta11") {
					if (row.entity.fecha_modif_sub_respuesta11)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta12_traducible && col.field == "sub_respuesta12") {
					if (row.entity.fecha_modif_sub_respuesta12)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta13_traducible && col.field == "sub_respuesta13") {
					if (row.entity.fecha_modif_sub_respuesta13)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				if (scope.pregunta.pregunta.sub_pregunta14_traducible && col.field == "sub_respuesta14") {
					if (row.entity.fecha_modif_sub_respuesta14)
						estado = ESTADO_PDT_APROVACION;
					else
						estado = ESTADO_CONFIRMADO;
				}
				return estado;
			};

			scope.filtrarSoloPendientesTraduccion = function (respuestas) {
				var result = [];
				respuestas.forEach(function (respuesta) {
					//Devolver solo las que sean traducibles y que en master tengan valor pero en la traduccion no.
					var cumple = false;
					var configuracionPregunta = scope.pregunta.pregunta;
					var preguntaMaster = scope.pregunta.respuestas.find(function (e) { return e.id == respuesta.id });

					if (configuracionPregunta.traducible && (preguntaMaster.valor && !respuesta.valor))
						cumple = true;
					if (configuracionPregunta.sub_pregunta1_traducible && (preguntaMaster.sub_respuesta1 && !respuesta.sub_respuesta1))
						cumple = true;
					if (configuracionPregunta.sub_pregunta2_traducible && (preguntaMaster.sub_respuesta2 && !respuesta.sub_respuesta2))
						cumple = true;
					if (configuracionPregunta.sub_pregunta3_traducible && (preguntaMaster.sub_respuesta3 && !respuesta.sub_respuesta3))
						cumple = true;
					if (configuracionPregunta.sub_pregunta4_traducible && (preguntaMaster.sub_respuesta4 && !respuesta.sub_respuesta4))
						cumple = true;
					if (configuracionPregunta.sub_pregunta5_traducible && (preguntaMaster.sub_respuesta5 && !respuesta.sub_respuesta5))
						cumple = true;
					if (configuracionPregunta.sub_pregunta6_traducible && (preguntaMaster.sub_respuesta6 && !respuesta.sub_respuesta6))
						cumple = true;
					if (configuracionPregunta.sub_pregunta7_traducible && (preguntaMaster.sub_respuesta7 && !respuesta.sub_respuesta7))
						cumple = true;
					if (configuracionPregunta.sub_pregunta8_traducible && (preguntaMaster.sub_respuesta8 && !respuesta.sub_respuesta8))
						cumple = true;
					if (configuracionPregunta.sub_pregunta9_traducible && (preguntaMaster.sub_respuesta9 && !respuesta.sub_respuesta9))
						cumple = true;
					if (configuracionPregunta.sub_pregunta10_traducible && (preguntaMaster.sub_respuesta10 && !respuesta.sub_respuesta10))
						cumple = true;
					if (configuracionPregunta.sub_pregunta11_traducible && (preguntaMaster.sub_respuesta11 && !respuesta.sub_respuesta11))
						cumple = true;
					if (configuracionPregunta.sub_pregunta12_traducible && (preguntaMaster.sub_respuesta12 && !respuesta.sub_respuesta12))
						cumple = true;
					if (configuracionPregunta.sub_pregunta13_traducible && (preguntaMaster.sub_respuesta13 && !respuesta.sub_respuesta13))
						cumple = true;
					if (configuracionPregunta.sub_pregunta14_traducible && (preguntaMaster.sub_respuesta14 && !respuesta.sub_respuesta14))
						cumple = true;


					if (cumple)
						result.push(respuesta);
				});
				return result;
			};

			scope.ajustarDataFromApi = function (array, grid) {
				var controlIsCheck = function(columnas, posicion){
					var cd = columnasDefs.find(function(c){ return c.field.toUpperCase() == "SUB_RESPUESTA" + posicion;});
					if (angular.isUndefined(cd))
						return false;
					else
						return cd.control == "CheckBox";
				};
				var columnasDefs = grid.columnDefs;
				var dataRespuestas = [];
				angular.forEach(array, function (value, key) {
					$log.log("array foreach", value, key);
					var dr = {};
					dr.id = value.id;
					dr.idioma = null;
					dr.id_ficha_tecnica = value.id_ficha_tecnica;
					dr.orden_bucle = value.orden_bucle;
					dr.orden_sub_bucle = value.orden_tab===0?0: (value.orden_tab || value.orden_sub_bucle);
					dr.orden_sub_sub_bucle = value.orden_tab2===0?0: (value.orden_tab2 || value.orden_sub_sub_bucle);
					dr.componente = value.componente;
					dr.valor = value.valor;
					dr.observaciones = value.observaciones;

					dr.sub_respuesta1 = value.sub_respuesta1;
					if (controlIsCheck(columnasDefs, 1)){
						if (dr.sub_respuesta1 === '1')
							dr.sub_respuesta1 = 1;
						else
							dr.sub_respuesta1 = 0;
					}

					dr.sub_respuesta2 = value.sub_respuesta2;
					if (controlIsCheck(columnasDefs, 2)){
						if (dr.sub_respuesta2 === '1')
						dr.sub_respuesta2 = 1;
					else
						dr.sub_respuesta2 = 0;
					}

					dr.sub_respuesta3 = value.sub_respuesta3;
					if (controlIsCheck(columnasDefs, 3)){
						if (dr.sub_respuesta3 === '1')
						dr.sub_respuesta3 = 1;
					else
						dr.sub_respuesta3 = 0;
					}

					dr.sub_respuesta4 = value.sub_respuesta4;
					if (controlIsCheck(columnasDefs, 4)){
						if (dr.sub_respuesta4 === '1')
						dr.sub_respuesta4 = 1;
					else
						dr.sub_respuesta4 = 0;
					}

					dr.sub_respuesta5 = value.sub_respuesta5;
					if (controlIsCheck(columnasDefs, 5)){
						if (dr.sub_respuesta5 === '1')
						dr.sub_respuesta5 = 1;
					else
						dr.sub_respuesta5 = 0;
					}

					dr.sub_respuesta6 = value.sub_respuesta6;
					if (controlIsCheck(columnasDefs, 6)){
						if (dr.sub_respuesta6 === '1')
						dr.sub_respuesta6 = 1;
					else
						dr.sub_respuesta6 = 0;
					}
					
					dr.sub_respuesta7 = value.sub_respuesta7;
					if (controlIsCheck(columnasDefs, 7)){
						if (dr.sub_respuesta7 === '1')
							dr.sub_respuesta7 = 1;
						else
							dr.sub_respuesta7 = 0;
					}

					dr.sub_respuesta8 = value.sub_respuesta8;
					if (controlIsCheck(columnasDefs, 8)){
						if (dr.sub_respuesta8 === '1')
							dr.sub_respuesta8 = 1;
						else
							dr.sub_respuesta8 = 0;
					}

					dr.sub_respuesta9 = value.sub_respuesta9;
					if (controlIsCheck(columnasDefs, 9)){
						if (dr.sub_respuesta9 === '1')
							dr.sub_respuesta9 = 1;
						else
							dr.sub_respuesta9 = 0;
					}

					dr.sub_respuesta10 = value.sub_respuesta10;
					if (controlIsCheck(columnasDefs, 10)){
						if (dr.sub_respuesta10 === '1')
							dr.sub_respuesta10 = 1;
						else
							dr.sub_respuesta10 = 0;
					}

					dr.sub_respuesta11 = value.sub_respuesta11;
					if (controlIsCheck(columnasDefs, 11)){
						if (dr.sub_respuesta11 === '1')
							dr.sub_respuesta11 = 1;
						else
							dr.sub_respuesta11 = 0;
					}

					dr.sub_respuesta12 = value.sub_respuesta12;
					if (controlIsCheck(columnasDefs, 12)){
						if (dr.sub_respuesta12 === '1')
							dr.sub_respuesta12 = 1;
						else
							dr.sub_respuesta12 = 0;
					}

					dr.sub_respuesta13 = value.sub_respuesta13;
					if (controlIsCheck(columnasDefs, 13)){
						if (dr.sub_respuesta13 === '1')
							dr.sub_respuesta13 = 1;
						else
							dr.sub_respuesta13 = 0;
					}

					dr.sub_respuesta14 = value.sub_respuesta14;
					if (controlIsCheck(columnasDefs, 14)){
						if (dr.sub_respuesta14 === '1')
							dr.sub_respuesta14 = 1;
						else
							dr.sub_respuesta14 = 0;
					}

					dr.bloqueado = value.bloqueado;
					//dr.contiene_info_etiquetado = false;
					dr.fecha_modif_valor = value.fecha_modif_valor;
					dr.fecha_modif_observaciones = value.fecha_modif_observaciones;
					dr.fecha_modif_sub_respuesta1 = value.fecha_modif_sub_respuesta1;

					dataRespuestas.push(dr);
				});

				//return DataRespuestas;
				$log.log("DataRespuestas",dataRespuestas);
				return dataRespuestas;
			};


			scope.edicionGridEnvase = function (cell) {
				var nivel = cell.row.entity["$$treeLevel"];
				//Puede ser nivel 0 o 1. El 0 es linea principal y 1 linea interna.
				//$log.log("Call edicionGridEnvase, row = " + cell.row.entity["orden_bucle"] + ", $$treeLevel = " + cell.row.entity["$$treeLevel"]);
				var celdas_editables = [];
				if (nivel == 0) {//Nivel principal se puede editar todo menos celdas calculadas 6 y 8.
					if (cell.row.entity["sub_respuesta3"] != "Si")
						celdas_editables = ["VALOR", "SUB_RESPUESTA1", "SUB_RESPUESTA2", "SUB_RESPUESTA3", "SUB_RESPUESTA4", "SUB_RESPUESTA5", "SUB_RESPUESTA7", "SUB_RESPUESTA9", "SUB_RESPUESTA10", "SUB_RESPUESTA11", "SUB_RESPUESTA12", "SUB_RESPUESTA13", "SUB_RESPUESTA14"];
					else
						celdas_editables = ["VALOR", "SUB_RESPUESTA1", "SUB_RESPUESTA2", "SUB_RESPUESTA3"];
				}
				else {
					celdas_editables = ["SUB_RESPUESTA4", "SUB_RESPUESTA5", "SUB_RESPUESTA7", "SUB_RESPUESTA9", "SUB_RESPUESTA10", "SUB_RESPUESTA11", "SUB_RESPUESTA12", "SUB_RESPUESTA13", "SUB_RESPUESTA14"];
				}
				if (celdas_editables.indexOf(cell.col.colDef.name.toUpperCase()) != -1) {
					if (cell.row.entity.bloqueado || (cell.row.entity.editingCols && cell.row.entity.editingCols.indexOf(cell.col.colDef.name)>=0)) {
						return false;
					}
					else {
						return !scope.estaBloqueado(cell) && !((typeof(cell.col.colDef.noeditable) == "function") ? cell.col.colDef.noeditable(cell) : cell.col.colDef.noeditable);
					}
				} else {
					return false;
				}				
			};

			scope.buildGrid = function (respuestas) {
				scope.gridManualLoad = true;
				//var prop = scope.getUniqueID(0);
				var prop = scope.pregunta.pregunta.id_pregunta;
				if (scope.pregunta.pregunta.preguntar_componente) {
					if (angular.isUndefined(scope.contadorTablas)) {
						scope.contadorTablas = 0;
					}
					prop += "-" + scope.contadorTablas;
					scope.contadorTablas++;
				}

				var metadata = scope.getFakeMetadata();
				if (!scope.data.grids) {
					scope.data.grids = {};
				}
				var gridName = "grid" + prop;
				var strEl = "";

				if (!scope.data.grids[gridName]) {
					//scope.data.grids[gridName] = gridService.createGrid(scope, "testListado", {}, undefined);
					var lineasDefault = 3;
					if (angular.isDefined(respuestas)) {
						if (respuestas.length) {
							if (respuestas.length > 15)
								lineasDefault = 15;
							else
								lineasDefault = respuestas.length;
						}
					}

					var optionsGrid = { pruebaFT: true, checkboxTemplate: 'checkboxCellFT', minRowsToShow: lineasDefault,/* minRowsToShow: 100,*/ metadata: metadata, enableGridMenu: scope.tienePerfilAdmin(), isRowSelectable: scope.isRowSelectable, onCellEdit: ((!scope.preview) ? scope.guardarDatosGrid : undefined) };

					if (scope.modoTraduccion) {
						optionsGrid.rowTemplate = 'app/FTBase/views/ui-grid-row-ft.html';
						optionsGrid.checkColState = scope.checkColState;
						optionsGrid.getCustomHint = scope.getCustomHint;
					}

					var acciones = [];

					if (scope.tienePerfilAdmin()) {
						acciones.push({
							icon: "fa-lock",
							title: "Desbloquear",
							visible: function (entity) {
								return scope.tienePerfilAdmin() && entity.bloqueado;
							},
							accion: function (entity) {
								entity.bloqueado = scope.switchBloqueado(entity.bloqueado);
								scope.changeLockGrid(entity);
							}
						});
						acciones.push({
							icon: "fa-unlock",
							title: "Bloquear",
							visible: function (entity) {
								return scope.tienePerfilAdmin() && !entity.bloqueado;
							},
							accion: function (entity) {
								entity.bloqueado = scope.switchBloqueado(entity.bloqueado);
								scope.changeLockGrid(entity);
							}
						});
					}

					if (scope.esGridJerarquico()) {
						if (scope.pregunta.pregunta.bucle_subnivel_simple) {
							optionsGrid.showTreeExpandNoChildren = false;
							acciones.push({
								icon: "fa-plus",
								title: "Agregar elemento mismo nivel",
								visible: function (entity) {
									if (scope.tienePerfilRestringido()) return false;

									if (entity["$$treeLevel"] > 0) {
										var respuestas_sn = scope.pregunta.respuestas.filter(function(item){
											return item.orden_bucle === entity.orden_bucle;
										});
										var max_index = respuestas_sn.sort(function(a,b){
											return parseInt(b.orden_sub_bucle) - parseInt(a.orden_sub_bucle);
										});
										//$log.log("Add element same level - Visible function: ");
										//$log.log("Maximo: " + max_index[0].orden_sub_bucle);
										return (entity.orden_sub_bucle === max_index[0].orden_sub_bucle);
									} 
									else
										return false;
								},
								accion: function (entity, grid) {
									// var ftd = {};
									// ftd.id_ficha_tecnica = entity.id_ficha_tecnica;
									// ftd.id_pregunta = scope.pregunta.pregunta.id_pregunta;
									// ftd.orden_bucle = entity.orden_bucle;
									// ftd.marca = entity.marca;
									$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/AgregarElementoSubNivel/" + entity.id).then(function (response) {
										$log.log(response.data.obj.Record);
										var ftd = response.data.obj.Record;
										//ftd.idioma = null;
										ftd.orden_sub_bucle = ftd.orden_tab;
										ftd.orden_sub_sub_bucle = ftd.orden_tab2;

										grid.options.ixAddRow(ftd);
										scope.actualizarGridsSinComponente(scope.pregunta.pregunta.id_pregunta);
										$timeout(function () {
											grid.gridApi.core.refresh();
										}, 300);
									},
									function(error){
										$log.log("Error call AgregarElementoSubNivel");
										$log.log(error);
									});
								}
							});
							acciones.push({
								icon: "fa-trash",
								title: "Eliminar línea",
								visible: function(entity){
									return !entity.bloqueado && !scope.tienePerfilRestringido();
								},
								accion: function(entity, grid){
									var row = entity;
									$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/EliminarElementoTablaJerarquicaSimple/" + entity.id).then(function(response){
										scope.actualizarGridsSinComponente(scope.pregunta.pregunta.id_pregunta);
										$timeout(function () {
											grid.gridApi.core.refresh();
										}, 300);

									},
									function(error){
										$log.log("Call EliminarElementoTablaJerarquicaSimple Error:");
										$log.log(error);
										ixStatusService.setResponse(error);
									});
								}
							});
							acciones.push({
								icon: "fa-sort",
								title: "Ordenar filas",
								visible: function (entity) {
									return !scope.modoTraduccion && scope.status.editing && !entity.bloqueado && !scope.tienePerfilRestringido();
								},
								accion: function (entity) { return true; }
							});
						} else {
							optionsGrid.enableCellEdit = !scope.tienePerfilRestringido();
							optionsGrid.keepFocusOnAddRow = true;
							var columnValor = optionsGrid.metadata.find(function (e) { return e.Name == "valor"; });
							columnValor.NoEditable = true;	
							optionsGrid.showTreeExpandNoChildren = false;

							//TODO: Hacer push
							acciones.push({
								icon: "fa-sort",
								title: "Ordenar filas",
								visible: function (entity) {
									return !scope.modoTraduccion && scope.status.editing && !entity.bloqueado && !scope.tienePerfilRestringido(); 
								},
								accion: function (entity) { return true; }
							});
							acciones.push({
								icon: "fa-pencil",
								title: "Editar",
								visible: function (entity) {
									return !scope.tienePerfilRestringido() && ((scope.status.editing && !entity.bloqueado) || (scope.status.editing && scope.modoTraduccion));
								},
								accion: function (entity, grid) {
									scope.abrirPopupAlimentacion(entity, grid.options);
								}
							});
							acciones.push({
								icon: "fa-trash",
								title: "Eliminar",
								visible: function (entity) {
									return (scope.status.editing && !entity.bloqueado && !scope.modoTraduccion && !scope.tienePerfilRestringido());
								},
								accion: function (entity) {
									scope.eliminarIngrediente(entity, scope.data.grids[gridName]);
								}
							});
						}
						optionsGrid.afterDragRow = function (grid, item, from, to) {
							var nextItem = null;
							var bulkParam = {
								ToInsert: [],
								ToUpdate: [],
								ToDelete: []
							};

							var contador_primer_nivel = 1;
							var contador_segundo_nivel = 1;
							var contador_tercer_nivel = 1;

							angular.forEach(grid.data, function (row) {

								row.orden_bucle = contador_primer_nivel;
								var update = {
									PK: grid.buildPK(row),
									PocoToUpdate: [
										{
											value: row.orden_bucle,
											path: "/orden_bucle",
											op: "replace"
										}
									]
								}

								if (row["$$treeLevel"] == 0) {
									contador_primer_nivel++;
									if (contador_segundo_nivel > 1)
										contador_segundo_nivel = 1;
									if (contador_tercer_nivel > 1)
										contador_tercer_nivel = 1;
								}
								else if (row["$$treeLevel"] == 1) {
									row.orden_bucle--;
									row.orden_sub_bucle = contador_segundo_nivel;
									row.orden_tab = row.orden_sub_bucle;
									update.PocoToUpdate = [{ value: row.orden_bucle, path: "/orden_bucle", op: "replace" }, { value: row.orden_sub_bucle, path: "/orden_tab", op: "replace" }];
									contador_segundo_nivel++;
									if (contador_tercer_nivel > 1)
										contador_tercer_nivel = 1;
								}
								else {
									row.orden_bucle--;
									row.orden_sub_bucle = (contador_segundo_nivel - 1);
									row.orden_tab = row.orden_sub_bucle;
									row.orden_sub_sub_bucle = contador_tercer_nivel;
									row.orden_tab2 = row.orden_sub_sub_bucle;
									update.PocoToUpdate = [{ value: row.orden_bucle, path: "/orden_bucle", op: "replace" }, { value: row.orden_sub_bucle, path: "/orden_tab", op: "replace" }, { value: row.orden_sub_sub_bucle, path: "/orden_tab2", op: "replace" }];
									contador_tercer_nivel++;
								}

								bulkParam.ToUpdate.push(update);
							});

							var tabla = (scope.modoTraduccion) ? "extranet_fichas_tecnicas_det_idioma" : "extranet_fichas_tecnicas_det";

							$http.post(cfg.baseURL + tabla + "/UpdateBulk", bulkParam).then(function (response) {
								$log.log("After update bulk respuestas", response, respuestas);
							}, function (err) {
								$log.error("Error actualizando el orden de los ingredientes", err);
							});

						};

						if (scope.modoTraduccion)
							optionsGrid.rowTemplate = "app/FTBase/views/ui-grid-tree-row-traduccion.html";
						else
							optionsGrid.rowTemplate = "app/base/views/grid/ui-grid-tree-row.html";

						scope.addTreeLevel(respuestas);
					}

					scope.data.grids[gridName] = gridService.createGrid(scope, 'ft_preguntagrid_' + scope.pregunta.pregunta.id_pregunta, optionsGrid);

					scope.data.grids[gridName].entity = "extranet_fichas_tecnicas_det";
					scope.data.grids[gridName].filtroExterno = [{ Field: "id_pregunta", Operator: CMP_EQ, Value: scope.pregunta.pregunta.id_pregunta }, { Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: scope.pregunta.respuestas[0].id_ficha_tecnica },{ Field: "marca", Operator: CMP_EQ, Value: 0 }];

					scope.data.grids[gridName].columnDefs = [];
					scope.data.grids[gridName].ixGetColsFromAPI();
					//if(scope.esGridJerarquico())
					if (acciones.length > 0)
						scope.data.grids[gridName].drawExtraColumns([{ name: 'Acciones', type: 'detalle', allowCellFocus: false, width: 100, acciones: acciones }]);

				} else {
					scope.data.grids[gridName] = gridService.createGridFunctions(scope, scope.data.grids[gridName]);
					scope.data.grids[gridName].ixRestoreConfig();
					scope.addTreeLevel(respuestas);
				}

				if (scope.pregunta.pregunta.bucle_subnivel_simple) {
					scope.data.grids[gridName].cellEditableCondition = scope.edicionGridEnvase;
				} else {
					// Bloqueamos la edición si hay alguna request peindiente en esa fila para la misma columna
					scope.data.grids[gridName].cellEditableCondition = function (cell) {
						if (cell.row.entity.bloqueado || (cell.row.entity.editingCols && cell.row.entity.editingCols.indexOf(cell.col.colDef.name)>=0)) {
							return false;
						}
						else {
							return !((typeof(cell.col.colDef.noeditable) == "function") ? cell.col.colDef.noeditable(cell) : cell.col.colDef.noeditable);
						}
					}					
				}

				if (scope.modoTraduccion && scope.soloPreguntasPdtTraduccion) {
					respuestas = scope.filtrarSoloPendientesTraduccion(respuestas);
				}

				if (respuestas.length > 0) {
					if (scope.data.grids[gridName].reloadData || ((angular.isDefined(scope.data.ToReload)) && scope.data.ToReload[scope.pregunta.pregunta.id_pregunta]))
						scope.data.grids[gridName].ixLoadInitialData().then(function (data) {
							scope.pregunta.respuestas = angular.copy(data);
							//scope.addTreeLevel(respuestas);
							scope.data.grids[gridName].reloadData = false;
							if (scope.data.ToReload) {
								if (scope.data.ToReload[scope.pregunta.pregunta.id_pregunta])
									scope.data.ToReload[scope.pregunta.pregunta.id_pregunta] = false;
							}
						});
					else
						scope.data.grids[gridName].data = respuestas.sort(function (a, b) {
							if (a.orden_bucle > b.orden_bucle) return 1;
							if (a.orden_bucle < b.orden_bucle) return -1;
							if (a.orden_sub_bucle > b.orden_sub_bucle) return 1;
							if (a.orden_sub_bucle < b.orden_sub_bucle) return -1;
							if (a.orden_sub_sub_bucle > b.orden_sub_sub_bucle) return 1;
							if (a.orden_sub_sub_bucle < b.orden_sub_sub_bucle) return -1;
							return 0;
						});

					if (scope.esGridJerarquico())
						scope.data.grids[gridName].ixRefreshGridDropDowns();

					ixUtilsService.showGrid(scope.data.grids[gridName]);

					var pregunta = "";

					if (scope.modoTraduccion) {
						pregunta = scope.pregunta.pregunta_idioma.pregunta || scope.pregunta.pregunta_idioma.pregunta_formulario || scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					}
					else {
						pregunta = scope.pregunta.pregunta.pregunta || scope.pregunta.pregunta.pregunta_formulario;
					}

					if (respuestas[0].componente)
						strEl += '<div ng-show="elComponenteEsVisible(\'' + respuestas[0].componente + '\')">';

					if ((!scope.modoTraduccion) && scope.pregunta.pregunta.ayuda_pregunta)
						strEl += '<span ix-hint="' + scope.textWithQuotes(scope.pregunta.pregunta.ayuda_pregunta) + '">';
					else if ((scope.modoTraduccion) && scope.pregunta.pregunta_idioma.ayuda_pregunta)
						strEl += '<span ix-hint="' + scope.textWithQuotes(scope.pregunta.pregunta_idioma.ayuda_pregunta) + '">';
					else
						strEl += '<span>';

					strEl += '<label>' + pregunta + ((scope.pregunta.pregunta.obligatoria) ? '<i class="fa fa-asterisk" style="color:red"></i>' : '') + '</label>';
					strEl += '</span>';

					strEl += '<div class="btn-toolbar" style="display:inline-block;float:right;">';

					//botones add/remove
					if (!scope.pregunta.pregunta.bloquear_borrar_b && !scope.esGridJerarquico())
						strEl += '<button style="padding: 3px 6px; margin: 0;" class="btn btn-danger pull-right" role="button" data-ng-show="status.editing && !respuestasBloqueadas()" data-ng-disabled="data.grids[\'' + gridName + '\'].gridApi.selection.getSelectedRows().length==0 || tienePerfilRestringido() || (modoTraduccion)" data-ng-click="deleteSelectedRows(data.grids[\'' + gridName + '\'])" uib-tooltip="{{ \'Eliminar registros seleccionados\' }}" translate-attr="uibTooltip" style=""><i class="fa fa-trash-o"></i></button>';

					if (!scope.pregunta.pregunta.bloquear_insert_b)
						strEl += '<button style="padding: 3px 6px; margin: 0;" class="btn btn-primary pull-right" role="button" data-ng-show="status.editing && !respuestasBloqueadas()" data-ng-disabled="tienePerfilRestringido() || (modoTraduccion)" data-ng-click="addRow(data.grids[\'' + gridName + '\'])" uib-tooltip="{{ \'Nuevo\' }}" translate-attr="uibTooltip" style=""><i class="fa fa-plus"></i></button>';

					//grid html
					// Establecemos el numdero de filas visibles igual a los datos que se mostrarán, para que no haya scroll en el grid.
					scope.data.grids[gridName].minRowsToShow= Math.max(scope.data.grids[gridName].data.length, 3) + 1;

					var styleHeight = "";

					// 3.2 COMPOSICION - Ingredientes : mostrar el grid a pantalla completa
					if(scope.pregunta.pregunta.id_pregunta==767  
						|| scope.pregunta.pregunta.id_pregunta==918
						|| scope.pregunta.pregunta.id_pregunta==1004
						|| scope.pregunta.pregunta.id_pregunta==1109
					) {  
						styleHeight = 'style="height: calc(100vh - 350px)"';
					}

					if (scope.esGridJerarquico())
						strEl += '</div><div class="ui-grid" data-ui-grid="data.grids[\'' + gridName + '\']" '+styleHeight+' data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-validate data-ui-grid-tree-view ui-grid-draggable-rows><div class="grid-loading" ng-if="data.grids[\'' + gridName + '\'].ixIsLoading"><a><i class="fa fa-circle-o-notch fa-spin"></i></a></div></div>';
					else
						strEl += '</div><div class="ui-grid" data-ui-grid="data.grids[\'' + gridName + '\']" '+styleHeight+' data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-validate><div class="grid-loading" ng-if="data.grids[\'' + gridName + '\'].ixIsLoading"><a><i class="fa fa-circle-o-notch fa-spin"></i></a></div></div>';

					if (respuestas[0].componente)
						strEl += '</div>';

					/*} else {
						scope.data.grids[gridName] = gridService.createGridFunctions(scope, scope.data.grids[gridName]);
						//scope.data.grids[gridName].ixRestoreConfig();
					}
					*/
					if (scope.esGridJerarquico()) {
						$timeout(function () {
							scope.data.grids[gridName].ixEditar();
						}, 0);
					}
				}

				scope.se_puede_visualizar = true;

				var el = $compile(strEl)(scope);
				return el;
			};

			scope.respuestasBloqueadas = function () {
				var respuestasBloqueadas = scope.pregunta.respuestas.filter(function (e) { return e.bloqueado; });
				return (scope.pregunta.respuestas.length == respuestasBloqueadas.length);
			};

			scope.actualizarRespuestas = function (data, componente, grid) {
				$log.log("actualizarRespuestas", data)
				var aux = scope.ajustarDataFromApi(data, grid);
				if (scope.pregunta.pregunta.preguntar_componente) {
					$log.log("actualizarRespuestas preguntar_componente")
					//Coger todas las preguntas del componente.
					var respuestasComponente = scope.pregunta.respuestas.filter(function (e) { return e.componente == componente; });
					if (respuestasComponente.length > 0) {
						var primerItemIdx = scope.pregunta.respuestas.indexOf(respuestasComponente[0]);
						scope.pregunta.respuestas.splice(primerItemIdx, respuestasComponente.length);

						for (var i = (aux.length - 1); i >= 0; i--) {
							scope.pregunta.respuestas.splice(primerItemIdx, 0, aux[i]);
						}

					} else {
						scope.pregunta.respuestas.push.apply(scope.pregunta.respuestas, aux);
					}
				}
				else {
					if (scope.pregunta.pregunta.bucle_subnivel_simple){
						angular.forEach(aux, function (respuesta) {
							respuesta["$$treeLevel"] = ((respuesta.orden_sub_bucle == 0 || respuesta.orden_tab == 0) ? 0 : (!respuesta.orden_sub_sub_bucle && !respuesta.orden_tab2) ? 1 : 2);
						});
					}

					scope.pregunta.respuestas = aux;
				}

			};


			scope.actualizarGridsSinComponente = function (idPregunta) {
				// var tmpGrid = scope.data.grids["grid" + idPregunta];
				var keyGrids = Object.keys(scope.data.grids).filter(function (e) { return e.indexOf("grid" + idPregunta) != -1; });

				angular.forEach(keyGrids, function (keyGrid) {
					var grid = scope.data.grids[keyGrid];
					if (angular.isDefined(grid)) {
						grid.reloadData = true;

						grid.ixLoadInitialData().then(function (data) {
							//var colDet = grid.columnDefs;
							scope.actualizarRespuestas(angular.copy(data), null, grid);
							scope.pregunta.respuestas = $filter('orderBy')(scope.pregunta.respuestas, ['orden_bucle', 'orden_sub_bucle']);
							grid.data = scope.pregunta.respuestas;
							
							$timeout(function(){
								grid.reloadData = false; //YVES: 07/02/2023
								if (grid.gridApi.treeBase){
									grid.gridApi.treeBase.expandAllRows();
								}
								grid.gridApi.core.refresh();
								ixUtilsService.showGrid(grid);
							},300);                                                
							
						});
					}
				});
			};

			scope.actualizarGrids = function (idPregunta, componente) {
				var keyGrids = Object.keys(scope.data.grids).filter(function (e) { return e.indexOf("grid" + idPregunta + "-") != -1; });

				if (angular.isDefined(componente)) {
					//Dejar en keyGrids solo elemento con el ID que toque.
					keyGrids = keyGrids.filter(function (elem) {
						return scope.data.grids[elem].data[0].componente == componente
					});
				}
				angular.forEach(keyGrids, function (keyGrid) {
					var componenteIdx = undefined;
					if (keyGrid.lastIndexOf("-") != -1)
						componenteIdx = keyGrid.substr(keyGrid.lastIndexOf("-") + 1);

					var grid = scope.data.grids[keyGrid];
					if (angular.isDefined(grid)) {
						grid.reloadData = true;
						//grid.data = [];


						if (componenteIdx) {
							var fComponente = grid.filtroExterno.find(function (e) { return e.Field == "componente"; });
							if (angular.isUndefined(fComponente))
								grid.filtroExterno.push({ Field: "componente", Operator: CMP_EQ, Value: scope.$parent.componentesRespuestas[componenteIdx].nombre });
						}

						grid.ixLoadInitialData().then(function (data) {
							var componente = undefined;
							if (scope.$parent.componentesRespuestas && componenteIdx)
								componente = scope.$parent.componentesRespuestas[componenteIdx];

							scope.actualizarRespuestas(angular.copy(data), componente, grid);
						});
					}
				});
			};

			scope.addRow = function (grid) {
				if (!scope.preview) {
					var data = {
						id_ficha_tecnica: scope.pregunta.respuestas[0].id_ficha_tecnica,
						id_pregunta: scope.pregunta.pregunta.id_pregunta,
						
						componente: grid.data[0].componente
					};

					if (scope.esGridJerarquico() && !scope.pregunta.pregunta.bucle_subnivel_simple) {
						scope.abrirPopupAlimentacion(data, grid, true);
					}
					else {
						$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det", data).then(function (response) {
							grid.ixAddRow(response.data.obj.Record);
							//YVES: ¿Como Copiar datos recibidos?
							if (scope.esGridJerarquico() && scope.pregunta.pregunta.bucle_subnivel_simple) {
								scope.actualizarGridsSinComponente(scope.pregunta.pregunta.id_pregunta);
								$timeout(function () {
									grid.gridApi.treeBase.expand.expandAllRows();
									grid.gridApi.core.refresh();
								}, 300);
							}
							else {
								scope.actualizarRespuestas(grid.data, data.componente, grid);
								$timeout(function () {
									grid.gridApi.core.refresh();
								}, 300);
							}
							$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: undefined, oldValue: undefined, pregunta: scope.pregunta.pregunta, tipo_modificacion: "Add" });
						}, function (err) {
							ixStatusService.setResponse(err);
						});
					}
				} else {
					grid.ixAddRow();
				}
			};

			scope.deleteRow = function (param) {
				var row = param.row;
				var grid = param.grid;
				if (!scope.preview) {
					var bulkParam = {
						ToInsert: [],
						ToUpdate: [],
						ToDelete: [row]
					};

					$http.delete(cfg.baseURL + "extranet_fichas_tecnicas_det/" + row.id).then(function (response) {
						var indexDeletedRow = grid.data.indexOf(row);
						if (indexDeletedRow != grid.data.length - 1) {
							if (row["$$treeLevel"] == 0) {
								var subingredientes = grid.data.filter(function (e) { return (e["$$treeLevel"] == 1 && e.orden_bucle == row.orden_bucle && e.orden_sub_bucle > 0 && e.componente == row.componente) });
								grid.data.splice(indexDeletedRow, subingredientes.length + 1);
								grid.data.forEach(function (e) {
									if (grid.data.indexOf(e) >= indexDeletedRow) e.orden_bucle--;
								});
							}
							else if (row["$$treeLevel"] == 1) {
								var subsubingredientes = grid.data.filter(function (e) { return (e["$$treeLevel"] == 2 && e.orden_bucle == row.orden_bucle && e.orden_sub_bucle == row.orden_sub_bucle && e.orden_sub_sub_bucle > 0 && e.componente == row.componente) });
								grid.data.splice(indexDeletedRow, subsubingredientes.length + 1);
								grid.data.forEach(function (e) {
									if (grid.data.indexOf(e) >= indexDeletedRow && e.orden_bucle == row.orden_bucle) {
										if (angular.isDefined(e.orden_tab)) {
											e.orden_tab--;
											e.orden_sub_bucle = e.orden_tab;
										}
										if (angular.isDefined(e.orden_sub_bucle)) {
											e.orden_sub_bucle--;
											e.orden_tab = e.orden_sub_bucle;
										}
									}
								});
							}
							else { //row.$$treeLevel == 2
								grid.data.splice(indexDeletedRow, 1);
								grid.data.forEach(function (e) {
									if (grid.data.indexOf(e) >= indexDeletedRow && e.orden_bucle == row.orden_bucle && ((e.orden_sub_bucle == row.orden_sub_bucle) || (e.orden_tab == row.orden_tab2))) {
										if (angular.isDefined(e.orden_tab2)) {
											e.orden_tab2--;
											e.orden_sub_sub_bucle = e.orden_tab2;
										}
										if (angular.isDefined(e.orden_sub_sub_bucle)) {
											e.orden_sub_sub_bucle--;
											e.orden_tab2 = e.orden_sub_sub_bucle;
										}
									}
								});
							}
						}
						else {
							grid.data.splice(indexDeletedRow, 1);
						}

						if (grid.data.length == 0) {
							grid.ixLoadInitialData().then(function (data) {
								scope.pregunta.respuestas = angular.copy(data);
							});
						} else {
							scope.actualizarRespuestas(grid.data, grid.data[0].componente, grid)
						}
						grid.ixDeleteSelectedRows();
						$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: undefined, oldValue: undefined, pregunta: response.data.obj.Record, tipo_modificacion: "Delete" });
					}, function (err) {
						ixStatusService.setResponse(err);
					});
				} else {
					grid.ixDeleteSelectedRows();
				}

			};
			scope.deleteSelectedRows = function (grid) {
				if (!scope.preview) {
					var bulkParam = {
						ToInsert: [],
						ToUpdate: [],
						ToDelete: grid.gridApi.selection.getSelectedRows()
					};

					$http.post(cfg.baseURL + "extranet_fichas_tecnicas_det/UpdateBulk", bulkParam).then(function (response) {
						grid.ixDeleteSelectedRows();

						if (grid.data.length == 0) {
							//							grid.entity = "extranet_fichas_tecnicas_det";
							//							grid.filtroExterno = [{ Field: "id_pregunta", Operator: CMP_EQ, Value: scope.pregunta.pregunta.id_pregunta }, { Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: scope.pregunta.respuestas[0].id_ficha_tecnica } ];
							grid.ixLoadInitialData().then(function (data) {
								scope.pregunta.respuestas = angular.copy(data);
							});
						} else {
							scope.actualizarRespuestas(grid.data, grid.data[0].componente, grid)
						}
						
						$rootScope.$broadcast("RECALCULAR_CUMPLIMENTACION_GRID", { newValue: undefined, oldValue: undefined, pregunta: response.data.Deleted[0].Record, tipo_modificacion: "Delete" });
					}, function (err) {
						ixStatusService.setResponse(err);
					});
				} else {
					grid.ixDeleteSelectedRows();
				}
			};

			//GRID FIN

			//FUNCIONES POR COMPONENTES
			scope.showDetails = function (evt) {
				var textoComponenteClick = evt.target.innerHTML;

				scope.$parent.componentesRespuestas.forEach(function (panel) {
					panel.visible = false;
				});

				var panelComponente = scope.$parent.componentesRespuestas.find(function (e) { return e.nombre == textoComponenteClick; });

				var contentTarget = angular.element(evt.currentTarget).parent().find("div.content");
				if (contentTarget.hasClass("visible")) {
					contentTarget.removeClass("visible");
					panelComponente.visible = false;
				}
				else {
					angular.element(angular.element(angular.element(evt.currentTarget).parent()).parent()).children().children().removeClass("visible");
					contentTarget.addClass("visible");
					panelComponente.visible = true;
				}
			};
			//FIN FUNCIONES POR COMPONENTES

			scope.getComponentesRespuestas = function () {
				if (angular.isUndefined(scope.pregunta.panelesComponentes)) {
					scope.pregunta.panelesComponentes = [];
				}
				angular.forEach(scope.pregunta.respuestas, function (respuesta, idx) {
					var existe = scope.pregunta.panelesComponentes.find(function (e) { return e.nombre == respuesta.componente; });
					if (angular.isUndefined(existe)) {
						var panelComponente = { nombre: respuesta.componente, visible: ((idx == 0) ? true : false) };
						scope.pregunta.panelesComponentes.push(panelComponente);
					}
				});

				return scope.pregunta.panelesComponentes;
			};

			scope.elComponenteEsVisible = function (nombre) {
				var esVisible = false;

				if (angular.isDefined(scope.$parent.componentesRespuestas)) {
					var componente = scope.$parent.componentesRespuestas.find(function (e) { return e.nombre == nombre; });
					esVisible = componente.visible;
				}
				return esVisible;
			};

			scope.createPanels = function () {
				scope.$parent.componentesRespuestas = scope.getComponentesRespuestas();

				angular.forEach(scope.$parent.componentesRespuestas, function (componente, idx) {
					var accordion = "";
					if (scope.preview) {
						accordion = '<div class="card"><div class="title" ng-click="showDetails($event)">Componente A</div><div class="content detalles"></div></div>';
						elem.append($compile(accordion)(scope));

					} else if (angular.element(scope.$parent.getContainerElement()).find("div#componente" + scope.quitarespacios(componente.nombre)).length == 0) {
						//Creamos el accordion cuando no exista.
						accordion = '<div id="componente' + scope.quitarespacios(componente.nombre) + '" class="card"><div class="title" ng-click="showDetails($event)">' + componente.nombre + '</div><div class="content detalles';
						if (idx == 0)
							accordion += ' visible';

						accordion += '"><div></div></div></div>';
						elem.append($compile(accordion)(scope));
					}
				});
			};

			scope.quitarespacios = function (componente) {
				var remplazado = componente.split(" ").join("_").split(".").join("_");

				return remplazado;
			};

			scope.divComponente = function () {
				//return "div.content";
				return "div.content > div";
			};

			scope.createPreguntas = function (elem) {

				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";

				if (scope.pregunta.pregunta.preguntar_componente) {
					angular.forEach(scope.$parent.componentesRespuestas, function (componente) {
						var containerComponent;
						if (scope.preview)
							containerComponent = elem.find("div.card > " + scope.divComponente());
						else
							if (angular.element(elem).find("div#componente" + scope.quitarespacios(componente.nombre)).length == 1)
								containerComponent = angular.element(elem).find("div#componente" + scope.quitarespacios(componente.nombre) + " > " + scope.divComponente());
							else if (angular.element(scope.$parent.getContainerElement()).find("div#componente" + scope.quitarespacios(componente.nombre)).length == 1)
								containerComponent = angular.element(scope.$parent.getContainerElement()).find("div#componente" + scope.quitarespacios(componente.nombre) + " > " + scope.divComponente());

						if (angular.isUndefined(scope.pregunta.respuestasComponentes))
							scope.pregunta.respuestasComponentes = {};

						var respuestasComponente = scope.pregunta[respuestasProperty].filter(function (e) { return e.componente == componente.nombre; });

						if (scope.modoTraduccion) {
							//Estamos en un grid, si la columna no es traducible, mostaremos el valor original.
							respuestasComponente = scope.rellenarNoTraducibles(respuestasComponente);
						}

						scope.pregunta.respuestasComponentes[componente.nombre] = respuestasComponente;

						scope.createPregunta(scope.pregunta.respuestasComponentes[componente.nombre], containerComponent);
					});
					scope.createPreviewComponentes();
				} else {
					if (scope.modoTraduccion && scope.pregunta.pregunta.bucle == 1) {
						scope.pregunta.respuestas_idioma = scope.rellenarNoTraducibles(scope.pregunta.respuestas_idioma);
					}
					scope.createPregunta(scope.pregunta[respuestasProperty], elem);
				}
			};

			scope.rellenarNoTraducibles = function (respuestasComponente) {
				angular.forEach(respuestasComponente, function (respuesta) {

					var respuesta_original = scope.pregunta.respuestas.find(function (e) { return e.id == respuesta.id; });

					if (!respuesta.valor && !scope.pregunta.pregunta.traducible) {
						respuesta.valor = respuesta_original.valor;
					}
					if (!respuesta.sub_respuesta1 && !scope.pregunta.pregunta.sub_pregunta1_traducible) {
						respuesta.sub_respuesta1 = respuesta_original.sub_respuesta1;
					}
					if (!respuesta.sub_respuesta2 && !scope.pregunta.pregunta.sub_pregunta2_traducible) {
						respuesta.sub_respuesta2 = respuesta_original.sub_respuesta2;
					}
					if (!respuesta.sub_respuesta3 && !scope.pregunta.pregunta.sub_pregunta3_traducible) {
						respuesta.sub_respuesta3 = respuesta_original.sub_respuesta3;
					}
					if (!respuesta.sub_respuesta4 && !scope.pregunta.pregunta.sub_pregunta4_traducible) {
						respuesta.sub_respuesta4 = respuesta_original.sub_respuesta4;
					}
					if (!respuesta.sub_respuesta5 && !scope.pregunta.pregunta.sub_pregunta5_traducible) {
						respuesta.sub_respuesta5 = respuesta_original.sub_respuesta5;
					}
					if (!respuesta.sub_respuesta6 && !scope.pregunta.pregunta.sub_pregunta6_traducible) {
						respuesta.sub_respuesta6 = respuesta_original.sub_respuesta6;
					}
					if (!respuesta.sub_respuesta7 && !scope.pregunta.pregunta.sub_pregunta7_traducible) {
						respuesta.sub_respuesta7 = respuesta_original.sub_respuesta7;
					}
					if (!respuesta.sub_respuesta8 && !scope.pregunta.pregunta.sub_pregunta8_traducible) {
						respuesta.sub_respuesta8 = respuesta_original.sub_respuesta8;
					}
					if (!respuesta.sub_respuesta9 && !scope.pregunta.pregunta.sub_pregunta9_traducible) {
						respuesta.sub_respuesta9 = respuesta_original.sub_respuesta9;
					}
					if (!respuesta.sub_respuesta10 && !scope.pregunta.pregunta.sub_pregunta10_traducible) {
						respuesta.sub_respuesta10 = respuesta_original.sub_respuesta10;
					}
					if (!respuesta.sub_respuesta11 && !scope.pregunta.pregunta.sub_pregunta11_traducible) {
						respuesta.sub_respuesta11 = respuesta_original.sub_respuesta11;
					}
					if (!respuesta.sub_respuesta12 && !scope.pregunta.pregunta.sub_pregunta12_traducible) {
						respuesta.sub_respuesta12 = respuesta_original.sub_respuesta12;
					}
					if (!respuesta.sub_respuesta13 && !scope.pregunta.pregunta.sub_pregunta13_traducible) {
						respuesta.sub_respuesta13 = respuesta_original.sub_respuesta13;
					}
					if (!respuesta.sub_respuesta14 && !scope.pregunta.pregunta.sub_pregunta14_traducible) {
						respuesta.sub_respuesta14 = respuesta_original.sub_respuesta14;
					}
				});
				return respuestasComponente;
			}

			/*
			scope.agregarPropiedadesNecesariasComponente = function(trad, original){
				trad.orden_bucle = original.orden_bucle;
				trad.orden_sub_bucle = original.orden_sub_bucle;
				trad.orden_sub_sub_bucle = original.orden_sub_sub_bucle;
				trad.componente = original.componente;
			};
			*/

			scope.createPreviewComponentes = function () {
				if (scope.preview && scope.pregunta.pregunta.preguntar_componente) {
					scope.componentesCount = 1;
					elem = elem.parent().parent();

					var accordion = '<div class="card"><div class="title" ng-click="showDetails($event)">Componente B</div><div class="content detalles"></div></div>';
					elem.append($compile(accordion)(scope));
					elem = elem.find("div.card > " + scope.divComponente()).eq(scope.componentesCount);


					if (scope.pregunta.pregunta.bucle) {
						elem.append(scope.buildGrid());
					} else {
						if (scope.pregunta.pregunta.tiene_imagen)
							elem.append(scope.buildControlImg(0));
						else
							elem.append(scope.buildControl());
					}
					if (scope.pregunta.pregunta.preguntar_obs) {
						elem.append(scope.buildControlObs());
					}

				}

				if (scope.preview && scope.pregunta.pregunta.preguntar_componente) {
					scope.componentesCount = 2;
					elem = elem.parent().parent();

					accordion = '<div class="card"><div class="title" ng-click="showDetails($event)">Componente C</div><div class="content detalles"></div></div>';
					elem.append($compile(accordion)(scope));
					elem = elem.find("div.card > " + scope.divComponente()).eq(scope.componentesCount);


					if (scope.pregunta.pregunta.bucle) {
						elem.append(scope.buildGrid());
					} else {
						if (scope.pregunta.pregunta.tiene_imagen)
							elem.append(scope.buildControlImg(0));
						else
							elem.append(scope.buildControl());
					}
					if (scope.pregunta.pregunta.preguntar_obs) {
						elem.append(scope.buildControlObs());
					}
				}
			};

			scope.switchBloqueado = function (bloqueado) {
				if (bloqueado)
					bloqueado = 0;
				else
					bloqueado = 1;
				return bloqueado;
			};

			scope.changeLock = function () {

				scope.pregunta.respuestas[0].bloqueado = scope.switchBloqueado(scope.pregunta.respuestas[0].bloqueado);
				var data = [
					{
						op: "replace",
						path: "/bloqueado",
						value: scope.pregunta.respuestas[0].bloqueado
					}
				];
				$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/" + scope.pregunta.respuestas[0].id, data).then(function (response) {

				}, function (err) {
					scope.pregunta.respuestas[0].bloqueado = scope.switchBloqueado(scope.pregunta.respuestas[0].bloqueado);
				});
			};

			scope.changeLockGrid = function (entity) {
				var data = [
					{
						op: "replace",
						path: "/bloqueado",
						value: entity.bloqueado
					}
				];
				$http.put(cfg.baseURL + "extranet_fichas_tecnicas_det/" + entity.id, data).then(function (response) {

				}, function (err) {
					entity.bloqueado = scope.switchBloqueado(entity.bloqueado);
				});
			};

			scope.addAdjuntarFichero = function () {
				var lastDiv = elem.children("div").eq(elem.children("div").length - 1);
				if (lastDiv.find("div.form-group").length > 0)
					lastDiv = lastDiv.find("div.form-group");

				var strEl = '<a class="btn btn-primary" role="button" data-ng-click="openPopupFicheros(\'' + scope.pregunta.respuestas[0].id_ficha_tecnica + '\', \'ficheros_ft\')" uib-tooltip="{{ \'Subir fichero\' }}" tooltip-placement="bottom" translate-attr="uibTooltip" style=""><i class="fa fa-upload"></i></a>';
				var el = $compile(strEl)(scope);

				if (elem.children("div").length == 1 || (scope.num_subpreguntas > 0 || scope.pregunta.pregunta.preguntar_obs))
					lastDiv.append(el);
				else
					lastDiv.after(el);
			};


			scope.addDependenciaEtiquetado = function (esComponente, elem_componente, esBucle) {
				var lastDiv = undefined;
				if (esComponente){
					lastDiv = elem_componente.children("div").eq(elem_componente.children("div").length - 1);
					if (esBucle)
						lastDiv = lastDiv.children("div").eq(lastDiv.children("div").length - 1);
				}
				else
					lastDiv = elem.children("div").eq(elem.children("div").length - 1);

				if (lastDiv.find("div.form-group").length > 0)
					lastDiv = lastDiv.find("div.form-group");

				var strEl = '';

				//En caso se trate de un componente recupero la descripción
				var desc_componente = undefined;
				if (angular.isDefined(elem_componente)){
					//desc_componente = elem_componente.selector.replace("div#componente","").replace(" > div.content > div","").trim();
					//desc_componente = "'" + desc_componente + "'";
					desc_componente = "'" + elem_componente.parent().prev().text() + "'";
				}

				if (scope.modoTraduccion) {
					var pregunta_formulario = scope.pregunta.pregunta_idioma.pregunta_formulario || scope.pregunta.pregunta.pregunta_formulario;
					strEl = '<button class="btn" ng-class="{ \'btn-primary\': pregunta.respuestas[0].contiene_info_etiquetado }" role="button" data-ng-disabled="tieneLlamadasPendientes(pregunta.respuestas[0].id,\'button\') || (!pregunta.pregunta.traducible)" data-ng-click="openPopupDedependenciaEtiquetado(\'' + scope.pregunta.respuestas[0].id_ficha_tecnica + '\', ' + scope.pregunta.pregunta.id_pregunta + ', \'' + pregunta_formulario + '\', ' + scope.pregunta.pregunta.bloquear_valor_b + ',\'' + scope.pregunta.respuestas_idioma[0].idioma + '\',' + desc_componente + ')" uib-tooltip="{{ \'Dependencia etiquetado\' }}" tooltip-placement="bottom" translate-attr="uibTooltip" style=""><i class="fa fa-tag"></i></button>';
				}
				else
					strEl = '<button class="btn" ng-class="{ \'btn-primary\': pregunta.respuestas[0].contiene_info_etiquetado }" role="button" data-ng-disabled="tieneLlamadasPendientes(pregunta.respuestas[0].id,\'button\')" data-ng-click="openPopupDedependenciaEtiquetado(\'' + scope.pregunta.respuestas[0].id_ficha_tecnica + '\', ' + scope.pregunta.pregunta.id_pregunta + ', \'' + scope.pregunta.pregunta.pregunta_formulario + '\', ' + scope.pregunta.pregunta.bloquear_valor_b + ',undefined,' + desc_componente + ')" uib-tooltip="{{ \'Dependencia etiquetado\' }}" tooltip-placement="bottom" translate-attr="uibTooltip" style=""><i class="fa fa-tag"></i></button>';

				var el = $compile(strEl)(scope);

				if ((elem.children("div").length == 1 || (scope.num_subpreguntas > 0 || scope.pregunta.pregunta.preguntar_obs)) || (esComponente && !esBucle))
					lastDiv.append(el);
				else {
					if (scope.pregunta.pregunta.bucle)
						lastDiv.before(el);
					else
						lastDiv.after(el);
				}

			};

			scope.addLockAction = function (elem) {
				//El icono de bloquear/desbloquear lo pondremos al final de la pregunta.
				var lastDiv = elem.children("div").eq(elem.children("div").length - 1);
				if (lastDiv.find("div.form-group").length > 0)
					lastDiv = lastDiv.find("div.form-group");

				var strEl = "<i class='fa' ng-click='changeLock()' ng-attr-title='{{pregunta.pregunta.pregunta || pregunta.pregunta.pregunta_formulario}}' ng-class='{ \"fa-lock\": pregunta.respuestas[0].bloqueado, \"fa-unlock\": !pregunta.respuestas[0].bloqueado }' aria-hidden='true' ";

				strEl += " style='right: 5px;top: 6px;position: absolute;' ";

				strEl += "></i>";
				var el = $compile(strEl)(scope);
				lastDiv.append(el);
			};

			scope.tienePerfilAdmin = function () {
				return authService.tienePerfilAdmin() || authService.tienePerfilUserKey();
			};

			scope.tienePerfilRestringido = function () {
				var perfilRestringido = false;
				var perfilesUsuario = authService.perfilesUsuario();

				var perfilesRestringidos = ["usr_cliente", "usr_laboratorio", "usr_visitante", "usr_export"];

				angular.forEach(perfilesUsuario, function (perfil) {
					if (perfilesRestringidos.indexOf(perfil) != -1)
						perfilRestringido = true;
				});

				return perfilRestringido;
			};

			scope.tieneLlamadasPendientes = function (idRespuesta, tag) {
				if(tag=='ix-select-ft') {
					return; // Para los ix-select-ft no miramos si tiene llamadasPendientes para que no se haga un disabled, ya que le hace perder el focus y luego el ix-focus-out que graba el valor no se ejecuta
				}
				return authInterceptorService.tieneLlamadasPendientes(cfg.baseURL + "extranet_fichas_tecnicas_det/" + idRespuesta);
			};

			scope.createPregunta = function (respuestas, elem) {
				//&& scope.pregunta.pregunta.bucle == 0 (AGREGADO POR YVES)
				if (scope.hayQueRecargarPregunta()) {
					var param = buildIxSearch();
					param.Filters.push({ Field: "id_pregunta", Operator: CMP_EQ, Value: scope.pregunta.pregunta.id_pregunta });
					param.Filters.push({ Field: "id_ficha_tecnica", Operator: CMP_EQ, Value: scope.pregunta.respuestas[0].id_ficha_tecnica });

					$http.post(cfg.baseURL + "ft_data/GetRespuestas", param).then(function (response) {
						scope.pregunta.respuestas = response.data;
						if (angular.isDefined(respuestas))
							respuestas = scope.pregunta.respuestas;

						scope.montarControlPreguntas(respuestas, elem);
					});
				} else {
					scope.montarControlPreguntas(respuestas, elem);
				}
			};

			scope.hayQueRecargarPregunta = function () {
				var recargar = false;
				if (angular.isDefined(scope.data.ToReload)) {
					if (scope.data.ToReload[scope.pregunta.pregunta.id_pregunta])
						recargar = true;
				}
				return recargar;
			};

			scope.montarControlPreguntas = function (respuestas, elem) {
				var respuestasProperty = (scope.modoTraduccion) ? "respuestas_idioma" : "respuestas";
				if (scope.pregunta.pregunta.nota_pregunta) {
					if (scope.modoTraduccion)
						elem.append("<h5><b>" + scope.pregunta.pregunta_idioma.nota_pregunta + "</b></h5>");
					else
						elem.append("<h5><b>" + scope.pregunta.pregunta.nota_pregunta + "</b></h5>");
				}

				if (scope.pregunta.pregunta.bucle) {
					//TODO: Gestionar dependencia etiquetado
					/*
					if (scope.pregunta.pregunta.dependencia_etiquetado){
						//TODO: montar tabs
						elem.append("<uib-tabset class='ix-tabs no-margin-bottom' active='0'>");
						elem.append("<uib-tab index='0' heading='Marca Común' select='changeTab(0)'>");
						elem.append(scope.buildGrid(respuestas));
						elem.append("</uib-tab");
						elem.append("</uib-tabset>");
					}
					else {
						elem.append(scope.buildGrid(respuestas));
					}
					*/
					elem.append(scope.buildGrid(respuestas));
					if (scope.pregunta.pregunta.dependencia_etiquetado){
						scope.addDependenciaEtiquetado(scope.pregunta.pregunta.preguntar_componente, (scope.pregunta.pregunta.preguntar_componente ? elem : undefined),scope.pregunta.pregunta.bucle);
					}
						
				}
				else {
					scope.num_subpreguntas = scope.cuentaSubPreguntas();
					angular.forEach(respuestas, function (respuesta) {
						var idx = scope.pregunta[respuestasProperty].indexOf(respuesta);

						if (!scope.inPopup) {
							if (scope.pregunta.pregunta.tiene_imagen)
								elem.append(scope.buildControlImg(idx));
							else
								elem.append(scope.buildControl(idx));
						}

						if (scope.num_subpreguntas > 0) {
							scope.buildControlSubPreguntas(idx);
						}
					});

					//Aplica sólo en preguntas simples
					if (scope.pregunta.pregunta.preguntar_obs) {
						elem.append(scope.buildControlObs(0));
					}

					//Aplica sólo en preguntas simples
					if (scope.pregunta.pregunta.adjuntar_fichero && !scope.preview)
						scope.addAdjuntarFichero();

					//Para preguntas bucle se gestiona de manera diferente
					if (scope.pregunta.pregunta.dependencia_etiquetado /*&& scope.se_puede_visualizar */)
						scope.addDependenciaEtiquetado(scope.pregunta.pregunta.preguntar_componente,(scope.pregunta.pregunta.preguntar_componente ? elem : undefined),scope.pregunta.pregunta.bucle);
				}

				if (!scope.pregunta.pregunta.bucle) {
					if (scope.tienePerfilAdmin() && !scope.inPopup && !scope.soloPreguntasPdtTraduccion)//Mirar si el usuario tiene perfil de ixnet y solo llamar la función si es así.
						scope.addLockAction(elem);
				}
			};

			//Creamos los controles necesarios:
			if (scope.pregunta.pregunta.preguntar_componente) {
				scope.createPanels();
			}
			scope.createPreguntas(elem);
		}
	}
}]);

angular.module('FTBase').directive('ftNzToggle', ['$timeout', function ($timeout) {
	return {
		restrict: 'E',
		require: '?ngModel',
		scope: {
			ngModel: '=',
			ngRequired: '=?',
			name: '@',
			icono: '@?',
			ngDisabled: '=?',
			textMaxWidth: '=?',
			ngDefault: '=?',
			afterClick: '=?',
			labelClass: '@?',
			inputClass: '@?'
		},
		link: function (scope, elem, attrs) {
			scope.prop = attrs.ixFocusOutParam;
			scope.idx = attrs.ixFocusOutParamIdx;
			scope.changeSelected = function () {
				if (scope.afterClick) {
					$timeout(function () {
						scope.afterClick({ data: { prop: scope.prop, idx: scope.idx } });
					}, 0);
				}
			}
		},
		templateUrl: 'app/FTBase/views/ftNzToggle.html'
	};
}]);

angular.module('FTBase').directive('ftTitulo', [function () {
	return {
		restrict: 'E',
		scope: {
			item: '='
		},
		templateUrl: 'app/FTBase/views/ftTitulo.html'
	}
}]);

//Controles FT (no se traducen usando el sistema de traducciones de GestPark)
angular.module('FTBase').directive('ixTextFt', [function () {
	return {
		restrict: 'E',
		require: '?ngModel',
		transclude: true,
		scope: {
			ngModel: '=',
			ngModel2: '=?',
			ngRequired: '=',
			name: '@',
			ngDisabled: '=?',
			ngValue: '=?',
			ngPlaceholder: '@?',
			isFilter: '=?',
			cleanSpecialChars: '&?',
			maxLength: '=?',
			maxLength2: '=?',
			labelClass: '@?',
			inputClass: '@?'
		},
		templateUrl: 'app/FTBase/views/ixTextFt.html',
		link: function (scope, elem, attrs, ctrl) {
			if (!ctrl) return;

			if (angular.isDefined(scope.cleanSpecialChars)) {
				scope.$watch('ngModel', function (newValue, oldValue) {
					if (newValue != oldValue) {
						scope.ngModel = scope.cleanSpecialChars()(newValue);
					}
				});
			}
			var input = angular.element(elem.find('input')[0]);
			var inputModelCtrl = input.controller('ngModel');

			if (angular.isDefined(inputModelCtrl)) {
				//El formatter del ixNumber modifica el valor que apareix en pantalla.
				//Per tant, si hi ha validació de maxlength, aquesta donaria error sempre que el numero contingui separador de milers.
				if (angular.isDefined(attrs.maxLength) && angular.isDefined(attrs.ixNumber)) {
					inputModelCtrl.$validators.maxlength = function (modelValue, viewValue) {
						if (angular.isDefined(modelValue) && modelValue != null) {
							var withoutSeparators = modelValue.replace(/\./g, '');
							withoutSeparators = withoutSeparators.replace(/\,/g, '');
							return withoutSeparators.length <= scope.maxLength;
						}
					};
				}
			}
		}
	};
}]);

angular.module('FTBase').directive('ixDateFt', [function () {
	return {
		restrict: 'E',
		require: '?ngModel',
		scope: {
			ngModel: '=',
			ngRequired: '=',
			name: '@',
			dateLimit: '=?',
			dateMin: '=?',
			ngDisabled: '=',
			appendToBody: '=?',
			oneLineText: '=?',
			labelClass: '@?',
			inputClass: '@?'
		},
		templateUrl: 'app/FTBase/views/ixDateFt.html'
	};
}]);

angular.module('FTBase').directive('ixOptionsSiNoFt', ['$timeout', function ($timeout) {
	return {
		restrict: 'E',
		require: '?ngModel',
		scope: {
			ngModel: '=',
			ngRequired: '=?',
			name: '@',
			ngDisabled: '=?',
			textMaxWidth: '=?',
			ngDefault: '=?',
			afterClick: '=?'
		},
		link: function (scope, elem, attrs) {
			$timeout(function () {
				var label = angular.element(elem.find('label')[0]);
				label.on('click', function (e) {
					if (e.target !== e.currentTarget) return;
					e.preventDefault();
				});
			}, 1);
		},
		controller: ['$scope', function ($scope) {
			if (angular.isDefined($scope.ngDefault)) {
				if (!angular.isFunction($scope.ngDefault)) {
					$scope.ngModel = $scope.ngDefault;
				} else {
					//En cas de que el default sigui una etiqueta de config s'executarà una funció que ha d'estar definida al controller de la pantalla.
					$scope.ngDefault().then(function (result) {
						$scope.ngModel = result;
						$scope.ngDefault = result;
					});
				}
			}
			if (isNaN($scope.ngModel)) {
				$scope.ngModel = 0;
			}

			$scope.changeSelected = function () {
				$scope.ngModel = (($scope.ngModel == 1) ? 0 : 1);
				if ($scope.afterClick) {
					$timeout(function () {
						$scope.afterClick($scope.ngModel);
					}, 0);
				}
			}

			$scope.$watch("ngModel", function (value) {
				//Ens permet buidar el ix-select però, en cas de que hi hagi valor per defecte, si el formulari es neteja, s'aplicarà el valor per defecte de nou.
				if (angular.isUndefined(value) && angular.isDefined($scope.ngDefault)) {
					$scope.ngModel = $scope.ngDefault;
				} else {
					if (isNaN($scope.ngModel)) {
						$scope.ngModel = 0;
					}
					else if (typeof $scope.ngModel == "boolean") {
						$scope.ngModel == true ? $scope.ngModel = 1 : $scope.ngModel = 0;
					}
					$scope.estaSeleccionado = angular.copy($scope.ngModel);
				}
				return $scope.ngModel;
			});
		}],
		templateUrl: 'app/FTBase/views/ixOptionsSiNoFt.html'
	};
}]);

angular.module('FTBase').directive('ixSelectFt', [function () {
	return {
		restrict: 'E',
		//require: '?ngModel',
		scope: {
			entity: '@',
			pk: '@',
			desc: '@',
			extraField: '@?',
			filterFields: '=?',
			ngModel: '=',
			name: '@',
			preload: '=?',
			ngDisabled: '=',
			ngRequired: '=',
			conditions: '=?',
			loadFunction: '=?',
			ngDefault: '=?',
			//Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
			wholeObj: '=?',
			orderStringAsInt: '=?',
			//permet afegir com a opcio allò que l'usuari escrigui al camp de text utilitzat per filtrar resultats.
			editableDropdown: '=?',
			allowCustomPriority: '=?',
			//Aquesta serà una funció que carregui un viewmodel sencer en el mateix moment d'accedir la pantalla. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
			preloadFunction: '=?',
			//
			preloadObj: '@?',
			//La pk no sempre s'ha de dir igual que la del viewmodel.
			preloadPk: '@?',
			//Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
			loadAllItems: '=?',
			//Podem fer que el dropdown pengi del body en comptes del div que el conté. D'aquesta manera, si un dropdown està en un div petit, les opcions no es veuràn tallades (útil per popups).
			appendToBody: '=?',
			//Per pantalles on tenim totes les dades a un objecte carregat previament desde la API. Aconsellable fer-ho a pantalles on hi hagi forces dropdowns.
			entityData: '=?',
			entityDataPk: '@?',
			entityDataDesc: '@?',
			oneLineText: '=?',
			onSelect: '=?',
			template: '@?',
			skipTableNameFilter: '=?',
			skipTableNameOrderBy: '=?',
			labelClass: '@?',
			inputClass: '@?',
			keepOriginalValue: '=?'
		},
		//controller: 'ixSelectController',
		templateUrl: 'app/FTBase/views/ixSelect2Ft.html'/*,
					link: function(scope, elem, attrs){
						if(!scope.allItems)
							scope.allItems = [];

						scope.$watch('wholeObj', function(newVal, oldVal){
							console.log("wholeObj updated");
						});
					}*/
	};
}]);

angular.module('FTBase').directive('ixSelectMultipleFt', [function () {
	return {
		restrict: 'E',
		require: '?ngModel',
		scope: {
			entity: '@',
			pk: '@',
			desc: '@',
			extraField: '@?',
			ngModel: '=',
			name: '@',
			preload: '=?',
			ngDisabled: '=',
			ngRequired: '=',
			conditions: '=?',
			loadFunction: '=?',
			limitTo: '=?',
			ngDefault: '=?',
			//Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
			wholeObj: '=?',
			orderStringAsInt: '=?',
			//permet afegir com a opcio allò que l'usuari escrigui al camp de text utilitzat per filtrar resultats.
			editableDropdown: '=?',
			//Aquesta serà una funció que carregui un viewmodel sencer. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
			preloadFunction: '=?',
			//La pk no sempre s'ha de dir igual que la del viewmodel.
			preloadPk: '@?',
			//Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
			loadAllItems: '=?',
			//Podem fer que el dropdown pengi del body en comptes del div que el conté. D'aquesta manera, si un dropdown està en un div petit, les opcions no es veuràn tallades (útil per popups).
			appendToBody: '=?',
			skipTableNameFilter: '=?',
			labelClass: '@?',
			inputClass: '@?',
			keepOriginalValue: '=?'
		},
		controller: 'ixSelectMultipleController',
		templateUrl: 'app/FTBase/views/ixSelectMultipleFt.html'
	};
}]);

angular.module('FTBase').directive('ixTextAreaFt', ['$compile', '$timeout', function ($compile, $timeout) {
	return {
		restrict: 'E',
		scope: {
			ngModel: '=',
			ngRequired: '=',
			name: '@',
			ngClass: '@?',
			ngDisabled: '=?',
			maxLength: '=?',
			rows: '@?',
			cols: '@?',
			labelClass: '@?',
			inputClass: '@?',
			placeholder: '@?',
			customHint: '@?',
			traducible: '=?',
			confirmado: '=?'
		},
		templateUrl: 'app/FTBase/views/ixTextAreaFt.html',
		link: function (scope, element, attrs) {

			scope.$on("focusOut", function () {
				scope.hasFocus = false;
			});

			scope.showCustomHint = function (ev) {
				if (scope.traducible) {
					scope.hasFocus = true;
					var auxElement = angular.element(element).find("textarea");
					if (angular.element(auxElement).parent().find("ix-custom-hint-ft").length == 0) {
						//auxElement.append("<ix-custom-hint-ft value='customHint'></ix-custom-hint-ft>");//Esto servira para poner el icono.
						auxElement.before($compile("<ix-custom-hint-ft ng-if='hasFocus' value='customHint'></ix-custom-hint-ft>")(scope));
					}
				}
			};

			scope.$on("CopiarValorHint", function () {
				scope.ngModel = scope.customHint;
			});

			$timeout(function () {
				var textareaElement = angular.element(element.find("textarea")[0]);
				scope.oldHeight = textareaElement[0].offsetHeight;
				textareaElement.on("mousemove", function () {
					var textareaElement = angular.element(element.find("textarea")[0]);
					var actualHeight = textareaElement[0].offsetHeight;
					if (scope.oldHeight != actualHeight) {
						scope.changedTextAreaHeight = true;
						scope.oldHeight = actualHeight;
					}
				});
				textareaElement.on("mouseup", function () {
					if (scope.changedTextAreaHeight) {
						scope.hasFocus = false;
						$timeout(function () {
							scope.hasFocus = true;
						});
					}
				});
			});
		}
	};
}]);

angular.module('FTBase').directive('ixCustomHintFt', ['$timeout', function ($timeout) {
	return {
		restrict: 'E',
		scope: {
			value: '=?',
			valueGrid: '@?',
			onCopyValue: '=?',
			row: '=?',
			col: '=?'
		},
		templateUrl: 'app/FTBase/views/ixCustomHintFt.html',
		link: function (scope, elem, attrs) {

			scope.calculateTop = function () {
				$timeout(function () {
					var height = angular.element(elem).parent().children("textarea")[0].offsetHeight;
					var calculatedTop = (height) + (2);
					var css = {};
					css["position"] = "fixed";
					css["margin-top"] = calculatedTop + 'px';
					css["z-index"] = '999';
					elem.css(css);
				});
			};

			scope.calculateMarginTop = function () {
				var height = angular.element(elem)[0].offsetHeight;
				var calculatedTop = scope.row.height;
				var css = {};
				css["margin-top"] = calculatedTop + 'px';
				elem.css(css);
			};

			if (angular.isDefined(scope.value)) {
				scope.calculateTop();
			} else if (angular.isDefined(scope.valueGrid)) {
				scope.calculateMarginTop();
			}

			scope.copiarValorHint = function () {
				if (angular.isDefined(scope.onCopyValue))
					scope.onCopyValue(scope.row, scope.col, scope.valueGrid);
				else
					scope.$emit("CopiarValorHint");
			};
		}
	};
}]);

angular.module('FTBase').directive('autosize', ['$timeout', function ($timeout) {
	return {
		restrict: 'A',
		link: function (scope, elem, attrs) {
			var autosize = function () {
				//angular.element(elem)[0].style.cssText = 'width: 100%; height: auto; overflow: hidden; padding:0';
				$timeout(function () {
					var height = angular.element(elem)[0].scrollHeight + 2;
					if(height<26) {
						height = 26;
					} 
					angular.element(elem)[0].style.height = height + 'px';
					angular.element(elem)[0].style.maxHeight = '25vh';
				}, 1);
			};
			elem.on('keyup', function (e) {
				autosize();
			});
			autosize();
		}
	}
}]);

/*global ixGetPatchOperations*/

angular.module('FTBase').controller('PopupFicheroLaboratorioController', [ '$scope', 'cfg', '$http', '$uibModalInstance', '$log', 'Upload', 'ixStatusService', function($scope, cfg, $http, $uibModalInstance, $log, Upload, ixStatusService){
	$scope.status = ixStatusService.current;
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
  $scope.data = {};
  $scope.idFichero = $scope.$resolve.idFichero;
  $scope.idLab = $scope.$resolve.idLab;
  $scope.mantenimiento_lab = $scope.$resolve.mantenimiento_lab;

  $scope.data.laboratorio = $scope.idLab;
  if (!$scope.mant_proveedor) $scope.bloquearGrupos = true;
  $scope.uploadingFile = false;
  $scope.uploadedFile = false;
  $scope.status.editing = true;
  $scope.esNuevo = false;

  if ($scope.idFichero == 0){
		//Es un nuevo fichero
		$scope.esNuevo = true;
    $scope.tituloPopup = "Cargar nuevo fichero";
	}
  else {
    //Se está editando un fichero existente
    $scope.tituloPopup = "Editar fichero";
    $http.get(cfg.baseURL + "laboratorios_ficheros/" + $scope.idFichero).then(function(response){
			$scope.data = response.data;
			$scope.original_data = angular.copy($scope.data);
		}, function(error){
			ixStatusService.setResponse(error);
		});
  }

  $scope.save = function(){
    if ($scope.esNuevo){
      if (angular.isUndefined($scope.archivosToUpload)){
        $log.log("No se ha seleccionado un archivo");
      }
      else {
        var fileNames = [];
        fileNames.push($scope.archivosToUpload[0].name);

        $http.post(cfg.baseURL + "laboratorios_ficheros/CanUpload?laboratorio=" + $scope.idLab, fileNames).then(function(response){
          if (response.data.GlobalMessage.ErrType == 0){
            $scope.uploadingFile = true;
            var upload = Upload.upload({
              url: cfg.baseURL + "laboratorios_ficheros/UploadAndCreate",
              data: {
                file: $scope.archivosToUpload,
                laboratorio: $scope.idLab,
                tipo: $scope.data.tipo,
                fecha_caducidad: $scope.data.fecha_caducidad,
                fecha_carga: $scope.data.fecha_carga,
                inicio_validez: $scope.data.inicio_validez
              },
              dataType: 'json'
            });

            upload.then(function(response){
              if (response.data){
                delete $scope.data.ixProgress;
                $scope.uploadingFile = false;
                $scope.uploadedFile = true;
                ixStatusService.setResponse(response);
                //$scope.status.editing = false;
                $uibModalInstance.close($scope.uploadedFile);
                }
            }, function(error){
              if (error.data) {
                delete $scope.data.ixProgress;
                $scope.uploadingFile = false;
              }
              ixStatusService.setResponse(error);
            }, function(evt){
              $scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
          }
          else {
            ixStatusService.setResponse(response);
          }
        }, function(error){
          ixStatusService.setResponse(error);
        });
      }
    }
    else { //EDITAR
      var param = {};
      param = ixGetPatchOperations($scope.original_data, $scope.data);

      $http.put(cfg.baseURL + "laboratorios_ficheros/" + $scope.data.id, param).then(function(response){
        ixStatusService.setResponse(response);
        //$scope.status.editing = false;
        $uibModalInstance.close(true);
      }, function(error){
        ixStatusService.setResponse(error);
      });
    }
  };


  $scope.$dismiss = function () {
		$uibModalInstance.close(false);
	};

}]);
/*global buildIxSearch*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global ixGetPatchOperations*/
/*global saveAs*/

angular.module('FTBase').controller('PlantasPopupController', ['$scope', '$uibModalInstance', 'gridService', 'ixStatusService', '$http', 'cfg', '$timeout', '$q', 'ixUtilsService', 'authService', '$ngConfirm', function ($scope, $uibModalInstance, gridService, ixStatusService, $http, cfg, $timeout, $q, ixUtilsService, authService, $ngConfirm) {
	$scope.status = ixStatusService.current;
	$scope.data = {};
	$scope.data.planta = $scope.$resolve.clickedItem;
	$scope.data.planta_datos_originales = angular.copy($scope.$resolve.clickedItem);
	$scope.data.fabricante = $scope.$resolve.fabricante;
	$scope.data.proveedor = $scope.$resolve.proveedor;
	$scope.data.bIsOneFabricante = $scope.$resolve.bIsOneFabricante;
	$scope.data.planta.fabricante = $scope.data.fabricante;
	$scope.data.lstProductos = $scope.$resolve.lstProductos;
	$scope.isNew = $scope.$resolve.isNew;
	$scope.gridManualLoad = true;

	$scope.es_proveedor = true;
	$scope.tienePerfilRestringido = function () {
		var perfilRestringido = false;
		var perfilesUsuario = authService.perfilesUsuario();

		var perfilesRestringidos = ["usr_proveedor"];

		angular.forEach(perfilesUsuario, function (perfil) {
			if (perfilesRestringidos.indexOf(perfil) != -1)
				perfilRestringido = true;
		});

		return perfilRestringido;
	};

	if(!$scope.$resolve.extranetUser.cliente && !$scope.$resolve.bloqueado)
		$scope.status.editing = true;

	$scope.addFicheros = function (){
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
		var controllerName = "UploadFilePopupProveedoresController";
		var optionsPopupFicheros = {
			controller: controllerName
		};
		var params = { "id_proveedor": $scope.data.proveedor, "grupo": "PLANTA", fabricante: $scope.data.fabricante, planta: $scope.data.planta.planta };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
		modalInstance.then(function (resp) {
			$scope.data.gridCertificadosPlanta.ixLoadInitialData();
		});
	};

	$scope.deleteSelectedRows = function (grid) {
		grid.ixDeleteSelectedRows();
	};

	//GRID CERTIFICADOS PLANTA
	if (!$scope.data.gridCertificadosPlanta) {
		var accionesCertificados = [
			{
				title: "Previsualizar PDF",
				icon: "fa-file-pdf-o",
				visible: function (entity) {
					return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
				},
				accion: function (entity){
					var tabla = "proveedores_ficheros";
					$http({
						method: 'post',
						url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
						headers: {},
						responseType: 'arraybuffer'
					}).then(function (r) {
						$scope.selectedPDF = new Uint8Array(r.data);
						$scope.idFicheroPreview = entity.id;
						var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
						ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
					},
						function (err) {
							ixStatusService.setResponse(err);
						});
				}
			},
			{
				title: "Previsualizar Imagen",
				icon: "fa-file-image-o",
				visible: function (entity) {
					return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
				},
				accion: function (entity){
					var tabla = $scope.getEntity();
					$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r){
						$scope.selectedImage = r.data;
						$scope.idFicheroPreview = entity.id;
						var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
						ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
					},
					function (err) {
						ixStatusService.setResponse(err);
					});
				}
			},
			{
				title: "Descargar fichero",
				icon: "fa-download",
				visible: function (entity) {
					return entity.archivo;
				},
				accion: function(entity){
				 	$scope.downloadFile(entity.id);
			 	}
			}
		];

		var metadata = [
			// { Name: "descripcion_actividad", NoVisible: true },
			// { Name: "baja", NoVisible: true },
			// { Name: "fecha_alta", NoVisible: true },
			// { Name: "fecha_baja", NoVisible: true },
			// { Name: "homologada", NoVisible: true },
			// { Name: "fecha_homologacion", NoVisible: true },
			// { Name: "certificacion_brc", NoVisible: true },
			// { Name: "certificacion_ifs", NoVisible: true }
		];
		if(cfg.appCliente == "ALCAMPO"){
			metadata.push({ Name: "comentarios", NoVisible: false });
			metadata.push({ Name: "resultado", NoVisible: false });
		}
		$scope.data.gridCertificadosPlanta = gridService.createGrid($scope, 'gnet_grid_certificados_planta', { metadata: metadata, minRowsToShow: 5, showOnlyDescribedCols: ["tipo", "num_certificado", "certificadora", "fecha_caducidad", "inicio_validez", "alcance", "comentarios", "resultado"] }, "proveedores_ficheros", [{ name: 'Acciones', type: 'detalle', acciones: accionesCertificados }]);
		$scope.data.gridCertificadosPlanta.filtroExterno = [{ Field: 'planta', Value: $scope.data.planta.planta, Operator: CMP_EQ }];
		$scope.data.gridCertificadosPlanta.ixLoadInitialData();
	}
	else {
		$scope.data.gridCertificadosPlanta = gridService.createGridFunctions($scope, $scope.data.gridCertificadosPlanta);
		$scope.data.gridCertificadosPlanta.ixRestoreConfig();
	}

	$scope.guardar = function (){
		if ($scope.isNew){
			$http.post(cfg.baseURL + "plantas", $scope.data.planta).then(function (r){
				delete $scope.isNew;
				$scope.data.planta.planta = r.data.obj.Record.planta;
				$scope.data.planta.fecha_alta=r.data.obj.Record.fecha_alta;
				$scope.data.planta_datos_originales = angular.copy($scope.data.planta);
				$scope.data.planta_datos_originales.fecha_alta = $scope.data.planta.fecha_alta
				//Actualizo el filtro externo ????
				$scope.data.gridCertificadosPlanta.filtroExterno = [{ Field: 'planta', Value: $scope.data.planta.planta, Operator: CMP_EQ }];
				$scope.dataModified = true;
				ixStatusService.setResponse(r);

			}, function(error){
				ixStatusService.setResponse(error);
			});
		}
		else {
			var existe = false;
			var todasFT = "";
			if($scope.data.planta_datos_originales.baja == 0 && $scope.data.planta.baja == 1)
			{
				angular.forEach($scope.data.lstProductos, function(productos) {
					if (productos.plantas.includes($scope.data.planta_datos_originales.nombre_planta) && productos.estado != "BAJA") {
					  existe = true;
					  todasFT += productos.ft+" </br>";
					}
				  });
			}
			if(existe == true){
				$ngConfirm({
					title: "No se puede dar de baja la planta, porque esta asociada a las siguientes FT:",
					content: todasFT
				});
				$scope.data.planta.baja = 0;
				var fakeResponse = { data: { GlobalMessage: {} }, status: 200 };
          		fakeResponse.data.GlobalMessage.Msg = todasFT;
          		fakeResponse.data.GlobalMessage.ErrType = 1;
				ixStatusService.setResponse(fakeResponse);
			}else{
				var data = {};
			data.jpdPlanta = ixGetPatchOperations($scope.data.planta_datos_originales, $scope.data.planta);
			data.ubpFicheros = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
			if ($scope.data.gridCertificadosPlanta.gridApi.rowEdit){
				data.ubpFicheros = $scope.data.gridCertificadosPlanta.ixGetBulkParam();
			}

			$http.put(cfg.baseURL + "plantas/PutPlanta/" + $scope.data.planta.planta, data).then(function (r) {
				$scope.data.planta_datos_originales = angular.copy($scope.data.planta);
				if(new Date($scope.data.planta.fecha_baja).getTime() 
					!= new Date(r.data.obj.Record.fecha_baja).getTime() ){
					$scope.data.planta.fecha_baja=r.data.obj.Record.fecha_baja;
					$scope.data.planta_datos_originales.fecha_baja = $scope.data.planta.fecha_baja;
				}
				
				$scope.dataModified = true;
				$scope.data.gridCertificadosPlanta.clearGridAfterSave();

				$scope.status.editing = true;
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
			}
		}
	};


	/*
	$scope.guardarOLD = function () {
		var data = {}
		if ($scope.isNew) {
			data.nuevaPlanta = $scope.data.planta;
			data.nuevosCertificados = $scope.data.gridCertificadosPlanta.data;
			$http.post(cfg.baseURL + "plantas/PostPlanta", data).then(function (r) {
				delete $scope.isNew;

				$http.get(cfg.baseURL + "plantas/" + r.data.obj.Record.planta).then(function(response){
					$scope.data.planta = response.data;
					$scope.data.planta_datos_originales = angular.copy($scope.data.planta);
				});

				$scope.data.gridCertificadosPlanta.deletedRows = [];
				$scope.data.gridCertificadosPlanta.insertedRows = [];
				$scope.data.gridCertificadosPlanta.clearFocus();
				var dataRows = $scope.data.gridCertificadosPlanta.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
				$scope.data.gridCertificadosPlanta.gridApi.rowEdit.setRowsClean( dataRows );
				$scope.data.gridCertificadosPlanta.filtroExterno = [{ Field: 'planta', Value: r.data.obj.Record.planta, Operator: CMP_EQ }];
				$scope.data.gridCertificadosPlanta.ixLoadInitialData();

				$scope.status.editing = true;
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		} else {
			data.jpdPlanta = ixGetPatchOperations($scope.data.planta_datos_originales, $scope.data.planta);
			// console.log(data.jpdPlanta);
			// console.log($scope.data.planta_datos_originales);
			// console.log($scope.data.planta);
			data.ubpCertificados = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
			if ($scope.data.gridCertificadosPlanta.gridApi.rowEdit){
				data.ubpCertificados = $scope.data.gridCertificadosPlanta.ixGetBulkParam();
			}

			$http.put(cfg.baseURL + "plantas/PutPlanta/" + $scope.data.planta.planta, data).then(function (r) {
				$scope.data.planta_datos_originales = angular.copy($scope.data.planta);

				$scope.data.gridCertificadosPlanta.deletedRows = [];
				$scope.data.gridCertificadosPlanta.insertedRows = [];
				$scope.data.gridCertificadosPlanta.clearFocus();
				var dataRows = $scope.data.gridCertificadosPlanta.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
				$scope.data.gridCertificadosPlanta.gridApi.rowEdit.setRowsClean( dataRows );
				$scope.data.gridCertificadosPlanta.ixLoadInitialData();

				$scope.status.editing = true;
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}

	};
*/
	// $scope.$close = function () {
	// 	$uibModalInstance.dismiss('cancel');
	// };

	$scope.$dismiss = function () {
		//$scope.save();
		var resp = {};
		// resp.planta = $scope.data.planta;
		// resp.planta_datos_originales = $scope.data.planta_datos_originales;
		resp.dataModified = $scope.dataModified;

		$uibModalInstance.close(resp);
	}

	$scope.downloadFile = function (id){
		$http({
			method: 'post',
			url: cfg.baseURL + 'proveedores_ficheros/DownloadFile?id=' + id,
			headers: { 'Content-type': 'application/pdf' },
			responseType: 'arraybuffer'
		}).then(function (r) {
			var file = new Blob([r.data], { type: r.headers('Content-type') });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function (err){
			ixStatusService.setResponse(err);
		});
	}

}]);

/*global buildIxSearch*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global CMP_ISNULL*/
/*global ixGetPatchOperations*/
/*global saveAs*/

angular.module('FTBase').controller('FabricantesPopupController', ['$scope', '$uibModalInstance', 'gridService', 'ixStatusService', '$http', 'cfg', '$timeout', '$q', 'ixUtilsService', 'ixWarningsService', '$log', function ($scope, $uibModalInstance, gridService, ixStatusService, $http, cfg, $timeout, $q, ixUtilsService, ixWarningsService, $log) {
	$scope.status = ixStatusService.current;
	$scope.data = {};
	$scope.data.fabricante = $scope.$resolve.clickedItem;
	$scope.data.fabricante_datos_originales = angular.copy($scope.$resolve.clickedItem);
	$scope.bloqueado = $scope.$resolve.bloqueado;
	$scope.isNew = $scope.$resolve.isNew;

	$scope.dataModified = false;

	$scope.gridManualLoad = true;
	if (!$scope.$resolve.extranetUser.cliente && !$scope.bloqueado)
		$scope.status.editing = true;

	// $scope.addFicheros = function () {
	// 	var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
	// 	var controllerName = "UploadFilePopupProveedoresController";
	// 	var optionsPopupFicheros = {
	// 		controller: controllerName
	// 	};
	// 	var params = { "id_proveedor": $scope.data.fabricante.proveedor, "grupo": "FABRICANTE", fabricante: $scope.data.fabricante.fabricante };
	// 	var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
	// 	modalInstance.then(function (resp) {
	// 		$scope.data.gridCertificadosFabricante.ixLoadInitialData();
	// 	});
	// };

	$scope.addRow = function (grid, item) {
		var nuevo = item || {};
		if (grid.entity == 'plantas') {
			nuevo.fabricante = $scope.data.fabricante.fabricante;
			abrirPopupPlantas(nuevo, true);
		}
	};

	$scope.deleteSelectedRows = function (grid) {
		var warningSentence = "ATENCIÓN: Se eliminaran las plantas seleccionadas con todos los documentos y auditorías asociados. ¿Se desea continuar?";
		ixWarningsService.warningConfirmacion($scope, warningSentence, confirmaEliminarPlanta, undefined, grid);
		//grid.ixDeleteSelectedRows();
	};

	//GRID PLANTAS
	if (!$scope.data.gridPlantas) {
		//var metadata = [];
		var acciones = [
			{
				icon: "fa-search",
				title: "Plantas",
				visible: function (entity) {
					return true;//!$scope.data.datos.isNew;
				},
				accion: function (entity) {
					abrirPopupPlantas(entity, false);
				}
			}
		];
		$scope.data.gridPlantas = gridService.createGrid($scope, 'gnet_grid_plantas', { metadata: [], minRowsToShow: 5 }, "plantas", [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
		$scope.data.gridPlantas.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }];
		$scope.data.gridPlantas.ixLoadInitialData();

	} else {
		$scope.data.gridPlantas = gridService.createGridFunctions($scope, $scope.data.gridPlantas);
		$scope.data.gridPlantas.ixRestoreConfig();
	}

	// //GRID CERTIFICADOS FABRICANTE
	// if (!$scope.data.gridCertificadosFabricante) {
	// 	var accionesCertificados = [
	// 		{
	// 			title: "Previsualizar PDF",
	// 			icon: "fa-file-pdf-o",
	// 			visible: function (entity) {
	// 				return entity.archivo && entity.archivo.toLowerCase().indexOf(".pdf") != -1;
	// 			},
	// 			accion: function (entity) {
	// 				var tabla = "proveedores_ficheros";
	// 				$http({
	// 					method: 'post',
	// 					url: cfg.baseURL + tabla + '/DownloadFile?id=' + entity.id,
	// 					headers: {},
	// 					responseType: 'arraybuffer'
	// 				}).then(function (r) {
	// 					$scope.selectedPDF = new Uint8Array(r.data);
	// 					$scope.idFicheroPreview = entity.id;
	// 					var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html";
	// 					ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
	// 				},
	// 					function (err) {
	// 						ixStatusService.setResponse(err);
	// 					});
	// 			}
	// 		},
	// 		{
	// 			title: "Previsualizar Imagen",
	// 			icon: "fa-file-image-o",
	// 			visible: function (entity) {
	// 				return entity.archivo && ((entity.archivo.toLowerCase().indexOf(".jpg") != -1) || (entity.archivo.toLowerCase().indexOf(".png") != -1));
	// 			},
	// 			accion: function (entity) {
	// 				var tabla = $scope.getEntity();
	// 				$http.post(cfg.baseURL + tabla + '/GetImgBase64?id=' + entity.id).then(function (r) {
	// 					$scope.selectedImage = r.data;
	// 					$scope.idFicheroPreview = entity.id;
	// 					var template = "app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html";
	// 					ixUtilsService.openModalV2(template, { scope: $scope }, "medium", undefined);
	// 				},
	// 					function (err) {
	// 						ixStatusService.setResponse(err);
	// 					});
	// 			}
	// 		},
	// 		{
	// 			title: "Descargar fichero",
	// 			icon: "fa-download",
	// 			visible: function (entity) {
	// 				return entity.archivo;
	// 			},
	// 			accion: function (entity) {
	// 				$scope.downloadFile(entity.id);
	// 			}
	// 		}
	// 		// {
	// 		// 	icon: "fa-upload",
	// 		// 	title: "Subir fichero",
	// 		// 	visible: function(entity){
	// 		// 		return !entity.isNew;
	// 		// 	},
	// 		// 	accion: function (entity){
	// 		// 		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html";
	// 		// 		var controllerName = "UploadFilePopupProveedoresController";
	// 		// 		var optionsPopupFicheros = {
	// 		// 			controller: controllerName
	// 		// 		};
	// 		// 		var params = { "id_proveedor": $scope.data.fabricante.proveedor, "grupo": "FABRICANTE", fabricante: entity.fabricante };
	// 		// 		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupFicheros, 'medium', params);
	// 		// 		modalInstance.then(function (resp) {
	// 		//
	// 		// 		});
	// 		// 	}
	// 		// }
	// 	];
	// 	var metadata = [];
	// 	$scope.data.gridCertificadosFabricante = gridService.createGrid($scope, 'gnet_grid_certificados_fabricante', { metadata: metadata, minRowsToShow: 5, showOnlyDescribedCols: ["tipo", "num_certificado", "certificadora", "fecha_caducidad", "inicio_validez", "alcance"] }, "proveedores_ficheros", [{ name: 'Acciones', type: 'detalle', acciones: accionesCertificados }]);
	// 	$scope.data.gridCertificadosFabricante.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }, { Field: 'planta', Value: null, Operator: CMP_ISNULL }];
	// 	$scope.data.gridCertificadosFabricante.ixLoadInitialData();

	// } else {
	// 	$scope.data.gridCertificadosFabricante = gridService.createGridFunctions($scope, $scope.data.gridCertificadosFabricante);
	// 	$scope.data.gridCertificadosFabricante.ixRestoreConfig();
	// }


	//$scope.ixEditar = $scope.data.gridPlantas.ixEditar;


	$scope.guardar = function () {
		if ($scope.isNew) {
			$http.post(cfg.baseURL + "fabricantes", $scope.data.fabricante).then(function (r) {
				delete $scope.isNew;
				$scope.dataModified = true;
				$scope.data.fabricante.fabricante = r.data.obj.Record.fabricante;
				$scope.data.fabricante_datos_originales = angular.copy($scope.data.fabricante);
				//Actualizo el filtro externo de los ficheros y plantas (????)
				//$scope.data.gridCertificadosFabricante.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }, { Field: 'planta', Value: null, Operator: CMP_ISNULL }];
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
		else {
			var data = {};

			data.jpdFabricante = ixGetPatchOperations($scope.data.fabricante_datos_originales, $scope.data.fabricante);

			data.ubpFicheros = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			};
			// if ($scope.data.gridCertificadosFabricante && $scope.data.gridCertificadosFabricante.gridApi.rowEdit)
			// 	data.ubpFicheros = $scope.data.gridCertificadosFabricante.ixGetBulkParam();

			data.ubpPlantas = {
				ToInsert: [],
				ToUpdate: [],
				ToDelete: []
			}
			//if ($scope.data.gridPlantas && $scope.data.gridPlantas.gridApi.rowEdit)
			//	data.ubpPlantas = $scope.data.gridPlantas.ixGetBulkParam();

			$http.put(cfg.baseURL + "fabricantes/PutFabricante/" + $scope.data.fabricante.fabricante, data).then(function (r) {
				$scope.data.fabricante_datos_originales = angular.copy($scope.data.fabricante);
				$scope.dataModified = true;

				//$scope.data.gridPlantas.clearGridAfterSave();
				//$scope.data.gridCertificadosFabricante.clearGridAfterSave();

				$scope.status.editing = true; //Porque las llamadas al clearGridAfterSave lo ponen a false
				ixStatusService.setResponse(r);
			}, function (error) {
				ixStatusService.setResponse(error);
			});
		}
	};

	var confirmaEliminarPlanta = function (grid) {
		grid.ixDeleteSelectedRows();
	};

	$scope.$dismiss = function () {
		//$scope.save();
		var resp = {};
		// resp.fabricante = $scope.data.fabricante;
		// resp.fabricante_datos_originales = $scope.data.fabricante_datos_originales;
		resp.isNew = $scope.isNew;
		resp.dataModified = $scope.dataModified;
		$uibModalInstance.close(resp);
	}

	var abrirPopupPlantas = function (entity, isNew) {
		var urlTemplate = "app/FTBase/Mantenimientos/proveedores/modales/plantasPopup.html";
		var controllerName = "PlantasPopupController";
		var optionsPopupPlantas = {
			controller: controllerName,
			resolve: {
				clickedItem: function () {
					return entity;
				},
				isNew: function () {
					return isNew;
				}
			}
		};
		var params = { "clickedItem": entity, "isNew": isNew, "fabricante": $scope.data.fabricante.fabricante,"bIsOneFabricante": true, "extranetUser": $scope.$resolve.extranetUser, "bloqueado": $scope.bloqueado, "proveedor": $scope.data.fabricante.proveedor };
		var modalInstance = ixUtilsService.openModalV2(urlTemplate, optionsPopupPlantas, 'medium', params);
		modalInstance.then(function (resp) {
			if (resp.dataModified) {			
				$scope.data.gridPlantas.filtroExterno = [{ Field: 'fabricante', Value: $scope.data.fabricante.fabricante, Operator: CMP_EQ }];
				$scope.data.gridPlantas.ixLoadInitialData();
			}
			$scope.dataModified = resp.dataModified;
		});
	};

	$scope.downloadFile = function (id) {
		$http({
			method: 'post',
			url: cfg.baseURL + 'proveedores_ficheros/DownloadFile?id=' + id,
			headers: { 'Content-type': 'application/pdf' },
			responseType: 'arraybuffer'
		}).then(function (r) {
			var file = new Blob([r.data], { type: r.headers('Content-type') });

			var filename = $scope.entity + ".pdf";
			if (r.headers('Content-Disposition')) {
				filename = r.headers('Content-Disposition').split("=")[1];
			}
			saveAs(file, filename);
		}, function (err) {
			ixStatusService.setResponse(err);
		});
	}

}]);

angular.module('FTBase').controller('UploadFilePopupProveedoresController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'Upload', 'ixStatusService', 'ixWarningsService', function($scope, cfg, $http, $uibModalInstance, Upload, ixStatusService, ixWarningsService){
	$scope.maxUploadFileSize = cfg.maxUploadFileSize;
	$scope.fichero_opcional = cfg.fichero_opcional;
  	$scope.proveedor = $scope.$resolve.id_proveedor;
	  $scope.fabricante = $scope.$resolve.fabricante;
	  $scope.bIsOneFabricante = $scope.$resolve.bIsOneFabricante;
	$scope.status = ixStatusService.current;
	$scope.data = {};
	$scope.grupo = $scope.$resolve.grupo;
	$scope.soloHayPlantaPuesta = $scope.$resolve.soloHayPlantaPuesta;
	if($scope.soloHayPlantaPuesta) $scope.status.editing=true;
	$scope.bloquearGrupos = $scope.grupo ? true : false;
	if(angular.isUndefined($scope.grupo) || $scope.grupo == null || $scope.grupo == "")
		$scope.grupo ="PLANTA";
	$scope.fabricante = $scope.$resolve.fabricante;
	$scope.planta = $scope.$resolve.planta;
	//Datos usados en caso de sustitución fichero
	//En el parámetro sustituir envío el id del fichero que se sostituirá para poder marcarlo como archivado
	$scope.sustituir = $scope.$resolve.sustituir;
	if ($scope.sustituir) $scope.status.editing = true; //Me aseguro de que la modalidad edición esté activa
	$scope.tipoSeleccionadoProveedor = $scope.$resolve.tipoFichero;
	$scope.alcance = $scope.$resolve.alcance;
	if ($scope.grupo === "PLANTA"){
		$scope.seleccionadoCertificado = 1;
		$scope.caducidadObligatoria = true;
	}
	else{
		$scope.seleccionadoCertificado = 0;
		$scope.caducidadObligatoria = false;
	}	
		
	$scope.save = function(){
		if(angular.isDefined($scope.sustituir)){
			var frase ="ATENCIÓN: Se eliminaran los certificados anteriores que esten obsoletos, siempre que haya uno activo y otro archivado. ¿Se desea continuar con la operación?";
			ixWarningsService.warningConfirmacion($scope,frase,guardarConfirmed);
		}else{
			guardarConfirmed();
		}
	};

	var guardarConfirmed = function(){
		var fileNames = [];
		angular.forEach($scope.archivosToUpload, function(fileToUpload){
			fileNames.push(fileToUpload.name);
		});

		// var upl_info = {
		// 	toReplace: $scope.sustituir,
		// 	fileNames: fileNames
		// };
		if(fileNames.length == 0){
			var dataNew= {
				ruta_raiz: "",
				ruta_relativa:"",
				archivo: "",
				file: $scope.archivosToUpload,
				grupo: $scope.grupo,
				proveedor: $scope.proveedor,
				fabricante: $scope.fabricante,
				planta: $scope.planta,
				tipo: $scope.tipoSeleccionadoProveedor,
				fecha_caducidad: $scope.fechaCaducidad,
				inicio_validez: $scope.inicio_validez,
				num_certificado: $scope.num_certificado,
				certificadora: $scope.certificadora,
				alcance: $scope.alcance,
				comentarios: $scope.comentarios,
				resultado: $scope.resultado
			}
			$http.post(cfg.baseURL + "proveedores_ficheros/", dataNew).then(function(response){
				ixStatusService.setResponse(response);
				$uibModalInstance.close($scope.data);
			},
			function(error){
				ixStatusService.setResponse(error);
			});
		}else{
			$http.post(cfg.baseURL + "proveedores_ficheros/CanUpload?id_proveedor="+$scope.proveedor, fileNames).then(function(response){
				if(response.data.GlobalMessage.ErrType == 0){
					$scope.data.uploadingFile = true;
					if ($scope.grupo == 'PROVEEDOR'){
						$scope.fabricante = null;
						$scope.planta = null;
					}
					if ($scope.grupo == 'FABRICANTE'){
						$scope.planta = null;
					}
					var upload = Upload.upload({
						url: cfg.baseURL + "proveedores_ficheros/UploadAndCreate",
						data: {
							file: $scope.archivosToUpload,
							grupo: $scope.grupo,
							proveedor: $scope.proveedor,
							fabricante: $scope.fabricante,
							planta: $scope.planta,
							tipo: $scope.tipoSeleccionadoProveedor,
							fecha_caducidad: $scope.fechaCaducidad,
							inicio_validez: $scope.inicio_validez,
							num_certificado: $scope.num_certificado,
							certificadora: $scope.certificadora,
							alcance: $scope.alcance,
							comentarios: $scope.comentarios,
							resultado: $scope.resultado
						},
						dataType: 'json'
					});
	
					upload.then(function(response){
						if(response.data){
							delete $scope.data.ixProgress;
							$scope.data.uploadingFile = false;
							ixStatusService.setResponse(response);
							$scope.status.editing = false;
							if ($scope.sustituir){
								var param = [];
								param.push({
									value: 1,
									path: "/archivado",
									op: "replace"
								});
	
								$http.put(cfg.baseURL + "proveedores_ficheros/" + $scope.sustituir, param).then(function(response){
									ixStatusService.setResponse(response);
									$uibModalInstance.close($scope.data);
								},
								function(error){
									ixStatusService.setResponse(error);
								});
							}
							else{
								$uibModalInstance.close($scope.data);
							}
						}
						else{
							$uibModalInstance.close($scope.data);
						}
					}, function(response){
						if(response.data){
							delete $scope.data.ixProgress;
							$scope.data.uploadingFile = false;
						}
					}, function(evt){
						$scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					});
				}
				else {
					ixStatusService.setResponse(response);
				}
			}, function(err){
				ixStatusService.setResponse(err);
			});
		}

		//$uibModalInstance.close($scope.data);
	}

	//Limpio los eventuales valores del tipo fichero, caducidad y alcance
	$scope.seleccionadoGrupo = function(){
		$scope.tipoSeleccionadoProveedor = undefined;
		if ($scope.grupo == 'PROVEEDOR' || $scope.grupo == 'FABRICANTE'){
			$scope.fechaCaducidad = null;
			$scope.alcance = null;
			$scope.seleccionadoCertificado = 0;
			$scope.caducidadObligatoria = 0;
		}
		else{
			$scope.seleccionadoCertificado = 1;
			$scope.caducidadObligatoria = true;
		} 
	};


	// $scope.tipoFicheroSelected = function(entity){
	// 	$scope.seleccionadoCertificado = entity.certificado;
	// 	$scope.caducidadObligatoria = (entity.caducidad_obligatoria == 1)
	// };

	$scope.limpiarPlanta = function(){
    	$scope.planta = undefined;
		$scope.fabricante = undefined;
  	};


	$scope.$close = function(){
		$uibModalInstance.dismiss('cancel');
	}

	$scope.$dismiss = function(){
		$uibModalInstance.close({});
	}

}]);

/*global CMP_EQ*/
angular.module('FTBase').controller('NuevoProductoPlantaPopupController', [ '$scope', 'cfg', '$http', '$uibModalInstance', 'ixStatusService', '$q', 'gridService', '$log', function($scope, cfg, $http, $uibModalInstance, ixStatusService, $q, gridService, $log){
    $scope.status = {editing: true};
    $scope.id_proveedor = $scope.$resolve.id_proveedor;
    $scope.data = [];

    $scope.crearGridPlantasAsociadas = function () {
      var metadata = [];
      var filtroPlantas = [];
      if (!$scope.data.gridPlantasAsociadas) {
        metadata.push({ Name: "razon_social", NoVisible: true });
        metadata.push({ Name: "direccion", NoVisible: true });
        metadata.push({ Name: "cp", NoVisible: true });
        metadata.push({ Name: "provincia", NoVisible: true });
        metadata.push({ Name: "pais", NoVisible: true });
        metadata.push({ Name: "telefono", NoVisible: true });
        metadata.push({ Name: "reg_sanitario", NoVisible: true });
        metadata.push({ Name: "descripcion_actividad", NoVisible: true });
        metadata.push({ Name: "baja", NoVisible: true });
        metadata.push({ Name: "fecha_alta", NoVisible: true });
        metadata.push({ Name: "fecha_baja", NoVisible: true });
        metadata.push({ Name: "homologada", NoVisible: true });
        metadata.push({ Name: "fecha_homologacion", NoVisible: true });
        metadata.push({ Name: "certificacion_brc", NoVisible: true });
        metadata.push({ Name: "certificacion_ifs", NoVisible: true });
        metadata.push({ Name: "fecha_ultima_auditoria", NoVisible: true });

        $scope.data.gridPlantasAsociadas = gridService.createGrid($scope, 'gnet_grid_proveedores_plantas_asociadas', { minRowsToShow: 4, metadata: metadata}, "plantas_proveedorVM");
        filtroPlantas = [{ Field: 'proveedor', Value: $scope.id_proveedor, Operator: CMP_EQ, skip: true },{Field: 'baja', Value: 0, Operator: CMP_EQ}];
        $scope.data.gridPlantasAsociadas.filtroExterno = filtroPlantas;
        $scope.data.gridPlantasAsociadas.ixLoadInitialData();
      } else {
        $scope.data.gridPlantasAsociadas = gridService.createGridFunctions($scope, $scope.data.gridPlantasAsociadas);
        $scope.data.gridPlantasAsociadas.ixRestoreConfig();
        filtroPlantas = [{ Field: 'proveedor', Value: $scope.id_proveedor, Operator: CMP_EQ, skip: true },{Field: 'baja', Value: 0, Operator: CMP_EQ}];
        $scope.data.gridPlantasAsociadas.filtroExterno = filtroPlantas;
        $scope.data.gridPlantasAsociadas.ixLoadInitialData();
      }
    }
    $scope.crearGridPlantasAsociadas();

    $scope.save = function(){
      $scope.nuevaft.idioma = "es";
      $scope.nuevaft.proveedor =  $scope.id_proveedor;
      $scope.nuevaft.ean =  $scope.nuevoproducto.ean;
      $scope.nuevaft.rsi =  $scope.nuevoproducto.codigo_interno;
      $scope.plantas_asociadas = [];
      var selectedRows = $scope.data.gridPlantasAsociadas.gridApi.selection.getSelectedRows();
      selectedRows.forEach(function (row) {
        $scope.plantas_asociadas.push({id_fabricante : row.fabricante,id_planta: row.planta});
      })
      var datos = {ft :$scope.nuevaft,ean :$scope.nuevoproducto.ean,codigo_interno :$scope.nuevoproducto.codigo_interno,marca :$scope.nuevoproducto.marca,plantas_asociadas:$scope.plantas_asociadas }
      $http.put(cfg.baseURL + "extranet_fichas_tecnicas/NuevoProducto", datos).then(function (r) {
        ixStatusService.setResponse(r);
        $uibModalInstance.close(r.data.obj.Record.id);
      },
      function (error) {
        ixStatusService.setResponse(error);
      });
    }
  }]);
  
/*global ixGetPatchOperations*/
/*global CMP_EQ*/

angular.module("FTBase").controller("EditarPreguntaPopupController", [ "$scope",'$uibModalInstance','$http','cfg','ixStatusService', '$q', 'Upload', function($scope,$uibModalInstance,$http,cfg,ixStatusService, $q, Upload){
	$scope.status = { editing: true };
	$scope.data = {};
	$scope.isNew = $scope.$resolve.isNew;
	$scope.pregunta  = angular.copy($scope.$resolve.pregunta);
	//nivel, lleno los campos dropdown segun cada subnivel, buscando en la tabla ft_niveles por el nivel general
	if($scope.pregunta.nivel > 0){
		$http.get(cfg.baseURL + "ft_niveles/" + $scope.pregunta.nivel).then(function(response){
			setNiveles(response.data);
		}, function(error){
			ixStatusService.setResponse(error);
		});
	}

	//tipos_fichero separo los valores que vienen en forma de string separados por ';' en un array de numbers con los ids para el select-multiple
	if($scope.pregunta.tipos_fichero){
		$scope.pregunta.tipos_fichero = $scope.pregunta.tipos_fichero.split(';').map(Number);
	}

	$scope.preguntaOriginal = angular.copy($scope.pregunta);


  $scope.changeTab = function(idxTab){
    $scope.data.activeTab = idxTab;
  }

	$scope.save = function(){

		if($scope.data.nivel1)
		{
			//nivel hace el get de la pk del nivel en la tabla ft_niveles en funcion de los valores de los dropdowns de nivel
			var nivel = 0;
			getNivel()
			.then(function(nivelReturned){

				nivel = nivelReturned;

				if(nivel != 0)
					$scope.pregunta.nivel = nivel;

				if($scope.data.archivosToUpload){
					subirArchivo();
				}

				separarTiposFichero();

				var patch = ixGetPatchOperations($scope.preguntaOriginal, $scope.pregunta);
				$http.put(cfg.baseURL + "ft_preguntas/" + $scope.pregunta.id_pregunta, patch).then(function(response){
					ixStatusService.setResponse(response);
					$uibModalInstance.close();
				}, function(err){
					ixStatusService.setResponse(err);
				});
			})
			.catch(function(error){
				ixStatusService.setResponse(error);
			})
		}
		else{

			$scope.pregunta.nivel = null;

			if($scope.data.archivosToUpload){
				subirArchivo();
			}

			separarTiposFichero();

			var patch = ixGetPatchOperations($scope.preguntaOriginal, $scope.pregunta);
			$http.put(cfg.baseURL + "ft_preguntas/" + $scope.pregunta.id_pregunta, patch).then(function(response){
				ixStatusService.setResponse(response);
				$uibModalInstance.close();
			}, function(err){
				ixStatusService.setResponse(err);
			});
		}


	}

	var separarTiposFichero = function(){
		//tipos_fichero se crea un string con los valores separados por ';' para guardarlos en DB
		var separados = "";
		if($scope.pregunta.tipos_fichero){
			$scope.pregunta.tipos_fichero.forEach(function(element){
				if(separados == "")
					separados = element;
				else {
					separados += ";" + element;
				}
			});
			$scope.pregunta.tipos_fichero = separados;
		}
	}

	var subirArchivo = function(){
		var fileNames = [];
		fileNames.push($scope.data.archivosToUpload.name);


		$http.post(cfg.baseURL + "ft_preguntas/CanUpload/"+$scope.pregunta.id_pregunta, fileNames).then(function(response){
			if(response.data.GlobalMessage.ErrType == 0){
				$scope.data.uploadingFile = true;
				var upload = Upload.upload({
					url: cfg.baseURL + "ft_preguntas/UploadAndCreate/"+$scope.pregunta.id_pregunta,
					data: {file: $scope.data.archivosToUpload},
					dataType: 'json'
				});

				upload.then(function (response) {
					if(response.data){
						delete $scope.ixProgress;
						$scope.data.uploadingFile = false;
					}
				}, function (response) {
					if(response.data){
						delete $scope.ixProgress;
						$scope.data.uploadingFile = false;
					}
				}, function (evt) {
					// Math.min is to fix IE which reports 200% sometimes
					//file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					$scope.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			} else {
				ixStatusService.setResponse(response);
			}
		}, function(err){
			ixStatusService.setResponse(err);
		});
	};

	$scope.eliminarImagenPregunta = function(){
		$scope.pregunta.imagen = null;
	};


	var getNivel = function(){
		var nivel = 0;
		var defered = $q.defer();
    	var promise = defered.promise;
		var params = {Filters: [{Field: 'version', Value: $scope.pregunta.version, Operator: CMP_EQ},{Field: 'nivel1', Value: $scope.data.nivel1, Operator: CMP_EQ},{Field: 'nivel2', Value: $scope.data.nivel2 ? $scope.data.nivel2 : 0, Operator: CMP_EQ}, {Field: 'nivel3', Value: $scope.data.nivel3 ? $scope.data.nivel3 : 0, Operator: CMP_EQ }]};
		$http.post(cfg.baseURL + "ft_niveles/List",params).then(function(response){
			nivel = response.data[0].nivel;
			defered.resolve(nivel);
		}, function(error){
			defered.reject(error);
		});

    	return promise;
	}

	var setNiveles = function(nivel){
		$scope.data.nivel1 = nivel.nivel1;
		$scope.data.nivel2 = nivel.nivel2;
		$scope.data.nivel3 = nivel.nivel3;
	}

	$scope.$dismiss = function(){
		if($scope.isNew)
			$uibModalInstance.close();
		else
			$uibModalInstance.dismiss('cancel');
	}


}]);

angular.module("FTBase").controller("PrevisualizarPreguntaPopupController", [ "$scope", function($scope){
	$scope.status = { editing: true };
	$scope.preguntas = [ { pregunta: $scope.$resolve.pregunta } ];
}]);

(function(){
  'use strict';
  angular.module('FTBaseApp', [ 'gp4App', 'ngHandsontable' ]);
})();

/*global msal */
angular.module('gp4App').factory('msalAuthenticationService', ['$window','cfg', '$q','$log', function ($window, cfg, $q,$log) {
  
  var instance = null;

  return {
    getInstance: function() {
      if(instance) return instance;
      $log.log("Creating msalAuthenticationService with "+cfg.azure_ApplicationID + " "+cfg.azure_TenantID);
      var msalConfig = {
        auth: {
          clientId: cfg.azure_ApplicationID,
          authority: cfg.azure_TenantID,
          redirectUri: $window.location.origin
        }
      };
      instance = new msal.PublicClientApplication(msalConfig);         
      return instance;
    }
  };
}]);  
angular.module('gp4App').factory('mapStorageService', [ 'ixStatusService', function(ixStatusService){
	var mapStorageService = {};
	var _apps = {};

	mapStorageService.saveMap = function(mapID, data){
		var href_app_actual = ixStatusService.current.href;

		if(angular.isUndefined(_apps[href_app_actual])){
			_apps[href_app_actual] = {};
		}

		var app_actual = _apps[href_app_actual];
		app_actual[mapID] = data;
	}

	mapStorageService.restoreMap = function(mapID){
		var href_app_actual = ixStatusService.current.href;
		var app_actual = _apps[href_app_actual];

		var data = ((app_actual) ? app_actual[mapID] : undefined);

		return data;
	}

	return mapStorageService;
}]);

/*global L*/
angular.module('gp4App').factory('mapService', [ '$rootScope', 'leafletData', 'leafletBoundsHelpers', 'leafletDrawEvents', '$timeout', '$compile', 
	'mapMarkerIconService', 'MAPA_NUMERACIONES', 'ixUtilsService', 'mapStorageService', '$filter', function ($rootScope, leafletData, leafletBoundsHelpers, 
		leafletDrawEvents, $timeout, $compile, mapMarkerIconService, MAPA_NUMERACIONES, ixUtilsService, mapStorageService, $filter) {
	var mapServiceInstance = {

		// Opciones
		options: {},
		// Items a pintar
		drawnItems: new L.FeatureGroup(),
		// Numero de items
		drawItemsCount: function () {
			return this.drawItems.getLayers().length;
		},
		// Recoger items
		getDrawItems: function () {
			return this.drawItems.getLayers();
		},
		// Eventos de los poligonos
		getDrawEvents: function () {
			return leafletDrawEvents.getAvailableEvents()
		},
		// Monta capas
		getNewLayer: function (data) {
			var layer = {};
			if (data.layerType == 'polygon') {
				layer = L.polygon(data.latlngs);
			}
			if (data.layerType == 'rectangle') {

				layer = L.rectangle(data.latlngs);
			}
			return layer;
		},
		// Añade capas al mapa
		addLayerToMap: function (layer) {
			leafletData.getMap(this.options.id).then(function (map) {
				// Añadimos control de capas
				mapServiceInstance.drawnItems.addTo(map);
				var newLayer = mapServiceInstance.getNewLayer(layer);
				mapServiceInstance.drawnItems.addLayer(newLayer);
			});
		},
		addToolBar: function () {
			leafletData.getMap(this.options.id).then(function (map) {
				var newToolbar = L.Toolbar();
				toolbar.addToolbar(map);
			});
		},
		// Añade o borra la barra de herramientas
		setingToolBar: function (scope) {
			leafletData.getMap(this.options.id).then(function (map) {
				if (mapServiceInstance.options.readOnly) {
					if (mapServiceInstance.drawControl)
						map.removeControl(mapServiceInstance.drawControl);
				} else {
					mapServiceInstance.drawControl = new L.Control.Draw({
						draw: {
							polygon: {},
							rectangle: {},
							circle: false,
							marker: false,
							polyline: false
						},
						edit: {
							featureGroup: mapServiceInstance.drawnItems,
							remove: true
						}
					});

					var handle = {
						// Se crea capa
						created: function (leafletEvent) {
							if (!mapServiceInstance.drawnItems.hasLayer(leafletEvent.layer)) {
								//TODO: Hacer solo si no puede ser multi
								//mapServiceInstance.drawnItems = new L.FeatureGroup();
								mapServiceInstance.drawnItems.addLayer(leafletEvent.layer);

								scope.$emit("MapLayerToSave", {
									id: leafletEvent.layer._leaflet_id,
									layerType: leafletEvent.layerType,
									latlngs: leafletEvent.layer._latlngs
								});
							}

						},
						edited: function (leafletEvent) {
							var layers = leafletEvent.layers._layers;
							var layersIdx = Object.keys(layers);
							var layer = layers[layersIdx[0]];
							scope.$emit("MapLayerToUpdate", {
								id: layer._leaflet_id,
								layerType: layer.layerType,
								latlngs: layer._latlngs
							});
						},
						// Se borra capa
						deleted: function (leafletEvent) {
							scope.$emit("MapLayersToDelete", leafletEvent.layers._layers);
						},
						drawstart: function (arg) {},
						drawstop: function (arg) {},
						editstart: function (arg) {},
						editstop: function (arg) {},
						deletestart: function (arg) {},
						deletestop: function (arg) {}
					};

					map.on('draw:created', function (e) {
						handle['created'](e);
					});

					map.on('draw:edited', function (e) {
						handle['edited'](e);
					});

					map.on('draw:deleted', function (e) {
						handle['deleted'](e);
					});

					map.addControl(mapServiceInstance.drawControl);

				}
			});
		},

		// Inicializa el mapa
		initMap: function (scope, options) {
			var auxKeepCenter = angular.copy(this.options.keepCenter);

			this.options = options;

			var mapStored = mapStorageService.restoreMap(scope.id);
			if(angular.isDefined(mapStored))
				this.options.center = mapStored.center;

			if (angular.isDefined(auxKeepCenter))
				this.options.keepCenter = auxKeepCenter;

			angular.extend(scope, {
				center: this.options.center ? this.options.center : {},
				tiles: {
					url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
				},
				legend: {},
				layers: {},
				paths: {},
				events: {
					map: {
						enable: ['click', 'dragend', 'zoomend'],
						logic: 'emit'
					},
					path: {
						enable: ['click'],
						logic: 'emit'
					}
				}
			});
			this.options.center = scope.center;
			return angular.copy(this);
		},

		drawMap: function (scope, data) {
			var markers = this.buildMarkers(scope, data, mapServiceInstance);
			var legend = this.buildLegend(data);
			var paths;
			if(this.options.connect || scope.connect)
				paths = this.buildConnectPointsPaths(markers);

			if(scope.directions){
				var pathsDirections = this.buildDirectionsPaths(scope.directions);
				if(angular.isDefined(paths))
					paths = angular.merge(paths, pathsDirections);
				else
					paths = pathsDirections;
			}

			if(angular.isUndefined(paths))
				paths = [];

			if(angular.isDefined(legend))
				scope.legend = legend;

			angular.extend(scope, {
				markers: markers,
				paths: paths
			});
			return angular.copy(this);
		},

		buildLegend: function (data) {
			var mapServiceInstance = this;
			var legend;
			var colors = [];
			var labels = [];
			if (data) {

				//Llegenda pels orides_geo
				angular.forEach(data, function (dato) {
					if (dato.nivel) {
						if (dato.nivel == 1 && labels.indexOf('País') == -1) {
							colors.push('red');
							labels.push('País');
						}
						if (dato.nivel == 2 && labels.indexOf('Autonomía') == -1) {
							colors.push('green');
							labels.push('Autonomía');
						}
						if (dato.nivel == 3 && labels.indexOf('Provincia') == -1) {
							colors.push('orange');
							labels.push('Provincia');
						}
						if (dato.nivel == 4 && labels.indexOf('Población') == -1) {
							colors.push('purple');
							labels.push('Población');
						}
						if (dato.nivel == 5 && labels.indexOf('Punto entrega') == -1) {
							colors.push('cadetblue');
							labels.push('Punto entrega');
						}
					}
				});
				//Llegenda per les posicions dels camions
				data.forEach(function(item){
					var color;
					var label;
					if(item.class == "actualizacion-reciente"){
						color = 'green';
						label = "< " + mapServiceInstance.options.options.actualizacion_reciente  + " minutos";
					}
					else if(item.class == "actualizacion-intermedia"){
						color = 'orange';
						label = "< " + mapServiceInstance.options.options.actualizacion_intermedia  + " minutos";
					}
					else if(item.class == "actualizacion-antigua"){
						color = 'red';
						label = "> " + mapServiceInstance.options.options.actualizacion_intermedia  + " minutos";
					}
					if(angular.isDefined(color) && colors.indexOf(color) == -1){
						colors.push(color);
						labels.push(label);
					}
				});

				if(labels.length > 0 && colors.length > 0)
					legend = mapServiceInstance.setLegend(colors, labels);
			}

			return legend;
		},

		setLegend: function(colors, labels){
			var legend = {
				position: 'bottomleft',
				colors: colors,
				labels: labels
			};
			return legend;
		},

		/**
		 * Colores e iconos para el mapa
		 *
		 *	Property	Description	Default Value	Possible values
		 *	icon	Name of the icon	'home'	See glyphicons or font-awesome
		 *	prefix	Select de icon library	'glyphicon'	'fa' for font-awesome or 'glyphicon' for bootstrap 3
		 *	markerColor	Color of the marker	'blue'	'red', 'darkred', 'orange', 'green', 'darkgreen', 'blue', 'purple', 'darkpuple', 'cadetblue'
		 *	iconColor	Color of the icon	'white'	'white', 'black' or css code (hex, rgba etc)
		 *	spin	Make the icon spin	false	true or false. Font-awesome required
		 *	extraClasses	Additional classes in the created tag	''	'fa-rotate90 myclass' eller other custom configuration
		 *
		 **/
		loadIcons: function (tipo, punto, icono, color) {
			var icon = {};
			var iconFunction = mapMarkerIconService.getIconFunction(tipo);
			if(angular.isDefined(iconFunction)){
				var orden = (punto.orden_paso || punto.orden);
				icon = iconFunction(orden, punto.nivel);
				if(punto.nivel == 5)
					icon.className = "max-z-index";
			}
			else {
				icon = {
					type: 'awesomeMarker'
				};
				// Si viene informado el icono
				if (icono) {
					icon.icon = icono;
					// Si no viene informado y tiene fecha de validacion
				} else if (punto.fecha_validacion_geo) {
					icon.icon = 'check';
				} else icon.icon = 'asterisk';
				// Si viene informado el color
				if (color) {
					icon.markerColor = color;
				} else {

					switch (punto.nivel) {
						case 1: // Pais
							icon.markerColor = 'red';
							punto.tipo = ' (País)';
							break;
						case 2: // Comunidad
							icon.markerColor = 'green';
							punto.tipo = ' (Comunidad)';
							break;
						case 3: // Provincia
							icon.markerColor = 'orange';
							punto.tipo = ' (Provincia)';
							break;
						case 4: // Poblacion
							icon.markerColor = 'purple';
							punto.tipo = ' (Población)';
							break;
						case 5: // Punto entrega
							icon.markerColor = 'cadetblue';
							punto.tipo = ' (Punto entrega)';
							break;
						default: // Por defecto
							if(punto.tipo){
								if(punto.tipo.toString().toUpperCase() == "POSICION")
									icon.markerColor = 'blue';
								else if(punto.tipo.toString().toUpperCase() == "REVISION")
									icon.markerColor = 'green';
								else if(punto.tipo.toString().toUpperCase() == "INCIDENCIA")
									icon.markerColor = 'orange';
								else
									icon.markerColor = 'blue';
							} else {
								icon.markerColor = 'blue';
								punto.tipo = ' Sin datos';
							}
							break;
					}
				}
			}
			return icon;
		},

		getOrdenPasoPuntoEntrega: function(puntos, punto){
			var orden_paso = 0;
			var puntos_ordenados = [];
			var puntos_entrega = puntos.filter(function(e){ return (angular.isDefined(e.orides_pe)) && e.orides_pe && !e.esRotura; });
			puntos_entrega.forEach(function(punto){
				if(puntos_ordenados.indexOf(punto.punto_planificacion) == -1)
					puntos_ordenados.push(punto.punto_planificacion);
			});
			if(puntos_ordenados.length > 0){
				orden_paso = (puntos_ordenados.indexOf(punto.punto_planificacion) + 1);
			}
			return orden_paso;
		},

//		clearAnimatedMakers: function(map){
//
//			var layersId = Object.keys(map._layers);
//			for(var i = 0; i < layersId.length; i++){
//				var layer = map._layers[layersId[i]];
//				if(layer._durations)
//					delete map._layers[layersId[i]];
//			}
//		},

		animateMarkers: function(markers, conjuntoUbicaciones, inicio){
			//Obtenemos la primera y ultima fecha y hora informadas.
			var primeraFechaConocida;
			if(angular.isDefined(inicio))
				primeraFechaConocida = new Date(inicio);

			var ultimaFechaConocida = new Date();

			conjuntoUbicaciones.forEach(function(conjuntoUbicaciones){
				conjuntoUbicaciones.posiciones.forEach(function(posicion){
					if((angular.isUndefined(primeraFechaConocida)) || posicion.fecha_hora < primeraFechaConocida)
						primeraFechaConocida = posicion.fecha_hora;

					if((angular.isUndefined(ultimaFechaConocida)) || posicion.fecha_hora > ultimaFechaConocida)
						ultimaFechaConocida = posicion.fecha_hora;
				});
			});

			//Creamos una lista de posiciones entre los datos que nos llegan y los tiempos que tenemos que rellenar.
			conjuntoUbicaciones.forEach(function(conjuntoUbicaciones){
				var id = conjuntoUbicaciones.conjunto.conjunto;
				var marker = markers.find(function(e){ return e.id == id; });
				if(angular.isDefined(marker)){
					var posicionesConocidas = conjuntoUbicaciones.posiciones;
					marker.animaciones = [];
					if(posicionesConocidas.length > 0){
						var primeraPosicionConocida = posicionesConocidas[0];

						var period = 1000*60*10;//diez minutos

						var fechasInicialesFaltantes = ixUtilsService.getTicksBetweenDates(primeraFechaConocida, primeraPosicionConocida.fecha_hora, period);
						var periodosDesconocidosIniciales = [];

						fechasInicialesFaltantes.forEach(function(fecha_inicial){
							var inicial = {};
							inicial.conjunto = primeraPosicionConocida.conjunto;
							inicial.fecha_hora = fecha_inicial;
							inicial.geolocalizador = primeraPosicionConocida.geolocalizador;
							inicial.latitud = primeraPosicionConocida.latitud;
							inicial.longitud = primeraPosicionConocida.longitud;
							inicial.pais = primeraPosicionConocida.pais;
							inicial.poblacion = primeraPosicionConocida.poblacion;

							periodosDesconocidosIniciales.push(inicial);
						});

						var ultimaPosicionConocida = posicionesConocidas[(posicionesConocidas.length-1)];
						var fechasFinalesFaltantes = ixUtilsService.getTicksBetweenDates(ultimaPosicionConocida.fecha_hora, ultimaFechaConocida, period);
						var periodosDesconocidosFinales = [];

						fechasFinalesFaltantes.forEach(function(fecha_final){
							var final = {};
							final.conjunto = ultimaPosicionConocida.conjunto;
							final.fecha_hora = fecha_final;
							final.geolocalizador = ultimaPosicionConocida.geolocalizador;
							final.latitud = ultimaPosicionConocida.latitud;
							final.longitud = ultimaPosicionConocida.longitud;
							final.pais = ultimaPosicionConocida.pais;
							final.poblacion = ultimaPosicionConocida.poblacion;

							periodosDesconocidosFinales.push(final);
						});

						marker.animaciones = [];
						marker.animaciones.push.apply(marker.animaciones, periodosDesconocidosIniciales);
						marker.animaciones.push.apply(marker.animaciones, posicionesConocidas);
						marker.animaciones.push.apply(marker.animaciones, periodosDesconocidosFinales);
					}
				}
			});

//			conjuntoUbicaciones.forEach(function(conjuntoUbicaciones){
//				var id = conjuntoUbicaciones.conjunto.conjunto;
//				var marker = markers.find(function(e){ return e.id == id; });
//				if(angular.isDefined(marker)){
//					marker.animaciones = conjuntoUbicaciones.posiciones;
//				}
//			});
			var auxMarkers = angular.copy(markers);

			markers = auxMarkers;
			return markers;
		},

//		inanimateMarkers: function(markers){
//			markers.forEach(function(e){ delete e.animaciones; });
//			var auxMarkers = angular.copy(markers);
//			markers = auxMarkers;
//			return markers;
//		},

		buildMarkers: function (scope, puntos, instance) {
			var mapServiceInstance = this;
			if(angular.isDefined(instance))
				mapServiceInstance.options.duration = instance.options.duration;

			var markers = {};
			var centerPosition = mapServiceInstance.getCenterPosition(scope);
			if (mapServiceInstance.options.connect || scope.connect || scope.directions) {
				angular.forEach(puntos, function (punto, index) {

					if (punto[mapServiceInstance.options.lat] || punto[mapServiceInstance.options.lng]) {

						if(punto.nivel == 5)
							punto.orden_paso = mapServiceInstance.getOrdenPasoPuntoEntrega(puntos, punto);

						var markerId = punto[mapServiceInstance.options.pk]+"";
						markerId = markerId.replace("-","N");
						var marker = {
							id: markerId,
							lat: punto[mapServiceInstance.options.lat],
							lng: punto[mapServiceInstance.options.lng],
							message: punto[mapServiceInstance.options.markerText] || punto.origen,
							nivel: punto.nivel,
							getMessageScope: function () {
								return scope;
							},
							draggable: false,
							icon: punto.icon || mapServiceInstance.loadIcons(mapServiceInstance.options.markerType, punto, null, null)
						};

						if (mapServiceInstance.options.template) {
							marker.message = "<div ng-include src=\"'" + mapServiceInstance.options.template + "'\"></div>";
						}
						//markers[marker.id + "" + index] = marker;
						markers[index] = marker;
					}
				});
			} else {
				leafletData.getMap(scope.id).then(function (map) {
					angular.forEach(puntos, function (punto, index) {

							if((!punto.animaciones) || ((punto.animaciones) && punto.animaciones.length == 1)){

								if(punto.nivel == 5)
									punto.orden_paso = mapServiceInstance.getOrdenPasoPuntoEntrega(puntos, punto);

								var markerId = punto[mapServiceInstance.options.pk]+"";
								markerId = markerId.replace("-","N");
								var marker = {
									id: markerId,
									lat: punto[mapServiceInstance.options.lat],
									lng: punto[mapServiceInstance.options.lng],
									message: punto.nombre,
									nivel: punto.nivel,
									getMessageScope: function () {
										return scope;
									},
									draggable: (mapServiceInstance.options.draggable && !mapServiceInstance.options.readOnly),
									icon: punto.icon || mapServiceInstance.loadIcons(mapServiceInstance.options.markerType, punto, null, null)
								};

								// Si vienen vacios
								if (!marker.lat && !marker.lng) {
									if (centerPosition) {
										marker.lat = centerPosition.lat;
										marker.lng = centerPosition.lng;
									} else {
										marker.lat = 0.00;
										marker.lng = 0.00;
									}
								}

								if (mapServiceInstance.options.template) {
									marker.message = "<div ng-include src=\"'" + mapServiceInstance.options.template + "'\"></div>";
								}
								//markers[marker.id] = marker;
								markers[index] = marker;
							} else {
								var ubicacionesGeo = punto.animaciones.map(function(e){ return [ e.latitud, e.longitud]; });

								var duracionAnimacionPuntos = (mapServiceInstance.options.duration || 20000);

								var myIcon = L.divIcon({className: 'leaflet-div-icon'});
								angular.merge(myIcon.options, punto.icon);

								var optionsMovingMarker = { id: punto.id, icon: myIcon, loop: true };

								var myMovingMarker = L.Marker.movingMarker(ubicacionesGeo, duracionAnimacionPuntos, optionsMovingMarker).addTo(map).on('click', function(e) {
									$rootScope.$broadcast("MarkerClicked", e.target.options);
								});
								myMovingMarker.start();

							}
						});
				});
			}
			return markers;
		},

		getCenterPosition: function (scope) {
			var centerPosition = {
				lat: 0,
				lng: 0
			};

			if(!this.options.boundsMap){
				var objInstance = this;

				leafletData.getMap(scope.id).then(function (map) {
					centerPosition.lat = map.getBounds().getCenter().lat;
					centerPosition.lng = map.getBounds().getCenter().lng;
					centerPosition.zoom = map.getZoom();
				});
			}

			return centerPosition;
		},

		keepCenter: function (value) {
			mapServiceInstance.options.keepCenter = value;
		},

		setCenterAndCalcZoom: function (scope) {
			var objInstance = this;
			if(!this.options.boundsMap){
				$timeout(function () {
					leafletData.getMap(scope.id).then(function (map) {
						map.invalidateSize();
						var markersArray = [];
						var layers = objInstance.drawnItems.getLayers();

						if (layers.length > 0) {
							angular.forEach(layers, function (layer) {
								markersArray.push(layer.getBounds());
							});
						}

						angular.forEach(scope.markers, function (marker) {
							markersArray.push(marker);
						});


						if (markersArray.length > 0) {
							map.fitBounds(markersArray);
							scope.center = mapServiceInstance.getCenterPosition(scope);
							mapServiceInstance.options.center = scope.center;
							mapStorageService.saveMap(scope.id, { center: scope.center });
						}


					});
				}, 0);
			} else {
				leafletData.getMap(scope.id).then(function(map) {
					var bounds = L.latLngBounds([ scope.boundsMap.northEast.lat, scope.boundsMap.northEast.lng ], [ scope.boundsMap.southWest.lat, scope.boundsMap.southWest.lng ]);
        	map.fitBounds(bounds);
					mapStorageService.saveMap(scope.id, { center: scope.center });
				});
			}
		},

		buildBounds: function(LatLngSuroeste, LatLngNoreste){
			var bounds = leafletBoundsHelpers.createBoundsFromArray([
				[ LatLngSuroeste.lat, LatLngSuroeste.lng ],
				[ LatLngNoreste.lat, LatLngNoreste.lng ]
			]);
			return bounds;
		},

		changeReadOnly: function (scope) {
			angular.forEach(scope.markers, function (marker) {
				marker.draggable = (mapServiceInstance.options.draggable && !mapServiceInstance.options.readOnly);
			});
		},

		//No acaba de refrescar el mapa, esta al MapaController ja que s'ha de posar un flag a false i despres a true i un ng-if al template.
		/*
		refreshMap: function(scope){
			var that = this;
			leafletData.getMap().then(function(map) {
        $timeout(function() {
					map.invalidateSize();
					that.setCenterAndCalcZoom(scope);
        }, 200);
    	});
		},
		*/

		buildConnectPointsPaths: function (markers) {
			var paths = {
				p1: {
					color: '#2b81cb',
					weight: 2,
					latlngs: []
				}
			};

			angular.forEach(markers, function (marker) {
				if(angular.isDefined(mapServiceInstance.options.connectConditionFunction)){
					if(mapServiceInstance.options.connectConditionFunction(marker))
						paths.p1.latlngs.push({ lat: marker.lat, lng: marker.lng });
				} else
					paths.p1.latlngs.push({ lat: marker.lat, lng: marker.lng });
			});
			return paths
		},

		buildDirectionsPaths: function (legs) {
			var paths = {};
			for(var i = 0; i < legs.length; i++){
				var leg = legs[i];
				paths["p_r"+i] = {
					//TODO: Haurem de fer que si el viatge ve donat d'API, el color sigui blau.
					//color: '#F6C700',
					color: '#32CD32',
					weight: 4,
					latlngs: []
				};
				var directions = leg.polyline.plain.polyline;
				angular.forEach(directions, function (direction) {
					paths["p_r"+i].latlngs.push({ lat: direction.y, lng: direction.x });
				});
				var inicio = leg.startWaypointName;
				var fin = leg.endWaypointName;

				inicio = inicio.substring(0, inicio.lastIndexOf("@"));
				fin = fin.substring(0, fin.lastIndexOf("@"));

				var metros = leg.distance;
				var kms = parseInt((metros / 1000));
				var distanciaText = "";
				if(kms == 0)
					distanciaText = metros + " m";
				else
					distanciaText = kms + " kms";

				paths["p_r"+i].message = "<h6><b>" + (i+1) + ") " + inicio +  " - " + fin + "</b></h6><p style='margin:0;'>Distancia: " + distanciaText + "<br/>Duración: " + ixUtilsService.segundosAHorasYMinutos(leg.travelTime) + " h</p>";
			}
			return paths;
		},

		getRandomColor: function() {
			var letters = '0123456789ABCDEF';
			var color = '#';
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}
			return color;
		}
	}
	return mapServiceInstance;
}]);

angular.module('gp4App').factory('mapMarkerIconService', [ 'leafletData', 'leafletBoundsHelpers', '$timeout', 'MAPA_NUMERACIONES', 'MAPA_PDI', 'MAPA_POSICIONES_REALES', function(leafletData, leafletBoundsHelpers, $timeout, MAPA_NUMERACIONES, MAPA_PDI, MAPA_POSICIONES_REALES){
	var iconNumeracionDefault = {
		type: 'div',
		iconSize: [25, 41],
		popupAnchor:  [0, 0],
		html: '<div class="icon-numerado"><img src="data:image/png;base64,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" class="leaflet-marker-icon leaflet-zoom-animated leaflet-clickable" /><span class="numeracion">[numeracion]</span></div>'
	};

	var iconNumeracionPais = {
		type: 'div',
		iconSize: [25, 41],
		popupAnchor:  [0, 0],
		html: '<div class="icon-numerado awesome-marker-icon-red awesome-marker leaflet-zoom-animated leaflet-clickable"><i class=" glyphicon glyphicon-asterisk  icon-white"></i><span class="numeracion">[numeracion]</span></div>'
	};

	var iconNumeracionAutonomia = {
		type: 'div',
		iconSize: [25, 41],
		popupAnchor:  [0, 0],
		html: '<div class="icon-numerado awesome-marker-icon-green awesome-marker leaflet-zoom-animated leaflet-clickable"><i class=" glyphicon glyphicon-asterisk  icon-white"></i><span class="numeracion">[numeracion]</span></div>'
	};

	var iconNumeracionProvincia = {
		type: 'div',
		iconSize: [25, 41],
		popupAnchor:  [0, 0],
		html: '<div class="icon-numerado awesome-marker-icon-orange awesome-marker leaflet-zoom-animated leaflet-clickable"><i class=" glyphicon glyphicon-asterisk  icon-white"></i><span class="numeracion">[numeracion]</span></div>'
	};

	var iconNumeracionPoblacion = {
		type: 'div',
		iconSize: [25, 41],
		popupAnchor:  [0, 0],
		html: '<div class="icon-numerado awesome-marker-icon-purple awesome-marker leaflet-zoom-animated leaflet-clickable"><i class=" glyphicon glyphicon-asterisk  icon-white"></i><span class="numeracion">[numeracion]</span></div>'
	};

	var iconNumeracionPuntoEntrega = {
		type: 'div',
		iconSize: [25, 41],
		popupAnchor:  [0, 0],
		html: '<div class="icon-numerado awesome-marker-icon-cadetblue awesome-marker leaflet-zoom-animated leaflet-clickable"><i class=" glyphicon glyphicon-asterisk  icon-white"></i><span class="numeracion">[numeracion]</span></div>'
	};

	var iconCamionesVehiculos = {
		type: 'div',
		popupAnchor:  [0, 0],
		html: '<span title="Camiones" class="marker-box camiones [extraClassesCamiones]"><i class="fa fa-truck" aria-hidden="true" style="position:absolute;display:contents;"></i>[cantidadCamiones]</span><span title="Vehículos" class="marker-box vehiculos [extraClassesVehiculos]"><i class="fa fa-car" aria-hidden="true" style="position:absolute;display:contents;"></i>[cantidadVehiculos]</span>'
	};

	var iconPosicionRealCamion = {
		type: 'div',
		popupAnchor:  [0, 0],
		html: '<span title="Camión" class="marker-box posicion_real_camion"><i class="fa fa-truck" aria-hidden="true"></i></span><span style="display: table; background: white; white-space: nowrap; font-size: 10px;margin-top: -3px;margin-left: -2px;">[codigoCamion]</span>'
	};


	var buildIconsNumeracion = function(orden, nivel){
		var icon;
		switch(nivel){
			case 1:
				icon = angular.copy(iconNumeracionPais);
				break;
			case 2:
				icon = angular.copy(iconNumeracionAutonomia);
				break;
			case 3:
				icon = angular.copy(iconNumeracionProvincia);
				break;
			case 4:
				icon = angular.copy(iconNumeracionPoblacion);
				break;
			case 5:
				icon = angular.copy(iconNumeracionPuntoEntrega);
				break;
			default:
				icon = angular.copy(iconNumeracionDefault);
				break;
		}

		if(angular.isUndefined(orden))
			orden = "";

		icon.html = icon.html.replace("[numeracion]", orden);
		return icon;
	};

	var buildIconsPDI = function(cantidadCamiones, cantidadVehiculos, isSelected){
		var icon = angular.copy(iconCamionesVehiculos);
		icon.html = icon.html.replace("[cantidadCamiones]", cantidadCamiones);
		icon.html = icon.html.replace("[cantidadVehiculos]", cantidadVehiculos);

		var extraClasses = "";
		if(isSelected)
			extraClasses += "selected";

		icon.html = icon.html.replace("[extraClassesCamiones]", extraClasses);
		icon.html = icon.html.replace("[extraClassesVehiculos]", extraClasses);
		return icon;
	};

	var buildIconsPosicionRealCamion = function(codigoCamion){
		var icon = angular.copy(iconPosicionRealCamion);
		icon.html = icon.html.replace("[codigoCamion]", codigoCamion);
		return icon;
	};

	var mapMarkerIconService = {
		getIconFunction: function(tipo){
			if(tipo == MAPA_NUMERACIONES){
				return buildIconsNumeracion;
			} else if(tipo == MAPA_PDI){
				return buildIconsPDI;
			} else if(tipo == MAPA_POSICIONES_REALES)
				return buildIconsPosicionRealCamion;
			else
				return undefined;
		}
	};
	return mapMarkerIconService;

}]);


angular.module('gp4App').factory('ixWarningsService', ['$rootScope', '$location','cfg','authService','$http', 'uiGridConstants', '$timeout', 'ixLockedViewService', '$log', '$window', '$ngConfirm', function ($rootScope, $location, cfg, authService, $http, uiGridConstants, $timeout, ixLockedViewService, $log, $window, $ngConfirm) {
	var serviceInstance = {

    warningConfirmacion : function(scope,frase,accionOk,accionCancelar,paramsAccion){
      $ngConfirm({
  			icon: 'fa fa-warning',
  			title: 'Aviso',
  			content: frase,
  			scope: scope,
  			closeIcon: false,
  			buttons: {
  				ok: {
  					text: "Continuar",
  					btnClass: 'btn-ix-green',
  					show: 'true',
  					keys: ['enter'], // will trigger when enter is pressed
  					action: function(scope){
              if(angular.isDefined(accionOk))
					      accionOk(paramsAccion);
  						return true;
  					}
  				},
          cancelar: {
            text: "Cancelar",
  					btnClass: 'btn-ix-green',
  					show: 'true',
  					action: function(scope){
              if(angular.isDefined(accionCancelar))
					      accionCancelar();
  						return true;
  					}
          }
  			}
  		});
    }

	};

	return serviceInstance;
}]);

/*eslint angular/json-functions: 0*/
/*global addDateDeriveds*/
/*global addDateSorters*/
/*global saveAs*/
/*global CMP_EQ*/
/*global CMP_GTE*/
/*global CMP_LT*/
/*global CMP_LIKEL*/
angular.module("gp4App").factory("ixUtilsService", [ 'cfg', '$filter', '$translate', 'gridUtil', '$http', '$sce', '$window', '$uibModal', '$timeout', 'moment', 'configuracionesCacheService', function(cfg, $filter, $translate, gridUtil, $http, $sce, $window, $uibModal, $timeout, moment, configuracionesCacheService){

	var service = {};

	service.drawPivot = function(tagId, data, pivotOptionsOverride, colDefs){
    var renderers = $.pivotUtilities;
    var pivotData = data;
    var pivotOptionsDefault = {
      rows: [],
      cols: [],
      renderers : $.extend($.pivotUtilities.renderers,$.pivotUtilities.d3_renderers,$.pivotUtilities.c3_renderers, $.pivotUtilities.export_renderers, $.pivotUtilities.derivers),
      rendererName: "Table",
	  onRefresh: function(config) {
		// Aquesta funcio copia l'estat del pivottable al pivotOptionsOverride que hem rebut com a parametre, de forma que si es torna a generar el pivot
		// amb el mateix objecte de configuració, mandindrà l'estat. La idea és que es que també es pugui guardar junt amb la configuració del grid.
		var keys = ["rows","cols","vals","aggregatorName","rendererName"];
		keys.forEach(function(k) {
    		pivotOptionsOverride[k] = JSON.parse(JSON.stringify(config[k]));
  		});
	  }
    };
    var pivotOptions = angular.merge(pivotOptionsDefault, pivotOptionsOverride);

		var propertyNamesWithTranslation = [];

		if(angular.isDefined(colDefs)){
			//Agafar del displayName de la metadata.
			if(angular.isDefined(pivotData) && pivotData[0]){
				propertyNamesWithTranslation = getPropertyNames(pivotData[0], colDefs);

				translateObjsProperties(pivotData, propertyNamesWithTranslation);

				translateStrings(pivotOptions.rows, propertyNamesWithTranslation);
				translateStrings(pivotOptions.cols, propertyNamesWithTranslation);
				translateStrings(pivotOptions.vals, propertyNamesWithTranslation);
				translateStrings(pivotOptions.hiddenAttributes, propertyNamesWithTranslation);
				translateStrings(pivotOptions.hiddenFromAggregators, propertyNamesWithTranslation);
				translateStrings(pivotOptions.hiddenFromDragDrop, propertyNamesWithTranslation);
			}

		} else {
			//Traducció de totes les propietats de la pivot.

			if(angular.isDefined(pivotData) && pivotData[0]){
				propertyNamesWithTranslation = getPropertyNames(pivotData[0]);
				translateObjsProperties(pivotData, propertyNamesWithTranslation);

				translateStrings(pivotOptions.rows, propertyNamesWithTranslation);
				translateStrings(pivotOptions.cols, propertyNamesWithTranslation);

				if(pivotOptions.vals)
					translateStrings(pivotOptions.vals, propertyNamesWithTranslation);
			}
		}

		if(angular.isDefined(cfg.momentDateFormat)){
			pivotOptions.sorters = function(attr){
				return addDateSorters(moment, cfg, pivotData, attr);
			};
		}

		if(!pivotOptions.derivedAttributes)
			pivotOptions.derivedAttributes = addDateDeriveds(cfg, $filter, $.pivotUtilities.derivers, pivotData);

    angular.element(tagId).pivotUI(pivotData, pivotOptions, true, "es");
  };
	
	service.downloadPDF = function(file, filename) {
		this.checkPermission("OpenPdfNewTab").then(function(result){
    	if(result) {
				var objectUrl = URL.createObjectURL(file);
				$window.open($sce.trustAsResourceUrl(objectUrl), "_blank");
			}
			else {			
				saveAs(file, filename);
			}
		}, function(err) {
			saveAs(file, filename);
		});
	};
	
	service.openModalV2 = function(template, options, size, params) {
		var defaultOptions = {
			templateUrl: template,
			size: size || 'lg',
			backdrop: 'static',
			keyboard: false
		};
		if(angular.isDefined(options.scope)){
			defaultOptions.scope = options.scope;
			delete options.scope;
		}

		if(angular.isDefined(params)){
			if(angular.isUndefined(defaultOptions.resolve)){
				defaultOptions.resolve = {};
			}
			angular.forEach(params, function(value, key){
				defaultOptions.resolve[key] = function(){ return value; };
			});
		}

		angular.merge(defaultOptions, options);
		if(options.appendTo)
			defaultOptions.appendTo = options.appendTo;
	if (options.returnInstance)							
	return $uibModal.open(defaultOptions);
	else
			return $uibModal.open(defaultOptions).result;      
	};

	function getPropertyNames(item, colDefs){
		var propertyNamesWithTranslation = [];
		angular.forEach(Object.keys(item), function(prop){
			if(angular.isDefined(colDefs)){
				var displayGridName = colDefs.find(function(e){ return e.field == prop; });
				if(displayGridName){
					propertyNamesWithTranslation.push({ original: prop, translated: displayGridName.displayName });
				} else {
					propertyNamesWithTranslation.push({ original: prop, translated: gridUtil.readableColumnName(prop) });
				}
			} else {
				propertyNamesWithTranslation.push({ original: prop, translated: $translate.instant(gridUtil.readableColumnName(prop)) });
			}
		});
		return propertyNamesWithTranslation;
	}

	function translateObjsProperties(collection, translations){
		angular.forEach(collection, function(item){
			angular.forEach(translations, function(translation){
				if(translation.translated != translation.original){
					if(item[translation.translated]){
						translation.translated = getUniqueName(item, translation.translated, 1);
					}
					item[translation.translated] = item[translation.original];
					delete item[translation.original];
				}
			});
		});
	}

	function getUniqueName(item, translation, attempt){
		var unique_translation = (translation + attempt);
		if(item[unique_translation]!=null && angular.isDefined(item[unique_translation])){
			getUniqueName(item, translation, attempt++);
		}
		return unique_translation;
	}

	function translateStrings(collection, translations){
		if(!collection) return;
		for(var i = 0; i < collection.length; i++){
			var translation = translations.find(function(e){ return e.original == collection[i]; });
			if(translation)
				collection[i] = translation.translated;
		}
	}

	service.checkPermission = function(etiqueta){
		// return $http.get(cfg.baseURL + "configuraciones/GetConfig/" + etiqueta).then(function(response){
		// 	return response.data;
		// });
		return configuracionesCacheService.get(etiqueta);
	};

	service.checkMultiplePermission = function(etiquetas){
		// return $http.post(cfg.baseURL + "configuraciones/GetConfigMultiple/", etiquetas).then(function(response){
		// 	return response.data;
		// });
		return configuracionesCacheService.get(etiquetas);
	};

	service.toJson = function(data, objPropertiesMap){
		var notEmpties = service.skipEmptyObjects(data);
		if(angular.isDefined(objPropertiesMap)){
			service.renameObjectKeys(notEmpties, objPropertiesMap);
		}
		var jsonData = JSON.stringify(notEmpties, function(key, val){
			if(key == "modifiedValues" || key == "$$hashKey" || key == "isNew" || key == "estaSeleccionado") return undefined;
			if(angular.isString(val))
				return val.trim();
			else
				return val;
		});
		return jsonData;
	};

	service.renameObjectKeys = function(src, map){
		if(angular.isArray(src)){
			for(var i = 0; i < src.length; i++){
				src[i] = service.renameObjectKeys(src[i], map);
			}
		} else {
			var dst = {};
	    // src --> dst (copy)
	    for(var key in src){
	        if(key in map)
	            // rename key
	            dst[map[key]] = src[key];
	        else
	            // same key
	            dst[key] = src[key];
	    }
	    return dst;
		}
	};

	service.skipEmptyObjects = function(data){
		data = data.filter(function(e){
			return service.isNotEmptyObject(e);
		});
		return data;
	};

	service.isNotEmptyObject = function(e){
		return (!angular.isObject(e) || (angular.isArray(e) && !allPropertiesNull(e)) || (Object.keys(e).length > 0 && !allPropertiesNull(e)));
	};

	function allPropertiesNull(obj){
		var countNulls = 0;
		angular.forEach(obj, function(val, key){
			if(!val) countNulls++;
		});
		return (Object.keys(obj).length == countNulls);
	}

	service.fromJson = function(data){
		return angular.fromJson(data);
	};

	service.showGrid = function(grid){
		if(angular.isDefined(grid.ixRestoreConfig))
			grid.ixRestoreConfig();
		$timeout(function(){
			if((angular.isDefined(grid)) && angular.isDefined(grid.gridApi))
				grid.gridApi.core.handleWindowResize();
				//grid.gridApi.core.scrollTo(grid.data[0], grid.columnDefs[0]);
		},200);
	};

	service.ixGetPatchOperations = function(originalObj, newObj){
		var data = [];
		if(Object.keys(originalObj).length > 0){
			angular.forEach(originalObj, function(valor, clave){
				if(angular.isDefined(newObj[clave]) && originalObj[clave] != newObj[clave] &&
					 (!angular.isObject(newObj[clave]) ||
						(angular.isDate(newObj[clave]) && !angular.equals(originalObj[clave], newObj[clave])) ||
						(angular.isArray(newObj[clave]) && !angular.equals(originalObj[clave], newObj[clave]) &&
						 //chapuza perque no hi hagi problemes al editar un llistat programat.
						 clave != "mailto" && clave != "mailcc")
					 )
					){
					data.push({
						value: newObj[clave],
						path: "/" + clave,
						op: "replace"
					});
				}
			});
		} else {
			angular.forEach(newObj, function(valor, clave){
				data.push({
					value: newObj[clave],
					path: "/" + clave,
					op: "replace"
				});
			});
		}

		return data;
	};

	service.ixFiltersToArray = function(filtersArray, entity, fieldsToSkip){
		var param = [];
		var paramValue;
		var filter;
		angular.forEach(filtersArray, function(value, key){
			var i = 0;
			if(angular.isObject(value) && Object.keys(value).length > 0){
				var notNullValues = Object.keys(value).filter(function(e){ return angular.isDefined(value[e]) && value[e] != null && value[e] != ""; }).map(function(a){ return { value: value[a], first: (a == 0) }; });
				while(i < notNullValues.length) {
					paramValue = notNullValues[i].value;

					if(angular.isUndefined(entity)){
						filter = { Field: key, Value: paramValue };
					} else {
						filter = { Field: entity+"."+key, Value: paramValue };
					}

					//obrim parentesis
					if(i == 0){
						filter.StartPar = true;
					} else if(i < (notNullValues.length) && !angular.isDate(paramValue)){//si hi ha múltiples i no són dates anem possant OR
						filter.Or = true;
					}

					if(angular.isDate(paramValue)){
						if(i == 0 && notNullValues[i].first){
							filter.Value = $filter("date")(filter.Value, "yyyy-MM-dd");
							filter.Operator = CMP_GTE;
						} else {
							var now = $filter("date")(filter.Value, "yyyy-MM-dd");
							var partsDate = now.split("-");
							var dateMax = new Date(parseInt(partsDate[0]), (parseInt(partsDate[1]) - 1), parseInt(partsDate[2]));
							//li sumem 1 dia perque els datetime que inclouen el temps també apareguin.
							dateMax.setDate(dateMax.getDate() + 1);
							filter.Value = $filter("date")(dateMax, "yyyy-MM-dd");
							filter.Operator = CMP_LT;
						}
					} else {
						filter.Operator = CMP_EQ;
					}

					if(i == (notNullValues.length - 1)){
						filter.EndPar = true;
					}
					if(angular.isDefined(fieldsToSkip) && (fieldsToSkip.indexOf(key) != -1 || fieldsToSkip == "*")) filter.skip = true;
					param.push(filter);
					i++;
				}
			} else {
				paramValue = value;

				if(angular.isUndefined(entity)){
					filter = { Field: key };
				} else {
					filter = { Field: entity+"."+key };
				}
				if(angular.isDate(paramValue)){
					filter.Value = $filter("date")(paramValue, "yyyy-MM-dd");
				} else {
					filter.Value = paramValue;
				}
				filter.Operator = CMP_EQ;
				if(angular.isDefined(filter.Value) && filter.Value != null && filter.Value !== "" && ( (!angular.isArray(filter.Value) ) || (angular.isArray(filter.Value) && filter.Value.length > 0) ) ){
					if(angular.isDefined(fieldsToSkip) && (fieldsToSkip.indexOf(key) != -1 || fieldsToSkip == "*")) filter.skip = true;
					param.push(filter);
				}
			}
		});
		return param;
	};


	//Si ens trobem que hi ha algun problema al enviar una data per query string a la API quan el format de la data està en un format diferent al espanyol dd/MM/yyyy es farà servir
	//aquesta funció. Exemple: fecha="+ixStatusService.dateEncoder($scope.data.fecha)+".....".
	service.dateEncoder = function(d){
		var z = function (n) { return (n < 10 ? '0' : '') + n; };
  	var off = d.getTimezoneOffset();
  	var sign = off < 0? '+' : '-';
  	off = Math.abs(off);

  	return encodeURIComponent(d.getFullYear() + '-' + z(d.getMonth()+1) + '-' +
															z(d.getDate()) + 'T' + z(d.getHours()) + ':'  + z(d.getMinutes()) +
															':' + z(d.getSeconds()) + sign + z(off/60|0) + z(off%60));
	};
	
	service.openDialogNotification = function(tipo, grupo, title, text, operario) {
		var template = "app/base/views/notification_pda_popup.html";	
		var options = { controller: "NotificationPdaPopupController" };
		var params = { notif_type: tipo, grupo: grupo, title: title, text: text, operario: operario };			
		service.openModalV2(template, options, "small", params);    
	};

	service.getCestaFilters = function(param, cesta, metadata, skip){
		var items = cesta.items;
		var terminacion = cesta.terminacion;
		var excluir = cesta.excluir;
		var cortar = cesta.cortar;
		var campo = cesta.campo;

		var numItems = items.length;

		for(var i = 0; i < items.length; i++){
			var newparam = {Field: service.getNameFromConfig(campo, cfg), Value: items[i] };

			if(cortar>0 && newparam.Value.length>cortar) {
				newparam.Value = newparam.Value.slice(-cortar)
			}

			if(campo == "chasis" && terminacion == 1){
				newparam.Operator = CMP_LIKEL;
				newparam.Field = "chasisr";
				newparam.Value = $filter("reverse")(newparam.Value);
			} else {
				newparam.Operator = CMP_EQ;
			}

			if(excluir == 1)
				newparam.Not = true;

			//Busquem el param a la metadata per aplicar el TableAliasName si aquest ve.
			if(angular.isDefined(metadata) && metadata != null){
				var attrMetadata = metadata.find(function(e){ return e.Name.toUpperCase() == newparam.Field.toUpperCase() });
				if(angular.isDefined(attrMetadata) && attrMetadata.TableAliasName){
					newparam.Field = attrMetadata.TableAliasName + "." + newparam.Field;
				}
			}

			if(i == 0 && i != numItems - 1){
				newparam.StartPar = true;
			}
			else if(i == numItems - 1 && i > 0){
				newparam.EndPar = true;
				if(newparam.Not != true)
					newparam.Or = true;
			}
			else if(i > 0){
				if(newparam.Not != true)
					newparam.Or = true;
			}
			if(angular.isDefined(skip) && skip){
				newparam.skip = true;
			}

			newparam.Cesta = true;
			newparam.Value = newparam.Value.trim();
			param.Filters.push(newparam);
		}
		return param.Filters;
	};

	/**
	 * Busca la existencia de 'search' en 'cadena' sin tener en cuenta mayúsculas ni acentos (accent folding)
	 * la funcion normalize("NFD") separa los acentos de su vocal, i el replace(/[\u0300-\u036f]/g,"") elimina cualquier cosa que no sea un 'char'
	 * @param {string} cadena cadena en la que buscar
	 * @param {string} search valor a buscar en cadena
	 * @returns cadena.indexOf(search) sin tener en cuenta mayúsculas ni acentos
	 */
	 service.comparar =  function(cadena,search) {
		if(!cadena) return -1;
		if(!search) return 0;
		return cadena.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").indexOf(search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,""));
	}


	service.getNameFromConfig = function(field, cfg){
		if(field == "chasis")
			return cfg.cestaFilterBy;
		else
			return field;
	};

	service.getNameColumnaInventadaAsociada = function(field){
		return field + "_hora_fend";
	};

	service.getMoreImportantResponse = function(responses){
		var moreImportant;
		responses.forEach(function(response){
			if(!moreImportant)
				moreImportant = response;
			else if(moreImportant.data.GlobalMessage.ErrType < response.data.GlobalMessage.ErrType)
				moreImportant = response;
		});
		return moreImportant;
	};

	service.segundosAHorasYMinutos = function(segundos){
		var h = Math.floor(segundos / 3600);
		var m = Math.floor(segundos % 3600 / 60);

		var hDisplay = ((h > 0) ? h : "00:");
		var mDisplay = ((m > 0) ? ((h > 0) ? ":" : "") + ((m < 10) ? "0" + m : m) : "");
		return hDisplay + mDisplay;
	};

	service.getTicksBetweenDates = function(d1, d2, period){
		for (var d=[],ms=d1*1,last=d2*1;ms<last;ms+=period){
			d.push(new Date(ms));
		}
		return d;
	};

	return service;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
/*global convertDateStringsToDates */
/*global ACCION_EDITAR*/
'use strict';
angular.module('gp4App').factory('ixStatusService', ['$rootScope', '$location','cfg','authService','$http', 'uiGridConstants', '$timeout', 'ixLockedViewService', '$log', '$window', '$ngConfirm', function ($rootScope, $location, cfg, authService, $http, uiGridConstants, $timeout, ixLockedViewService, $log, $window, $ngConfirm) {
	var serviceInstance = {

		/* status de la aplicacio oberta */
		current: {},

		/* llista aplicacions obertes (o marcasdes com a fav) */
		availApps: [],

    checkObjAndHref: function(arr, obj){
      for(var i = 0; i < arr.length; i++){
        if(angular.equals(arr[i], obj) || angular.equals(arr[i].href, obj.href)){//Si l'objecte es troba a l'array o si l'atribut href coincideix.
          if(obj.atributos == null || angular.equals(arr[i].atributos, obj.atributos))//Si la nova app no conté 'atributos' o si hi ha un objecte a l'array que té el mateix valor a 'atributos'
          return i;                                                                   //la app ja està oberta.
        }

      }
      return -1;
    },

		/* obrir una aplicacio */
		openApp: function(app, param) {
      if(this.current !== app || $rootScope.fromDesktop == true){
        this.current.transitionend = false;
        $rootScope.fromDesktop = false;
      }
      $log.log("openApp");
			
			var pageAnimationSuffix = ""; 
			if (angular.isDefined(cfg.pageAnimation) && cfg.pageAnimation != "")
					pageAnimationSuffix = "-" + cfg.pageAnimation;
			
      if($rootScope.pageAnimationClass == 'page-animation-bottom' + pageAnimationSuffix) { $rootScope.pageAnimationClass = 'page-animation-top' + pageAnimationSuffix; }
			else { $rootScope.pageAnimationClass = 'page-animation-left' + pageAnimationSuffix; }
      //var indexAvail = this.availApps.indexOf(app);
      var indexAvail = this.availApps.map(function(e){ return e.href; }).indexOf(app.href);
      var indexDynApp = this.checkObjAndHref(this.availApps, app);
      //La directiva ixAccion genera objectes app dinamicament. Aquestes app no es trobem al menus.js
      //Els únics atributs que té l'objecte són:
      //display, href i atributos
      //
      //if(!app.open && (this.availApps[indexAvail] == null || !this.availApps[indexAvail].open)) {

			var auxPrevious;
			if(app.onCloseGoToPrev)
				auxPrevious = angular.copy(this.current);
			else if(angular.isDefined(this.current))
				this.current.onCloseGoToPrev = false;

			if(app.multiple)
				indexAvail = indexDynApp;

      if(!app.open) {
          app.data = param || {};
					app.open = true;
          this.availApps[indexAvail] = app;
          this.current = app;

      } else if(!app.open && (this.availApps[indexDynApp] == null || !this.availApps[indexDynApp].open)){
        app.data = param || {};
        app.open = true;
        this.current = app;
      } else {
				if(angular.isDefined(param)){
					this.availApps[indexAvail] = angular.merge(this.availApps[indexAvail], param);
				}
				this.current = this.availApps[indexAvail];
      }

			if(this.current && app.onCloseGoToPrev)
				this.current.previous = auxPrevious;

      if(app.atributos){
        $location.path("/"+app.href).search(app.atributos);
      } else {
        $location.path("/"+app.href);
      }
			$timeout(function(that,app,indexAvail){
				if(indexAvail === -1) {
					that.availApps.push(app);
				}
			},300,true,this, app, indexAvail)
		},

		/* canvia el mode edicio a l'aplicacio actual */
		setEditing: function(editing) {
      if(editing == true){
				var ixStatusInstance = this;
				authService.compruebaAccionDenegada(this.current.href, ACCION_EDITAR).then(function(response){

					ixLockedViewService.lock(ixStatusInstance.current);

					$timeout(function(){
						ixStatusInstance.current.deleteEnabled = true;
					},5000);

					ixStatusInstance.current.deleteEnabled = false;
					ixStatusInstance.current.editing = editing;
				}, function(err){
					ixStatusInstance.setResponse(err);
				});

      } else {
        ixLockedViewService.free(this.current);
				this.current.deleteEnabled = false;
				this.current.editing = editing;
      }
		},

		blockUIWhileProcessing: function(process, callbackOK, callbackErr){
			var serviceObj = this;
			var currentApp = this.current;
			this.blockUIBtns(currentApp, true);
			process.then(function(res){
				serviceObj.blockUIBtns(currentApp, false);
				callbackOK(res);
			}, function(err){
				serviceObj.blockUIBtns(currentApp, false);
				callbackErr(err);
			});
		},

		blockUIBtns: function(app, block){
			app.blockUIBtns = block;
		},

    //Iteració de Warnings per anar montant els missatges de toast.
    buildWarnIfNecessary: function(response, scopeObj, optionsPopup){
      var theStatusObj = this;

      var content = "";
      if(angular.isDefined(response.data)){
        if(angular.isDefined(response.data.Inserted) && response.data.Inserted != null){
          response.data.Inserted.forEach(function(e){
            if(angular.isDefined(e.Errors)){
              e.Errors.forEach(function(errorObj){
                if(errorObj.ErrType == 1){
                  content += "<p class='ix-warning'>"+errorObj.Msg+"</p>";
                }
              });
            }
          });
        }

        if(angular.isDefined(response.data.Updated) && response.data.Updated != null){
          response.data.Updated.forEach(function(e){
            if(angular.isDefined(e.Errors)){
              e.Errors.forEach(function(errorObj){
                if(errorObj.ErrType == 1){
                  content += "<p class='ix-warning'>"+errorObj.Msg+"</p>";
                }
              });
            }
          });
        }

        if(angular.isDefined(response.data.Deleted) && response.data.Deleted != null){
          response.data.Deleted.forEach(function(e){
            if(angular.isDefined(e.Errors)){
              e.Errors.forEach(function(errorObj){
                if(errorObj.ErrType == 1){
                  content += "<p class='ix-warning'>"+errorObj.Msg+"</p>";
                }
              });
            }
          });
        }

				if(angular.isDefined(response.data.Processed) && response.data.Processed != null){
          response.data.Processed.forEach(function(e){
            if(angular.isDefined(e.Errors)){
              e.Errors.forEach(function(errorObj){
                if(errorObj.ErrType == 1){
                  content += "<p class='ix-warning'>"+errorObj.Msg+"</p>";
                }
              });
            }
          });
        }

        if(angular.isDefined(response.data.obj) && response.data.obj != null){
          if(response.data.obj.Errors != null){
            response.data.obj.Errors.forEach(function(errorObj){
              if(errorObj.ErrType == 1){
                content += "<p class='ix-warning'>"+errorObj.Msg+"</p>";
              }
            });
          }
        }

				if(!content && response.data.GlobalMessage.Msg){
					content += "<p class='ix-warning'>"+response.data.GlobalMessage.Msg+"</p>";
				}

      }

			if(angular.isDefined(content) && content != ""){
        theStatusObj.current.data.warnings = true;
        //Montar la nova directiva pels warning.

				var okBtnText = "Guardar";
				if(angular.isDefined(optionsPopup)){
					if(optionsPopup.okBtnText)
						okBtnText = optionsPopup.okBtnText;
				}

				var defaultButtons = {
					ok: {
						text: okBtnText,
						btnClass: 'btn-ix-green',
						show: angular.isDefined(scopeObj),
						keys: ['enter'], // will trigger when enter is pressed
						action: function(scope){
							theStatusObj.current.data.warnings = false;
							if(angular.isDefined(scope.executeAfterProcess)){
								scope.executeAfterProcess();
								theStatusObj.current.data.warnings = true;
							}
							else if(angular.isDefined(scope.ixGuardar)){
								scope.ixGuardar();
								theStatusObj.current.data.warnings = true;
							}
						}
					},
					close: {
						text: "Cerrar"
					}
				};

				if(angular.isDefined(optionsPopup))
					defaultButtons = Object.assign({}, optionsPopup.extraButtons, defaultButtons);

        $ngConfirm({
          icon: 'fa fa-warning',
          title: 'Aviso',
          content: content,
          scope: scopeObj,
          buttons: defaultButtons
        });
      }/* else if(theStatusObj.current.data.hasWarnings && response.data.GlobalMessage.ErrType == 0) {
        //TODO: Si no venen warnings i el ErrorNotice no és error (2) possarem el editing a false.
        theStatusObj.current.data.warnings = undefined;
      }*/

    },

    setResponse: function(response, scope, optionsPopup){
      var theStatusObj = this;
      theStatusObj.current.response = response;

      if(response && response.data && response.data.GlobalMessage && response.data.GlobalMessage.ErrType == 1)
        this.buildWarnIfNecessary(response, scope, optionsPopup);


      if(response && response.status == 200 && response.data && response.data.GlobalMessage && response.data.GlobalMessage.ErrType == 0){
        $timeout(function(){
          delete theStatusObj.current.response;
        }, 2500);
      }
    },

    clearResponse: function(){
      var theStatusObj = this;
      delete theStatusObj.current.response;
    },

    sendWarnings: function(){
      var warningString = "";
      if(angular.isDefined(this.current.data.hasWarnings)){
        warningString += "warning="+(this.current.data.warnings !== false);
      }
      return warningString;
    },

		/* tancar una aplicacio */
		closeApp: function(app) {
      $log.log("closeApp");
			this.blockUIBtns(app, false);
			
			var pageAnimationSuffix = ""; 
			if (angular.isDefined(cfg.pageAnimation) && cfg.pageAnimation != "")
				pageAnimationSuffix = "-" + cfg.pageAnimation;
					
			
      $rootScope.pageAnimationClass = 'page-animation-bottom' + pageAnimationSuffix;
      ixLockedViewService.free(app);
      delete(this.current.response);
      //this.current = app;
      //this.setEditing(false);
      var indexAvail = this.availApps.indexOf(app);
      if(indexAvail >= 0) {
        this.availApps[indexAvail].open = false;
        this.availApps[indexAvail].editing = false;
        if(this.availApps[indexAvail].filtered) this.availApps[indexAvail].filtered = false;
				delete(this.availApps[indexAvail].data);
				/*if(!this.availApps[indexAvail].fav) {
					this.availApps.splice(indexAvail,1);
					$log.log("closedApp", this.availApps);
				}*/
			}
      //Redirecciona a index en cas de tancar la app desde la app oberta.
      if($location.path() !== "/" && !app.onCloseGoTo && !app.onCloseGoToPrev){
        $location.path("/");
      } else if($location.path() !== "/" && angular.isDefined(app.onCloseGoTo)) {
        //Si al tancar ha de tornar a alguna app en concret, la busca a partir del href i la obre.
				//Si tiene onCloseGoTo puede pasar parametros a la pantalla anterior.

				var sendParamsBack = app.onCloseSendParam;

        this.openApp(this.availApps.find(function(e){ return e.href === app.onCloseGoTo; }), sendParamsBack);
      } else if($location.path() !== "/" && angular.isDefined(app.onCloseGoToPrev)){
				//this.openApp(this.availApps.find(function(e){ return e.href === app.onCloseGoTo; }));
				this.openApp({
					isopen: this.current.previous.isopen,
					open: this.current.previous.open,
					filtered: this.current.previous.filtered,
					//transitionend: this.current.previous.transitionend,
					display: this.current.previous.display,
					icon: this.current.previous.icon,
					href: this.current.previous.href
				}, this.current.previous.data);
			}
		},

		/* recuprear estat de backend (es crida just després del login) */
		load: function () {
			$log.log("restoring status");
			var that = this;
      that.availApps = [];
			/*return $http.get(cfg.baseURL+"fend_config/usuario/"+authService.authentication.userName+"/openApps").then( function(response){
        if(response.data != null && response.data.valor != null){
          var news = angular.fromJson(response.data.valor);
					news = news.filter(function(app){return app.open || app.fav});
          convertDateStringsToDates(news);
          that.availApps = news;

					$log.log("restored status", that.availApps);

          // Establir current app a partir de la URL
          //Arnau: $location.path abans era $location.$$path, comprobar al final.
          that.availApps.forEach(function(app) {
            if($location.path === "/" + app.href) {
              that.current = app;
              if(!app.data) {
                app.data={};
              }
              app.open = true;
              $log.log("current app is",$location.path, app);
            }
          })
        }
      });*/
      //Recupera les apps favorites.
      return $http.get(cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave=Desktop").then( function(response){        
        var favApps = (angular.isDefined(response.data) && response.data != null) ? angular.fromJson(response.data.valor) : [];
        /*favApps.forEach(function(favApp){
          var app = that.availApps.find(function(e){ return e.display === favApp.display; });
          var index = that.availApps.indexOf(app);
          app.fav = true;
          that.availApps[index] = app;
        });*/
        return favApps;
      });
		},

		/* guardar estat a backend (es crida al fer logout) */
		save: function() {
			// Eliminar cicles provocats per gridApi
			this.availApps.forEach(function(app){
				angular.forEach(app.data,function(key) {
					if(key.gridApi) {
						delete(key.gridApi);
					}
				});
			});
			$log.log("Si dona error al saving status, buscar cycles aquí",this.availApps);
      var bodyValue = angular.toJson(this.availApps);
			return $http.post(cfg.baseURL+"fend_config/usuario/"+authService.authentication.userName+"/openApps", bodyValue);
		}


	};

	return serviceInstance;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';
angular.module('gp4App').factory('ixLockedViewService', [ 'cfg', '$http', 'authService', '$log', function(cfg, $http, authService, $log){
  var serviceInstance = {
    checkIsLocked: function(app){
      //TODO: Comprobará en el servidor, si la app que llega por parámetro está o no bloqueada.
      //Si lo está, crearemos el bloqueo en el objeto de app que llega por parámetro.
      //Nota: Esta función no hará falta si se hace mediante WebSockets.
      //Si se hace mediante WebSockets, definir una función init que se subscriba al WebSocket, está se ejecutará al abrir una nueva app.
    },
    lock: function(app){
      $log.log("lock the app");
      //TODO: Bloquear, añadirá (o notificará a WebSocket) el bloqueo.
      app.data.bloqueo = {
        user: authService.authentication.userName,
        ts: new Date(),
        app: app.display
      };
    },
    free: function(app){
      $log.log("free the app");
      //TODO: Desbloquear, borrará (o notificará a WebSocket) el bloqueo.
      if(app.data && app.data.bloqueo){
        delete app.data.bloqueo;
      }
    }
  };

  return serviceInstance;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict'
angular.module('gp4App').factory('ixCestaVehiculosService',[ 'cfg', function(cfg) {
  var service = {};
  //var _cesta = JSON.fromJson(localStorage.getItem('cesta')) || [];
  var _pantalla = "";
  var _cesta = {};
  var _options = {};
  var _showing = false;
  var _parseLines = function(items){
    if(items == ""){ return []; }

    var array = [];
    var lines = items.split('\n');
    lines.forEach(function(line){
      if(line !== "")
        array.push(line);
    });
    return array;
  }

  service.getCesta = function(){
    if(angular.isDefined(_options[_pantalla].campo)){
      if(_options[_pantalla].campo != _cesta[_pantalla].campo)
        _cesta[_pantalla].campo = _options[_pantalla].campo;
    }

    return _cesta[_pantalla] ? _cesta[_pantalla] : "";
  }

  service.getOptions = function(){
    return _options[_pantalla] ? _options[_pantalla] : "";
  }

  service.saveCesta = function(cesta){
    /*
    if(items == null) _cesta[_pantalla] = [];
    else if(angular.isString(items)){ _cesta[_pantalla] = _parseLines(items); }
    else _cesta[_pantalla] = items;
    */
    if(cesta == null){
      _cesta[_pantalla] = {};
    }
    else if(angular.isString(cesta.items)){
      _cesta[_pantalla] = {
        campo: cesta.campo,
        items: _parseLines(cesta.items),
        terminacion: cesta.terminacion,
        excluir: cesta.excluir,
				cortar: cesta.cortar
      };
    }
    else {
      _cesta[_pantalla] = {
        campo: cesta.campo,
        items: cesta.items,
        terminacion: cesta.terminacion,
        excluir: cesta.excluir,
				cortar: cesta.cortar
      };
    }
  }

  service.emptyCesta = function(){
    _cesta[_pantalla] = cestaInitialValues();
    return _cesta[_pantalla];
  }

  service.getCount = function(){
    return ((_cesta[_pantalla]) && _cesta[_pantalla].items) ? _cesta[_pantalla].items.length : 0;
  }

  service.isShowing = function(){
    return _showing;
  }

  service.setShowing = function(visible){
    _showing = visible;
  }

  service.init = function(pantalla, cestaOptions){
    _pantalla = pantalla;
    _cesta[_pantalla] = _cesta[_pantalla] || cestaInitialValues();
    _options[_pantalla] = _options[_pantalla] || angular.merge({ requestDataAfterSave: true }, cestaOptions);
    service.setShowing(true);
  }

	var cestaInitialValues = function(){
		return { items: [], campo: cfg.cestaFilterBy, terminacion: 0, excluir: 0 };
	}

  return service;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
/*eslint no-constant-condition: 0*/
/*global v */
/*global setDefaultFilter */
/*global saveAs */
/*global getDefaultFilters */
/*global getLocalFilters*/
/*global getCestaFilters */
/*global getColors */
/*global convertFromServerType */
/*global CMP_EQ */
/*global CMP_GT */
/*global CMP_LT */
/*global CMP_GTE */
/*global CMP_LTE */
/*global CMP_LIKER */
/*global CMP_LIKEL */
/*global CMP_LIKE */
/*global CMP_LIKENONE */
/*global CMP_ISNULL */
/*global mergeArraysByTag */
/*global parseObjectsToString */
/*global ixGridColumnFilterCondition*/
/*global canceller*/
/*global ixNewDate*/
'use strict';
angular.module('gp4App').factory('gridService', ['ixStatusService','ixCestaVehiculosService','$compile','cfg','authService','$http', 'uiGridConstants', 'uiGridEditConstants', '$timeout', '$filter', '$log', '$window', '$document', '$translate', 'gridUtil', 'uiGridExporterService', 'uiGridExporterConstants', 'clipboard', 'uiGridValidateService', 'gridConfigService', '$interval', '$uibModal', '$q', '$rootScope', 'moment', 'uiGridCellNavService', 'uiGridCellNavConstants', 'uiGridDraggableRowsConstants', 'ixUtilsService', 'uiGridMoveColumnService', function (ixStatusService, ixCestaVehiculosService, $compile, cfg, authService, $http, uiGridConstants, uiGridEditConstants, $timeout, $filter, $log, $window, $document, $translate, gridUtil, uiGridExporterService, uiGridExporterConstants, clipboard, uiGridValidateService, gridConfigService, $interval, $uibModal, $q, $rootScope, moment, uiGridCellNavService, uiGridCellNavConstants, uiGridDraggableRowsConstants, ixUtilsService, uiGridMoveColumnService) {

  var canceller;
	var cancellerBusquedaFunction;

	var TOOLTIP_CLASSIC = 0;
	var TOOLTIP_NOT_EMPTY_VALUES = 1;
	var TOOLTIP_ALL_VALUES = 2;

	var TAB_KEY = 9;
	var INTRO_KEY = 13;
	var DOWN_KEY = 40;
	var LEFT_KEY = 37;
	var RIGHT_KEY = 39;
	var gridServiceInstance = {

		/**
		 * Crea un griodOptions per a ui-grid
		 *
		 * @param   {object}   scope       [[Description]]
		 * @param   {[[Type]]} gridName    [[Description]]
		 * @param   {[[Type]]} gridOptions [[Description]]
		 * @param   [[String]]   entity      [[Si s'informa, recuperara les columnes de metadata]]
     * @param   [{object}] extraColumns [{name: "string", type: "string", enPopup: Boolean, url: "string", atributos: ["string"] }]
		 * @returns gridOptions
		 */
		createGrid: function(scope, gridName, gridOptionsOverride, entity, extraColumns) {
			$log.log("creating grid",gridName);
			ixStatusService.current.ixCellNav = true;
      //Canviem la manera de funcionar del grid després d'afegir el botó de bloquerar/desbloquejar ordre. Aquest botó està sempre a la columna que permet sel·leccionar files a eliminar.
      //Si la propietat ve com a false, la convertim a true perquè la columna es segueixi mostrant però fem que sigui impossible marcar les files.
      if(gridOptionsOverride.enableRowHeaderSelection == false && !gridOptionsOverride.hideBlockOrderColumn){
        gridOptionsOverride.enableRowHeaderSelection = true;
        gridOptionsOverride.isRowSelectable = function(row){
          return false;
        };
      }
			var gridOptions = angular.merge({
        headerTemplate: "app/base/views/grid/ui-grid-header.html",
        rowTemplate: "app/base/views/grid/ui-grid-row.html",
        rowHeight: 40,
        exporterMenuCsv: false,
        exporterMenuPdf: false,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.ALWAYS,//D'entrada sempre es mostra l'scroll horitzontal.
        modifierKeysToMultiSelectCells: true,//permet sel·leccionar multiples cel·les deixant apretada la tecla ctrl.
        showColumnFooter: false,
				enableFiltering: true,
				appendToFilterPopup: undefined,
				showGridFooter: false,
				enableGridMenu: true,
				enableCellEdit: true,
				rowEditWaitInterval: -1, // save won't be triggered automatically (see: getDirtyRows/setRowsClean in http://ui-grid.info/docs/#/api/ui.grid.rowEdit.api:PublicApi)
				saveFilter: true,
				saveFocus: true,
				saveGroupingExpandedStates: true,
				saveSelection: true,
				saveWidths: true,
        //Edit on single click:
        enableCellEditOnFocus: true,
        exporterMenuAllData: false,
        exporterMenuVisibleData: false,

				ixIsLoading: false,
        ixContador: false,//aqui guardarem si la grid en concret utilitza o no contadors.
        ixColDefCreated: false,

        //Paths per defecte.
				ixLoadInitialDataEntity: undefined,
				ixDownloadExcelDataEntity: undefined,
        ixGuardarAction: "UpdateBulk",
        ixLoadInitialDataAction: "Search",
        ixDownloadExcelAction: "Excel",				
				
				//keyDownOverrides: [ { keyCode: 9 }, { keyCode: 13 }, { keyCode: 40 }, { keyCode: 37 }, { keyCode: 39 }],				
				keyDownOverrides: [ { keyCode: 9 }, { keyCode: 13 }, { keyCode: 40 }],				

        exporterFieldCallback: function (grid, row, col, value) {
          var returnString = value;
          if(col.colDef.control == "Search"){
            returnString = $filter("gridfk")(value, row, col);
          }
					else if(col.colDef.type==="date") {
            returnString = $filter("date")(value, cfg.dateFormat);
					}
          return returnString;
        },

				columnDefs: [{field: "loading...",type: "string"}],

				gridMenuCustomItems: [
					{
						icon: 'fa fa-unlock',
						title: 'Bloquear/Desbloquear orden',
						shown: function() {if(angular.isDefined(this.grid)) return this.grid.options.enableSorting; else false},
						action: function($event) { this.grid.api.ix.blockOrUnblockGridOrder() }
					},
					{
						icon: 'fa fa-lock',
						title: 'Bloquear/Desbloquear orden',
						shown: function() {if(angular.isDefined(this.grid)) return !this.grid.options.enableSorting; else false},
						action: function($event) { this.grid.api.ix.blockOrUnblockGridOrder() }
					},
          //Acció que permet copiar a clipboard tota la grid mitjançant la llibreria angular-clipboard (S'ha de baixar per bower)
          {
            icon: 'fa fa-clipboard',
            title: $translate.instant('Copiar contenido'),
            shown: function(){ return true; },
            action: function($event){
              var exportColumnHeaders = uiGridExporterService.getColumnHeaders(this.grid, uiGridExporterConstants.VISIBLE);
              //var exportData = uiGridExporterService.getData(this.grid, uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE);
							var exportData = uiGridExporterService.getData(this.grid, uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
              var gridCSV = uiGridExporterService.formatAsCsv(exportColumnHeaders, exportData, "\t");
              clipboard.copyText(gridCSV);
            },
            order: 98
          },
		  {
            icon: 'fa fa-clipboard',
            title: $translate.instant('Copiar lineas seleccionadas'),
            shown: function(){ return true; },
            action: function($event){
              var exportColumnHeaders = uiGridExporterService.getColumnHeaders(this.grid, uiGridExporterConstants.VISIBLE);
							var exportData = uiGridExporterService.getData(this.grid, uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE);
              var gridCSV = uiGridExporterService.formatAsCsv(exportColumnHeaders, exportData, "\t");
              clipboard.copyText(gridCSV);
            },
            order: 99
          },
					{
						icon: 'fa fa-filter',
						title: $translate.instant('Activar filtros'),
						shown: function() { if(angular.isDefined(this.grid))return !this.grid.options.enableFiltering && !this.grid.options.disableFiltering;},
						action: function ($event) {
							this.grid.options.enableFiltering = true;
							this.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
						},
						order: 101
					},
					{
						icon: 'fa fa-filter',
						title: $translate.instant('Desactivar filtros'),
						shown: function() { if(angular.isDefined(this.grid))return this.grid.options.enableFiltering && !this.grid.options.disableFiltering;},
						action: function ($event) {
							this.grid.options.enableFiltering = false;
							this.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
						},
						order: 101
					},
					{
						title: $translate.instant('Preferencias de visualización:'),
						order: 101
					},
					{
						icon: 'fa fa-wrench',
						title: $translate.instant('Guardar configuración'),
						action: function ($event) {
              //Substitueix els filtres d'API actuals pels valors suggerits abans de guardar estat.
              var cols = this.grid.api.grid.columns;
              var auxAPIFilters = [];
              angular.forEach(cols, function(column, index){
                if(angular.isDefined(column.colDef.filteropt)){
                  auxAPIFilters.push(angular.copy(column.filters[0]));
                  column.filters = [];
                }
              });
              if(angular.isDefined(gridOptions.originalGridOrder)){
                gridOptions.applyOriginallySortedColumns();
              }
							var bodyValue = angular.toJson(this.grid.api.saveState.save());
              gridConfigService.saveConfig(gridName, this.grid.api.saveState.save());
              $http({
                url: cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave="+gridName,
                method: "POST",
                data: bodyValue
              }).then(function(r){
                ixStatusService.setResponse(r);
							});
              angular.forEach(cols, function(column, index){
                if(angular.isDefined(column.colDef.filteropt)){
                  column.filters = auxAPIFilters.splice(0,1);
                }
              });
              if(angular.isDefined(gridOptions.originalGridOrder)){
                gridOptions.applyCurrentlySortedColumns();
              }
						},
						order: 101
					},
					{
						icon: 'fa fa-wrench',
						title: $translate.instant('Guardar configuración (admin)'),
						shown: function() {
              if(angular.isDefined(this.grid)){
                var visible = false;
                angular.forEach(this.grid.options.getProfiles(), function(perfil){
                  if(perfil.toUpperCase().indexOf("IXNET") !== -1 || perfil.toUpperCase().indexOf("USERKEY") !== -1) visible = true;
                });
                return visible;
              }
            },//Nomes es mostra quan l'usuari tingui perfil ixnet o userkey.
						action: function ($event) {
              //Substitueix els filtres d'API actuals pels valors suggerits abans de guardar estat.
              var cols = this.grid.api.grid.columns;
              var auxAPIFilters = [];
              angular.forEach(cols, function(column, index){
                if(angular.isDefined(column.colDef.filteropt)){
                  auxAPIFilters.push(angular.copy(column.filters[0]));
                  column.filters = [];
                }
              });
              if(angular.isDefined(gridOptions.originalGridOrder)){
                gridOptions.applyOriginallySortedColumns();
              }

							var bodyValue = angular.toJson(this.grid.api.saveState.save());
              gridConfigService.saveConfig(gridName, this.grid.api.saveState.save());
							$http.post(cfg.baseURL+"fend_config/global/"+gridName, bodyValue).then(function(r){
                ixStatusService.setResponse(r);
							});
              angular.forEach(cols, function(column, index){
                if(angular.isDefined(column.colDef.filteropt)){
                  column.filters = auxAPIFilters.splice(0,1);
                }
              });
              if(angular.isDefined(gridOptions.originalGridOrder)){
                gridOptions.applyCurrentlySortedColumns();
              }
						},
						order: 101
					},
					{
						icon: 'fa fa-undo',
						title: $translate.instant('Deshacer cambios'),
						action: function ($event) {
							//this.grid.options.ixRestoreConfig();
              var gridInstance = this;

              $http.get(cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave="+gridOptions.gridName).then(function(r){
                if(r.data) {
                  //Recupera l'estat
                  gridOptions.gridApi.saveState.restore(scope, angular.fromJson(r.data.valor));
                }
                gridInstance.grid.options.ixSaveConfig();
                gridInstance.grid.options.ixRestoreConfig();
              });
						},
						order: 102
					},
					{
						icon: 'fa fa-trash',
						title: $translate.instant('Restablecer configuración'),
						action: function ($event) {
							var that = this;

              $http.delete(cfg.baseURL+"fend_config?usuario="+authService.authentication.userName+"&clave="+gridName).then(function(){
								$http.get(cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave="+gridName).then(function(r){
									if(r.data) {
										that.grid.api.saveState.restore(scope, angular.fromJson(r.data.valor));
									} else {
										// esto está duplicado aqui porque el API debería devolver un 404 not found y no un null
										that.grid.options.columnDefs.forEach(function (c) {
											if(!c.pk && c.enableHiding !== false) c.visible = true;
											c.width = "*";
										});
										that.grid.columns.forEach(function (c, i) {
											if (i > 0) {
												c.width = "*";
											}
										});
										that.grid.api.core.refresh();
									}
								}, function() {
									this.grid.options.columnDefs.forEach(function (c) {
										if(!c.pk) c.visible = true;
										c.width = "*";
									});
									that.grid.columns.forEach(function (c, i) {
										if (i > 0) {
											c.width = "*";
										}
									});
									that.grid.api.core.refresh();
								});
							}, function(r){
                ixStatusService.setResponse(r);
							});
						},
						order: 103
					}
				]

			}, gridOptionsOverride);
			
			//El angular.merge feia que el element appendToFilterPopup (DOM ) perdres la referencia y no funciones correctament
			if(gridOptionsOverride.appendToFilterPopup)
				gridOptions.appendToFilterPopup= gridOptionsOverride.appendToFilterPopup;

			this.createGridFunctions(scope, gridOptions);

			// Si ens passen una entity buscarem la metadada
      //TODO: Quan ens passin una entity s'hauràn de fer 2 peticions extres a API: 1. Comprobar si utilitza alguna mena de contador. 2. Comprobar si l'usuari té permis per Afegir, modificar,... etiqueta Mant_XXX...

      gridOptions.gridName = gridName;

			if(entity) {
        if(entity.length - entity.toUpperCase().lastIndexOf('VM') == 'VM'.length){
          gridOptions.skipTableName = true;
        }
				gridOptions.entity = entity;

        var storedMetadata = gridConfigService.getConfig(gridOptions.gridName+"-metadata");
        if(storedMetadata != ""){
          gridOptions.metadata = (angular.isDefined(gridOptions.metadata)) ? mergeArraysByTag(gridOptions.metadata, storedMetadata, "Name") : storedMetadata;
          gridOptions.columnDefs = [];
          //Possem les columnes extres primer:
          if(extraColumns){
            gridOptions.drawExtraColumns(extraColumns);
          }
          gridOptions.ixGetColsFromAPI();
        } else {
		  gridOptions.metadataName=entity;
          $http.get(cfg.baseURL + "metadata/" + entity).then(function (r) {
            //gridOptions.metadata = r.data;  // guadem la metadata perque el metode ixCheckErrors la fa servir després
            gridOptions.metadata = (angular.isDefined(gridOptions.metadata)) ? mergeArraysByTag(gridOptions.metadata, r.data, "Name") : r.data;  // guadem la metadata perque el metode ixCheckErrors la fa servir després
						gridOptions.crearColumnasHoraCamposDateAndTime(gridOptions.metadata);
            gridConfigService.saveConfig(gridOptions.gridName+"-metadata", gridOptions.metadata);
            gridOptions.columnDefs = [];
            //Possem les columnes extres primer:
            if(extraColumns){
              gridOptions.drawExtraColumns(extraColumns);
            }

            gridOptions.ixGetColsFromAPI();
          });
        }
			}

			return gridOptions;
		},

		createGridFunctions: function(scope, gridOptions) {
			gridOptions.ixGetBulkParam = function () {
				var bulkParam = {
					ToInsert: [],
					ToUpdate: [],
					ToDelete: []
				};

				if(gridOptions.gridApi){
					var dirtyRows = gridOptions.gridApi.rowEdit.getDirtyRows();
					dirtyRows.forEach(function (row) {
						if(row.entity.manuallyAdded) delete row.entity.manuallyAdded;
						if (gridOptions.insertedRows.indexOf(row.entity) >= 0) {
							delete(row.entity.isNew);
							bulkParam.ToInsert.push(row.entity);
						} else {
							bulkParam.ToUpdate.push({
								PK: gridOptions.buildPK(row.entity),
								PocoToUpdate: gridOptions.getPatchOperations(row.entity)
							});
						}
					});
					gridOptions.deletedRows.forEach(function (data) {
						bulkParam.ToDelete.push(gridOptions.buildPK(data));
					});
				}

				return bulkParam;
			};

      gridOptions.checkControlPkUnica = function(){
        var arrPkUnica = [];
        var hasControlPkUnica = gridOptions.metadata.some(function(e){ return e.EnableControlPkUnica; });
        var controlPkUnicaSuccess;
        if(hasControlPkUnica){
          var checkFields = gridOptions.metadata.filter(function(e){ return e.EnableControlPkUnica; });
          controlPkUnicaSuccess = true;
          for(var i=0; i < gridOptions.data.length; i++){
            var rowToCheck = gridOptions.data[i];
            var pkUnica = "";
            checkFields.forEach(function(checkField){
              var newCondition = "";
              if(checkField.Control == "CheckBox"){
                newCondition = (angular.isUndefined(rowToCheck[checkField.Name]) ? 0 : rowToCheck[checkField.Name])
              } else {
                newCondition = (angular.isUndefined(rowToCheck[checkField.Name]) ? null : rowToCheck[checkField.Name])
              }
              pkUnica += newCondition + "$";

            });
            if(arrPkUnica.indexOf(pkUnica) == -1){
              arrPkUnica.push(pkUnica);
            } else {
              controlPkUnicaSuccess = false;
              break;
            }
          }
        }
        if((!hasControlPkUnica) || (hasControlPkUnica && controlPkUnicaSuccess)){
          return true;
        } else {
          return false;
        }
      };

      gridOptions.ixGetNewMetaData = function(newMetadata, gridName, extraColumns, newEntity, metadataOverride){
        gridOptions.ixColDefCreated = false;
		gridOptions.entity = newEntity ? newEntity : newMetadata;
        return $http.get(cfg.baseURL + "metadata/" + newMetadata).then(function (r) {
		  gridOptions.metadata = r.data;  // guadem la metadata perque el metode ixCheckErrors la fa servir després
          gridOptions.metadata = (angular.isDefined(metadataOverride)) ? mergeArraysByTag(metadataOverride, gridOptions.metadata, "Name") : gridOptions.metadata;
          gridOptions.gridName = gridName;
          gridOptions.columnDefs = [];
          //Possem les columnes extres primer:
          //Check if there are extraColumns.
          if(extraColumns){
            gridOptions.drawExtraColumns(extraColumns);
          }
          gridOptions.ixGetColsFromAPI();
				});
      };

      gridOptions.ixGetColsFromAPI = function(){
        var that = this;
        that.ixIsLoading = true;
          if(!that.ixColDefCreated){
            //Al final es farà una crida a SelectAndProject sempre i quan showOnlyDescribedCols tingui valor.
            that.ixColDefCreated = true;
            var columnNames = (that.showOnlyDescribedCols) ? that.showOnlyDescribedCols : [];
            that.ixCreateColDef(columnNames);
          }
      };

			gridOptions.tooltipSelector = function(){
				var tooltipMode = gridOptions.cellTooltipFunction;

				if(angular.isUndefined(cfg.gridTooltip) || cfg.gridTooltip == TOOLTIP_NOT_EMPTY_VALUES){
					gridOptions.hintDiscardEmpties = true;
				}
				else if(cfg.gridTooltip == false || cfg.gridTooltip == TOOLTIP_CLASSIC)
					tooltipMode = true;

				return tooltipMode;
			};

			gridOptions.cellTooltipFunction = function(row){
				var visibleCols = getVisibleCols();
				var tooltip = "";

				angular.forEach(visibleCols, function(col){
					var formattedValue = row.entity[col.field];
					if(angular.isUndefined(formattedValue) || formattedValue == null || formattedValue === "")
						formattedValue = "(sin valor)";
					else {
						if(col.colDef.control == "Search"){
							formattedValue = $filter("gridfk")(formattedValue, row, col);
						}
						else if(col.colDef.type==="date") {
							formattedValue = $filter("date")(formattedValue, cfg.dateFormat);
						}
					}

					if(!gridOptions.hintDiscardEmpties || formattedValue != "(sin valor)")
						tooltip += col.displayName + ": " + formattedValue + "\n";
				});

				var noVisibleCols = getNoVisibleCols();
				if(noVisibleCols.length > 0)
					tooltip += "-------------------------------\n"
				angular.forEach(noVisibleCols, function(col){
					var formattedValue = row.entity[col.field];
					if(angular.isUndefined(formattedValue) || formattedValue == null || formattedValue === "")
						formattedValue = "(sin valor)";
					else {
						if(col.colDef.control == "Search"){
							formattedValue = $filter("gridfk")(formattedValue, row, col);
						}
						else if(col.colDef.type==="date") {
							formattedValue = $filter("date")(formattedValue, cfg.dateFormat);
						}
					}
					if(!gridOptions.hintDiscardEmpties || formattedValue != "(sin valor)")
						tooltip += col.displayName + ": " + formattedValue + "\n";
				});

				return tooltip;
			};

			gridOptions.getHeaderCellClass = function(row, rowRenderIndex, col, colRenderIndex){
				var classes = "";
				var filteredColumns = "";
				if(col.colDef.pk || col.colDef.required)
					classes += "HeaderCellRequired";
//				if(gridOptions.gridApi.core.getVisibleRows().length < gridOptions.data.length)
//					classes += " GridFiltered";

				var isFiltered = false;
				for(var i = 0; i < gridOptions.columnDefs.length; i++){
					var colDef = gridOptions.columnDefs[i];
					if(angular.isDefined(colDef.filter)){
						if(colDef.filter.numfilters > 0 || (angular.isDefined(colDef.filter.term) && colDef.filter.term !== "" && colDef.filter.term !== null)){
							isFiltered = true;
							if(filteredColumns.length>0)
								filteredColumns = filteredColumns +	", ";
							filteredColumns = filteredColumns + colDef.displayName;
							//break;
						}
					}
				}
				if(isFiltered)
					classes += " GridFiltered";					

				gridOptions.ixFilteredColumns = filteredColumns;
				return classes;
			};

      gridOptions.ixCreateColDef = function(columnNames) {
        var numVisibleCols = gridOptions.metadata.filter(function(e){ return !e.NoVisible && e.Name != "$$hashKey"; });
        numVisibleCols = (columnNames && columnNames.length > 0) ? columnNames.length : numVisibleCols.length;
				var tooltipAction = gridOptions.tooltipSelector();
        gridOptions.metadata.filter(function(e){ return e.Name != "$$hashKey"; }).forEach(function (x,i,a) {
          //El controller pot passar una llista de filtres d'api en cas de que hagin de ser-ho només per una vista en concret.
          var apiFilter = (angular.isDefined(gridOptions.filtersAPI)) ? gridOptions.filtersAPI.find(function(e){ return e.field == x.Name; }) : false;
          if(columnNames.length == 0 || columnNames.indexOf(x.Name) != -1 || columnNames.indexOf("_"+x.Name) != -1){
            var columnType = convertFromServerType(x.Type);
            var colDef = {
			  headerTooltip: (x.Tooltip) ? x.Tooltip : "",
              displayName: (!x.ColumnDescription) ? $translate.instant(gridUtil.readableColumnName(x.Name)) : $translate.instant(gridUtil.readableColumnName(x.ColumnDescription)),
              field: x.Name,
              type: columnType == "decimal" ? "number" : columnType,
							db_type: columnType,
							maxLength: x.MaxLength,
              filterHeaderTemplate: ((x.Filter || apiFilter) && gridOptions.skipAPIFilter !== true) ? '<ix-grid-filtro-servidor></ix-grid-filtro-servidor>' : '<ix-grid-filtro></ix-grid-filtro>',
              cellTooltip: tooltipAction,
              pk: x.Pk,
              fk: x.Fk,
              noeditable: x.NoEditable,
							columnexpandable: x.ColumnExpandable,
              TableAliasName: x.TableAliasName,
							DBFieldName: x.DBFieldName,
							GridListSelectConditions: x.GridListSelectConditions,
              //cellClass: gridOptions.getCellClass,
              width: (gridOptions.width) ? gridOptions.width : ((numVisibleCols > 10) ? 200 : "*"),//Si passen un width per parametre s'aplica. Si no, i la grid té mes de 10 columnes s'aplica width de 200.
                                                                                                     //En qualsevol altre cas, el width es auto.
              filter: {
                condition: ixGridColumnFilterCondition($filter)								
              },
							headerCellClass: gridOptions.getHeaderCellClass,
							SkipEnterTabIfMultipleResults: x.SkipEnterTabIfMultipleResults,
							cortarDecimales: x.CortarDecimales
            };
						if(x.OnChangeAlsoUpdate)
							colDef.OnChangeAlsoUpdate = x.OnChangeAlsoUpdate;
			if (x.cellTemplate)
				colDef.cellTemplate = x.cellTemplate;
			if (x.editableCellTemplate)
				colDef.editableCellTemplate = x.editableCellTemplate;						
            if(x.SumColumn){
							colDef.type = "number";
              gridOptions.showColumnFooter = true;
							colDef.footerCellTemplate = '<div class="ui-grid-cell-contents">Total: {{col.getAggregationValue() | number }}</div>';
              colDef.aggregationType = uiGridConstants.aggregationTypes.sum;
            }
            if(convertFromServerType(x.Type)==="decimal") {
							if(colDef.cortarDecimales){
								colDef.cellTemplate = 'app/base/views/helpers_templates/ixGridCortarDecimales.html';
							}
							colDef.cellFilter = "number:'"+(x.DecimalScale || cfg.DecimalScale || "2")+"'";
							if(gridOptions.pruebaFT) {
								// en FT se usa un custom cellFilter para permitir que se muestren valores "numericos" string que tienen coma com separador decimal
								colDef.cellFilter = "customFormatNumber";
							}
            } else if(convertFromServerType(x.Type)==="number" && !x.Search){
              colDef.cellFilter = "number:'0'";
            }
            if(colDef.type==="date") {
              colDef.cellFilter = "date:'"+cfg.dateFormat+"'";
              colDef.filterCellFiltered = true;
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridDateEditor.html';
            }
            if(x.Control==="CheckBox") {
							colDef.enableCellEdit = false;
              colDef.cellTemplate = gridOptions.checkboxTemplate ? gridOptions.checkboxTemplate : 'checkboxCell';
              colDef.editableCellTemplate = x.editableCellTemplate?x.editableCellTemplate:'checkboxEditCell';
              if(!x.Filter){
                colDef.filterHeaderTemplate = 'app/base/views/grid/checkBoxHeaderCell.html';
              }
              colDef.sortingAlgorithm = function(a,b){
                if(!a) a = 0;
                if(!b) b = 0;
                if (a === b) { return 0 }
                if (a < b) { return -1 }
                if (a > b) { return 1 }
              }
              colDef.control = "CheckBox";
              //colDef.enableCellEdit = false;
							if(x.beforeClick){ colDef.beforeClick = x.beforeClick }
            	if(x.afterClick){ colDef.afterClick = x.afterClick }
            }
            else if(x.Control==="List") {
							colDef.cellTemplate = "<div class=\"ui-grid-cell-contents ngCellText\" title=\"TOOLTIP\"><span ng-cell-text style=\"white-space: normal;\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>";
							if(gridOptions.pruebaFT){
								colDef.editableCellTemplate = 'listCellFT';
							} else{
								colDef.editableCellTemplate = 'listCell';
							}
            } else if(x.Control==="Progress"){
              colDef.cellTemplate = 'app/base/views/grid/ixGridProgress';
            }
            if(x.Required || x.Pk) {
              //colDef.headerCellClass = "HeaderCellRequired";
			  colDef.required = true;
			  if(x.NoVisible)
              	colDef.enableHiding = false;
            }
			if(x.Filter)
				colDef.enableHiding = false;

            if(x.Search && x.Control !== "Text") {
                if(x.Control !== "ixGridSelect" && x.Control !== "MultiBusqueda" && x.Control !== "ixListBusqueda"){
									if(x.template){
										colDef.template = 'app/base/views/select/'+x.template+'2.html';
									}
									colDef.enableCellEdit = false;
									colDef.cellTemplate = 'app/base/views/helpers_templates/ixGridSelectEditor2.html';
                }
                colDef.allFkObjects = [];
                colDef.editDropdownOptionsArray = [""];
								if(!x.ColumnFkDescription && !x.skipFirstLoad){
                  // necessitem una primera carrega de tots els valors pel filter que mostra clau-valor
					if(angular.isUndefined(x.busquedaFunction)){	// FT: si tenim busquedaFunction no s'ha de fer aquest get 
						$http.get(cfg.baseURL+x.Search.LookUpTableName).then(function(r){
							colDef.allFkObjects = r.data;
							colDef.editDropdownOptionsArray = r.data;
							scope.$broadcast("gridfkUpdate");
						});
					} else {
						x.busquedaFunction(x, {Filters:[], OrderBy:[]}).then(function(fields){
							colDef.allFkObjects = fields;
							colDef.editDropdownOptionsArray = fields;
							scope.$broadcast("gridfkUpdate");
						});
					}

									if(x.EditableDropdown){
										gridOptions.defineSetDropdownValueAfterLoad(colDef);
									}
									
                } else {
                  colDef.ColumnFkDescription = x.ColumnFkDescription;
									if(!angular.isArray(colDef.ColumnFkDescription))
										colDef.ColumnFkDescription = [ colDef.ColumnFkDescription ];
									//La propietat ColumnFkDescriptionExtra morira. Es va crear per resoldre alguna pantalla amb dropdown a nivell de frontend.
									//En uns dies, l'API serà capaç de retornar una llista a ColumnFkDescription.
									//Quan arrivi el moment, revisar tots els llocs on es faci servir i modificar la metadata a l'API.
                  colDef.ColumnFkDescriptionExtra = x.ColumnFkDescriptionExtra;
                  colDef.skipFirstLoad = x.skipFirstLoad;
                  gridOptions.defineSetDropdownValueAfterLoad(colDef);
                }

                colDef.editDropdownOptionsArray = [""];

                colDef.onSelectDropdown = function($item, $model) {
									//
									if(angular.isDefined(colDef.ColumnFkDescription)){
										if(colDef.ColumnFkDescription.length > 0){
											colDef.LookUpResultFields.forEach(function(lookUpResultField, idx){
												if(angular.isUndefined($item[lookUpResultField]) && angular.isDefined(colDef.ColumnFkDescription[idx]))
													$item[lookUpResultField] = $item[colDef.ColumnFkDescription[idx]];
											});
										}
									}


                  if($model == "(sin valor)" && colDef.LookUpResultFields.length == 1 && Object.keys($item).indexOf(colDef.LookUpResultFields[0]) !== -1)
                    gridOptions.gridApi.clickedRowObj.entity[colDef.LookUpResultFields[0]] = undefined;

									if(angular.isDefined(gridOptions.gridApi.clickedRowObj)){
										var isnewrow = gridOptions.gridApi.clickedRowObj.entity.isNew;
										if(angular.isDefined(colDef.copySelectedValues) && ($item.specialFlag != -1)){
											var propsToCopy = [];

											if(angular.isFunction(colDef.copySelectedValues)){
												propsToCopy = colDef.copySelectedValues($item);
											} else {
												propsToCopy = colDef.copySelectedValues;
											}
											angular.forEach(propsToCopy, function(value){
												if(angular.isObject(value)){
													var no_arrastrar_si_vacio = false;
													if(Object.keys(value).indexOf("no_arrastrar_si_vacio") != -1){
														no_arrastrar_si_vacio = value.no_arrastrar_si_vacio;
														delete(value.no_arrastrar_si_vacio);
													}

													if(Object.keys(value).length == 1){
														angular.forEach(value, function(val, key){
															if((!no_arrastrar_si_vacio) || (no_arrastrar_si_vacio && $item[key])){//si es marca amb no_arrastrar_si_vacio ha de tenir valor perque s'arrossegui
																gridOptions.gridApi.clickedRowObj.entity[val] = $item[key];
																gridOptions.addToModifiedValues(val);
																//Agafem automaticament camps que es diguin igual pero acabant en nombre.
																if(angular.isDefined($item[key+"nombre"])){
																	gridOptions.gridApi.clickedRowObj.entity[val+"nombre"] = $item[key+"nombre"];
																}
	
																var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });
																angular.forEach(columnFKDescs, function(columnFKDesc){
																	columnFKDesc.setDropdownValueAfterLoad(columnFKDesc, isnewrow);
																});
															}
														});
													} else {
														angular.forEach(value.condition, function(val, key){
															if((!no_arrastrar_si_vacio) || (no_arrastrar_si_vacio && $item[key])){//si es marca amb no_arrastrar_si_vacio ha de tenir valor perque s'arrossegui
																if(gridOptions.gridApi.clickedRowObj.entity[val] == $item[key]){
																	gridOptions.gridApi.clickedRowObj.entity[value.gridField] = $item[value.dropdownField];
																	gridOptions.addToModifiedValues(value.gridField);
																	//Agafem automaticament camps que es diguin igual pero acabant en nombre.
																	if(angular.isDefined($item[value.dropdownField+"nombre"])){
																		gridOptions.gridApi.clickedRowObj.entity[value.dropdownField+"nombre"] = $item[value.dropdownField+"nombre"];
																	}
																} else {
																	gridOptions.gridApi.clickedRowObj.entity[value.gridField] = null;
																}
															}
														});
													}
												} else {
													gridOptions.gridApi.clickedRowObj.entity[value] = $item[value];
													gridOptions.addToModifiedValues(value);
													if(angular.isDefined($item[value+"nombre"])){
														gridOptions.gridApi.clickedRowObj.entity[value+"nombre"] = $item[value+"nombre"];
													}
												}
											});
											//Si s'han d'arrossegar valors, s'executa funció per que els valors de dropdown s'omplin per si ve algun registre que no hi és.
											var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

											angular.forEach(columnFKDescs, function(columnFKDesc){
												columnFKDesc.setDropdownValueAfterLoad(columnFKDesc, isnewrow);
											});
										}
									}



									if(colDef.LookUpResultFields.length == 1 && colDef.setDropdownValueAfterLoad)
										colDef.setDropdownValueAfterLoad(colDef, isnewrow);

                  //Els dropdowns depenents es buiden si el $model es undefined i si no ho és es recarreguen.
                  var fieldName = colDef.field;
                  var dependantFields = gridOptions.metadata.filter(function(e){
                    if(e.Search){
                      var idx = e.Search.KeyFields.indexOf(fieldName);
					  var idx2 = -1;
					  if(angular.isDefined(e.depenendingOn))
					  	idx2 = e.depenendingOn.indexOf(fieldName);

                      return (idx != -1 && idx < (e.Search.KeyFields.length - 1)) || (idx2 != -1);
                    }
                  });

                  if($model == undefined){
                    angular.forEach(dependantFields, function(dependantField){
                      gridOptions.gridApi.clickedRowObj.entity[dependantField.Name] = undefined;
                    });
                  } else {
                    angular.forEach(dependantFields, function(dependantField){
                      //var depCol = gridOptions.gridApi.grid.columns.find(function(c){ return c.field == dependantField.Name});
                      var depCol = gridOptions.columnDefs.find(function(c){ return c.field == dependantField.Name; });
                      if(angular.isDefined(depCol)){
						if(depCol.control == "ixListBusqueda") {
							depCol.refreshDependantField(gridOptions.gridApi.clickedRowObj);	
																			
						}
						else if(angular.isDefined(depCol.refreshDropdown)){
							depCol.refreshDropdown({ search: '' }, gridOptions.gridApi.clickedRowObj, undefined, undefined, true);
						}
                      }
                    });
                  }

                  // function to close cellEditor when selecting a value
									//Disabled angular-virtual-select
                  //gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.END_CELL_EDIT);
									if(angular.isDefined(colDef.onSelect)
										 && typeof colDef.onSelect == "function"){
										colDef.onSelect(gridOptions.gridApi.clickedRowObj.entity, $item);
									}
                };

                colDef.onOpenCloseDropdown = function(isOpen) {
                  // function to close cellEditor when closing dropdown
                  gridOptions.gridApi.grid.cellNav.focusedCells[0].col.colDef.isOpen = isOpen;
                  if(!isOpen) {
                    gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                  }
                };

								var getEditableDropdown = function(){
									var result = colDef.EditableDropdown;
									if(angular.isFunction(colDef.EditableDropdown))
										result = colDef.EditableDropdown(gridOptions.gridApi.clickedRowObj.entity);
									return result;
								};
								colDef.refreshDependantField = function(row) {
									row.entity[colDef.field] = null;
									gridOptions.ixCheckErrors();
								}
                colDef.refreshDropdown = function($select, row, paramsGeneratedInVirtualSelect, cancellerDropdown, isDependanField) {

                  if(x.minLengthToLoad){
                    colDef.editDropdownOptionsArray = [];
                  }
									var text = $select.search != "" ? $select.search : row.entity[colDef.field];
                  //Si es de tipus EditableDropdown, se li permet afegir nous registres. (nomes funcionarà per a selects de clau simple)
                  if(getEditableDropdown()){
                    var list = angular.copy(colDef.editDropdownOptionsArray);
                    var FLAG = -1;

                    if(text){
                      var userInputItem = {
                        specialFlag: FLAG
                      };
                      angular.forEach(x.Search.LookUpKeyFields, function(lookupkeyField, idx){
												if(x.Search.LookUpKeyFields.length-1 == idx)
												{
													userInputItem[lookupkeyField] = text;
												} else {
													userInputItem[lookupkeyField] = row.entity[x.Search.KeyFields[idx]];
												}
											});
                      userInputItem[x.Search.KeyFields[x.Search.KeyFields.length-1]] = text;
                      $select.selected = userInputItem;
                      colDef.editDropdownOptionsArray = [userInputItem].concat(list);
                      colDef.allFkObjects.push(userInputItem);
                    }
                  }

                  colDef.lastSearch = text;

                  if(angular.isDefined(x.busquedaFunction)){

										//var defer = $q.defer();

										if(angular.isDefined(cancellerBusquedaFunction)){
											cancellerBusquedaFunction.resolve();
										}

										cancellerBusquedaFunction = $q.defer();

										var param = paramsGeneratedInVirtualSelect || buildDropdownFilters(x, text, row);
										if(paramsGeneratedInVirtualSelect)
											buildDropdownExtraFilters(param, x, text, row);

                    //colDef.editDropdownOptionsArray.splice(1);
                    x.busquedaFunction(x, param, text, row, { timeout: cancellerBusquedaFunction.promise }).then(function(fields){
											if(angular.isDefined(fields.data)){
												if(angular.isDefined(fields.data.Items) && angular.isArray(fields.data.Items))
													fields = fields.data.Items;
											}
                      //Tenim dues opcins: Sobreescriure les opcions que s'han carregat previament mitjançant el GET inicial o bé afegir els resultats retornats a les opcions carregades previament.
                      if(((angular.isDefined(x.overridePreloadedOptions)) && x.overridePreloadedOptions == true) || (colDef.allFkObjects.length == 0)){
                        colDef.allFkObjects = fields;
                        colDef.editDropdownOptionsArray = fields;
                      } else {
                        //Si hay alguna lista definida entonces aplicamos esa lista, sino la cargamos de la API.
                        var arrayToAdd = [];
                        angular.forEach(fields, function(field){
                            var itemInList = colDef.allFkObjects.find(function(e){ return e[x.Search.LookUpKeyFields[0]] == field[x.Search.LookUpKeyFields[0]] });
                            if(!itemInList)
                            arrayToAdd.push(field);
                        });
                        colDef.allFkObjects = colDef.allFkObjects.concat(arrayToAdd);
                        colDef.editDropdownOptionsArray = colDef.editDropdownOptionsArray.concat(arrayToAdd);
                      }

					if(isDependanField) {
						//vaciamos valor selected
						row.entity[colDef.field] = null;
						gridOptions.ixCheckErrors();
						scope.$broadcast('needToReload');
					}

					cancellerBusquedaFunction.resolve({ data: fields });
                    });

										return cancellerBusquedaFunction.promise;
                  }
                  //Fa un Get a un path diferent passant parametres per url.
                  //Es un cas especial que podria utilitzar-se més cops.
                  else if(x.lookUpExtraParam || x.lookUpExtraParam == ""){
                    var lookUpExtraParam = "";
                    if(x.rowAttr && x.rowAttr != ""){
                      lookUpExtraParam = "/" + row.entity[x.rowAttr];
                    } else if(scope.data.datos){
                      lookUpExtraParam = "/" + scope.data.datos[scope.data.pk];
                    }
										if(lookUpExtraParam != "") lookUpExtraParam = "/" + lookUpExtraParam;
										if(angular.isDefined(canceller)){
											canceller.resolve();
										}
										canceller = $q.defer();
										var requestPromiseEspecial = $http({
											url: cfg.baseURL+ x.Search.LookUpTableName + ((x.lookUpExtraParam != "") ? "/" + x.lookUpExtraParam : x.lookUpExtraParam) + lookUpExtraParam,
											timeout: canceller.promise,
											method: "GET"
										});

										return requestPromiseEspecial.then(function(response){
											var resultData = response.data;
                      if($select.selected && $select.selected.specialFlag == -1){
												resultData.push($select.selected);
											}
											return {data: resultData };
                    });
                  } else {
                    if((!x.SinPaginar) && !x.minLengthToLoad || (x.minLengthToLoad && text.length >= x.minLengthToLoad) && row) {

											param = paramsGeneratedInVirtualSelect || buildDropdownFilters(x, text, row);
											if(paramsGeneratedInVirtualSelect)
												buildDropdownExtraFilters(param, x, text, row);
                      var controllerMethod = "/Search";
                      if(x.CustomMethod == true){
                        controllerMethod = "";
                      } else if(x.CustomMethod){
                        controllerMethod = "/" + x.CustomMethod;
                      }
                      var requestPromise = $http({
                        url: cfg.baseURL+x.Search.LookUpTableName+controllerMethod+"?ItemsPerPage=599",	// BIOTECNAL: devolver más filas en el dropdown
                        data: param,
                        //timeout: canceller.promise,
												//timeout: cancellerDropdown ? cancellerDropdown.promise : canceller.promise,
												timeout: cancellerDropdown ? cancellerDropdown.promise : undefined,
                        method: "POST"
                      });

                      return requestPromise.then(function(response){
												var data = response.data;
                        $log.log("Refresh data in dropdown", data);
												var dataItems = ((angular.isDefined(data.Items)) ? data.Items : data);
												dataItems.forEach(function(result, resultIndex){
													if(result.ContextID)
														delete result.ContextID;

													// actualitzar valor selected
													var isSelected = true;
													x.Search.KeyFields.forEach(function(keyField,idx){
														if((angular.isDefined(result)) && row.entity[keyField]!==result[x.Search.LookUpKeyFields[idx]]) {
															isSelected = false;
														}
													});
													if(isSelected) {
														$select.selected = result;
														$select.activeIndex = resultIndex + (x.Required || (text != "" && "sin valor".indexOf(text) == -1) ? 0 : 1);
													}
													// Afegir resultats nous a allFkObjects perquè el fitre gridfk els mostri bé
													var found = colDef.allFkObjects.some(function(e) {
														return angular.equals(e,result);
													});

													if(!found){
														colDef.allFkObjects.push(result);
													}
												});
												

                        colDef.editDropdownOptionsArray = dataItems;
												if(angular.isDefined($select.selected)){
													if(angular.isDefined($select.selected.specialFlag) && $select.selected.specialFlag == -1){
														colDef.editDropdownOptionsArray.push($select.selected);
													}

												}
												
												if(colDef.editDropdownOptionsArray.length == 0 && isDependanField) {
													//vaciamos valor selected
													row.entity[colDef.field] = null;
													gridOptions.ixCheckErrors();
												}

                        if(angular.isDefined(x.ZeroOption)){
                          colDef.editDropdownOptionsArray.unshift(x.ZeroOption);
                        }

												return data;
                      });

                    } else if(!x.minLengthToLoad) {
                      colDef.editDropdownOptionsArray = $filter("orderBy")(colDef.allFkObjects, x.Search.LookUpResultFields[0]);
                      colDef.editDropdownOptionsArray.forEach(function(result, resultIndex){
                        // actualitzar valor selected
                        var isSelected = true;
                        x.Search.KeyFields.forEach(function(keyField,idx){
                          if((angular.isDefined(result)) && row.entity[keyField]!==result[x.Search.LookUpKeyFields[idx]]) {
                            isSelected = false;
                          }
                        });
                        if(isSelected) {
                          $select.selected = result;
                          //$select.activeIndex = resultIndex + (x.Required || (text != "" && "sin valor".indexOf(text) == -1) ? 0 : 1);
                          //Si hi ha algun problema es miraria de possar la de dalt modificada.
                          $select.activeIndex = resultIndex;
                        }
                      });
											$log.log("refreshing dropdown with text", text, row);
											var defer = $q.defer();
											if($select.search){
												var returnedElements = colDef.editDropdownOptionsArray.filter(function(e){
													var match = false;
													angular.forEach(x.Search.LookUpResultFields, function(resultField){
														if(e[resultField]){
															if(e[resultField].toLowerCase().indexOf($select.search.toLowerCase()) != -1)
																match = true;
														}
													});
													return match;
												});
												defer.resolve({ data: returnedElements });
											} else {
												defer.resolve({ data: angular.copy(colDef.editDropdownOptionsArray) });
											}
											return defer.promise;
                    }
                  }
                };

                if(x.minLengthToLoad){ colDef.minLengthToLoad = x.minLengthToLoad; }
                if(x.copySelectedValues){ colDef.copySelectedValues = x.copySelectedValues; }
              //}
              colDef.LookUpKeyFields = x.Search.LookUpKeyFields;
              colDef.KeyFields = x.Search.KeyFields;
              colDef.LookUpResultFields = x.Search.LookUpResultFields;
              colDef.LookUpTableName = x.Search.LookUpTableName;
              colDef.LookUpTableAlias = x.Search.LookUpTableAlias;
              colDef.LookUpConditions = x.Search.LookUpConditions;
							colDef.LookUpOrders = x.Search.LookUpOrders;
							colDef.EditableDropdown = x.EditableDropdown;
							colDef.skipTableNameFilter = (x.skipTableName || scope.skipTableName || gridOptions.skipTableName);
							colDef.skipTableNameOrderBy = x.skipTableNameForDropdown;
							colDef.onSelect = x.onSelect;
							if(angular.isDefined(x.EditableDropdownPriority)){ colDef.EditableDropdownPriority = x.EditableDropdownPriority; }

              colDef.control = "Search";
            }
            if(x.Control === "MultiBusqueda"){
              colDef.cellFilter = "";
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridMultipleSelectEditor.html';
              colDef.control = "MultiBusqueda";
            }
						if(x.Control === "ixListBusqueda"){
              colDef.cellFilter = "";
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridListSelectEditor.html';
              colDef.control = "ixListBusqueda";
            }

						if(x.Url){
							colDef.cellTemplate = 'app/base/views/helpers_templates/ixGridURL.html';
							colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridURL.html';
						}

            if(x.Control === "ixSiNo"){
              colDef.cellTemplate = "<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\" tabindex=\"0\">{{COL_FIELD CUSTOM_FILTERS}}<span class=\"glyphicon glyphicon-chevron-down\"></span></div>";
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridSiNoEditor.html';
              colDef.control = "ixSiNo";
              colDef.LookUpKeyFields = ["pk"];
              colDef.KeyFields = [colDef.field];
              colDef.LookUpResultFields = ["desc","pk"];

							var ixSiNoOptions = [];
              if(!colDef.required)
                ixSiNoOptions.push({ pk: null, desc: "(sin valor)" });

							//Es poden definir les opcions que tindrà el dropdown a través d'un array d'objectes.
							//En aquest punt només les aplicarà si customIxSiNoOptions no es una funció.
              if(angular.isDefined(x.customIxSiNoOptions) && !angular.isFunction(x.customIxSiNoOptions)){
                ixSiNoOptions.push.apply(ixSiNoOptions, x.customIxSiNoOptions);
              } else {
                ixSiNoOptions.push({ pk: 0, desc: "No" });
                ixSiNoOptions.push({ pk: 1, desc: "Si" });

                if(angular.isDefined(x.extraIxSiNoOptions) && x.extraIxSiNoOptions.length > 0)
                  ixSiNoOptions.push.apply(ixSiNoOptions, x.extraIxSiNoOptions);
              }

              colDef.allFkObjects = ixSiNoOptions;

              colDef.editDropdownOptionsArray = angular.copy(colDef.allFkObjects);
              colDef.enableCellEditOnFocus = false;
              colDef.cellFilter = "gridfk:row:col";

              colDef.onSelectDropdown = function($item, $model) {
                // function to close cellEditor when selecting a value
                gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.END_CELL_EDIT);
              };

              colDef.onOpenCloseDropdown = function(isOpen) {
                // function to close cellEditor when closing dropdown
                gridOptions.gridApi.grid.cellNav.focusedCells[0].col.colDef.isOpen = isOpen;
                if(!isOpen) {
                  gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                } else {
									//en cas de que customIxSiNoOptions sigui una funció es carregaràn els items al obrir.
                  if(angular.isDefined(x.customIxSiNoOptions) && angular.isFunction(x.customIxSiNoOptions)){
                    x.customIxSiNoOptions(gridOptions.gridApi.clickedRowObj.entity).then(function(result){
                      colDef.allFkObjects = result.data;
                      colDef.editDropdownOptionsArray = angular.copy(colDef.allFkObjects);
                    });

                  }
                }
              };
            }

            if(x.InPopup){
              colDef.cellTemplate = 'iconCell';
              //colDef.enableFiltering = false;
              colDef.NoFilterable = true;
              colDef.enableCellEdit = false;//La columna no és editable, prevenim que el valor es pugui modificar al fer doble click.
            }
            //La directiva ix-search-from-grid passa els camps que el frontend li digui que son filtres d'api com a filtersAPI a les opcions de grid.
            //var apiFilter = (angular.isDefined(gridOptions.filtersAPI)) ? gridOptions.filtersAPI.find(function(e){ return e.field == x.Name; }) : false;
            if((x.Filter || apiFilter) && gridOptions.skipAPIFilter !== true){
              colDef.filteropt = (apiFilter) ? apiFilter.type : x.Filter;
              if(colDef.filteropt == "Fecha"){
                //colDef.filterHeaderTemplate = '<ix-grid-filtro-servidor></ix-grid-filtro-servidor>';
                //Aplicar filtre per defecte de dates: (mes actual)
                var filterAPIUnit = angular.isUndefined(scope.filterAPIBy) ? cfg.filterAPIUnit : scope.filterAPIBy;
                var filterAPIPeriod = angular.isUndefined(scope.period) ? cfg.filterAPIPeriod : scope.period;
                colDef.filters = setDefaultFilter(colDef.filteropt, filterAPIUnit, filterAPIPeriod, (scope.filtroAPISinFecha || x.NoFiltered));
                gridOptions.enableFiltering = true;
              } else if(colDef.filteropt == "CheckBox"){
                //colDef.filterHeaderTemplate = '<ix-grid-filtro-servidor></ix-grid-filtro-servidor>';
                colDef.filter.term = setDefaultFilter(colDef.filteropt, x.APICheckDefValue);
              } else if(colDef.filteropt == "Texto"){
                //colDef.filterHeaderTemplate = '<ix-grid-filtro-servidor></ix-grid-filtro-servidor>';
                var filterAPIValue = angular.isUndefined(gridOptions.APIStringDefValue) ? x.APIStringDefValue : gridOptions.APIStringDefValue;
                colDef.filters = setDefaultFilter(colDef.filteropt, filterAPIValue);
                //TODO: La llista de possibles valors haurà de venir de la API o definir-la al controller del frontend.
                if(angular.isDefined(x.filterOptionsFunction)){
                  x.filterOptionsFunction().then(function(data){
                    colDef.listValues = data;
                  });
                } else if(angular.isDefined(x.filterOptions)){
                  colDef.listValues = x.filterOptions;
                } else if(angular.isDefined(x.ColumnFkDescription) && x.ColumnFkDescription){
                  //Encara que vingui amb el ColumnFkDescription, farem un GetAll ja que la intenció del filtre d'API és aquesta:
                  $http.get(cfg.baseURL+x.Search.LookUpTableName, { headers: { multipleCalls: true } }).then(function(r){
				          //WebWorkerService.get(cfg.baseURL+x.Search.LookUpTableName).then(function(r){
                    colDef.listValues = parseObjectsToString(r.data, colDef.LookUpResultFields);
                  });
                } else {
                  colDef.listValues = [ "Autorizada", "NO Autorizada", "PDT Autorizacion" ];
                }
              }
            }

            if(x.Control === "Color"){
              colDef.cellTemplate = 'app/base/views/helpers_templates/ixGridColor';
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridColorEditor.html';
              colDef.colors = getColors();
							colDef.control = "Color";
							colDef.hideDesc = x.hideDesc || x.HideDesc;
							colDef.enableCellEditOnFocus = false;

              colDef.onSelectDropdown = function($item, $model) {
                if(angular.isDefined(colDef.copySelectedValues)){
                  angular.forEach(colDef.copySelectedValues, function(value){
                    if(angular.isObject(value)){
                      angular.forEach(value, function(val, key){
                        gridOptions.gridApi.clickedRowObj.entity[val] = $item[key];
                      });
                    } else {
                      gridOptions.gridApi.clickedRowObj.entity[value] = $item[value];
                    }
                  });
                }
								// function to close cellEditor when selecting a value
                gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.END_CELL_EDIT);
							};

							colDef.onOpenCloseDropdown = function(isOpen) {
								// function to close cellEditor when closing dropdown
                gridOptions.gridApi.grid.cellNav.focusedCells[0].col.colDef.isOpen = isOpen;
								if(!isOpen) {
                  gridOptions.gridApi.grid.appScope.$broadcast(uiGridEditConstants.events.CANCEL_CELL_EDIT);
								}
							};
            }

            if(x.Control === "ixGridSelect"){
              colDef.cellFilter = "";
              colDef.control = "ixGridSelect";
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixSelectFromGrid.html';
            }
						
            if(x.Control=== "ixTime"){
              colDef.control = "ixTime";
              colDef.editableCellTemplate = 'app/base/views/helpers_templates/ixGridTimeEditor.html';
			  colDef.sortingAlgorithm = function(a, b){
				var partsA = [0,0,0];
				var partsB = [0,0,0];

				if(!a) a = 0;
                if(!b) b = 0;

				if(a != 0){
					var auxPartsA = a.split(":");
					if(auxPartsA[0]) partsA[0] = auxPartsA[0];
					if(auxPartsA[1]) partsA[1] = auxPartsA[1];
					if(auxPartsA[2]) partsA[2] = auxPartsA[2];
				}
				if(b != 0){
					var auxPartsB = b.split(":");
					if(auxPartsB[0]) partsB[0] = auxPartsB[0];
					if(auxPartsB[1]) partsB[1] = auxPartsB[1];
					if(auxPartsB[2]) partsB[2] = auxPartsB[2];
				}

				//Evaluamos la hora, en algunos casos será suficiente.
				a = parseInt(partsA[0]);
				b = parseInt(partsB[0]);
				
				
				if(a == b){//Si la hora es la misma, bajamos a minutos
					a = parseInt(partsA[1]);
					b = parseInt(partsB[1]);
					if(a == b){//Si los minutos son los mismos bajamos a los segundos
						a = parseInt(partsA[2]);
						b = parseInt(partsB[2]);
					}
				}

                if (a === b) { return 0 }
                if (a < b) { return -1 }
                if (a > b) { return 1 }
			  };
            }
						if(x.AlignRight){
							colDef.alignRight = true;
						}

            if(x.NoFilterable){
              colDef.NoFilterable = true;
            }

            if(x.Sort){
              colDef.sort = x.Sort;
            }

            if(x.VirtualVMField){
				colDef.VirtualVMField = true;
			  }
				if(x.PersistibleField){
					colDef.PersistibleField = true;
				}
				
			if(x.DisableOrder){
				colDef.DisableOrder = true;
			  }

            colDef.menuItems = [
							{
								icon: 'ui-grid-icon-filter',
								title: 'Activar filtros',
								shown: function() { return !this.grid.options.enableFiltering;},
								action: function ($event) {
									this.grid.options.enableFiltering = true;
									this.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
								}
							},
							{
								icon: 'ui-grid-icon-angle-down',
								title: 'Expandir',
								shown: function() { return colDef.columnexpandable && (this.grid.api.cellNav.getFocusedCell().col.field == this.context.col.field);},
								action: function ($event) {
									var field = this.context.col.field; 
									var grid = this.grid;
									var currentcell =  this.grid.api.cellNav.getFocusedCell();									
									var visiblerows = this.grid.api.core.getVisibleRows();
									var currentrowindex = visiblerows.indexOf(currentcell.row);
									
									for(currentrowindex; currentrowindex < visiblerows.length; currentrowindex++)
									{
										var row = visiblerows[currentrowindex];
										if(!grid.api.ix.disableField({ col: currentcell.col, row: row }))
										{
											row.entity[field] = currentcell.row.entity[field];	
											//sino s'omple modifiedValues no fa el update
											if (!row.entity.modifiedValues) {
												row.entity.modifiedValues = [];
												
											}
											if(row.entity.modifiedValues.indexOf(field)===-1) {
												row.entity.modifiedValues.push(field);
											}
											grid.api.rowEdit.setRowsDirty([row.entity]);
										}	
									}	
									grid.api.grid.options.ixCheckErrors();
								}								
							},
							{
								//icon: 'ui-grid-icon-menu',
								icon: 'fa fa-clipboard',								
								title: 'Copiar valores',
								shown: function() { return true;},
								action: function ($event) {																					
									var grid = this.grid;
									var gridCol = this.context.col;
									var columnToCopy = gridCol.field;
									
									var exportData = [];
									angular.forEach(this.grid.api.core.getVisibleRows(), function(row) {										
										//exportData.push(row.entity[columnToCopy]);
										var cellValue = grid.getCellValue(row, gridCol);
										var extractedField = grid.options.exporterFieldCallback(grid,row,gridCol,cellValue);
										if(extractedField)
											exportData.push(extractedField);
									});																		
									var gridCSV = exportData.join("\n");
									clipboard.copyText(gridCSV);
								}
							},
							{
								//icon: 'ui-grid-icon-menu',
								icon: 'fa fa-angle-double-left',								
								title: 'Mover a la izquierda',
								shown: function() { return true;},
								action: function ($event) {																					
									var columns = this.grid.columns;
                  var columnIndex = 0;
                  for (var i = 0; i < columns.length; i++) {
                    if (columns[i].colDef.name !== this.context.col.colDef.name) {
                      columnIndex++;
                    }
                    else {
                      break;
                    }
                  }

									//this.grid.api.colMovable.moveColumn(4, 0);
									uiGridMoveColumnService.redrawColumnAtPosition(this.grid, columnIndex, 0);
								}
							}
						];

            if(angular.isUndefined(colDef.editableCellTemplate) && angular.isDefined(x.MaxLength) && x.MaxLength !== 0){
              if(colDef.type === "string"){
                //Si es un camp de text i no se li ha aplicat encara cap html d'edició especial li possem el nostre per limitar la longitud dels camps.
                colDef.editableCellTemplate = "<div><form name=\"inputForm\"><input type=\"INPUT_TYPE\" ng-class=\"'colt' + col.uid\" ui-grid-editor ng-model=\"MODEL_COL_FIELD\" maxlength='"+x.MaxLength+"'></form></div>";
              } else if(colDef.type === "number"){

                colDef.editableCellTemplate = "<div><form name=\"inputForm\"><input type=\"INPUT_TYPE\" ng-model=\"MODEL_COL_FIELD\" ng-class=\"'colt' + col.uid\" ui-grid-editor maxlength='"+x.MaxLength+"' ix-number allow-negative='true'";
				if (x.CommaSeparator) colDef.editableCellTemplate += " comma-separator='true' "; // FT

                if(angular.isDefined(x.MinValue) && x.MinValue != null){
                  colDef.editableCellTemplate += " min='"+x.MinValue+"' min-value='"+x.MinValue+"'";
                }

                if(angular.isDefined(x.MaxValue) && x.MaxValue != null){
                  colDef.editableCellTemplate += " max='"+x.MaxValue+"' max-value='"+x.MaxValue+"'";
                }

                if(convertFromServerType(x.Type) == "decimal"){
                  colDef.editableCellTemplate += " with-decimals='2'";
                }

                colDef.editableCellTemplate += "></form></div>";
              }
            }
            //En cas de que es pugui tenir més d'un template, podriem permetre rebre per param el nom del template i aplicar-lo directament per nom.
            if(x.sortableCellTemplate == true){
              colDef.cellTemplate = 'app/base/views/grid/uiGridSortableCell';
            }

            if(!x.NoVisible){
              colDef.cellClass = gridOptions.getCellClass(colDef);
              gridOptions.columnDefs.push(colDef);
            } else if(x.NoVisible && (x.Pk || x.Fk)){
              colDef.visible = false;
              gridOptions.columnDefs.push(colDef);
            } else if(angular.isFunction(x.NoVisible)){
				if(!x.NoVisible()){
					colDef.cellClass = gridOptions.getCellClass(colDef);
              		gridOptions.columnDefs.push(colDef);
				}
			}
          }
        });
        var virtualOrderColumn = {
          field: "virtualOrderColumn",
          type: "number",
          visible: false,
          VirtualVMField: true,
          enableHiding: false
        };
        //
        gridOptions.columnDefs.push(virtualOrderColumn);

				if(gridOptions.gridName)
					gridOptions.loadConfig();
				else {
					gridOptions.ixIsLoading = false;
					if(!scope.gridManualLoad){
						gridOptions.ixLoadInitialData();
					}
					scope.$emit('gridConfigLoaded');
				}

        gridOptions.metadataLoaded = true;        
				scope.$emit('metadataLoaded', gridOptions.gridName);
        var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

        angular.forEach(columnFKDescs, function(columnFKDesc){
          columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
        });
      };

			gridOptions.ixGuardar = function (emptyTable, queryString) {
        var bulkParam  = gridOptions.ixGetBulkParam();
        if(angular.isUndefined(queryString)) queryString = "";
        var warnings = "";
        if((warnings = ixStatusService.sendWarnings()) != ""){
          if(queryString != "") queryString += "&";
          else queryString += "?";
          queryString += warnings;
        }

				var config = { AlsoSendTime: gridOptions.getDateAndTimeFieldNames() };

		var ixGuardarEntity = gridOptions.ixGuardarEntity || gridOptions.entity;
        return $http.patch(cfg.baseURL + ixGuardarEntity + '/' + gridOptions.ixGuardarAction + queryString, bulkParam, config).then(function (response) {
              if (response.data.Result) {
                //Comprovar si hi ha alguna acció que s'ha guardat pel final.
                if(angular.isDefined(gridOptions.delayedActions)){
                    gridOptions.delayedActions.forEach(function (delayedAction){
                        var url = delayedAction.url;
                        delete(delayedAction.url);
                        $http.post(url, delayedAction).then(function(r){
                            ixStatusService.setResponse(r);
                        });
                    });
                    delete(gridOptions.delayedActions);
                }
                ixStatusService.setResponse(response);
                gridOptions.clearGridAfterSave(emptyTable);
              } else {
                ixStatusService.setResponse(response);
              }
							return response;
            }, function (response) {
              gridOptions.insertedRows.forEach(function(e){e.isNew=true;});
              //Probar les dues lineas seguents.
              gridOptions.deletedRows.forEach(function(e){ if(gridOptions.data.indexOf(e) == -1) gridOptions.data.push(e);});
              gridOptions.deletedRows = [];
              ixStatusService.setResponse(response, scope);
			  return response;
            });
          };

      gridOptions.clearGridAfterSave = function(emptyTable){

        gridOptions.deletedRows = [];
        gridOptions.insertedRows = [];

				gridOptions.clearFocus();

        var dataRows = gridOptions.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
        gridOptions.gridApi.rowEdit.setRowsClean( dataRows );

        //gridOptions.bloqueo = null;
        ixStatusService.setEditing(false);

        if(!gridOptions.keepSortingEditing){
          // Rehabilitar ordenacion al finalizar la edición
          //gridOptions.enableSorting = true;
					gridOptions.gridApi.ix.unblockGridOrder();
        }
        if(angular.isDefined(gridOptions.originalGridOrder)){
          gridOptions.applyOriginallySortedColumns();
          //ixTODO: Valorar si fa falta tornar a bloquejar sempre i quan ho estigui.
        }
        //gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);
        gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);

        if(!emptyTable){
          gridOptions.ixLoadInitialData();
        } else {
          gridOptions.data = [];
        }
      };
      gridOptions.ixCancelEdit = function (emptyTable, force) {
				if(gridOptions.gridApi){
					// TODO: eliminar bloqueig al server
					var doit = true;
					if(angular.isDefined(gridOptions.gridApi.rowEdit)){
						if(gridOptions.deletedRows.length+gridOptions.insertedRows.length+gridOptions.gridApi.rowEdit.getDirtyRows().length>0 && !force) {
							doit = $window.confirm("Hay datos modificados sin guardar, si pulsa Aceptar se perderán");
						}
					}
					if(doit || force) {
						gridOptions.clearFocus();
						delete(ixStatusService.current.response);
						gridOptions.deletedRows = [];
						gridOptions.insertedRows = [];
						gridOptions.gridStatus = {$invalid:false, $error:{}};

						if(angular.isDefined(gridOptions.gridApi.rowEdit)){
							var dataRows = gridOptions.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
							gridOptions.gridApi.rowEdit.setRowsClean( dataRows );
						}

						if(gridOptions.gridApi.dragndrop){
							gridOptions.gridApi.dragndrop.setDragDisabled(true);
						}

						if(!emptyTable){
							gridOptions.ixLoadInitialData().then(function(){
								//that.bloqueo = null;
								ixStatusService.setEditing(false);
							});
						} else {
							gridOptions.data = [];
						}

						if(!gridOptions.keepSortingEditing){
							// Rehabilitar ordenacion al finalizar la edición
							//gridOptions.enableSorting = true;
							gridOptions.gridApi.ix.unblockGridOrder();
						}
						if(angular.isDefined(gridOptions.originalGridOrder)){
							gridOptions.applyOriginallySortedColumns();
							//ixTODO: Valorar si fa falta tornar a bloquejar sempre i quan ho estigui.
						}
						gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);

					}
				}
				ixStatusService.clearResponse();
			};

			gridOptions.ixAddRow = function(entityProps){
        var newEntity = entityProps || {};
        newEntity.isNew = true;

        if(!gridOptions.ignorePredefinedValuesOnCreate){
          // Preasignamos valores de filtroExterno a la nueva entidad
          //angular.forEach(gridOptions.filtroExterno, function(value,filter) {
					if(angular.isDefined(gridOptions.filtroExterno)){
						var filtroExterno;
						if(angular.isArray(gridOptions.filtroExterno))
							filtroExterno = gridOptions.filtroExterno.filter(function(x){ return x.Operator == CMP_EQ || !x.Operator; });
						else
							filtroExterno = gridOptions.filtroExterno;
						angular.forEach(filtroExterno, function(value,filter) {
							if(angular.isObject(value)){
								//comprovem si és una data per formatejar-la al format que tenim definit al config.json
								var ptrn = /(\d{4})\-(\d{2})\-(\d{2})/;
								if((typeof value.Value == "string") && value.Value.match(ptrn)){
									//value.Value = new Date(value.Value);
									//value.Value = $filter("date")(new Date(value.Value), cfg.dateTimeFormat, null);
									var parts = value.Value.split("-");
									value.Value = ixNewDate(cfg, moment, parts[2], parseInt(parts[1])-1, parts[0]);
									value.Value.setHours(0, 0, 0, 0);//hours,minutes,seconds,milliseconds
								}
								if(value.Field.lastIndexOf(".") !== -1){
									newEntity[value.Field.substr(value.Field.lastIndexOf(".")+1)] = value.Value;
								} else {
									newEntity[value.Field] = value.Value;
								}
							} else {
								//
								newEntity[filter] = value;
							}
						});
					}
        }
				if(gridOptions.arrastrarValoresAddRow && gridOptions.gridApi.core.getVisibleRows().length > 0 && gridOptions.gridApi.cellNav.getFocusedCell())
				{					
					var row = gridOptions.gridApi.cellNav.getFocusedCell().row;
					angular.forEach(gridOptions.arrastrarValoresAddRow, function(field) {
						if(!newEntity[field])
							newEntity[field] = row.entity[field];
					});	
				}				
				gridOptions.data.push(newEntity);
				gridOptions.insertedRows.push(newEntity);
				if((angular.isDefined(gridOptions.columnDefs)) && gridOptions.columnDefs.length > 0){
					var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });
					angular.forEach(columnFKDescs, function(columnFKDesc){
						columnFKDesc.setDropdownValueAfterLoad(columnFKDesc, true);
					});
				}
				gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ROW);
				if(!newEntity.manuallyAdded && !gridOptions.loadItemWhenSelect && !gridOptions.keepFocusOnAddRow){
          gridOptions.gridApi.ix.goToBottom();
        }				
			};

			gridOptions.ixSelectRow = function(row){
				gridOptions.gridApi.selection.selectRow(row);
			};
			gridOptions.ixDeleteSelectedRows = function(){
				var selectedRows = gridOptions.gridApi.selection.getSelectedRows();
				if(gridOptions.deleteIncluirLineasSel){
					selectedRows.push.apply(selectedRows, gridOptions.data.filter(function(x){ return x.Sel; }));
				}
				if(selectedRows.length == 0){
					if(angular.isDefined(gridOptions.rowsToDelete)){
						selectedRows = gridOptions.rowsToDelete;
					}
				}
						var focusedCell = gridOptions.gridApi.cellNav.getFocusedCell();
						if(focusedCell){
							if(selectedRows.indexOf(focusedCell.row.entity) != -1){
								gridOptions.clearFocus();
							}
						}
				gridOptions.gridApi.rowEdit.setRowsClean( selectedRows );
				selectedRows.reverse().forEach(function (item) {
					if(gridOptions.data.indexOf(item) != -1)
				  		gridOptions.data.splice(gridOptions.data.indexOf(item), 1);
						
				  var insertedIdx = gridOptions.insertedRows.indexOf(item);
				  if(insertedIdx===-1) {
					gridOptions.deletedRows.push(item);
				  } else {
					gridOptions.insertedRows.splice(insertedIdx,1);
				  }
				  $timeout(function(){
					gridOptions.ixCheckErrors();
				  });
				});
			  };

      gridOptions.ixDownloadExcel = function(){

        var config = {responseType:"arraybuffer"};
        var param = gridOptions.buildIxProjectionParam();

				var that = gridOptions;
				var searchEntity = angular.isDefined(gridOptions.ixLoadInitialDataEntity) ? gridOptions.ixLoadInitialDataEntity : that.entity;

        $http.post(cfg.baseURL + searchEntity + '/' + gridOptions.ixDownloadExcelAction, param, config).then(function(r){
          var file = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

					var filename = gridOptions.entity + ".xlsx";
					if(r.headers('Content-Disposition')) {
						filename = r.headers('Content-Disposition').split("=")[1];
					}
					saveAs(file, filename);
        }, function(err){
			ixStatusService.setResponse(err);
		});
      };

      gridOptions.ixProgramar = function(){
        var modalInstance = $uibModal.open({
          templateUrl: 'app/base/views/listados_programados_popup.html',
          controller: 'ListadosProgramadosController',
          //scope: scope,
          size: 'medium',
          backdrop: 'static',
          keyboard: false
        });

        modalInstance.result.then(function(datosListadoProgramado){
          if(angular.isDefined(datosListadoProgramado)){
            var paramProgramar = {};
            paramProgramar.Param = gridOptions.buildIxProjectionParam();
            paramProgramar.Mailto = angular.isDefined(datosListadoProgramado.mailto) ? angular.copy(datosListadoProgramado.mailto) : [];
            paramProgramar.Mailcco = angular.isDefined(datosListadoProgramado.mailcc) ? angular.copy(datosListadoProgramado.mailcc) : [];

            delete datosListadoProgramado.mailto;
            delete datosListadoProgramado.mailcc;

            paramProgramar.Listado = datosListadoProgramado;
            paramProgramar.Listado.client_id = cfg.clientId;

            $http.post(cfg.baseURL + gridOptions.entity + "/Programar", paramProgramar).then(function(response){
              ixStatusService.setResponse(response);
            }, function(err){
              ixStatusService.setResponse(err);
            })
          }
        });
      };

      gridOptions.addIncidencia = function () {

        gridOptions.incidencias = gridOptions.incidencias || [];
        var newIncidencia = {};
        newIncidencia.time = new Date();
        newIncidencia.user = authService.authentication.userName;
        newIncidencia.text = gridOptions.newIncidencia.text;
        gridOptions.incidencias.push(newIncidencia);
        delete gridOptions.newIncidencia.text;
      };


      gridOptions.numberOfChanges = function(){
				if(gridOptions.gridApi) {
					var insertedModified = gridOptions.insertedRows.reduce(function(p,e){ return p+(e.modifiedValues || e.manuallyAdded?1:0);},0);
        	return (gridOptions.gridApi.rowEdit.getDirtyRows().length - insertedModified) + gridOptions.deletedRows.length + gridOptions.insertedRows.length;
				} else {
					return 0;
				}
      };

      gridOptions.updateIxGuardarTooltip = function(){
          var tooltip = [];
          var insertedModified = gridOptions.insertedRows.reduce(function(p,e){return p+(e.modifiedValues?1:0);},0);
          if((gridOptions.gridApi.rowEdit.getDirtyRows().length - insertedModified)>0) {
            tooltip.push((gridOptions.gridApi.rowEdit.getDirtyRows().length - insertedModified)+" filas modificadas");
          }
          if(gridOptions.deletedRows.length>0) {
            tooltip.push(gridOptions.deletedRows.length+" filas eliminadas");
          }
          if(gridOptions.insertedRows.length>0) {
            tooltip.push(gridOptions.insertedRows.length+" filas nuevas");
          }
          gridOptions.ixGuardarTooltip = "Guardar cambios" + (tooltip.length>0?" : " + tooltip.join(","):"");

      };


      gridOptions.buildPK = function(item) {
        var key = {};
        this.metadata.forEach(function(f){
          if(f.Pk) {
            key[f.Name] = item[f.Name];
          }
        });
        return key;
      };

      gridOptions.getPatchOperations = function(data){
        var r = [];
				if(angular.isDefined(data.modifiedValues)){
					data.modifiedValues.forEach(function (col) {
						var metadataCampo = gridOptions.metadata.find(function(e){ return e.Name == col; });
						if(!metadataCampo.VirtualVMField || metadataCampo.PersistibleField){
							var propName = getRealName(col);
							r.push({
								value: data[col],
								path: "/" + propName,
								op: "replace"
							});
						}
					});
				}
        return r;
      };

			gridOptions.ixCheckErrors = function(keep_status) {
				var that = this;
				if (!keep_status) {									
        	scope.gridStatus = {$invalid:false, $error:{}};
				}        
				var requiredFields = this.metadata.filter(function(f){return !f.NoVisible && f.Required || !f.NoVisible && f.Pk && !f.Fk;});//Si son Fk no son obligatories.
				var dateFields = this.metadata.filter(function(f){ return f.Type == "DateTime"; });
				this.gridApi.rowEdit.getDirtyRows().forEach(function(row){
					requiredFields.forEach(function(f) {
            if((!row.entity[f.Name] && row.entity[f.Name]!==0) || row.entity[f.Name]==="") {
              scope.gridStatus.$invalid = true;
							if(!scope.gridStatus.$error.required) {
								scope.gridStatus.$error.required=[];
							}
							scope.gridStatus.$error.required.push({$name:f.Name, pk:that.buildPK(row.entity)});
            }
					});

					dateFields.forEach(function(f){
						var fecha = row.entity[f.Name];
						if(fecha){
							if(fecha.getFullYear() > 9999){
								scope.gridStatus.$invalid = true;
								if(!scope.gridStatus.$error.fecha) {
									scope.gridStatus.$error.fecha=[];
								}
								scope.gridStatus.$error.fecha.push({message: "Fecha con año {{param}} incorrecta", param: fecha.getFullYear()});
							} else {
								delete scope.gridStatus.$error.fecha;
							}
						}
					});

					if(angular.isDefined(gridOptions.ixCheckErrorsExtra)){
						var requiredProperty = gridOptions.ixCheckErrorsExtra(row.entity);
						if(requiredProperty != ""){
							scope.gridStatus.$invalid = true;
							if(!scope.gridStatus.$error.required) {
								scope.gridStatus.$error.required=[];
							}
							scope.gridStatus.$error.required.push({$name:requiredProperty, pk:that.buildPK(row.entity)});
						}
					}
				});
			};

			gridOptions.onRegisterApi = function (gridApi) {
          this.deletedRows = (gridOptions.deletedRows) ? gridOptions.deletedRows : [];
          this.insertedRows = (gridOptions.insertedRows) ? gridOptions.insertedRows : [];
          this.ixGuardarTooltip = "Guardar cambios";

					this.gridApi = gridApi;
					//Funcio definida perque quan fem click a Limpiar todos los filtros, l'estat de filtre de totes les columnes es quedui buit
					gridApi.core.on.filterChanged(scope, function(col) {
						var g = this.grid;
						for (var i = 0; i < g.columns.length; i++) {
							for (var j = 0; j < g.columns[i].filters.length; j++) {
								if(g.columns[i].filters[0].term == "$reload")
									g.columns[i].filters[0].term = undefined;
								if(angular.isUndefined(g.columns[i].filters[0].term) && 
								angular.isUndefined(g.columns[i].filters[0].data_ini) && angular.isUndefined(g.columns[i].filters[0].data_fi)){
									if(angular.isDefined(g.columns[i].filters[0].excluir))
										delete g.columns[i].filters[0].excluir;
									if(angular.isDefined(g.columns[i].filters[0].filtervalue))
										delete g.columns[i].filters[0].filtervalue;
									if(angular.isDefined(g.columns[i].filters[0].numfilters))
										delete g.columns[i].filters[0].numfilters;
									if(angular.isDefined(g.columns[i].filters[0].selectionType))
										delete g.columns[i].filters[0].selectionType;
								}
							}
						}
					});
          //this.gridApi.core.handleWindowResize();

					if(gridOptions.singleFilter){
						gridApi.grid.registerRowsProcessor(gridOptions.singleFilter, 200);
					}

					//Test drag rows:

					if(gridApi.dragndrop)
						gridApi.dragndrop.setDragDisabled(true);
					//beforeRowMove

					if(gridApi.draggableRows){


						gridApi.draggableRows.on.rowDragged(scope, function(info, targetElement){
							scope.dragStartsIn = gridOptions.gridName;
						});

						gridApi.draggableRows.on.beforeRowMove(scope, function(from, to, data) {
							if(angular.isDefined(gridOptions.beforeRowMove) && typeof gridOptions.beforeRowMove == "function")
									gridOptions.beforeRowMove();
							else if(gridOptions.pruebaFT) {
								// FT: Guardar el grid jerarquico despues de modificar el orden de sus filas.
								var item = data[from];
								var auxFrom = angular.copy(from);
								//Si se intenta meter un item de nivel superior en uno inferior, que no haga nada (to = from).
								if(item["$$treeLevel"] != data[to]["$$treeLevel"])
									gridOptions.dragBack = true;
								else {
									while((data[auxFrom+1]) && data[auxFrom+1]["$$treeLevel"] > item["$$treeLevel"]){
										auxFrom++;
									}
								}
								gridOptions.firstChildrenItemIndex = from + 1;
								gridOptions.lastChildrenItemIndex = auxFrom;
								gridOptions.draggedFrom = from;
								gridOptions.draggedTo = to;

								gridOptions.copyOfList = angular.copy(data);								
							}
						});

						gridApi.draggableRows.on.rowDropped(scope, function(info, targetElement){
							//Al arrossegar entre grids, agafa l'item que hi hagi a la posicio d'on ve i el mou a on el deixis anar.
							//Revertim.
							if(scope.dragStartsIn != gridOptions.gridName && gridOptions.data[info.toIndex]){
								var itemMoved = gridOptions.data.splice(info.toIndex ,1);
								if(!itemMoved[0].dragInitialCol)
									gridOptions.data.splice(info.fromIndex, 0, itemMoved[0]);
							}

							var existe = gridOptions.data.find(function(e){ return angular.equals(e, info.draggedRowEntity); });
							if(angular.isUndefined(existe)){
								gridOptions.data.splice(gridOptions.data.length,0,info.draggedRowEntity);
								gridOptions.data = gridOptions.data.filter(function(e){return (angular.isDefined(e)) && !e.dragInitialCol;});

								gridOptions.gridApi.core.refresh();
								gridOptions.ixRefreshGridDropDowns();

								if(angular.isDefined(gridOptions.rowDroppedInAnotherGrid) && typeof gridOptions.rowDroppedInAnotherGrid == "function")
									gridOptions.rowDroppedInAnotherGrid(info.draggedRowEntity);
							}
						});

						gridApi.draggableRows.on.rowFinishDrag(scope, function() {
							//eliminar el cursor de posicio de qualsevol taula

							angular.forEach($document.querySelectorAll('.' + uiGridDraggableRowsConstants.ROW_OVER_CLASS), function(row) {
								row.classList.remove(uiGridDraggableRowsConstants.ROW_OVER_CLASS);
								row.classList.remove(uiGridDraggableRowsConstants.ROW_OVER_ABOVE_CLASS);
								row.classList.remove(uiGridDraggableRowsConstants.ROW_OVER_BELOW_CLASS);
							});

							angular.forEach($document.querySelectorAll('.' + uiGridDraggableRowsConstants.ROW_TARGET_CLASS), function(row) {
									row.classList.remove(uiGridDraggableRowsConstants.ROW_TARGET_CLASS);
							});

							if(angular.isDefined(gridOptions.rowFinishDrag) && typeof gridOptions.rowFinishDrag == "function")
									gridOptions.rowFinishDrag(gridOptions);

							if(gridOptions.pruebaFT) {	// Grid jerarquico de FT
								var removed = [];

								var minus = 0;

								if(angular.isDefined(gridOptions.draggedFrom) && angular.isDefined(gridOptions.draggedTo)){
									if(gridOptions.dragBack){
										removed = gridOptions.data.splice(gridOptions.draggedTo, 1);
										gridOptions.data.splice(gridOptions.draggedFrom, 0, removed[0]);
									}
									else if(angular.isDefined(gridOptions.firstChildrenItemIndex) && angular.isDefined(gridOptions.lastChildrenItemIndex)){
										if(gridOptions.draggedFrom < gridOptions.draggedTo)
											minus = 1;

										var x = 1;
										var item = gridOptions.data[gridOptions.draggedTo];


										if((gridOptions.data[gridOptions.draggedTo - 1] && gridOptions.data[gridOptions.draggedTo + 1]) && gridOptions.data[gridOptions.draggedTo - 1]["$$treeLevel"] == item["$$treeLevel"] && gridOptions.data[gridOptions.draggedTo + 1]["$$treeLevel"] > item["$$treeLevel"]){
											while((gridOptions.copyOfList[gridOptions.draggedTo+1]) && gridOptions.copyOfList[gridOptions.draggedTo+1]["$$treeLevel"] > item["$$treeLevel"]){
												gridOptions.draggedTo++;
											}
											var currIdx = gridOptions.data.indexOf(item);
											removed = gridOptions.data.splice(currIdx, 1);
											gridOptions.data.splice(gridOptions.draggedTo + ((minus == 0) ? 1 : 0), 0, removed[0]);
										}


										//for(var i = gridOptions.firstChildrenItemIndex; i <= gridOptions.lastChildrenItemIndex; i++){
											var removeds = gridOptions.data.splice(gridOptions.firstChildrenItemIndex - minus, (gridOptions.lastChildrenItemIndex - gridOptions.firstChildrenItemIndex) + 1);
											gridOptions.draggedTo = gridOptions.data.indexOf(item);
											angular.forEach(removeds, function(remov){
												gridOptions.data.splice((gridOptions.draggedTo + x), 0, remov);
												x++;
											});
										//}

										// Guardar el grid jerarquico despues de modificar el orden de sus filas.
										if(angular.isDefined(gridOptions.afterDragRow)){
											gridOptions.afterDragRow(gridOptions, item, gridOptions.draggedFrom, gridOptions.draggedTo);
										}
									}
									gridOptions.dragBack = undefined;
									gridOptions.firstChildrenItemIndex = undefined;
									gridOptions.lastChildrenItemIndex = undefined;
									gridOptions.draggedFrom = undefined;
									gridOptions.draggedTo = undefined;
								}								
							}
						});
					}

          //pintar tota la fila després de fer clic a una cel·la:
          if(gridApi.cellNav){
            gridApi.cellNav.on.navigate(scope, function (selected){
              var isDifferent = false;
              if('.ui-grid-cell-focus'){
                if(selected.row.uid != gridApi.clickedRow) isDifferent = true;
                gridApi.clickedRow = selected.row.uid;
                gridApi.ix.focusSelectedRow(selected.row);
                //gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);//Aquest notify fa que vagi molt lenta la navegació, només es fa servir per pintar la row sel·leccionada.
              }
              if(gridOptions.loadItemWhenSelect && isDifferent){
                //Carrega fitxa.
                if(angular.isDefined(gridOptions.actionLoadItemWhenSelect)){
                    gridOptions.actionLoadItemWhenSelect(selected.row.entity, gridApi.grid.options.entity)
                }
                else if(angular.isDefined(scope.accion))
                    scope.accion(selected.row.entity, gridApi.grid.options.entity);
              }
              gridApi.clickedRowObj = selected.row;
            });
						
						gridApi.cellNav.on.viewPortKeyDown(scope, function (evt, newRowCol, defaultHandler) {
							var fireDefaultHandler = true;
							var row = {};
							var col = {};
							var obj = {};
							if (evt.keyCode === TAB_KEY || evt.keyCode === INTRO_KEY) {
								row = newRowCol.row;
								col = newRowCol.col
								if(scope.status.editing && gridOptions.enableCellEdit && angular.isDefined(scope.ixAddRow)){
									var visibleCols = gridOptions.gridApi.grid.columns.filter(function(e){ return e.visible!==false && e.colDef.isExtra!==true && e.displayName!==""}).map(function(e){return { Field: e.name } });
									if (
											uiGridCellNavService.getDirection(evt) == uiGridCellNavConstants.direction.RIGHT &&
											gridApi.grid.rows.indexOf(row) ==gridApi.grid.rows.length - 1 &&											
											visibleCols.findIndex(function (record){return  record.Field === col.field;}) == visibleCols.length - 1
									) {
											obj.toInsert = true;
											gridOptions.ixAddRow(obj);								
										}
								}
							}
							if (evt.keyCode === DOWN_KEY) {
								row = newRowCol.row;
								col = newRowCol.col;
								if(scope.status.editing && gridOptions.enableCellEdit && angular.isDefined(scope.ixAddRow)){
									if (
											uiGridCellNavService.getDirection(evt) == uiGridCellNavConstants.direction.DOWN &&
											gridApi.grid.rows.indexOf(row) ==gridApi.grid.rows.length - 1
									) {
											obj.toInsert = true;
											gridOptions.ixAddRow(obj);								
										}
								}
							}
							if (fireDefaultHandler)
								defaultHandler(evt);
						});
          }

					if(gridApi.edit) {
						//if(!gridOptions.originalflagScrollingHorizontallyFunc){
						gridOptions.originalflagScrollingHorizontallyFunc = angular.copy(gridApi.grid.flagScrollingHorizontally);							
						//}						
						if(gridOptions.originalflagScrollingHorizontallyFunc){							
							gridApi.grid.flagScrollingHorizontally = function(scrollEvent){
								scrollEvent.withDelay = true; //ibran
								gridOptions.originalflagScrollingHorizontallyFunc(scrollEvent);
							}
						}
						
						gridOptions.originalflagScrollingVerticallyFunc = angular.copy(gridApi.grid.flagScrollingVertically);							
						//}						
						if(gridOptions.originalflagScrollingVerticallyFunc){							
							gridApi.grid.flagScrollingVertically = function(scrollEvent){
								scrollEvent.withDelay = true; //ibran
								gridOptions.originalflagScrollingVerticallyFunc(scrollEvent);
								$timeout(function(){
									//llamada a gridfkupdate para refrescar el valor de los combos angular-virtual-select al hacer scroll
									scope.$broadcast("gridfkUpdate");
								},1);
							}
						}
						
						// Guardamos registro de las columnas modificadas en cada fila
						gridApi.edit.on.afterCellEdit(scope, function (rowEntity, colDef, newValue, oldValue) {
							if(newValue!==oldValue) {
								//Si la columna forma part de la PK i es de tipus string, no pot contenir espais.
								if(colDef.pk && colDef.type == "string" && colDef.field != "referencia"){
									newValue = newValue.replace(/ /g, '');
									rowEntity[colDef.field] = newValue;
								}
                //TODO: En cas que s'hagi modificar la pk (colDef.pk == true); Esborrar totes les entrades d'error que tinguin una pk = a oldValue (Aixi evitarem arrossegar errors de validació falsos).
								if (!rowEntity.modifiedValues) {
									rowEntity.modifiedValues = [];
								}
								if(rowEntity.modifiedValues.indexOf(colDef.name)===-1) {
									rowEntity.modifiedValues.push(colDef.name);
								}

                if(angular.isDefined(gridApi.grid.options.onCellEdit)
                   && typeof gridApi.grid.options.onCellEdit == "function"){
                  gridApi.grid.options.onCellEdit(rowEntity, colDef, newValue, oldValue);
                }

								if(angular.isDefined(colDef.OnChangeAlsoUpdate))
									gridOptions.actualizarCampoDateAndTime(rowEntity, colDef, newValue);

								var tieneColumnaAsociada = gridOptions.metadata.find(function(e){ return e.OnChangeAlsoUpdate == colDef.field; });
								if(angular.isDefined(tieneColumnaAsociada))
									gridOptions.actualizarCampoDateAndTime(rowEntity, tieneColumnaAsociada, rowEntity[tieneColumnaAsociada.Name]);

				if(!colDef.Search){
					var fieldName = colDef.field;
					var dependantFields = gridOptions.metadata.filter(function(e){
						if(e.Search){
							var idx = -1;
							if(angular.isDefined(e.depenendingOn))
								idx = e.depenendingOn.indexOf(fieldName);
	
							return idx != -1;
						}
					});

					if(!newValue){
						angular.forEach(dependantFields, function(dependantField){
							gridOptions.gridApi.clickedRowObj.entity[dependantField.Name] = undefined;
						});
					} else {
						angular.forEach(dependantFields, function(dependantField){
							var depCol = gridOptions.columnDefs.find(function(c){ return c.field == dependantField.Name; });
							if(angular.isDefined(depCol)){
								if(depCol.control == "ixListBusqueda") {
									depCol.refreshDependantField(gridOptions.gridApi.clickedRowObj);													
								}
								else if(angular.isDefined(depCol.refreshDropdown)){
									depCol.refreshDropdown({ search: '' }, gridOptions.gridApi.clickedRowObj, undefined, undefined, true);
								}
							}
						});
					}
				}
				

                //Si no possem timeout, la funció ixCheckErrors es crida i la fila no està encara a la col·lecció de dirty rows.
                $timeout(function(){
								  gridApi.grid.options.ixCheckErrors();
                });
							}
						});
          }          
					

					//PRUEBAS FT

					if(gridOptions.pruebaFT){
						var alignContainers =  function alignContainers ( gridContainer , grid) {
							gridOptions.headerHeight = 0;
							gridOptions.largestRow = 0;
							var header = angular.element(gridContainer + ' .ui-grid-header-cell-row')[0].offsetHeight;
							gridOptions.headerHeight = header;

							var rows = angular.element(gridContainer + '.ui-grid .ui-grid-render-container-body .ui-grid-row');
							var pinnedRowsLeft = angular.element(gridContainer + '.ui-grid .ui-grid-pinned-container-left .ui-grid-row');
							var gridHasRightContainer = grid.hasRightContainer();
							if (gridHasRightContainer) {
								var pinnedRowsRight = angular.element(gridContainer + '.ui-grid .ui-grid-pinned-container-right .ui-grid-row');
							}

							var bodyContainer = grid.renderContainers.body;

							// get count columns pinned on left
							var columnsPinnedOnLeft = grid.renderContainers.left.renderedColumns.length;

							for (var r = 0; r < heightRowsChanged.length; r++) {
								heightRowsChanged[r].height = 30;
							}
							heightRowsChanged = [];

							gridOptions.totalHeight = 0;

							for(r = 0; r < rows.length; r++) {
								// Remove height CSS property to get new height if container resized (slidePanel)
								var elementBody = angular.element(rows[r]).children('div');
								elementBody.css('height', '');
								var elementLeft = angular.element(pinnedRowsLeft[r]).children('div');
								elementLeft.css('height', '');
								if (gridHasRightContainer) {
									var elementRight = angular.element(pinnedRowsRight[r]).children('div');
									elementRight.css('height', '');
								}

								// GET Height when set in auto for each container
								// BODY CONTAINER
								var rowHeight = rows[r].offsetHeight;
								// LEFT CONTAINER
								var pinnedRowLeftHeight = 0;
								if (columnsPinnedOnLeft) {
									pinnedRowLeftHeight = pinnedRowsLeft[r].offsetHeight;
								}
								// RIGHT CONTAINER
								var pinnedRowRightHeight = 0;
								if (gridHasRightContainer) {
									pinnedRowRightHeight = pinnedRowsRight[r].offsetHeight;
								}
								// LARGEST
								var largest = Math.max(rowHeight, pinnedRowLeftHeight, pinnedRowRightHeight);

								if(gridOptions.largestRow < largest)
									gridOptions.largestRow = largest;

								gridOptions.totalHeight += largest;

								// Apply new row height in each container
								elementBody.css('height', largest);
								elementLeft.css('height', largest);
								if (gridHasRightContainer) {
									elementRight.css('height', largest);
								}

								// Apply new height in gridRow definition (used by scroll)
								//bodyContainer.renderedRows[r].height = largest;
								var heightRowChanged = bodyContainer.renderedRows[r];
								if(angular.isDefined(heightRowChanged)){
									heightRowChanged.height = largest;
									heightRowsChanged.push(heightRowChanged);
								}
							}
							// NEED TO REFRESH CANVAS
							$timeout(function(){
								bodyContainer.canvasHeightShouldUpdate = true;
							},300);

						};
				// END alignContainers()
					var heightRowsChanged = [];
					var rowsRenderedTimeout;
					// ROWS RENDER
					gridApi.core.on.rowsRendered(scope, function () {
						// each rows rendered event (init, filter, pagination, tree expand)
						// Timeout needed : multi rowsRendered are fired, we want only the last one
						if (rowsRenderedTimeout) {
							$timeout.cancel(rowsRenderedTimeout)
						}
						rowsRenderedTimeout = $timeout(function () {
							//alignContainers('', gridApi.grid);
							alignContainers('.grid'+gridApi.grid.id, gridApi.grid);
						},300);
					});

					// SCROLL END
					gridApi.core.on.scrollEnd(scope, function () {
						//alignContainers('', gridApi.grid);
						alignContainers('.grid'+gridApi.grid.id, gridApi.grid);

					});
				} else {
					if(angular.isDefined(gridOptions.onRowsRendered)){
						gridApi.core.on.rowsRendered( scope, gridOptions.onRowsRendered );
					}
				}					
					
					//ibran
					gridApi.core.on.rowsVisibleChanged( scope, function() {				
						$timeout(function(){
							//llamada a gridfkupdate para refrescar el valor de los combos angular-virtual-select al hacer filtros
							scope.$broadcast("gridfkUpdate");
						},10);
					});

          gridApi.ix = {};
          gridApi.ix.status = scope.status; // Binding amb status de la pagina
          gridApi.ix.focusSelectedRow = function(selectedRow){
            gridApi.ix.unfocusPreviousRow(selectedRow);
            selectedRow.estaSeleccionado = true;
          };

          gridApi.ix.unfocusPreviousRow = function(selectedRow){
            var lastRow = gridApi.cellNav.getFocusedCell();
            if((angular.isDefined(lastRow) && lastRow !== null) && lastRow.col.colDef.control == "Search" && lastRow.col.colDef.isOpen) lastRow.col.colDef.isOpen = false;
            if(angular.isDefined(lastRow) && lastRow !== null && lastRow.row !== selectedRow.row){
              lastRow.row.estaSeleccionado = false;
            }
          };

					gridApi.ix.disableField = function(cell, col){
						return !gridOptions.cellEditableCondition(cell);
					};
          //Nova funció per obrir un popup en quan el icon d'una columna es clica.
          gridApi.ix.showPopup = function(cell, col, $event) {
            if(scope.status.editing){
              var $elm;

              scope.entityObj = cell.row.entity;
              scope.colDisplayname = col.displayName;
              scope.colField = col.field;
              scope.gridEntity = gridOptions.entity;
              scope.isNew = cell.row.entity.isNew;

              var html = '<ix-grid-modal col-displayname="col.displayName" col-field="col.field" entity="entity" is-new="cell.row.entity.isNew"></ix-grid-modal>';

              $elm = angular.element(html);
              angular.element($document.find('body').eq(0)).prepend($elm);

              $compile($elm)(scope);
            }
          };

          gridApi.ix.blockOrUnblockGridOrder = function(){
						if(!gridOptions.disableOrderLock){
							if(gridOptions.enableSorting){
								gridApi.ix.blockGridOrder();
							} else {
								gridApi.ix.unblockGridOrder();
							}
						}
          };

		  gridApi.ix.gridHeaderEllipsis = cfg.gridHeaderEllipsis;

          gridApi.ix.blockGridOrder = function(){
            var rows = gridOptions.gridApi.core.getVisibleRows();

						if(rows.length > 0){
							angular.forEach(rows, function(row,i){
								row.entity.virtualOrderColumn = i;
							});

							var sortedColumns = gridOptions.gridApi.grid.columns.filter(function(e){ return (Object.keys(e.sort)).length > 0; });
							gridOptions.originalGridOrder = sortedColumns.map(function(e){ return { field: e.field, sort: e.sort }; });

							sortedColumns.forEach(function(column){ column.sort = {}; });

							var virtualOrderColumn = gridOptions.gridApi.grid.columns.find(function(e){ return e.field.toUpperCase() == "VIRTUALORDERCOLUMN"; });
							if(angular.isDefined(virtualOrderColumn))
								virtualOrderColumn.sort = { priority: 0, direction: "asc" };
						}
            gridOptions.enableSorting = false;
            gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
          };

          gridApi.ix.unblockGridOrder = function(){
            if(angular.isDefined(gridOptions.originalGridOrder)){
              gridOptions.applyOriginallySortedColumns();
              delete gridOptions.originalGridOrder;
            }

            gridOptions.enableSorting = true;
            gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
          };

          gridApi.ix.goToBottom = function(){
            var gridPrevToRow = gridOptions.data[gridOptions.data.length - 2];
            var gridRow = gridOptions.data[gridOptions.data.length - 1];
            gridOptions.gridApi.ix.focusSelectedRow(gridRow);
            //var gridCol = gridOptions.columnDefs[0];
						var visibleCols = gridOptions.gridApi.grid.columns.filter(function(e){ return e.visible!==false && e.colDef.isExtra!==true && e.displayName!==""}).map(function(e){return { Field: e.name } });
						var gridCol = gridOptions.columnDefs.find(function(c){ return c.field == visibleCols[0].Field; });						
						
            $timeout(function() {
              gridOptions.gridApi.cellNav.scrollToFocus( gridPrevToRow, gridCol);
            }, 100);
            $timeout(function() {
              gridOptions.gridApi.cellNav.scrollToFocus( gridRow, gridCol);
            }, 200);
          };

          gridApi.ix.drawDirtyRows = function(){
            // marcar les dirty rows si estem restaurant la grid
            $timeout(function(that,gridApi){
              if(that.data) {
                var dirtyRows = that.data.filter(function(x){
                  return x.modifiedValues || x.manuallyAdded
                });
                $log.log("dirty rows",dirtyRows);
                gridApi.rowEdit.setRowsDirty(dirtyRows);
                if(dirtyRows.length > 0){
                  gridApi.grid.options.ixCheckErrors();
                }
              }
            },100,true,this,gridApi);
          };
          if(angular.isDefined(gridApi.rowEdit)){
            var bound = gridApi.ix.drawDirtyRows.bind(gridOptions);
            bound();
          }
			};

			gridOptions.cellEditableCondition = function (cell) {
        var noeditable = true;
				(typeof(gridOptions.NoEditable) == "function") ? noeditable = gridOptions.NoEditable(cell) : noeditable = cell.col.colDef.noeditable;
				(typeof(cell.col.colDef.noeditable) == "function") ? noeditable = cell.col.colDef.noeditable(cell) : noeditable = noeditable;
				if(!cell.col.colDef.isExtraColumn){
					return (gridOptions.enableCellEdit && scope.status.editing && !noeditable && ((!cell.col.colDef.fk && !cell.col.colDef.pk) || cell.row.entity.isNew ));
				} else {
					return (angular.isDefined(noeditable) && !noeditable);
				}
			};

      gridOptions.ixEditar = function(loadData){
          // TODO: crear un bloqueig

          //grid.bloqueo = {
            //user: authService.authentication.userName,
            //ts: new Date(),
            //app: grid.entity
          //};
          //if(loadData) this.ixLoadInitialData();

				ixStatusService.setEditing(true);
				if(gridOptions.gridApi.dragndrop){
					gridOptions.gridApi.dragndrop.setDragDisabled(false);
				}
		  	ixStatusService.current.ixCellNav = true;

        if(!gridOptions.keepSortingEditing){
					// Deshabilitar ordenacion durante la edición
					//gridOptions.enableSorting = false;
					gridOptions.gridApi.ix.blockGridOrder();

					//gridOptions.gridApi.grid.columns.forEach(function(c){c.unsort()});
					gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }

      };

			var buildOrderByCol = function(c){
				var metadataColumn = gridOptions.metadata.find(function(e){ return e.Name == c.field; });
				var fieldName = ((c.colDef.TableAliasName || c.colDef.LookUpTableAlias) && c.colDef.LookUpKeyFields) ? c.colDef.LookUpKeyFields[c.colDef.LookUpKeyFields.length-1] : c.field;
				if((angular.isDefined(metadataColumn)) && (!metadataColumn.skipTableName || metadataColumn.addTableNameOrderBy) && !scope.skipTableName && !gridOptions.skipTableName){
					var tableName = gridOptions.entity;
					if(c.colDef.TableAliasName) tableName = c.colDef.TableAliasName;
					if(c.colDef.LookUpTableAlias) tableName = c.colDef.LookUpTableAlias;
					if(fieldName.indexOf("_") == 0){
						fieldName = fieldName.substring(1);
					}
					return (c.sort.direction==="desc"?"-":"")+ tableName + "." +fieldName;
				} else if(gridOptions.skipTableName && c.colDef.KeyFields){
					fieldName = c.colDef.KeyFields[c.colDef.KeyFields.length-1]
					return (c.sort.direction==="desc"?"-":"")+ fieldName;
				} else {
					return (c.sort.direction==="desc"?"-":"")+ fieldName;
				}
			};

			gridOptions.ixLoadInitialData = function (page, param) {
          		page = angular.isDefined(page) ? page : 1;
          		//Excluim les columnes que vinguin marcades com VirtualVMField.
				var sortCols = angular.isDefined(gridOptions.gridApi) ? (gridOptions.gridApi.grid.columns.filter(function(c){return c.sort.priority>=0 && !c.colDef.VirtualVMField && !c.colDef.DisableOrder;}).sort(function(a,b){return a.sort.priority-b.sort.priority}).map(function(c){
					return buildOrderByCol(c);
				})) : [];
		    	param = angular.isDefined(param) ? param : {Filters: [], OrderBy: sortCols};

				var that = gridOptions;
				that.ixIsLoading = true;
				if (that.incloureCesta) {
            		//getCestaFilters(param, $filter, cfg, ixCestaVehiculosService.getCesta(), gridOptions.metadata, gridOptions.skip);
					ixUtilsService.getCestaFilters(param, ixCestaVehiculosService.getCesta(), gridOptions.metadata, gridOptions.skip);
				}
				if(!gridOptions.skipAPIFilter){
					if (getDefaultFilters(that.columnDefs, param, $filter, cfg)) {
					that.enableFiltering = true;
					}
				}
				//Si la grid té algún select o algún altre input per filtrar ho comprovarem aquí.
				//En cas afirmatiu, afegirem els valors a l'objecte Filters de la variable param.
				if (that.filtroExterno) {
					angular.forEach(that.filtroExterno, function (valor, filtro) {
		              	if(valor && typeof valor == "object"){
							if(angular.isDate(valor.Value)){
							valor.Value = $filter("date")(valor.Value, 'yyyy-MM-dd', null);
							}
	                		param.Filters.push(valor);
              			} else {
							param.Filters.push({
								Field: filtro,
								Value: valor,
								Operator: CMP_EQ
							});
        				}
					});
				}
					
				if(that.orderByExterno){
					angular.forEach(that.orderByExterno, function(orderByExterno){
						param.OrderBy.push(orderByExterno);
					});
				}
				var listado = "";
				if(that.listado){
					listado = "/" + that.listado;
				}
				var searchEntity = angular.isDefined(gridOptions.ixLoadInitialDataEntity) ? gridOptions.ixLoadInitialDataEntity : that.entity;

				if(angular.isDefined(gridOptions.cancellerIxLoad)){
					gridOptions.cancellerIxLoad.resolve();
				}
				gridOptions.cancellerIxLoad = $q.defer();

				var requestPromiseIxLoadInitialData = $http({
					url: cfg.baseURL + searchEntity + listado + '/'+gridOptions.ixLoadInitialDataAction+'?Page=' + page + '&ItemsPerPage=' + cfg.pageSize,
					data: param,
					timeout: gridOptions.cancellerIxLoad.promise,
					method: "POST"
				});

				return requestPromiseIxLoadInitialData.then(function (response) {
					//Per a cada crida s'actualitzarà la data d'informació generada.
					that.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
					var nuevasFilas = response.data.Items || response.data;
					gridOptions.obtenerTiempoCamposDateAndTime(nuevasFilas);
					if (page == 1) {
						if(angular.isDefined(scope.data)) scope.data.ixProgress = 0;
						that.data = nuevasFilas;
					} else {
						that.data.push.apply(that.data, nuevasFilas);
					}


					if (!scope.isDestroyed && response.data.TotalItems > response.data.CurrentPage * response.data.ItemsPerPage) {
						var x = 100 / (response.data.TotalItems / response.data.ItemsPerPage);
						if(angular.isDefined(scope.data)) scope.data.ixProgress = page * x;

			            var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

						angular.forEach(columnFKDescs, function(columnFKDesc){
							columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
						});

						return that.ixLoadInitialData(page + 1);

					} else {

						columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

						angular.forEach(columnFKDescs, function(columnFKDesc){
							columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
						});


						//if(response.data.TotalItems <= response.data.CurrentPage*response.data.ItemsPerPage){
						//Cridar event de que ja ha acabat.
						scope.$emit('gridLoaded', gridOptions.gridName);

						// BIOTECNAL
						// Este código evita el grid capture el foco cuando se hace click fuera del ui-grid-focuser.
						// El problema estaba en que, cuando hay scroll en la pagina, el grid esta en edición, y se hace click fuera del grid, el ui-grid-focuser capturaba el foco y no permite que se haga click en otro elemento de la página.
						// Habría que mirar si en versiones más modernas de ui-grid (>4.6.1) esto ya está solucionado.
						$timeout(function () {
							if(gridOptions.gridApi && gridOptions.gridApi.grid && gridOptions.gridApi.grid.element && gridOptions.gridApi.grid.element.length > 0) {
								var gridElement = gridOptions.gridApi.grid.element[0];
								var focuser = gridElement.querySelector('.ui-grid-focuser');

								if (!focuser || focuser.__externalFocusGuard) {
									return;
								}

								var originalFocus = focuser.focus;
								focuser.focus = function () {
									var activeElement = $document.activeElement;
									if (activeElement && !gridElement.contains(activeElement)) {
										return;
									}

									return originalFocus.apply(this, arguments);
								};
								focuser.__externalFocusGuard = true;
							}
						}, 500);	

						if(angular.isDefined(scope.data)) scope.data.ixProgress = 100;
						that.ixIsLoading = false;
						if(angular.isDefined(scope.data)){
							$timeout(function () {
								delete scope.data.ixProgress;
							}, 500);
						}
			            return that.data;
					}
				}, function (response) {
					that.ixIsLoading = false;				
					ixStatusService.setResponse(response);						
				});

				//TODO: Fer el load passant pel blockUiBtns del IxStatusService per a que no es pugui fer res mentre es fa el load.
				/*
				var process = $http.post(cfg.baseURL + that.entity + listado + '/'+gridOptions.ixLoadInitialDataAction+'?Page=' + page + '&ItemsPerPage=' + cfg.pageSize, param);
				var callbackOK = function(response){
					//Per a cada crida s'actualitzarà la data d'informació generada.
					that.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
					if (page == 1) {
						if(angular.isDefined(scope.data)) scope.data.ixProgress = 0;
						that.data = response.data.Items || response.data;
					} else {
						that.data.push.apply(that.data, (response.data.Items || response.data));
					}


					if (!scope.isDestroyed && response.data.TotalItems > response.data.CurrentPage * response.data.ItemsPerPage) {
						var x = 100 / (response.data.TotalItems / response.data.ItemsPerPage);
						if(angular.isDefined(scope.data)) scope.data.ixProgress = page * x;

						var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

						angular.forEach(columnFKDescs, function(columnFKDesc){
							columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
						});

						return that.ixLoadInitialData(page + 1);

					} else {

						columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });

						angular.forEach(columnFKDescs, function(columnFKDesc){
							columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
						});


						//if(response.data.TotalItems <= response.data.CurrentPage*response.data.ItemsPerPage){
						//Cridar event de que ja ha acabat.
						scope.$emit('gridLoaded');
						if(angular.isDefined(scope.data)) scope.data.ixProgress = 100;
						that.ixIsLoading = false;
						if(angular.isDefined(scope.data)){
							$timeout(function () {
								delete scope.data.ixProgress;
							}, 500);
						}
						return that.data;
					}
				};
				var callbackErr = function(response){
					that.ixIsLoading = false;
					ixStatusService.setResponse(response);
				};
				ixStatusService.blockUIWhileProcessing(process, callbackOK, callbackErr);*/

			};
			gridOptions.ixRefreshGridDropDowns = function () {
				var columnFKDescs = gridOptions.columnDefs.filter(function(e){ return e.setDropdownValueAfterLoad && (e.ColumnFkDescription || e.skipFirstLoad); });
				angular.forEach(columnFKDescs, function(columnFKDesc){
					columnFKDesc.setDropdownValueAfterLoad(columnFKDesc);
				});	
			};			

			gridOptions.ixRestoreConfig = function() {
					if(this.savedStatus) {
						var that = this;
						$timeout(function() {
							var savedStatusJson = angular.fromJson(that.savedStatus);
							var virtualOrderColumnSaved = savedStatusJson.columns.find(function(x){ return x.name == "virtualOrderColumn"; });
							if(angular.isDefined(virtualOrderColumnSaved)){
								virtualOrderColumnSaved.visible = false;
							}
							that.gridApi.saveState.restore(that, savedStatusJson);
						},0);
					}
			};

			gridOptions.ixSaveConfig = function() {
        if(angular.isDefined(this.gridApi)){
          this.savedStatus = angular.toJson(this.gridApi.saveState.save());
          gridConfigService.saveConfig(gridOptions.gridName, this.gridApi.saveState.save());
        }
			};

			gridOptions.ixShowFilteredFields = function(metadata, stored_config){
				stored_config.columns.forEach(function(column){
					var metadata_column = metadata.find(function(e){ return e.Name == column.name; });
					if(angular.isDefined(metadata_column)){
						if(metadata_column.Filter)
							column.visible = true;
					}
				});
				return stored_config;
			};

      gridOptions.getProfiles = function(){
        return authService.authentication.perfiles;
      };

      gridOptions.getCellClass = function(colDef) {
        var clase = "";

        if((colDef.type==="number" && colDef.control!=="Color") || (colDef.alignRight)) {
          clase = "text-right";
        }
        if(colDef.control==="CheckBox"){
          clase = "text-center";
        }
        else if(colDef.control==="Search" || colDef.control==="ixSiNo"){
          clase = "text-left";
        }

        return clase;
      };

      gridOptions.drawExtraColumns = function(extraColumns){
				var tooltipAction = gridOptions.tooltipSelector();
				if(gridOptions.tooltipDataInPopup)
					addAccionTooltipInPopup(extraColumns);

        extraColumns.forEach(function(column){
          var colDef = {
            field: column.name,
            displayName: column.name,
            type: column.type,
            filterHeaderTemplate: '<ix-grid-filtro></ix-grid-filtro>',
						cellTooltip: tooltipAction,
            isExtra: true,
            enableSorting: false
            //cellClass: gridOptions.getCellClass,
          };
					if(column.allowCellFocus == false)
						colDef.allowCellFocus = false;

          if(colDef.type==="date") {
            colDef.cellFilter = "date:'"+cfg.dateFormat+"'";
            colDef.filterCellFiltered = true;
          }
          else if(colDef.type==="detalle"){
            colDef.cellTemplate = '<div class="ui-grid-cell-contents">';
            colDef.acciones = column.acciones;
            var numberActions = 0;
            column.acciones.forEach(function(accion,i){
				if(angular.isFunction(accion))
					colDef.cellTemplate += '<ix-accion-dynamic-grid index="'+i+'"></ix-accion-dynamic-grid>';
				else
					colDef.cellTemplate += '<ix-accion-grid index="'+i+'"></ix-accion-grid>';

              numberActions++;
            });
            colDef.cellTemplate += "</div>";
            colDef.width = (column.width) || (numberActions * 30);
            colDef.minWidth = (column.width) || (numberActions * 20);
            //colDef.enableFiltering = false;
            colDef.enableCellEdit = false;//La columna no és editable, prevenim que el valor es pugui modificar al fer doble click.

          } else if(colDef.type==="CheckBox"){
            colDef.cellTemplate = 'checkboxCell';
            colDef.filterHeaderTemplate = 'app/base/views/grid/checkBoxHeaderCell.html';
            colDef.enableCellEdit = false;
            colDef.control = "CheckBox";
						colDef.noeditable = column.NoEditable;
						if(column.beforeClick){ colDef.beforeClick = column.beforeClick }
            if(column.afterClick){ colDef.afterClick = column.afterClick }
            //colDef.cellClass = "text-center";
						colDef.isExtraColumn = true;
						if(column.ignoreCellModifications)colDef.ignoreCellModifications = true;
          } else {
            colDef.cellTemplate = colDef.type;
          }
          colDef.cellClass = gridOptions.getCellClass(colDef);
          colDef.NoFilterable = true;
          gridOptions.columnDefs.push(colDef);
        });
      };



      gridOptions.buildIxProjectionParam = function(){
        var IxProjectionParameter = { Selection: {Filters: [], OrderBy: [] }, Fields: [] };

        var visibleCols = getVisibleCols("name");
        //Excluim les columnes que vinguin marcades com VirtualVMField.
        var sortCols = gridOptions.gridApi.grid.columns.filter(function(c){return c.sort.priority>=0 && !c.colDef.VirtualVMField && !c.colDef.DisableOrder;}).sort(function(a,b){return a.sort.priority-b.sort.priority}).map(function(c){
            return buildOrderByCol(c);
          });

        IxProjectionParameter.Selection.OrderBy = sortCols;
        IxProjectionParameter.Fields = visibleCols;

        if(gridOptions.incloureCesta){
					//getCestaFilters(IxProjectionParameter.Selection, $filter, cfg, ixCestaVehiculosService.getCesta(), gridOptions.metadata);
					ixUtilsService.getCestaFilters(IxProjectionParameter.Selection, ixCestaVehiculosService.getCesta(), gridOptions.metadata);
				}
        getDefaultFilters(gridOptions.columnDefs, IxProjectionParameter.Selection, $filter, cfg);
        getLocalFilters(gridOptions.columnDefs, IxProjectionParameter.Selection, $filter);

				if (gridOptions.filtroExterno) {
					angular.forEach(gridOptions.filtroExterno, function (valor, filtro) {
						if(valor && typeof valor == "object"){
							if(angular.isDate(valor.Value)){
								valor.Value = $filter("date")(valor.Value, 'yyyy-MM-dd', null);
							}
							IxProjectionParameter.Selection.Filters.push(valor);
						} else {
							IxProjectionParameter.Selection.Filters.push({
								Field: filtro,
								Value: valor,
								Operator: CMP_EQ
							});
						}
					});
				}

        return IxProjectionParameter;
      };

	  
      gridOptions.getPivotRows = function(colsVisiblesPivot){
		var pivotRows=angular.copy(gridOptions.gridApi.grid.getVisibleRows().map(function (e) { return e.entity; }));
		
		return $http.get(cfg.baseURL+"fend_config/GetVisibleColumns?usuario="+authService.authentication.userName+"&clave="+gridOptions.gridName+"&entity="+gridOptions.metadataName).then(function(r){
			if (r.data){
				if(colsVisiblesPivot){
					angular.forEach(colsVisiblesPivot, function (key, value){
						r.data.push(value);
						if (r.data.indexOf(key) !=- 1)
							delete r.data.splice(r.data.indexOf(key), 1)});
				}
				angular.forEach(pivotRows, function(value, key){
					angular.forEach(value, function(valueRow, keyRow){
						if (r.data.indexOf(keyRow)===-1)
							delete value[keyRow]});
					})
				}

			return pivotRows; 		
		});
      };

      scope.leftMarkup = function(){
        return !gridOptions.enableRowSelection;
      };

	  	scope.conAlarma = function(row){
			if(angular.isDefined(gridOptions.compruebaAlarmaFunc))
				return gridOptions.compruebaAlarmaFunc(row);
			else
				return false;
		};	  

      scope.$on('gridsRefreshLanguage', function(){
        gridOptions.columnDefs.forEach(function(columnDef){
          columnDef.displayName = $translate.instant(gridUtil.readableColumnName(columnDef.field));
        });
        gridOptions.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      });

      var addSelectedOptionsToDropdown = function(column, colDef, row, data){
        //Afegim el registre marcat a la llista de opcions.
        var lastKeyField = column.Search.KeyFields[column.Search.KeyFields.length - 1];
        var lastLookUpKeyField = column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1];
        if(angular.isDefined(row.entity[lastKeyField])){
          //var selectedOptionId = row.entity[lastKeyField];
          //var selectedOption = colDef.allFkObjects.find(function(e){ return e[lastLookUpKeyField] == selectedOptionId; });

          var selectedOption = colDef.allFkObjects.find(function(e){
            var result = true;
            for(var i = 0; i < column.Search.KeyFields.length; i++){
              if(e[column.Search.LookUpKeyFields[i]] != row.entity[column.Search.KeyFields[i]]) result = false;
            }
            return result;
          });

          if(angular.isDefined(selectedOption)){
            var found = data.some(function(e) {
              return angular.equals(e,selectedOption) || e[lastLookUpKeyField] == row.entity[lastKeyField];
            });

            if(!found){
              data.push(selectedOption);
            }
          }
        }
      };

			var buildDropdownFilters = function(x, text, row){
				var param = {};
				var filtersConditions = x.Search.LookUpConditions.map(function(c){return {Field:c.KeyField,Value:c.Value,Operator:c.Operator||CMP_EQ,Not:(c.Not==true)};});

				var filtersKey = x.Search.LookUpKeyFields.map(function (c, ii, aa) {
				//Filtrem per clau composta només quan té valor.
				//var filtersKey = x.Search.LookUpKeyFields.filter(function(e, i){ return angular.isDefined(row.entity[x.Search.KeyFields[i]]) && row.entity[x.Search.KeyFields[i]] != null && i < x.Search.LookUpKeyFields.length - 1; }).map(function (c, ii) {
					if(ii!==x.Search.LookUpKeyFields.length-1) {
						// no importa l'ordre de les columnes, agafarà el valor que es demana per metadata
						// PREMISA: pos(KeyField)===pos(LookupKeyField).
						var tblName = "";
						if(!x.skipTableName && !scope.skipTableName && !gridOptions.skipTableName){
							tblName = x.Search.LookUpTableName+".";
						}
						return {Field: tblName + c, Value:row.entity[x.Search.KeyFields[ii]], Operator: CMP_EQ};
					}
				});
				filtersKey.pop();//Treiem l'últim valor de l'array. Després del map, a la ultima posició tenim null.
				if(text) {
					var filtersDesc = x.Search.LookUpResultFields.map(function(c,i,a){return {StartPar:i===0, Or: i>0, Field:c,Value:text,Operator:CMP_LIKE, EndPar:i==a.length-1, Skip: x.Skip };});
					param.Filters = filtersKey.concat(filtersDesc).concat(filtersConditions);
				} else {
					param.Filters = filtersKey.concat(filtersConditions);
				}
				//Agafem tots els filtres de filtroExterno i els passem al Search.
				if(gridOptions.enviaParamsFiltroExterno){
					param.Filters = [];
					angular.forEach(gridOptions.filtroExterno, function (valor, filtro) {
						if(angular.isFunction(valor.Value)){
							param.Filters.push({ Field: valor.Field, Value: valor.Value(), Operator: valor.Operator });
						} else {
							param.Filters.push(valor);
						}
					});
				} else if(angular.isDefined(x.conditions) && x.conditions.length > 0){
					angular.forEach(x.conditions, function (condition){
						var filtroExternoCondition = gridOptions.filtroExterno.find(function(e){
							var parts = e.Field.split('.');
							var stringToEval = parts[parts.length-1];
							return stringToEval.toLowerCase() == condition.toLowerCase();
						});
						if(angular.isDefined(filtroExternoCondition)){
							var copyFiltro = angular.copy(filtroExternoCondition);
							var parts = copyFiltro.Field.split('.');
							copyFiltro.Field = parts[parts.length-1];
							param.Filters.push(copyFiltro);
						}
					});
				}

				if(angular.isDefined(x.extraConditions) && x.extraConditions.length > 0){
					x.extraConditions.forEach(function(extraCondition){
						param.Filters.push(extraCondition);
					});
				}

				//if(!x.skipTableName && !scope.skipTableName && !gridOptions.skipTableName){
				var tblName = "";
				if(!x.skipTableNameForDropdown){
					if(x.TableAliasName)
						tblName = x.TableAliasName + ".";
					else if(!x.skipTableName)
						tblName = (!gridOptions.enviaParamsFiltroExterno ? (x.Search.LookUpTableName + ".") : "");
				}

				param.OrderBy = x.Search.LookUpOrders.map(function (o) {return (o.Desc ? "-" : "") + tblName + o.KeyField;});
				//} else {
					//param.OrderBy = x.Search.LookUpOrders.map(function (o) {return (o.Desc ? "-" : "") + o.KeyField;});
				//}

				return param;
			};
			
			var buildDropdownExtraFilters = function(param, x, text, row){
				if(gridOptions.enviaParamsFiltroExterno){
					param.Filters = [];
					angular.forEach(gridOptions.filtroExterno, function (valor, filtro) {
						if(angular.isFunction(valor.Value)){
							param.Filters.push({ Field: valor.Field, Value: valor.Value(), Operator: valor.Operator });
						} else {
							param.Filters.push(valor);
						}
					});
				} else if(angular.isDefined(x.conditions) && x.conditions.length > 0){
					angular.forEach(x.conditions, function (condition){
						var filtroExternoCondition = gridOptions.filtroExterno.find(function(e){
							var parts = e.Field.split('.');
							var stringToEval = parts[parts.length-1];
							return stringToEval.toLowerCase() == condition.toLowerCase();
						});
						if(angular.isDefined(filtroExternoCondition)){
							var copyFiltro = angular.copy(filtroExternoCondition);
							var parts = copyFiltro.Field.split('.');
							copyFiltro.Field = parts[parts.length-1];
							param.Filters.push(copyFiltro);
						}
					});
				}

				if(angular.isDefined(x.extraConditions) && x.extraConditions.length > 0){
					x.extraConditions.forEach(function(extraCondition){
						param.Filters.push(extraCondition);
					});
				}
				return param;
			};

			var getRealName = function(col){
				if(gridOptions.realVsAliasName){
					angular.forEach(gridOptions.realVsAliasName, function(value, key){
						if(value == col)
							col = key;
					});
				}
				return col;
			};

			var getVisibleCols = function(returnProperty){
				var visibleCols = gridOptions.gridApi.grid.columns.filter(function(e){ return e.visible!==false && e.colDef.isExtra!==true && e.displayName!==""});
				if(angular.isDefined(returnProperty))
					visibleCols = visibleCols.map(function(e){return { Field: (e[returnProperty]) } });

				return visibleCols;
			};

			var getNoVisibleCols = function(returnProperty){
				var noVisibleCols = gridOptions.gridApi.grid.columns.filter(function(e){ return e.visible==false && e.field != "virtualOrderColumn" });
				if(angular.isDefined(returnProperty))
					noVisibleCols = noVisibleCols.map(function(e){return { Field: (e[returnProperty]) } });

				return noVisibleCols;
			};

			var addAccionTooltipInPopup = function(extraColumns){
				var columnaAcciones = extraColumns.find(function(e){ return e.type == "detalle"; });

				var accionDataInPopup = {
					icon: "fa-window-maximize",
					title: "Ver información en popup",
					accion: function(entity){
						var template = "app/base/views/framework_templates/ixTooltipPopup.html";
						var options = { controller: "TooltipPopupController" };
						var params = { texto: gridOptions.cellTooltipFunction({ entity: entity }) };
						ixUtilsService.openModalV2(template, options, "small", params);
					}
				};

				if(angular.isDefined(columnaAcciones))
					columnaAcciones.acciones.push(accionDataInPopup);
				else {
					columnaAcciones = { name: 'Acciones', type: 'detalle', acciones: [ accionDataInPopup ] };
					extraColumns.push(columnaAcciones);
				}
			};

      gridOptions.applyOriginallySortedColumns = function(){
        var sortedColumns = gridOptions.gridApi.grid.columns.filter(function(e){ return (Object.keys(e.sort)).length > 0; });
        sortedColumns.forEach(function(column){ column.sort = {}; });

        angular.forEach(gridOptions.originalGridOrder, function(sortedColumn){
          var col = gridOptions.gridApi.grid.columns.find(function(e){ return e.field.toUpperCase() == sortedColumn.field.toUpperCase(); });
          if(angular.isDefined(col)){
            col.sort = sortedColumn.sort;
          }
        });
      };

      gridOptions.applyCurrentlySortedColumns = function(){
        var sortedColumns = gridOptions.gridApi.grid.columns.filter(function(e){ return (Object.keys(e.sort)).length > 0; });
        sortedColumns.forEach(function(column){ column.sort = {}; });
        var virtualOrderColumn = gridOptions.gridApi.grid.columns.find(function(e){ return e.field.toUpperCase() == "VIRTUALORDERCOLUMN"; });
        virtualOrderColumn.sort = { priority: 0, direction: "asc" };
      };

			gridOptions.hasPropertyModified = function(row, property){
				var isModified = false;
				if(angular.isDefined(property)){
					isModified = ((angular.isDefined(row.entity.modifiedValues)) && row.entity.modifiedValues.indexOf(property) != -1);
				}
				else {
					isModified = ((angular.isDefined(row.entity.modifiedValues)) && row.entity.modifiedValues.length > 0);
				}
				return isModified;
			};

			gridOptions.addToModifiedValues = function(field){
				if(!gridOptions.gridApi.clickedRowObj.entity.modifiedValues)
					gridOptions.gridApi.clickedRowObj.entity.modifiedValues = [];

				gridOptions.gridApi.clickedRowObj.entity.modifiedValues.push(field);
			};

			gridOptions.clearFocus = function(){
				if(this.gridApi.grid.cellNav){
					this.gridApi.grid.cellNav.clearFocus();
					this.gridApi.grid.cellNav.lastRowCol = null;
				}
			};

			gridOptions.loadConfig = function(){
        var storedConfig = gridConfigService.getConfig(gridOptions.gridName);
        if(storedConfig != ""){
            var restoreConfig = $interval(function(){
              if(angular.isDefined(gridOptions.gridApi)){
                $interval.cancel(restoreConfig);
                if(storedConfig != null){
					storedConfig = gridOptions.ixShowFilteredFields(gridOptions.metadata, storedConfig);
                  gridOptions.gridApi.saveState.restore(scope, storedConfig);
                  gridOptions.ixSaveConfig();
                  gridOptions.ixRestoreConfig();
                }
                gridOptions.ixIsLoading = false;
                if(!scope.gridManualLoad){
                  gridOptions.ixLoadInitialData();
                }
								scope.$emit('gridConfigLoaded');
              }
            },200);
        } else {
          $http.get(cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave="+gridOptions.gridName).then(function(r){
						var restoreConfigIni = $interval(function(){
							if(angular.isDefined(gridOptions.gridApi)){
                $interval.cancel(restoreConfigIni);
								if(r.data) {
									//Recupera l'estat
									var fend_config_user = gridOptions.ixShowFilteredFields(gridOptions.metadata, angular.fromJson(r.data.valor));
									gridOptions.gridApi.saveState.restore(scope, fend_config_user);
								}
								//El guarda a l'objecte
								gridOptions.ixSaveConfig();
								//El recupera per aplicar filtres correctament
								gridOptions.ixRestoreConfig();
								//gridConfigService.saveConfig(gridOptions.gridName, null);
								gridOptions.ixIsLoading = false;
								if(!scope.gridManualLoad){
									gridOptions.ixLoadInitialData();
								}
								scope.$emit('gridConfigLoaded');
							}
						},200);

          });
        }
			};

			gridOptions.crearColumnasHoraCamposDateAndTime = function(metadata){
				var columnasDateAndTime = metadata.filter(function(e){ return e.DateAndTime === true; });
				angular.forEach(columnasDateAndTime, function(columna){
					var columna_hora = angular.copy(columna);
					columna_hora.DateAndTime = false;
					columna_hora.Type = "string";
					columna_hora.Control = "ixTime";
					columna_hora.Filter = null;
					columna_hora.OnChangeAlsoUpdate = columna_hora.Name;
					columna_hora.ColumnDescription = columna_hora.Name.replace("fecha","hora");
					columna_hora.Name = ixUtilsService.getNameColumnaInventadaAsociada(columna.Name);
					columna_hora.VirtualVMField = true;

					metadata.splice((metadata.indexOf(columna)+1), 0, columna_hora);
				});
			};

			gridOptions.obtenerTiempoCamposDateAndTime = function(filas){
				if(angular.isDefined(gridOptions.metadata)){
					var camposTiempoDependientes = gridOptions.metadata.filter(function(e){ return angular.isDefined(e.OnChangeAlsoUpdate); });
					angular.forEach(camposTiempoDependientes, function(campoDependiente){
						var campoAActualizar = campoDependiente.OnChangeAlsoUpdate;
						var campoPrincipal = gridOptions.metadata.find(function(e){ return e.Name == campoAActualizar; });
						if((angular.isDefined(campoPrincipal)) && campoPrincipal.Type == "DateTime" && campoPrincipal.DateAndTime){
							filas.forEach(function(fila){
								fila[campoDependiente.Name] = $filter("date")(fila[campoPrincipal.Name], "HH:mm:ss", null);
							});
						}
					});
				}
			};

			gridOptions.actualizarCampoDateAndTime = function(row, colDef, value){
				var campoPrincipal = gridOptions.metadata.find(function(e){ return e.Name == colDef.OnChangeAlsoUpdate; });
				if((angular.isDefined(campoPrincipal)) && campoPrincipal.Type == "DateTime"){
					var date = row[campoPrincipal.Name];
					var partsTime = value.split(":");
					var hours = partsTime[0];
					var minutes = partsTime[1];
					var seconds = partsTime[2];
					date.setHours(hours, minutes, seconds);

					if(angular.isUndefined(row.modifiedValues))
						row.modifiedValues = [];
					if(row.modifiedValues.indexOf(campoPrincipal.Name) == -1)
						row.modifiedValues.push(campoPrincipal.Name);
					if(row.modifiedValues.indexOf(colDef.field) != -1)
						row.modifiedValues.splice(row.modifiedValues.indexOf(colDef.field), 1);
				}
			};

			gridOptions.getDateAndTimeFieldNames = function(){
				return gridOptions.metadata.filter(function(e){ return e.DateAndTime; }).map(function(x){ return x.Name; });
			};


			gridOptions.defineSetDropdownValueAfterLoad = function(colDef){
				colDef.setDropdownValueAfterLoad = function(colDef, isNewRow){
					if((angular.isDefined(gridOptions.data)) && gridOptions.data.length > 0){
						var keyFieldsToGenerate = [];
						var fieldsToGenerate = [];
						colDef.LookUpKeyFields.forEach(function(field){
							if(keyFieldsToGenerate.indexOf(field) == -1){
								keyFieldsToGenerate.push(field);
							}
						});
						colDef.LookUpResultFields.forEach(function(field){
							if(fieldsToGenerate.indexOf(field) == -1){
								fieldsToGenerate.push(field);
							}
						});

						gridOptions.data.forEach(function(row){
							var obj = {};
							var filteredOptions;
							for(var i = 0; i < keyFieldsToGenerate.length; i++){
								if(angular.isUndefined(filteredOptions)){
									filteredOptions = colDef.allFkObjects.filter(function(e){ return e[keyFieldsToGenerate[i]] == row[colDef.KeyFields[i]]; });
								}
								else {
									filteredOptions = filteredOptions.filter(function(e){ return e[keyFieldsToGenerate[i]] == row[colDef.KeyFields[i]]; });
								}
							}

							if(angular.isDefined(filteredOptions) && filteredOptions.length == 0){
								if(keyFieldsToGenerate.length > 1){
									for(i = 0; i < keyFieldsToGenerate.length - 1; i++){
										obj[keyFieldsToGenerate[i]] = row[colDef.KeyFields[i]];
									}
								}
								for(i = 0; i < fieldsToGenerate.length; i++){
									if(i == (fieldsToGenerate.length - 1)){
										obj[fieldsToGenerate[i]] = row[colDef.field];
									} else {
										obj[fieldsToGenerate[i]] = row[colDef.ColumnFkDescription[i]];
									}
								}
								if(colDef.allFkObjects.indexOf(obj) == -1 && isNewRow){
									//Comprovar que té clau / valor definits i amb valor, si no farem el Get corresponent.
									var hasKeyValue = true;
									var hasValue = true;
									angular.forEach(colDef.LookUpResultFields, function(lookUpResultField, idx){
										hasKeyValue = (hasKeyValue && angular.isDefined(obj[lookUpResultField]));
										if(idx == colDef.LookUpResultFields.length - 1)
											//hasValue = angular.isDefined(obj[lookUpResultField]);
											hasValue = (angular.isDefined(obj[lookUpResultField]) && obj[lookUpResultField] != null);
									});

									if(hasKeyValue){
										colDef.allFkObjects.push(obj);
									} else if(hasValue) {
										var getParams = "";
										angular.forEach(colDef.LookUpKeyFields, function(lookupkeyField){
											getParams += obj[lookupkeyField] + "/";
										});
										$http.get(cfg.baseURL + colDef.LookUpTableName + "/" + getParams, { headers: { multipleCalls: true } }).then(function(response){
											delete response.data.ContextID;
											colDef.allFkObjects.push(response.data);																																
											scope.$broadcast("gridfkUpdate");
										}, function(err){
											ixStatusService.setResponse(err);
										});
									}
								} else {
									colDef.allFkObjects.push(obj);
								}
							}
						});
					}
					if((colDef.editDropdownOptionsArray.length == 0) || ((colDef.editDropdownOptionsArray.length == 1) && colDef.editDropdownOptionsArray[0] == "") )
						colDef.editDropdownOptionsArray = angular.copy(colDef.allFkObjects);
				};
			};

			return gridOptions;
		}

	};
	return gridServiceInstance;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';
angular.module('gp4App').factory('gridConfigService', ['$http', '$q', 'cfg', '$log', '$timeout', function ($http, $q, cfg, $log, $timeout) {
  var gridConfigService = {};
  var _getConfig = function(nombre){
    var config = sessionStorage[nombre];
    return (angular.isDefined(config)) ? angular.fromJson(config) : "";
  };

  var _saveConfig = function(nombre, config){
    sessionStorage[nombre] = angular.toJson(config);
    return true;
  };

  var _clearGridMetadata = function(){
    angular.forEach(sessionStorage, function(item, key){
      if(key.lastIndexOf("-metadata") !== -1){
        sessionStorage.removeItem(key);
      }
    });
  };

  gridConfigService.getConfig = _getConfig;
  gridConfigService.saveConfig = _saveConfig;
  gridConfigService.clearGridMetadata = _clearGridMetadata;

  return gridConfigService;
}]);

/*global ixNewDate*/
/*global moment*/
angular.module("gp4App").factory("dateService", [ 'cfg', '$filter', function(cfg, $filter){
	var service = {};

	service.fillDate = function(valor){
		var newVal = valor;
		var dateParts = newVal.split(/[\/\.\- '\+]{1}/);

		//var now = new Date();
		var now = ixNewDate(cfg,moment);
		var day = now.getDate();
		var month = now.getMonth() + 1;
		var year = now.getFullYear();

		if(dateParts.length==1) {
			if(dateParts[0].length==0) {
				valor = null;
				return valor;
			}
			day = dateParts[0].slice(0,2);
			if(dateParts[0].length>2) {
				month = dateParts[0].slice(2,4)
			}
			if(dateParts[0].length>4) {
				year = dateParts[0].slice(4,8);
			}
		}

		if(dateParts[0].length>0 && dateParts[0].length<=2) {
			day = dateParts[0];
		}
		if(dateParts.length>1 && dateParts[1].length>0) {
			month = dateParts[1];
		}
		if(dateParts.length>2 && dateParts[2].length>0) {
			year = dateParts[2];
		}

		if(year.length<=2) {
			// si sintrodueix l'any en 2 dígits, el passem al segle que correspon
			year = parseInt(year) + (now.getFullYear()-(now.getFullYear()%100));
		}

		valor = ixNewDate(cfg,moment, day, month-1, year);

		return valor;
	};
	service.dateToString = function(dateObj){
		return $filter("date")(dateObj, cfg.dateFormat);
	}
	return service;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';
angular.module('gp4App').factory('configuracionesCacheService', [ 'cfg', '$http', '$log', function(cfg, $http, $log){
  var serviceInstance = {};
    var _cache = {};

    var _load = function(etiqueta){
      if(angular.isObject(etiqueta)){//Els arrays son objectes
        return $http.post(cfg.baseURL + "configuraciones/GetConfigMultiple/", etiqueta).then(function(response){
          return response.data;
        });
      } else {
        return $http.get(cfg.baseURL + "configuraciones/GetConfig/" + etiqueta).then(function(response){
          return response.data;
        });
      }
    };

    serviceInstance.get = function(etiqueta){
      if(angular.isUndefined(_cache[etiqueta]))
        _cache[etiqueta] = _load(etiqueta);
      
      return _cache[etiqueta]; 
    };

    serviceInstance.reset = function(){
      //No es fa servir enlloc pero la deixo definida per si es vol fer servir.
      //Buida la cache. Si no l'unica manera de que es buidi es tancar pestanya de navegador.
      _cache = {};
    };

  return serviceInstance;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';
angular.module('gp4App').factory('authService', ['$http', '$q', 'cfg', '$log', '$timeout', 'gridConfigService', 'moment', '$location', '$window', '$rootScope', function ($http, $q, cfg, $log, $timeout, gridConfigService, moment, $location, $window, $rootScope) {

    //var serviceBase = cfg.baseAuthURL;
    var authServiceFactory = {};

    var _authentication = {
        isAuth: false,
        userName: "",
        language: "",
        domain: "",
				timeDiff: "",
        errorLogin: ""
    };

    var _login = function (loginData) {
        var data =
            "grant_type=password" +
            "&username=" + encodeURIComponent(loginData.userName.toLowerCase()) +
            "&password=" + encodeURIComponent(loginData.password) +
            "&client_id=" + encodeURIComponent(cfg.clientId);

        if (loginData.domain) {
            data += "&domain=" + encodeURIComponent(loginData.domain);
        }

        if (loginData.recaptchaToken) {
            data += "&recaptcha_token=" + encodeURIComponent(loginData.recaptchaToken);
        }

        if (loginData.azureToken) {
            data += "&azure_token=" + encodeURIComponent(loginData.azureToken);
        }      
      
        //TODO: Afegir el timeDiff a data per enviar-ho a la API.

        var deferred = $q.defer();

        _authentication.errorLogin = {"error_description":"Procesando login..."};
        $rootScope.$broadcast('login-error');
        $http.post(cfg.baseAuthURL + 'token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (responseData) {
          var response = responseData.data;
          _authentication.errorLogin = "";
          $rootScope.$broadcast('login-error');
          $log.log("Login OK", response);
          loginData.userName = response.userName;
          //localStorage['gp4App.cfg'] = angular.toJson(cfg);
          //localStorage['authorizationData'] = angular.toJson({ token: response.access_token, userName: loginData.userName, language: response.language, refreshToken: response.refresh_token});
          /*var fechaActual = new Date();
          var expirationTime = fechaActual.setHours(fechaActual.getHours() + 8);
          localStorage['expirationTime'] = expirationTime;*/

          _authentication.isAuth = true;
          _authentication.userName = loginData.userName;
          _authentication.domain = loginData.domain;
          _authentication.language = response.language;

          if(angular.isDefined(cfg.serverTimeZone)){
            var now = moment.utc();
            var clientTZ = moment.tz.guess();

            var client_tz_offset = moment.tz.zone(clientTZ).utcOffset(now);
            var server_tz_offset = moment.tz.zone(cfg.serverTimeZone).utcOffset(now);
            // calculate the difference in hours
            var difference = ((client_tz_offset - server_tz_offset) / 60);

            if(angular.isDefined(difference)){
              _authentication.timeDiff = difference * -1;
              cfg.timeDiff = difference * -1;
            }
          }
					
					var currentApp = $location.absUrl();
					if(currentApp.indexOf("/login") != -1)
						currentApp = currentApp.substring(0, currentApp.indexOf("/login"));
					if(currentApp.lastIndexOf("/") == currentApp.length - 1)
						currentApp = currentApp.substring(0, currentApp.length - 1);
					cfg.appURL = currentApp;

          sessionStorage['gp4App.cfg'] = angular.toJson(cfg);
          sessionStorage['authorizationData'] = angular.toJson({ token: response.access_token, userName: loginData.userName, language: response.language, refreshToken: response.refresh_token, timeDiff: _authentication.timeDiff, twoFARequired: response["2FA_required"]});

          deferred.resolve(response);

        }, function (errData, status) {
          var err = errData.data;
          _authentication.errorLogin = err;
          $rootScope.$broadcast('login-error');
          $log.log("error on login in authService",err, status);
          _logOut();
          deferred.reject(err);
        });
        return deferred.promise;

    };

    var _login2FA = function (twoFaToken)
    { 
      var deferred = $q.defer();
      var authData = angular.fromJson(sessionStorage['authorizationData']);
      $log.log("method 2FA token from auth service", authData);
      if (authData) {
        $log.log("try to 2FA token");
        sessionStorage['authorizationData'] = angular.toJson(authData);
        var data = "grant_type=refresh_token&refresh_token=" + encodeURIComponent(authData.refreshToken) + "&client_id=" + encodeURIComponent(cfg.clientId)+"&2fa_token="+encodeURIComponent(twoFaToken);
        return $http.post(cfg.baseAuthURL + 'token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          $log.log("return OK from token (storing new token)",response);            
          sessionStorage['authorizationData'] = angular.toJson({ token: response.data.access_token, userName: response.data.userName, language: response.data.language, refreshToken: response.data.refresh_token, timeDiff: cfg.timeDiff });
          authData = angular.fromJson(sessionStorage['authorizationData']);
          authData.refreshing=false;
          return response.data;
        });        
      } else {
        $log.log("No stored token");
        _logOut();
        deferred.reject("No stored token");
      }

      return deferred.promise;
    };

    var _logOut = function () {
      gridConfigService.clearGridMetadata();
      var keys = Object.keys(sessionStorage);
      angular.forEach(keys, function(key){
        if(key != "gp4App.cfg")
          delete sessionStorage[key];
      });
    
      _authentication.isAuth = false;
      _authentication.userName = "";
      _authentication.domain = "";
      _authentication.language = "";
      _authentication.timeDiff = "";
      _authentication.appURL = "";

    };

    var _fillAuthData = function () {

        //var authData = angular.fromJson(localStorage['authorizationData']);
        var authData = angular.fromJson(sessionStorage['authorizationData']);
        if (authData) {
          _authentication.isAuth = true;
          _authentication.userName = authData.userName;
          _authentication.domain = authData.domain;
          _authentication.language = authData.language;
          _authentication.timeDiff = authData.timeDiff;
        }

    };

    var _refreshToken = function ()
    {
        var deferred = $q.defer();

        //var authData = angular.fromJson(localStorage['authorizationData']);
        var authData = angular.fromJson(sessionStorage['authorizationData']);

        $log.log("method refresh token from auth service", authData);


        if (authData) {
					$log.log("test if refreshing");
					if(authData.refreshing) {
						//El codi que hi ha dintre, waitforawhile.resolve, waitforawhile.reject, fa que si l'usuari te una connexio lenta, el tiri cap a la pantalla de login quan fa el refreshToken.
						$log.log("token is already refresing, let's wait 5 seconds", new Date());
						var waitforawhile = $q.defer();
						$timeout(function () {
							//authData = angular.fromJson(localStorage['authorizationData']);
							authData = angular.fromJson(sessionStorage['authorizationData']);
							$log.log("after 5 seconds, token refreshing is ", authData, new Date());
							if(authData && authData.token) {
								waitforawhile.resolve("token should be refreshed now");
							} else {
								waitforawhile.reject("token not refreshed in 5 seconds");
							}
  					}, 5000);
  					return waitforawhile.promise;
					} else {
						$log.log("try to refresh token");
						authData.refreshing=true;
						//localStorage['authorizationData'] = angular.toJson(authData);
						sessionStorage['authorizationData'] = angular.toJson(authData);
						var data = "grant_type=refresh_token&refresh_token=" + encodeURIComponent(authData.refreshToken) + "&client_id=" + encodeURIComponent(cfg.clientId);
						return $http.post(cfg.baseAuthURL + 'token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
							$log.log("return OK from token (storing new token)",response);
							//localStorage['authorizationData'] = angular.toJson({ token: response.data.access_token, userName: response.data.userName, language: response.data.language, refreshToken: response.data.refresh_token });
							sessionStorage['authorizationData'] = angular.toJson({ token: response.data.access_token, userName: response.data.userName, language: response.data.language, refreshToken: response.data.refresh_token, timeDiff: cfg.timeDiff });
							//authData = angular.fromJson(localStorage['authorizationData']);
							authData = angular.fromJson(sessionStorage['authorizationData']);
							authData.refreshing=false;
							return response.data;
						});
					}
        } else {
        	$log.log("No stored token");
        	deferred.reject("No stored token");
        }

        return deferred.promise;
    };

		var _compruebaAccionDenegada = function(url, accion){
			//return $http.get(cfg.baseURL + "fend_acciones_perfiles/AccionDenegada?url=" + url + "&accion=" + accion);
      return Promise.resolve(false); // Biotecnal: por el momento no tenemos la tabla fend_acciones_perfiles, no denegamos acciones
		};
		var _tienePerfilAdmin = function(){
			return (_authentication.perfiles.indexOf("ixnet") != -1);
		};
		var _tienePerfilUserKey = function(){
			var tiene = false;
			for(var i = 0; i < _authentication.perfiles.length; i++){
				var perfil = _authentication.perfiles[i];
				tiene = perfil.indexOf("userkey") !== -1;
				if(tiene)
					break;
			}
			return tiene;
		};
    var _perfilesUsuario = function(){
			return _authentication.perfiles;
		};    
		var _tieneModuloLMS = function(){
			return ((cfg.modules) && cfg.modules.indexOf("LMS") != -1);
		};
    authServiceFactory.login = _login;
    authServiceFactory.logOut = _logOut;
    authServiceFactory.fillAuthData = _fillAuthData;
    authServiceFactory.authentication = _authentication;
    authServiceFactory.refreshToken = _refreshToken;
		authServiceFactory.compruebaAccionDenegada = _compruebaAccionDenegada;
		authServiceFactory.tienePerfilAdmin = _tienePerfilAdmin;
    authServiceFactory.perfilesUsuario = _perfilesUsuario;
		authServiceFactory.tienePerfilUserKey = _tienePerfilUserKey;
		authServiceFactory.tieneModuloLMS = _tieneModuloLMS;
    authServiceFactory.login2FA = _login2FA;

    return authServiceFactory;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';
angular.module('gp4App').factory('authInterceptorService', ['$rootScope', '$q', '$injector','$location', '$log', 'moment', function ($rootScope, $q, $injector,$location,$log,moment) {

    var authInterceptorServiceFactory = {};
		var requestsPending = [];


		var formatDatesToServerTime = function(data, alsoSendTime){
			if (!angular.isObject(data)) {
				return data;
			}
			var key = "";
			for (key in data) {
				if (!data.hasOwnProperty(key)){ continue; }

				var value = data[key];
				if(angular.isDate(value)){
					var originalDate = new Date(value);

					var year = originalDate.getFullYear();
					var month = (originalDate.getMonth()+1);
					if(month < 10)
						month = "0" + month;

					var day = originalDate.getDate();
					if(day < 10)
						day = "0" + day;

					/*var hours = originalDate.getHours();
					if(hours < 10)
						hours = "0" + hours;

					var minutes = originalDate.getMinutes();
					if(minutes < 10)
						minutes = "0"+minutes;

					var seconds = originalDate.getSeconds();
					if(seconds < 10)
						seconds = "0"+seconds;*/

					var cfg = $injector.get('cfg');

					var tzServer = moment(originalDate).tz(cfg.serverTimeZone).format("ZZ");

					if(key.lastIndexOf("instante") != -1)
						data[key] = moment(originalDate).format("YYYY-MM-DD") +"T" + moment(originalDate).format("HH:mm:ss") + tzServer;
					else if((!alsoSendTime) || ((angular.isArray(alsoSendTime)) && alsoSendTime.length == 0)){
//						data[key] = moment(originalDate).tz(cfg.serverTimeZone).format("YYYY-MM-DD") +"T00:00:00"+ tzServer;
						data[key] = moment(originalDate).format("YYYY-MM-DD") +"T00:00:00"+ tzServer;
					} else {
						if(angular.isArray(alsoSendTime)){
							if(data.path){
								if(alsoSendTime.indexOf(data.path.substring(1)) == -1)
//									data[key] = moment(originalDate).tz(cfg.serverTimeZone).format("YYYY-MM-DD") +"T00:00:00"+ tzServer;
									data[key] = moment(originalDate).format("YYYY-MM-DD") +"T00:00:00"+ tzServer;
								else
//									data[key] = moment(originalDate).tz(cfg.serverTimeZone).format("YYYY-MM-DD") +"T" + moment(originalDate).format("HH:mm:ss") + tzServer;
									data[key] = moment(originalDate).format("YYYY-MM-DD") +"T" + moment(originalDate).format("HH:mm:ss") + tzServer;
							}
							else if(alsoSendTime.indexOf(key) != -1)
//								data[key] = moment(originalDate).tz(cfg.serverTimeZone).format("YYYY-MM-DD") +"T" + moment(originalDate).format("HH:mm:ss") + tzServer;
								data[key] = moment(originalDate).format("YYYY-MM-DD") +"T" + moment(originalDate).format("HH:mm:ss") + tzServer;
							else
//								data[key] = moment(originalDate).tz(cfg.serverTimeZone).format("YYYY-MM-DD") +"T00:00:00"+ tzServer;
								data[key] = moment(originalDate).format("YYYY-MM-DD") +"T00:00:00"+ tzServer;
						}
						else
//							data[key] = moment(originalDate).tz(cfg.serverTimeZone).format("YYYY-MM-DD") +"T" + moment(originalDate).format("HH:mm:ss") + tzServer;
							data[key] = moment(originalDate).format("YYYY-MM-DD") +"T" + moment(originalDate).format("HH:mm:ss") + tzServer;
					}

				} else if (angular.isObject(value)) {
					// Recurse into object
					formatDatesToServerTime(value, alsoSendTime);
				}
			}
			return data;
		}
	var _tieneLlamadasPendientes = function(path){
		return (requestsPending.indexOf(path) != -1);
	}

    var _request = function (config) {
        config.headers = config.headers || {};
        //var authData = angular.fromJson(localStorage['authorizationData']);
        var authData = angular.fromJson(sessionStorage['authorizationData']);

				var cfg = $injector.get('cfg');

				var requestRepetida = false;
				
				var baseAuthURL = cfg.baseAuthURL;
				if(baseAuthURL != null) {
					baseAuthURL = cfg.baseAuthURL.replace(/^((?:https?:)?\/\/)(.*)$/, function(match, protocol, rest) {
						return protocol + rest.replace(/\/{2,}/g, '/');
					});
				}
				
				if(tienePathAPI(baseAuthURL, config.url)){
					if(soloPermitimosUnaLlamada(config.url)){
						if(requestsPending.indexOf(config.url) == -1)
							requestsPending.push(config.url);
						else
							requestRepetida = true;
					}
				}

				if(!requestRepetida || config.headers.multipleCalls){
					if (authData && authData.token && config.url.lastIndexOf(cfg.baseURL) != -1) {//Nomes enviem el token de la nostra API quan les peticions vagin contra ella
						config.headers.Authorization = 'Bearer ' + authData.token;
						config.headers.TimeDiff = authData.timeDiff;
					}

					if(cfg.logApiCalls && config.url.indexOf(cfg.baseURL)==0) {
						$log.log("API request" , config.method+ " " + config.url, config);
					}

		  			/* BIOTECNAL: no convertir fechas

					//AMP20200825: He fet la assignacio de l'objecte resultant a config.data. Hi havia el copy pero aixo fa que s'acabi enviant l'objecte original.
					//Si donés alguna mena de problema amb els controls de data pel two way data binding pel fet de manipular els valors, hauriem de crear una variable configAux i treballar amb ella.
					if(angular.isDefined(config.data) && config.dataType != "json"){
						if (config.url.indexOf("lms_")!=-1  || true)   
							config.AlsoSendTime=true;
						config.data = formatDatesToServerTime(angular.copy(config.data), config.AlsoSendTime);

					}

					*/
					return config;
				} else {
					$log.log("Descartamos API request, ya hay una pendiente" , config.method+ " " + config.url, config);
					return $q.reject(config);
				}
    }

    var _response = function (response) {
        var cfg = $injector.get('cfg');

				if(tienePathAPI(cfg.baseAuthURL, response.config.url)){
					if(soloPermitimosUnaLlamada(response.config.url)){
						var idx = requestsPending.indexOf(response.config.url);
						if(idx != -1)
							requestsPending.splice(idx, 1);
					}
				}

        if(cfg.logApiCalls && response.config.url.indexOf(cfg.baseURL)==0) {
        	$log.log("API response" , response.config.method+ " " + response.config.url, response);
        }
        return response;
    }


    var _responseError = function (rejection) {
		//var isTemplate = !!rejection.config.url.match(/^content/g);
		// para cuando Descartamos API request si ya hay una pendiente
        if(!rejection.config && rejection.url) {
            rejection = {config: rejection};
        }
		var isTemplate = (rejection.config.url.indexOf(".html") != -1/* && rejection.status == 404 && rejection.statusText == "Not Found"*/);
       	if (isTemplate) {
			//rejection.data = '<div><template-error url="\''+ (rejection.config.url) + '\'"><strong>Error from interceptor.</strong></template-error></div>';
			$log.log("Template no encontrado: " + rejection.config.url);
         	return rejection;
       	} else {
			var textDecoder = new TextDecoder('utf-8'); // your encoding may vary!
        	
			var cfg = $injector.get('cfg');
			var url = angular.isDefined(rejection.config) ? rejection.config.url : rejection.url;
			if(tienePathAPI(cfg.baseAuthURL, url)){
				if(soloPermitimosUnaLlamada(url)){
					var idx = requestsPending.indexOf(url);
					if(idx != -1)
						requestsPending.splice(idx, 1);
				}
			}
			if(angular.isDefined(rejection.status)){
				var authService = "";
				var authData = "";
				if (rejection.status === 401) {
					authService = $injector.get('authService');
					//var authData = angular.fromJson(localStorage['authorizationData']);
					authData = angular.fromJson(sessionStorage['authorizationData']);
					var $http = $injector.get('$http');

								$log.log("got a 401 error", authData, rejection);
					if (authData) {
						if(authData.token) {
							delete authData.token;
							sessionStorage['authorizationData'] = angular.toJson(authData);
							$log.log("deleted old access token and saving in sessionStorage",authData)
						}

						$log.log("using refresh_token", authData);
						return authService.refreshToken().then(function(r){
							$log.log("token refreshed", r,"relaunch revious rejected request", rejection.config);
							//rejection.config.headers.Authorization = 'Bearer ' + r.data.access_token;
							return $http(rejection.config);
						}, function(e) {
							$log.error("refresh token failed", e);
							$rootScope.$broadcast("userLoggedOut");
							$location.path('/login');
							return $q.reject(rejection);
						});
            } else {
                $log.error("no auth data stored going to /login");
                $rootScope.$broadcast("userLoggedOut");
                $location.path('/login');
            }
		} else if(rejection.status === 403) {
			var authService2 = $injector.get('authService');
			var authData2 = angular.fromJson(sessionStorage['authorizationData']);
			$log.log("got a 403 error", authData2, rejection);
			if (authData2) {
				if(authData2.twoFARequired === true || authData2.twoFARequired === 1 || authData2.twoFARequired === "1") {
					$log.error("token invalid, required 2FA");
					$rootScope.$broadcast("userLoggedOut");
					$location.path('/login');
				} else {
					$log.error("API response error "+rejection.status+" at "+rejection.config.method+" "+rejection.config.url , rejection);
				}
					} else {
						$log.error("no auth data stored going to /login");
						$rootScope.$broadcast("userLoggedOut");
						$location.path('/login');
					}
				} else {
					$log.error("API response error "+rejection.status+" at "+rejection.config.method+" "+rejection.config.url , rejection);
				}

				if(rejection.data && (!angular.isObject(rejection.data) || Object.prototype.toString.call(rejection.data) === '[object ArrayBuffer]') && typeof(rejection.data) != 'string')
					rejection.data = angular.fromJson(textDecoder.decode(rejection.data));

        		return $q.reject(rejection);
			}
		}
    }

		var tienePathAPI = function(APIBaseUrl, url){
			return (url.lastIndexOf(APIBaseUrl) != -1);
		}

		var soloPermitimosUnaLlamada = function(url){
			//Solo permitiremos multiples llamadas al path de las traducciones, dashboards, configs y Search (dropdowns)
			return (
				(url.lastIndexOf("/api_traduction_msg/") == -1) &&
				(url.lastIndexOf("/lms_orides_nivel") == -1) &&
				(url.lastIndexOf("/api_dashboard/") == -1) &&
				(url.lastIndexOf("/metadata/") == -1) &&
				(url.lastIndexOf("/fend_config/") == -1) &&
				(url.lastIndexOf("/fend_config_dashboards/") == -1) &&
				(url.lastIndexOf("/fend_config_listados/") == -1) &&
				(url.lastIndexOf("/configuraciones/") == -1) &&
				(url.lastIndexOf("/List") == -1) &&
				(url.lastIndexOf("/Search") == -1) &&
				(url.lastIndexOf("/tipos_") == -1) &&
				(url.lastIndexOf("/referencias/") == -1) &&
				(url.lastIndexOf("/metadata/") == -1) &&
				//A aquests dos s'els hi hauria de donar una volta. Veure com fer per nomes haver de fer una crida.
				//Si es treuen les linies, el detall de la planificacio de ordre de transport peta.
				(url.lastIndexOf("/lms_orides_geo/") == -1) &&
				(url.lastIndexOf("/integracion_") == -1) &&
				(url.lastIndexOf("/articulos/") == -1) &&
				(url.lastIndexOf("/lms_ptv/PintaRuta") == -1) &&

				//Les d' articles afecten a la creacio de Ordres de treball i s' estan cridant mes d' una vegada
				//Es tindria que revisar el proces (añadir lineas desde daños o desde escandallos)
				(url.lastIndexOf("/articulos_stock_min/") == -1) &&
				(url.lastIndexOf("/articulos_tarifas/GetByCliente/") == -1) &&
				(url.lastIndexOf("/articulos_agrupaciones/") == -1) &&

				
				(url.lastIndexOf("/lms_geolocalizador_distancias/") == -1) &&
				(url.lastIndexOf("/bastidores/GetList") == -1)
				);
		}


    authInterceptorServiceFactory.request = _request;
    authInterceptorServiceFactory.response = _response;
    authInterceptorServiceFactory.responseError = _responseError;
	authInterceptorServiceFactory.tieneLlamadasPendientes = _tieneLlamadasPendientes;

    return authInterceptorServiceFactory;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
'use strict';

angular.module('gp4App').factory('apiHubService', ['$rootScope', 'cfg', '$log','ixStatusService', function ($rootScope, cfg, $log, ixStatusService) {

		function apiHubServiceFactory(hubName, jobId) {
			//var proxy = $.connection.ixJobHub;

			var connection = $.hubConnection(cfg.baseAuthURL);
			var proxy = connection.createHubProxy(hubName);
			var i  = 0;
      //$log.log("proxy");
      proxy.on('foo',function(){});

			var trackJob = function() {
				proxy.invoke('trackJob', jobId)
				.done(function (result) {
					//ya no dejamos el undefined por si el API no esta actualizado??
					//if(result) { 
					if(result == undefined || result) {
						$log.log("trackJob fin - OK: " + result);
						i = 20;
					}
					else {
						i++;
						if(i<=20) {
							$log.log("trackJob ini - reintento");
							trackJob();
						} else {
							$log.log("trackJob fin - ERROR - se terminaron los reintentos (20)");
							connection.stop();							
							$rootScope.$broadcast("loader_hide");
							$rootScope.$apply(function () {
								var postResult = {result: false, 
									GlobalMessage : {
										ErrType:2,
										Msg:"Error al lanzar el proceso. Reintentelo de nuevo.",
										Property:null,
										TypeOfError:2
									}
								};
								ixStatusService.setResponse({ status: 200, data: postResult });
							});							
						}						
					}
				}).fail(function (e) {
					$log.log("trackJob FAIL");
					$log.log(e);
					$log.warn(e);										
				});
			}

			connection.start().done(function () {
        //$log.log("trackJob");
        //proxy.invoke('trackJob', jobId);				
				$log.log("trackJob ini");
				trackJob();
			}).fail(function (e) {
          $log.warn(e);
      });

			return {
        connection: connection,
				on: function (eventName, callback) {
					proxy.on(eventName, function (result) {
						$rootScope.$apply(function () {
							if (callback) {
								callback(result);
							}
						});
					});
				},
				off: function (eventName, callback) {
					proxy.off(eventName, function (result) {
						$rootScope.$apply(function () {
							if (callback) {
								callback(result);
							}
						});
					});
				},
				invoke: function (methodName, callback) {
					proxy.invoke(methodName)
						.done(function (result) {
            //$log.log("proxy invoke");
							$rootScope.$apply(function () {
								if (callback) {
									callback(result);
								}
							});
						});
				},
        getConnection: function(){
          return this.connection;
        },
        closeConnection: function(connection){
          connection.stop();
        }
			};
		}

		return apiHubServiceFactory;

}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
/*global CMP_EQ */
'use strict';
angular.module('gp4App').service('ViewBuilderService', [ 'ixStatusService', 'gridService', '$timeout', '$log', function(ixStatusService, gridService, $timeout, $log){
  var ViewBuilderService = {};
  ViewBuilderService.scope = {};
  ViewBuilderService.init = function(scope, viewName, loadViewFunction){
    ViewBuilderService.scope = scope;
    this.viewName = viewName;

    //Si la vista encara no s'ha carregat, la carreguem i iniciem les grids que faci falta.
    if(!this.scope.data.gridsTab){
      this.view = loadViewFunction();
      angular.forEach(this.view, function(value, key){
        value.grids.forEach(function(grid, i){
          if((key == "general" || grid.startup == true) && value.refresh == true){
            ViewBuilderService.loadTabGrid(grid, value.Gkeys[i], true);
          }
        });
      });
    } else {
      //Si ja s'havia iniciat previament restaurar configuració de grids.
      this.view = this.scope.data.gridsTab;
      angular.forEach(this.scope.data.gridsTab, function(value, key){
        if(value.grids){
          value.grids.forEach(function(grid, i){
            if(ViewBuilderService.scope.data[grid.nombre]){
              ViewBuilderService.scope.data[grid.nombre] = gridService.createGridFunctions(ViewBuilderService.scope, ViewBuilderService.scope.data[grid.nombre]);
              ViewBuilderService.scope.data[grid.nombre].ixRestoreConfig();
            }
          });
        }
        if(value.gridspopup){
          value.gridspopup.forEach(function(grid, i){
            if(ViewBuilderService.scope.data[grid.nombre]){
              ViewBuilderService.scope.data[grid.nombre] = gridService.createGridFunctions(ViewBuilderService.scope, ViewBuilderService.scope.data[grid.nombre]);
              ViewBuilderService.scope.data[grid.nombre].ixRestoreConfig();
            }
          });
        }
      });
    }

    return this.view;
  };
  ViewBuilderService.clearGridDirtyRows = function(grid){
    grid.deletedRows = [];
    grid.insertedRows = [];
    var dataRows = grid.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
    grid.gridApi.rowEdit.setRowsClean( dataRows );
  };
  ViewBuilderService.clearGrid = function(grid){
    ViewBuilderService.clearGridDirtyRows(grid);
    grid.data = [];
  };
  ViewBuilderService.changesInTables = function(){
    var num = 0;
    angular.forEach(this.scope.data.gridsTab, function(value, key){
      if(value.grids){
        value.grids.forEach(function(grid, i){
          if(ViewBuilderService.scope.data[grid.nombre]){
            num += ViewBuilderService.scope.data[grid.nombre].numberOfChanges();
          }
        });
      }
      if(value.gridspopup){
        value.gridspopup.forEach(function(grid, i){
          if(ViewBuilderService.scope.data[grid.nombre]){
            num += ViewBuilderService.scope.data[grid.nombre].numberOfChanges();
          }
        });
      }
    });
    return num;
  };
  ViewBuilderService.numberOfChanges = function(){
		var datos = this.scope.data.datos_ope || this.scope.data.datos;
		var datosOriginales = this.scope.data.datos_opeOriginales || this.scope.data.datosOriginales;
    return (datos.ToDelete) ? 1 : ViewBuilderService.changesInTables() + (datosOriginales ? (!angular.equals(datos, datosOriginales) ? 1 : 0) : (datos.isNew) ? 1 : 0);
  };
  ViewBuilderService.changeTab = function(tabName){
    this.checkGridsTab(tabName);
    this.scope.data.selectedTab = tabName;
  };
  ViewBuilderService.checkGridsTab = function(tabName, datos, pk){
    var i = 0;
    var tabGeneral = this.scope.data.gridsTab["general"];
    var tab = this.scope.data.gridsTab[tabName];

    datos = angular.isUndefined(datos) ? this.scope.data.datos : datos;
    pk = angular.isUndefined(pk) ? this.scope.data.pk : pk;

    if(datos && datos[pk]){
      //Carreguem sempre la tab general.
      if(tabGeneral && tabGeneral.refresh){
        for(i = 0; i < tabGeneral.grids.length; i++){
          this.loadTabGrid(tabGeneral.grids[i], tabGeneral.Gkeys[i]);
        }
        tabGeneral.refresh = false;
      }
      //Carreguem la data de la tab sel·leccionada.
      if(angular.isDefined(tab))
        tab.grids[i].visible = false;
      if(tab && tab.refresh){
        for(i = 0; i < tab.grids.length; i++){
          this.loadTabGrid(tab.grids[i], tab.Gkeys[i]);
        }
        if(tab.gridspopup){
          for(i = 0; i < tab.gridspopup.length; i++){
            this.loadTabGrid(tab.gridspopup[i], tab.Gkeys[i]);
          }
        }
        tab.refresh = false;
      }// else {
        //Fem que la grid no es vagi redimensionant visualment.
      if(angular.isDefined(tab))
        this.handleWindowResize(tab.grids);
      //}
    }
  };
  ViewBuilderService.refreshAllGrids = function(){
    angular.forEach(this.scope.data.gridsTab, function(gridsInTab){
      gridsInTab.refresh = true;
      angular.forEach(gridsInTab.grids, function(grid){
        //Si la grid s'ha iniciat.
        if(ViewBuilderService.scope.data[grid.nombre] && ViewBuilderService.scope.data[grid.nombre].gridApi){
          ViewBuilderService.clearGrid(ViewBuilderService.scope.data[grid.nombre]);
        }
      });
      if(gridsInTab.gridspopup){
        angular.forEach(gridsInTab.gridspopup, function(gridpopup){
          if(ViewBuilderService.scope.data[gridpopup.nombre] && ViewBuilderService.scope.data[gridpopup.nombre].gridApi){
            ViewBuilderService.clearGrid(ViewBuilderService.scope.data[gridpopup.nombre]);
          }
        });
      }
    });
  };
  ViewBuilderService.saveConfig = function(){
    angular.forEach(ViewBuilderService.scope.data.gridsTab, function(gridsInTab){
      //gridsInTab.refresh = true;
      angular.forEach(gridsInTab.grids, function(grid){
        //Si la grid s'ha iniciat.
        if(ViewBuilderService.scope.data[grid.nombre] && ViewBuilderService.scope.data[grid.nombre].gridApi){
          ViewBuilderService.scope.data[grid.nombre].ixSaveConfig();
        }
      });
      if(gridsInTab.gridspopup){
        angular.forEach(gridsInTab.gridspopup, function(gridpopup){
          if(ViewBuilderService.scope.data[gridpopup.nombre] && ViewBuilderService.scope.data[gridpopup.nombre].gridApi){
             ViewBuilderService.scope.data[gridpopup.nombre].ixSaveConfig();
          }
        });
      }
    });
  };
  ViewBuilderService.loadTabGrid = function(grid, keys, onlyInitialize){
    if(!this.scope.data[grid.nombre]){
      if(!onlyInitialize){
        this.scope.gridManualLoad = false;
      }
      var gridOptions = { minRowsToShow: 8, enableCellEdit: true };
      if(grid.options){
        gridOptions = angular.merge(gridOptions, grid.options);
      }
      this.scope.data[grid.nombre] = gridService.createGrid(this.scope, this.viewName + "_G" + grid.entity, gridOptions, grid.entity, (grid.acciones) ? [{ name: 'Acciones', type: 'detalle', acciones: grid.acciones }] : null );
			if(angular.isDefined(grid.routeEntity))
				this.scope.data[grid.nombre].entity = grid.routeEntity;
      this.scope.data[grid.nombre].visible = false;
      this.applyFilters(grid, keys);
    } else {
      this.scope.data[grid.nombre].visible = false;
      this.applyFilters(grid, keys);
      return this.scope.data[grid.nombre].ixLoadInitialData();
    }
  };

  ViewBuilderService.applyFilters = function(grid, keys){
    var filtros = [];
    keys.forEach(function(key){
      if(angular.isObject(key)){
				var value = key[Object.keys(key)[0]];
				if(key.datosModelo && angular.isDefined(ViewBuilderService.scope.data.datos[value]))
					value = ViewBuilderService.scope.data.datos[value];

        filtros.push({Field: Object.keys(key)[0], Value: value, Operator: CMP_EQ });
      } else {
        var keyFormatted = "";
        if(key.indexOf("_") == 0){
          keyFormatted = key.substr(key.indexOf("_") + 1);
        } else {
          keyFormatted = key;
        }

        filtros.push({Field: grid.sendTblName === true ? grid.entity + "." + keyFormatted : keyFormatted, Value: ViewBuilderService.scope.data.datos[key], Operator: CMP_EQ });
      }
    });
    this.scope.data[grid.nombre].filtroExterno = filtros;
  };

  ViewBuilderService.handleWindowResize = function(grids){
    for(var i = 0; i < grids.length; i++){
      grids[i].visible = true;
      this.scope.showGrid(ViewBuilderService.scope.data[grids[i].nombre]);
    }
  };
  ViewBuilderService.getChangesTables = function(){
    var data = {};
    angular.forEach(this.scope.data.gridsTab, function(value, key){
      if(value.grids){
        value.grids.forEach(function(grid){
          if(ViewBuilderService.scope.data[grid.nombre] && ViewBuilderService.scope.data[grid.nombre].gridApi){
            data[grid.nombre] = ViewBuilderService.scope.data[grid.nombre].ixGetBulkParam();
          }
        });
      }
      if(value.gridspopup){
        value.gridspopup.forEach(function(grid){
          if(ViewBuilderService.scope.data[grid.nombre] && ViewBuilderService.scope.data[grid.nombre].gridApi){
            data[grid.nombre] = ViewBuilderService.scope.data[grid.nombre].ixGetBulkParam();
          }
        });
      }
    });

    return data;
  };

  ViewBuilderService.getViewDefault = function(){
    var view = {};
    view["general"] = { grids: [{ entity: this.scope.entity, nombre: "grid", class: "col-md-12" }], Gkeys: [ [ ]], refresh: true };
    return view;
  };
  return ViewBuilderService;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true */
(function(){
  'use strict';
  angular.module('gp4Filters',[]);


  angular.module('gp4Filters').filter("timeago", [ function () {
      //time: the time
      //local: compared to what time? default: now
      //raw: wheter you want in a format of "5 minutes ago", or "5 minutes"
      return function (time, local, raw) {
          if (!time) return "never";

          if (!local) {
              (local = Date.now())
          }

          if (angular.isDate(time)) {
              time = time.getTime();
          } else if (angular.isString(time)) {
              time = new Date(time).getTime();
          }

          if (angular.isDate(local)) {
              local = local.getTime();
          }else if (angular.isString(local)) {
              local = new Date(local).getTime();
          }

          if (!angular.isNumber(time) || !angular.isNumber(local)) {
              return;
          }

          var
              offset = Math.abs((local - time) / 1000),
              span = [],
              MINUTE = 60,
              HOUR = 3600,
              DAY = 86400,
              WEEK = 604800,
              MONTH = 2629744,
              YEAR = 31556926,
              DECADE = 315569260;

          if (offset <= MINUTE)              span = [ '', raw ? 'now' : 'less than a minute' ];
          else if (offset < (MINUTE * 60))   span = [ Math.round(Math.abs(offset / MINUTE)), 'min' ];
          else if (offset < (HOUR * 24))     span = [ Math.round(Math.abs(offset / HOUR)), 'hr' ];
          else if (offset < (DAY * 7))       span = [ Math.round(Math.abs(offset / DAY)), 'day' ];
          else if (offset < (WEEK * 52))     span = [ Math.round(Math.abs(offset / WEEK)), 'week' ];
          else if (offset < (YEAR * 10))     span = [ Math.round(Math.abs(offset / YEAR)), 'year' ];
          else if (offset < (DECADE * 100))  span = [ Math.round(Math.abs(offset / DECADE)), 'decade' ];
          else                               span = [ '', 'a long time' ];

          span[1] += (span[0] === 0 || span[0] > 1) ? 's' : '';
          span = span.join(' ');

          if (raw === true) {
              return span;
          }
          return (time <= local) ? span + ' ago' : 'in ' + span;
      }
  }]);

angular.module('gp4Filters').filter("getFieldsInColumn", [ function(){
    return function(fields, level){
      if(angular.isDefined(fields)){
        return fields.filter(function(e){
          if(e.ColumnAndOrder){ return e.ColumnAndOrder.Column == level; }
        });
      }
    }
  }]);

angular.module('gp4Filters').filter("reverse", [ function() {
  return function(input) {
    var result = "";
    input = input || "";
    for (var i=0; i<input.length; i++) {
      result = input.charAt(i) + result;
    }
    return result;
  };
}]);

/**
 * Filters out all duplicate items from an array by checking the specified key
 * @param [key] {string} the name of the attribute of each object to compare for uniqueness
 if the key is empty, the entire object will be compared
 if the key === false then no filtering will be performed
 * @return {array}
 */
angular.module('gp4Filters').filter('unique', [ function () {

  return function (items, filterOn) {

    if (filterOn === false) {
      return items;
    }

    if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
      var hashCheck = {}, newItems = [];

      var extractValueToCompare = function (item) {
        if (angular.isObject(item) && angular.isString(filterOn)) {
          return item[filterOn];
        } else {
          return item;
        }
      };

      angular.forEach(items, function (item) {
        var valueToCheck, isDuplicate = false;

        for (var i = 0; i < newItems.length; i++) {
          if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
            isDuplicate = true;
            break;
          }
        }
        if (!isDuplicate) {
          newItems.push(item);
        }

      });
      items = newItems;
    }
    return items;
  };
}]);


angular.module('gp4Filters').filter('groupBy', [ function () {
  var results={};
  return function (data, key) {
    if (!(data && key)) return;
    var result = {};
    for(var groupKey in result)
      result[groupKey].splice(0,result[groupKey].length);

    for (var i=0; i<data.length; i++) {
      if (!result[data[i][key]])
        result[data[i][key]]=[];
      result[data[i][key]].push(data[i]);
    }

    var keys = Object.keys(result);
    for(var k=0; k<keys.length; k++){
      if(result[keys[k]].length===0)
        delete result[keys[k]];
    }
    return result;
  };
}]);

angular.module('gp4Filters').filter('customFormatNumber', [ function() {
  // usado en FT para mostrar valores aunque no sean numéricos (por tema , y . de sepsarador decimal)
	return function(input) {
		if(input){
			if(isNaN(input))
			 	return input;
		 	else
			 	return Number(input);
		}
	};
}]);

angular.module('gp4Filters').filter('highlight', [ '$sce', function($sce){
  return function(text, phrase) {
    if (phrase) text = text.replace(new RegExp('('+phrase+')', 'gi'),
      '<span class="highlightedText">$1</span>')

    return $sce.trustAsHtml(text);
  };
}]);

angular.module('gp4Filters').filter('underscoreToSpace', [function() {
  return function(input) {
    if (!input) return '';
    return input.replace(/_/g, ' ');
  };
}]);

})();
/*jslint browser: true, devel: true, white: true, plusplus: true, vars: true*/
/*eslint angular/di: [2,"array"]*/
/*eslint angular/window-service: 0 */
/*eslint angular/document-service: 0 */
/*global angular */
angular.module('gp4App').directive('uiGridClipboard', [ '$rootScope', '$document', '$timeout', function($rootScope, $document, $timeout){
  return {
    replace: true,
    require: '^uiGrid',
    scope: false,
    controller: function () { },
    compile: function(){
      return {
        pre: function(scope, elem, attrs, controller){},
        post: function(scope, elem, attrs, controller){
          //Abans el possavem al document. Millor el possem al grid així evitem l'error [Object object]. D'aquesta manera tampoc possem al document la funció múltiples vegades.
          controller.grid.api.cellNav.on.viewPortKeyDown(scope, function(e){
            var cKey = 67;
            var endKey = 35;
            var curTarget = angular.element(e.target);
            //Si l'usuari esta fent el ctrl + c tenint el focus en el grid, evitem que tingui conflictes amb el copy de l'excel.
            var uiGridTarget = angular.element(document.querySelector('.ui-grid-focuser'));
            if(angular.equals(uiGridTarget, curTarget)){
              if(e.keyCode !== 86 || !e.ctrlKey){
                window.getSelection().removeAllRanges();
                e.preventDefault();
                e.stopPropagation();
              }
            }
            if (e.keyCode == cKey && e.ctrlKey){
              if(window.getSelection() + '' === '') {
                scope.copyData = scope.getSelection(controller);
                document.execCommand('copy');
                e.preventDefault();
              }
            } else if(e.keyCode == endKey && e.ctrlKey){
              controller.grid.api.ix.goToBottom();
            }
          });

          $document.on('copy', documentCopyCells);
          $document.on('paste', documentPaste);

          scope.getSelection = function(controller){
            var selectionText = "";
            var selection = controller.grid.api.cellNav.getCurrentSelection();
            selection.forEach(function(cellSelection){
              selectionText += cellSelection.getIntersectionValueRaw() + ((selection.length > 1) ? "\n" : "");
            });
            return selectionText;
          };

          function documentCopyCells(evt) {
            var cbData,
              cbType;

            if(evt.originalEvent.clipboardData){
              cbData = evt.originalEvent.clipboardData;
              cbType = 'text/plain';
            } else {
              cbData = window.clipboardData;
              cbType = 'Text';
            }

            //if(cbData && (window.getSelection() + '' === '' || window.getSelection() + '' === ' ') && scope.copyData !== ''){
            if(cbData && angular.isDefined(scope.copyData) && scope.copyData !== '' && !angular.isObject(scope.copyData)){
              cbData.setData(cbType, scope.copyData);
              scope.copyData = {};
              evt.preventDefault();
            }
          }

          function documentPaste(evt){
            var cbData,
              cbType;

            if(evt.originalEvent.clipboardData){
              cbData = evt.originalEvent.clipboardData;
              cbType = 'text/plain';
            } else {
              cbData = window.clipboardData;
              cbType = 'Text';
            }

            if(cbData){
              //Si tenim marcada una sola columna i aquesta té control search farem el ctrl + v
              if(controller.grid.cellNav.focusedCells.length == 1 && controller.grid.cellNav.focusedCells[0].col.colDef.control == "Search" && !controller.grid.cellNav.focusedCells[0].col.colDef.isOpen){
                var text = cbData.getData(cbType);
                $rootScope.typedText = text.trim();
              }
            }
          }

          //Definim una funció per quan es canvii o tanqui la pantalla (si es un popup no es fa ja que ens carregariem l'event de la pantalla de sota).
          //Els events dels popups s'eliminaran al canviar o tancar la pantalla de sota.
          var isAPopup = document.querySelector("div.modal-dialog");
          if(isAPopup == null){
            scope.$on("$destroy", function(){
              $document.off('copy');
              $document.off('paste');
            });
          }
        }
      }
    }
  }
}]);

/*global angular */
angular.module('gp4App').directive('sidebarToggle', ['$document', 'sidebarService', function($document, sidebarService) {
	return {
		restrict: 'A',
		link: function (scope, iElement, iAttrs) {

			scope.element = iElement[0];
			scope.body = $document.body;

			scope.element.addEventListener("click", function() {
				var _element = $document[0].getElementById(iAttrs.sidebarToggle);
				/* YVES: DESCOMENTAR siguientes lineas 13-17) para que side-bar se cierre sólo manualmente */
				if(_element.classList.contains("sidebar--is-open")){
					sidebarService.manuallyOpened = false;
				} else {
					sidebarService.manuallyOpened = true;
				}
				_element.classList.toggle("sidebar--is-open");
				/* YVES: DESCOMENTAR siguiente linea para que side-bar se cierre sólo manualmente */
				angular.element(angular.element(_element.parentElement).children("#main-page"))[0].classList.toggle("sidebar--is-open");

				//var _bgSidebar = $document[0].getElementById(iAttrs.sidebarToggle + "-bg");
				//_bgSidebar.classList.toggle("sidebar-bg--is-visible");

				//control body
				/*
				if (scope.body.style.overflowY == "auto") {
					scope.body.style.overflowY = "hidden";
				} else {
					scope.body.style.overflowY = "auto";
				}
				*/
			});

		}
	};
}]);

angular.module('gp4App').directive('sidebar', ['$compile', '$document', 'ixStatusService', 'sidebarService', function($compile, $document, ixStatusService, sidebarService) {
	return {
		restrict: 'E',
		templateUrl: 'app/base/views/sidebar_apps.html',
		link: function (scope, iElement, iAttrs) {
			scope.status  = ixStatusService;
			scope.body = $document.body;
			scope.element = iElement[0];

			scope.isCurrent = function(app) {
				return angular.equals(app, scope.status.current)
			}

			scope.filterFunction = function (filter) {
				return filter.open;
			};
			scope.isSideBarOpen = function() {
				return angular.element(scope.element).hasClass('sidebar--is-open');
			};

			scope.openSideBar = function(){
				scope.element.classList.add("sidebar--is-open");
				angular.element(angular.element(scope.element.parentElement).children("#main-page"))[0].classList.add("sidebar--is-open");
			};

			scope.closeSideBarApps = function() {
				if(!sidebarService.manuallyOpened){
					scope.element.classList.toggle("sidebar--is-open");
					angular.element(angular.element(scope.element.parentElement).children("#main-page"))[0].classList.toggle("sidebar--is-open");
				}
			};

			//renderize sidebar
			scope.element.style.display = "block";
			scope.element.style.top = "50px";
			scope.element.style.height = "calc(100vh - 82px)";

			//add width on sidebar
			function isNumber(n) {
				return !isNaN(parseFloat(n)) && isFinite(n);
			}

			if (isNumber(iAttrs.size)) {
				scope.element.style.maxWidth = iAttrs.size + 'px';
			} else {
				scope.element.style.maxWidth = iAttrs.size;
			}

			// if(iAttrs.openOnMouseClose){
			// 	scope.element.parentElement.addEventListener("mousemove", function(ev) {
			// 		var offsetWidth = scope.element.parentElement.offsetWidth;
			// 		var mouseX = ev.clientX;
			//
			// 		if((offsetWidth - mouseX) < 6)
			// 			scope.openSideBar();
			//
			// 	});
			// }

			//add class to position on sidebar
			scope.element.classList.add("sidebar--" + iAttrs.position);

			//renderize bg-sidebar
			/*
			var bgSidebar = $document[0].createElement("div");
			bgSidebar.setAttribute("class", "sidebar-bg");
			bgSidebar.setAttribute("id", iAttrs.id + "-bg");
			bgSidebar.setAttribute("sidebar-toggle", iAttrs.id);
			scope.body.appendChild(bgSidebar);

			$compile(bgSidebar)(scope);
			*/

		}
	};
}]);

angular.module('gp4App').factory('sidebarService', [ function(){
	var sidebarServiceInstance = {
		manuallyOpened: false
	};
	return sidebarServiceInstance;
}]);

/*jslint browser: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
/*global getColors */
/*global CMP_EQ */
/*global CMP_GT */
/*global CMP_LT */
/*global CMP_GTE */
/*global CMP_LTE */
/*global CMP_LIKER */
/*global CMP_LIKEL */
/*global CMP_LIKE */
/*global CMP_LIKENONE */
/*global CMP_ISNULL */
/*global buildIxSearch*/
/*global ixNewDate*/
/*global moment*/
/*global simulateAPIError*/
/*global saveAs*/
(function(){
  'use strict';
  angular.module('gp4helpers', []);

	/*angular.module('gp4helpers').directive('datepickerTimezone', [ function () {
		return {
			restrict: 'A',
			priority: 1,
			require: 'ngModel',
			link: function (scope, element, attrs, ctrl) {
				//TODO: if scope firstopen fer calcul de les dates
					ctrl.$formatters.push(function (value) {
							var date = new Date(Date.parse(value));
							date = new Date(date.getTime() + (60000 * date.getTimezoneOffset()));
							//if (!dateFormat || !modelValue) return "";
							//var retVal = moment(modelValue).format(dateFormat);
							return date;
					});

					ctrl.$parsers.push(function (value) {
							var date = new Date(value.getTime() - (60000 * value.getTimezoneOffset()));
							return date;
					});
			}
		};
	}]);*/

  angular.module('gp4helpers').directive('ixDatepicker', ['$filter', 'cfg', '$timeout', function($filter, cfg, $timeout) {
      return {
          restrict: 'E',
          require: 'ngModel',
          scope: {
            ngModel: '=',
            name: '@',
            dateLimit: '=?',
						dateMin: '=?',
            compareDatetime: '=', // desde el ixDateTime pasamos compare-datetime a true para que sepa como validar date-min y date-limit
            ngDisabled: '=',
            appendToBody: '=?'
          },
          template: '<div class="input-group add-on"><input type="text" uib-datepicker-popup ng-model="ngModel" is-open="isOpen" datepicker-options="datepickerOpts" show-button-bar="false" placeholder="DD/MM/YYYY" ng-disabled="ngDisabled" datepicker-append-to-body="appendToBody" /><span class="input-group-btn"><span class="btn btn-default btn-calendar" ng-disabled="ngDisabled" ng-click="isOpen=!isOpen"><i class="glyphicon glyphicon-calendar"></i></span></span></div>',
          link: function(scope, elem, attrs, ngModelController) {
            // si dateLimit=true cogemos la fecha actual como límite
            if(angular.isDefined(scope.dateLimit) && scope.dateLimit == true){ 
              scope.dateLimit = new Date();
              scope.dateLimit.setHours(23);
              scope.dateLimit.setMinutes(59);
              scope.dateLimit.setSeconds(59);
              scope.dateLimit.setMilliseconds(999); 
            }

            scope.datepickerOpts = {
              minDate: scope.dateMin,
              maxDate: scope.dateLimit
            };

            // Si canvien ngModel, dateLimit o dateMin
            scope.$watchGroup(['dateLimit', 'dateMin','ngModel'], function(newVals,oldVals) {
              // Si rebem un valor sense hora i minuts, recuperem la hora i els minuts del valor que teniem (el uib-datepicker-popup els posa sempre a zero)
              recuperarHora(newVals[0], oldVals[0]);
              recuperarHora(newVals[1], oldVals[1]);
              recuperarHora(newVals[2], oldVals[2]);
              // Passem el valor al datepicker perquè pugui validar correctament
              scope.datepickerOpts.minDate = newVals[1];
              scope.datepickerOpts.maxDate = newVals[0];
              if (ngModelController && ngModelController.$modelValue) {
                ngModelController.$validate();
              }
            });

            function recuperarHora(newValue,oldValue) {
              if(!newValue || !(newValue instanceof Date) || !(oldValue instanceof Date)) return newValue;
              if (newValue.getHours() === 0 && newValue.getMinutes() === 0 && newValue.getSeconds() === 0 && newValue.getMilliseconds() === 0) {
                newValue.setHours(oldValue.getHours());
                newValue.setMinutes(oldValue.getMinutes());
                newValue.setSeconds(oldValue.getSeconds());
                newValue.setMilliseconds(oldValue.getMilliseconds());
              }
            }

            var input = elem.children(0).children(0);
                input.on('keypress', function(e){
              var keyCode = (e.which||e.charCode||e.keyCode);
              if("0123456789/-. '+".indexOf(String.fromCharCode(keyCode))>=0  ||  // Allow: numbers and valid separators
                  [8,9,13,27,46].indexOf(keyCode)>=0 ||  // Allow: backspace, tab, enter, escape, delete
                  ([65,67,86,88,90].indexOf(keyCode)  && ( e.ctrlKey === true || e.metaKey === true ) ) ||  // Allow: Ctrl+A, Command+A, ctrl+C,ctrl+X,ctrl+V, ctrl+Z
                  (keyCode >= 35 && keyCode <= 40) // Allow: home, end, left, right, down, up
              ) {
                return true;
              } else {
                e.preventDefault();
                return false;
              }
            });

            function normalizeDate(date) {   
              // Para comparar fechas , si compareDatetime no es true lo haremos sin hora,minutos ni segundos           
              if (!date) return null;
              if(scope.compareDatetime) {
                return date;
              } else {
                return new Date(date.getFullYear(), date.getMonth(), date.getDate(),0,0,0,0);
              }
            }

            ngModelController.$validators.maxDate = function(modelValue) {
              if (!modelValue || !scope.dateLimit) return true;
              return normalizeDate(modelValue) <= normalizeDate(scope.dateLimit);
            };

            ngModelController.$validators.minDate = function(modelValue) {
              if (!modelValue || !scope.dateMin) return true;
              return normalizeDate(modelValue) >= normalizeDate(scope.dateMin);
            };          


            input.on('blur',function(event){
              var newVal = event.target.value;
              var dateParts = newVal.split(/[\/\.\- '\+]{1}/);

              //var now = new Date();
              var now = ixNewDate(cfg,moment);
              var day = now.getDate();
              var month = now.getMonth() + 1;
              var year = now.getFullYear();
              //var momentParts = now.split("T");
              //var parts = momentParts[0].split("-");
              //var parts = now.split("-");
              //var day = parts[2];
              //var month = parts[1];
              //var year = parts[0];
              if(dateParts.length==1) {
                if(dateParts[0].length==0) {
                  ngModelController.$setViewValue(null);
                  ngModelController.$render();

                  //scope.$apply;
                  return;
                }
                day = dateParts[0].slice(0,2);
                if(dateParts[0].length>2) {
                  month = dateParts[0].slice(2,4)
                }
                if(dateParts[0].length>4) {
                  year = dateParts[0].slice(4,8);
                }
              }

              if(dateParts[0].length>0 && dateParts[0].length<=2) {
                day = dateParts[0];
              }
              if(dateParts.length>1 && dateParts[1].length>0) {
                month = dateParts[1];
              }
              if(dateParts.length>2 && dateParts[2].length>0) {
                year = dateParts[2];
              }

              if(year.length<=2) {
                // si sintrodueix l'any en 2 dígits, el passem al segle que correspon
                year = parseInt(year) + (now.getFullYear()-(now.getFullYear()%100));
              }

              scope.ngModel = ixNewDate(cfg,moment, day, month-1, year);
              scope.$applyAsync();
          });
        }
      };
    }])

	angular.module('gp4helpers').directive('ixDatepickerRange', ['$filter', 'cfg', '$timeout', function($filter, cfg, $timeout) {
		return {
			restrict: 'E',
			require: 'ngModel',
			scope: {
				ngModel: '=',
				name: '@',
				dateLimit: '=?',
				dateMin: '=?',
				ngDisabled: '=',
				appendToBody: '=?',
				onChange: '=?'
			},
			template: '<div class="input-group add-on"><span style="top: 5px;position: relative;" uib-datepicker-popup ng-model="ngModel" multi-select="selectedDates" select-range="true" datepicker-options="optionsTest" is-open="isOpen" show-button-bar="false" placeholder="DD/MM/YYYY" ng-disabled="ngDisabled" datepicker-append-to-body="appendToBody">{{ ((ngModel[0]) ? (ngModel[0] | date:"dd/MM/yyyy") : "")  }} - {{ ((ngModel[1]) ? (ngModel[1] | date:"dd/MM/yyyy") : "")  }}</span><span class="input-group-btn"><span class="btn btn-default btn-calendar" ng-disabled="ngDisabled" ng-click="isOpen=!isOpen"><i class="glyphicon glyphicon-calendar"></i></span></span></div>',
			link: function(scope, elem, attrs, ngModelController) {

				scope.selectedDates = [];
				scope.optionsTest = {
					startingDay:1,
					minDate:((scope.dateMin) ? scope.dateMin : null),
					maxDate:((scope.dateLimit) ? scope.dateLimit : null),
					customClass: function(data) {
						if(scope.selectedDates.indexOf(data.date.setHours(0, 0, 0, 0)) > -1) {
							return 'selected';
						}
						return '';
					}
				};

				var input = elem.children(0).children(0);

				scope.$watch('selectedDates', function(newVal, oldVal){
					if(newVal.length > 1){
						scope.isOpen = false;
						scope.ngModel = [];
						scope.ngModel[0] = new Date(newVal[0]);
						scope.ngModel[1] = new Date(newVal[1]);
					}
					else if(newVal.length > 0){
						scope.isOpen = true;
						scope.ngModel = [];
						scope.ngModel[0] = new Date(newVal[0]);
					}
				},true);

				scope.$watch('isOpen', function(newVal, oldVal){
					if(newVal == false && oldVal){
						if(!scope.ngModel[1]){
							if(scope.ngModel[0])
								scope.ngModel[1] = angular.copy(scope.ngModel[0]);
							else if(angular.isDate(scope.ngModel)){
								scope.ngModel[0] = angular.copy(scope.ngModel);
								scope.ngModel[1] = angular.copy(scope.ngModel);
							}
						} else if(scope.ngModel[0] > scope.ngModel[1]){
							var auxFechaMasLejana = angular.copy(scope.ngModel[0]);
							scope.ngModel[0] = angular.copy(scope.ngModel[1]);
							scope.ngModel[1] = auxFechaMasLejana;
						}
						if(angular.isDefined(scope.onChange)){
							$timeout(function(){
								scope.onChange();
							},1);
						}
					}
				});
			}
		};
	}])    

	//ixSelect Original
  /*angular.module('gp4helpers').directive('ixSelect', [ function() {
      return {
          restrict: 'E',
          require: '?ngModel',
          scope: {
            entity: '@',
            pk: '@',
            desc: '@',
            extraField: '@?',
            ngModel: '=',
            name: '@',
            preload: '=?',
            ngDisabled: '=',
            ngRequired: '=',
            conditions: '=?',
            loadFunction: '=?',
            ngDefault: '=?',
            //Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
            wholeObj: '=?',
            orderStringAsInt: '=?',
            //permet afegir com a opcio allò que l'usuari escrigui al camp de text utilitzat per filtrar resultats.
            editableDropdown: '=?',
            //Aquesta serà una funció que carregui un viewmodel sencer en el mateix moment d'accedir la pantalla. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
            preloadFunction: '=?',
            //La pk no sempre s'ha de dir igual que la del viewmodel.
            preloadPk: '@?',
            //Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
            loadAllItems: '=?',
            //Podem fer que el dropdown pengi del body en comptes del div que el conté. D'aquesta manera, si un dropdown està en un div petit, les opcions no es veuràn tallades (útil per popups).
            appendToBody: '=?',
            //Per pantalles on tenim totes les dades a un objecte carregat previament desde la API. Aconsellable fer-ho a pantalles on hi hagi forces dropdowns.
            entityData: '=?',
            entityDataPk: '@?',
            entityDataDesc: '@?',
						oneLineText: '=?'
          },
          controller: 'ixSelectController',
          templateUrl: 'app/base/views/helpers_templates/ixSelect.html'
      };
    }]);
	*/
	//nuevo ixSelect
	angular.module('gp4helpers').directive('ixSelect', [ function() {
      return {
          restrict: 'E',
          //require: '?ngModel',
          scope: {
            entity: '@',
            pk: '@',
            desc: '@',
            extraField: '@?',
            dropdownSinCodigo: '=?',
			filterFields: '=?',
            ngModel: '=',
            name: '@',
            preload: '=?',
            ngDisabled: '=',
            ngRequired: '=',
            conditions: '=?',
            loadFunction: '=?',
            ngDefault: '=?',
            //Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
            wholeObj: '=?',
            orderStringAsInt: '=?',
            //permet afegir com a opcio allò que l'usuari escrigui al camp de text utilitzat per filtrar resultats.
            editableDropdown: '=?',
						allowCustomPriority: '=?',
            //Aquesta serà una funció que carregui un viewmodel sencer en el mateix moment d'accedir la pantalla. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
            preloadFunction: '=?',
						//
						preloadObj: '@?',
            //La pk no sempre s'ha de dir igual que la del viewmodel.
            preloadPk: '@?',
            //Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
            loadAllItems: '=?',
            //Podem fer que el dropdown pengi del body en comptes del div que el conté. D'aquesta manera, si un dropdown està en un div petit, les opcions no es veuràn tallades (útil per popups).
            appendToBody: '=?',
            //Per pantalles on tenim totes les dades a un objecte carregat previament desde la API. Aconsellable fer-ho a pantalles on hi hagi forces dropdowns.
            entityData: '=?',
            entityDataPk: '@?',
            entityDataDesc: '@?',
						oneLineText: '=?',
						onSelect: '=?',
						template: '@?',
						skipTableNameFilter: '=?',
						skipTableNameOrderBy: '=?',
						labelClass: '@?',
						inputClass: '@?',
            longerResultBox: '=?',
            redBackground: '=?',
            stringId: '=?'
          },
          //controller: 'ixSelectController',
          templateUrl: 'app/base/views/helpers_templates/ixSelect2.html'/*,
					link: function(scope, elem, attrs){
						if(!scope.allItems)
							scope.allItems = [];

						scope.$watch('wholeObj', function(newVal, oldVal){
							console.log("wholeObj updated");
						});
					}*/
      };
    }]);

    angular.module('gp4helpers').directive('ixSelectMultiple', [ function() {
      return {
          restrict: 'E',
          require: '?ngModel',
          scope: {
            entity: '@',
            pk: '@',
            desc: '@',
            extraField: '@?',
            ngModel: '=',
            name: '@',
            preload: '=?',
            ngDisabled: '=',
            ngRequired: '=',
            conditions: '=?',
            loadFunction: '=?',
            ngDefault: '=?',
            //Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
            wholeObj: '=?',
            orderStringAsInt: '=?',
            //permet afegir com a opcio allò que l'usuari escrigui al camp de text utilitzat per filtrar resultats.
            editableDropdown: '=?',
            //Aquesta serà una funció que carregui un viewmodel sencer. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
            preloadFunction: '=?',
            //La pk no sempre s'ha de dir igual que la del viewmodel.
            preloadPk: '@?',
            //Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
            loadAllItems: '=?',
            //Podem fer que el dropdown pengi del body en comptes del div que el conté. D'aquesta manera, si un dropdown està en un div petit, les opcions no es veuràn tallades (útil per popups).
            appendToBody: '=?',
						//Si queremos manipular el valor para que el resultado sea el array de items seleccionados separado por coma.
						commaSeparated: '=?',
            skipTableNameFilter: '=?',
            keepPreviouslyLoadedItems: '=?'
          },
          controller: 'ixSelectMultipleController',
          templateUrl: 'app/base/views/helpers_templates/ixSelectMultiple.html'
      };
    }])


  angular.module('gp4helpers').directive('ixCheckbox', [ function() {
      return {
          restrict: 'E',
          scope: {
          entity: '=entity',
          field: '@field',
          name: '@'
          },
          template: '<div class="checkbox"><label><input type="checkbox" name="{{name}}" id="{{name}}" ng-model="entity[field]" ng-true-value="1" ng-false-value="0"></input>  {{field}}</label></div>'


      };
    }])

  angular.module('gp4helpers').directive('ixOptionsSiNo', ['$timeout', function ($timeout) {
    return {
      restrict: 'E',
      require: '?ngModel',
      scope: {
        ngModel: '=',
        ngRequired: '=?',
        name: '@',
        ngDisabled: '=?',
        textMaxWidth: '=?',
        ngDefault: '=?',
				afterClick: '=?'
      },
      link: function(scope, elem, attrs){
        $timeout(function(){
          var label = angular.element(elem.find('label')[0]);
          label.on('click', function(e){
            if(e.target !== e.currentTarget) return;
            e.preventDefault();
          });
        },1);
      },
      controller: ['$scope', function($scope){
        if(angular.isDefined($scope.ngDefault)){
          if(!angular.isFunction($scope.ngDefault)){
            $scope.ngModel = $scope.ngDefault;
          } else {
            //En cas de que el default sigui una etiqueta de config s'executarà una funció que ha d'estar definida al controller de la pantalla.
            $scope.ngDefault().then(function(result){
              $scope.ngModel = result;
              $scope.ngDefault = result;
            });
          }
        }
        if(isNaN($scope.ngModel)){
          $scope.ngModel = 0;
        }

        $scope.changeSelected = function(){
          $scope.ngModel = (($scope.ngModel == 1) ? 0 : 1);
					if($scope.afterClick){
						$timeout(function(){
							$scope.afterClick($scope.ngModel);
						},0);
					}
        }

        $scope.$watch("ngModel", function(value){
          //Ens permet buidar el ix-select però, en cas de que hi hagi valor per defecte, si el formulari es neteja, s'aplicarà el valor per defecte de nou.
          if(angular.isUndefined(value) && angular.isDefined($scope.ngDefault)){
            $scope.ngModel = $scope.ngDefault;
          } else {
            if(isNaN($scope.ngModel)){
              $scope.ngModel = 0;
            }
            else if(typeof $scope.ngModel == "boolean"){
              $scope.ngModel == true ?  $scope.ngModel = 1 : $scope.ngModel = 0;
            }
            $scope.estaSeleccionado = angular.copy($scope.ngModel);            
          }
          return $scope.ngModel;
        });
      }],
      templateUrl: 'app/base/views/helpers_templates/ixOptionsSiNo.html'
    };
  }])

  angular.module('gp4helpers').directive('ixTextArea', [ function () {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        ngClass: '@?',
        ngDisabled: '=?',
        maxLength: '=?',
				rows: '@?',
				cols: '@?',
				labelClass: '@?',
				inputClass: '@?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixTextArea.html'
    };
  }])

  angular.module('gp4helpers').directive('ixTextField', [ function () {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        ngClass: '@?',
        ngDisabled: '='
      },
      template: '<div class="form-group"> ' +
        '<label class="col-md-4"><translate>{{::name}}</translate><i class="fa fa-asterisk" style="color:red" ng-show="ngRequired"></i></label> ' +
        '<div class="col-md-8 btn-group"> ' +
        '<input class="btn btn-default form-control" ng-class="ngClass" type="text" ng-model="ngModel" readonly="ngDisabled" />' +
        '</div></div> '
    };
  }])


	angular.module('gp4helpers').directive('ixListSelect', [ 'ixUtilsService', 'ivhTreeviewMgr', function (ixUtilsService, ivhTreeviewMgr) {
    return {
      restrict: 'E',
			require: 'ngModel',
			transclude: true,
      scope: {
        ngModel: '=',
				pk: '@',
				desc: '@',
				values: '=?',
				loadFunction: '=?',
				ngDisabled: '=?',
        ngRequired: '=?',
        name: '@',
        ngValue: '=?',
        ngPlaceholder: '@?',
				labelClass: '@?',
				inputClass: '@?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixListSelect.html',
      link: function(scope, elem, attrs, ngModelController){

				if(scope.loadFunction) {
					scope.loadFunction().then(function(r) {
						scope.optionValues = r.data.Items ? r.data.Items : r.data;
						scope.optionValues.forEach(function(option){
							option.id = option[scope.pk];
							option.label = option[scope.desc];
							option.children = [];
							option.selected = false;
						});
					});
				} else if(scope.values){
					scope.optionValues = angular.copy(scope.values);
					scope.optionValues.forEach(function(option){
						option.id = option[scope.pk];
						option.label = option[scope.desc];
						option.children = [];
						option.selected = false;
					});
				}

				scope.selectedOptions = scope.ngModel;
				scope.searchvalue = "";
				scope.showModalSelection = function() {
					if(!scope.ngDisabled){
						ixUtilsService.openModalV2("ixListSelectModal.html", { scope: scope }, "small").then(function(){
							var selectedValues = [];
							scope.optionValues.forEach( function( val ) {
								if(val.selected) {
									selectedValues.push( val.id );
								}
								val.children.forEach(function(v2) {
									v2.children.forEach(function(v3) {
										if(v3.selected){
											selectedValues.push(v3.id);
										}
									});
								});
							});
							scope.selectedOptions = selectedValues.join(',');
							ngModelController.$setViewValue(scope.selectedOptions);
						});

						var distinctValues = {};
						//scope.optionValues = [];
						var selectedValues = [];
						if(scope.selectedOptions) {
							selectedValues=scope.selectedOptions.split(",");
						}
						//Sort recursive.
						sortListOfValues(scope.optionValues);
					}
				};

				var sortListOfValues = function(listOfValues){
					//Si l'array actual només conté 1 objecte i aquest objecte té més d'un fill, ordenem els fills de l'objecte.
					if(listOfValues.length == 1 && hasChildrenToSort(listOfValues[0])){ sortListOfValues(listOfValues[0].children); }

					listOfValues.sort(function(a,b){
						//Ordenem els fills de l'objecte que estem comparant (si n'hi han).
						if(hasChildrenToSort(a)){
							sortListOfValues(a.children);
						}
						if(hasChildrenToSort(b)){
							sortListOfValues(b.children);
						}
						//return (a.label>b.label)-(a.label<b.label);
						return (a.id>b.id)-(a.id<b.id);
					});
				};

				var hasChildrenToSort = function(obj){
					return obj.children && obj.children.length > 1;
				};

				scope.selectAll = function() {
					var matchingValues = [];
					if(scope.searchvalue != null){
						angular.forEach(scope.optionValues, function(value){
							if(value.label.toUpperCase().indexOf(scope.searchvalue.toUpperCase()) !== -1){
							 matchingValues.push(value);
							}
						});
						ivhTreeviewMgr.selectAll(matchingValues);
					} else {
						ivhTreeviewMgr.selectAll(scope.optionValues);
					}

				};

				scope.deselectAll = function() {
					ivhTreeviewMgr.deselectAll(scope.optionValues);
				};
      }
    };
  }])

  angular.module('gp4helpers').directive('ixDate', [ function () {
    return {
      restrict: 'E',
      require: '?ngModel',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        dateLimit: '=?',
				dateMin: '=?',
        ngDisabled: '=',
        appendToBody: '=?',
				oneLineText: '=?',
				labelClass: '@?',
				inputClass: '@?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixDate.html'
    };
  }])

	angular.module('gp4helpers').directive('ixDateRange', [ function () {
    return {
      restrict: 'E',
      require: '?ngModel',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        dateLimit: '=?',
				dateMin: '=?',
        ngDisabled: '=',
        appendToBody: '=?',
				withoutLabel: '=?',
				addTime: '=?',
				onChange: '=?',
				id: '=?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixDateRange.html'
    };
  }])

  angular.module('gp4helpers').directive('ixTime', [ '$filter', function ($filter) {
    return {
      restrict: 'E',
      require: 'ngModel',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        ngDisabled: '=?',
				withoutLabel: '=?',
				bindWith: '=?',
				onChange: '=?',
				id: '=?',
        minutoExacto: '=?',
        minutoMultipleDe: '@?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixTime.html',
      link: function(scope, elem, attrs, ngModelController){
				
				var input = angular.element(elem.find('input')[0]);
				input.on('keypress', function(e){
              var keyCode = (e.which||e.charCode||e.keyCode);
              if("0123456789:. '+".indexOf(String.fromCharCode(keyCode))>=0  ||  // Allow: numbers and valid separators
                  [8,9,13,27,46].indexOf(keyCode)>=0 ||  // Allow: backspace, tab, enter, escape, delete
                  ([65,67,86,88,90].indexOf(keyCode)  && ( e.ctrlKey === true || e.metaKey === true ) ) ||  // Allow: Ctrl+A, Command+A, ctrl+C,ctrl+X,ctrl+V, ctrl+Z
                  (keyCode >= 35 && keyCode <= 40) // Allow: home, end, left, right, down, up
              ) {
                return true;
              } else {
                e.preventDefault();
                return false;
              }
            });						
				
				var addTimeToVariable = function(){
					var partsTime = scope.ngModel.split(":");
					if(partsTime.length == 3){
						scope.bindWith.setHours(partsTime[0]);
						scope.bindWith.setMinutes(partsTime[1]);
						scope.bindWith.setSeconds(partsTime[2]);
					}
				};
				
				if(scope.onChange){
					input.on('focus',function(event){
						scope.oldValue = angular.copy(scope.ngModel);
					});
				}

				input.on('blur',function(event){
              var newVal = event.target.value;
              var dateParts = newVal.split(/[\:\.\- '\+]{1}/);
              
              var now = ($filter("date")(new Date(), "H:mm:ss", null)).split(":");
              var hours = now[0];
              var minutes = now[1];              
							var seconds = now[2];
              if(scope.minutoExacto)
                seconds = "00";
					
              /* INI introduccio sense separadors (. | + | -) */
              if(dateParts.length==1) {
                if(dateParts[0].length==0) {
                  ngModelController.$setViewValue(null);
                  ngModelController.$render();
              
                  return;
                }
								var index = 2;
                hours = parseInt(dateParts[0].slice(0,2));								
								if(hours>23) {									
									hours = dateParts[0].slice(0,1);
									index = 1;
								}
                if(dateParts[0].length>2) {									
                  minutes = dateParts[0].slice(index,index+2);
									if(parseInt(minutes)>59)
									{
										minutes = "0"+dateParts[0].slice(index,index+1);
										index = index + 1;
									}
									else {
										index = index + 2;
									}
                }
                if(dateParts[0].length>4) {
                  //seconds = dateParts[0].slice(index,index+2);
									seconds = parseInt(dateParts[0].slice(index,index+2)) < 9 ? "0"+parseInt(dateParts[0].slice(index,index+2)) : dateParts[0].slice(index,index+2);
                } else {
									seconds = "00";
								}
              }
							/* FIN introduccio sense separadors (. | + | -) */
					
							/* INI introduccio amb separadors (. | + | -) */
              if(dateParts[0].length>0 && dateParts[0].length<=2) {
                hours = parseInt(dateParts[0]);
              }
              if(dateParts.length>1 && dateParts[1].length>0) {
								if(parseInt(dateParts[1]) < 9){
									minutes = "0"+parseInt(dateParts[1]);
								} else if(parseInt(dateParts[1]) > 59){
									minutes = "00";
								} else {
									minutes = dateParts[1];
								}
              }
              if(dateParts.length>2 && dateParts[2].length>0) {
								if(parseInt(dateParts[2]) < 9){
									seconds = "0"+parseInt(dateParts[2]);
								} else if(parseInt(dateParts[2]) > 59){
									seconds = "00";
								} else {
									seconds = dateParts[2];
								}
              }
							/* FIN introduccio amb separadors (. | + | -) */              
              
              if(scope.minutoMultipleDe){
                scope.minutoMultipleDe = parseInt(scope.minutoMultipleDe);
                
                minutes = (minutes % scope.minutoMultipleDe) >= 2.5 ? parseInt(minutes / scope.minutoMultipleDe) * scope.minutoMultipleDe + scope.minutoMultipleDe : parseInt(minutes / scope.minutoMultipleDe) * scope.minutoMultipleDe;
                if(parseInt(minutes) < 9){
									minutes = "0"+parseInt(minutes);
								}
              }

              scope.ngModel = hours + ":" + minutes + ":" + seconds;
							scope.validateTIME(scope.ngModel);

							if(scope.ngModel && scope.bindWith)
								addTimeToVariable();

							if(angular.isDefined(scope.onChange) && !angular.equals(scope.oldValue, scope.ngModel))
								scope.onChange(scope.oldValue, scope.ngModel, scope.id);
              scope.$apply();
          });
				
				
				
				
				
        scope.validateTIME = function(val){
          //TODO: Fer que rebi per paràmetre si ha de ser en format hh:mm o hh:mm:ss.
          //var regex = /([01]\d|2[0-3]):([0-5]\d):([0-5]\d)/;
					var regex = /^(?:\d|[01]\d|2[0-3]):([0-5]\d):([0-5]\d)/;					
          if(val && !regex.test(val)){
						ngModelController.$setViewValue(null);
						ngModelController.$render();
					}
        };				
      }
    };
  }])

  angular.module('gp4helpers').directive('ixDateTime', [ '$filter', function($filter) {
    return {
      restrict: 'E',
      require: '?ngModel',
      scope: {
        ngModel: '=',
        ngModelTime: '=?',
        dateLimit: '=?',
        dateMin: '=?',
        ngRequired: '=',
        ngDisabled: '=',
        name: '@',
        isFilter: '=?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixDateTime.html',
      link: function(scope, elem, attrs, ngModelController) {

        // Quan ngModel canvia (la data), i no tenim ngModelTime, agafem l'hora de la data
        scope.$watch('ngModel', function(newDate) {
          if (newDate instanceof Date && !scope.ngModelTime) {
            var hours = newDate.getHours() || 0;
            var minutes = newDate.getMinutes() || 0;
            //Se asigna la hora del sistema en el caso que se escoja fecha desde el datepicker y el ngModelTime no este definido
            if (hours === 0 && minutes === 0) {
              var currentDate = new Date();
              hours = currentDate.getHours();
              minutes = currentDate.getMinutes();
            }
            //Formatem amb zero inicial si cal
            var hStr = (hours < 10 ? '0' : '') + hours;
            var mStr = (minutes < 10 ? '0' : '') + minutes;
            scope.ngModelTime = hStr + ':' + mStr;
          }
           else if (angular.isUndefined(newDate)) {
            //Si el campo de fecha quedo vacio se limpia tambien el de hora
            scope.ngModelTime = undefined;
          }
        });

        // Quan ngModelTime canvia, actualitzem l'hora dins de ngModel
        scope.$watch('ngModelTime', function(newTime) {
          if (scope.ngModel instanceof Date && newTime && angular.isString(newTime) && /^\d{1,2}:\d{2}$/.test(newTime)) {
            var parts = newTime.split(':');
            var h = parseInt(parts[0], 10);
            var m = parseInt(parts[1], 10);
            var updatedDate = new Date(scope.ngModel.getTime()); // clonem la data
            updatedDate.setHours(h);
            updatedDate.setMinutes(m);
            updatedDate.setSeconds(0);
            updatedDate.setMilliseconds(0);
            scope.ngModel = updatedDate;
          }
        });

				var input = angular.element(elem.find('input#horaVarChar')[0]);
				input.on('keypress', function(e){
          var keyCode = (e.which||e.charCode||e.keyCode);
          if("0123456789:. '+".indexOf(String.fromCharCode(keyCode))>=0  ||  // Allow: numbers and valid separators
              [8,9,13,27,46].indexOf(keyCode)>=0 ||  // Allow: backspace, tab, enter, escape, delete
              ([65,67,86,88,90].indexOf(keyCode)  && ( e.ctrlKey === true || e.metaKey === true ) ) ||  // Allow: Ctrl+A, Command+A, ctrl+C,ctrl+X,ctrl+V, ctrl+Z
              (keyCode >= 35 && keyCode <= 40) // Allow: home, end, left, right, down, up
          ) {
            return true;
          } else {
            e.preventDefault();
            return false;
          }
        });
				
				input.on('blur',function(event){
          var newVal = event.target.value;
          var dateParts = newVal.split(/[\:\.\- '\+]{1}/);
          
          var now = ($filter("date")(new Date(), "HH:mm", null)).split(":");
          var hours = now[0];
          var minutes = now[1];
      
          /* INI introduccio sense separadors (. | + | -) */
          if(dateParts.length==1) {
            if(dateParts[0].length==0) {
              ngModelController.$setViewValue(null);
              ngModelController.$render();
          
              return;
            }
            var index = 2;
            hours = parseInt(dateParts[0].slice(0,2));								
            if(hours>23) {									
              hours = dateParts[0].slice(0,1);
              index = 1;
            }
            if(hours<10){
              hours="0"+hours;
            }
            if(dateParts[0].length>2) {									
              minutes = dateParts[0].slice(index,index+2);
              if(parseInt(minutes)>59)
              {
                minutes = "0"+dateParts[0].slice(index,index+1);
              }
            }
          }
          /* FIN introduccio sense separadors (. | + | -) */
      
          /* INI introduccio amb separadors (. | + | -) */
          if(dateParts[0].length>0 && dateParts[0].length<=2) {
            hours = parseInt(dateParts[0]);
            if(hours<10){
              hours="0"+hours;
            }
          }
          if(dateParts.length>1 && dateParts[1].length>0) {
            if(parseInt(dateParts[1]) < 9){
              minutes = "0"+parseInt(dateParts[1]);
            } else if(parseInt(dateParts[1]) > 59){
              minutes = "00";
            } else {
              minutes = dateParts[1];
            }
          }
          /* FIN introduccio amb separadors (. | + | -) */   
          
          scope.ngModelTime = hours + ":" + minutes;
          scope.validateTIME(scope.ngModelTime);
          scope.$applyAsync();
        });
				
        scope.validateTIME = function(val){
          //TODO: Fer que rebi per paràmetre si ha de ser en format hh:mm o hh:mm:ss.
					var regex = /^(?:\d|[01]\d|2[0-3]):([0-5]\d)/;					
          if(val && !regex.test(val)){
						ngModelController.$setViewValue(null);
						ngModelController.$render();
					}
        };				
              
      }
    };
  }])

  angular.module('gp4helpers').directive('ixP', [ function(){
    return {
      restrict: 'E',
      scope: {
        name: '@'
      },
      template: '<p translate="{{::name}}"></p>'
    }
  }])

  angular.module('gp4helpers').directive('ixText', [ function () {
    return {
      restrict: 'E',
			require: '?ngModel',
			transclude: true,
      scope: {
        ngModel: '=',
        ngModel2: '=?',
        ngRequired: '=',
        name: '@',
        ngDisabled: '=?',
        ngValue: '=?',
        ngPlaceholder: '@?',
        isFilter: '=?',
        cleanSpecialChars: '&?',
        maxLength: '=?',
        maxLength2: '=?',
				labelClass: '@?',
				inputClass: '@?',
				input1Class: '@?',
				input2Class: '@?',
				ngKeydown: '&?',
        redBackground: '=?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixText.html',
      link: function(scope, elem, attrs, ctrl){
				if (!ctrl) return;

        scope.mostrarControlSecundario = false;
        if(Object.keys(scope).indexOf("ngModel2") != -1)
          scope.mostrarControlSecundario = true;

        if(angular.isDefined(scope.cleanSpecialChars)){
          scope.$watch('ngModel', function (newValue, oldValue) {
            if (newValue != oldValue) {
              scope.ngModel = scope.cleanSpecialChars()(newValue);
            }
          });
        }

				scope.onKeydown = function(evt){
					if(angular.isDefined(scope.ngKeydown) && angular.isFunction(scope.ngKeydown))
						scope.ngKeydown()(evt);
				};

				var input = angular.element(elem.find('input')[0]);
				var inputModelCtrl = input.controller('ngModel');

				if(angular.isDefined(inputModelCtrl)){
					//El formatter del ixNumber modifica el valor que apareix en pantalla.
					//Per tant, si hi ha validació de maxlength, aquesta donaria error sempre que el numero contingui separador de milers.
					if(angular.isDefined(attrs.maxLength) && angular.isDefined(attrs.ixNumber)){
						inputModelCtrl.$validators.maxlength = function(modelValue, viewValue){
							if(angular.isDefined(modelValue) && modelValue != null){
								var withoutSeparators = modelValue.toString().replace(/\./g,'');
								withoutSeparators = withoutSeparators.replace(/\,/g,'');
								return withoutSeparators.length <= scope.maxLength;
							} else
                return true;
						};
					}
				}

        if(angular.isUndefined(scope.ngModel) && angular.isDefined(scope.ngValue))
          scope.ngModel = scope.ngValue;
      }
    };
  }])

  angular.module('gp4helpers').directive('ixPassword', [ function () {
    return {
      restrict: 'E',
			require: '?ngModel',
			transclude: true,
      scope: {
        ngModel: '=',
        ngModel2: '=?',
        ngRequired: '=',
        name: '@',
        ngDisabled: '=?',
        ngValue: '=?',
        ngPlaceholder: '@?',
        isFilter: '=?',
        cleanSpecialChars: '&?',
        maxLength: '=?',
        maxLength2: '=?',
				labelClass: '@?',
				inputClass: '@?',
				input1Class: '@?',
				input2Class: '@?',
				ngKeydown: '&?',
        redBackground: '=?'
      },
      templateUrl: 'app/base/views/helpers_templates/ixPassword.html',
      link: function(scope, elem, attrs, ctrl){
				if (!ctrl) return;

        scope.mostrarControlSecundario = false;
        if(Object.keys(scope).indexOf("ngModel2") != -1)
          scope.mostrarControlSecundario = true;

        if(angular.isDefined(scope.cleanSpecialChars)){
          scope.$watch('ngModel', function (newValue, oldValue) {
            if (newValue != oldValue) {
              scope.ngModel = scope.cleanSpecialChars()(newValue);
            }
          });
        }

				scope.onKeydown = function(evt){
					if(angular.isDefined(scope.ngKeydown) && angular.isFunction(scope.ngKeydown))
						scope.ngKeydown()(evt);
				};

				var input = angular.element(elem.find('input')[0]);
				var inputModelCtrl = input.controller('ngModel');

				if(angular.isDefined(inputModelCtrl)){
					//El formatter del ixNumber modifica el valor que apareix en pantalla.
					//Per tant, si hi ha validació de maxlength, aquesta donaria error sempre que el numero contingui separador de milers.
					if(angular.isDefined(attrs.maxLength) && angular.isDefined(attrs.ixNumber)){
						inputModelCtrl.$validators.maxlength = function(modelValue, viewValue){
							if(angular.isDefined(modelValue) && modelValue != null){
								var withoutSeparators = modelValue.replace(/\./g,'');
								withoutSeparators = withoutSeparators.replace(/\,/g,'');
								return withoutSeparators.length <= scope.maxLength;
							}
						};
					}
				}
      }
    };
  }])

  angular.module('gp4helpers').directive('ixRadio', [ function() {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        ngRequired: '=',
        name: '@',
        options: '=',
        ngDisabled: '=?',
        label: '@?',
        multipleInLine: '=?',
        withoutLabel: '=?',
        separateInTwoColumns: '=?',
        onChange: '=?',
        labelStyle: "=?"
      },
      templateUrl: 'app/base/views/helpers_templates/ixRadio.html'
    }
  }])

  /**
   * Directiva per formatejar/desformatejar inputs text amb valors numèrics
   * Ús: <input type="text" class="form-control" ng-model="facutra.importe" format-number with-decimals="2" allow-negative />
   */
   angular.module('gp4helpers').directive('ixNumber', ['$filter', 'cfg', function ($filter, cfg) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function (scope, elem, attrs, ctrl) {
        if (!ctrl) return;

        var input = angular.element(elem.find('input')[0]);

        // si attrs.withDecimals es nunumero, asumimos que es el numero de posiciones decimales deseadas. En caso que sea otra cosa (bool?) usaremos el valor cfg.DecimalScale (o 2 si no está definido)
				var decimals = (!isNaN(attrs.withDecimals) && attrs.withDecimals !== null && attrs.withDecimals !== '')?attrs.withDecimals:(cfg.DecimalScale || 2);

				var inputModelCtrl = input.controller('ngModel');

				if(angular.isDefined(inputModelCtrl)){
					//Afegim $formatter per fer que els valors que es veuen al carregar en pantalla tinguin el separador de numero i si cal decimal.
					inputModelCtrl.$formatters.push(function(value) {
						if(attrs.withDecimals)
							return $filter('number')(value, decimals);
						else
							return $filter('number')(value, 0);
					});
				}

				input.on('focus', function(e){
					e.target.value = ctrl.$modelValue || null;
				});

        input.on('blur', function (e) {
          if(angular.isDefined(attrs.minValue) && parseInt(ctrl.$modelValue) < attrs.minValue){
            scope.showCustomError("El rango es incorrecto = Desde " + attrs.minValue + " hasta " + attrs.maxValue);
            input.focus();
          }
          else if(angular.isDefined(attrs.maxValue) && parseInt(ctrl.$modelValue) > attrs.maxValue){
            scope.showCustomError("El rango es incorrecto = Desde " + attrs.minValue + " hasta " + attrs.maxValue);
            input.focus();
          }
          else {
            scope.clearCustomError();
          }

					if(attrs.withDecimals && ctrl.$modelValue){
						if(attrs.commaSeparator)  // usado en FT
							ctrl.$modelValue = ctrl.$modelValue.toString().replace(".",",");
						else
							ctrl.$modelValue = ctrl.$modelValue.toString().replace(",",".");

						var display = $filter('number')(ctrl.$modelValue, decimals);

						if (display)
							e.target.value = display;
						else {
							e.target.value = null;
						}
					}

        });

        elem.on('keypress', function (e) {

          var key = e.which;
          var numeros = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57]; //0123456789
          var separadores = [44, 46]; //.,  (teclat normal i numpad)
          var negativeSign = [45]; // -

          if(!key) {
            return true;
          } else if (numeros.indexOf(key) >= 0) {
            if(angular.isDefined(attrs.minValue) && parseInt(ctrl.$viewValue + (key - 48 ) ) < attrs.minValue){
              e.preventDefault();//si hi ha valor minim, ens assegurem que es cumpleix.
              return false;
            }
            //En el caso de que estamos usando decimales la siguiente condición no se debe de ejecutar porque en caso de que se haya presionado ','
            //el caracter no pasa al $viewValue y el cálculo del valor máximo lo hace mal
            if(!attrs.withDecimals && angular.isDefined(attrs.maxValue) && parseInt(ctrl.$viewValue + (key - 48 ) ) > attrs.maxValue){
              e.preventDefault();//si hi ha valor maxim, ens assegurem que es cumpleix.
              return false;
            }
            return true; // Allow: numbers
          } else if	(separadores.indexOf(key) >= 0 && attrs.withDecimals>0) {
            
						if(attrs.commaSeparator){
							if (e.target.value.indexOf(",")== -1) { // only one separateor allowed
								if (key === 46) { // si es . reemplazar por ,
									e.target.value = e.target.value.slice(0, e.target.selectionStart) + "," + e.target.value.slice(e.target.selectionEnd);
									e.preventDefault();
									return false; // Replace , for .
								} else {
									return true;  //Allow: valid separators
								}
							} else {	// Si ya hay un separador decimal ignorar
								e.preventDefault();
								return false;
							}
						} else {
							if (e.target.value.indexOf(".")== -1) { // only one separateor allowed
								if (key === 44) { // si es , reemplazar por .
									e.target.value = e.target.value.slice(0, e.target.selectionStart) + "." + e.target.value.slice(e.target.selectionEnd);
									e.preventDefault();
									return false; // Replace , for .
								} else {
									return true;  //Allow: valid separators
								}
							} else {	// Si ya hay un separador decimal ignorar
								e.preventDefault();
								return false;
							}
						}
					} else if (negativeSign.indexOf(key) >= 0 && attrs.allowNegative && !e.target.selectionStart) {//Als grids selectionStart = null. Si posem el negat, cumpliran els que sigui = 0 i null.
            return true; //Allow: negative sign at first position if enabled
          } else if (key==8) {
            return true;  // Allow backspace (firefox)
          } else if (e.ctrlKey === true || e.metaKey === true) {
            return true;  // Allow (ignore) Ctrl key
          }
          e.preventDefault();
          return false;

        });

        scope.showCustomError = function(msg){
          simulateAPIError(scope.form, "atencion", [{ message: msg }]);
        };

        scope.clearCustomError = function(){
					if(angular.isDefined(scope.form)){
						scope.form.$invalid = false;
						delete scope.form.$error["atencion"];
					}
        };
      }
    };
  }]);


  /**
   * Directiva validar que el valor d'un control sigui inferior al d'un altre. Per exemple, per dates.
   */
  angular.module('gp4helpers').directive('lowerThan', ['$timeout', '$log', 'cfg', '$filter', function($timeout, $log, cfg, $filter) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, elem, attrs, ctrl){
        if (!ctrl) return;
        elem.on('focus', function (e) {
          if (ctrl.$modelValue) {
            e.target.value = ctrl.$modelValue;
          }
        });
        elem.on('keypress', function (e) {
          $timeout(function(){ scope.validar() }, 1);
        });

        scope.validar = function(){
          var value = attrs.lowerThan.split('.').reduce(function(a, b) {
            return a[b];
          }, scope);

          if(angular.isDefined(ctrl.$modelValue)){
            if(ctrl.$modelValue > value){
              //scope.form.$invalid = true;
              scope.form.$error.validacion = [];
              scope.form.$error.validacion.push({$name:"El tiempo no puede ser superior a " + $filter("date")(value, cfg.dateFormat)});
            } else {
              //scope.form.$invalid = false;
              scope.form.$error.validacion = [];
            }
          }
        }
      }
    }
  }]);


  /**
   * Directiva validar que el valor d'un control sigui superior al d'un altre. Per exemple, per dates.
   */
  angular.module('gp4helpers').directive('higherThan', ['$timeout', '$log', 'cfg', '$filter', function($timeout, $log, cfg, $filter) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, elem, attrs, ctrl){
        if (!ctrl) return;
        elem.on('focus', function (e) {
          if (ctrl.$modelValue) {
            e.target.value = ctrl.$modelValue;
          }
        });
        elem.on('keypress', function (e) {
          $timeout(function(){ scope.validar() }, 1);
        });

        scope.validar = function(){
          var value = attrs.higherThan.split('.').reduce(function(a, b) {
            return a[b];
          }, scope);

          if(angular.isDefined(ctrl.$modelValue)){
            if(ctrl.$modelValue < value){
              //scope.form.$invalid = true;
              scope.form.$error.validacion = [];
              scope.form.$error.validacion.push({$name:"El tiempo no puede ser inferior de " +$filter("date")(value, cfg.dateFormat)});
            } else {
              //scope.form.$invalid = false;
              scope.form.$error.validacion = [];
            }
          }
        }
      }
    }
  }]);


  angular.module('gp4helpers').directive('ixGrid', [ function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        options : "@",
        height: "@"
      },
      templateUrl: 'app/base/views/helpers_templates/ixGrid.html'
    };
  }])

  angular.module('gp4helpers').directive('ixColor', [ function() {
    return {
      restrict: "E",
      require: '?ngModel',
      scope: {
        ngModel: '=',
        ngDisabled: '=',
        ngRequired: '='
      },
      controller: ['$scope', function($scope) {
        $scope.colors = getColors();
      }],
      templateUrl: 'app/base/views/helpers_templates/ixColor.html'
    };
  }])

	angular.module('gp4helpers').directive('ixSearchFromGrid', [ 'gridService', '$uibModal', 'ixStatusService', '$timeout', function(gridService, $uibModal, ixStatusService, $timeout){
    return {
      restrict: 'E',
      require: '?ngModel',
      transclude: true,
      scope: {
        ngModel: '=',
        ngDisabled: '=',
        ngDisabledText: '=?',
        ngRequired: '=',
        ngBlur: '=',
        name: '@',
        loadFunction: '=?',
        validateFunction: '=',
        ngValueFunc: '=?',
        //La entidad sobre la que cargaremos la tabla y sus datos.
        entity: '@',
        extraEntity: '@',
        //Guardará en ng-model la propiedad que se especifique cómo pk.
        pk: '@',
        extraPk: '@',
        //Opcionales:
        //Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
        wholeObj: '=?',
        //permite especificar que columnas se quieren mostrar, independientemente de la metadata.
        showOnlyDescribedCols: '=?',
        conditions: '=?',
        extraConditions: '=?',
        filtersApi: '=?',
        filterApiBy: '@?',
        period: '@?',
        identifierName: '@?',
        onSelect: '=?',
				windowTitle: '@?',
        descField: '@?',
        extraIcon: '@?'
      },
			link: function(scope, elem, attrs, ngModelController){
        if(scope.windowTitle)
          scope.windowTitleAux = scope.windowTitle;

        scope.openWindow = function(size, extraEntity){
          scope.status = ixStatusService.current;
          scope.data = ixStatusService.current.data;
          if(!scope.gridBusqueda || scope.extraEntity){
            var acciones = [
              {
                icon: "fa-eye",
                title: "Condiciones",
                accion: function(entity){
                  scope.ngModel = entity[extraEntity ? scope.extraPk : scope.pk];
                  //El valor que ensenyarem serà el valor que té el ngModel a no ser que definim una funció i la passem com a ng-value-func.
                  setValue(entity);
                  scope.wholeObj = entity;
				  if(angular.isDefined(scope.onSelect))
					scope.onSelect(entity);
                  //Mirem si té algún camp depenent, si és així l'actualitzem.
                  updateDependentFields(entity);
                  scope.modalDialog.close();
                  return true;
                }
              }
            ];
            var visibleCols = (scope.showOnlyDescribedCols) ? scope.showOnlyDescribedCols : [];
            var filtersApi = (scope.filtersApi) ? scope.filtersApi : [];
            if(angular.isDefined(scope.filterApiBy))
              scope.filterAPIBy = scope.filterApiBy;            
            scope.period = parseInt(scope.period);
            
            if(extraEntity) {
              scope.windowTitle = scope.extraEntity; //para cambiar el titulo del dialog
              scope.gridBusqueda = gridService.createGrid(scope, "searchFromGrid_"+scope.extraEntity+"Grid",  { enableHorizontalScrollbar: 2, enableRowSelection: false, enableRowHeaderSelection: false, enableFiltering: true, showOnlyDescribedCols: visibleCols, filtersAPI: filtersApi, enableCellEdit: false }, scope.extraEntity, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
              scope.gridBusqueda.filtroExterno = getAppliableConditions(true);
            }
            else {
              if(scope.windowTitleAux) 
                scope.windowTitle = scope.windowTitleAux;
              else
                scope.windowTitle = undefined;

              scope.gridBusqueda = gridService.createGrid(scope, "searchFromGrid_"+scope.entity+"Grid",  { enableHorizontalScrollbar: 2, enableRowSelection: false, enableRowHeaderSelection: false, enableFiltering: true, showOnlyDescribedCols: visibleCols, filtersAPI: filtersApi, enableCellEdit: false }, scope.entity, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
              scope.gridBusqueda.filtroExterno = getAppliableConditions(false);            
            }

            if(scope.loadFunction) {
              // scope.loadFunction().then(function(r) {
              //   scope.optionValues = r.data.Items ? r.data.Items : r.data;
              //   scope.optionValues.forEach(function(option){
              //     option.id = option[scope.pk];
              //     option.label = option[scope.desc];
              //     option.children = [];
              //     option.selected = false;
              //   });
              // });
              scope.gridBusqueda.ixLoadInitialData = function(){
                scope.loadFunction().then(function(response){
                  scope.gridBusqueda.data = response.data.Items;
                });
              }
            }


          } else {
            scope.gridBusqueda = gridService.createGridFunctions(scope, scope.gridBusqueda);
            scope.gridBusqueda.ixRestoreConfig();
          }

          scope.modalDialog = $uibModal.open({
            templateUrl: "ixSearchGridModal.html",
            scope: scope,
            size: size,
            windowClass: 'megawhere-popup',
            backdrop: 'static',
            keyboard: false
          });

        };

        var setValue = function(entity){
          if(angular.isDefined(scope.ngValueFunc) && typeof scope.ngValueFunc == "function"){
            scope.ngValueFunc(scope, entity).then(function(response){
              scope.ngModel = response.data;
							ngModelController.$setViewValue(scope.ngModel);
							ngModelController.$render();

							//return;
            });
          }
        };

        var getAppliableConditions = function(extraEntity){
          var appliableConditions = [];
          if(angular.isDefined(scope.conditions) && !extraEntity){
            appliableConditions = scope.conditions.filter(function(condition){ return angular.isDefined(condition.value) && condition.value != null; });
          }
          else if(angular.isDefined(scope.extraConditions)){
            appliableConditions = scope.extraConditions.filter(function(condition){ return angular.isDefined(condition.value) && condition.value != null; });
          }
          return appliableConditions;
        };

        var updateDependentFields = function(entity){
          if(angular.isDefined(scope.conditions)){
            var auxConditions = angular.copy(scope.conditions);
            auxConditions.forEach(function(condition){
              var dField = angular.isDefined(condition.dependentField) ? condition.dependentField : condition.field;
              //TODO: Buscar tots els <ix-search-from-grid> i revissar que sempre que hi ha condicions aquestes s'apliquen a propietats dintre de scope.data.datos.
              scope.data[dField] = entity[condition.field];
            });
          }
        };

        if(scope.conditions) {
          scope.$watch(function() {return scope.conditions}, function(nv, ov) {
            if(!angular.equals(nv,ov)) {
              if(angular.isDefined(scope.gridBusqueda)){
                scope.gridBusqueda.filtroExterno = getAppliableConditions();
                scope.gridBusqueda.ixLoadInitialData();
              }
            }
          });
        }

        scope.$watch('ngModel', function(nv, ov) {
          if(!angular.equals(nv,ov) && !angular.equals(nv,ngModelController.$modelValue)) {
            $timeout(function(){
              setValue(undefined);
            },1);
          }
        });
      },
//      controller: [ '$scope', 'gridService', '$uibModal', 'ixStatusService', '$timeout', function($scope, gridService, $uibModal, ixStatusService, $timeout){
//        $scope.openWindow = function(size){
//          $scope.status = ixStatusService.current;
//          $scope.data = ixStatusService.current.data;
//          if(!$scope.gridBusqueda){
//            var acciones = [
//              {
//                icon: "fa-eye",
//                title: "Condiciones",
//                accion: function(entity){
//                  $scope.ngModel = entity[$scope.pk];
//                  //El valor que ensenyarem serà el valor que té el ngModel a no ser que definim una funció i la passem com a ng-value-func.
//                  setValue(entity);
//                  $scope.wholeObj = entity;
//				  if(angular.isDefined($scope.onSelect))
//					$scope.onSelect(entity);
//                  //Mirem si té algún camp depenent, si és així l'actualitzem.
//                  updateDependentFields(entity);
//                  $scope.modalDialog.close();
//                  return true;
//                }
//              }
//            ];
//            var visibleCols = ($scope.showOnlyDescribedCols) ? $scope.showOnlyDescribedCols : [];
//            var filtersApi = ($scope.filtersApi) ? $scope.filtersApi : [];
//            $scope.gridBusqueda = gridService.createGrid($scope, "searchFromGrid_"+$scope.entity+"Grid",  { enableHorizontalScrollbar: 2, enableRowSelection: false, enableRowHeaderSelection: false, enableFiltering: true, showOnlyDescribedCols: visibleCols, filtersAPI: filtersApi, enableCellEdit: false }, $scope.entity, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
//            $scope.gridBusqueda.filtroExterno = getAppliableConditions();
//          } else {
//            $scope.gridBusqueda = gridService.createGridFunctions($scope, $scope.gridBusqueda);
//            $scope.gridBusqueda.ixRestoreConfig();
//          }
//
//          $scope.modalDialog = $uibModal.open({
//            templateUrl: "ixSearchGridModal.html",
//            scope: $scope,
//            size: size,
//            windowClass: 'megawhere-popup',
//            backdrop: 'static',
//            keyboard: false
//          });
//
//        };
//
//        var setValue = function(entity){
//          if(angular.isDefined($scope.ngValueFunc) && typeof $scope.ngValueFunc == "function"){
//            $scope.ngValueFunc($scope, entity).then(function(response){
//              $scope.ngValue = response.data;
//							ngModelController.$setViewValue($scope.ngValue);
//							ngModelController.$render();
//
//							return;
//            });
//          } else {
//            $scope.ngValue = $scope.ngModel;
//          }
//        };
//
//        var getAppliableConditions = function(){
//          var appliableConditions = [];
//          if(angular.isDefined($scope.conditions)){
//            appliableConditions = $scope.conditions.filter(function(condition){ return angular.isDefined(condition.value) && condition.value != null; });
//          }
//          return appliableConditions;
//        };
//
//        var updateDependentFields = function(entity){
//          if(angular.isDefined($scope.conditions)){
//            var auxConditions = angular.copy($scope.conditions);
//            auxConditions.forEach(function(condition){
//              var dField = angular.isDefined(condition.dependentField) ? condition.dependentField : condition.field;
//              //TODO: Buscar tots els <ix-search-from-grid> i revissar que sempre que hi ha condicions aquestes s'apliquen a propietats dintre de $scope.data.datos.
//              $scope.data[dField] = entity[condition.field];
//            });
//          }
//        };
//
//        if($scope.conditions) {
//          $scope.$watch(function() {return $scope.conditions}, function(nv, ov) {
//            if(!angular.equals(nv,ov)) {
//              if(angular.isDefined($scope.gridBusqueda)){
//                $scope.gridBusqueda.filtroExterno = getAppliableConditions();
//                $scope.gridBusqueda.ixLoadInitialData();
//              }
//            }
//          });
//        }
//
//        $scope.$watch('ngModel', function(nv, ov) {
//          if(!angular.equals(nv,ov)) {
//            $timeout(function(){
//              setValue(undefined);
//            },1);
//          }
//        });
//      }],
      templateUrl: 'app/base/views/helpers_templates/ixSearchFromGrid.html'
    };
  }]);

	/*
  angular.module('gp4helpers').directive('ixSearchFromGrid', [ function(){
    return {
      restrict: 'E',
      require: '?ngModel',
      transclude: true,
      scope: {
        ngModel: '=',
        ngDisabled: '=',
        ngRequired: '=',
        name: '@',
        validateFunction: '=',
        ngValueFunc: '=?',
        //La entidad sobre la que cargaremos la tabla y sus datos.
        entity: '@',
        //Guardará en ng-model la propiedad que se especifique cómo pk.
        pk: '@',
        //Opcionales:
        //Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
        wholeObj: '=?',
        //permite especificar que columnas se quieren mostrar, independientemente de la metadata.
        showOnlyDescribedCols: '=?',
        conditions: '=?',
        filtersApi: '=?',
        filterApiBy: '@?',
        period: '@?',
        identifierName: '@?',
        onSelect: '=?',
				windowTitle: '@?'
		
      },
      controller: [ '$scope', 'gridService', '$uibModal', 'ixStatusService', '$timeout', function($scope, gridService, $uibModal, ixStatusService, $timeout){
        $scope.openWindow = function(size){
          $scope.status = ixStatusService.current;
          $scope.data = ixStatusService.current.data;
          if(!$scope.gridBusqueda){
            var acciones = [
              {
                icon: "fa-eye",
                title: "Condiciones",
                accion: function(entity){
                  $scope.ngModel = entity[$scope.pk];
                  //El valor que ensenyarem serà el valor que té el ngModel a no ser que definim una funció i la passem com a ng-value-func.
                  setValue(entity);
                  $scope.wholeObj = entity;
				  if(angular.isDefined($scope.onSelect))
					$scope.onSelect(entity);
                  //Mirem si té algún camp depenent, si és així l'actualitzem.
                  updateDependentFields(entity);
                  $scope.modalDialog.close();
                  return true;
                }
              }
            ];
            var visibleCols = ($scope.showOnlyDescribedCols) ? $scope.showOnlyDescribedCols : [];
            var filtersApi = ($scope.filtersApi) ? $scope.filtersApi : [];
            $scope.gridBusqueda = gridService.createGrid($scope, "searchFromGrid_"+$scope.entity+"Grid",  { enableHorizontalScrollbar: 2, enableRowSelection: false, enableRowHeaderSelection: false, enableFiltering: true, showOnlyDescribedCols: visibleCols, filtersAPI: filtersApi, enableCellEdit: false }, $scope.entity, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
            $scope.gridBusqueda.filtroExterno = getAppliableConditions();
          } else {
            $scope.gridBusqueda = gridService.createGridFunctions($scope, $scope.gridBusqueda);
            $scope.gridBusqueda.ixRestoreConfig();
          }

          $scope.modalDialog = $uibModal.open({
            templateUrl: "ixSearchGridModal.html",
            scope: $scope,
            size: size,
            windowClass: 'megawhere-popup',
            backdrop: 'static',
            keyboard: false
          });

        };

        var setValue = function(entity){
          if(angular.isDefined($scope.ngValueFunc) && typeof $scope.ngValueFunc == "function"){
            $scope.ngValueFunc($scope, entity).then(function(response){
              $scope.ngValue = response.data;
							ngModelController.$setViewValue($scope.ngValue);
							ngModelController.$render();

							return;
            });
          } else {
            $scope.ngValue = $scope.ngModel;
          }
        };

        var getAppliableConditions = function(){
          var appliableConditions = [];
          if(angular.isDefined($scope.conditions)){
            appliableConditions = $scope.conditions.filter(function(condition){ return angular.isDefined(condition.value) && condition.value != null; });
          }
          return appliableConditions;
        };

        var updateDependentFields = function(entity){
          if(angular.isDefined($scope.conditions)){
            var auxConditions = angular.copy($scope.conditions);
            auxConditions.forEach(function(condition){
              var dField = angular.isDefined(condition.dependentField) ? condition.dependentField : condition.field;
              //TODO: Buscar tots els <ix-search-from-grid> i revissar que sempre que hi ha condicions aquestes s'apliquen a propietats dintre de $scope.data.datos.
              $scope.data[dField] = entity[condition.field];
            });
          }
        };

        if($scope.conditions) {
          $scope.$watch(function() {return $scope.conditions}, function(nv, ov) {
            if(!angular.equals(nv,ov)) {
              if(angular.isDefined($scope.gridBusqueda)){
                $scope.gridBusqueda.filtroExterno = getAppliableConditions();
                $scope.gridBusqueda.ixLoadInitialData();
              }
            }
          });
        }

        $scope.$watch('ngModel', function(nv, ov) {
          if(!angular.equals(nv,ov)) {
            $timeout(function(){
              setValue(undefined);
            },1);
          }
        });
      }],
      templateUrl: 'app/base/views/helpers_templates/ixSearchFromGrid.html'
    };
  }]);
	*/

  angular.module("gp4App").directive('ixNavbarResize', [ '$window', '$timeout', function($window,$timeout) {
	  return {
	    link: function(scope, el) {
	    	return;
	    }
	  }
	}]);

  angular.module("gp4App").directive('translateAttr', [ '$translate', function($translate){
    return {
      restrict: 'A',
      link: {
        pre: function (scope, elem, attrs) {
          var attribute = attrs.translateAttr,
              attributeValue = attrs[attribute];

          if (attributeValue) {
            $translate(attributeValue).then(function (translation) {
              //attrs.$set(attribute, translation[attributeValue]);
              attrs.$set(attribute, translation);
            });
          }
        }
      }
    };
  }]);

  angular.module("gp4App").directive('ixClearInput', [ '$compile', function($compile){
    return {
      restrict: 'A',
      require: '^ngModel',
      link: function(scope, elem, attr, ngModelCtrl){
        var modelController = ngModelCtrl;

        var template = '<span ng-show="notEmpty() && !status.editing" class="input-group-addon icon" ng-click="clear()"><i class="fa fa-close fa-lg"></i></span>';
        elem.parent().append($compile(template)(scope));

        scope.clear = function(){
          elem.val("");
          modelController.$setViewValue("");
        }

        scope.notEmpty = function(){
          if(angular.isDefined(modelController.$viewValue)){
            return modelController.$viewValue.length > 0;
          }
          return false;
        }
      }
    }
  }]);

  angular.module("gp4App").directive('gridScrollShared', [ '$timeout', function($timeout) {
    return {
      restrict: 'A',
      link: function(scope, elem, attr){
        $timeout(function() {
          var gridToSync = angular.element("#" + attr['gridScrollShared']);
          var target = gridToSync.find('.ui-grid-viewport');
          var source = elem.find('.ui-grid-viewport');

          source.scroll(function (evt) {
            target.scrollLeft(angular.element(this).scrollLeft());
          });
        }, 200);
      }
    }
  }]);

  angular.module("gp4App").directive('ixPivotTotal', [ '$q', '$log', function($q, $log){
    return {
      restrict: 'EA',
      require: '?ngModel',
      scope: {
        ngModel: '=',
        fields: '='
      },
      template: '<h3>Totales</h3><button ng-click="addTotal()">+</button><button ng-click="removeTotal()">-</button><div class="row" ng-repeat="total in ngModel track by $index"><div class="col-md-6"><ix-select ng-model="total.field" name="Campo" pk="campo" desc="nombre" load-function="listFields" load-all-items="true"></ix-select></div><div class="col-md-6"><ix-select ng-model="total.op" name="Operación" pk="operacion" desc="nombre" load-function="listOperations" load-all-items="true"></ix-select></div></div></div>',
      link: function(scope, elem, attr, ctrl){
        scope.addTotal = function(){
          var total = {};
          total.field = undefined;
          total.op = undefined;
          scope.ngModel.push(total);
        };

        scope.removeTotal = function(){
          scope.ngModel.pop();
        };

        scope.listFields = function(){
          var deferr = $q.defer();
          deferr.resolve({ data: Object.keys(scope.fields[0]).map(function(e){ return { campo: e, nombre: e }; }) });
          return deferr.promise;
        };

        scope.listOperations = function(){
          var deferr = $q.defer();
          deferr.resolve({ data: [ { operacion: 'count', nombre: 'Contar' }, { operacion: 'sum', nombre: 'Sumar' } ] });
          return deferr.promise;
        };
      }
    }
  }]);

  angular.module("gp4App").directive('ixBreadCrumb', [ '$log', '$filter', function($log, $filter){
    return {
      restrict: 'E',
      scope: {
        app: '=',
        menu: '='
      },
      template: "<span>{{ ::getBreadCrumb() }}</span>",
      link: function(scope, elem, attr){
        scope.setParentsMenu = function(menulevel, parent){
          angular.forEach(menulevel, function(level){
            if(angular.isDefined(parent)) level.parent = parent;
            if(angular.isDefined(level.children)) var existe = level.children.find(function(e){ return e == scope.app; });
            if(angular.isDefined(existe)){
              scope.itemInMenu = existe;
            }
            if(angular.isDefined(level.children)){
              scope.setParentsMenu(level.children, level);
            }
          });
        };
        scope.getBreadCrumb = function(){
          var breadcrumb = "";
          if(angular.isDefined(scope.itemInMenu)){
            return scope.generateBreadCrumb(scope.itemInMenu.parent, breadcrumb);
          } else {
            return "";
          }
        };

        scope.generateBreadCrumb = function(item, breadcrumb){
          if(angular.isDefined(item.parent)) breadcrumb = scope.generateBreadCrumb(item.parent, breadcrumb);
          breadcrumb = breadcrumb + $filter("translate")(item.display) + " > ";
          return breadcrumb;
        }

        scope.setParentsMenu(scope.menu[0].children);
      }
    }
  }]);

angular.module("gp4App").directive('ixFocusOut', ['$timeout', function($timeout) {
  return {
    restrict: 'A',

    link: function(scope, elem, attr) {
      var callback = scope[attr.ixFocusOut];
      // Para FT se añadió un timeout de 250ms al fosucout para dar tiempo a que se actualice el valor. Además hemos puesto un $destroy para optimizar
      if (angular.isFunction(callback)) {

        var handler = function(e) {
          $timeout(function() {
            callback(e);
          }, 250);
        };

        elem.on('focusout', {
          prop: attr.ixFocusOutParam,
          idx: attr.ixFocusOutParamIdx
        }, handler);

        scope.$on('$destroy', function() {
          elem.off('focusout', handler);
        });
      }
    }
  };
}]);




  angular.module("gp4App").directive('captureKeyDown', [ function(){
    return {
      restrict: 'EA',
      link: function(scope, elem, attr){
        elem.on('keydown', function(e){
        });
      }
    }
  }]);


  angular.module("gp4App").directive('datepickerTimezone', [ function () {
    var directive = {
            restrict: 'A',
            require: ['ngModel'],
            link: link
        };
        return directive;

        function link(scope, element, attr, ctrls) {
            var ngModelController = ctrls[0];

            // called with a JavaScript Date object when picked from the datepicker
            ngModelController.$parsers.push(function (viewValue) {
							if(viewValue){
								// undo the timezone adjustment we did during the formatting
                viewValue.setMinutes(viewValue.getMinutes() - viewValue.getTimezoneOffset());
                // we just want a local date in ISO format
                return viewValue.toISOString().substring(0, 10);
							}
							else {
								return null;
							}
            });

            // called with a 'yyyy-mm-dd' string to format
            ngModelController.$formatters.push(function (modelValue) {
                if (!modelValue) {
                    return undefined;
                }

              var timeZoneOffset = modelValue.getTimezoneOffset();
              if(timeZoneOffset != -60 && modelValue.getHours() != 0){
                /*if(timeZoneOffset < 0){
                  //Modificar la fecha a las 00:00 del mismo dia.
                  //modelValue.setDate(modelValue.getDate() - 1);
                  //modelValue.setHours(0);
                  //modelValue.setMinutes(0);
                  //modelValue.setSeconds(0);
                  //modelValue.setMilliseconds(0);
                  //modelValue.setMinutes(modelValue.getMinutes() + (timeZoneOffset) - 60);
                } else */
                if(timeZoneOffset > 0) {
                  //Modificar la fecha a las 00:00 del dia siguiente.
                  modelValue.setDate(modelValue.getDate() + 1);
                  modelValue.setHours(0);
                  modelValue.setMinutes(0);
                  modelValue.setMilliseconds(0);
                }
              }

              return modelValue;
            });
        }
}]);

	angular.module('gp4helpers').directive('ixForm', [ '$http', 'cfg', function($http, cfg){
		return {
			restrict: 'EA',
			scope: {
				entity: '@'
			},
			controller: ['$scope', function($scope){
				var that = this;
        this.getMetadata = function(){
					if(angular.isDefined($scope.entity)){
						return $http.get(cfg.baseURL + "metadata/" + $scope.entity).then(function(response){
							that.metadataForm = response.data;
							return that.metadataForm;
						});
					}
				};

				if(!this.metadataForm){
					this.getMetadata();
				}
      }]
		}
	}]);


	angular.module('gp4helpers').directive('ixField', [ function() {
		return {
			restrict: 'A',
			priority: 10,
			require: ['^ixForm', 'ngModel'],
			link: function(scope, elem, attr, controllers){
				scope.getMaxLength = function(keyName){
					var ixFormController = controllers[0];
					if(angular.isDefined(ixFormController.metadataForm)){
						var obj = ixFormController.metadataForm.find(function(e){ return e.Name == keyName; });
						return obj.MaxLength;
					}
				};

				scope.isVisible = function(keyName){
					var ixFormController = controllers[0];
					if(angular.isDefined(ixFormController.metadataForm)){
						var obj = ixFormController.metadataForm.find(function(e){ return e.Name == keyName; });
						return !obj.NoVisible;
					}
				};
			}
		};
	}]);

angular.module("gp4App").directive('ixHint', [ '$compile', function($compile){
    return {
      restrict: 'A',
			priority: 10,
      link: function(scope, elem, attr){
				var label = angular.element(elem.find('label')[0]);
				//Para añadir icono o cualquier html.
				var styles = "color:#7878ff;";
				if(attr.floatLeft){
					styles += "position: relative; left: -4px; ";
				} else {
					styles += "margin: 0px 2px;";
				}
        var template = '<span style="'+ styles +'"><i class="fa fa-question-circle fa-lg"></i></span>';
				label.prepend(template);
				
				label.attr("title", attr.ixHint);
      }
    }
  }]);


//	angular.module('gp4helpers').directive('ixPreviewImage', [ 'ixUtilsService', function(ixUtilsService) {
//		return {
//			restrict: 'E',
//			scope: {
//				src: '@',
//				type: '@?'
//			},
//			templateUrl: 'app/base/views/helpers_templates/ixPreviewImage.html',
//			link: function(scope, elem, attr){
//				scope.type = scope.type || "image";
//				scope.openPopup = function(){
//					var template = "ixPreviewImageModal.html";
//					var params = { src: scope.src };
//					ixUtilsService.openModalV2(template, { controller: "ixPreviewImageController" }, "small", params);
//				};
//			}
//		}
//	}]);
	
	
	angular.module('gp4helpers').directive('ixPreviewImage', [ 'ixUtilsService', '$http', 'Upload', 'cfg', 'ixStatusService', function(ixUtilsService, $http, Upload, cfg, ixStatusService) {
		return {
			restrict: 'E',
			scope: {
				entity: '@?',
				id: '=?',
				src: '@?',
				type: '@?',
				canUpload: '=?',
				height: '@?',
				width: '@?'
			},
			templateUrl: 'app/base/views/helpers_templates/ixPreviewImage.html',
			link: function(scope, elem, attr){
				if(angular.isUndefined(scope.height)){
					scope.height = "67";
				}
				scope.height += "px";
				
				if(angular.isUndefined(scope.width)){
					scope.width = "70";
				}
				scope.width += "px";
				
				scope.status = ixStatusService.current;
				scope.data = ixStatusService.current.data;
				scope.type = scope.type || "image";
				
				scope.guardarFoto = function(foto, id){
					if(foto, id){
						scope.data.uploadingFile = true;
						var upload = Upload.upload({
							url: cfg.baseURL + scope.entity+ "/UploadAndCreate/"+scope.id,
							data: {file: foto},
							dataType: 'json'
						});

						upload.then(function (response) {
							if(response.data){
								delete scope.data.ixProgress;
								scope.data.uploadingFile = false;
								//if(response.data.GlobalMessage.ErrorType != 0){
								scope.downloadImage(scope.entity, id);
								ixStatusService.setResponse(response);
								//}
								ixStatusService.setEditing(false);
								//$uibModalInstance.close(scope.data);
							}
						}, function (response) {
							if(response.data){
								delete scope.data.ixProgress;
								scope.data.uploadingFile = false;
							}
						}, function (evt) {
							// Math.min is to fix IE which reports 200% sometimes
							//file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
							scope.data.ixProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
						});
					}
				};
				
				scope.seleccionarFoto = function(event){
					if(scope.status.editing){
						var seleccionar = {
							controller:['$scope', '$uibModalInstance', 'cfg', function ($scope, $uibModalInstance, cfg) {
								$scope.status = { editing: true };
								$scope.maxUploadFileSize = cfg.maxUploadFileSize;

								$scope.data = {};
								$scope.save = function(){
									$uibModalInstance.close($scope.data.foto);
								};
								$scope.$close = function () {
									$scope.status.editing = false;
									$uibModalInstance.dismiss('cancel');
								};
							}],
							resolve: {
								clickedItem: function(){
									return angular.copy(scope.data.datos);
								}
							}
						};
						ixUtilsService.openModalV2('ixUploadImageModal.html', seleccionar, 'small').then(function(response){

							if(response){
								// Si no es nuevo conductor
								if(angular.isUndefined(scope.data.datos.isNew)){
									// Guardo la foto
									scope.guardarFoto(response[0], scope.id);
								}else scope.fotoToUpload = response[0];
							}
						});
					}
					if(angular.isDefined(event))
						event.stopPropagation();
				};

				scope.verFotoPopup = function(){
					if(scope.foto){
						var seleccionar = {
							controller:['$scope', '$uibModalInstance', 'cfg', function ($scope, $uibModalInstance, cfg) {
								$scope.status = { editing: true };
								$scope.maxUploadFileSize = cfg.maxUploadFileSize;
								$scope.nombre = scope.foto.nombre.split('.',1)[0];
								$scope.foto = scope.foto;
								$scope.src = scope.src;

								$scope.$close = function () {
									$scope.status.editing = false;
									$uibModalInstance.dismiss('cancel');
								};

								function urltoFile(url, filename, mimeType){
									return (fetch(url)
													.then(function(res){return res.arrayBuffer();})
													.then(function(buf){return new File([buf], filename,{type:mimeType});})
												 );
								}

								$scope.downloadImage = function(){
									urltoFile('data:'+scope.foto.imageMimetype+';base64,'+scope.foto.imagenBase64, $scope.nombre ,scope.foto.imageMimetype).then(function(file){ 
										saveAs(file, $scope.nombre);
									});

								};
							}]
						};
						var template = "ixPreviewImageModal.html";
						var params = { src: scope.src };
						ixUtilsService.openModalV2(template, seleccionar, 'small', params).then(function(response){

						});
					} else {
						scope.seleccionarFoto();
					}
				};


				scope.downloadImage = function(){

					$http.post(cfg.baseURL + scope.entity + "/DownloadImage/" + scope.id).then(function(response){
						// Cargo la foto
						//scope.data.datos.foto = response.data;
						scope.foto = response.data;
						scope.src = response.data.imagenBase64;
					}, function(err){
						// No se marca status por que puede no tener foto
						//ixStatusService.setResponse(err);
					});
				};
				
				if(angular.isUndefined(scope.src)){
					scope.downloadImage();
				}
				
				scope.$watch("id", function(newVal, oldVal){
					if(newVal != oldVal){
						if(newVal){
							scope.foto = undefined;
							scope.src = undefined;
							scope.downloadImage();
						}
					}
				});
			}
		}
	}]);

	angular.module('gp4helpers').directive('rotate', [ '$compile', '$timeout', function($compile, $timeout){
		return {
			restrict: 'A',
			link: function(scope, elem, attr){
				$timeout(function(){
					scope.orientation = (elem.width() > elem.height()) ? "H" : "V";
					if(scope.orientation == "H")
						scope.recalculateTop = true;
				},100);

				scope.rotation = 0;

				var el = angular.element('<span><button class="btn" style="float:left;" title="Rotar hacía la izquierda" ng-click="rotateLeft()"><i class="fa fa-undo" aria-hidden="true"></i></button><button class="btn pull-right" title="Rotar hacía la derecha" ng-click="rotateRight()"><i class="fa fa-repeat" aria-hidden="true"></i></button></span>');

				scope.rotateLeft = function(){
					if(scope.rotation == -4)
						scope.rotation = 0;

					scope.rotation--;
					scope.rotate();
				};

				scope.rotateRight = function(){
					if(scope.rotation == 4)
						scope.rotation = 0;

					scope.rotation++;
					scope.rotate();
				};

				scope.rotate = function(){
					var degrees = 90;
					var r = 'rotate(' + (degrees * scope.rotation) + 'deg) ';

					var top = "0px";
					if(scope.recalculateTop)
						top = (scope.orientation == "V") ? '0px' : ((elem.width() - elem.height()) / 2) + 'px';

					if(scope.orientation == "H")
						scope.orientation = "V";
					else
						scope.orientation = "H";

					elem.css({
						'-moz-transform': r,
						'-webkit-transform': r,
						'-o-transform': r,
						'-ms-transform': r,
						'position': 'relative',
						'top': top
					});
				};

				$compile(el)(scope);
				elem.before(el);
			}
		}
	}]);

	angular.module('gp4helpers').directive('zoomInPopup', [ 'ixUtilsService', function(ixUtilsService){
		return {
			restrict: 'A',
			link: function(scope, elem, attr){
				elem.css("cursor", "pointer");
				elem.on('click', function(){
					var template = "app/base/views/helpers_templates/ixPreviewImageFullWidthPopup.html";
					var params = { foto: angular.fromJson(attr.foto) };
					ixUtilsService.openModalV2(template, { controller: "ixPreviewImageFullWidthPopupController" }, 'big', params)
				});
			}
		}
	}]);

	angular.module('gp4helpers').directive('ixPreviewPdf', [ 'ixUtilsService', function(ixUtilsService) {
		return {
			restrict: 'E',
			scope: {
				src: '@',
				name: '@'
			},
			templateUrl: 'app/base/views/helpers_templates/ixPreviewPDF.html',
			link: function(scope, elem, attr){
				scope.openPopup = function(){
					var template = "ixPreviewPDFModal.html";
					var params = { src: scope.src };
					ixUtilsService.openModalV2(template, { controller: "ixPreviewPDFController" }, "medium", params);
				};
			}
		}
	}]);



})();

angular.module('gp4helpers').directive('onFinishRender', [ "$timeout", function ($timeout) {
  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      if (scope.$last === true) {
        $timeout(function () {
					if(angular.isDefined(scope[attr.onFinishRender]) && angular.isFunction(scope[attr.onFinishRender]))
						scope[attr.onFinishRender]();
					else
						scope.$emit('ngRepeatFinished');
        });
      }
    }
  }
}]);

angular.module('gp4helpers').directive('ixMapa', ['mapService', '$http', 'cfg', 'ixStatusService', 'ixUtilsService', '$window', '$timeout', 'mapStorageService', function (mapService, $http, cfg, ixStatusService, ixUtilsService, $window, $timeout, mapStorageService) {
	return {
		restrict: 'E',
		scope: {
			id: '@',
			pk: '@',
			lat: '@',
			lng: '@',
			markerText: '@?',
			markerType: '=?',
			entity: '@?',
			puntos: '=',
			boundsMap: '=?',
			readOnly: '=?',
			restablecerBtn: '=?',
			draggable: '=?',
			template: '@?',
			height: '@?',
			legend: '@?',
			draw: '@?',
			drawMultiple: '=?',
			minzoom: '@?',
			maxzoom: '@?',
			directions: '=?',
			connect: '=?',
			connectConditionFunction: '=?',
			savedlayers: '=?',
			createdInNgRepeat: '=?',
			options: '=?',
			tooltipTextProperty: '@?'
		},
		templateUrl: 'app/base/views/helpers_templates/ixMapa.html',
		link: function (scope, elem, params) {

			//Test
			scope.drawLayers = function(){
				mapService.drawnItems.clearLayers();
				var newLayers = [];
				angular.forEach(scope.savedlayers, function (layer, index) {
					if (layer) {
						mapService.addLayerToMap(layer);

						$timeout(function () {
							var capas = mapService.drawnItems.getLayers();
							newLayers.push({
								id: capas[index]._leaflet_id,
								layerType: layer.layerType,
								latlngs: layer.latlngs
							});
						}, 10);
					}
				});
				if (!mapService.options.keepCenter)
					mapService.setCenterAndCalcZoom(scope);
				scope.$emit("RefreshLayers", newLayers);
			};

			scope.$on("MapLayerToSave", function(event, data){
				if(!scope.savedlayers || !scope.drawMultiple){
					scope.savedlayers = [];
					//mapService.drawnItems.clearLayers();
				}
				scope.savedlayers.push(data);
			});


			scope.$on("MapLayerToUpdate", function(event, data){});

			scope.$on("MapLayersToDelete", function(event, data){
				for(var id in data){
					var idx = scope.savedlayers.findIndex(function(layer){
						return layer.id == id;
					});
					if(idx!= -1){
						scope.savedlayers.splice(idx, 1);
					}
				}
		});


			//

			// Puntos del mapa
			scope.puntosOriginales = [];

			// Si tiene layers guardadas
			if (mapService.drawnItems.getLayers().length > 0) {
				mapService.drawnItems.clearLayers();
			}

			// Inicializo el mapa
			var mapaObj = mapService.initMap(scope, {
				id: scope.id,
				pk: scope.pk,
				lat: scope.lat,
				lng: scope.lng,
				markerText: scope.markerText,
				markerType: scope.markerType,
				readOnly: scope.readOnly,
				draggable: scope.draggable,
				template: scope.template,
				draw: scope.draw,
				boundsMap: scope.boundsMap,
				directions: scope.directions,
				connect: scope.connect,
				connectConditionFunction: scope.connectConditionFunction,
				options: scope.options
				//items: scope.items//Parece que no se usa para nada
			});

			scope.mapServiceInstance = mapaObj;


			// Si se guardaron layers los cargo
			if (scope.savedlayers) {
				if (scope.savedlayers.length > 0) {
					/////////

					scope.drawLayers();

//					var newLayers = [];
//					angular.forEach(scope.savedlayers, function (layer, index) {
//						if (layer) {
//							mapService.addLayerToMap(layer);
//
//							$timeout(function () {
//								var capas = mapService.drawnItems.getLayers();
//								newLayers.push({
//									id: capas[index]._leaflet_id,
//									layerType: layer.layerType,
//									latlngs: layer.latlngs
//								});
//							}, 10);
//						}
//					});
//					if (!mapService.options.keepCenter)
//						mapService.setCenterAndCalcZoom(scope);
//					scope.$emit("RefreshLayers", newLayers);
					//////////
				}
			}

			scope.$watch('readOnly', function () {
				if (scope.draw)
					mapService.setingToolBar(scope);

				mapService.options.readOnly = scope.readOnly;
				//mapService.drawMap(scope, scope.puntos);
				mapService.changeReadOnly(scope);
			});

			scope.$watchCollection('puntos', function (newVal, oldVal) {
				if (scope.puntos) {
					//if (scope.puntos.length > 0) {
						//scope.puntos[0].orides_geo ? scope.clave = 'orides_geo' : scope.clave = 'orides';
						scope.puntoSeleccionado = {};
						scope.puntosOriginales = angular.copy(scope.puntos);
						scope.mapServiceInstance.drawMap(scope, scope.puntos);
//						if (scope.puntos.length >= 0 && !mapService.options.keepCenter && (!oldVal || (scope.createdInNgRepeat == true))) scope.mapServiceInstance.setCenterAndCalcZoom(scope);
					if (scope.puntos.length >= 0 && (!mapService.options.keepCenter || !oldVal) && (!oldVal || (scope.createdInNgRepeat == true))){
						scope.mapServiceInstance.setCenterAndCalcZoom(scope);
					}
					//}
				}
			});

			scope.$watch('savedlayers', function(newVal, oldVal) {
				if(!angular.equals(oldVal, newVal)){
					scope.drawLayers();
				}
			});


			// Opciones por defecto
			scope.defaults = {
				/*zoomSnap: 0, */
				zoomControl: true,
				scrollWheelZoom: true,
				doubleClickZoom: true,
				minZoom: scope.minzoom ? scope.minzoom : 1,
				maxZoom: scope.maxzoom ? scope.maxzoom : 18
			};

			scope.controls = {
				fullscreen: {
					position: 'topleft'
				}
			};

			///////////////////////////////////////////////////////Funciones mapas normales//////////////////////////////////////
			scope.calcularAltura = function (altura) {
				// Si no esta definia la calculo
				if (angular.isUndefined(altura)) {
					altura = 0;
					// Altura de los tabs
					var alturaTabs = 0;
					// Altura de los filtros	
					var alturaFiltros = 0;
					// Altura de la ventana
					var alturaTotal = angular.element('.view-frame')[0].offsetHeight;
					// Altura del menu superior
					var alturaMenuSup = angular.element('.view-frame')[0].offsetTop;
					var alturaLista = 0;

					// Si tiene tabs
					if (angular.element('.nav-tabs')[0]) {
						alturaTabs = angular.element('.nav-tabs')[0].offsetHeight;
					}
					// Si es un modal
					if (angular.element('.modal-body')[0]) {
						alturaTotal = angular.element('.modal-body')[0].offsetHeight;
						//if(angular.element(angular.element('.modal-body')[0]).children('.panel-group').length > 0){
						if (angular.element('.modal-body .panel-group')[0]) {
							alturaFiltros = angular.element('.modal-body .panel-group')[0].offsetHeight;
						}
					}
					// Si no es modal y tiene filtros
//					else if (angular.element('.panel-group').length > 0) {
//						alturaFiltros = angular.element('.panel-group')[0].offsetHeight;
//					}
					else if (angular.element('.panel-group').length > 0) {
						for(var i = 0; i < angular.element('.panel-group').length; i++){
							alturaFiltros = angular.element('.panel-group')[i].offsetHeight;
						}
					}
					// Si tiene cualquier otro item a tener en cuenta.
					if (angular.element('.info-group')[0]) {
						alturaLista = angular.element('.info-group')[0].offsetHeight;
					}
					// Altura final
					altura = (alturaTotal - alturaMenuSup - alturaFiltros - alturaTabs - alturaLista) - 70; // Variable de ajuste
				}
				return altura;
			}

			$timeout(function(){
				scope.height = scope.calcularAltura(scope.height);
			},100);

			scope.guardarCoordenadas = function (id) {

				var marker = {};
				angular.forEach(scope.markers, function (e) {
					if (e.id == id) marker = angular.copy(e);
				});

				var puntoActual = scope.puntos.find(function (e) {
					return e[scope.pk] == id;
				});
				var puntoOriginal = scope.puntosOriginales.find(function (e) {
					return e[scope.pk] == id;
				});
				// Añado la fecha de confirmación
				if (puntoActual.longitud && puntoActual.latitud)
					puntoActual.fecha_validacion_geo = new Date();
				var tabla = scope.entity;

				var changes = ixUtilsService.ixGetPatchOperations(puntoOriginal, puntoActual);

				if (puntoActual.table) {
					$http.put(cfg.baseURL + puntoActual.table + "/" + marker.id, changes).then(function (response) {
						ixStatusService.setResponse(response);
						scope.puntosOriginales = angular.copy(scope.puntos);
					}, function (err) {
						ixStatusService.setResponse(err);
					});
				} else {
					$http.put(cfg.baseURL + tabla + "/" + marker.id, changes).then(function (response) {
						ixStatusService.setResponse(response);
						scope.puntosOriginales = angular.copy(scope.puntos);
					}, function (err) {
						ixStatusService.setResponse(err);
					});
				}

			};

			scope.restablecerMapa = function () {
				scope.puntos = angular.copy(scope.puntosOriginales);
			};

			scope.tieneCambioCoordenadas = function (id) {
				if (id) {
					var puntoActual = scope.puntos.find(function (e) {
						return e[scope.pk] == id;
					});

					var puntoOriginal = scope.puntosOriginales.find(function (e) {
						return e[scope.pk] == id;
					});

					if (puntoActual) {
						return ((puntoActual.latitud != puntoOriginal.latitud) || (puntoActual.longitud != puntoOriginal.longitud) || puntoOriginal.fecha_validacion_geo == null);
					}
				} else return false;
			};

			scope.$on('leafletDirectiveMap.' + scope.id + '.zoomend', function(event, args){
				mapStorageService.saveMap(scope.id, { center: event.currentScope.center });
    	});

			scope.$on('leafletDirectiveMap.' + scope.id + '.dragend', function(event, args){
				mapStorageService.saveMap(scope.id, { center: event.currentScope.center });
    	});

			scope.$on('leafletDirectiveMarker.' + scope.id + '.dragend', function (event, args) {
				var punto = scope.puntos.find(function (e) {
					return e[scope.pk] == args.model.id;
				});
				punto.latitud = args.model.lat;
				punto.longitud = args.model.lng;

				mapService.drawMap(scope, scope.puntos);

				scope.$emit("MarkerDragEnd", punto);
			});

			scope.$on('leafletDirectiveMarker.' + scope.id + '.click', function (event, args) {
				var targetID = args.leafletEvent.originalEvent.target.id;
				scope.puntoSeleccionado = scope.puntos.find(function (e) {
					return e[scope.pk] == args.model.id;
				});
				if(angular.isDefined(scope.puntoSeleccionado)){
					if(angular.isDefined(scope.tooltipTextProperty)){
						if(angular.isDefined(scope.puntoSeleccionado[scope.tooltipTextProperty]))
							scope.puntoSeleccionado = scope.puntoSeleccionado[scope.tooltipTextProperty];
					}
				}
				scope.$emit("MarkerClicked", scope.puntoSeleccionado, targetID);
			});

		}
	};
}]);

/*
 * Directiva per donar el focus automàticament a un element
 * quan l'expressió passada a focus-me canvia a true.
 *
 * Exemple:
 *   <input focus-me="showInput">
 *
 * Quan showInput == true, es fa focus() sobre l'element.
 * S'utilitza $timeout perquè AngularJS hagi acabat de
 * renderitzar el DOM abans d'aplicar el focus.
 */
angular.module('gp4helpers').directive('focusMe', [ "$timeout", function ($timeout) {
    return function(scope, element, attrs) {
        scope.$watch(attrs.focusMe, function(value) {
            if (value) {
                $timeout(function() { element[0].focus() });
            }
        });
    };
}]);
/*eslint angular/no-private-call: 0*/
/*eslint angular/document-service: 0*/
angular.module('gp4helpers').directive('myTransitionEnd', ['$parse', 'ixStatusService', '$log', '$document', '$rootScope', '$timeout', function ( $parse, ixStatusService, $log, $document, $rootScope, $timeout ) {
  var transitions = {
      "transition"      : "transitionend",
      "OTransition"     : "oTransitionEnd",
      "MozTransition"   : "transitionend",
      "WebkitTransition": "webkitTransitionEnd"
  };

  var whichTransitionEvent = function () {
    var t,
      el = document.createElement("fakeelement");

    for (t in transitions) {
      if (angular.isDefined(el.style[t])){
        return transitions[t];
      }
    }
  };

  var transitionEvent = whichTransitionEvent();

  return {
    'restrict': 'A',
    'priority': 100,
    'link': function (scope, element, attrs) {
      var expr = attrs['myTransitionEnd'];
      var delayAnimation = attrs['delay'] || 1000;
      var fn = $parse(expr);

      element.bind(transitionEvent, function (evt) {
        if(!ixStatusService.current.transitionend){
          $log.log('got a css transition event', evt);

          if (scope.$root && !scope.$root.$$phase) {
            scope.finishedAnimation();
          }
        }
      });

      scope.finishedAnimation = function(){
        //ixStatusService.current.transitionend = true;
        if(ixStatusService.current.realtransitionend != true)
        {
          $timeout(function(){
            $rootScope.$broadcast('splash_hide');
          },delayAnimation);
          ixStatusService.current.transitionend = true;
        }
        var phase = scope.$root.$$phase;

        if (phase === '$apply' || phase === '$digest') {
          fn();
        } else {
          scope.$apply(fn);
        }
      }
    }
  };
 }]);

/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global CMP_LIKENONE*/
/*global buildIxSearch*/
	angular.module('angular-virtual-select', ['vs-repeat']);
	angular.module('angular-virtual-select').directive('virtualSelect', ['$filter', '$document', '$timeout', '$http', 'cfg', 'uiGridEditConstants', 'ixStatusService', 'lodash', '$q', '$log', function($filter, $document, $timeout, $http, cfg, uiGridEditConstants, ixStatusService, _, $q, $log) {
			return {
				restrict: 'AE',
				replace: true,
				require: '?ngModel',
				scope: {
					ngModel: '=',
					choicesRepeat: '=',
					filterBy: '=',
					placeholder: '=',
					displayProperty: '=',
					coreProperty: '=',
					singleselect: '=',
					multiselect: '=',
					limit: '=',
					onInputChange: '&',
					dynamicChoices: '=',
					allowCustom: '=?',
					allowCustomPriority: '=?',
					selectName: '=',
					localizeDisplayProperty: '=',
					blockModelUpdate: '=',
					ngDisabled: '=?',
					ngRequired: '=?',
					ngRequiredForm: '=?',

					//ix-select
					entity: '=',
					extraField: '=?',
					dropdownSinCodigo: '=?',
					filterFields: '=?',
					preload: '=?',
					conditions: '=?',
					loadFunction: '=?',
					ngDefault: '=?',
					//Si se li passa alguna variable de scope a whole-obj. El item que s'hagi sel·leccionat es guardarà a aquesta variable.
					wholeObj: '=?',
					orderStringAsInt: '=?',
					//Aquesta serà una funció que carregui un viewmodel sencer en el mateix moment d'accedir la pantalla. Útil per totes aquelles pantalles que tinguin un volum considerable de dropdowns.
					preloadFunction: '=?',
					//
					preloadObj: '=?',
					//La pk no sempre s'ha de dir igual que la del viewmodel.
					preloadPk: '=?',
					//Si és un dropdown que es monta a partir d'una funció de frontend i necessitem tots ja que es un filtre.
					loadAllItems: '=?',
					//Per pantalles on tenim totes les dades a un objecte carregat previament desde la API. Aconsellable fer-ho a pantalles on hi hagi forces dropdowns.
					entityData: '=?',
					entityDataPk: '=?',
					entityDataDesc: '=?',
					onSelect: '=?',
					appendToBody: '=?',

					//Grid properties:

					dropdownInGrid: "=?",
					gridRow: "=?",
					gridCol: "=?",
					keyFields: "=?",
					lookupKeyFields: "=?",
					lookupOrders: "=?",
					template: "=?",
					minLengthToLoad: "=?",
					maxLength: "=?",
					skipTableNameFilter: '=?',
					skipTableNameOrderBy: '=?',
					tableAliasName: '=?',
					longerResultBox: '=?',
					stringId: '=?'
				},
				/*template: `<div class="virtual-select ui-select-container ui-select-multiple ui-select-bootstrap">
						<div class="ui-select-match">
							<span ng-repeat="item in selected track by $index">
								<span class="ui-select-match-item btn btn-primary btn-xs btn-sm">
									<span class="close ui-select-match-close" ng-click="removeItem(item)">&nbsp;&times;</span>
									<span>{{display(item)}}</span>
								</span>
							</span>
							<input type="text" class="ui-select-search" ng-model="searchText" ng-click="activate()" placeholder="{{ selected.length ? '' : placeholder}}">
						</div>
						<ul ng-if="opened && list" class="virtual-select-list-container ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu">
							<li class="virtual-scroll-container ui-select-choices-group" vs-repeat="{size: 48}">
								<div class="ui-select-choices-row btn-sm" ng-repeat="choice in list | virtualSelectfilterSelected:choice:selected track by $index" ng-click="itemClick(choice)">
									<a class="virtual-scroll-list-item ui-select-choices-row-inner"> <!-- ui-select layout -->
										<span>
											{{display(choice)}}
										</span>
									</a>
								</div>
							</li>
						</ul>
					</div>`,*/
				template: '<div class="virtual-select ui-select-container ui-select-multiple ui-select-bootstrap">' +
						'<div class="ui-select-match">' +
							'<span ng-if="!dropdownInGrid" ng-repeat="item in selected track by $index" style="width:calc(100% - 26px);">' +
								'<span class="ui-select-match-item" style="width:100%;" ng-click="focusInput()">' +
									'<span ng-if="!dropdownInGrid" style="display: inline-block;white-space: nowrap;overflow: hidden;width: 100%;text-overflow: ellipsis;">{{display(item)}}</span>' +
								'</span>' +
							'</span>' +
							// FT: el grid jerarquico (pruebaFT) necesita definir un max-width al dropdown porque no tiene defina una altura fija a las filas
							'<span ng-if="dropdownInGrid" ng-style="gridCol.grid.options.pruebaFT?{\'max-width\' : \'calc(100% - 24px)\'}:{}" ng-click="forceInputFocus($event)" ng-dblclick="activate($event)">' +
								'<span class="ui-select-match-item" style="width:100%; margin:0;">' +
									/*'<span ng-if="dropdownInGrid" style="min-height: 22px; margin-top: 3px; display: inline-block;white-space: nowrap;overflow: hidden;width: 100%;text-overflow: ellipsis;">{{ngModel | gridfk:gridRow:gridCol}}</span>' +*/
									'<span ng-if="dropdownInGrid" ng-bind="ngModelDescription" ng-init="gridfkUpdate(gridRow, gridCol);" style="min-height: 22px; margin-top: 3px; display: inline-block;white-space: nowrap;overflow: hidden;width: 100%;text-overflow: ellipsis;"></span>' +
									//'<span ng-if="dropdownInGrid" style="margin-top: 3px; display: inline-block;white-space: nowrap;overflow: hidden;width: 100%;text-overflow: ellipsis;">{{display(ngModel)}}</span>' +
								'</span>' +
							'</span>' +
							'<input autocomplete="off" ng-click="forceInputFocus($event)" ng-dblclick="activate($event)" ng-disabled="ngDisabled" type="text" class="ui-select-search" ng-model-options="{\'updateOn\': \'default blur\',\'debounce\': {\'default blur\': 350 }}" ng-model="searchText" ng-keydown="checkActivateKeys($event)" placeholder="{{ selected.length ? \'\' : placeholder}}" maxlength="{{ allowCustom ? maxLength : 100}}">' +
							'<span ng-if="(!$parent.ngDisabled && !ngDisabled) && (!$parent.ngRequired && !ngRequired) && (!$parent.ngRequiredForm && !ngRequiredForm) && isSingleSelect() && ((ngModel != null && ngModel != \'\') || ($parent.ngModel != null && $parent.ngModel != \'\'))" class="icon close ui-select-match-close" ng-mousedown="clearSelected($event)">&nbsp;&times;</span>' +
							'<span ng-click="forceInputFocus($event)" ng-if="!ngDisabled" ng-mousedown="activate($event)"><i ng-class="{ \'fa-angle-down\': (!opened), \'fa-angle-up\': (opened) }" class="fa fa-lg"></i></span>' +
						'</div>' +
						'<ul ng-if="opened" class="virtual-select-list-container ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu">' +
							'<li class="virtual-scroll-container ui-select-choices-group" ng-class="{ \'longer-result-box\': longerResultBox }">' +
								'<div ng-if="!template" class="ui-select-choices-row btn-sm" ng-repeat="choice in list | virtualSelectfilterSelected:choice:selected:this track by $index" ng-click="itemClick(choice)" ng-class="{active: highlighted == $index}">' +
									'<a class="virtual-scroll-list-item ui-select-choices-row-inner"> <!-- ui-select layout -->' +
										'<div>{{choice[displayProperty]}} <span ng-if="extraField">/ {{choice[extraField]}}</span>'+				
										'<span ng-if="gridCol.colDef.LookUpResultFields.length > 1"><span ng-repeat="resultfield in gridCol.colDef.LookUpResultFields"><span ng-if="!$first && !$last">/ {{choice[resultfield] || choice[gridCol.colDef.ColumnFkDescription[$index]] }}</span></span></span>' +
										'</div>' +
										//'<div ng-class="{ \'invisible\': cfg.dropdownSinCodigo || dropdownSinCodigo }" class="text-muted">{{choice[coreProperty]}}</div>' +
										'<div ng-if="choice[coreProperty]!=(choice[resultfield] || choice[gridCol.colDef.ColumnFkDescription[$index]])" ng-show="!cfg.dropdownSinCodigo && !dropdownSinCodigo" class="text-muted">{{choice[coreProperty]}}</div>' +
										'<div ng-if="(cfg.dropdownSinCodigo || dropdownSinCodigo) && extraField">{{choice[extraField]}}</div>' +
									'</a>' +
								'</div>' +
								'<div ng-if="template" ng-include src="template"></div>' +
							'</li>' +
						'</ul>' +
					'</div>',
				link: function (scope, element, attrs) {
					scope.cfg = cfg;
					//Tecles:

					var cancellerCompleteLoad = {};

					var TAB_KEY = 9;
					var INTRO_KEY = 13;
					var ARROW_DOWN_KEY = 40;
					var ARROW_UP_KEY = 38;
					var ESCAPE_KEY = 27;
					var F4_KEY = 115;
					var F9_KEY = 120;
					var SPACE_BAR_KEY = 32;

					//Status ixSelect:
					var JUST_LOADED = 0;
					var FIRST_LOAD_INIT = 1;
					var FIRST_LOAD_DONE = 2;
					var COMPLETE_LOAD_DONE = 3;

					var CELL_HEIGHT = 39;
					var RESULT_BOX_HEIGHT = 200;
					var RESULT_OPTION_HEIGHT = 38;

					var customOption = {};
					var calledFromItemClick = false;

					var input = angular.element(element.find('input')[0]);

					// cancelar la propagació de l'event mousewheel per evitar que la pagina on es troba el virtual-select faci scroll
					element.on('wheel', function(e) {
						if(scope.opened) {
        					e.stopPropagation();
						}
      				});

					scope.forceInputFocus = function(ev){
						if(scope.dropdownInGrid){

							var isFocused = input.parent(".ui-grid-cell-focus");

							scope.focusInput();
							ev.preventDefault();
							if(angular.element(isFocused).hasClass("ui-grid-cell-focus"))
								ev.stopPropagation();
						}
					};
					
					scope.gridfkUpdate = function(row, col){
						//var itemWithDescription = $filter("gridfk")(input, scope.gridRow, scope.gridCol);
						scope.ngModelDescription = $filter("gridfk")(input, row, col);						
					};

					var clearHighlight = function(){
						scope.highlighted = -1;
					};

					//scope.firstLoadOrOpened = false;
					scope.dropdownStatus = JUST_LOADED;

					if(scope.preload) {
						$http.get(cfg.baseURL+scope.entity, { headers: { multipleCalls: true } }).then(function(r) {
							addToDropdown(r.data);
							clearHighlight();
							scope.choicesRepeat = r.data;
							if(!scope.dropdownInGrid){
								if (scope.list.length == 1) {
									//Si nomes hi ha un que quedi marcat
									//scope.ngModel = (scope.choicesRepeat[0][scope.coreProperty] !== 0) ? scope.choicesRepeat[0][scope.coreProperty] : null;
									//if(scope.ngModel != null) scope.wholeObj = scope.choicesRepeat[0];
									scope.itemClick(scope.list[0]);
								}
							}
						});
					}
					//else {
						if(!scope.dropdownInGrid)
							scope.list = [];

						scope.lastSearch = "";

						scope.refreshDropdown = function(searchInInput){
							//input.focus();
							scope.refresh(searchInInput);
						};

						scope.refresh = function(searchText){
							if(!scope.minLengthToLoad || (scope.minLengthToLoad && searchText.length >= scope.minLengthToLoad)){
								if(angular.isDefined(scope.preloadFunction) && scope.dropdownStatus == JUST_LOADED && scope.changedConditions)
									scope.loadFromPreloadFunction();
								else if(angular.isDefined(scope.entityData) && angular.isDefined(scope.entityDataDesc) && scope.dropdownStatus == JUST_LOADED && scope.changedConditions)
									scope.loadFromEntityData();
								else
									scope.doCompleteLoad(searchText, false);
							}
						};

						scope.loadFromEntityData = function(){
							scope.dropdownStatus = FIRST_LOAD_DONE;
							var item = {};
							item[scope.coreProperty] = angular.isDefined(scope.entityDataPk) ? scope.entityData[scope.entityDataPk] : scope.entityData[scope.coreProperty];
							item[scope.displayProperty] = scope.entityData[scope.entityDataDesc];

							addToDropdown([item]);
							clearHighlight();
						};

						scope.doCompleteLoad = function(search, equal){
							var param = {Filters:[],OrderBy:[]};
							var operator = CMP_LIKE;
							if(equal) operator = CMP_LIKENONE;
							
							if(scope.lookupKeyFields){
								param.Filters = scope.lookupKeyFields.map(function (c, ii, aa) {
								//Filtrem per clau composta només quan té valor.
									if(ii!==scope.lookupKeyFields.length-1) {
										// no importa l'ordre de les columnes, agafarà el valor que es demana per metadata
										// PREMISA: pos(KeyField)===pos(LookupKeyField).
										var tblName = "";
										if(!scope.skipTableNameFilter && scope.entity){
											tblName = scope.entity+".";
										}
										return {Field: tblName + c, Value: scope.gridRow.entity[scope.keyFields[ii]], Operator: CMP_EQ};
									}
								});
								param.Filters.pop();
							}

							if(!scope.dropdownInGrid && angular.isDefined(scope.entity) && !scope.skipTableNameFilter){
								param.Filters.push({StartPar:true, Field : scope.entity+"."+scope.displayProperty, Value : search, Operator : operator});
								param.Filters.push({Or: true, Field : scope.entity+"."+scope.coreProperty, Value : search, Operator : operator, EndPar:true});
							} else {
								if(scope.dropdownInGrid){
									//Busquem per totes les properties que es mostren en el dropdown.
									scope.gridCol.colDef.LookUpResultFields.forEach(function(fieldName, index){
										param.Filters.push({StartPar: (index == 0), Or: (index > 0), Field : fieldName, Value : search, Operator : operator, EndPar:(index==scope.gridCol.colDef.LookUpResultFields.length-1)});
									});
								}
								else {
									param.Filters.push({StartPar:true, Field : scope.displayProperty, Value : search, Operator : operator});
									param.Filters.push({Or: true, Field : scope.coreProperty, Value : search, Operator : operator, EndPar:true});
								}
							}

							var tblName = "";
							if(!scope.skipTableNameOrderBy){
								if(scope.tableAliasName)
									tblName = scope.tableAliasName + ".";
								else if(!scope.skipTableNameFilter && scope.entity)
									tblName = scope.entity + ".";
							}
							if(!scope.dropdownInGrid){
								if(angular.isDefined(scope.displayProperty)) param.OrderBy.push(tblName + scope.displayProperty);
							}
							else {
								param.OrderBy = scope.lookupOrders.map(function (o) {return (o.Desc ? "-" : "") + tblName + o.KeyField;});
							}

							if(scope.conditions) {
								scope.error = false;
								if(scope.dropdownInGrid){
									scope.conditions.forEach(function(cond) {
										if(angular.isUndefined(cond.Value)) scope.error = true;
										param.Filters.push({Field: cond.KeyField, Value: cond.Value, Operator : cond.Operator | CMP_EQ, Not : cond.Not | false, Skip: cond.Skip | false });
									});
								} else {
									scope.conditions.forEach(function(cond) {
										if(angular.isUndefined(cond.value)) scope.error = true;
										param.Filters.push({Field: cond.field, Value: cond.value, Operator : cond.op | CMP_EQ, Not : cond.not | false, Skip: cond.skip | false });
									});
								}
							}

							if(angular.isDefined(cancellerCompleteLoad[scope.entity])){
								//console.log("Entity (" + new Date() + "): " + scope.entity);
								//console.log("cancellerCompleteLoad(" + new Date() + "): " + cancellerCompleteLoad);								
								cancellerCompleteLoad[scope.entity].resolve();								
							}
							cancellerCompleteLoad[scope.entity] = $q.defer();

							if(scope.loadFunction) {
								scope.loadingResults = true;
								if(scope.dropdownInGrid){
									scope.loadFunction({ selected: (scope.selected) ? scope.selected[0] : scope.selected, search: search }, scope.gridRow, param, cancellerCompleteLoad[scope.entity]).then(function(r){
										scope.loadingResults = false;
										scope.dropdownStatus = COMPLETE_LOAD_DONE;
										var results = r.Items ? r.Items : r.data;
										//Si al buscar valor exacto solo se devuelve el item inventado, recuperamos los resultados cargados en la lista.
										if(equal && (results.length - countCustomOptions(results)) == 0)
											results = scope.list;
										if (!equal || (equal && results.length >0)){
											addToDropdown(results);
										}
										

										if(scope.moveBoxAfterLoad){
											moveBox();
										}

										clearHighlight();
										
										if(angular.isDefined(scope.changeSelectionAfterLoad)){
											scope.changeSelectionAfterLoad(scope.searchTextAux);
										} else if (equal) {											
											var item = getItemMatchingWithSearchText(search);
											if(angular.isDefined(item))
												scope.$emit("changeSelectionByValue", item);
											else {
												if((results.length - countCustomOptions(results)) == 1 || (results.length == countCustomOptions(results)) || (!scope.$parent.col.colDef.SkipEnterTabIfMultipleResults))
													scope.$emit("changeSelectionByValue", results[0]);
											}
										}
									});
								}
								else {
									return scope.loadFunction(param, search, scope.entity).then(function(r) {
										scope.loadingResults = false;
										scope.dropdownStatus = COMPLETE_LOAD_DONE;
										var results = r.data.Items ? r.data.Items : r.data;
										if (!equal || (equal && results.length>0)){
											addToDropdown(results);
										}
										if(getAllowCustom()){
											addCustomOption();
										}

										//Filtrar los resultados aquí. Se hace por si el loadFunction hace un get sin tener en cuenta parámetros.
										if(angular.isDefined(scope.searchText)){
											//scope.choicesRepeat = r.data.Items ? r.data.Items : r.data;
											//initializeListIfNeeded();
											initialList = angular.copy(scope.list);
											filterBySearchText(scope.searchText, null);
										}

										clearHighlight();

										if(angular.isDefined(scope.changeSelectionAfterLoad)){
											scope.changeSelectionAfterLoad(scope.searchTextAux);
										} else if (equal) {											
											var item = getItemMatchingWithSearchText(search);
											if(angular.isDefined(item))
												scope.$emit("changeSelectionByValue", item);
											else
												scope.$emit("changeSelectionByValue", results[0]);
										}	else if(getAllowCustom() && search != scope.searchTextAux && scope.list.length == 1 && scope.selected.length == 0 && !scope.opened){
											scope.itemClick(scope.list[0], true);
										}
									});
								}
							} else {
								if(!scope.error){
									scope.loadingResults = true;

									var requestPromise = $http({
										url: cfg.baseURL+scope.entity+"/Search?ItemsPerPage=100",
										data: param,
										timeout: cancellerCompleteLoad[scope.entity].promise,
										method: "POST"
									});

									//return $http.post(cfg.baseURL+scope.entity+"/Search?ItemsPerPage=100", param).then(function(r) {
									return requestPromise.then(function(response) {
										var r = response.data;
										scope.loadingResults = false;
										scope.dropdownStatus = COMPLETE_LOAD_DONE;
										//addToDropdown(r.data.Items);
										if (!equal || (equal && r.Items.length>0)){
											addToDropdown(r.Items);
										}
										if(getAllowCustom()){
											addCustomOption();
										}
										clearHighlight();

										if(angular.isDefined(scope.changeSelectionAfterLoad)){
											scope.changeSelectionAfterLoad(scope.searchTextAux);
										}

										if (equal)
											scope.$emit("changeSelectionByValue", r.Items[0]);
										
										//TODO: Mirar si això dona alguna mena de problema.
										//if(!scope.dropdownInGrid)
											//scope.choicesRepeat = angular.copy(scope.list);
									}, function(r) {
										if (equal)
											scope.$emit("changeSelectionByValue", undefined);
									});
								}

							}
						};


					//}

					scope.loadFromPreloadFunction = function(){
						return scope.preloadFunction().then(function(r) {
							scope.dropdownStatus = FIRST_LOAD_DONE;
							if(r.data != null){
								var obj = {};
								var objToSearch = angular.isDefined(scope.preloadObj) ? r.data[scope.preloadObj] : r.data;

								obj[scope.coreProperty] = angular.isDefined(scope.preloadPk) ? objToSearch[scope.preloadPk] : objToSearch[scope.coreProperty];

								if(scope.coreProperty != scope.displayProperty)
									obj[scope.displayProperty] = angular.isDefined(scope.preloadPk) ? objToSearch[scope.preloadPk + "nombre"] : objToSearch[scope.coreProperty + "nombre"];

								addToDropdown([obj]);

								if(optionNotInList(scope.ngModel))
									scope.loadSelectedItem(scope.ngModel);

								clearHighlight();
							} else {
								scope.changedConditions = false;
							}
						});
					};

					scope.focusInput = function(){
						input.focus();
					};

					scope.loadSelectedItem = function(value){
						var param = buildIxSearch();
						param.Filters.push({ Field: scope.coreProperty, Value: value, Operator: CMP_EQ });
						/*angular.forEach(scope.conditions, function(condition){
							param.Filters.push({ Field: condition.field, Value: condition.value, Operator: condition.op || CMP_EQ , Not: condition.not || false});
						});*/

						scope.dropdownStatus = FIRST_LOAD_INIT;
						
						if(angular.isDefined(cancellerCompleteLoad[scope.entity])){
							//console.log("Entity - loadSelectedItem (" + new Date() + "): " + scope.entity);
							//console.log("cancellerCompleteLoad - loadSelectedItem (" + new Date() + "): " + cancellerCompleteLoad);
							cancellerCompleteLoad[scope.entity].resolve();								
						}							

						if(scope.loadFunction) {
							return scope.loadFunction(param, undefined, scope.entity).then(function(r) {
								scope.loadingResults = false;
								var results = r.data.Items ? r.data.Items : r.data;

								if(scope.dropdownStatus == FIRST_LOAD_INIT && results.length == 1)
									scope.needsReload = true;
									
								scope.dropdownStatus = COMPLETE_LOAD_DONE;
								
								addToDropdown(results);
								if(getAllowCustom()){
									addCustomOption();
								}
								if(angular.isDefined(scope.changeSelectionAfterLoad)){
									scope.changeSelectionAfterLoad(scope.searchTextAux);
								}
								clearHighlight();
							});
						} else {

							return $http.post(cfg.baseURL + scope.entity + "/Search?ItemsPerPage=1", param).then(function(r){
								scope.dropdownStatus = FIRST_LOAD_DONE;
								if(angular.isDefined(r.data.Items) && r.data.Items[0]){
									//scope.choicesRepeat.push(r.data.Items[0]);
									//scope.virtualSelectSelectedOption(r.data.Items[0]);
									addToDropdown(r.data.Items);
								}
							}).catch(function(e) {
								scope.dropdownStatus = FIRST_LOAD_DONE;
								$log.error("Error al buscar el valor de "+scope.entity+" para "+value,e);
							});
						}
					};

					var restoreSingleSelectedValue = function(){
						var newSelected = {};
						var foundOne = false;

						//Aixo no hauria de perque ser-hi, scope.selected es converteix en array en algun punt despres de fer la sel·lecció.
						//Si es troba a on i no fa falta que sigui array, podrem esborrar la linea següent:
						scope.selected = (angular.isArray(scope.selected)) ? scope.selected[0] : scope.selected;

						if(angular.isDefined(scope.selected)){
							if(scope.dropdownInGrid){
								var filteredList = scope.filterResultsByPK(angular.copy(scope.list));
								foundOne = restoreFromList(filteredList);
							} else {
								foundOne = restoreFromList(scope.list);
							}

							if (foundOne) {
								newSelected = foundOne;
							}
						}

						return newSelected;
					};

					var restoreFromList = function(list){
						var foundOne = false;
						if (scope.coreProperty) {
							foundOne = _.find(list, function (obj) {
								return _.isEqual(jsonsify(obj[scope.coreProperty]), jsonsify(scope.selected[scope.coreProperty]));
							});
						}
						else {
							foundOne = _.find(list, function (obj) {
								return _.isEqual(jsonsify(obj), jsonsify(scope.selected));
							});
						}
						return foundOne;
					};

					var restoreMultipleSelectedValues = function(){
						var newSelected = [];
						var foundOne = false;
						_.each(scope.selected, function (value) {

							if (scope.coreProperty) {
								foundOne = _.find(scope.list, function (obj) {
									return _.isEqual(jsonsify(obj[scope.coreProperty]), jsonsify(value[scope.coreProperty]));
								});
							}
							else {
								foundOne = _.find(scope.list, function (obj) {
									return _.isEqual(jsonsify(obj), jsonsify(value));
								});
							}

							if (foundOne) {
								newSelected.push(foundOne);
							}
						});
						return newSelected;
					};

					var optionNotInList = function(id){
						var itemInList = scope.list.find(function(e){ return e[scope.coreProperty] == id; });
						return angular.isUndefined(itemInList);
					};

					var addCustomOption = function(){
						if(Object.keys(customOption).length > 0){
							if(!getItemMatchingWithSearchText(customOption[scope.coreProperty]))
								scope.list.push(customOption);
							//scope.searchText = '';
						}
					};
					/*
					var pushSelectionIfNotPresent = function(arrayToInspect, valuesToExclude){
						var returnedItems, selectedItemsNotInNewList;
						//TODO: Si hi ha condicions, s'haurà de mirar també per aquelles condicions.
						if(scope.dropdownInGrid){
							returnedItems = addNotPresentOptions(arrayToInspect, valuesToExclude);
						}
						else {
							selectedItemsNotInNewList = _.differenceBy(arrayToInspect, valuesToExclude, scope.coreProperty);
							returnedItems = selectedItemsNotInNewList.concat(valuesToExclude);
						}
						return returnedItems;
					};

					var addNotPresentOptions = function(newOptions, existingOptions){
						var alreadyExistingOptions = getDuplicateds(newOptions, existingOptions);
						return existingOptions.concat(_.difference(newOptions, alreadyExistingOptions));
					};

					var getDuplicateds = function(newOptions, existingOptions){
						var duplicateds = [];
						//La idea es que no ens retorni objectes que tinguin la PK repetida.
						angular.forEach(existingOptions, function(existingOption){
							duplicateds = duplicateds.concat(duplicatedItems(existingOption, newOptions));
						});
						return duplicateds;
					};

					var duplicatedItems = function(existingOption, newOptions){
						return newOptions.filter(function(newOption){
							var isInArray = true;
							for(var i = 0; i < scope.lookupKeyFields.length; i++){
								var filter = scope.lookupKeyFields[i];
								if(newOption[filter] != existingOption[filter])
									isInArray = false;
							}
							return isInArray;
						});
					};
					*/

					var addToDropdown = function(dataResult){
						dataResult.forEach(function(res){
							if(res.ContextID)
								delete res.ContextID;
						});

						if(scope.changedConditions){

							var seleccionado_valor_inventado;
							if(getAllowCustom() && scope.ngModel && scope.selected[0]){
								seleccionado_valor_inventado = (scope.selected[0].id == -1);
							}

							scope.list = dataResult;
							//setSelectedOption();
							//TODO: Se podría hacer otra cosa, como por ejemplo mirar si en la lista hay algún elemento con la misma pk, de momento solamente vacíamos.
							if(scope.dropdownStatus == COMPLETE_LOAD_DONE && (scope.selected[0] && !scope.containsObject(scope.selected[0], dataResult) && !dataResult.find(function(e){ return e[scope.coreProperty] === scope.ngModel; })))
							{
								if(!seleccionado_valor_inventado)
									scope.ngModel = null;
								scope.gridfkUpdate(scope.gridRow, scope.gridCol);
							}
							scope.changedConditions = false;
						} else {
							//scope.list = pushSelectionIfNotPresent(dataResult, (scope.dropdownInGrid) ? angular.copy(scope.list) : scope.selected);
							scope.list = dataResult;
						}


						if(scope.orderStringAsInt){ scope.list.sort(sortByNumber) }
						/*if (scope.list.length == 1 && (scope.ngRequired || scope.ngRequiredForm)) {
							$timeout(function(){
								scope.itemClick(scope.list[0]);
							},1);
						} else */
						if(scope.list.length == 0 ) {
							// Si no n'hi ha cap esborrar valor
							if(scope.ngRequired && scope.dropdownInGrid)
								scope.raiseAfterCellEdit = true;
							scope.ngModel = null;
							scope.wholeObj = {};
							scope.selected = [];
						}
						//Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
						else if(angular.isUndefined(scope.ngModel) && angular.isDefined(scope.ngDefault)){
							scope.ngModel = scope.ngDefault;
							setSelectedOption();
						} else {
							//Esta linea se ha puesto porque cuando hay dropdowns que arrastran datos no se muestra el valor seleccionado.
							setSelectedOption();
						}
					};

					var sortByNumber = function(a, b){
						return a[scope.displayProperty] - b[scope.displayProperty];
					};

					if(scope.conditions) {
						scope.$watch(function() {return scope.conditions}, function(nv, ov) {
							if(!angular.equals(nv,ov)) {
								scope.changedConditions = true;
								scope.wholeObj = null;
								scope.refresh("");
							}
						});
					}

					scope.clearSelected = function(event){
						initializeListIfNeeded();
						if(singleselect){
							scope.selected = null;
						} else {
							scope.selected = [];
						}
						updateModel();
						scope.opened = false;
						clearHighlight();
						onChangeResult();
						event.stopPropagation();
					};

					scope.isSingleSelect = function(){
						return singleselect;
					};

					var setSelectedOption = function(){
						//var appliableOptions = angular.copy(initialList);
						//var appliableOptions = angular.copy(scope.choicesRepeat);
						var appliableOptions = (angular.isDefined(scope.list)) ? angular.copy(scope.list) : angular.copy(scope.choicesRepeat);
						if(scope.dropdownInGrid)
							appliableOptions = scope.filterResultsByPK(appliableOptions);

						var found = appliableOptions.find(function(e){ return e[scope.coreProperty] === scope.ngModel && angular.isDefined(e[scope.coreProperty]); });
						if(scope.wholeObj)
							scope.wholeObj = found;
						if(found)
							scope.selected = [found];
						//ERROR SCROLL GRID FIXED
						//Per algun motiu, el grid, al fer scroll està gravant també a l'scope de les lineas de sota el selected.
						else if(scope.ngModel == null && scope.selected)
							scope.selected = [];
					};

					//


					var singleselect = attrs.singleselect != null;
					var multiselect = attrs.multiselect != null;
					var dynamicChoices = attrs.dynamicChoices != null;
					var allowCustom = scope.allowCustom;

					clearHighlight();

					var inputChangeFunctionProvided = attrs.onInputChange;

					var jsonsify = function (target) {
						var jsonsified = target;

						if (target && typeof target == 'object') {
							jsonsified = angular.fromJson(angular.toJson(jsonsified));
						}

						return jsonsified;
					};

					if (!singleselect && !multiselect) {
						multiselect = true;
					}

					var initialList;

					var initialize = function () {

						initialList = angular.copy(scope.choicesRepeat);
						initialList = jsonsify(initialList);

						//scope.list = angular.copy(initialList);
					};
					//initialize();

					var initializeListIfNeeded = function(){
						if((!initialList) || initialList.length == 0)
							initialize();
						if((!scope.list) || scope.list.length == 0)
							scope.list = angular.copy(initialList);
					};

					var applyFilters = function () {
						if (scope.filterBy) {
							var haveSomeFilters = _.some(scope.filterBy, function (val) {
								return !_.isUndefined(val);
							});

							var newVal;

							if (haveSomeFilters) {
								newVal = angular.copy(initialList);
							}

							_.each(scope.filterBy, function (filterValue, filterName) {
								if (filterValue) {
									newVal = $filter(filterName)(newVal, filterValue);
								}
							});

							if (haveSomeFilters) {
								scope.list = newVal;
								initialList = scope.list;
							}
						}
					};
					/*
					scope.$watchCollection('choicesRepeat', function () {

						initialize();

						applyFilters();
						filterBySearchText(scope.searchText);

						if (!scope.blockModelUpdate) {
							restoreSelectedValues();
						}
					}, true);
					*/


					var restoreSelectedValues = function () {
						if (typeof scope.selected != 'undefined') {
							var newSelected = [];

							if(singleselect){
								newSelected = restoreSingleSelectedValue();
							} else {
								newSelected = restoreMultipleSelectedValues();
							}
							if(newSelected.length > 0){
								scope.selected = newSelected;
							}
							updateModel();
						}
					};

					scope.$watchCollection('filterBy', function(newValue, oldValue) {
						if (newValue) {
							if (!_.isEqual(newValue, oldValue)) {
								applyFilters();
							}
						}
					}, true);

					var convert = function (model) {
						var result = [];

						var initialListAux = angular.copy(scope.list);
						if(scope.dropdownInGrid){
							initialListAux = scope.filterResultsByPK(initialListAux);
						}

						if (typeof model != 'object') {
							var candidate = _.find(initialListAux, function (item) {
								var target = scope.coreProperty ? item[scope.coreProperty] : item;
								if (typeof target == 'object') {
									target = jsonsify(target);
								}

								return _.isEqual(target, model);
							});

							if (candidate != null) result.push(candidate);
						}
						else if (typeof model == 'object') {
							_.each(model, function (value) {
								var candidate = _.find(initialListAux, function (item) {
									var target = scope.coreProperty ? item[scope.coreProperty] : item;
									if (typeof target == 'object') {
										target = jsonsify(target);
									}

									return _.isEqual(target, value);
								});

								if (candidate != null) result.push(candidate);
							});
						}

						return result;
					};

					var convertDynamic = function (model) {
						var result = [];

						if (typeof model == 'string') {
							result.push(model);
						}
						else if (typeof model == 'object') {
							_.each(model, function (value) {
								result.push(value);
							});
						}

						return result;
					};

					scope.display = function (item) {
						/*if(!scope.selected)
							setSelectedOption();

						if(scope.selected){
							var item = scope.selected[0];
							var result = item;
							if (scope.displayProperty) {
								result = item[scope.displayProperty];
								if(scope.extraField && angular.isDefined(item[scope.extraField]))
									result += " / " + item[scope.extraField];
							}
							if (attrs.localizeDisplayProperty != null) {
								result = $filter('i18n')(result, scope.localizeDisplayProperty);
							}

							return result;
						}
						return null;*/
						if(!scope.dropdownInGrid){
							if (item != null) {
								var result = item;

								if (scope.displayProperty) {
									result = item[scope.displayProperty];
									if(scope.extraField && angular.isDefined(item[scope.extraField]))
										result += " / " + item[scope.extraField];
								}
								if (attrs.localizeDisplayProperty != null) {
									result = $filter('i18n')(result, scope.localizeDisplayProperty);
								}

								return result;
							}
							return null;
						}/* else {
							var itemWithDescription = $filter("gridfk")(item, scope.gridRow, scope.gridCol);
							if(angular.isUndefined(itemWithDescription) && scope.ngModel){
								//scope.ngModel = null;
							}
							return itemWithDescription || scope.ngModel;
						}*/
					};

					var updateModel = function () {
						var result = null;

						if(angular.isDefined(scope.selected) && scope.selected != null){
							if(singleselect){
								if (scope.coreProperty) {
									result = scope.selected[scope.coreProperty];
								}
								else {
									result = scope.selected;
								}
							} else {
								if (scope.selected && scope.selected.length) {
									if (scope.coreProperty) {
										result = scope.selected.map(function(el){ return el[scope.coreProperty]; });
									}
									else {
										result = scope.selected;
									}
								}
							}
						}
						if(!calledFromItemClick)
							scope.selected = convert(jsonsify(result));
						else
							scope.selected = [ angular.copy(scope.selected) ];
						if(scope.selected.length == 0){
							if(scope.stringId)
								scope.ngModel = "";
							else
								scope.ngModel = null;
						}
						else scope.ngModel = (result === "") ? null : result;
					};


					////

					//provar
					scope.highlight = function(index){
						if(index < -1){
							index = -1;
							scope.highlighted = index;
						}
						else {
							var length = scope.list.length;
							if (length){
								var visibleElements = $filter("virtualSelectfilterSelected")(scope.list, undefined, scope.selected, scope);
								//scope.highlighted = scope.list.indexOf(scope.list[index]);
								//scope.highlighted = scope.list.indexOf(visibleElements[index]);
								scope.highlighted = visibleElements.indexOf(visibleElements[index]);
							}
						}
						scrollToHighlightedRegister();
					};

					var scrollToHighlightedRegister = function(){
						$timeout(function(){
							//scroll to element:
							var containerElement = angular.element(".virtual-select-list-container .virtual-scroll-container");
							containerElement.scrollTop(0);//set to top
							if(scope.highlighted > -1){
								var activeRowElement = angular.element('.ui-select-choices-row.active');
								var activeRowElementOffset = activeRowElement.offset();
								if(angular.isDefined(activeRowElementOffset)){
									//var activeRowElementTop = activeRowElementOffset.top;
									//var containerElementHeight = containerElement.height();
									var activeRowElementHeight = activeRowElement.height();
									//containerElement.scrollTop(activeRowElementTop - containerElementHeight);//then set equal to the position of the selected element minus the height of scrolling div
									containerElement.scrollTop(activeRowElementHeight * scope.highlighted);//then set equal to the position of the selected element minus the height of scrolling div
								}
							} else {
								containerElement.scrollTop(0);//set to top
							}
						},1);
					};

					var countCustomOptions = function(result){
						var customOptions = result.filter(function(e){ return e.specialFlag == -1 || e.id == -1 });
						return customOptions.length;
					};

					scope.checkActivateKeys = function(event){
						if(scope.opened){
							if(event.keyCode == ESCAPE_KEY){
								scope.searchText = '';
								//Tancar la llista sense sel·leccionar valor.
								if(scope.dropdownInGrid){
									scope.$emit('refreshCellFocus');
								}
								disposeElement();
							}
							else if(event.keyCode == ARROW_UP_KEY){
								//Tecla de flecha hacia arriba. Marcar opción superior
								scope.highlight(scope.highlighted - 1)
							}
							else if(event.keyCode == ARROW_DOWN_KEY){
								//Tecla de flecha hacia abajo. Marcar opción inferior
								scope.highlight(scope.highlighted + 1);
							}
							else if(event.keyCode == INTRO_KEY || event.keyCode == TAB_KEY){

								if(!scope.loadingResults){
									changeSelection();
								} else {
									scope.searchTextAux = angular.copy(scope.searchText);
									scope.changeSelectionAfterLoad = changeSelectionAfterLoad;
								}
								scope.searchText = '';
								if(scope.dropdownInGrid){
									scope.$emit('refreshCellFocus');
								}
								disposeElement();
							}
						}
						else {
							if(event.keyCode == SPACE_BAR_KEY){
								event.preventDefault();
							}
							if(event.keyCode == F4_KEY || 
								event.keyCode == F9_KEY ||   // BIOTECNAL prefiere usar F9 para abrir el dropdown
								isPrintableCharacter(event) ||	// BIOTECNAL: permitir abrir el dropdown con cualquier tecla que escriba un caracter imprimible, no sólo letras y números
								//anyNumberKey(event.keyCode) ||
								//anyLetterKey(event.keyCode) ||
								event.keyCode == ARROW_DOWN_KEY ||
								event.keyCode == SPACE_BAR_KEY){
								scope.activate(event);
							} else if((event.keyCode == INTRO_KEY || event.keyCode == TAB_KEY) && scope.searchText){
								scope.searchText = '';
							}
						}
						//TODO: Provar amb els grids que entra a dintre de la funció i que no fa el que fa al apretar les fletxes per evitar canvii de cel·la.
						//event.stopPropagation();
					};

					/* BIOTECNAL: mejor usar isPrintableCharacter y no anyNumberKey/anyLetterKey
					var anyNumberKey = function(keyCode){
						return (keyCode >= 96 && keyCode <= 105) || (keyCode >= 48 && keyCode <= 57);
					};

					var anyLetterKey = function(keyCode){
						return (keyCode >= 65 && keyCode <= 90);
					};
					*/					

					var isPrintableCharacter = function(event) {
						return event.key &&
							event.key.length === 1 &&
							!event.ctrlKey &&
							!event.altKey &&
							!event.metaKey;
					};

					var isDisabled = function(){
						if(scope.dropdownInGrid){
							return isCellDisabled();
						}
						else {
							return scope.ngDisabled;
						}
					};

					var isCellDisabled = function(){
						return scope.gridCol.grid.api.ix.disableField({row: scope.gridRow, col: scope.gridCol });
					};

					scope.filterResultsByPK = function(items){
						for(var i = 0; i < scope.keyFields.length - 1; i++){
							var keyField = scope.keyFields[i];
							var lookupKeyField = scope.lookupKeyFields[i];
							items = items.filter(function(e){ return e[lookupKeyField] == scope.gridRow.entity[keyField]; });
						}
						return items;
					};

					///

					scope.activate = function (event) {
						if(!scope.ngDisabled && !scope.opened){
							initializeListIfNeeded();
							input.focus();
							if (multiselect && scope.limit && scope.selected && (scope.limit <= scope.selected.length)) {
								return;
							}

							scope.opened = true;

							//if(scope.dropdownStatus == COMPLETE_LOAD_DONE && scope.searchText == "")
								//scope.refreshDropdown("");

							$timeout(function () {
								scope.$digest();
								if(scope.dropdownInGrid || scope.appendToBody)
									//TODO: Colocar la caja allí donde toque:
									input.focus();
									event.currentTarget = event.currentTarget.parentNode;
									putResultBoxCloseToClickedCell(event);
							}, 0);
						} else {

							disposeElement();
						}
					};

					var putResultBoxCloseToClickedCell = function(event){

						var clickedElement = angular.element(event.currentTarget);
						var clickedElementOffset = clickedElement.offset();

						var resultBox = angular.element("ul.virtual-select-list-container");
						if((scope.dropdownInGrid || scope.appendToBody) && angular.isDefined(resultBox[0])){
							resultBox[0].style.top = (clickedElement[0].offsetTop + clickedElement[0].offsetHeight) + "px";
							resultBox[0].style.left = clickedElement[0].offsetLeft + "px";
							resultBox[0].style.minWidth = clickedElement[0].clientWidth + "px";
							appendToBody(resultBox);
						}/* else {
							resultBox[0].style.top = clickedElementOffset.top + "px";
							resultBox[0].style.left = clickedElementOffset.left + "px";
						}*/

						//if(scope.appendToBody)
							//appendToBody(resultBox);

						scope.focused = false;
						scope.focused = true;
					};

					var appendToBody = function(htmlElement){
						htmlElement = setCoordinates(htmlElement);
						var fullscreendiv = closest(element, "isInFullScreen");
						if(fullscreendiv) {
							angular.element(fullscreendiv).append(htmlElement);
							//$document.find(fullscreendiv).append(htmlElement);
						} else {							
							$document.find('body').append(htmlElement);
						}
					};

					var setCoordinates = function(htmlElement){
						var bodyRect = $document.find('body')[0].getBoundingClientRect();
					var elemRect = htmlElement[0].getBoundingClientRect();
					var offsetTop = elemRect.top - bodyRect.top;
						var offsetLeft = elemRect.left - bodyRect.left;


						if(!isOutOfBodyRect(bodyRect, elemRect)){
							htmlElement[0].style.top = offsetTop + "px";
							htmlElement[0].style.left = offsetLeft + "px";
						} else {
							scope.initialTop = (offsetTop - RESULT_BOX_HEIGHT - CELL_HEIGHT);
							htmlElement[0].style.top = (offsetTop - RESULT_BOX_HEIGHT - CELL_HEIGHT) + "px";
							htmlElement[0].style.left = offsetLeft + "px";

							scope.moveBoxAfterLoad = true;
							if(scope.dropdownStatus != JUST_LOADED && !scope.loadingResults)
								moveBox();
						}

						return htmlElement;
					};

					var moveBox = function(){
						if(scope.opened){
							var numItems = scope.list.length;
							var resultBox = angular.element("ul.virtual-select-list-container");
							resultBox[0].style.top = (scope.initialTop) + "px";
							if(((angular.isDefined(scope.selected)) && scope.selected.length > 0)){
								var selected = false;
								for(var i = 0; i < scope.list.length; i++){
									var item = scope.list[i];
									if(angular.equals(item, scope.selected[0])){
										selected=true;
										break;
									}
								}
								if(selected)
									numItems--;
							}

							if(numItems < 6){
								if(numItems == 5)
									resultBox[0].style.top = (parseInt(resultBox[0].style.top) + 8)+ "px";
								else if(numItems > 0)
									resultBox[0].style.top = (parseInt(resultBox[0].style.top) + (RESULT_OPTION_HEIGHT * (5 - numItems)) + 8)+ "px";
								else
									resultBox[0].style.top = (parseInt(resultBox[0].style.top) + (RESULT_OPTION_HEIGHT * 5) + 8)+ "px";
							}
						}
					};

					var isOutOfBodyRect = function(bodyRect, elemRect){
						return (elemRect.y + RESULT_BOX_HEIGHT > bodyRect.height);
					};

					scope.$on('virtualScrollActivate', function (event, name) {
						if ((name == scope.selectName) && (name != null)) {
							scope.activate();
						}
						else if (name != scope.selectName) {
							disposeElement();
						}
					});

					scope.virtualSelectSelectedOption = function(value){
						//scope.selectedAfterLoad = true;
						if(singleselect){
							scope.selected = value;
						} else {
							if (!scope.limit || (scope.limit && scope.selected && (+scope.limit > scope.selected.length))) {
								scope.selected.push(value);
							}
						}
					};

					/*scope.$watch('opened', function (newVal, oldVal) {
						if (scope.selectName) {
							scope.$emit('vsSpecificOpenStateChange', {name: scope.selectName, val: newVal});
						}
						if(newVal == true && scope.dropdownStatus != COMPLETE_LOAD_DONE && !scope.preload) scope.refreshDropdown("");
					});*/

					scope.itemClick = function (choice, isDelayed, skipOnChangeResult) {
						var alreadySelected;
						if(singleselect){
							alreadySelected = _.isEqual(scope.selected, choice);
						} else {
							alreadySelected = _.find(scope.selected, function (item) {
								return _.isEqual(item, choice);
							});
						}

						if (!alreadySelected) {
							calledFromItemClick = true;
							if (singleselect) {
								//scope.selected = [ choice ];
								scope.selected = choice;
								updateModel();
							}
							else if (multiselect) {
								if (!scope.limit || (scope.limit && scope.selected && (+scope.limit > scope.selected.length))) {
									scope.selected.push(choice);
									updateModel();
								}
							}
						}

						if (!multiselect) {
							scope.opened = false;
						}

						if (!getAllowCustom() || (scope.selected && scope.selected.length)) {
							scope.searchText = '';
						}

						clearHighlight();
						if(!skipOnChangeResult)
							onChangeResult();
						calledFromItemClick = false;
					};

					scope.removeItem = function (event, choice) {

						var ind = scope.selected && scope.selected.indexOf(choice);

						if (ind > -1) {
							scope.selected.splice(ind, 1);
							updateModel();
						}

						if (inputChangeFunctionProvided) {
							scope.onInputChange({text: ''});
						}

						event.preventDefault();
					};


					scope.removeSelection = function(event){
						scope.removeItem(event, scope.selected[0]);
					};

					var disposeElement = function (emptySearchText) {
						if(scope.searchText)
							scope.needsReload = true;

						scope.opened = false;

						if ((emptySearchText) || (!getAllowCustom()) || (scope.selected && scope.selected.length)) {
							scope.searchText = '';
						}

						$timeout(function () {
							scope.$digest();
						}, 0);
					};

					var onDocumentClick = function (event) {
						if (!element[0].contains(event.target)) {
							disposeElement(true);
						}
					};

					var changeSelection = function(){

						var visibleElements = $filter("virtualSelectfilterSelected")(scope.list, undefined, scope.selected, scope);
						//si hay alguno marcado quedarse con ese.
						if(hasOptionHighlighted()){
							scope.itemClick(visibleElements[scope.highlighted]);
						} else if(scope.searchText){//si no, quedarse con el primero que coincida con el texto de busqueda, si no hay ninguno coge el primero de la lista.
							var matchingElement = getItemMatchingWithSearchText(scope.searchText);
							if(matchingElement)
								scope.itemClick(matchingElement);
							else
							{	
								//seleccionamos el primer item
								//scope.itemClick(visibleElements[0]);
								
								//ibran: aquí lanzaremos un search con IGUAL a scope.searchText del código								
								if(angular.isDefined(scope.doCompleteLoad))
									scope.doCompleteLoad(scope.searchText, true);
								else
									scope.itemClick(scope.list[0]);
							}
						}
					};
					
					scope.$on("changeSelectionByValue", function (ev, item) {
						var visibleElements = $filter("virtualSelectfilterSelected")(scope.list, undefined, scope.selected, scope);
						if(angular.isUndefined(item))
							scope.itemClick(visibleElements[0]);										
						else
							scope.itemClick(item);										
					});

					var onChangeResult = function(){
						if(!calledFromItemClick)
							setSelectedOption();

						scope.searchText = '';
						if(scope.dropdownInGrid)
							scope.raiseAfterCellEdit = true;

						$timeout(function(){
							if(angular.isDefined(scope.onSelect)){
								if(singleselect){
									scope.onSelect(scope.selected[0], scope.ngModel, scope.entityDataPk);
								}
							}
						});
					};

					scope.$watch('opened', function (newVal, oldVal) {
						if (newVal) {
							$document[0].addEventListener('click', onDocumentClick, true);
						}
						else if (!_.isUndefined(newVal)) {
							$document[0].removeEventListener('click', onDocumentClick, true);
						}
						if (scope.selectName) {
							scope.$emit('vsSpecificOpenStateChange', {name: scope.selectName, val: newVal});
						}
						//ERROR SCROLL GRID FIXED
						//Per algun motiu, el grid, al fer scroll està gravant també a l'scope de les lineas de sota el selected.
						if(scope.selected && scope.ngModel == null)
							scope.needsReload = true;
						if(newVal == true && (scope.dropdownStatus != COMPLETE_LOAD_DONE && !scope.preload || scope.needsReload)){
							scope.needsReload = false;
							scope.refreshDropdown("");
						}
					});


					//Events per marcar la opció marcada al dropdown de formulari.
					if(!scope.dropdownInGrid){
						angular.element(input).bind('focus',function(e){
							angular.element(e.currentTarget.parentNode).addClass("focused");
							scope.focused = true;
						});

						angular.element(input).bind('blur',function(e){
							angular.element(e.currentTarget.parentNode).removeClass("focused");
							scope.focused = false;
						});
					}

					scope.$watch('ngModel', function (newVal, oldVal) {
						if(!scope.dropdownInGrid){
							//el dropdown está en un formulario.
							if (angular.isDefined(newVal) /*&& newVal != null*/ && (typeof newVal != 'object' || newVal == null /* && !newVal.length*/)) {
								if (!dynamicChoices && !getAllowCustom()) {
									scope.selected = convert(jsonsify(newVal));
									if(scope.selected.length == 0 && newVal != null/* && scope.dropdownStatus == JUST_LOADED*/){
										if(!scope.loadAllItems){
											if(angular.isDefined(scope.preloadFunction) && scope.dropdownStatus == JUST_LOADED)
												scope.loadFromPreloadFunction();
											else if(angular.isDefined(scope.entityData) && angular.isDefined(scope.entityDataDesc))
												scope.loadFromEntityData();
											else if(scope.dropdownStatus == JUST_LOADED || optionNotInList(newVal))
												scope.loadSelectedItem(newVal);
										}
										else
											scope.refresh("");
									}
								}
								else {
									if (typeof newVal == 'string') {
										scope.searchText = newVal;
										scope.forceLoad = true;
										//troç que fa que el dropdown tingui sel·leccionat el valor inventat al carregar
										buildCustomOption(newVal);
										if(getAllowCustom()){
											addCustomOption();
										}
										if(scope.list.length == 1)
											scope.itemClick(scope.list[0], true, true);
										//
									}
									else {
										scope.selected = newVal;
									}
								}
							}
							else if(angular.isUndefined(scope.ngModel)){
								scope.selected = [];
							}
							else {
								if(angular.isDefined(scope.selected) && scope.selected.length > 0){
									if(singleselect){
										scope.list.push(scope.selected);
									} else {
										scope.list.push.apply(scope.list, scope.selected);
									}
								} else {
									scope.selected = [];
									scope.searchText = '';
								}
							}
						}
						else {
							//el dropdown está dentro de un grid
							//setSelectedOption();
							if((ixStatusService.current.editing || ixStatusService.current.changeDropdownWithoutEditing) && oldVal != newVal){
								if(scope.raiseAfterCellEdit){
									$timeout(function(){
										scope.raiseAfterCellEdit = false;									
										scope.$emit('raiseAfterCellEdit', { newVal: newVal, oldVal: oldVal} );									
										scope.gridfkUpdate(scope.gridRow, scope.gridCol);
									},1);
								} else {
									scope.gridfkUpdate(scope.gridRow, scope.gridCol);
								}
							}
						}
					});

					scope.containsObject = function(obj, list) {
						var i;
						for (i = 0; i < list.length; i++) {
							if (angular.equals(list[i], obj)) {
								return true;
							}
						}
						return false;
					};

					scope.$watch('searchText', function (newVal, oldVal) { // filter by search text
						if(angular.isDefined(newVal)){
							if(newVal != "" || oldVal != ""){
								filterBySearchText(newVal, oldVal);
								scope.searchTextChanged = true;
								if((scope.opened || typeof scope.opened == "undefined") && (!scope.preload || scope.forceLoad)){
									scope.forceLoad = false;
									if(getAllowCustom() && scope.forceLoad)
										scope.searchText = '';
									scope.refreshDropdown(newVal);
								}
							}
						}
					});

					var filterBySearchText = function (newVal, oldVal) {
						if (inputChangeFunctionProvided) {
							scope.onInputChange({text: newVal});
						}
						else if (newVal) {
							if (newVal != oldVal) {

								if(angular.isUndefined(initialList) && angular.isDefined(scope.list))
									initialList = scope.list;

								scope.list = _.filter(initialList, function (item) {
									var target = scope.displayProperty ? item[scope.displayProperty] : item;
									var targetID = scope.coreProperty ? item[scope.coreProperty] : item;
									
									var resultok = ((target && target.toString().toLocaleLowerCase().indexOf(newVal.toLowerCase()) != -1) ||
										(targetID && targetID.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1));
									if(scope.extraField && !resultok){
										var targetExtraField = scope.extraField ? item[scope.extraField] : item;
										resultok = (targetExtraField && targetExtraField.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1);										
									}
									if(scope.filterFields && !resultok){
										var i;
										for (i = 0; i < scope.filterFields.length; i++) {
											var targetFilterField = item[scope.filterFields[i]];
											resultok = (targetFilterField && targetFilterField.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1);
											if(resultok)										
												i =  scope.filterFields.length;
										}
										/*
										for(var filterField of scope.filterFields) {
											var targetFilterField = item[filterField];
											resultok = (targetFilterField && targetFilterField.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1);
											if(resultok)										
												break;											
										}	
										*/									
									}
									return resultok;
									
									/*
									if(scope.extraField){
										var targetExtraField = scope.extraField ? item[scope.extraField] : item;
										return ((target && target.toLowerCase().indexOf(newVal.toLowerCase()) != -1) ||
											(targetID && targetID.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1) ||
											(targetExtraField && targetExtraField.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1)
										);
									}
									else
										return ((target && target.toLowerCase().indexOf(newVal.toLowerCase()) != -1) ||
										(targetID && targetID.toString().toLowerCase().indexOf(newVal.toLowerCase()) != -1));
									*/
								});
							}
						}
						else {
							//scope.list = initialList || scope.list;
							scope.list = scope.list;
						}

						if (newVal && getAllowCustom()) {
							if(!scope.dropdownInGrid){
								buildCustomOption(newVal);

								if(getAllowCustom() && scope.list.length == 1){
									if((!scope.selected) || (scope.selected[0] && scope.selected[0][scope.displayProperty] != scope.ngModel && scope.selected[0][scope.coreProperty] != scope.ngModel))
									scope.itemClick(scope.list[0], true, true);
								}
							}
						}

						var scrollContainer = element[0].getElementsByClassName('virtual-scroll-container') && element[0].getElementsByClassName('virtual-scroll-container')[0];
						if (scrollContainer) {
							scrollContainer.scrollTo(0, 0); // fix issue with vs-repeat scroll
						}

						$timeout(function () {
							scope.$digest();
						}, 0);
					};

					var buildCustomOption = function(val){
						customOption.id = -1;
						customOption[scope.coreProperty] = val;
						if(angular.isDefined(scope.displayProperty) && scope.displayProperty != scope.coreProperty){
							customOption[scope.displayProperty] = val;
						}
					};

					var hasOptionHighlighted = function(){
						return (scope.highlighted != -1 && angular.isDefined(scope.list[scope.highlighted]));
					};

					var changeSelectionAfterLoad = function(searchText){
						
						scope.changeSelectionAfterLoad = undefined;
						if(scope.list && scope.list.length > 0){
							var itemMatching = getItemMatchingWithSearchText(scope.searchTextAux);

							if(itemMatching)
								scope.itemClick(itemMatching, true);
							else
								scope.doCompleteLoad(scope.searchTextAux, true);
						}						
						scope.searchTextAux = '';

					};

					var getItemMatchingWithSearchText = function(searchText){
						var itemMatching = scope.list.find(function(e){
							return (
								(angular.isNumber(e[scope.coreProperty]) && e[scope.coreProperty] == searchText) ||
								(!angular.isNumber(e[scope.coreProperty]) && e[scope.coreProperty].toString().toUpperCase() == searchText.toUpperCase()) ||
								(e[scope.displayProperty].toString().toUpperCase() == searchText.toUpperCase())
							)
						});

						if(((angular.isDefined(itemMatching))) && (angular.isDefined(itemMatching.specialFlag) || angular.isDefined(itemMatching.id))){
							if((itemMatching.specialFlag == -1 || itemMatching.id == -1) && scope.allowCustomPriority == false)
								itemMatching = undefined;
						}
						return itemMatching;
					};
					
					var getAllowCustom = function(){
						var result = allowCustom;
						if(angular.isFunction(allowCustom))
							result = allowCustom(scope.gridRow.entity);
						return result;
					};
					
					/** evento que se dispara en ui-grid **/
					if(scope.dropdownInGrid) {
						scope.$on('gridfkUpdate', function() {						
							scope.gridfkUpdate(scope.gridRow, scope.gridCol);
						});

						scope.$on('needToReload', function(){
							scope.selected = [];
						});
					}
					scope.$on('$destroy', function() {
						$document.off('click', onDocumentClick);
					});
					
					var closest = function (e, className) {
						if (e[0].nodeName == "HTML") {
							return null;
						} else if (e.hasClass(className)) {
							return e;
						} else {
							return closest(e.parent(), className);
						}
					};
				}
			};
		}]);
	angular.module('angular-virtual-select').filter('virtualSelectfilterSelected', [ 'lodash', function(_) {
		return function(items, item, selected, scope) {			
			var textLength = (!scope.searchText) ? 0 : scope.searchText.length;
			if(scope.minLengthToLoad && scope.minLengthToLoad > textLength){
				return [];
			}
			else {			
				if(scope.dropdownInGrid && scope.keyFields.length > 0 && scope.lookupKeyFields.length > 0)
					items = scope.filterResultsByPK(items);

				if (!selected || !selected.length) {
					return items;
				}
				else {
					if(angular.isArray(selected)){
						return _.differenceBy(items, selected, scope.coreProperty);
					} else {
						return _.differenceBy(items, [ selected ], scope.coreProperty);
					}
				}			
			}
			//return items;
		};
	}]);

/*global CMP_LIKE*/
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module("gp4App").controller('ixSelectMultipleController',
['$scope','$http', '$timeout', 'cfg', '$log', 'ixUtilsService', function($scope, $http, $timeout, cfg, $log, ixUtilsService) {  
  $scope.cfg = cfg;

  //Status ixSelect:
  var JUST_LOADED = 0;
  var FIRST_LOAD_INIT = 1;
  var FIRST_LOAD_DONE = 2;
  var COMPLETE_LOAD_DONE = 3;
  $scope.dropdownStatus = JUST_LOADED;

  if($scope.preload) {
    $http.get(cfg.baseURL+$scope.entity).then(function(r) {
      $scope.allItems = r.data;
    });
  } else {
    $scope.allItems = [];
    $scope.lastSearch = "";
    $scope.refresh =  function($select){
      var userInputItem = undefined;
      var search = $select.search;
      
      //Aqui podem afegir ho que l'usuari escriu al filtre com a opció de dropdown.
      if($scope.editableDropdown){
        //var list = angular.copy($scope.allItems),
        var FLAG = -1;
        //remove last user input
//				if(angular.isDefined(list)){
//					list = list.filter(function(item) {
//						return item.id !== FLAG;
//					});
//				}

        if (search) {
          //manually add user input and set selection
          userInputItem = {
            id: FLAG,
            description: search
          };
          userInputItem[$scope.pk] = search;
          userInputItem[$scope.desc] = search;

          
          //$select.selected = userInputItem;

          if(!$scope.optionInList(search)){
            $scope.allItems.push(userInputItem);
          }
        }

      }
      //20240410: Ibran
      //if($scope.allItems.length > 1) return;

      $scope.lastSearch = search;
      if(!$scope.preload) {
        $scope.doCompleteLoad($select, search, userInputItem);
      }
    }

    $scope.filtrarResultados = function($select){
      return function(item){
        // Comparacion sin tener en cuenta acentos
        if (!$select.search || ixUtilsService.comparar(item[$scope.pk].toString(),$select.search) != -1 
            || ixUtilsService.comparar(item[$scope.desc].toString(),$select.search) != -1){
              return item;
        }
      }
    };    

    $scope.doCompleteLoad = function($select, search, userInputItem){
      var param = {Filters:[],OrderBy:[]};

      if(angular.isDefined($scope.entity) && !$scope.skipTableNameFilter){
        if(angular.isDefined($scope.desc)) param.OrderBy.push($scope.entity+"."+$scope.desc);
        param.Filters.push({StartPar:true, Field : ((!$scope.skipTableNameFilter) ? $scope.entity+"."+$scope.desc : $scope.desc), Value : search, Operator : CMP_LIKE});
        param.Filters.push({Or: true, Field : ((!$scope.skipTableNameFilter) ? $scope.entity+"."+$scope.pk : $scope.pk), Value : search, Operator : CMP_LIKE, EndPar:true});
      } else {
        if(angular.isDefined($scope.desc)) param.OrderBy.push($scope.desc);
        param.Filters.push({StartPar:true, Field : $scope.desc, Value : search, Operator : CMP_LIKE});
        param.Filters.push({Or: true, Field : $scope.pk, Value : search, Operator : CMP_LIKE, EndPar:true});
      }

      if($scope.conditions) {
        $scope.error = false;
        $scope.conditions.forEach(function(cond) {
          if(angular.isUndefined(cond.value)) $scope.error = true;
          param.Filters.push({Field: cond.field, Value: cond.value, Operator : cond.op | CMP_EQ, Not : cond.not | false, Skip: cond.skip | false });
        });
      }

      //afegir condiciones amb OR dels items del objecte
      if ($scope.ngModel && $scope.dropdownStatus == JUST_LOADED) {
        var values;
        if (angular.isArray($scope.ngModel)) {
            values = $scope.ngModel;
        } else if (angular.isString($scope.ngModel)) {
            values = $scope.ngModel.split(',');
        } else {
            values = [];
        }
        if (values.length > 0) {
          $scope.dropdownStatus = FIRST_LOAD_INIT;
          values.forEach(function (cond, index) {
              param.Filters.push({StartPar: index === 0, Field: $scope.pk, Value: cond, Operator: CMP_EQ, Or: index > 0, EndPar: index === values.length - 1});
          });
        }
      }      

      if($scope.loadFunction) {
        return $scope.loadFunction(param, undefined, $scope.entity).then(function(r) {
          var newItems = r.data.Items ? r.data.Items : r.data;
          if($scope.keepPreviouslyLoadedItems){
            angular.forEach(newItems, function(newItem){
              var existItem = $scope.allItems.find(function(e){ return e[$scope.pk] == newItem[$scope.pk]; });
              if(angular.isUndefined(existItem))
                $scope.allItems.push(newItem);
            });
          } else
            $scope.allItems = newItems;

          if($scope.editableDropdown){
            $scope.addOptionIfNotExists(userInputItem);
            if($scope.allItems.length == 0 && $scope.wholeObj)
              $scope.addOptionIfNotExists($scope.wholeObj);
          }

          
//          if ($scope.allItems.length == 1 && !$scope.editableDropdown) {
//            //Si nomes hi ha un que quedi marcat
//            $scope.ngModel = [ $scope.allItems[0][$scope.pk] ];
//            $scope.wholeObj = $scope.allItems[0];
//          } else
          if($scope.allItems.length == 0 ) {
            // Si no n'hi ha cap esborrar valor
            $scope.ngModel = undefined;
          }
          //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
          else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
            $scope.ngModel = $scope.ngDefault;
          } else {
            //$scope.wholeObj = $scope.allItems.find(function(e){ })$scope.ngModel;
            $scope.wholeObj = $scope.allItems.find(function(e){ return e[$scope.pk] == $scope.ngModel; });
          }
        });
      } else {
        if(!$scope.error){
          return $http.post(cfg.baseURL+$scope.entity+"/Search?ItemsPerPage=9999", param).then(function(r) {
            $scope.allItems = r.data.Items;
            if(angular.isDefined(userInputItem)) $scope.allItems.push(userInputItem);
            //Crearem la opció
            if($scope.editableDropdown && (angular.isDefined($scope.ngModel) && $scope.ngModel != null)){
              $select.search = $scope.ngModel;
              $scope.refresh($select);
            }
            if($scope.orderStringAsInt){ $scope.allItems.sort($scope.sortByNumber) }

            //20240410: Ibran
            /*
            if($scope.allItems.length == 0 ) {
              // Si no n'hi ha cap esborrar valor
              
              if(angular.isDefined($scope.ngModel)){
                $scope.ngModel = null;
              }
            }
            //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
            else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
              $scope.ngModel = $scope.ngDefault;
            }*/
          });
        }

      }
    };
    
    $scope.addOptionIfNotExists = function(userInputItem){
      var customOptionAdded = $scope.allItems.find(function(e){ return e.id === -1; });

      if(angular.isDefined(userInputItem) && angular.isUndefined(customOptionAdded))
        $scope.allItems.push(userInputItem);
    };
    
    $scope.optionInList = function(search){
      var found = $scope.allItems.some(function(e) {
        return (e[$scope.pk] == search || e[$scope.desc] == search);
      });
      
      return found;
    };

    if($scope.conditions) {
      $scope.$watch(function() {return $scope.conditions}, function(nv, ov) {
        if(!angular.equals(nv,ov)) {
          $scope.ngModel = undefined;
          $scope.refresh({ search: $scope.lastSearch });
        }
      });
    }
  }

  $scope.onSelectOption = function($item, $model) {
    $scope.$apply(function() {
      $scope.wholeObj = $item;
    });
  };

  $scope.sortByNumber = function(a, b){
    return a[$scope.desc] - b[$scope.desc];
  };

  $scope.$watch("ngModel", function(value, oldVal){
    if($scope.dropdownStatus == JUST_LOADED && angular.isDefined(value) && !$scope.preload){      
      $scope.refresh({ search: "" });
    }
    //Ens permet buidar el ix-select però, en cas de que hi hagi valor per defecte, si el formulari es neteja, s'aplicarà el valor per defecte de nou.
    if(angular.isUndefined(value) && angular.isDefined($scope.ngDefault)){
      $scope.ngModel = $scope.ngDefault;
    }
    if(value){
      if($scope.commaSeparated){
          if(!$scope.ngModelFormatted)//Si aun no se ha definido la propiedad.
            $scope.ngModelFormatted = value.split(","); //AHLAM: la primera càrrega desde una pantalla q no sigui manteniment surt buida pq no entra al if de la 209
        // else if($scope.ngModelFormatted.length != value.split(",").length)//si se han añadido o quitado etiquetas
        //   $scope.ngModelFormatted = value.split(",");
        if(oldVal != value)
          $scope.ngModelFormatted = value.split(",");

        for(var i = 0; i < $scope.ngModelFormatted.length; i++){
          if(!isNaN($scope.ngModelFormatted[i]))
            $scope.ngModelFormatted[i] = parseInt($scope.ngModelFormatted[i]);
        }

      } else {
        $scope.ngModelFormatted = $scope.ngModel;	
      }
    } else {
      $scope.ngModelFormatted = $scope.ngModel;
    }
  });
  
  $scope.$watch("ngModelFormatted", function(value, oldVal){
    if(value){
      if(value != oldVal){
        if($scope.commaSeparated)
          $scope.ngModel = $scope.ngModelFormatted.join(",");
        else
          $scope.ngModel = $scope.ngModelFormatted;
      }
        
    }
  });
}]);

/*global CMP_LIKE*/
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module("gp4App").controller('ixSelectController',
['$scope','$http', '$timeout', 'cfg', '$log', function($scope, $http, $timeout, cfg, $log) {
  $scope.firstLoadOrOpened = false;
  if($scope.preload) {
    $http.get(cfg.baseURL+$scope.entity).then(function(r) {
      $scope.allItems = r.data;
      if ($scope.allItems.length == 1) {
        //Si nomes hi ha un que quedi marcat
        $scope.ngModel = ($scope.allItems[0][$scope.pk] !== 0) ? $scope.allItems[0][$scope.pk] : null;
        if($scope.ngModel != null) $scope.wholeObj = $scope.allItems[0];
			}
    });
  }
  //Valorar si a alguna pantalla fa falta un preloadFunction.
  //S'ha de pensar que els preloads no paginen ni actualitzen valors quan s'escriu.
  //Si s'ha d'afegir es possarà aqui un else if($scope.preloadFunction) i es cridarà.
  else {
    $scope.allItems = [];
    $scope.lastSearch = "";
    $scope.refresh =  function($select){
			if($scope.skipNextRefresh){
				$scope.skipNextRefresh = false;
				return;
			}
      //serveix per actualitzar el nou valor sel·leccionat quan aquest canvi s'ha fet per alguna condició.
      if(angular.isDefined($select.selected) && angular.isDefined($scope.newSelected)){
        $select.selected = angular.copy($scope.newSelected);
        $scope.newSelected = undefined;
      }

      var userInputItem = undefined;
      var search = $select.search;

      //Aqui podem afegir ho que l'usuari escriu al filtre com a opció de dropdown.
      if($scope.editableDropdown == true){
        var list = angular.copy($select.items),
        FLAG = -1;
        //remove last user input
        if(angular.isDefined(list)){
          list = list.filter(function(item) {
            return item.id !== FLAG;
          });
        }

        if (search) {
          //manually add user input and set selection
          userInputItem = {
            id: FLAG,
            description: search
          };
          userInputItem[$scope.pk] = search;
          userInputItem[$scope.desc] = search;

          var found = $scope.allItems.some(function(e) {
            return e.id == userInputItem.id;
          });

					$select.selected = userInputItem;

          if(!found){
            $scope.allItems = [userInputItem].concat(list);
          }
        }
      }
      if(($scope.firstLoadOrOpened) && ($scope.ngModel) && !$scope.editableDropdown && !$scope.allItems.find(function(e){ return e[$scope.pk] == $scope.ngModel; })){
        $scope.loadFirst($select, search);
        return;
      }
      if(($scope.countNotEmpties() > 1 || $scope.countNotEmpties() == 1 && manuallyAddedOptionSelection($select)) && (!$scope.conditions || $scope.conditions && !$scope.changedConditions) && $scope.lastSearch == search && !$scope.justLoaded){
				return;
			} else {
				$scope.lastSearch = search;
				if(!$scope.preload) {

					//1: Per defecte ensenyarà el valor que té marcat.
					//Com només arriva la clau, hem de fer un search per obtenir la descripció
					//S'ha de tenir en compte de manera general les condicions. Les quals serviràn per filtrar.
					if(!$scope.firstLoadOrOpened && !$scope.loadAllItems){
						$scope.doFirstLoad($select, search);
					}

					//2: Primera càrrega de resultats: Es farà la primera càrrega al obrir el dropdown.
					//i
					//3: Ja ha sigut carregat i té resultats però s'ha de refrescar. O bé perquè té filtres (conditions) o perquè s'està filtrant pel camp de text.
					else {
						$scope.doCompleteLoad($select, search, userInputItem);
					}
					if($scope.justLoaded) $scope.justLoaded = false;
				}
			}
    }

    $scope.doFirstLoad = function($select, search){
      //s'utilitza a pantalles que tenen molta càrrega, per exemple, les d'entrades manuals, assignacio,.., fitxa d'operativa,...
      //el nom està mal possat, mes que preloadFunction ve a ser un loadFromModelFunction ja que està pensat per carregar les dades després d'un get que retorni un objecte complex.
      if($scope.preloadFunction){
        return $scope.preloadFunction().then(function(r) {
          $scope.firstLoadOrOpened = true;
          if(r.data != null){
            var obj = {};
            obj[$scope.pk] = angular.isDefined($scope.preloadPk) ? r.data[$scope.preloadPk] : r.data[$scope.pk];
            obj[$scope.desc] = angular.isDefined($scope.preloadPk) ? r.data[$scope.preloadPk + "nombre"] : r.data[$scope.pk + "nombre"];

            //Si el valor ha sigut modificat en pantalla i tornem a entrar a la pantalla desde l'escriptori l'ensenyem en comptes de l'inicial.
            if(angular.isDefined($scope.ngModel) && $scope.ngModel != obj[$scope.pk]){
              $scope.loadFirst($select, search);
            } else {
              if(angular.isDefined($scope.extraField)){
                obj[$scope.extraField] = r.data[$scope.extraField];
              }

              //Pot ser que el viewmodel no porti algun paràmetre o aquest sigui null.
              //Si és així, deixem allItems buit. D'aquesta manera veurem el placeholder.
              if(angular.isDefined(obj[$scope.pk]) && obj[$scope.pk] != null){
                $scope.allItems = [obj];
              }
              if ($scope.allItems.length == 1) {
                //Si nomes hi ha un que quedi marcat
                $scope.ngModel = ($scope.allItems[0][$scope.pk] !== 0) ? $scope.allItems[0][$scope.pk] : null;
                if($scope.ngModel != null) $scope.wholeObj = $scope.allItems[0];
              } else if($scope.allItems.length == 0 ) {
                // Si no n'hi ha cap esborrar valor
                $scope.ngModel = undefined;
              }
              //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
              else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
                $scope.ngModel = $scope.ngDefault;
              } else {
                $scope.wholeObj = obj;
              }
            }
          }
        });
      } else {
        $scope.loadFirst($select, search);
      }
    };

    $scope.loadFirst = function($select, search){
      if($scope.ngModel != null){
        if(angular.isDefined($scope.entityData) && angular.isDefined($scope.entityDataDesc)){
          $scope.firstLoadOrOpened = true;
          $scope.allItems = [];
          var item = {};
          item[$scope.pk] = angular.isDefined($scope.entityDataPk) ? $scope.entityData[$scope.entityDataPk] : $scope.entityData[$scope.pk];
          item[$scope.desc] = $scope.entityData[$scope.entityDataDesc];

          var found = $scope.allItems.some(function(e) {
            return angular.equals(e,item);
          });

          if(!found){
            $scope.allItems.push(item);
          }
        }
        else if(angular.isUndefined($scope.loadFunction)){
          var param = buildIxSearch();
          param.Filters.push({ Field: $scope.pk, Value: $scope.ngModel, Operator: CMP_EQ });
          angular.forEach($scope.conditions, function(condition){
            param.Filters.push({ Field: condition.field, Value: condition.value, Operator: condition.op || CMP_EQ });
          });

          return $http.post(cfg.baseURL + $scope.entity + "/Search?ItemsPerPage=1", param).then(function(r){
            $scope.firstLoadOrOpened = true;
						$scope.justLoaded = true;
            //$scope.allItems = r.data.Items;
            //$scope.allItems.push.apply($scope.allItems, r.data.Items);

            r.data.Items.forEach(function(result){
              var found = $scope.allItems.some(function(e) {
                //return angular.equals(e,result);
                return e[$scope.pk] == result[$scope.pk];
              });

              if(!found){
                $scope.allItems.push(result);
              }
            });

						$scope.allItems = $scope.getNotEmpties();

            if ($scope.allItems.length == 1) {
              //Si nomes hi ha un que quedi marcat
              $scope.ngModel = ($scope.allItems[0][$scope.pk] !== 0) ? $scope.allItems[0][$scope.pk] : null;
              if($scope.ngModel != null) $scope.wholeObj = $scope.allItems[0];
            } else if($scope.allItems.length == 0 ) {
              // Si no n'hi ha cap esborrar valor
              $scope.ngModel = undefined;
            }
            //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
            else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
              $scope.ngModel = $scope.ngDefault;
            } else {
              $scope.wholeObj = r.data;
            }
          });
        } else {//20180112: Si algun dropdown de formulari fa el tonto, revissar aquest else. La seva raó de ser es la de recarregar el dropdowns de traspassos al guardar canvis.
          $scope.doCompleteLoad($select, search, undefined);
        }
      } else {
        //Aquest push fa que allItems tingui alguna cosa i per tant inicialitza el html de la directiva, fent que no perdi caràcters al escriure al inici.
        //$scope.firstLoadOrOpened = true;
        var containsVacio = $scope.allItems.find(function(e){ return e.pk == ""; });
        if(!containsVacio) $scope.allItems.push({pk:'',desc:''});
      }
    };

    $scope.doCompleteLoad = function($select, search, userInputItem){
      var param = {Filters:[],OrderBy:[]};

      if(angular.isDefined($scope.entity)){
        if(angular.isDefined($scope.desc)) param.OrderBy.push($scope.entity+"."+$scope.desc);
        param.Filters.push({StartPar:true, Field : $scope.entity+"."+$scope.desc, Value : search, Operator : CMP_LIKE});
        param.Filters.push({Or: true, Field : $scope.entity+"."+$scope.pk, Value : search, Operator : CMP_LIKE, EndPar:true});
      } else {
        if(angular.isDefined($scope.desc)) param.OrderBy.push($scope.desc);
        param.Filters.push({StartPar:true, Field : $scope.desc, Value : search, Operator : CMP_LIKE});
        param.Filters.push({Or: true, Field : $scope.pk, Value : search, Operator : CMP_LIKE, EndPar:true});
      }

      if($scope.conditions) {
        $scope.error = false;
        $scope.conditions.forEach(function(cond) {
          if(angular.isUndefined(cond.value)) $scope.error = true;
          param.Filters.push({Field: cond.field, Value: cond.value, Operator : cond.op | CMP_EQ, Not : cond.not | false, Skip: cond.skip | false });
        });
      }

      if($scope.loadFunction) {
        return $scope.loadFunction(param).then(function(r) {
          $scope.allItems = r.data.Items ? r.data.Items : r.data;
          if ($scope.allItems.length == 1) {
            //Si nomes hi ha un que quedi marcat
            $scope.ngModel = $scope.allItems[0][$scope.pk];
            $scope.wholeObj = $scope.allItems[0];
          } else if($scope.allItems.length == 0 ) {
            // Si no n'hi ha cap esborrar valor
            $scope.ngModel = undefined;
          }
          //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
          else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
            $scope.ngModel = $scope.ngDefault;
          } else {
            //$scope.wholeObj = $scope.allItems.find(function(e){ })$scope.ngModel;
            $scope.wholeObj = $scope.allItems.find(function(e){ return e[$scope.pk] == $scope.ngModel; });
          }

          //Forcem el focus.
          if(angular.isDefined($select) && angular.isDefined($select.focusSearchInput)) $select.focusSearchInput();
        });
      } else {
        if(!$scope.error){
          return $http.post(cfg.baseURL+$scope.entity+"/Search?ItemsPerPage=10", param).then(function(r) {
            if($scope.changedConditions && $scope.allItems.length == 1)
              $scope.allItems.push.apply($scope.allItems, r.data.Items);
            else
              $scope.allItems = r.data.Items;
            if(angular.isDefined(userInputItem) && $scope.allItems.indexOf(userInputItem) == -1) $scope.allItems.push(userInputItem);
            //Crearem la opció
            //if($scope.editableDropdown && (angular.isDefined($scope.ngModel) && $scope.ngModel != null)){
              ////$select.search = $scope.ngModel;
              //if(((angular.isDefined($select.selected))) && (angular.isUndefined($select.selected.id) || (angular.isDefined($select.selected.id) && $select.selected.id != -1)))
                //$scope.refresh($select);
            //}
            if($scope.orderStringAsInt){ $scope.allItems.sort($scope.sortByNumber) }
            if ($scope.allItems.length == 1) {
              //Si nomes hi ha un i es obligatori que quedi marcat
              if($scope.ngRequired == true){
                $scope.ngModel = $scope.allItems[0][$scope.pk];
              } //else {
                //$scope.ngModel = undefined;
              //}
            } else if($scope.allItems.length == 0 ) {
              // Si no n'hi ha cap esborrar valor
              if(angular.isDefined($scope.ngModel)){
                $scope.ngModel = null;
              }/* else {
                $scope.ngModel = undefined;
              }*/
            } else if($scope.changedConditions && angular.isDefined($scope.ngModel)){
              $scope.changedConditions = false;
              //Mirem si el conjunt d'opcions retornat conté el valor. Si no és així el netejem.
              var found = $scope.allItems.find(function(e){ return e[$scope.pk] == $scope.ngModel; });
              if(angular.isDefined(found)){
                $scope.newSelected = found;
              } else {
                $scope.ngModel = null;
              }
            }
            //Assignar valor per defecte si ngModel es undefined i s'ha passat per param a la directiva.
            else if(angular.isUndefined($scope.ngModel) && angular.isDefined($scope.ngDefault)){
              $scope.ngModel = $scope.ngDefault;
            }

            //Forcem el focus.
            if(angular.isDefined($select) && angular.isDefined($select.focusSearchInput)) $select.focusSearchInput();
          });
        }

      }
    };

    if($scope.conditions) {
      $scope.$watch(function() {return $scope.conditions}, function(nv, ov) {
        if(!angular.equals(nv,ov)) {
          //$scope.ngModel = undefined;
          $scope.changedConditions = true;
          //$scope.ngModel = null;
          $scope.wholeObj = null;
          $scope.refresh({ search: $scope.lastSearch });
        }
      });
    }
  }

  $scope.onSelectOption = function($item, $model) {
		if(angular.isDefined($item)){
			if(angular.isDefined($item.id) && $item.id == -1){
				$scope.skipNextRefresh = true;
			}
		}
    $scope.$apply(function() {
      //Hi havia casos en que, quan l'atribut preload era true, el dropdown desmarcava el valor sel·leccionat i deixava marcat l'anterior.
			//if($scope.preload){
				$scope.ngModel = $item[$scope.pk];
			//}
      $scope.wholeObj = $item;
    });
  };

  $scope.sortByNumber = function(a, b){
    return a[$scope.desc] - b[$scope.desc];
  };

  $scope.onOpenCloseDropdown = function(isOpen) {
    if(isOpen) $scope.firstLoadOrOpened = true;
  };

  $scope.countNotEmpties = function(){
    var notEmpties = $scope.allItems.filter(function(e){ if(angular.isDefined(e)){ return e[$scope.pk] !== "" && e.pk !== ""; } });
    return notEmpties.length;
  };

	$scope.getNotEmpties = function(){
    var notEmpties = $scope.allItems.filter(function(e){ if(angular.isDefined(e)){ return e[$scope.pk] !== "" && e.pk !== ""; } });
    return notEmpties;
  };


  $scope.$watch("ngModel", function(value){
    if(angular.isDefined(value) && !$scope.firstLoadOrOpened && !$scope.preloadFunction && !$scope.preload){
      //Si durant el moment de la primera càrrega, el ng-model no tenia valor, no ha fet el Search. Farem el Search del item sel·leccionat ara.
      $scope.refresh({ search: $scope.lastSearch });
    } else if(angular.isDefined(value) && value != null && !$scope.preloadFunction && !$scope.preload){//TODO: Afegir al else if aquest, que faci el refresh si l'item no està a $scope.allItems.
      //$scope.firstLoadOrOpened = false;
      $scope.refresh({ search: $scope.lastSearch });
    }
    //Ens permet buidar el ix-select però, en cas de que hi hagi valor per defecte, si el formulari es neteja, s'aplicarà el valor per defecte de nou.
    if(angular.isUndefined(value) && angular.isDefined($scope.ngDefault)){
      $scope.ngModel = $scope.ngDefault;
    }
  });

	var manuallyAddedOptionSelection = function($select){
		if(angular.isDefined($select.selected)){
			if((angular.isDefined($select.selected) && $select.selected != null) && $select.selected.id == -1){
				return true;
			}
			return false;
		}
		return false;
	};

}]);

/*eslint angular/document-service:0*/
angular.module("gp4App").controller('ixPreviewPDFController', [ '$scope', '$uibModalInstance', '$location', function($scope, $uibModalInstance, $location){
	$scope.src = $scope.$resolve.src;

	var protocol = $location.protocol();
	var host = $location.host();
	var port = $location.port();
	$scope.urlPDF = protocol + "://" + host + ":" + port + "/assets/documents/" + $scope.src;

	$scope.downloadFile = function(src){
		var link = document.createElement("a");
		link.download = src;
		link.href = "assets/documents/"+src;
		link.click();
	};
}]);

/*eslint angular/document-service:0*/
/*global saveAs*/
angular.module("gp4App").controller('ixPreviewImageController', [ '$scope', '$uibModalInstance', function($scope, $uibModalInstance){
	$scope.src = $scope.$resolve.src;

	$scope.downloadFile = function(src){
		var link = document.createElement("a");
		link.download = src;
		link.href = "assets/images/"+src;
		link.click();
	};
}]);

angular.module("gp4App").controller('ixPreviewImageFullWidthPopupController', [ '$scope', '$uibModalInstance', function($scope, $uibModalInstance){

	$scope.foto = $scope.$resolve.foto;
	$scope.nombre = $scope.foto.nombre.split('.',1)[0];
	$scope.src = $scope.$resolve.src;

	$scope.status = { editing: true };

	function urltoFile(url, filename, mimeType){
		return (fetch(url)
						.then(function(res){return res.arrayBuffer();})
						.then(function(buf){return new File([buf], filename,{type:mimeType});})
					 );
	}

	$scope.downloadImage = function(){
		urltoFile('data:'+$scope.foto.imageMimetype+';base64,'+$scope.foto.imagenBase64, $scope.nombre, $scope.foto.imageMimetype).then(function(file){
			saveAs(file, $scope.nombre);
		});

	};

}]);

/*global getColors*/
/*global ixGridColumnFilterCondition*/
angular.module("gp4App").controller('ixGridFiltroController', ['$scope','$compile','$timeout', '$uibModal', '$filter', 'cfg', 'ivhTreeviewMgr', 'ixStatusService', '$document', function( $scope, $compile, $timeout, $uibModal, $filter, cfg, ivhTreeviewMgr, ixStatusService, $document) {
    $scope.col = $scope.$resolve.col;
    $scope.options = [];
    $scope.esColumnaDecimalSinDropdown = function(col){
      return (!col.pk && col.db_type == "decimal" && angular.isUndefined(col.Search) && angular.isUndefined(col.control));
    };
  
    if($scope.esColumnaDecimalSinDropdown($scope.col.colDef)){
      $scope.filtrosRango = [];
      $scope.options = [{ value: "#rango", text: "Según rango" }, { value: "#value", text: "Con valor" }, { value: "#empty" , text: "Vacíos" }];
    } else {
      $scope.options = [{ value: "undefined", text: "Según selección" }, { value: "#lista", text: "Lista" }, { value: "#value", text: "Con valor" }, { value: "#empty" , text: "Vacíos" }];
    }
  
    $scope.showFilterModal = function() {
      $timeout(function(){
        //Per defecte tindrem la opció "Según rango" si es un numero o "Según selección" marcada.
        if(angular.isUndefined($scope.col.filters[0].selectionType)){
          if($scope.esColumnaDecimalSinDropdown($scope.col.colDef))
            $scope.col.filters[0].selectionType = "#rango";
          else
            $scope.col.filters[0].selectionType = "undefined";
        }
        //Aprofitem que la opció "Limpiar todos los filtros" del angular-ui-grid esborra la propietat condition. Quan s'esborri netejarem el control de cerca.
        if(angular.isUndefined($scope.col.filters[0].condition)){
          $scope.col.filters[0].filtervalue = "";
        }
      },1);
      
  
      var defaultOptions = { templateUrl: "ixGridFiltroModal.html",  scope: $scope, backdrop: 'static', keyboard: false };
      //para las pantallas fullscreen es necesario indicar "appendToFilterPopup"
      if($scope.col.grid.options.appendToFilterPopup)
        defaultOptions.appendTo = $document.find($scope.col.grid.options.appendToFilterPopup).eq(0);
  
    //   $uibModal.open(defaultOptions).result.then(function(){
    //     var selectedValues = [];
    //     if(angular.isDefined($scope.col.filters[0].selectionType) && $scope.col.filters[0].selectionType != "undefined" && $scope.col.filters[0].selectionType != "#lista" && $scope.col.filters[0].selectionType != "#rango"){
    //       selectedValues.push($scope.col.filters[0].selectionType);
    //     }
    //     $scope.listOfValues.forEach( function( val ) {
    //       if(val.selected) {
    //         selectedValues.push( val.id );
    //       }
    //       val.children.forEach(function(v2) {
    //         v2.children.forEach(function(v3) {
    //           if(v3.selected){
    //             selectedValues.push(v3.id);
    //           }
    //         });
    //       });
    //     });
    //     if(selectedValues.length == 0)
    //       $scope.col.filters[0].filtervalue = "";
    //     //La opció "Limpiar todos los filtros" està inclosa al mòdul angular-ui-grid.
    //     //Els filtres que nosaltres fem servir són personalitzats, per aquesta raó, al netejar els filtres, la condició que nosaltres apliquem s'esborra.
    //     //Si això passa, la tornem a assignar.
    //     if(angular.isUndefined($scope.col.filters[0].condition)){
    //       $scope.col.filters[0].condition = ixGridColumnFilterCondition();
    //     }
  
    //     if($scope.col.filters[0].selectionType == "#rango"){
    //       if(angular.isUndefined($scope.filtrosRango[0]))
    //         $scope.filtrosRango[0] = null;
  
    //       if(angular.isUndefined($scope.filtrosRango[1]))
    //         $scope.filtrosRango[1] = null;
  
    //       $scope.col.filters[0].term = $scope.filtrosRango.join('|');
    //       $scope.col.filters[0].numfilters = $scope.filtrosRango.filter(function(e){ return e !== "" && e !== null; }).length;
    //     } else {
    //       $scope.col.filters[0].term = selectedValues.join('|');
    //       $scope.col.filters[0].numfilters = selectedValues.length;
    //     }
  
  
  
    //     var columnDef = $scope.col.grid.options.columnDefs.find(function(e){ return e.field == $scope.col.field && !e.Required; });
    //     if(angular.isDefined(columnDef)){
    //       if(selectedValues.length > 0){
    //         columnDef.enableHiding = false;
    //       } else {
    //         columnDef.enableHiding = true;
    //       }
    //     }
    //     $scope.col.filters[0].term += "$reload";
    //   });
  
      var distinctValues = {};
      $scope.listOfValues = [];
      var type = $scope.col.colDef.type;
      var esSearch = $scope.col.colDef.control == "Search";
      var selectedValues = [];
  
      if($scope.col.filters[0].term) {
        if($scope.col.filters[0].term.indexOf("$reload") != -1)
          $scope.col.filters[0].term = $scope.col.filters[0].term.substring(0, $scope.col.filters[0].term.indexOf("$reload"));
  
        if($scope.col.filters[0].selectionType == "#rango"){
          $scope.filtrosRango	= $scope.col.filters[0].term.split("|");
          if(angular.isUndefined($scope.filtrosRango[0]) || $scope.filtrosRango[0] === "")
            $scope.filtrosRango[0] = null;
          if(angular.isUndefined($scope.filtrosRango[1]) || $scope.filtrosRango[1] === "")
            $scope.filtrosRango[1] = null;
        } else {
          selectedValues=$scope.col.filters[0].term.split("|");
        }
      }
  
      //Pendiente revisar para ignorar el filtro de la propia columna: ($scope.grid.api.core.getVisibleRows()).forEach(function(obj) {
      //$scope.col.grid.options.data.forEach( function ( row ) {
      filterIgnoringItself().forEach( function ( obj ) {
        var row = obj.entity;
        var selected = "";
        var value = row[$scope.col.field];
        if(value || value === 0){
          if(type=="date"){
            selected = false;
            var year = value.getFullYear()
            //Agafa el dia i mes actual (sense convertir el datetime actual a UTC, sino agafa el dia anterior ja que la data conte la zona horaria)
            var month = year+"-"+( (value.getMonth() + 1) < 10 ? "0"+(value.getMonth() + 1) : (value.getMonth() + 1) );
            var day = month+"-"+(value.getDate() < 10 ? "0"+value.getDate() : value.getDate() );
            //var month = value.toISOString().substring(0,7);
            //var day =  value.toISOString().substring(0,10);
            if ( !distinctValues[year] ) {
              distinctValues[year]={id:year, label:year, selected:selected, children:[]};
              $scope.listOfValues.push(distinctValues[year]);
            }
            if ( !distinctValues[month] ) {
              distinctValues[month]={id:month, label:$filter("date")(value,"MMMM"), selected:selected, children:[]};
              distinctValues[year].children.push(distinctValues[month])
            }
            if ( !distinctValues[day] ) {
              //distinctValues[day]={id:day,label:$filter("date")(value,cfg.dateFormat), selected:selected, children:[]};
              distinctValues[day]={id:$filter("date")(value,"yyyy-MM-dd"),label:$filter("date")(value,cfg.dateFormat), selected:selected, children:[]};
              distinctValues[month].children.push(distinctValues[day])
            }
  
          } else if($scope.col.colDef.control == "Search"){
            var lookupresultfields = $scope.col.colDef.LookUpResultFields;
            var fkObjects = $scope.col.colDef.allFkObjects;
            var object = fkObjects.filter(function(e){
              var coincide = false;
              for(var i = 0; i < lookupresultfields.length; i++){
                if(e[lookupresultfields[i]]==value)
                  coincide = true;
              }
              return coincide;
            });
            object = object.map(function(e){
              var label = e[lookupresultfields[0]];
              if(lookupresultfields.length > 1){
                for(var i = 1; i < lookupresultfields.length; i++){
                  if(angular.isDefined(e[lookupresultfields[i]])){
                    label += " - " + e[lookupresultfields[i]];
                  }
                }
              }
              var obj = { "clave": e[$scope.col.colDef.LookUpKeyFields[$scope.col.colDef.LookUpKeyFields.length - 1]], "label": label };
              if($scope.col.colDef.LookUpKeyFields){
                for(var x = 0; x < $scope.col.colDef.LookUpKeyFields.length - 1; x++){
                  var property = $scope.col.colDef.LookUpKeyFields[x];
                  obj[property] = e[property];
                }
              }
              return obj;
            });
  
            if($scope.col.colDef.LookUpKeyFields){
              for(var i = 0; i < $scope.col.colDef.LookUpKeyFields.length - 1; i++){
                var property = $scope.col.colDef.LookUpKeyFields[i];
                var propertyLeftJoinTable = $scope.col.colDef.KeyFields[i];
                if(angular.isDefined(obj.entity[propertyLeftJoinTable])){
                  object = object.filter(function(e){ return e[property] == obj.entity[propertyLeftJoinTable]; });
                }
              }
            }
  
            if(object.length > 1)
              object = object.find(function(e){ return e.clave == value; });
            else
              object = object[0];
  
            if(angular.isDefined(object)){
              if ( !distinctValues[object.label] ) {
                distinctValues[object.label]=true;


                if($scope.col.colDef.LookUpKeyFields.length > 1 && $scope.col.colDef.ColumnFkDescription && row[$scope.col.colDef.ColumnFkDescription]){
                  //He vist que ColumnFkDescription pot tenir mes d'un valor. Quan es doni el cas haurem de veure com es fa.
                  selected = selectedValues.indexOf(row[$scope.col.colDef.ColumnFkDescription])>=0;
                } else
                  selected = selectedValues.indexOf(object.clave.toString())>=0;

                
                
                $scope.listOfValues.push({id:object.clave, label:object.label, selected:selected, children:[]});
              }
            }
          } else {
            if ( !distinctValues[value] ) {
              distinctValues[value]=true;
              selected = selectedValues.indexOf(value.toString())>=0;
  
              var label = value;
              if($scope.col.colDef.control == "Color"){
                var colors = getColors();
                var color = colors.find(function(e){ return e.color == label; });

                label = '<span style="position: relative; top: 18px; left: 15px; background-color: '+ color.visual +';" class="color_leyenda"></span>' + color.name;
              }
                
  
              $scope.listOfValues.push({id:value, label:label, selected:selected, children:[]});
            } else {
              //$scope.listOfValues[0].children.push({label:value,selected:false});
            }
  
          }
        }
      });
      //Sort recursive.
      sortListOfValues($scope.listOfValues);
    };
  
    $scope.filterList = function(item, B) {		
      var result = false;
      if(angular.isDefined($scope.col.filters[0].filtervalue)){
        var listValues = $scope.col.filters[0].filtervalue.toUpperCase().split("\n");

        for (var i = 0, len = listValues.length; i < len; i++) {
          if(item.label.toString().toUpperCase().indexOf(listValues[i].toUpperCase()) !== -1) {			
            result = true;
            break;
          }			
        }
      } else
        result = true;
      /*
      angular.forEach(listValues, function(filterValue){
         if(!result && item.label.toString().toUpperCase().indexOf(filterValue.toUpperCase()) !== -1) {
           result = true;
         }        
      });
      */
      return result;
    };
    
    var sortListOfValues = function(listOfValues){
      //Si l'array actual només conté 1 objecte i aquest objecte té més d'un fill, ordenem els fills de l'objecte.
      if(listOfValues.length == 1 && hasChildrenToSort(listOfValues[0])){ sortListOfValues(listOfValues[0].children); }
  
      listOfValues.sort(function(a,b){
        //Ordenem els fills de l'objecte que estem comparant (si n'hi han).
        if(hasChildrenToSort(a)){
          sortListOfValues(a.children);
        }
        if(hasChildrenToSort(b)){
          sortListOfValues(b.children);
        }
        //return (a.label>b.label)-(a.label<b.label);
        return (a.id>b.id)-(a.id<b.id);
      });
    };
  
    var hasChildrenToSort = function(obj){
      return obj.children;// && obj.children.length > 1;
    };
  
    var filterIgnoringItself = function(){
      var gridFilters = $scope.col.grid.columns.filter(function(column){ return column.field !== $scope.col.field && angular.isDefined(column.filter.term) && column.filter.term !== null && column.filter.term !== ""; });
      var dataRows = $scope.col.grid.rows;
  
      var filteredDataRows = dataRows.filter(function(_row){
        var isMatch = true;
        angular.forEach(gridFilters, function (_filter) {
          if((typeof(_filter.filter.term) == "string") && _filter.filter.term.indexOf("$reload") != -1)
            _filter.filter.term = _filter.filter.term.substring(0, _filter.filter.term.indexOf("$reload"));
  
          isMatch = isMatch && _filter.filter.condition(_filter.filter.term, _row.entity[_filter.field], _row, _filter);
        });
  
        return isMatch;
      });
      return filteredDataRows;
    };
  
    $scope.selectAll = function() {
      var matchingValues = [];
      if($scope.col.filters[0].filtervalue != null){
        var listValues = $scope.col.filters[0].filtervalue.toUpperCase().split("\n");			
        angular.forEach($scope.listOfValues, function(value){
          for (var i = 0, len = listValues.length; i < len; i++) {
            if(value.label.toString().toUpperCase().indexOf(listValues[i].toUpperCase()) !== -1) {			
              matchingValues.push(value);
              break;
            }			
          }  
        });			
        /*
        angular.forEach($scope.listOfValues, function(value){
          if(value.label.toString().toUpperCase().indexOf($scope.col.filters[0].filtervalue.toUpperCase()) !== -1){
           matchingValues.push(value);
          }
        });
        */
        ivhTreeviewMgr.selectAll(matchingValues);
      } else {
        ivhTreeviewMgr.selectAll($scope.listOfValues);
      }
  
    };
  
    $scope.selectAllNotEmpty = function(){
      $scope.selectionType = "*";
    };
  
    $scope.selectAllEmpty = function(){
      $scope.selectionType = "\"\"";
    };
  
    $scope.deselectAll = function() {
      ivhTreeviewMgr.deselectAll($scope.listOfValues);
      $scope.col.filters[0].filtervalue = "";
    };
  
    

    $scope.showFilterModal();
  }]);
/*global CMP_ISNULL*/
/*global CMP_LIKE*/
/*global CMP_EQ*/
angular.module("gp4App").controller('ixCellValorDefController',
[ "$scope", "$q", "ivhTreeviewMgr", "cfg", "ixStatusService", "$http", "$uibModalInstance", "$timeout", "$filter",
function($scope, $q, ivhTreeviewMgr, cfg, ixStatusService, $http, $uibModalInstance, $timeout, $filter) {
  $scope.entity = $scope.$resolve.entity;
  $scope.columnType = $scope.$resolve.column.type;
  $scope.control = $scope.$resolve.column.control;


  $scope.filtro_periodo = [];

  $scope.filtro = $scope.$resolve.filtro == null ? undefined : $scope.$resolve.filtro;
  if(($scope.columnType == "date" && typeof $scope.filtro == "string") && $scope.filtro.lastIndexOf("*") != -1){
    $scope.filtroespecial = $scope.filtro;
  }

  $scope.filterOp = $scope.$resolve.filterOp;
  $scope.singleOption = angular.isDefined($scope.$resolve.singleOption) ? true : false;
  $scope.hideSelectionMode = angular.isDefined($scope.$resolve.hideSelectionMode) ? $scope.$resolve.hideSelectionMode : false;

  $scope.selectAll = function() {
    var matchingValues = [];
    if($scope.searchfiltro != null){
      angular.forEach($scope.listOfValues, function(value){
        if(value.label.toUpperCase().indexOf($scope.searchfiltro.toUpperCase()) !== -1){
          matchingValues.push(value);
        }
      });
      ivhTreeviewMgr.selectAll(matchingValues);
    } else {
      ivhTreeviewMgr.selectAll($scope.listOfValues);
    }

  };

  $scope.deselectAll = function() {
		$scope.searchfiltro = "";
    ivhTreeviewMgr.deselectAll($scope.listOfValues);
  };

  $scope.selectionChanged = function(ivhNode, ivhIsSelected, ivhTree){
    if($scope.singleOption){
      if(ivhIsSelected){
        ivhTreeviewMgr.selectAll($scope.listOfValues);
        ivhTreeviewMgr.deselectAll($scope.listOfValues);
        ivhTreeviewMgr.selectEach(ivhTree, [ivhNode]);
      }
    }
  };

  $scope.processData = function(){
    //Mirem si hem de canviar el operador.
    if($scope.filtro == "#value" || $scope.filtro == "#empty"){
      $scope.filterOp = CMP_ISNULL;
      $scope.listOfValues = undefined;
    }
    $uibModalInstance.close({ filtro: $scope.filtro, filtros: $scope.listOfValues, op: $scope.filterOp, filtro_periodo: $scope.filtro_periodo });
  };


  //
  $scope.loadSelectableOptions = function(column, filtroObj){
      var selected = false;
      var listOfValues = [];
      var deferred = $q.defer();
      if(angular.isDefined(column) && angular.isDefined(column.Search) && column.Search != null){
        if(angular.isDefined(column.options)){
          if(column.options != null){
            column.options.forEach(function(item){
              selected = false;
              if(angular.isDefined(filtroObj)){
                selected = (filtroObj == item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]]);
              }
              //listOfValues.push({id:item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]], label:item.nombre, selected:selected, children:[]});
              var id = item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]];
              var label = "";
              for(var i=0; i < column.Search.LookUpResultFields.length; i++){
                var key = column.Search.LookUpResultFields[i];
                label += "" + (angular.isDate(item[key]) ? $filter('date')(item[key], cfg.dateFormat) : item[key] );
                if(i != column.Search.LookUpResultFields.length - 1) label += " - ";
              }
              listOfValues.push({id:id, label:label, selected:selected, children:[]});
            });
            $timeout(function(){
              return deferred.resolve(listOfValues);
            },0);
          }
        } else {
          $http.get(cfg.baseURL + column.Search.LookUpTableName).then(function(r){

            if(r.data != null){
              //Mirem si té alguna condició per aplicar-la al conjunt de resultats.
              if(angular.isDefined(column.Search.LookUpConditions) && column.Search.LookUpConditions.length > 0){
                angular.forEach(column.Search.LookUpConditions, function(condition){
                  //Fem filters de r.data fins que s'hagin comprovat totes les condicions.
                  if(condition.Not)
                    r.data = r.data.filter(function(e){ return e[condition.KeyField] != condition.Value; });
                  else
                    r.data = r.data.filter(function(e){ return e[condition.KeyField] == condition.Value; });
                });
              }
              column.Search.LookUpOrders.forEach(function(order){
                r.data = $filter("orderBy")(r.data, order.KeyField, order.Desc);
              });
              column.options = r.data;
              r.data.forEach(function(item){
                selected = false;
                if(angular.isDefined(filtroObj)){
                  selected = (filtroObj == item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]]);
                }
                //listOfValues.push({id:item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]], label:item.nombre, selected:selected, children:[]});

                var id = item[column.Search.LookUpKeyFields[column.Search.LookUpKeyFields.length - 1]];
                var label = "";
                for(var i=0; i < column.Search.LookUpResultFields.length; i++){
                  var key = column.Search.LookUpResultFields[i];
                  label += "" + (angular.isDate(item[key]) ? $filter('date')(item[key], cfg.dateFormat) : item[key] );
                  if(i != column.Search.LookUpResultFields.length - 1) label += " - ";
                }
                listOfValues.push({id:id, label:label, selected:selected, children:[]});

              });
              return deferred.resolve(listOfValues);
            }
          });
        }
      }
      return deferred.promise;
    };

  //

  //var columna = $scope.data.metadata.find(function(e){ return e.name.toLowerCase() == $scope.entity.campo.toLowerCase(); });//Si al provar els traspassos dona un error
  var columna = $scope.$resolve.column;//si provant els traspassos dona error, comentar aquesta línea i descomentar la de la fila de dalt.
  $scope.loadSelectableOptions(columna, $scope.filtro).then(function(data){
    $scope.listOfValues = data;
  });
}]);

/*global CMP_ISNULL*/
/*global CMP_LIKE*/
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module("gp4App").controller('ixCellFiltroController',
  [ "$scope", "$q", "ivhTreeviewMgr", "cfg", "ixStatusService", "$http", "$uibModalInstance", "$timeout", "$filter",
  function($scope, $q, ivhTreeviewMgr, cfg, ixStatusService, $http, $uibModalInstance, $timeout, $filter) {
    $scope.entity = $scope.$resolve.entity;
    $scope.columnType = $scope.$resolve.column.type;
    $scope.control = $scope.$resolve.column.control;
    $scope.gridEntity = $scope.$resolve.gridEntity;
    $scope.gridData = $scope.$resolve.gridData;
  
  
    $scope.filtro_periodo = [];
    $scope.filtro = $scope.$resolve.filtro == null ? undefined : $scope.$resolve.filtro;
    $scope.filtro_valor = $scope.$resolve.filtro_valor == null ? undefined : $scope.$resolve.filtro_valor;
    $scope.filtro_tipo = $scope.$resolve.filtro_tipo == null ? undefined : $scope.$resolve.filtro_tipo;
    angular.forEach($scope.filtro, function(filtro, i){
      if(($scope.columnType == "date" && typeof filtro == "string") && filtro.lastIndexOf("*") != -1){
        $scope.filtro_periodo[i] = filtro;
        $scope.filtro[i] = null;
      }
    });
    if(($scope.columnType == "date" && typeof $scope.filtro == "string") && $scope.filtro.lastIndexOf("*") != -1){
      $scope.filtroespecial = $scope.filtro;
    }
    // if((angular.isArray($scope.filtro)) && $scope.filtro_tipo == "#lista"){
    //   $scope.filtro = $scope.filtro.join("\n");
    // }
  //	else if($scope.columnType == "number"){
  //    if(angular.isUndefined($scope.filtro)){//Si es de tipus numeric, s'ha de mostrar un rang desde / hasta, inicialitzem els valors del filtre ja que sino no es mostrarà el 2on input.
  //      $scope.filtro = [];
  //      $scope.filtro[0] = "";
  //      $scope.filtro[1] = "";
  //    }
  //  }
  
    $scope.filterOp = $scope.$resolve.filterOp;
    $scope.not = $scope.$resolve.not;
    $scope.singleOption = angular.isDefined($scope.$resolve.singleOption) ? true : false;
    $scope.hideSelectionMode = angular.isDefined($scope.$resolve.hideSelectionMode) ? $scope.$resolve.hideSelectionMode : false;
  
    $scope.filterOptions = function(){
      var deferral = $q.defer();
      deferral.resolve({
          data: [{ op: CMP_EQ, nombre: 'Valor exacto'}, {op: CMP_LIKE, nombre: 'Contiene'}]
      });
      return deferral.promise;
    };
  
    $scope.loadTiposFecha = function(){
      if(angular.isUndefined($scope.tiposFecha)){
        return $http.get(cfg.baseURL + "tipos_fecha").then(function(response){
          var result = [];
          if(response.data != null){
            result = response;
          }
          $scope.tiposFecha = result.data;
          return result;
        }, function(err){
          ixStatusService.setResponse(err);
        });
      } else {
        var defer = $q.defer();
        defer.resolve({ data: $scope.tiposFecha });
        return defer.promise;
      }
    };
  
    if($scope.columnType == "date"){
      $scope.loadTiposFecha().then(function(response){
        $scope.tiposFecha = response.data;
      });
    }
  
    $scope.selectAll = function() {
      var matchingValues = [];
      if($scope.searchfiltro != null){
        angular.forEach($scope.listOfValues, function(value){
          if($scope.searchfiltro != ""){
            if(value.label.toUpperCase().indexOf($scope.searchfiltro.toUpperCase()) !== -1){
              matchingValues.push(value);
            }
          }
          else if($scope.filtrotexto){
            var listValues = $scope.filtrotexto.toUpperCase().split("\n");			
            for (var i = 0, len = listValues.length; i < len; i++) {
              if(value.label.toString().toUpperCase().indexOf(listValues[i].toUpperCase()) !== -1) {
                if(matchingValues.indexOf(value) == -1)
                  matchingValues.push(value);
              }			
            }
          }
        });
        ivhTreeviewMgr.selectAll(matchingValues);
      } else {
        ivhTreeviewMgr.selectAll($scope.listOfValues);
      }
  
    };
  
    $scope.deselectAll = function() {
      $scope.searchfiltro = "";
      ivhTreeviewMgr.deselectAll($scope.listOfValues);
    };
  
    $scope.selectionChanged = function(ivhNode, ivhIsSelected, ivhTree){
      if($scope.singleOption){
        if(ivhIsSelected){
          ivhTreeviewMgr.selectAll($scope.listOfValues);
          ivhTreeviewMgr.deselectAll($scope.listOfValues);
          ivhTreeviewMgr.selectEach(ivhTree, [ivhNode]);
        }
      }
    };
  
    $scope.filterList = function(item, B) {		
      var result = false;
      if($scope.filtrotexto){
        var listValues = $scope.filtrotexto.toUpperCase().split("\n");			
        for (var i = 0, len = listValues.length; i < len; i++) {
          if(item.label.toString().toUpperCase().indexOf(listValues[i].toUpperCase()) !== -1) {			
            result = true;
            break;
          }			
        }
      } else {
        result = true;
      }
      return result;
    };
  
    $scope.processData = function(){
      var filtro_valor = $scope.filtro;
      //if($scope.filtro_tipo == "#lista")
        //filtro_valor = $scope.filtrotexto;
      $scope.not = false;
      //Mirem si hem de canviar el operador.
      if($scope.filtro_tipo == "#value" || $scope.filtro_tipo == "#empty"){
        filtro_valor = undefined;
        $scope.filterOp = CMP_ISNULL;
        $scope.listOfValues = undefined;
      }
      else if($scope.filtro_tipo == "#exclude")
        $scope.not = true;
  
      //if($scope.columnType == "string" && !$scope.listOfValues && ($scope.filtrotexto || $scope.filtrotexto === ""))
      if(!$scope.listOfValues){
        if($scope.columnType == "string" && ($scope.filtrotexto || $scope.filtrotexto === "") || $scope.filtro_tipo == "#lista")
          filtro_valor = $scope.filtrotexto;
        else if($scope.columnType == "number" && ($scope.filtronumero || $scope.filtronumero === ""))
          filtro_valor = $scope.filtronumero;
  
        if($scope.filtro_tipo == "#lista")
          filtro_valor = filtro_valor.split(/\r?\n|\r|\n/g);
      }
  
      $uibModalInstance.close({ filtro: filtro_valor, filtros: $scope.listOfValues, op: $scope.filterOp, not: $scope.not, filtro_periodo: $scope.filtro_periodo, filtro_tipo: $scope.filtro_tipo });
    };
  
    //
    $scope.loadSelectableOptions = function(column, filtroObj){
      var selected = false;
      var listOfValues = [];
      var deferred = $q.defer();
      if(angular.isDefined(column) && angular.isDefined(column.Search) && column.Search != null){
        if(angular.isDefined(column.options) && column.Search.LookUpKeyFields.length <= 1){
          if(column.options != null){
            column.options.forEach(function(item){
              selected = false;
              if(angular.isDefined(filtroObj)){
                selected = filtroObj.indexOf(item[column.Search.LookUpResultFields[0]])>=0;
              }
              var id = item[column.Search.LookUpResultFields[0]];
              var label = "";
              for(var i=0; i < column.Search.LookUpResultFields.length; i++){
                var key = column.Search.LookUpResultFields[i];
                label += "" + (angular.isDate(item[key]) ? $filter('date')(item[key], cfg.dateFormat) : item[key] );
                if(i != column.Search.LookUpResultFields.length - 1) label += " - ";
              }
              listOfValues.push({id:id, label:label, selected:selected, children:[]});
            });
  
            if($scope.not)
              $scope.filtro = "#exclude";
  
            $timeout(function(){
              return deferred.resolve(listOfValues);
            },0);
          }
        } else {
          var params = buildIxSearch();
          if(column.Search.LookUpKeyFields.length > 1){
            for(var i = 0; i < column.Search.LookUpKeyFields.length - 1; i++){
              var campo_tabla_busqueda = column.Search.LookUpKeyFields[i];
              var campo = column.Search.KeyFields[i];
              var filaGrid = $scope.gridData.find(function(e){ return e.campo == campo; });
              if(angular.isDefined(filaGrid)){
                if(filaGrid.filtro_valor){
                  for(var x = 0; x < filaGrid.filtro_valor.length; x++){
                    params.Filters.push({ StartPar: (x == 0), Field: campo_tabla_busqueda, Operator: CMP_EQ, Value: filaGrid.filtro_valor[x], Or: (x > 0), EndPar: (x == filaGrid.filtro_valor.length - 1) });
                  }
                }
              }
            }
          }
  
          var api_call = $http.post(cfg.baseURL + column.Search.LookUpTableName + "/List", params);
          if(params.Filters.length == 0)
          api_call = $http.get(cfg.baseURL + column.Search.LookUpTableName);
  
          api_call.then(function(r){
            if(r.data != null){
              if(angular.isDefined(column.Search.LookUpConditions) && column.Search.LookUpConditions.length > 0){
                angular.forEach(column.Search.LookUpConditions, function(condition){
                  //Fem filters de r.data fins que s'hagin comprovat totes les condicions.
                  r.data = r.data.filter(function(e){ return e[condition.KeyField] == condition.Value; });
                });
              }
              column.Search.LookUpOrders.forEach(function(order){
                r.data = $filter("orderBy")(r.data, order.KeyField, order.Desc);
              });
              column.options = r.data;
              r.data.forEach(function(item){
                selected = false;
                if(angular.isDefined(filtroObj)){
                  selected = filtroObj.indexOf(item[column.Search.LookUpResultFields[0]])>=0;
                }
                var id = item[column.Search.LookUpResultFields[0]];
                var label = "";
                for(var i=0; i < column.Search.LookUpResultFields.length; i++){
                  var key = column.Search.LookUpResultFields[i];
                  label += "" + (angular.isDate(item[key]) ? $filter('date')(item[key], cfg.dateFormat) : item[key] );
                  if(i != column.Search.LookUpResultFields.length - 1) label += " - ";
                }
                listOfValues.push({id:id, label:label, selected:selected, children:[]});
              });
              if($scope.not)
                $scope.filtro = "#exclude";
              return deferred.resolve(listOfValues);
            }
          });
        }
      } else if(column.type == "string" && column.Control == null) {
        if(angular.isDefined(column.options)){
  
          if(column.options != null){
            column.options.forEach(function(item){
              selected = false;
              if(angular.isDefined(filtroObj)){
                selected = filtroObj.indexOf(item[column.name])>=0;
              }
              listOfValues.push({id:item[column.name], label:item[column.name], selected:selected, children:[]});
            });
            $timeout(function(){
              return deferred.resolve(listOfValues);
            },0);
          }
        } else {
          var param = { Fields: [ { Field: column.name } ], Selection: buildIxSearch() };
          //Fer un SelectAndProject del camp
          $http.post(cfg.baseURL + $scope.gridEntity + "/SelectAndProject", param).then(function(response){
            if(response.data != null){
              var uniqueValues = $filter('unique')(response.data, column.name);
              column.options = uniqueValues;
              uniqueValues.forEach(function(item){
                selected = false;
                if(angular.isDefined(filtroObj)){
                  selected = filtroObj.indexOf(item[column.name])>=0;
                }
                listOfValues.push({id:item[column.name], label:item[column.name], selected:selected, children:[]});
              });
              return deferred.resolve(listOfValues);
              //return listOfValues;
            }
          }, function(err){
            ixStatusService.setResponse(err);
          });
        }
      } else {
        $timeout(function(){
          //if($scope.columnType == 'string' && !$scope.listOfValues && $scope.filtro)
          if(!$scope.listOfValues && $scope.filtro){
            if((angular.isArray($scope.filtro)) && $scope.filtro_tipo == "#lista"){
              $scope.filtro = $scope.filtro.join("\n");
            }
            if($scope.columnType == 'string' || $scope.filtro_tipo == "#lista")
              $scope.filtrotexto = $scope.filtro;
            else if($scope.columnType == 'number')
              $scope.filtronumero = $scope.filtro.replace(/(\r\n|\n|\r)/gm, "");
          }
          return deferred.resolve(null);
        });
      }
      return deferred.promise;
    };
    //
  
    //var columna = $scope.data.metadata.find(function(e){ return e.name.toLowerCase() == $scope.entity.campo.toLowerCase(); });//Si al provar els traspassos dona un error
    var columna = $scope.$resolve.column;//si provant els traspassos dona error, comentar aquesta línea i descomentar la de la fila de dalt.
    $scope.loadSelectableOptions(columna, $scope.filtro).then(function(data){
      $scope.listOfValues = data;
    });
  }]);
  
angular.module('gp4App').controller('formularioAyudaController', ['$rootScope', '$scope', '$location', 'authService', '$http', 'cfg', '$log', '$timeout', function ($rootScope, $scope, $location, authService, $http, cfg, $log, $timeout) {
    $scope.maxUploadFileSize = '10MB';
    $scope.data = { datos: { archivosToUpload: [] } };

    $scope.getFileUrl = function (file) {
        if (file && !file.$objectUrl) {
            file.$objectUrl = URL.createObjectURL(file);
        }
        return file.$objectUrl;
    };

    $scope.removeFile = function (index) {
        var file = $scope.data.datos.archivosToUpload[index];
        if (file && file.$objectUrl) {
            URL.revokeObjectURL(file.$objectUrl);
        }
        $scope.data.datos.archivosToUpload.splice(index, 1);
    };
}]);
/*jslint browser: true, white: true, plusplus: true, node: true */
/*global angular */
/*global buildMenus*/
angular.module('gp4App').controller("ApiPerfilesController", ['$scope', '$http', '$routeParams', 'cfg', 'uiGridConstants', 'uiGridEditConstants', 'ixStatusService', '$filter', function ($scope, $http, $routeParams, cfg, uiGridConstants, uiGridEditConstants, ixStatusService, $filter) {

	$scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.data.pk = "perfil";
  $scope.data.ixEditarDisabled = true;
  $scope.searchText = '';
  
  $scope.searchFilter = function() {
    if (!$scope.searchText) return $scope.data.menuItems; // Si no hay búsqueda, mostrar todo    
    var searchLower = $scope.searchText.toLowerCase();    
    var menus = $scope.data.menuItems.filter(function(e){ return (e.path.toLowerCase().includes(searchLower) || e.node.display.toLowerCase().includes(searchLower)); });
    return menus;
  };

  function getNodes(node) {
    var vm = this;
    if(node.children) {
      node.children.forEach(getNodes, vm + (angular.isDefined(node.display) ? "/" + node.display : ""));
    } else {
      if(node.href && ($scope.allowedMenus.some(function(e){ return e.indexOf(vm + "/"+node.display)!==-1 }) || $scope.authentication.perfiles.some(function(e){ return e.toUpperCase() == ("IXNET");}))){
        var item = {
          key: vm+"/"+node.display,
          node: node,
          path: vm.toString(),
          checked: false
        }
        $scope.data.menuItems[vm+"/"+node.display] = item;
        $scope.data.menuItems = Object.values($scope.data.menuItems);
      }
    }    
  }

  if(!$scope.data.menuItems){
    $scope.data.menuItems = {};
    buildMenus().forEach(getNodes, "");
  }

  //
  $scope.$parent.filters[0].onNew = function(){
    var nuevo = {};
    nuevo.isNew = true;
    $scope.data.datos = nuevo;
    $scope.data.menuItems = {};
    buildMenus().forEach(getNodes, "");
    return nuevo;
  };

	$scope.deleteUser = function(u) {
		if($scope.status.editing) {
			$scope.data.datos.perfilesusuario.splice($scope.data.datos.perfilesusuario.indexOf(u),1);
		}
	}

	$scope.notAssigned = function(u) {
		return ($scope.data.datos.perfilesusuario.indexOf(u) !== -1);
	}
	$scope.onSelectNewUser = function(u){
    if($scope.data.datos.perfilesusuario.indexOf(u) == -1)
		  $scope.data.datos.perfilesusuario.push(u);
	}

	$http.get(cfg.baseURL + 'api_usuarios/GetAllByClientId?clientId='+cfg.clientId).then(function (response) {
		$scope.allUsers = response.data.map(function(x){return x.usuario});
	});

  $scope.$watch('current', function (current) {
    if(current && current.isNew && !$scope.data.datos.perfilesusuario && !$scope.data.datos.perfilesmenu){
      $scope.data.datos.perfilesusuario = [];
      $scope.data.datos.perfilesmenu = [];
      return;
    }
		if(!current || current.perfil == undefined || Object.keys(current).length == 0 ) return;
		else if(!current.isNew) {
      $scope.data.ixEditarDisabled = true;
			$http.get(cfg.baseURL + 'api_perfiles/Usuarios_Menus/'+current.perfil+'?clientId='+cfg.clientId).then(function (response) {
        $scope.data.datos = response.data;
        $scope.data.datos.perfil = current.perfil;
        $scope.data.datos.es_ventas = current.EsVentas;
        $scope.data.datos.es_costes = current.EsCostes;
        $scope.data.datos.es_tarifas_ventas = current.EsTarifasVentas;
        $scope.data.datos.es_tarifas_costes = current.EsTarifasCostes;
        $scope.data.datos.es_admin_users = current.EsAdminUsers;
        $scope.data.datos.es_ixnet = current.EsIxnet;
				if(response.data){
					$scope.data.menuItems = {};
					buildMenus().forEach(getNodes, "");
				}
				for(var key in $scope.data.menuItems) {
					$scope.data.menuItems[key].checked = false;
				}
        response.data.perfilesmenus.forEach(function(e) {
          var index = $scope.data.menuItems.findIndex(function(menu) { return menu.key === e; });            
          if (index !== -1) 
            $scope.data.menuItems[index].checked = true;              
        });
        $scope.data.datosOriginales = angular.copy(response.data);
        $scope.data.ixEditarDisabled = false;
			});
		}
	}, true);

  $scope.numberOfChanges = function(){
    return ($scope.data.datos.ToDelete) ? 1 : ((!angular.equals($scope.data.datos, $scope.data.datosOriginales)) ? 1 : undefined);
  };

  $scope.ixDeleteSelectedRows = function() {
    $scope.data.datos.ToDelete = true;
  };

	$scope.ixGuardar = function() {
    if($scope.data.datos.ToDelete == true){
      $http.delete(cfg.baseURL + 'api_perfiles/Delete_Usuarios_Menus/'+$scope.data.datos.perfil+'?clientId='+cfg.clientId, data).then(function (response) {
        $scope.response = response;
          $scope.applyFilter();
          ixStatusService.setEditing(false);
          if($scope.data.datos.isNew) delete($scope.data.datos.isNew);
      }, function(error){
        ixStatusService.setResponse(error);
      });
    } else {
      if($scope.data.datos.perfil){
        var data = {
          perfilesusuario: $scope.data.datos.perfilesusuario,
          perfilesmenus: []
        };   
        $scope.data.menuItems.forEach(function(e) {           
          if (e.checked) 
            data.perfilesmenus.push(e.key);             
        });

        var partsPerfil = $scope.data.datos.perfil.split(" ");
        if(partsPerfil.length > 0){
          $scope.data.datos.perfil = partsPerfil.join("_");
        }
        $scope.data.datos.perfil = $scope.data.datos.perfil.toLowerCase();

        $http.post(cfg.baseURL + 'api_perfiles/Usuarios_Menus/'+$scope.data.datos.perfil+'?clientId='+cfg.clientId, data).then(function (response) {
          $scope.response = response;
          $scope.applyFilter();
          ixStatusService.setEditing(false);
          if($scope.data.datos.isNew) delete($scope.data.datos.isNew);
        }, function(error) {
          ixStatusService.setResponse(error);
        });
        
        $http.post(cfg.baseURL + 'api_perfiles/Tipos_Permisos/'+$scope.data.datos.perfil+'?clientId='+cfg.clientId, $scope.data.datos).then(function (response) {
          $scope.response = response;
          $scope.applyFilter();
          ixStatusService.setEditing(false);
          if($scope.data.datos.isNew) delete($scope.data.datos.isNew);
        }, function(error) {
          ixStatusService.setResponse(error);
        });
      }
    }
	};

  if(!$scope.data.list){
    $scope.$parent.actualizarListado();
  }

}]);

angular.module("gp4App").controller("XMLPopupController", ['$scope', '$uibModalInstance', '$http', 'cfg', '$filter', 'ixStatusService', function ($scope, $uibModalInstance, $http, cfg, $filter, ixStatusService) {
	$scope.status = { editing: true };

	$scope.data = $scope.$resolve.xml;
	$scope.titulo = $scope.$resolve.titulo;
	
	function prettyPrintXML(xmlString) {
		var xmlDoc = new DOMParser().parseFromString(xmlString, 'application/xml');
		var xsltDoc = new DOMParser().parseFromString(
			[
			'<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform" version="1.0">',
			'  <xsl:output method="xml" indent="yes"/>',
			'  <xsl:strip-space elements="*"/>',
			'  <xsl:template match="@*|node()">',
			'    <xsl:copy><xsl:apply-templates select="@*|node()"/></xsl:copy>',
			'  </xsl:template>',
			'</xsl:stylesheet>'
			].join('\n'),
			'application/xml'
		);
		
		var xsltProcessor = new XSLTProcessor();
		xsltProcessor.importStylesheet(xsltDoc);
		var resultDoc = xsltProcessor.transformToDocument(xmlDoc);
		return new XMLSerializer().serializeToString(resultDoc);
	}

	
	$scope.XMLPretty = prettyPrintXML($scope.data);

	$scope.$close = function () {
		$uibModalInstance.dismiss('cancel');
	};
}]);

angular.module("gp4App").controller('VideoPlayerController', [ '$scope', function($scope){
  $scope.config = {
    sources: [],
    /*tracks: [
      {
        src: "http://www.videogular.com/assets/subs/pale-blue-dot.vtt",
        kind: "subtitles",
        srclang: "en",
        label: "English",
        default: ""
      }
    ],*/
    theme: "bower_components/videogular-themes-default/videogular.css",
    plugins: {
      poster: "",
      controls: {
        autoHide: true,
        autoHideTime: 5000
      }
    }
  };
}]);

angular.module('gp4App').controller('TooltipPopupController', [ "$scope", function($scope){
	$scope.texto = $scope.$resolve.texto;
}]);

/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global ixGetPatchOperations*/
/*global CMP_ISNULL*/
angular.module('gp4App').controller('ListadosProgramadosListController', ['$scope', '$controller', 'cfg', '$interval','ixUtilsService','ixStatusService', '$uibModal', '$http', 
  '$routeParams', '$filter', function($scope, $controller, cfg, $interval, ixUtilsService, ixStatusService, $uibModal, $http, $routeParams, $filter){
  
    $scope.filterByUser = $routeParams.filterByUser;
    $scope.esExtranet = (cfg.clientId == "Extranet" || cfg.clientId == "ExtranetVideo" || cfg.clientId == 'Gestpark-Internet');
  
    $scope.gridManualLoad = true;
  
    
  
    $scope.acciones = [
      {
        icon: "fa-list",
        title: "Editar listado",
        accion: function(entity){
          $scope.clickedList = entity;
          var modalInstance = $uibModal.open({
            templateUrl: 'app/base/views/listados_programados_popup.html',
            controller: 'ListadosProgramadosController',
            //scope: $scope,
            size: 'medium',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              clickedList: function(){
                return angular.copy(entity);
              }
            }
          });
  
          modalInstance.result.then(function(datosListadoProgramado){
            if(angular.isDefined(datosListadoProgramado)){
              var data = {};
              data.CambiosListado = ixGetPatchOperations($scope.clickedList, datosListadoProgramado);
              data.Mailto = (angular.isDefined(datosListadoProgramado.mailto) && datosListadoProgramado.mailto != null && datosListadoProgramado.mailto != "") ? angular.copy(datosListadoProgramado.mailto) : [];
              data.Mailcco = (angular.isDefined(datosListadoProgramado.mailcc) && datosListadoProgramado.mailcc != null && datosListadoProgramado.mailcc != "") ? angular.copy(datosListadoProgramado.mailcc) : [];
  
              delete datosListadoProgramado.mailto;
              delete datosListadoProgramado.mailcc;
  
              data.PlantillaCfgGrupos = datosListadoProgramado.plantilla_cfg_grupos;
              data.PlantillaCfgTransportistas = datosListadoProgramado.plantilla_cfg_transportistas;
              data.PlantillaCfgClientes = datosListadoProgramado.plantilla_cfg_clientes;
              data.PlantillaCfgCuentas = datosListadoProgramado.plantilla_cfg_cuentas;
  
              $http.put(cfg.baseURL + "listados_programados/PutCustom/" + $scope.clickedList.contador, data).then(function(response){
                ixStatusService.setResponse(response);
                $scope.data.grid.ixLoadInitialData();
              }, function(err){
                ixStatusService.setResponse(err);
              });
            }
          });
        }
      },
      {
          icon: "fa-quora",
          title: "Querys",
          visible: function(entity){
              return $scope.data.permisoQuery && !$scope.esExtranet;
          },
          accion: function(entity){
              var template = "app/base/views/listados_programados_querys_popup.html";
              var options = { controller: "ListadosProgramadosQuerysController" };
              var params = { Id_listado: entity.contador };
  
              ixUtilsService.openModalV2(template, options, "medium", params).then(function(response){
                  ixStatusService.setResponse(response);
                  //$scope.data.grid.ixLoadInitialData();
              });
          }
      }
    ];
    $controller("GridEditorController", {$scope: $scope});
  
    $scope.executeAfterInit = function(){
    //var interval;
    //interval = $interval(function(){
  
      if(angular.isUndefined($scope.filterStatus))
        $scope.filterStatus = { isCollapsed: true };
  
      //Desde GP4 hem de poder gestionar tots els llistats programats.
      if($scope.cfg.clientId == "GPv4" || $scope.cfg.clientId == "Gestpark-Intranet"){
        $scope.hideNewOnPreFilter = true;
        if(angular.isUndefined($scope.data.filtro)){
          $scope.data.filtro = {};
          $scope.data.filtro.client_id = cfg.clientId;
          $scope.filterStatus = { isCollapsed: true };
        }
  
        $scope.searchDropdown = function(param){
          if(param.Filters[0]){
            if(param.Filters[0].Value == "GPv4" || param.Filters[0].Value == "Gestpark-Intranet"){
              param.Filters[0].Operator = CMP_LIKE;
              param.Filters[0].Value = "";
            }
              
          }
          return $http.post(cfg.baseURL + "api_client/SearchDropdown", param);
        };
      
        $scope.ixFiltrar = function(){
          //var param = ixFiltersToArray($scope.data.filtro, $filter);
          $scope.data.grid.filtroExterno = [{ Field: "client_id", Value: $scope.data.filtro.client_id, Operator: CMP_EQ }];
          if($scope.data.filtro.client_id == "GPv4" || $scope.data.filtro.client_id == "Gestpark-Intranet"){
            $scope.data.grid.filtroExterno[0].StartPar = true;
            $scope.data.grid.filtroExterno.push({ Or: true, Field: "client_id", Operator: CMP_ISNULL, Value: "", EndPar: true });
          }
  
          if($scope.filterByUser == true){
            $scope.data.grid.filtroExterno.push({ Field: "usuario", Value: $scope.$parent.user.usuario, Operator: CMP_EQ });
          }
          //$scope.data.grid.filtroExterno = param;
          $scope.data.grid.ixLoadInitialData();
          $scope.filterStatus.isCollapsed = false;
          $scope.status.filtered = true;
        };
  
        $scope.ixCancelEdit = function(){
          if($scope.status.editing){
            ixStatusService.setEditing(false);
            $scope.data.grid.ixCancelEdit();
            $scope.data.registrosSeleccionados = [];
          } else {
            $scope.data.grid.ixCancelEdit(true);
            $scope.status.filtered = false;
            $scope.filterStatus.isCollapsed = true;
          }
        };  
  
        $scope.ixAddRowWhenEdit = function(){            
          var modalInstance = $uibModal.open({
            templateUrl: 'app/base/views/listados_programados_popup.html',
            controller: 'ListadosProgramadosController',          
            size: 'medium',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              showDatosPlantilla: function(){
                return true;
              }
            }            
          });
  
          modalInstance.result.then(function(datosListadoProgramado){
            if(angular.isDefined(datosListadoProgramado)){
              var data = {};
              //data.CambiosListado = ixGetPatchOperations({}, datosListadoProgramado);
              data.Listado = datosListadoProgramado;
              data.Mailto = (angular.isDefined(datosListadoProgramado.mailto) && datosListadoProgramado.mailto != null && datosListadoProgramado.mailto != "") ? angular.copy(datosListadoProgramado.mailto) : [];
              data.Mailcco = (angular.isDefined(datosListadoProgramado.mailcc) && datosListadoProgramado.mailcc != null && datosListadoProgramado.mailcc != "") ? angular.copy(datosListadoProgramado.mailcc) : [];
  
              delete datosListadoProgramado.mailto;
              delete datosListadoProgramado.mailcc;
              if(angular.isDefined(datosListadoProgramado.gridMailTo))
                delete datosListadoProgramado.gridMailTo;
              if(angular.isDefined(datosListadoProgramado.gridMailCC))
                delete datosListadoProgramado.gridMailCC;
              
  
              data.PlantillaCfgGrupos = datosListadoProgramado.plantilla_cfg_grupos;
              data.PlantillaCfgTransportistas = datosListadoProgramado.plantilla_cfg_transportistas;
              data.PlantillaCfgClientes = datosListadoProgramado.plantilla_cfg_clientes;
              data.PlantillaCfgCuentas = datosListadoProgramado.plantilla_cfg_cuentas;
  
              $http.post(cfg.baseURL + "listados_programados/PostCustom/", data).then(function(response){
                ixStatusService.setResponse(response);
                $scope.data.grid.ixLoadInitialData();
              }, function(err){
                ixStatusService.setResponse(err);
              });
            }
          });
        };
      } else {
        if(angular.isDefined($scope.data.grid)){
  
          $scope.ixAddRow = undefined;
          $scope.ixAddRowWhenEdit = undefined;
    
          if((angular.isUndefined($scope.data.grid.data)) || $scope.data.grid.data.length == 0){
            $scope.data.grid.filtroExterno = [{ Field: "client_id", Value: cfg.clientId, Operator: CMP_EQ }];
            if(cfg.clientId == "GPv4" || cfg.clientId == "Gestpark-Intranet"){
              $scope.data.grid.filtroExterno[0].StartPar = true;
              $scope.data.grid.filtroExterno.push({ Or: true, Field: "client_id", Operator: CMP_ISNULL, Value: "", EndPar: true });
            }
            if($scope.filterByUser == true){
              $scope.data.grid.filtroExterno.push({ Field: "usuario", Value: $scope.$parent.user.usuario, Operator: CMP_EQ });
            }
            $scope.data.grid.ixLoadInitialData();
          }
          //$interval.cancel(interval);
        }
      }
  
      if(angular.isUndefined($scope.data.ListProgramados)){    
        ixUtilsService.checkMultiplePermission([ "ListProgramados" ]).then(function(result){    
          $scope.data.ListProgramados = result[0];
        });
      }
  
      $scope.usuarioConPermisos = function(){
        if(angular.isUndefined($scope.data.permisosCall)){
          $scope.data.permisosCall = $http.get(cfg.baseURL + "listados_programados/ExecutionSetVisible").then(function(response){
            $scope.data.permisoQuery = response.data;
            $scope.data.permisosCall = undefined;
          });
        }
      };
      $scope.usuarioConPermisos();
    }
    //}, 100);
  }]);
  
angular.module('gp4App').controller('ListadosProgramadosQuerysController', ['$scope', '$uibModalInstance', 'ixStatusService', '$http', 'cfg', function($scope, $uibModalInstance, ixStatusService, $http, cfg){
  $scope.status = ixStatusService.current;
  
    $http.get(cfg.baseURL + "listados_programados/ExecutionSet/" + $scope.$resolve.Id_listado).then(function(r){
      $scope.data = r.data;
    }, function(err){
      ixStatusService.setResponse(err);
      $uibModalInstance.dismiss('cancel');
    });

  }]);

/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module('gp4App').controller('ListadosProgramadosController', ['$scope', '$uibModalInstance', 'ixStatusService', 'ixUtilsService', '$http', 'cfg', 
  'gridService', function($scope, $uibModalInstance, ixStatusService, ixUtilsService, $http, cfg, gridService){
  $scope.status = { editing: true };

	$scope.loadMetadata = function(metadataEntity){
		if(angular.isDefined(metadataEntity)){
			return $http.get(cfg.baseURL + "metadata/" + metadataEntity).then(function(response){
				$scope.data.metadataForm = response.data;
				return $scope.data.metadataForm;
			});
		}
	};

  

	$scope.getMaxLength = function(keyName){
		if(angular.isDefined($scope.data.metadataForm)){
			var obj = $scope.data.metadataForm.find(function(e){ return e.Name == keyName; });
			return obj.MaxLength;
		}
	};

  $scope.data = {};

  ixUtilsService.checkPermission("ListProgramadosEnviosModoGrid").then(function(data){
    $scope.data.ListProgramadosEnviosModoGrid = data;
    if($scope.data.ListProgramadosEnviosModoGrid){
      $scope.gridManualLoad = true;
      $scope.createGridsEnvio();
    }
    $scope.configLoaded = true;
  });

  $scope.addRow = function(grid){
		grid.ixAddRow();
  };

  $scope.deleteSelectedRows = function(grid){
		grid.ixDeleteSelectedRows();
  };

  $scope.createGridsEnvio = function(){
    $scope.data.gridMailTo = gridService.createGrid($scope, "gp4_list_prog_mail_toGrid", { showOnlyDescribedCols: [ "mail_to" ], minRowsToShow: 4 }, "mail_toVM");

    if(angular.isDefined($scope.data.mailsto)){
      var rowsMailTo = [];
      var direcciones_mail_to = $scope.data.mailsto.split(";");
      angular.forEach(direcciones_mail_to, function(direccion_mail_to){
        rowsMailTo.push({ mail_to: direccion_mail_to });
      });
  
      $scope.data.gridMailTo.data = rowsMailTo;
    }

    $scope.data.gridMailCC = gridService.createGrid($scope, "gp4_list_prog_mail_ccGrid", { showOnlyDescribedCols: [ "mail_cc" ], minRowsToShow: 4 }, "mail_toVM");

    if(angular.isDefined($scope.data.mailscco)){
      var rowsMailCC = [];
      var direcciones_mail_cc = $scope.data.mailscco.split(";");
      angular.forEach(direcciones_mail_cc, function(direccion_mail_cc){
        rowsMailCC.push({ mail_cc: direccion_mail_cc });
      });
  
      $scope.data.gridMailCC.data = rowsMailCC;
    }
  };

	if(!$scope.data.metadataForm){
		$scope.loadMetadata("listados_programados");
	}

	$scope.regExpSpecialChars = function(){
		// //Substituim qualsevol d'aquests caracters per \ / : * ? " < > | un _
		// var regexSpecialChars = /[\\/:*?"<>\|]/g;

    //Substituim qualsevol d'aquests caracters per \ * ? " < > | un _
		var regexSpecialChars = /[\\*?"<>\|]/g;

		// //Substitum espais per _
		// var regexSpaces = /\s+/g;

		if(regexSpecialChars.test($scope.data.nombre)){
			$scope.data.nombre = $scope.data.nombre.replace(regexSpecialChars, '_');
		}
		// if(regexSpaces.test($scope.data.nombre)){
		// 	$scope.data.nombre = $scope.data.nombre.replace(regexSpaces, '_');
		// }
		return $scope.data.nombre;
	};

  $scope.data.intervalo = null;
  $scope.data.intervalo_horas = null;
  $scope.data.intervalo_dias = null;
  $scope.data.intervalo_meses = null;
  $scope.data.intervaloseleccionado = 0;
  $scope.data.activo = 1;

  $scope.data.lunes = 1;
  $scope.data.martes = 1;
  $scope.data.miercoles = 1;
  $scope.data.jueves = 1;
  $scope.data.viernes = 1;
  $scope.data.sabado = 1;
  $scope.data.domingo = 1;

  $scope.data.clave = ixStatusService.current.href;

  //De moment nomes es poden treure excels.
  $scope.data.extension = "XLS";

  $scope.loadPlantillas = function(param){
		return $http.post(cfg.baseURL + "listados_programados_plantillas/Search?Page=1&ItemsPerPage=999", param);
	};
  $scope.loadGrupos = function(param){
		return $http.post(cfg.baseURL + "grupos/Search?Page=1&ItemsPerPage=999", param);
	};
  $scope.loadTransportistas = function(param){
		return $http.post(cfg.baseURL + "transportistas/Search?Page=1&ItemsPerPage=99", param);
	};
  $scope.loadClientes = function(param){
		return $http.post(cfg.baseURL + "clientes/Search?Page=1&ItemsPerPage=999", param);
	};
  $scope.loadClientesCue = function(param){
		return $http.post(cfg.baseURL + "search_ref_clientes/Search?Page=1&ItemsPerPage=999", param);
	};

  $scope.save = function () {
    if((angular.isDefined($scope.data.intervaloseleccionado)) && ( 
       ($scope.data.intervaloseleccionado == 0) ||
       ($scope.data.intervaloseleccionado == 1 && $scope.data.intervalo > 0 && $scope.data.intervalo <= 59) ||
       ($scope.data.intervaloseleccionado == 2 && $scope.data.intervalo_horas > 0 && $scope.data.intervalo_horas <= 24) ||
       ($scope.data.intervaloseleccionado == 3 && $scope.data.intervalo_dias > 0 && $scope.data.intervalo_dias <= 31) ||
       ($scope.data.intervaloseleccionado == 4 && $scope.data.intervalo_meses > 0 && $scope.data.intervalo_meses <= 12) )
    ){
      if($scope.data.intervaloseleccionado == 0){
        $scope.data.intervalo = 0;
        $scope.data.intervalo_horas = 0;
        $scope.data.intervalo_dias = 0;
        $scope.data.intervalo_meses = 0;
      } else if($scope.data.intervaloseleccionado == 1){
        //$scope.data.intervalo = null;
        $scope.data.intervalo_horas = 0;
        $scope.data.intervalo_dias = 0;
        $scope.data.intervalo_meses = 0;
      } else if($scope.data.intervaloseleccionado == 2){
        $scope.data.intervalo = 0;
        //$scope.data.intervalo_horas = null;
        $scope.data.intervalo_dias = 0;
        $scope.data.intervalo_meses = 0;
      } else if($scope.data.intervaloseleccionado == 3){
        $scope.data.intervalo = 0;
        $scope.data.intervalo_horas = 0;
        //$scope.data.intervalo_dias = null;
        $scope.data.intervalo_meses = 0;
      } else if($scope.data.intervaloseleccionado == 4){
        $scope.data.intervalo = 0;
        $scope.data.intervalo_horas = 0;
        $scope.data.intervalo_dias = 0;
        //$scope.data.intervalo_meses = null;
      }

      if(!$scope.data.ListProgramadosEnviosModoGrid){
        if(angular.isDefined($scope.data.mailto) && $scope.data.mailto != null){
          $scope.data.mailto = $scope.data.mailto.split(";");
          for(var i = 0; i < $scope.data.mailto.length; i++){
            $scope.data.mailto[i] = $scope.data.mailto[i].trim();
          }
        }
    
        if(angular.isDefined($scope.data.mailcc) && $scope.data.mailcc != null){
          $scope.data.mailcc = $scope.data.mailcc.split(";");
          for(var x = 0; x < $scope.data.mailcc.length; x++){
            $scope.data.mailcc[x] = $scope.data.mailcc[x].trim();
          }
        }
      } else {
        $scope.data.mailto = $scope.data.gridMailTo.data.map(function(x){ return x.mail_to; });
        $scope.data.mailcc = $scope.data.gridMailCC.data.map(function(x){ return x.mail_cc; });
      }
      
      $uibModalInstance.close($scope.data);
    }
  };

  $scope.$close = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.getListadoProgramado = function(datos){
    if(datos.intervalo){
      datos.intervaloseleccionado = 1;
    } else if(datos.intervalo_horas){
      datos.intervaloseleccionado = 2;
    } else if(datos.intervalo_dias){
      datos.intervaloseleccionado = 3;
    } else if(datos.intervalo_meses){
      datos.intervaloseleccionado = 4;
    } else {
      datos.intervaloseleccionado = 0;
    }
    $scope.datosOriginales = datos;

    return datos;
  };

  //Si el llistat ja existeix, rebrem un objecte entity amb els atributs d'aquest llistat.
  if(angular.isDefined($scope.$resolve.clickedList)){
    var datos = $scope.$resolve.clickedList;
    $scope.data = $scope.getListadoProgramado(datos);

    var param = { Fields: [ { Field: "mail" } ], Selection: buildIxSearch() };
    param.Selection.Filters.push({ Field: "contador", Value: datos.contador, Operator: CMP_EQ });

    $http.post(cfg.baseURL + "listados_programados_mailto/SelectAndProject", param).then(function(mailto){
      if(mailto.data.length > 0){
        var arrStrings = mailto.data.map(function(obj){
          return obj.mail;
        });
        $scope.data.mailto = arrStrings.join(';');
      }
    });

    $http.post(cfg.baseURL + "listados_programados_mailcco/SelectAndProject", param).then(function(mailcco){
      if(mailcco.data.length > 0){
        var arrStrings = mailcco.data.map(function(obj){
          return obj.mail;
        });
        $scope.data.mailcc = arrStrings.join(';');
      }
    });

    $http.get(cfg.baseURL + "listados_programados_plantillas_cfg/" + $scope.data.contador).then(function(response){
      $scope.data.plantilla_cfg_grupos = response.data.grupos;
      $scope.data.plantilla_cfg_transportistas = response.data.transportistas;      
      $scope.data.plantilla_cfg_clientes = response.data.clientes;      
      $scope.data.plantilla_cfg_cuentas = response.data.cuentas;      
    });	
  }

  if(angular.isDefined($scope.$resolve.showDatosPlantilla)){    
    $scope.showDatosPlantilla = $scope.$resolve.showDatosPlantilla;
  }
}]);

/*jslint browser: true, devel: true, white: true, plusplus: true, vars: true*/
/*eslint angular/di: [2,"array"]*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
angular.module('gp4App').controller('ListEditController', ['$scope', '$rootScope', '$controller', '$http', '$routeParams', '$uibModal', '$timeout', 'cfg', 'uiGridConstants', 'authService', 'ixStatusService', 'gridService', '$log', function($scope, $rootScope, $controller, $http, $routeParams, $uibModal, $timeout, cfg, uiGridConstants, authService, ixStatusService, gridService, $log) {
  $scope.angular = angular; // FT: agregar angular al scope de ListEditController para evaluar angular.equals en la view (filters.html)
  $scope.ixEditar = function () {
    //No canviar a mode edició si no hi ha cap registre sel·leccionat.
    if(!$scope.data.datos[$scope.data.pk] && !$scope.data.datos_ope[$scope.data.pk]) return;
    // TODO: crear un bloqueo
    /*$scope.bloqueo = {
      user: authService.authentication.userName,
      ts: new Date(),
      app: $scope.entity
    };*/
    ixStatusService.setEditing(true);
  };

  $scope.ixCancelEdit = function () {
    delete ixStatusService.current.response;
    $scope.data.cancelEdit = true;
    $scope.current = {};
    $scope.data.datos = {};

    $scope.applyFilter();
    ixStatusService.setEditing(false);
    //Recuperar l'objecte que estava sel·leccionat del llistat lateral.
    $timeout(function(){
      $scope.selectItem($scope.data.datosOriginales);
    });
  };

  // todo: obnener filtros de backend
  $scope.filters = [
    {name:$scope.entity, view:"list", search: {Filters: [], OrderBy: []}, data : {CurrentPage:1, ItemsPerPage: 6, Items:[]}, filterVisible:false }
  ];

  $scope.init = function(){
    var timer;
    $scope.module = ($routeParams.module && $routeParams.module != "") ? $routeParams.module + "/" : '';
    $scope.entity = $routeParams.entity;

    $scope.status = ixStatusService.current;
    $scope.data = ixStatusService.current.data;
    if(angular.isUndefined($scope.data)) $scope.data = {};
		var lastBusqueda = $scope.data.busqueda || "";

    $scope.includeFiltersTemplate = ($routeParams.includeFiltersTemplate && $routeParams.includeFiltersTemplate != "") ? $routeParams.includeFiltersTemplate : 'app/base/views/filters.html';
    //$scope.gridManualLoad = true;
    if(!$scope.current) $scope.current = {};
    if(!$scope.data.datos){
      $scope.data.datos = {};
    }

    $scope.loadMetadata = function(metadataEntity){
      if(angular.isDefined(metadataEntity)){
        return $http.get(cfg.baseURL + "metadata/" + metadataEntity).then(function(response){
          $scope.data.metadataForm = response.data;
          return $scope.data.metadataForm;
        });
      }
    };

		$scope.getMaxLength = function(keyName){
      if(angular.isDefined($scope.data.metadataForm)){
        var obj = $scope.data.metadataForm.find(function(e){ return e.Name == keyName; });
				if(obj.MaxLength == null && obj.Type == "Int32"){
					obj.MaxLength = 11;
				}
        return obj.MaxLength;
      }
    };
    
    if($scope.entity == "api_perfiles"){
      $scope.filters[0].search.Filters.push({Field : "client_id", Value : cfg.clientId, Operator : CMP_EQ});
    } else if($scope.entity == "api_perfiles_mobile"){
      $scope.filters[0].search.Filters.push({Field : "client_id", Value : "GPv4MobileCampa", Operator : CMP_EQ});
    } else if($scope.entity == "api_perfiles_extranet"){
      $scope.filters[0].search.Filters.push({Field : "client_id", Value : "Extranet", Operator : CMP_EQ});
    }

    if($scope.data.grid){
      $scope.data.grid = gridService.createGridFunctions($scope, $scope.data.grid);
      $scope.data.grid.ixRestoreConfig();
      if (!$scope.data.ocultaExportarList)
        $scope.ixDownloadExcelListado = $scope.data.grid.ixDownloadExcel;
    }

    //Fins aqui anirà fora.
    $scope.addNewItem = function(f) {
      var newItem = (typeof(f.onNew) == "function") ? f.onNew() : { "isNew": true };
      $scope.data.list.push(newItem);
      $scope.current = newItem;
      ixStatusService.setEditing(true);
    }


    if(angular.isDefined($routeParams.readOnly) && $routeParams.readOnly == true){
      $scope.readOnly = true;
      $scope.ixEditar = undefined;
      $scope.ixCancelEdit = undefined;
      $scope.addNewItem = undefined;
    }

    $scope.applyFilter = function() {
      $scope.actualizarListado(true);
    };

    $scope.selectItem = function(item) {
      if(!ixStatusService.current.editing && !ixStatusService.current.filtered || $scope.changeWhileEditing){  // FT: $scope.changeWhileEditing
				if(item.isNew) delete item.isNew;
        $scope.current = angular.merge($scope.current, item);
        //$scope.currentItemObj = item;
      }
    };
    $scope.accion = function(entity){
      if(!$scope.status.editing){
        if(entity.isNew) delete entity.isNew;
        $scope.current = angular.merge($scope.current, entity);
        //ixStatusService.setEditing(true);
      }
    };

    $scope.cargarGrid = function(){
      $scope.tipoBusqueda = $scope.buscar ? $scope.buscar : ($scope.data.tabla ? $scope.data.tabla : $scope.entity);
      if($scope.data.listpk) {
        $scope.data.grid = gridService.createGrid($scope, "Mant_"+$scope.entity+"Grid", { minWidth: 75, minRowsToShow: 5, enableCellEdit: false, enableFiltering: true, showOnlyDescribedCols: $scope.showOnlyDescribedCols, loadItemWhenSelect: true }, ($scope.metadataFrom ? $scope.metadataFrom : "gp4_listado_"+$scope.tipoBusqueda+"VM"), ($scope.setAcciones ? $scope.setAcciones() : null));
        //TODO: Este if se borrará, al final todos irán por la entity y se pasará un parámetro listado (operaciones/listado... , orides/listado...).
        if($scope.entity == "operaciones"){
          $scope.data.grid.entity = $scope.entity;
          $scope.data.grid.listado = "listado_" + $scope.entity;
        } else if($scope.entity == "zcp"){
          $scope.data.grid.entity = "listado_campas";
        } else {
          if(!$scope.data.useModel){
            $scope.data.grid.entity = "listado_" + $scope.entity;
          } else {
            $scope.data.grid.entity = $scope.tipoBusqueda;
						if(angular.isDefined($scope.data.filtrosExtra))
							$scope.data.grid.filtroExterno = $scope.data.filtrosExtra;
          }
        }
      } else {
        $scope.data.grid = gridService.createGrid($scope, "Mant_"+$scope.entity+"Grid",  { minWidth: 75, minRowsToShow: 5, enableCellEdit: true, enableFiltering: true, loadItemWhenSelect: true }, ($scope.metadataFrom ? $scope.metadataFrom : $scope.tipoBusqueda), ($scope.setAcciones ? $scope.setAcciones() : null));
				if(angular.isDefined($scope.metadataFrom) && $scope.metadataFrom != $scope.tipoBusqueda)
					$scope.data.grid.entity = $scope.tipoBusqueda;

        $scope.data.grid.filtroExterno = $scope.filters[0].search.Filters;
      }
      $scope.filters[0].isOpen=true;
      $scope.ixDownloadExcelListado = $scope.data.grid.ixDownloadExcel;
    };

		$scope.buildParamsWithSeparator = function(search, field, skip){
			var param = [];
			if(search != ""){
				var parts_search = search.split("&&");
				for(var i = 0; i < parts_search.length; i++){
					var ixFilterItem = { Field: field, Operator: CMP_LIKE, Value: parts_search[i] };
					if(i == 0){
						ixFilterItem.StartPar = true;
            if($scope.hayFiltros)
              $scope.hayFiltros = false;
            else
						  ixFilterItem.Or = true;
					}
					if(i == (parts_search.length - 1))
						ixFilterItem.EndPar = true;

					if(skip)
						ixFilterItem.Skip = true;

					param.push(ixFilterItem);
				}
			}
			return param;
		};

    $scope.actualizarListado = function(forzarActualizacion){
      var listado = "";
      $scope.tipoBusqueda = $scope.buscar ? $scope.buscar : ($scope.data.tabla ? $scope.data.tabla : $scope.entity);
      //TODO: Al final tots anirán per entitat/listado/...
      if($scope.entity == "operaciones") listado = $scope.data.listpk ? $scope.entity + "/listado_" : "";
      else listado = $scope.data.listpk && !$scope.data.useModel ? "/listado_" : "";

      if(lastBusqueda !== $scope.data.busqueda || forzarActualizacion){
        $scope.data.list = [];
        $scope.data.loaded = false;
        if(timer){ $timeout.cancel(timer); }
        timer = $timeout(function(){
            var params = {Filters: ($scope.data.filtrosExtra ? angular.copy($scope.data.filtrosExtra) : []), OrderBy: []};
            params.Filters = angular.merge(params.Filters, $scope.filters[0].search.Filters);//En cas de que hi hagi algun parametre obligatori per separat.
            if(params.Filters.length > 0)
              $scope.hayFiltros = true;

            if($scope.data.busqueda && $scope.data.busqueda != ""){
              //Si el search es fa contra la API executant una query passarem un sol Field busqueda.
              if($scope.data.listpk && !$scope.data.useModel){
                //params.Filters.push({Field : "busqueda", Value : $scope.data.busqueda, Operator : CMP_LIKE, Skip: true});
                params.Filters.push.apply(params.Filters, $scope.buildParamsWithSeparator($scope.data.busqueda, "busqueda", true));

              } else {
                //Si fa el search contra un objecte PetaPoco passarem alguna cosa més.

                //TODO: Tots es montaran a partir d'un array de camps a buscar entre parentesis i OR's.
                //El useModel només existirà mentre no s'hagi fet a tots.
                if(!$scope.data.useModel){
									if($scope.data.pk){
//										var filter = { Field : $scope.data.pk, Value : $scope.data.busqueda, Operator : CMP_LIKE };
//										if($scope.data.list[0] && ($scope.data.list[0].nombre || $scope.data.list[0].descripcion)){
//											filter["StartPar"] = true;
//										}
//										params.Filters.push(filter);
										params.Filters.push.apply(params.Filters, $scope.buildParamsWithSeparator($scope.data.busqueda, $scope.data.pk));
									}
                  if($scope.data.list[0] && $scope.data.list[0].nombre){
//                    params.Filters.push({Or: true, Field : "nombre", Value : $scope.data.busqueda, Operator : CMP_LIKE, EndPar: true});
                    params.Filters.push.apply(params.Filters, $scope.buildParamsWithSeparator($scope.data.busqueda, "nombre"));
                  } else if($scope.data.list[0] && $scope.data.list[0].descripcion){
//                    params.Filters.push({Or: true, Field : "descripcion", Value : $scope.data.busqueda, Operator : CMP_LIKE, EndPar: true});
                    params.Filters.push.apply(params.Filters, $scope.buildParamsWithSeparator($scope.data.busqueda, "descripcion"));
                  }
                }
              }

							angular.forEach($scope.data.fieldsToFilter, function(field, idx){
                var new_params = $scope.buildParamsWithSeparator($scope.data.busqueda, field);
                //if(idx == 0 && $scope.data.fieldsToFilter.length > 0)
                  //new_params[0].Or = false;
								params.Filters.push.apply(params.Filters, new_params);
							});

            }
            if(angular.isDefined($scope.data.fieldsToOrderBy)){
              $scope.data.fieldsToOrderBy.forEach(function(fieldToOrderBy){
                params.OrderBy.push(fieldToOrderBy);
              });
            }
            $http.post(cfg.baseURL + listado + $scope.tipoBusqueda + "/Search?Page=1&ItemsPerPage=200", params).then(function(response){

              $timeout(function(){
                $scope.data.list = response.data.Items;
                $scope.data.loaded = true;
              },1);
            }, function(error){
              ixStatusService.setResponse(error);
            });
        },350);
      }
      lastBusqueda = $scope.data.busqueda;
    };

		$scope.fullScreen = function(to_fullscreen){
			$scope.data.fullScreen = to_fullscreen;
		};
  }

}]);

angular.module('gp4App').controller('GridUsuariosGruposController', ['$scope', '$timeout', 'cfg', '$uibModal', 'gridService', 'uiGridEditConstants', 'ixStatusService', '$http', '$filter', 'uiGridConstants', function($scope, $timeout, cfg, $uibModal, gridService, uiGridEditConstants, ixStatusService, $http, $filter, uiGridConstants){

  $scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

  $scope.grid = gridService.createGrid($scope, "admin_usuarios_api_gruposusuarioGrid",  { showOnlyDescribedCols: [ 'grupo' ]}, "api_gruposusuario");

  $scope.ixEditar = $scope.grid.ixEditar;
  $scope.ixCancelEdit = $scope.grid.ixCancelEdit;
  $scope.ixAddRow = $scope.grid.ixAddRow;
  $scope.ixDeleteSelectedRows = $scope.grid.ixDeleteSelectedRows;
  $timeout(function(){
    $scope.numberOfChanges = $scope.grid.numberOfChanges;
  });
  $scope.updateIxGuardarTooltip = $scope.grid.updateIxGuardarTooltip;

  //Buscar només tot el que estigui relacionat amb l'usuari.
  $scope.grid.filtroExterno = {usuario:$scope.$parent.$parent.$parent.row.entity.usuario};

  $scope.grid.ixCheckErrors = function(){
    //No comprova res.
    return true;
  };
  
  $scope.grid.ixLoadInitialData = function(){
    $scope.grid.ixIsLoading = true;
    $http.get(cfg.baseURL + $scope.grid.entity + '/GetByUsuario?usuario='+$scope.grid.filtroExterno.usuario).then(function (response) {
      //Per a cada crida s'actualitzarà la data d'informació generada.
      //$scope.grid.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
      $scope.data.ixProgress = 0;
      $scope.grid.data = response.data;    
      $scope.data.ixProgress = 100;
      $scope.grid.ixIsLoading = false;
      $timeout(function () {
        delete $scope.data.ixProgress;
      }, 500);
    }, function (response) {
      $scope.grid.ixIsLoading = false;
      ixStatusService.setResponse(response);
    });
  };
  
  $scope.save = function(){
    var bulkParam  = $scope.grid.ixGetBulkParam();
        
    $http.patch(cfg.baseURL + $scope.grid.entity + '/UpdateBulkCustom', bulkParam).then(function (response) {
      if (response.data.Result) {
        ixStatusService.setResponse(response);
        $scope.grid.deletedRows = [];
        $scope.grid.insertedRows = [];

        var dataRows = $scope.grid.gridApi.rowEdit.getDirtyRows().map( function( gridRow ) { return gridRow.entity; });
        $scope.grid.gridApi.rowEdit.setRowsClean( dataRows );

        ixStatusService.setEditing(false);

        // Rehabilitar ordenacion al finalizar la edición
        $scope.grid.enableSorting = true;
        $scope.grid.gridApi.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);

        $scope.grid.ixLoadInitialData();
      } else {
        ixStatusService.setResponse(response);
      }
    }, function (response) {
      $scope.grid.insertedRows.forEach(function(e){e.isNew=true;});
      ixStatusService.setResponse(response);
    });
  };
}]);

angular.module('gp4App').controller('GridUsuariosEtiquetasController', ['$scope', '$timeout', 'cfg', '$uibModal', 'gridService', 'uiGridEditConstants', 'ixStatusService', function($scope, $timeout, cfg, $uibModal, gridService, uiGridEditConstants, ixStatusService){

  $scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

  $scope.grid = gridService.createGrid($scope, "admin_usuarios_etiquetasGrid",  { showOnlyDescribedCols: [ 'etiqueta', 'valor', 'descripcion' ] }, "configuraciones");

  $scope.ixEditar = $scope.grid.ixEditar;
  $scope.ixCancelEdit = $scope.grid.ixCancelEdit;
  $timeout(function(){
    $scope.numberOfChanges = $scope.grid.numberOfChanges;
  });
  $scope.updateIxGuardarTooltip = $scope.grid.updateIxGuardarTooltip;
  $scope.save = $scope.grid.ixGuardar;

  //Buscar només tot el que estigui relacionat amb l'usuari.
  $scope.grid.filtroExterno = {usuario:$scope.$parent.$parent.$parent.row.entity.usuario == undefined ? $scope.$parent.$parent.$parent.row.entity.operario : $scope.$parent.$parent.$parent.row.entity.usuario};

  $scope.grid.ixCheckErrors = function(){
    //No comprova res.
    return true;
  };
}]);

angular.module('gp4App').controller('GridUsuariosMegawhereController', ['$scope', '$timeout', 'cfg', '$uibModal', 'gridService', 'uiGridEditConstants', 'ixStatusService', function($scope, $timeout, cfg, $uibModal, gridService, uiGridEditConstants, ixStatusService){

  $scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

  //$scope.openWindow = function(size){
  //if(ixStatusService.current.editing){
	
		//var metadata = [{ Name: "cliente", skipTableNameForDropdown: true },
		//							  { Name: "centro", skipTableNameForDropdown: true }];

    $scope.gridmegawhere = gridService.createGrid($scope, "extranet_condition_userGrid",  { skipTableName: true/*, metadata: metadata*/ }, "extranet_condition_user");

    $scope.gridmegawhere.entity = "extranet_condition_user";

    $scope.ixEditar = $scope.gridmegawhere.ixEditar;
    $scope.ixCancelEdit = $scope.gridmegawhere.ixCancelEdit;
    $scope.ixAddRow = $scope.gridmegawhere.ixAddRow;
    $scope.ixDeleteSelectedRows = $scope.gridmegawhere.ixDeleteSelectedRows;
    //$scope.ixDownloadExcel = $scope.gridmegawhere.ixDownloadExcel;
    $timeout(function(){
      $scope.numberOfChanges = $scope.gridmegawhere.numberOfChanges;
    });
    $scope.updateIxGuardarTooltip = $scope.gridmegawhere.updateIxGuardarTooltip;
    $scope.save = $scope.gridmegawhere.ixGuardar;

    //Buscar només tot el que estigui relacionat amb l'usuari.
    $scope.gridmegawhere.filtroExterno = {username:$scope.$parent.$parent.$parent.row.entity.usuario};

    $scope.gridmegawhere.ixCheckErrors = function(){
      //No comprova res.
      return true;
    };
  //}
  //};
}]);

/*global buildIxSearch*/
/*global CMP_EQ*/
angular.module('gp4App').controller("GridUsuariosController", ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', "ixUtilsService", function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService, ixUtilsService) {
  $scope.status = ixStatusService.current;
  $scope.init = function(){
    $scope.data = ixStatusService.current.data;
    $scope.entity = "api_usuarios";

    if(!$scope.data.filtro) {
      $scope.data.filtro = {client_id:cfg.clientId}
      if(cfg.clientId == ""){
        $scope.data.filtro.client_id = "Intranet";
      }
    }

    $scope.showClient = (authService.tienePerfilAdmin() || authService.tienePerfilUserKey());


    var gridName = $scope.entity + "Grid";

    $scope.compruebaCaracteresProhibidos = function(entity, column, newValue, oldValue){
      if(column.field.toUpperCase() == "USUARIO" && newValue != oldValue){
        //Lista de carácteres prohibidos: no permita espacios, ni “–“,”/*”,”*/”,”;”, “//”)
        var ESPACIO = /(\s)/gm;
        var DOBLE_GUION = /(--)/gm;
        var BARRA_ASTERISCO = /(\/\*)/gm;
        var ASTERISCO_BARRA = /(\*\/)/gm;
        var PUNTO_COMA = /(;)/gm;
        var DOBLE_BARRA = /(\/\/)/gm;
        
        if(ESPACIO.test(newValue)){
          newValue = newValue.replace(ESPACIO, "");
        }
        if(DOBLE_GUION.test(newValue)){
          newValue = newValue.replace(DOBLE_GUION, "");
        }
        if(BARRA_ASTERISCO.test(newValue)){
          newValue = newValue.replace(BARRA_ASTERISCO, "");
        }
        if(ASTERISCO_BARRA.test(newValue)){
          newValue = newValue.replace(ASTERISCO_BARRA, "");
        }
        if(PUNTO_COMA.test(newValue)){
          newValue = newValue.replace(PUNTO_COMA, "");
        }
        if(DOBLE_BARRA.test(newValue)){
          newValue = newValue.replace(DOBLE_BARRA, "");
        }
        entity.usuario = newValue;
      }
    };

    $scope.carregaGrid = function(){
      //
      var metadata = [
        {
          Name: "client_id",
          overridePreloadedOptions: true,
          busquedaFunction:function(column){
            return $http.post(cfg.baseURL + "api_client/Search", { id: $scope.data.filtro.client_id }).then(function(response){
              if(response.data != null){
                column.options = response.data.map(function(e){ return { client_id: e.id, id: e.id }; });
                return column.options;
              }
              column.options = [];
              return column.options;
            }, function(err){
              ixStatusService.setResponse(err);
              return [];
            });

          }
        }
      ];
      var acciones = [
        {
          icon: "fa-window-maximize",
          title: "Condiciones",
          template: "app/base/views/gridUsuarios_megawhere.html",
          visible: function(entity){
            //return !entity.isNew && ($scope.data.filtro.client_id.toUpperCase() == "EXTRANET" || $scope.data.filtro.client_id.toUpperCase() == "GPV4MOBILE" || $scope.data.filtro.client_id.toUpperCase() == "GPV4MOBILE3CHECK" || $scope.data.filtro.client_id.toUpperCase() == "GPV4TRANSPORTISTAS");
            return !entity.isNew && ($scope.data.filtro.client_id.toUpperCase() != "INTRANET" || $scope.data.filtro.client_id.toUpperCase() != "INTRANET");
          }
        },
        {
          icon: "fa-group",
          title: "Grupos",
          template: "app/base/views/gridUsuarios_grupos.html",
          visible: function(entity){
            return !entity.isNew && ($scope.data.filtro.client_id.toUpperCase() == "GPV4" || $scope.data.filtro.client_id.toUpperCase() == "GPV4MOBILECAMPA" || $scope.data.filtro.client_id.toUpperCase() == "GESTPARK-INTRANET");
          }
        },
        /*{
          icon: "fa-envelope",
          title: "Mails",
          template: "app/base/views/gridUsuarios_mails.html",
          visible: function(entity){
            return !entity.isNew && ($scope.data.filtro.client_id.toUpperCase() == "EXTRANET" || $scope.data.filtro.client_id.toUpperCase() == "GESTPARK-INTERNET");
          }
        },
        {
          icon: "fa-th",
          title: "Campas",
          template: "app/base/views/gridUsuarios_campas.html",
          visible: function(entity){
            return !entity.isNew && ($scope.data.filtro.client_id.toUpperCase() == "EXTRANET" || $scope.data.filtro.client_id.toUpperCase() == "GESTPARK-INTERNET");
          }
        },*/
        {
          icon: "fa-cog",
          title: "Etiquetas",
          template: "app/base/views/gridUsuarios_etiquetas.html",
          visible: function(entity){
            return !entity.isNew;
          }
        },
        {
          icon: "fa-qrcode",
          title: "Generar nuevo QR - 2FA",
          visible: function(entity){
            return !entity.isNew && entity.two_factor_auth_enabled && entity.email.length > 0 && 
            ($scope.data.filtro.client_id.toUpperCase() == "INTRANET" || $scope.data.filtro.client_id.toUpperCase() == "EXTRANET");
          },
          accion: function(entity){
            //call API to generate and send QR to mail
            $http.post(cfg.baseURL + $scope.entity + "/Generate2FaQr", entity).then(function(response){
              ixStatusService.setResponse(response);
            }, function(err){
              ixStatusService.setResponse(err);
            });
          }
        } 
      ];
      if(!$scope.data.grid){
        $scope.data.grid = gridService.createGrid($scope, $scope.entity + "Grid", { metadata: metadata, onCellEdit: $scope.compruebaCaracteresProhibidos }, $scope.entity, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);
        $scope.data.grid.entity = $scope.entity;
        $scope.data.grid.filtroExterno = $scope.data.filtro;
        //$scope.data.grid.ixLoadInitialData();
      } else {
        $scope.data.grid = gridService.createGridFunctions($scope, $scope.data.grid);
        $scope.data.grid.ixRestoreConfig();
      }
    };

    $scope.carregaGrid();

    $scope.ixEditar = $scope.data.grid.ixEditar;
    $scope.ixCancelEdit = $scope.data.grid.ixCancelEdit;
    $scope.ixAddRow = function(){
      var newItem = {};
      newItem.idioma = cfg.defaultLanguage || "es";
      $scope.data.grid.ixAddRow(newItem);
    }
    $scope.ixDeleteSelectedRows = $scope.data.grid.ixDeleteSelectedRows;
    $scope.ixDownloadExcel = $scope.data.grid.ixDownloadExcel;
    $scope.numberOfChanges = $scope.data.grid.numberOfChanges;
    $scope.updateIxGuardarTooltip = $scope.data.grid.updateIxGuardarTooltip;
    $scope.addIncidencia = $scope.data.grid.addIncidencia;
    $scope.ixGuardar = $scope.data.grid.ixGuardar;
    //$scope.ixLoadInitialData = $scope.grid.ixLoadInitialData($scope.grid, gridName);


    $scope.$on("$destroy", function() {
      delete($scope.delayedActions);
      $scope.isDestroyed=true;
    });


    /**
     * Construye un objeto PK para enviar a la API
     * Si la entity es barco, devuelve  {barco: 123}
     */
    $scope.buildPK = function (item) {
      return $scope.data.grid.buildPK(item);
    };

    $scope.loadClients = function(){
      var param = cfg.clientId;
      if(cfg.clientId == "Intranet"){
        param = "";
      }
      return $http.post(cfg.baseURL + "api_client/Search", { id: param });
    };

    $scope.$watch('data.filtro.client_id', function(nuevo, anterior){
      if(nuevo !== anterior){
        $scope.carregaGrid();
        $scope.data.grid.ixLoadInitialData();
      }
    });

    /*$scope.$watch('status.response', function(nuevo, anterior){
      if(nuevo !== anterior){
        $timeout(function(){
          delete $scope.status.response;
        }, 2000);
      }
    });*/
  }
}]);

/*jslint browser: true, devel: true, white: true, plusplus: true, vars: true*/
/*global CMP_EQ*/
"use strict";
angular.module('gp4Controllers').controller('GridTraduccionesController', ['$scope', '$controller', '$log', function ($scope, $controller, $log) {
  $controller('GridEditorController', {$scope: $scope});
  $scope.executeAfterInit = function(){
    $scope.ixAddRow = undefined;
    $scope.ixDeleteSelectedRows = undefined;
  };
}]);

/*jslint browser: true, devel: true, white: true, plusplus: true, node: true*/
/*eslint angular/di: [2,"array"]*/
/*global convertDateStringsToDates */
/*global parseObjectsToString */
/*global ixGridColumnFilter */
/*global ixGridColumnFilterCondition*/
/*global ixNewDate*/
/*global CMP_EQ*/
angular.module("gp4App").controller('GridEditorController', ['$scope', '$controller', '$http', '$timeout', 'cfg', 'uiGridConstants', 'uiGridEditConstants', '$routeParams', 'authService', 'gridService', 'ixStatusService', '$log', '$translate', 'ixCestaVehiculosService', function ($scope, $controller, $http, $timeout, cfg, uiGridConstants, uiGridEditConstants, $routeParams, authService, gridService, ixStatusService,$log,$translate, ixCestaVehiculosService) {
  $scope.status = ixStatusService.current;
  $scope.data = ixStatusService.current.data;
  $scope.init = function(){
    $scope.entity = angular.isUndefined($scope.entity) ? $routeParams.entity : $scope.entity;

		if(angular.isDefined($scope.nombreCesta))
			ixCestaVehiculosService.init($scope.nombreCesta);

    if(!$scope.data.grid) {
      var gridOptions = angular.merge({
        enableHorizontalScrollbar: 2,
        enableFiltering: true
      }, $scope.gridOptions);

      if(angular.isUndefined($scope.nombreConfigListado)){
        $scope.nombreConfigListado = $scope.entity + "Grid";
      }

      $scope.gridExtraColumns = (!$scope.acciones ? [] : [{ name: 'Acciones', type: 'detalle', acciones: $scope.acciones }]);
			if(angular.isDefined($scope.extraActions))
				$scope.gridExtraColumns.push.apply($scope.gridExtraColumns, $scope.extraActions);

      $scope.data.grid = gridService.createGrid($scope, $scope.nombreConfigListado, gridOptions, $scope.entity, $scope.gridExtraColumns);
      $scope.data.grid.entity = $scope.routeEntity ? $scope.routeEntity : $scope.entity;
			//Incluir params de cesta:
			if(angular.isDefined($scope.nombreCesta))
      	$scope.data.grid.incloureCesta = true;
			if(angular.isDefined($scope.filtroExterno))
				$scope.data.grid.filtroExterno = $scope.filtroExterno;
    } else{
      $scope.data.grid = gridService.createGridFunctions($scope, $scope.data.grid);
      $scope.data.grid.ixRestoreConfig();
    }

    $scope.ixEditar = $scope.data.grid.ixEditar;
    $scope.ixCancelEdit = angular.isUndefined($scope.ixCancelEdit) ? $scope.data.grid.ixCancelEdit : $scope.ixCancelEdit;
    $scope.ixAddRow = angular.isUndefined($scope.ixAddRow) ? $scope.data.grid.ixAddRow : $scope.ixAddRow;//en cas de que definim un ixAddRow a un controller que hereda d'aquest.
    $scope.ixDeleteSelectedRows = $scope.data.grid.ixDeleteSelectedRows;
    $scope.ixDownloadExcel = $scope.data.grid.ixDownloadExcel;
    $scope.numberOfChanges = angular.isUndefined($scope.numberOfChanges) ? $scope.data.grid.numberOfChanges : $scope.numberOfChanges;//podem sobreescriure la funció.
    $scope.updateIxGuardarTooltip = $scope.data.grid.updateIxGuardarTooltip;
    $scope.ixGuardar = angular.isUndefined($scope.ixGuardar) ? $scope.data.grid.ixGuardar : $scope.ixGuardar;//en cas de que definim un ixGuardar a un controller que hereda d'aquest.

    $scope.$on("$destroy", function() {
			if(ixCestaVehiculosService && angular.isDefined($scope.nombreCesta)){
        ixCestaVehiculosService.setShowing(false);
      }
      $scope.data.grid.ixSaveConfig();
      $scope.isDestroyed=true;
    });

    /**
     * Construye un objeto PK para enviar a la API
     * Si la entity es barco, devuelve  {barco: 123}
     */
    $scope.buildPK = function (item) {
      return gridService.buildPK($scope, item);
    };
    //Si tenim algún controller que heredi d'aquest i volem executar codi després de que s'executi l'init, l'haurem de possar dintre d'una funció que es digui executeAfterInit.
    if(angular.isDefined($scope.executeAfterInit)){
      $scope.executeAfterInit();
    }
  }
}]);



/**
 * proporciona metode per notificar la fi de edició de la cell
 */
angular.module("gp4App").directive('ixUiGridSelectEditor', ['gridUtil', 'uiGridConstants', 'uiGridEditConstants', '$timeout', 'uiGridEditService', '$animate', function (gridUtil, uiGridConstants, uiGridEditConstants, $timeout, uiGridEditService, $animate) {
	return {
		require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel', 'uiSelect'],
		link: function (scope, elm, attrs, controllers) {
      var uiGridCtrl, renderContainerCtrl, ngModelController;
      if (controllers[0]) { uiGridCtrl = controllers[0]; }
      if (controllers[1]) { renderContainerCtrl = controllers[1]; }
      if (controllers[2]) { ngModelController = controllers[2]; }

			var uiSelect = controllers[3];

      //Deshabilitem el animate, l'activem dintre del timeout. Si no ho fem l'animació de transició entre pantalles deixarà de funcionar.
      $animate.enabled(false, elm);

      //Treiem el activate i focus del timeout. Dintre del timeout calculem el top.
      uiSelect.activate();
      uiSelect.focusSearchInput();
			$timeout(function() {//Al possar el uiSelect.activate fora del timeout visualment és més ràpid, però el top no es calcula bé. El calculem dintre.
        var wrongTop = elm.css("top");
        wrongTop = parseInt(wrongTop);
        var calculatedTop = wrongTop + 39;

        elm.css("top", calculatedTop+"px");

        angular.element(uiSelect.searchInput[0]).bind('blur',function(e){
          if(e.relatedTarget) {
            if(!e.relatedTarget.closest(".ui-select-dropdown")) {
              // Blur hacia fuera del dropdown. cerramos cellEditor
              scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            } else {
              // Blur hacia dentro del dropdown: devolvemos focus al searchinput
              $timeout(function(){
                uiSelect.focusSearchInput();
              });
            }
          }
        });
        $animate.enabled(true, elm);
			},1);

      angular.element(uiSelect.searchInput[0]).on('keydown', function (evt) {
        switch (evt.keyCode) {
          case uiGridConstants.keymap.ESC:
            evt.stopPropagation();
            scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            break;
        }

        if (evt.keyCode === uiGridConstants.keymap.UP ||
           evt.keyCode === uiGridConstants.keymap.DOWN){
          evt.stopPropagation();
        }
        // Pass the keydown event off to the cellNav service, if it exists
        else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
          evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
          if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
            scope.stopEdit(evt);
          }
        }
        else {
          //handle enter and tab for editing not using cellNav
          switch (evt.keyCode) {
            case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
            case uiGridConstants.keymap.TAB:
              evt.stopPropagation();
              evt.preventDefault();
              scope.stopEdit(evt);
              break;
          }
        }

        return true;
      });


      scope.stopEdit = function (evt) {
        /*if (scope.inputForm && !scope.inputForm.$valid) {
          evt.stopPropagation();
          scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
        }
        else {
          scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
        }
        scope.deepEdit = false;*/
        evt.stopPropagation();
        scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
      };
      //

			//Possem sempre un z-index superior als modals, això té utilitat quan hi ha una grid a un popup, per exemple, al llistat d'usuaris.
			//TODO: Mirar d'aplicar només el z-index en aquells casos que el ix-ui-grid-select-editor es trobi dins d'un popup.
			elm.css("z-index", "1051");
		}
	};
}]);

/**
 * proporciona metode per notificar la fi de edició de la cell
 */
angular.module("gp4App").directive('ixUiGridSelectEditor2', ['gridUtil', 'uiGridConstants', 'uiGridEditConstants', '$timeout', 'uiGridEditService', '$animate', 'ixStatusService', function (gridUtil, uiGridConstants, uiGridEditConstants, $timeout, uiGridEditService, $animate, ixStatusService) {
	return {
		restrict: 'A',
		scope: false,
		require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
		link: function (scope, elm, attrs, controllers) {
      var uiGridCtrl, renderContainerCtrl, ngModelController;
      if (controllers[0]) { uiGridCtrl = controllers[0]; }
      if (controllers[1]) { renderContainerCtrl = controllers[1]; }
      if (controllers[2]) { ngModelController = controllers[2]; }

			var input = angular.element(elm.find('input')[0]);
			var TAB_KEY = 9;
			var INTRO_KEY = 13;
			var LEFT_KEY = 37;
			var UP_KEY = 38;
			var RIGHT_KEY = 39;
			var DOWN_KEY = 40;
			

			//la llibrería angular-ui-grid es la que s'encarrega de canviar el valor a la propietat focused.
			scope.$watch('focused', function(newVal, oldVal){
				if(newVal){
					//$timeout(function(){
					//console.log("focused");
						input.focus();
						input.select();						
					//},0);
				}
			});
			
			input.on('blur', function (evt) {
				if(!scope.focused)
				{
					//console.log("blur: NO focused");
					//scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
					//input.off();
				}
				else if(angular.element(evt.relatedTarget).hasClass("ui-grid-focuser")) {
					//console.log("blur: focused");
					input.focus();
					input.select();
				}
			});			

			scope.$on('raiseAfterCellEdit', function(event, data){
				uiGridCtrl.grid.api.edit.raise.afterCellEdit(scope.row.entity, scope.col.colDef, data.newVal, data.oldVal);
			});

			scope.$on('refreshCellFocus', function(event){
				scope.stopEdit(event);
			});
			scope.stopEdit = function (evt) {
        scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
      };

			input.on('keydown', function(evt) {
				if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
					evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
					if(evt.keyCode == INTRO_KEY || evt.keyCode == TAB_KEY || evt.keyCode == LEFT_KEY || evt.keyCode == RIGHT_KEY){
						if(evt.keyCode == INTRO_KEY || evt.keyCode == TAB_KEY)							
							ixStatusService.current.ixCellNav = true;
						if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
							scope.stopEdit(evt);
						}
					}
					else {
						ixStatusService.current.ixCellNav = false;
					}
				}
				return true;
			});
		}
	};
}]);

angular.module("gp4App").directive('ixGridTimeEditor', [ 'gridUtil', 'uiGridConstants', 'uiGridEditConstants', 'uiGridEditService', '$log', '$filter', '$timeout', function(gridUtil, uiGridConstants, uiGridEditConstants, uiGridEditService, $log, $filter, $timeout) {
  return {
    restrict: 'EA',
    //require: '?ngModel',
                               require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
    scope: {
      ngModel: '=',
      name: '@'
    },
    //template: '<input time="text" ui-grid-editor class="form-control" ng-model="ngModel" ui-mask="99:99" model-view-value="true" ui-validate="\'validateTIME($value)\'" />',
    //template: '<input time="text" ui-grid-editor class="form-control" ng-model="ngModel" />'/*,
    //template: '<input type="text" ui-grid-editor class="form-control" ng-model="ngModel" />'/*,
    //template: '<input type="text" ui-grid-editor ng-model="MODEL_COL_FIELD" class="form-control" />'/*,
    //template: '<div><form name="test"><input type="text" ui-grid-editor ng-model="MODEL_COL_FIELD"></form></div>'/*,
    //link: function(scope, elem, attrs, ngModelController) {
    link: function(scope, elem, attrs, controllers) {
                                               var uiGridCtrl, renderContainerCtrl, ngModelController;
                                               if (controllers[0]) { uiGridCtrl = controllers[0]; }
                                               if (controllers[1]) { renderContainerCtrl = controllers[1]; }
                                               if (controllers[2]) { ngModelController = controllers[2]; }
                                               
      var input = elem;
                                               $timeout(function(){
                                                               input.focus();
                                               });
      
                                               input.on('keypress', function(e){
                                                               var keyCode = (e.which||e.charCode||e.keyCode);
                                                               if("0123456789:. '+".indexOf(String.fromCharCode(keyCode))>=0  ||  // Allow: numbers and valid separators
                                                                                              [8,9,13,27,46].indexOf(keyCode)>=0 ||  // Allow: backspace, tab, enter, escape, delete
                                                                                              ([65,67,86,88,90].indexOf(keyCode)  && ( e.ctrlKey === true || e.metaKey === true ) ) ||  // Allow: Ctrl+A, Command+A, ctrl+C,ctrl+X,ctrl+V, ctrl+Z
                                                                                              (keyCode >= 35 && keyCode <= 40) // Allow: home, end, left, right, down, up
                                                               ) {
                                                                               return true;
                                                               } else {
                                                                               e.preventDefault();
                                                                               return false;
                                                               }
                                               });
      input.on('blur', function(event){
        $log.log("blur");
        //scope.done = true;
        //scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
        //scope.$apply();
                                                               var newVal = event.target.value;
                                                               var dateParts = newVal.split(/[\:\.\- '\+]{1}/);

                                                               var now = ($filter("date")(new Date(), "H:mm:ss", null)).split(":");
                                                               var hours = now[0];
                                                               var minutes = now[1];              
                                                               var seconds = now[2];

                                                               /* INI introduccio sense separadors (. | + | -) */
                                                               if(dateParts.length==1) {
                                                                               if(dateParts[0].length==0) {
                                                                                              ngModelController.$setViewValue(null);
                                                                                              ngModelController.$render();
																							  if(scope.callStopEdit == undefined)
																								scope.stopEdit(event);
                                                                                              return;
                                                                               }
                                                                               var index = 2;
                                                                               hours = parseInt(dateParts[0].slice(0,2));                                                                                                                           
                                                                               if(hours>23) {                                                                                                                                  
                                                                                              hours = dateParts[0].slice(0,1);
                                                                                              index = 1;
                                                                               }
                                                                               if(dateParts[0].length>2) {                                                                                                                                        
                                                                                              minutes = dateParts[0].slice(index,index+2);
                                                                                              if(parseInt(minutes)>59)
                                                                                              {
                                                                                                              minutes = "0"+dateParts[0].slice(index,index+1);
                                                                                                              index = index + 1;
                                                                                              }
                                                                                              else {
                                                                                                              index = index + 2;
                                                                                              }
                                                                               }
                                                                               if(dateParts[0].length>4) {
                                                                                              //seconds = dateParts[0].slice(index,index+2);
                                                                                              seconds = parseInt(dateParts[0].slice(index,index+2)) < 9 ? "0"+parseInt(dateParts[0].slice(index,index+2)) : dateParts[0].slice(index,index+2);
                                                                               } else {
                                                                                              seconds = "00";
                                                                               }
                                                               }
                                                               /* FIN introduccio sense separadors (. | + | -) */

                                                               /* INI introduccio amb separadors (. | + | -) */
                                                               if(dateParts[0].length>0 && dateParts[0].length<=2) {
                                                                               hours = parseInt(dateParts[0]);
                                                               }
                                                               if(dateParts.length>1 && dateParts[1].length>0) {
                                                                               if(parseInt(dateParts[1]) < 9){
                                                                                              minutes = "0"+parseInt(dateParts[1]);
                                                                               } else if(parseInt(dateParts[1]) > 59){
                                                                                              minutes = "00";
                                                                               } else {
                                                                                              minutes = dateParts[1];
                                                                               }
                                                               }
                                                               if(dateParts.length>2 && dateParts[2].length>0) {
                                                                               if(parseInt(dateParts[2]) < 9){
                                                                                              seconds = "0"+parseInt(dateParts[2]);
                                                                               } else if(parseInt(dateParts[2]) > 59){
                                                                                              seconds = "00";
                                                                               } else {
                                                                                              seconds = dateParts[2];
                                                                               }
                                                               }
                                                               /* FIN introduccio amb separadors (. | + | -) */              

                                                               scope.ngModel = hours + ":" + minutes + ":" + seconds;
                                                               scope.validateTIME(scope.ngModel);
                                                               scope.$apply();
															   if(scope.callStopEdit == undefined)
																   scope.stopEdit(event);
      });

                                               /*
      input.on('keydown', function (evt) {
        switch (evt.keyCode) {
          case uiGridConstants.keymap.ESC:
            evt.stopPropagation();
            scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            break;
        }

        if (scope.deepEdit &&
          (evt.keyCode === uiGridConstants.keymap.LEFT ||
           evt.keyCode === uiGridConstants.keymap.RIGHT ||
           evt.keyCode === uiGridConstants.keymap.UP ||
           evt.keyCode === uiGridConstants.keymap.DOWN)) {
          evt.stopPropagation();
        }
        // Pass the keydown event off to the cellNav service, if it exists
        else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
          evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
          if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
            scope.stopEdit(evt);
          }
        }
        else {
          //handle enter and tab for editing not using cellNav
          switch (evt.keyCode) {
            case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
            case uiGridConstants.keymap.TAB:
              evt.stopPropagation();
              evt.preventDefault();
              scope.stopEdit(evt);
              break;
          }
        }

        return true;
      });
                                               */
                                               
                                               input.on('keydown', function (evt) {
                                                               switch (evt.keyCode) {
                                                                               case uiGridConstants.keymap.ESC:
                                                                                              evt.stopPropagation();
                                                                                              scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                                                                                              break;
                                                                               case 8://backspace
                                                                                              scope.changed = true;
                                                                                              break;
                                                                               case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
                                                                               case uiGridConstants.keymap.TAB:
																							  scope.calledStopEdit = true;
                                                                                              input.blur();
                                                                                              evt.stopPropagation();
                                                                                              evt.preventDefault();
                                                                                              uiGridCtrl.cellNav.handleKeyDown(evt);
                                                                                              scope.stopEdit(evt);																							  
                                                                                              break;
																			    default:																
																							  if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
																								scope.stopEdit(evt);
																							  }
																							  break;
                                                               }

                                                               if (scope.deepEdit &&
                                                                               (evt.keyCode === uiGridConstants.keymap.LEFT ||
                                                                               evt.keyCode === uiGridConstants.keymap.RIGHT ||
                                                                               evt.keyCode === uiGridConstants.keymap.UP ||
                                                                               evt.keyCode === uiGridConstants.keymap.DOWN)) {
                                                                               evt.stopPropagation();
                                                               }

                                                               return true;
                                               });
                                               
                                               scope.stopEdit = function (evt) {
                                                               if (scope.inputForm && !scope.inputForm.$valid) {
                                                                               evt.stopPropagation();
                                                                               scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                                                               }
                                                               else {
                                                                               scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
                                                               }
                                                               scope.deepEdit = false;
                                               };
                                               
                                                               
                                               scope.validateTIME = function(val){
                                                               //TODO: Fer que rebi per paràmetre si ha de ser en format hh:mm o hh:mm:ss.
                                                               //var regex = /([01]\d|2[0-3]):([0-5]\d):([0-5]\d)/;
                                                               var regex = /^(?:\d|[01]\d|2[0-3]):([0-5]\d):([0-5]\d)/;                                                                 
                                                               if(val && !regex.test(val)){
                                                                               ngModelController.$setViewValue(null);
                                                                               ngModelController.$render();
                                                               }
                                               };                            

      /*scope.validateTIME = function(value){
        $log.log("validateTIME");
        var regex = /([01]\d|2[0-3]):([0-5]\d):([0-5]\d)/;
        return !value || regex.test(value);
      }*/
    }
  }
}]);


angular.module("gp4App").directive('ixUiGridCheckbox', [ 'gridUtil', 'uiGridConstants', 'uiGridEditConstants', 'uiGridEditService', '$log', '$timeout', function(gridUtil, uiGridConstants, uiGridEditConstants, uiGridEditService, $log, $timeout) {
  return {
    restrict: 'EA',
    require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel' ],
		link: function (scope, elem, attrs, controllers) {
      var hasFocus = false;
      var uiGridCtrl, renderContainerCtrl, ngModelController;
      if (controllers[0]) { uiGridCtrl = controllers[0]; }
      if (controllers[1]) { renderContainerCtrl = controllers[1]; }
      if (controllers[2]) { ngModelController = controllers[2]; }      

			//la llibrería angular-ui-grid es la que s'encarrega de canviar el valor a la propietat focused.
			scope.$watch('focused', function(newVal, oldVal){
				if(newVal){
					$timeout(function(){
						elem.focus();
					});
				}
			});
      elem.on('keydown', function (evt) {
        switch (evt.keyCode) {
          case uiGridConstants.keymap.ESC:
            evt.stopPropagation();
            scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            break;
          case uiGridConstants.keymap.SPACE:
						elem.on('blur',function(){
							elem.focus();
							elem.off("blur");
						});
            break;
        }
		/*
        if (evt.keyCode === uiGridConstants.keymap.UP ||
           evt.keyCode === uiGridConstants.keymap.DOWN){
          evt.stopPropagation();
        }
		*/
        // Pass the keydown event off to the cellNav service, if it exists
        //else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
		if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
          evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
          if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
            scope.stopEdit(evt);
          }
        }
        else {
          //handle enter and tab for editing not using cellNav
          switch (evt.keyCode) {
            case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
            case uiGridConstants.keymap.TAB:
              evt.stopPropagation();
              evt.preventDefault();
              scope.stopEdit(evt);
              break;
          }
        }
        return true;
      });


			scope.checkboxClick = function(cell, col) {
				var noeditable = true;
				(typeof(cell.col.colDef.noeditable) == "function") ? noeditable = cell.col.colDef.noeditable(cell) : noeditable = cell.col.colDef.noeditable;
				if(!noeditable){
					var rowEntity = cell.row.entity;  //TODO: revisar el valor que s'enviara
					var oldVal = rowEntity[col.colDef.name];
					if(col.colDef.beforeClick){ col.colDef.beforeClick(cell, col); }
					if(col.colDef.type == "number"){
						//Si es de tipus numeric significa que a les metadates ve com a int, per tant, mantenim el tipus de la variable.
						if(typeof(rowEntity[col.colDef.name]) === "boolean"){
							(angular.isUndefined(rowEntity[col.colDef.name]) || rowEntity[col.colDef.name] === true) ? rowEntity[col.colDef.name] = 1 : rowEntity[col.colDef.name] = 0;
            } else if(angular.isString(rowEntity[col.colDef.name])){
              // BIOTECNAL: para FT puede llegar el valor como String
              (rowEntity[col.colDef.name].toUpperCase() === "TRUE" || rowEntity[col.colDef.name] == "1") ? rowEntity[col.colDef.name] = 0 : rowEntity[col.colDef.name] = 1;
						} else {
              // BIOTECNAL: para FT puede llegar el valor como null
							(angular.isUndefined(rowEntity[col.colDef.name]) || rowEntity[col.colDef.name] == null || rowEntity[col.colDef.name] === 0) ? rowEntity[col.colDef.name] = 1 : rowEntity[col.colDef.name] = 0;
						}
					} else {
						if(angular.isString(oldVal)){
							oldVal = (oldVal == "True") ? true : false;
							rowEntity[col.colDef.name] = (rowEntity[col.colDef.name] == "True") ? false : true;
						} else {
              oldVal = !oldVal;
              rowEntity[col.colDef.name] = ((rowEntity[col.colDef.name] === 1) ? false : rowEntity[col.colDef.name]);
						}            
					}
					var newVal = rowEntity[col.colDef.name];
					//Si es fa click a una columna extra tipus Sel, la linea no es marca com dirty.
					if(!cell.col.colDef.isExtraColumn)
						uiGridCtrl.grid.api.rowEdit.setRowsDirty([rowEntity]);


//					var focusedCell = uiGridCtrl.grid.api.cellNav.getFocusedCell();
//
//					if(!cell.col.colDef.ignoreCellModifications)
//						uiGridCtrl.grid.api.edit.raise.afterCellEdit(focusedCell.row.entity, focusedCell.col.colDef, newVal, oldVal);

					if(!cell.col.colDef.ignoreCellModifications)
						uiGridCtrl.grid.api.edit.raise.afterCellEdit(cell.row.entity, cell.col.colDef, newVal, oldVal);

          //AMP20240920: Després de pujar la versió de angular-ui-grid i debugar he vist que al arrivar aqui, si el valor de la propietat es 1, al cap de milisegons passa a "true".
          //Despres del timeout seguent, passo el true a 1, així no reventa l'API.
          $timeout(function(){
            if(typeof(rowEntity[col.colDef.name]) === "boolean"){
              rowEntity[col.colDef.name] === true ? rowEntity[col.colDef.name] = 1 : rowEntity[col.colDef.name] = 0;
            }
            
            if(col.colDef.afterClick){ col.colDef.afterClick(cell, col); }
            ngModelController.$modelValue = rowEntity[col.colDef.name]; // Arreglado el bug de los checkboxes en la ficha tecnica
          },1);
				}
			};
      scope.stopEdit = function (evt) {
        //evt.stopPropagation();
        scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
      };
    }
  }
}]);

//Fa el mateix que el ixDatepicker, amb l'afegit que canviar l'estil a position absolute quan el popup esta obert perque es vegi el calendari sencer i marca a dirtyRow la fila quan s'ha editat la cel·la.
angular.module("gp4App").directive('ixUiGridDateEditor', ['$filter', 'gridUtil', 'uiGridConstants', 'uiGridEditConstants', '$timeout', 'uiGridEditService', 'cfg', 'moment','ixStatusService', function ($filter, gridUtil, uiGridConstants, uiGridEditConstants, $timeout, uiGridEditService, cfg, moment, ixStatusService) {
	  return {
	      restrict: 'E',
	      require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
	      scope: {
	    		ngModel: '=',
					name: '@',
          dateLimit: '=?',
					initDate: '=?'
	      },
	      template: '<p class="input-group"><input type="text" style="background-color: white; width: 100%;" uib-datepicker-popup datepicker-timezone ng-model="ngModel" datepicker-append-to-body="true" datepicker-options="datePickerOptions" show-button-bar="false" is-open="isOpen" placeholder="DD/MM/YYYY" /><span class="input-group-btn"><span class="btn btn-default" ng-click="checkIsOpen()"><i class="glyphicon glyphicon-calendar"></i></span></span></p>',
	      link: function(scope, elem, attrs, controllers) {

          scope.datePickerOptions = {
            maxDate: scope.dateLimit,
            initDate: scope.initDate,
            dateDisabled: function(data){
              //return $filter("date")(data.date,"dd/MM/yyyy") == "23/06/2025";
            }
          }

          var uiGridCtrl, renderContainerCtrl, ngModelController;
          if (controllers[0]) { uiGridCtrl = controllers[0]; }
          if (controllers[1]) { renderContainerCtrl = controllers[1]; }
          if (controllers[2]) { ngModelController = controllers[2]; }

					if(angular.isDefined(uiGridCtrl.grid.api.ix.ixUiGridDateEditorInitDate)){
						scope.initDate = uiGridCtrl.grid.api.ix.ixUiGridDateEditorInitDate();
            scope.datePickerOptions.initDate = scope.initDate;
					}
	    	  var input = elem.children(0).children(0);

					input.on('focus', function(e){
						input.select();
					});

					input.on('keypress', function(e){
	    		  var keyCode = (e.which||e.charCode||e.keyCode);
	    		  if("0123456789/-. '+".indexOf(String.fromCharCode(keyCode))>=0  ||  // Allow: numbers and valid separators
	    				  [8,9,13,27,46].indexOf(keyCode)>=0 ||  // Allow: backspace, tab, enter, escape, delete
	    				  ([65,67,86,88,90].indexOf(keyCode)  && ( e.ctrlKey === true || e.metaKey === true ) ) ||  // Allow: Ctrl+A, Command+A, ctrl+C,ctrl+X,ctrl+V, ctrl+Z
	    				  (keyCode >= 35 && keyCode <= 40) // Allow: home, end, left, right, down, up
	    		  ) {
							scope.changed = true;
	    			  return true;
	    		  } else {
	    			  e.preventDefault();
	    			  return false;
	    		  }
	    	  });

          $timeout(function(){
            input.focus();
          });

          //
          input.on('keydown', function (evt) {
            switch (evt.keyCode) {
              case uiGridConstants.keymap.ESC:
                evt.stopPropagation();
                scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                break;
							case 8://backspace
								scope.changed = true;
								break;
							case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
							case uiGridConstants.keymap.TAB:
								input.blur();
								evt.stopPropagation();
								evt.preventDefault();
								uiGridCtrl.cellNav.handleKeyDown(evt);
								scope.stopEdit(evt);
								break;
							default:																
								if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
									scope.stopEdit(evt);
								}
								break;
            }			
			
/*
            if (scope.deepEdit &&
              (evt.keyCode === uiGridConstants.keymap.LEFT ||
               evt.keyCode === uiGridConstants.keymap.RIGHT ||
               evt.keyCode === uiGridConstants.keymap.UP ||
               evt.keyCode === uiGridConstants.keymap.DOWN)) {
              evt.stopPropagation();			  
            }	
*/
            return true;
          });


          scope.stopEdit = function (evt) {
            if (scope.inputForm && !scope.inputForm.$valid) {
              evt.stopPropagation();
              scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            }
            else {
              scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
            }
            scope.deepEdit = false;
          };
          //

	    	  input.on('blur',function(event){
	    		  var newVal = event.target.value;
						if(angular.isDefined(newVal)){


							var dateParts = newVal.split(/[\/\.\- '\+]{1}/);
							//var now = new Date();
							var now = ixNewDate(cfg, moment);

							var day = now.getDate();
							var month = now.getMonth() + 1;
							var year = now.getFullYear();

							if(dateParts.length==1) {
								if(dateParts[0].length==0) {
									ngModelController.$setViewValue(null);
									ngModelController.$render();

									$timeout(function(){
										scope.dateChanged(event, input);
									});
									return;
								}
								day = dateParts[0].slice(0,2);
								if(dateParts[0].length>2) {
									month = dateParts[0].slice(2,4)
								}
								if(dateParts[0].length>4) {
									year = dateParts[0].slice(4,8);
								}
							}

							if(dateParts[0].length>0 && dateParts[0].length<=2) {
								day = dateParts[0];
							}
							if(dateParts.length>1 && dateParts[1].length>0) {
								month = dateParts[1];
							}
							if(dateParts.length>2 && dateParts[2].length>0) {
								year = dateParts[2];
							}

							if(year.length<=2) {
								// si sintrodueix l'any en 2 dígits, el passem al segle que correspon
								year = parseInt(year) + (now.getFullYear()-(now.getFullYear()%100));
							}

							var newDate = ixNewDate(cfg,moment, day, month-1, year);
							if((!ngModelController.$viewValue) || newDate.getTime() !== ngModelController.$viewValue.getTime()){
								ngModelController.$setViewValue(newDate);
							}
							scope.dateChanged(event, input);
						}
	    	});

        scope.dateChanged = function (event, input) {
          if((!event.relatedTarget) || !event.relatedTarget.closest(".ui-grid-cell") || elem.closest(".ui-grid-cell").attr("id") !== angular.element(event.relatedTarget).attr("id")) {
            scope.done = true;
						scope.changed = false;
            scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
          }
        };
        scope.checkIsOpen = function(){
          scope.isOpen = !scope.isOpen;
          if(scope.isOpen){
            elem.parent().parent().css("position", "absolute");
          }
        };

        input.css("z-index", "1051");
        elem.parent().parent().css("width", Number(elem.parent().parent().css("width").replace(/[^\d\.\-]/g, '')));
	    }
	  };
	}]);

  angular.module("gp4App").directive('ixGridFiltro', [ '$filter', 'ixUtilsService', '$timeout', function($filter, ixUtilsService, $timeout) {
    return {
      templateUrl: 'app/base/views/helpers_templates/ixGridFiltro.html',
      link: function(scope, elem, attrs){
        scope.showFilterModal = function() {
          var template = "app/base/views/helpers_templates/ixGridFiltroModal.html";
          var options = { controller: 'ixGridFiltroController' };
          var params = { col: scope.col, element: elem };
          ixUtilsService.openModalV2(template, options, "small", params).then(function(response){
            var listOfValues = response.listOfValues; 
            var filtrosRango = response.filtrosRango;
            var selectedValues = [];
            if(angular.isDefined(scope.col.filters[0].selectionType) && scope.col.filters[0].selectionType != "undefined" && scope.col.filters[0].selectionType != "#lista" && scope.col.filters[0].selectionType != "#rango"){
              selectedValues.push(scope.col.filters[0].selectionType);
            }
            listOfValues.forEach( function( val ) {
              if(val.selected) {
                var id = val.id;
                if(scope.col.colDef.control == "Search"){
                  if(scope.col.colDef.LookUpKeyFields.length > 1 && scope.col.colDef.ColumnFkDescription){
                    id = val.label.substr(0, val.label.lastIndexOf('-')).trim();
                  }
                }
                selectedValues.push( id );
              }
              val.children.forEach(function(v2) {
                v2.children.forEach(function(v3) {
                  if(v3.selected){
                    selectedValues.push(v3.id);
                  }
                });
              });
            });
            if(selectedValues.length == 0)
              scope.col.filters[0].filtervalue = "";
            //La opció "Limpiar todos los filtros" està inclosa al mòdul angular-ui-grid.
            //Els filtres que nosaltres fem servir són personalitzats, per aquesta raó, al netejar els filtres, la condició que nosaltres apliquem s'esborra.
            //Si això passa, la tornem a assignar.
            if(angular.isUndefined(scope.col.filters[0].condition)){
              scope.col.filters[0].condition = ixGridColumnFilterCondition();
            }
      
            if(scope.col.filters[0].selectionType == "#rango"){
              if(angular.isUndefined(filtrosRango[0]))
                filtrosRango[0] = null;
      
              if(angular.isUndefined(filtrosRango[1]))
                filtrosRango[1] = null;
      
              scope.col.filters[0].term = filtrosRango.join('|');
              scope.col.filters[0].numfilters = filtrosRango.filter(function(e){ return e !== "" && e !== null; }).length;
            } else {
              scope.col.filters[0].term = selectedValues.join('|');
              scope.col.filters[0].numfilters = selectedValues.length;
            }
      
      
      
            var columnDef = scope.col.grid.options.columnDefs.find(function(e){ return e.field == scope.col.field && !e.Required; });
            if(angular.isDefined(columnDef)){
              if(selectedValues.length > 0){
                columnDef.enableHiding = false;
              } else {
                columnDef.enableHiding = true;
              }
            }
            scope.col.filters[0].term += "$reload";
          });
        };

        scope.showFilterInput = function() {
          scope.col.filters[0].showFilterInput = !scope.col.filters[0].showFilterInput;
          if(!scope.col.filters[0].showFilterInput) {
            //vaciamos valor
            scope.col.filters[0].term = "";
          }
        };

        scope.deslectAllAndApply = function() {
          scope.col.filters[0].filtervalue = "";		
          scope.col.filters[0].condition = ixGridColumnFilterCondition($filter);
          scope.col.filters[0].term = "";
          scope.col.filters[0].numfilters = 0;
          var columnDef = scope.col.grid.options.columnDefs.find(function(e){ return e.field == scope.col.field && !e.Required; });
          columnDef.enableHiding = true;		
        };
      }
    };
  }]);

/**
 * Directiva y controller para los filtros en el grid
 */
// angular.module("gp4App").directive('ixGridFiltro', [ '$filter', function($filter) {
//   return {
//     templateUrl: 'app/base/views/helpers_templates/ixGridFiltro.html',
//     controller: 'ixGridFiltroController'
//   };
// }]).controller('ixGridFiltroController', ['$scope','$compile','$timeout', '$uibModal', '$filter', 'cfg', 'ivhTreeviewMgr', 'ixStatusService', '$document', '$element', function( $scope, $compile, $timeout, $uibModal, $filter, cfg, ivhTreeviewMgr, ixStatusService, $document, $element ) {
//   $scope.col.fast_filter_input = $element[0].getElementsByClassName("fast-filter-input")[0];
// 	$scope.options = [];
// 	$scope.esColumnaDecimalSinDropdown = function(col){
// 		return (!col.pk && col.db_type == "decimal" && angular.isUndefined(col.Search) && angular.isUndefined(col.control));
// 	};

// 	if($scope.esColumnaDecimalSinDropdown($scope.col.colDef)){
// 		$scope.filtrosRango = [];
// 		$scope.options = [{ value: "#rango", text: "Según rango" }, { value: "#value", text: "Con valor" }, { value: "#empty" , text: "Vacíos" }];
// 	} else {
// 		$scope.options = [{ value: "undefined", text: "Según selección" }, { value: "#lista", text: "Lista" }, { value: "#value", text: "Con valor" }, { value: "#empty" , text: "Vacíos" }];
// 	}

//   $scope.showFilterModal = function() {
//     //Per defecte tindrem la opció "Según rango" si es un numero o "Según selección" marcada.
//     if(angular.isUndefined($scope.col.filters[0].selectionType)){
// 			if($scope.esColumnaDecimalSinDropdown($scope.col.colDef))
// 				$scope.col.filters[0].selectionType = "#rango";
// 			else
// 				$scope.col.filters[0].selectionType = "undefined";
//     }
//     //Aprofitem que la opció "Limpiar todos los filtros" del angular-ui-grid esborra la propietat condition. Quan s'esborri netejarem el control de cerca.
//     if(angular.isUndefined($scope.col.filters[0].condition)){
//       $scope.col.filters[0].filtervalue = "";
//     }

// 		var defaultOptions = { templateUrl: "ixGridFiltroModal.html",  scope: $scope, backdrop: 'static', keyboard: false };
// 		//para las pantallas fullscreen es necesario indicar "appendToFilterPopup"
// 		if($scope.col.grid.options.appendToFilterPopup)
// 			defaultOptions.appendTo = $document.find($scope.col.grid.options.appendToFilterPopup).eq(0);

// 		$uibModal.open(defaultOptions).result.then(function(){
//   		var selectedValues = [];
//       if(angular.isDefined($scope.col.filters[0].selectionType) && $scope.col.filters[0].selectionType != "undefined" && $scope.col.filters[0].selectionType != "#lista" && $scope.col.filters[0].selectionType != "#rango"){
//         selectedValues.push($scope.col.filters[0].selectionType);
//       }
// 			$scope.listOfValues.forEach( function( val ) {
// 				if(val.selected) {
// 					selectedValues.push( val.id );
// 				}
// 				val.children.forEach(function(v2) {
// 					v2.children.forEach(function(v3) {
// 						if(v3.selected){
// 							selectedValues.push(v3.id);
// 						}
// 					});
// 				});
// 			});
// 			if(selectedValues.length == 0)
// 				$scope.col.filters[0].filtervalue = "";
//       //La opció "Limpiar todos los filtros" està inclosa al mòdul angular-ui-grid.
//       //Els filtres que nosaltres fem servir són personalitzats, per aquesta raó, al netejar els filtres, la condició que nosaltres apliquem s'esborra.
//       //Si això passa, la tornem a assignar.
//       if(angular.isUndefined($scope.col.filters[0].condition)){
//         $scope.col.filters[0].condition = ixGridColumnFilterCondition();
//       }

// 			if($scope.col.filters[0].selectionType == "#rango"){
// 				if(angular.isUndefined($scope.filtrosRango[0]))
// 					$scope.filtrosRango[0] = null;

// 				if(angular.isUndefined($scope.filtrosRango[1]))
// 					$scope.filtrosRango[1] = null;

// 				$scope.col.filters[0].term = $scope.filtrosRango.join('|');
// 				$scope.col.filters[0].numfilters = $scope.filtrosRango.filter(function(e){ return e !== "" && e !== null; }).length;
// 			} else {
// 				$scope.col.filters[0].term = selectedValues.join('|');
// 				$scope.col.filters[0].numfilters = selectedValues.length;
// 			}



//       var columnDef = $scope.col.grid.options.columnDefs.find(function(e){ return e.field == $scope.col.field && !e.Required; });
//       if(angular.isDefined(columnDef)){
//         if(selectedValues.length > 0){
//           columnDef.enableHiding = false;
//         } else {
//           columnDef.enableHiding = true;
//         }
//       }
// 			$scope.col.filters[0].term += "$reload";
// 		});

// 		var distinctValues = {};
//   	$scope.listOfValues = [];
// 		var type = $scope.col.colDef.type;
//     var esSearch = $scope.col.colDef.control == "Search";
// 		var selectedValues = [];

// 		if($scope.col.filters[0].term) {
// 			if($scope.col.filters[0].term.indexOf("$reload") != -1)
// 				$scope.col.filters[0].term = $scope.col.filters[0].term.substring(0, $scope.col.filters[0].term.indexOf("$reload"));

// 			if($scope.col.filters[0].selectionType == "#rango"){
// 				$scope.filtrosRango	= $scope.col.filters[0].term.split("|");
// 				if(angular.isUndefined($scope.filtrosRango[0]) || $scope.filtrosRango[0] === "")
// 					$scope.filtrosRango[0] = null;
// 				if(angular.isUndefined($scope.filtrosRango[1]) || $scope.filtrosRango[1] === "")
// 					$scope.filtrosRango[1] = null;
// 			} else {
// 				selectedValues=$scope.col.filters[0].term.split("|");
// 			}
// 		}

//     //Pendiente revisar para ignorar el filtro de la propia columna: ($scope.grid.api.core.getVisibleRows()).forEach(function(obj) {
//     //$scope.col.grid.options.data.forEach( function ( row ) {
//     filterIgnoringItself().forEach( function ( obj ) {
//       var row = obj.entity;
//       var selected = "";
//       var value = row[$scope.col.field];
//       if(value || value === 0){
// 				if(type=="date"){
//           selected = false;
//           var year = value.getFullYear()
//           //Agafa el dia i mes actual (sense convertir el datetime actual a UTC, sino agafa el dia anterior ja que la data conte la zona horaria)
//           var month = year+"-"+( (value.getMonth() + 1) < 10 ? "0"+(value.getMonth() + 1) : (value.getMonth() + 1) );
//           var day = month+"-"+(value.getDate() < 10 ? "0"+value.getDate() : value.getDate() );
//           //var month = value.toISOString().substring(0,7);
//           //var day =  value.toISOString().substring(0,10);
//           if ( !distinctValues[year] ) {
//             distinctValues[year]={id:year, label:year, selected:selected, children:[]};
//             $scope.listOfValues.push(distinctValues[year]);
//           }
//           if ( !distinctValues[month] ) {
//             distinctValues[month]={id:month, label:$filter("date")(value,"MMMM"), selected:selected, children:[]};
//             distinctValues[year].children.push(distinctValues[month])
//           }
//           if ( !distinctValues[day] ) {
//             //distinctValues[day]={id:day,label:$filter("date")(value,cfg.dateFormat), selected:selected, children:[]};
//             distinctValues[day]={id:$filter("date")(value,"yyyy-MM-dd"),label:$filter("date")(value,cfg.dateFormat), selected:selected, children:[]};
//             distinctValues[month].children.push(distinctValues[day])
//           }

//         } else if($scope.col.colDef.control == "Search"){
//           var lookupresultfields = $scope.col.colDef.LookUpResultFields;
//           var fkObjects = $scope.col.colDef.allFkObjects;
//           var object = fkObjects.filter(function(e){
// 						var coincide = false;
// 						for(var i = 0; i < lookupresultfields.length; i++){
// 							if(e[lookupresultfields[i]]==value)
// 								coincide = true;
// 						}
// 						return coincide;
// 					}).map(function(e){
//             var label = e[lookupresultfields[0]];
//             if(lookupresultfields.length > 1){
//               for(var i = 1; i < lookupresultfields.length; i++){
//                 if(angular.isDefined(e[lookupresultfields[i]])){
//                   label += " - " + e[lookupresultfields[i]];
//                 }
//               }
//             }
// 						var obj = { "clave": e[$scope.col.colDef.LookUpKeyFields[$scope.col.colDef.LookUpKeyFields.length - 1]], "label": label };
// 						if($scope.col.colDef.LookUpKeyFields){
// 							for(var x = 0; x < $scope.col.colDef.LookUpKeyFields.length - 1; x++){
// 								var property = $scope.col.colDef.LookUpKeyFields[x];
// 								obj[property] = e[property];
// 							}
// 						}
// 						return obj;
//           });

// 					if($scope.col.colDef.LookUpKeyFields){
// 						for(var i = 0; i < $scope.col.colDef.LookUpKeyFields.length - 1; i++){
// 							var property = $scope.col.colDef.LookUpKeyFields[i];
// 							var propertyLeftJoinTable = $scope.col.colDef.KeyFields[i];
// 							if(angular.isDefined(obj.entity[property])){
// 								object = object.filter(function(e){ return e[property] == obj.entity[propertyLeftJoinTable]; });
// 							}
// 						}
// 					}

// 					if(object.length > 1)
// 						object = object.find(function(e){ return e.clave == value; });
// 					else
// 						object = object[0];

// 					if(angular.isDefined(object)){
// 						if ( !distinctValues[object.label] ) {
// 							distinctValues[object.label]=true;
// 							selected = selectedValues.indexOf(object.clave.toString())>=0;
              
// 							$scope.listOfValues.push({id:object.clave, label:object.label, selected:selected, children:[]});
// 						}
// 					}
//         } else {
//           if ( !distinctValues[value] ) {
//             distinctValues[value]=true;
//             selected = selectedValues.indexOf(value.toString())>=0;

//             var label = value;
//             if($scope.col.colDef.control == "Color")
//               label = '<span style="position: relative; top: 18px; left: 15px; background-color: red;" class="color_leyenda"></span>' + label;

//             $scope.listOfValues.push({id:value, label:label, selected:selected, children:[]});
//           } else {
//             //$scope.listOfValues[0].children.push({label:value,selected:false});
//           }

//         }
//       }
//     });
//     //Sort recursive.
//     sortListOfValues($scope.listOfValues);
//   };

//   $scope.showFilterInput = function() {
//     $scope.col.showFilterInput = !$scope.col.showFilterInput;
//     if($scope.col.showFilterInput) {
//       //cogemos el foco
//       $timeout(function(){
//         $scope.col.fast_filter_input.focus();
//       },1);      
//     } else {
//       //vaciamos valor
//       $scope.col.filters[0].term = "";
//     }
//   };

// 	$scope.filterList = function(item, B) {		
// 		var result = false;
// 		var listValues = $scope.col.filters[0].filtervalue.toUpperCase().split("\n");
// 		//return listValues.indexOf(item.label.toUpperCase()) !== -1;				
// 		for (var i = 0, len = listValues.length; i < len; i++) {
// 			if(item.label.toString().toUpperCase().indexOf(listValues[i].toUpperCase()) !== -1) {			
// 				result = true;
// 				break;
// 			}			
// 		}
		
// 		/*
// 		angular.forEach(listValues, function(filterValue){
// 			 if(!result && item.label.toString().toUpperCase().indexOf(filterValue.toUpperCase()) !== -1) {
// 				 result = true;
// 			 }        
// 		});
// 		*/
// 		return result;
// 	};
	
//   var sortListOfValues = function(listOfValues){
//     //Si l'array actual només conté 1 objecte i aquest objecte té més d'un fill, ordenem els fills de l'objecte.
//     if(listOfValues.length == 1 && hasChildrenToSort(listOfValues[0])){ sortListOfValues(listOfValues[0].children); }

//     listOfValues.sort(function(a,b){
//       //Ordenem els fills de l'objecte que estem comparant (si n'hi han).
//       if(hasChildrenToSort(a)){
//         sortListOfValues(a.children);
//       }
//       if(hasChildrenToSort(b)){
//         sortListOfValues(b.children);
//       }
//       //return (a.label>b.label)-(a.label<b.label);
//       return (a.id>b.id)-(a.id<b.id);
//     });
//   };

//   var hasChildrenToSort = function(obj){
//     return obj.children;// && obj.children.length > 1;
//   };

//   var filterIgnoringItself = function(){
//     var gridFilters = $scope.col.grid.columns.filter(function(column){ return column.field !== $scope.col.field && angular.isDefined(column.filter.term) && column.filter.term !== null && column.filter.term !== ""; });
//     var dataRows = $scope.col.grid.rows;

//     var filteredDataRows = dataRows.filter(function(_row){
//       var isMatch = true;
//       angular.forEach(gridFilters, function (_filter) {
// 				if((typeof(_filter.filter.term) == "string") && _filter.filter.term.indexOf("$reload") != -1)
// 					_filter.filter.term = _filter.filter.term.substring(0, _filter.filter.term.indexOf("$reload"));

//         isMatch = isMatch && _filter.filter.condition(_filter.filter.term, _row.entity[_filter.field], _row, _filter);
//       });

//       return isMatch;
//     });
//     return filteredDataRows;
//   };

// 	$scope.selectAll = function() {
//     var matchingValues = [];
//     if($scope.col.filters[0].filtervalue != null){
// 			var listValues = $scope.col.filters[0].filtervalue.toUpperCase().split("\n");			
// 			angular.forEach($scope.listOfValues, function(value){
//       	for (var i = 0, len = listValues.length; i < len; i++) {
// 					if(value.label.toString().toUpperCase().indexOf(listValues[i].toUpperCase()) !== -1) {			
// 						matchingValues.push(value);
// 						break;
// 					}			
// 				}  
//       });			
//       /*
// 			angular.forEach($scope.listOfValues, function(value){
//         if(value.label.toString().toUpperCase().indexOf($scope.col.filters[0].filtervalue.toUpperCase()) !== -1){
//          matchingValues.push(value);
//         }
//       });
// 			*/
//       ivhTreeviewMgr.selectAll(matchingValues);
//     } else {
//       ivhTreeviewMgr.selectAll($scope.listOfValues);
//     }

//   };

//   $scope.selectAllNotEmpty = function(){
//     $scope.selectionType = "*";
//   };

//   $scope.selectAllEmpty = function(){
//     $scope.selectionType = "\"\"";
//   };

//   $scope.deselectAll = function() {
// 		ivhTreeviewMgr.deselectAll($scope.listOfValues);
// 		$scope.col.filters[0].filtervalue = "";
//   };

// 	$scope.deslectAllAndApply = function() {
// 		$scope.col.filters[0].filtervalue = "";		
// 		$scope.col.filters[0].condition = ixGridColumnFilterCondition($filter);
// 		$scope.col.filters[0].term = "";
// 		$scope.col.filters[0].numfilters = 0;
// 		var columnDef = $scope.col.grid.options.columnDefs.find(function(e){ return e.field == $scope.col.field && !e.Required; });
// 		columnDef.enableHiding = true;		
// 	};
// }]);


angular.module("gp4App").directive('ixGridFiltroServidor', [ function(){
  return {
    //restrict: 'E',
    templateUrl: 'app/base/views/helpers_templates/ixGridFiltroServidor.html',
    //scope: false,
    controller: 'ixGridFiltroServidorController'
  };
}]).controller('ixGridFiltroServidorController', [ '$scope','$compile','$timeout', '$uibModal', '$filter', 'cfg', 'ivhTreeviewMgr', 'ixStatusService', '$http', function($scope, $compile, $timeout, $uibModal, $filter, cfg, ivhTreeviewMgr, ixStatusService, $http){
  //TODO: Aixo s'haurà de mirar per tal de fer-ho més dinàmic.
	var numfilters;
  if($scope.col.colDef.filteropt == "Fecha"){
    var num = 0;
    if($scope.col.colDef.filters[0].data_ini != null) num++;
    if($scope.col.colDef.filters[0].data_fi != null) num++;
    $scope.col.filters[0].numfilters = num;
  } else if($scope.col.colDef.filteropt == "Texto"){
    numfilters = angular.isDefined($scope.col.filters[0].term) ? $scope.col.filters[0].term.split("|") : [];
    $scope.col.filters[0].numfilters = numfilters.length;
  } else if($scope.col.colDef.filteropt == "Numero"){
    numfilters = angular.isDefined($scope.col.filters[0].term) ? $scope.col.filters[0].term.split("|") : [];
    $scope.col.filters[0].numfilters = numfilters.length;
  }
  //


  $scope.showFilterModal = function() {
    convertDateStringsToDates($scope.col.filters[0]);
		$uibModal.open({
			templateUrl: "ixGridFiltroServidorModal.html",
			scope: $scope,
      backdrop: 'static',
      keyboard: false
		}).result.then(function(){
      //TODO: Passar type a la directiva. Si és date, llavors passem dos paràmetres com filtre >= data_ini <= data_fi.
      convertDateStringsToDates($scope.col.filters[0]);
      //TODO: Aixo s'haurà de mirar per tal de fer-ho més dinàmic.
      var columnDef = $scope.col.grid.options.columnDefs.find(function(e){ return e.field == $scope.col.field && !e.Required; });
			var selectedValues = [];
      if($scope.col.colDef.filteropt == "Fecha"){
        var num = 0;
        if($scope.col.colDef.filters[0].periodo_ini != null) num++;
        else if($scope.col.colDef.filters[0].data_ini != null) num++;
        if($scope.col.colDef.filters[0].periodo_fin != null) num++;
        else if($scope.col.colDef.filters[0].data_fi != null) num++;
        $scope.col.filters[0].numfilters = num;

        if(angular.isDefined(columnDef)){
          if($scope.col.filters[0].numfilters > 0){
            columnDef.enableHiding = false;
          } else {
            columnDef.enableHiding = true;
          }
        }

      } else if($scope.col.colDef.filteropt == "Texto"){
        
        $scope.listOfValues.forEach( function( val ) {
          if(val.selected) {
            if(val.id.indexOf('-') !== -1){
              //var partsId = val.id.split('-');
              //var valId = partsId[partsId.length - 1].replace(/\s+/g, '');
              var valId = val.id.substr(0, val.id.lastIndexOf('-'));
              valId = valId.trim();
              selectedValues.push( valId );
            } else {
              selectedValues.push( val.id );
            }
          }
          val.children.forEach(function(v2) {
            v2.children.forEach(function(v3) {
              if(v3.selected){
                selectedValues.push(v3.id);
              }
            });
          });
        });

				if(selectedValues.length == 0)
					$scope.col.filters[0].filtervalue = "";

        $scope.col.filters[0].term = selectedValues.join('|');
        $scope.col.filters[0].numfilters = selectedValues.length;

        if(angular.isDefined(columnDef)){
          if($scope.col.filters[0].numfilters > 0){
            columnDef.enableHiding = false;
          } else {
            columnDef.enableHiding = true;
          }
        }

        //$scope.col.filters[0].condition = new RegExp($scope.col.filters[0].term);
        $scope.col.filters[0].condition = $scope.col.filter.condition;
      } else if($scope.col.colDef.filteropt == "Numero"){        
        $scope.listOfValues.forEach( function( val ) {
          if(val.selected) {
            if(val.id.indexOf('-') !== -1){              
              //var valId = val.id.substr(1, val.id.lastIndexOf('-'));
							var valId = val.id.split("-")[1];							
              valId = valId.trim();
              selectedValues.push( valId );
            } else {
              selectedValues.push( val.id );
            }
          }
          val.children.forEach(function(v2) {
            v2.children.forEach(function(v3) {
              if(v3.selected){
                selectedValues.push(v3.id);
              }
            });
          });
        });

				if(selectedValues.length == 0)
					$scope.col.filters[0].filtervalue = "";

        $scope.col.filters[0].term = selectedValues.join('|');
        $scope.col.filters[0].numfilters = selectedValues.length;

        if(angular.isDefined(columnDef)){
          if($scope.col.filters[0].numfilters > 0){
            columnDef.enableHiding = false;
          } else {
            columnDef.enableHiding = true;
          }
        }

        //$scope.col.filters[0].condition = new RegExp($scope.col.filters[0].term);
        $scope.col.filters[0].condition = $scope.col.filter.condition;
      }
      //
      $scope.applyFiltersToGrid();
		});


    //Aixo es per quan es tipus Texto:
		var distinctValues = {};
		var type;
		var selectedValues = [];
    if($scope.col.colDef.filteropt == "Texto"){      
      $scope.listOfValues = [];
      type = $scope.col.colDef.type;
      //var esSearch = $scope.col.colDef.control == "Search";
      
      if($scope.col.filters[0].term) {
        selectedValues=$scope.col.filters[0].term.split("|");
      }
      /*if(!$scope.col.filters[0].numfilters){
        $scope.col.filters[0].numfilters = 0;
      }*/

      //$scope.col.grid.options.data.forEach( function ( row ) {
      $scope.col.colDef.listValues.forEach(function(value){
        //var value = row[$scope.col.field];
        if(value){
          //Per ara nomes tenim fets els camps string
          /*if($scope.col.colDef.control == "Search"){
            var filtersKey = $scope.col.colDef.LookUpKeyFields.map(function (c, ii, aa) {
              if(ii!==aa.length-1) {
                return {Field: c, Value: row[$scope.col.colDef.KeyFields[ii]]};
              }
            });
            var lookupresultfields = $scope.col.colDef.LookUpResultFields;

            var fkObjects = $scope.col.colDef.allFkObjects;

            var object = fkObjects.filter(function(e){
              return e[lookupresultfields[0]]==value || e[lookupresultfields[1]]==value && (angular.isDefined(filtersKey[0]) ? e[filtersKey[0].Field] == filtersKey[0].Value : true);
            }).map(function(e){ return { "clave": value, "label": e[lookupresultfields[0]] + " - " + e[lookupresultfields[1]] }; });
            object = object[0];
            if ( !distinctValues[object.label] ) {
              distinctValues[object.label]=true;
              var selected = selectedValues.indexOf(object.clave.toString())>=0;
              $scope.listOfValues.push({id:object.clave, label:object.label, selected:selected, children:[]});
            }
          } else {*/
            if ( !distinctValues[value] ) {
              distinctValues[value]=true;
              var selected = selectedValues.indexOf(value.toString())>=0 || selectedValues.indexOf(value.substr(0, value.lastIndexOf('-')).trim()) >= 0;
              //if(selected) $scope.col.filters[0].numfilters++;
              $scope.listOfValues.push({id:value, label:value, selected:selected, children:[]});
            } else {
              //$scope.listOfValues[0].children.push({label:value,selected:false});
            }

          //}
        }
      });
      //Sort recursive.
      sortListOfValues($scope.listOfValues);
    } else if($scope.col.colDef.filteropt == "Numero"){
      
      $scope.listOfValues = [];
      type = $scope.col.colDef.type;
      //var esSearch = $scope.col.colDef.control == "Search";
      
      if($scope.col.filters[0].term) {
        selectedValues=$scope.col.filters[0].term.split("|");
      }
      /*if(!$scope.col.filters[0].numfilters){
        $scope.col.filters[0].numfilters = 0;
      }*/

      //$scope.col.grid.options.data.forEach( function ( row ) {
      $scope.col.colDef.listValues.forEach(function(value){
        //var value = row[$scope.col.field];
        if(value){
          //Per ara nomes tenim fets els camps string
          /*if($scope.col.colDef.control == "Search"){
            var filtersKey = $scope.col.colDef.LookUpKeyFields.map(function (c, ii, aa) {
              if(ii!==aa.length-1) {
                return {Field: c, Value: row[$scope.col.colDef.KeyFields[ii]]};
              }
            });
            var lookupresultfields = $scope.col.colDef.LookUpResultFields;

            var fkObjects = $scope.col.colDef.allFkObjects;

            var object = fkObjects.filter(function(e){
              return e[lookupresultfields[0]]==value || e[lookupresultfields[1]]==value && (angular.isDefined(filtersKey[0]) ? e[filtersKey[0].Field] == filtersKey[0].Value : true);
            }).map(function(e){ return { "clave": value, "label": e[lookupresultfields[0]] + " - " + e[lookupresultfields[1]] }; });
            object = object[0];
            if ( !distinctValues[object.label] ) {
              distinctValues[object.label]=true;
              var selected = selectedValues.indexOf(object.clave.toString())>=0;
              $scope.listOfValues.push({id:object.clave, label:object.label, selected:selected, children:[]});
            }
          } else {*/
            if ( !distinctValues[value] ) {
              distinctValues[value]=true;
              var selected = selectedValues.indexOf(value.toString())>=0 || selectedValues.indexOf(value.substr(1, value.lastIndexOf('-')).trim()) >= 0;
              //if(selected) $scope.col.filters[0].numfilters++;
              $scope.listOfValues.push({id:value, label:value, selected:selected, children:[]});
            } else {
              //$scope.listOfValues[0].children.push({label:value,selected:false});
            }

          //}
        }
      });
      //Sort recursive.
      sortListOfValues($scope.listOfValues);
    }
  };

  $scope.loadTiposFecha = function(){
    return $http.get(cfg.baseURL + "tipos_fecha").then(function(response){
      var result = [];
      if(response.data != null){
        result = response;
      }
      return result;
    }, function(err){
      ixStatusService.setResponse(err);
    });
  };

  var sortListOfValues = function(listOfValues){
    //Si l'array actual només conté 1 objecte i aquest objecte té més d'un fill, ordenem els fills de l'objecte.
    if(listOfValues.length == 1 && hasChildrenToSort(listOfValues[0])){ sortListOfValues(listOfValues[0].children); }

    listOfValues.sort(function(a,b){
      //Ordenem els fills de l'objecte que estem comparant (si n'hi han).
      if(hasChildrenToSort(a)){
        sortListOfValues(a.children);
      }
      if(hasChildrenToSort(b)){
        sortListOfValues(b.children);
      }
      //return (a.label>b.label)-(a.label<b.label);
      return (a.id>b.id)-(a.id<b.id);
    });
  };

  var hasChildrenToSort = function(obj){
    return obj.children && obj.children.length > 1;
  };

	$scope.selectAll = function() {
    var matchingValues = [];
    if($scope.col.filters[0].filtervalue != null){
      angular.forEach($scope.listOfValues, function(value){
        if(value.label.toString().toUpperCase().indexOf($scope.col.filters[0].filtervalue.toUpperCase()) !== -1){
         matchingValues.push(value);
        }
      });
      ivhTreeviewMgr.selectAll(matchingValues);
    } else {
      ivhTreeviewMgr.selectAll($scope.listOfValues);
    }

  };

  $scope.deselectAll = function() {
		ivhTreeviewMgr.deselectAll($scope.listOfValues);
		$scope.col.filters[0].filtervalue = "";
  };

  $scope.applyFiltersToGrid = function(){
    $scope.col.grid.options.ixLoadInitialData();
  };
}]);


//Directiva dels dialegs modals que s'obren a través de la app:

angular.module("gp4App").directive('ixGridModal', [ function(){
  return {
    scope: {
      colDisplayname: '=',
      colField: '=',
      entity: '=',
      isNew: '='
    },
    templateUrl: 'app/base/views/helpers_templates/ixGridModal.html',
    controller: 'ixGridModalController'
  };
}]).controller('ixGridModalController', ['$rootScope','$scope','$compile', '$timeout', '$filter', 'cfg', '$http', 'ixStatusService', function($rootScope, $scope, $compile, $timeout, $filter, cfg, $http, ixStatusService){
  if(!ixStatusService.current.data.grid.delayedActions){
    ixStatusService.current.data.grid.delayedActions = [];
  }

  $scope.colDisplayname = $scope.$parent.colDisplayname;
  $scope.colField = $scope.$parent.colField;
  $scope.entity = $scope.$parent.gridEntity;
  $scope.isNew = $scope.$parent.isNew;

  var popup = angular.element('ix-grid-modal');
  $scope.closePopup = function () {
    if(popup){
	  ixStatusService.current.data.grid.ixCheckErrors();
      popup.remove();
    }
  };

  $scope.saveData = function () {
    if(Object.keys($scope.modalForm.$error).length === 0){
      var data = $scope.$parent.buildPK($scope.$parent.entityObj);
      data["new"+$scope.colField] = $scope.modify_value;
      if($scope.isNew){
				$scope.$parent.entityObj[$scope.colField] = $scope.modify_value;
        //Si l'usuari és nou, guardem l'attempt per més tard.
        //data.url = cfg.baseURL + $scope.entity + "/Reset"+$scope.colDisplayname;
        //ixStatusService.current.data.grid.delayedActions.push( data );
        $scope.closePopup();
      } else {
        $http.post(cfg.baseURL + $scope.entity + "/ResetPassword", data).then(function(r){
            ixStatusService.setResponse(r);
            $scope.closePopup();
        }, function(err){
					ixStatusService.setResponse(err);
				});
      }
    }
  };

}]);

angular.module("gp4App").directive('ixMegawhere', [ function(){
  return {
    restrict: 'E',
    templateUrl: 'app/base/views/helpers_templates/ixMegawhere.html',
    controller: 'ixMegawhereController'
  };
}]).controller('ixMegawhereController', ['$scope', '$timeout', 'cfg', '$uibModal', 'gridService', 'uiGridEditConstants', 'ixStatusService', function($scope, $timeout, cfg, $uibModal, gridService, uiGridEditConstants, ixStatusService){
  $scope.status = ixStatusService.current;
	$scope.data = ixStatusService.current.data;

  $scope.openWindow = function(size){
    if(ixStatusService.current.editing){

      $scope.gridmegawhere = gridService.createGrid($scope, "extranet_condition_userGrid",  {}, "extranet_condition_user");

      $scope.gridmegawhere.entity = "extranet_condition_user";

      $scope.ixEditar = $scope.gridmegawhere.ixEditar;
      $scope.ixCancelEdit = $scope.gridmegawhere.ixCancelEdit;
      $scope.ixAddRow = $scope.gridmegawhere.ixAddRow;
      $scope.ixDeleteSelectedRows = $scope.gridmegawhere.ixDeleteSelectedRows;
      //$scope.ixDownloadExcel = $scope.gridmegawhere.ixDownloadExcel;
      $timeout(function(){
        $scope.numberOfChanges = $scope.gridmegawhere.numberOfChanges;
      });
      $scope.updateIxGuardarTooltip = $scope.gridmegawhere.updateIxGuardarTooltip;
      $scope.ixGuardar = $scope.gridmegawhere.ixGuardar;

      //Buscar només tot el que estigui relacionat amb l'usuari.
      $scope.gridmegawhere.filtroExterno = {username:$scope.row.entity.usuario};

      $scope.gridmegawhere.ixLoadInitialData();



      $uibModal.open({
        templateUrl: "ixMegawhereModal.html",
        scope: $scope,
        size: size,
        windowClass: 'megawhere-popup',
        backdrop: 'static',
        keyboard: false
      }).result.then(function(){

      });
    }
  };
}]);
//TODO: Simplificar directiva de manera que al final rebi els paràmetres:
//{icon:"", title:"", action:function(obj){ $uibModal.open(template, size,...)},  visible: function(obj) {if(obj.Filterloquesea...)}}
/*angular.module("gp4App").directive('ixDetallePopup', [ 'gridService', '$uibModal', 'ixStatusService', '$http', 'cfg', '$filter', function(gridService, $uibModal, ixStatusService, $http, cfg, $filter){
  return {
    restrict: 'E',
    scope: {
      title: '@',
      pks: '@',
      viewmodel: '@'
    },
    template: '<div ng-dblclick="open()" class ="ui-grid-cell-contents"><i ng-click="open()" title="Petición servicio" class="fa fa-fw fa-window-maximize"></i></div>',
    link: function(scope, element, attrs){

      scope.status = ixStatusService.current;

      scope.loadPeticionServiciosSolicitar = function(){
        if(scope.serviciosPDI != null){
          var urlAttr = "?pdi="+scope.serviciosPDI+"&VIN="+scope.$parent.row.entity["VIN"]+"&grupo="+scope.$parent.row.entity["Grupo"]+"&movimiento="+scope.$parent.row.entity["Movimiento"];
          return $http.get(cfg.baseURL+scope.grid1.entity+urlAttr).then(function(response) {
            //Per a cada crida s'actualitzarà la data d'informació generada.
            scope.grid1.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
            scope.grid1.data = response.data;
            //S'esta editant.
            scope.grid1.gridApi.ix.status.editing = true;
          }, function (response) {
            ixStatusService.setResponse(response);
          });
        }
      };

      scope.loadPeticionServiciosAccesorios = function(){
        if(scope.serviciosPDI != null){
          var urlAttr = "?pdi="+scope.serviciosPDI+"&VIN="+scope.$parent.row.entity["VIN"]+"&grupo="+scope.$parent.row.entity["Grupo"]+"&movimiento="+scope.$parent.row.entity["Movimiento"];
          return $http.get(cfg.baseURL+scope.grid2.entity+urlAttr).then(function(response) {
            //Per a cada crida s'actualitzarà la data d'informació generada.
            scope.grid2.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
            scope.grid2.data = response.data;
            //S'esta editant.
            scope.grid2.gridApi.ix.status.editing = true;
          }, function (response) {
            ixStatusService.setResponse(response);
          });
        }
      }

      scope.loadPeticionServiciosHistorico = function(){

        var urlAttr = "?VIN="+scope.$parent.row.entity["VIN"]+"&grupo="+scope.$parent.row.entity["Grupo"]+"&movimiento="+scope.$parent.row.entity["Movimiento"];
        return $http.get(cfg.baseURL+scope.grid3.entity+urlAttr).then(function(response) {
          //Per a cada crida s'actualitzarà la data d'informació generada.
          scope.grid3.generadaEl = $filter("date")(new Date(), "dd/MM/yyyy HH:mm:ss");
          scope.grid3.data = response.data;
        }, function (response) {
          ixStatusService.setResponse(response);
        });

      }

      scope.loadData = function(){
        scope.grid1.ixLoadInitialData();
        scope.grid2.ixLoadInitialData();
      }

      scope.cellEditableCondition = function (cell) {
        return !cell.col.colDef.noeditable && (!cell.col.colDef.pk || cell.row.entity.isNew );
      };

      scope.open = function(){
        if(typeof(scope.viewmodel) == "string"){
          scope.viewmodel = scope.viewmodel.split(",");
        }
        if(typeof(scope.pks) == "string"){
          scope.pks = scope.pks.split(",");
        }
        if(!scope.grid1){
          scope.grid1 = gridService.createGrid(scope, scope.viewmodel[0]+"Grid",  { enableCellEdit: true, enableRowSelection: false, enableRowHeaderSelection: false }, scope.viewmodel[0], [{ name: 'Cancelar servicio', type: 'CheckBox' }]);
          scope.grid1.entity = "peticion_servicios/solicitar";

          scope.grid1.ixLoadInitialData = scope.loadPeticionServiciosSolicitar;
          scope.grid1.cellEditableCondition = scope.cellEditableCondition;
        }

        if(!scope.grid2){
          scope.grid2 = gridService.createGrid(scope, scope.viewmodel[1]+"Grid",  { enableCellEdit: true, enableRowSelection: false, enableRowHeaderSelection: false }, scope.viewmodel[1],  [{ name: 'Asignar accesorio', type: 'CheckBox' }]);
          scope.grid2.entity = "peticion_servicios/accesorios";
          scope.grid2.ixLoadInitialData = scope.loadPeticionServiciosAccesorios;
          scope.grid2.cellEditableCondition = scope.cellEditableCondition;
        }

        if(!scope.grid3){
          scope.grid3 = gridService.createGrid(scope, scope.viewmodel[1]+"Grid",  { enableCellEdit: false, enableRowSelection: false, enableRowHeaderSelection: false }, scope.viewmodel[2]);
          scope.grid3.entity = "peticion_servicios/historico";
          scope.grid3.ixLoadInitialData = scope.loadPeticionServiciosHistorico;
          scope.grid3.ixLoadInitialData();
        }

        scope.titleVal = scope.$parent.row.entity[scope.pks[0]];
        $uibModal.open({
					templateUrl: 'Extranet/Peticion_servicios_popup.html?'+v,
					size: 'big',
          scope: scope
				});
      };

      scope.save = function(){
        scope.idServicios = new Array();
        scope.grid1.data.forEach(function(rowOri){
          var cancelado = false;
          scope.grid1.gridApi.rowEdit.getDirtyRows().forEach(function(rowMod){
            if(rowOri.trabajo == rowMod.entity.trabajo && rowMod.entity["Cancelar servicio"] == true){
              cancelado = true;
            }
          });
          if(!cancelado){
            scope.idServicios.push(rowOri.trabajo);
          }
        });
        scope.grid2.gridApi.rowEdit.getDirtyRows().forEach(function(rowMod){
          if(rowMod.entity["Asignar accesorio"] == true){
            scope.idServicios.push(rowMod.entity.trabajo);
          }
        });
        if(scope.idServicios.length > 0){
          var urlAttr = "?VIN="+scope.$parent.row.entity["VIN"]+"&grupo="+scope.$parent.row.entity["Grupo"]+"&movimiento="+scope.$parent.row.entity["Movimiento"];
          $http.post(cfg.baseURL + "peticion_servicios/Set"+urlAttr, { idServicios: scope.idServicios }).then(function(response){
            //Show success
            scope.grid1.ixLoadInitialData();
            scope.grid2.ixLoadInitialData();
            scope.grid3.ixLoadInitialData();
            if(ixStatusService.current.data != null)
              ixStatusService.current.data.grid.ixLoadInitialData();

          }, function(response){
            //Show error.


          });
        }
      }
    }
  }
}]);*/
//Botonets d'acció en general.
angular.module("gp4App").directive('ixAccion', [ '$timeout', 'ixStatusService', '$uibModal', 'cfg', function($timeout, ixStatusService, $uibModal, cfg) {
  return {
    restrict: 'A',
    scope: {
      'item': '=',
      'accion': '=',
			'itemAux': '=?'
    },
    link: function(scope, elem, attrs){
      elem.addClass("accion");
      elem.on('click', function(event){

				if(angular.isFunction(scope.item)){
					if(angular.isDefined(scope.itemAux)){
						scope.item = scope.item(scope.itemAux);
					} else {
						scope.item = scope.item();
					}
				}

				if((angular.isUndefined(scope.accion.isDisabled)) || (angular.isDefined(scope.accion.isDisabled) && !scope.accion.isDisabled(scope.item))){
					if(scope.accion.accion)
						scope.accion.accion(scope.item);
					else {
						var atributos = {};
						var atributosTitleObj = {};
						var displayAttr = "";
						if(typeof(scope.accion.redirect.atributos) == "string"){
							scope.accion.redirect.atributos = scope.accion.redirect.atributos.split(",");
						}
						if(typeof(scope.accion.redirect.atributosTitle) == "string"){
							scope.accion.redirect.atributosTitle = scope.accion.redirect.atributosTitle.split(",");
						}
						scope.accion.redirect.atributos.forEach(function(valor){
							if (angular.isDefined(scope.item[valor]))
								atributos[valor] = scope.item[valor];
							else
								atributos[valor] = valor;
						});
						scope.accion.redirect.atributosTitle.forEach(function(valor){
							var partsValor = valor.split("$");
							if(partsValor.length > 1){
								displayAttr += " - " + partsValor[0] + " " + scope.item[partsValor[1]];
								atributosTitleObj[partsValor[1]] = scope.item[partsValor[1]];
							}
							else {
								displayAttr += " - " + partsValor[0] + " " + scope.item[partsValor[0]];
								atributosTitleObj[partsValor[0]] = scope.item[partsValor[0]];
							}
						});
						var app = {};
						var claves = Object.keys(atributos);
						app.icon = scope.accion.redirect.iconBox;
						app.display = scope.accion.title/* + displayAttr*/;
						app.href = scope.accion.redirect.template;
						app.atributos = atributos;
						app.atributosTitle = displayAttr;
						app.atributosTitleObj = atributosTitleObj;
						$timeout(function(){
							ixStatusService.openApp(app).bind(ixStatusService);
						},1);
					}
				}
      });
    }
  }
}]);
//Botonets d'acció dintre d'una grid.
angular.module("gp4App").directive('ixAccionGrid', [ '$timeout', 'ixStatusService', '$uibModal', 'cfg', function($timeout, ixStatusService, $uibModal, cfg) {
  return {
    restrict: 'EA',
    scope: {
      'index': '@'
    },
    template: '<span title="{{ accionDef.title || accionDef.titleFunction(entity) }}" ng-show="visibleFunction(entity) || visibleFunction == undefined" ng-dblclick="actionFunction(entity)">'+
		'<i ng-style="getStyleFunction(entity)" ng-show="!accionDef.customType" ng-click="actionFunction(entity)" class="fa fa-fw" ng-class="accionDef.icon" ></i>'+
		'<img ng-style="getStyleFunction(entity)" ng-if="accionDef.customType" ng-click="actionFunction(entity)" ng-src="{{ accionDef.icon }}" />'+
		'<span ng-show="showBadgeFunction(entity) && showBadgeFunction(entity) != 0" class="badge">{{ showBadgeFunction(entity) }}</span><span ng-show="accionDef.showValueFunction(entity)">{{ accionDef.showValueFunction(entity) }}</span></span>',
    controller: function($scope){
      var colDef = $scope.$parent.col.colDef;
      var row = $scope.$parent.row;
			$scope.accionDef = colDef.acciones[$scope.index];
			$scope.entity = row.entity;
      //si es visible.
      if($scope.accionDef.visible){
        $scope.visibleFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          return $scope.accionDef.visible($scope.entity);
        };
      }
      //si ha de mostrar alguna mena de contador.
      if($scope.accionDef.showBadge){
        $scope.showBadgeFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          return $scope.accionDef.showBadge($scope.entity);
        };
      }
      //Si te algun estil especial aplicat desde el controller.
      if($scope.accionDef.getStyle){
        $scope.getStyleFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          return $scope.accionDef.getStyle($scope.entity);
        };
      }
      //Si el titol s'ha de calcular al controller mitjançant alguna funció.
      if($scope.accionDef.titleFunction && typeof $scope.accionDef.titleFunction == 'function'){
        $scope.titleFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          return $scope.accionDef.titleFunction($scope.entity);
        }
      }
      //Si el valor s'ha de calcular al controller mitjançant alguna funció.
      if($scope.accionDef.showValueFunction && typeof $scope.accionDef.showValueFunction == 'function'){
        $scope.showValueFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          return $scope.accionDef.showValueFunction($scope.entity);
        }
      }
			if($scope.accionDef.accion) {
				//$scope.actionFunction = $scope.accionDef.accion.bind($scope.accionDef);
        $scope.actionFunction = function(){
          $scope.entity = $scope.$parent.row.entity;
          if($scope.$parent.row.grid.options.ixIsLoading == false){
            //$scope.accionDef.accion($scope.entity).bind($scope.accionDef);
            $timeout(function(){$scope.accionDef.accion($scope.entity, $scope.$parent.col.grid);})  // dejamos un tick para que la celda que contiene la accion pueda recibir el focus
          }
        };
      } else if($scope.accionDef.redirect){
        var atributos = {};
        var displayAttr = "";
        if(typeof($scope.accionDef.redirect.atributos) == "string"){
          $scope.accionDef.redirect.atributos = $scope.accionDef.redirect.atributos.split(",");
        }
        if(typeof($scope.accionDef.redirect.atributosTitle) == "string"){
          $scope.accionDef.redirect.atributosTitle = $scope.accionDef.redirect.atributosTitle.split(",");
        }
        $scope.actionFunction = function() {
          $scope.entity = $scope.$parent.row.entity;
          if($scope.$parent.row.grid.options.ixIsLoading == false){
            $scope.accionDef.redirect.atributos.forEach(function(valor){
              atributos[valor] = $scope.entity[valor];
            });
            $scope.accionDef.redirect.atributosTitle.forEach(function(valor){
              displayAttr += " - " + valor + " " + $scope.entity[valor];
            });
            var app = {};
            var claves = Object.keys(atributos);
            app.icon = $scope.accionDef.redirect.iconBox;
            app.display = $scope.accionDef.title + displayAttr;
            app.href = $scope.accionDef.redirect.template;
            app.atributos = atributos;
						app.multiple = $scope.accionDef.redirect.multiple;
						if(angular.isDefined($scope.accionDef.redirect.onCloseGoTo))
							app.onCloseGoTo = $scope.accionDef.redirect.onCloseGoTo;

            ixStatusService.openApp(app).bind(ixStatusService);
          }
        };
			} else {
				$scope.actionFunction = function() {
          var currentStatus = ixStatusService.current.editing;
          $scope.entity = $scope.$parent.row.entity;
          if($scope.$parent.row.grid.options.ixIsLoading == false){
            $uibModal.open({
              templateUrl: $scope.accionDef.template,
              size: $scope.accionDef.size ? $scope.accionDef.size : 'big',
              scope: $scope,
              backdrop: 'static',
              keyboard: false
            }).result.then(function(response){
              if(cfg.clientId == "Extranet"){
                ixStatusService.setEditing(currentStatus);
              }
              if(angular.isDefined($scope.accionDef.onClose)){
                $scope.accionDef.onClose(response);
              }
            });
          }
				};
			}
    }
  }
}]);

//Botonets d'acció dintre d'una grid.
angular.module("gp4App").directive('ixAccionDynamicGrid', [ '$timeout', 'ixStatusService', '$uibModal', 'cfg', function($timeout, ixStatusService, $uibModal, cfg) {
  return {
    restrict: 'EA',
    scope: {
      'index': '@'
    },
    template: '<span><span title="{{ accion.title }}" ng-repeat="accion in buildIconsFunction(entity)"><i ng-click="accion.accion(entity, accion.id)" class="fa fa-fw {{ accion.icon }}"></i></span></span>',
    controller: function($scope, $element){
      var colDef = $scope.$parent.col.colDef;
      var row = $scope.$parent.row;
			$scope.accionDef = colDef.acciones[$scope.index];
			$scope.entity = row.entity;

			if(angular.isFunction($scope.accionDef)){
				$scope.buildIconsFunction = function(){
					$scope.entity = $scope.$parent.row.entity;
					var accionesAux = $scope.accionDef($scope.index, $scope.entity);

					if(!angular.equals($scope.acciones, accionesAux))
						$scope.acciones = accionesAux;

					return $scope.acciones;
				};
			}
    }
  }
}]);

angular.module("gp4App").directive('ixDetalle', [ 'ixStatusService', '$httpParamSerializer', function(ixStatusService, $httpParamSerializer){
  return {
    restrict: 'E',
    template: '<div ng-dblclick="goTo()" class ="ui-grid-cell-contents"><i ng-click="goTo()" title="Ver detalles" class="fa fa-fw fa-window-maximize"></i></div>',
    link: function(scope, element, attr){
      scope.goTo = function(){
        var atributos = {};
        scope.atributos = attr.atributos.split(",");
        scope.atributos.forEach(function(valor){
          atributos[valor] = scope.row.entity[valor];
        });
        var item = {};
        var claves = Object.keys(atributos);
        item.display = attr.title + " - " + claves[0] + atributos[claves[0]];
        item.href = attr.url;
        item.atributos = atributos;

        ixStatusService.openApp(item);
      }
    }
  };
}]);

angular.module("gp4App").directive('ixDatetimeGridGenerada', [ 'ixStatusService', function(ixStatusService){
  return {
    scope: {
      grid: '='
    },
    template: "<div style=\"display: block; width:100%;\">"+
    "<span style=\"display: block; float: left;\">{{'search.totalItems' | t}} {{grid.gridApi.grid.rows.length}}</span>"+
    "<span style=\"display: block; float: left;\" ng-if=\"grid.gridApi.grid.renderContainers.body.visibleRowCache.length !== grid.gridApi.grid.rows.length\" class=\"ngLabel\">&nbsp({{\"search.showingItems\" | t}} {{grid.gridApi.grid.renderContainers.body.visibleRowCache.length}} | Filtros Activos: <span style=\"font-weight: bold;font-style: italic;\">{{grid.ixFilteredColumns}}</span>)</span>"+
    //"<span style=\"display: block; float: left;\" ng-if=\"grid.gridApi.grid.renderContainers.body.visibleRowCache.length !== grid.gridApi.grid.rows.length\" class=\"ngLabel\">(Filtros Activos: <span style=\"font-weight: bold;font-style: italic;\">{{grid.ixFilteredColumns}}</span>)</span>"+
    "<span style=\"display: block; float:right;\" ng-if=\"grid.generadaEl\"><translate translate-value-generadael=\"{{grid.generadaEl}}\">{{ 'Información generada el \\{\\{ generadael \\}\\}' }}</translate> - <a ng-click=\"actualizar()\"><translate>Actualizar</translate></a></span>"+
    "</div>",
    link: function(scope, ele, attrs){
      //scope.grid = ixStatusService.current.data.grid;
      scope.actualizar = function(){
        if(ixStatusService.current.editing && scope.grid.numberOfChanges() > 0){
          scope.grid.ixCancelEdit();
        } else {
          scope.grid.ixLoadInitialData();
        }
      }
    }
  }
}]);

angular.module('gp4App').directive('ixGridMultipleSelect', [ function() {
  return {
		scope: {
      ngModel: '=',
      valor: '@'
    },
    require: 'ngModel',
    replace: true,
    template: '<div><i ng-click="showModalSelection()" class="fa fa-search">{{ valor }}</div>',
    controller: 'ixGridMultipleSelectController'
  };
}]).controller('ixGridMultipleSelectController', ['$scope','$compile','$timeout', '$uibModal', '$filter', 'cfg', 'ivhTreeviewMgr', 'ixStatusService', 'uiGridEditConstants', '$element', function( $scope, $compile, $timeout, $uibModal, $filter, cfg, ivhTreeviewMgr, ixStatusService, uiGridEditConstants, $element ) {
  var ngModel = $element.controller('ngModel');
  $scope.selectedOptions = $scope.valor;
  $scope.searchvalue = "";
  var allOptionValues = [];
  $scope.showModalSelection = function() {
		$uibModal.open({
			templateUrl: "ixGridMultipleSelectModal.html",
			scope: $scope,
      backdrop: 'static',
      keyboard: false
		}).result.then(function(){
  		var selectedValues = [];
			allOptionValues.forEach( function( val ) {
				if(val.selected) {
					selectedValues.push( val.id );
				}
				val.children.forEach(function(v2) {
					v2.children.forEach(function(v3) {
						if(v3.selected){
							selectedValues.push(v3.id);
						}
					});
				});
			});
      $scope.selectedOptions = selectedValues.join(',');
			if(selectedValues.length == 0)
				ngModel.$setViewValue(null);
			else
      	ngModel.$setViewValue($scope.selectedOptions);

      $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
		});

    var distinctValues = {};
    $scope.optionValues = [];
    var selectedValues = [];
    if($scope.selectedOptions) {
      selectedValues=$scope.selectedOptions.split(",");
    }
    var lookupresultfields = $scope.$parent.col.colDef.LookUpResultFields;
    angular.forEach($scope.$parent.col.colDef.allFkObjects, function(obj){
      var value = "";
      var clave = "";
      angular.forEach(lookupresultfields, function(lookupresultfield){
        if(value !== "") value = value + " - ";
        value = value + obj[lookupresultfield];
        clave = obj[$scope.$parent.col.colDef.LookUpKeyFields[0]];
      });
      distinctValues[value]=true;
      var selected = (selectedValues.indexOf(clave)>=0 || selectedValues.indexOf(clave.toString())>=0);
      allOptionValues.push({id:clave, label:value, selected:selected, children:[]});
    });

    $scope.updateListValues();
    //Sort recursive.
    sortListOfValues($scope.optionValues);
  };

  var sortListOfValues = function(listOfValues){
    //Si l'array actual només conté 1 objecte i aquest objecte té més d'un fill, ordenem els fills de l'objecte.
    if(listOfValues.length == 1 && hasChildrenToSort(listOfValues[0])){ sortListOfValues(listOfValues[0].children); }

    listOfValues.sort(function(a,b){
      //Ordenem els fills de l'objecte que estem comparant (si n'hi han).
      if(hasChildrenToSort(a)){
        sortListOfValues(a.children);
      }
      if(hasChildrenToSort(b)){
        sortListOfValues(b.children);
      }
      //return (a.label>b.label)-(a.label<b.label);
      return (a.id>b.id)-(a.id<b.id);
    });
  };

  var hasChildrenToSort = function(obj){
    return obj.children && obj.children.length > 1;
  };

  $scope.updateListValues = function(){
    $scope.optionValues = [];
    var max = (allOptionValues.length < 100 ? allOptionValues.length : 100);
    
    for(var i = 0; $scope.optionValues.length < max; i++){
      if(i > allOptionValues.length)
        break;
      var optionValue = allOptionValues[i];
      if(angular.isDefined(optionValue)){
        if(optionValue.label.toUpperCase().lastIndexOf($scope.searchvalue.toUpperCase()) != -1)
          $scope.optionValues.push(optionValue);
      }
    }
  };

	$scope.selectAll = function() {
    var matchingValues = [];
    if($scope.searchvalue != null){
      angular.forEach($scope.optionValues, function(value){
        if(value.label.toUpperCase().indexOf($scope.searchvalue.toUpperCase()) !== -1){
         matchingValues.push(value);
        }
      });
      ivhTreeviewMgr.selectAll(matchingValues);
    } else {
      ivhTreeviewMgr.selectAll($scope.optionValues);
    }

  };

  $scope.deselectAll = function() {
		ivhTreeviewMgr.deselectAll($scope.optionValues);
		$scope.col.filters[0].filtervalue = "";
  };

}]);

angular.module('gp4App').directive('ixGridListSelectOld', [ function() {
  return {
		scope: {
      ngModel: '=',
      valor: '@'
    },
    require: 'ngModel',
    replace: true,
    template: '<div><i ng-click="showModalSelection()" class="fa fa-search">{{ valor }}</div>',
    controller: 'ixGridListSelectOLDController'
  };
}]).controller('ixGridListSelectOLDController', ['$scope','$compile','$timeout', '$uibModal', '$filter', 'cfg', 'ivhTreeviewMgr', 'ixStatusService', 'uiGridEditConstants', '$element','$http', function( $scope, $compile, $timeout, $uibModal, $filter, cfg, ivhTreeviewMgr, ixStatusService, uiGridEditConstants, $element, $http ) {
  var ngModel = $element.controller('ngModel');
  $scope.selectedOptions = $scope.valor;
  $scope.searchvalue = "";
  $scope.title_param = $scope.$parent.$parent.col.name;
  $scope.showModalSelection = function() {
		$scope.modalInstance = $uibModal.open({
			templateUrl: "ixGridListSelectModal.html",
			scope: $scope,
      backdrop: 'static',
      keyboard: false
		});
    $scope.modalInstance.result.then(function(){      
  		var selectedValues = [];
			$scope.optionValues.forEach( function( val ) {
				if(val.selected) {
					selectedValues.push( val.id );          
				}
				val.children.forEach(function(v2) {
					v2.children.forEach(function(v3) {
						if(v3.selected){
							selectedValues.push(v3.id);
						}
					});
				});
			});
      
      $scope.selectedOptions = selectedValues.join(',');
      if(selectedValues.length == 0)
        ngModel.$setViewValue(null);
      else
        ngModel.$setViewValue($scope.selectedOptions);

      $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);      
		});

    var distinctValues = {};
    $scope.optionValues = [];
    var selectedValues = [];
    if($scope.selectedOptions) {
      selectedValues=$scope.selectedOptions.split(",");
    }    

    //llamada API en base a la metadata
    var param = {Filters:[],OrderBy:[]};    
    if($scope.$parent.col.colDef.LookUpKeyFields){
      param.Filters = $scope.$parent.col.colDef.LookUpKeyFields.map(function (c, ii, aa) {
      //Filtrem per clau composta només quan té valor.
        if(ii!==$scope.$parent.col.colDef.LookUpKeyFields.length-1) {
          // no importa l'ordre de les columnes, agafarà el valor que es demana per metadata
          // PREMISA: pos(KeyField)===pos(LookupKeyField).
          var tblName = "";
          /*if(!scope.skipTableNameFilter && scope.entity){
            tblName = scope.entity+".";
          }*/
          return {Field: tblName + c, Value: $scope.$parent.row.entity[$scope.$parent.col.colDef.KeyFields[ii]], Operator: CMP_EQ};
        }
      });
      param.Filters.pop();
    }
    $http.post(cfg.baseURL + $scope.$parent.col.colDef.LookUpTableName + "/Search?ItemsPerPage=9999", param).then(function(response){      
      var lookupresultfields = $scope.$parent.col.colDef.LookUpResultFields;      
      angular.forEach(response.data.Items, function(obj){
        var value = "";
        var clave = "";
        angular.forEach(lookupresultfields, function(lookupresultfield){
          if(value !== "") value = value + " | ";
          if ($scope.$parent.col.colDef.LookUpTableName == "stock_taller_ubica" && lookupresultfield == "stock"){
            value = value + "Stock: " + obj[lookupresultfield];
          }
          else {
            value = value + obj[lookupresultfield];
          }       

          //clave = obj[$scope.$parent.col.colDef.LookUpKeyFields[0]];
          clave = obj[$scope.$parent.col.colDef.LookUpKeyFields[$scope.$parent.col.colDef.LookUpKeyFields.length-1]]
        });
        distinctValues[value]=true;
        var selected = (selectedValues.indexOf(clave)>=0 || selectedValues.indexOf(clave.toString())>=0);
        $scope.optionValues.push({id:clave, label:value, selected:selected, children:[], entity: obj});
      });

      //Sort recursive.
      sortListOfValues($scope.optionValues);
    }); 
    
    $scope.accionesToolBar = [];
    if ($scope.$parent.col.colDef.LookUpTableName == "stock_taller_ubica") {
      $scope.accionesToolBar = [
        {
          title: 'Asignar Nueva Ubicación',
          isVisible: function(item){
            return true;
          },          
          accion: function(entity){
            
          }
        },
        {
          title: 'Desasignar Ubicación',
          isVisible: function(item){
            var visible = false;
            $scope.optionValues.forEach( function( val ) {
              if(val.selected) {
                selectedValues.push( val.id );
                if(val.entity.stock == 0)
                  visible = true;
              }              
            });
            return visible;
          },          
          accion: function(entity){
            
          }
        }
      ];
    }

    $scope.aplicarSeleccion = function() {
      var continuar = true;
      $scope.optionValues.forEach( function( val ) {
				if(val.selected) {
					selectedValues.push( val.id );
          if(val.entity.stock == 0)
            continuar = false;
				}
				val.children.forEach(function(v2) {
					v2.children.forEach(function(v3) {
						if(v3.selected){
							selectedValues.push(v3.id);
						}
					});
				});
			});
      if (continuar)
        $scope.modalInstance.close();
        //modalInstance.close();
        
    }    
  };

  var sortListOfValues = function(listOfValues){
    //Si l'array actual només conté 1 objecte i aquest objecte té més d'un fill, ordenem els fills de l'objecte.
    if(listOfValues.length == 1 && hasChildrenToSort(listOfValues[0])){ sortListOfValues(listOfValues[0].children); }

    listOfValues.sort(function(a,b){
      //Ordenem els fills de l'objecte que estem comparant (si n'hi han).
      if(hasChildrenToSort(a)){
        sortListOfValues(a.children);
      }
      if(hasChildrenToSort(b)){
        sortListOfValues(b.children);
      }
      //return (a.label>b.label)-(a.label<b.label);
      return (a.id>b.id)-(a.id<b.id);
    });
  };

  var hasChildrenToSort = function(obj){
    return obj.children && obj.children.length > 1;
  };

	$scope.selectAll = function() {
    var matchingValues = [];
    if($scope.searchvalue != null){
      angular.forEach($scope.optionValues, function(value){
        if(value.label.toUpperCase().indexOf($scope.searchvalue.toUpperCase()) !== -1){
         matchingValues.push(value);
        }
      });
      ivhTreeviewMgr.selectAll(matchingValues);
    } else {
      ivhTreeviewMgr.selectAll($scope.optionValues);
    }

  };

  $scope.deselectAll = function() {
		ivhTreeviewMgr.deselectAll($scope.optionValues);
		$scope.col.filters[0].filtervalue = "";
  };

  $scope.selectionChanged = function(ivhNode, ivhIsSelected, ivhTree){    
    if(ivhIsSelected){
      ivhTreeviewMgr.selectAll($scope.optionValues);
      ivhTreeviewMgr.deselectAll($scope.optionValues);
      ivhTreeviewMgr.selectEach(ivhTree, [ivhNode]);
    }    
  };

}]);

angular.module('gp4App').directive('ixGridUrl', ['uiGridEditConstants', function(uiGridEditConstants) {
  return {
		scope: {
      ngModel: '=',
      valor: '@'
    },    
    require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
    replace: true,    
    template: '<span ng-show="ngModel" title="Abrir en nueva pestaña" ng-dblclick="abrirURL()"><i ng-click="abrirURL()" class="fa fa-fw fa-external-link"></i></span>',
    controller: [ "$scope", "$element", "$window", function($scope, $element, $window){
      $scope.abrirURL = function(){
        var ngModel = $element.controller('ngModel');
        var url = ngModel.$modelValue;
        $window.open(url, '_blank');
      };
    }]
  };
}]);

angular.module('gp4App').directive('ixGridListSelect', ['uiGridEditConstants', function(uiGridEditConstants) {
  return {
		scope: {
      ngModel: '=',
      valor: '@'
    },    
    require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
    replace: true,    
    template: '<p class="input-group"><input type="text" style="background-color: white; width: 100%;" ng-model="ngModel" readonly="true"/><span class="input-group-btn" style="padding: 0px;"><span class="btn btn-default" ng-click="showModalSelection()"><i class="glyphicon glyphicon-search"></i></span></span></p>',
    controller: 'ixGridListSelectController'    
  };
}]).controller('ixGridListSelectController', ['$scope','$compile','$timeout', '$uibModal', '$filter', 'cfg', 'ixStatusService', 'uiGridEditConstants', '$element','$http', 'gridService', 'uiGridConstants', 'ixUtilsService', '$ngConfirm', 
                function( $scope, $compile, $timeout, $uibModal, $filter, cfg, ixStatusService, uiGridEditConstants, $element, $http, gridService, uiGridConstants, ixUtilsService, $ngConfirm ) {   
  var ngModel = $element.controller('ngModel');  
  var input = $element.children(0);  

  //ini modal
  $scope.title_param = $scope.$parent.$parent.col.name;
  $scope.showModalSelection = function() {
		$scope.modalInstance = $uibModal.open({
			templateUrl: "ixGridListSelectModal.html",
			scope: $scope,
      backdrop: 'static',
      keyboard: false      
		});
    $scope.modalInstance.result.then(function(){        		
      ngModel.$setViewValue($scope.ngModel);
      //$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);      //pasa por "closed" siempre
		});  
    $scope.modalInstance.closed.then(function(){
      $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);      
    });     
    
    //ini grid
    $scope.gridManualLoad = true;
    if(!$scope.gridBusqueda){
      //TODO: EN UN FUTUR aquet acciones tindria que estar en un FACTORY i seleccionar segons el LookUpTableName
      var acciones = [
        {
          icon: "fa-hand-pointer-o",
          title: "Seleccionar",
          visible: function(entity){
            var validValue = true;            
            if ($scope.$parent.col.colDef.LookUpTableName == "stock_taller_ubica") {
              if(entity["stock"] == 0 && !$scope.$parent.col.colDef.GridListSelectConditions.permiteStock0)
                validValue = false;
            }
            return validValue;   
          },
          accion: function(entity){ 
            var resultValue = entity[$scope.$parent.col.colDef.LookUpKeyFields[$scope.$parent.col.colDef.LookUpKeyFields.length-1]];          
            $scope.ngModel = resultValue;                          
            $scope.modalInstance.close();
            return true;            
          }
        }
      ];

      var visibleCols = ["ubicacion","stock"];
      var filtersApi = [];                        
      $scope.gridBusqueda = gridService.createGrid($scope, "selectFromGrid_"+$scope.$parent.col.colDef.LookUpTableName+"Grid",  { minRowsToShow: 5, enableHorizontalScrollbar: 2, enableRowSelection: false, enableRowHeaderSelection: false, enableFiltering: true, showOnlyDescribedCols: visibleCols, enableCellEdit: false, filtersAPI: filtersApi }, $scope.$parent.col.colDef.GridListSelectConditions.metadataEntity, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);				
      $scope.gridBusqueda.entity = $scope.$parent.col.colDef.LookUpTableName;      

    } else {
      $scope.gridBusqueda = gridService.createGridFunctions($scope, $scope.gridBusqueda);
      $scope.gridBusqueda.ixRestoreConfig();      
    }  
    
    var param = {Filters:[],OrderBy:[]};        
    if($scope.$parent.col.colDef.LookUpKeyFields){
      param.Filters = $scope.$parent.col.colDef.LookUpKeyFields.map(function (c, ii, aa) {
      //Filtrem per clau composta només quan té valor.
        if(ii!==$scope.$parent.col.colDef.LookUpKeyFields.length-1) {
          // no importa l'ordre de les columnes, agafarà el valor que es demana per metadata
          // PREMISA: pos(KeyField)===pos(LookupKeyField).
          var tblName = "";
          /*if(!scope.skipTableNameFilter && scope.entity){
            tblName = scope.entity+".";
          }*/
          return {Field: tblName + c, Value: $scope.$parent.row.entity[$scope.$parent.col.colDef.KeyFields[ii]], Operator: CMP_EQ};
        }
      });
      param.Filters.pop();
    }
    param = param.Filters.concat($scope.$parent.col.colDef.LookUpConditions.map(function(c){return {Field:c.KeyField,Value:c.Value,Operator:c.Operator||CMP_EQ};}));
    $scope.gridBusqueda.filtroExterno = param;
    $scope.gridBusqueda.ixLoadInitialData();

    $scope.accionesToolBar = [];


    $scope.$on("$destroy", function() {    
      $scope.gridBusqueda.ixSaveConfig();
      $scope.isDestroyed=true;
    });
  };    
  //fin modal
  
  //init events grid
  $timeout(function(){
    input.focus();
  }); 
  
  input.on('blur',function(event){
    var newVal = event.target.value;
    if(angular.isDefined(newVal)){
      $scope.dataChanged(event, input);              
    } 
    
  });
  $scope.dataChanged = function (event, input) {
    if((!event.relatedTarget) || !event.relatedTarget.closest(".ui-grid-cell") || $element.closest(".ui-grid-cell").attr("id") !== angular.element(event.relatedTarget).attr("id")) {
      $scope.done = true;
      $scope.changed = false;
      $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
    }
  };   
  //fin events grid

}]);
/////

angular.module('gp4App').directive('ixGridSelect', [ 'gridService', '$uibModal', 'ixStatusService', 'uiGridEditConstants', 'uiGridConstants', '$timeout', function(gridService, $uibModal, ixStatusService, uiGridEditConstants, uiGridConstants, $timeout) {
  return {
    restrict: 'EA',
		scope: {
      ngModel: '=',
      valor: '@'
    },
    require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
    template: '<p class="input-group"><input style="width:calc(100% - 20px);" type="text" ng-model="ngModel" ix-number><i style="text-align:center;width:20px;" ng-click="showModalSelection()" class="fa fa-search"></i></input></p>',
    link: function(scope, elem, attrs, controllers) {
      var uiGridCtrl, renderContainerCtrl, ngModelController;
      if (controllers[0]) { uiGridCtrl = controllers[0]; }
      if (controllers[1]) { renderContainerCtrl = controllers[1]; }
      if (controllers[2]) { ngModelController = controllers[2]; }
      var input = elem.children(0).children(0);

      scope.selectedOptions = scope.valor;
      scope.searchvalue = "";
      scope.showModalSelection = function() {
        scope.modalDialog = $uibModal.open({
          templateUrl: "ixGridSelectModal.html",
          scope: scope,
          size: "big",
          backdrop: 'static',
          keyboard: false
        });
        scope.modalDialog.result.then(function(){
          ngModelController.$setViewValue(scope.ngModel);
          $timeout(function(){
            input.focus();
          });
          //scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
        });
      };

      if(!scope.gridSeleccion){
        scope.accionesToolBar = [];

        var acciones = [
          {
            icon: "fa-eye",
            title: "Seleccionar",
            accion: function(entity){
              if(scope.$parent.col.colDef.LookUpTableName == "operaciones"){
                scope.ngModel = entity.operacion;
              } else if(scope.$parent.col.colDef.LookUpTableName == "stock_taller_ubica"){
                scope.ngModel = entity.ubicacion;
              }

              //El valor que ensenyarem serà el valor que té el ngModel a no ser que definim una funció i la passem com a ng-value-func.
              setValue(entity);
              scope.modalDialog.close();
              return true;
            }
          }
        ];

        var visibleCols = [];
        var filtersApi = [];
				var params = [];
        //var visibleCols = (scope.showOnlyDescribedCols) ? scope.showOnlyDescribedCols : [];
        //var filtersApi = ($scope.filtersApi) ? $scope.filtersApi : [];

        //
        //No es poden accedir propietats de l'objecte colDef del angular-ui-grid.
        //
        if(scope.$parent.col.colDef.LookUpTableName == "operaciones"){
          visibleCols = [ 'operacion', 'medio', 'fecha', 'fechape', 'estado', 'barco', 'linea', 'num_viaje', 'num_atraque', 'num_carpeta' ];
          filtersApi = [{ field: "fecha", type: "Fecha"}];
					params = scope.$parent.col.colDef.LookUpConditions.map(function(c){return {Field:c.KeyField,Value:c.Value,Operator:c.Operator||CMP_EQ};});					
        }
        if(scope.$parent.col.colDef.LookUpTableName == "stock_taller_ubica"){
          visibleCols = [ 'almacen_nombre', 'ubicacion', 'stock' ];          
					params = scope.$parent.col.colDef.LookUpConditions.map(function(c){return {Field:c.KeyField,Value:c.Value,Operator:c.Operator||CMP_EQ};});					
        }

        scope.gridSeleccion = gridService.createGrid(scope, "selectFromGrid_"+scope.$parent.col.colDef.LookUpTableName+"Grid",  { enableHorizontalScrollbar: 2, enableRowSelection: false, enableRowHeaderSelection: false, enableFiltering: true, showOnlyDescribedCols: visibleCols, enableCellEdit: false, filtersAPI: filtersApi }, scope.$parent.col.colDef.LookUpTableName, [{ name: 'Acciones', type: 'detalle', acciones: acciones }]);				
        scope.gridSeleccion.entity = scope.$parent.col.colDef.LookUpTableName;
				scope.gridSeleccion.filtroExterno = params;
				
      } else {
        scope.gridSeleccion = gridService.createGridFunctions(scope, scope.gridSeleccion);
        scope.gridSeleccion.ixRestoreConfig();
      }

      var setValue = function(entity){
        scope.valor = scope.ngModel;
      };

      $timeout(function(){
        input.focus();
      });

      //
      input.on('keydown', function (evt) {
        switch (evt.keyCode) {
          case uiGridConstants.keymap.ESC:
            evt.stopPropagation();
            scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
            break;
        }
/*
        if (scope.deepEdit &&
          (evt.keyCode === uiGridConstants.keymap.LEFT ||
           evt.keyCode === uiGridConstants.keymap.RIGHT ||
           evt.keyCode === uiGridConstants.keymap.UP ||
           evt.keyCode === uiGridConstants.keymap.DOWN)) {
          evt.stopPropagation();
        } */
        // Pass the keydown event off to the cellNav service, if it exists
        //else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
		if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {			
          evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
          if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
            scope.stopEdit(evt);
          }
        }
        else {
          //handle enter and tab for editing not using cellNav
          switch (evt.keyCode) {
            case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
            case uiGridConstants.keymap.TAB:
              evt.stopPropagation();
              evt.preventDefault();
              scope.stopEdit(evt);
              break;
          }
        }

        return true;
      });


      scope.stopEdit = function (evt) {
        if (scope.inputForm && !scope.inputForm.$valid) {
          evt.stopPropagation();
          scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
        }
        else {
          scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
        }
        scope.deepEdit = false;
      };
      //

      input.on('blur',function(event){
        //scope.ngModel = new Date(year, month-1, day);

        $timeout(function(){
          scope.dataChanged(event, input);
          scope.$apply();
        });
      });

      scope.dataChanged = function (event, input) {
        if((!event.relatedTarget) || !event.relatedTarget.closest(".ui-grid-cell") || elem.closest(".ui-grid-cell").attr("id") !== angular.element(event.relatedTarget).attr("id")) {
          scope.done = true;
          scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
        }
      };
    }
  };
}]);


/////
angular.module('gp4App').directive('ixUiColorGridCell', [ function(){
  return {
    restrict: 'A',
		require: '?ngModel',
		scope: {
			ngModel: '=',
			col: '='
		},
		template: '<div class="text-muted"><label class="colorPreview" ng-class="{ \'full-cell\' : hideDesc }" ng-style="getHTMLColor()"></label><span ng-show="!hideDesc">{{selectedColor.name}}</span></div>',
    link: function(scope, elem, attrs){
			scope.hideDesc = scope.col.colDef.hideDesc;
      scope.getHTMLColor = function(){
        scope.selectedColor = scope.col.colDef.colors.find(function(e){ return e.color == scope.ngModel;});
				var resultado = {};
				if(angular.isDefined(scope.selectedColor))
					resultado = { 'background-color': scope.selectedColor.visual };
        return resultado;
      };
    }
  }
}]);

/* Filtro para mostar descripciones de las FK */
angular.module("gp4App").filter('gridfk', [ 'cfg', function(cfg) {
	return function(input, row, col) {

    if(angular.isDefined(row)){
      if(!col || !col.colDef.allFkObjects) {
        return "...";	// mentre no estigui carregat
      }

      // indice de la columna en la grid
      var colIndex = col.grid.columns.findIndex(function(e) {return e.field === col.field;});

      // construimos la clave para la cache de descripciones
      var lookupKey = col.colDef.LookUpKeyFields.reduce(function(prev,curr,idx){
        return prev+"|"+row.entity[col.colDef.KeyFields[idx]];
      },"");

      if(!col.colDef.usedDescriptionsCache) {
        col.colDef.usedDescriptionsCache = {};  // mantememos una cache de lookupKey-descripcion utilizadas
      }
      if(col.colDef.usedDescriptionsCache[lookupKey]) {
        return col.colDef.usedDescriptionsCache[lookupKey]; // cache HIT!
      } else {
        if(angular.isDefined(input) && col.colDef.allFkObjects) {
          var lookupObjects = col.colDef.allFkObjects.filter(function(e,i) {
            var pasa=true;
            col.colDef.LookUpKeyFields.forEach(function(keyField, idx) {              							
							if(row.entity[col.colDef.KeyFields[idx]]!==e[keyField] && angular.isDefined(e[keyField]) && ((e[keyField]!=="") || e[keyField]=="" && col.colDef.LookUpResultFields.length == 1)) {
                pasa = false;
              }
              var objectKeys = Object.keys(e);
              var todoUndefined = true;
              for(var i = 0; i < objectKeys.length; i++){
                if(e[objectKeys[i]])
                  todoUndefined = false;
              }
              if(todoUndefined)
                pasa = false;
            });
            return pasa;
          });
          if(lookupObjects.length>0) {
						var fields = angular.copy(col.colDef.LookUpResultFields);
						if(cfg.dropdownSinCodigo && fields.length > 1)
							fields = fields.slice(0, -1);
            var result = parseObjectsToString(lookupObjects, fields, col.colDef.ColumnFkDescription); //col·lecció d'objectes, camps.
            if(result.length > 1){
              col.colDef.usedDescriptionsCache[lookupKey] = result[0];
            }
              
            else {
              col.colDef.usedDescriptionsCache[lookupKey] = result[0];
            }
              
            return result[0];
          }
					else{
						//console.log("Field:" + col.field + " Entity:" + row.entity.campa + "/" + row.entity.zona + "/" + row.entity.calle + "/" + row.entity.posicion);
					}
        }
      }
    }
  }
}]);
/*jslint browser: true, devel: true, white: true, plusplus: true, vars: true*/
/*eslint angular/di: [2,"array"]*/
/*global angular */
/*global CMP_EQ*/
/*global buildIxSearch*/
angular.module('gp4App').controller('DesktopController', ['$scope', '$rootScope', '$log', '$location', '$http', '$timeout', 'cfg', 'authService', '$window', 'ixStatusService', '$injector', '$uibModal', '$q', function ($scope, $rootScope, $log, $location, $http, $timeout, cfg, authService, $window, ixStatusService, $injector, $uibModal, $q) {
	$scope.extra_desktop_dashboard = cfg.extra_desktop_dashboard;
  $scope.frameClass = 'page-desktop';
	// publiquem tot perquè necessitem accedir a totes les aplicacions (lo normal es publicar ixStatusService.current)
	$scope.status  = ixStatusService;

	$scope.setFav = function (app) {
		app.fav = !app.fav;
    //Agafem només les propietats display, href i icon de les apps favorites.
    var favApps = $scope.status.availApps.filter(function(e){
      return e.fav == true;
    }).map(function(item){
      return { display: item.display, href: item.href, icon: item.icon };
    });
    //Guardar tots els fav a fend_config
    var bodyValue = angular.toJson(favApps);
    $http({
      url: cfg.baseURL+"fend_config/usuario?usuario="+authService.authentication.userName+"&clave=Desktop",
      method: "POST",
      data: bodyValue
    }).then(function(r){
      ixStatusService.setResponse(r);
    });
	};


	$scope.filterFunction = function (filter) {
		if (angular.isObject($scope.appFilter)) {
			if ($scope.appFilter.fav && angular.isDefined($scope.appFilter.fav)) {
				if ($scope.appFilter.$ !== "" && angular.isDefined($scope.appFilter.$)) {
					return filter.fav && filter.display.toLowerCase().lastIndexOf($scope.appFilter.$.toLowerCase()) !== -1;
				}
				return filter.fav;
			} else if ($scope.appFilter.$ !== "" && angular.isDefined($scope.appFilter.$)) {
				if(filter.display.toLowerCase().lastIndexOf($scope.appFilter.$.toLowerCase()) !== -1){
          return true;
        }
			} else {
				return filter.open;
			}
		} else {
			//La vista just s'ha inicialitzat i encara no s'ha introduït cap valor al searchbox.
			//Mostrem només apps obertes.
			return filter.open;
		}
	};

	/* #region Alarmas (FT) */

	$scope.mostrarAlarmas = false;
	$scope.titulosAlarmas = [];
	var usuario = authService.authentication.userName;

	if (cfg.appCliente == "EUROMADI") {
			$scope.titulosAlarmas.push(
			{
				titulo: "Estado fuera de plazo",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Estado fuera de plazo',
					href: 'Alarmas/estado_fuera_plazo',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "Expiración certificados",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Expiración certificados',
					href: 'Alarmas/expiracion_certificados',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "Actualización FT",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Actualización FT',
					href: 'Alarmas/actualizacion_ft',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "Verificación nuevos ingredientes",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Verificación ingredientes',
					href: 'Alarmas/verificacion_ingredientes',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "Certificado fichero obligatorio",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Certificado fichero obligatorio',
					href: 'Alarmas/certificados_ficheros',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "Ingredientes a monitorizar",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'Ingredientes a monitorizar',
					href: 'Alarmas/ingredientes_monitorizar',
					icon: 'person_pin'
				}
			}
		);
		$scope.titulosAlarmas.push(
			{
				titulo: "FT en revisión propietario",
				cantidad: 0,
				mostrar: false,
				app:
				{
					display: 'FT por revisar',
					href: 'Alarmas/ft_revision_propietario',
					icon: 'person_pin'
				}
			}
		);

		$http.get(cfg.baseURL + "extranet_condition_user/" + usuario).then(function (response) {
			$scope.extranetUser = response.data;
			if ($scope.extranetUser.proveedor) {
				$scope.mostrarAlarmas = true;
				$scope.titulosAlarmas[0].mostrar = true;
				$scope.titulosAlarmas[1].mostrar = true;
				$scope.titulosAlarmas[2].mostrar = true;
				$scope.titulosAlarmas[4].mostrar = true;
			}
			if ($scope.extranetUser.cliente) { 
				$scope.mostrarAlarmas = true;
				$scope.titulosAlarmas[0].mostrar = true;
				$scope.titulosAlarmas[1].mostrar = true;
				$scope.titulosAlarmas[2].mostrar = true;
				if ($scope.extranetUser.cliente == 1031)
					$scope.titulosAlarmas[5].mostrar = true;
				$scope.titulosAlarmas[6].mostrar = true;
			}
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		//Cargar counts de alarmas

		$http.post(cfg.baseURL + "alarma_estado_fuera_plazoVM/Count").then(function (response) {
			$scope.titulosAlarmas[0].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		$http.post(cfg.baseURL + "alarma_expiracion_certificadosVM/Count").then(function (response) {
			$scope.titulosAlarmas[1].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		$http.post(cfg.baseURL + "alarma_actualizacion_ftVM/Count").then(function (response) {
			$scope.titulosAlarmas[2].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		$http.post(cfg.baseURL + "alarma_verificacion_nuevo_ingredienteVM/Count").then(function (response) {
			$scope.titulosAlarmas[3].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		$http.post(cfg.baseURL + "alarma_certificado_ficherosVM/Count").then(function (response) {
			$scope.titulosAlarmas[4].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		$http.post(cfg.baseURL + "alarma_ingredientes_monitorizarVM/Count").then(function (response) {
			$scope.titulosAlarmas[5].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});

		var param = { Filters: [{ Field: "estado", Operator: CMP_EQ, Value: "S" }] };
		$http.post(cfg.baseURL + "listado_ftVM/Count", param).then(function (response) {
			$scope.titulosAlarmas[6].cantidad = response.data;
		}, function (error) {
			ixStatusService.setResponse(error);
		});
	}
	else if (cfg.appCliente == "BONPREU") {
		$scope.$on('currentUserLoaded', function () {
			$scope.titulosAlarmas.push(
				{
					titulo: "Estado fuera de plazo",
					cantidad: 0,
					mostrar: false,
					app:
					{
						display: 'Estado fuera de plazo',
						href: 'ListadosAlarmas/estado_fuera_plazo',
						icon: 'person_pin'
					}
				}
			);
			$scope.titulosAlarmas.push(
				{
					titulo: "Expiración certificados proveedores",
					cantidad: 0,
					mostrar: false,
					app:
					{
						display: 'Expiración certificados proveedores',
						href: 'ListadosAlarmas/expiracion_certificados',
						icon: 'person_pin'
					}
				}
			);

			var perfilesUsuario = authService.perfilesUsuario();
			var esProveedor = false;
			var esBpuser = false;

			if (perfilesUsuario.indexOf("usr_proveedor") != -1) esProveedor = true;
			if (perfilesUsuario.indexOf("usr_bp_userkey") != -1) esBpuser = true;

			if (esProveedor || esBpuser) {
				$scope.mostrarAlarmas = true;
				$scope.titulosAlarmas[0].mostrar = true;
				$scope.titulosAlarmas[1].mostrar = true;

				$http.post(cfg.baseURL + "alarmabp_estado_fuera_plazoVM/Count").then(function (response) {
					$scope.titulosAlarmas[0].cantidad = response.data;
				}, function (error) {
					ixStatusService.setResponse(error);
				});

				$http.post(cfg.baseURL + "alarmabp_expiracion_certificadosVM/Count").then(function (response) {
					$scope.titulosAlarmas[1].cantidad = response.data;
				}, function (error) {
					ixStatusService.setResponse(error);
				});
			}
		});

	}

	$scope.openAlarma = function (app) {
		ixStatusService.openApp(app);
	}

	/* #endregion */	

  $scope.appFilter = {};
	var DataService;
	
	if (authService.authentication.isAuth && sessionStorage['force_reset_password'] !== 'true') {
		$timeout(function(){
			DataService = $injector.get("DataService");
			var gridService = $injector.get("gridService");
				
			$http.get(cfg.baseURL + "fend_config_dashboards/dashboards_usuario?usuario=" + authService.authentication.userName + "&modulo=Desktop").then(function (response) {
				$scope.dashboards = response.data;
				angular.forEach($scope.dashboards, function (dashboard) {
						dashboard.isOpen = true;
						dashboard.widgets = angular.fromJson(dashboard.valor);
						angular.forEach(dashboard.widgets, function (widget) {
							widget.modulo = dashboard.modulo;
							DataService.loadWidget($scope, dashboard.modulo, widget);
						});

				});
			});
		},500);
	}

		// FIXME: gridService mira aquesta variable per dedicir si te que fer un Search inicial o no, per els widgets tipus taula s'ha de posar perquè sino fa una crida Serach amb entity "undefinded"
		$scope.gridManualLoad = true;

		$scope.gridsterOptions = {
				margins: [20, 20],
				columns: 4,
				mobileModeEnabled: false,
				draggable: { enabled: false },
				resizable: { enabled: false }
		}

	$scope.openSettings = function(widget){
		var templateUrl = "app/Global/Dashboard/widget_settings_popup.html";
		if(cfg.clientId == "Extranet")
			templateUrl = "app/extranetbase/GEN/Dashboard/widget_settings_popup.html";

				var modalInstance = $uibModal.open({
					//scope: $scope,
					templateUrl: templateUrl,
					controller:['$scope', '$timeout', '$uibModalInstance', 'widget', 'modulo', 'isEditing', function ($scope, $timeout, $uibModalInstance, widget, modulo, isEditing) {
						$scope.isEditing = isEditing;
						$scope.status = { editing: true };
						$scope.ixCancelEdit = undefined;
						$scope.ixAddRow = undefined;
						$scope.formSettings = {
							titulo: widget.titulo,
							subtitulo: widget.subtitulo,
							dataSource: widget.dataSource,
							tipo: widget.tipo,
							filtros: widget.filtros,
							mostrar: widget.mostrar,
							invertir_bar_lin: widget.invertir_bar_lin,
							totales: widget.totales,
							explicativo: widget.explicativo
						};


						//$scope.$watch("dataSourceObj", function(newValue,oldValue){
						$scope.onSelectDataSource = function(newValue){
							if(angular.isDefined(newValue) && !angular.equals(newValue, $scope.oldDataSourceObj)){
								$scope.dataSourceObj = newValue;
								$scope.buildFilters($scope.oldDataSourceObj);
								$scope.oldDataSourceObj = newValue;
							}
						//});
						};

						$scope.buildFilters = function(oldValue){
							if(angular.isDefined($scope.dataSourceObj)){
								if(angular.isUndefined($scope.formSettings.titulo) || $scope.formSettings.titulo == "" || ((angular.isDefined(oldValue)) && oldValue.subtitulo === $scope.formSettings.subtitulo)) $scope.formSettings.titulo = $scope.dataSourceObj.titulo;
								if(angular.isUndefined($scope.formSettings.subtitulo) || $scope.formSettings.subtitulo == "" || ((angular.isDefined(oldValue)) && oldValue.subtitulo === $scope.formSettings.subtitulo)) $scope.formSettings.subtitulo = $scope.dataSourceObj.subtitulo;
								$scope.formSettings.mostrar = $scope.dataSourceObj.mostrar;
								$scope.formSettings.invertir_bar_lin = $scope.dataSourceObj.invertir_bar_lin;
								$scope.formSettings.totales = $scope.dataSourceObj.totales;
								$scope.formSettings.explicativo = $scope.dataSourceObj.explicativo;
								//Construim filtres del widget.
								if(angular.isDefined(oldValue) || angular.isUndefined($scope.formSettings.filtros)){
									$scope.formSettings.filtros = [];
									var filtros = $scope.dataSourceObj.filtros.split(",");
									angular.forEach(filtros, function(filtro, i){
										var filterInfo = filtro.split("$");
										var tipo = "";
										var multiple = false;
										if(filterInfo[0].lastIndexOf("anyo") != -1) tipo = "anyo";
										else if(filterInfo[0].lastIndexOf("mes") != -1) tipo = "mes";
										else if(filterInfo[0].lastIndexOf("periodo") != -1) tipo = "periodo";
										else if(filterInfo[0].lastIndexOf("texto") != -1) tipo = "texto";
										else if(filterInfo[0].lastIndexOf("zonas") != -1) tipo = "texto";
										else if(filterInfo[0].lastIndexOf("modos") != -1) tipo = "texto";
										else if(filterInfo[0].lastIndexOf("fecha") != -1) tipo = "fecha";
										else tipo = "busqueda";

										if(filterInfo[0].lastIndexOf('*') != -1){
											filterInfo[0] = filterInfo[0].replace("*", "");
											multiple = true;
										}


										$scope.formSettings.filtros.push({ name: filterInfo[0], visibleText: filterInfo[1], tipo: tipo, multiple: multiple });
									});
									//$scope.$apply();
								}
							}
						};

						$scope.loadClientesCuenta = function(param){
							return $http.post(cfg.baseURL + "search_ref_clientes/Search?ItemsPerPage=9999", param);
						};
						$scope.loadClientesCuentaMin = function(param){
							return $http.post(cfg.baseURL + "search_ref_clientes/Search?ItemsPerPage=10", param);
						};

						$scope.save = function(){
							angular.extend(widget, $scope.formSettings);
							$uibModalInstance.close(widget);
						};

						$scope.loadDataSources = function(){
							var param = { Fields: [ { Field: "nombre" }, { Field: "tipo" }, { Field: "filtros" }, { Field: "titulo" }, { Field: "subtitulo" }, { Field: "totales" }, { Field: "mostrar" }, { Field: "invertir_bar_lin" }, { Field: "explicativo" } ], Selection: buildIxSearch() };
							param.Selection.Filters.push({ Field: "modulo", Value: modulo, Operator: CMP_EQ });
							return $http.post(cfg.baseURL + "api_dashboard/SelectAndProject", param);
						};

						$scope.loadChartTypes = function(){
							var deferr = $q.defer();

							if(widget.tipo != "medidor_radial"){
								$timeout(function(){
									deferr.resolve({data: [ { tipo: 'lineChart', nombre: 'Gráfica lineas'}, { tipo: 'pieChart', nombre: 'Gráfico pastel' }, { tipo: 'multiBarChart', nombre: 'Gráfico barras múltiples verticales' }, { tipo: 'discreteBarChart', nombre: 'Gráfico barras múltiples verticales con valor' }, { tipo: 'multiBarHorizontalChart', nombre: 'Gráfico barras múltiples horizontales' }, { tipo: 'multiBarHorizontalValuesChart', nombre: 'Gráfico barras múltiples horizontales con valor' }, { tipo: 'grid', nombre: 'Tabla' } ] });
								},1);
							}
							return deferr.promise;
						};
					}],
					backdrop: 'static',
					keyboard: false,
					resolve: {
						widget: function() {
							return widget;
						},
						modulo: function(){
							return $scope.modulo;
						},
						isEditing: function(){
							return $scope.status.editing;
						}
					}
				});

				modalInstance.result.then(function(widget){
					if(angular.isDefined(widget)){
							DataService.loadWidget($scope, widget.modulo, widget);
					}
				});
			};

		$scope.exportWidget = function(widget){
			DataService.exportWidget(widget.modulo, widget.dataSource, widget.filtros);
		};

		$scope.init = function(){


			// We want to manually handle `window.resize` event in each directive.
			// So that we emulate `resize` event using $broadcast method and internally subscribe to this event in each directive
			// Define event handler
			$scope.events = {
				resize: function(e, scope){
					$timeout(function(){
						scope.api.update()
					},200)
				}
			};
			angular.element(window).on('resize', function(e){
				$scope.$broadcast('resize');
			});


			// We want to hide the charts until the grid will be created and all widths and heights will be defined.
			// So that use `visible` property in config attribute
			$scope.config = {
				visible: false
			};
			$timeout(function(){
				$scope.config.visible = true;
			}, 200);

	}



}]);

angular.module('gp4App').directive('bioCestaAnaliticas', [ 'ixCestaVehiculosService', 'ixStatusService', 'cfg', function(ixCestaVehiculosService, ixStatusService, cfg){
  return {
    restrict: "E",
    replace: true,
    template: '<a ng-show="isVisible()" ng-click="openPopup()"><i class="fa fa-flask fa-lg"></i><span class="badge">{{ cesta.getCount() }}</span></a>',
    link: function(scope){

      scope.cesta = ixCestaVehiculosService;

      scope.openPopup = function(){
        //Agafem l'array i substituim totes les comes per salts de linea. El textarea fa ús d'aquesta variable.
        scope.vehiculos = [];
        if(angular.isDefined(ixCestaVehiculosService.getCesta().items)){
          var cesta = ixCestaVehiculosService.getCesta();
          scope.vehiculos = cesta.items.toString().replace(/,/g , "\n");
          scope.campo = cesta.campo;
          //scope.terminacion = cesta.terminacion;
          scope.clientId = cfg.clientId;
        }
        scope.openModal('app/base/views/helpers_templates/biotecnal/ixCestaVehiculosModal.html', scope, 'med').then(function(){
          ixCestaVehiculosService.saveCesta({items: scope.vehiculos, campo: scope.campo, terminacion: scope.terminacion});
          var options = ixCestaVehiculosService.getOptions();
          if(ixStatusService.current.data != null && options.requestDataAfterSave !== false){
            if(angular.isDefined(options.actionGrid) && angular.isFunction(options.actionGrid)){
              options.actionGrid().ixLoadInitialData();
            } else {
              ixStatusService.current.data.grid.ixLoadInitialData();
            }
          }

        });
      }

      scope.vaciarCesta = function(){
        scope.vehiculos = ixCestaVehiculosService.emptyCesta().items;
      }

      scope.isVisible = function(){
        return ixCestaVehiculosService.isShowing();
      }
    }
  }
}]);

/**
 * Coses que no s'haurien de fer així però que és massa complicat fer en angulat-way
 */



/**
 * Funció per maximitzar els ui-grid. Cal que el ui-grid tingui autoResize activat.
 * S'utilitza a grideditable.html i a ixGridToolBar.html
 * El grid ha de tenir les propietats css height i min-height definides amb el mateix valor.
 *
 * @param button botó que llança la funcio (this) situat a una toolbar a sobre del ui-grid
 * @param event event javascript onclick
 */
/*function maximizeGrid(button, event) {
	var grid = button.parentNode.nextElementSibling;
	if(grid.style.height==grid.style.minHeight) {
		grid.style.height='75vh';
		window.scroll(0,event.pageY-120);
		//window.scroll(0,grid.getBoundingClientRect().top);
	} else {
		grid.style.height=grid.style.minHeight;
		window.scroll(0,0);
	}
	angular.element(button).toggleClass('active');
}*/


/*jslint browser: true, white: false*/
/*global CMP_GTE*/
/*global CMP_LTE*/
/*global CMP_LT*/
/*global CMP_EQ*/
/*global CMP_LIKE*/
/*global CMP_LIKEL*/
/*global CMP_ISNULL*/
function convertDateStringsToDates(input, keepOriginal) {
  var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(\.(\d{1,}))?(Z|([\-+])(\d{2}):(\d{2}))?)?)?)$/;
  // Ignore things that aren't objects.
  if (!angular.isObject(input)) {
    return input;
  }
  var key = "";
  for (key in input) {
    if (!input.hasOwnProperty(key)){ continue; }

    var value = input[key];
    var match;
    // Check for string properties which look like dates.
    if (angular.isString(value) && (match = value.match(regexIso8601))) {
			if(!keepOriginal){
				match[0] = match[0].substring(0, match[0].lastIndexOf("T") + 9);
				match[0] += diff_to_GMT(new Date(Date.parse(match[0])));
			}
			var milliseconds = Date.parse(match[0]);
			if (!isNaN(milliseconds)) {
					input[key] = new Date(milliseconds);
			}
    } else if (angular.isObject(value)) {
        // Recurse into object
        convertDateStringsToDates(value, keepOriginal);
    }
  }
}

function diff_to_GMT(dt){
	return (-dt.getTimezoneOffset() < 0 ? '-' : '+') + (Math.abs(dt.getTimezoneOffset() / 60) < 10 ? '0' : '') + (Math.abs(dt.getTimezoneOffset() / 60)) + '00';
}

/*function convertDateStringsToDates2(input) {
  var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(\.(\d{1,}))?(Z|([\-+])(\d{2}):(\d{2}))?)?)?)$/;

  var value = input;
  var match;
  // Check for string properties which look like dates.
  if (angular.isString(value) && (match = value.match(regexIso8601))) {
    var milliseconds = Date.parse(match[0]);
    if (!isNaN(milliseconds)) {
        input = new Date(milliseconds);
    }
  }
  return input;
}

function convertDateToUTC(year,month,day) {
  var date = new Date(Date.UTC(year,month,day));
  //return new Date(dateUtc);
  var utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  return utc;
}*/


function convertFromServerType(servertype) {
    if   (servertype=="Int32" || servertype == "Byte") return "number";
    else if(servertype=="Decimal" || servertype == "Double") return "decimal";
    else if(servertype=="Char") return "boolean";
    else if(servertype=="DateTime") return "date";
    else return "string";
}
function setDefaultFilter(filterType, filterApiBy, minus, noDates){
    if(filterType == "Fecha"){
      if(noDates){
        return [{ data_ini: null, data_fi: null }];
      }
      filterApiBy = angular.isDefined(filterApiBy) ? filterApiBy : "month";
      var ahora = new Date();
      var fechaCalculada = new Date();

      if(filterApiBy == "days"){
        if(angular.isNumber(minus)){
          fechaCalculada.setDate(ahora.getDate() - minus);
        } else {
          //TODO: Ara mateix nomes es fa servir aixo per la setmana actual, quan rep un string fa la setmana actual.
          //Si hi haguessin més opcions, s'hauria de fer ús d'un switch.
          var day = fechaCalculada.getDay() || 7;
          if( day !== 1 ){
            fechaCalculada.setHours(-24 * (day - 1));
          }
        }
      } else {
        fechaCalculada.setDate(1);
      }

      if(filterApiBy == "month"){
        if(minus){
          fechaCalculada.setMonth(ahora.getMonth() - minus);
        } else {
          fechaCalculada.setMonth(ahora.getMonth());
        }
      }

      if(filterApiBy == "year" || filterApiBy == "full_year"){
        if(minus){
          fechaCalculada.setFullYear(ahora.getFullYear() - minus);
        } else {
          fechaCalculada.setFullYear(ahora.getFullYear());
        }
        fechaCalculada.setMonth(0);
      }

      if(filterApiBy == "full_year"){
        ahora.setFullYear(fechaCalculada.getFullYear());
        ahora.setMonth(11);
        ahora.setDate(31);
      }

      return [{ data_ini: fechaCalculada, data_fi: ahora }];
    } else if(filterType == "CheckBox"){
      return filterApiBy;
    } else if(filterType == "Texto" || filterType == "Numero"){
      return [{term: filterApiBy}];
    }
  }


function getDefaultFilters(columns, param, $filter, cfg){
  var hayFiltros = false;
  if(angular.isDefined(columns)){
    columns.forEach(function(column){
      if(column.filteropt == "Fecha"){
        if(column.filters != null && column.filters.length != 0){
          //Periodo: Hoy, Ayer,...
          if(angular.isDefined(column.filters[0].periodo_ini) && column.filters[0].periodo_ini){
            hayFiltros = true;
            param.Filters.push({ Field: column.field, Value: column.filters[0].periodo_ini, Operator: CMP_GTE });
            //param.Filters.push({ Field: column.field, Value: column.filters[0].data_especial, Operator: CMP_LTE });
          } else {
            if(column.filters[0].data_ini != null){
              hayFiltros = true;
              param.Filters.push({ Field: column.field, Value: $filter("date")(column.filters[0].data_ini, "yyyy-MM-dd"), Operator: CMP_GTE });
            }
          }
          //Periodo: Hoy, Ayer,...
          if(angular.isDefined(column.filters[0].periodo_fin) && column.filters[0].periodo_fin){
            hayFiltros = true;
            param.Filters.push({ Field: column.field, Value: column.filters[0].periodo_fin, Operator: CMP_LTE });
          } else {
            if(column.filters[0].data_fi != null){
              hayFiltros = true;
							var now = $filter("date")(column.filters[0].data_fi, "yyyy-MM-dd");
							var partsDate = now.split("-");
              var dateMax = new Date(parseInt(partsDate[0]), (parseInt(partsDate[1]) - 1), parseInt(partsDate[2]));
              //li sumem 1 dia perque els datetime que inclouen el temps també apareguin.
              dateMax.setDate(dateMax.getDate() + 1);
							if(angular.isDefined(cfg.timeDiff) && cfg.timeDiff != "" && cfg.timeDiff != null && cfg.timeDiff > 0 && angular.isDefined(cfg.serverTimeZone))
								dateMax.setDate(dateMax.getDate() + 1);

              param.Filters.push({ Field: column.field, Value: $filter("date")(dateMax, "yyyy-MM-dd"), Operator: CMP_LT });
            }
          }
        }
      } else if(column.filteropt == "CheckBox"){
        if(column.filter.term != null){
          var valor = column.filter.term;
          if(typeof(valor) === "boolean"){
            valor == true ? valor = "1" : valor = "0";
          }
          hayFiltros = true;
          param.Filters.push({ Field: column.field, Value: valor, Operator: CMP_EQ });
        }
      } else if(column.filteropt == "Texto" || column.filteropt == "Numero"){
        if(column.filters != null && column.filters.length != 0){
          if(column.filters[0].term != null && column.filters[0].term != ""){
            hayFiltros = true;
            var pars = column.filters[0].term.split("|");
            var first = true;
            pars.forEach(function(parameter, index){
              //var partsParameter = parameter.split('-');
              //var parameterValue = parameter.indexOf('-');
              //if(parameterValue != -1){
                //parameterValue = partsParameter[partsParameter.length - 1].replace(/\s+/g, '');//Arnau: Crec que no fa falta esborrar espais.
                //parameterValue = partsParameter[partsParameter.length - 1];
                //parameterValue = parameter.substr(parameter.indexOf('-') + 1);
              //} else {
                var parameterValue = parameter;
              //}
              var paramObj = { Field: column.field, Value: parameterValue, Operator: CMP_EQ };
              if(first == true){
                paramObj.StartPar = true;
                first = false;
              } else {
                paramObj.Or = true;
              }
              if(index == (pars.length - 1)){
                paramObj.EndPar = true;
              }
              param.Filters.push(paramObj);
            });

          }/* else { //Això serveix per fer que si un filtre d'API està buit la API no retorni resultats, però en Joan vol que en aquest cas es retornin tots.
            param.Filters.push({ Field: column.field, Value: "", Operator: CMP_EQ });
          }*/
        }
      }
    });
  }
  return hayFiltros;
}

function getLocalFilters(columns, param, $filter){
  columns.forEach(function(column){
    if(angular.isUndefined(column.filteropt)){
      if ((column.filter != null && angular.isDefined(column.filter.numfilters) && column.filter.numfilters > 0) || 
          (column.control == "CheckBox" && (!column.isExtra)) ||
          (column.filter && column.filter.showFilterInput && column.filter.term != null && column.filter.term !== "")) {
        var colFilterTerm = column.filter.term;
        if(colFilterTerm === true)
          colFilterTerm = "1";
        else if(colFilterTerm === false)
          colFilterTerm = "0";

        if (colFilterTerm != null && colFilterTerm !== "") {

          if (colFilterTerm.indexOf("$reload") != -1)
            colFilterTerm = colFilterTerm.substring(0, colFilterTerm.indexOf("$reload"));

          var pars = colFilterTerm.split("|");
          var first = true;

          pars.forEach(function(parameter, index){

            var columnField = column.field;

            if(column.control == "Search"){
              if(column.LookUpKeyFields.length > 1 && column.ColumnFkDescription){
                columnField = column.LookUpTableAlias + "." + column.LookUpResultFields[0];
              }
            }

            if(column.DBFieldName){
              if(column.TableAliasName)
                columnField = column.TableAliasName+".";
              columnField += column.DBFieldName;
            }
            if(column.type != "date" || column.type == "date" && (parameter.lastIndexOf("-") != -1 || parameter.lastIndexOf("#") != -1)){

							var paramObj = {};

							if(parameter == "#value"){
								if(column.type == "number")
									addNotNullAndNotZero(param.Filters, columnField);
								else
									addNotNullAndNotEmpty(param.Filters, columnField);

							} else if(parameter == "#empty"){
								if(column.type == "number")
									addNullOrZero(param.Filters, columnField);
								else
									addNullOrEmpty(param.Filters, columnField);

							} else if(column.filter.selectionType == "#rango"){
								paramObj = { Field: columnField, Value: parameter, Skip: (column.VirtualVMField) };
								if(first == true){
									paramObj.Operator = CMP_GTE;
									first = false;
								}
								if(index == (pars.length - 1))
									paramObj.Operator = CMP_LTE;
								if(paramObj.Value !== "")
									param.Filters.push(paramObj);
							} else {
								paramObj = { Field: columnField, Value: parameter, Operator: (column.filter.showFilterInput?CMP_LIKE:CMP_EQ), Skip: (column.VirtualVMField) };
								if(first == true){
									paramObj.StartPar = true;
									if(column.filter.excluir)
										paramObj.Not = true;
									first = false;
								} else {
									if(column.filter.excluir)
										paramObj.Not = true;
									else
										paramObj.Or = true;
								}
								if(index == (pars.length - 1)){
									paramObj.EndPar = true;
								}
								param.Filters.push(paramObj);
							}
            }
          });
        }
      }
    }
  });
}

function addNotNullAndNotEmpty(paramFilters, colName){
	var paramNotEmpty = { Field: colName, Value: "", Operator: CMP_EQ, StartPar: true, Not: true };
	var paramNotNull = { Field: colName, Value: "", Operator: CMP_ISNULL, EndPar: true, Not: true };

	paramFilters.push(paramNotEmpty);
	paramFilters.push(paramNotNull);

	return paramFilters;
}

function addNotNullAndNotZero(paramFilters, colName){
	var paramNotEmpty = { Field: colName, Value: "0", Operator: CMP_EQ, StartPar: true, Not: true };
	var paramNotNull = { Field: colName, Value: "", Operator: CMP_ISNULL, EndPar: true, Not: true };

	paramFilters.push(paramNotEmpty);
	paramFilters.push(paramNotNull);

	return paramFilters;
}

function addNullOrEmpty(paramFilters, colName){
	var paramEmpty = { Field: colName, Value: "", Operator: CMP_EQ, StartPar: true };
	var paramNull = { Field: colName, Value: "", Operator: CMP_ISNULL, EndPar: true, Or: true };

	paramFilters.push(paramEmpty);
	paramFilters.push(paramNull);

	return paramFilters;
}

function addNullOrZero(paramFilters, colName){
	var paramEmpty = { Field: colName, Value: "0", Operator: CMP_EQ, StartPar: true };
	var paramNull = { Field: colName, Value: "", Operator: CMP_ISNULL, EndPar: true, Or: true };

	paramFilters.push(paramEmpty);
	paramFilters.push(paramNull);

	return paramFilters;
}

function getCestaFilters(param, $filter, cfg, cesta, metadata, skip){

  var items = cesta.items;
  var terminacion = cesta.terminacion;
  var excluir = cesta.excluir;
	var cortar = cesta.cortar;
  var campo = cesta.campo;

  var numItems = items.length;

  for(var i = 0; i < items.length; i++){
    var newparam = {Field: getNameFromConfig(campo, cfg), Value: items[i] };

		if(cortar>0 && newparam.Value.length>cortar) {
			newparam.Value = newparam.Value.slice(-cortar)
		}
		
    if(campo == "chasis" && terminacion == 1){
      newparam.Operator = CMP_LIKEL;
      newparam.Field = "chasisr";
      newparam.Value = $filter("reverse")(newparam.Value);
    } else {
      newparam.Operator = CMP_EQ;
    }

		if(excluir == 1)
			newparam.Not = true;

    //Busquem el param a la metadata per aplicar el TableAliasName si aquest ve.
    if(angular.isDefined(metadata) && metadata != null){
      var attrMetadata = metadata.find(function(e){ return e.Name.toUpperCase() == newparam.Field.toUpperCase() });
      if(angular.isDefined(attrMetadata) && attrMetadata.TableAliasName){
        newparam.Field = attrMetadata.TableAliasName + "." + newparam.Field;
      }
    }

    if(i == 0 && i != numItems - 1){
      newparam.StartPar = true;
    }
    else if(i == numItems - 1 && i > 0){
      newparam.EndPar = true;
      if(newparam.Not != true)
        newparam.Or = true;
    }
    else if(i > 0){
      if(newparam.Not != true)
        newparam.Or = true;
    }
    if(angular.isDefined(skip) && skip){
      newparam.skip = true;
    }
    newparam.Value = newparam.Value.trim();
    param.Filters.push(newparam);
  }
  return param.Filters;
}

function getNameFromConfig(field, cfg){
  if(field == "chasis")
    return cfg.cestaFilterBy;
  else
    return field;
}


function ixGetPatchOperations(originalObj, newObj){
  var data = [];
	if(originalObj && Object.keys(originalObj).length > 0){
		angular.forEach(originalObj, function(valor, clave){
			if(angular.isDefined(newObj[clave]) && originalObj[clave] != newObj[clave] &&
				 (!angular.isObject(newObj[clave]) ||
					(angular.isDate(newObj[clave]) && !angular.equals(originalObj[clave], newObj[clave])) ||
					(angular.isArray(newObj[clave]) && !angular.equals(originalObj[clave], newObj[clave]) &&
					 //chapuza perque no hi hagi problemes al editar un llistat programat.
					 clave != "mailto" && clave != "mailcc")
				 )
				){
				data.push({
					value: newObj[clave],
					path: "/" + clave,
					op: "replace"
				});
			}
		});
	} else {
		angular.forEach(newObj, function(valor, clave){
			data.push({
				value: newObj[clave],
				path: "/" + clave,
				op: "replace"
			});
		});
	}

  return data;
}

function getColors(){
  return [
                { color: 0, name: "Black", visual: "#000000" },
                { color: 128, name: "Maroon", visual: "#800000" },
                { color: 32768, name: "Green", visual: "#008000" },
                { color: 32896, name: "Olive", visual: "#808000" },
                { color: 8388608, name: "Navy", visual: "#000080" },
                { color: 8388736, name: "Purple", visual: "#800080" },
                { color: 8421376, name: "Teal", visual: "#008080" },
                { color: 8421504, name: "Gray", visual: "#808080" },
                { color: 12632256, name: "Silver", visual: "#C0C0C0" },
                { color: 255, name: "Red", visual: "#FF0000" },
                { color: 65280, name: "Lime", visual: "#00FF00" },
                { color: 65535, name: "Yellow", visual: "#FFFF00" },
                { color: 1219071, name: "Orange", visual: "#FF9912" },
                { color: 16711680, name: "Blue", visual: "#0000FF" },
                { color: 16711935, name: "Fuchsia", visual: "#FF00FF" },
                { color: 16776960, name: "Aqua", visual: "#00FFFF" },
                { color: 16777215, name: "White", visual: "#FFFFFF" },
                { color: 12639424, name: "MoneyGreen", visual: "#c0dcc0" },
                { color: 15780518, name: "SkyBlue", visual: "#a6caf0" },
                { color: 15651748, name: "Sail", visual: "#A4D3EE" },
                { color: 16449525, name: "Cream", visual: "#F5FFFA" },
                { color: 10789024, name: "MedGray", visual: "#a4a0a0" },
								{ color: 15793151, name: "FloralWhite", visual: "#FFFBF0" }
              ];
}

function getColorsPastel() {
  return [
          { color: 16772047, name: "Light Peach", visual: "#FFDAB9" },
          { color: 15792383, name: "Mint", visual: "#98FF98" },
          { color: 15528255, name: "Light Blue", visual: "#ADD8E6" },
          { color: 15790783, name: "Light Coral", visual: "#F08080" },
          { color: 16776960, name: "Pale Yellow", visual: "#FFFFCC" },
          { color: 14596231, name: "Sky Blue", visual: "#87CEEB" },
          { color: 16775064, name: "Light Lavender", visual: "#F0E6FA" },
          { color: 16773365, name: "Pale Green", visual: "#CCFFCC" },
          { color: 16773143, name: "Soft Lilac", visual: "#D8BFD8" },
          { color: 16774367, name: "Light Lemon", visual: "#FFFACD" },
          { color: 16773097, name: "Pale Peach", visual: "#FFEFD5" },
          { color: 16772777, name: "Misty Rose", visual: "#FFE4E1" },
          { color: 16774917, name: "Light Beige", visual: "#F5F5DC" },
          { color: 16772545, name: "Pale Mint", visual: "#F5FFFA" },
          { color: 16448510, name: "Cream", visual: "#FFFDD0" },
          { color: 16773156, name: "Baby Blue", visual: "#B0E0E6" },
          { color: 15792441, name: "Light Aqua", visual: "#E0FFFF" },
          { color: 16581029, name: "Powder Blue", visual: "#B0E0E6" },
          { color: 16774418, name: "Ivory", visual: "#FFFFF0" },
          { color: 16772021, name: "Soft Pink", visual: "#F8C8DC" },
          { color: 16774271, name: "Lavender", visual: "#E6E6FA" }
  ];
}
//Sol·lució temporal per problema d'Extranet.
function ixPing($interval, $http, cfg){
  var interval
  interval = $interval(function(){
    //if(angular.isDefined(localStorage['authorizationData'])){
    if(angular.isDefined(sessionStorage['authorizationData'])){
      $http.get(cfg.baseURL+'api_usuarios/CurrentUser');
    } else {
      if(angular.isDefined(interval)){
        $interval.cancel(interval);
      }
    }
  }, 60*1000);
}

function buildIxSearch(){
  return {Filters: [], OrderBy: []};
}

function buildIxProjectionParam(){
	return { Selection: {Filters: [], OrderBy: [] }, Fields: [] };
}

function addToParamFilters(paramFilters, field, value, op, or, not){
  if(angular.isUndefined(op)) op = CMP_EQ;
  paramFilters.push({
    Field: field,
    Value: value,
    Operator: op,
    Or: (angular.isDefined(or) && or),
    Not: (angular.isDefined(not) && not)
  });

  return paramFilters;
}

/*
  ** funciones obsoletas, ahora hay que usar ixUtilsService.checkPermission(entity) o ixUtilsService.checkMultiplPermission(entities)
  
function checkPermission($http, cfg, entity){
  return $http.get(cfg.baseURL + "configuraciones/GetConfig/" + entity).then(function(response){
    return response.data;
  });
}

function checkMultiplePermission($http, cfg, entities){
  return $http.post(cfg.baseURL + "configuraciones/GetConfigMultiple/", entities).then(function(response){
    return response.data;
  });
}
*/

function mergeArraysByTag(iterateArray, searchInArray, tag){
  var mergedArr = [];
  iterateArray.forEach(function(arrayItem){
    var updateItem = searchInArray.find(function(e){ return e[tag].toLowerCase() === arrayItem[tag].toLowerCase(); });
    if(angular.isUndefined(updateItem)) searchInArray.push(arrayItem);
    else angular.merge(updateItem, arrayItem);
  });
  return searchInArray;
}

function getCurrentDate() {
  var now = new Date();
  var day = now.getDate();
  var month = now.getMonth() + 1;
  var year = now.getFullYear();

  return new Date(year, month-1, day);
}

function getCurrentTime(){}

function parseObjectsToString(objects, fields, fkFields){
	if(angular.isDefined(fkFields) && fkFields.length > 0){
		return objects.map(function(e) {
      // BIOTECNAL: Para casos en que el objeto tiene ID y DESCRICPCION iguales, devolvemos  sólo un valor
      if(fields.length==2 && e[fields[0]]==e[fields[1]]) {
        return e[fields[0]];
      }
			return fields.map(function(ee, idx) { return e[ee] || e[fkFields[idx]] }).join(" - ");
		});
	} else {
		return objects.map(function(e) {
      // BIOTECNAL: Para casos en que el objeto tiene ID y DESCRICPCION iguales, devolvemos  sólo un valor
      if(fields.length==2 && e[fields[0]]==e[fields[1]]) {
        return e[fields[0]];
      }
			return fields.map(function(ee) { return e[ee]}).join(" - ");
		});
	}

}

function capitalizeFirstLetter(word){
  return word.charAt(0).toUpperCase() + word.slice(1);
}

function skipValidationErrors(){
  return ["parse", "mask", "date"];
}

function deleteSkippedValidations(formErrors, skippedErrors){
  angular.forEach(Object.keys(formErrors), function(error){
    if(skippedErrors.indexOf(error) > -1) delete formErrors[error];
  });
  return formErrors;
}

function simulateAPIError(contextStatusObj, errorKey, messages){
  contextStatusObj.$invalid = true;
  contextStatusObj.$error[errorKey] = messages;
}

function ixGridColumnFilterCondition($filter){
  return function(searchTerm, cellValue, row, column){

    if(column.colDef.control == "Search"){
      if(column.colDef.LookUpKeyFields.length > 1 && column.colDef.ColumnFkDescription){
        if(row.entity[column.colDef.ColumnFkDescription]){
          cellValue = row.entity[column.colDef.ColumnFkDescription];
          //searchTerm = cellValue+"\\|"+searchTerm;
        }
      }
    }
    

		if(angular.isString(searchTerm)){
			if(searchTerm.indexOf("$reload") != -1)
				searchTerm = searchTerm.substring(0,searchTerm.indexOf("$reload")-1);
		}

		var seleccion_vacios = false;

    if(searchTerm == "#empty"){
			searchTerm = "";
			seleccion_vacios = true;
		}
    else if(searchTerm == "#value") searchTerm = "*";
    if(typeof(searchTerm) === "boolean"){
      searchTerm === true ? searchTerm = "1" : searchTerm = "0";
    }
    searchTerm = searchTerm.replace(/\\/g, "");
    var conditions = searchTerm.split('|');

    if(column.colDef.type == "number" && typeof(cellValue) !== "boolean" && column.colDef.control == "CheckBox"){//serveix per retornar tots aquells checks que no estiguin marcats perque el seu valor es null o undefined
      if(cellValue !== 1) cellValue = 0;
    }

    //Si la row es nova es mostra sense importar el filtre que hi hagi.
    if(row.entity.isNew == true && !row.entity.manuallyAdded){
      return true;
    } else if(angular.isDefined(cellValue) && cellValue != null){//Si no, mirem que tingui valor i que aquest es trobi dintre de la col·lecció de condicions.
      if(column.filter.showFilterInput) {
        var lookupresultfields = column.colDef.LookUpResultFields;
        var fkObjects = column.colDef.allFkObjects;
        var cellText = cellValue;
        if(fkObjects) {
          cellText = fkObjects.filter(function(e){
            var coincide = false;
            for(var i = 0; i < lookupresultfields.length; i++){
              if(e[lookupresultfields[i]]==cellValue)
                coincide = true;
            }
            return coincide;
          }).map(function(e){
            var label = e[lookupresultfields[0]];
            if(lookupresultfields.length > 1){
              for(var i = 1; i < lookupresultfields.length; i++){
                if(angular.isDefined(e[lookupresultfields[i]])){
                  label += " - " + e[lookupresultfields[i]];
                }
              }
            }          
            return label;
          });
        }
        return cellText.toString().trim().toUpperCase().indexOf(conditions[0].trim().toUpperCase()) != -1 || (conditions.length == 1 && conditions[0] == "");         
        //return cellValue.toString().trim().toUpperCase().indexOf(conditions[0].trim().toUpperCase()) != -1 || (conditions.length == 1 && conditions[0] == "");         
      } else {      
        if(column.colDef.type == "date"){
          var dateParts = [];
          if(angular.isDate(cellValue))
            dateParts = ($filter("date")(cellValue, "dd/MM/yyyy", null)).split("/");
          else
            dateParts = cellValue.split("/");
          var newDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
          cellValue = newDate.toISOString().slice(0,10);
          //var newDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
          //cellValue = newDate.toISOString().slice(0,10);
          cellValue = dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
        } else if(typeof(cellValue) === "boolean"){
          cellValue === true ? cellValue = 1 : cellValue = 0;
        }
        if(searchTerm == "*"){
          return cellValue.toString() != "";
        } else {
          if(column.filter.selectionType == "#rango"){
            return ((conditions[0] !== "" && cellValue >= conditions[0]) || conditions[0] === "") && ((conditions[1] !== "" && cellValue <= conditions[1]) || conditions[1] === "");
          } else {
            //Agafo la llista de opcions marcades i trec els espais del principi i final.
            if(conditions.length > 0){
              angular.forEach(conditions, function(condition, idx){
                conditions[idx] = condition.trim();
              });	
            }
            
            if(seleccion_vacios)
              return conditions.indexOf(cellValue.toString().trim()) > -1 || (angular.isDefined(column.colDef.LookUpTableName) && !cellValue);
            else if(column.filter.excluir)
              return conditions.indexOf(cellValue.toString().trim()) == -1;
            else
              return conditions.indexOf(cellValue.toString().trim()) > -1 || (conditions.length == 1 && conditions[0] == "");

          }

        }
      }
    } else if(searchTerm == ""){//Si marquem todos los vacíos, retornem aquells que son null.
      return cellValue == null;
    }
    return false;
  };
}

function ixFiltersToArray(filtersArray, $filter, entity, fieldsToSkip){
  var param = [];
  var paramValue;
  var filter;
  angular.forEach(filtersArray, function(value, key){
    var i = 0;
    if(angular.isObject(value) && (Object.keys(value).length > 0 || angular.isArray(value))){
      var notNullValues = Object.keys(value).filter(function(e){ return angular.isDefined(value[e]) && value[e] != null && value[e] != ""; }).map(function(a){ return { value: value[a], first: (a == 0) }; });
      while(i < notNullValues.length) {
        paramValue = notNullValues[i].value;

        if(angular.isUndefined(entity)){
          filter = { Field: key, Value: paramValue };
        } else {
          filter = { Field: entity+"."+key, Value: paramValue };
        }

        //obrim parentesis
        if(i == 0){
          filter.StartPar = true;
        } else if(i < (notNullValues.length) && !angular.isDate(paramValue)){//si hi ha múltiples i no són dates anem possant OR
          filter.Or = true;
        }

        if(angular.isDate(paramValue)){
          if(i == 0 && notNullValues[i].first){
            filter.Value = $filter("date")(filter.Value, "yyyy-MM-dd");
            filter.Operator = CMP_GTE;
          } else {
            var now = $filter("date")(filter.Value, "yyyy-MM-dd");
						var partsDate = now.split("-");
						var dateMax = new Date(parseInt(partsDate[0]), (parseInt(partsDate[1]) - 1), parseInt(partsDate[2]));
            //li sumem 1 dia perque els datetime que inclouen el temps també apareguin.
            dateMax.setDate(dateMax.getDate() + 1);
            filter.Value = $filter("date")(dateMax, "yyyy-MM-dd", null);
            filter.Operator = CMP_LT;
          }
        } else {
          filter.Operator = CMP_EQ;
        }

        if(i == (notNullValues.length - 1)){
          filter.EndPar = true;
        }
        if(angular.isDefined(fieldsToSkip) && (fieldsToSkip.indexOf(key) != -1 || fieldsToSkip == "*")) filter.skip = true;
        param.push(filter);
        i++;
      }
    } else {
      paramValue = value;

      if(angular.isUndefined(entity)){
        filter = { Field: key };
      } else {
        filter = { Field: entity+"."+key };
      }
      if(angular.isDate(paramValue)){
        filter.Value = $filter("date")(paramValue, "yyyy-MM-dd");
      } else {
        filter.Value = paramValue;
      }
      filter.Operator = CMP_EQ;
      if(angular.isDefined(filter.Value) && filter.Value != null && filter.Value !== "" && ( (!angular.isArray(filter.Value) ) || (angular.isArray(filter.Value) && filter.Value.length > 0) ) ){
        if(angular.isDefined(fieldsToSkip) && (fieldsToSkip.indexOf(key) != -1 || fieldsToSkip == "*")) filter.skip = true;
        param.push(filter);
      }
    }
  });
  return param;
}

function ixNewDate(cfg, moment, day, month, year, keepUTC){
  var date = new Date();
  if(angular.isUndefined(day)){
    year = date.getFullYear();
    month = date.getMonth();
    day = date.getDate();
  } else {
    date.setYear(year);
    date.setMonth(month, day);
  }

  if(angular.isDefined(cfg.timeDiff) && cfg.timeDiff != "" && cfg.timeDiff != null && angular.isDefined(cfg.serverTimeZone)){
    if(month<9 && (angular.isUndefined(month.length) || month.length < 2)) month = "0"+month;
    if(day<9 && (angular.isUndefined(day.length) || day.length < 2)) day = "0"+day;
    var d = moment();
    d.year(parseInt(year)).month(parseInt(month)).date(parseInt(day)).hours("00").minutes("00").seconds(0).milliseconds(0);

    var another = d.clone();
    another.tz(cfg.serverTimeZone, true);

    return ixCalculateTzOffset(another.format(), keepUTC);
  } else {
    date.setHours(0,0,0,0);
    return date;
  }
}

function ixCalculateTzOffset(value, keepUTC){
  var date = new Date(value);
  var minutes;
  if (isNaN(date) || (value == null)) {
    return value;  // needed for null/empty/undefined values
  }
  var timeZoneOffset = date.getTimezoneOffset();

	value = value.substring(value.lastIndexOf("T"));

	var timezoneOriginal;
	if(value.lastIndexOf("+") != -1)
  	timezoneOriginal = value.substring((value.lastIndexOf("+") + 1), value.lastIndexOf(":"));
	else
		timezoneOriginal = value.substring((value.lastIndexOf("-") + 1), value.lastIndexOf(":"));

  if(timeZoneOffset < 0){
    minutes =(timeZoneOffset*-1);
    if(!keepUTC){
      minutes = minutes + (60 * parseInt(timezoneOriginal));
    }
    date.setMinutes(minutes);  // forces the "local" version of the date to match the intended +0100 date when necessary
  } else {
    minutes =(timeZoneOffset);
    if(!keepUTC){
      minutes = minutes + (60 * parseInt(timezoneOriginal));
    }
    date.setMinutes(minutes);  // forces the "local" version of the date to match the intended +0100 date when necessary
  }
  return date;
}

function addDateDeriveds(cfg, $filter, derivers, data){
  var derivedsObj = {};
  if(angular.isDefined(data) && data.length > 0){
    var firstRecord = data[0];
    var allKeys = Object.keys(data[0]);
    angular.forEach(allKeys, function(key){
      var firstRecordWithValue = data.find(function(e){ return e[key] || e[key] === ""; });
      if(angular.isDefined(firstRecordWithValue)){
        var value = firstRecordWithValue[key];
        if(angular.isDate(value)){
          var transformed = false;
          if(angular.isDefined(cfg.timeDiff) && cfg.timeDiff != "" && cfg.timeDiff != null && angular.isDefined(cfg.serverTimeZone)){
            var hoursToAdd = cfg.timeDiff*-1;
            value.setTime(value.getTime() + (hoursToAdd*60*60*1000));
            if(hoursToAdd > 0) transformed = true;
          }

          // derived attribute (con el mismo nombre) que convierte la fecha al formato definido en cfg.dateFormat
          derivedsObj[key] = function(record){
            return record[key]?$filter("date")(record[key], cfg.dateFormat):null;
          }
          // crearemos también derived attributes para "fecha_año","fecha_mes" (si no existen), para poder hacer agrupaciones/drilldown
          if(!firstRecord[key+"_año"] && !firstRecord[key+"_ano"] && cfg.dateFormat.indexOf("yyyy")>=0) {
            derivedsObj[key+"_año"] = function(record) {return record[key]?record[key].substring(cfg.dateFormat.indexOf("yyyy"),cfg.dateFormat.indexOf("yyyy")+4):null}; 
          }
          if(!firstRecord[key+"_mes"] && cfg.dateFormat.indexOf("MM")>=0) {
            derivedsObj[key+"_mes"] = function(record) {return record[key]?record[key].substring(cfg.dateFormat.indexOf("MM"),cfg.dateFormat.indexOf("MM")+2):null}; 
          }
        }
      }
    });
  }
  return derivedsObj;
}

function addDateSorters(moment, cfg, data, attr){
	var sortFunction = undefined;
	if(cfg.momentDateFormat){
		if(angular.isDefined(data) && data.length > 0){
			var firstRecord = data[0];

			var isValidDate = moment(firstRecord[attr], cfg.dateFormat).isValid();

			if(isValidDate){
				sortFunction = function(a, b){
					if(a == "null")
						return -1;
					else if(b == "null")
						return 1;
					else {
						var dateA = new Date(moment(a, cfg.momentDateFormat).format("YYYY-MM-DD"));
						var dateB = new Date(moment(b, cfg.momentDateFormat).format("YYYY-MM-DD"));
						var diff = dateA - dateB;
						if(diff > 0)
							return 1;
						else if(diff < 0)
							return -1;
						else return 0;
					}
				};
			}
		}
	}
  return sortFunction;
}


/*!
 * SmartMenus more option - November 9, 2016
 * http://www.smartmenus.org/
 */
var ixMenuMore;
var handleResize;
var ixMenuMoreFunction = function ($) {

	if(angular.isUndefined($.SmartMenus.prototype.old_init))
  	$.SmartMenus.prototype.old_init = $.SmartMenus.prototype.init;

  $.SmartMenus.prototype.init = function(refresh) {
    var injector = angular.element(angular.element(document).injector().get('$document')[0].body).injector();
    var $translate = injector.get('$translate');
    
    if (!refresh && !this.$root.hasClass('sm-vertical') && (this.$root.prop('id') == 'main-menu') && !this.$root.hasClass('sm-collapsible')) {
      var $originalItems = this.$root.children('li'),
        $moreSub = this.$root.clone(true, true).removeAttr('id').removeAttr('class').addClass('dropdown-menu'),
        $moreSubItems = $moreSub.children('li'),
        $moreItem = angular.element('<li><a>+ '+$translate.instant("Más")+' <span class="caret"></span></a></li>').append($moreSub).appendTo(this.$root),
        self = this,
        vieportW,
        hiddenItems = [],
        hiddenMoreItems = [];
    }

		if(!this.$root.hasClass('sm-collapsible')) {
    	this.old_init(true);
		}
	
    if (!refresh && !this.$root.hasClass('sm-vertical') && (this.$root.prop('id') == 'main-menu') && !this.$root.hasClass('sm-collapsible')) {
      handleResize = function (force) {
				var widthLogo = parseInt(angular.element(".navbar-brand").css("width"));
				var widthRightSideMenu = parseInt(angular.element("#user-menu").css("width"));
				if(widthRightSideMenu < 498)//Com el menu creix depenent de si estas buscant un vehicle o el numero de chasis a cistella, fixem el 498 com a maxim.
					widthRightSideMenu = 498;

				var widthUsedByOthers = widthLogo + widthRightSideMenu + 20;
				var curWidth = angular.element(window).width() - (widthUsedByOthers);
				//var curWidth = $(window).width();
        if (vieportW !== curWidth || force) {
					if(!self.$root.hasClass('sm-collapsible')) {
						angular.element("#main-menu").css('width', curWidth); 	 
					}
					else {
						angular.element("#main-menu").css('width', "auto"); 	 
					}
					
					
          // hide More item
          $moreItem.detach();

          // show all main menu items
          $.each(hiddenItems, function() {
            angular.element(this).appendTo(self.$root);
          });
          hiddenItems = [];

          // show all More sub items
          $.each(hiddenMoreItems, function() {
            angular.element(this).prependTo($moreSub);
          });
          hiddenMoreItems = [];

          // if in desktop view and the last item is wrapped
          if (!self.$root.hasClass('sm-vertical') && !self.$root.hasClass('sm-collapsible') && (self.$root.prop('id') == 'main-menu') && (/^(left|right)$/.test(self.$firstLink.parent().css('float')) || self.$firstLink.parent().css('display') == 'table-cell') && $originalItems.eq(-1)[0].offsetTop != $originalItems.eq(0)[0].offsetTop) {
            // show More item
            $moreItem.appendTo(self.$root);

            // while the More item is wrapped
            while ($moreItem[0].offsetTop != $originalItems.eq(0)[0].offsetTop) {
              hiddenItems.unshift($moreItem.prev('li').detach());
            }

            // hide proper More sub items
            $moreSubItems.slice(0, $moreSubItems.length - hiddenItems.length).each(function() {
              hiddenMoreItems.unshift(angular.element(this).detach());
            });
          }

          // save new viewport width
          vieportW = curWidth;
        }
      }
      handleResize();

      angular.element(window).bind({
        'load.smartmenus': function() {
          handleResize(true);
        },
        'resize.smartmenus': handleResize
      });
    }
  };

	ixMenuMore = $.SmartMenus.prototype.init;
	
  // Fix isCollapsible method
  $.SmartMenus.prototype.isCollapsible = function() {
    return this.$root.find('ul').eq(0).css('position') == 'static';
  };

};

/**
 * @license angularjs-google-recaptcha-v3 build:2019-06-12
 *
 * Copyright (c) 2019 FayzaanCorp
**/

/*global angular, Recaptcha*/
/*eslint angular/document-service:0*/
(function (ng) {
	'use strict';

	ng.module('fayzaan.gRecaptcha.v3', []);
}(angular));
/*global angular*/

(function (ng) {
	'use strict';

	ng.module('fayzaan.gRecaptcha.v3').provider('gRecaptcha', [ function () {
		var service = this;
		var config = {};

		service.$get = ['$window', '$q', '$document', '$interval', '$timeout',
			function ($window, $q, $document, $interval, $timeout) {
				var key = null;
				var url = 'https://www.google.com/recaptcha/api.js';
				var onLoadFunctionName = 'onGRecaptchaScriptLoaded';
				var defered = $q.defer();
				var initializing = false;
				var initialized = false;

				function writeScript () {
		      var tag = document.createElement('script');
		      tag.src = url + '?render=' + key + '&onload=' + onLoadFunctionName + '&render=explicit';
		      $document.find('body')[0].appendChild(tag);
		    }

		    function isExecuteAvailable () {
		      return angular.isFunction(($window.grecaptcha || {}).execute);
		    }

		    function scriptExists () {
		      return $window.document.querySelector('script[src^="' + url + '"]')
		    }

		    function execute (params) {
		      if (isInitializing()) {
		        return defered
		          .promise
		          .then(function () {
		            return execute(params);
		          })
		      }
		      return $window.grecaptcha.execute(key, params)
		    }

		    function isInitialized () {
		      return !!initialized;
		    }

		    function isInitializing () {
		      return !!initializing;
		    }

		    function reset () {
		      return $window.grecaptcha.reset();
		    }

		    function initialize (params) {
		      $timeout(function () {
		        try {
		          if (!params || !params.key) {
		            throw new Error('Missing required public key for reCaptcha.');
		          }

		          key = params.key + '';

		          if (isExecuteAvailable()) {
		            initialized = true;
		            initializing = false;
		            defered.resolve();
		          } else if (scriptExists()) {
		            initializing = true;
		            var wait = $interval(function () {
		              if (isExecuteAvailable()) {
		                $interval.cancel(wait);

		                initialized = true;
		                initializing = false;
		                defered.resolve();
		              }
		            }, 50)
		          } else {
		            initializing = true;
		            $window[onLoadFunctionName] = function () {
		              initialized = true;
		              initializing = false;
		              defered.resolve();
		            };

		            writeScript();
		          }


		        } catch (e) {
		          defered.reject(e);
		        }
		      });

		      return defered.promise;
		    }

				return {
					initialize: initialize,
					execute: execute,
					reset: reset,
					isInitialized: isInitialized,
					isInitializing: isInitializing
				};
			}
		]
	}])
})(angular)

/*jslint browser: true, white: false*/
function buildBaseAppMenus() {
	var menus = {
		children: []
	};
  return menus;
}

function mergeSubArrays(objectArray){
  var baseMenuChildren = objectArray[0].children;
  for(var pos = 1; pos < objectArray.length; pos++){
    //Itera el menu baseApp, si ja hi ha algun item (ex: Administración), li afegeix els items del submenu.
    angular.forEach(baseMenuChildren, function(menuchildren){
      var itemInNextMenu = objectArray[pos].children.find(function(e){ return e.display === menuchildren.display; });
      if(angular.isDefined(itemInNextMenu)){

				//Test

				angular.forEach(itemInNextMenu.children, function(childMenu){
					var foundSubMenu = menuchildren.children.find(function(e){ return e.display == childMenu.display; });
					if(foundSubMenu && angular.isDefined(foundSubMenu.children)){
						foundSubMenu.children.push.apply(foundSubMenu.children, childMenu.children);
					} else {
						//menuchildren.children.push.apply(menuchildren.children, childMenu);
						menuchildren.children.push(childMenu);
					}
				});


				//

				//Original:
        //menuchildren.children = menuchildren.children.concat(itemInNextMenu.children);
      }
    });
    //Mirem si hi ha algun item (Tablas Maestras,...) que no hi es al menu principal, sino hi es l'afegim.
    angular.forEach(objectArray[pos].children, function(menuchildren){
      var found = baseMenuChildren.some(function(e){ return menuchildren.display === e.display; });
      if(!found){
        baseMenuChildren = baseMenuChildren.concat(menuchildren);
      }
    });
  }
  objectArray[0].children = baseMenuChildren;
  return objectArray;
}

/*jslint browser: true, white: false*/
/*global buildBaseAppMenus*/
/*global mergeSubArrays*/
var buildMenus = function() {
  var generalMenus = buildBaseAppMenus();
  var menus = {
	children: [
    { // Administracion
			display: 'Administración',
			children: [
        {
          display: 'Usuarios',
          href: 'Administracion/api_usuarios/edit',
          icon: 'person'
        },
        {
          display: 'Perfiles',
          href: 'Administracion/api_perfiles/list',
          icon: 'group'
        },
        {
          display: 'Traducciones',
          href: 'Administracion/api_traduction_msg/edit',
          icon: 'translate'
        },
        {
          display: 'Configuraciones',
          href: 'Administracion/configuraciones/edit',
          icon: 'settings'
        },
        {
          display : 'Herramientas',
          children : [
            {
              display : 'Cambio estado masivo',
              href: 'herramientas/cambioestadomasivo',
              icon: 'attachment'
            }, 
            {
              display : 'Cambio ean/cod interno masivo',
              href: 'herramientas/cambioeancodinternomasivo',
              icon: 'attachment'
            }
          ]
        }
      ]
		},
    
    {
      display: 'Configuración FT',
      icon: '',
      children:
      [
        {
          display: 'Tipos Ficha Técnica',
          href: 'ConfiguracionPreguntas/ft_versiones',
          icon: 'list'
        },
        {
          display: 'Niveles Ficha Técnica',
          href: 'ConfiguracionPreguntas/ft_niveles',
          icon: 'list'
        },
        {
          display: 'Preguntas Ficha Técnica',
          href: 'ConfiguracionPreguntas/ft_preguntas',
          icon: 'list'
        }
      ]
    },
    {
      display: 'Tablas Maestras',
      icon: '',
      children:
      [
        /* SOLO BONPREU */
        {
          display: 'Áreas',
          href: 'Mantenimientos/departamentos',
          icon: 'store'
        },
        {
          display: 'Clientes',
          href: 'Mantenimientos/clientes',
          icon: 'person_pin'
        },
        /* SOLO BONPREU */
        {
          display: 'Compradores',
          href: 'Mantenimientos/compradores',
          icon: 'shopping_cart'
         
        },
        {
          display: 'Laboratorios',
          href: 'Mantenimientos/laboratorios',
          icon: 'people'
        },
        {
          display: 'Marcas',
          href: 'Mantenimientos/extranet_marcas',
          icon: 'local_play'
        },
        {
          display: 'Estados',
          href: 'Mantenimientos/ft_estados',
          icon: 'list'
        },
        {
          display: 'Diccionarios',
          href: 'Mantenimientos/diccionarios',
          icon: 'import_contacts'
        },
        {
          display: 'Tipos Fichero Ficha técnica',
          href: 'Mantenimientos/tipos_fichero_ft',
          icon: 'rate_review'
        },
        {
          display: 'Categorías certificaciones proveedor',
          href: 'MantenimientosEuromadi/categorias_certificaciones_proveedores',
          icon: 'rate_review'
        },
        {
          display: 'Tipos Ficheros y Certificados Proveedor',
          href: 'MantenimientosEuromadi/tipos_fichero_proveedor',
          icon: 'rate_review'
        },
        {
          display: 'Tipos Auditorías',
          href: 'MantenimientosEuromadi/tipos_auditorias_plantas',
          icon: 'rate_review'
        },
        {
          display: 'Tipos Fichero Proveedor',
          href: 'Mantenimientos/tipos_fichero_proveedor',
          icon: 'rate_review'
        },
        {
          display: 'Tipos Fichero Laboratorio',
          href: 'Mantenimientos/tipos_fichero_laboratorio',
          icon: 'rate_review'
        },
        /* SOLO BONPREU */
        {
          display: 'Tipos análisis',
          href: 'Mantenimientos/tipos_analisis',
          icon: 'rate_review'
        }
      ]
    },
    {
      display: 'Proveedores',
      icon: '',
      children:
      [
        {
          display: 'Gestión proveedores',
          href: 'Mantenimientos/proveedores',
          icon: 'people'
        },
        // {
        //   display: 'Listado proveedores',
        //   href: '',
        //   icon: 'list'
        // },
        {
          display: 'Homologación proveedores',
          href: 'HomologacionPlantas/Listado_control_homologacion',
          icon: 'list'
        },
        {
          display: 'Resumen homologación proveedores',
          href: 'HomologacionPlantas/Listado_resumen_homologacion',
          icon: 'list'
        },
        {
          display: 'Carga ficheros FT',
          href: 'ListadosFt/Carga_Ficheros_FT',
          icon: 'list'
        }
      ]
    },
    {
      display: 'Gestión Fichas Técnicas',
      icon: '',
      children:
      [
        {
          display: 'Listado Fichas Técnicas por agrupación',
          href: 'ListadosFT/Listado_Ft',
          icon: 'list'
        },
        {
          display: 'Listado Fichas Técnicas por Producto',
          href: 'ListadosFT/Listado_ProductosFt',
          icon: 'list'
        },
        {
          display: 'Búsqueda Avanzada',
          href: 'ListadosFT/Busqueda_Avanzada',
          icon: 'search'
				},
        {
          display: 'Control envío observaciones alérgenos App',
          href: 'ListadosFT/Listado_control_envio_obs_alergenos_app',
          icon: 'perm_device_information'
        },
        {
          display: 'Listado Proveedores/Fabricantes',
          href: 'ListadosFT/Listado_Productos_Marca',
          icon: 'list'
        },
        {
          display: 'Listado Fichas de Seguridad y Certificaciones',
          href: 'ListadosFT/Listado_Fichas_Seguridad',
          icon: 'list'
        },
        {
          display: 'Cambios de estado FT',
          href: 'ListadosFT/Listado_cambio_estados_ft',
          icon: 'list'
        }
      ]
    },
    {
      display: 'Gestión Ficheros',
      icon: '',
      children:
      [
        {
          display: 'Listado Ficheros',
          href: 'ListadosFT/Listado_Proveedores_Ficheros',
          icon: 'list'
        }
      ]
    },
    {
      display: 'Gestión Fotos Productos',
      icon: '',
      children:
      [
        {
          display: 'Carga Fotos',
          href: 'ListadosFT/Listado_Ft_Fotos_Producto',
          icon: 'list'
        },
        {
          display: 'Control Presencia Fotos',
          href: 'ListadosFT/Control_presencia_fotos',
          icon: 'list'
        }
      ]
    },
    {
      display: 'Gestión Analíticas',
      icon: '',
      children:
      [
				{
          display: 'Planificaciones analiticas',
          href: 'ListadosFT/Listado_analiticas_ft',
          icon: 'list'
        },
        {
          display: 'Descarga de informes',
          href: 'ListadosFT/Descarga_informes_analiticas',
          icon: 'list'
        },
				{
					display: 'Carga masiva planificaciones',
					href: 'Integraciones/Planificaciones_analiticas',
					icon: 'attachment'
				}
      ]
    },
    {
      display: 'Contratos',
      icon: '',
      children:
      [
        {
          display: 'Contratos Fichas Técnicas',
          href: 'Contratos/extranet_fichas_tecnicas_contratos',
          icon:'euro_symbol'
        }
      ]
    },
    {
      display: 'Dashboards',
      icon: '',
      children:
      [
				{
          display: 'Dashboard',
          href: 'Dashboards/Dashboard',
          icon: 'dashboard'
        }
      ]
    },
    {
      display: 'Alarmas',
      icon: '',
      children:
      [
				{
          display: 'Estado fuera de plazo',
          href: 'Alarmas/estado_fuera_plazo',
          icon: 'list'
        },
        {
          display: 'Expiración certificados',
          href: 'Alarmas/expiracion_certificados',
          icon: 'list'
        },
        {
          display: 'Actualización FT',
          href: 'Alarmas/actualizacion_ft',
          icon: 'list'
        },
        {
          display: 'Verificación nuevos ingredientes',
          href: 'Alarmas/verificacion_ingredientes',
          icon: 'list'
        },
        {
          display: 'Certificados con ficheros obligatorios',
          href: 'Alarmas/certificados_ficheros',
          icon: 'list'
        },
        {
          display: 'Ingredientes por monitorizar',
          href: 'Alarmas/ingredientes_monitorizar',
          icon: 'list'
        }
      ]
    }
	]
};
  var mergedMenus = mergeSubArrays([].concat(generalMenus, menus));
  mergedMenus.splice(1);
  return mergedMenus;
}

var buildGP4Menus = angular.copy(buildMenus);

/*jslint browser: true, white: false*/
/*global buildBaseAppMenus*/
/*global buildGP4Menus*/
/*global mergeSubArrays*/
var buildMenus = function() {
  var menus = {
    children: [
      {
        display: 'Gestión Proveedores',
        icon: '',
        children: [
          {
            display: 'Proveedores',
            href: 'MantenimientosBP/proveedores',
            icon: 'list'
          },
          {
            display: 'Listado proveedores',
            href: 'ListadosFtBP/Listado_proveedores',
            icon: 'list'
          },
          {
            display: 'Listado ficheros',
            href: 'ListadosFtBP/Listado_ficheros_proveedores',
            icon: 'list'
          },
          {
            display: 'Listado empresas/plantas',
            href: 'ListadosFtBP/Listado_empresas_plantas',
            icon: 'list'
          },
          {
            display: 'Listado plantas/productos',
            href: 'ListadosFtBP/Listado_plantas_productos',
            icon: 'list'
          }
        ]
      },
      {
        display: 'Fichas Técnicas',
        icon: '',
        children: [
          {
            display: 'Listado Fichas Técnicas',
            href: 'ListadosFtBP/Listado_Ft_Bp',
            icon: 'list'
          },
          {
            display: 'Listado ficheros de fichas técnicas',
            href: 'ListadosFtBP/Listado_ficheros_ft',
            icon: 'list'
          },
          {
            display: 'Búsqueda Avanzada',
            href: 'ListadosFTBP/Busqueda_Avanzada',
            icon: 'search'
          },
          {
            display: 'Auditoría estados FT',
            href: 'ListadosFT/Listado_cambio_estados_ft',
            icon: 'list'
          }
        ]
      },
      {
        display: 'Fichas Recepción',
        icon: '',
        children: [
          {
            display: 'Listado productos',
            href: 'Recepcion/ListadoProductos',
            icon: 'list'
          },
          {
            display: 'Configuración preguntas recepción',
            href: 'Recepcion/Configuracion',
            icon: 'build'
          }
        ]
      },
      {
        display: 'Gestión análisis',
        icon: '',
        children: [
          {
            display: 'Planificación análisis',
            href: 'GestionAnaliticasBP/Listado_planificacion_analiticas',
            icon: 'event_note'
          },
          {
            display: 'Resultados análisis',
            href: 'GestionAnaliticasBP/Listado_resultados_analisis',
            //icon: 'playlist_add_check'
            icon: 'list'
          },
          {
            display: 'Gestión no conformidades',
            href: 'GestionAnaliticasBP/Listado_nc_analisis',
            icon: 'playlist_add_check' //'checklist'
          },
          {
            display: 'Carga masiva planificación análisis',
            href: 'GestionAnaliticasBP/Carga_masiva',
            icon: 'file_upload'
          }
        ]
      },
      {
        display: 'Tirajes de etiquetado',
        icon: '',
        children: [
          {
            display: 'Listado',
            href: 'ListadosFtBP/Tirajes_Etiquetado',
            icon: 'style'
          }
        ]
      },
      {
        display: 'Listados Alarmas',
        icon: '',
        children: [
          {
            display: 'Estado fuera de plazo',
            href: 'ListadosAlarmas/estado_fuera_plazo',
            icon: 'list'
          },
          {
            display: 'Expiración certificados proveedores',
            href: 'ListadosAlarmas/expiracion_certificados',
            icon: 'list'
          },
          {
            display: 'Actualización FT',
            href: 'ListadosAlarmas/actualizacion_ft',
            icon: 'list'
          },
          {
            display: 'Control ingredientes por validar',
            href: 'Alarmas/verificacion_ingredientes',
            icon: 'list'
          }
        ]
      },
      // {
      //   display: 'Dashboard',
      //   icon: '',
      //   children: []
      // },
      {
        display: 'Contactos BonPreu',
        icon: '',
        children: [
          {
            display: 'Productos Marca Propia y Fleca',
            href: 'Contactos/MarcaPropiaFleca',
            icon: 'message'
          },
          {
            display: 'Productos Frescos',
            href: 'Contactos/Frescos',
            icon: 'message'
          }
        ]
      }
    ]
  };

  var mergedMenus = mergeSubArrays([].concat(buildGP4Menus(), menus));
  //var mergedMenus = mergeSubArrays([].concat(buildBaseAppMenus(), menus));
  return mergedMenus;
}

angular.module("gp4App").run(["$templateCache", function($templateCache) {$templateCache.put("app/base/views/askEmail.html","<div class=\"div-login\" style=\"max-width: 500px\">\n<form class=\"form-login\" role=\"form\">\n    <h3 class=\"form-login-heading\" style=\"text-align:center\"><translate>{{\"Por favor, informe su correo electrónico\" }}</translate></h3>\n    <p style=\"margin: 2em 0\">\n        Para dar cumplimiento a nuevas medidas de seguridad, en las próximas semanas activaremos la autenticación con doble factor, para ello es necesario que nos indique su correo electrónico. De lo contrario no podrá ingresar en la plataforma.\n    </p>\n    <div class=\"form-group\">\n        <input placeholder=\"Email\" ng-model=\"data.email\" required autofocus>\n    </div>\n    <div class=\"form-group\">\n        <button type=\"button\" class=\"btn btn-lg\" style=\"width: 45%\" ng-click=\"skip()\"><translate>{{\"Ahora no\" }}</translate></button>\n        <button class=\"btn btn-lg btn-gp-red\" style=\"width: 45%\" ng-click=\"send()\"><translate>{{\"Guardar correo\" }}</translate></button>\n    </div>\n    <br>\n    <div ng-show=\"message\" class=\"alert\" ng-class=\"{\'alert-danger\':message.ErrType==2,\'alert-warning\':message.ErrType==1,\'alert-info\':message.ErrType==0}\">\n        {{message.Msg}}\n    </div>\n</form>\n</div>\n");
$templateCache.put("app/base/views/changePassword.html","<div class=\"div-login\">\n<form class=\"form-login\" role=\"form\">\n    <h3 class=\"form-login-heading\" style=\"text-align:center\"><translate>{{\"Cambiar password\" }}</translate></h3>\n    <div class=\"form-group\">\n        <input type=\"password\" translate translate-attr-placeholder=\"Password actual\" ng-model=\"data.oldpassword\" required autofocus>\n    </div>\n    <div class=\"form-group\">\n        <input type=\"password\" translate translate-attr-placeholder=\"Nuevo password\" ng-model=\"data.newpassword\" required>\n    </div>\n    <div class=\"form-group\">\n        <input type=\"password\" translate translate-attr-placeholder=\"Repetir nuevo password\" ng-model=\"data.repetir\" required>\n    </div>\n    <div class=\"form-group\">\n        <button class=\"btn btn-lg btn-gp-red btn-block\" ng-click=\"send()\"><translate>{{\"Aplicar\" }}</translate></button>\n    </div>\n    <div ng-show=\"message\" class=\"alert\" ng-class=\"{\'alert-danger\':message.ErrType==2,\'alert-warning\':message.ErrType==1,\'alert-info\':message.ErrType==0}\">\n        {{message.Msg}}\n    </div>\n</form>\n</div>\n");
$templateCache.put("app/base/views/changePasswordCodigoUser.html","<div class=\"div-login\">\n<form class=\"form-login\" role=\"form\">\n    <h3 class=\"form-login-heading\" style=\"text-align:center\"><translate>{{\"Cambiar password\" }}</translate></h3>\n    <div class=\"form-group\">\n        <input type=\"password\" translate translate-attr-placeholder=\"Nuevo password\" ng-model=\"data.newpassword\" required>\n    </div>\n    <div class=\"form-group\">\n        <input type=\"password\" translate translate-attr-placeholder=\"Repetir nuevo password\" ng-model=\"data.repetir\" required>\n    </div>\n    <div class=\"form-group\">\n        <button class=\"btn btn-lg btn-gp-red btn-block\" ng-click=\"send()\"><translate>{{\"Aplicar\" }}</translate></button>\n    </div>\n    <div ng-show=\"message\" class=\"alert\" ng-class=\"{\'alert-danger\':message.ErrType==2,\'alert-warning\':message.ErrType==1,\'alert-info\':message.ErrType==0}\">\n        {{message.Msg}}\n    </div>\n</form>\n</div>\n");
$templateCache.put("app/base/views/desktop.html","<div ng-scrollbars class=\"scrolldiv\">\n	<div id=\"div-desktop\">\n		<header class=\"header-toolbar\">\n			<div class=\"toolbar-buttons\">\n				<span class=\"toolbar-title\"><translate>{{\"Desktop\" }}</translate></span>\n				<a class=\"btn btn-default pull-right\" role=\"button\" data-ng-click=\"appFilter.fav = (appFilter.fav?undefined:true)\">\n					<i class=\"material-icons\" data-ng-show=\"!appFilter.fav\">star</i>\n					<i class=\"material-icons yellow\" data-ng-show=\"appFilter.fav\">star</i>\n				</a>\n				<div class=\"container-search input-group pull-right\">\n					<input id=\"search\" type=\"text\" translate translate-attr-placeholder=\"{{\'Buscar aplicación...\' }}\" data-ng-model=\"appFilter.$\" ix-clear-input>\n					<span class=\"input-group-addon icon\"><i class=\"fa fa-search\"></i></span>\n				</div>\n\n			</div>\n		</header>\n		<div class=\"row\">\n			<div class=\"col-lg-2 col-md-3 col-sm-6 repeated-item\" data-ng-repeat=\"app in status.availApps | filter:filterFunction\">\n\n				<div ng-class=\"{\'open\': app.open}\" class=\"appbox\" data-ng-click=\"status.openApp(app)\">\n					<div class=\"appbox-image\"></div>\n					<div class=\"appbox-content\">\n						<div class=\"name\">\n							<span class=\"appbox-content-title\">\n								<translate>{{app.display }}</translate> <small>{{app.groupname}}</small>\n								<small ng-if=\"app.multiple\" ng-show=\"!key.startsWith(\'_\')\" ng-repeat=\"(key,value) in app.atributos\">{{ value }}</small>\n							</span>\n							<span class=\"appbox-content-text\" ng-if=\"!app.multiple && app.editing\">\n								<span ng-if=\"app.data.datos\" style=\"display:block; clear:both\">\n									<translate translate-value-idregistro=\"{{app.data.datos[app.data.showAsID] || app.data.datos[app.data.pk]}}\">{{ \'Modificando registro con id \\{\\{ idregistro \\}\\}\'  }}</translate>\n								</span>\n								<span ng-if=\"!app.data.datos && app.data.grid\">\n									<translate translate-value-numregistros=\"{{app.data.grid.numberOfChanges()}}\">{{ \'Registros por confirmar: \\{\\{numregistros\\}\\}\' }}</translate>\n								</span>\n							</span>\n						</div>\n						<uib-progressbar max=\"100\" min=\"0\" value=\"app.data.ixProgress\" class=\"progress-ix\" ng-class=\"{ \'invisible\': !app.data.ixProgress}\"></uib-progressbar>\n					</div>\n					<div class=\"appbox-icons\">\n						<div ng-show=\"app.open\" class=\"icon\" data-ng-click=\"status.closeApp(app);$event.stopPropagation()\" style=\"float: right\">\n							<i class=\"material-icons\">close</i>\n						</div>\n						<div class=\"icon\">\n							<!--<i data-ng-class=\"app.icon\" class=\"fa fa-fw\"></i>-->\n							<i class=\"material-icons\" ng-if=\"!app.customType\">{{app.icon}}</i>\n							<!--Si tiene iconos personalizados-->\n							<img ng-if=\"app.customType\" class=\"material-icons\" ng-src=\"{{::app.icon}}\" style=\"margin-bottom:10px\"> \n						</div>\n						<div class=\"star\" data-ng-click=\"setFav(app);$event.stopPropagation()\">\n							<!--<i class=\"fa fa-star-o grey\" data-ng-show=\"!app.fav\"></i> <i class=\"fa fa-star yellow\" data-ng-show=\"app.fav\"></i>-->\n							<i class=\"material-icons\" data-ng-show=\"!app.fav\">star</i> <i class=\"material-icons yellow\" data-ng-show=\"app.fav\">star</i>\n						</div>\n						<div class=\"star\" ng-show=\"app.editing\">\n							<i class=\"material-icons\" aria-hidden=\"true\">lock</i>\n						</div>\n					</div>\n					<!-- div class=\"boxbotleft\">{{app.id}}</div -->\n					<div class=\"count\" data-ng-class=\"app.countclass\">{{app.count}}</div>\n					<div class=\"count_label\" data-ng-class=\"app.countclass\">{{app.label}}</div>\n				</div>\n			</div>\n		</div>\n		<div ng-show=\"mostrarAlarmas\">\n			<header class=\"header-toolbar\">\n				<div class=\"toolbar-buttons\">\n					<span class=\"toolbar-title\">\n						<translate>{{\"Alarmas caducidad\" }}</translate>\n					</span>\n				</div>\n			</header>\n			<div class=\"row\">\n				<div class=\"col-lg-3 col-md-4 col-sm-6 repeated-item\">\n\n					<div ng-class=\"{\'open\': app.open}\" class=\"appbox\">\n						<hr>\n						<div class=\"appbox-content-alarma\">\n\n							<div class=\"name\">\n								<span class=\"appbox-content-title\">\n\n									<button style=\"display:block !important\" class=\"btn\" ng-class=\"{ \'con-alarma\': alarma.cantidad > 0 }\" ng-click=\"openAlarma(alarma.app)\" ng-repeat=\"alarma in titulosAlarmas\" ng-if=\"alarma.mostrar\">{{ alarma.titulo }}\n										{{ alarma.cantidad }}</button>\n								</span>\n							</div>\n						</div>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n\n	<style>\n		.nvd3 .nv-groups .nv-point {\n			stroke-opacity: 0.5 !important;\n			stroke-width: 10px;\n	}\n	</style>\n\n	<div class=\"div-desktop-dash\" my-transition-end=\"init()\" ng-if=\"dashboards.length>0 || extra_desktop_dashboard\">\n		<div class=\"row\">\n				<uib-accordion close-others=\"oneAtATime\">\n						<div uib-accordion-group class=\"panel-default ixFilter div-desktop-dash\" heading=\"{{dashboard.clave}}\" is-open=\"dashboard.isOpen\" ng-repeat=\"dashboard in dashboards\">\n								<div class=\"row dashboard\">\n										<!-- Dashboard widgets -->\n										<div gridster=\"gridsterOptions\">\n												<ul class=\"with-3d-shadow with-transitions\">\n														<li gridster-item=\"widget\" ng-repeat=\"widget in dashboard.widgets\">\n																<div class=\"box\">\n																		<div class=\"box-header\">\n																				<a class=\"widget-information\" title=\"{{ widget.explicativo }}\"><i class=\"glyphicon glyphicon-info-sign\"></i></a>\n																				<span class=\"h3\">{{ widget.titulo }}</span> <span class=\"h4\"> - {{ widget.subtitulo }}</span>\n																				<div class=\"box-header-btns pull-right\">\n																					<button class=\"btn btn-primary\" ng-click=\"refreshWidget(widget)\"><i class=\"fa fa-refresh\"></i> <translate>Actualizar</translate></button>\n																					<button class=\"btn btn-primary\" ng-click=\"exportWidget(widget)\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\n																					<button ng-if=\"widget.filtros.length > 0\" class=\"btn btn-primary\" ng-click=\"openSettings(widget)\"><i class=\"fa fa-filter\"></i> <translate>Filtrar</translate></button>\n																				</div>\n																		</div>\n																		<div class=\"box-content\">\n																				<!-- Grafic -->\n																				<nvd3 class=\"small-text {{ widget.chart.options.class }}\" ng-if=\"widget.tipo != \'grid\'\" options=\"widget.chart.options\" data=\"widget.chart.data\" api=\"widget.chart.api\" config=\"config\" events=\"events\"></nvd3>\n																				<!-- O grid -->\n																				<div ng-if=\"widget.tipo == \'grid\' && widget.grid\" style=\"height:inherit\">\n																					<div style=\"height:inherit\" data-ui-grid=\"widget.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate></div>\n																					<div class=\"footer\" style=\"position:relative;top:-20px\">\n																						<div ix-datetime-grid-generada grid=\"widget.grid\"></div>\n																					</div>\n																				</div>\n																		</div>\n																</div>\n														</li>\n												</ul>\n										</div>\n\n								</div>\n						</div>\n				<div ng-if=\"extra_desktop_dashboard\" ng-include=\"extra_desktop_dashboard\"></div>\n				</uib-accordion>\n		</div>  \n	</div>\n</div>\n\n\n\n\n\n");
$templateCache.put("app/base/views/desktop_new.html","<div id=\"div-desktop\">\n<header class=\"header-toolbar\">\n	<div class=\"toolbar-buttons\">\n		<span class=\"toolbar-title\">Desktop</span>\n		<a class=\"btn btn-default pull-right\" role=\"button\" data-ng-click=\"appFilter.fav = (appFilter.fav?undefined:true)\">\n			<i class=\"fa fa-star-o\" data-ng-show=\"!appFilter.fav\"></i>\n			<i class=\"fa fa-star yellow\" data-ng-show=\"appFilter.fav\"></i>\n		</a>\n		<!--<div class=\"input-group pull-right\" style=\"width: 300px;\">\n			<input id=\"search\" class=\"form-control\" type=\"text\" placeholder=\"Buscar aplicación...\" data-ng-model=\"appFilter.$\"/>\n			<span class=\"input-group-addon\"><i class=\"fa fa-search fa-lg\"></i></span>\n		</div>	-->\n		<div class=\"container-search input-group pull-right\">\n      <input id=\"search\" type=\"text\" placeholder=\"Buscar aplicación...\" data-ng-model=\"appFilter.$\">\n			<span class=\"input-group-addon icon\"><i class=\"fa fa-search\"></i></span>\n  	</div>\n\n	<!--<a class=\"btn btn-primary pull-right\" role=\"button\"><i class=\"fa fa-plus\"></i> Abrir aplicación</a>-->\n\n	</div>\n</header>\n<div class=\"row\" style=\"padding-bottom:20px\">\n	<div class=\"col-lg-2 col-md-3 col-sm-6 repeated-item\" data-ng-repeat=\"app in status.availApps | filter:filterFunction\">\n\n		<div ng-class=\"{\'open\': app.open}\" class=\"appbox\" data-ng-click=\"status.openApp(app)\">\n			<div ng-show=\"app.open\" class=\"close\" data-ng-click=\"status.closeApp(app);$event.stopPropagation()\">\n				<i class=\"fa fa-times black\"></i>\n			</div>\n			<div class=\"icon\">\n				<i data-ng-class=\"app.icon\" class=\"fa fa-fw\"></i>\n			</div>\n      <div class=\"star\" data-ng-click=\"setFav(app);$event.stopPropagation()\">\n        <i class=\"fa fa-star-o grey\" data-ng-show=\"!app.fav\"></i> <i class=\"fa fa-star yellow\" data-ng-show=\"app.fav\"></i>\n      </div>\n      <div class=\"star\" ng-show=\"app.editing\">\n        <i class=\"fa fa-lock\" aria-hidden=\"true\"></i>\n      </div>\n      <uib-progressbar max=\"100\" min=\"0\" value=\"app.data.ixProgress\" class=\"progress-ix\" ng-class=\"{ \'invisible\': !app.data.ixProgress}\"></uib-progressbar>\n			<div class=\"name\">\n        <span>\n				  {{app.display}} <small>{{app.groupname}}</small>\n        </span>\n        <span ng-if=\"app.editing\">\n          <span ng-if=\"app.data.datos\" style=\"display:block; clear:both\">\n            modificando registro con id {{ app.data.datos[app.data.pk] }}\n          </span>\n          <span ng-if=\"!app.data.datos && app.data.grid\">\n            registros por confirmar: {{app.data.grid.numberOfChanges()}}\n          </span>\n        </span>\n\n			</div>\n			<!-- div class=\"boxbotleft\">{{app.id}}</div -->\n			<div class=\"count\" data-ng-class=\"app.countclass\">{{app.count}}</div>\n			<div class=\"count_label\" data-ng-class=\"app.countclass\">{{app.label}}</div>\n		</div>\n	</div>\n</div>\n</div>\n\n\n\n");
$templateCache.put("app/base/views/filters.html","<style>\n    .ix-panel-nopaddingh > div > .panel-body {\n        padding: 15px 0; /* elimina el padding horizntal */\n    }\n</style>\n<div>\n<!--<uib-accordion close-others=\"true\">-->\n  <div>\n    <!--<div uib-accordion-group ng-repeat=\"f in filters track by $index\" is-open=\"f.isOpen\" class=\"panel-default ix-panel-nopaddingh\">-->\n    <div ng-repeat=\"f in filters track by $index\" is-open=\"f.isOpen\" class=\"panel-default ix-panel-nopaddingh\">\n        <!--<uib-accordion-heading>-->\n        <div class=\"header-toolbar\">\n          <div class=\"btn-toolbar toolbar-buttons\">\n            <button class=\"btn btn-primary\" ng-click=\"addNewItem(f)\" ng-show=\"addNewItem && f.view==\'list\' && !data.ocultaNuevo\" ng-disabled=\"status.editing || data.ixReadOnly == true\" uib-tooltip=\"Nuevo registro\" tooltip-placement=\"bottom\"><i class=\"fa fa-plus\"></i> <translate>Nuevo</translate></button>\n            <button class=\"btn btn-default\" ng-show=\"ixDownloadExcelListado && f.view==\'grid\'\" ng-click=\"ixDownloadExcelListado()\" uib-tooltip=\"Descargar excel\" tooltip-placement=\"bottom-right\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\n            <div class=\"pull-right btn-group\">\n                <label class=\"btn btn-default\" ng-model=\"f.view\" uib-btn-radio=\"\'list\'\"><i class=\"fa fa-th-list\"></i></label>\n                <label class=\"btn btn-default\" ng-model=\"f.view\" uib-btn-radio=\"\'grid\'\" ng-click=\"showGrid(data.grid)\"><i class=\"fa fa-table\"></i></label>\n								<label class=\"btn btn-default\" ng-click=\"fullScreen(true)\"><i class=\"fa fa-eye-slash\"></i></label>\n            </div>\n          </div>\n            <!--<i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': f.isOpen, \'glyphicon-chevron-right\': !f.isOpen}\"></i>-->\n        <!--</uib-accordion-heading>-->\n        </div>\n        <div style=\"min-height: 50px; background-color: #eee\">\n            <div class=\"btn-toolbar\" ng-show=\"f.view==\'list\'\">\n              <!--<button class=\"btn btn-default\"><i class=\"fa fa-cogs\"></i></button>-->\n\n              <!--<input class=\"btn btn-default form-control\" type=\"text\" name=\"buscar\" placeholder=\"Buscar\" />-->\n              <div style=\"width: 100%\" ng-if=\"loadExtraFilters\" data-ng-include=\"module + entity+\'/\'+entity+\'Filters.html\'\"></div>\n              <div class=\"input-group\" style=\"width: 100%;background-color: #fafafa;border-bottom: 1px solid #e1e1e1\">\n								<span class=\"input-group-addon\" style=\"border: 0px;background-color: #fafafa\"><i class=\"fa fa-search fa-lg\"></i></span> <input id=\"search\" type=\"text\" translate translate-value-entidad=\"{{::f.name}}\" translate-attr-placeholder=\"{{ \'Buscar \\{\\{entidad\\}\\}...\' }}\" ng-disabled=\"status.editing && !changeWhileEditing\" ng-change=\"actualizarListado()\" ng-model=\"data.busqueda\" style=\"border: 0px; background-color: #fafafa;line-height: 2.2em; font-size: 16px; width: 90%\" ix-clear-input autocomplete=\"off\">\n              </div>\n              <!--<button class=\"btn btn-default pull-right\" ng-model=\"f.orderByVisible\" uib-btn-checkbox><i class=\"fa fa-sort-alpha-asc\"></i> <span class=\"badge\" style=\"margin: 0 0 0 5px\">{{f.search.OrderBy.length}}</span></button>\n              <button class=\"btn btn-default pull-right\" ng-model=\"f.filterVisible\" uib-btn-checkbox><i class=\"fa fa-filter\"></i> <span class=\"badge\" style=\"margin: 0 0 0 5px\">{{f.search.Filters.length}}</span></button>-->\n            </div>\n						<div ng-scrollbars class=\"scrolldiv\">\n							<div ng-show=\"f.view==\'list\'\">\n								<div>\n									<!--<form name=\"searchform\" class=\"form-horizontal\" novalidate style=\"padding: 10px 15px 5px\" ng-show=\"f.filterVisible\">\n											<div class=\"form-group\" ng-repeat=\"field in f.search.Filters\">\n													<label class=\"col-md-5\">\n															<button type=\"button\" class=\"close\" ng-click=\"removeFilter(f,$index)\">&times;</button>\n															{{field.Field}}\n													</label>\n													<div class=\"col-md-7\">\n															<div class=\"input-group\">\n																	<div class=\"input-group-btn\">\n																			<div uib-dropdown class=\"btn btn-default\">\n																					<div uib-dropdown-toggle><i ng-class=\"k.CMP[field.Operator].icon\"></i></div>\n																					<ul uib-dropdown-menu>\n																							<li ng-repeat=\"op in k.CMP\" ng-click=\"field.Operator=op.operator; applyFilter(f)\">&nbsp;&nbsp;<i ng-class=\"op.icon\"></i> &nbsp;&nbsp;{{op.name}}</li>\n																					</ul>\n																			</div>\n																	</div>\n																	<input type=\"text\" class=\"form-control\" ng-model=\"field.Value\" ng-change=\"applyFilter(f)\" ng-model-options=\"{updateOn:\'blur\'}\" />\n															</div>\n													</div>\n											</div>\n											<div class=\"form-group\">\n													<div class=\"col-md-5\">\n															<input type=\"text\" class=\"form-control\" placeholder=\"nuevo filtro\" ng-model=\"newFilter\" uib-typeahead=\"field.Name as field.Name for field in metadata | filter:$viewValue\" typeahead-editable=\"false\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelectNewFilter($item);newFilter=null\" typeahead-focus-on-select=\"false\" typeahead-append-to-body=\"true\">\n													</div>\n											</div>\n									</form>\n									<div style=\"padding: 10px 15px 5px\" ng-show=\"f.orderByVisible\">\n											<div class=\"form-group\">\n													<div class=\"input-group\">\n															<span class=\"input-group-addon\">\n																	<i class=\"fa fa-sort-alpha-asc\"></i>\n															</span>\n															<ui-select multiple ng-model=\"f.search.OrderBy\" append-to-body=\"true\">\n																	<ui-select-match placeholder=\"seleccione los campos para ordenar\">\n																			{{$item.Name}}\n																	</ui-select-match>\n																	<ui-select-choices repeat=\"field.Name as field in (metadata | filter: $select.search) track by $index\">\n																			<span ng-bind=\"field.Name\"></span>\n																	</ui-select-choices>\n															</ui-select>\n													</div>\n											</div>\n									</div>-->\n									<div ng-if=\"data.loaded\">\n											<!--<uib-pagination ng-show=\"f.data.TotalPages>1\" items-per-page=\"f.data.ItemsPerPage\" total-items=\"f.data.TotalItems\" ng-model=\"f.data.CurrentPage\" max-size=\"5\" class=\"pagination-md\" next-text=\">\" previous-text=\"<\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"applyFilter(f)\" style=\"padding: 0 20px;\"></uib-pagination>-->\n										<div class=\"listEditResult\" ng-repeat=\"item in data.list\" ng-click=\"selectItem(item, $event)\" ng-show=\"!item.ToDelete\" ng-include=\"module + entity+\'/\'+entity+\'Card.html\'\" ng-class=\"{\'bg-info\':(angular.equals(item,current) || (data.datos[data.pk] && (data.datos[data.pk] == item[data.pk] || data.datos[data.pk] == item[data.listpk]))) && entity != \'FormularioFtBP\', \'recordDisabled\': ( item.activo == 0 || item.estado == 0 ) }\"></div>\n									</div>\n								</div>\n							</div>\n              <div ng-show=\"f.view==\'grid\'\" style=\"height: calc(100vh - 190px)\">\n                <span ng-if=\"!data.grid\"><translate>Esta acción puede tardar unos segundos.</translate><button class=\"btn btn-primary\" ng-click=\"cargarGrid()\"><translate>Cargar datos</translate></button></span>\n                <span ng-if=\"data.grid\">\n                  <div class=\"fwGrid\" ui-grid=\"data.grid\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\n                    <div class=\"grid-loading\" ng-if=\"data.grid.ixIsLoading\">\n                      <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\n                    </div>\n                  </div>\n                  <div>\n                    <div class=\"footer\">\n                      <div ix-datetime-grid-generada grid=\"data.grid\"></div>\n                    </div>\n                  </div>\n                </span>\n              </div>\n					</div>\n        </div>\n    </div>\n<!--</uib-accordion>-->\n  </div>\n</div>\n\n\n<script type=\"text/ng-template\" id=\"setOrderBy.html\">\n	<h1>\n		Ordenar resultados\n	</h1>\n	<div>\n		<div ng-repeat=\"f in orderBy\">\n            <span ng-if=\"\">{{f}}</span>\n        </div>\n		<button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Guardar</button>\n		<button type=\"button\" class=\"btn btn-danger\" ng-click=\"$uibModalInstance.dismiss(\'cancel\')\">Cancelar</button>\n	</div>\n	<div data-ng-show=\"{{user.role!=\'administrador\'}}\" data-ng-bind-html=\"currentApp.help\"></div>\n</script>\n");
$templateCache.put("app/base/views/formularioAyuda.html","<ix-popup-tool-bar title-left=\"Formulario de ayuda\"></ix-popup-tool-bar>\n<form name=\"form\" class=\"form-horizontal page-content scrolldiv\" id=\"div-desktop\" ng-scrollbars>\n    <div class=\"col-md-12\">\n        <div class=\"card-header\">\n            <h4 style=\"font-weight: bold\"><i class=\"fa fa-info\"></i> Información general</h4>\n        </div>\n        <div class=\"col-md-6\">\n            <ix-select ng-model=\"data.datos.clasificacion_incidencia\" name=\"Clasificación de la incidencia\" entity=\"clasificaciones\" pk=\"clasificacion\" desc=\"nombre\" ng-required=\"true\">\n            </ix-select>\n            <ix-select ng-model=\"data.datos.nivel_criticidad\" name=\"Nivel de criticidad\" entity=\"criticidades\" pk=\"criticidad\" desc=\"nombre\" ng-required=\"true\">\n            </ix-select>\n            <ix-select ng-model=\"data.datos.entorno\" name=\"Entorno\" entity=\"categorias\" pk=\"categoria\" desc=\"nombre\" ng-required=\"true\">\n            </ix-select>\n            <ix-select ng-model=\"data.datos.modulo\" name=\"Menú principal\" entity=\"modulos\" pk=\"modulo\" desc=\"nombre\" ng-required=\"true\">\n            </ix-select>\n            <ix-select ng-model=\"data.datos.submodulo\" name=\"Submenú\" entity=\"submodulos\" pk=\"submodulo\" desc=\"nombre\" ng-required=\"true\">\n            </ix-select>\n        </div>\n        <div class=\"col-md-6\">\n            <ix-select ng-model=\"data.datos.apk\" name=\"Aplicación Android\" entity=\"apks\" pk=\"apk\" desc=\"nombre\">\n            </ix-select>\n            <ix-text ng-model=\"data.datos.apk_version\" name=\"Versión App\" is-filter=\"true\">\n            </ix-text>\n            <ix-text ng-model=\"data.datos.apk_version_url\" name=\"URL App\" is-filter=\"true\">\n            </ix-text>\n        </div>\n    </div>\n    <div class=\"col-md-12\">\n        <div class=\"card shadow-sm\">\n            <div class=\"card-header\">\n                <h4 style=\"font-weight: bold\"><i class=\"fa fa-edit\"></i> Detalles de la incidencia</h4>\n            </div>\n            <div>\n                <div class=\"row\">\n                    <div class=\"col-12 col-md-6\">\n                        <div>\n                            <label class=\"form-label\">\n                                Describe el problema que presentas y los pasos realizados.\n                            </label>\n                            <ix-text-area class=\"form-control\" ng-model=\"data.datos.descripcion_problema\" rows=\"9\">\n                            </ix-text-area>\n                        </div>\n                    </div>\n                    <div class=\"col-12 col-md-6\">\n                        <div>\n                            <label class=\"form-label\">\n                                Respuesta esperada del sistema y qué ha sucedido realmente.\n                            </label>\n                            <ix-text-area class=\"form-control\" ng-model=\"data.datos.respuesta_sistema\" rows=\"4\">\n                            </ix-text-area>\n                        </div>\n                        <div>\n                            <label class=\"form-label\">\n                                Información relevante.\n                            </label>\n                            <small class=\"text-muted d-block\">\n                                Ej: chasis, número de OT, código de cliente, código de trabajo, etc.\n                            </small>\n                            <ix-text-area class=\"form-control\" ng-model=\"data.datos.info_relevante\" rows=\"4\">\n                            </ix-text-area>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"col-md-12\">\n        <div class=\"card shadow-sm\">\n            <!-- <div class=\"card-header\"> -->\n                <h4 style=\"font-weight: bold\"><i class=\"fa fa-paperclip\"></i> Adjuntar documentación</h4>\n            <!-- </div> -->\n            <p style=\"padding-left: 1.5rem\">\n                <span style=\"font-weight: bold\">IMPORTANTE: </span>\n                Adjunte capturas completas donde se vea el menú, el error y toda la información necesaria para revisar la incidencia.\n            </p>\n            <div class=\"card-body\">\n                <div>\n                    <input type=\"file\" class=\"form-control\" ngf-select ngf-multiple=\"true\" ng-model=\"data.datos.archivosToUpload\" name=\"archivo\">\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\" ng-repeat=\"img in data.datos.archivosToUpload track by $index\">\n                        <div class=\"card position-relative shadow-sm\">\n                            <img ng-src=\"{{getFileUrl(img)}}\" class=\"card-img-top\" alt=\"Vista previa\" style=\"height: 180px; object-fit: cover\">\n                            <div class=\"card-body p-2 text-center\">\n                                <small class=\"text-truncate d-block\">{{img.name}}</small>\n                                <button type=\"button\" class=\"btn btn-md btn-danger position-absolute\" uib-tooltip=\"{{ \'Eliminar\' }}\" ng-click=\"removeFile($index)\">\n                                    <i class=\"fa fa-times\"></i>\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</form>");
$templateCache.put("app/base/views/gridEditor.html","<div my-transition-end=\"init()\">\n  <ix-splash></ix-splash>\n  <ix-tool-bar>\n    <div ng-if=\"masAcciones\" class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\n      <button id=\"acciones-button\" uib-tooltip=\"Más acciones\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\n        Acciones <span class=\"caret\"></span>\n      </button>\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\n				<li role=\"menuitem\"><a ng-click=\"marcarTodos(1)\">Marcar Todo</a></li>\n        <li role=\"menuitem\"><a ng-click=\"marcarTodos(0)\">Desmarcar Todo</a></li>\n        <li class=\"divider\"></li>\n				<li ng-repeat=\"accion in masAcciones\" role=\"menuitem\" ng-if=\"accion.isVisible(item)\"><a ix-accion item=\"item\" accion=\"accion\" style=\"cursor:pointer\"><translate>{{::accion.title}}</translate></a></li>\n      </ul>\n    </div>\n  </ix-tool-bar>\n  <div ng-scrollbars class=\"scrolldiv\">\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\n    <div ng-show=\"!showPivot\" style=\"width:100%\">\n      <div ng-if=\"data.grid\" class=\"full-ui-grid\" data-ui-grid=\"data.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\n        <div class=\"grid-loading\" ng-if=\"data.grid.ixIsLoading\">          \n					<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>					\n        </div>\n      </div>\n    </div>\n    <div ng-show=\"showPivot && generatePivot\">\n      <div ng-include src=\"\'app/base/views/pivot.html\'\"></div>\n    </div>\n    <div>\n      <div class=\"footer\">\n        <div ix-datetime-grid-generada grid=\"data.grid\"></div>\n      </div>\n    </div>\n  </div>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/gridFooterCustomTemplate.html","<div class=\"ui-grid-footer-info ui-grid-grid-footer\">\n  <span>{{\'search.totalItems\' | t}} {{grid.rows.length}}</span>\n  <span ng-if=\"grid.renderContainers.body.visibleRowCache.length !== grid.rows.length\" class=\"ngLabel\">({{\"search.showingItems\" | t}} {{grid.renderContainers.body.visibleRowCache.length}})</span>\n  <span ng-if=\"grid.api.ix.generadaEl\" class=\"pull-right\">Información generada el {{grid.api.ix.generadaEl}}</span>\n</div>\n");
$templateCache.put("app/base/views/gridUsuarios.html","<div my-transition-end=\"init()\">\n  <ix-splash></ix-splash>\n  <ix-tool-bar></ix-tool-bar>\n  <div ng-scrollbars class=\"scrolldiv\">\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\n      <form name=\"form\" class=\"form-horizontal\" novalidate>\n          <fieldset class=\"form-data-filter\" ng-disabled=\"status.editing\">\n              <!--<div ng-repeat=\"(key, value) in filtro.data\" class=\"col-md-4\">\n                <!-- TODO: Fer-ho més dinàmic, possar tots els atributs necessaris en un objecte, llavors podriem reutilitzar la mateixa view sense importar els filtres que aquesta tingui. -->\n                <!--<ix-select ng-model=\"filtro.data[key]\" entity=\"api_clientes\" pk=\"id\" desc=\"id\" name=\'Client\' ng-disabled=\"status.editing\" load-function=\"loadClients\"></ix-select>-->\n                <!--<ix-select ng-model=\"filtro.data.client_id\" entity=\"api_clientes\" pk=\"id\" desc=\"id\" name=\'Client\' ng-disabled=\"status.editing\" load-function=\"loadClients\"></ix-select>\n              </div>-->\n            <!-- EXEMPLE de directiva ixSearchFromGrid -->\n            <!--<div class=\"col-md-4\">\n              <ix-search-from-grid ng-model=\"data.filtro.operativa\" entity=\"operaciones\" pk=\"operacion\" ng-disabled=\"status.editing\" ng-required=\"true\" name=\"Operativa\" show-only-described-cols=\"[\'operacion\', \'medio\', \'fecha\' ]\"></ix-search-from-grid>\n            </div>-->\n            <div class=\"col-md-4\" ng-if=\"showClient\">\n                <ix-select ng-model=\"data.filtro.client_id\" entity=\"api_clientes\" pk=\"id\" desc=\"id\" name=\"Client\" ng-disabled=\"status.editing\" load-function=\"loadClients\"></ix-select>\n            </div>\n          </fieldset>\n      <!--<fieldset class=\"form-data\" ng-disabled=\"!status.editing\">\n      <div class=\"col-md-12\">-->\n          <div style=\"width:100%\">\n            <div ng-show=\"!showPivot\" style=\"height: calc(100vh - 200px)\" data-ui-grid=\"data.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-exporter>\n              <div class=\"grid-loading\" ng-if=\"data.grid.ixIsLoading\">\n                <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"generatePivot\" ng-show=\"showPivot\">\n          <div ng-include src=\"\'Framework/views/pivot.html\'\"></div>\n          </div>\n      <!--</div>\n      </fieldset>-->\n    </form>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/gridUsuarios_etiquetas.html","<div ng-controller=\"GridUsuariosEtiquetasController\">\r\n  <!--<div class=\"modal-header-custom btn-toolbar\" style=\"margin-left: 0px;\">\n    <div class=\"pull-right\">\r\n      <a><i class=\"fa fa-spinner fa-pulse\" ix-loader></i></a>\r\n    </div>\r\n    <ix-tool-bar></ix-tool-bar>\r\n  </div>-->\n  <ix-popup-tool-bar title-left=\"Etiquetas\"></ix-popup-tool-bar>\n  <div class=\"modal-body\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div ng-if=\"!showPivot\" style=\"height: calc(100vh - 320px)\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-exporter>\n          <div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n            <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\n</div>\r\n");
$templateCache.put("app/base/views/gridUsuarios_grupos.html","<div ng-controller=\"GridUsuariosGruposController\">\r\n  <!--<div class=\"modal-header-custom btn-toolbar\" style=\"margin-left: 0px;\">\n    <div class=\"pull-right\">\r\n      <a><i class=\"fa fa-spinner fa-pulse\" ix-loader></i></a>\r\n    </div>\r\n    <ix-tool-bar></ix-tool-bar>\r\n  </div>-->\n  <ix-popup-tool-bar title-left=\"Grupos\"></ix-popup-tool-bar>\n  <div class=\"modal-body\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div ng-if=\"!showPivot\" style=\"height: calc(100vh - 320px)\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-exporter>\n          <div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n            <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\n</div>\r\n");
$templateCache.put("app/base/views/gridUsuarios_megawhere.html","<div ng-controller=\"GridUsuariosMegawhereController\">\n  <!--<div class=\"modal-header-custom btn-toolbar\" style=\"margin-left: 0px;\">\n    <div class=\"pull-right\">\n      <a><i class=\"fa fa-spinner fa-pulse\" ix-loader></i></a>\n    </div>\n    <ix-tool-bar></ix-tool-bar>\n  </div>-->\n  <ix-popup-tool-bar title-left=\"Condiciones\"></ix-popup-tool-bar>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"grid full-ui-grid\">\n        <div ng-if=\"!showPivot\" style=\"height: calc(100vh - 320px)\" data-ui-grid=\"gridmegawhere\" ng-style=\"{\'height\': \'calc(100vh - 170px)\' }\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\n          <div class=\"grid-loading\" ng-if=\"gridmegawhere.ixIsLoading\">\n            <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n<!-- \n\n<div class=\"grid full-ui-grid\" data-ui-grid=\"data.grid_nc\" ng-style=\"{\'height\': \'calc(100vh - 170px)\' }\"\n  data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-move-columns\n  data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard\n  data-ui-grid-exporter data-ui-grid-validate>\n  <div class=\"grid-loading\" ng-if=\"data.grid_nc.ixIsLoading\">\n    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\n  </div> -->");
$templateCache.put("app/base/views/listEdit.html","<div my-transition-end=\"init()\" style=\"position:relative; height: calc(100vh - 82px)\">\n  <ix-splash></ix-splash>\n  <div ui-layout=\"{ flow : \'column\', disableToggle: true, dividerSize: 0 }\" ng-class=\"{ \'centerToFullScreen\': data.fullScreen }\">\n      <div class=\"ix-layout-left\" ui-layout-container size=\"{{(cfg.listEditSize||\'18%\')}}\" style=\"background-color:#ffffff\">\n          <div ng-if=\"status.transitionend\" data-ng-include=\"includeFiltersTemplate\" style=\"overflow-x:hidden\"></div>\n      </div>\n      <div class=\"ix-layout-central\" ui-layout-container=\"central\">\n          <div ng-if=\"status.transitionend\" data-ng-include=\"module + entity+\'/\'+entity+\'Form.html\'\"></div>\n      </div>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/listados_programados.html","<div my-transition-end=\"init()\">\n  <ix-splash></ix-splash>\n  <ix-tool-bar special-tool-bar=\"true\"></ix-tool-bar>\n  <div ng-scrollbars class=\"scrolldiv\">\n    <div class=\"page-content\" ng-show=\"status.transitionend\">\n      <form ng-if=\"(cfg.clientId == \'GPv4\' || cfg.clientId == \'Gestpark-Intranet\') && searchDropdown\" name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\n        <uib-accordion close-others=\"oneAtATime\">\n          <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\n            <fieldset class=\"form-data-filter\">\n              <div class=\"row\">\n                  <div class=\"col-md-4\">\n                      <ix-select ng-model=\"data.filtro.client_id\" name=\"Client ID\" entity=\"api_client\" pk=\"id\" desc=\"id\" load-function=\"searchDropdown\" ng-disabled=\"status.filtered\"></ix-select>\n                  </div>\n              </div>\n            </fieldset>\n          </div>\n        </uib-accordion>\n      </form>\n      <div ng-if=\"status.transitionend\">\n        <div class=\"full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 334px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\n          <div class=\"grid-loading\" ng-if=\"data.grid.ixIsLoading\">\n            <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\n          </div>\n        </div>\n        <div>\n          <div class=\"footer\">\n            <div ix-datetime-grid-generada grid=\"data.grid\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/listados_programados_popup.html","<div>\n  <ix-popup-tool-bar title-left=\"Programar Listado\"></ix-popup-tool-bar>\n  <div ng-scrollbars class=\"scrolldiv\">\n		<div class=\"scrolldiv-content\">\n      <div class=\"modal-body\">\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\n          <div class=\"row\">\n            <h3 style=\"margin-left:90px\">Listado</h3>\n            <div class=\"col-md-6\">\n              <ix-text ng-model=\"data.nombre\" name=\"Listado\" ng-required=\"true\" max-length=\"getMaxLength(\'nombre\')\" clean-special-chars=\"regExpSpecialChars\"></ix-text>\n              <ix-text-area ng-model=\"data.descripcion\" name=\"Descripción\" max-length=\"getMaxLength(\'descripcion\')\"></ix-text-area>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-6\">\n              <ix-radio ng-model=\"data.intervaloseleccionado\" options=\'[{value: 0, text: \"Único\"},{value: 1, text: \"Minutos\"},{value: 2, text: \"Horas\"},{value: 3, text: \"Días\"},{value: 4, text: \"Meses\"},]\' name=\"intervalo\" label=\"Intervalo\"></ix-radio>\n              <ix-text ng-if=\"data.intervaloseleccionado == \'1\'\" ng-model=\"data.intervalo\" name=\"Minutos\" ix-number ng-required=\"true\" min-value=\"1\" max-value=\"59\"></ix-text>\n              <ix-text ng-if=\"data.intervaloseleccionado == \'2\'\" ng-model=\"data.intervalo_horas\" name=\"Horas\" ix-number ng-required=\"true\" min-value=\"1\" max-value=\"24\"></ix-text>\n              <ix-text ng-if=\"data.intervaloseleccionado == \'3\'\" ng-model=\"data.intervalo_dias\" name=\"Días\" ix-number ng-required=\"true\" min-value=\"1\" max-value=\"31\"></ix-text>\n              <ix-text ng-if=\"data.intervaloseleccionado == \'4\'\" ng-model=\"data.intervalo_meses\" name=\"Meses\" ix-number ng-required=\"true\" min-value=\"1\" max-value=\"12\"></ix-text>\n            </div>\n\n            <div class=\"col-md-6\">\n              <ix-options-si-no ng-model=\"data.activo\" name=\"Activo\"></ix-options-si-no>\n              <ix-date ng-model=\"data.fecha_ini\" name=\"Fecha Inicial\" ng-required=\"true\"></ix-date>\n              <ix-date ng-model=\"data.fecha_fin\" name=\"Fecha Final\"></ix-date>\n              <ix-time ng-model=\"data.hora_ini\" name=\"Hora Inicial\" ng-required=\"true\" minuto-exacto=\"true\" minuto-multiple-de=\"5\"></ix-time>\n              <ix-time ng-model=\"data.hora_fin\" name=\"Hora Final\" ng-required=\"data.intervaloseleccionado == 1 || data.intervaloseleccionado == 2\" minuto-exacto=\"true\" minuto-multiple-de=\"5\"></ix-time>\n              <ix-select ng-model=\"data.body\" name=\"Body\" entity=\"listados_programados_bodies\" pk=\"body\" desc=\"nombre\"></ix-select>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-6\">\n              <!-- De moment només es poden treure excels. -->\n              <!--<ix-radio ng-model=\"data.extension\" options=\'[{value: \"XLS\", text: \"XLS\"},{value: \"TXT\", text: \"TXT\"},{value: \"CSV\", text: \"CSV\"},{value: \"PDF\", text: \"PDF\"}]\' name=\"extension\" label=\"Extensión\"></ix-radio>\n              <ix-options-si-no ng-if=\"data.extension==\'CSV\'\" ng-model=\"data.con_cabeceras\" name=\"Con cabeceras de columna\"></ix-options-si-no>-->\n              <ix-options-si-no ng-model=\"data.test\" name=\"Forzar un envío único (se realizará en los siguientes 5 minutos)\" text-max-width=\"true\"></ix-options-si-no>\n            </div>\n            <div class=\"col-md-6\">\n              <ix-options-si-no ng-model=\"data.enviar_sin_resultados\" name=\"Enviar si no se generan resultados\" text-max-width=\"true\"></ix-options-si-no>\n            </div>\n          </div>\n          <div class=\"row\" ng-if=\"data.intervaloseleccionado == \'3\' && data.intervalo_dias == 1 && datosOriginales.client_id\">\n            <h3 style=\"margin-left:90px\">Días de envío</h3>\n            <div class=\"col-md-2\">\n            </div>\n            <div class=\"col-md-2\">\n              <ix-options-si-no ng-model=\"data.lunes\" name=\"Lunes\"></ix-options-si-no>\n              <ix-options-si-no ng-model=\"data.martes\" name=\"Martes\"></ix-options-si-no>\n              <ix-options-si-no ng-model=\"data.miercoles\" name=\"Miércoles\"></ix-options-si-no>\n              <ix-options-si-no ng-model=\"data.jueves\" name=\"Jueves\"></ix-options-si-no>\n            </div>\n            <div class=\"col-md-2\">\n              <ix-options-si-no ng-model=\"data.viernes\" name=\"Viernes\"></ix-options-si-no>\n              <ix-options-si-no ng-model=\"data.sabado\" name=\"Sábado\"></ix-options-si-no>\n              <ix-options-si-no ng-model=\"data.domingo\" name=\"Domingo\"></ix-options-si-no>\n            </div>\n          </div>\n          <div class=\"row\" ng-if=\"data.plantilla > 0 || (!data.contador && showDatosPlantilla)\">\n            <h3 style=\"margin-left:90px\">Datos Plantilla</h3>\n            <div class=\"col-md-6\">\n              <ix-select ng-model=\"data.plantilla\" entity=\"listados_programados_plantillas\" pk=\"plantilla\" desc=\"nombre\" name=\"Plantilla\" load-function=\"loadPlantillas\" ng-required=\"false\" append-to-body=\"true\"></ix-select>              						\n            </div>\n          </div>\n          <div class=\"row\" ng-if=\"data.plantilla > 0 || (!data.contador && showDatosPlantilla)\">            \n            <div class=\"col-md-6\">              \n              <ix-select-multiple ng-model=\"data.plantilla_cfg_grupos\" name=\"Grupos\" pk=\"grupo\" desc=\"nombre\" load-function=\"loadGrupos\" editable-dropdown=\"false\" append-to-body=\"true\" comma-separated=\"true\"></ix-select-multiple>\n              <!--<ix-select-multiple ng-model=\"data.plantilla_cfg_transportistas\" name=\"Transportistas\" pk=\"transp\" desc=\"nombre\" load-function=\"loadTransportistas\" editable-dropdown=\"false\" append-to-body=\"true\" comma-separated=\"true\"></ix-select-multiple>						-->\n              <ix-select-multiple ng-model=\"data.plantilla_cfg_transportistas\" name=\"Transportistas\" entity=\"transportistas\" pk=\"transp\" desc=\"nombre\" editable-dropdown=\"false\" append-to-body=\"true\" comma-separated=\"true\"></ix-select-multiple>\n            </div>\n            <div class=\"col-md-6\">\n              <ix-select-multiple ng-model=\"data.plantilla_cfg_clientes\" name=\"Clientes\" pk=\"cliente\" desc=\"nombre\" load-function=\"loadClientes\" editable-dropdown=\"false\" append-to-body=\"true\" comma-separated=\"true\"></ix-select-multiple>\n              <ix-select-multiple ng-model=\"data.plantilla_cfg_cuentas\" name=\"Clientes/Cuentas\" pk=\"clicue\" desc=\"nombre\" load-function=\"loadClientesCue\" editable-dropdown=\"false\" append-to-body=\"true\" comma-separated=\"true\"></ix-select-multiple>						\n            </div>\n          </div>\n          <div class=\"row\">\n            <h3 style=\"margin-left:90px\">Envío</h3>\n            <span ng-if=\"!data.ListProgramadosEnviosModoGrid && configLoaded\">\n              <div class=\"col-md-6\">\n                <ix-text-area ng-model=\"data.mailto\" name=\"Direcciones de correo\" rows=\"6\"></ix-text-area>\n                <p style=\"padding-left:120px\">Puede separar direcciones de correo con ;</p>\n              </div>\n              <div class=\"col-md-6\">\n                <ix-text-area ng-model=\"data.mailcc\" name=\"Direcciones de correo ocultas\" rows=\"6\"></ix-text-area>\n              </div>\n            </span>\n            <span ng-if=\"data.ListProgramadosEnviosModoGrid\">\n              <div class=\"col-md-6\">\n                <div class=\"btn-toolbar\">\n                  <a style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridMailTo.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridMailTo)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\n                  <a style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow(data.gridMailTo)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\n                </div>\n                <div data-ui-grid=\"data.gridMailTo\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\n                  <div class=\"grid-loading\" ng-if=\"data.gridMailTo.ixIsLoading\">\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\n                  </div>\n                </div>\n                <div>\n                  <div class=\"footer\">\n                    <div ix-datetime-grid-generada grid=\"data.gridMailTo\"></div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"col-md-6\">\n                <div class=\"btn-toolbar\">\n                  <a style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridMailCC.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridMailCC)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\n                  <a style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow(data.gridMailCC)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\n                </div>\n                <div data-ui-grid=\"data.gridMailCC\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\n                  <div class=\"grid-loading\" ng-if=\"data.gridMailCC.ixIsLoading\">\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\n                  </div>\n                </div>\n                <div>\n                  <div class=\"footer\">\n                    <div ix-datetime-grid-generada grid=\"data.gridMailCC\"></div>\n                  </div>\n                </div>\n              </div>\n            </span>\n          </div>\n\n          <div class=\"row\">\n            <h3 style=\"margin-left:90px\">FTP</h3>\n            <div class=\"col-md-6\">\n              <ix-radio ng-model=\"data.ftp\" ng-default=\"0\" options=\"[{ value: 0, text: \'Ninguno\' }, { value: 1, text: \'FTP\' }, { value: 2, text: \'SFTP/WinSCP\' } ]\"></ix-radio>\n              <ix-text ng-model=\"data.ftphost\" name=\"Host\" ng-required=\"data.ftp == 1 || data.ftp == 2\"></ix-text>\n              <ix-text ng-model=\"data.ftpport\" name=\"Puerto\" ix-number ng-required=\"data.ftp == 1 || data.ftp == 2\"></ix-text>\n              <ix-text ng-model=\"data.ftpuser\" name=\"Usuario\" ng-required=\"data.ftp == 1 || data.ftp == 2\"></ix-text>\n              <ix-password ng-model=\"data.ftppwd\" name=\"Password\" ng-required=\"data.ftp == 1 || data.ftp == 2\"></ix-password>\n              <ix-text ng-model=\"data.ftppath\" name=\"Path\"></ix-text>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/listados_programados_querys_popup.html","<div>\n    <ix-popup-tool-bar title-left=\"Querys Listado\"></ix-popup-tool-bar>\n    <div ng-scrollbars class=\"scrolldiv\">\n      <div class=\"scrolldiv-content\">\n        <div class=\"modal-body\">\n            <div class=\"row\">\n                <div ng-if=\"data.Query != null\">\n                    <label>Query:</label> <p>{{data.Query}}</p>\n                    <label>Where:</label> <p>{{data.Where}}</p>\n                </div>\n                <div ng-if=\"data.Select != null\">\n                    <label>Select:</label> <p>{{data.Select}}</p>\n                    <label>SelectDetalle:</label> <p>{{data.SelectDetalle}}</p>\n                    <label>SelectDetalle2:</label> <p>{{data.SelectDetalle2}}</p>\n                    <label>SelectDetalle3:</label> <p>{{data.SelectDetalle3}}</p>\n                    <label>SelectDetalle4:</label> <p>{{data.SelectDetalle4}}</p>\n                </div>\n            </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  ");
$templateCache.put("app/base/views/login.html","<div class=\"div-login\">\n    <form class=\"form-login\" role=\"form\" ng-disabled=\"loading\">\n        <h3 class=\"form-login-heading\" style=\"text-align:center\"><translate>{{ cfg.welcomeMsg || \"Bienvenido a \" }} </translate> <translate>{{ cfg.appName }}</translate></h3>\n        <div class=\"form-group\">\n            <input type=\"text\" placeholder=\"Usuario\" data-ng-model=\"loginData.userName\" ng-keyup=\"compruebaCaracteresProhibidos($event, \'userName\')\" required autofocus ng-disabled=\"request_token2fa || loading\">\n        </div>\n        <div class=\"form-group\">\n            <input type=\"password\" placeholder=\"Contraseña\" data-ng-model=\"loginData.password\" required ng-disabled=\"request_token2fa || loading\">\n        </div>\n        <div class=\"form-group\" ng-if=\"request_token2fa\">\n            <input type=\"text\" placeholder=\"Token 2FA\" data-ng-model=\"loginData.token2fa\" required>\n        </div>\n        <div class=\"form-group\">\n            <ui-select ng-model=\"loginData.domain\" search-enabled=\"false\" ng-hide=\"!allDomains.length\" ng-disabled=\"request_token2fa\">\n                 <ui-select-match allow-clear=\"true\" placeholder=\"Dominio\">{{$select.selected}}</ui-select-match>\n                 <ui-select-choices repeat=\"item in (allDomains)\">\n                    <div>{{item}}</div>\n                </ui-select-choices>\n            </ui-select>\n           </div>\n        <div class=\"form-group\">\n            <ui-select class=\"ui-select-login\" ng-model=\"loginData.api\" search-enabled=\"false\" on-select=\"ChangeAPI()\" ng-hide=\"allApis.length<=1\" ng-disabled=\"request_token2fa || loading\">\n                 <ui-select-match placeholder=\"API | translate\">{{$select.selected.Descripcion}}</ui-select-match>\n                 <ui-select-choices repeat=\"item in (allApis)\">\n                    <div>{{item.Descripcion}}</div>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n        <div class=\"form-group\" ng-if=\"!request_token2fa\">\n            <button class=\"btn btn-lg btn-gp-red btn-block\" type=\"submit\" data-ng-click=\"login()\" ng-disabled=\"loading\"><translate>ACCEDER</translate><a ng-if=\"logueando\" class=\"ix-loader-container\" ix-loader><i class=\"fa fa-circle-o-notch fa-spin\" style=\"margin-left: 5px;font-size: 18px;color: white\"></i></a></button>\n        </div>\n        <div class=\"form-group\" ng-if=\"request_token2fa\">\n            <button class=\"btn btn-lg btn-gp-red btn-block\" type=\"submit\" data-ng-click=\"login2FA()\"><translate>CONTINUAR</translate><a ng-if=\"logueando\" class=\"ix-loader-container\" ix-loader><i class=\"fa fa-circle-o-notch fa-spin\" style=\"margin-left: 5px;font-size: 18px;color: white\"></i></a></button>\n        </div>\n        <div class=\"form-group\" ng-if=\"cfg.loginAzure\">\n            <div class=\"login-divider\">\n            <span>o</span>\n            </div>\n            <button class=\"ms-login-btn\" type=\"button\" ng-click=\"loginWithMicrosoft()\" ng-disabled=\"loading\">\n                <svg width=\"20\" height=\"20\" viewBox=\"0 0 23 23\" aria-hidden=\"true\">\n                    <rect x=\"1\" y=\"1\" width=\"10\" height=\"10\" fill=\"#F25022\"/>\n                    <rect x=\"12\" y=\"1\" width=\"10\" height=\"10\" fill=\"#7FBA00\"/>\n                    <rect x=\"1\" y=\"12\" width=\"10\" height=\"10\" fill=\"#00A4EF\"/>\n                    <rect x=\"12\" y=\"12\" width=\"10\" height=\"10\" fill=\"#FFB900\"/>\n                </svg>\n                <span>Sign in with Microsoft</span>\n            </button>            \n        </div>\n        <div data-ng-hide=\"message == \'\'\" class=\"alert\" ng-class=\"messsage.error?\'alert-error\':\'alert-info\'\" style=\"margin: 1em 0\">\n            {{message.error_description}} <a><i class=\"fa fa-circle-o-notch fa-spin\" ix-loader></i></a>\n        </div>\n		<br>\n		<div class=\"row\" ng-if=\"loginData.api.clientId==\'Extranet\'\">\n			<div class=\"col text-center\">\n				<button ng-click=\"abrirResetPassword()\" type=\"button\" class=\"btn btn-xs btn-link\">¿Contraseña olvidada?</button>\n			</div>\n		</div>	        \n    </form>\n    </div>\n    ");
$templateCache.put("app/base/views/notification_pda_popup.html","<div>\n  <ix-popup-tool-bar title-left=\"Enviar Notificación\">\n		<button class=\"btn pull-right\" ng-click=\"enviar()\" ng-disabled=\"status.blockUIBtns || form.$invalid\" tooltip-placement=\"bottom\"><translate>Enviar</translate></button>\n	</ix-popup-tool-bar>\n	<div class=\"modal-body\">\n		<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\n			<div class=\"row\">\n				<div class=\"col-md-12\">\n					<ix-text ng-model=\"data.title\" name=\"Título\" ng-required=\"true\"></ix-text>\n					<ix-text-area ng-model=\"data.text\" name=\"Texto\" ng-required=\"true\" rows=\"8\"></ix-text-area>\n					<ix-select on-select=\"checkOperario\" ng-model=\"data.operario\" name=\"Operario\" entity=\"operarios\" pk=\"operario\" desc=\"nombre\" conditions=\"[{ field: \'activo\', value: \'1\' }]\" append-to-body=\"true\" ng-disabled=\"data.grupo\"></ix-select>					\n					<ix-select ng-model=\"data.grupo\" name=\"Grupo\" entity=\"grupos\" pk=\"grupo\" desc=\"nombre\" ng-required=\"!data.operario\" ng-disabled=\"data.operario\" append-to-body=\"true\" preload=\"true\"></ix-select>										\n					<ix-select on-select=\"checkCargo\" ng-model=\"data.cargo\" name=\"Cargo\" entity=\"cargos\" pk=\"cargo\" desc=\"nombre\" ng-disabled=\"data.operario\" append-to-body=\"true\"></ix-select>					\n				</div>\n			</div>\n		</form>\n	</div>  \n</div>\n");
$templateCache.put("app/base/views/pivot.html","<div>\n	<div>\n		<div id=\"pivotTableOutput\" style=\"margin:30px\"></div>\n	</div>\n</div>\n");
$templateCache.put("app/base/views/reset_password_popup.html","<div>\n  <ix-popup-tool-bar title-left=\"Reiniciar Contraseña\"></ix-popup-tool-bar>\n  <div ng-scrollbars class=\"scrolldiv\">\n		<div class=\"scrolldiv-content\">\n			<div class=\"modal-body div-reset-password\">\n				<div class=\"div-login\">\n\n					<form class=\"form-login\" role=\"form\">					\n						<div class=\"form-group\">\n								<input type=\"text\" placeholder=\"Usuario\" data-ng-model=\"data.usuario\" required autofocus>\n						</div>\n						<div class=\"form-group\">\n							<button ng-disabled=\"!data.usuario\" class=\"btn btn-lg btn-gp-warning btn-block\" type=\"submit\" data-ng-click=\"enviar_mail()\"><translate>REINICIAR CONTRASEÑA</translate><a ng-if=\"logueando\" class=\"ix-loader-container\" ix-loader><i class=\"fa fa-circle-o-notch fa-spin\" style=\"margin-left: 5px;font-size: 18px;color: white\"></i></a></button>\n						</div>\n						<div data-ng-hide=\"!message\" class=\"alert alert-info\">\n									{{message}}\n								</div>\n<!--\n						<div class=\"form-group\">\n								<input type=\"text\" placeholder=\"Código Recibido\" data-ng-model=\"data.codigo\" required>\n						</div>					\n						<div class=\"form-group\">\n								<button ng-disabled=\"!data.usuario || !data.codigo\" class=\"btn btn-lg btn-gp-red btn-block\" type=\"submit\" data-ng-click=\"reset_password()\"><translate>RESETEAR PASSWORD</translate><a ng-if=\"logueando\" class=\"ix-loader-container\" ix-loader><i class=\"fa fa-circle-o-notch fa-spin\" style=\"margin-left: 5px;font-size: 18px;color: white;\"></i></a></button>\n						</div>	\n-->\n						<div data-ng-hide=\"message_error == \'\'\" class=\"alert alert-danger\">\n								{{message_error}}\n						</div>\n					</form>					\n				</div>\n			</div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/base/views/sidebar.html","<div id=\"div-sidebar-apps\" class=\"scrolldiv\">\n	<div ng-include=\"template\"></div>\n</div>\n");
$templateCache.put("app/base/views/sidebar_apps.html","<div id=\"div-sidebar-apps\" class=\"scrolldiv\" ng-scrollbars style=\"height:100%\">			\r\n	<ul class=\"list-group\">\r\n		<li data-ng-repeat=\"app in status.availApps | filter:filterFunction\" ng-class=\"{\'current\': isCurrent(app)}\">\r\n			<div ng-class=\"{\'open\': app.open}\" data-ng-click=\"status.openApp(app);closeSideBarApps()\">			\r\n				<div ng-show=\"app.open && !isCurrent(app)\" class=\"icon\" data-ng-click=\"app.onCloseGoTo=status.current.href;status.closeApp(app);$event.stopPropagation()\" style=\"float:right; position: relative; right: -10px\">\r\n					<i class=\"material-icons\">close</i>\r\n				</div>\r\n				<a>\r\n					<span class=\"pull-left\"><i class=\"material-icons\">{{app.icon}}</i></span> <translate>{{app.display }}</translate> <small>{{app.groupname}}</small>\r\n					<small ng-if=\"app.multiple\" ng-show=\"!key.startsWith(\'_\')\" ng-repeat=\"(key,value) in app.atributos\">{{ value }}</small>\r\n					</a>\r\n				<uib-progressbar max=\"100\" min=\"0\" value=\"app.data.ixProgress\" class=\"progress-ix\" ng-class=\"{ \'invisible\': !app.data.ixProgress}\"></uib-progressbar>				\r\n			</div>		\r\n		</li>\r\n	</ul>\r\n</div>\r\n");
$templateCache.put("app/base/views/videoPlayer.html","<div my-transition-end=\"init()\">\n  <ix-splash></ix-splash>\n  <ix-tool-bar></ix-tool-bar>\n  <div ng-scrollbars class=\"scrolldiv\">\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\n      <div class=\"videogular-container\">\n        <videogular vg-theme=\"config.theme\">\n          <vg-media vg-src=\"config.sources\" vg-tracks=\"config.tracks\">\n          </vg-media>\n\n          <vg-controls vg-autohide=\"config.plugins.controls.autoHide\" vg-autohide-time=\"config.plugins.controls.autoHideTime\">\n            <vg-play-pause-button></vg-play-pause-button>\n            <vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display>\n            <vg-scrub-bar>\n              <vg-scrub-bar-current-time></vg-scrub-bar-current-time>\n            </vg-scrub-bar>\n            <vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display>\n            <vg-volume>\n              <vg-mute-button></vg-mute-button>\n              <vg-volume-bar></vg-volume-bar>\n            </vg-volume>\n            <vg-fullscreen-button></vg-fullscreen-button>\n          </vg-controls>\n\n          <vg-overlay-play></vg-overlay-play>\n          <vg-poster vg-url=\"config.plugins.poster\"></vg-poster>\n        </videogular>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/xml_popup.html","<div>\n  <ix-popup-tool-bar title-left=\"Visor XML\"></ix-popup-tool-bar>\n  <div ng-scrollbars class=\"scrolldiv\">\n		<div class=\"scrolldiv-content\">\n      <div class=\"modal-body\">\n        <div class=\"row\">\n          <div class=\"col-md-6\">              \n            <h2>{{titulo}}</h2>\n            <ix-text-area label-class=\"col-md-0\" input-class=\"col-md-12\" ng-disabled=\"true\" ng-model=\"XMLPretty\" rows=\"30\"></ix-text-area>\n          </div>  \n          <div class=\"col-md-6\">              \n            <h2>Sin Formato</h2>\n            <ix-text-area label-class=\"col-md-0\" input-class=\"col-md-12\" ng-disabled=\"true\" ng-model=\"data\" rows=\"30\"></ix-text-area>\n          </div>             \n        </div>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/base/views/framework_templates/ixErrorsPopup.html","<div>\n  <ix-popup-tool-bar title-left=\"Errores\" hide-all=\"true\"></ix-popup-tool-bar>\n  <div ng-scrollbars class=\"scrolldiv\">\n		<div class=\"scrolldiv-content\">\n      <div class=\"modal-body\">\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <h4></h4>\n              <span ng-if=\"status.response.data.Errors\" ng-init=\"firstError = status.response.data.Errors[0]\">\n                <p ng-repeat=\"error in status.response.data.Errors\">{{error.Msg}}<br></p>\n              </span>\n              <span ng-if=\"(status.response.data.obj.Errors) && status.response.data.obj.Errors.length > 0\">\n                <p ng-repeat=\"error in status.response.data.obj.Errors | filter:{ErrType: 2}\">{{error.Msg}}</p>\n              </span>\n              <span ng-repeat=\"itemResp in status.response.data.Inserted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\n                <p ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</p>\n              </span>\n              <span ng-repeat=\"itemResp in status.response.data.Updated\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\n                <p ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</p>\n              </span>\n              <span ng-repeat=\"itemResp in status.response.data.Deleted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\n                <p ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</p>\n              </span>\n              <span ng-repeat=\"itemResp in status.response.data.Processed\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\n                <p ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</p>\n              </span>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/framework_templates/ixGridToolBar.html","<div class=\"btn-toolbar\">\n	<div class=\"pull-left\" ng-show=\"status.editing\">\n		{{gridApi.rowEdit.getDirtyRows().length}} filas modificadas\n		{{deletedRows.length}} filas eliminadas\n		{{insertedRows.length}} filas creadas\n		{{gridApi.selection.getSelectedRows().length}} filas seleccionadas\n	</div>\n	<button class=\"btn btn-default pull-right\" onclick=\"maximizeGrid(this, event)\" uib-tooltip=\"maximizar/minimizar\"><i class=\"fa fa-arrows-alt\"></i></button>\n	<div uib-dropdown class=\"pull-right\" is-open=\"false\">\n		<button uib-dropdown-toggle class=\"btn btn-default\"><i class=\"fa fa-cogs\"></i> <span class=\"caret\"></span></button>\n		<ul uib-dropdown-menu>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" data-ng-click=\"savePreferences()\"><i class=\"fa fa-floppy-o\"></i> Guardar preferencias de visualización</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" data-ng-click=\"restorePreferences()\"><i class=\"fa fa-undo\"></i> Restaurar preferencias de visualización</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-wrench\"></i> Predefinir para todos los usuarios (admin)</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-trash-o\"></i> Eiminar settings de todos los usuarios (admin)</a></li>\n		</ul>\n	</div>\n	<a class=\"btn btn-default pull-right\" ng-class=\"gridOptions.enableFiltering?\'active\':\'\'\" role=\"button\" data-ng-click=\"toggleFiltering()\" uib-tooltip=\"togle filter\"><i class=\"fa fa-filter\"></i></a>\n	<a class=\"btn btn-default pull-right\" role=\"button\" data-ng-click=\"downloadCSV()\" uib-tooltip=\"Descargar datos de la tabla cómo excel\"><i class=\"fa fa-file-excel-o\"></i></a>\n	<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows()\" uib-tooltip=\"Eliminar selección\"><i class=\"fa fa-trash-o\"></i></a>\n	<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"Nuevo registro\"><i class=\"fa fa-plus\"></i></a>\n\n</div>\n");
$templateCache.put("app/base/views/framework_templates/ixPopupToolBar.html","<div>\r\n<header class=\"header-toolbar\">\r\n	<div class=\"btn-toolbar\">\r\n		<div style=\"float: left\">\r\n    <!-- Per warnings de frontend nostres -->\r\n    <!--<span uib-dropdown is-open=\"openIfChanges(form, status) && showNotif\" auto-close=\"disabled\" class=\"\" ng-if=\"warnings && warnings.length\">\r\n			<a uib-dropdown-toggle><i class=\"fa fa-bell amarillo\"></i><span class=\"badge\">{{warnings.length}}</span></a>\r\n			<ul uib-dropdown-menu>\r\n				<li>\r\n					<a class=\"alert-callout alert-warning\" >\r\n						<i class=\"fa fa-exclamation-triangle\"></i> <strong>Atención ({{warnings.length}})</strong>\r\n						<br>\r\n						<small ng-repeat=\"warning in warnings\">{{warning}}{{$last ? \'\' : \', \'}}</small>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>\r\n\r\n\r\n		<span uib-dropdown class=\"\" is-open=\"openIfChanges(form, status) && showNotif\" auto-close=\"disabled\" ng-show=\"form.$invalid && (!status.data.pk || status.data.datos[status.data.pk])\">\r\n			<a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(form)}}</span></a>\r\n      <ul uib-dropdown-menu>\r\n				<li ng-repeat=\"(k,v) in form.$error\">\r\n					<a class=\"alert-callout alert-warning\" ng-if=\"v.length > 0\" ng-click=\"setFocusError(k)\" >\r\n						<i class=\"fa fa-exclamation-triangle\"></i> <strong>{{k}} ({{v.length}})</strong>\r\n						<br>\r\n            <small ng-repeat=\"vv in v | unique: \'$name\'\">\r\n              <span ng-if=\"vv.$name\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.$name && vv.pk\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\r\n            </small>\r\n            <small ng-if=\"k == \'Tiempo\'\">El valor del campo tiene que estar entre 00:00 y 23:59</small>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>-->\r\n\r\n		<span uib-dropdown auto-close=\"disabled\" ng-if=\"warnings && warnings.length\">\r\n			<a uib-dropdown-toggle><i class=\"fa fa-bell amarillo\"></i><span class=\"badge\">{{warnings.length}}</span></a>\r\n			<ul uib-dropdown-menu>\r\n				<li>\r\n					<a class=\"alert-callout alert-warning\">\r\n						<i class=\"fa fa-exclamation-triangle\"></i> <strong>Atención ({{warnings.length}})</strong>\r\n						<br>\r\n						<small ng-repeat=\"warning in warnings\">{{warning}}{{$last ? \'\' : \', \'}}</small>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>\r\n    <!-- -->\r\n		<span uib-dropdown auto-close=\"disabled\" ng-show=\"form.$invalid && (!status.data.pk || status.data.datos[status.data.pk])\">\r\n			<a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(form)}}</span></a>\r\n      <ul uib-dropdown-menu>\r\n				<li ng-repeat=\"(k,v) in form.$error\">\r\n					<a class=\"alert-callout alert-warning\" ng-if=\"v.length > 0\" ng-click=\"setFocusError(k)\">\r\n						<i class=\"fa fa-exclamation-triangle\"></i> <strong>{{k}} ({{v.length}})</strong>\r\n						<br>\r\n            <!--<small ng-repeat=\"vv in v\">{{vv.$name}}{{$last ? \'\' : \', \'}}</small>-->\r\n            <small ng-repeat=\"vv in v | unique: \'$name\'\">\r\n              <span ng-if=\"vv.$name\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.$name && vv.pk\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\r\n            </small>\r\n            <!-- PERSONALITZATS -->\r\n            <small ng-if=\"k == \'Tiempo\'\">El valor del campo tiene que estar entre 00:00 y 23:59</small>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>\r\n\r\n    <!-- Errors de grid abans d\'anar a la API -->\r\n    <span uib-dropdown ng-show=\"gridStatus.$invalid && status.editing\">\r\n      <a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(gridStatus)}}</span></a>\r\n      <ul uib-dropdown-menu>\r\n        <li ng-repeat=\"(k,v) in gridStatus.$error\">\r\n          <a ng-if=\"v.length > 0\" class=\"alert-callout alert-warning\" ng-click=\"setFocusError(k)\">\r\n            <i class=\"fa fa-exclamation-triangle\"></i> <strong><translate>{{k}}</translate> ({{v.length}})</strong>\r\n            <small ng-if=\"k == \'required\'\">\r\n              <br>\r\n              <span><translate>Los campos siguientes son obligatorios:</translate></span>\r\n            </small>\r\n            <br>\r\n            <small ng-repeat=\"vv in v | unique: \'$name\'\">\r\n              <span ng-if=\"vv.$name && vv.pk && k != \'required\'\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.$name && vv.pk && k == \'required\'\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\r\n              <span ng-if=\"vv.message && vv.param\"><translate translate-value-param=\"{{vv.param}}\">{{vv.message}}</translate>{{$last ? \'\' : \', \'}}<br></span>\r\n            </small>\r\n            <small ng-if=\"k == \'required\'\">\r\n              <br>\r\n              <span ng-repeat=\"vv in v | unique:\'pk\'\">\r\n                <span ng-if=\"$first\"><translate>Revise los registros con</translate></span>\r\n                <span ng-repeat=\"(pkKey, pkVal) in vv.pk\">\r\n                  <span ng-if=\"$last && $parent.$first\"> {{pkKey}}: <br></span>\r\n                  <span ng-if=\"$last\">{{pkVal}}{{$parent.$parent.$last ? \'\' : \', \'}}</span>\r\n                </span>\r\n              </span>\r\n            </small>\r\n          </a>\r\n        </li>\r\n      </ul>\r\n    </span>\r\n\r\n		<span uib-dropdown auto-close=\"disabled\" ng-class=\"{\'open\': status.response.data.GlobalMessage.ErrType == 0}\" ng-show=\"status.response.status==400 || status.response.status==200 || status.response.GlobalMessage.ErrType==2\">\r\n      <a uib-dropdown-toggle><i class=\"fa fa-bell\" ng-class=\"{\'verde\' : status.response.data.GlobalMessage.ErrType == 0, \'amarillo\': status.response.data.GlobalMessage.ErrType == 1, \'rojo\': status.response.data.GlobalMessage.ErrType == 2 || status.response.status==400}\"></i><span class=\"badge\">{{ status.response.data.Errors.length || \'1\' }}</span></a>\r\n			<ul uib-dropdown-menu>\r\n        <li ng-switch on=\"status.response.data.GlobalMessage.ErrType\" ng-show=\"status.response.data.GlobalMessage.ErrType >= 0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':status.response.data.GlobalMessage.ErrType==0,\'alert-warning\':status.response.data.GlobalMessage.ErrType==1,\'alert-error\':status.response.data.GlobalMessage.ErrType==2 || status.response.GlobalMessage.ErrType==2}\">\r\n						<i class=\"fa fa-info-circle\" ng-switch-when=\"0\"></i>\r\n						<i class=\"fa fa-exclamation-triangle\" ng-switch-when=\"1\"></i>\r\n						<i class=\"fa fa-exclamation-circle\" ng-switch-when=\"2\"></i>\r\n						<strong ng-switch-when=\"0\"><translate>{{ \"Info\" }}</translate></strong>\r\n						<strong ng-switch-when=\"1\"><translate>{{ \"Warning\" }}</translate></strong>\r\n						<strong ng-switch-when=\"2\"><translate>{{ \"Error\" }}</translate></strong>\r\n						<br>\r\n            <small ng-switch-when=\"0\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Operación realizada con éxito.\") }}</translate></small>\r\n            <small ng-switch-when=\"1\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Operación realizada con avisos.\") }}</translate></small>\r\n            <small ng-switch-when=\"2\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Se ha producido un error al realizar la operación.\") }}</translate></small>\r\n					</a>\r\n				</li>\r\n        <!-- Mostrar errors 400 d\'API -->\r\n        <li ng-show=\"!status.response.data.GlobalMessage && status.response.status==400\">\r\n          <a class=\"alert-callout alert-error\">\r\n						<i class=\"fa fa-exclamation-circle\"></i>\r\n						<strong>{{status.response.statusText}}</strong>\r\n						<br>\r\n						<small>{{status.response.data}}</small>\r\n					</a>\r\n        </li>\r\n        <!-- Aixo mostrarà els errors que vinguin dintre d\'un OperationResult. -->\r\n        <!--<li ng-repeat=\"itemResp in status.response.data\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">-->\r\n				<li ng-if=\"status.response.data.Errors\" ng-init=\"firstError = status.response.data.Errors[0]\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n						<strong>Error</strong>\r\n						<br>\r\n						<small ng-repeat=\"error in status.response.data.Errors\">{{error.Msg}}<br></small>\r\n					</a>\r\n				</li>\r\n        <!-- -->\r\n\r\n				<li ng-if=\"(status.response.data.obj.Errors) && status.response.data.obj.Errors.length > 0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':status.response.data.GlobalMessage.ErrType==0,\'alert-warning\':status.response.data.GlobalMessage.ErrType==1,\'alert-error\':status.response.data.GlobalMessage.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':status.response.data.GlobalMessage.ErrType==0,\'fa-exclamation-triangle\':status.response.data.GlobalMessage.ErrType==1,\'fa-exclamation-circle\':status.response.data.GlobalMessage.ErrType==2}\"></i>\r\n						<strong>Error</strong>\r\n						<br>\r\n						<small ng-repeat=\"error in status.response.data.obj.Errors | filter:{ErrType: 2}\">{{error.Msg}}<br></small>\r\n					</a>\r\n				</li>\r\n				<!-- -->\r\n				<li ng-repeat=\"itemResp in status.response.data.Inserted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n						<strong>Error de inserción</strong>\r\n						<br>\r\n						<small ng-repeat=\"error in itemResp.Errors\">{{error.Msg}}</small>\r\n					</a>\r\n				</li>\r\n				<li ng-repeat=\"itemResp in status.response.data.Updated\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n						<strong>Error de modificación</strong>\r\n						<br>\r\n						<small ng-repeat=\"error in itemResp.Errors\">{{error.Msg}}</small>\r\n					</a>\r\n				</li>\r\n				<li ng-repeat=\"itemResp in status.response.data.Deleted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n						<strong>Error al eliminar</strong>\r\n						<br>\r\n						<small ng-repeat=\"error in itemResp.Errors\">{{error.Msg}}</small>\r\n					</a>\r\n				</li>\r\n				<li ng-repeat=\"itemResp in status.response.Processed\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\r\n					<a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\r\n						<i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\r\n						<span ng-repeat=\"error in itemResp.Errors\">\r\n							<strong>Error: {{error.Msg}}</strong>\r\n							<br>\r\n							<small><strong>{{error.Property}}</strong>: {{error.Values[0]}}</small>\r\n						</span>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>\r\n		<span uib-dropdown ng-show=\"status.response.status>400\">\r\n			<a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">1</span></a>\r\n			<ul uib-dropdown-menu>\r\n				<li>\r\n					<a class=\"alert-callout alert-error\">\r\n						<i class=\"fa fa-exclamation-circle\"></i>\r\n						<strong>{{status.response.statusText}}</strong>\r\n						<br>\r\n						<small>{{status.response.data.Message}}</small>\r\n					</a>\r\n				</li>\r\n			</ul>\r\n		</span>\r\n      <a data-ng-show=\"status.data.bloqueo && !status.editing\"><i class=\"fa fa-lock\"></i> <translate translate-value-username=\"{{status.data.bloqueo.user.name}}\" translate-value-tiempo=\"{{status.data.bloqueo.ts | date:\'HH:mm:ss\'}}\">{{ \'Registro bloqueado por <strong>\\{\\{username\\}\\}</strong> a las \\{\\{tiempo\\}\\}h\'  }}</translate> </a>\r\n		</div>\r\n    <span style=\"float: left;display: block;font-size: 1.6em;padding-left: 15px;color: #faf2f2;line-height: 2.3em\"><translate>{{ titleLeft }}</translate> {{ titleLeftParam }} {{ titleVal }}</span>\r\n    \r\n    <div class=\"toolbar-buttons\">\r\n      <button id=\"cancelFilter\" class=\"btn pull-right\" ng-click=\"$dismiss()\" uib-tooltip=\"{{ \'Cerrar\' | translate }}\" ng-disabled=\"status.blockUIBtns\" tooltip-placement=\"bottom\"><translate>{{ closeBtnText || \'CERRAR\' }}</translate></button>\r\n\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" ng-show=\"ixDeleteSelectedRows && status.editing\" ng-disabled=\"gridApi.selection.getSelectedRows().length==0 || status.blockUIBtns\" ng-click=\"ixDeleteSelectedRows()\" uib-tooltip=\"{{ \'Eliminar selección\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-trash-o\"></i> <translate>Eliminar</translate> <span class=\"badge\" ng-show=\"gridApi.selection.getSelectedRows().length>0\">{{gridApi.selection.getSelectedRows().length}}</span></button>\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" ng-show=\"(ixAddRow && status.editing && !hideNuevo)\" ng-click=\"ixAddRow()\" uib-tooltip=\"{{ \'Nuevo registro\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-plus\" ng-disabled=\"data.ixReadOnly == true\"></i> <translate>Nuevo</translate></button>\r\n\r\n\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" data-ng-show=\"ixEditar && !status.editing\" ng-click=\"ixEditar(loadData)\" ng-disabled=\"ixEditarDisabled || data.grid.ixIsLoading == true || data.ixReadOnly == true || form.$invalid\" uib-tooltip=\"{{ixEditarTooltip | translate }}\" tooltip-placement=\"bottom\"><translate>EDITAR</translate></button>\r\n\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" ng-click=\"ixCancelEdit()\" ng-show=\"(ixCancelEdit && ixEditar && status.editing && !hideCancelEdit)\" ng-disabled=\"status.blockUIBtns\" uib-tooltip=\"{{ \'Descartar cambios\' | translate }}\" tooltip-placement=\"bottom\"><translate>CANCELAR</translate></button>\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" ng-show=\"exportar\" ng-click=\"exportar()\" uib-tooltip=\"{{ \'Descargar excel\' | translate }}\" tooltip-placement=\"bottom-right\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\r\n      <button ng-if=\"!hideAll\" class=\"btn pull-right\" data-ng-show=\"status.editing && save\" ng-click=\"save()\" ng-mouseover=\"updateIxGuardarTooltip()\" uib-tooltip=\"{{ (ixGuardarTooltip || \'Guardar cambios\') | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"gridStatus.$invalid || numberOfChanges()==0 || form.$invalid || ((loadingInterceptor) && loadingInterceptor.getPendingRequests() > 0)\"><i class=\"fa fa-floppy-o\"></i> <translate>{{ okBtnText || \'Guardar\' }}</translate><span class=\"badge\" ng-show=\"numberOfChanges()>0\">{{numberOfChanges()}}</span></button>\r\n\r\n      <div ng-transclude>\r\n        <!-- AQUI -->\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"pull-right loader\">\r\n      <a><i class=\"fa fa-spinner fa-pulse\" ix-loader></i></a>\r\n    </div>\r\n    <div class=\"center\">\r\n      <span style=\"float: left;display: block;font-size: 1.6em;padding-left: 15px;color: #faf2f2;line-height: 2.3em\" class=\"ng-binding\">{{ titleCenter }} {{ titleCenterParam }}</span>\r\n    </div>\r\n	</div>\r\n</header>\r\n	<uib-progressbar max=\"100\" min=\"0\" value=\"data.ixProgress\" class=\"progress-ix\" ng-class=\"{ \'invisible\': !data.ixProgress}\"></uib-progressbar>\r\n</div>\r\n");
$templateCache.put("app/base/views/framework_templates/ixToolBar.html","<div>\n  <!-- header style=\"position:fixed\"  desactivado para listEdit, investigar angular-sticky -->\n  <header class=\"header-toolbar\">\n    <div class=\"btn-toolbar\">\n      <div style=\"float: left\" ng-show=\"!hideHeader\">\n        <!-- Errors de formulari abans d\'anar a la API -->\n        <span uib-dropdown is-open=\"openIfChanges(form, status) && showNotif\" auto-close=\"disabled\" ng-show=\"form.$invalid && numberOfErrors(form) > 0 && (!status.data.pk || status.data.datos[status.data.pk] || status.data.datos_ope[status.data.pk])\">\n          <a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(form)}}</span></a>\n          <ul uib-dropdown-menu>\n            <li ng-repeat=\"(k,v) in form.$error\">\n              <a class=\"alert-callout alert-warning\" ng-if=\"v.length > 0\" ng-click=\"setFocusError(k)\">\n                <i class=\"fa fa-exclamation-triangle\"></i> <strong><translate>{{k}}</translate> ({{v.length}})</strong>\n                <small ng-if=\"k == \'required\'\">\n                  <br>\n                  <span><translate>Los campos siguientes son obligatorios:</translate></span>\n                </small>\n                <br>\n                <!--<small ng-repeat=\"vv in v\">{{vv.$name}}{{$last ? \'\' : \', \'}}</small>-->\n                <small ng-repeat=\"vv in v | unique: \'$name\'\">\n                <span ng-if=\"vv.$addControl\"><!--es un subformulario-->\n                  <span ng-if=\"vv.$name\">{{vv.$name | underscoreToSpace}}:</span>\n                  <small ng-repeat=\"vvv in vv.$error[k] | unique: \'$name\'\">\n                    <span ng-if=\"vvv.$name\">{{vvv.$name}}{{$last ? \'\' : \', \'}}</span>\n                    <span ng-if=\"vvv.$name && vvv.pk\">{{vvv.$name}} en {{vvv.pk}}{{$last ? \'\' : \', \'}}</span>\n                    <span ng-if=\"vvv.message && !vvv.param\"><translate>{{vvv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\n                    <span ng-if=\"vvv.message && vvv.param\"><translate translate-value-param=\"{{vvv.param}}\">{{vvv.message}}</translate>{{$last ? \'\' : \', \'}}<br></span>\n                  </small>\n                  {{$last ? \'\' : \', \'}}\n                </span>\n                <span ng-if=\"!vv.$addControl\"><!-- es un control-->\n                  <span ng-if=\"vv.$name\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\n                  <span ng-if=\"vv.$name && vv.pk\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\n                  <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\n                  <span ng-if=\"vv.message && vv.param\"><translate translate-value-param=\"{{vv.param}}\">{{vv.message}}</translate>{{$last ? \'\' : \', \'}}<br></span>\n                </span>\n                </small>\n                <!-- PERSONALITZATS -->\n                <small ng-if=\"k == \'Tiempo\'\">El valor del campo tiene que estar entre 00:00 y 23:59</small>\n              </a>\n            </li>\n          </ul>\n        </span>\n        <!-- Errors de grid abans d\'anar a la API -->\n        <span uib-dropdown ng-show=\"gridStatus.$invalid && status.editing\">\n          <a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(gridStatus)}}</span></a>\n          <ul uib-dropdown-menu>\n            <li ng-repeat=\"(k,v) in gridStatus.$error\">\n              <a ng-if=\"v.length > 0\" class=\"alert-callout alert-warning\" ng-click=\"setFocusError(k)\">\n                <i class=\"fa fa-exclamation-triangle\"></i> <strong><translate>{{k}}</translate> ({{v.length}})</strong>\n                <small ng-if=\"k == \'required\'\">\n                  <br>\n                  <span><translate>Los campos siguientes son obligatorios:</translate></span>\n                </small>\n                <br>\n                <small ng-repeat=\"vv in v | unique: \'$name\'\">\n                  <span ng-if=\"vv.$name && vv.pk && k != \'required\'\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\n                  <span ng-if=\"vv.$name && vv.pk && k == \'required\'\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\n                  <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\n                  <span ng-if=\"vv.message && vv.param\"><translate translate-value-param=\"{{vv.param}}\">{{vv.message}}</translate>{{$last ? \'\' : \', \'}}<br></span>\n                </small>\n                <small ng-if=\"k == \'required\'\">\n                  <br>\n                  <span ng-repeat=\"vv in v | unique:\'pk\'\">\n                    <span ng-if=\"$first\"><translate>Revise los registros con</translate></span>\n                    <span ng-repeat=\"(pkKey, pkVal) in vv.pk\">\n                      <span ng-if=\"$last && $parent.$first\"> {{pkKey}}: <br></span>\n                      <span ng-if=\"$last\">{{pkVal}}{{$parent.$parent.$last ? \'\' : \', \'}}</span>\n                    </span>\n                  </span>\n                </small>\n              </a>\n            </li>\n          </ul>\n        </span>\n        <span uib-dropdown ng-show=\"formExtraValidations.$invalid && status.editing\">\n          <a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{numberOfErrors(formExtraValidations)}}</span></a>\n          <ul uib-dropdown-menu>\n            <li ng-repeat=\"(k,v) in formExtraValidations.$error\">\n              <a ng-if=\"v.length > 0\" class=\"alert-callout alert-warning\" ng-click=\"setFocusError(k)\">\n                <i class=\"fa fa-exclamation-triangle\"></i> <strong><translate>{{k}}</translate> ({{v.length}})</strong>\n                <small ng-if=\"k == \'required\'\">\n                  <br>\n                  <span><translate>Los campos siguientes son obligatorios:</translate></span>\n                </small>\n                <br>\n                <small ng-repeat=\"vv in v | unique: \'$name\'\">\n                  <span ng-if=\"vv.$name && vv.pk && k != \'required\'\">{{vv.$name}} en {{vv.pk}}{{$last ? \'\' : \', \'}}</span>\n                  <span ng-if=\"vv.$name && vv.pk && k == \'required\'\">{{vv.$name}}{{$last ? \'\' : \', \'}}</span>\n                  <span ng-if=\"vv.message && !vv.param\"><translate>{{vv.message}}</translate>{{$last ? \'\' : \', \'}}</span>\n                  <span ng-if=\"vv.message && vv.param\"><translate translate-value-param=\"{{vv.param}}\">{{vv.message}}</translate>{{$last ? \'\' : \', \'}}<br></span>\n                </small>\n                <small ng-if=\"k == \'required\'\">\n                  <br>\n                  <span ng-repeat=\"vv in v | unique:\'pk\'\">\n                    <span ng-if=\"$first\"><translate>Revise los registros con</translate></span>\n                    <span ng-repeat=\"(pkKey, pkVal) in vv.pk\">\n                      <span ng-if=\"$last && $parent.$first\"> {{pkKey}}: <br></span>\n                      <span ng-if=\"$last\">{{pkVal}}{{$parent.$parent.$last ? \'\' : \', \'}}</span>\n                    </span>\n                  </span>\n                </small>\n              </a>\n            </li>\n          </ul>\n        </span>\n        <!-- Resposta de la API. Pot ser un OK o un error però només estarà obert si és un OK -->\n        <span uib-dropdown is-open=\"openIfError(status)\" auto-close=\"disabled\" ng-class=\"{\'open\': (status.response.data.GlobalMessage.ErrType == 0 || (status.response.data.GlobalMessage.ErrType == 2 && showErrorNotif))}\" ng-show=\"status.response.status==400 || status.response.status==403 || status.response.status==200 || status.response.GlobalMessage.ErrType==2\">\n          <a uib-dropdown-toggle><i class=\"fa fa-bell\" ng-class=\"{\'verde\' : status.response.data.GlobalMessage.ErrType == 0, \'amarillo\': status.response.data.GlobalMessage.ErrType == 1, \'rojo\': status.response.data.GlobalMessage.ErrType == 2 || status.response.status==400 || status.response.status==403}\"></i><span class=\"badge\">{{ status.response.data.Errors.length || \'1\' }}</span></a>\n          <ul uib-dropdown-menu>\n            <span style=\"margin: 1px 0px 0px 6px\" ng-show=\"status.response.data.GlobalMessage.ErrType == 2\">\n              <a ng-click=\"openPopup(status.response.data)\" title=\"Ver errores en popup\" style=\"display:inline-block\"><i class=\"fa fa-window-maximize\"></i></a>\n              <a ng-click=\"downloadTxt(status.response.data)\" title=\"Generar fichero de errores\" style=\"display:inline-block\"><i class=\"fa fa-download\"></i></a>\n              <a ng-if=\"status.response.data.JsonError\" ng-click=\"downloadExcel(status.response.data.JsonError)\" title=\"Generar excel de errores\" style=\"display:inline-block\"><i class=\"fa fa-file-excel-o\"></i></a>\n            </span>\n            <li ng-switch on=\"status.response.data.GlobalMessage.ErrType\" ng-show=\"status.response.data.GlobalMessage.ErrType >= 0\">\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':status.response.data.GlobalMessage.ErrType==0,\'alert-warning\':status.response.data.GlobalMessage.ErrType==1,\'alert-error\':status.response.data.GlobalMessage.ErrType==2 || status.response.GlobalMessage.ErrType==2}\">\n                <i class=\"fa fa-info-circle\" ng-switch-when=\"0\"></i>\n                <i class=\"fa fa-exclamation-triangle\" ng-switch-when=\"1\"></i>\n                <i class=\"fa fa-exclamation-circle\" ng-switch-when=\"2\"></i>\n                <strong ng-switch-when=\"0\"><translate>{{ \"Info\" }}</translate></strong>\n                <strong ng-switch-when=\"1\"><translate>{{ \"Warning\" }}</translate></strong>\n                <strong ng-switch-when=\"2\"><translate>{{ \"Error\" }}</translate></strong>\n                <br>\n                <small ng-switch-when=\"0\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Operación realizada con éxito.\") }}</translate></small>\n                <small ng-switch-when=\"1\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Operación realizada con avisos.\") }}</translate></small>\n                <small ng-switch-when=\"2\"><translate>{{(status.response.data.GlobalMessage.Msg || \"Se ha producido un error al realizar la operación.\") }}</translate></small>\n              </a>\n            </li>\n            <!-- Mostrar errors 400 d\'API -->\n            <li ng-show=\"!status.response.data.GlobalMessage && (status.response.status==400 || status.response.status==403)\">\n              <a class=\"alert-callout alert-error\">\n                <i class=\"fa fa-exclamation-circle\"></i>\n                <strong>{{status.response.statusText}}</strong>\n                <br>\n                <small>{{status.response.data.Message || status.response.data}}</small>\n              </a>\n            </li>\n            <!-- Aixo mostrarà els errors que vinguin dintre d\'un OperationResult. -->\n            <!--<li ng-repeat=\"itemResp in status.response.data\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">-->\n            <li ng-if=\"status.response.data.Errors\" ng-init=\"firstError = status.response.data.Errors[0]\">\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\n                <strong>Error</strong>\n                <br>\n                <small ng-repeat=\"error in status.response.data.Errors\">{{error.Msg}}<br></small>\n              </a>\n            </li>\n            <!-- -->\n            <li ng-if=\"(status.response.data.obj.Errors) && status.response.data.obj.Errors.length > 0\">\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':status.response.data.GlobalMessage.ErrType==0,\'alert-warning\':status.response.data.GlobalMessage.ErrType==1,\'alert-error\':status.response.data.GlobalMessage.ErrType==2}\">\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':status.response.data.GlobalMessage.ErrType==0,\'fa-exclamation-triangle\':status.response.data.GlobalMessage.ErrType==1,\'fa-exclamation-circle\':status.response.data.GlobalMessage.ErrType==2}\"></i>\n                <strong>Error</strong>\n                <br>\n                <small ng-repeat=\"error in status.response.data.obj.Errors\">{{error.Msg}}<br></small>\n              </a>\n            </li>\n            <!-- -->\n            <li ng-repeat=\"itemResp in status.response.data.Inserted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\n                <strong ng-if=\"itemResp.Errors[0].ErrType == 0\">Detalle de inserción</strong>\n                <strong ng-if=\"itemResp.Errors[0].ErrType == 1\">Aviso de inserción</strong>\n                <strong ng-if=\"itemResp.Errors[0].ErrType == 2\">Error de inserción</strong>\n                <br>\n                <small ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</small>\n              </a>\n            </li>\n            <li ng-repeat=\"itemResp in status.response.data.Updated\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\n                <strong ng-if=\"itemResp.Errors[0].ErrType == 0\">Detalle de modificación</strong>\n                <strong ng-if=\"itemResp.Errors[0].ErrType != 0\">Error de modificación</strong>\n                <br>\n                <small ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</small>\n              </a>\n            </li>\n            <li ng-repeat=\"itemResp in status.response.data.Deleted\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\n                <strong>Error al eliminar</strong>\n                <br>\n                <small ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</small>\n              </a>\n            </li>\n            <li ng-repeat=\"itemResp in status.response.Processed\" ng-init=\"firstError = itemResp.Errors[0]\" ng-if=\"itemResp.Errors.length>0\">\n              <a class=\"alert-callout\" ng-class=\"{\'alert-info\':firstError.ErrType==0,\'alert-warning\':firstError.ErrType==1,\'alert-error\':firstError.ErrType==2}\">\n                <i class=\"fa\" ng-class=\"{\'fa-info-circle\':firstError.ErrType==0,\'fa-exclamation-triangle\':firstError.ErrType==1,\'fa-exclamation-circle\':firstError.ErrType==2}\"></i>\n                <!--<span ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">\n                  <strong>Error: {{error.Msg}}</strong>\n                  <br>\n                  <small><strong>{{error.Property}}</strong>: {{error.Values[0]}}</small>\n                </span>-->\n                <strong ng-if=\"itemResp.Errors[0].ErrType == 0\">Detalle</strong>\n                <strong ng-if=\"itemResp.Errors[0].ErrType != 0\">Error</strong>\n                <br>\n                <small ng-repeat=\"error in itemResp.Errors| filter:{error:\'!\'} track by $index\">{{error.Msg}}</small>\n              </a>\n            </li>\n          </ul>\n        </span>\n        <div ng-show=\"data.fullScreen\" class=\"btn-toolbar toolbar-buttons\" style=\"float:left\">\n          <label class=\"btn btn-default\" ng-click=\"fullScreen(false)\"><i class=\"fa fa-eye\"></i></label>\n        </div>\n      <span uib-dropdown ng-show=\"status.response.status>400 && status.response.status!=403\">\n        <a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">1</span></a>\n        <ul uib-dropdown-menu>\n          <li>\n            <a class=\"alert-callout alert-error\">\n              <i class=\"fa fa-exclamation-circle\"></i>\n              <strong>{{status.response.statusText}}</strong>\n              <br>\n              <small>{{status.response.data.Message}}</small>\n            </a>\n          </li>\n        </ul>\n      </span>\n        <a data-ng-show=\"status.data.bloqueo && !status.editing\"><i class=\"fa fa-lock\"></i> <translate translate-value-username=\"{{status.data.bloqueo.user.name}}\" translate-value-tiempo=\"{{status.data.bloqueo.ts | date:\'HH:mm:ss\'}}\">{{ \'Registro bloqueado por <strong>\\{\\{username\\}\\}</strong> a las \\{\\{tiempo\\}\\}h\'  }}</translate> </a>\n      </div>\n      <span ng-show=\"!hideHeader\" style=\"float: left;display: block;font-size: 1.6em;padding-left: 15px;color: #faf2f2;line-height: 2.3em\"><ix-bread-crumb app=\"status\" menu=\"menu\"></ix-bread-crumb><translate>{{ (manualTitle() || status.display)  }}</translate> {{ status.atributosTitle || \'\' }} <span ng-if=\"status.data.datos && status.data.pk && status.data.datos[status.data.pk]\"> > <translate translate-value-idregistro=\"{{status.data.datos[status.data.showAsID] || status.data.datos[status.data.tituloCabecera] || status.data.datos[status.data.pk]}}\">{{ \'\\{\\{idregistro\\}\\}\' }}</translate></span><span ng-if=\"status.data.tituloExtra\">&nbsp;{{ status.data.tituloExtra }}</span></span>\n    <!--\n      <a class=\"btn  pull-right\" data-ng-show=\"!incidencias\" ng-click=\"openModal(\'incidencia.html\')\"><i class=\"fa fa-plus\"></i> Incidencia</a>\n      <a class=\"btn btn-warning pull-right\" data-ng-show=\"incidencias\" ng-click=\"openModal(\'incidencia.html\')\"><i class=\"fa fa-exclamation-circle\"></i> Incidencia <span class=\"badge\">{{incidencias.length}}</span></a>\n      <div uib-dropdown class=\"pull-right\">\n        <a uib-dropdown-toggle class=\"btn \"><i class=\"fa fa-print\"></i> Impresos <span class=\"caret\"></span></a>\n        <ul uib-dropdown-menu>\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-excel-o\"></i> Excel</a></li>\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-pdf-o\"></i> Pdf</a></li>\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-clipboard\"></i> Copiar</a></li>\n        </ul>\n      </div>\n      <div uib-dropdown class=\"pull-right\">\n        <a uib-dropdown-toggle class=\"btn \"><i class=\"fa fa-bolt\"></i> Acciones <span class=\"caret\"></span></a>\n        <ul uib-dropdown-menu>\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-truck\"></i> Acción Una</a></li>\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-user-plus\"></i> Acción dos</a></li>\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-venus-mars\"></i> Acción tres</a></li>\n          <li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-user-secret\"></i> Acción cuatro</a></li>\n        </ul>\n      </div>\n      <a class=\"btn btn-warning pull-right\" role=\"button\" data-ng-show=\"!status.editing && bloqueo\" data-ng-click=\"desbloquear()\"><i class=\"fa fa-unlock\"></i> Desbloquear</a>\n  \n      <a class=\"btn  pull-right\" role=\"button\" data-ng-show=\"ixEditar && !status.editing\" href=\"javascript:history.back()\"><i class=\"fa fa-undo\"></i> Volver</a>\n    -->\n      <div class=\"toolbar-buttons\" ng-if=\"!specialToolBar\" ng-show=\"!hideButtons\">\n        <button class=\"btn pull-right\" ng-show=\"ixCloseApp\" ng-disabled=\"status.blockUIBtns\" ng-click=\"ixCloseApp()\" uib-tooltip=\"{{ \'Cerrar\' | translate }}\" tooltip-placement=\"bottom\"><translate>CERRAR</translate></button>\n        <div ng-if=\"generatePivot\" ng-show=\"pivotData\" class=\"pull-right btn-group\">\n            <label class=\"btn\" ng-show=\"!showPivot\" title=\"{{ \'Ver tabla dinámica\' | translate }}\" ng-model=\"showPivot\" uib-btn-radio=\"true\" ng-click=\"setPivot(true)\"><i class=\"fa fa-th-list\"></i></label>\n            <label class=\"btn\" ng-show=\"showPivot\" title=\"{{ \'Ver detalle\' | translate }}\" ng-model=\"showPivot\" uib-btn-radio=\"false\" ng-click=\"setPivot(false)\"><i class=\"fa fa-table\"></i></label>\n        </div>\n        <button class=\"btn pull-right\" ng-show=\"ixDownloadExcel\" ng-disabled=\"status.blockUIBtns\" ng-click=\"ixDownloadExcel()\" uib-tooltip=\"{{ \'Descargar excel\' | translate }}\" tooltip-placement=\"bottom-right\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\n        <button class=\"btn pull-right\" ng-show=\"ixProgramar && ixPermiteProgramar\" ng-click=\"ixProgramar()\" uib-tooltip=\"{{ \'Programar listado\' | translate }}\" tooltip-placement=\"bottom-right\"><i class=\"material-icons\">access_time</i> <translate>Programar</translate></button>\n  \n  \n        <button class=\"btn pull-right\" ng-show=\"ixDeleteSelectedRows && status.editing\" ng-disabled=\"status.blockUIBtns || gridApi.selection.getSelectedRows().length==0 || !status.deleteEnabled || data.ixReadOnly == true\" ng-click=\"ixDeleteSelectedRows()\" uib-tooltip=\"{{ \'Eliminar selección\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-trash-o\"></i> <translate>Eliminar</translate> <span class=\"badge\" ng-show=\"gridApi.selection.getSelectedRows().length>0\">{{gridApi.selection.getSelectedRows().length}}</span></button>\n        <button class=\"btn pull-right\" ng-show=\"ixAddRow && status.editing\" ng-click=\"ixAddRow()\" uib-tooltip=\"{{ \'Nuevo registro\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"status.blockUIBtns || data.ixReadOnly == true\"><i class=\"fa fa-plus\"></i> <translate>Nuevo</translate></button>\n  \n  \n  \n        <button class=\"btn pull-right\" ng-show=\"ixFiltrar && !status.editing\" ng-click=\"ixFiltrar()\" ng-disabled=\"status.blockUIBtns || form.$invalid\" tooltip-placement=\"bottom\"><i class=\"fa fa-filter\"></i> <translate>Filtrar</translate></button>\n        <button class=\"btn pull-right\" ng-show=\"ixProcesar && !status.editing\" ng-click=\"ixProcesar()\" ng-disabled=\"status.blockUIBtns || form.$invalid\" tooltip-placement=\"bottom\"><i class=\"fa fa-filter\"></i> <translate>Procesar</translate></button>\n        <button class=\"btn pull-right\" data-ng-show=\"ixEditar && !ocultaEditar && !status.editing\" ng-click=\"ixEditar(loadData)\" ng-disabled=\"status.blockUIBtns || ixEditarDisabled || data.ixEditarDisabled || data.grid.ixIsLoading == true\" uib-tooltip=\"{{ ixEditarTooltip || (\'Cambia a modo edición\' | translate )}}\" tooltip-placement=\"bottom\"><translate>EDITAR</translate></button>\n  \n        <button class=\"btn pull-right\" data-ng-show=\"(ixCancelEdit && (ixEditar || ixFiltrar) && !ocultaEditar) && status.editing\" ng-click=\"ixCancelEdit()\" ng-disabled=\"status.blockUIBtns\" uib-tooltip=\"{{ \'Descartar cambios\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-times\"></i> <translate>Cancelar</translate></button>\n        <button class=\"btn pull-right\" data-ng-show=\"((ixEditar || ixFiltrar || ixGuardar) && !ocultaGuardar) && status.editing\" ng-click=\"ixGuardar()\" ng-mouseover=\"updateIxGuardarTooltip()\" uib-tooltip=\"{{ ixGuardarTooltip || (\'Guardar cambios\' | translate)  }}\" tooltip-placement=\"bottom\" ng-disabled=\"status.blockUIBtns || gridStatus.$invalid || numberOfChanges()==0 || (form.$invalid && !status.ignorarFormulario) || ((formExtraValidations) && formExtraValidations.$invalid && !status.ignorarFormulario)\"><i class=\"fa fa-floppy-o\"></i> <translate>Guardar</translate> <span class=\"badge\" ng-show=\"numberOfChanges()>0\">{{numberOfChanges()}}</span></button>\n        <button class=\"btn pull-right\" data-ng-show=\"(ixCustomButton) && status.editing\" ng-click=\"ixCustomButton()\" ng-disabled=\"status.blockUIBtns || gridStatus.$invalid || form.$invalid\"><translate>{{ixCustomButtonText}}</translate> </button>\n  \n        <div ng-transclude>\n          <!-- Podem afegir botons html desde el template. Apareixerien a continuació: -->\n        </div>\n        <!--<button class=\"btn btn-success pull-right\" ng-show=\"ixGuardar && !ixEditar && !ixFiltrar\" ng-click=\"ixGuardar()\" ng-disabled=\"form.$invalid\"><i class=\"fa fa-floppy-o\"></i> Guardar</button>-->\n      </div>\n  \n      <div class=\"toolbar-buttons\" ng-if=\"specialToolBar == true\" ng-show=\"!hideButtons\">\n        <button class=\"btn pull-right\" ng-show=\"ixCloseApp\" ng-disabled=\"status.blockUIBtns\" ng-click=\"ixCloseApp()\" uib-tooltip=\"{{ \'Cerrar\' | translate }}\" tooltip-placement=\"bottom\"><translate>CERRAR</translate></button>\n        <!--<div ng-if=\"generatePivot\" ng-show=\"pivotData\" class=\"pull-right btn-group\">\n            <label class=\"btn \" ng-model=\"showPivot\" uib-btn-radio=\"true\" ng-click=\"setPivot(true)\"><i class=\"fa fa-th-list\"></i></label>\n            <label class=\"btn \" ng-model=\"showPivot\" uib-btn-radio=\"false\" ng-click=\"setPivot(false)\"><i class=\"fa fa-table\"></i></label>\n        </div>-->\n  \n  \n  \n  \n        <!-- En mode edició: -->\n  \n        <button class=\"btn pull-right\" ng-show=\"ixDownloadExcel && (status.editing || status.filtered)\" ng-disabled=\"status.blockUIBtns\" ng-click=\"ixDownloadExcel()\" uib-tooltip=\"Descargar excel\" tooltip-placement=\"bottom-right\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\n        <button class=\"btn pull-right\" ng-show=\"ixProgramar && status.editing && ixPermiteProgramar\" ng-click=\"ixProgramar()\" uib-tooltip=\"Programar listado\" tooltip-placement=\"bottom-right\"><i class=\"material-icons\">access_time</i> <translate>Programar</translate></button>\n  \n        <button class=\"btn pull-right\" ng-show=\"ixAddRowWhenEdit && status.editing\" ng-click=\"ixAddRowWhenEdit()\" uib-tooltip=\"Nuevo registro\" tooltip-placement=\"bottom\" ng-disabled=\"status.blockUIBtns || data.ixReadOnly == true\"><i class=\"fa fa-plus\"></i> <translate>Nuevo</translate></button>\n  \n        <button class=\"btn pull-right\" ng-show=\"ixDeleteSelectedRows && status.editing\" ng-disabled=\"status.blockUIBtns || gridApi.selection.getSelectedRows().length==0 || !status.deleteEnabled || data.ixReadOnly == true\" ng-click=\"ixDeleteSelectedRows()\" uib-tooltip=\"Eliminar selección\" tooltip-placement=\"bottom\"><i class=\"fa fa-trash-o\"></i> <translate>Eliminar</translate> <span class=\"badge\" ng-show=\"gridApi.selection.getSelectedRows().length>0\">{{gridApi.selection.getSelectedRows().length}}</span></button>\n  \n  \n        <!-- Pantalla carregada, sense estar filtrant ni editant -->\n  \n        <button class=\"btn pull-right\" ng-show=\"ixFiltrar && !status.editing && !status.filtered\" ng-click=\"ixFiltrar()\" ng-disabled=\"status.blockUIBtns || form.$invalid\" tooltip-placement=\"bottom\"><i class=\"fa fa-filter\"></i> <translate>Filtrar</translate></button>\n        <button class=\"btn pull-right\" ng-show=\"ixProcesar && !status.editing && !status.filtered\" ng-click=\"ixProcesar()\" ng-disabled=\"status.blockUIBtns || form.$invalid\" tooltip-placement=\"bottom\"><i class=\"fa fa-filter\"></i> <translate>Procesar</translate></button>\n        <button class=\"btn pull-right\" ng-show=\"ixAddRow && !status.editing && !status.filtered && !hideNewOnPreFilter\" ng-click=\"ixAddRow()\" uib-tooltip=\"{{ \'Nuevo registro\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"status.blockUIBtns || data.ixReadOnly == true\"><i class=\"fa fa-plus\"></i> <translate>Nuevo</translate></button>\n        <!-- -->\n  \n  \n        <!-- En mode edició: -->\n        <button class=\"btn pull-right\" data-ng-show=\"ixCancelEdit && (ixEditar || ixFiltrar) && (status.editing || (status.filtered && !hideCancelOnFilter))\" ng-click=\"ixCancelEdit()\" ng-disabled=\"status.blockUIBtns\" uib-tooltip=\"{{ \'Descartar cambios\' | translate }}\" tooltip-placement=\"bottom\"><i class=\"fa fa-times\"></i> <translate>Cancelar</translate></button>\n        <button class=\"btn pull-right\" data-ng-show=\"((ixEditar || ixFiltrar || ixGuardar) && !ocultaGuardar) && status.editing\" ng-click=\"ixGuardar()\" ng-mouseover=\"updateIxGuardarTooltip()\" uib-tooltip=\"{{ ixGuardarTooltip || (\'Guardar cambios\' | translate) }}\" tooltip-placement=\"bottom\" ng-disabled=\"status.blockUIBtns || gridStatus.$invalid || numberOfChanges()==0 || (form.$invalid && !status.ignorarFormulario) || ((formExtraValidations) && formExtraValidations.$invalid && !status.ignorarFormulario)\"><i class=\"fa fa-floppy-o\"></i> <translate>Guardar</translate> <span class=\"badge\" ng-show=\"numberOfChanges()>0\">{{numberOfChanges()}}</span></button>\n  \n  \n  \n  \n        <!-- -->\n  \n        <div ng-transclude>\n          <!-- Podem afegir botons html desde el template. Apareixerien a continuació: -->\n        </div>\n  \n        <button class=\"btn pull-right\" data-ng-show=\"(ixCustomButton) && status.editing\" ng-click=\"ixCustomButton()\" ng-disabled=\"status.blockUIBtns || gridStatus.$invalid || form.$invalid\"><translate>{{ixCustomButtonText}}</translate> </button>\n        <!-- -->\n  \n        <!-- Filtrant pel registre sel·leccionat -->\n        <button class=\"btn pull-right\" data-ng-show=\"ixEditar && !status.editing && status.filtered\" ng-click=\"ixEditar(loadData)\" ng-disabled=\"status.blockUIBtns || ixEditarDisabled || data.ixEditarDisabled || data.grid.ixIsLoading == true || form.$invalid\" uib-tooltip=\"{{ ixEditarTooltip || (\'Cambia a modo edición\' | translate) }}\" tooltip-placement=\"bottom\"><translate>EDITAR</translate></button>\n  \n        <!-- -->\n  \n  \n        <!--<button class=\"btn btn-success pull-right\" ng-show=\"ixGuardar && !ixEditar && !ixFiltrar\" ng-click=\"ixGuardar()\" ng-disabled=\"form.$invalid\"><i class=\"fa fa-floppy-o\"></i> Guardar</button>-->\n      </div>\n  \n      <script type=\"text/ng-template\" id=\"incidencia.html\">\n        <h1>Incidencias <small>{{status.current.title}}</small></h1>\n        <div data-ng-repeat=\"i in incidencias track by $index\">\n          <div data-ng-bind-html=\"i.text\" style=\"padding: 10px 0\"></div>\n          <small class=\"pull-right\">reported by <strong>{{i.user.name}}</strong> {{i.time | timeago}}</small>\n        </div>\n        <div>\n          <div data-text-angular data-ng-model=\"newIncidencia.text\" style=\"padding: 10px 0\"></div>\n          <button type=\"button\" class=\"btn \" data-ng-click=\"addIncidencia()\"><i class=\"fa fa-plus\"></i> añadir</button>\n        </div>\n      </script>\n    </div>\n  </header>\n    <uib-progressbar max=\"100\" min=\"0\" value=\"data.ixProgress\" class=\"progress-ix\" ng-class=\"{ \'invisible\': !data.ixProgress}\"></uib-progressbar>\n  </div>\n  ");
$templateCache.put("app/base/views/grid/checkBoxHeaderCell.html","<!--<div ng-class=\"{ \'sortable\': sortable }\">\n  <div class=\"ui-grid-vertical-bar\">&nbsp;</div>\n  <div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\">\n    <span>{{ col.displayName CUSTOM_FILTERS }}</span>\n    <span ui-grid-visible=\"col.sort.direction\" ng-class=\"{ \'ui-grid-icon-up-dir\': col.sort.direction == asc, \'ui-grid-icon-down-dir\': col.sort.direction == desc, \'ui-grid-icon-blank\': !col.sort.direction }\">&nbsp;</span>\n  </div>\n  <div class=\"ui-grid-column-menu-button\" ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false\" class=\"ui-grid-column-menu-button\" ng-click=\"toggleMenu($event)\">\n    <i class=\"ui-grid-icon-angle-down\">&nbsp;</i>\n  </div>-->\n  <div class=\"ui-grid-filter-container\" ng-hide=\"col.colDef.NoFilterable == true\">\n    <span style=\"text-align: center\" ng-if=\"filterable\" class=\"ui-grid-filter-container\" ng-repeat=\"colFilter in col.filters\">\n      <div class=\"checkbox\">\n        <label>\n          <input type=\"checkbox\" class=\"ui-grid-filter-input\" ng-model=\"colFilter.term\" ng-click=\"$event.stopPropagation()\" ng-attr-placeholder=\"{{colFilter.placeholder || \'\'}}\">\n          <span class=\"checkbox-material\">\n            <span class=\"check\"></span>\n          </span>\n        </label>\n        <span class=\"badge\" style=\"margin: 0 0 0 5px\" ng-show=\"colFilter.term != null\">1</span>\n        <div class=\"ui-grid-filter-button\" ng-click=\"colFilter.term = null\">\n          <i ng-click=\"colFilter.term = null\" class=\"ui-grid-icon-cancel\" ng-show=\"colFilter.term != null\">&nbsp;</i>\n        </div>\n\n      </div>\n    </span>\n  </div>\n<!--</div>-->\n");
$templateCache.put("app/base/views/grid/ixCellGridFiltro.html","<div class=\"modal-header\">\n  <h3><translate translate-value-nombrecolumna=\"{{entity.campo}}\">{{ \'Filtrar por \\{\\{nombrecolumna\\}\\}\' }}</translate></h3>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\" ng-show=\"!hideSelectionMode\">\n    <div class=\"col-md-12\">\n      <ix-radio ng-if=\"columnType != \'date\' && listOfValues != undefined\" without-label=\"true\" ng-model=\"$parent.filtro_tipo\" name=\"seleccion\" label=\"Selección\" options=\'[{ value: undefined, text: \"Selección\"}, { value: \"#lista\", text: \"Lista\" }, { value: \"#value\", text: \"Con valor\" }, { value: \"#empty\" , text: \"Vacíos\" }, { value: \"#exclude\", text: \"Excluir\" }]\' multiple-in-line=\"true\"></ix-radio>\n      <ix-radio ng-if=\"columnType != \'date\' && listOfValues == undefined\" without-label=\"true\" ng-model=\"$parent.filtro_tipo\" name=\"seleccion\" label=\"Selección\" options=\'[{ value: undefined, text: \"Selección\"}, { value: \"#lista\", text: \"Lista\" }, { value: \"#value\", text: \"Con valor\" }, { value: \"#empty\" , text: \"Vacíos\" }, { value: \"#exclude\", text: \"Excluir\" }]\' multiple-in-line=\"true\"></ix-radio>\n      <!-- <ix-radio ng-if=\"columnType != \'date\'\" without-label=\"true\" ng-model=\"$parent.filtro_tipo\" name=\"seleccion\" label=\"Selección\" options=\'[{ value: undefined, text: \"Selección\"}, { value: \"#lista\", text: \"Lista\" }, { value: \"#value\", text: \"Con valor\" }, { value: \"#empty\" , text: \"Vacíos\" }, { value: \"#exclude\", text: \"Excluir\" }]\' multiple-in-line=\"true\"></ix-radio> -->\n      <ix-radio ng-if=\"columnType == \'date\'\" without-label=\"true\" ng-model=\"$parent.filtro_tipo\" name=\"seleccion\" label=\"Selección\" options=\'[{ value: undefined, text: \"Selección\"}, { value: \"#value\", text: \"Con valor\" }, { value: \"#empty\" , text: \"Vacíos\" }]\' multiple-in-line=\"true\"></ix-radio>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div ng-show=\"filtro_tipo != \'#empty\' && filtro_tipo != \'#value\'\">\n        <!-- Tots els filtres que siguin de columnes que no són tipus date tindran el input de filtrar filtres -->\n        <span ng-show=\"listOfValues != undefined && filtro_tipo != \'#lista\'\">\n          <ix-text ng-model=\"searchfiltro\" name=\"Buscar\" is-filter=\"true\"></ix-text>\n          <hr>\n        </span>\n        <!-- Filtrar camps que no van contra ninguna taula -->\n        <div class=\"row\" ng-show=\"columnType == \'string\' && listOfValues == undefined && filtro_tipo != \'#lista\'\">\n          <div class=\"col-md-12\">\n            <ix-text ng-model=\"filtrotexto\" name=\"Filtro\" is-filter=\"true\"></ix-text>\n          </div>\n          <div class=\"col-md-12\">\n            <ix-select ng-show=\"control == \'Text\'\" ng-model=\"filterOp\" name=\"Método\" pk=\"op\" desc=\"nombre\" load-function=\"filterOptions\" load-all-items=\"true\" ng-default=\"7\"></ix-select>\n          </div>\n        </div>\n        <span ng-show=\"columnType == \'date\'\">\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <ix-select ng-if=\"columnType == \'date\'\" ng-model=\"filtro_periodo[0]\" name=\"Periodo Inicial\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadTiposFecha\" load-all-items=\"true\"></ix-select>\n            </div>\n            <div class=\"col-md-12\">\n              <ix-select ng-if=\"columnType == \'date\'\" ng-model=\"filtro_periodo[1]\" name=\"Periodo Final\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadTiposFecha\" load-all-items=\"true\"></ix-select>\n            </div>\n            <div class=\"col-md-12\">\n              <ix-date ng-show=\"filtro_periodo[0] == undefined\" ng-model=\"filtro[0]\" name=\"Fecha Inicial\"></ix-date>\n            </div>\n            <div class=\"col-md-12\">\n              <ix-date ng-show=\"filtro_periodo[1] == undefined\" ng-model=\"filtro[1]\" name=\"Fecha Final\"></ix-date>\n            </div>\n          </div>\n        </span>\n        <div ng-show=\"filtro_tipo == \'#lista\'\">            \n          <div class=\"col-md-12\" ng-show=\"columnType !== \'date\'\">              \n            <ix-text-area ng-model=\"filtrotexto\" name=\"Buscar\" rows=\"8\"></ix-text-area>\n            <hr>\n          </div>\n          <div class=\"col-md-12\">              \n            <div style=\"max-height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filterList\">\n            </div>\n          </div>\n        </div>\n\n        <span ng-show=\"columnType == \'number\' && filtro_tipo != \'#lista\'\">\n          <!--<ix-text ng-model=\"filtro[0]\" ng-model2=\"filtro[1]\" name=\"Valor entre\" is-filter=\"true\" ix-number></ix-text>-->\n          <ix-text ng-model=\"filtronumero\" name=\"Valor\" is-filter=\"true\" ix-number></ix-text>\n        </span>\n        <div class=\"col-md-12\" ng-show=\"filtro_tipo != \'#lista\'\">\n          <div style=\"max-height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"{ label: searchfiltro }\" ivh-treeview-on-cb-change=\"selectionChanged(ivhNode, ivhIsSelected, ivhTree)\">\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div ng-show=\"filtro_tipo != \'#empty\' && filtro_tipo != \'#value\'\">\n    <button class=\"btn pull-left\" ng-show=\"listOfValues != undefined && !singleOption\" ng-click=\"selectAll()\"><translate>Todos</translate></button>\n    <button class=\"btn pull-left\" ng-show=\"listOfValues != undefined\" ng-click=\"deselectAll()\"><translate>Ninguno</translate></button>\n  </div>\n  <button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"processData()\"><translate>Aplicar</translate></button>\n  <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cancelar</translate></button>\n</div>\n");
$templateCache.put("app/base/views/grid/ixCellGridValorDef.html","<div class=\"modal-header\">\n  <h3><translate translate-value-nombrecolumna=\"{{entity.campo}}\">{{ \'Valor por Defecto \\{\\{nombrecolumna\\}\\}\' }}</translate></h3>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\" ng-show=\"!hideSelectionMode\">\n    <div class=\"col-md-12\">\n      <ix-radio ng-model=\"filtro\" name=\"seleccion\" label=\"Selección\" options=\'[{ value: undefined, text: \"Según selección\"}, { value: \"#value\", text: \"Con valor\" }, { value: \"#empty\" , text: \"Vacíos\" }]\' multiple-in-line=\"true\"></ix-radio>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div ng-show=\"filtro != \'#empty\' && filtro != \'#value\'\">\n        <!-- Tots els filtres que siguin de columnes que no són tipus date tindran el input de filtrar filtres -->\n        <span ng-show=\"listOfValues != undefined\">\n          <ix-text ng-model=\"searchfiltro\" name=\"Buscar\" is-filter=\"true\"></ix-text>\n          <hr>\n        </span>\n        <!-- Filtrar camps que no van contra ninguna taula -->\n        <div class=\"row\" ng-show=\"listOfValues == undefined\">\n          <div class=\"col-md-12\">\n            <ix-text ng-model=\"filtro\" name=\"Valor\" is-filter=\"true\"></ix-text>\n          </div>\n        </div>\n        <div class=\"col-md-12\">\n          <div style=\"max-height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"{ label: searchfiltro }\" ivh-treeview-on-cb-change=\"selectionChanged(ivhNode, ivhIsSelected, ivhTree)\">\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div ng-show=\"filtro != \'#empty\' && filtro != \'#value\'\">\n    <button class=\"btn pull-left\" ng-show=\"listOfValues != undefined && !singleOption\" ng-click=\"selectAll()\"><translate>Todos</translate></button>\n    <button class=\"btn pull-left\" ng-show=\"listOfValues != undefined\" ng-click=\"deselectAll()\"><translate>Ninguno</translate></button>\n  </div>\n  <button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"processData()\"><translate>Aplicar</translate></button>\n  <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cancelar</translate></button>\n</div>\n");
$templateCache.put("app/base/views/grid/ixGridProgress.html","<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">\n  <uib-progressbar value=\"COL_FIELD\" type=\"danger\" animate=\"false\"></uib-progressbar>\n</div>\n");
$templateCache.put("app/base/views/grid/ui-grid-header.html","<div role=\"rowgroup\" class=\"ui-grid-header\">\n  <!-- theader -->\n  <div class=\"ui-grid-top-panel\">\n    <div class=\"ui-grid-header-viewport\">\n      <div class=\"ui-grid-header-canvas\">\n        <div class=\"ui-grid-header-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\">\n          <div role=\"row\" class=\"ui-grid-header-cell-row\">\n            <div ng-class=\"{\'header-multi-line\':!grid.api.ix.gridHeaderEllipsis}\" class=\"ui-grid-header-cell ui-grid-clearfix\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" ui-grid-header-cell col=\"col\" render-index=\"$index\" title=\"{{col.displayName}}\">\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/grid/ui-grid-row.html","<div grid=\"grid\" class=\"ui-grid-draggable-row\" draggable=\"true\">\n  <!--<div ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell>\n  </div>-->\n  <div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" ng-class=\'{ \"disabled-cell\": row.cellClass == \"disabled-cell\", \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"con-alarma\": grid.appScope.conAlarma(row), \"selected\": row.entity.Sel == 1, \"highlight\": row.entity.highlight == 1, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell></div>\n</div>\n");
$templateCache.put("app/base/views/grid/ui-grid-tree-row.html","<div grid=\"grid\" class=\"ui-grid-draggable-row\" draggable=\"true\">\n  <!--<div ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell>\n  </div>-->\n  <div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ng-style=\"{\'padding-left\': grid.options.treeIndent * row.treeLevel + \'px\'}\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" ng-class=\'{ \"tree-level-0\": (row.treeLevel == 0), \"tree-level-1\": (row.treeLevel == 1), \"tree-level-2\": (row.treeLevel == 2), \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell></div>\n</div>\n");
$templateCache.put("app/base/views/grid/uiGridSortableCell.html","<div>\n  <div class=\"ui-grid-cell-contents\" ng-click=\"grid.appScope.orderInRow(grid, row, col)\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}} <i ng-class=\"{ \'ui-grid-icon-up-dir\': row.entity.orderby == \'asc\', \'ui-grid-icon-down-dir\': row.entity.orderby == \'desc\' }\"><sub ui-grid-visible=\"grid.appScope.isSortPriorityVisible(grid, row, col)\" class=\"ui-grid-sort-priority-number\">{{row.priority + 1}}</sub></i></div>\n</div>\n");
$templateCache.put("app/base/views/select/SearchBastidorInfo.html","<div>\n<form>\n<ui-select ng-model=\"MODEL_COL_FIELD\" style=\"min-width: 300px\" theme=\"TEMA_GRID\" ix-ui-grid-select-editor append-to-body=\"true\" on-select=\"col.colDef.onSelectDropdown($item, $model)\" uis-open-close=\"col.colDef.onOpenCloseDropdown(isOpen)\">\n  <ui-select-match translate-attr=\"placeholder\">{{$select.selected[\"chasis\"]}} </ui-select-match>\n  <ui-select-choices repeat=\"item[\'chasis\'] as item in col.colDef.editDropdownOptionsArray | filter: $select.search\" refresh=\"col.colDef.refreshDropdown($select, row)\" refresh-delay=\"50\">\n    <span ng-if=\"item.chasis\">\n      <span>{{item.chasis}} - <span ng-if=\"item.matricula\">{{item.matricula}} -</span> {{item.gruponombre}} - {{item.marcanombre}} - {{item.modelonombre}}</span>\n      <br>\n      <span class=\"text-muted\" ng-if=\"item.e_fecha && item.movimiento != 0\">Entrada: {{ item.e_fecha | date: \"dd/MM/yyyy\" }} </span><span class=\"text-muted\" ng-if=\"item.s_fecha && item.movimiento != 0\">Salida: {{ item.s_fecha | date: \"dd/MM/yyyy\" }}</span>\n      <span class=\"text-muted\" ng-if=\"item.e_fecha && item.movimiento == 0\">Previsión: {{ item.e_fecha | date: \"dd/MM/yyyy\" }} </span>\n      <br>\n      <span class=\"text-muted\">Cliente: {{item.clientenombre}} Cuenta: {{item.cuentanombre}}</span>\n    </span>\n  </ui-select-choices>\n</ui-select>\n</form>\n</div>\n");
$templateCache.put("app/base/views/select/SearchBastidorInfo2.html","<div class=\"ui-select-choices-row btn-sm\" ng-repeat=\"item in list | virtualSelectfilterSelected:item:selected:this track by $index\" ng-click=\"itemClick(item)\" ng-class=\"{active: highlighted == $index}\">\n	<a class=\"virtual-scroll-list-item ui-select-choices-row-inner\">\n		<span ng-if=\"item.chasis || item.vin\">\n      <div>{{item.chasis || item.vin}} - <span ng-if=\"item.matricula\">{{item.matricula}} -</span> {{item.gruponombre}} - {{item.marcanombre}} - {{item.modelonombre}}</div>\n      <div class=\"text-muted\" ng-if=\"item.e_fecha && item.movimiento != 0\">Entrada: {{ item.e_fecha | date: \"dd/MM/yyyy\" }} </div><div class=\"text-muted\" ng-if=\"item.s_fecha && item.movimiento != 0\">Salida: {{ item.s_fecha | date: \"dd/MM/yyyy\" }}</div>\n      <div class=\"text-muted\" ng-if=\"item.e_fecha && item.movimiento == 0\">Previsión: {{ item.e_fecha | date: \"dd/MM/yyyy\" }} </div>\n      <div class=\"text-muted\">Cliente: {{item.clientenombre}} Cuenta: {{item.cuentanombre}}</div>\n    </span>\n	</a>\n</div>\n");
$templateCache.put("app/base/views/select/SearchRefcarga.html","<div class=\"ui-select-choices-row btn-sm\" ng-repeat=\"item in list | virtualSelectfilterSelected:item:selected:this track by $index\" ng-click=\"itemClick(item)\" ng-class=\"{active: highlighted == $index}\">\r\n	<a class=\"virtual-scroll-list-item ui-select-choices-row-inner\">\r\n		<span ng-if=\"item.refcarga\">\r\n			<div>{{item.refcarga}} - <span>{{item.vehiculos}} </span></div>\r\n			<div>Grupo: {{ item.gruponombre }} </div>\r\n		</span>\r\n	</a>\r\n</div>");
$templateCache.put("app/base/views/helpers_templates/ixBuscaFichaBastidor.html","<div>\n  <!--<div class=\"input-group\" style=\"width: 300px; padding-top: 8px;\">\n    <span class=\"input-group-addon\"><i class=\"fa fa-search fa-lg\"></i></span> <input class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" placeholder=\"Buscar VIN...\" ng-model=\"filtreVIN\" type=\"text\"><span ng-if=\"filtreVIN.length\" ng-click=\"clearSearch()\" class=\"input-group-addon\"><i class=\"fa fa-close fa-lg\"></i></span>\n\n  </div>-->\n  <div class=\"input-group\" style=\"width: 200px;background-color: #fafafa;border-bottom: 1px solid #e1e1e1;top:10px\">\n    <span class=\"input-group-addon\" style=\"border: 0px;background-color: #fafafa\"><i class=\"fa fa-search fa-lg\"></i></span> \n    <input placeholder=\"Buscar VIN...\" ng-model=\"filtreVIN\" type=\"text\" style=\"border: 0px; background-color: #fafafa;height: 30px;color:#333\">\n    <span ng-if=\"filtreVIN.length\" ng-click=\"clearSearch()\" class=\"input-group-addon\"><i class=\"fa fa-close fa-lg\"></i></span>\n  </div>\n  <div ng-show=\"listItems.length\" class=\"listcontainer\">\n    <!--<ul ng-show=\"abrir\">-->\n    <ul>\n      <li ng-mousedown=\"open(item)\" ng-repeat=\"item in listItems\">\n        <span>\n          Chasis: <b>{{item.VIN || item.vin }}</b> Matrícula: <b>{{item.Matricula || item.matricula}}</b><br>\n          {{item.Marca || item.marca}} {{item.Modelo || item.modelo }}<br>\n        </span>\n        <span ng-show=\"item.estado_gp || item.estado_personalizado\">\n          Estado: {{ item.estado_gp }} - {{ item.estado_personalizado }}<br>\n        </span>\n				<span ng-show=\"item.campa\">\n					Ubicación: {{ item.campa }} / {{ item.zona }} / {{ item.calle }} / {{ item.posicion }}<br>\n				</span>\n        <span>\n          Entrada: {{(item.FechaEntrada || item.fecha_ent) | date: \'dd/MM/yyyy\' }} <span ng-show=\"item.FechaSalida || item.fecha_sal\">Salida: {{(item.FechaSalida || item.fecha_sal) | date: \'dd/MM/yyyy\' }}</span>\n        </span>\n      </li>\n    </ul>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixCestaVehiculosModal.html","<div class=\"modal-header\">\n  <h3>Cesta vehiculos</h3>\n</div>\n<div class=\"modal-body\">\n<div class=\"row\">\n  <ix-text-area ng-class=\"inputcestaVehiculos\" ng-model=\"$parent.vehiculos\" name=\"Numeros de {{ $parent.campo }}\"></ix-text-area>\n  <ix-radio ng-model=\"$parent.campo\" name=\"campo\" label=\"Buscar por\" options=\"[{value:\'matricula\', text:\'Matrícula\'},{value:\'chasis\', text: \'Chasis\'}]\"></ix-radio>\n  <ix-options-si-no ng-if=\"$parent.clientId == \'GPv4\'\" ng-model=\"$parent.$parent.terminacion\" name=\"Terminación\"></ix-options-si-no>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button id=\"cancelFilter\" class=\"btn btn-danger pull-left\" ng-click=\"vaciarCesta()\">Vaciar</button>\n\n<button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\">Guardar</button>\n<button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cerrar</button>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixColor.html","<div class=\"form-group\">\n	<label class=\"col-md-4\"><translate>Color</translate>\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\n    </label>\n	<div class=\"col-md-8\">\n		<ui-select ng-model=\"$parent.ngModel\" ng-disabled=\"ngDisabled\">\n			<ui-select-match placeholder=\"Selecciona un registro...\" translate-attr=\"placeholder\"><label class=\"colorPreview\" style=\"background-color:{{$select.selected.visual}}\"></label>{{$select.selected.name}}</ui-select-match>\n			<ui-select-choices repeat=\"color.color as color in (colors | filter: $select.search) track by color.color\" refresh=\"refresh($select.search)\" refresh-delay=\"300\">\n				<div><translate>{{color.name}}</translate></div>\n				<div class=\"text-muted\"><label class=\"colorPreview\" style=\"background-color:{{color.visual}}\"></label>{{color.color}}</div>\n			</ui-select-choices>\n		</ui-select>\n	</div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixDate.html","<div class=\"form-group\">\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\" ng-class=\"{ \'col-md-8\': !oneLineText, \'col-md-12\': oneLineText }\">\n		<ix-datepicker ng-model=\"ngModel\" name=\"{{name}}\" date-limit=\"dateLimit\" date-min=\"dateMin\" ng-disabled=\"ngDisabled\" append-to-body=\"appendToBody\"></ix-datepicker>\n	</div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixDateRange.html","<div class=\"form-group\">\n	<label ng-if=\"!withoutLabel\" class=\"col-md-4\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\n	<div ng-class=\"{ \'col-md-8\': !withoutLabel, \'col-md-12\': withoutLabel }\">\n		<ix-datepicker-range ng-model=\"ngModel\" name=\"{{name}}\" date-limit=\"dateLimit\" date-min=\"dateMin\" ng-disabled=\"ngDisabled\" append-to-body=\"appendToBody\" add-time=\"addTime\" on-change=\"onChange\" id=\"id\"></ix-datepicker-range>\n	</div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixDateTime.html","		<div class=\"form-group\">\n			<label class=\"col-md-4\">{{name}}<i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\n			<div class=\"col-md-8\">\n				<div class=\"row\">\n					<div class=\"col-xs-8\">\n						<ix-datepicker ng-model=\"ngModel\" date-limit=\"dateLimit\" date-min=\"dateMin\" ng-required=\"ngRequired\" name=\"{{name}}\" compare-datetime=\"true\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\"></ix-datepicker>\n					</div>\n					<div class=\"col-xs-4\" style=\"padding-left: 0\">\n						<!-- <input id=\"horaVarChar\" name=\"{{name}} (hora)\" time=\"text\" class=\"form-control\" ng-model=\"ngModelTime\" ui-mask=\"99:99\" model-view-value=\"true\" ui-validate=\"\'$parent.validateTIME($value)\'\" ng-required=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\"/> -->\n						<input id=\"horaVarChar\" name=\"{{name}} (hora)\" type=\"text\" ng-model=\"ngModelTime\" placeholder=\"HH:MM\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\">\n					</div>\n				</div>\n			</div>\n		</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixGrid.html","	<div style=\"height: {{height}}\" data-ui-grid=\"{{options}}\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize></div>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridColor.html","<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\" ix-ui-color-grid-cell>\n  <div class=\"text-muted\"><label class=\"colorPreview\" ng-style=\"getHTMLColor()\"></label><span ng-show=\"!hideDesc\">{{selectedColor.name}}</span></div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridColorEditor.html","<div>\n  <form>\n    <ui-select ng-model=\"MODEL_COL_FIELD\" style=\"min-width: 300px\" theme=\"TEMA_GRID\" ix-ui-grid-select-editor append-to-body=\"true\" on-select=\"col.colDef.onSelectDropdown($item, $model)\" uis-open-close=\"col.colDef.onOpenCloseDropdown(isOpen)\">\n      <ui-select-match placeholder=\"Selecciona un registro...\"><label class=\"colorPreview\" style=\"background-color:{{$select.selected.visual}}\"></label>{{$select.selected.name}}</ui-select-match>\n      <ui-select-choices repeat=\"color.color as color in (col.colDef.colors | filter: $select.search) track by color.color\" refresh=\"refresh($select.search)\" refresh-delay=\"300\">\n        <div>{{color.name}}</div>\n        <div class=\"text-muted\"><label class=\"colorPreview\" style=\"background-color:{{color.visual}}\"></label>{{color.color}}</div>\n      </ui-select-choices>\n    </ui-select>\n  </form>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridCortarDecimales.html","<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\" ng-model=\"MODEL_COL_FIELD\" ix-cortar-decimales>{{ngModelManipulado}}</div>");
$templateCache.put("app/base/views/helpers_templates/ixGridDateEditor.html","<!--<div>\n  <form>\n    <div class=\"col-md-8\">\n      <ix-datepicker ng-model=\"MODEL_COL_FIELD\" name=\"COL_FIELD\"></ix-datepicker>\n    </div>\n  </form>\n</div>-->\n<div>\n	<form>\n		<ix-ui-grid-date-editor ng-model=\"MODEL_COL_FIELD\" name=\"{{COL_FIELD}}\"></ix-ui-grid-date-editor>\n	</form>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridFiltro.html","<div class=\"ui-grid-filter-container\">\n  <div class=\"row\" style=\"padding: 0 !important;margin: 0 !important\">\n    <div style=\"padding: 0 !important;margin: 0 !important; width: 20px;float: left;position: relative\">\n      <button ng-class=\"{ \'novisible\': col.colDef.NoFilterable == true }\" ng-click=\"showFilterInput()\" class=\"btn btn-xs btn-block\">\n        <i class=\"fa fa-search\"></i>		\n      </button>\n    </div>\n    <div style=\"padding: 0 !important;margin: 0 !important;display: flex\" ng-show=\"col.filters[0].showFilterInput\">\n      <input class=\"fast-filter-input\" type=\"text\" focus-me=\"col.filters[0].showFilterInput\" ng-model=\"col.filters[0].term\" ng-attr-placeholder=\"{{colFilter.placeholder || \'\'}}\" aria-label=\"Filter for column\" placeholder=\"\" style=\"width: 100%;height: 19px\">\n    </div>\n    <div style=\"padding: 0 !important;margin: 0 !important;display: flex\" ng-show=\"!col.filters[0].showFilterInput\">\n      <button ng-class=\"{ \'novisible\': col.colDef.NoFilterable == true }\" ng-click=\"showFilterModal()\" class=\"btn btn-xs btn-block\">\n        <i class=\"fa fa-filter\"></i>\n        <span class=\"badge\" style=\"margin: 0 0 0 5px\" ng-if=\"col.filters[0].numfilters && col.filters[0].term\">{{col.filters[0].numfilters}}</span>\n      </button>\n      <div class=\"ui-grid-filter-button\" ng-click=\"deslectAllAndApply()\">\n        <i ng-click=\"deslectAllAndApply()\" class=\"ui-grid-icon-cancel\" ng-show=\"col.filters[0].numfilters && col.filters[0].term\">&nbsp;</i>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/base/views/helpers_templates/ixGridFiltroModal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <h3><translate translate-value-nombrecolumna=\"{{col.displayName}}\">{{ \'Filtrar por \\{\\{nombrecolumna\\}\\}\' }}</translate></h3>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n<div class=\"row\">\r\n  <div class=\"col-md-12\">\r\n    <ix-radio ng-model=\"col.filters[0].selectionType\" name=\"seleccion\" label=\"Selección\" options=\"options\" multiple-in-line=\"true\"></ix-radio>\r\n  </div>\r\n  <div ng-show=\"col.filters[0].selectionType == \'undefined\'\">            \r\n    <div class=\"col-md-12\" ng-show=\"col.colDef.type !== \'date\'\">              \r\n      <ix-text ng-model=\"col.filters[0].filtervalue\" name=\"Buscar\" is-filter=\"true\"></ix-text>\r\n      <hr>\r\n    </div>\r\n\r\n    <div class=\"col-md-12\">\r\n      <div style=\"max-height:calc(100vh - 345px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"{ label: col.filters[0].filtervalue }\">\r\n          <script type=\"text/ng-template\">\r\n            <span ivh-treeview-toggle>\r\n              <span ivh-treeview-twistie></span>\r\n            </span>\r\n            <span ivh-treeview-checkbox is-treeview-cb-enabled></span>\r\n            <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>\r\n              <span ng-bind-html=\"trvw.label(node)\"></span>\r\n            </span>\r\n            <div ivh-treeview-children></div>\r\n          </script>\r\n      </div>\r\n                    <hr class=\"no-margin\">\r\n                    <ix-options-si-no ng-model=\"col.filters[0].excluir\" name=\"Excluir selección\"></ix-options-si-no>\r\n    </div>\r\n  </div>\r\n\r\n            <div ng-if=\"col.filters[0].selectionType == \'#rango\'\">\r\n                <div class=\"col-md-12\">\r\n                    <ix-text ng-model=\"filtrosRango[0]\" name=\"Desde\" is-filter=\"true\" ix-number with-decimals=\"2\" allow-negative=\"true\"></ix-text>\r\n                </div>\r\n                <div class=\"col-md-12\">\r\n                    <ix-text ng-model=\"filtrosRango[1]\" name=\"Hasta\" is-filter=\"true\" ix-number with-decimals=\"2\" allow-negative=\"true\"></ix-text>\r\n                </div>\r\n            </div>\r\n\r\n            <div ng-if=\"col.filters[0].selectionType == \'#lista\'\">            \r\n\r\n    <div class=\"col-md-12\" ng-show=\"col.colDef.type !== \'date\'\">              \r\n      <ix-text-area ng-model=\"col.filters[0].filtervalue\" name=\"Buscar\" rows=\"8\"></ix-text-area>\r\n      <hr>\r\n    </div>\r\n    <div class=\"col-md-12\">              \r\n      <div style=\"max-height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filterList\">\r\n        <script type=\"text/ng-template\">\r\n            <span ivh-treeview-toggle>\r\n              <span ivh-treeview-twistie></span>\r\n            </span>\r\n            <span ivh-treeview-checkbox is-treeview-cb-enabled></span>\r\n            <span class=\"ivh-treeview-node-label\" ivh-treeview-toggle>\r\n              <span ng-bind-html=\"trvw.label(node)\"></span>\r\n            </span>\r\n            <div ivh-treeview-children></div>\r\n          </script>\r\n      </div>\r\n      <div ng-show=\"col.colDef.type !== \'date\'\">\r\n        <hr class=\"no-margin\">\r\n                      <ix-options-si-no ng-model=\"col.filters[0].excluir\" name=\"Excluir selección\"></ix-options-si-no>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n<span ng-show=\"col.filters[0].selectionType == \'undefined\' || col.filters[0].selectionType == \'#lista\'\">\r\n  <button class=\"btn pull-left\" ng-click=\"selectAll()\"><translate>Todos</translate></button>\r\n  <button class=\"btn pull-left\" ng-click=\"deselectAll()\"><translate>Ninguno</translate></button>\r\n</span>\r\n<button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close({ listOfValues: listOfValues, filtrosRango: filtrosRango })\"><translate>Aplicar</translate></button>\r\n<button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cancelar</translate></button>\r\n    </div>\r\n</div>");
$templateCache.put("app/base/views/helpers_templates/ixGridFiltroServidor.html","<div class=\"ui-grid-filter-container\">\n	<button ng-if=\"col.colDef.filteropt == \'Fecha\'\" ng-click=\"showFilterModal()\" class=\"btn btn-xs btn-block\">\n		<i class=\"fa fa-filter\"></i>\n    <span class=\"badge\" style=\"margin: 0 0 0 5px\" ng-if=\"col.filters[0].numfilters\">{{col.filters[0].numfilters}}</span>\n	</button>\n  <button ng-if=\"col.colDef.filteropt == \'Texto\' || col.colDef.filteropt == \'Numero\'\" ng-click=\"showFilterModal()\" class=\"btn btn-xs btn-block\">\n    <i class=\"fa fa-filter\"></i>\n    <span class=\"badge\" style=\"margin: 0 0 0 5px\" ng-if=\"col.filters[0].numfilters && col.filters[0].term\">{{col.filters[0].numfilters}}</span>\n  </button>\n  <!--<div ng-if=\"col.colDef.filteropt == \'CheckBox\'\" style=\"text-align: center;\" ng-repeat=\"colFilter in col.filters\">\n      <input type=\"checkbox\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" class=\"ui-grid-filter-input\" ng-model=\"colFilter.term\" ng-click=\"applyFiltersToGrid()\" ng-attr-placeholder=\"{{colFilter.placeholder || \'\'}}\">\n    <span class=\"badge\" style=\"margin: 0 0 0 5px; background-color: red;\" ng-show=\"colFilter.term != null\">1</span>\n    <div class=\"ui-grid-filter-button\" ng-click=\"colFilter.term = null; applyFiltersToGrid()\">\n      <i class=\"ui-grid-icon-cancel\" ng-show=\"colFilter.term != null\">&nbsp;</i>\n    </div>\n  </div>-->\n  <div ng-if=\"col.colDef.filteropt == \'CheckBox\'\" style=\"text-align: center\" ng-repeat=\"colFilter in col.filters\">\n    <div class=\"checkbox\">\n      <label>\n        <input type=\"checkbox\" class=\"ui-grid-filter-input\" ng-model=\"colFilter.term\" ng-click=\"applyFiltersToGrid()\" ng-checked=\"colFilter.term == \'1\'\" ng-attr-placeholder=\"{{colFilter.placeholder || \'\'}}\">\n        <span class=\"checkbox-material\">\n          <span class=\"check\"></span>\n        </span>\n      </label>\n      <span class=\"badge\" style=\"margin: 0 0 0 5px; background-color: red\" ng-show=\"colFilter.term != null\">1</span>\n      <div class=\"ui-grid-filter-button\" ng-click=\"colFilter.term = null; applyFiltersToGrid()\">\n        <i ng-click=\"colFilter.term = null\" class=\"ui-grid-icon-cancel\" ng-show=\"colFilter.term != null\">&nbsp;</i>\n      </div>\n\n    </div>\n  </div>\n</div>\n\n<script type=\"text/ng-template\" id=\"ixGridFiltroServidorModal.html\">\n			<div class=\"modal-header\">\n				<h3><translate translate-value-nombrecolumna=\"{{col.displayName}}\">{{ \'Filtrar por \\{\\{nombrecolumna\\}\\}\' }}</translate></h3>\n			</div>\n			<div class=\"modal-body\">\n        <div ng-if=\"col.colDef.filteropt == \'Fecha\'\" class=\"row\">\n          <div class=\"col-md-12\">\n            <ix-select ng-model=\"col.filters[0].periodo_ini\" name=\"Periodo inicio\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadTiposFecha\" load-all-items=\"true\"></ix-select>\n          </div>\n          <div class=\"col-md-12\">\n            <ix-select ng-model=\"col.filters[0].periodo_fin\" name=\"Periodo fin\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadTiposFecha\" load-all-items=\"true\"></ix-select>\n          </div>\n          <div class=\"col-md-12\" ng-show=\"col.filters[0].data_especial == undefined\">\n            <ix-date ng-if=\"!col.filters[0].periodo_ini\" ng-model=\"col.filters[0].data_ini\" name=\"Fecha inicio\"></ix-date>\n            <ix-date ng-if=\"!col.filters[0].periodo_fin\" ng-model=\"col.filters[0].data_fi\" name=\"Fecha final\"></ix-date>\n          </div>\n        </div>\n        <div ng-if=\"col.colDef.filteropt == \'Texto\' || col.colDef.filteropt == \'Numero\'\" class=\"row\">\n          <!-- Tots els filtres que siguin de columnes que no són tipus date tindran el input de filtrar filtres -->\n          <span ng-show=\"col.colDef.type !== \'date\'\">\n              <!--<label>Buscar</label>\n              <input type=\"text\" ng-model=\"col.filters[0].filtervalue\" />-->\n            <ix-text ng-model=\"col.filters[0].filtervalue\" name=\"Buscar\" is-filter=\"true\"></ix-text>\n            <hr/>\n          </span>\n          <div style=\"max-height:calc(100vh - 315px); overflow:auto;\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"{ label: col.filters[0].filtervalue }\">\n          </div>\n        </div>\n			</div>\n			<div ng-if=\"col.colDef.filteropt == \'Fecha\'\" class=\"modal-footer\">\n				<button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\">Aplicar</button>\n				<button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button>\n			</div>\n			<div ng-if=\"col.colDef.filteropt == \'Texto\' || col.colDef.filteropt == \'Numero\'\" class=\"modal-footer\">\n				<button class=\"btn pull-left\" ng-click=\"selectAll()\">Todos</button>\n				<button class=\"btn pull-left\" ng-click=\"deselectAll()\">Ninguno</button>\n				<button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\">Aplicar</button>\n				<button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button>\n			</div>\n</script>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridModal.html","<div class=\"modal\" ng-style=\"{display:\'block\'}\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{ colDisplayname }}</h3>\n      </div>\n      <div class=\"modal-body\" id=\"modal-body\">\n        <form class=\"popup-form\" name=\"modalForm\">\n          <div uib-alert class=\"alert-danger\" ng-if=\"modalForm.modify_value_repeat.$error.validator\">¡Las contraseñas no coinciden!</div>\n          <!-- Tots els camps que no siguin password seran tipus text -->\n          <div class=\"row\" ng-if=\"colField !== \'password\'\">\n            <!--<div><label>{{ colDisplayname }}<i class=\"fa fa-asterisk\"></i></label>\n              <input type=\"text\" ng-model=\"$parent.modify_value\" name=\"modify_value\" />\n            </div>-->\n            <div class=\"col-md-12\">\n              <div class=\"form-group\">\n                <label class=\"col-md-4\"><translate>{{ colDisplayname }}</translate><i class=\"fa fa-asterisk\"></i></label>\n                <div class=\"col-md-8\">\n                  <input class=\"input-full-width\" type=\"text\" ng-model=\"$parent.modify_value\" name=\"modify_value\">\n                </div>\n              </div>\n            </div>\n          </div>\n          <!-- Camps tipus password, s\'hauran de repetir. -->\n          <div class=\"row\" ng-if=\"colField === \'password\'\">\n            <!--<div><label>{{ colDisplayname }}<i class=\"fa fa-asterisk\"></i></label>\n                <input type=\"password\" ng-model=\"$parent.modify_value\" name=\"modify_value\" />\n            </div>-->\n            <!--<div ng-if=\"colField === \'password\'\"><label>Repeat {{ colDisplayname }}<i class=\"fa fa-asterisk\" style=\"color:red\"></i></label>\n                <input type=\"password\" ng-model=\"$parent.modify_value_repeat\" name=\"modify_value_repeat\" ui-validate=\" \'$value==modify_value\' \" ui-validate-watch=\" \'modify_value\' \" />\n            </div>-->\n            <div class=\"col-md-12\">\n              <div class=\"form-group\">\n                <label class=\"col-md-4\"><translate>{{ colDisplayname }}</translate><i class=\"fa fa-asterisk\"></i></label>\n                <div class=\"col-md-8\">\n                  <input class=\"input-full-width\" type=\"password\" ng-model=\"$parent.modify_value\" name=\"modify_value\" autocomplete=\"off\">\n                </div>\n              </div>\n            </div>\n            <div class=\"col-md-12\">\n              <div class=\"form-group\">\n                <label class=\"col-md-4\"><translate>Repeat {{ colDisplayname }}</translate><i class=\"fa fa-asterisk\"></i></label>\n                <div class=\"col-md-8\">\n                  <input class=\"input-full-width\" type=\"password\" ng-model=\"$parent.modify_value_repeat\" name=\"modify_value_repeat\" ui-validate=\" \'$value==modify_value\' \" ui-validate-watch=\" \'modify_value\' \" autocomplete=\"off\">\n                </div>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n      <div class=\"modal-footer\">\n        <button class=\"btn btn-success\" ng-click=\"saveData()\">Guardar</button>\n        <button class=\"btn btn-danger\" ng-click=\"closePopup()\">Cerrar</button>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridMultipleSelectEditor.html","<div class=\"ui-grid-cell-contents\">\n  <ix-grid-multiple-select ng-model=\"MODEL_COL_FIELD\" valor=\"{{COL_FIELD}}\"></ix-grid-multiple-select>\n</div>\n\n<script type=\"text/ng-template\" id=\"ixGridMultipleSelectModal.html\">\n			<div class=\"modal-header\">\n				<h3><translate translate-value-nombrecolumna=\"{{col.displayName}}\">{{ \'Selección de \\{\\{nombrecolumna\\}\\}\' }}</translate></h3>\n			</div>\n			<div class=\"modal-body\">\n        <label><translate>Buscar</translate></label>\n        <input type=\"text\" ng-model=\"$parent.searchvalue\" />\n        <hr/>\n        <div style=\"max-height:calc(100vh - 315px); overflow:auto;\" ivh-treeview=\"optionValues\" ivh-treeview-filter=\"$parent.searchvalue\">\n				</div>\n			</div>\n			<div class=\"modal-footer\">\n        <button class=\"btn pull-left\" ng-click=\"selectAll()\"><translate>Todos</translate></button>\n        <button class=\"btn pull-left\" ng-click=\"deselectAll()\"><translate>Ninguno</translate></button>\n        <button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\"><translate>Aplicar</translate></button>\n        <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cancelar</translate></button>\n			</div>\n</script>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridSelectEditor.html","<div>\n  <form>\n    <ui-select ng-model=\"MODEL_COL_FIELD\" style=\"min-width: 300px\" theme=\"TEMA_GRID\" ix-ui-grid-select-editor append-to-body=\"true\" on-select=\"col.colDef.onSelectDropdown($item, $model)\" uis-open-close=\"col.colDef.onOpenCloseDropdown(isOpen)\">\n      <ui-select-match translate-attr=\"placeholder\"><span ng-repeat=\"f in col.colDef.LookUpResultFields\">{{$select.selected[f]}} </span></ui-select-match>\n      <ui-select-choices repeat=\"item[col.colDef.LookUpKeyFields[col.colDef.LookUpKeyFields.length-1]] as item in col.colDef.editDropdownOptionsArray | filter: $select.search\" refresh=\"col.colDef.refreshDropdown($select, row)\" refresh-delay=\"50\">\n        <span ng-repeat=\"f in col.colDef.LookUpResultFields\" ng-class=\"{\'text-muted\':(col.colDef.LookUpKeyFields.indexOf(f)>=0)}\"><span ng-if=\"$index>0 && item[f]\"> - </span>{{item[f]}}</span>\n      </ui-select-choices>\n    </ui-select>\n\n\n    <!--<ui-select ng-model=\"MODEL_COL_FIELD\" theme=\"TEMA_GRID\" ng-disabled=\"disabled\" ix-ui-grid-select-editor append-to-body=\"true\">\n      <ui-select-match translate-attr=\"placeholder\"><span ng-repeat=\"f in col.colDef.LookUpResultFields\">{{$select.selected[f]}} </span></ui-select-match>\n      <ui-select-choices repeat=\"item in col.colDef.editDropdownOptionsArray | filter: $select.search\">\n        <span>{{ item }}</span>\n      </ui-select-choices>\n    </ui-select>-->\n\n    <!--<ui-select ng-model=\"MODEL_COL_FIELD\" style=\"min-width: 300px;\" theme=\"TEMA_GRID\" append-to-body=\"true\" on-select=\"col.colDef.onSelectDropdown($item, $model)\" uis-open-close=\"col.colDef.onOpenCloseDropdown(isOpen)\">\n      <ui-select-match><span ng-repeat=\"f in col.colDef.LookUpResultFields\">{{$select.selected[f]}} </span></ui-select-match>\n      <ui-select-choices repeat=\"item[col.colDef.LookUpKeyFields[col.colDef.LookUpKeyFields.length-1]] as item in col.colDef.editDropdownOptionsArray | filter: $select.search\" refresh=\"col.colDef.refreshDropdown($select, row)\" refresh-delay=\"300\">\n        <span ng-repeat=\"f in col.colDef.LookUpResultFields\" ng-class=\"{\'text-muted\':(col.colDef.LookUpKeyFields.indexOf(f)>=0)}\"><span ng-if=\"$index>0 && item[f]\"> - </span>{{item[f]}}</span>\n      </ui-select-choices>\n    </ui-select>-->\n\n    <!--<ui-select ng-model=\"MODEL_COL_FIELD\" theme=\"selectize\" ng-disabled=\"disabled\" append-to-body=\"true\">\n      <ui-select-match placeholder=\"Choose...\">{{ COL_FIELD }}</ui-select-match>\n      <ui-select-choices repeat=\"item in col.colDef.editDropdownOptionsArray | filter: $select.search\">\n        <span>{{ item }}</span>\n      </ui-select-choices>\n    </ui-select>-->\n  </form>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridSelectEditor2.html","<div>\n  <form>\n		<virtual-select title=\"TOOLTIP\" ng-class=\"{\'required\':col.colDef.required, \'noeditable\':col.grid.api.ix.disableField({row: row, col: col }, col)}\" choices-repeat=\"col.colDef.editDropdownOptionsArray\" ix-ui-grid-select-editor2 style=\"line-height:22px\" ng-model=\"MODEL_COL_FIELD\" core-property=\"col.colDef.LookUpResultFields[col.colDef.LookUpResultFields.length - 1]\" display-property=\"col.colDef.LookUpResultFields[0]\" singleselect dropdown-in-grid=\"true\" ng-disabled=\"col.grid.api.ix.disableField({row: row, col: col }, col)\" ng-required=\"col.colDef.required\" entity=\"col.colDef.LookUpTableName\" extra-field=\"extraField\" preload=\"preload\" conditions=\"col.colDef.LookUpConditions\" key-fields=\"col.colDef.KeyFields\" lookup-key-fields=\"col.colDef.LookUpKeyFields\" load-function=\"col.colDef.refreshDropdown\" allow-custom=\"col.colDef.EditableDropdown\" allow-custom-priority=\"col.colDef.EditableDropdownPriority\" on-select=\"col.colDef.onSelectDropdown\" grid-row=\"row\" grid-col=\"col\" append-to-body=\"true\" all-fk-objects=\"col.colDef.allFkObjects\" template=\"col.colDef.template\" min-length-to-load=\"col.colDef.minLengthToLoad\" max-length=\"col.colDef.maxLength\" skip-table-name-filter=\"col.colDef.skipTableNameFilter\" skip-table-name-order-by=\"col.colDef.skipTableNameOrderBy\" table-alias-name=\"col.colDef.TableAliasName\" lookup-orders=\"col.colDef.LookUpOrders\"></virtual-select>\n  </form>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridSiNoEditor.html","<div>\n  <form>\n    <ui-select class=\"ix-si-no\" ng-model=\"MODEL_COL_FIELD\" style=\"min-width: 300px\" theme=\"TEMA_GRID\" ix-ui-grid-select-editor append-to-body=\"true\" on-select=\"col.colDef.onSelectDropdown($item, $model)\" uis-open-close=\"col.colDef.onOpenCloseDropdown(isOpen)\">\n      <ui-select-match allow-clear=\"true\">{{$select.selected.desc}}</ui-select-match>\n      <ui-select-choices repeat=\"item.pk as item in (col.colDef.editDropdownOptionsArray | filter: $select.search) track by item.pk\" refresh=\"col.colDef.onOpenCloseDropdown(true)\" refresh-delay=\"50\">\n				<div>{{::item.desc}}</div>\n				<div class=\"text-muted\">{{::item.pk}}</div>\n			</ui-select-choices>\n    </ui-select>\n  </form>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridTimeEditor.html","<div>\n  <form>\n    <input style=\"background-color: white\" time=\"text\" ix-grid-time-editor ui-grid-editor class=\"form-control\" ng-model=\"MODEL_COL_FIELD\" ui-mask=\"99:99:99\" model-view-value=\"true\" ui-validate=\"\'validateTIME($value)\'\">\n  </form>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixGridURL.html","<div class=\"ui-grid-cell-contents\">\n  <ix-grid-url ng-model=\"MODEL_COL_FIELD\"></ix-grid-url>\n</div>");
$templateCache.put("app/base/views/helpers_templates/ixListSelect.html","<div class=\"form-group\">\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\n    <input type=\"text\" name=\"{{::name}}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-model=\"ngModel\" class=\"input-full-width\" ngrequired=\"ngRequired\" ng-disabled=\"true\" ng-value=\"ngValue\" placeholder=\"{{ ngPlaceholder }}\" maxlength=\"{{::maxLength}}\" autocomplete=\"off\">\n		<span class=\"icon-box\" ng-click=\"showModalSelection()\"><i class=\"fa fa-search\"></i></span>\n	</div>\n</div>\n<script type=\"text/ng-template\" id=\"ixListSelectModal.html\">\n			<div class=\"modal-header\">\n				<h3>{{ $parent.name }}</h3>\n			</div>\n			<div class=\"modal-body\">\n        <label><translate>Buscar</translate></label>\n        <input type=\"text\" ng-model=\"$parent.searchvalue\" />\n        <hr/>\n        <div style=\"max-height:calc(100vh - 315px); overflow:auto;\" ivh-treeview=\"optionValues\" ivh-treeview-filter=\"$parent.searchvalue\">\n				</div>\n			</div>\n			<div class=\"modal-footer\">\n        <button class=\"btn pull-left\" ng-click=\"selectAll()\"><translate>Todos</translate></button>\n        <button class=\"btn pull-left\" ng-click=\"deselectAll()\"><translate>Ninguno</translate></button>\n        <button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\"><translate>Aplicar</translate></button>\n        <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cancelar</translate></button>\n			</div>\n</script>\n");
$templateCache.put("app/base/views/helpers_templates/ixMapa.html","<div>\n	<button ng-show=\"restablecerBtn\" class=\"btn btn-primary\" ng-click=\"restablecerMapa()\">Restablecer</button>\n	<leaflet ng-if=\"tiles\" id=\"{{id}}\" lf-center=\"center\" defaults=\"defaults\" legend=\"legend\" height=\"{{height}}\" width=\"100%\" paths=\"paths\" markers=\"markers\" tiles=\"tiles\" controls></leaflet>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixMegawhere.html","<div ng-dblclick=\"openWindow(\'big\')\" class=\"ui-grid-cell-contents\">\n  <i ng-click=\"openWindow(\'big\')\" title=\"Condiciones\" class=\"fa fa-fw fa-window-maximize\"></i>\n</div>\n\n<script type=\"text/ng-template\" id=\"ixMegawhereModal.html\" class=\"megawhereWindow\">\n			<div class=\"modal-header\">\n				<ix-tool-bar></ix-tool-bar>\n			</div>\n			<div class=\"modal-body\">\n        <div class=\"row\">\n          <div ng-if=\"!showPivot\" style=\"height: calc(100vh - 320px)\" data-ui-grid=\"gridmegawhere\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize></div>\n        </div>\n			</div>\n			<div class=\"modal-footer\">\n				<!--<button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\">Guardar</button>-->\n				<button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\"><translate>Cerrar</translate></button>\n			</div>\n</script>\n\n");
$templateCache.put("app/base/views/helpers_templates/ixOptionsSiNo.html","<div class=\"togglebutton\" abm-toggle>\n  <label ng-class=\"{ \'col-md-8\': textMaxWidth == true, \'col-md-4\': !textMaxWidth }\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" style=\"color:red\" ng-show=\"ngRequired\"></i></label>\n  <input ng-class=\"{ \'pull-right\': textMaxWidth == true }\" ng-checked=\"estaSeleccionado == 1\" type=\"checkbox\" ng-click=\"changeSelected(ngModel)\" ng-model=\"ngModel\" ng-disabled=\"ngDisabled\" ng-true-value=\"1\" ng-false-value=\"0\">\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixPassword.html","<div class=\"form-group\">\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\n    	<input type=\"password\" name=\"{{::name}}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-model=\"ngModel\" ng-class=\"{ \'input-full-width\': (ngModel2 === undefined && !input1Class), \'input-half-width\': (ngModel2 !== undefined && !input1Class), \'background-red\': redBackground }\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\" placeholder=\"{{ ngPlaceholder }}\" maxlength=\"{{::maxLength}}\" autocomplete=\"off\" ng-keydown=\"onKeydown($event)\">\n	</div>\n	<div ng-transclude></div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixPreviewImage.html","<div class=\"form-group\">\n	<div class=\"col-md-12\" ng-style=\"{ \'height\': height, \'width\': width }\" style=\"padding: 0;box-shadow: 0px 2px 12px -5px rgba(0,0,0,0.57);background-color: white;border: 1px solid #80808073;border-radius: 3px;z-index:1;display: table\" ng-click=\"verFotoPopup()\">\n		<!-- Aun no hay imagen asociada -->\n		<span ng-if=\"!foto && canUpload\" style=\"display: table-cell; vertical-align: middle; line-height: normal; margin-top:5px; color: grey;text-align: center\">Puede añadir una imagen haciendo click</span>\n		<!-- Hay imagen asociada -->\n		<span ng-if=\"canUpload && src\" style=\"position:absolute;background-color: rgb(151, 189, 209);z-index:1\" title=\"Subir imágen\" ng-click=\"seleccionarFoto($event)\"><i style=\"color: white\" class=\"fa fa-fw fa-upload\"></i></span>\n		<img ng-if=\"src\" style=\"height: inherit;width: inherit;border-radius: 3px;position: absolute\" ng-src=\"data:image/jpg;base64,{{src}}\" alt=\"Foto\">\n	</div>\n</div>\n\n<script type=\"text/ng-template\" id=\"image_viewer.html\">\n	<div class=\"col-md-12 imgContainer\">\n		<img class=\"slide\" src=\"assets/images/{{src}}\" />\n	</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"ixPreviewImageModal.html\">\n	<div>\n		<ix-popup-tool-bar title-left=\"Vista previa\" title-right=\"nombre\">\n			<div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\n				<button id=\"acciones-button\" uib-tooltip=\"Más acciones\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"status.blockUIBtns || !status.editing\">\n					Acciones <span class=\"caret\"></span>\n				</button>\n				<ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\n					<li role=\"menuitem\"><a ng-click=\"downloadImage()\">Descargar Imagen</a></li>\n				</ul>\n			</div>\n		</ix-popup-tool-bar>\n		<div ng-scrollbars class=\"scrolldiv\">\n			<div class=\"scrolldiv-content\">\n				<div class=\"modal-body\">\n					<div class=\"row\">\n						<div class=\"col-md-12 imgContainer\" style=\"text-align: center\">\n							<img class=\"slide\" ng-src=\"data:image/jpg;base64,{{src}}\"  alt=\"Foto\" title=\"{{nombre}}\" />\n						</div>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"ixUploadImageModal.html\">\n	<div>\n		<ix-popup-tool-bar title-left=\"Seleccionar Fotografia\"></ix-popup-tool-bar>\n		<div ng-scrollbars class=\"scrolldiv\">\n			<div class=\"scrolldiv-content\">\n				<div class=\"modal-body\">\n					<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\n						<div class=\"row\">\n							<div class=\"col-md-12\">\n								<div class=\"col-md-8\">\n									<input ng-disabled=\"!status.editing\" class=\"btn\" type=\"file\" ngf-select ngf-multiple=\"true\" ng-model=\"data.foto\" name=\"archivo\"\n												 ngf-max-size=\"{{maxUploadFileSize}}\"\n												 ngf-model-invalid=\"errorFile\">\n								</div>\n							</div>\n						</div>\n					</form>\n				</div>\n			</div>\n		</div>\n	</div>\n</script>\n");
$templateCache.put("app/base/views/helpers_templates/ixPreviewImageFullWidthPopup.html","<div>\n	<ix-popup-tool-bar title-left=\"Vista previa\" title-left-param=\"nombre\">\n		<div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\n			<button id=\"acciones-button\" uib-tooltip=\"Más acciones\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"status.blockUIBtns || !status.editing\">\n				Acciones <span class=\"caret\"></span>\n			</button>\n			<ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\n				<li role=\"menuitem\"><a ng-click=\"downloadImage()\">Descargar Imagen</a></li>\n			</ul>\n		</div>\n	</ix-popup-tool-bar>\n	<div ng-scrollbars class=\"scrolldiv\">\n		<div class=\"scrolldiv-content\">\n			<div class=\"modal-body\">\n				<div class=\"row\">\n					<div class=\"col-md-12\" style=\"text-align: center\">\n						<img style=\"max-width:100%;position:relative\" class=\"slide\" ng-src=\"data:{{foto.imageMimetype}};base64,{{foto.imagenBase64}}\" alt=\"Foto\" title=\"{{nombre}}\" rotate=\"true\">\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixPreviewPDF.html","<span>\n	<button class=\"btn no-margin\" ng-click=\"openPopup()\">{{ name }}</button>\n</span>\n\n<script type=\"text/ng-template\" id=\"pdf_viewer.html\">\n	<div class=\"col-md-12\" style=\"height: 700px\">\n		<div class=\"some-pdf-container\" style=\"width: 100%; height: 100%;\">\n			<pdfjs-viewer src=\"{{urlPDF}}\"></pdfjs-viewer>\n		</div>\n	</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"ixPreviewPDFModal.html\">\n	<div>\n		<ix-popup-tool-bar title-left=\"Previsualizar PDF\"></ix-popup-tool-bar>\n		<div ng-scrollbars class=\"scrolldiv\">\n			<div class=\"scrolldiv-content\">\n				<div class=\"modal-body\">\n					<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\n						<div class=\"row\">\n							<span ng-include=\"\'pdf_viewer.html\'\"></span>\n						</div>\n					</form>\n				</div>\n			</div>\n		</div>\n	</div>\n</script>\n");
$templateCache.put("app/base/views/helpers_templates/ixRadio.html","<div class=\"form-group\">\n	<label ng-if=\"!withoutLabel\" ng-style=\"labelStyle\" class=\"col-md-4\"><translate>{{label}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\n	<div ng-class=\"{ \'col-md-8\': !withoutLabel, \'col-md-12\': withoutLabel }\">\n    <div class=\"row options\">\n      <div class=\"col-md-12\">\n        <div class=\"options-container col-md-12\">\n          <div ng-class=\"{ \'radio-container-two-column\': separateInTwoColumns }\">\n            <div ng-repeat=\"option in options\" ng-class=\"{ \'multipleinline\': multipleInLine == true, \'radio-item-two-column\': separateInTwoColumns }\">\n              <!-- ngRepeat crea un childScope, per accedir propietats de la directiva ha de ser a través de $parent -->\n              <input type=\"radio\" id=\"{{name}}{{option.value}}\" ng-model=\"$parent.ngModel\" name=\"{{$parent.name}}\" ng-value=\"option.value\" ng-disabled=\"ngDisabled\" ng-change=\"onChange(option)\">\n              <label ng-style=\"labelStyle\" for=\"{{name}}{{option.value}}\"><img ng-if=\"option.icon\" ng-src=\"{{::option.icon}}\"> {{option.text | translate}}</label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n	</div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixSearchFromGrid.html","<div class=\"form-group\">\n  <label class=\"col-md-4\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\n  <div class=\"col-md-8\">\n    <div class=\"input-group add-on\">\n      <input ng-model=\"ngModel\" type=\"text\" ngrequired=\"ngRequired\" ng-disabled=\"ngDisabled\" ng-value=\"ngValue\" ix-focus-out=\"validateFunction\">\n      <span class=\"input-group-btn\">\n        <span class=\"btn btn-default\" ng-disabled=\"ngDisabled\" ng-click=\"openWindow(\'big\')\">\n          <span ng-transclude></span>\n        </span>\n      </span>\n    </div>\n    <!--<input ng-click=\"openWindow(\'big\')\" type=\"text\" ngRequired =\"ngRequired\" ng-disabled=\"ngDisabled\" ng-value=\"ngValue\" readonly>-->\n  </div>\n</div>\n\n<script type=\"text/ng-template\" id=\"ixSearchGridModal.html\" class=\"megawhereWindow\">\n  <ix-popup-tool-bar title-left=\"Buscar\" title-left-param=\"entity\"></ix-popup-tool-bar>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"btn-toolbar\">\n          <div style=\"height: calc(100vh - 320px)\" data-ui-grid=\"gridBusqueda\" data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-cellNav>\n            <div class=\"grid-loading\" ng-if=\"gridBusqueda.ixIsLoading\">\n              <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</script>\n");
$templateCache.put("app/base/views/helpers_templates/ixSelect.html","<div class=\"form-group\">\n	<label class=\"col-md-4\"><translate>{{::name || pk}}</translate>\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\n    </label>\n	<div ng-class=\"{ \'col-md-8\': !oneLineText, \'col-md-12\': oneLineText }\">\n		<ui-select ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-model=\"$parent.ngModel\" ng-class=\"{ \'show-always\': editableDropdown == true }\" append-to-body=\"appendToBody\" ng-disabled=\"ngDisabled\" on-select=\"onSelectOption($item)\" uis-open-close=\"onOpenCloseDropdown(isOpen)\">\n      <ui-select-match allow-clear=\"{{ !ngRequired }}\" placeholder=\"Selecciona un registro...\" translate-attr=\"placeholder\">{{$select.selected[desc]}} <span ng-if=\"extraField\">/ {{$select.selected[extraField]}}</span></ui-select-match>\n			<!--ixTODO: aquet filtre de DOM ((allItems | filt...) per un filtre de controller-->\n			<ui-select-choices repeat=\"item[pk] as item in (allItems | filter: $select.search) track by item[pk]\" refresh=\"refresh($select)\" refresh-delay=\"300\">\n				<div>{{::item[desc]}} <span ng-if=\"extraField\">/ {{::item[extraField]}}</span></div>\n				<div class=\"text-muted\">{{::item[pk]}}</div>\n			</ui-select-choices>\n		</ui-select>\n	</div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixSelect2.html","<div class=\"form-group\">\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{::name || pk}}</translate>\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\n    </label>\n<!--	<div ng-class=\"inputClass ? inputClass : (\'col-md-8\': !oneLineText, \'col-md-12\': oneLineText)\">-->\n	<div class=\"{{::inputClass}}\" ng-class=\"{ \'col-md-8\': !oneLineText && !inputClass, \'col-md-12\': oneLineText && !inputClass }\">\n		<virtual-select ng-class=\"{ \'disabled\': ngDisabled, \'background-red\': redBackground }\" choices-repeat=\"allItems\" ng-model=\"ngModel\" core-property=\"pk\" display-property=\"desc\" singleselect ng-disabled=\"ngDisabled\" custom-ng-required=\"ngRequired\" entity=\"entity\" extra-field=\"extraField\" filter-fields=\"filterFields\" preload=\"preload\" conditions=\"conditions\" load-function=\"loadFunction\" ng-default=\"ngDefault\" whole-obj=\"wholeObj\" order-string-as-int=\"orderStringAsInt\" allow-custom=\"editableDropdown\" preload-function=\"preloadFunction\" preload-obj=\"preloadObj\" preload-pk=\"preloadPk\" load-all-items=\"loadAllItems\" entity-data=\"entityData\" entity-data-pk=\"entityDataPk\" entity-data-desc=\"entityDataDesc\" append-to-body=\"appendToBody\" on-select=\"onSelect\" template=\"template\" skip-table-name-filter=\"skipTableNameFilter\" skip-table-name-order-by=\"skipTableNameOrderBy\" longer-result-box=\"longerResultBox\" string-id=\"stringId\" dropdown-sin-codigo=\"dropdownSinCodigo\"></virtual-select>\n	</div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixSelectFromGrid.html","<div>\n  <form>\n    <ix-grid-select ng-model=\"MODEL_COL_FIELD\" valor=\"{{COL_FIELD}}\"></ix-grid-select>\n  </form>\n</div>\n<script type=\"text/ng-template\" id=\"ixGridSelectModal.html\">\n  <ix-popup-tool-bar ng-if=\"accionesToolBar.length>0\" title-left=\"Selección de\" title-left-param=\"$parent.$parent.col.name\">\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"false\">\n      <button id=\"acciones-button\" uib-tooltip=\"Más acciones\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\n      Acciones <span class=\"caret\"></span>\n      </button>\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">			\n        <li ng-repeat=\"accion in accionesToolBar\" role=\"menuitem\" ng-if=\"accion.isVisible(item)\"><a ix-accion item=\"item\" accion=\"accion\" style=\"cursor:pointer;\"><translate>{{::accion.title}}</translate></a></li> \n      </ul>\n    </div>\n  </ix-popup-tool-bar>\n  <div class=\"modal-header\">\n    <h3>Selección de {{$parent.$parent.col.name}}</h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"btn-toolbar\">\n          <div style=\"height: calc(100vh - 320px)\" data-ui-grid=\"gridSeleccion\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize data-ui-grid-cellNav>\n            <div class=\"grid-loading\" ng-if=\"gridSeleccion.ixIsLoading\">\n              <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"accionesToolBar.length == 0\" class=\"modal-footer\">\n    <button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$close()\"><translate>Cancelar</translate></button>\n  </div>\n</script>\n");
$templateCache.put("app/base/views/helpers_templates/ixSelectMultiple.html","<div class=\"form-group\">\n	<label class=\"col-md-4\"><translate>{{::name || pk}}</translate>\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\n    </label>\n	<div class=\"col-md-8\">\n		<ui-select multiple ng-model=\"$parent.ngModelFormatted\" ng-class=\"{ \'show-always\': editableDropdown == true }\" append-to-body=\"appendToBody\" ng-disabled=\"ngDisabled\" on-select=\"onSelectOption($item)\">\n      <ui-select-match allow-clear=\"{{ !ngRequired }}\" placeholder=\"Selecciona un registro...\" translate-attr=\"placeholder\">{{$item[desc]}} {{ (cfg.dropdownSinCodigo) ? \"\" : \"- \"+$item[pk] }}</ui-select-match>\n			<ui-select-choices repeat=\"item[pk] as item in (allItems | filter: filtrarResultados($select)) track by item[pk]\" refresh=\"refresh($select)\" refresh-delay=\"300\">\n				<div>{{::item[desc]}} <span ng-if=\"extraField\">/ {{::item[extraField]}}</span></div>\n				<div ng-class=\"{\'invisible\': cfg.dropdownSinCodigo }\" class=\"text-muted\">{{::item[pk]}}</div>\n			</ui-select-choices>\n		</ui-select>\n	</div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixText.html","<div class=\"form-group\">\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\n    	<input type=\"text\" name=\"{{::name}}\" class=\"{{ ::input1Class }}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-model=\"ngModel\" ng-class=\"{ \'input-full-width\': (ngModel2 === undefined && !input1Class), \'input-half-width\': (ngModel2 !== undefined && !input1Class), \'background-red\': redBackground }\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\" placeholder=\"{{ ngPlaceholder }}\" maxlength=\"{{::maxLength}}\" autocomplete=\"off\" ng-keydown=\"onKeydown($event)\">\n    	<input type=\"text\" name=\"{{::name}}\" class=\"{{ ::input2Class }}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-show=\"mostrarControlSecundario\" ng-model=\"ngModel2\" ng-class=\"{ \'input-half-width\': (!input2Class) }\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\" maxlength=\"{{::maxLength2}}\" autocomplete=\"off\">\n	</div>\n	<div ng-transclude></div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixTextArea.html","<div class=\"form-group\">\n	<label class=\"{{::labelClass || \'col-md-4\'}}\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" style=\"color:red\" ng-show=\"ngRequired\"></i></label>\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\n		<textarea ng-class=\"ngClass\" ng-model=\"ngModel\" style=\"width:100%\" ngrequired=\"ngRequired\" ng-disabled=\"ngDisabled\" maxlength=\"{{::maxLength}}\" rows=\"{{::rows}}\" cols=\"{{::cols}}\"></textarea>\n	</div>\n</div>\n");
$templateCache.put("app/base/views/helpers_templates/ixTime.html","<div class=\"form-group\">\n  <label ng-if=\"!withoutLabel\" class=\"col-md-4\"><translate>{{::name}}</translate><i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\n  <div ng-class=\"{ \'col-md-8\': !withoutLabel, \'col-md-12\': withoutLabel }\">\n    <!--<input time=\"text\" ng-model=\"ngModel\" ui-mask=\"99:99\" model-view-value=\"true\" ui-validate=\"{ Tiempo: \'validateTIME($value)\' }\" ngRequired=\"ngRequired\" ng-disabled=\"ngDisabled\" />-->\n		<input type=\"text\" ng-model=\"ngModel\" placeholder=\"HH:MM:SS\" ngrequired=\"ngRequired\" ng-disabled=\"ngDisabled\">\n  </div>\n</div>\n");
$templateCache.put("app/base/views/api_perfiles/api_perfilesCard.html","<strong>{{item.perfil}}</strong>\n<br>\n{{item.bd}}\n");
$templateCache.put("app/base/views/api_perfiles/api_perfilesForm.html","<div ng-controller=\"ApiPerfilesController\">\n	<ix-tool-bar></ix-tool-bar>\n	<div ng-scrollbars class=\"scrolldiv\">\n		<div class=\"scrolldiv-content\">\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\n				<fieldset>\n          <legend><ix-text ng-model=\"data.datos.perfil\" name=\"Nombre del perfil\" ng-required=\"true\"></ix-text></legend>\n					<div class=\"row\">\n						<div class=\"col-md-3\">\n							<h3><translate>Usuarios</translate></h3>\n							<ul class=\"list-group\">\n								<li class=\"list-group-item\" ng-repeat=\"u in data.datos.perfilesusuario\">\n									{{u}}<span style=\"margin-left:11px\" ng-click=\"deleteUser(u)\" uib-tooltip=\"{{ \'Quitar\' | translate }} {{u}}\" tooltip-append-to-body=\"true\">&times;</span>\n								</li>\n								<li class=\"list-group-item\" ng-show=\"status.editing\">\n									<input type=\"text\" class=\"form-control\" placeholder=\"añadir usuario\" ng-model=\"newUser\" uib-typeahead=\"u for u in allUsers | filter:$viewValue\" typeahead-editable=\"false\" typeahead-min-length=\"0\" typeahead-on-select=\"onSelectNewUser($item);newUser=undefined\" typeahead-focus-on-select=\"false\" typeahead-append-to-body=\"true\">\n								</li>\n							</ul>\n						</div>						\n						<div class=\"col-md-3\">\n							<h3><translate>Tipos Permisos</translate></h3>\n							<ul class=\"list-group\" ng-if=\"data.datos\">\n								<li class=\"list-group-item\">\n									Ventas\n									<div class=\"checkbox pull-right\" abm-checkbox>\n										<input type=\"checkbox\" ng-model=\"data.datos.es_ventas\" class=\"pull-right\" ng-disabled=\"!status.editing\">\n									</div>\n								</li>\n								<li class=\"list-group-item\">\n									Costes\n									<div class=\"checkbox pull-right\" abm-checkbox>\n										<input type=\"checkbox\" ng-model=\"data.datos.es_costes\" class=\"pull-right\" ng-disabled=\"!status.editing\">\n									</div>\n								</li>\n								<li class=\"list-group-item\">\n									Tarifas Ventas\n									<div class=\"checkbox pull-right\" abm-checkbox>\n										<input type=\"checkbox\" ng-model=\"data.datos.es_tarifas_ventas\" class=\"pull-right\" ng-disabled=\"!status.editing\">\n									</div>\n								</li>\n								<li class=\"list-group-item\">\n									Tarifas Compras\n									<div class=\"checkbox pull-right\" abm-checkbox>\n										<input type=\"checkbox\" ng-model=\"data.datos.es_tarifas_costes\" class=\"pull-right\" ng-disabled=\"!status.editing\">\n									</div>\n								</li>\n								<li class=\"list-group-item\">\n									Administar Usuarios\n									<div class=\"checkbox pull-right\" abm-checkbox>\n										<input type=\"checkbox\" ng-model=\"data.datos.es_admin_users\" class=\"pull-right\" ng-disabled=\"!status.editing\">\n									</div>\n								</li>\n								<!-- <li class=\"list-group-item\">\n									Ixnet\n									<div class=\"checkbox pull-right\" abm-checkbox>\n										<input type=\"checkbox\" ng-model=\"data.datos.es_ixnet\" class=\"pull-right\" ng-disabled=\"!status.editing\">\n									</div>\n								</li> -->\n							</ul>\n						</div>\n						<style>\n							.liMenu:hover {\n								background-color: grey;\n								color: #262626;\n							}\n							.liMenu {\n								display: flex;\n								align-items: center; \n								justify-content: space-between; \n							}\n							.chkMenu {\n								display: flex;\n								align-items: center;\n							}\n						</style>\n						<div class=\"col-md-6\">\n							<h3><translate>Menús</translate></h3>\n							<input type=\"text\" ng-model=\"searchText\" placeholder=\"Buscar menú...\" class=\"form-control\">\n							<ul class=\"list-group\">\n								<li class=\"list-group-item liMenu\" ng-repeat=\"(key,menu) in data.menuItems | filter: searchText\">\n									{{menu.path}}/{{menu.node.display}}\n									<div class=\"checkbox pull-right chkMenu\" abm-checkbox>                    \n										<input type=\"checkbox\" ng-model=\"menu.checked\" class=\"pull-right\" ng-disabled=\"!status.editing\">\n									</div>\n								</li>\n							</ul>\n						</div>\n					</div>\n				</fieldset>\n			</form>\n		</div>\n  </div>\n</div>\n");
$templateCache.put("app/base/views/controls/editbuttons.html","	<span uib-dropdown ng-show=\"form.$invalid\">\n		<a uib-dropdown-toggle><i class=\"fa fa-bell\"></i><span class=\"badge\">{{length(form.$error)}}</span></a>\n		<ul uib-dropdown-menu>\n			<li ng-repeat=\"(k,v) in form.$error\">\n				<a class=\"alert-callout alert-warning\" ng-click=\"setFocus(v[0].$name)\">\n					<i class=\"fa fa-exclamation-triangle\"></i> <strong>{{k}}</strong><br>\n					<small ng-repeat=\"vv in v\">{{vv.$name}}&nbsp;</small>\n				</a>\n			</li>\n		</ul>\n	</span>\n	<a data-ng-show=\"bloqueo && !editing\"><i class=\"fa fa-lock\"></i> Registro bloqueado por <strong>{{bloqueo.user.name}}</strong> a las {{bloqueo.ts | date:\'HH:mm:ss\'}}h </a>\n	<div class=\"alertbox alert alert-warning\" role=\"alert\" ng-show=\"response.status==-1 || response.status>=400 || (response.data.Result)\">\n		<a class=\"close\" aria-label=\"close\">&times;</a>\n		<div ng-show=\"response.status==-1\">\n			<i class=\"fa fa-exclamation-triangle\"></i> Error <strong>OPTIONS</strong>\n		</div>\n		<div ng-show=\"response.status>=400\">\n			<i class=\"fa fa-exclamation-triangle\"></i> <strong>Error {{response.status}}</strong>: {{respose.statusText}} {{response.data.Message}}\n		</div>\n		<div ng-show=\"response.data.Result\">\n			<i class=\"fa fa-info-circle\"></i> {{response.data.ErrorMessage}}\n		</div>\n		<div ng-show=\"response.data.Result==false\">\n			<i class=\"fa fa-exclamation-triangle\"></i> {{response.data.GlobalMessage.Msg}}\n			<div ng-repeat=\"item in response.data.Deleted\">\n				<div ng-repeat=\"error in item.Errors\">\n					<i class=\"fa fa-exclamation-triangle\"></i> <strong>Error Deleting</strong>: {{error.Msg}}\n				</div>\n			</div>\n			<div ng-repeat=\"item in response.data.Updated\">\n				<div ng-repeat=\"error in item.Errors\">\n					<i class=\"fa fa-exclamation-triangle\"></i> <strong>Error Updating</strong>: {{error.Msg}}\n				</div>\n			</div>\n			<div ng-repeat=\"item in response.data.Inserted\">\n				<div ng-repeat=\"error in item.Errors\">\n					<i class=\"fa fa-exclamation-triangle\"></i> <strong>Error Inserting</strong>: {{error.Msg}}\n				</div>\n			</div>\n		</div>\n	</div>\n\n\n\n	<a class=\"btn btn-primary pull-right\" data-ng-show=\"!incidencias\" ng-click=\"openModal(\'incidencia.html\')\"><i class=\"fa fa-plus\"></i> Incidencia</a>\n	<a class=\"btn btn-warning pull-right\" data-ng-show=\"incidencias\" ng-click=\"openModal(\'incidencia.html\')\"><i class=\"fa fa-exclamation-circle\"></i> Incidencia <span class=\"badge\">{{incidencias.length}}</span></a>\n	<div uib-dropdown class=\"pull-right\">\n		<a uib-dropdown-toggle class=\"btn btn-default\"><i class=\"fa fa-print\"></i> Impresos <span class=\"caret\"></span></a>\n		<ul uib-dropdown-menu>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-excel-o\"></i> Excel</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-pdf-o\"></i> Pdf</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-clipboard\"></i> Copiar</a></li>\n		</ul>\n	</div>\n	<div uib-dropdown class=\"pull-right\">\n		<a uib-dropdown-toggle class=\"btn btn-default\"><i class=\"fa fa-bolt\"></i> Acciones <span class=\"caret\"></span></a>\n		<ul uib-dropdown-menu>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-truck\"></i> Acción Una</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-user-plus\"></i> Acción dos</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-venus-mars\"></i> Acción tres</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-user-secret\"></i> Acción cuatro</a></li>\n		</ul>\n	</div>\n	<a class=\"btn btn-warning pull-right\" role=\"button\" data-ng-show=\"!editing && bloqueo\" data-ng-click=\"desbloquear()\"><i class=\"fa fa-unlock\"></i> Desbloquear</a>\n	<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"!editing\" href=\"javascript:history.back()\"><i class=\"fa fa-undo\"></i> Volver</a>\n	<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"!editing\" data-ng-click=\"editar()\" data-ng-disabled=\"{{bloqueo}}\"><i class=\"fa fa-pencil\"></i> Editar</a>\n	<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"editing\" data-ng-click=\"cancelEdit()\"><i class=\"fa fa-times\"></i> Cancelar</a>\n	<a class=\"btn btn-success pull-right\" role=\"button\" data-ng-show=\"editing\" data-ng-click=\"guardar()\"><i class=\"fa fa-floppy-o\"></i> Guardar</a>\n\n\n	<script type=\"text/ng-template\" id=\"incidencia.html\">\n		<h1>Incidencias <small>{{$root.currentApp.name}}</small></h1>\n		<div data-ng-repeat=\"i in incidencias track by $index\">\n			<div data-ng-bind-html=\"i.text\" style=\"padding: 10px 0\"></div>\n			<small class=\"pull-right\">reported by <strong>{{i.user.name}}</strong> {{i.time | timeago}}</small>\n		</div>\n		<div>\n			<div data-text-angular data-ng-model=\"newIncidencia.text\" style=\"padding: 10px 0\"></div>\n			<button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"addIncidencia()\"><i class=\"fa fa-plus\"></i> añadir</button>\n		</div>\n	</script>\n\n");
$templateCache.put("app/base/views/controls/formerrors.html","	<div class=\"alert alert-warning alert-dismissible\" role=\"alert\">\n		<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\n			<span aria-hidden=\"true\">&times;</span>\n		</button>\n		<div ng-repeat=\"error in form.$error\">\n			<strong>Warning!</strong> Better check yourself, you\'re not looking too good.\n		</div>\n	</div>\n	errors\n");
$templateCache.put("app/base/views/controls/grideditable.html","<div class=\"btn-toolbar\">\n	<div class=\"pull-left\" ng-show=\"editing\">\n		{{gridApi.rowEdit.getDirtyRows().length}} filas modificadas\n		{{deletedRows.length}} filas eliminadas\n		{{insertedRows.length}} filas creadas\n		{{gridApi.selection.getSelectedRows().length}} filas seleccionadas\n	</div>\n	<a class=\"btn btn-default pull-right\" role=\"button\" onclick=\"maximizeGrid(this, event)\" uib-tooltip=\"Maximize/minimize grid\"><i class=\"fa fa-arrows-alt\"></i></a>\n	<div uib-dropdown class=\"pull-right\">\n		<a uib-dropdown-toggle class=\"btn btn-default\"><i class=\"fa fa-cogs\"></i> <span class=\"caret\"></span></a>\n		<ul uib-dropdown-menu>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" data-ng-click=\"savePreferences()\"><i class=\"fa fa-floppy-o\"></i> Guardar preferencias de visualización</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" data-ng-click=\"restorePreferences()\"><i class=\"fa fa-undo\"></i> Restaurar preferencias de visualización</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-wrench\"></i> Predefinir para todos los usuarios (admin)</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-trash-o\"></i> Eiminar settings de todos los usuarios (admin)</a></li>\n		</ul>\n	</div>\n	<a class=\"btn btn-default pull-right\" ng-class=\"gridOptions.enableFiltering?\'active\':\'\'\" role=\"button\" data-ng-click=\"toggleFiltering()\" uib-tooltip=\"togle filter\"><i class=\"fa fa-filter\"></i></a>\n	<a class=\"btn btn-default pull-right\" role=\"button\" data-ng-click=\"downloadCSV()\" uib-tooltip=\"Download grid data as CSV\"><i class=\"fa fa-file-excel-o\"></i></a>\n	<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"editing\" data-ng-disabled=\"gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows()\" uib-tooltip=\"Delete selected items\"><i class=\"fa fa-trash-o\"></i></a>\n	<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"editing\" data-ng-click=\"addRow()\" uib-tooltip=\"Add new item\"><i class=\"fa fa-plus\"></i></a>\n\n</div>\n<div style=\"height:400px\" data-ui-grid=\"gridOptions\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize></div>\n");
$templateCache.put("app/base/views/controls/listbuttons.html","	<div class=\"alert alert-warning pull-left\" role=\"alert\" ng-show=\"response\">\n		<i class=\"fa fa-exclamation-triangle\"></i> <strong>Error {{response.status}}</strong>: {{respose.statusText}} {{response.data.Message}} ({{response}})\n	</div>\n\n	<a class=\"btn btn-warning pull-right\"><i class=\"fa fa-print\"></i> Imprimir</a>\n	<div class=\"dropdown pull-right\">			<!-- aquest bootstrap dropdown crec que no es fa servir -->\n		<a class=\"btn btn-default dropdown-toggle\" role=\"button\" data-toggle=\"dropdown\"><i class=\"fa fa-download\"></i> Exportar <span class=\"caret\"></span></a>\n		<ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dropdownMenu1\">\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-excel-o\"></i> Excel</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-file-pdf-o\"></i> Pdf</a></li>\n			<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-clipboard\"></i> Copiar al portapapeles</a></li>\n		</ul>\n	</div>\n	<a class=\"btn btn-danger pull-right\" role=\"button\" href=\"javascript:history.back()\"><i class=\"fa fa-undo\"></i> Volver</a>\n	<a class=\"btn btn-success pull-right\" role=\"button\" data-ng-href=\"{{entity}}\"><i class=\"fa fa-plus\"></i> Nuevo </a>\n\n");
$templateCache.put("app/base/views/helpers_templates/biotecnal/ixCestaVehiculosModal.html","<div class=\"modal-header\">\r\n  <h3>Cesta Informes</h3>\r\n</div>\r\n<div class=\"modal-body\">\r\n<div class=\"row\">\r\n  <ix-text-area ng-class=\"inputcestaVehiculos\" ng-model=\"$parent.vehiculos\" name=\"Numeros de {{ $parent.campo }}\"></ix-text-area>\r\n</div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n<button id=\"cancelFilter\" class=\"btn btn-danger pull-left\" ng-click=\"vaciarCesta()\">Vaciar</button>\r\n\r\n<button id=\"applyFilter\" class=\"btn btn-primary\" ng-click=\"$close()\">Guardar</button>\r\n<button id=\"cancelFilter\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cerrar</button>\r\n</div>\r\n");}]);
angular.module("FTBaseApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/FTBase/Contratos/detalles_contrato_ft.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Editar contrato\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n              <ix-text ng-model=\"contrato.ncontrato\" name=\"Núm. Contrato\" ng-required=\"true\"></ix-text>\r\n              <ix-date ng-model=\"contrato.fecha\" name=\"Fecha\" ng-disabled=\"!status.editing\"></ix-date>\r\n              <ix-text ng-model=\"contrato.numfactura\" name=\"Núm. Factura\"></ix-text>\r\n              <ix-text ng-model=\"contrato.concepto\" name=\"Concepto\"></ix-text>\r\n              <ix-options-si-no ng-model=\"contrato.mantenimiento\" name=\"Mantenimiento\"></ix-options-si-no>\r\n              <ix-text ng-model=\"contrato.coste_ft\" name=\"Coste por ficha técnica\" ix-number></ix-text>\r\n              <ix-options-si-no ng-model=\"contrato.pagado\" name=\"Pagado\"></ix-options-si-no>\r\n            </div>\r\n            <div class=\"col-md-6\">\r\n              <ix-text ng-model=\"contrato.nrevision\" name=\"Núm. revisión\" ix-number></ix-text>\r\n              <ix-select ng-model=\"contrato.proveedor\" name=\"Proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"contrato.cod_cli_fact\" name=\"Codigo cliente facturacion\"></ix-text>\r\n              <ix-options-si-no ng-model=\"contrato.aceptado\" name=\"Aceptado\"></ix-options-si-no>\r\n              <ix-text ng-model=\"contrato.coste_mantenimiento\" name=\"Coste mantenimiento\" ix-number></ix-text>\r\n              <ix-text ng-model=\"contrato.iva\" name=\"IVA\" ix-number></ix-text>\r\n              <ix-date ng-model=\"contrato.fechapago\" name=\"Fecha de pago\" ng-disabled=\"!status.editing\"></ix-date>\r\n            </div>\r\n          </div>\r\n          <hr>\r\n          <div style=\"width:100%\">\r\n            <div class=\"pull-left\">\r\n              <ix-select ng-model=\"ft_add\" name=\"Seleccionar FT\" pk=\"id\" desc=\"id\" load-function=\"loadFt\" on-select=\"loadDetFt\" append-to-body=\"true\"></ix-select>\r\n            </div>\r\n            <div class=\"btn-toolbar\">\r\n							<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridFt.ixIsLoading\" data-ng-disabled=\"data.gridFt.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFt)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n							<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridFt.ixIsLoading\" data-ng-click=\"addRow(data.gridFt)\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n						</div>\r\n						<div data-ui-grid=\"data.gridFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows>\r\n							<div class=\"grid-loading\" ng-if=\"data.gridFt.ixIsLoading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/GestionFichasTecnicasCard.html","<style>\r\n	.listEditResult {\r\n    border-bottom: none;\r\n    padding: inherit;\r\n	}\r\n</style>\r\n<div class=\"row\" style=\"position:relative;padding: 10px 30px;border-bottom: 1px solid #e5e5e5\">\r\n	<div class=\"col-md-1\">\r\n		<span><i class=\"fa fa-{{item.icono}} icono-ficha-tecnica\"></i></span>\r\n	</div>\r\n	<div class=\"col-md-9\">\r\n		<div class=\"table\">\r\n			<div class=\"table-row\">\r\n				<div class=\"table-cell\" style=\"width: 36px\">\r\n					<span ng-show=\"item.nivel1\"><strong>{{ item.nivel1 }}<span ng-show=\"item.nivel2\">.{{ item.nivel2 }}<span ng-show=\"item.nivel3\">.{{ item.nivel3 }}</span></span> -</strong></span>\r\n				</div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"!item.nivel2\"><strong class=\"uppercase\">{{item.titulo1}}</strong></span>\r\n					<span ng-if=\"item.nivel2\"><strong class=\"uppercase\">{{item.titulo2}}</strong></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"table-row\">\r\n				<div class=\"table-cell\"></div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"!item.nivel2 && (item.titulo2 || item.titulo2_valor)\"><strong>{{ item.titulo2 }}</strong>{{item.titulo2_valor}}<br></span>\r\n					<span ng-if=\"item.titulo3 || item.titulo3_valor\"><strong>{{ item.titulo3 }}</strong>{{item.titulo3_valor}}<br></span>\r\n					<span ng-if=\"item.icono == \'home\' && (item.titulo4 || item.titulo4_valor)\"><strong>{{ item.titulo4 }}</strong>{{item.titulo4_valor}}%<br></span>\r\n					<span ng-if=\"item.icono != \'home\' && (item.titulo4 || item.titulo4_valor)\"><strong>{{ item.titulo4 }}</strong>{{item.titulo4_valor}} de {{item.titulo4_valor2}}<br></span>\r\n					<span ng-if=\"item.icono == \'home\' && (item.titulo5 || item.titulo5_valor)\"><strong>{{ item.titulo5 }}</strong>{{item.titulo5_valor}}%<br></span>\r\n					<span ng-if=\"item.icono != \'home\' && (item.titulo5 || item.titulo5_valor)\"><strong>{{ item.titulo5 }}</strong>{{item.titulo5_valor}}<br></span>\r\n					<span ng-if=\"item.titulo6 || item.titulo6_valor\"><strong>{{ item.titulo6 }}</strong>{{item.titulo6_valor}}<br></span>\r\n				</div>\r\n			</div>\r\n			<!--<div class=\"table-row\">\r\n				<div class=\"table-cell\"></div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"item.nivel2nombre\">Preguntas: {{item.nc_preguntas}}/{{item.nt_preguntas}}<br/></span>\r\n				</div>\r\n			</div>-->\r\n		</div>\r\n	</div>\r\n	<div class=\"col-md-2\" style=\"height: 100%;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0\">\r\n		<div class=\"table\" style=\"top:25%; position:relative\">\r\n			<div class=\"table-row\">\r\n				<!-- <div class=\"table-cell\">\r\n					<span><i class=\"fa fa-{{item.icono_cabecera}} icono-ficha-tecnica\"></i></span>\r\n				</div> -->\r\n				<div class=\"table-cell\" ng-if=\"item.nivel1 || item.icono == \'home\' || item.icono == \'industry\' || item.icono == \'paperclip\'\">\r\n					<!-- Solo se verá con un perfil de biotecnal, además, los botones tendrán enlazada una función ng-click -->\r\n					<span ng-show=\"tienePerfilAdmin() && !item.bloqueado\" ng-click=\"bloquearPreguntas($event,item,1)\"><i class=\"material-icons icono-ficha-tecnica\">lock_open</i></span>\r\n					<span ng-show=\"tienePerfilAdmin() && item.bloqueado\" ng-click=\"bloquearPreguntas($event,item,0)\"><i class=\"material-icons icono-ficha-tecnica\">lock</i></span>\r\n				</div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"item.alarma\"><i style=\"color: red\" class=\"material-icons icono-ficha-tecnica alarma\" title=\"{{item.alarma_info}}\">warning</i></span>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>\r\n<div class=\"listEditResult detalles\" ng-repeat=\"item in item.subniveles\" style=\"padding: 0px 0px 0px 10px\" ng-style=\"{\'background-color\':item.color}\" ng-click=\"selectItem(item, $event);$event.stopPropagation();\" ng-show=\"!item.ToDelete\" ng-include=\"module + entity+\'/\'+entity+\'Card.html\'\" ng-class=\"{\'bg-info\':angular.equals(item,current) || (data.datos[data.pk] && (data.datos[data.pk] == item[data.pk] || data.datos[data.pk] == item[data.listpk])), \'recordDisabled\': (item.activo == 0 || item.estado == 0), \'visible\': (item.visible), \'error-tarjeta\': (item.error) }\"></div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/GestionFichasTecnicasForm.html","<style>\r\n\r\n	.ui-grid-row{\r\n		height: auto!important;\r\n		min-height:39px\r\n	}\r\n\r\n	.ui-grid-render-container-body .ui-grid-viewport {\r\n/*		height: auto !important;*/\r\n		min-height:70px;\r\n	}\r\n\r\n	.ui-grid-row   > div {\r\n		display: table-row;\r\n\r\n	}\r\n\r\n	.ui-grid-row > div .ui-grid-cell {\r\n		display: table-cell;\r\n		float: none;\r\n		vertical-align: middle;\r\n		/*height: auto!important;*/\r\n		min-height:40px;\r\n	}\r\n\r\n	.ui-grid-cell-contents{\r\n		line-height: 16px !important;\r\n		white-space: normal;\r\n		text-overflow: inherit;\r\n		word-break: break-word;\r\n	}\r\n\r\n	.ui-grid-cell-contents .ui-select-match-item span {\r\n		white-space: normal !important;\r\n	}\r\n\r\n\r\n	.ui-grid-draggable-row {\r\n		height: inherit !important;\r\n	}\r\n\r\n	.ui-grid-draggable-row > div.ui-grid-row-header-cell {\r\n		height: inherit !important;\r\n	}\r\n\r\n	.ui-grid-cell-contents.ui-grid-disable-selection {\r\n		height: 38px !important;\r\n	}\r\n\r\n</style>\r\n<div ng-controller=\"GestionFichasTecnicasController\">\r\n	<ix-tool-bar>\r\n		<div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"Más acciones\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\" ng-show=\"!extranetUser.laboratorio\">\r\n        Acciones <span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-show=\"(!extranetUser.laboratorio && !extranetUser.proveedor && !extranetUser.cliente && !pantallaBasePorProducto())\" ng-click=\"versionarFt()\"><a>Versionar ficha técnica</a></li>\r\n        <li role=\"menuitem\" ng-show=\"!tienePerfilRestringido()\" ng-click=\"duplicarFt(2)\"><a>Duplicar niveles</a></li>\r\n        <li role=\"menuitem\" ng-show=\"!tienePerfilRestringido()\" ng-click=\"duplicarFt(0)\"><a>Duplicar ficha técnica</a></li>\r\n		<hr ng-show=\"!tienePerfilRestringido()\">\r\n		<li role=\"menuitem\" ng-click=\"imprimirFt(\'PDF\',0)\"><a>Imprimir ficha ténica PDF</a></li>\r\n        <li role=\"menuitem\" ng-click=\"imprimirFt(\'PDF\',1)\"><a>Imprimir ficha ténica reducida PDF</a></li>\r\n        <li role=\"menuitem\" ng-click=\"imprimirFt(\'MSWORD\',0)\" ng-show=\"!extranetUser.laboratorio\"><a>Imprimir ficha ténica word</a></li>\r\n		<li role=\"menuitem\" ng-click=\"imprimirFt(\'MSWORD\',1)\" ng-show=\"!extranetUser.laboratorio\"><a>Imprimir ficha técnica reducida word</a></li>\r\n		<li role=\"menuitem\" ng-click=\"imprimirFtRevision()\" ng-show=\"permiteImprimirFtRevision()\"><a>Imprimir ficha revisión</a></li>\r\n		<li role=\"menuitem\" ng-click=\"control_errores_transformacion()\" ng-show=\"permiteControlTransformacion()\"><a>Controlar errores transformacion</a></li>\r\n		<hr ng-show=\"data.modoTraduccion\">\r\n		<!-- <li role=\"menuitem\" ng-show=\"tienePerfilAdmin() && data.modoTraduccion && data.datos.estado_traduccion != \'P\'\" ng-click=\"cambioEstadoTraduccion(\'P\')\"><a>Volver traducción a pendiente</a></li>\r\n		<li role=\"menuitem\" ng-show=\"tienePerfilAdmin() && data.modoTraduccion && data.datos.estado_traduccion == \'C\'\" ng-click=\"cambioEstadoTraduccion(\'V\')\"><a>Validar traducción</a></li> -->\r\n		<li role=\"menuitem\" ng-click=\"soloPreguntasPdt()\" ng-show=\"data.modoTraduccion\"><a><translate>Ver solo preguntas pendientes de traducir</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"soloCardsPdt()\" ng-show=\"data.modoTraduccion\"><a><translate>Ver solo tarjetas pendientes de traducir</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"verTodasCards()\" ng-show=\"data.modoTraduccion\"><a><translate>Ver todo</translate></a></li>\r\n      </ul>\r\n    </div>\r\n\r\n		<button class=\"btn pull-right\" ng-click=\"selectNextPage()\" uib-tooltip=\"Siguiente\" ng-disabled=\"isLast()\" tooltip-placement=\"bottom\"><i class=\"fa fa-arrow-right\"></i> <translate class=\"ng-scope\">Siguiente</translate></button>\r\n\r\n		<button class=\"btn pull-right\" ng-click=\"selectPreviousPage()\" uib-tooltip=\"Anterior\" ng-disabled=\"isFirst()\" tooltip-placement=\"bottom\"><i class=\"fa fa-arrow-left\"></i> <translate class=\"ng-scope\">Anterior</translate></button>\r\n		<button class=\"btn pull-right\" ng-show=\"!tienePerfilRestringido() && data.datos.ft_cabecera.estado == \'O\' && !data.modoTraduccion\" ng-click=\"confirmarCumplimentacion()\" uib-tooltip=\"Finalizar cumplimentación\" tooltip-placement=\"bottom\"><i class=\"fa fa-check\"></i> <translate class=\"ng-scope\">Finalizar</translate></button>\r\n		<!-- <button class=\"btn pull-right\" ng-show=\"data.modoTraduccion && data.datos.estado_traduccion == \'P\'\" ng-click=\"cambioEstadoTraduccion(\'C\')\" uib-tooltip=\"Finalizar traducción\"  tooltip-placement=\"bottom\"><i class=\"fa fa-check\"></i> <translate class=\"ng-scope\">Finalizar traducción</translate></button> -->\r\n	</ix-tool-bar>\r\n\r\n	<div ng-scrollbars ng-scrollbars-config=\"scrollBarConfig\" class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-class=\"{ \'multi-ft\': data.id_fichas_tecnicas }\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<uib-tabset ng-if=\"data.id_fichas_tecnicas\" class=\"ix-tabs multi-ft no-margin-bottom\" active=\"data.activeTabFichaTecnica\">\r\n					<uib-tab ng-repeat=\"ficha_tecnica in data.id_fichas_tecnicas track by $index\" index=\"$index\" heading=\"{{ ficha_tecnica }}\" translate-attr=\"heading\" select=\"cambiarFicha(ficha_tecnica, $index)\">\r\n					</uib-tab>\r\n				</uib-tabset>\r\n\r\n				<!-- Si la tarjeta es de tipo Cabecera-->\r\n				<div ng-if=\"data.pantalla == \'cabecera\'\">\r\n					<div class=\"row\">\r\n						<ix-select ng-if=\"data.modoTraduccion\" ng-model=\"data.datos.estado_traduccion\" name=\"Estado traducción\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadEstadosTraduccion\" append-to-body=\"true\" ng-disabled=\"!status.editing\"></ix-select>\r\n						<ix-select ng-model=\"data.datos.ft_cabecera.departamento\" name=\"Mercado\" entity=\"departamentos\" pk=\"codigo\" desc=\"descripcion\" append-to-body=\"true\" ng-disabled=\"!status.editing || tieneCabeceraRestringida()\" ng-show=\"cfg.appCliente == \'ALCAMPO\'\"></ix-select>\r\n						<!-- <ix-select ng-if=\"data.modoTraduccion && data.datos.traducir_completa == 1\" ng-model=\"data.datos.estado_traduccion\" name=\"Estado traducción\" entity=\"ft_estados_traduccion\" pk=\"codigo\" desc=\"descripcion\" loadFunction=\"loadEstadosTraduccion()\" conditions=\"[{ field: \'codigo\', value: \'V\', op: \'0\', not: true }]\" append-to-body=\"true\" ng-disabled=\"!status.editing\"></ix-select> -->\r\n						<!-- <ix-select ng-show=\"data.modoTraduccion && data.datos.traducir_completa == 0\" ng-model=\"data.datos.estado_traduccion\" name=\"Estado traducción\" entity=\"ft_estados_traduccion\" pk=\"codigo\" desc=\"descripcion\" conditions=\"[{ field: \'codigo\', value: \'W\', op: \'0\', not: true }]\" append-to-body=\"true\" ng-disabled=\"!status.editing\"></ix-select> -->\r\n						<div ng-show=\"tienePerfilAdmin()\">\r\n							<ix-select ng-model=\"data.datos.ft_cabecera.revisor_FT\" name=\"Revisor FT\" entity=\"usuarios_RevisorVM\" pk=\"usuario\" desc=\"user_nombre\" append-to-body=\"true\" ng-disabled=\"!status.editing\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select>\r\n						</div>\r\n						<ix-text ng-model=\"data.datos.ft_cabecera.titulo\" name=\"Título\" ng-disabled=\"!status.editing || tieneCabeceraRestringida()\"></ix-text>\r\n						<ix-date ng-model=\"data.datos.ft_cabecera.fecha\" name=\"Fecha creación\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-date>\r\n						<ix-select ng-model=\"data.datos.ft_cabecera.proveedor\" name=\"Proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\" on-select=\"marcarRecargaFicherosProveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" append-to-body=\"true\"></ix-select>\r\n						<ix-select ng-model=\"data.datos.ft_cabecera.cliente\" name=\"Cliente Master\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" append-to-body=\"true\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-select>\r\n						<!--<ix-select-multiple ng-model=\"data.datos.ft_cabecera.clientesasociados\" name=\"Clientes asociados\" pk=\"codigo\" desc=\"nombre\" load-function=\"loadClientes\" append-to-body=\"true\" ng-disabled=\"!status.editing\" ix-focus-out=\"ixGuardar\"></ix-select-multiple>-->\r\n						<ix-select ng-if=\"data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.ft_version\" name=\"Tipo\" entity=\"ft_versiones_idioma\" pk=\"version\" desc=\"nombre\" append-to-body=\"true\" ng-disabled=\"true\"></ix-select>\r\n						<ix-select ng-if=\"!data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.ft_version\" name=\"Tipo\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" append-to-body=\"true\" ng-disabled=\"true\"></ix-select>\r\n						<ix-text ng-model=\"data.datos.ft_cabecera.familia\" name=\"Familia\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.ft_cabecera.ft_componentes\" name=\"Componentes\" ng-disabled=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.ft_cabecera.comentarios\" name=\"Comentarios\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-text>\r\n						<ix-select ng-show=\"!data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.estado\" name=\"Estado\" entity=\"ft_estados\" pk=\"codigo\" desc=\"descripcion\" append-to-body=\"true\" ng-disabled=\"!status.editing || tieneCabeceraRestringida()\"></ix-select>\r\n						<ix-select ng-show=\"data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.estado\" name=\"Estado\" entity=\"ft_estados_idioma\" pk=\"codigo\" desc=\"descripcion\" append-to-body=\"true\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-select>\r\n						<ix-text ng-model=\"data.datos.ft_cabecera.tiempo_cumplimentacion\" name=\"Días para cumplimentar FT\" ix-number ng-show=\"(!extranetUser.laboratorio && !extranetUser.proveedor && !extranetUser.cliente) || (extranetUser.cliente == 1031)\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-text>\r\n						<ix-date ng-model=\"data.datos.ft_cabecera.fecha_aprobada\" name=\"Fecha aprobación\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-date>\r\n						<ix-date ng-model=\"data.datos.ft_cabecera.fecha_revision\" name=\"Fecha revisión\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-date>\r\n						<ix-date ng-model=\"data.datos.ft_cabecera.fecha_baja\" name=\"Fecha baja\" ng-disabled=\"true\"></ix-date>\r\n						<ix-options-si-no ng-if=\"tienePerfilAdmin() && !data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.traducible\" name=\"Traducible\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n						<ix-options-si-no ng-if=\"!data.modoTraduccion\" ng-model=\"data.datos.traducir_completa\" name=\"Traducir completa\" ng-disabled=\"!tienePerfilAdmin() || (!status.editing && tienePerfilAdmin())\"></ix-options-si-no>\r\n					</div>\r\n					<div class=\"row\" style=\"border: 2px solid red\" ng-if=\"!data.modoTraduccion && (tienePerfilAdmin() || extranetUser.proveedor) && false\">\r\n						<div class=\"col-md-8\">\r\n							<p><translate>Nota compromiso proveedor</translate></p>\r\n						</div>\r\n						<div class=\"col-md-4\">\r\n							<ix-options-si-no ng-model=\"data.datos.ft_cabecera.aceptacion_compromiso_proveedor\" name=\"Aceptado\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n						</div>\r\n					</div>\r\n					<br ng-if=\"!data.modoTraduccion && (tienePerfilAdmin() || extranetUser.proveedor)\">\r\n					<div class=\"row\" ng-if=\"tienePerfilAdmin() && !data.modoTraduccion\">\r\n						<div class=\"col-md-3\">\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.revision_inicial\" name=\"Revisión inicial\" ng-disabled=\"!status.editing\"></ix-date>\r\n						</div>\r\n						<div class=\"col-md-3\">\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.revision_final\" name=\"Revisión final\" ng-disabled=\"!status.editing\"></ix-date>\r\n						</div>\r\n						<div class=\"col-md-3\">\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.notificacion_proveedor\" name=\"Notificación proveedor\" ng-disabled=\"!status.editing\"></ix-date>\r\n						</div>\r\n						<div class=\"col-md-3\">\r\n							<ix-select ng-model=\"data.datos.ft_cabecera.revision_etiquetado\" name=\"Revisión etiquetado\" pk=\"descripcion\" desc=\"descripcion\" load-function=\"loadRevisionEtiquetado\" append-to-body=\"true\" ng-disabled=\"!status.editing\"></ix-select>\r\n						</div>\r\n					</div>\r\n					<div style=\"width:100%\" ng-if=\"data.gridProductosFT\">\r\n						<div class=\"btn-toolbar\">\r\n							<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridProductosFT.ixIsLoading && !tieneCabeceraRestringida() && !data.modoTraduccion\" data-ng-disabled=\"data.gridProductosFT.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridProductosFT)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n							<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridProductosFT.ixIsLoading && !tieneCabeceraRestringida() && !data.modoTraduccion\" data-ng-click=\"addRow(data.gridProductosFT)\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n						</div>\r\n						<div data-ui-grid=\"data.gridProductosFT\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows>\r\n							<div class=\"grid-loading\" ng-if=\"data.gridProductosFT.ixIsLoading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n						<div class=\"pull-left\" ng-show=\"status.editing\">\r\n								{{data.gridProductosFT.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n								{{data.gridProductosFT.deletedRows.length}} filas eliminadas\r\n								{{data.gridProductosFT.insertedRows.length}} filas creadas\r\n								{{data.gridProductosFT.gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n						</div>\r\n					</div>\r\n				</div>\r\n\r\n				<!-- Si la tarjeta es de tipo Ficheros -->\r\n				<div ng-if=\"data.pantalla == \'ficheros\'\">\r\n					<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTabFicheros\">\r\n						<uib-tab index=\"0\" heading=\"Ficheros de ficha técnica\" translate-attr=\"heading\" select=\"changeTabFicheros(0)\">\r\n							<div style=\"width:100%\">\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"!data.gridFicherosFT.ixIsLoading && !tienePerfilRestringido() && data.datos.ft_cabecera.bloqueo_datos_ficheros == 0\" data-ng-disabled=\"data.gridFicherosFT.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFicherosFT, true)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"!data.gridFicherosFT.ixIsLoading && !tienePerfilRestringido() && data.datos.ft_cabecera.bloqueo_datos_ficheros == 0\" data-ng-click=\"openPopupFicheros(data.gridFicherosFT, \'ficheros_ft\')\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFicherosFT\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFicherosFT.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n								<div class=\"pull-left\" ng-show=\"status.editing\">\r\n										{{data.gridFicherosFT.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n										{{data.gridFicherosFT.deletedRows.length}} filas eliminadas\r\n										{{data.gridFicherosFT.insertedRows.length}} filas creadas\r\n										{{data.gridFicherosFT.gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n								</div>\r\n							</div>\r\n						</uib-tab>\r\n						<uib-tab index=\"1\" heading=\"Ficheros del proveedor\" translate-attr=\"heading\" select=\"changeTabFicheros(1)\">\r\n							<div style=\"width:100%\" ng-if=\"data.gridFicherosProveedor\">\r\n								<div data-ui-grid=\"data.gridFicherosProveedor\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFicherosProveedor.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n								<div class=\"pull-left\" ng-show=\"status.editing\">\r\n										{{data.gridFicherosProveedor.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n										{{data.gridFicherosProveedor.deletedRows.length}} filas eliminadas\r\n										{{data.gridFicherosProveedor.insertedRows.length}} filas creadas\r\n										{{data.gridFicherosProveedor.gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n								</div>\r\n							</div>\r\n						</uib-tab>\r\n					</uib-tabset>\r\n				</div>\r\n\r\n			<!-- Si la tarjeta es de tipo Datos Proveedor -->\r\n				<div ng-show=\"data.pantalla == \'proveedor\'\">\r\n					<div style=\"width:100%\" ng-if=\"data.gridPlantasFabricante\">\r\n						<!-- <button class=\"btn btn-primary\" ng-click=\"guardarProveedores()\">Aplicar cambios</button> -->\r\n						<button class=\"btn btn-primary\" ng-click=\"openProveedor()\">Detalles proveedor</button>\r\n						<div data-ui-grid=\"data.gridPlantasFabricante\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n							<div class=\"grid-loading\" ng-if=\"data.gridPlantasFabricante.ixIsLoading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n						<div class=\"pull-left\">\r\n								{{data.gridPlantasFabricante.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n						</div>\r\n					</div>\r\n				</div>\r\n				<div ng-show=\"data.pantalla == \'comentarios\'\">\r\n					<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTabComentarios\">\r\n						<uib-tab index=\"0\" heading=\"Comentarios\" translate-attr=\"heading\" select=\"changeTabComentarios(0)\">\r\n							<div style=\"width:100%\" ng-if=\"data.gridComentariosFt\">\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridComentariosFt.ixIsLoading && !tienePerfilRestringido()\" data-ng-disabled=\"data.gridComentariosFt.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridComentariosFt)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridComentariosFt.ixIsLoading && !tienePerfilRestringido()\" data-ng-click=\"addRowComentarioFt(data.gridComentariosFt,0)\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridComentariosFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridComentariosFt.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</div>\r\n						</uib-tab>\r\n						<uib-tab index=\"1\" heading=\"Comentarios Internos\" translate-attr=\"heading\" select=\"changeTabComentarios(1)\" ng-if=\"tienePerfilAdmin()\">\r\n							<div style=\"width:100%\" ng-if=\"data.gridComentariosInternosFt\">\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridComentariosInternosFt.ixIsLoading && !tienePerfilRestringido()\" data-ng-disabled=\"data.gridComentariosInternosFt.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridComentariosInternosFt)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridComentariosInternosFt.ixIsLoading && !tienePerfilRestringido()\" data-ng-click=\"addRowComentarioFt(data.gridComentariosInternosFt,1)\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridComentariosInternosFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridComentariosInternosFt.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</div>\r\n						</uib-tab>\r\n					</uib-tabset>\r\n				</div>\r\n				<div ng-show=\"data.pantalla == \'log\'\">\r\n					<div class=\"row\">\r\n						<!-- <div class=\"col-md-8\"></div> -->\r\n						<div class=\"col-md-12\">\r\n							<button class=\"btn btn-default\" ng-click=\"descargarExcelLog()\">Descargar Excel</button>\r\n						</div>\r\n					</div>\r\n					<div style=\"width:100%\" ng-if=\"data.gridCambioDatosFt\">\r\n						<div data-ui-grid=\"data.gridCambioDatosFt\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n							<div class=\"grid-loading\" ng-if=\"data.gridCambioDatosFt.ixIsloading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Herramientas/cambio_estado_masivo.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar></ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n          <div id=\"hot-container\" style=\"height:600px\">\r\n              <hot-table settings=\"excelsettings\" datarows=\"data.excelData\" hot-instance=\"tableInstance\">\r\n                  <hot-column ng-repeat=\"column in data.excelcolumns\" title=\"column.title\" read-only=\"!status.editing\" renderer=\"column.renderer\" width=\"column.width\" type=\"column.type\" value=\"column.value\"></hot-column>\r\n                  <hot-column ng-if=\"data.showResults\" data=\"resultado_color\" title=\"\'Resultado\'\" read-only=\"!status.editing\" width=\"60\" renderer=\"rendererColor\"></hot-column>\r\n                  <hot-column ng-if=\"data.showResults\" data=\"resultado_msg\" title=\"\'Detalles\'\" read-only=\"!status.editing\" width=\"250\"></hot-column>\r\n              </hot-table>\r\n          </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/FTBase/Herramientas/eans_cod_interno_masivo.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar></ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n          <div id=\"hot-container\" style=\"height:600px\">\r\n              <hot-table settings=\"excelsettings\" datarows=\"data.excelData\" hot-instance=\"tableInstance\">\r\n                  <hot-column ng-repeat=\"column in data.excelcolumns\" title=\"column.title\" read-only=\"!status.editing\" renderer=\"column.renderer\" width=\"column.width\" type=\"column.type\" value=\"column.value\"></hot-column>\r\n                  <hot-column ng-if=\"data.showResults\" data=\"resultado_color\" title=\"\'Resultado\'\" read-only=\"!status.editing\" width=\"60\" renderer=\"rendererColor\"></hot-column>\r\n                  <hot-column ng-if=\"data.showResults\" data=\"resultado_msg\" title=\"\'Detalles\'\" read-only=\"!status.editing\" width=\"250\"></hot-column>\r\n              </hot-table>\r\n          </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/FTBase/HomologacionPlantas/editar_auditoria_planta.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Editar datos auditoría\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <ng-form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <ix-select ng-model=\"data.proveedor\" name=\"Proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" on-select=\"limpiarPlanta\" ng-required=\"true\" ng-disabled=\"!status.editing\" append-to-body=\"true\" ng-show=\"!bPantallaProveedor\">\r\n              </ix-select>\r\n              <ix-select ng-model=\"data.datos.planta\" name=\"Planta\" entity=\"plantas\" pk=\"planta\" desc=\"nombre_planta\" load-function=\"cargarPlantasProveedor\" ng-required=\"true\" ng-disabled=\"!status.editing || !data.proveedor\" append-to-body=\"true\">\r\n              </ix-select>\r\n              <ix-select ng-model=\"data.categoria\" name=\"Categoría\" entity=\"categorias_certificaciones_proveedores\" pk=\"id\" desc=\"categoria\" ng-required=\"true\" ng-disabled=\"!status.editing\" append-to-body=\"true\">\r\n              </ix-select>\r\n              <ix-text-area ng-model=\"data.datos.alcance\" name=\"Alcance\" rows=\"5\" ng-show=\"data.categoria == 1\" ng-required=\"data.categoria == 1\"></ix-text-area>\r\n              <ix-select ng-model=\"data.datos.tipo\" name=\"Tipo\" entity=\"tipos_auditorias_plantas\" pk=\"id\" desc=\"descripcion\" conditions=\"[{field: \'categoria\',value: data.categoria}]\" on-select=\"selectTipoAuditoria\" ng-required=\"true\" ng-disabled=\"!status.editing || !data.categoria\" append-to-body=\"true\">\r\n              </ix-select>\r\n              <ix-date ng-model=\"data.datos.fecha_realizacion\" name=\"Fecha realización\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-date>\r\n              <ix-select ng-model=\"data.datos.laboratorio\" name=\"Laboratorio\" entity=\"laboratorios\" pk=\"id_laboratorio\" desc=\"nombre\" ng-required=\"!(data.datos.tipo == 7 || data.datos.tipo == 8 || data.datos.tipo == 9)\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"data.datos.resultado_auditoria\" name=\"Resultado (%)\" ix-number with-decimals=\"2\" min-value=\"0.00\" max-value=\"100.00\" ng-required=\"!(data.datos.tipo == 7 || data.datos.tipo == 8 || data.datos.tipo == 9)\"></ix-text>\r\n              <ix-text ng-model=\"data.datos.proxima_auditoria\" name=\"Próxima auditoría\" ix-number ng-required=\"!(data.datos.tipo == 7 || data.datos.tipo == 8 || data.datos.tipo == 9)\" ng-if=\"appCliente != \'ALCAMPO\'\"></ix-text>\r\n              <ix-date ng-model=\"fecha_limite\" name=\"Fecha limite\" ng-disabled=\"true\" ng-if=\"appCliente == \'ALCAMPO\'\"></ix-date>\r\n              <ix-text-area ng-model=\"data.datos.comentarios\" name=\"Comentarios\" rows=\"3\"></ix-text-area>\r\n              <ix-options-si-no ng-model=\"data.datos.verificacion\" name=\"Verificado\" ng-if=\"appCliente != \'ALCAMPO\'\"></ix-options-si-no>\r\n              <div class=\"row\" ng-if=\"data.isNew\">\r\n                <div class=\"col-md-12\">\r\n                  <div ngf-drop ngf-select ng-model=\"data.archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"!(data.datos.tipo == 7 || data.datos.tipo == 8 || data.datos.tipo == 9)\">\r\n                  <translate>Arrastrar o hacer click para adjuntar documento</translate>\r\n                  </div>\r\n                  <ul>\r\n                    <li ng-repeat=\"f in data.archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n                  </ul>\r\n                  </div>\r\n              </div>\r\n              <div class=\"row\" ng-if=\"!data.isNew\">\r\n                <h5><translate>Documentos adjuntos</translate></h5>\r\n                <hr>\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"btn-toolbar\">\r\n                    <button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"true\" ng-disabled=\"data.gridDocs.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedDocs()\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\">\r\n                      <i class=\"fa fa-trash-o\"></i>\r\n                    </button>\r\n                    <button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"true\" data-ng-click=\"addDoc()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\">\r\n                      <i class=\"fa fa-plus\"></i>\r\n                    </button>\r\n                  </div>\r\n                  <div data-ui-grid=\"data.gridDocs\" ng-if=\"data.gridDocs\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n                    <div class=\"grid-loading\" ng-if=\"data.gridDocs.ixIsLoading\">\r\n                      <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/HomologacionPlantas/listado_control_homologacion.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <button ng-if=\"data.permisoSubirCertificado\" id=\"acciones-button\" uib-tooltip=\"Crear nuevo certificado\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-disabled=\"disabled\" ng-click=\"openCertificado()\">\r\n        <i class=\"fa fa-plus\"></i> Nuevo certificado\r\n    </button>\r\n    <button id=\"acciones-button\" uib-tooltip=\"Crear nueva auditoría\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-disabled=\"disabled\" ng-click=\"openEditAuditoria()\">\r\n        <i class=\"fa fa-plus\"></i> Nueva auditoría\r\n    </button>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n      <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n        <uib-accordion close-others=\"oneAtATime\">\r\n            <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n              <fieldset class=\"form-data-filter\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-4\">\r\n                    <ix-options-si-no ng-model=\"data.filtro.vigentes\" name=\"Sólo datos vigentes\" is-filter=\"true\"></ix-options-si-no>\r\n                  </div>\r\n                  <div class=\"col-md-4\">\r\n                  </div>\r\n                  <div class=\"col-md-4\">\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n          </uib-accordion>\r\n      </form>\r\n      <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n          <div ng-if=\"data.grid_control_homologacion\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 310px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.grid_control_homologacion\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n            <div class=\"grid-loading\" ng-if=\"data.grid_control_homologacion.ixIsLoading\">\r\n                <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n            </div>\r\n          </div>\r\n      </div>\r\n      <div>\r\n          <div class=\"footer\">\r\n              <div ix-datetime-grid-generada grid=\"data.grid_control_homologacion\"></div>\r\n          </div>\r\n      </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/HomologacionPlantas/listado_resumen_homologacion.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isseleccionaropen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"Descarga de los ficheros seleccionados\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle>\r\n        Descarga Masiva<span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a>Seleccionar lineas visibles</a></li>\r\n        <li role=\"menuitem\" ng-click=\"desSeleccionarRows()\"><a>Desseleccionar todo</a></li>\r\n        <li role=\"menuItem\" ng-click=\"descargarFicherosSeleccionados()\"><a>Descargar ficheros de lineas seleccionadas</a></li>\r\n      </ul>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-options-si-no ng-model=\"data.filtro.vigentes\" name=\"Plantas activas\" is-filter=\"true\"></ix-options-si-no>\r\n              </div>\r\n              <div class=\"col-md-4\"></div>\r\n              <div class=\"col-md-4\">\r\n                <ix-options-si-no ng-model=\"data.filtro.solo_exclusivas\" name=\"Sólo FT exclusivas\" is-filter=\"true\"></ix-options-si-no>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div ng-if=\"data.grid_resumen_homologacion\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 310px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.grid_resumen_homologacion\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.grid_resumen_homologacion.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.grid_resumen_homologacion\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/busqueda_avanzada.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div ng-if=\"!ocultarSelAsociados\">\r\n      <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n        <uib-accordion close-others=\"oneAtATime\">\r\n          <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n            <fieldset class=\"form-data-filter\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4\">\r\n                  <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"Asociados\" conditions=\"[{field: \'cliente\', value: \'1000009\', not: true}]\"></ix-select-multiple>\r\n                </div>\r\n                <div class=\"col-md-4\"></div>\r\n                <div class=\"col-md-4\"></div>\r\n              </div>\r\n            </fieldset>\r\n          </div>\r\n        </uib-accordion>\r\n      </form>\r\n      </div>\r\n    <div style=\"width:100%\">\r\n      <div class=\"full-ui-grid\" data-ui-grid=\"data.gridBusqueda\" ng-style=\"{\'height\': (!ocultarSelAsociados) ? ((filterStatus.isCollapsed) ? \'calc(100vh - 300px)\' : \'calc(100vh - 220px)\') : \'calc(100vh - 160px)\' }\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridBusqueda.ixIsLoading\">\r\n					<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridBusqueda\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/carga_ficheros_ft.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isseleccionaropen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"Carga Ficheros\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        Cargar ficheros<span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a>Seleccionar lineas visibles</a></li>\r\n        <li role=\"menuitem\" ng-click=\"desSeleccionarRows()\"><a>Desseleccionar todo</a></li>\r\n        <li role=\"menuItem\" ng-click=\"guardarFichero()\"><a>Guardar</a></li>\r\n      </ul>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-show=\"status.transitionend\">\r\n\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <!-- <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6\">\r\n                <div ngf-drop ngf-select ng-model=\"archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\"\r\n                  ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                  <translate>Arrastrar o hacer click para subir archivo</translate>\r\n                </div>\r\n                <ul>\r\n                  <li ng-repeat=\"f in archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n                </ul>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n  \r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion> -->\r\n      <div class=\"panel-default\">\r\n        <fieldset>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4\">\r\n              <ix-select ng-model=\"seleccion.tipoSeleccionadoFt\" name=\"Tipo archivo\" entity=\"tipos_fichero_ft\" pk=\"id\" desc=\"descripcion\" on-select=\"tipoArchivoSeleccionado\" append-to-body=\"true\" ng-required=\"true\" load-function=\"loadTiposFicheroFT\">\r\n              </ix-select>\r\n              <ix-date ng-model=\"seleccion.inicioValidez\" name=\"Inicio validez\" ng-disabled=\"false\" append-to-body=\"true\">\r\n              </ix-date>\r\n              <ix-date ng-model=\"seleccion.fechaCaducidad\" name=\"Fecha caducidad\" ng-disabled=\"false\" append-to-body=\"true\" ng-required=\"caducidad_obligatoria\"></ix-date>\r\n            </div>\r\n            <div class=\"col-md-8\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-4\">\r\n                  <div ngf-drop ngf-select ng-model=\"seleccion.archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                    <translate>Arrastrar o hacer click para subir archivo</translate>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                  <ul>\r\n                    <li ng-repeat=\"f in seleccion.archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}\r\n                    </li>\r\n                  </ul>\r\n                  <button class=\"btn btn-danger\" ng-click=\"seleccion.archivosToUpload = null\" ng-show=\"seleccion.archivosToUpload\">Borrar</button>\r\n                </div>\r\n                <div class=\"col-md-4\"></div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n      </div>\r\n    </form>\r\n\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div ng-if=\"data.gridProductosFt\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': \'calc(100vh - 310px)\' }\" data-ui-grid=\"data.gridProductosFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridProductosFt.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridProductosFt\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/control_presencia_fotos.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar>\r\n    </ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n        <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n            <uib-accordion close-others=\"oneAtATime\">\r\n                <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n                    <fieldset class=\"form-data-filter\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-4\">\r\n                                <ix-options-si-no ng-model=\"data.filtro.ft_activas\" name=\"Visializar sólo FT activas\" is-filter=\"true\"></ix-options-si-no>\r\n                            </div>\r\n                            <div class=\"col-md-4\"></div>\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n            </uib-accordion>\r\n        </form>\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n            <div ng-if=\"data.grid_control_fotos\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 310px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.grid_control_fotos\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n                <div class=\"grid-loading\" ng-if=\"data.grid_control_fotos.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div class=\"footer\">\r\n                <div ix-datetime-grid-generada grid=\"data.grid_control_fotos\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/descarga_informes_analiticas.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar>\r\n    </ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n        <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n            <uib-accordion close-others=\"oneAtATime\">\r\n                <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Descargar informes\" is-open=\"true\" is-disabled=\"true\">\r\n                    <fieldset class=\"form-data-filter\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-4\">\r\n                                <ix-p name=\"Lista de EANs, un EAN por línea\"></ix-p>\r\n                                <br>\r\n                                <textarea ng-model=\"data.listEans\" style=\"width:100%\" rows=\"15\"></textarea>\r\n                            </div>\r\n                            <div class=\"col-md-4\">\r\n                                <ix-date ng-model=\"data.fecha_inicio\" name=\"Fecha inicio\"></ix-date>\r\n                                <ix-date ng-model=\"data.fecha_fin\" name=\"Fecha fin\"></ix-date>\r\n                            </div>\r\n                            <div class=\"col-md-4\">\r\n                                <ix-options-si-no ng-model=\"data.checkInformesEnsayo\" name=\"Informes de ensayo\">\r\n                                </ix-options-si-no>\r\n                                <ix-options-si-no ng-model=\"data.checkInformesEtiquetado\" name=\"Informes de etiquetado\">\r\n                                </ix-options-si-no>\r\n                                <ix-options-si-no ng-model=\"data.checkInformesPosicionamiento\" name=\"Informes de posicionamiento\">\r\n                                </ix-options-si-no>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-11\">\r\n                                <button class=\"btn btn-primary pull-right\" ng-click=\"descargarInformes()\">\r\n                                    <translate>Descargar informes</translate>\r\n                                </button>\r\n                            </div>\r\n                        </div>\r\n\r\n                    </fieldset>\r\n                </div>\r\n            </uib-accordion>\r\n        </form>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_analiticas_ft.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <button id=\"acciones-button\" uib-tooltip=\"Subir fotos\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"abrirPopupAnalitica(true)\" ng-show=\"extranetUser.cliente\">\r\n      <i class=\"fa fa-plus\"></i> Nueva planificación\r\n    </button>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <!-- <h4>Periodo Inicio</h4> -->\r\n                <ix-select ng-model=\"data.filtro.start_month\" name=\"Periodo inicio - Mes\" entity=\"meses\" pk=\"mes\" desc=\"mes_nombre\"></ix-select>\r\n                <ix-text ng-model=\"data.filtro.start_year\" name=\"Periodo inicio - Año\" ix-number is-filter=\"true\"></ix-text>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <!-- <h4>Periodo final</h4> -->\r\n                <ix-select ng-model=\"data.filtro.end_month\" name=\"Periodo final - Mes\" entity=\"meses\" pk=\"mes\" desc=\"mes_nombre\"></ix-select>\r\n                <ix-text ng-model=\"data.filtro.end_year\" name=\"Periodo final - Año\" ix-number is-filter=\"true\"></ix-text>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-text ng-model=\"data.filtro.busqueda_generica\" name=\"Búsqueda Genérica\" is-filter=\"true\"></ix-text>\r\n                <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"Asociados\" conditions=\"[{field: \'cliente\', value: \'1000009\', not: true}]\" ng-show=\"!ocultarSelAsociados\"></ix-select-multiple>\r\n                <ix-options-si-no ng-show=\"!extranetUser.laboratorio\" ng-model=\"data.filtro.exclusivas\" name=\"Fichas Técnicas exclusivas\" is-filter=\"true\"></ix-options-si-no>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div ng-if=\"data.gridft_analiticas\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 365px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.gridft_analiticas\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridft_analiticas.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridft_analiticas\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_cambio_estados_ft.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"{{ \'Filtros\' | translate }}\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.proveedor\" entity=\"proveedores\" name=\"Proveedor\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-2\">\r\n                <ix-date ng-model=\"data.filtro.fecha_inicio\" name=\"Desde\"></ix-date>\r\n                <ix-date ng-model=\"data.filtro.fecha_fin\" name=\"Hasta\"></ix-date>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div class=\"grid full-ui-grid\" data-ui-grid=\"data.gridCambioEstadosFt\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 350px)\' : \'calc(100vh - 230px)\' }\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridCambioEstadosFt.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridCambioEstadosFt\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/listado_control_envio_obs_alergenos_app.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar>\r\n        <!-- <button id=\"editar-button\" ng-show=\"!data.grid_envio_obs.ixEditar\" uib-tooltip=\"Marcar/desmarcar envío observaciones\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"setEditar()\" >\r\n            Editar\r\n        </button>\r\n        <button id=\"guardar-button\" ng-show=\"data.grid_envio_obs.ixEditar\" uib-tooltip=\"Guardar cambios\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"marcar_envios()\" >\r\n            Guardar\r\n        </button> -->\r\n    </ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n            <div class=\"grid full-ui-grid\" data-ui-grid=\"data.grid_envio_obs\" data-ui-grid-cellnav data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n                <div class=\"grid-loading\" ng-if=\"data.grid_envio_obs.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div class=\"footer\">\r\n                <div ix-datetime-grid-generada grid=\"data.grid_envio_obs\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/listado_emd_fichas_seguridad.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"false\">\r\n      <button id=\"descarga-masiva-btn\" uib-tooltip=\"Descarga masiva\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle>\r\n        <translate>Descarga masiva</translate><span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"descarga-masiva-btn\">\r\n        <li role=\"menuitem\" ng-click=\"descargaMasivaArchivos()\"><a><translate>Descargar ficheros seleccionados</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a><translate>Seleccionar líneas visibles</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"borrarSeleccionRows()\"><a><translate>Limpiar líneas seleccionadas</translate></a></li>\r\n      </ul>\r\n    </div>\r\n  </ix-tool-bar>\r\n\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-6\">\r\n                <ix-select-multiple ng-model=\"data.filtro.proveedores\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" name=\"Proveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-show=\"!extranetUser.proveedor\"></ix-select-multiple>\r\n                <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"Asociados\" conditions=\"[{field: \'cliente\', value: \'1000009\', not: true}]\" ng-show=\"!ocultarSelAsociados\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                <ix-select-multiple ng-model=\"data.filtro.tipos_ficheros\" entity=\"tipos_fichero_ft\" pk=\"id\" desc=\"descripcion\" name=\"Tipo fichero\"></ix-select-multiple>\r\n                <ix-options-si-no ng-show=\"!extranetUser.laboratorio\" ng-model=\"data.filtro.exclusivas\" name=\"Sólo exclusivas\" is-filter=\"true\"></ix-options-si-no>\r\n                <ix-options-si-no ng-show=\"!extranetUser.laboratorio\" ng-model=\"data.filtro.vigentes\" name=\"Sólo archivos vigentes\" is-filter=\"true\"></ix-options-si-no>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div ng-if=\"data.gridFicheros\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 365px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.gridFicheros\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridFicheros.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridFicheros\"></div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_ft.html","<style>\r\n  .row-alarm {\r\n  background-color: rgb(255, 116, 108) !important;\r\n}\r\n  .row-ok {\r\n  background-color: rgb(178, 251, 165) !important;\r\n}\r\n</style>\r\n<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n		<div ng-if=\"status.filtered\" class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n      <!-- <button id=\"acciones-button\" uib-tooltip=\"Más acciones\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled || status.blockUIBtns\">\r\n        Acciones <span class=\"caret\"></span>\r\n      </button> -->\r\n      <!-- <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-class=\"{\'disabled\': getSelectedRows().length == 0 }\"><a ng-click=\"abrirMultiplesFichasTecnicas()\">Abrir múltiples fichas técnicas</a></li>\r\n      </ul> -->\r\n    </div>\r\n    <button id=\"acciones-button\" uib-tooltip=\"Crear nueva ficha técnica\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-disabled=\"disabled\" ng-click=\"openAddFtPopup()\" ng-show=\"status.editing && !extranetUser.proveedor\">\r\n      <i class=\"fa fa-plus\"></i> Nueva FT\r\n    </button>\r\n    <button id=\"acciones-button\" class=\"btn pull-right\" ng-show=\"!(extranetUser.proveedor || extranetUser.cliente || extranetUser.laboratorio)\" ng-click=\"EliminarFtObsoletas()\">Eliminar Obsoletas</button> \r\n\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"herramientas\" ng-show=\"!(extranetUser.proveedor || extranetUser.cliente || extranetUser.laboratorio)\">\r\n      <button class=\"btn\" uib-dropdown-toggle ng-disabled=\"data.gridFichasTecnicas.gridApi.selection.getSelectedRows()==0 || !Herramientas()\">\r\n          Herramientas <span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu>\r\n          <li role=\"menuitem\" ng-click=\"VersionarMasivamente()\"><a>Versionar Masivamente</a></li>\r\n          <li role=\"menuitem\" ng-click=\"DesbloquearMasivamente()\"><a>Desbloquear Masivamente</a></li>\r\n      </ul>\r\n    </div>\r\n\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.tipo_ft\" entity=\"versiones\" name=\"Tipo\" pk=\"version\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-select-multiple ng-model=\"data.filtro.estado\" entity=\"estados\" name=\"Estado\" pk=\"codigo\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.marca\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" name=\"Marca\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-select-multiple ng-model=\"data.filtro.proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" name=\"Proveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-show=\"!extranetUser.proveedor\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-text ng-model=\"data.filtro.busqueda_generica\" name=\"Búsqueda Genérica\" is-filter=\"true\"></ix-text>\r\n                <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"Asociados\" conditions=\"[{field: \'cliente\', value: \'1000009\', not: true}]\" ng-show=\"!ocultarSelAsociados\"></ix-select-multiple>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n\r\n    <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n      <uib-tab index=\"0\" heading=\"Fichas técnicas\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n          <div ng-if=\"data.gridFichasTecnicas\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 430px)\' : \'calc(100vh - 265px)\' }\" data-ui-grid=\"data.gridFichasTecnicas\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n            <div class=\"grid-loading\" ng-if=\"data.gridFichasTecnicas.ixIsLoading\">\r\n              <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div>\r\n          <div class=\"footer\">\r\n            <div ix-datetime-grid-generada grid=\"data.gridFichasTecnicas\"></div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n      <uib-tab index=\"1\" heading=\"Resumen\" translate-attr=\"heading\" select=\"changeTab(1)\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div id=\"pivotFichasTecnicas\" style=\"margin:30px; overflow:auto\"></div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n    </uib-tabset>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/listado_ft_fotos_producto.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isseleccionaropen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"Descarga múltiple de fotos\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        Descarga Fotos<span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"selectVisibleRows()\"><a>Seleccionar lineas visibles</a></li>\r\n        <li role=\"menuitem\" ng-click=\"cleanSelectedRows()\"><a>Desseleccionar todo</a></li>\r\n        <li role=\"menuItem\" ng-click=\"downloadSelectedPictures()\"><a>Descargar</a></li>\r\n      </ul>\r\n    </div>\r\n    <button id=\"acciones-button\" uib-tooltip=\"Subir fotos\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-show=\"!hideLoadFotos\" ng-click=\"abrirPopupSubirFotos()\">\r\n      <i class=\"fa fa-plus\"></i> Subir fotos\r\n    </button>\r\n  </ix-tool-bar>\r\n  <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n    <uib-accordion close-others=\"oneAtATime\">\r\n      <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n        <fieldset class=\"form-data-filter\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4\">\r\n              <ix-date ng-model=\"data.filtro.fecha_inicio\" name=\"Fecha inicio\"></ix-date>\r\n              <ix-date ng-model=\"data.filtro.fecha_fin\" name=\"Fecha fin\"></ix-date>\r\n            </div>\r\n            <div class=\"col-md-4\">\r\n              <ix-text ng-model=\"data.filtro.busqueda_generica\" name=\"Búsqueda Genérica\" is-filter=\"true\"></ix-text>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n      </div>\r\n    </uib-accordion>\r\n  </form>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div ng-if=\"data.gridft_fotos_producto\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 340px)\' : \'calc(100vh - 225px)\' }\" data-ui-grid=\"data.gridft_fotos_producto\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridft_fotos_producto.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridft_fotos_producto\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_productos_ft.html","<style>\r\n  .row-alarm {\r\n  background-color: rgb(255, 116, 108) !important;\r\n}\r\n  .row-ok {\r\n  background-color: rgb(178, 251, 165) !important;\r\n}\r\n</style>\r\n<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isseleccionaropen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"Descarga masiva FT\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        Acciones<span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a>Seleccionar lineas visibles</a></li>\r\n        <li role=\"menuitem\" ng-click=\"desSeleccionarRows()\"><a>Desseleccionar todo</a></li>\r\n      </ul>\r\n    </div>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n<!--\r\n      <button id=\"acciones-button\" uib-tooltip=\"Descarga masiva FT\" tooltip-placement=\"bottom\" class=\"btn\"\r\n        uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        Descarga masiva <span class=\"caret\"></span>\r\n-->\r\n			<button id=\"acciones-button\" uib-tooltip=\"Descarga masiva FT\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\" ng-click=\"impresionMasivaFT()\">\r\n        Descarga masiva\r\n      </button>\r\n<!--\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFT(\'PDF\',0)\"><a>Imprimir FT PDF</a></li>\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFT(\'PDF\',1)\"><a>Imprimir FT reducida PDF</a></li>\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFT(\'MSWORD\',0)\"><a>Imprimir FT Doc</a></li>\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFT(\'MSWORD\',1)\"><a>Imprimir FT reducida Doc</a></li>\r\n      </ul>\r\n-->\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <!-- <ix-select-multiple ng-model=\"data.filtro.tipo_ft\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\"\r\n                  name=\"Tipo\"></ix-select-multiple> -->\r\n                <ix-select-multiple ng-model=\"data.filtro.tipo_ft\" entity=\"versiones\" name=\"Tipo\" pk=\"version\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <!-- <ix-select-multiple ng-model=\"data.filtro.estado\" entity=\"ft_estados\" pk=\"codigo\" desc=\"descripcion\"\r\n                  name=\"Estado\"></ix-select-multiple> -->\r\n                <ix-select-multiple ng-if=\"!esPerfilVisitante()\" ng-model=\"data.filtro.estado\" entity=\"estados\" name=\"Estado\" pk=\"codigo\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.marca\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" name=\"Marca\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-select-multiple ng-if=\"!esPerfilExport()\" ng-model=\"data.filtro.proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" name=\"Proveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-text ng-model=\"data.filtro.busqueda_generica\" name=\"Búsqueda Genérica\" is-filter=\"true\"></ix-text>\r\n                <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"Asociados\" conditions=\"[{field: \'cliente\', value: \'1000009\', not: true}]\" ng-show=\"!ocultarSelAsociados\"></ix-select-multiple>\r\n                <ix-options-si-no ng-show=\"!modificacionesRestringidas()\" ng-model=\"data.filtro.exclusivas\" name=\"Fichas Técnicas exclusivas\" is-filter=\"true\">\r\n                </ix-options-si-no>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n\r\n    <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n      <uib-tab index=\"0\" heading=\"Productos - Fichas técnicas\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n          <div ng-if=\"data.gridProductosFt\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 432px)\' : \'calc(100vh - 265px)\' }\" data-ui-grid=\"data.gridProductosFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n            <div class=\"grid-loading\" ng-if=\"data.gridProductosFt.ixIsLoading\">\r\n              <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div>\r\n          <div class=\"footer\">\r\n            <div ix-datetime-grid-generada grid=\"data.gridProductosFt\"></div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n      <uib-tab index=\"1\" heading=\"Resumen\" translate-attr=\"heading\" select=\"changeTab(1)\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div id=\"pivotProductosFt\" style=\"margin:30px; overflow:auto\"></div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n    </uib-tabset>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_productos_marca.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar>\r\n    </ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n        <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n            <uib-accordion close-others=\"oneAtATime\" ng-show=\"esClienteDM() || tienePerfilAdmin()\">\r\n                <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n                    <fieldset class=\"form-data-filter\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-4\">\r\n                                <ix-select-multiple ng-model=\"data.filtro.asociados\" entity=\"clientes\" name=\"Cliente\" pk=\"cliente\" desc=\"nombre\"></ix-select-multiple>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n            </uib-accordion>\r\n        </form>\r\n        <!-- ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 436px)\' : \'calc(100vh - 265px)\' }\" -->\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n            <!-- <div class=\"grid full-ui-grid\"\r\n                ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 300px)\' : \'calc(100vh - 200px)\' }\"\r\n                data-ui-grid=\"data.gridProductosMarca\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav\r\n                data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection\r\n                data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter\r\n                data-ui-grid-validate> -->\r\n                <div class=\"grid full-ui-grid\" ng-style=\"calcularAlturaDisponible()\" data-ui-grid=\"data.gridProductosMarca\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n                <div class=\"grid-loading\" ng-if=\"data.gridProductosMarca.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div class=\"footer\">\r\n                <div ix-datetime-grid-generada grid=\"data.gridProductosMarca\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/listado_proveedores_ficheros.html","<div my-transition-end=\"init()\">\r\n    <ix-splash></ix-splash>\r\n    <ix-tool-bar>\r\n      <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n        <button uib-tooltip=\"Descarga Masiva lineas seleccionadas\" tooltip-placement=\"bottom\" class=\"btn\" ng-disabled=\"data.gridProveedoresFicheros.gridApi.selection.getSelectedRows()==0\" uib-dropdown-toggle ng-click=\"downloadMultiFile()\"><span class=\"badge\"> {{data.gridProveedoresFicheros.gridApi.selection.getSelectedRows().length}}</span>Descarga Masiva</button>\r\n      </div>\r\n    </ix-tool-bar>\r\n    <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n        <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n            <uib-accordion close-others=\"oneAtATime\">\r\n                <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n                  <fieldset class=\"form-data-filter\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-4\">\r\n                        <ix-options-si-no ng-model=\"data.filtro.vigentes\" name=\"Solo ficheros vigentes\" is-filter=\"true\"></ix-options-si-no>\r\n                      </div>\r\n                      <div class=\"col-md-4\">\r\n                      </div>\r\n                      <div class=\"col-md-4\">\r\n                      </div>\r\n                    </div>\r\n                  </fieldset>\r\n                </div>\r\n              </uib-accordion>\r\n        </form>\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n            <div class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 436px)\' : \'calc(100vh - 265px)\' }\" data-ui-grid=\"data.gridProveedoresFicheros\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate data-ui-grid-selection>\r\n                <div class=\"grid-loading\" ng-if=\"data.gridProveedoresFicheros.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div class=\"footer\">\r\n                <div ix-datetime-grid-generada grid=\"data.gridProveedoresFicheros\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/views/ftNzToggle.html","<div class=\"togglebutton manual-control form-group\">\r\n  <label class=\"{{::labelClass || \'col-md-4\'}}\">\r\n		<img style=\"width: 60px; margin-right: 5px\" ng-src=\"data:image/png;base64, {{::icono || \'R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==\'}}\" title=\"{{::name}}\" ng-if=\"icono\">\r\n		{{::name}} <i class=\"fa fa-asterisk\" style=\"color:red\" ng-show=\"ngRequired\"></i>\r\n	</label>\r\n	<span class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n		<nz-toggle tri-toggle on-toggle=\"changeSelected()\" ng-model=\"ngModel\" ng-disabled=\"ngDisabled\" val-true=\"\'1\'\" val-false=\"\'0\'\" val-null=\"null\"></nz-toggle>\r\n	</span>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ftTitulo.html","<div>\r\n	<div style=\"font-size: large\">\r\n		<span ng-show=\"item.nivel1\"><strong>{{ item.nivel1 }}<span ng-show=\"item.nivel2\">.{{ item.nivel2 }}<span ng-show=\"item.nivel3\">.{{ item.nivel3 }}</span></span> -</strong></span><strong class=\"uppercase\">{{item.titulo2}}</strong><span ng-show=\"item.nivel3\"><strong> {{item.titulo3}}</strong></span><br>\r\n	</div>\r\n	<strong>{{ item.titulo4 }}</strong>{{item.titulo4_valor}} de {{item.titulo4_valor2}}\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/grid_jerarquico_add_row_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"{{rowsGrid.length > 0 ? \'Añadir\' : \'Editar\'}} Ingrediente {{ rowsGrid.length > 0 ? \'Nuevo\' : entity.valor }}\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n<!--\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n					<div class=\"row\">\r\n						<div ng-if=\"rowsGrid.length > 0\" class=\"col-md-7\">\r\n							<ix-select ng-if=\"!reload\" ng-model=\"entity.orden_bucle\" name=\"Seleccionar Nivel/Posición\" pk=\"codigo\" desc=\"descripcion\" load-function=\"cargarValoresNivel\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n							<ix-text ng-model=\"$parent.searchtext\" name=\"Buscar ingrediente\"></ix-text>\r\n							<ix-text ng-model=\"entity.valor\" name=\"Ingrediente\" ng-show=\"false\" ng-required=\"true\"></ix-text>\r\n							<div style=\"border:1px solid black; float:right;\" class=\"col-md-8\">\r\n								<p>Ingrediente:</p>\r\n								<div style=\"height:calc(100vh - 315px); overflow:auto;\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filterItems\" ivh-treeview-on-cb-change=\"selectionChanged(ivhNode, ivhIsSelected, ivhTree)\">\r\n								</div>\r\n							</div>\r\n						</div>\r\n						<div ng-class=\"{ \'col-md-5\': (rowsGrid.length > 0), \'col-md-8\': (rowsGrid.length == 0) }\">\r\n							<ft-pregunta pregunta=\"pregunta\" data=\"entity\" in-popup=\"true\" modo-traduccion=\"modoTraduccion\"></ft-pregunta>\r\n						</div>\r\n					</div>\r\n        </form>\r\n-->\r\n				<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-7\">\r\n							<ix-select ng-if=\"!reload && rowsGrid.length > 0\" ng-model=\"entity.orden_bucle\" name=\"Seleccionar Nivel/Posición\" pk=\"codigo\" desc=\"descripcion\" load-function=\"cargarValoresNivel\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n							<ix-text ng-model=\"searchtext\" name=\"Buscar ingrediente\"></ix-text>\r\n							<ix-text ng-model=\"entity.valor\" name=\"Ingrediente\" ng-show=\"false\" ng-required=\"true\"></ix-text>\r\n							<div style=\"border:1px solid black; float:right\" class=\"col-md-8\">\r\n								<p>Ingrediente:</p>\r\n								<div style=\"height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filterItems\" ivh-treeview-on-cb-change=\"selectionChanged(ivhNode, ivhIsSelected, ivhTree)\">\r\n								</div>\r\n							</div>\r\n						</div>\r\n						<div class=\"col-md-5\">\r\n							<ft-pregunta pregunta=\"pregunta\" data=\"entity\" in-popup=\"true\" modo-traduccion=\"modoTraduccion\"></ft-pregunta>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixCustomHintFt.html","<div>\r\n	<span ng-mousedown=\"copiarValorHint()\"><i class=\"fa fa-clipboard\"></i></span>\r\n	<span><translate>Texto original</translate>: </span>\r\n	<span ng-if=\"value && value != \'null\'\">{{ value }}</span>\r\n	<span ng-if=\"valueGrid\">{{ valueGrid }}</span>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixDateFt.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\">{{name}}<i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\" ng-class=\"{ \'col-md-8\': !oneLineText, \'col-md-12\': oneLineText }\">\r\n		<ix-datepicker ng-model=\"ngModel\" name=\"{{name}}\" date-limit=\"dateLimit\" date-min=\"dateMin\" ng-disabled=\"ngDisabled\" append-to-body=\"appendToBody\"></ix-datepicker>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixOptionsSiNoFt.html","<div class=\"togglebutton\" abm-toggle>\r\n  <label ng-class=\"{ \'col-md-8\': textMaxWidth == true, \'col-md-4\': !textMaxWidth }\">{{::name}}<i class=\"fa fa-asterisk\" style=\"color:red\" ng-show=\"ngRequired\"></i></label>\r\n  <input ng-class=\"{ \'pull-right\': textMaxWidth == true }\" ng-checked=\"estaSeleccionado == 1\" type=\"checkbox\" ng-click=\"changeSelected(ngModel)\" ng-model=\"ngModel\" ng-disabled=\"ngDisabled\" ng-true-value=\"1\" ng-false-value=\"0\">\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixSelect2Ft.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\">{{::name || pk}}\r\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\r\n    </label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\" ng-class=\"{ \'col-md-8\': !oneLineText, \'col-md-12\': oneLineText }\">\r\n		<virtual-select ng-class=\"{ \'disabled\': ngDisabled }\" choices-repeat=\"allItems\" ng-model=\"ngModel\" core-property=\"pk\" display-property=\"desc\" singleselect ng-disabled=\"ngDisabled\" custom-ng-required=\"ngRequired\" entity=\"entity\" extra-field=\"extraField\" filter-fields=\"filterFields\" preload=\"preload\" conditions=\"conditions\" load-function=\"loadFunction\" ng-default=\"ngDefault\" whole-obj=\"wholeObj\" order-string-as-int=\"orderStringAsInt\" allow-custom=\"editableDropdown\" preload-function=\"preloadFunction\" preload-obj=\"preloadObj\" preload-pk=\"preloadPk\" load-all-items=\"loadAllItems\" entity-data=\"entityData\" entity-data-pk=\"entityDataPk\" entity-data-desc=\"entityDataDesc\" append-to-body=\"appendToBody\" on-select=\"onSelect\" template=\"template\" skip-table-name-filter=\"skipTableNameFilter\" skip-table-name-order-by=\"skipTableNameOrderBy\" keep-original-value=\"keepOriginalValue\"></virtual-select>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixSelectMultipleFt.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\">{{::name || pk}}\r\n    <i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i>\r\n    </label>\r\n		<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n		<ui-select multiple ng-model=\"$parent.ngModel\" ng-class=\"{ \'show-always\': (editableDropdown == true ||  keepOriginalValue == true) }\" append-to-body=\"appendToBody\" ng-disabled=\"ngDisabled\" on-select=\"onSelectOption($item)\">\r\n      <ui-select-match allow-clear=\"{{ !ngRequired }}\" placeholder=\"Selecciona un registro...\" translate-attr=\"placeholder\">{{$item[desc]}} {{ (cfg.dropdownSinCodigo) ? \"\" : \"- \"+$item[pk] }}</ui-select-match>\r\n			<ui-select-choices repeat=\"item[pk] as item in (allItems | filter: filtrarResultados($select)) track by item[pk]\" refresh=\"refresh($select)\" refresh-delay=\"300\">\r\n				<div>{{::item[desc]}} <span ng-if=\"extraField\">/ {{::item[extraField]}}</span></div>\r\n				<div ng-class=\"{\'invisible\': cfg.dropdownSinCodigo }\" class=\"text-muted\">{{::item[pk]}}</div>\r\n			</ui-select-choices>\r\n		</ui-select>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixTextAreaFt.html","<div class=\"form-group\" ng-class=\"{\'ToConfirm\': traducible && !confirmado }\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\">{{::name}}<i class=\"fa fa-asterisk\" style=\"color:red\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n		<span ng-show=\"traducible && customHint && ngModel\" style=\"top: 4px;position: absolute;left: 19px\">\r\n			<i ng-show=\"!confirmado\" class=\"fa fa-pencil\"></i>\r\n			<i ng-show=\"confirmado\" class=\"fa fa-check\"></i>\r\n		</span>\r\n		<textarea autosize ng-class=\"ngClass\" ng-focus=\"showCustomHint($event)\" ng-model=\"ngModel\" style=\"width:100%\" ng-required=\"ngRequired\" ng-disabled=\"ngDisabled\" maxlength=\"{{::maxLength}}\" rows=\"{{::rows}}\" cols=\"{{::cols}}\" placeholder=\"{{::placeholder}}\"></textarea>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ixTextFt.html","<div class=\"form-group\">\r\n	<label class=\"{{::labelClass || \'col-md-4\'}}\">{{::name}}<i class=\"fa fa-asterisk\" ng-show=\"ngRequired\"></i></label>\r\n	<div class=\"{{ ::inputClass || \'col-md-8\' }}\">\r\n    <input type=\"text\" name=\"{{::name}}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-model=\"ngModel\" ng-class=\"(ngModel2 === undefined) ? \'input-full-width\' : \'input-half-width\'\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\" ng-value=\"ngValue\" placeholder=\"{{ ngPlaceholder }}\" maxlength=\"{{::maxLength}}\" autocomplete=\"off\">\r\n    <input type=\"text\" name=\"{{::name}}\" ng-model-options=\"{\'updateOn\': \'default blur\',\'debounce\': {\'default\': 350,\'blur\': 0 }}\" ng-show=\"ngModel2 !== undefined\" ng-model=\"ngModel2\" class=\"input-half-width\" ngrequired=\"ngRequired\" ng-disabled=\"(!$parent.status.editing || ngDisabled) && (!isFilter || (isFilter && ngDisabled))\" ng-value=\"ngValue\" maxlength=\"{{::maxLength2}}\" autocomplete=\"off\">\r\n	</div>\r\n	<div ng-transclude></div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/previsualizar_imagen_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Previsualizar Imagen\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12 imgContainer\">\r\n              <img class=\"slide\" style=\"width: 43%\" src=\"{{selectedImage}}\">\r\n            </div>\r\n          </div>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-3\">\r\n							<button ng-click=\"downloadFile(selectedImage)\"><i class=\"fa fa-download\"></i></button>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/previsualizar_pdf_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Previsualizar PDF\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\" style=\"height: 700px\">\r\n              <div class=\"some-pdf-container\" style=\"width: 100%; height: 100%\">\r\n								<pdfjs-viewer src=\"{{urlPDF}}\"></pdfjs-viewer>\r\n							</div>\r\n            </div>\r\n          </div>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-3\">\r\n							<button ng-click=\"downloadFile(selectedPDF)\"><i class=\"fa fa-download\"></i></button>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ui-grid-cell-editor-traduccion.html","<div>\r\n	<ix-custom-hint-ft on-copy-value=\"grid.appScope.changeCellValue\" row=\"row\" col=\"col\" value-grid=\"{{ grid.appScope.getCustomHint(row,col) }}\" style=\"position: fixed; background: #fff; outline: 1px solid black; padding: 4px 5px\"></ix-custom-hint-ft>\r\n	<form name=\"inputForm\">\r\n		<input type=\"INPUT_TYPE\" placeholder=\"{{ grid.appScope.getCustomHint(row,col) }}\" class=\"cell-traduccion\" ng-class=\"\'colt\' + col.uid\" ui-grid-editor ng-model=\"MODEL_COL_FIELD\">\r\n	</form>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ui-grid-cell-traduccion.html","<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">\r\n    <span ng-show=\"COL_FIELD\"></span>{{COL_FIELD CUSTOM_FILTERS}}\r\n    <span ng-show=\"!COL_FIELD\" style=\"color:blue\">{{ grid.appScope.getCustomHint(row,col) }}</span>\r\n</div>");
$templateCache.put("app/FTBase/views/ui-grid-row-ft.html","<div grid=\"grid\" class=\"ui-grid-draggable-row\" draggable=\"true\">\r\n  <!--<div ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell>\r\n  </div>-->\r\n  <div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0), \"CellToConfirm\": grid.getCellValue(row ,col) && grid.appScope.checkColState(row,col) == 1, \"CellConfirmed\": grid.getCellValue(row ,col) && grid.appScope.checkColState(row,col) == 2 }\' role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell></div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/views/ui-grid-tree-row-traduccion.html","<div grid=\"grid\" class=\"ui-grid-draggable-row\" draggable=\"true\">\r\n  <!--<div ng-class=\'{ \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0)}\' ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell>\r\n  </div>-->\r\n  <div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ng-style=\"{\'padding-left\': grid.options.treeIndent * row.treeLevel + \'px\'}\" ui-grid-one-bind-id-grid=\"rowRenderIndex + \'-\' + col.uid + \'-cell\'\" class=\"ui-grid-cell\" ng-class=\'{ \"tree-level-0\": (row.treeLevel == 0), \"tree-level-1\": (row.treeLevel == 1), \"tree-level-2\": (row.treeLevel == 2), \"ui-grid-row-header-cell\": col.isRowHeader, \"left-markup\": grid.appScope.leftMarkup(), \"highlight\": row.estaSeleccionado == true, \"CellRequired\": ((col.colDef.required || col.colDef.pk) && (!col.colDef.fk)) && (!grid.getCellValue(row ,col) && grid.getCellValue(row ,col)!==0), \"CellToConfirm\": grid.getCellValue(row ,col) && grid.appScope.checkColState(row,col) == 1, \"CellConfirmed\": grid.getCellValue(row ,col) && grid.appScope.checkColState(row,col) == 2 }\' role=\"{{col.isRowHeader ? \'rowheader\' : \'gridcell\'}}\" ui-grid-cell></div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Dashboards/Dashboard/dashboard.html","<style>\r\n	.nvd3 .nv-groups .nv-point {\r\n    stroke-opacity: 0.5 !important;\r\n    stroke-width: 10px;\r\n}\r\n</style>\r\n<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar special-tool-bar=\"true\">\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n      <button id=\"acciones-button\" ng-show=\"status.editing\" ng-disabled=\"!status.editing\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        Acciones <span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\"><a ng-click=\"addWidget()\">Añadir widget</a></li>\r\n      </ul>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <!--<div class=\"page-content\" ng-if=\"status.transitionend\">-->\r\n    <div ng-scrollbars class=\"scrolldiv\">\r\n      <div class=\"page-content\" ng-show=\"status.transitionend\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <uib-accordion close-others=\"oneAtATime\">\r\n            <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"Filtros\" is-open=\"filterStatus.isCollapsed\">\r\n              <fieldset class=\"form-data-filter\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-4\" ng-if=\"!status.editing\">\r\n                    <ix-select ng-model=\"data.filtro.id\" entity=\"fend_config_dashboards\" pk=\"id\" desc=\"clave\" extra-field=\"asignado_a\" name=\"Dashboard\" ng-disabled=\"status.editing || status.filtered\" load-function=\"loadDashboardsUsuario\" on-select=\"onSelectDashboard\" ng-required=\"true\" conditions=\"[{field: \'modulo\', value: modulo }]\"></ix-select>\r\n                  </div>\r\n                  <div class=\"col-md-4\" ng-if=\"status.editing\">\r\n                    <ix-text ng-model=\"data.filtro.nombre_dashboard\" name=\"Dashboard\" ng-required=\"true\"></ix-text>\r\n                  </div>\r\n                  <div class=\"col-md-4\">\r\n                    <ix-select ng-model=\"data.filtro.nivel_acceso\" name=\"Nivel de acceso\" pk=\"acceso\" desc=\"nombre\" load-function=\"loadNivelesAcceso\" load-all-items=\"true\" ng-disabled=\"!status.editing\"></ix-select>\r\n										<ix-select ng-if=\"data.filtro.nivel_acceso == \'u\' && data.dashboardsEdit == 2\" ng-model=\"data.filtro.usuario\" name=\"Usuario\" entity=\"api_usuarios\" pk=\"usuario\" desc=\"usuario\" conditions=\"[{field:\'activo\',value:1},{field:\'client_id\', value:cfg.clientId}]\" ng-disabled=\"!status.editing\"></ix-select>\r\n										<ix-select ng-if=\"data.filtro.nivel_acceso == \'p\' && data.dashboardsEdit == 2\" ng-model=\"data.filtro.perfil\" name=\"Perfil\" entity=\"api_perfiles\" pk=\"perfil\" desc=\"perfil\" conditions=\"[{field:\'client_id\', value:cfg.clientId}]\" ng-disabled=\"!status.editing\"></ix-select>\r\n                  </div>\r\n									<div class=\"col-md-4\">\r\n                    <ix-options-si-no ng-model=\"data.filtro.desktop\" name=\"Mostrar en Escritorio\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n										<button class=\"btn btn-primary pull-right\" style=\"margin-right:13px\" ng-click=\"cargarWidgets()\">Actualizar</button>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n          </uib-accordion>\r\n        </form>\r\n        <div class=\"dashboard\">\r\n          <!-- Dashboard widgets -->\r\n          <div gridster=\"gridsterOptions\" style=\"min-height: calc(100vh - 192px)\">\r\n            <ul class=\"with-3d-shadow with-transitions\">\r\n              <li gridster-item=\"widget\" ng-repeat=\"widget in data.dashboard.widgets\">\r\n                <div class=\"box\">\r\n                    <div class=\"box-header\">\r\n                      <a class=\"widget-information\" title=\"{{ widget.explicativo }}\"><i class=\"glyphicon glyphicon-info-sign\"></i></a>\r\n                      <span class=\"h3\">{{ widget.titulo }}</span> <span class=\"h4\"> - {{ widget.subtitulo }}</span>\r\n                      <div class=\"box-header-btns pull-right\">\r\n												<button ng-if=\"!status.editing && widget.tipo == \'grid\'\" class=\"btn btn-primary\" ng-click=\"exportWidget(widget)\"><i class=\"fa fa-file-excel-o\"></i> <translate>Exportar</translate></button>\r\n												<button ng-if=\"!status.editing\" class=\"btn btn-primary\" ng-click=\"openSettings(widget)\"><i class=\"fa fa-filter\"></i> <translate>Filtrar</translate></button>\r\n                        <a ng-if=\"status.editing\" title=\"Exportar\" ng-click=\"exportWidget(widget)\"><i class=\"fa fa-file-excel-o\"></i></a>\r\n                        <a ng-if=\"status.editing\" title=\"Ajustes\" ng-click=\"openSettings(widget)\"><i class=\"glyphicon glyphicon-cog\"></i></a>\r\n                        <a ng-if=\"status.editing\" title=\"Eliminar\" ng-click=\"remove(widget)\"><i class=\"glyphicon glyphicon-trash\"></i></a>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"box-content\">\r\n                      <!-- Grafic -->\r\n                      <nvd3 class=\"small-text {{ widget.chart.options.class }}\" ng-if=\"widget.tipo != \'grid\'\" options=\"widget.chart.options\" data=\"widget.chart.data\" api=\"widget.chart.api\" config=\"config\" events=\"events\"></nvd3>\r\n                      <!-- O grid -->\r\n											<div ng-if=\"widget.tipo == \'grid\' && widget.grid\" style=\"height:inherit\">\r\n												<div style=\"height:inherit\" data-ui-grid=\"widget.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate></div>\r\n												<div class=\"footer\" style=\"position:relative;top:-20px\">\r\n													<div ix-datetime-grid-generada grid=\"widget.grid\"></div>\r\n												</div>\r\n											</div>\r\n                    </div>\r\n                </div>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  <!--</div>-->\r\n</div>\r\n");
$templateCache.put("app/FTBase/Dashboards/Dashboard/settings_animacion_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Animación\"></ix-popup-tool-bar>\r\n    <div ng-scrollbars class=\"scrolldiv\">\r\n        <div class=\"scrolldiv-content\">\r\n            <div class=\"modal-body\">\r\n                <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                            <ix-text ng-model=\"animacion_segundos\" name=\"Segundos animación\" is-filter=\"true\" ng-required=\"true\"></ix-text>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/FTBase/Dashboards/Dashboard/widget_settings_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Ajustes\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n							<div ng-if=\"isEditing\">\r\n								<h4>General</h4>\r\n								<ix-select ng-model=\"formSettings.dataSource\" name=\"Fuente Datos\" pk=\"nombre\" desc=\"titulo\" on-select=\"onSelectDataSource\" load-function=\"loadDataSources\" append-to-body=\"true\" load-all-items=\"true\"></ix-select>\r\n								<ix-search-from-grid ng-model=\"formSettings.dataSource\" name=\"Fuente Datos\" entity=\"api_dashboard\" pk=\"nombre\" desc=\"titulo\" ng-disabled=\"status.editing\" on-select=\"onSelectDataSource\" conditions=\"[{ field: \'modulo\', value: modulo }]\" show-only-described-cols=\"[ \'nombre\', \'titulo\', \'subtitulo\', \'explicativo\']\">\r\n                  <i class=\"material-icons ng-binding\">dashboard</i>\r\n                </ix-search-from-grid>               \r\n                <ix-text ng-model=\"formSettings.titulo\" name=\"Título\" ng-required=\"true\"></ix-text>\r\n								<ix-text ng-model=\"formSettings.subtitulo\" name=\"Subtítulo\" ng-required=\"true\"></ix-text>\r\n								<ix-select ng-if=\"formSettings.tipo != \'medidor_radial\' && formSettings.tipo != \'tabla\' && dataSourceObj.tipo != \'medidor_radial\' && dataSourceObj.tipo != \'tabla\'\" ng-model=\"formSettings.tipo\" pk=\"tipo\" desc=\"nombre\" name=\"Tipo\" load-function=\"loadChartTypes\" append-to-body=\"true\" load-all-items=\"true\" ng-required=\"true\"></ix-select>\r\n							</div>\r\n              <h4 ng-show=\"formSettings.filtros.length > 0\">Filtros</h4>\r\n\r\n              <span ng-repeat=\"(idx, filtro) in formSettings.filtros\">\r\n                <!-- año -->\r\n                <ix-text ng-if=\"filtro.tipo == \'anyo\'\" ng-model=\"filtro.value\" name=\"{{ filtro.visibleText }}\" ix-number max-value=\"2050\"></ix-text>\r\n                <!-- mes -->\r\n                <ix-text ng-if=\"filtro.tipo == \'mes\'\" ng-model=\"filtro.value\" name=\"{{ filtro.visibleText }}\" ix-number min-value=\"1\" max-value=\"12\"></ix-text>\r\n                <!-- periodos -->\r\n                <div ng-if=\"filtro.tipo == \'periodo\'\" class=\"manual-control form-group\">\r\n                  <label class=\"col-md-4\"><translate class=\"ng-scope ng-binding\">{{ filtro.visibleText }}</translate></label>\r\n                  <div class=\"col-md-8\">\r\n                    <input time=\"text\" ng-model=\"filtro.value\" ui-mask=\"9999-99\" model-view-value=\"true\" class=\"input-full-width\">\r\n                  </div>\r\n                </div>\r\n                <!-- texto -->\r\n                <ix-text ng-if=\"filtro.tipo == \'texto\'\" ng-model=\"filtro.value\" name=\"{{ filtro.visibleText }}\"></ix-text>								\r\n\r\n								<!-- fecha -->\r\n								<ix-date ng-if=\"filtro.tipo == \'fecha\'\" ng-model=\"filtro.value\" name=\"{{ filtro.visibleText }}\" append-to-body=\"true\"></ix-date>\r\n\r\n                <!-- TODO: Intentar reduir els ng-if. Si quan és tipus busqueda vingués la pk i la descripcio de la base de dades ens estalviariem 2 ng-if x cada possible filtre. -->\r\n                <!-- clientes -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'cliente\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && filtro.multiple && filtro.name.startsWith(\'cliente\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select-multiple>\r\n                <!-- proveedores -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'proveedor\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && filtro.multiple && filtro.name.startsWith(\'proveedor\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <!-- marcas -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'marca\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" name=\"{{ filtro.visibleText }}\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && filtro.multiple && filtro.name.startsWith(\'marca\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" name=\"{{ filtro.visibleText }}\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <!-- ft_versiones -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'version\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && filtro.multiple && filtro.name.startsWith(\'version\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select-multiple>\r\n                <!-- materiales -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'material\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"diccionarios_valores\" pk=\"id\" desc=\"valor\" name=\"{{ filtro.visibleText }}\" conditions=\"[{ field: \'diccionario\', value: 59 }]\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && filtro.multiple && filtro.name.startsWith(\'material\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"diccionarios_valores\" pk=\"id\" desc=\"valor\" name=\"{{ filtro.visibleText }}\" conditions=\"[{ field: \'diccionario\', value: 59 }]\"></ix-select-multiple>\r\n\r\n                <!-- tipo materiales -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'tipo_mat_rec\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"dashb_tipo_mat_reciclajeVM\" pk=\"tipo\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select>\r\n                <ix-select-multiple ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'subtipo_mat_rec\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"dashb_subtipo_mat_reciclajeVM\" pk=\"subtipo\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select-multiple>\r\n\r\n                <!-- agrupador materiales -->\r\n                <ix-select ng-if=\"filtro.tipo == \'busqueda\' && !filtro.multiple && filtro.name.startsWith(\'agrupa_mat_rec\')\" append-to-body=\"true\" ng-model=\"filtro.value\" entity=\"dashb_agrupa_mat_reciclajeVM\" pk=\"agrupa\" desc=\"nombre\" name=\"{{ filtro.visibleText }}\"></ix-select>\r\n\r\n              </span>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_niveles/ft_nivelesCard.html","<strong>Nombre: {{ item.nombre }} </strong><br>\r\n<strong>Tipo FT: {{item.version}}</strong><br>\r\n<strong>Nivel 1: {{item.nivel1}}</strong><br>\r\n<strong>Nivel 2: {{item.nivel2}}</strong><br>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_niveles/ft_nivelesForm.html","<div ng-controller=\"Ft_NivelesController\">\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos.nombre\" name=\"Nombre\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n            <ix-select ng-model=\"data.datos.version\" name=\"Tipo FT\" ng-disabled=\"!status.editing\" ng-required=\"true\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" append-to-body=\"true\"></ix-select>\r\n            <ix-text ng-model=\"data.datos.nivel1\" name=\"Nivel 1\" ng-disabled=\"!status.editing\" ng-required=\"true\" ix-number></ix-text>\r\n            <ix-text ng-model=\"data.datos.nivel2\" name=\"Nivel 2\" ng-disabled=\"!status.editing\" ng-required=\"true\" ix-number></ix-text>\r\n            <ix-text ng-model=\"data.datos.nivel3\" name=\"Nivel 3\" ng-disabled=\"!status.editing\" ng-required=\"true\" ix-number></ix-text>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_versiones/ft_versionesCard.html","<strong>Tipo: {{ item.nombre }} </strong><br>\r\n<strong>Id: {{item.version}}</strong><br>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_versiones/ft_versionesForm.html","<div ng-controller=\"Ft_VersionesController\">\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos.nombre\" name=\"Tipo\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n          </div>\r\n          <button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.version)\" uib-tooltip=\"{{ \'Traducciones\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_versiones/traducciones_ft_versiones.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Versiones\" title-left-param=\"nombre\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/add_elementos_saludables_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Añadir Elementos Saludables\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <span ng-show=\"listOfValues != undefined\">\r\n            <ix-text ng-model=\"searchfiltro\" name=\"Buscar\" is-filter=\"true\"></ix-text>\r\n            <hr>\r\n          </span>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-12\">\r\n							<div style=\"max-height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"{ label: searchfiltro }\">\r\n							</div>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/datos_fabricante_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Datos Fabricante\" title-left-param=\"cif_fabricante\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <ix-text ng-model=\"datos_fabricante.razon_social\" name=\"Razón social\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.cif\" name=\"CIF\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.direccion\" name=\"Dirección\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.cp\" name=\"CP\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.localidad\" name=\"Localidad\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.provincia\" name=\"Provincia\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.pais\" name=\"País\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.telefono\" name=\"Teléfono\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_fabricante.reg_sanitario\" name=\"Registro sanitario\" ng-disabled=\"true\"></ix-text>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/datos_planta_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Datos Planta\" title-left-param=\"planta_nombre\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <ix-text ng-model=\"datos_planta.nombre_planta\" name=\"Nombre\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.direccion\" name=\"Dirección\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.cp\" name=\"CP\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.localidad\" name=\"Localidad\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.provincia\" name=\"Provincia\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.pais\" name=\"País\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.telefono\" name=\"Teléfono\" ng-disabled=\"true\"></ix-text>\r\n          <ix-text ng-model=\"datos_planta.reg_sanitario\" name=\"Registro sanitario\" ng-disabled=\"true\"></ix-text>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/dependencia_etiquetado_nutricionales_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Dependencia Etiquetado\" title-left-param=\"pregunta_formulario\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n	<div class=\"scrolldiv-content\">\r\n		<div class=\"modal-body\">\r\n			<!-- <div style=\"width:100%;\" ng-if=\"!tabs\">\r\n				<div class=\"btn-toolbar\" style=\"\">	\r\n					<button style=\"padding: 3px 6px; margin: 0;\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0  || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\" style=\"\"><i class=\"fa fa-trash-o\"></i></button>\r\n					<button style=\"padding: 3px 6px; margin: 0;\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tienePerfilRestringido() || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"grid.ixAddRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\" style=\"\"><i class=\"fa fa-plus\"></i></button>\r\n				</div>\r\n				<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n					<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n						<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n					</div>\r\n				</div>\r\n			</div> -->\r\n			<div ng-if=\"tabs\">\r\n				<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"activeTabDependenciaEtiquetado\">\r\n					<uib-tab ng-repeat=\"tab in tabs track by $index\" index=\"$index\" heading=\"{{ tab.nombre }}\" translate-attr=\"heading\" select=\"cambiarTabDependenciaEtiquetado(tab, $index)\">\r\n						<div class=\"btn-toolbar\">	\r\n							<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tab.grid.data.length == 0  || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"deleteNutricionales(tab.grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n							<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tienePerfilRestringido() || modoTraduccion || pregunta_bloqueada || registrosCreados || tab.grid.data.length > 0\" data-ng-click=\"addNutricionales(tab, $index)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n						</div>\r\n						<div ng-if=\"tab.grid\" class=\"full-ui-grid\" data-ui-grid=\"tab.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n							<div class=\"grid-loading\" ng-if=\"tab.grid.ixIsLoading\">\r\n								<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n							</div>\r\n						</div>\r\n					</uib-tab>\r\n				</uib-tabset>\r\n			</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/dependencia_etiquetado_popup.html","<div>\r\n	<ix-popup-tool-bar title-left=\"Dependencia Etiquetado\" title-left-param=\"pregunta_formulario\"></ix-popup-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<div class=\"modal-body\">\r\n				<div style=\"width:100%\" ng-if=\"!tabs\">\r\n					<div class=\"btn-toolbar\">\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0  || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<!-- <button style=\"padding: 3px 6px; margin: 0;\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tienePerfilRestringido() || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"grid.ixAddRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\" style=\"\"><i class=\"fa fa-plus\"></i></button> -->\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tienePerfilRestringido() || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"addRow(grid)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n				<div ng-if=\"tabs\">\r\n					<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"activeTabDependenciaEtiquetado\">\r\n						<uib-tab ng-repeat=\"tab in tabs track by $index\" index=\"$index\" heading=\"{{ tab.nombre }}\" translate-attr=\"heading\" select=\"cambiarTabDependenciaEtiquetado(tab, $index)\">\r\n							<div class=\"btn-toolbar\">\r\n								<div ng-if=\"!esGridJerarquico()\">\r\n									<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tab.grid.gridApi.selection.getSelectedRows().length==0  || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"deleteSelectedRows(tab.grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n								</div>\r\n\r\n								<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"tienePerfilRestringido() || modoTraduccion || pregunta_bloqueada\" data-ng-click=\"addRow(tab.grid)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n							</div>\r\n							<div ng-if=\"tab.grid\" class=\"full-ui-grid\" data-ui-grid=\"tab.grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-tree-view data-ui-grid-validate>\r\n								<div class=\"grid-loading\" ng-if=\"tab.grid.ixIsLoading\">\r\n									<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n								</div>\r\n							</div>\r\n						</uib-tab>\r\n					</uib-tabset>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/duplicarFT_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Duplicar Ficha Técnica\" title-left-param=\"ft_origen\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <ix-text ng-model=\"ft_destino\" name=\"Ficha técnica destino\" ng-required=\"true\"></ix-text>\r\n          <ix-select ng-model=\"nivel1\" name=\"Nivel 1\" entity=\"ft_niveles\" pk=\"nivel1\" desc=\"nivel1\" extra-field=\"nombre\" conditions=\"[{field: \'version\',value: version},{field: \'nivel1\',value: \'1\', op: 1},{field: \'nivel2\',value: \'0\'},{field: \'nivel3\',value: \'0\'}]\" ng-show=\"nivel_duplicar > 0\" ng-required=\"nivel_duplicar > 0\" append-to-body=\"true\"></ix-select>\r\n          <ix-select ng-model=\"nivel2\" name=\"Nivel 2\" entity=\"ft_niveles\" pk=\"nivel2\" desc=\"nivel2\" extra-field=\"nombre\" conditions=\"[{field: \'version\',value: version},{field: \'nivel1\', value: nivel1},{field: \'nivel2\',value: \'0\', op: 1},{field: \'nivel3\',value: \'0\'}]\" ng-show=\"nivel_duplicar > 1\" ng-disabled=\"!nivel1\" append-to-body=\"true\"></ix-select>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/previsualizar_imagen_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Previsualizar Imagen\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12 imgContainer\">\r\n              <img class=\"slide\" style=\"width: 43%\" ng-src=\"data:image/png;base64,{{selectedImage.imagenBase64}}\">\r\n            </div>\r\n          </div>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-3\">\r\n							<button ng-click=\"downloadFile({ id: idFicheroPreview })\"><i class=\"fa fa-download\"></i></button>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/previsualizar_pdf_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Previsualizar PDF\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\" style=\"height: 700px\">\r\n              <div class=\"some-pdf-container\" style=\"width: 100%; height: 100%\">\r\n								<pdfjs-viewer data=\"selectedPDF\"></pdfjs-viewer>\r\n							</div>\r\n            </div>\r\n          </div>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-3\">\r\n							<button ng-click=\"downloadFile(idFicheroPreview)\"><i class=\"fa fa-download\"></i></button>\r\n						</div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/GestionFichasTecnicas/acciones/upload_file_popup.html","<style>\r\n	.nota-importante{\r\n		font-size: 14px;\r\n		font-family: \'Roboto\', \'Helvetica\', \'Arial\', sans-serif;\r\n		line-height: 1.6;\r\n		padding: 15px;\r\n		margin: 0 15px 15px;\r\n		color: white;\r\n		background-color: rgb(241,110,110);\r\n	}\r\n	.nota-explicativa{\r\n		margin: 1em 0 0.5em 0;\r\n		font-weight: normal;\r\n		position: relative;\r\n		text-shadow: 0 -1px rgba(0,0,0,0.6);\r\n		/* font-size: 18px; */\r\n		line-height: 30px;\r\n		background: #d15a4a;\r\n		/* background: rgba(53,86,129, 0.8); */\r\n		border: 1px solid #fff;\r\n		padding: 5px 15px;\r\n		color: white;\r\n		border-radius: 0 10px 0 10px;\r\n		box-shadow: inset 0 0 5px rgba(53,86,129, 0.5);\r\n		font-family: \'Muli\', sans-serif;\r\n	};\r\n</style>\r\n\r\n<div>\r\n  <ix-popup-tool-bar title-left=\"Cargar Fichero\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4\"></div>\r\n            <div class=\"col-md-8\">\r\n              <!-- <input ng-disabled=\"!status.editing\" class=\"btn\" type=\"file\" ngf-select ngf-multiple=\"true\"\r\n                  ng-model=\"archivosToUpload\" name=\"archivo\" ng-required=\"true\" ngf-max-size=\"{{maxUploadFileSize}}\"\r\n                  ngf-model-invalid=\"errorFile\"> -->\r\n              <!-- <button ng-disabled=\"!status.editing\" class=\"btn btn-danger\" ng-click=\"archivosToUpload = null\"\r\n                  ng-show=\"archivosToUpload\">Borrar</button> -->\r\n              <div ngf-drop ngf-select ng-model=\"archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                <translate>Arrastrar o hacer click para subir archivo</translate>\r\n              </div>\r\n              <ul>\r\n                <li ng-repeat=\"f in archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div class=\"nota-importante\" ng-show=\"tipoSeleccionadoFt == 28\">\r\n                <translate>Explicativo formato imágenes</translate>\r\n              </div>\r\n              <ix-select ng-model=\"tipoSeleccionadoFt\" name=\"Tipo archivo\" entity=\"tipos_fichero_ftVM\" pk=\"id\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"tipoArchivoSeleccionado\" append-to-body=\"true\" ng-required=\"true\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select>\r\n              <ix-select-multiple ng-model=\"productoSeleccionado\" ng-show=\"especificar_producto\" name=\"Producto\" entity=\"ft_productos\" pk=\"id_producto\" desc=\"ean\" ng-required=\"especificar_producto\" conditions=\"[{field: \'id_ficha_tecnica\', value: id_ficha_tecnica, skip: 1}]\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-select-multiple>\r\n              <ix-date ng-model=\"inicioValidez\" name=\"Inicio validez\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <ix-date ng-model=\"fechaCaducidad\" name=\"Fecha caducidad\" ng-disabled=\"!status.editing\" append-to-body=\"true\" ng-required=\"caducidad_obligatoria\" ng-show=\"caducidad_obligatoria\"></ix-date>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/Integraciones/Planificaciones_analiticas/planificacion_analiticas.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n		<div id=\"hot-container\" style=\"height:600px\">\r\n			<hot-table settings=\"excelsettings\" datarows=\"data.excelData\" hot-instance=\"tableInstance\">\r\n				<hot-column ng-repeat=\"column in data.excelcolumns\" title=\"column.title\" read-only=\"!status.editing\" renderer=\"column.renderer\" width=\"column.width\"></hot-column>\r\n				<hot-column ng-if=\"data.showResults\" data=\"resultado_color\" title=\"\'Resultado\'\" read-only=\"!status.editing\" width=\"60\" renderer=\"rendererColor\"></hot-column>\r\n				<hot-column ng-if=\"data.showResults\" data=\"resultado_msg\" title=\"\'Detalles\'\" read-only=\"!status.editing\" width=\"250\"></hot-column>\r\n			</hot-table>\r\n		</div>\r\n  </div>\r\n</div>\r\n\r\n\r\n");
$templateCache.put("app/FTBase/HomologacionPlantas/modales/uploadDocumentoAuditoriaPlanta.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Cargar documento auditoría planta\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-4\"></div>\r\n          <div class=\"col-md-8\">\r\n            <div ngf-drop ngf-select ng-model=\"data.archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                <translate>Arrastrar o hacer click para subir archivo</translate>\r\n            </div>\r\n            <ul>\r\n              <li ng-repeat=\"f in data.archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/compradores/compradoresCard.html","<strong><translate>Nombre</translate>: {{ item.nombre }} </strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/compradores/compradoresForm.html","<div ng-controller=\"CompradoresController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.nif\" name=\"Nif\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nombre\" name=\"Nombre\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.direccion\" name=\"Direccion\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.poblacion\" name=\"Poblacion\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.cpostal\" name=\"Código postal\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.pais\" ng-disabled=\"!status.editing\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'31\'}]\"></ix-select>\r\n					</div>\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.telefono\" name=\"Teléfono\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<!-- <ix-text ng-model=\"data.datos.fax\" name=\"Fax\" ng-disabled=\"!status.editing\" ></ix-text> -->\r\n						<ix-text ng-model=\"data.datos.email\" name=\"E-mail\" ng-disabled=\"!status.editing\"></ix-text>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/clientes/clientesCard.html","<strong><translate>Referencia</translate>: {{ item.referencia }} </strong><br>\r\n<strong><translate>Nombre</translate>: {{item.nombre}}</strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/clientes/clientesForm.html","<div ng-controller=\"ClientesController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<!-- <ix-select ng-model=\"data.datos.cliente\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" name=\'Cliente\' ng-required=\"true\" ng-disabled=\"!status.editing || !data.datos.isNew\"></ix-select> -->\r\n						<ix-text ng-model=\"data.datos.referencia\" name=\"Referencia\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nif\" name=\"Nif\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.razon\" name=\"Razón Social\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nombre\" name=\"Nombre\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.direccion\" name=\"Direccion\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.poblacion\" name=\"Poblacion\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.cpostal\" name=\"Código postal\" ng-disabled=\"!status.editing\"></ix-text>\r\n					</div>\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.pais\" ng-disabled=\"!status.editing\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\"></ix-select>\r\n						<ix-text ng-model=\"data.datos.telefono1\" name=\"Teléfono 1\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.telefono2\" name=\"Teléfono 2\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.telefono3\" name=\"Teléfono 3\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.fax\" name=\"Fax\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.email\" name=\"E-mail\" ng-disabled=\"!status.editing\"></ix-text>\r\n					</div>\r\n				</div>\r\n				<div class=\"col-md-12\" ng-if=\"data.datos.cliente && data.datos[data.pk] != 0\">\r\n					<!-- <h4>Contactos responsables</h4> -->\r\n					<hr>\r\n					<div class=\"col-md-6\">\r\n						<ix-select-multiple ng-model=\"data.marcas_extra\" entity=\"extranet_marcas\" name=\"Visibilidad otras marcas\" pk=\"id\" desc=\"marca\" load-function=\"loadMarcas\" conditions=\"[{field: \'propietario\',value: data.datos.cliente, not: true}]\" append-to-body=\"true\" ng-disabled=\"!status.editing\">\r\n						<!-- skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" -->\r\n					</ix-select-multiple>\r\n					</div>\r\n				</div>\r\n				\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/departamentos/departamentosCard.html","<strong> {{ item.descripcion }} </strong><br>");
$templateCache.put("app/FTBase/Mantenimientos/departamentos/departamentosForm.html","<div ng-controller=\"DepartamentosController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<!-- <button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.codigo)\"\r\n						uib-tooltip=\"{{ \'Traducciones\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" ng-disabled=\"!status.editing\"><i\r\n							class=\"fa fa-language\"></i></button> -->\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.codigo)\" uib-tooltip=\"{{ \'Traducciones\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/departamentos/traducciones_departamentos.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones áreas\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/extranet_marcas/extranet_marcasCard.html","<strong><translate>Marca</translate>: {{ item.marca }} </strong><br>\r\n<strong><translate>Propietario</translate>: {{item.propietarionombre}}</strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/extranet_marcas/extranet_marcasForm.html","<div ng-controller=\"Extranet_MarcasController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.marca\" name=\"Marca\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.propietario\" name=\"Propietario\" ng-disabled=\"!status.editing\" ng-required=\"true\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" append-to-body=\"true\"></ix-select>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/ft_estados/ft_estadosCard.html","<strong><translate>Estado</translate>: {{ item.descripcion }} </strong><br>\r\n<strong><translate>Código</translate>: {{item.codigo}}</strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/ft_estados/ft_estadosForm.html","<div ng-controller=\"Ft_EstadosController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.codigo\" name=\"Código\" ng-disabled=\"!data.datos.isNew\" ng-required=\"true\">\r\n						</ix-text>\r\n					</div>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.codigo)\" uib-tooltip=\"{{ \'Traducciones\'  | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.posicion\" name=\"Posición\" ng-disabled=\"!status.editing\" ng-required=\"true\" ix-number></ix-text>\r\n					</div>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/ft_estados/traducciones_ft_estados.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Estados\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/diccionarios/diccionariosCard.html","<strong> {{ item.descripcion }} </strong><br>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/diccionarios/diccionariosForm.html","<div ng-controller=\"DiccionariosController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<button ng-click=\"ordenarValores()\" class=\"btn btn-primary\" ng-show=\"status.editing\">\r\n							<translate>Ordenar valores</translate>\r\n						</button>\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing && data.datos.isNew\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-12\">\r\n						<div class=\"btn-toolbar\">\r\n							<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridDiccionariosValores.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridDiccionariosValores)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' |translate }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n							<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow(data.gridDiccionariosValores)\" uib-tooltip=\"{{ \'Nuevo\' | translate }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n						</div>\r\n						<div data-ui-grid=\"data.gridDiccionariosValores\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows data-ui-grid-exporter>\r\n						</div>\r\n					</div>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/laboratorios/laboratoriosCard.html","<strong><translate>Nombre</translate>: {{ item.nombre }} </strong>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/laboratorios/laboratoriosForm.html","<div ng-controller=\"LaboratoriosController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<!-- <ix-text ng-model=\"data.datos.id_laboratorio\" name=\"ID\" ng-disabled=\"!status.editing || !data.datos.isNew\" ng-required=\"true\"></ix-text> -->\r\n            <ix-text ng-model=\"data.datos.nombre\" name=\"Nombre\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.razon_social\" name=\"Razón social\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nif\" name=\"Nif\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.direccion\" name=\"Dirección\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.poblacion\" name=\"Población\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.cpostal\" name=\"Cód. Postal\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.pais\" name=\"Pais\" ng-disabled=\"!status.editing\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\" append-to-body=\"true\"></ix-select>\r\n					</div>\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.telefono\" name=\"Teléfono\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.fax\" name=\"fax\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.email\" name=\"E-mail\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.url\" name=\"Página Web\" ng-disabled=\"!status.editing\"></ix-text>\r\n						<ix-text-area ng-model=\"data.datos.notas\" name=\"Notas\" ng-class=\"resizable\" ng-disabled=\"!status.editing\" rows=\"4\"></ix-text-area>\r\n					</div>\r\n				</div>\r\n				<div class=\"row\" ng-show=\"data.datos.id_laboratorio\">\r\n					<div class=\"col-md-12\">\r\n						<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n							<uib-tab index=\"0\" heading=\"Contactos\" translate-attr=\"heading\" select=\"changeTab(0)\" ng-show=\"data.datos.id_laboratorio != 0\">\r\n								<div class=\"btn-toolbar\">\r\n									<button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridContactos.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridContactos)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n									<button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRowContactos()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridContactos\" ng-if=\"data.gridContactos && data.activeTab == 0\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter ng-style=\"{\'height\': \'calc(100vh - 580px)\' }\">\r\n									<div class=\"grid-loading\" ng-if=\"data.gridContactos.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab index=\"1\" heading=\"Ficheros\" translate-attr=\"heading\" select=\"changeTab(1)\" ng-show=\"data.datos.id_laboratorio != 0\">\r\n								<div class=\"btn-toolbar\">\r\n									<button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridFicheros.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFicheros)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i>\r\n									</button>\r\n									<button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addFicherosPopup()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i>\r\n									</button>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFicheros\" ng-if=\"data.gridFicheros && data.activeTab == 1\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter ng-style=\"{\'height\': \'calc(100vh - 580px)\' }\">\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFicheros.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n						</uib-tabset>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/proveedoresCard.html","<strong>{{ item.nombre }} </strong><br>\r\n<span ng-if=\"cfg.appCliente == \'ALCAMPO\'\">{{item.codigo}}</span>");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/proveedoresForm.html","<style>\r\n	.nota-importante{\r\n		font-size: 14px;\r\n		font-family: \'Roboto\', \'Helvetica\', \'Arial\', sans-serif;\r\n		line-height: 1;\r\n		padding: 15px;\r\n		margin: 0 15px 15px;\r\n		color: white;\r\n		background-color: rgb(241,110,110);\r\n	}\r\n	.row-alarm {\r\n    color: red;\r\n  }\r\n</style>\r\n<div ng-controller=\"ProveedoresController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.codigo\" name=\"Codigo proveedor\" ng-disabled=\"!status.editing || blockMainDetails\" ng-show=\"cfg.appCliente == \'ALCAMPO\'\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nombre\" name=\"Nombre\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.razon\" name=\"Razón social\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nif\" name=\"Nif\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\">\r\n						</ix-text>\r\n						<ix-text ng-model=\"data.datos.direccion\" name=\"Dirección\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.poblacion\" name=\"Población\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.cpostal\" name=\"Código postal\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing || blockMainDetails\" ng-required=\"true\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.pais\" ng-disabled=\"!status.editing || blockMainDetails\" name=\"Pais\" ng-required=\"true\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\"></ix-select>\r\n					</div>\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.telefono\" name=\"Teléfono\" ng-disabled=\"!status.editing || blockMainDetails\" ng-show=\"cfg.appCliente != \'ALCAMPO\'\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.fax\" name=\"Fax\" ng-disabled=\"!status.editing || blockMainDetails\" ng-show=\"cfg.appCliente != \'ALCAMPO\'\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.email\" name=\"E-mail\" ng-disabled=\"!status.editing || blockMainDetails\" ng-show=\"cfg.appCliente != \'ALCAMPO\'\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.tiempo_cumplimentacion\" name=\"Días para cumplimentar FT\" ng-disabled=\"!status.editing || blockMainDetails\" ix-number ng-show=\"cfg.appCliente != \'ALCAMPO\' &&((!extranetUser.laboratorio && !extranetUser.proveedor && !extranetUser.cliente) || (extranetUser.cliente == 1031))\"></ix-text>\r\n						<br>\r\n						<ix-options-si-no ng-model=\"data.datos.proveedor_riesgo\" name=\"Proveedor de riesgo\" ng-disabled=\"!status.editing || blockMainDetails\" ng-show=\"cfg.appCliente == \'ALCAMPO\'\"></ix-options-si-no>\r\n						<ix-options-si-no ng-model=\"data.datos.otros_datos_bloqueado\" name=\"Otros datos bloqueado\" ng-disabled=\"!status.editing || blockMainDetails\" ng-show=\"cfg.appCliente != \'ALCAMPO\'\"></ix-options-si-no>\r\n						<ix-options-si-no ng-model=\"data.datos.fabricantes_bloqueado\" name=\"Fabricantes bloqueados\" ng-disabled=\"!status.editing || blockMainDetails\" ng-show=\"cfg.appCliente != \'ALCAMPO\'\"></ix-options-si-no>\r\n						<ix-options-si-no ng-model=\"data.datos.bloqueado\" name=\"Plantas bloqueadas\" ng-disabled=\"!status.editing || blockMainDetails\" ng-show=\"cfg.appCliente != \'ALCAMPO\'\"></ix-options-si-no>\r\n						<ix-date ng-model=\"data.datos.fecha_alta\" name=\"Fecha alta\" ng-disabled=\"!status.editing || blockMainDetails\" ng-show=\"data.datos.baja == 0\"></ix-date>\r\n						<ix-options-si-no ng-model=\"data.datos.baja\" name=\"Baja\" ng-disabled=\"!status.editing || blockMainDetails\"></ix-options-si-no>\r\n						<ix-date ng-model=\"data.datos.fecha_baja\" name=\"Fecha baja\" ng-disabled=\"!status.editing || blockMainDetails\" ng-show=\"data.datos.baja == 1\"></ix-date>\r\n					</div>\r\n				</div>\r\n				<div class=\"row\" ng-show=\"data.datos.proveedor && data.datos[data.pk] != 0\">\r\n					<div class=\"col-md-12\">\r\n						<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n							<uib-tab index=\"0\" heading=\"Otros datos\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<div class=\"col-md-6\">\r\n											<ix-text ng-model=\"data.datos.registro_sanitario\" name=\"Registro sanitario\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										</div>\r\n\r\n									</div>\r\n									<div class=\"col-md-12\">\r\n										<h4>Contactos responsables</h4>\r\n										<hr>\r\n									</div>\r\n									<div class=\"col-md-6\">\r\n										<ix-text ng-model=\"data.datos.responsable_alerta\" name=\"Responsable alerta\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.tel_responsable_alerta\" name=\"Teléfono responsable alerta\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.email_responsable_alerta\" name=\"E-mail responsable alerta\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.cargo_responsable_alerta\" name=\"Cargo responsable alerta\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.responsable_calidad\" name=\"Responsable calidad\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.tel_responsable_calidad\" name=\"Teléfono responsable calidad\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.email_responsable_calidad\" name=\"E-mail responsable calidad\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n									</div>\r\n									<div class=\"col-md-6\" ng-show=\"cfg.appCliente != \'ALCAMPO\'\">\r\n										<ix-text ng-model=\"data.datos.responsable_comercial\" name=\"Responsable comercial\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.tel_responsable_comercial\" name=\"Teléfono responsable comercial\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\">\r\n										</ix-text>\r\n										<ix-text ng-model=\"data.datos.email_responsable_comercial\" name=\"E-mail responsable comercial\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.responsable_marketing\" name=\"Responsable marketing\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.tel_responsable_marketing\" name=\"Teléfono responsable marketing\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\">\r\n											</ix-text>\r\n											<ix-text ng-model=\"data.datos.email_responsable_marketing\" name=\"E-mail responsable marketing\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n											<ix-text ng-model=\"data.datos.email_envio_notificaciones\" name=\"E-mail notificación alarmas\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n									</div>\r\n								</div>\r\n								<!-- <div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<h4>Laboratorios</h4>\r\n										<hr />\r\n									</div>\r\n									<div class=\"col-md-6\">\r\n										<ix-text ng-model=\"data.datos.laboratorio_propio\" name=\"Laboratorio propio\"\r\n											ng-disabled=\"!status.editing\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.laboratorio_externo\" name=\"Laboratorio externo\"\r\n											ng-disabled=\"!status.editing\"></ix-text>\r\n									</div>\r\n								</div> -->\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<h4>Información proveedores de cosméticos <i>(solo rellenar en el caso que sea proveedor de cosméticos)</i></h4>\r\n										<hr>\r\n									</div>\r\n									<div class=\"col-md-6\">\r\n										<ix-text ng-model=\"data.datos.autorizacion_cosmeticos\" name=\"Autorización cosméticos\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.num_inscripcion_plaguicidas\" name=\"Num. inscripción plaguicidas\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<!-- <uib-tab index=\"1\" heading=\"Certificados proveedor\" translate-attr=\"heading\" select=\"changeTab(1)\">\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<div class=\"btn-toolbar\">\r\n											<a class=\"btn btn-danger pull-right\" role=\"button\"\r\n												data-ng-show=\"status.editing && !(extranetUser.cliente || extranetUser.proveedor || extranetUser.laboratorio)\"\r\n												data-ng-disabled=\"data.gridCertificadosProveedor.gridApi.selection.getSelectedRows().length==0\"\r\n												data-ng-click=\"deleteSelectedRows(data.gridCertificadosProveedor)\"\r\n												uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\"\r\n												translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n											<a class=\"btn btn-primary pull-right\" role=\"button\"\r\n												data-ng-show=\"status.editing\"\r\n												data-ng-click=\"addRow(data.gridCertificadosProveedor)\" uib-tooltip=\"{{ \'Nuevo\' }}\"\r\n												translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n										</div>\r\n										<div data-ui-grid=\"data.gridCertificadosProveedor\" ng-if=\"data.activeTab == 1 && data.gridCertificadosProveedor\"\r\n											data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav\r\n											data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning\r\n											data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize\r\n											ui-grid-clipboard>\r\n											<div class=\"grid-loading\"\r\n												ng-if=\"data.gridCertificadosProveedor.ixIsLoading\">\r\n												<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n											</div>\r\n										</div>\r\n									</div>\r\n								</div>\r\n							</uib-tab> -->\r\n							<uib-tab index=\"1\" heading=\"Fabricantes\" translate-attr=\"heading\" select=\"changeTab(1)\" ng-show=\"data.datos.proveedor != 0 && !cfg.ocultar_fabricante\">\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.datos.fabricantes_bloqueado\" data-ng-disabled=\"data.gridFabricantes.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFabricantes)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.datos.fabricantes_bloqueado\" data-ng-click=\"addRow(data.gridFabricantes)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFabricantes\" ng-if=\"data.activeTab == 1\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFabricantes.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab index=\"2\" heading=\"Plantas\" translate-attr=\"heading\" select=\"changeTab(2)\" ng-show=\"data.datos.proveedor != 0\">\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.datos.bloqueado\" data-ng-disabled=\"data.gridFabricantesPlantas.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFabricantesPlantas)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.datos.bloqueado\" data-ng-click=\"addRow(data.gridFabricantesPlantas)\" uib-tooltip=\"{{ \'Nueva planta\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFabricantesPlantas\" ng-if=\"data.activeTab == 2\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFabricantesPlantas.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab ng-show=\"data.datos.proveedor != 0\" index=\"3\" heading=\"Certificados y otros ficheros\" translate-attr=\"heading\" select=\"changeTab(3)\">\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<div class=\"nota-importante\">\r\n											<translate>Nota Importante Certificados Plantas</translate>\r\n										</div>\r\n									</div>\r\n								</div>\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridFicheros.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFicheros)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addFicheros()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFicheros\" ng-if=\"data.activeTab == 3\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFicheros.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab index=\"4\" heading=\"Auditorias\" translate-attr=\"heading\" select=\"changeTab(4)\" ng-show=\"data.datos.proveedor != 0\">\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"openEditAuditoria()\" uib-tooltip=\"{{ \'Crear nueva auditoría\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridAuditorias\" ng-if=\"data.activeTab == 4\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridAuditorias.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab index=\"5\" heading=\"Productos\" translate-attr=\"heading\" select=\"changeTab(5)\" ng-show=\"data.datos.proveedor != 0\">\r\n								<div class=\"btn-toolbar\">\r\n									<a ng-if=\"cfg.appCliente == \'ALCAMPO\'\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"nuevoProducto()\" uib-tooltip=\"{{ \'Crear nuevo producto\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridProductos\" ng-if=\"data.activeTab == 5\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridProductos.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n						</uib-tabset>\r\n					</div>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_analisis/tipos_analisisCard.html","<strong><translate>Nombre</translate>: {{ item.descripcion }} </strong>");
$templateCache.put("app/FTBase/Mantenimientos/tipos_analisis/tipos_analisisForm.html","<div ng-controller=\"TiposAnalisisController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\" uib-tooltip=\"{{ \'Traducciones\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-options-si-no ng-model=\"data.datos.extra\" name=\"Extra\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n          </div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_analisis/traducciones_tipos_analisis.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Tipos Análisis\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_ft/tipos_fichero_ftCard.html","<strong><translate>Nombre</translate>: {{ item.descripcion }} </strong>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_ft/tipos_fichero_ftForm.html","<div ng-controller=\"TiposFicheroFtController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<!-- <ix-text ng-model=\"data.datos.id_laboratorio\" name=\"ID\" ng-disabled=\"!status.editing || !data.datos.isNew\" ng-required=\"true\"></ix-text> -->\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\" uib-tooltip=\"{{ \'Traducciones\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-options-si-no ng-model=\"data.datos.caducidad_obligatoria\" name=\"Caducidad obligatoria\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n						<ix-options-si-no ng-model=\"data.datos.especificar_producto\" name=\"Especificar producto\" ng-disabled=\"!status.editing\" ng-required=\"false\"></ix-options-si-no>\r\n					</div>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_ft/traducciones_tipos_fichero_ft.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Tipos Fichero FT\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_certificados_proveedor/tipos_certificados_proveedorCard.html","<strong>Nombre: {{ item.descripcion }} </strong>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_certificados_proveedor/tipos_certificados_proveedorForm.html","<div ng-controller=\"TiposCertificadosProveedorController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.tipo_fichero_proveedor\" name=\"Tipo fichero proveedor\" ng-disabled=\"!status.editing\" entity=\"tipos_fichero_proveedor\" pk=\"id\" desc=\"descripcion\" append-to-body=\"true\" ng-required=\"false\"></ix-select>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_laboratorio/tipos_fichero_laboratorioCard.html","<strong><translate>Nombre</translate>: {{ item.descripcion }} </strong>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_laboratorio/tipos_fichero_laboratorioForm.html","<div ng-controller=\"TiposFicheroLaboratorioController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\" uib-tooltip=\"{{ \'Traducciones\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-options-si-no ng-model=\"data.datos.caducidad_obligatoria\" name=\"Caducidad obligatoria\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n						</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_laboratorio/traducciones_tipos_fichero_laboratorio.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Tipos Ficheros laboratorio\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_proveedor/tipos_fichero_proveedorCard.html","<strong><translate>Nombre</translate>: {{ item.descripcion }} </strong>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_proveedor/tipos_fichero_proveedorForm.html","<div ng-controller=\"TiposFicheroProveedorController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\" uib-tooltip=\"{{ \'Traducciones\' | translate }}\" tooltip-placement=\"bottom\" ng-disabled=\"!status.editing\"><i class=\"fa fa-language\"></i></button>\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-options-si-no ng-model=\"data.datos.certificado\" name=\"Es certificado\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n						<ix-options-si-no ng-model=\"data.datos.caducidad_obligatoria\" name=\"Caducidad obligatoria\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n						</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/tipos_fichero_proveedor/traducciones_tipos_fichero_proveedor.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Traducciones Tipos Ficheros Proveedor\" title-left-param=\"descripcion\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div style=\"width:100%\">\r\n					<div class=\"btn-toolbar\">	\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"grid.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(grid)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n						<button style=\"padding: 3px 6px; margin: 0\" class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addRow()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n					</div>\r\n					<div ng-if=\"grid\" class=\"full-ui-grid\" data-ui-grid=\"grid\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n						<div class=\"grid-loading\" ng-if=\"grid.ixIsLoading\">\r\n							<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/acciones/add_documentos_analitica_ft_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Agregar boletín\"></ix-popup-tool-bar>\r\n    <div class=\"scrolldiv-content\">\r\n        <div class=\"modal-body\">\r\n            <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                        <div>\r\n                            <div ngf-drop ngf-select ng-model=\"data.filesToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n                                <translate>Arrastrar o hacer click aquí para subir un documento</translate>\r\n                            </div>\r\n                            <ul>\r\n                                <li ng-repeat=\"f in data.filesToUpload\" style=\"font:medium\">{{f.name}} {{f.$error}}\r\n                                    {{f.$errorParam}}</li>\r\n                            </ul>\r\n                        </div>\r\n                        <div>\r\n                            <ix-select ng-model=\"data.datos.tipo\" name=\"Tipo de informe\" pk=\"id\" desc=\"nombre\" entity=\"tipos_boletines_analisis\" conditions=\"[{field: \'id\', value: 3,not: !(data.tipo_analisis==3) }]\" append-to-body=\"true\" ng-required=\"true\"></ix-select>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/acciones/add_ft_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Crear nueva ficha técnica\"></ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n						<ix-text ng-model=\"nuevaft.titulo\" name=\"Título\" ng-required=\"true\"></ix-text>\r\n						<ix-select ng-model=\"nuevaft.cliente\" name=\"Cliente Master\" entity=\"clientes\" pk=\"cliente\" desc=\"nombre\" ng-required=\"true\"></ix-select>\r\n						<ix-select ng-model=\"nuevaft.ft_version\" name=\"Tipo FT\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" ng-required=\"true\"></ix-select>\r\n						<ix-text ng-model=\"nuevaft.ft_componentes\" name=\"Componentes\"></ix-text>\r\n						<ix-select ng-model=\"nuevaft.idioma\" name=\"Idioma Master\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadIdiomas\" ng-required=\"true\"></ix-select>\r\n						<ix-options-si-no ng-model=\"nuevaft.traducible\" name=\"Traducible\"></ix-options-si-no>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/acciones/analitica_ft_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Analítica\">\r\n        <button id=\"acciones-button\" uib-tooltip=\"Finalizar\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"finalizar()\" ng-show=\"!$resolve.is_new && $resolve.extranetUser.laboratorio && (data.datos.estado == \'PLANIFICADO\' || data.datos.estado == \'EN CORRECCION\')\">\r\n            Finalizar\r\n        </button>\r\n    </ix-popup-tool-bar>\r\n    <div class=\"scrolldiv-content\">\r\n        <div class=\"modal-body\">\r\n            <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n                <div class=\"row\">\r\n                    <h4>Cabecera</h4>\r\n                    <hr>\r\n                    <!--Cabecera-->\r\n                    <div class=\"col-md-6\">\r\n                        <ix-text ng-model=\"data.datos.id_ficha_tecnica\" name=\"Ficha técnica\" ng-disabled=\"save\">\r\n                        </ix-text>\r\n                        <ix-text ng-model=\"data.datos.ean\" name=\"Ean\" ng-disabled=\"save\"></ix-text>\r\n                        <ix-text ng-model=\"data.datos.marca_desc\" name=\"Marca\" ng-disabled=\"true\"></ix-text>\r\n                        <ix-text ng-model=\"data.datos.proveedor\" name=\"Proveedor\" ng-disabled=\"true\"></ix-text>\r\n                        <ix-text ng-model=\"data.datos.cod_interno\" name=\"Código interno\" ng-disabled=\"true\"></ix-text>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <ix-text ng-model=\"data.datos.denominacion\" name=\"Denominación\" ng-disabled=\"true\"></ix-text>\r\n                        <!-- Campos a rellenar por cliente-->\r\n                        <ix-select ng-model=\"data.datos.id_laboratorio\" name=\"Laboratorio\" entity=\"laboratorios\" pk=\"id_laboratorio\" desc=\"nombre\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-select>\r\n                        <ix-text ng-model=\"data.datos.mes_planificacion\" name=\"Mes planificación\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-text>\r\n                        <ix-text ng-model=\"data.datos[\'año_planificacion\']\" name=\"Año planificación\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-text>\r\n                        <!--Tipo analisis-->\r\n                        <ix-select ng-model=\"data.datos.tipo_analisis\" name=\"Tipo análisis\" entity=\"ft_tipo_analisis\" pk=\"id\" desc=\"descripcion\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-select>\r\n                        <ix-text ng-model=\"data.datos.parametro\" name=\"Parámetro\" ng-show=\"data.datos.tipo_analisis == 2\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-text>\r\n                        <ix-text ng-model=\"data.datos.num_unidades\" name=\"Num. unidades\" ng-show=\"data.datos.tipo_analisis == 2\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                        </ix-text>\r\n                        <button class=\"btn btn-primary pull-right\" ng-show=\"$resolve.is_new && !save\" ng-click=\"cargarCamposLectura()\" ng-disabled=\"!$resolve.extranetUser.cliente || data.datos.estado == \'FINALIZADO\' || data.datos.estado == \'FINALIZADO-CORREGIDO\'\">\r\n                            Cargar\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <h4>Estado</h4>\r\n                    <hr>\r\n                    <!--Estado-->\r\n                    <div class=\"col-md-6\">\r\n                        <ix-text ng-model=\"data.datos.estado\" name=\"Estado\" ng-disabled=\"true\"></ix-text>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <ix-date ng-model=\"data.datos.fecha_finalizacion\" name=\"Fecha finalización\" ng-disabled=\"true\"></ix-date>\r\n                    </div>\r\n                </div>\r\n                <div ng-show=\"!$resolve.is_new\">\r\n                    <fieldset ng-disabled=\"deshabilitarResultados()\">\r\n                        <div class=\"row\">\r\n                            <h4>Resultados</h4>\r\n                            <hr>\r\n                            <!--Resultados-->\r\n                            <div class=\"col-md-6\">\r\n                                <ix-date ng-model=\"data.datos.fecha_realizacion\" name=\"Fecha análisis\" ng-show=\"false\"></ix-date>\r\n                                <ix-text ng-model=\"data.datos.ref_analisis\" name=\"Referéncia análisis\"></ix-text>\r\n                                <ix-text ng-model=\"data.datos.ref_analisis_corregido\" name=\"Análisis corregido\" ng-disabled=\"true\"></ix-text>\r\n                                <ix-select ng-model=\"data.datos.estado_incidencia_planificacion\" name=\"Estado incidencia\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresEstadosIncidencia\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                                </ix-select>\r\n                                <ix-text-area ng-model=\"data.datos.incidencias_planificacion\" name=\"Incidencias planificación\" rows=\"4\"></ix-text-area>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-6\">\r\n                                <h5>\r\n                                    Resultados analitica\r\n                                </h5>\r\n                                <hr>\r\n                                <div>\r\n                                    <!--Resultados analitica-->\r\n                                    <ix-select ng-model=\"data.datos.resultado_analisis\" name=\"Resultado analítica\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresResultados\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\" on-select=\"cleanValues\">\r\n                                    </ix-select>\r\n                                </div>\r\n                                <div ng-show=\"data.datos.resultado_analisis == \'NO CONFORME\' || data.datos.resultado_analisis == \'INCORRECTO\'\">\r\n                                    <ix-select-multiple ng-model=\"data.datos.desviacion_analisis\" name=\"Desviaciones analítica\" pk=\"descripcion\" desc=\"descripcion\" load-function=\"load_desviaciones_analiticas\" ng-disabled=\"deshabilitarResultados()\">\r\n                                    </ix-select-multiple>\r\n                                    <ix-text-area ng-model=\"data.datos.descripcion_desviacion_analisis\" name=\"Descripción detallada de las desviaciones\" rows=\"4\">\r\n                                    </ix-text-area>\r\n                                    <ix-select-multiple ng-model=\"data.datos.acciones_analisis\" name=\"Acciones correctoras\" pk=\"descripcion\" desc=\"descripcion\" load-function=\"load_acciones_correctoras\" ng-disabled=\"deshabilitarResultados()\" ng-show=\"data.datos.resultado_analisis == \'INCORRECTO\'\">\r\n                                    </ix-select-multiple>\r\n                                </div>\r\n                                <!-- PARA TIPO ANÁLISIS SOMMELIER -->\r\n                                <div ng-show=\"data.datos.tipo_analisis == 5\">\r\n                                    <ix-select ng-model=\"data.datos.puntuacion_vinos\" name=\"Puntuación\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresPuntuacionVinos\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                                    </ix-select>\r\n                                    <ix-text-area ng-model=\"data.datos.valoracion_sensorial\" name=\"Valoración sensorial\" rows=\"4\"></ix-text-area>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class=\"col-md-6\">\r\n                                <h5>\r\n                                    Resultados etiquetado\r\n                                </h5>\r\n                                <hr>\r\n                                <!--Resultados etiquetado-->\r\n                                <ix-select ng-model=\"data.datos.resultado_etiquetado\" name=\"Resultado etiquetado\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresResultados\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                                </ix-select>\r\n                                <div>\r\n                                    <div ng-show=\"data.datos.resultado_etiquetado == \'INCORRECTO\'\">\r\n                                        <ix-select-multiple ng-model=\"data.datos.desviacion_etiquetado\" name=\"Desviaciones etiquetado\" pk=\"descripcion\" desc=\"descripcion\" load-function=\"load_desviaciones_etiquetados\" ng-disabled=\"deshabilitarResultados()\">\r\n                                        </ix-select-multiple>\r\n                                        <ix-text-area ng-model=\"data.datos.descripcion_desviacion_etiquetado\" name=\"Descripción detallada de las desviaciones\" rows=\"4\"></ix-text-area>\r\n                                    </div>\r\n                                    <ix-text-area ng-model=\"data.datos.error_ft\" name=\"Error FT\" rows=\"4\"></ix-text-area>\r\n                                    <ix-select ng-model=\"data.datos.revision_nutriscore\" name=\"Revisión Nutriscore\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresRevisionNutriscore\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                                    </ix-select>\r\n                                    <ix-select ng-model=\"data.datos.puntuacion_nutriscore\" name=\"Puntuación Nutriscore\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresPuntuacionNutriscore\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                                    </ix-select>\r\n                                </div>\r\n\r\n                                <ix-text-area ng-if=\"data.datos.estado != \'PLANIFICADO\' && data.datos.estado != \'EN CORRECCION\'\" ng-model=\"data.datos.revision_online\" name=\"Revisión OnLine\" rows=\"4\">\r\n                                </ix-text-area>\r\n                                <ix-select-multiple ng-if=\"data.datos.estado == \'PLANIFICADO\' || data.datos.estado == \'EN CORRECCION\'\" ng-model=\"data.datos.revision_online\" name=\"Revisión OnLine\" pk=\"descripcion\" desc=\"descripcion\" load-function=\"load_valores_revision_online\">\r\n                                </ix-select-multiple>\r\n                            </div>\r\n                        </div>\r\n                </fieldset></div>\r\n                <div class=\"row\" ng-show=\"data.datos.tipo_analisis == 3\">\r\n                    <div class=\"col-md-12\">\r\n                        <h5>\r\n                            Valores Posicionamiento\r\n                        </h5>\r\n                        <hr>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <ix-text-area ng-model=\"data.datos.comentario_envases\" name=\"Comentario Envases\" rows=\"4\"></ix-text-area>\r\n                        <ix-text-area ng-model=\"data.datos.comentario_receta\" name=\"Comentario Receta\" rows=\"4\"></ix-text-area>\r\n                        <ix-text ng-model=\"data.datos.valoracion_producto\" name=\"Valoración producto AUCHAN\" ng-disabled=\"deshabilitarResultados()\" ix-number with-decimals=\"2\"></ix-text>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <ix-select ng-model=\"data.datos.tipo_estudio\" name=\"Tipo estudio\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresTiposEstudio\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                        </ix-select>\r\n                        <ix-select ng-model=\"data.datos.categorizacion\" name=\"Categorización\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresCategorizaciones\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados() || data.datos.resultado_analisis == \'INCORRECTO\'\">\r\n                        </ix-select>\r\n                        <ix-text ng-model=\"data.datos.valoracion_global\" name=\"Valoración global\" ng-disabled=\"deshabilitarResultados()\" ix-number with-decimals=\"2\">\r\n                        </ix-text>\r\n                        <ix-text ng-model=\"data.datos.intencion_compra\" name=\"Intención de compra\" ng-disabled=\"deshabilitarResultados()\" ix-number with-decimals=\"2\">\r\n                        </ix-text>\r\n                        <ix-select ng-model=\"data.datos.perfil_nutricional\" name=\"Perfil nutricional\" pk=\"valor\" desc=\"valor\" load-function=\"loadValoresPerfilesNutricionales\" append-to-body=\"true\" ng-disabled=\"deshabilitarResultados()\">\r\n                        </ix-select>\r\n                    </div>\r\n                </div>\r\n\r\n                <div ng-show=\"!$resolve.is_new\" class=\"row\" style=\"padding: 2em 2em\">\r\n                    <div class=\"col-md-12\">\r\n                        <h5>\r\n                            Informes\r\n                        </h5>\r\n                        <hr>\r\n                    </div>\r\n                    <div class=\"col\" ng-if=\"data.griddocumentos\">\r\n                        <div>\r\n                            <div class=\"btn-toolbar\">\r\n                                <button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"data.datos.estado != \'FINALIZADO\'\" data-ng-disabled=\"data.griddocumentos.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.griddocumentos)\" uib-tooltip=\"{{ \'Eliminar documentos seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n                                <button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-disabled=\"deshabilitarResultados()\" data-ng-show=\"status.editing\" data-ng-click=\"addRow(data.griddocumentos)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n                            </div><br>\r\n                            <div data-ui-grid=\"data.griddocumentos\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate></div>\r\n                        </div>\r\n                        <div>\r\n                            <div class=\"footer\">\r\n                                <div ix-datetime-grid-generada grid=\"data.griddocumentos\"></div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                \r\n        </form></div>\r\n\r\n        \r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/acciones/copiar_foto_producto_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Copiar foto producto del ean: \" title-left-param=\"data.eanorigen\"></ix-popup-tool-bar>\r\n    <div ng-scrollbars class=\"scrolldiv\">\r\n        <div class=\"scrolldiv-content\">\r\n            <div class=\"modal-body\">\r\n                <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                            <ix-text ng-model=\"datos.eannuevo\" name=\"Ean destino\" ng-minlength=\"13\" ng-maxlength=\"13\" ng-required=\"true\"></ix-text>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/acciones/desbloquear_masivamente_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Bloquear/Desbloquear masivamente\"></ix-popup-tool-bar>\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n          <div class=\"row\">\r\n            <ix-select-multiple ng-model=\"data.preguntas\" entity=\"ft_preguntas\" pk=\"id_pregunta\" desc=\"pregunta_formulario\" extra-field=\"orden\" name=\"Preguntas\" conditions=\"[{field: \'version\', value: tipoFT},{field: \'activa\', value: \'1\'}]\" ng-required=\"true\"></ix-select-multiple>\r\n            <ix-select ng-model=\"data.bloqueardesbloquear\" name=\"Bloquear/Desbloquear\" pk=\"id\" desc=\"nombre\" load-function=\"loadBloquearDesbloquear\" append-to-body=\"true\" ng-required=\"true\"></ix-select>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/FTBase/ListadosFT/acciones/imprimir_ft_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Descargar Ficha Técnica\"></ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n        <div class=\"row\">\r\n					<div class=\"col-md-12\">\r\n						<ix-radio ng-model=\"datos.tipo_doc\" ng-if=\"!extranetUser.laboratorio\" options=\'[{value: \"PDF\", text: \"PDF\"},{value: \"MSWORD\", text: \"Word\"}]\' name=\"tipo_doc\" label=\"Formato\" ng-required=\"true\"></ix-radio>\r\n            <ix-radio ng-model=\"datos.tipo_doc\" ng-if=\"extranetUser.laboratorio\" options=\'[{value: \"PDF\", text: \"PDF\"}]\' name=\"tipo_doc\" label=\"Formato\" ng-required=\"true\"></ix-radio>\r\n					</div>\r\n					<div class=\"col-md-12\">\r\n						<ix-radio ng-model=\"reducida\" options=\'[{value: 0, text: \"Completa\"},{value: 1, text: \"Reducida\"}]\' name=\"reducida\" label=\"Tipo\" ng-required=\"true\"></ix-radio>\r\n					</div>\r\n					<div class=\"col-md-12\" ng-show=\"traducible\">\r\n						<!-- <ix-radio ng-model=\"idioma\" options=\'idiomas\' name=\"idioma\" label=\"Idioma\" ng-required=\"traducible\"></ix-radio> -->\r\n            <ix-radio ng-model=\"idioma\" options=\"idiomas\" name=\"idioma\" label=\"Idioma\"></ix-radio>\r\n					</div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ListadosFT/acciones/subir_foto_producto_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Cargar Fichero\"></ix-popup-tool-bar>\r\n    <div ng-scrollbars class=\"scrolldiv\">\r\n        <div class=\"scrolldiv-content\">\r\n            <div class=\"modal-body\">\r\n                <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                            <div class=\"col-md-8\">\r\n                                <input ng-disabled=\"!status.editing\" class=\"btn\" type=\"file\" ngf-select ngf-multiple=\"true\" ng-model=\"archivosToUpload\" name=\"archivo\" ngf-max-size=\"{{maxUploadFileSize}}\" ngf-model-invalid=\"errorFile\">\r\n                                <button ng-disabled=\"!status.editing\" class=\"btn btn-danger\" ng-click=\"archivosToUpload = null\" ng-show=\"archivosToUpload\">Borrar</button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                            <ul>\r\n                                <li ng-repeat=\"error in erroresUpload\">{{error.Msg}}</li>\r\n                            </ul>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/FTBase/ListadosFT/acciones/versionar_masivamente_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Versionar masivamente\"></ix-popup-tool-bar>\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n          <div class=\"row\">\r\n            <ix-text ng-model=\"data.comentario\" name=\"Comentario FT origen\" is-filter=\"true\"></ix-text>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/FTBase/MantenimientosEuromadi/categorias_certificaciones_proveedores/categorias_certificaciones_proveedoresCard.html","<strong>Nombre: {{ item.categoria }} </strong>");
$templateCache.put("app/FTBase/MantenimientosEuromadi/categorias_certificaciones_proveedores/categorias_certificaciones_proveedoresForm.html","<div ng-controller=\"CategoriasCertificacionesProveedorController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.categoria\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<!-- <button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\"\r\n						uib-tooltip=\"{{ \'Traducciones\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" ng-disabled=\"!status.editing\"><i\r\n						class=\"fa fa-language\"></i></button> -->\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/MantenimientosEuromadi/tipos_auditorias_plantas/tipos_auditorias_plantasCard.html","<strong>Categoria: {{ item.descripcioncategoria }} </strong><br>\r\n<strong>Tipo: {{ item.descripcion }} </strong>");
$templateCache.put("app/FTBase/MantenimientosEuromadi/tipos_auditorias_plantas/tipos_auditorias_plantasForm.html","<div ng-controller=\"TiposAuditoriasPlantasController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n            <ix-select ng-model=\"data.datos.categoria\" name=\"Categoría\" entity=\"categorias_certificaciones_proveedores\" pk=\"id\" desc=\"categoria\" ng-disabled=\"!status.editing\" ng-required=\"true\" append-to-body=\"true\">\r\n            </ix-select>\r\n			<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n			<ix-text ng-model=\"data.datos.prioridad_homologacion\" name=\"Prioridad homologación\" ng-disabled=\"!status.editing\" ng-required=\"true\" ix-number></ix-text>\r\n			<ix-text ng-model=\"data.datos.anos_vigencia\" name=\"Años vigencia\" ng-disabled=\"!status.editing\" ix-number></ix-text>\r\n					</div>\r\n					<!-- <button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\"\r\n						uib-tooltip=\"{{ \'Traducciones\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" ng-disabled=\"!status.editing\"><i\r\n						class=\"fa fa-language\"></i></button> -->\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/MantenimientosEuromadi/tipos_fichero_proveedor/tipos_fichero_proveedorCard.html","<strong>Nombre: {{ item.descripcion }} </strong>");
$templateCache.put("app/FTBase/MantenimientosEuromadi/tipos_fichero_proveedor/tipos_fichero_proveedorForm.html","<div ng-controller=\"TiposFicherosCertificadosAuditoriasController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.descripcion\" name=\"Descripción\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n					</div>\r\n					<!-- <button class=\"btn btn-primary\" role=\"button\" data-ng-click=\"openPopupTraduccion(data.datos.id)\"\r\n						uib-tooltip=\"{{ \'Traducciones\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" ng-disabled=\"!status.editing\"><i\r\n						class=\"fa fa-language\"></i></button> -->\r\n				</div>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-options-si-no ng-model=\"data.datos.certificado\" name=\"Es certificado\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n            <ix-select ng-model=\"data.datos.categoria\" name=\"Categoría\" entity=\"categorias_certificaciones_proveedores\" pk=\"id\" desc=\"categoria\" ng-show=\"data.datos.certificado\" ng-disabled=\"!status.editing\" ng-required=\"data.datos.certificado\" append-to-body=\"true\">\r\n            </ix-select>\r\n			<ix-text ng-model=\"data.datos.prioridad_homologacion\" name=\"Prioridad homologación\" ng-disabled=\"!status.editing\" ng-required=\"data.datos.certificado\" ng-show=\"data.datos.certificado\" ix-number></ix-text>\r\n						<ix-options-si-no ng-model=\"data.datos.caducidad_obligatoria\" name=\"Caducidad obligatoria\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-options-si-no>\r\n          </div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_preguntas/acciones/editar_pregunta_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Editar pregunta\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n            <uib-tab index=\"0\" heading=\"General\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                  <ix-select ng-model=\"pregunta.version\" name=\"Tipo FT\" entity=\"ft_versiones\" pk=\"version\" desc=\"nombre\" append-to-body=\"true\"></ix-select>\r\n                  <ix-select ng-model=\"data.nivel1\" name=\"Nivel 1\" entity=\"ft_niveles\" pk=\"nivel1\" desc=\"nivel1\" extra-field=\"nombre\" conditions=\"[{field: \'version\',value: pregunta.version},{field: \'nivel2\',value: \'0\'},{field: \'nivel3\',value: \'0\'}]\" ng-disabled=\"!pregunta.version\" append-to-body=\"true\"></ix-select>\r\n                  <ix-select ng-model=\"data.nivel2\" name=\"Nivel 2\" entity=\"ft_niveles\" pk=\"nivel2\" desc=\"nivel2\" extra-field=\"nombre\" conditions=\"[{field: \'version\',value: pregunta.version},{field: \'nivel1\',value: data.nivel1 },{field: \'nivel2\',value: \'0\', op:1},{field: \'nivel3\',value: \'0\'}]\" ng-disabled=\"!data.nivel1\" append-to-body=\"true\"></ix-select>\r\n                  <ix-select ng-model=\"data.nivel3\" name=\"Nivel 3\" entity=\"ft_niveles\" pk=\"nivel3\" desc=\"nivel3\" extra-field=\"nombre\" conditions=\"[{field: \'version\',value: pregunta.version},{field: \'nivel1\',value: data.nivel1 },{field: \'nivel2\',value: data.nivel2 },{field: \'nivel3\',value: \'0\', op:1}]\" ng-disabled=\"!data.nivel2\" append-to-body=\"true\"></ix-select>\r\n                  <!-- <ix-text ng-model=\"pregunta.nivel\" name=\"Nivel\" ix-number></ix-text> -->\r\n                  <ix-text ng-model=\"pregunta.orden\" name=\"Orden\" ix-number></ix-text>\r\n                  <ix-text ng-model=\"pregunta.pregunta_formulario\" name=\"Pregunta (En formulario)\" ng-disabled=\"true\"></ix-text>\r\n                  <!-- <ix-text ng-model=\"pregunta.pregunta_informe\" name=\"Pregunta (En impresos)\"></ix-text> -->\r\n                  <ix-options-si-no ng-model=\"pregunta.activa\" name=\"Activa\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.obligatoria\" name=\"Obligatoria\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.preguntar_componente\" name=\"Por componente\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.preguntar_obs\" name=\"Observaciones\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.dependencia_etiquetado\" name=\"Dependencia etiquetado\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.separador_linea\" name=\"Linea de separación\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.muestra_en_recepcion\" name=\"Muestra en recepción\"></ix-options-si-no>\r\n                  <ix-text ng-model=\"pregunta.ayuda_pregunta\" name=\"Info pregunta (tooltip)\"></ix-text>\r\n									<!-- <ix-options-si-no ng-model=\"pregunta.traducible\" name=\"Traducible\"></ix-options-si-no> -->\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                  <ix-options-si-no ng-model=\"pregunta.bucle\" name=\"Tabla\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.sub_bucle\" name=\"Sub Tabla\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.resultados_fijos\" name=\"Resultados fijos\"></ix-options-si-no>\r\n                  <ix-text ng-model=\"pregunta.titulo_primera_columna\" name=\"Título en primera columna\"></ix-text>\r\n                  <ix-text ng-model=\"pregunta.dimensiones\" name=\"Dimensiones columnas\"></ix-text>\r\n                  <ix-options-si-no ng-model=\"pregunta.bloquear_valor_b\" name=\"Bloqueo respuesta\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.bloquear_borrar_b\" name=\"Bloqueo eliminar filas\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.bloquear_insert_b\" name=\"Bloquear agregar filas\"></ix-options-si-no>\r\n                  <ix-options-si-no ng-model=\"pregunta.adjuntar_fichero\" name=\"Adjuntar fichero\"></ix-options-si-no>\r\n                  <ix-select-multiple ng-model=\"pregunta.tipos_fichero\" name=\"Tipo fichero\" entity=\"tipos_fichero_ft\" pk=\"id\" desc=\"descripcion\"></ix-select-multiple>\r\n                  <ix-options-si-no ng-model=\"pregunta.fichero_obligatorio\" name=\"Fichero obligatorio\"></ix-options-si-no>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-11\">\r\n                      <ix-text ng-model=\"pregunta.imagen\" name=\"Archivo imagen\" ng-disabled=\"true\"></ix-text>\r\n                    </div>\r\n                    <div class=\"col-md-1\">\r\n                      <button class=\"btn btn-danger\" role=\"button\" data-ng-click=\"eliminarImagenPregunta()\" ng-disabled=\"!pregunta.imagen\" uib-tooltip=\"{{\'Eliminar imagen\'}}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\">\r\n                        <i class=\"fa fa-trash-o\"></i>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-2\"></div>\r\n                    <div class=\"col-md-10\">\r\n                      <input ng-disabled=\"fileUploaded\" class=\"btn\" type=\"file\" ngf-select ng-model=\"data.archivosToUpload\" name=\"archivo\" ngf-max-size=\"{{maxUploadFileSize}}\" ngf-model-invalid=\"errorFile\">\r\n                        <!-- <button ng-disabled=\"data.fileUploaded || data.uploadingFile\" class=\"btn btn-danger\" ng-click=\"data.archivo = null\" ng-show=\"data.archivosToUpload\">Borrar</button> -->\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </uib-tab>\r\n            <uib-tab index=\"1\" heading=\"Pregunta principal\" translate-attr=\"heading\" select=\"changeTab(1)\">\r\n              <ix-text ng-model=\"pregunta.pregunta_formulario\" name=\"Pregunta (En formulario)\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.pregunta_informe\" name=\"Pregunta (En impresos)\"></ix-text>\r\n              <ix-text-area ng-model=\"pregunta.nota_pregunta\" name=\"Nota explicativa\" rows=\"4\"></ix-text-area>\r\n              <ix-select ng-model=\"pregunta.tipo_valor\" name=\"Tipo valor\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_pregunta\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_pregunta\" name=\"Diccionario pregunta\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor==\'DICCIONARIO\' || pregunta.tipo_valor==\'DICCIONARIO_MULTIPLE\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor\" name=\"Formato respuesta\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo\" name=\"Val. minimo respuesta\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo\" name=\"Val. máximo respuesta\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.traducible\" name=\"Traducible\"></ix-options-si-no>\r\n              <ix-text ng-model=\"pregunta.valor_defecto\" name=\"Valor por defecto\" ng-show=\"pregunta.bucle == 0\"></ix-text>\r\n            </uib-tab>\r\n            <uib-tab index=\"2\" heading=\"Subpregunta 1\" translate-attr=\"heading\" select=\"changeTab(2)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta1\" name=\"Subpregunta 1\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta1\" name=\"Tipo valor subresp 1\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta1\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta1==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta1\" name=\"Diccionario subpregunta 1\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta1==\'DICCIONARIO\' || pregunta.tipo_valor_sub_pregunta1==\'DICCIONARIO_MULTIPLE\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta1\" name=\"Formato subresp 1\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta1\" name=\"Val. min subresp 1\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta1\" name=\"Val. max subresp 1\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta1\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta1\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta1_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"3\" heading=\"Subpregunta 2\" translate-attr=\"heading\" select=\"changeTab(3)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta2\" name=\"Subpregunta 2\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta2\" name=\"Tipo valor subresp 2\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta2\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta2==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta2\" name=\"Diccionario subpregunta 2\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta2==\'DICCIONARIO\' || pregunta.tipo_valor_sub_pregunta2==\'DICCIONARIO_MULTIPLE\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta2\" name=\"Formato subresp 2\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta2\" name=\"Val. min subresp 2\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta2\" name=\"Val. max subresp 2\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta2\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta2\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta2_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"4\" heading=\"Subpregunta 3\" translate-attr=\"heading\" select=\"changeTab(4)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta3\" name=\"Subpregunta 3\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta3\" name=\"Tipo valor subresp 3\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta3\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta3==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta3\" name=\"Diccionario subpregunta 3\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta3==\'DICCIONARIO\' || pregunta.tipo_valor_sub_pregunta3==\'DICCIONARIO_MULTIPLE\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta3\" name=\"Formato subresp 3\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta3\" name=\"Val. min subresp 3\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta3\" name=\"Val. max subresp 3\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta3\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta3\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta3_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"5\" heading=\"Subpregunta 4\" translate-attr=\"heading\" select=\"changeTab(5)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta4\" name=\"Subpregunta 4\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta4\" name=\"Tipo valor subresp 4\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta4\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta4==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta4\" name=\"Diccionario subpregunta 4\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta4==\'DICCIONARIO\' || pregunta.tipo_valor_sub_pregunta4==\'DICCIONARIO_MULTIPLE\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta4\" name=\"Formato subresp 4\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta4\" name=\"Val. min subresp 4\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta4\" name=\"Val. max subresp 4\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta4\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta4\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta4_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"6\" heading=\"Subpregunta 5\" translate-attr=\"heading\" select=\"changeTab(6)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta5\" name=\"Subpregunta 5\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta5\" name=\"Tipo valor subresp 5\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta5\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta5==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta5\" name=\"Diccionario subpregunta 5\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta5==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta5\" name=\"Formato subresp 5\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta5\" name=\"Val. min subresp 5\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta5\" name=\"Val. max subresp 5\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta5\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta5\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta5_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"7\" heading=\"Subpregunta 6\" translate-attr=\"heading\" select=\"changeTab(7)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta6\" name=\"Subpregunta 6\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta6\" name=\"Tipo valor subresp 6\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta6\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta6==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta6\" name=\"Diccionario subpregunta 6\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta6==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta6\" name=\"Formato subresp 6\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta6\" name=\"Val. min subresp 6\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta6\" name=\"Val. max subresp 6\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta6\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta6\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta6_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"8\" heading=\"Subpregunta 7\" translate-attr=\"heading\" select=\"changeTab(8)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta7\" name=\"Subpregunta 7\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta7\" name=\"Tipo valor subresp 7\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta7\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta7==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta7\" name=\"Diccionario subpregunta 7\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta7==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta7\" name=\"Formato subresp 7\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta7\" name=\"Val. min subresp 7\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta7\" name=\"Val. max subresp 7\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta7\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta7\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta7_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"9\" heading=\"Subpregunta 8\" translate-attr=\"heading\" select=\"changeTab(9)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta8\" name=\"Subpregunta 8\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta8\" name=\"Tipo valor subresp 8\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta8\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta8==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta8\" name=\"Diccionario subpregunta 8\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta8==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta8\" name=\"Formato subresp 8\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta8\" name=\"Val. min subresp 8\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta8\" name=\"Val. max subresp 8\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta8\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta8\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta8_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"10\" heading=\"Subpregunta 9\" translate-attr=\"heading\" select=\"changeTab(10)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta9\" name=\"Subpregunta 9\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta9\" name=\"Tipo valor subresp 9\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta9\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta9==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta9\" name=\"Diccionario subpregunta 9\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta9==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta9\" name=\"Formato subresp 9\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta9\" name=\"Val. min subresp 9\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta9\" name=\"Val. max subresp 9\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta9\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta9\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta9_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"11\" heading=\"Subpregunta 10\" translate-attr=\"heading\" select=\"changeTab(10)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta10\" name=\"Subpregunta 10\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta10\" name=\"Tipo valor subresp 10\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta10\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta10==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta10\" name=\"Diccionario subpregunta 10\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta10==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta10\" name=\"Formato subresp 10\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta10\" name=\"Val. min subresp 10\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta10\" name=\"Val. max subresp 10\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta10\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta10\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta10_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"12\" heading=\"Subpregunta 11\" translate-attr=\"heading\" select=\"changeTab(12)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta11\" name=\"Subpregunta 11\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta11\" name=\"Tipo valor subresp 11\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta11\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta11==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta11\" name=\"Diccionario subpregunta 11\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta11==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta11\" name=\"Formato subresp 11\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta11\" name=\"Val. min subresp 11\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta11\" name=\"Val. max subresp 11\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta11\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta11\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta11_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"13\" heading=\"Subpregunta 12\" translate-attr=\"heading\" select=\"changeTab(13)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta12\" name=\"Subpregunta 12\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta12\" name=\"Tipo valor subresp 12\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta12\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta12==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta12\" name=\"Diccionario subpregunta 12\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta12==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta12\" name=\"Formato subresp 12\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta12\" name=\"Val. min subresp 12\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta12\" name=\"Val. max subresp 12\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta12\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta12\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta12_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"14\" heading=\"Subpregunta 13\" translate-attr=\"heading\" select=\"changeTab(14)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta13\" name=\"Subpregunta 13\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta13\" name=\"Tipo valor subresp 13\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta13\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta13==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta13\" name=\"Diccionario subpregunta 13\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta13==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta13\" name=\"Formato subresp 13\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta13\" name=\"Val. min subresp 13\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta13\" name=\"Val. max subresp 13\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta13\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta13\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta13_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"15\" heading=\"Subpregunta 14\" translate-attr=\"heading\" select=\"changeTab(15)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta14\" name=\"Subpregunta 14\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta14\" name=\"Tipo valor subresp 14\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta14\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta14==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta14\" name=\"Diccionario subpregunta 14\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta14==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta14\" name=\"Formato subresp 14\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta14\" name=\"Val. min subresp 14\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta14\" name=\"Val. max subresp 14\" ix-number withdecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta14\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta14\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta14_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <!-- <uib-tab index=\"16\" heading=\"Subpregunta 15\" translate-attr=\"heading\" select=\"changeTab(16)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta15\" name=\"Subpregunta 15\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta15\" name=\"Tipo valor subresp 15\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta15\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta15==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta15\" name=\"Diccionario subpregunta 15\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta15==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta15\" name=\"Formato subresp 15\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta15\" name=\"Val. min subresp 15\" ix-number withDecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta15\" name=\"Val. max subresp 15\" ix-number withDecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta15\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta15\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta15_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab>\r\n            <uib-tab index=\"17\" heading=\"Subpregunta 16\" translate-attr=\"heading\" select=\"changeTab(17)\">\r\n              <ix-text ng-model=\"pregunta.sub_pregunta16\" name=\"Subpregunta 16\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.tipo_valor_sub_pregunta16\" name=\"Tipo valor subresp 16\" entity=\"tipos_valor_pregunta\" pk=\"tipo_valor\" desc=\"tipo_valor\" append-to-body=\"true\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.numlineas_texto_sub_pregunta16\" name=\"Núm. lineas\" ix-number ng-show=\"pregunta.tipo_valor_sub_pregunta16==\'TEXTO\'\"></ix-text>\r\n              <ix-select ng-model=\"pregunta.diccionario_sub_pregunta16\" name=\"Diccionario subpregunta 16\" entity=\"diccionarios\" pk=\"diccionario\" desc=\"descripcion\" append-to-body=\"true\" ng-show=\"pregunta.tipo_valor_sub_pregunta16==\'DICCIONARIO\'\"></ix-select>\r\n              <ix-text ng-model=\"pregunta.formato_valor_sub_pregunta16\" name=\"Formato subresp 16\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.minimo_valor_sub_pregunta16\" name=\"Val. min subresp 16\" ix-number withDecimals=\"true\"></ix-text>\r\n              <ix-text ng-model=\"pregunta.maximo_valor_sub_pregunta16\" name=\"Val. max subresp 16\" ix-number withDecimals=\"true\"></ix-text>\r\n              <ix-options-si-no ng-model=\"pregunta.validar_sub_pregunta16\" name=\"Requerida cumplimentación\"></ix-options-si-no>\r\n              <ix-options-si-no ng-model=\"pregunta.deshabilitar_sub_pregunta16\" name=\"Deshabilitar\"></ix-options-si-no>\r\n							<ix-options-si-no ng-model=\"pregunta.sub_pregunta16_traducible\" name=\"Traducible\"></ix-options-si-no>\r\n            </uib-tab> -->\r\n          </uib-tabset>\r\n				</form>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>");
$templateCache.put("app/FTBase/ConfiguracionPreguntas/ft_preguntas/acciones/previsualizar_pregunta_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Previsualizar pregunta\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<div class=\"row\">\r\n        	<ft-preguntas preguntas=\"preguntas\" preview=\"true\"></ft-preguntas>\r\n				</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBase/Mantenimientos/laboratorios/modales/popupFicheroLaboratorio.html","<div>\r\n  <ix-popup-tool-bar title-left=\"{{tituloPopup}}\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-4\" ng-show=\"esNuevo\">\r\n              <div ngf-drop ngf-select ng-model=\"archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"esNuevo\">\r\n                <translate>Arrastrar o hacer click para subir archivo</translate>\r\n              </div>\r\n              <ul>\r\n                <li ng-repeat=\"f in archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"col-md-8\">\r\n              <ix-text ng-show=\"!esNuevo\" ng-model=\"data.archivo\" name=\"Nombre fichero\" ng-disabled=\"!status.editing\" ng-required=\"!esNuevo\"></ix-text>\r\n              <ix-select ng-model=\"data.tipo\" name=\"Tipo archivo\" entity=\"tipos_fichero_laboratorio\" pk=\"id\" desc=\"descripcion\" ng-disabled=\"!status.editing\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n              <ix-date ng-model=\"data.fecha_carga\" name=\"Fecha carga\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <ix-date ng-model=\"data.fecha_caducidad\" name=\"Fecha caducidad\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <ix-date ng-model=\"data.inicio_validez\" name=\"Inicio validez\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/modales/fabricantesPopup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Fabricante\" title-left-param=\"mes\">\r\n    <button id=\"acciones-button\" uib-tooltip=\"Guardar\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"guardar()\" ng-disabled=\"!form.$valid\">\r\n      Guardar\r\n    </button>\r\n  </ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n              <ix-text ng-model=\"data.fabricante.razon_social\" name=\"Razón social\" ng-required=\"true\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.cif\" name=\"CIF\" ng-required=\"true\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.direccion\" name=\"Dirección\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.cp\" name=\"Código postal\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.localidad\" name=\"Localidad\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.provincia\" name=\"Provincia\"></ix-text>\r\n              <ix-select ng-model=\"data.fabricante.pais\" ng-disabled=\"!status.editing\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\" append-to-body=\"true\">\r\n              </ix-select>\r\n              <ix-text ng-model=\"data.fabricante.telefono\" name=\"Teléfono\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.fax\" name=\"Fax\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.email\" name=\"E-mail\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.reg_sanitario\" name=\"Registro sanitario\"></ix-text>\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <!-- Grid de plantas -->\r\n        <!--<div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n              <uib-tab index=\"0\" heading=\"Plantas\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"btn-toolbar\">\r\n                      <a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\"\r\n                        data-ng-disabled=\"data.gridPlantas.gridApi.selection.getSelectedRows().length==0\"\r\n                        data-ng-click=\"deleteSelectedRows(data.gridPlantas)\"\r\n                        uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i\r\n                          class=\"fa fa-trash-o\"></i>\r\n                        </a>\r\n                      <a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\"\r\n                        data-ng-disabled=\"isNew\" data-ng-click=\"addRow(data.gridPlantas)\" uib-tooltip=\"{{ \'Nuevo\' }}\"\r\n                        translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i>\r\n                      </a>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div data-ui-grid=\"data.gridPlantas\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav\r\n                  data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection\r\n                  data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n                  <div class=\"grid-loading\" ng-if=\"data.gridPlantas.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                  </div>\r\n                </div>\r\n              </uib-tab>\r\n              <uib-tab index=\"1\" heading=\"Certificados fabricante\" translate-attr=\"heading\" select=\"changeTab(1)\" disable=\"isNew\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"btn-toolbar\">\r\n                      <a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\"\r\n                        data-ng-disabled=\"data.gridCertificadosFabricante.gridApi.selection.getSelectedRows().length==0\"\r\n                        data-ng-click=\"deleteSelectedRows(data.gridCertificadosFabricante)\"\r\n                        uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i\r\n                          class=\"fa fa-trash-o\"></i></a>\r\n                      <a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\"\r\n                        data-ng-disabled=\"false\" data-ng-click=\"addFicheros()\"\r\n                        uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div data-ui-grid=\"data.gridCertificadosFabricante\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellNav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning\r\n                  data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n                  <div class=\"grid-loading\" ng-if=\"data.gridCertificadosFabricante.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                  </div>\r\n                </div>\r\n              </uib-tab>\r\n            </uib-tabset>\r\n          </div>\r\n        </div> -->\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/modales/nuevo_producto_planta_popup.html","<div>\r\n    <ix-popup-tool-bar title-left=\"Crear nuevo producto\"></ix-popup-tool-bar>\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n          <div class=\"row\">\r\n            <div>\r\n              <ix-text ng-model=\"nuevaft.titulo\" name=\"Título\" ng-required=\"true\"></ix-text>\r\n              <ix-select ng-model=\"nuevaft.departamento\" name=\"Mercado\" entity=\"departamentos\" pk=\"codigo\" desc=\"descripcion\" append-to-body=\"true\" ng-required=\"true\"></ix-select>\r\n              <ix-text ng-model=\"nuevoproducto.ean\" name=\"Ean\" ng-required=\"true\"></ix-text>\r\n              <ix-text ng-model=\"nuevoproducto.codigo_interno\" name=\"Codigo interno\"></ix-text>\r\n              <ix-select ng-model=\"nuevoproducto.marca\" name=\"Marca\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" append-to-body=\"true\" ng-required=\"true\"></ix-select>\r\n            </div>\r\n            <div data-ui-grid=\"data.gridPlantasAsociadas\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridPlantasAsociadas.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n						</div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/modales/plantasPopup.html","<style>\r\n	.nota-importante{\r\n		font-size: 14px;\r\n		font-family: \'Roboto\', \'Helvetica\', \'Arial\', sans-serif;\r\n		line-height: 1;\r\n		padding: 15px;\r\n		margin: 0 15px 15px;\r\n		color: white;\r\n		background-color: rgb(241,110,110);\r\n	}\r\n</style>\r\n\r\n<div>\r\n    <ix-popup-tool-bar title-left=\"Planta\" title-left-param=\"mes\">\r\n        <button id=\"acciones-button\" uib-tooltip=\"Guardar\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"guardar()\" ng-disabled=\"!form.$valid\" ng-show=\"status.editing\">\r\n            Guardar\r\n        </button>\r\n    </ix-popup-tool-bar>\r\n    <div ng-scrollbars class=\"scrolldiv\">\r\n        <div class=\"scrolldiv-content\">\r\n            <div class=\"modal-body\">\r\n                <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-6\">\r\n                            <ix-select ng-model=\"data.planta.fabricante\" ng-show=\"data.bIsOneFabricante == false\" ng-disabled=\"!status.editing\" name=\"Fabricante\" ng-required=\"true\" entity=\"fabricantes\" pk=\"fabricante\" desc=\"razon_social\" conditions=\"[{field: \'proveedor\',value: data.proveedor}]\" append-to-body=\"true\"></ix-select>\r\n                            <ix-text ng-model=\"data.planta.nombre_planta\" name=\"Nombre planta\" ng-required=\"true\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.direccion\" name=\"Dirección\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.cp\" name=\"Código postal\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.localidad\" name=\"Localidad\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.provincia\" name=\"Provincia\"></ix-text>\r\n                            <ix-select ng-model=\"data.planta.pais\" ng-disabled=\"!status.editing\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\"></ix-select>\r\n                            <ix-text ng-model=\"data.planta.telefono\" name=\"Teléfono\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.reg_sanitario\" name=\"Registro sanitario\"></ix-text>\r\n                        </div>\r\n                        <div class=\"col-md-6\">\r\n                            <ix-date ng-model=\"data.planta.fecha_alta\" name=\"Fecha Alta\" ng-show=\"!tienePerfilRestringido()\" ng-disabled=\"!status.editing\"></ix-date>\r\n                            <ix-options-si-no ng-model=\"data.planta.baja\" name=\"Baja\" ng-if=\"!isNew\" ng-show=\"!tienePerfilRestringido()\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n                            <ix-date ng-model=\"data.planta.fecha_baja\" name=\"Fecha Baja\" ng-show=\"data.planta.baja==1\" ng-if=\"!isNew\" ng-show=\"!tienePerfilRestringido()\" ng-disabled=\"!status.editing\"></ix-date>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n                <!-- Grid de plantas -->\r\n                <br>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"nota-importante\">\r\n                            <translate>Nota Importante Certificados Plantas</translate>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"btn-toolbar\">\r\n                            <a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridCertificadosPlanta.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridCertificadosPlanta)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n                            <a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"isNew\" data-ng-click=\"addFicheros()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n                        </div>\r\n                        <div data-ui-grid=\"data.gridCertificadosPlanta\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n                            <div class=\"grid-loading\" ng-if=\"data.gridCertificadosPlanta.ixIsLoading\">\r\n                                <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/FTBase/Mantenimientos/proveedores/modales/upload_file_popup_proveedores.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Cargar Fichero\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div class=\"col-md-4\"></div>\r\n              <div class=\"col-md-4\">\r\n                <div ngf-drop ngf-select ng-model=\"archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"!fichero_opcional\">\r\n                  <translate>Arrastrar o hacer click para subir archivo</translate>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ul>\r\n                  <li ng-repeat=\"f in archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}\r\n                  </li>\r\n                </ul>\r\n                <button ng-disabled=\"!status.editing\" class=\"btn btn-danger\" ng-click=\"archivosToUpload = null\" ng-show=\"archivosToUpload\">Borrar</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <ix-select ng-model=\"proveedor\" ng-show=\"soloHayPlantaPuesta\" name=\"Proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" on-select=\"limpiarPlanta\" ng-required=\"true\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-select>\r\n              \r\n              <ix-select ng-model=\"grupo\" name=\"Grupo\" entity=\"grupos_proveedores_ficheros\" pk=\"grupo\" desc=\"grupo\" ng-required=\"true\" ng-disabled=\"!status.editing || bloquearGrupos || soloHayPlantaPuesta\" append-to-body=\"true\" on-select=\"seleccionadoGrupo\"></ix-select>\r\n              \r\n                <ix-select ng-model=\"fabricante\" name=\"Fabricante\" entity=\"fabricantes\" pk=\"fabricante\" desc=\"razon_social\" ng-required=\"grupo==\'FABRICANTE\' || grupo == \'PLANTA\'\" ng-disabled=\"!status.editing || bloquearGrupos\" append-to-body=\"true\" conditions=\"[{field: \'proveedor\',value: proveedor}]\" ng-show=\"(grupo == \'FABRICANTE\' || grupo == \'PLANTA\') && bIsOneFabricante == false\"></ix-select>\r\n\r\n              <ix-select ng-model=\"planta\" name=\"Planta\" entity=\"plantas\" pk=\"planta\" desc=\"nombre_planta\" ng-required=\"grupo==\'PLANTA\'\" ng-disabled=\"!status.editing || bloquearGrupos || !fabricante\" append-to-body=\"true\" conditions=\"[{field: \'fabricante\',value: fabricante}]\" ng-show=\"grupo == \'PLANTA\'\"></ix-select>\r\n              <ix-select ng-model=\"tipoSeleccionadoProveedor\" name=\"Tipo archivo\" entity=\"tipos_fichero_proveedor\" pk=\"id\" desc=\"descripcion\" conditions=\"[{field: \'certificado\',value: 0}]\" ng-required=\"true\" ng-show=\"grupo==\'PROVEEDOR\' || grupo==\'FABRICANTE\'\" ng-disabled=\"!status.editing || sustituir\" append-to-body=\"true\"></ix-select>\r\n              <!-- <ix-select ng-model=\"tipoSeleccionadoProveedor\" name=\"Tipo archivo\" entity=\"tipos_fichero_proveedor\" pk=\"id\" desc=\"descripcion\" conditions=\"[{field: \'certificado\',value: 1}]\" ng-required=\"true\" ng-show=\"grupo==\'PLANTA\'\" ng-disabled=\"!status.editing || sustituir\" append-to-body=\"true\" on-select=\"seleccionadoTipoFichero\"></ix-select> -->\r\n              <ix-select ng-model=\"tipoSeleccionadoProveedor\" name=\"Tipo archivo\" entity=\"tipos_fichero_proveedor\" pk=\"id\" desc=\"descripcion\" conditions=\"[{field: \'certificado\',value: 1}]\" ng-required=\"true\" ng-show=\"grupo==\'PLANTA\'\" ng-disabled=\"!status.editing || sustituir\" append-to-body=\"true\"></ix-select>\r\n              <ix-date ng-model=\"inicio_validez\" name=\"Inicio validez\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <ix-date ng-model=\"fechaCaducidad\" name=\"Fecha caducidad\" ng-disabled=\"!status.editing\" ng-required=\"grupo==\'PLANTA\'\" append-to-body=\"true\"></ix-date>\r\n              <ix-text ng-model=\"num_certificado\" name=\"Número certificado\" ng-show=\"seleccionadoCertificado\" ng-disabled=\"!status.editing\" ng-required=\"fichero_opcional\"></ix-text>\r\n              <ix-text ng-model=\"certificadora\" name=\"Certificadora\" ng-show=\"seleccionadoCertificado\" ng-disabled=\"!status.editing\"></ix-text>\r\n              <ix-text ng-model=\"alcance\" name=\"Alcance\" ng-disabled=\"!status.editing\" ng-required=\"seleccionadoCertificado\"></ix-text>\r\n              <ix-text ng-model=\"comentarios\" name=\"Comentario\" ng-disabled=\"!status.editing\" ng-show=\"fichero_opcional\"></ix-text>\r\n              <ix-text ng-model=\"resultado\" name=\"Resultado\" ng-disabled=\"!status.editing\" ng-show=\"fichero_opcional\"></ix-text>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");}]);
angular.module("FTBonpreuApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/FTBonpreu/Contactos/pagina_contacto.html","<div>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <br>\r\n        <img src=\"assets/images/logo_bp.gif\" alt=\"Logo Bonpreu\">\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-8\">\r\n        <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n          <h3>{{data.desc_prods}}</h3>\r\n          <p class=\"lead\"><span class=\"glyphicon glyphicon-phone\"></span> {{data.tel_contacto}}</p>\r\n          <p class=\"lead\"><span class=\"glyphicon glyphicon-envelope\"></span> {{data.email_contacto}}</p> \r\n          <!-- <hr />\r\n          <h3>Contacte con nosotros</h3>\r\n          <br/>\r\n          <ix-text ng-model=\"data.nombre_mitente\" name=\"Nombre\"></ix-text>\r\n          <ix-text ng-model=\"data.email_mitente\" name=\"E-mail\"></ix-text>\r\n          <br />\r\n          <ix-text-area ng-model=\"data.mensaje\" name=\"Comentarios\" rows=\"4\"></ix-text-area> -->\r\n        </form>\r\n      </div>\r\n    </div>  \r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/FormularioFtBP/FormularioFtBPCard.html","<style>\r\n	.listEditResult {\r\n    border-bottom: none;\r\n    padding: inherit;\r\n	}\r\n</style>\r\n<div class=\"row\" ng-class=\"{\'card-selected\': item.selected, \'nivel1\': ((item.nivel1 || !item.nivel1) && !item.nivel2 && !item.nivel3) }\" style=\"position:relative;padding: 10px 30px; margin-right: 10px; border-bottom: 1px solid #e5e5e5\">\r\n	<div class=\"col-md-1\">\r\n		<span><i class=\"fa fa-{{item.icono}} icono-ficha-tecnica\"></i></span>\r\n	</div>\r\n	<div class=\"col-md-9\">\r\n		<div class=\"table\">\r\n			<div class=\"table-row\">\r\n				<div class=\"table-cell\" style=\"width: 36px\">\r\n					<span ng-show=\"item.nivel1\"><strong>{{ item.nivel1 }}<span ng-show=\"item.nivel2\">.{{ item.nivel2 }}<span ng-show=\"item.nivel3\">.{{ item.nivel3 }}</span></span> -</strong></span>\r\n				</div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"!item.nivel2\"><strong class=\"uppercase\">{{item.titulo1}}</strong></span>\r\n					<span ng-if=\"item.nivel2\"><strong class=\"uppercase\">{{item.titulo2}}</strong></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"table-row\">\r\n				<div class=\"table-cell\"></div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"!item.nivel2 && (item.titulo2 || item.titulo2_valor)\"><strong>{{ item.titulo2 }}</strong>{{item.titulo2_valor}}<br></span>\r\n					<span ng-if=\"item.titulo3 || item.titulo3_valor\"><strong>{{ item.titulo3 }}</strong>{{item.titulo3_valor}}<br></span>\r\n					<span ng-if=\"item.icono == \'home\' && (item.titulo4 || item.titulo4_valor)\"><strong>{{ item.titulo4 }}</strong>{{item.titulo4_valor}}%<br></span>\r\n					<span ng-if=\"item.icono != \'home\' && (item.titulo4 || item.titulo4_valor)\"><strong>{{ item.titulo4 }}</strong>{{item.titulo4_valor}} de {{item.titulo4_valor2}}<br></span>\r\n					<span ng-if=\"item.icono == \'home\' && (item.titulo5 || item.titulo5_valor)\"><strong>{{ item.titulo5 }}</strong>{{item.titulo5_valor}}%<br></span>\r\n					<span ng-if=\"item.icono != \'home\' && (item.titulo5 || item.titulo5_valor)\"><strong>{{ item.titulo5 }}</strong>{{item.titulo5_valor}}<br></span>\r\n					<span ng-if=\"item.titulo6 || item.titulo6_valor\"><strong>{{ item.titulo6 }}</strong>{{item.titulo6_valor}}<br></span>\r\n				</div>\r\n			</div>\r\n			<!--<div class=\"table-row\">\r\n				<div class=\"table-cell\"></div>\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"item.nivel2nombre\">Preguntas: {{item.nc_preguntas}}/{{item.nt_preguntas}}<br/></span>\r\n				</div>\r\n			</div>-->\r\n		</div>\r\n	</div>\r\n	<div class=\"col-md-2\" style=\"height: 100%;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0\">\r\n		<div class=\"table\" style=\"top:25%; position:relative\">\r\n			<div class=\"table-row\">\r\n				<!-- <div class=\"table-cell\">\r\n					<span><i class=\"fa fa-{{item.icono_cabecera}} icono-ficha-tecnica\"></i></span>\r\n				</div> -->\r\n				<div class=\"table-cell\">\r\n					<span ng-if=\"item.alarma\"><i style=\"color: red\" class=\"material-icons icono-ficha-tecnica alarma\" title=\"{{item.alarma_info}}\">warning</i></span>\r\n				</div>\r\n				<div class=\"table-cell\" ng-if=\"item.nivel1 || item.icono == \'home\'\">\r\n					<!-- Solo se verá con un perfil de biotecnal, además, los botones tendrán enlazada una función ng-click -->\r\n					<span ng-show=\"tienePerfilAdmin() && !item.bloqueado\" ng-click=\"bloquearPreguntas($event,item,1)\"><i class=\"material-icons icono-ficha-tecnica\">lock_open</i></span>\r\n					<span ng-show=\"tienePerfilAdmin() && item.bloqueado\" ng-click=\"bloquearPreguntas($event,item,0)\"><i class=\"material-icons icono-ficha-tecnica\">lock</i></span>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>\r\n<div class=\"listEditResult detalles\" ng-repeat=\"item in item.subniveles\" style=\"padding: 0px 0px 0px 10px\" ng-style=\"{\'background-color\':item.color}\" ng-click=\"selectItem(item, $event);$event.stopPropagation();\" ng-show=\"!item.ToDelete\" ng-include=\"module + entity+\'/\'+entity+\'Card.html\'\" ng-class=\"{ \'recordDisabled\': (item.activo == 0 || item.estado == 0), \'visible\': (item.visible), \'error-tarjeta\': (item.error) }\"></div>\r\n");
$templateCache.put("app/FTBonpreu/FormularioFtBP/FormularioFtBPForm.html","<style>\r\n\r\n	.ui-grid-row{\r\n		height: auto!important;\r\n		min-height:39px\r\n	}\r\n\r\n	.ui-grid-render-container-body .ui-grid-viewport {\r\n/*		height: auto !important;*/\r\n		min-height:70px;\r\n	}\r\n\r\n	.ui-grid-row   > div {\r\n		display: table-row;\r\n\r\n	}\r\n\r\n	.ui-grid-row > div .ui-grid-cell {\r\n		display: table-cell;\r\n		float: none;\r\n		vertical-align: middle;\r\n		/*height: auto!important;*/\r\n		min-height:40px;\r\n	}\r\n\r\n	.ui-grid-cell-contents{\r\n		line-height: 16px !important;\r\n		white-space: normal;\r\n		text-overflow: inherit;\r\n		word-break: break-word;\r\n	}\r\n\r\n	.ui-grid-cell-contents .ui-select-match-item span {\r\n		white-space: normal !important;\r\n	}\r\n\r\n\r\n	.ui-grid-draggable-row {\r\n		height: inherit !important;\r\n	}\r\n\r\n	.ui-grid-draggable-row > div.ui-grid-row-header-cell {\r\n		height: inherit !important;\r\n	}\r\n\r\n	.ui-grid-cell-contents.ui-grid-disable-selection {\r\n		height: 38px !important;\r\n	}\r\n\r\n  .row-alarm {\r\n    color: red;\r\n  }\r\n</style>\r\n<div ng-controller=\"FtBPController\">\r\n	<ix-tool-bar>\r\n		<div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n      <button id=\"acciones-button\" uib-tooltip=\"{{ \'Más acciones\' | translate }}\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\" translate-attr=\"uib-tooltip\">\r\n        <translate>Acciones</translate><span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n				<li role=\"menuitem\" ng-show=\"!tieneAccionesRestringidas()\" ng-click=\"generarPreguntasFt()\"><a><translate>Generar preguntas FT</translate></a></li>\r\n				<li role=\"menuitem\" ng-show=\"!tieneAccionesRestringidas()\" ng-click=\"versionarFt()\"><a><translate>Versionar ficha técnica</translate></a></li>\r\n        <li role=\"menuitem\" ng-show=\"!tieneAccionesRestringidas() || esProveedor\" ng-click=\"duplicarFt(2)\"><a><translate>Duplicar niveles</translate></a></li>\r\n        <li role=\"menuitem\" ng-show=\"!tieneAccionesRestringidas() || esProveedor\" ng-click=\"duplicarFt(0)\"><a><translate>Duplicar ficha técnica</translate></a></li>\r\n				<hr ng-show=\"!tieneAccionesRestringidas() || esProveedor\">\r\n				<li role=\"menuitem\" ng-click=\"imprimirFt()\"><a><translate>Imprimir ficha ténica PDF</translate></a></li>\r\n        <!-- <li role=\"menuitem\" ng-click=\"imprimirFt(\'PDF\',1)\"><a><translate>Imprimir ficha ténica reducida PDF</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"imprimirFt(\'MSWORD\',0)\" ng-show=\"!tieneAccionesRestringidas()\"><a><translate>Imprimir ficha ténica word</translate></a></li>\r\n				<li role=\"menuitem\" ng-click=\"imprimirFt(\'MSWORD\',1)\" ng-show=\"!tieneAccionesRestringidas()\"><a><translate>Imprimir ficha técnica reducida word</translate></a></li> -->\r\n				<li role=\"menuitem\" ng-click=\"imprimirFtRevision()\" ng-show=\"tienePerfilBio() && (data.datos.ft_cabecera.ft_version == 6 || data.datos.ft_cabecera.ft_version == 10)\"><a><translate>Imprimir ficha revisión</translate></a></li>\r\n				<!-- <li role=\"menuitem\" ng-click=\"control_errores_transformacion()\" ng-show=\"permiteControlTransformacion()\"><a>Controlar errores transformacion</a></li> -->\r\n      </ul>\r\n    </div>\r\n\r\n		<button class=\"btn pull-right\" ng-click=\"selectNextPage()\" uib-tooltip=\"Siguiente\" ng-disabled=\"isLast()\" tooltip-placement=\"bottom\"><i class=\"fa fa-arrow-right\"></i> <translate class=\"ng-scope\">Siguiente</translate></button>\r\n\r\n		<button class=\"btn pull-right\" ng-click=\"selectPreviousPage()\" uib-tooltip=\"Anterior\" ng-disabled=\"isFirst()\" tooltip-placement=\"bottom\"><i class=\"fa fa-arrow-left\"></i> <translate class=\"ng-scope\">Anterior</translate></button>\r\n		<button class=\"btn pull-right\" ng-show=\"!edicionPreguntasRestringida() && (data.datos.ft_cabecera.estado == \'O\' || data.datos.ft_cabecera.estado == \'Q\') && !data.modoTraduccion\" ng-click=\"confirmarCumplimentacion()\" uib-tooltip=\"Finalizar cumplimentación\" tooltip-placement=\"bottom\"><i class=\"fa fa-check\"></i> <translate class=\"ng-scope\">Finalizar</translate></button>\r\n	</ix-tool-bar>\r\n\r\n	<div ng-scrollbars ng-scrollbars-config=\"scrollBarConfig\" class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\" style=\"min-height: calc(100vh - 135px)\">\r\n			<form name=\"form\" ng-class=\"{ \'multi-ft\': data.id_fichas_tecnicas }\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<uib-tabset ng-if=\"data.id_fichas_tecnicas\" class=\"ix-tabs multi-ft no-margin-bottom\" active=\"data.activeTabFichaTecnica\">\r\n					<uib-tab ng-repeat=\"ficha_tecnica in data.id_fichas_tecnicas track by $index\" index=\"$index\" heading=\"{{ ficha_tecnica }}\" translate-attr=\"heading\" select=\"cambiarFicha(ficha_tecnica, $index)\">\r\n					</uib-tab>\r\n				</uib-tabset>\r\n\r\n				<!-- Si la tarjeta es de tipo Cabecera-->\r\n				<div ng-show=\"data.pantalla == \'cabecera\'\">\r\n					<div class=\"row\">\r\n						<div class=\"col-md-6\">\r\n							<ix-select ng-if=\"data.modoTraduccion\" ng-model=\"data.datos.estado_traduccion\" name=\"Estado traducción\" pk=\"codigo\" desc=\"descripcion\" load-function=\"loadEstadosTraduccion\" append-to-body=\"true\" ng-show=\"!tieneCabeceraRestringida()\" ng-disabled=\"!status.editing\"></ix-select>\r\n							<ix-text ng-model=\"data.datos.ft_cabecera.CodInterno\" name=\"Num. artículo\" data-ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-text>\r\n							<ix-text ng-model=\"data.datos.ft_cabecera.titulo\" name=\"Título\" ng-disabled=\"!status.editing || tieneCabeceraRestringida()\"></ix-text>\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.fecha\" name=\"Fecha de alta\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-date>\r\n							<ix-select ng-model=\"data.datos.ft_cabecera.ft_version\" name=\"Tipo\" entity=\"versiones\" pk=\"version\" desc=\"nombre\" append-to-body=\"true\" ng-show=\"!esUsuarioConsulta()\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-select>\r\n							<ix-select ng-model=\"data.datos.ft_cabecera.departamento\" name=\"Área\" entity=\"deptoarea\" pk=\"codigo\" desc=\"descripcion\" append-to-body=\"true\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!status.editing || data.modoTraduccion\" ng-show=\"!tieneCabeceraRestringida() && !esUsuarioConsulta()\"></ix-select>\r\n							<ix-text ng-model=\"data.datos.ft_cabecera.agrupacion\" name=\"Agrupación\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\" ng-show=\"!esUsuarioConsulta()\"></ix-text>\r\n							<ix-text ng-model=\"data.datos.ft_cabecera.ean\" name=\"EAN\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-text>\r\n							<ix-select ng-model=\"data.datos.ft_cabecera.marca_ref\" name=\"Marca\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" append-to-body=\"true\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\"></ix-select>\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.fecha_baja_axional\" name=\"Baja Axional\" ng-show=\"!tieneCabeceraRestringida()\" ng-disabled=\"!status.editing || data.modoTraduccion\" ng-show=\"!esUsuarioConsulta()\"></ix-date>\r\n							<ix-select ng-model=\"data.datos.ft_cabecera.proveedor\" name=\"Proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\" on-select=\"marcarRecargaFicherosProveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" append-to-body=\"true\"></ix-select>\r\n							<ix-select ng-model=\"data.datos.comprador.id\" name=\"Comprador\" entity=\"compradores\" pk=\"id\" desc=\"nombre\" ng-show=\"!tieneCabeceraRestringida()\" ng-disabled=\"!status.editing || data.modoTraduccion\" append-to-body=\"true\"></ix-select>\r\n							<ix-text ng-model=\"data.datos.ft_cabecera.ft_componentes\" name=\"Producto multi-artículo\" ng-show=\"!tieneCabeceraRestringida()\" ng-disabled=\"!status.editing || data.modoTraduccion\"></ix-text>\r\n							<ix-select ng-model=\"data.datos.ft_cabecera.estado\" name=\"Estado\" entity=\"flujo_estados\" pk=\"codigo\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" conditions=\"[{field: \'estado\', value: data.datos.ft_cabecera.estado, skip: true }]\" append-to-body=\"true\" ng-disabled=\"!status.editing || tieneCabeceraRestringida() || data.modoTraduccion\">\r\n							</ix-select>\r\n						</div>\r\n						<div class=\"col-md-6\">\r\n							<ix-text ng-model=\"data.datos.ft_cabecera.tiempo_cumplimentacion\" name=\"Días para cumplimentar FT\" ix-number ng-show=\"!tieneCabeceraRestringida()\" ng-disabled=\"!status.editing || data.modoTraduccion\"></ix-text>\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.fecha_aprobada\" name=\"Fecha aprobación\" ng-disabled=\"!status.editing || data.modoTraduccion\"></ix-date>\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.fecha_revision\" name=\"Fecha revisión\" ng-show=\"!tieneCabeceraRestringida()\" ng-disabled=\"!status.editing || data.modoTraduccion\"></ix-date>\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.fecha_baja\" name=\"Fecha baja\" ng-show=\"!tieneCabeceraRestringida()\" ng-disabled=\"true\"></ix-date>\r\n							<!-- TODO: Verificar si se quiere que sólo Biotecnal pueda modificar si la FT es traducible o menos -->\r\n							<ix-select ng-model=\"data.datos.ft_cabecera.idioma\" name=\"Idioma\" pk=\"cod_idioma\" desc=\"nombre_idioma\" load-function=\"loadIdiomas\" append-to-body=\"true\" ng-show=\"tienePerfilAdmin()\" ng-disabled=\"true\"></ix-select>\r\n							<ix-options-si-no ng-if=\"tienePerfilAdmin() && !data.modoTraduccion\" ng-model=\"data.datos.ft_cabecera.traducible\" name=\"Traducible\" ng-show=\"tienePerfilAdmin()\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n							<ix-text-area ng-model=\"data.datos.ft_cabecera.comentarios\" name=\"Comentarios Bon Preu\" ng-class=\"resizable\" ng-show=\"!tieneCabeceraRestringida()\" ng-disabled=\"!status.editing || data.modoTraduccion\" rows=\"4\"></ix-text-area>\r\n							<ix-text-area ng-model=\"data.datos.ft_cabecera.comunicaciones_recepcion\" name=\"Mensaje a recepción\" ng-class=\"resizable\" ng-show=\"!tieneCabeceraRestringida()\" ng-disabled=\"!status.editing || data.modoTraduccion\" rows=\"4\"></ix-text-area>\r\n						</div>\r\n					</div>\r\n					<!-- ¿Esto debería verslo sólo Biotecnal ?-->\r\n					<div class=\"row\" ng-if=\"tienePerfilBio() && !data.modoTraduccion\">\r\n						<div class=\"col-md-4\">\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.revision_inicial\" name=\"Revisión inicial\" ng-disabled=\"!status.editing\"></ix-date>\r\n						</div>\r\n						<div class=\"col-md-4\">\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.revision_final\" name=\"Revisión final\" ng-disabled=\"!status.editing\"></ix-date>\r\n						</div>\r\n						<div class=\"col-md-4\">\r\n							<ix-date ng-model=\"data.datos.ft_cabecera.notificacion_proveedor\" name=\"Notificación proveedor\" ng-disabled=\"!status.editing\"></ix-date>\r\n						</div>\r\n					</div>\r\n					<br>\r\n					<div style=\"width: 100%\" ng-if=\"!esUsuarioConsulta()\">\r\n						<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTabCabecera\">\r\n							<uib-tab index=\"0\" heading=\"Tiraje de etiquetado\" translate-attr=\"heading\" select=\"changeTabCabecera(0)\">\r\n								<div class=\"row\" style=\"width: 100%\" ng-if=\"data.gridTirajeEtiquetas\">\r\n									<div class=\"col-md-12\">\r\n										<div class=\"btn-toolbar\">\r\n											<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridTirajeEtiquetas.ixIsLoading && !data.modoTraduccion\" data-ng-disabled=\"data.gridTirajeEtiquetas.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridTirajeEtiquetas)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n											<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridTirajeEtiquetas.ixIsLoading && !data.modoTraduccion\" data-ng-click=\"addRow(data.gridTirajeEtiquetas)\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n										</div>\r\n										<div data-ui-grid=\"data.gridTirajeEtiquetas\" ng-if=\"data.gridTirajeEtiquetas\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows data-ui-grid-exporter>\r\n											<div class=\"grid-loading\" ng-if=\"data.gridTirajeEtiquetas.ixIsLoading\">\r\n												<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n											</div>\r\n										</div>\r\n										<div class=\"pull-left\" ng-show=\"status.editing\">\r\n											{{data.gridTirajeEtiquetas.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n											{{data.gridTirajeEtiquetas.deletedRows.length}} filas eliminadas\r\n											{{data.gridTirajeEtiquetas.insertedRows.length}} filas creadas\r\n											{{data.gridTirajeEtiquetas.gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n										</div>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab index=\"1\" ng-if=\"tienePerfilAdmin()\" heading=\"Planificación analíticas rutinarias\" translate-attr=\"heading\" select=\"changeTabCabecera(1)\">\r\n								<div class=\"row\" style=\"width: 100%\" ng-if=\"data.gridAnaliticas\">\r\n									<div class=\"col-md-12\">\r\n										<div class=\"btn-toolbar\">\r\n											<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridAnaliticas.ixIsLoading && !data.modoTraduccion\" data-ng-disabled=\"data.gridAnaliticas.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridAnaliticas)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n											<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridAnaliticas.ixIsLoading && !data.modoTraduccion\" data-ng-click=\"addPlanificacionAnalitica()\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n										</div>\r\n										<div data-ui-grid=\"data.gridAnaliticas\" ng-if=\"data.gridAnaliticas\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard ui-grid-draggable-rows data-ui-grid-exporter>\r\n											<div class=\"grid-loading\" ng-if=\"data.gridAnaliticas.ixIsLoading\">\r\n												<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n											</div>\r\n										</div>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n						</uib-tabset>\r\n					</div>\r\n				</div>\r\n\r\n			<!-- Si la tarjeta es de tipo Ficheros -->\r\n			<div ng-show=\"data.pantalla == \'ficheros\'\">\r\n				<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTabFicheros\">\r\n					<uib-tab index=\"0\" heading=\"Ficheros del producto\" translate-attr=\"heading\" select=\"changeTabFicheros(0)\">\r\n						<div class=\"row\" style=\"width:100%\" ng-if=\"data.gridFicherosFT\">\r\n							<div class=\"col-md-12\">\r\n								<div class=\"alert alert-warning\" role=\"alert\" style=\"font-size: 130%; line-height: 1.3\">\r\n									<translate>NotaAgregarFicherosProducto</translate>\r\n								</div>\r\n								<!-- </div> -->\r\n								<div class=\"btn-toolbar\">\r\n									<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridFicherosFT.ixIsLoading && !tieneAccionesRestringidas()\" data-ng-disabled=\"data.gridFicherosFT.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFicherosFT, true)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n									<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridFicherosFT.ixIsLoading && !tieneAccionesRestringidas()\" data-ng-click=\"openPopupFicherosFt(0)\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFicherosFT\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-auto-resize data-ui-grid-move-columns ui-grid-draggable-rows data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state ui-grid-clipboard data-ui-grid-exporter>\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFicherosFT.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n								<div class=\"pull-left\" ng-show=\"status.editing\">\r\n										{{data.gridFicherosFT.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n										{{data.gridFicherosFT.deletedRows.length}} filas eliminadas\r\n										{{data.gridFicherosFT.insertedRows.length}} filas creadas\r\n										{{data.gridFicherosFT.gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n								</div>\r\n							</div>\r\n						</div>\r\n					</uib-tab>\r\n					<uib-tab index=\"1\" heading=\"Ficheros del proveedor\" translate-attr=\"heading\" select=\"changeTabFicheros(1)\">\r\n						<div style=\"width:100%\" ng-if=\"data.gridFicherosProveedor\">\r\n							<div data-ui-grid=\"data.gridFicherosProveedor\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-auto-resize data-ui-grid-move-columns ui-grid-draggable-rows data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state ui-grid-clipboard data-ui-grid-exporter>\r\n								<div class=\"grid-loading\" ng-if=\"data.gridFicherosProveedor.ixIsLoading\">\r\n									<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n								</div>\r\n							</div>\r\n							<div class=\"pull-left\" ng-show=\"status.editing\">\r\n									{{data.gridFicherosProveedor.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n									{{data.gridFicherosProveedor.deletedRows.length}} filas eliminadas\r\n									{{data.gridFicherosProveedor.insertedRows.length}} filas creadas\r\n									{{data.gridFicherosProveedor.gridApi.selection.getSelectedRows().length}} filas seleccionadas\r\n							</div>\r\n						</div>\r\n					</uib-tab>\r\n				</uib-tabset>\r\n			</div>\r\n\r\n			<!-- Si la tarjeta es de tipo Datos Proveedor -->\r\n<!--				<div ng-if=\"data.pantalla == \'proveedor\'\">-->\r\n				<div ng-show=\"data.pantalla == \'proveedor\'\">\r\n					<div style=\"width:100%\" ng-if=\"data.gridPlantasFabricante\">\r\n						<!-- <button class=\"btn btn-primary\" ng-click=\"openProveedor()\">Detalles proveedor</button> -->\r\n						<div class=\"alert alert-warning\" role=\"alert\" style=\"font-size: 130%; line-height: 1.3\">\r\n							<translate>NotaFtPlantasAsociadas</translate>\r\n						</div>\r\n						<div data-ui-grid=\"data.gridPlantasFabricante\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-auto-resize data-ui-grid-save-state ui-grid-clipboard data-ui-grid-exporter>\r\n							<div class=\"grid-loading\" ng-if=\"data.gridPlantasFabricante.ixIsLoading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n						<!-- <div class=\"pull-left\">\r\n								{{data.gridPlantasFabricante.gridApi.rowEdit.getDirtyRows().length}} filas modificadas\r\n						</div> -->\r\n					</div>\r\n				</div>\r\n				<div ng-show=\"data.pantalla == \'comentarios\'\">\r\n					<div style=\"width:100%\" ng-if=\"data.gridComentariosFt && !tieneCabeceraRestringida()\">\r\n						<div class=\"btn-toolbar\">\r\n							<a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridComentariosFt.ixIsLoading\" data-ng-disabled=\"data.gridComentariosFt.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridComentariosFt)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n							<a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.gridComentariosFt.ixIsLoading\" data-ng-click=\"addRowComentarioFt()\" uib-tooltip=\"{{ \'Nuevo\' }}\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n						</div>\r\n						<div data-ui-grid=\"data.gridComentariosFt\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-auto-resize data-ui-grid-save-state ui-grid-clipboard data-ui-grid-exporter> \r\n							<div class=\"grid-loading\" ng-if=\"data.gridComentariosFt.ixIsloading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n					</div>\r\n				</div>\r\n				<div ng-show=\"data.pantalla == \'log\'\">\r\n					<div class=\"row\">\r\n						<!-- <div class=\"col-md-8\"></div> -->\r\n						<div class=\"col-md-12\">\r\n							<button class=\"btn btn-default\" ng-click=\"descargarExcelLog()\"><translate>Descargar Excel</translate></button>\r\n						</div>\r\n					</div>\r\n					<div style=\"width:100%\" ng-if=\"data.gridCambioDatosFt && !tieneCabeceraRestringida()\">\r\n						<div data-ui-grid=\"data.gridCambioDatosFt\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n							<div class=\"grid-loading\" ng-if=\"data.gridCambioDatosFt.ixIsloading\">\r\n								<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n							</div>\r\n						</div>\r\n					</div>\r\n				</div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/GestionAnaliticasBP/carga_masiva_planificacion_analiticas_ft.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n		<div id=\"hot-container\" style=\"height:600px\">\r\n			<hot-table settings=\"excelsettings\" datarows=\"data.excelData\" hot-instance=\"tableInstance\">\r\n				<hot-column ng-repeat=\"column in data.excelcolumns\" title=\"column.title\" read-only=\"!status.editing\" renderer=\"column.renderer\" width=\"column.width\"></hot-column>\r\n				<hot-column ng-if=\"data.showResults\" data=\"resultado_color\" title=\"\'Resultado\'\" read-only=\"!status.editing\" width=\"60\" renderer=\"rendererColor\"></hot-column>\r\n				<hot-column ng-if=\"data.showResults\" data=\"resultado_msg\" title=\"\'Detalles\'\" read-only=\"!status.editing\" width=\"250\"></hot-column>\r\n			</hot-table>\r\n		</div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/GestionAnaliticasBP/listado_nc_analiticas.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <!-- <div class=\"btn-group pull-right\" uib-dropdown is-open=\"false\">\r\n      <button id=\"descarga-masiva-btn\" uib-tooltip=\"Descarga masiva\" tooltip-placement=\"bottom\" class=\"btn\"\r\n        uib-dropdown-toggle>\r\n        <translate>Descarga masiva</translate><span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"descarga-masiva-btn\">\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaInformes()\"><a><translate>Descargar ficheros seleccionados</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a><translate>Seleccionar líneas visibles</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"borrarSeleccionRows()\"><a><translate>Limpiar líneas seleccionadas</translate></a></li>\r\n      </ul>\r\n    </div> -->\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div style=\"width: 100%\">\r\n      <div class=\"full-ui-grid\" data-ui-grid=\"data.gridNc\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridNc.ixIsLoading\">\r\n          <a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridNc\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/GestionAnaliticasBP/listado_plan_analiticas_bp.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n      <!-- <button class=\"btn pull-right\" id=\"nueva-extra-button\" ng-disabled=\"disabled\" ng-click=\"openAddExtraPopup()\" ng-show=\"tienePerfilAdmin()\"> -->\r\n      <button class=\"btn pull-right\" id=\"nueva-extra-button\" ng-click=\"openAddExtraPopup()\" ng-show=\"tienePerfilAdmin()\">\r\n        <i class=\"fa fa-plus\"></i> <translate>Nueva analítica extraordinaria</translate>\r\n      </button>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div style=\"width: 100%\">\r\n      <div class=\"full-ui-grid\" ng-if=\"data.gridPlan\" data-ui-grid=\"data.gridPlan\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridPlan.ixIsLoading\">\r\n          <a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridPlan\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/GestionAnaliticasBP/listado_resultados_analisis.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"false\">\r\n      <button id=\"descarga-masiva-btn\" uib-tooltip=\"Descarga masiva\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle>\r\n        <translate>Descarga masiva</translate><span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"descarga-masiva-btn\">\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaInformes()\"><a><translate>Descargar ficheros seleccionados</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a><translate>Seleccionar líneas visibles</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"borrarSeleccionRows()\"><a><translate>Limpiar líneas seleccionadas</translate></a></li>\r\n      </ul>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div style=\"width: 100%\">\r\n      <div class=\"full-ui-grid\" data-ui-grid=\"data.gridResultados\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridResultados.ixIsLoading\">\r\n          <a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridResultados\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/ListadosFtBP/busqueda_avanzada_bp.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div style=\"width:100%\">\r\n      <div class=\"full-ui-grid\" data-ui-grid=\"data.gridBusqueda\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridBusqueda.ixIsLoading\">\r\n					<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridBusqueda\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/ListadosFtBP/lista_tirajes_etiquetado.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div style=\"width: 100%\">\r\n      <div class=\"grid full-ui-grid\" data-ui-grid=\"data.gridTirajes\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridTirajes.ixIsLoading\">\r\n					<a><i class=\"fa fa-circle-o-notch fa-spin\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridTirajes\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/ListadosFtBP/listado_empresas_plantas_bp.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"{{ \'Filtros\' | translate }}\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-options-si-no ng-model=\"data.filtro.activas\" name=\"Solo plantas activas\" is-filter=\"true\">\r\n                </ix-options-si-no>\r\n              </div>\r\n              <div class=\"col-md-4\"></div>\r\n              <div class=\"col-md-4\"></div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width: 100%\" ng-if=\"status.transitionend\">\r\n      <div class=\"grid full-ui-grid\" ng-if=\"data.gridPlantas\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 308px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.gridPlantas\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridPlantas.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridPlantas\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/ListadosFtBP/listado_ficheros_ft_bp.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"false\">\r\n      <button id=\"descarga-masiva-btn\" uib-tooltip=\"Descarga masiva\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle>\r\n        <translate>Descarga masiva</translate><span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"descarga-masiva-btn\">\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFicheros()\"><a><translate>Descargar ficheros seleccionados</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a><translate>Seleccionar líneas visibles</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"borrarSeleccionRows()\"><a><translate>Limpiar líneas seleccionadas</translate></a></li>\r\n      </ul>\r\n    </div>\r\n    <div class=\"btn-group pull-right\">\r\n      <button class=\"btn pull-right\" id=\"acciones-button\" ng-disabled=\"disabled\" ng-click=\"loadFiles()\" ng-show=\"true\">\r\n        <translate>Carga masiva ficheros</translate>\r\n      </button>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"{{ \'Filtros\' | translate }}\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-options-si-no ng-model=\"data.filtro.vigentes\" name=\"Solo ficheros vigentes\" is-filter=\"true\">\r\n                </ix-options-si-no>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div class=\"grid full-ui-grid\" ng-if=\"data.gridFtFicheros\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 308px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.gridFtFicheros\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridFtFicheros.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridFtFicheros\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/ListadosFtBP/listado_ficheros_proveedores_bp.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"false\">\r\n      <button id=\"descarga-masiva-btn\" uib-tooltip=\"Descarga masiva\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle>\r\n        <translate>Descarga masiva</translate><span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"descarga-masiva-btn\">\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFicheros()\"><a><translate>Descargar ficheros seleccionados</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a><translate>Seleccionar lineas visibles</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"borrarSeleccionRows()\"><a><translate>Limpiar líneas seleccionadas</translate></a></li>\r\n      </ul>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n      <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n          <uib-accordion close-others=\"oneAtATime\">\r\n              <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"{{ \'Filtros\' | translate }}\" is-open=\"filterStatus.isCollapsed\">\r\n                <fieldset class=\"form-data-filter\">\r\n                  <div class=\"row\">\r\n                    <div class=\"col-md-4\">\r\n                      <ix-options-si-no ng-model=\"data.filtro.vigentes\" name=\"Solo ficheros vigentes\" is-filter=\"true\"></ix-options-si-no>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                  </div>\r\n                </fieldset>\r\n              </div>\r\n            </uib-accordion>\r\n      </form>\r\n      <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n          <div class=\"grid full-ui-grid\" ng-if=\"data.gridProveedoresFicheros\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 308px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.gridProveedoresFicheros\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n            <div class=\"grid-loading\" ng-if=\"data.gridProveedoresFicheros.ixIsLoading\">\r\n                <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n            </div>\r\n          </div>\r\n      </div>\r\n      <div>\r\n          <div class=\"footer\">\r\n              <div ix-datetime-grid-generada grid=\"data.gridProveedoresFicheros\"></div>\r\n          </div>\r\n      </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/ListadosFtBP/listado_ft_bp.html","<style>\r\n  .row-alarm {\r\n      color: red;\r\n  }\r\n</style>\r\n<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n    <div ng-if=\"status.filtered\" class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n      <button id=\"acciones-burron\" uib-tooltip=\"{{ \'Más acciones\' | translate }}\" tooltip-placement=\"bottom\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled || status.blockUIBtns\">\r\n        <translate>Acciones</translate><span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-class=\"{\'disabled\': getSelectedRows().length == 0 }\"><a ng-click=\"abrirMultiplesFichasTecnicas()\"><translate>Abrir múltiples fichas técnicas</translate></a></li>\r\n      </ul>\r\n    </div>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isseleccionaropen\">\r\n      <button id=\"acciones-button\" class=\"btn\" uib-dropdown-toggle ng-disabled=\"disabled\">\r\n        <translate>Impresión Masiva</translate><span class=\"caret\"></span>\r\n      </button>\r\n      <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"acciones-button\">\r\n        <li role=\"menuitem\" ng-click=\"seleccionarRowsVisibles()\"><a><translate>Seleccionar lineas visibles</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"desSeleccionarRows()\"><a><translate>Desseleccionar todo</translate></a></li>\r\n        <li role=\"menuitem\" ng-click=\"impresionMasivaFT()\"><a><translate>Imprimir fichas seleccionadas</translate></a></li>\r\n      </ul>\r\n    </div>\r\n    <div class=\"btn-group pull-right\" uib-dropdown is-open=\"status.isopen\">\r\n      <button class=\"btn pull-right\" id=\"acciones-button\" ng-disabled=\"disabled\" ng-click=\"openAddFtPopup()\" ng-show=\"tienePerfilAdmin()\">\r\n        <i class=\"fa fa-plus\"></i> <translate>Nueva FT</translate>\r\n      </button>\r\n    </div>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"{{ \'Filtros\' | translate }}\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.tipo_ft\" entity=\"versiones\" name=\"Tipo\" pk=\"version\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-select-multiple ng-if=\"!esPerfilVisitante()\" ng-model=\"data.filtro.estado\" limit-to=\"15\" entity=\"estados\" name=\"Estado\" pk=\"codigo\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.marca\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" name=\"Marca\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-select-multiple ng-model=\"data.filtro.proveedor\" entity=\"proveedoresBP\" pk=\"proveedor\" desc=\"nombre\" name=\"Proveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.departamento\" entity=\"deptoarea\" pk=\"codigo\" desc=\"descripcion\" name=\"Área\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-text ng-model=\"data.filtro.busqueda_generica\" name=\"Búsqueda Genérica\" is-filter=\"true\"></ix-text>\r\n                <!-- <ix-options-si-no ng-show=\"!extranetUser.laboratorio\" ng-model=\"data.filtro.exclusivas\" name=\"Fichas Técnicas exclusivas\" is-filter=\"true\">\r\n                </ix-options-si-no> -->\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n\r\n    <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n      <uib-tab index=\"0\" heading=\"Fichas técnicas\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n        <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n          <div ng-if=\"data.gridFtBp\" class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 490px)\' : \'calc(100vh - 265px)\' }\" data-ui-grid=\"data.gridFtBp\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n            <div class=\"grid-loading\" ng-if=\"data.gridFtBp.ixIsLoading\">\r\n              <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div>\r\n          <div class=\"footer\">\r\n            <div ix-datetime-grid-generada grid=\"data.gridFtBp\"></div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n      <uib-tab index=\"1\" heading=\"Resumen\" translate-attr=\"heading\" select=\"changeTab(1)\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div id=\"pivotFtBp\" style=\"margin:30px; overflow:auto\"></div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n    </uib-tabset>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/ListadosFtBP/listado_plantas_productos_bp.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"{{ \'Filtros\' | translate }}\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-options-si-no ng-model=\"data.filtro.ft_activas\" name=\"Solo FT activas\" is-filter=\"true\">\r\n                </ix-options-si-no>\r\n              </div>\r\n              <div class=\"col-md-4\"></div>\r\n              <div class=\"col-md-4\"></div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n    <div style=\"width: 100%\" ng-if=\"status.transitionend\">\r\n      <div class=\"grid full-ui-grid\" ng-if=\"data.gridPlantas\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 308px)\' : \'calc(100vh - 220px)\' }\" data-ui-grid=\"data.gridPlantas\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridPlantas.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridPlantas\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/ListadosFtBP/listado_proveedores_bp.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div style=\"width: 100%\" ng-if=\"status.transitionend\">\r\n      <div class=\"grid full-ui-grid\" ng-if=\"data.gridProveedores\" ng-style=\"{\'height\': \'calc(100vh - 180px)\' }\" data-ui-grid=\"data.gridProveedores\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridProveedores.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridProveedores\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/Recepcion/recepcionForm.html","<div ng-controller=\"FormRecepcionController\">\r\n  <div ng-bind-html=\"renderHtml(body)\"></div>\r\n</div>");
$templateCache.put("app/FTBonpreu/Recepcion/vistaRecepcion.html","<style>\r\n  /* CSS used here will be applied after bootstrap.css */\r\n  /*\r\n  .table-bordered > tbody > tr > td,\r\n  .table-bordered > tbody > tr > th,\r\n  .table-bordered > tfoot > tr > td,\r\n  .table-bordered > tfoot > tr > th,\r\n  */\r\n  .table-bordered,\r\n  .table-bordered > thead > tr > td,\r\n  .table-bordered > thead > tr > th \r\n  {\r\n    border: 1px solid darkgrey;\r\n  }\r\n  \r\n  \r\n  body{\r\n    -webkit-print-color-adjust:exact;\r\n    color-adjust:exact;\r\n  }\r\n  \r\n  @media print {\r\n      \r\n      #divHeader {\r\n          color: white !important;\r\n          font-size: 1.5em !important;\r\n          background-color: #A4343A !important;\r\n      }\r\n      #divHeaderText {\r\n          width: 75% !important;\r\n      }\r\n      #divHeaderImage {\r\n          float: right important!;\r\n          width: 25% !important;\r\n      }\r\n      \r\n      h2 {\r\n          color: white !important;\r\n          font-size: 1em !important;\r\n      }\r\n\r\n      .table > thead {\r\n          background-color: #D8D8D8 !important;\r\n      }\r\n      .tituloNivel {\r\n          color: white !important;\r\n          font-size: 1em !important; \r\n          background-color: #A4343A !important;\r\n      }\r\n      .tableHeadForPrint {\r\n          background-color: #D8D8D8 !important;\r\n      }\r\n  }\r\n</style>\r\n<div>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div ng-scrollbars ng-scrollbars-config=\"scrollBarConfig\" class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <form>\r\n        <div id=\"divFtHeader\" class=\"row\">\r\n          <div class=\"col-md-8\">\r\n            <table>\r\n              <tr>\r\n                <td style=\"font-weight: bold\">{{data.cabecera.lbl_desc_producto}}</td>\r\n                <td>{{data.cabecera.desc_producto}}</td>\r\n              </tr>\r\n              <tr>\r\n                <td style=\"font-weight: bold\">{{data.cabecera.lbl_cod_producto}}</td>\r\n                <td>{{data.cabecera.cod_producto}}</td>               \r\n              </tr>\r\n              <tr>\r\n                <td style=\"font-weight: bold\">{{data.cabecera.lbl_marca}}</td>\r\n                <td>{{data.cabecera.marca}}</td>\r\n              </tr>\r\n              <tr>\r\n                <td style=\"font-weight: bold\">{{data.cabecera.ean}}</td>\r\n                <td>{{data.cabecera.ean}}</td>\r\n              </tr>\r\n            </table>\r\n          </div>\r\n        </div>\r\n        <!-- <div class=\"row\">\r\n          <div class=\"col-md-8\">\r\n            <label style=\"font-weight: bold\">Producte:</label>\r\n            <label>{{data.desc_producto}}</label>\r\n            <br/>\r\n            <label style=\"font-weight: bold\">Núm. Article:</label>\r\n            <label>{{data.cod_producto}}</label>\r\n            <br/>\r\n            <label style=\"font-weight: bold\">Marca:</label>\r\n            <label>{{data.marca}}</label>\r\n            <br/>\r\n            <label style=\"font-weight: bold\">EAN:</label>\r\n            <label>{{data.ean}}</label>\r\n            <br/>\r\n            <label style=\"font-weight: bold\">Missatge a recepció:</label>\r\n            <label>{{data.mensaje_recepcion}}</label>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <label style=\"font-weight: bold\">Nº FT:</label>\r\n            <label>{{data.id_ficha_tecnica}}</label>\r\n            <br/>\r\n            <label style=\"font-weight: bold\">Data:</label>\r\n            <label>{{data.fecha}}</label>\r\n            <br/>\r\n            <label style=\"font-weight: bold\">Codi proveïdor:</label>\r\n            <label>{{data.nombre_proveedor}}</label>\r\n            <div>\r\n              \r\n            </div>\r\n          </div> \r\n        </div> -->\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/views/grid_jerarquico_bp_add_row_popup.html","<div>\r\n  <!-- <ix-popup-tool-bar title-left=\"{{rowsGrid.length > 0 ? \'Añadir\' : \'Editar\'}} Ingrediente {{ rowsGrid.length > 0 ? \'Nuevo\' : entity.valor }}\"></ix-popup-tool-bar> -->\r\n	<ix-popup-tool-bar title-left=\"{{rowsGrid.length > 0 ? \'Añadir ingrediente nuevo\' : \'Editar ingrediente\'}}\" title-left-param=\"valIngredienteModificar\"></ix-popup-tool-bar>\r\n	  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n				<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n					<div class=\"row\">\r\n						<div class=\"col-md-7\">\r\n							<ix-select ng-if=\"!reload && rowsGrid.length > 0\" ng-model=\"entity.orden_bucle\" name=\"Seleccionar Nivel/Posición\" pk=\"codigo\" desc=\"descripcion\" load-function=\"cargarValoresNivel\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n							<ix-select ng-if=\"entity.orden_bucle == 1 && isNew\" ng-model=\"entity.orden_subingrediente\" name=\"Subingrediente\" pk=\"codigo\" desc=\"descripcion\" load-function=\"cargarIngredientes\" ng-required=\"true\" append-to-body=\"true\" longer-result-box=\"true\"></ix-select>\r\n							<ix-text ng-model=\"searchtext\" name=\"Buscar ingrediente\"></ix-text>\r\n							<ix-text ng-model=\"entity.valor\" name=\"Ingrediente\" ng-show=\"false\" ng-required=\"true\"></ix-text>\r\n							<div style=\"border:1px solid black; float:right\" class=\"col-md-8\">\r\n								<p><translate>Ingrediente</translate>:</p>\r\n								<div style=\"height:calc(100vh - 315px); overflow:auto\" ivh-treeview=\"listOfValues\" ivh-treeview-filter=\"filterItems\" ivh-treeview-on-cb-change=\"selectionChanged(ivhNode, ivhIsSelected, ivhTree)\">\r\n								</div>\r\n							</div>\r\n						</div>\r\n						<div class=\"col-md-5\">\r\n							<ft-pregunta-bp pregunta=\"pregunta\" data=\"entity\" in-popup=\"true\" modo-traduccion=\"modoTraduccion\">\r\n						</ft-pregunta-bp></div>\r\n					</div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/FormularioFtBP/modales/editarFicheroFtPopup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"{{tituloPopup}}\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\" ng-show=\"esNuevo\">\r\n            <div class=\"col-md-4\"></div>\r\n            <div class=\"col-md-8\">\r\n              <div ngf-drop ngf-select ng-model=\"archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"esNuevo\">\r\n                <translate>Arrastrar o hacer click para subir archivo</translate>\r\n              </div>\r\n              <ul>\r\n                <li ng-repeat=\"f in archivosToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"col-md-4\"></div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <ix-text ng-show=\"!esNuevo\" ng-model=\"data.archivo\" name=\"Nombre fichero\" ng-disabled=\"!status.editing\" ng-required=\"!esNuevo\"></ix-text>\r\n              <ix-select ng-model=\"data.tipo\" name=\"Tipo archivo\" entity=\"tipos_fichero_ftVM\" pk=\"id\" desc=\"descripcion\" ng-disabled=\"!status.editing\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" append-to-body=\"true\" ng-required=\"true\"></ix-select>\r\n              <ix-options-si-no ng-show=\"data.tipo == 7 || data.tipo == 8\" ng-model=\"data.en_impreso\" name=\"Impreso en la FT\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n              <ix-date ng-model=\"data.fecha_carga\" name=\"Fecha carga\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <ix-date ng-model=\"data.inicio_validez\" name=\"Inicio validez\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <ix-date ng-model=\"data.fecha_caducidad\" name=\"Caducidad\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/FormularioFtBP/modales/planificacionAnaliticaPopup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"{{tituloPopup}}\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class-col-md-12>\r\n              <ix-select ng-model=\"data.datos.tipo\" name=\"Tipo de análisis\" entity=\"tipos_analisis\" pk=\"id\" desc=\"descripcion\" conditions=\"[{field: \'extra\',value: \'0\'}]\" ng-disabled=\"!status.editing\" ng-required=\"true\" append-to-body=\"true\">\r\n              </ix-select>\r\n              <ix-select ng-model=\"data.datos.laboratorio\" name=\"Laboratorio\" entity=\"laboratorios\" pk=\"id_laboratorio\" desc=\"nombre\" ng-disabled=\"!status.editing\" append-to-body=\"true\">\r\n              </ix-select>\r\n              <ix-text ng-model=\"data.datos.intervalo_meses\" name=\"Intervalo de análisis\" ix-number ng-disabled=\"!status.editing\"></ix-text>\r\n              <ix-date ng-model=\"data.datos.fecha_ultima_analisis\" name=\"Última fecha\" ng-disabled=\"!status.editing\"></ix-date>\r\n              <ix-text-area ng-model=\"data.datos.comentarios\" name=\"Comentarios\" ng-disabled=\"!status.editing\" rows=\"4\"></ix-text-area>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/FormularioFtBP/modales/seleccionarEstadoVersion.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Seleccionar estado nueva versión FT\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-8\">\r\n              <ix-select ng-model=\"estado_sel\" name=\"Estado inicial\" entity=\"estados\" pk=\"codigo\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" append-to-body=\"true\" load-function=\"loadEstados\" ng-required=\"true\">\r\n              </ix-select>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/GestionAnaliticasBP/modales/addBoletinesPopup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Agregar boletín resultado\"></ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-8\">\r\n            <div ngf-drop ngf-select ng-model=\"data.filesToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n              <translate>Arrastrar o hacer click aquí para subir uno o más boletines</translate>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <ul>\r\n              <li ng-repeat=\"f in data.filesToUpload\" style=\"font:medium\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/GestionAnaliticasBP/modales/addDocumentosNcAnalisisPopup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Agregar documento NC análisis\"></ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-8\">\r\n            <div ngf-drop ngf-select ng-model=\"data.filesToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n              <translate>Arrastrar o hacer click aquí para subir uno o documentos</translate>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <ul>\r\n              <li ng-repeat=\"f in data.filesToUpload\" style=\"font:medium\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/GestionAnaliticasBP/modales/addPlanificacionExtraPopup.html","<div>\r\n  <ix-popup-tool-bar tittle-left=\"Agregar planificación analítica Extra\"></ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <ix-text ng-model=\"data.nueva_planificacion.cod_articulo\" name=\"Código artículo\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n            <ix-select ng-model=\"data.nueva_planificacion.proveedor\" name=\"Proveedor\" entity=\"proveedoresBP\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!status.editing\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-select ng-model=\"data.nueva_planificacion.laboratorio\" name=\"Laboratorio\" entity=\"laboratorios\" pk=\"id_laboratorio\" desc=\"nombre\" ng-disabled=\"!status.editing\" ng-required=\"true\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-select ng-model=\"data.nueva_planificacion.tipo\" name=\"Tipo de análisis\" entity=\"tipos_analisis\" pk=\"id\" desc=\"descripcion\" conditions=\"[{field: \'extra\',value: \'1\'}]\" ng-disabled=\"!status.editing\" ng-required=\"true\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.nueva_planificacion.comentarios\" name=\"Comentarios\" ng-disabled=\"!status.editing\" rows=\"5\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/GestionAnaliticasBP/modales/editarNcAnalisisPopup.html","<style>\r\n	.nota-importante{\r\n		font-size: 14px;\r\n		font-family: \'Roboto\', \'Helvetica\', \'Arial\', sans-serif;\r\n		line-height: 1.6;\r\n		padding: 15px;\r\n		margin: 0 15px 15px;\r\n		color: white;\r\n		background-color: rgb(241,110,110);\r\n	}\r\n	.nota-explicativa{\r\n		margin: 1em 0 0.5em 0;\r\n		font-weight: normal;\r\n		position: relative;\r\n		text-shadow: 0 -1px rgba(0,0,0,0.6);\r\n		/* font-size: 18px; */\r\n		line-height: 30px;\r\n		background: #d15a4a;\r\n		/* background: rgba(53,86,129, 0.8); */\r\n		border: 1px solid #fff;\r\n		padding: 5px 15px;\r\n		color: white;\r\n		border-radius: 0 10px 0 10px;\r\n		box-shadow: inset 0 0 5px rgba(53,86,129, 0.5);\r\n		font-family: \'Muli\', sans-serif;\r\n	};\r\n</style>\r\n\r\n<div>\r\n  <ix-popup-tool-bar title-left=\"No conformidad análisis\"></ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <ng-form name=\"form\" class=\"form-horizontal\" novalidate>\r\n        <div class=\"row\">\r\n          <h4>\r\n            <translate>Datos del producto</translate>\r\n          </h4>\r\n          <hr>\r\n          <div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos_resultado.id_ficha_tecnica\" name=\"Núm. FT\" ng-disabled=\"true\"></ix-text>\r\n            <ix-text ng-model=\"data.datos_resultado.cod_articulo\" name=\"Núm. artículo\" ng-disabled=\"true\"></ix-text>\r\n            <ix-text ng-model=\"data.info.desc_articulo\" name=\"descripción artículo\" ng-disabled=\"true\"></ix-text>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-select ng-model=\"data.datos_resultado.proveedor\" name=\"Código proveedor\" entity=\"proveedoresBP\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"true\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text ng-model=\"data.info.ean\" name=\"EAN\" ng-disabled=\"true\"></ix-text>\r\n            <ix-text ng-model=\"data.info.marca\" name=\"Marca\" ng-disabled=\"true\"></ix-text>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <h4>\r\n            <translate>Datos del análisis</translate>\r\n          </h4>\r\n          <hr>\r\n          <div class=\"col-md-6\">\r\n            <ix-select ng-model=\"data.datos_resultado.laboratorio\" name=\"Laboratorio\" entity=\"laboratorios\" pk=\"id_laboratorio\" desc=\"nombre\" ng-disabled=\"true\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-select ng-model=\"data.datos_resultado.tipo_analisis\" name=\"Tipo análisis\" entity=\"tipos_analisis\" pk=\"id\" desc=\"descripcion\" ng-disabled=\"true\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text ng-model=\"data.datos_resultado.analisis_corregido\" name=\"Análisis corregido\" ng-disabled=\"true\">\r\n            </ix-text>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha\" name=\"Fecha análisis\" ng-disabled=\"true\" ng-required=\"true\">\r\n            </ix-date>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos_resultado.referencia_analisis\" name=\"Núm. boletín\" ng-disabled=\"true\" ng-required=\"true\"></ix-text>\r\n            <ix-text ng-model=\"data.datos_resultado.lote\" name=\"Lote\" ng-disabled=\"true\"></ix-text>\r\n            <ix-date ng-model=\"data.datos_resultado.caducidad\" name=\"Caducidad\" ng-disabled=\"true\"></ix-date>\r\n            <ix-text-area ng-model=\"data.datos_resultado.observaciones\" name=\"Observaciones\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- ***** NC FQ ***** -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'FQ\'\">\r\n          <h4>\r\n            <translate>No conformidad FQ</translate>\r\n          </h4>\r\n          <hr>\r\n          <!-- Resultados Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_fq\" name=\"Resultado Físico-Químico\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_fq_obs\" name=\"Observaciones FQ\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Resultados Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_fq\" name=\"Resultado Físico-Químico\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_fq_obs\" name=\"Observaciones FQ\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Estado y fecha cierre Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_fq\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_fq\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre_nc_fq\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado_nc_fq == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n          <!-- Estado y fecha cierre Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_fq\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_fq\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre2_nc_fq\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado2_nc_fq == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Laboratorio -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'FQ\' && !data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_proveedor_fq\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_cliente_fq\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Bonpreu -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'FQ\' && data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_proveedor_fq\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_cliente_fq\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing  || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- ***** NC MICRO ***** -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'MICRO\'\">\r\n          <h4>\r\n            <translate>No conformidad Micro</translate>\r\n          </h4>\r\n          <hr>\r\n          <!-- Resultados Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_micro\" name=\"Resultado microbiológicas\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_micro_obs\" name=\"Observaciones microbiológicas\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Resultados Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_micro\" name=\"Resultado microbiológicas\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_micro_obs\" name=\"Observaciones microbiológicas\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Estado y fecha cierre Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_micro\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_micro\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre_nc_micro\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado_nc_micro == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n          <!-- Estado y fecha cierre Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_micro\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_micro\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre2_nc_micro\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado2_nc_micro == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Laboratorio -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'MICRO\' && !data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_proveedor_micro\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_cliente_micro\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Bonpreu -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'MICRO\' && data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_proveedor_micro\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_cliente_micro\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- ***** NC VIDA ÚTIL ***** -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'VIDA ÚTIL\'\">\r\n          <h4>\r\n            <translate>No conformidad Vida Útil</translate>\r\n          </h4>\r\n          <hr>\r\n          <!-- Resultados Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_vidautil\" name=\"Resultado vida útil\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_vidautil_obs\" name=\"Observaciones vida útil\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Resultados Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_vidautil\" name=\"Resultado vida útil\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_vidautil_obs\" name=\"Observaciones vida útil\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Estado y fecha cierre Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_vidautil\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_vidautil\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre_nc_vidautil\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado_nc_vidautil == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n          <!-- Estado y fecha cierre Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_vidautil\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_vidautil\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre2_nc_vidautil\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado2_nc_vidautil == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Laboratorio -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'VIDA ÚTIL\' && !data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_proveedor_vidautil\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_cliente_vidautil\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Bonpreu -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'VIDA ÚTIL\' && data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_proveedor_vidautil\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_cliente_vidautil\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- ***** NC NUTRICIONAL ***** -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'NUTRICIONAL\'\">\r\n          <h4>\r\n            <translate>No conformidad Nutricional</translate>\r\n          </h4>\r\n          <hr>\r\n          <!-- Resultados Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_nutricional\" name=\"Resultado nutricional\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_nutricional_obs\" name=\"Observaciones nutricional\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Resultados Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_nutricional\" name=\"Resultado nutricional\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_nutricional_obs\" name=\"Observaciones nutricional\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Estado y fecha cierre Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_nutricional\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_nutricional\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre_nc_nutricional\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado_nc_nutricional == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n          <!-- Estado y fecha cierre Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_nutricional\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_nutricional\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\">\r\n            </ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre2_nc_nutricional\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado2_nc_nutricional == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Laboratorio -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'NUTRICIONAL\' && !data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_proveedor_nutricional\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_cliente_nutricional\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Bonpreu -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'NUTRICIONAL\' && data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_proveedor_nutricional\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_cliente_nutricional\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>       \r\n        <!-- ***** NC ALÉRGENOS ***** -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'AL·LÈRGENS\' || data.info.parametro == \'ALÉRGENOS\'\">\r\n          <h4>\r\n            <translate>No conformidad Alérgenos</translate>\r\n          </h4>\r\n          <hr>\r\n          <!-- Resultados Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_alergenos\" name=\"Resultado alérgenos\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_alergenos_obs\" name=\"Observaciones alérgenos\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Resultados Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_alergenos\" name=\"Resultado alérgenos\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_alergenos_obs\" name=\"Observaciones alérgenos\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>   \r\n          <!-- Estado y fecha cierre Laboratorio-->      \r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_alergenos\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_alergenos\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre_nc_alergenos\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado_nc_alergenos == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n          <!-- Estado y fecha cierre Bonpreu-->      \r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_alergenos\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_alergenos\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre2_nc_alergenos\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado2_nc_alergenos == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>         \r\n        </div>\r\n        <!-- Comentarios NC Laboratorio -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'AL·LÈRGENS\' || data.info.parametro == \'ALÉRGENOS\') && !data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_proveedor_alergenos\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_cliente_alergenos\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Bonpreu -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'AL·LÈRGENS\' || data.info.parametro == \'ALÉRGENOS\') && data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_proveedor_alergenos\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_cliente_alergenos\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- ***** NC PESO ***** -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'PES\' || data.info.parametro == \'PESO\'\">\r\n          <h4>\r\n            <translate>No conformidad Peso</translate>\r\n          </h4>\r\n          <hr>\r\n          <!-- Resultados Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_peso\" name=\"Resultado peso\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_peso_obs\" name=\"Observaciones peso\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Resultados Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_peso\" name=\"Resultado peso\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_peso_obs\" name=\"Observaciones peso\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Estado y fecha cierre Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_peso\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_peso\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre_nc_peso\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado_nc_peso == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n          <!-- Estado y fecha cierre Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_peso\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_peso\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre2_nc_peso\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado2_nc_peso == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Laboratorio -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'PES\' || data.info.parametro == \'PESO\') && !data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_proveedor_peso\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_cliente_peso\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Bonpreu -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'PES\' || data.info.parametro == \'PESO\') && data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_proveedor_peso\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_cliente_peso\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- ***** NC ORGANOLÉPTICO ***** -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'ORGANOLÈPTIC\' || data.info.parametro == \'ORGANOLÉPTICO\'\">\r\n          <h4>\r\n            <translate>No conformidad Organoléptico</translate>\r\n          </h4>\r\n          <hr>\r\n          <!-- Resultados Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_organoleptico\" name=\"Resultado organoléptico\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_organoleptico_obs\" name=\"Observaciones organoléptico\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Resultados Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_organoleptico\" name=\"Resultado organoléptico\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_organoleptico_obs\" name=\"Observaciones organoléptico\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Estado y fecha cierre Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_org\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_org\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre_nc_org\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado_nc_org == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n          <!-- Estado y fecha cierre Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_organoleptico\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_organoleptico\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre2_nc_orgaoleptico\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado2_nc_organoleptico == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Laboratorio -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'ORGANOLÈPTIC\' || data.info.parametro == \'ORGANOLÉPTICO\') && !data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_proveedor_org\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_cliente_org\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Bonpreu -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'ORGANOLÈPTIC\' || data.info.parametro == \'ORGANOLÉPTICO\') && data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_proveedor_organoleptico\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_cliente_organoleptico\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- ***** NC ETIQUETADO ***** -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'ETIQUETAT\' || data.info.parametro == \'ETIQUETADO\'\">\r\n          <h4>\r\n            <translate>No conformidad Etiquetado</translate>\r\n          </h4>\r\n          <hr>\r\n          <!-- Resultados Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_etiquetado\" name=\"Resultado etiquetado\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_etiquetado_obs\" name=\"Observaciones etiquetado\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Resultados Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_etiquetado\" name=\"Resultado etiquetado\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_etiquetado_obs\" name=\"Observaciones etiquetado\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Estado y fecha cierre Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_etiq\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_etiq\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre_nc_etiq\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado_nc_etiq == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n          <!-- Estado y fecha cierre Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_etiquetado\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_etiquetado\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre2_nc_etiquetado\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado2_nc_etiquetado == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Laboratorio -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'ETIQUETAT\' || data.info.parametro == \'ETIQUETADO\') && !data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_proveedor_etiq\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_cliente_etiq\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Bonpreu -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'ETIQUETAT\' || data.info.parametro == \'ETIQUETADO\') && data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_proveedor_etiquetado\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_cliente_etiquetado\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- ***** NC RESIDUOS ***** -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'RESIDUS\' || data.info.parametro == \'RESIDUOS\'\">\r\n          <h4>\r\n            <translate>No conformidad Residuos</translate>\r\n          </h4>\r\n          <hr>\r\n          <!-- Resultados Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_residuos\" name=\"Resultado residuos\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_residuos_obs\" name=\"Observaciones residuos\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Resultados Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_residuos\" name=\"Resultado residuos\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_residuos_obs\" name=\"Observaciones residuos\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Estado y fecha cierre Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_residuos\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_residuos\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre_nc_residuos\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado_nc_residuos == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n          <!-- Estado y fecha cierre Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_residuos\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_residuos\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre2_nc_residuos\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado2_nc_residuos == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Laboratorio -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'RESIDUS\' || data.info.parametro == \'RESIDUOS\') && !data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_proveedor_residuos\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_cliente_residuos\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Bonpreu -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'RESIDUS\' || data.info.parametro == \'RESIDUOS\') && data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_proveedor_residuos\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_cliente_residuos\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- ***** NC OTROS ***** -->\r\n        <div class=\"row\" ng-if=\"data.info.parametro == \'ALTRES\' || data.info.parametro == \'OTROS\'\">\r\n          <h4>\r\n            <translate>No conformidad Otros</translate>\r\n          </h4>\r\n          <hr>\r\n          <!-- Resultados Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_otros\" name=\"Resultado otros\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_otros_obs\" name=\"Observaciones otros\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Resultados Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_otros\" name=\"Resultado otros\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_otros_obs\" name=\"Observaciones otros\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"true\"></ix-text-area>\r\n          </div>\r\n          <!-- Estado y fecha cierre Laboratorio-->\r\n          <div class=\"col-md-6\" ng-if=\"!data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_otros\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado_nc_otros\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre_nc_otros\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado_nc_otros == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n          <!-- Estado y fecha cierre Bonpreu-->\r\n          <div class=\"col-md-6\" ng-if=\"data.nc_bonpreu\">\r\n            <ix-select ng-if=\"tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_otros\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-select ng-if=\"!tienePerfilUserkey()\" ng-model=\"data.datos_resultado.estado2_nc_otros\" name=\"Estado\" entity=\"estados_nc_bp\" pk=\"id\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" load-function=\"loadEstados\" ng-disabled=\"!editar_estado_nc\" on-select=\"checkCierre\"></ix-select>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha_cierre2_nc_otros\" name=\"Fecha cierre\" ng-disabled=\"true\" ng-show=\"data.datos_resultado.estado2_nc_otros == 4\" append-to-body=\"true\"></ix-date>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Laboratorio -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'ALTRES\' || data.info.parametro == \'OTROS\') && !data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_proveedor_otros\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios_nc_cliente_otros\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <!-- Comentarios NC Bonpreu -->\r\n        <div class=\"row\" ng-if=\"(data.info.parametro == \'ALTRES\' || data.info.parametro == \'OTROS\') && data.nc_bonpreu\">\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_proveedor_otros\" name=\"Comentarios proveedor\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text-area ng-model=\"data.datos_resultado.comentarios2_nc_cliente_otros\" name=\"Comentarios Bonpreu\" ng-class=\"resizable\" rows=\"12\" ng-disabled=\"!status.editing || !tienePerfilUserkey()\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <h4>\r\n            <translate>Documentación</translate>\r\n          </h4>\r\n          <hr>\r\n          <div class=\"col-md-12\">\r\n            <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n              <uib-tab index=\"0\" heading=\"Documentos NC\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"nota-importante\">\r\n                      <translate>NOTA IMPORTANTE: carga documentos como evidencia a la resolución y/o justificación de la no conformidad</translate>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"btn-toolbar\">\r\n                      <button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"true\" ng-disabled=\"data.gridDocsNc.gridApi.selection.getSelectedRows().length==0 || !status.editing\" data-ng-click=\"confirmarEliminarDocNc()\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\">\r\n                        <i class=\"fa fa-trash-o\"></i>\r\n                      </button>\r\n                      <button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addDocNc()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\">\r\n                        <i class=\"fa fa-plus\"></i>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div data-ui-grid=\"data.gridDocsNc\" ng-if=\"data.gridDocsNc\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n                  <div class=\"grid-loading\" ng-if=\"data.gridDocsNc.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                  </div>\r\n                </div>\r\n              </uib-tab>\r\n              <uib-tab index=\"1\" heading=\"Boletines análisis\" translate-attr=\"heading\" select=\"changeTab(1)\">\r\n                <!-- <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"btn-toolbar\">\r\n                      <button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"tienePerfilUserkey()\"\r\n                        ng-disabled=\"data.gridBoletines.gridApi.selection.getSelectedRows().length==0\"\r\n                        data-ng-click=\"confirmarEliminarBoletines()\"\r\n                        uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\">\r\n                        <i class=\"fa fa-trash-o\"></i>\r\n                      </button>\r\n                      <button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"true\"\r\n                        data-ng-click=\"addBoletin()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\">\r\n                        <i class=\"fa fa-plus\"></i>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div> -->\r\n                <div data-ui-grid=\"data.gridBoletines\" ng-if=\"data.gridBoletines\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n                  <div class=\"grid-loading\" ng-if=\"data.gridBoletines.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                  </div>\r\n              </div></uib-tab>\r\n            </uib-tabset>\r\n\r\n          </div>\r\n        </div>\r\n    </ng-form></div>\r\n    \r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/GestionAnaliticasBP/modales/resultadosAnalisisPopup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Resultados análisis\">\r\n    <button id=\"enviar-button\" uib-tooltip=\"Enviar boletín\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" class=\"btn pull-right\" ng-click=\"enviarBoletin()\" ng-show=\"data.datos_resultado.finalizada == 1 && data.datos_resultado.boletin_enviado == 0\">\r\n      <!-- ng-disabled=\"gridStatus.$invalid || numberOfChanges()==0 || form.$invalid\"> -->\r\n      <!-- <i class=\"fa fa-envelope-o\"></i> -->\r\n      <i class=\"fa fa-paper-plane-o\"></i>\r\n      <translate>Enviar</translate>\r\n    </button>\r\n    <button id=\"copia-button\" uib-tooltip=\"Crear copia nuevo boletín\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"crearCopia()\" ng-show=\"!data.isNew && data.es_extra\">\r\n      <i class=\"fa fa-clone\"></i>\r\n      <translate>Crear nuevo boletín</translate>\r\n    </button>\r\n    <!-- <button id=\"guardar_button\" uib-tooltip=\"Guardar\" tooltip_placement=\"bottom\" class=\"btn pull-right\"\r\n      ng-click=\"guardarResultado()\" ng-show=\"data.isNew\"\r\n      ng-disabled=\"form.$invalid\">\r\n      <i class=\"fa fa-floppy-o\"></i>\r\n      Guardar\r\n    </button> -->\r\n  </ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <ng-form name=\"form\" class=\"form-horizontal\" novalidate>\r\n        <div class=\"row\">\r\n          <h4><translate>Datos del producto</translate></h4>\r\n          <hr>\r\n          <div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos_resultado.id_ficha_tecnica\" name=\"Núm. FT\" ng-disabled=\"true\"></ix-text>\r\n            <ix-text ng-model=\"data.datos_resultado.cod_articulo\" name=\"Núm. artículo\" ng-disabled=\"true\"></ix-text>\r\n            <ix-text ng-model=\"data.info.desc_articulo\" name=\"descripción artículo\" ng-disabled=\"true\"></ix-text>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-select ng-model=\"data.datos_resultado.proveedor\" name=\"Código proveedor\" entity=\"proveedoresBP\" pk=\"proveedor\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\" ng-disabled=\"true\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text ng-model=\"data.info.ean\" name=\"EAN\" ng-disabled=\"true\"></ix-text>\r\n            <ix-text ng-model=\"data.info.marca\" name=\"Marca\" ng-disabled=\"true\"></ix-text>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <h4><translate>Datos del análisis</translate></h4>\r\n          <hr>\r\n          <div class=\"col-md-6\">\r\n            <ix-select ng-model=\"data.datos_resultado.laboratorio\" name=\"Laboratorio\" entity=\"laboratorios\" pk=\"id_laboratorio\" desc=\"nombre\" ng-disabled=\"true\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-select ng-model=\"data.datos_resultado.tipo_analisis\" name=\"Tipo análisis\" entity=\"tipos_analisis\" pk=\"id\" desc=\"descripcion\" ng-disabled=\"true\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text ng-model=\"data.datos_resultado.analisis_corregido\" name=\"Análisis corregido\" ng-disabled=\"!status.editing\"></ix-text>\r\n            <ix-date ng-model=\"data.datos_resultado.fecha\" name=\"Fecha análisis\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-date>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ix-text ng-model=\"data.datos_resultado.referencia_analisis\" name=\"Núm. boletín\" ng-disabled=\"!status.editing\" ng-required=\"true\"></ix-text>\r\n            <ix-text ng-model=\"data.datos_resultado.lote\" name=\"Lote\" ng-disabled=\"!status.editing\"></ix-text>\r\n            <ix-date ng-model=\"data.datos_resultado.caducidad\" name=\"Caducidad\" ng-disabled=\"!status.editing\"></ix-date>\r\n            <ix-text-area ng-model=\"data.datos_resultado.observaciones\" name=\"Observaciones\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <h4><translate>Resultados del análisis</translate></h4>\r\n          <hr>\r\n          <div class=\"col-md-6\">\r\n            <button class=\"btn btn-primary\" ng-click=\"visualizarNCBp(\'FQ\')\" ng-show=\"tienePerfilUserkey() && !data.datos_resultado.resultado2_fq\"><translate>Agregar NC FQ Bonpreu</translate></button>\r\n            <button class=\"btn btn-primary\" ng-click=\"borrarNCBp(\'FQ\')\" ng-show=\"tienePerfilUserkey() && data.datos_resultado.resultado2_fq\"><translate>Borrar NC FQ Bonpreu</translate></button>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_fq\" name=\"Resultado BP Físico-Químico\" ng-show=\"showResultsBp_FQ\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_fq_obs\" name=\"Observaciones BP FQ\" ng-class=\"resizable\" rows=\"4\" ng-show=\"showResultsBp_FQ\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_fq\" name=\"Resultado Físico-Químico\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_fq_obs\" name=\"Observaciones FQ\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <br>\r\n\r\n            <button class=\"btn btn-primary\" ng-click=\"visualizarNCBp(\'MICRO\')\" ng-show=\"tienePerfilUserkey() && !data.datos_resultado.resultado2_micro\"><translate>Agregar NC Micro Bonpreu</translate></button>\r\n            <button class=\"btn btn-primary\" ng-click=\"borrarNCBp(\'MICRO\')\" ng-show=\"tienePerfilUserkey() && data.datos_resultado.resultado2_micro\"><translate>Borrar NC Micro Bonpreu</translate></button>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_micro\" name=\"Resultado BP Micro\" ng-show=\"showResultsBp_MICRO\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_micro_obs\" name=\"Observaciones BP microbiológicas\" ng-class=\"resizable\" rows=\"4\" ng-show=\"showResultsBp_MICRO\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_micro\" name=\"Resultado microbiológicas\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_micro_obs\" name=\"Observaciones microbiológicas\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n            <br>\r\n\r\n            <button class=\"btn btn-primary\" ng-click=\"visualizarNCBp(\'VIDAUTIL\')\" ng-show=\"tienePerfilUserkey() && !data.datos_resultado.resultado2_vidautil\"><translate>Agregar NC vida útil Bonpreu</translate></button>\r\n            <button class=\"btn btn-primary\" ng-click=\"borrarNCBp(\'VIDAUTIL\')\" ng-show=\"tienePerfilUserkey() && data.datos_resultado.resultado2_vidautil\"><translate>Borrar NC vida útil Bonpreu</translate></button>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_vidautil\" name=\"Resultado BP vida útil\" ng-show=\"showResultsBp_VIDAUTIL\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_vidautil_obs\" name=\"Observaciones BP vida útil\" ng-class=\"resizable\" rows=\"4\" ng-show=\"showResultsBp_VIDAUTIL\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_vidautil\" name=\"Resultado vida útil\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_vidautil_obs\" name=\"Observaciones vida útil\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\"></ix-text-area>\r\n            <br>\r\n\r\n            <button class=\"btn btn-primary\" ng-click=\"visualizarNCBp(\'NUTRICIONAL\')\" ng-show=\"tienePerfilUserkey() && !data.datos_resultado.resultado2_nutricional\"><translate>Agregar NC nutricional Bonpreu</translate></button>\r\n            <button class=\"btn btn-primary\" ng-click=\"borrarNCBp(\'NUTRICIONAL\')\" ng-show=\"tienePerfilUserkey() && data.datos_resultado.resultado2_nutricional\"><translate>Borrar NC nutricional Bonpreu</translate></button>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_nutricional\" name=\"Resultado BP nutricional\" ng-show=\"showResultsBp_NUTRICIONAL\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_nutricional_obs\" name=\"Observaciones BP nutricional\" ng-class=\"resizable\" rows=\"4\" ng-show=\"showResultsBp_NUTRICIONAL\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_nutricional\" name=\"Resultado nutricional\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_nutricional_obs\" name=\"Observaciones nutricional\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <br>\r\n\r\n            <button class=\"btn btn-primary\" ng-click=\"visualizarNCBp(\'ALERGENOS\')\" ng-show=\"tienePerfilUserkey() && !data.datos_resultado.resultado2_alergenos\"><translate>Agregar NC alérgenos Bonpreu</translate></button>\r\n            <button class=\"btn btn-primary\" ng-click=\"borrarNCBp(\'ALERGENOS\')\" ng-show=\"tienePerfilUserkey() && data.datos_resultado.resultado2_alergenos\"><translate>Borrar NC alérgenos Bonpreu</translate></button>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_alergenos\" name=\"Resultado BP alérgenos\" ng-show=\"showResultsBp_ALERGENOS\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_alergenos_obs\" name=\"Observaciones BP alérgenos\" ng-class=\"resizable\" rows=\"4\" ng-show=\"showResultsBp_ALERGENOS\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_alergenos\" name=\"Resultado alérgenos\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_alergenos_obs\" name=\"Observaciones alérgenos\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n          </div>\r\n\r\n          <div class=\"col-md-6\">\r\n            <button class=\"btn btn-primary\" ng-click=\"visualizarNCBp(\'PESO\')\" ng-show=\"tienePerfilUserkey() && !data.datos_resultado.resultado2_peso\"><translate>Agregar NC peso Bonpreu</translate></button>\r\n            <button class=\"btn btn-primary\" ng-click=\"borrarNCBp(\'PESO\')\" ng-show=\"tienePerfilUserkey() && data.datos_resultado.resultado2_peso\"><translate>Borrar NC peso Bonpreu</translate></button>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_peso\" name=\"Resultado BP peso\" ng-show=\"showResultsBp_PESO\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_peso_obs\" name=\"Observaciones BP peso\" ng-class=\"resizable\" rows=\"4\" ng-show=\"showResultsBp_PESO\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_peso\" name=\"Resultado peso\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_peso_obs\" name=\"Observaciones peso\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <br>\r\n\r\n            <button class=\"btn btn-primary\" ng-click=\"visualizarNCBp(\'ORGANOLEPTICO\')\" ng-show=\"tienePerfilUserkey() && !data.datos_resultado.resultado2_organoleptico\"><translate>Agregar NC organoléptico Bonpreu</translate></button>\r\n            <button class=\"btn btn-primary\" ng-click=\"borrarNCBp(\'ORGANOLEPTICO\')\" ng-show=\"tienePerfilUserkey() && data.datos_resultado.resultado2_organoleptico\"><translate>Borrar NC organoléptico Bonpreu</translate></button>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_organoleptico\" name=\"Resultado BP organoléptico\" ng-show=\"showResultsBp_ORGANOLEPTICO\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_organoleptico_obs\" name=\"Observaciones BP organoléptico\" ng-class=\"resizable\" rows=\"4\" ng-show=\"showResultsBp_ORGANOLEPTICO\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_organoleptico\" name=\"Resultado organoléptico\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_organoleptico_obs\" name=\"Observaciones organoléptico\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <br>\r\n\r\n            <button class=\"btn btn-primary\" ng-click=\"visualizarNCBp(\'ETIQUETADO\')\" ng-show=\"tienePerfilUserkey() && !data.datos_resultado.resultado2_etiquetado\"><translate>Agregar NC etiquetado Bonpreu</translate></button>\r\n            <button class=\"btn btn-primary\" ng-click=\"borrarNCBp(\'ETIQUETADO\')\" ng-show=\"tienePerfilUserkey() && data.datos_resultado.resultado2_etiquetado\"><translate>Borrar NC etiquetado Bonpreu</translate></button>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_etiquetado\" name=\"Resultado BP etiquetado\" ng-show=\"showResultsBp_ETIQUETADO\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_etiquetado_obs\" name=\"Observaciones BP etiquetado\" ng-class=\"resizable\" rows=\"4\" ng-show=\"showResultsBp_ETIQUETADO\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_etiquetado\" name=\"Resultado etiquetado\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_etiquetado_obs\" name=\"Observaciones etiquetado\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <br>\r\n\r\n            <button class=\"btn btn-primary\" ng-click=\"visualizarNCBp(\'RESIDUOS\')\" ng-show=\"tienePerfilUserkey() && !data.datos_resultado.resultado2_residuos\"><translate>Agregar NC residuos Bonpreu</translate></button>\r\n            <button class=\"btn btn-primary\" ng-click=\"borrarNCBp(\'RESIDUOS\')\" ng-show=\"tienePerfilUserkey() && data.datos_resultado.resultado2_residuos\"><translate>Borrar NC residuos Bonpreu</translate></button>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_residuos\" name=\"Resultado BP residuos\" ng-show=\"showResultsBp_RESIDUOS\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_residuos_obs\" name=\"Observaciones BP residuos\" ng-class=\"resizable\" rows=\"4\" ng-show=\"showResultsBp_RESIDUOS\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_residuos\" name=\"Resultado residuos\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_residuos_obs\" name=\"Observaciones residuos\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <br>\r\n\r\n            <button class=\"btn btn-primary\" ng-click=\"visualizarNCBp(\'OTROS\')\" ng-show=\"tienePerfilUserkey() && !data.datos_resultado.resultado2_otros\"><translate>Agregar NC otros Bonpreu</translate></button>\r\n            <button class=\"btn btn-primary\" ng-click=\"borrarNCBp(\'OTROS\')\" ng-show=\"tienePerfilUserkey() && data.datos_resultado.resultado2_otros\"><translate>Borrar NC otros Bonpreu</translate></button>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado2_otros\" name=\"Resultado BP otros\" ng-show=\"showResultsBp_OTROS\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado2_otros_obs\" name=\"Observaciones BP otros\" ng-class=\"resizable\" rows=\"4\" ng-show=\"showResultsBp_OTROS\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n            <ix-select ng-model=\"data.datos_resultado.resultado_otros\" name=\"Resultado otros\" entity=\"valores_resultados_analisis\" pk=\"codigo\" desc=\"descripcion\" ng-disabled=\"!status.editing\" on-select=\"checkValid()\" append-to-body=\"true\">\r\n            </ix-select>\r\n            <ix-text-area ng-model=\"data.datos_resultado.resultado_otros_obs\" name=\"Observaciones otros\" ng-class=\"resizable\" rows=\"4\" ng-disabled=\"!status.editing\">\r\n            </ix-text-area>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\" ng-if=\"data.isNew\">\r\n          <h4><translate>Boletines análisis</translate></h4>\r\n          <hr>\r\n          <div class=\"col-md-8\">\r\n            <div ngf-drop ngf-select ng-model=\"data.boletinesToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-size=\"{{maxUploadFileSize}}\" name=\"archivo boletín\" ng-required=\"data.isNew\">\r\n              <translate>Arrastrar o hacer click aquí para subir uno o más boletines</translate>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <ul>\r\n              <li ng-repeat=\"f in data.boletinesToUpload\" style=\"font:medium\">{{f.name}} {{f.$error}} {{f.$errorParam}}\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\" ng-if=\"!data.isNew\">\r\n          <h4><translate>Boletines análisis</translate></h4>\r\n          <hr>\r\n          <div class=\"col-md-12\">\r\n            <div class=\"btn-toolbar\">\r\n              <!-- <button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" -->\r\n              <button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"true\" ng-disabled=\"data.gridBoletines.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedBoletines()\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\">\r\n                <i class=\"fa fa-trash-o\"></i>\r\n              </button>\r\n              <!-- <button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" -->\r\n              <button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"true\" data-ng-click=\"addBoletin()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\">\r\n                <i class=\"fa fa-plus\"></i>\r\n              </button>\r\n            </div>\r\n            <div data-ui-grid=\"data.gridBoletines\" ng-if=\"data.gridBoletines\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter>\r\n              <div class=\"grid-loading\" ng-if=\"data.gridBoletines.ixIsLoading\">\r\n                <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </ng-form>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/ListadosFtBP/acciones/add_ftbp_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Crear nueva ficha técnica\"></ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n						<ix-text ng-model=\"nuevaft.titulo\" name=\"Título\" ng-required=\"true\"></ix-text>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/ListadosFtBP/acciones/carga_masiva_ficheros_ftbp_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Carga masiva ficheros\">\r\n    <button id=\"load-button\" uib-tooltip=\"Subir fichero ZIP\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" class=\"btn pull-right\" ng-click=\"subirZip()\" ng-disabled=\"form.$invalid\"><translate>Subir</translate></button>\r\n    <button id=\"load-indexXLS\" uib-tooltip=\"Coger Plantilla XLS\" tooltip-placement=\"bottom\" translate-attr=\"uibTooltip\" class=\"btn pull-right\" ng-click=\"descargarPlantillaIndex()\">Descargar plantilla</button>\r\n  </ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"alert alert-warning\" role=\"alert\" style=\"font-size:130%; line-height: 1.3\">\r\n                <translate>InstruccionesCargaMasivaFicherosFT</translate>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\">\r\n            <div ngf-drop ngf-select ng-model=\"archivoToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"true\">\r\n              <translate>Arrastrar o hacer click para subir archivo ZIP</translate>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <ul>\r\n              <li ng-repeat=\"f in archivoToUpload\" style=\"font:small\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n        <div clas=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div ng-if=\"resultReady\" data-ui-grid=\"gridResultData\" style=\"height: 300px\" data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-selection data-ui-grid-auto-resize ui-grid-clipboard>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\"></div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/ListadosFtBP/acciones/imprimir_ftbp_popup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Descargar Ficha Técnica\"></ix-popup-tool-bar>\r\n  <div class=\"scrolldiv-content\">\r\n    <div class=\"modal-body\">\r\n      <form name=\"form\" class=\"form-horizontal\" ng-submit=\"submit()\" novalidate>\r\n        <div class=\"row\">\r\n					<div class=\"col-md-12\">\r\n						<ix-radio ng-model=\"datos.tipo_doc\" ng-if=\"!extranetUser.laboratorio\" options=\'[{value: \"PDF\", text: \"PDF\"},{value: \"MSWORD\", text: \"Word\"}]\' name=\"tipo_doc\" label=\"Formato\" ng-required=\"true\"></ix-radio>\r\n            <ix-radio ng-model=\"datos.tipo_doc\" ng-if=\"extranetUser.laboratorio\" options=\'[{value: \"PDF\", text: \"PDF\"}]\' name=\"tipo_doc\" label=\"Formato\" ng-required=\"true\"></ix-radio>\r\n					</div>\r\n					<div class=\"col-md-12\">\r\n						<ix-radio ng-model=\"reducida\" options=\'[{value: 0, text: \"Completa\"},{value: 1, text: \"Reducida\"}]\' name=\"reducida\" label=\"Tipo\" ng-required=\"true\"></ix-radio>\r\n					</div>\r\n					<div class=\"col-md-12\">\r\n						<!-- <ix-radio ng-model=\"idioma\" options=\'idiomas\' name=\"idioma\" label=\"Idioma\" ng-required=\"traducible\"></ix-radio> -->\r\n            <ix-radio ng-model=\"idioma\" options=\"idiomas\" name=\"idioma\" label=\"Idioma\"></ix-radio>\r\n					</div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/MantenimientosBP/proveedores/proveedoresCard.html","<strong><translate>Código proveedor</translate>: {{ item.nombre }} </strong><br>\r\n<strong><translate>Razón social</translate>: {{ item.razon }} </strong>\r\n");
$templateCache.put("app/FTBonpreu/MantenimientosBP/proveedores/proveedoresForm.html","<style>\r\n	.nota-importante{\r\n		font-size: 14px;\r\n		font-family: \'Roboto\', \'Helvetica\', \'Arial\', sans-serif;\r\n		line-height: 1.6;\r\n		padding: 15px;\r\n		margin: 0 15px 15px;\r\n		color: white;\r\n		background-color: rgb(241,110,110);\r\n	}\r\n	.nota-explicativa{\r\n		margin: 1em 0 0.5em 0;\r\n		font-weight: normal;\r\n		position: relative;\r\n		text-shadow: 0 -1px rgba(0,0,0,0.6);\r\n		/* font-size: 18px; */\r\n		line-height: 30px;\r\n		background: #d15a4a;\r\n		/* background: rgba(53,86,129, 0.8); */\r\n		border: 1px solid #fff;\r\n		padding: 5px 15px;\r\n		color: white;\r\n		border-radius: 0 10px 0 10px;\r\n		box-shadow: inset 0 0 5px rgba(53,86,129, 0.5);\r\n		font-family: \'Muli\', sans-serif;\r\n	};\r\n	.row-alarm {\r\n    color: red;\r\n  }\r\n</style>\r\n<div ng-controller=\"ProveedoresBPController\">\r\n	<ix-tool-bar>\r\n	</ix-tool-bar>\r\n	<div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n			<form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n				<div class=\"row\">\r\n					<div class=\"col-md-6\">\r\n						<ix-text ng-model=\"data.datos.nombre\" name=\"Código proveedor\" ng-show=\"showCodProveedor\" ng-disabled=\"!status.editing || data.datos.bloqueado\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.razon\" name=\"Razón social\" ng-disabled=\"!status.editing || data.datos.bloqueado\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.nif\" name=\"Nif\" ng-disabled=\"!status.editing || data.datos.bloqueado\" ng-required=\"true\">\r\n						</ix-text>\r\n						<ix-text ng-model=\"data.datos.direccion\" name=\"Dirección\" ng-disabled=\"!status.editing || data.datos.bloqueado\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.poblacion\" name=\"Población\" ng-disabled=\"!status.editing || data.datos.bloqueado\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.cpostal\" name=\"Código postal\" ng-disabled=\"!status.editing || data.datos.bloqueado\" ng-required=\"true\"></ix-text>\r\n						<ix-text ng-model=\"data.datos.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing || data.datos.bloqueado\" ng-required=\"true\"></ix-text>\r\n						<ix-select ng-model=\"data.datos.pais\" ng-disabled=\"!status.editing || data.datos.bloqueado\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\" ng-required=\"true\"></ix-select>\r\n						<ix-text ng-model=\"data.datos.telefono\" name=\"Teléfono\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n						<!-- <ix-text ng-model=\"data.datos.fax\" name=\"Fax\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text> -->\r\n						<ix-text ng-model=\"data.datos.email\" name=\"E-mail\" ng-disabled=\"!status.editing || data.datos.bloqueado\"></ix-text>\r\n						</div>\r\n					<div class=\"col-md-6\">\r\n						<!-- <ix-text ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.tiempo_cumplimentacion\" name=\"Días para cumplimentar FT\" ng-disabled=\"!status.editing || data.datos.bloqueado\" ix-number></ix-text> -->\r\n						<!-- <br /> -->\r\n						<ix-select ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.idioma\" name=\"Idioma\" data-ng-disabled=\"!status.editing || data.datos.bloqueado\" entity=\"idiomas\" pk=\"idioma_code\" desc=\"idioma_desc\" append-to-body=\"true\">\r\n						</ix-select>\r\n						<ix-select-multiple ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.tipo\" name=\"Tipo\" data-ng-disabled=\"!status.editing || data.datos.bloqueado\" pk=\"tipo\" desc=\"tipo\" load-function=\"loadTiposProveedor\">\r\n						</ix-select-multiple>\r\n						<ix-select ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.area\" name=\"Área\" data-ng-disabled=\"!status.editing || data.datos.bloqueado\" pk=\"area\" desc=\"area\" load-function=\"loadAreasProveedor\">\r\n						</ix-select>\r\n						<ix-date ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.fecha_alta\" name=\"Fecha alta\" ng-disabled=\"!status.editing\"></ix-date>\r\n						<ix-options-si-no ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.baja\" name=\"Baja\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n						<ix-date ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.fecha_baja\" name=\"Fecha baja\" ng-show=\"data.datos.baja\" ng-disabled=\"!status.editing\"></ix-date>\r\n						<ix-options-si-no ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.homologado\" name=\"Homologado\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n						<ix-date ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.fecha_homologacion\" name=\"Fecha homologación\" ng-show=\"data.datos.homologado\" ng-disabled=\"!status.editing\"></ix-date>\r\n						<ix-options-si-no ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.bloqueado\" name=\"Cabecera bloqueada\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n						<ix-options-si-no ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.otros_datos_bloqueado\" name=\"Otros Datos Bloqueado\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n						<ix-options-si-no ng-if=\"tienePerfilAdminUsrKey\" ng-model=\"data.datos.fabricantes_bloqueado\" name=\"Empresas/Plantas Bloqueado\" ng-disabled=\"!status.editing\"></ix-options-si-no>\r\n					</div>\r\n				</div>\r\n				<div class=\"row\" ng-show=\"data.current.proveedor\">\r\n					<div class=\"col-md-12\">\r\n						<uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\" ng-if=\"status.transitionend\">\r\n							<uib-tab index=\"0\" heading=\"Otros datos del proveedor\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<span ng-show=\"!data.datos.otros_datos_bloqueado\"><i class=\"material-icons\">lock_open</i></span>\r\n										<span ng-show=\"data.datos.otros_datos_bloqueado\"><i class=\"material-icons\">lock</i></span>\r\n									</div>\r\n									<!-- <div class=\"col-md-12\">\r\n										<div class=\"col-md-6\">\r\n											<ix-text ng-model=\"data.datos.registro_sanitario\" name=\"Registro sanitario\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										</div>\r\n\r\n									</div> -->\r\n									<!-- <div class=\"col-md-12\">\r\n										<h4>Contactos responsables</h4>\r\n										<hr />\r\n									</div> -->\r\n									<div class=\"col-md-6\">\r\n										<h4><b><translate>Contactos responsable calidad</translate></b></h4>\r\n										<ix-text ng-model=\"data.datos.responsable_calidad\" name=\"Nombre responsable calidad\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.tel_responsable_calidad\" name=\"Teléfono responsable calidad\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.email_responsable_calidad\" name=\"E-mail responsable calidad\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<hr>\r\n										<h4><b><translate>Contactos responsable alerta</translate></b></h4>\r\n										<ix-text ng-model=\"data.datos.responsable_alerta\" name=\"Nombre responsable alerta\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.tel_responsable_alerta\" name=\"Teléfono responsable alerta\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.email_responsable_alerta\" name=\"E-mail responsable alerta\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.cargo_responsable_alerta\" name=\"Cargo responsable alerta\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n									</div>\r\n									<div class=\"col-md-6\">\r\n										<h4><b><translate>Contactos responsable comercial</translate></b></h4>\r\n										<ix-text ng-model=\"data.datos.responsable_comercial\" name=\"Nombre responsable comercial\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.tel_responsable_comercial\" name=\"Teléfono responsable comercial\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\">\r\n										</ix-text>\r\n										<ix-text ng-model=\"data.datos.email_responsable_comercial\" name=\"E-mail responsable comercial\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<hr>\r\n										<h4><b><translate>Contactos responsable marketing</translate></b></h4>\r\n										<ix-text ng-model=\"data.datos.responsable_marketing\" name=\"Nombre responsable marketing\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n										<ix-text ng-model=\"data.datos.tel_responsable_marketing\" name=\"Teléfono responsable marketing\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\">\r\n										</ix-text>\r\n										<ix-text ng-model=\"data.datos.email_responsable_marketing\" name=\"E-mail responsable marketing\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>\r\n									</div>\r\n								</div>\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<hr>\r\n									</div>\r\n									<div class=\"col-md-6\">\r\n										<ix-text ng-model=\"data.datos.email_envio_analiticas\" name=\"Email para el envío de analíticas\" ng-disabled=\"!status.editing || data.datos.otros_datos_bloqueado\"></ix-text>									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab index=\"1\" heading=\"Datos de las empresas\" translate-attr=\"heading\" select=\"changeTab(1)\" ng-show=\"data.datos.proveedor != 0\">\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<span ng-show=\"!data.datos.fabricantes_bloqueado\"><i class=\"material-icons\">lock_open</i></span>\r\n										<span ng-show=\"data.datos.fabricantes_bloqueado\"><i class=\"material-icons\">lock</i></span>\r\n									</div>\r\n								</div>\r\n								<div class=\"row\">\r\n									<div class=\"col-md-12\">\r\n										<div class=\"nota-importante\">\r\n											<translate>Texto explicativo tabla empresas/plantas pantalla proveedores</translate>\r\n										</div>\r\n									</div>\r\n								</div>\r\n								<div class=\"btn-toolbar\">\r\n									<button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.datos.fabricantes_bloqueado\" data-ng-disabled=\"data.gridFabricantes.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFabricantes)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n									<button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && !data.datos.fabricantes_bloqueado\" data-ng-click=\"addRow(data.gridFabricantes)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFabricantes\" ng-if=\"data.activeTab == 1\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter ng-style=\"{\'height\': \'calc(100vh - 580px)\' }\">\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFabricantes.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab ng-show=\"data.datos.proveedor != 0\" index=\"2\" heading=\"Certificados y otros ficheros\" translate-attr=\"heading\" select=\"changeTab(2)\">\r\n								<div class=\"btn-toolbar\">\r\n									<button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridFicheros.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridFicheros)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n									<button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-click=\"addFicheros()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridFicheros\" ng-if=\"data.activeTab == 2\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter ng-style=\"{ \'height\': \'calc(100vh - 500px)\' }\">\r\n									<div class=\"grid-loading\" ng-if=\"data.gridFicheros.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n							<uib-tab ng-if=\"tienePerfilAdminUsrKey\" data-ng-show=\"data.datos.proveedor != 0\" index=\"3\" heading=\"Notas/Observaciones\" translate-attr=\"heading\" select=\"changeTab(3)\">\r\n								<div class=\"btn-toolbar\">\r\n									<button class=\"btn btn-danger pull-right\" role=\"button\" ng-show=\"status.editing\" ng-disabled=\"data.gridComentarios.gridApi.selection.getSelectedRows().length==0\" ng-click=\"deleteSelectedRows(data.gridComentarios)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\">\r\n										<i class=\"fa fa-trash-o\"></i>\r\n									</button>\r\n									<button class=\"btn btn-primary pull-right\" role=\"button\" ng-show=\"status.editing\" ng-click=\"addRow(data.gridComentarios)\" uib-tooltip=\"{{ \'Agregar comentario\' }}\" translate-attr=\"uibTooltip\">\r\n										<i class=\"fa fa-plus\"></i>\r\n									</button>\r\n								</div>\r\n								<div data-ui-grid=\"data.gridComentarios\" ng-if=\"data.activeTab == 3\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-selection data-ui-grid-cellnav data-ui-grid-pinning data-ui-grid-resize-columns data-ui-gridmove-columns data-ui-grid-resize data-ui-grid-save-state data-ui-grid-clipboard data-ui-grid-exporter ng-style=\"{ \'height\': \'calc(100vh - 500px\' }\">\r\n									<div class=\"grid-loading\" ng-if=\"data.gridComentarios.ixIsLoading\">\r\n										<a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n									</div>\r\n								</div>\r\n							</uib-tab>\r\n						</uib-tabset>\r\n					</div>\r\n				</div>\r\n			</form>\r\n		</div>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/Manuales/ArchivosAyuda/archivos_ayuda.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n		<div>\r\n\r\n			<div class=\"col-md-6\" ng-show=\"perfilActivo == \'usr_proveedor\' || perfilActivo == \'usr_bp_userkey\' || perfilActivo == \'usr_bio_userkey\' || perfilActivo == \'ixnet\'\">\r\n				<div class=\"card-form\">\r\n					<div class=\"card-title\">\r\n						<h4><translate>Archivos Ayuda Proveedores</translate></h4>\r\n					</div>\r\n					<div class=\"card-content\">\r\n						<ul>\r\n							<li ng-repeat=\"archivo in archivos_proveedor\">\r\n								<a ng-click=\"downloadFile(archivo)\">{{::archivo.nombre}}</a>\r\n							</li>\r\n						</ul>\r\n					</div>\r\n				</div>\r\n			</div>\r\n\r\n    	<div class=\"col-md-6\" ng-show=\"perfilActivo == \'usr_laboratorio\' || perfilActivo == \'usr_bp_userkey\' || perfilActivo == \'usr_bio_userkey\' || perfilActivo == \'ixnet\'\">\r\n				<div class=\"card-form\">\r\n					<div class=\"card-title\">\r\n						<h4><translate>Archivos Ayuda Laboratorios</translate></h4>\r\n					</div>\r\n					<div class=\"card-content\">\r\n						<ul>\r\n              <li ng-repeat=\"archivo in archivos_laboratorio\">\r\n                <a ng-click=\"downloadFile(archivo)\">{{::archivo.nombre}}</a>\r\n              </li>\r\n            </ul>\r\n					</div>\r\n				</div>\r\n			</div>\r\n\r\n			<div class=\"col-md-6\" ng-show=\"perfilActivo == \'usr_comprador\' || perfilActivo == \'usr_bp_userkey\' || perfilActivo == \'usr_bio_userkey\' || perfilActivo == \'ixnet\'\">\r\n				<div class=\"card-form\">\r\n					<div class=\"card-title\">\r\n						<h4><translate>Archivos Ayuda Compradores</translate></h4>\r\n					</div>\r\n					<div class=\"card-content\">\r\n						<ul>\r\n							<li ng-repeat=\"archivo in archivos_comprador\">\r\n								<a ng-click=\"downloadFile(archivo)\">{{::archivo.nombre}}</a>\r\n							</li>\r\n						</ul>\r\n					</div>\r\n				</div>\r\n			</div>\r\n\r\n			<div class=\"col-md-6\" ng-show=\"perfilActivo == \'usr_bp_consulta\' || perfilActivo == \'usr_bp_userkey\' || perfilActivo == \'usr_bio_userkey\' || perfilActivo == \'ixnet\'\">\r\n				<div class=\"card-form\">\r\n					<div class=\"card-title\">\r\n						<h4><translate>Archivos Ayuda Consulta</translate></h4>\r\n					</div>\r\n					<div class=\"card-content\">\r\n						<ul>\r\n							<li ng-repeat=\"archivo in archivos_consulta\">\r\n								<a ng-click=\"downloadFile(archivo)\">{{::archivo.nombre}}</a>\r\n							</li>\r\n						</ul>\r\n					</div>\r\n				</div>\r\n			</div>\r\n\r\n		</div>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/Recepcion/Configuracion/configPreguntasRecepcion.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar></ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div class=\"grid full-ui-grid\" data-ui-grid=\"data.gridConfigRecepcion\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate ng-style=\"{\'height\': \'calc(100vh - 175px)\' }\">\r\n        <div class=\"grid-loading\" ng-if=\"data.gridConfigRecepcion.ixIsLoading\">\r\n            <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n        <div class=\"footer\">\r\n            <div ix-datetime-grid-generada grid=\"data.gridConfigRecepcion\"></div>\r\n        </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/Recepcion/ListadoProductos/listadoProductosRecepcion.html","<div my-transition-end=\"init()\">\r\n  <ix-splash></ix-splash>\r\n  <ix-tool-bar>\r\n  </ix-tool-bar>\r\n  <div class=\"page-content\" ng-if=\"status.transitionend\">\r\n    <form name=\"form\" class=\"form-horizontal\" novalidate>\r\n      <uib-accordion close-others=\"oneAtATime\">\r\n        <div uib-accordion-group class=\"panel-default ixFilter\" heading=\"{{ \'Filtros\' | translate }}\" is-open=\"filterStatus.isCollapsed\">\r\n          <fieldset class=\"form-data-filter\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.tipo_ft\" entity=\"versiones\" name=\"Tipo\" pk=\"version\" desc=\"nombre\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-select-multiple ng-model=\"data.filtro.estado\" limit-to=\"15\" entity=\"estados\" name=\"Estado\" pk=\"codigo\" desc=\"descripcion\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.marca\" entity=\"extranet_marcas\" pk=\"id\" desc=\"marca\" name=\"Marca\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-select-multiple ng-model=\"data.filtro.proveedor\" entity=\"proveedoresBP\" pk=\"proveedor\" desc=\"nombre\" name=\"Proveedor\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <ix-select-multiple ng-model=\"data.filtro.departamento\" entity=\"deptoarea\" pk=\"codigo\" desc=\"descripcion\" name=\"Área\" skip-table-name-filter=\"true\" skip-table-name-order-by=\"true\"></ix-select-multiple>\r\n                <ix-text ng-model=\"data.filtro.busqueda_generica\" name=\"Búsqueda Genérica\" is-filter=\"true\"></ix-text>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n      </uib-accordion>\r\n    </form>\r\n\r\n    <div style=\"width:100%\" ng-if=\"status.transitionend\">\r\n      <div class=\"grid full-ui-grid\" ng-style=\"{\'height\': (filterStatus.isCollapsed) ? \'calc(100vh - 440px)\' : \'calc(100vh - 225px)\' }\" data-ui-grid=\"data.gridProductos\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard data-ui-grid-exporter data-ui-grid-validate>\r\n        <div class=\"grid-loading\" ng-if=\"data.gridProductos.ixIsLoading\">\r\n          <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <div class=\"footer\">\r\n        <div ix-datetime-grid-generada grid=\"data.gridProductos\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/FTBonpreu/MantenimientosBP/proveedores/modales/empresasPopup.html","<style>\r\n  .row-alarm {\r\n    color: red;\r\n  }\r\n</style>\r\n<div>\r\n  <ix-popup-tool-bar title-left=\"Datos de la empresa\" title-left-param=\"nombre_empresa\">\n    <button id=\"acciones-button\" uib-tooltip=\"Guardar\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"guardar()\" ng-show=\"status.editing\" ng-disabled=\"!form.$valid\">\r\n      Guardar\r\n    </button>\r\n    <button id=\"copia-button\" uib-tooltip=\"{{ \'Copiar datos principales del proveedor\' | translate }}\" tooltip-placement=\"botom\" class=\"btn pull-right\" ng-click=\"copiarDatos()\" ng-show=\"status.editing && isNew\">\r\n      <translate>Copiar datos proveedor</translate>\r\n    </button>\r\n  </ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n              <ix-text ng-model=\"data.fabricante.razon_social\" name=\"Razón social\" ng-required=\"true\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.cif\" name=\"NIF\" ng-required=\"true\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.direccion\" name=\"Dirección\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.cp\" name=\"Código postal\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.localidad\" name=\"Población\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n              <ix-text ng-model=\"data.fabricante.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n              <ix-select ng-model=\"data.fabricante.pais\" ng-disabled=\"!status.editing || editOnlyFiles\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" append-to-body=\"true\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\">\r\n              </ix-select>\r\n              <ix-text ng-model=\"data.fabricante.telefono\" name=\"Teléfono\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n              <!-- <ix-text ng-model=\"data.fabricante.fax\" name=\"Fax\"></ix-text> -->\r\n              <ix-text ng-model=\"data.fabricante.email\" name=\"E-mail\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n              <!-- <ix-text ng-model=\"data.fabricante.reg_sanitario\" name=\"Registro sanitario\"></ix-text> -->\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <!-- Grid de plantas -->\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <uib-tabset class=\"ix-tabs no-margin-bottom\" active=\"data.activeTab\">\r\n              <uib-tab index=\"0\" heading=\"Plantas\" translate-attr=\"heading\" select=\"changeTab(0)\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div ng-if=\"data.gridPlantas && data.gridPlantas.data.length == 0\" class=\"alert alert-warning\" role=\"alert\" style=\"font-size:130%\">\r\n                      <translate>AlertaAgregarNuevaPlanta</translate>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"btn-toolbar\">\r\n                      <button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing && editOnlyFiles != 1\" data-ng-disabled=\"data.gridPlantas.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridPlantas)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></button>\r\n                      <button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing && editOnlyFiles != 1\" data-ng-disabled=\"isNew\" data-ng-click=\"addRow(data.gridPlantas)\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div data-ui-grid=\"data.gridPlantas\" ng-if=\"data.activeTab == 0\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-selection ui-grid-clipboard data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-auto-resize data-ui-grid-pinning data-ui-grid-save-state>\r\n                  <div class=\"grid-loading\" ng-if=\"data.gridPlantas.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                  </div>\r\n                </div>\r\n              </uib-tab>\r\n              <uib-tab index=\"1\" heading=\"Certificados fabricante\" translate-attr=\"heading\" select=\"changeTab(1)\" disable=\"isNew\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"alert alert-warning\" role=\"alert\" style=\"font-size:130%; line-height:120%\">\r\n                      <translate>NotaFicherosPopupEmpresa</translate>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"btn-toolbar\">\r\n                      <a class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"data.gridCertificadosFabricante.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridCertificadosFabricante)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-trash-o\"></i></a>\r\n                      <a class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" data-ng-disabled=\"false\" data-ng-click=\"addFicheros()\" uib-tooltip=\"{{ \'Nuevo\' }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></a>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div data-ui-grid=\"data.gridCertificadosFabricante\" ng-if=\"data.activeTab == 1\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-pinning data-ui-grid-selection data-ui-grid-save-state data-ui-grid-auto-resize ui-grid-clipboard>\r\n                  <div class=\"grid-loading\" ng-if=\"data.gridCertificadosFabricante.ixIsLoading\">\r\n                    <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                  </div>\r\n                </div>\r\n              </uib-tab>\r\n            </uib-tabset>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\n");
$templateCache.put("app/FTBonpreu/MantenimientosBP/proveedores/modales/plantasBpPopup.html","<style>\r\n    .row-alarm {\r\n        color: red;\r\n    }\r\n</style>\r\n<div>\r\n    <ix-popup-tool-bar title-left=\"Datos planta\" title-left-param=\"nombre_planta\">\n        <button id=\"acciones-button\" ng-show=\"status.editing\" uib-tooltip=\"Guardar\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"guardar()\" ng-disabled=\"!form.$valid\">\r\n            Guardar\r\n        </button>\r\n        <button id=\"copia-button\" uib-tooltip=\"{{ \'Copiar datos de principales de la empresa\' | translate }}\" tooltip-placement=\"botom\" class=\"btn pull-right\" ng-click=\"copiarDatos()\" ng-show=\"status.editing && isNew\">\r\n            <translate>Copiar datos empresa</translate>\r\n        </button>\r\n    </ix-popup-tool-bar>\r\n    <div ng-scrollbars class=\"scrolldiv\">\r\n        <div class=\"scrolldiv-content\">\r\n            <div class=\"modal-body\">\r\n                <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-6\">\r\n                            <ix-text ng-model=\"data.planta.nombre_planta\" name=\"Nombre planta\" ng-required=\"true\" ng-disabled=\"!status.editing || editOnlyFiles\">\r\n                            </ix-text>\r\n                            <ix-text ng-model=\"data.planta.direccion\" name=\"Dirección\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.cp\" name=\"Código postal\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.localidad\" name=\"Población\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.provincia\" name=\"Provincia\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n                            <ix-select ng-model=\"data.planta.pais\" ng-disabled=\"!status.editing || editOnlyFiles\" name=\"Pais\" entity=\"diccionarios_valores\" pk=\"valor\" desc=\"valor\" append-to-body=\"true\" conditions=\"[{field: \'diccionario\',value: \'1\'}]\"></ix-select>\r\n                            <ix-text ng-model=\"data.planta.telefono\" name=\"Teléfono\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n                            <ix-text ng-model=\"data.planta.reg_sanitario\" name=\"Registro sanitario\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-text>\r\n                            <ix-text-area ng-model=\"data.planta.descripcion_actividad\" name=\"Descripción actividad\" ng-class=\"resizable\" ng-disabled=\"!status.editing || editOnlyFiles\" rows=\"4\">\r\n                            </ix-text-area>\r\n                        </div>\r\n                        <div class=\"col-md-6\">\r\n                            <ix-date ng-model=\"data.planta.fecha_alta\" name=\"Fecha alta\" ng-disabled=\"true\"></ix-date>\r\n                            <ix-options-si-no ng-model=\"data.planta.baja\" name=\"Baja\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-options-si-no>\r\n                            <ix-date ng-model=\"data.planta.fecha_baja\" name=\"Fecha Baja\" ng-show=\"data.planta.baja == 1\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-date>\r\n                            <!-- Datos Homologación : Deshabilitar o esconder para usuarios diferentes usrkey o bonpreu qualitat -->\r\n                            <ix-options-si-no ng-model=\"data.planta.homologada\" name=\"Planta homologada\" ng-show=\"tienePerfilAdminUsrKey || tienePerfilBP\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-options-si-no>\r\n                            <ix-date ng-model=\"data.planta.fecha_homologacion\" name=\"Fecha homologación\" ng-show=\"(tienePerfilAdminUsrKey || tienePerfilBP) && data.planta.homologada == 1\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-date>\r\n                            <ix-options-si-no ng-model=\"data.planta.certificacion_brc\" name=\"Certificación BRC\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-options-si-no>\r\n                            <ix-options-si-no ng-model=\"data.planta.certificacion_ifs\" name=\"Certificación IFS\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-options-si-no>\r\n                            <ix-date ng-model=\"data.planta.fecha_ultima_auditoria\" name=\"Fecha última auditoría\" ng-show=\"(tienePerfilAdminUsrKey || tienePerfilBP)\" ng-disabled=\"!status.editing || editOnlyFiles\"></ix-date>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n                <!-- Grid de plantas -->\r\n                <br>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"alert alert-warning\" role=\"alert\" style=\"font-size:130%; line-height: 1.3\">\r\n                            <translate>NotaFicherosPopupPlanta</translate>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <div class=\"btn-toolbar\">\r\n                            <button class=\"btn btn-danger pull-right\" role=\"button\" data-ng-show=\"status.editing\" ng-disabled=\"data.gridCertificadosPlanta.gridApi.selection.getSelectedRows().length==0\" data-ng-click=\"deleteSelectedRows(data.gridCertificadosPlanta)\" uib-tooltip=\"{{ \'Eliminar registros seleccionados\' |translate }}\" translate-attr=\"uibTooltip\">\r\n                                <i class=\"fa fa-trash-o\"></i>\r\n                            </button>\r\n                            <button class=\"btn btn-primary pull-right\" role=\"button\" data-ng-show=\"status.editing\" ng-disabled=\"isNew\" data-ng-click=\"addFicheros()\" uib-tooltip=\"{{ \'Nuevo\' | translate }}\" translate-attr=\"uibTooltip\"><i class=\"fa fa-plus\"></i></button>\r\n                        </div>\r\n                        <div data-ui-grid=\"data.gridCertificadosPlanta\" data-ui-grid-edit data-ui-grid-row-edit data-ui-grid-cellnav data-ui-grid-selection ui-grid-clipboard data-ui-grid-resize-columns data-ui-grid-move-columns data-ui-grid-auto-resize data-ui-grid-pinning data-ui-grid-save-state>\r\n                            <div class=\"grid-loading\" ng-if=\"data.gridCertificadosPlanta.ixIsLoading\">\r\n                                <a><i class=\"fa fa-spinner fa-pulse\"></i></a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\n");
$templateCache.put("app/FTBonpreu/MantenimientosBP/proveedores/modales/popupFicheroProveedor.html","<div>\r\n  <ix-popup-tool-bar title-left=\"{{tituloPopup}}\"></ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n		<div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div class=\"row\" ng-show=\"esNuevo\">\r\n                <div class=\"col-md-4\"></div>\r\n                <div class=\"col-md-8\">\r\n                  <div ngf-drop ngf-select ng-model=\"archivosToUpload\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-max-files=\"1\" ngf-max-size=\"{{maxUploadFileSize}}\" ng-required=\"esNuevo\">\r\n                  <translate>Arrastrar o hacer click para subir archivo</translate>\r\n                </div>\r\n                <ul>\r\n                  <li ng-repeat=\"f in archivosToUpload\" style=\"font:medium\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\r\n                </ul>\r\n              </div>\r\n                </div>\r\n              <!-- <div class=\"col-md-8\"> -->\r\n                <ix-text ng-show=\"!esNuevo\" ng-model=\"data.archivo\" name=\"Nombre fichero\" ng-disabled=\"!status.editing\" ng-required=\"!esNuevo\"></ix-text>\r\n                <ix-select ng-model=\"data.grupo\" name=\"Grupo\" entity=\"grupos_proveedores_ficheros_bp\" pk=\"grupo\" desc=\"grupo_trad\" ng-disabled=\"!status.editing || bloquearGrupos\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n                <ix-select ng-model=\"data.proveedor\" ng-show=\"!mant_proveedor\" name=\"Proveedor\" entity=\"proveedores\" pk=\"proveedor\" desc=\"nombre\" ng-disabled=\"true\"></ix-select>\r\n                <ix-select ng-model=\"data.fabricante\" name=\"Empresa\" entity=\"fabricantes\" pk=\"fabricante\" desc=\"razon_social\" ng-disabled=\"!status.editing || bloquearGrupos\" append-to-body=\"true\" conditions=\"[{field: \'proveedor\',value: data.proveedor}]\" ng-show=\"data.grupo == \'EMPRESA\' || data.grupo == \'PLANTA\'\"></ix-select>\r\n                <ix-select ng-model=\"data.planta\" name=\"Planta\" entity=\"plantas\" pk=\"planta\" desc=\"nombre_planta\" ng-disabled=\"!status.editing || bloquearGrupos\" append-to-body=\"true\" conditions=\"[{field: \'fabricante\',value: data.fabricante}]\" ng-show=\"data.grupo == \'PLANTA\'\"></ix-select>\r\n                <ix-select ng-model=\"data.tipo\" name=\"Tipo archivo\" entity=\"tipos_fichero_proveedorVM\" skip-table-name-filter=\"true\" pk=\"id\" desc=\"descripcion\" on-select=\"setCaducityRequired\" ng-disabled=\"!status.editing\" ng-required=\"true\" append-to-body=\"true\"></ix-select>\r\n                <ix-date ng-model=\"data.inicio_validez\" name=\"Inicio validez\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n                <ix-date ng-model=\"data.fecha_caducidad\" name=\"Fecha caducidad\" ng-disabled=\"!status.editing\" append-to-body=\"true\" ng-required=\"caducityDateRequired\"></ix-date>\r\n                <ix-date ng-model=\"data.fecha_carga\" name=\"Fecha carga\" ng-disabled=\"!status.editing\" append-to-body=\"true\"></ix-date>\r\n              <!-- </div> -->\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/FTBonpreu/MantenimientosBP/proveedores/modales/renombrarArchivoPopup.html","<div>\r\n  <ix-popup-tool-bar title-left=\"Renombrar archivo: \" title-left-param=\"data.nombre_original\">\r\n    <button id=\"acciones-button\" uib-tooltip=\"Guardar\" tooltip-placement=\"bottom\" class=\"btn pull-right\" ng-click=\"guardar()\" ng-disabled=\"!form.$valid\">\r\n      Guardar\r\n    </button>\r\n  </ix-popup-tool-bar>\r\n  <div ng-scrollbars class=\"scrolldiv\">\r\n    <div class=\"scrolldiv-content\">\r\n      <div class=\"modal-body\">\r\n        <form name=\"form\" ng-submit=\"submit()\" class=\"form-horizontal\" novalidate>\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <h5 class=\"bg-warning\"><translate>Introducir sólo el nuevo nombre del archivo sin la extensión</translate></h5>\r\n              <ix-text ng-model=\"data.nuevo_nombre\" name=\"Nuevo nombre fichero\" ng-required=\"true\"></ix-text>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");}]);